
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("irimY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4253c39628e0acb7$export$2e2bcd8739ae039);
parcelRequire("41VL9");

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $9pL9Y = parcelRequire("9pL9Y");

var $12DRg = parcelRequire("12DRg");

var $b5RwB = parcelRequire("b5RwB");

var $h6i8k = parcelRequire("h6i8k");

var $hqYEY = parcelRequire("hqYEY");

var $4cTDP = parcelRequire("4cTDP");

var $82cqT = parcelRequire("82cqT");

var $eibCx = parcelRequire("eibCx");

var $fsisP = parcelRequire("fsisP");

var $aPS2z = parcelRequire("aPS2z");

var $dLEbR = parcelRequire("dLEbR");

var $hLPih = parcelRequire("hLPih");

var $iEXnd = parcelRequire("iEXnd");

var $4EKqI = parcelRequire("4EKqI");

var $2mHfh = parcelRequire("2mHfh");
var $lcB5K = parcelRequire("lcB5K");
var $ivzXw = parcelRequire("ivzXw");

var $bJscI = parcelRequire("bJscI");

var $ad2Dp = parcelRequire("ad2Dp");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $cZKSy = parcelRequire("cZKSy");

var $cwIb6 = parcelRequire("cwIb6");

var $7NJNZ = parcelRequire("7NJNZ");

var $eKcrE = parcelRequire("eKcrE");

var $eacwX = parcelRequire("eacwX");

var $lUYYk = parcelRequire("lUYYk");
const $4253c39628e0acb7$var$BROWSER_METRICS_INTERACTION_APP_KEY = 'jira.project-issue-navigator';
const $4253c39628e0acb7$var$initInteractions = ()=>({
        pagination: {
            metrics: (0, $hqYEY.metrics).interaction({
                key: `${$4253c39628e0acb7$var$BROWSER_METRICS_INTERACTION_APP_KEY}.pagination.start-end.diff`
            }),
            properties: {}
        },
        refinement: {
            metrics: (0, $hqYEY.metrics).interaction({
                key: `${$4253c39628e0acb7$var$BROWSER_METRICS_INTERACTION_APP_KEY}.refinement.start-end.diff`
            }),
            properties: {}
        },
        filter: {
            metrics: (0, $hqYEY.metrics).interaction({
                key: `${$4253c39628e0acb7$var$BROWSER_METRICS_INTERACTION_APP_KEY}.filter.start-end.diff`
            }),
            properties: {}
        },
        'list-view': {
            metrics: (0, $hqYEY.metrics).interaction({
                key: `${$4253c39628e0acb7$var$BROWSER_METRICS_INTERACTION_APP_KEY}.list-view.start-end.diff`
            }),
            properties: {}
        },
        'split-view': {
            metrics: (0, $hqYEY.metrics).interaction({
                key: `${$4253c39628e0acb7$var$BROWSER_METRICS_INTERACTION_APP_KEY}.split-view.start-end.diff`
            }),
            properties: {}
        },
        'column-configuration': {
            metrics: (0, $hqYEY.metrics).interaction({
                key: `${$4253c39628e0acb7$var$BROWSER_METRICS_INTERACTION_APP_KEY}.column-configuration.start-end.diff`
            }),
            properties: {}
        }
    });
const $4253c39628e0acb7$var$MaybeNinErrorBoundary = (0, $bJscI.componentWithFG)('improve_nin_slo_events', (0, $ad2Dp.NinErrorBoundary), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children));
// eslint-disable-next-line jira/react/no-class-components
class $4253c39628e0acb7$var$ProjectIssueNavigatorSPAWrapper extends (0, $eJOHy.Component) {
    constructor(props){
        super(props), /** @deprecated Behind jira_nin_last_used_jql_tech_changes. Remove on cleanup */ this.view = undefined, /**
   * Update the currently selected issue in the URL.
   *
   * @param issueKey Issue key to update in the URL
   * @param isSelectedByUserInteraction True if this issue was selected by a user interaction, e.g. clicking an issue
   * in the list. This will be false if an issue was automatically selected by the app, e.g. automatically selecting
   * the first issue once the issue list has loaded.
   * @param viewActivity True to indicate the issue app should scroll to the activity feed section after opening.
   */ this.onChangeIssue = (issueKey, isSelectedByUserInteraction, viewActivity)=>{
            if ((0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes')) {
                this.pushOrReplace({
                    query: {
                        selectedIssue: issueKey === '' ? undefined : issueKey,
                        viewActivity: viewActivity?.toString()
                    }
                }, // Replace the history entry when an issue is auto selected by the app so we're not pushing redundant entries to
                // the history stack
                !isSelectedByUserInteraction);
                return;
            }
            // Replace the history entry when an issue is auto selected by the app so we're not pushing redundant entries to
            // the history stack
            this.push({
                issueKey: issueKey,
                viewActivity: viewActivity
            }, !isSelectedByUserInteraction);
        }, /**
   * Set the currently selected view and update the selected issue in the URL if provided.
   *
   * @param newView View to update
   * @param issueKey Issue key to update in the URL
   */ this.onSetView = (newView, issueKey)=>{
            this.startInteraction((0, $eibCx.convertToView)(newView));
            (0, $4cTDP.fg)('add_nin_press_interactions') && (0, $h6i8k.default)(`issue-navigator.${(0, $eibCx.convertToView)(newView)}`);
            if ((0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes')) {
                this.pushOrReplace({
                    query: {
                        selectedIssue: issueKey === '' ? undefined : issueKey,
                        ...newView === 'detail' ? {
                            groupBy: undefined,
                            hideDone: undefined
                        } : {}
                    }
                }, true);
                return;
            }
            this.view = newView;
            if (issueKey !== undefined || newView === 'detail') this.push({
                ...issueKey !== undefined ? {
                    issueKey: issueKey
                } : {},
                ...newView === 'detail' ? {
                    groupBy: undefined,
                    hideDone: undefined
                } : {}
            }, true);
        }, this.onRefinement = ()=>{
            this.startInteraction('refinement');
            (0, $4cTDP.fg)('add_nin_press_interactions') && (0, $h6i8k.default)('issue-navigator.refinement');
        }, /**
   * Callback function called when internal changes are made to PIN's state which generates new JQL.
   *
   * @param jql string The new JQL string
   * @param clearFilter boolean When true we clear the filter from url params
   */ this.onChangeJql = (jql, clearFilter = false)=>{
            if ((0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes')) {
                this.pushOrReplace({
                    query: {
                        // Clear issue key from URL whenever JQL changes
                        selectedIssue: undefined,
                        ...clearFilter ? {
                            filter: undefined
                        } : {},
                        jql: jql
                    }
                });
                return;
            }
            this.push({
                ...clearFilter ? {
                    filter: undefined
                } : {},
                jql: jql,
                // Clear issue key from URL whenever JQL changes
                issueKey: ''
            });
        }, /**
   * Callback function called when internal changes are made to PINs state which generates new JQL and groupBy.
   * This allows us to update both values in the URL at the same time, allowing the data to be passed back down the tree.
   * This is introduced strictly for jira_list_nin_merge changeboarding, and can be removed on cleanup.
   *
   * @param {Object} params - The new JQL and groupBy strings
   * @param {string} [params.jql] - The new JQL string
   * @param {string} [params.groupBy] - The new groupBy string
   */ this.onChangeJqlAndGroupBy = (params)=>{
            if ((0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes')) {
                this.pushOrReplace({
                    query: {
                        ...params.jql !== undefined ? {
                            jql: params.jql,
                            selectedIssue: undefined
                        } : {},
                        ...params.groupBy !== undefined ? {
                            groupBy: params.groupBy
                        } : {}
                    }
                });
                return;
            }
            this.push({
                ...params.jql !== undefined ? {
                    jql: params.jql,
                    issueKey: ''
                } : {},
                ...params.groupBy !== undefined ? {
                    groupBy: params.groupBy
                } : {}
            });
        }, this.onPageDataLoad = (selectedView)=>{
            if (!(0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes')) {
                if (selectedView !== undefined) this.view = selectedView;
                if (!this.state.initialised) this.setState({
                    initialised: true
                });
            }
            this.endInteractions();
        }, this.onStartFilterChangeInteractionIfAny = (filter)=>{
            if ((0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes')) throw new Error('Method `onStartFilterChangeInteractionIfAny` deprecated behind jira_nin_last_used_jql_tech_changes and to be removed on cleanup');
            if (this.lastFilter !== filter) {
                this.lastFilter = filter;
                if (filter != null && ((0, $82cqT.isFilterId)(filter) || (0, $hLPih.isFilterKey)(filter))) {
                    this.startInteraction('filter', {
                        filterId: filter
                    });
                    (0, $4cTDP.fg)('add_nin_press_interactions') && (0, $h6i8k.default)('issue-navigator.filter');
                }
            }
        }, this.onChangeFilter = (filter)=>{
            if ((0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes')) {
                this.pushOrReplace({
                    query: {
                        ...filter ? {
                            filter: filter,
                            jql: undefined
                        } : {
                            jql: undefined
                        }
                    }
                }, true);
                return;
            }
            this.push({
                ...filter ? {
                    filter: filter,
                    jql: undefined
                } : {
                    jql: undefined
                }
            }, true);
        }, this.onChangeColumnConfiguration = ()=>{
            this.startInteraction('column-configuration');
            (0, $4cTDP.fg)('add_nin_press_interactions') && (0, $h6i8k.default)('issue-navigator.column-configuration');
        }, /** Dispatch route history action with provided attributes and set selected issue into state (if modified). */ this.pushOrReplace = (attributes, shouldReplace)=>{
            this.props.pushOrReplace(attributes, shouldReplace);
            if (attributes.query && 'selectedIssue' in attributes.query) // We explicitly set this into state instead of being purely prop driven as browser history actions are not
            // re-rendered synchronously. Setting into state makes our render order more reliable.
            this.setState({
                issueKey: attributes.query.selectedIssue ?? ''
            });
        }, this.startInteraction = (key, properties)=>{
            if (!this.activeInteractions.includes(key)) this.activeInteractions.push(key);
            const interaction = this.interactions[key];
            if (interaction) {
                interaction.properties = properties || {};
                interaction.metrics.start();
            }
        }, this.endInteractions = ()=>{
            this.activeInteractions.forEach((key)=>{
                this.interactions[key]?.metrics.stop({
                    customData: this.interactions[key]?.properties
                });
            });
            this.activeInteractions = [];
        }, this.getQueryStringParams = ()=>{
            if ((0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes')) throw new Error('Method `getQueryStringParams` deprecated behind jira_nin_last_used_jql_tech_changes and to be removed on cleanup');
            const { location: location } = this.props;
            const { filter: filter, jql: jql } = (0, $b5RwB.parse)(location?.search ?? '', {
                // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
                arrayFormat: 'comma'
            });
            return {
                filter: filter,
                jql: jql
            };
        };
        const { location: location } = props;
        this.activeInteractions = [];
        this.interactions = $4253c39628e0acb7$var$initInteractions();
        if ((0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes')) {
            this.state = {
                initialised: false,
                issueKey: this.props.selectedIssue ?? ''
            };
            return;
        }
        if ((0, $4cTDP.fg)('add_nin_press_interactions')) {
            // Ensure filter change event does not fire on initial loads & transitions because it
            // will cause the page load interaction to be aborted
            const { filter: filter } = this.getQueryStringParams();
            this.lastFilter = filter;
        }
        const query = (0, $b5RwB.parse)(location?.search ?? '');
        const issueKey = query.selectedIssue ?? '';
        this.state = {
            initialised: false,
            issueKey: issueKey
        };
    }
    shouldComponentUpdate(nextProps, nextState) {
        if ((0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes')) return !((0, $fsisP.isShallowEqual)(this.props, nextProps) && (0, $fsisP.isShallowEqual)(this.state, nextState));
        return true;
    }
    componentDidUpdate(prevProps) {
        if ((0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes')) {
            const prevIssueKey = prevProps.selectedIssue ?? '';
            const issueKey = this.props.selectedIssue ?? '';
            // If issue key has changed from the router and does not match our internal key then update our state
            if (issueKey !== prevIssueKey && issueKey !== this.state.issueKey) this.setState({
                issueKey: issueKey
            });
            return;
        }
        const prevQuery = (0, $b5RwB.parse)(prevProps.location?.search ?? '');
        const query = (0, $b5RwB.parse)(this.props.location?.search ?? '');
        const prevIssueKey = prevQuery.selectedIssue ?? '';
        const issueKey = query.selectedIssue ?? '';
        // If issue key has changed from the router and does not match our internal key then update our state
        if (issueKey !== prevIssueKey && issueKey !== this.state.issueKey) this.setState({
            issueKey: issueKey
        });
    }
    push(newParams, shouldReplace = false) {
        if ((0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes')) throw new Error('Method `push` deprecated behind jira_nin_last_used_jql_tech_changes and to be removed on cleanup');
        const { match: match, push: push, location: location, replace: replace } = this.props;
        const historyAction = shouldReplace ? replace : push;
        const oldIssueKey = this.state.issueKey;
        const { projectKey: projectKey = match?.params.projectKey ?? '', issueKey: issueKey = oldIssueKey ?? '', ...params } = newParams;
        const newProjectKey = newParams.projectKey;
        const oldProjectKey = match?.params.projectKey;
        const projectKeyChanged = typeof newProjectKey !== 'undefined' && newProjectKey !== oldProjectKey;
        const newIssueKey = newParams.issueKey;
        const issueKeyParamsAreDefined = !!(newIssueKey || oldIssueKey);
        const issueKeyChanged = issueKeyParamsAreDefined && newIssueKey !== oldIssueKey;
        // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
        const query = (0, $b5RwB.parse)(location?.search ?? '', {
            arrayFormat: 'comma'
        });
        const queryParamsChanged = Object.keys(params).length !== 0 && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))((0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))(params, (param)=>param != null), query);
        if (projectKeyChanged || issueKeyChanged || queryParamsChanged) {
            const queryParams = {
                ...query,
                ...params,
                selectedIssue: newIssueKey
            };
            if (newIssueKey == null || newIssueKey === '') delete queryParams.selectedIssue;
            const navigationItemId = match?.params.navigationItemId;
            const navigationItemIdSegment = navigationItemId && (0, $4cTDP.fg)('saved_list_view_technical_changes') ? `${navigationItemId}/` : '';
            // @ts-expect-error - React-resource-router's external type interface claims push/replace only accept "string", however the underlying code works with the `Location` object we're using
            historyAction({
                pathname: `${(match && (0, $hLPih.getUrlPrefix)(match.url)) ?? ''}/projects/${projectKey}/${(0, $4cTDP.fg)('jira_list_nin_merge') ? 'list' : 'issues'}/${navigationItemIdSegment}`,
                search: (0, $b5RwB.stringify)(queryParams, // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
                {
                    arrayFormat: 'comma'
                })
            });
        }
        if (issueKeyChanged) // We explicitly set this into state instead of being purely prop driven as browser history actions are not
        // re-rendered synchronously. Setting into state makes our render order more reliable.
        this.setState({
            issueKey: issueKey ?? ''
        });
        return true;
    }
    render() {
        let projectKey;
        let filter;
        let jql;
        if ((0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes')) projectKey = this.props.projectKey;
        else {
            const { match: match, location: location } = this.props;
            projectKey = match?.params?.projectKey;
            const params = (0, $4cTDP.fg)('add_nin_press_interactions') ? this.getQueryStringParams() : // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
            (0, $b5RwB.parse)(location?.search ?? '', {
                arrayFormat: 'comma'
            });
            filter = params.filter;
            jql = params.jql;
            this.onStartFilterChangeInteractionIfAny(filter);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iEXnd.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4253c39628e0acb7$var$MaybeNinErrorBoundary, {
            id: "unhandled",
            packageName: "jiraSpaAppsProjectIssueNavigator"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLEbR.ProjectSubProductUpdater), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aPS2z.default), {
            projectKey: projectKey ?? null
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lUYYk.default), {
            showNav3Header: this.props.showNav3Header,
            projectKey: projectKey ?? '',
            issueKey: this.state.issueKey,
            jql: jql,
            onChangeIssue: this.onChangeIssue,
            onChangeJqlAndGroupBy: (0, $4cTDP.fg)('jira_list_nin_merge_technical_changes') ? this.onChangeJqlAndGroupBy : undefined,
            onPageDataLoad: this.onPageDataLoad,
            onChangeColumnConfiguration: this.onChangeColumnConfiguration,
            onChangeJql: this.onChangeJql,
            initialised: this.state.initialised,
            onRefinement: this.onRefinement,
            onSetView: this.onSetView,
            view: this.view && !(0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes') ? (0, $eibCx.convertToView)(this.view) : undefined,
            filter: filter,
            onChangeFilter: this.onChangeFilter,
            preloadedEntryPoints: this.props.preloadedEntryPoints
        })));
    }
}
const $4253c39628e0acb7$var$ProjectIssueNavigatorSPAWithRouterSubscriber = ({ entryPoints: entryPoints })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "project-issue-navigator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lcB5K.RouterActions), null, ({ push: push, replace: replace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivzXw.RouterSubscriber), null, ({ location: location, match: match, route: route })=>{
            let path = match.url;
            const navigationItemId = match.params.navigationItemId ?? '';
            const issueKeyRegex = new RegExp(`^${(0, $eacwX.ISSUEKEY_REGEX)}$`);
            const isIssueKey = issueKeyRegex.test(navigationItemId);
            const queryParams = (0, $b5RwB.parse)(location.search);
            /*
           * At some point the route config was changed from:
           *
           * .../:issueKey
           * to
           * .../:navigationItemId
           *
           * Where the :issueKey path param represented the selected issue key
           * and the :navigationItemId path param represents the navigation item ID.
           *
           * We are performing a frontend redirect when we detect that an issue key
           * is present in the position where the navigation item ID is expected.
           *
           * This ensures we maintain backwards compatibility with existing links
           * when performing a SPA transition.
           */ if (isIssueKey) {
                const pathSegments = path.split('/').filter(Boolean);
                const updatedPathSegments = pathSegments.filter((segment)=>segment !== navigationItemId);
                path = `/${updatedPathSegments.join('/')}`;
                queryParams.selectedIssue = navigationItemId;
            }
            let url = path;
            if (Object.keys(queryParams).length) url += `?${(0, $b5RwB.stringify)(queryParams)}`;
            if (isIssueKey) {
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'route redirected', {
                    didIssueKeyRedirect: true
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
                    to: url
                });
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4253c39628e0acb7$var$ProjectIssueNavigatorSPAWrapper, {
                push: push,
                location: location,
                match: match,
                replace: replace,
                showNav3Header: (0, $4cTDP.fg)('jira_list_nin_merge') ? route.name === 'servicedesk-issues' || route.name === 'servicedesk-list' : route.name === 'servicedesk-issues',
                preloadedEntryPoints: entryPoints,
                pushOrReplace: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
                projectKey: undefined,
                selectedIssue: undefined
            });
        })));
};
const $4253c39628e0acb7$var$ProjectIssueNavigatorSPA = ({ entryPoints: entryPoints })=>{
    const query = (0, $eKcrE.useQueryParams)();
    const params = (0, $eKcrE.usePathParams)();
    const route = (0, $eKcrE.useCurrentRoute)();
    const pushOrReplace = (0, $cZKSy.useRoutePushOrReplace)(query, params, route);
    // Handle redirecting from /:issueKey path param to ?selectedIssue query param
    (0, $cwIb6.useSelectedIssueParamRedirect)(params, pushOrReplace);
    (0, $7NJNZ.useFilterChangeInteraction)(query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "project-issue-navigator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4253c39628e0acb7$var$ProjectIssueNavigatorSPAWrapper, {
        pushOrReplace: pushOrReplace,
        projectKey: params.projectKey,
        selectedIssue: query.selectedIssue,
        showNav3Header: (0, $4cTDP.fg)('jira_list_nin_merge') ? route.name === 'servicedesk-issues' || route.name === 'servicedesk-list' : route.name === 'servicedesk-issues',
        preloadedEntryPoints: entryPoints
    }));
};
var $4253c39628e0acb7$export$2e2bcd8739ae039 = (0, $bJscI.componentWithFG)('jira_nin_last_used_jql_tech_changes', /*#__PURE__*/ (0, $eJOHy.memo)($4253c39628e0acb7$var$ProjectIssueNavigatorSPA), /*#__PURE__*/ (0, $eJOHy.memo)($4253c39628e0acb7$var$ProjectIssueNavigatorSPAWithRouterSubscriber));

});
parcelRegister("aPS2z", function(module, exports) {
$parcel$export(module.exports, "isProjectArchivedCondition", () => $09ee4a6709eeeeea$export$34040938aec58f90);
$parcel$export(module.exports, "RedirectToArchivedPage", () => $09ee4a6709eeeeea$export$36db2ddf32573bd8);
$parcel$export(module.exports, "default", () => $09ee4a6709eeeeea$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2aY2d = parcelRequire("2aY2d");

var $2mHfh = parcelRequire("2mHfh");

const $09ee4a6709eeeeea$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
const $09ee4a6709eeeeea$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
    if (projectKey === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2aY2d.ProjectContextProvider), null, (projectContext)=>$09ee4a6709eeeeea$export$34040938aec58f90(projectContext.data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: (0, $5e412e91f864721a$export$9a6ccb84170b615b)
        }) : null);
};
const $09ee4a6709eeeeea$export$36db2ddf32573bd8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: (0, $5e412e91f864721a$export$9a6ccb84170b615b)
    });
var $09ee4a6709eeeeea$export$2e2bcd8739ae039 = $09ee4a6709eeeeea$var$RedirectIfProjectArchived;

});
const $5e412e91f864721a$export$9a6ccb84170b615b = '/jira/errors/project-archived';


parcelRegister("dLEbR", function(module, exports) {
$parcel$export(module.exports, "ProjectSubProductUpdater", () => $22f8ab1c02faa372$export$bfbf80c212b0dcb9);

var $eJOHy = parcelRequire("eJOHy");

var $6nVJI = parcelRequire("6nVJI");

var $jRGAq = parcelRequire("jRGAq");

var $figsJ = parcelRequire("figsJ");

var $cZTMg = parcelRequire("cZTMg");
const $22f8ab1c02faa372$export$bfbf80c212b0dcb9 = ({ allowMonolithDeferral: allowMonolithDeferral = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6nVJI.ContainerContextSubscriber), null, ({ data: data })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, data && (0, $jRGAq.isProjectContext)(data) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cZTMg.SubProductUpdater), {
            subProduct: (0, $figsJ.subProductFromProjectTypeForAnalytics)(data.project.type),
            allowMonolithDeferral: allowMonolithDeferral
        })));

});
parcelRegister("jRGAq", function(module, exports) {
$parcel$export(module.exports, "isProjectContext", () => $ac0d9f43e2f849b3$export$d46e75e464bf2407);
$parcel$export(module.exports, "isUserContext", () => $ac0d9f43e2f849b3$export$8d1083037a4a6250);
const $ac0d9f43e2f849b3$export$d46e75e464bf2407 = (containerContext)=>containerContext.project !== undefined;
const $ac0d9f43e2f849b3$export$8d1083037a4a6250 = (containerContext)=>containerContext.user !== undefined;

});

parcelRegister("cZTMg", function(module, exports) {
$parcel$export(module.exports, "SubProductUpdater", () => $e3e218a75c21102a$export$eb40d3df56aa5c53);

var $eJOHy = parcelRequire("eJOHy");

var $5onjV = parcelRequire("5onjV");

var $figsJ = parcelRequire("figsJ");

var $5nYJB = parcelRequire("5nYJB");

var $aO6tw = parcelRequire("aO6tw");

var $adiVF = parcelRequire("adiVF");
const $e3e218a75c21102a$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $adiVF.isSubProductProps)(props) ? props.subProduct : (0, $figsJ.subProductFromProjectTypeForAnalytics)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5onjV.default), {
        op: (0, $aO6tw.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5nYJB.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("5nYJB", function(module, exports) {
$parcel$export(module.exports, "default", () => $82e051cbb2adac57$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3aa9n = parcelRequire("3aa9n");

var $8VfmF = parcelRequire("8VfmF");
const $82e051cbb2adac57$var$TagMauEvent = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3aa9n.default), {
        op: (0, $8VfmF.default),
        args: [
            subProduct
        ]
    });
var $82e051cbb2adac57$export$2e2bcd8739ae039 = $82e051cbb2adac57$var$TagMauEvent;

});
parcelRegister("8VfmF", function(module, exports) {
$parcel$export(module.exports, "default", () => $811461c69dc55236$export$2e2bcd8739ae039);

var $eSnSE = parcelRequire("eSnSE");

var $3ugTQ = parcelRequire("3ugTQ");
const $811461c69dc55236$var$tagMauEvent = (subProduct)=>{
    (0, $3ugTQ.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};
var $811461c69dc55236$export$2e2bcd8739ae039 = $811461c69dc55236$var$tagMauEvent;

});


parcelRegister("aO6tw", function(module, exports) {
$parcel$export(module.exports, "default", () => $53a2c520c0b2b632$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $97BGz = parcelRequire("97BGz");
var $iyT45 = parcelRequire("iyT45");
var $4T9yL = parcelRequire("4T9yL");


var $eSnSE = parcelRequire("eSnSE");

var $2Mqjh = parcelRequire("2Mqjh");
const $53a2c520c0b2b632$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
const $53a2c520c0b2b632$var$setCurrentSubProduct = async (subProduct, allowMonolithDeferral)=>{
    (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $c2258fadc4095860$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $53a2c520c0b2b632$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4T9yL.waitForHeritage)() : null, ()=>(0, $97BGz.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ],
            // jira/analytics/sub-product-resolver is not using any heritage code
            isolatedFromHeritage: true
        }), ()=>(0, $iyT45.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $eSnSE.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };
var $53a2c520c0b2b632$export$2e2bcd8739ae039 = $53a2c520c0b2b632$var$setCurrentSubProduct;

});
const $c2258fadc4095860$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("adiVF", function(module, exports) {
$parcel$export(module.exports, "isSubProductProps", () => $b41c599c0dbb9c69$export$c3063d6d7a8c075f);
const $b41c599c0dbb9c69$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});



parcelRegister("iEXnd", function(module, exports) {
$parcel$export(module.exports, "PRODUCT_START_MARK", () => $528da7e985f30ee4$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $528da7e985f30ee4$export$2a999c5f84501025);

var $6uWhG = parcelRequire("6uWhG");
const $528da7e985f30ee4$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $528da7e985f30ee4$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($528da7e985f30ee4$export$8e54fca0a680fdfd);
        (0, $6uWhG.setMark)($528da7e985f30ee4$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("ad2Dp", function(module, exports) {
$parcel$export(module.exports, "NinErrorBoundary", () => $4ee5781ea33fce97$export$b63c3d14be9f8b13);

var $eJOHy = parcelRequire("eJOHy");

var $cblKs = parcelRequire("cblKs");

var $lBYgs = parcelRequire("lBYgs");

var $5vQ2T = parcelRequire("5vQ2T");

var $aqnJa = parcelRequire("aqnJa");

var $2aY2d = parcelRequire("2aY2d");

var $8Uqf3 = parcelRequire("8Uqf3");

var $1BZ8a = parcelRequire("1BZ8a");

var $jiTA8 = parcelRequire("jiTA8");

var $dMM78 = parcelRequire("dMM78");

var $7wFII = parcelRequire("7wFII");

var $4cTDP = parcelRequire("4cTDP");

var $bFY6o = parcelRequire("bFY6o");

var $iRahl = parcelRequire("iRahl");
const $4ee5781ea33fce97$var$ANALYTICS_SOURCE = 'issue-navigator';
const $4ee5781ea33fce97$export$b63c3d14be9f8b13 = ({ children: children, id: id, packageName: packageName })=>{
    const { data: project } = (0, $2aY2d.useProjectContext)();
    const onExperienceStart = (0, $8Uqf3.useExperienceStart)({
        experience: (0, $iRahl.EXPERIENCE_NAME),
        experienceId: undefined,
        analyticsSource: $4ee5781ea33fce97$var$ANALYTICS_SOURCE
    });
    const appEditions = (0, $1BZ8a.useAppEditions)();
    const application = project?.projectType ? (0, $lBYgs.getApplicationForProject)(project.projectType) : null;
    const edition = application ? (0, $cblKs.getEdition)(application, appEditions) : null;
    let analyticsAttributes = {
        application: application,
        edition: edition
    };
    const isEmbed = (0, $jiTA8.useIsEmbedMode)();
    analyticsAttributes = {
        ...analyticsAttributes,
        isEmbed: isEmbed
    };
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $iRahl.EXPERIENCE_NAME),
        attributes: analyticsAttributes
    });
    const onExperienceAbort = (0, $bFY6o.useExperienceAbort)({
        experience: (0, $iRahl.EXPERIENCE_NAME),
        attributes: analyticsAttributes
    });
    const onError = (0, $eJOHy.useCallback)((location, error)=>{
        if (!(0, $dMM78.isHttpClientErrorResponse)(error)) {
            onExperienceStart();
            if ((0, $7wFII.isAbortableError)(error) && (0, $4cTDP.fg)('improve_abortable_errors_experience_tracker')) {
                onExperienceAbort(location, {
                    errorMessage: error.message,
                    location: location
                });
                return;
            }
            onExperienceFail(location, error);
        }
    }, [
        onExperienceFail,
        onExperienceStart,
        onExperienceAbort
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        onError: onError,
        sendToPrivacyUnsafeSplunk: true
    }, children);
};

});
parcelRegister("7wFII", function(module, exports) {
$parcel$export(module.exports, "isAbortableError", () => $a93b392b7e4fefa9$export$e05e0fb17c2ab75a);

var $6NFx3 = parcelRequire("6NFx3");

var $9Dhvc = parcelRequire("9Dhvc");

var $14RSn = parcelRequire("14RSn");

var $dMM78 = parcelRequire("dMM78");

var $4cTDP = parcelRequire("4cTDP");
const $a93b392b7e4fefa9$export$e05e0fb17c2ab75a = (error)=>{
    const statusCode = $a93b392b7e4fefa9$var$extractStatusCode(error);
    if ((0, $dMM78.isHttpClientErrorStatusCode)(statusCode) || !statusCode && (0, $dMM78.isClientFetchError)(error) || error?.name === (0, $14RSn.VALIDATION_ERROR_NAME)) return true;
    return false;
};
const $a93b392b7e4fefa9$var$getStatusCodeFromGraphQLErrors = (graphQLErrors)=>{
    const statusCodes = graphQLErrors.map((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(e, [
            'extensions',
            'statusCode'
        ])).filter((statusCode)=>!!statusCode);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($6NFx3)))(statusCodes);
    return statusCode || null;
};
const $a93b392b7e4fefa9$var$extractStatusCode = (error)=>{
    const errorStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'statusCode'
    ], null);
    const graphQLErrors = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'graphQLErrors'
    ], null);
    const networkError = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'networkError'
    ], null);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(networkError, [
        'statusCode'
    ], null);
    const relayErrors = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'source',
        'errors'
    ], null);
    if (typeof errorStatusCode === 'number') return errorStatusCode;
    if (typeof statusCode === 'number') return statusCode;
    if (Array.isArray(graphQLErrors) && graphQLErrors.length > 0) return $a93b392b7e4fefa9$var$getStatusCodeFromGraphQLErrors(graphQLErrors);
    if (Array.isArray(relayErrors) && relayErrors.length > 0 && (0, $4cTDP.fg)('improve_abortable_errors_experience_tracker')) return $a93b392b7e4fefa9$var$getStatusCodeFromGraphQLErrors(relayErrors);
    return null;
};

});
parcelRegister("6NFx3", function(module, exports) {

var $dbOsL = parcelRequire("dbOsL");

var $9wRNl = parcelRequire("9wRNl");

var $d7YnM = parcelRequire("d7YnM");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $4f3789168d11a4da$var$max(array) {
    return array && array.length ? $dbOsL(array, $d7YnM, $9wRNl) : undefined;
}
module.exports = $4f3789168d11a4da$var$max;

});
parcelRegister("dbOsL", function(module, exports) {

var $9D78T = parcelRequire("9D78T");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $99a3725aea015bd0$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$9D78T(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = $99a3725aea015bd0$var$baseExtremum;

});

parcelRegister("9wRNl", function(module, exports) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $6f00d4c0b88cefe1$var$baseGt(value, other) {
    return value > other;
}
module.exports = $6f00d4c0b88cefe1$var$baseGt;

});




parcelRegister("cZKSy", function(module, exports) {
$parcel$export(module.exports, "useRoutePushOrReplace", () => $43cb7c5a178481a4$export$baf3e37cbb2acfd9);

var $eJOHy = parcelRequire("eJOHy");

var $9pL9Y = parcelRequire("9pL9Y");

var $83DiZ = parcelRequire("83DiZ");
const $43cb7c5a178481a4$export$baf3e37cbb2acfd9 = (query, params, route)=>{
    const { pushTo: pushTo, replaceTo: replaceTo } = (0, $83DiZ.useRouterActions)();
    const pushOrReplace = (0, $eJOHy.useCallback)(({ query: newQuery, params: newParams }, shouldReplace = false)=>{
        // Omit any query params that have explicitly been set to undefined
        const updatedQuery = (0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))({
            ...query,
            ...newQuery
        }, (param)=>param != null);
        const historyAction = shouldReplace ? replaceTo : pushTo;
        historyAction(route, {
            query: updatedQuery,
            params: {
                ...params,
                ...newParams
            }
        });
    }, [
        params,
        query,
        pushTo,
        replaceTo,
        route
    ]);
    const pushOrReplaceStable = (0, $eJOHy.useRef)(pushOrReplace);
    pushOrReplaceStable.current = pushOrReplace;
    // We ensure this hook returns a stable function reference to avoid unnecessary re-renders when params change.
    return (0, $eJOHy.useCallback)((attributes, shouldReplace)=>pushOrReplaceStable.current(attributes, shouldReplace), []);
};

});

parcelRegister("cwIb6", function(module, exports) {
$parcel$export(module.exports, "useSelectedIssueParamRedirect", () => $1ea2da86797627e8$export$54e38b73e3eaeb3a);

var $eacwX = parcelRequire("eacwX");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");
const $1ea2da86797627e8$export$54e38b73e3eaeb3a = (params, pushOrReplace)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const navigationItemId = params.navigationItemId ?? '';
    const issueKeyRegex = new RegExp(`^${(0, $eacwX.ISSUEKEY_REGEX)}$`);
    const isIssueKey = issueKeyRegex.test(navigationItemId);
    /*
	 * At some point the route config was changed from:
	 *
	 * .../:issueKey
	 * to
	 * .../:navigationItemId
	 *
	 * Where the :issueKey path param represented the selected issue key
	 * and the :navigationItemId path param represents the navigation item ID.
	 *
	 * We are performing a frontend redirect when we detect that an issue key
	 * is present in the position where the navigation item ID is expected.
	 *
	 * This ensures we maintain backwards compatibility with existing links
	 * when performing a SPA transition.
	 */ if (isIssueKey) {
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'route redirected', {
            didIssueKeyRedirect: true
        });
        pushOrReplace({
            params: {
                navigationItemId: undefined
            },
            query: {
                selectedIssue: navigationItemId
            }
        }, true);
    }
};

});
parcelRegister("eacwX", function(module, exports) {
$parcel$export(module.exports, "ISSUEKEY_REGEX", () => $73cfa692bc7b4588$export$b52c9cee589449a8);
$parcel$export(module.exports, "default", () => $73cfa692bc7b4588$export$2e2bcd8739ae039);

var $3Q6BV = parcelRequire("3Q6BV");
const $73cfa692bc7b4588$export$b52c9cee589449a8 = '([A-Z][A-Z0-9_]+-\\d+)';
/**
 * Returns the issue key if the URL is a valid full page Jira issue URL. It may also include a trailing
 * hash fragment. A matching URL must look like:
 * <host><baseurl>/browse/<issuekey><#hash?>
 * e.g. https://my-jira-instance.atlassian.net/browse/FOO-123#xyz
 */ const $73cfa692bc7b4588$var$matchJiraUrl = (url, host)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($3Q6BV)))(url, {});
    const isMatchingProtocol = parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
    const isMatchingHost = parsedUrl.host === host;
    const matches = parsedUrl.pathname.match(new RegExp(`^\\/browse\\/${$73cfa692bc7b4588$export$b52c9cee589449a8}\\/?$`));
    const issueKey = matches && matches.length > 1 ? matches[1] : null;
    return isMatchingProtocol && isMatchingHost && issueKey || null;
};
var $73cfa692bc7b4588$export$2e2bcd8739ae039 = $73cfa692bc7b4588$var$matchJiraUrl;

});


parcelRegister("7NJNZ", function(module, exports) {
$parcel$export(module.exports, "useFilterChangeInteraction", () => $774c75c5997fd541$export$f334a5375c358f3b);

var $h6i8k = parcelRequire("h6i8k");

var $6d9QY = parcelRequire("6d9QY");

var $82cqT = parcelRequire("82cqT");

var $hLPih = parcelRequire("hLPih");

var $4cTDP = parcelRequire("4cTDP");
const $774c75c5997fd541$export$f334a5375c358f3b = ({ filter: filter })=>{
    const prevFilter = (0, $6d9QY.usePreviousWithInitial)(filter);
    if (prevFilter !== filter && filter != null && ((0, $82cqT.isFilterId)(filter) || (0, $hLPih.isFilterKey)(filter)) && (0, $4cTDP.fg)('add_nin_press_interactions')) (0, $h6i8k.default)('issue-navigator.filter');
};

});

parcelRegister("eKcrE", function(module, exports) {
$parcel$export(module.exports, "useQueryParams", () => $ba375642028a3f33$export$b37ee0d76c6d2fbc);
$parcel$export(module.exports, "usePathParams", () => $ba375642028a3f33$export$4e3059c7b420e415);
$parcel$export(module.exports, "useCurrentRoute", () => $ba375642028a3f33$export$c4b7ea2942f2d0e);

var $kfvK2 = parcelRequire("kfvK2");
const $ba375642028a3f33$export$b37ee0d76c6d2fbc = (0, $kfvK2.createRouterSelector)((state)=>state.query);
const $ba375642028a3f33$export$4e3059c7b420e415 = (0, $kfvK2.createRouterSelector)((state)=>state.match.params);
const $ba375642028a3f33$export$c4b7ea2942f2d0e = (0, $kfvK2.createRouterSelector)((state)=>state.route);

});

parcelRegister("lUYYk", function(module, exports) {
$parcel$export(module.exports, "default", () => $21104aa9edc62ebc$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $c12HM = parcelRequire("c12HM");

var $fGnU6 = parcelRequire("fGnU6");

var $huMFD = parcelRequire("huMFD");

var $4cTDP = parcelRequire("4cTDP");

var $cxKOj = parcelRequire("cxKOj");

var $dydbT = parcelRequire("dydbT");

var $82cqT = parcelRequire("82cqT");

var $dV4qk = parcelRequire("dV4qk");

var $fAgUF = parcelRequire("fAgUF");

var $hbF3h = parcelRequire("hbF3h");

var $iRahl = parcelRequire("iRahl");

var $3Ssg5 = parcelRequire("3Ssg5");

var $2imLM = parcelRequire("2imLM");

var $kGj4V = parcelRequire("kGj4V");

var $dzJIl = parcelRequire("dzJIl");

var $2vBmG = parcelRequire("2vBmG");

var $jUHqr = parcelRequire("jUHqr");

var $9FYIg = parcelRequire("9FYIg");

var $dSkEC = parcelRequire("dSkEC");

var $8k1uC = parcelRequire("8k1uC");

var $dghMS = parcelRequire("dghMS");

var $dZRaT = parcelRequire("dZRaT");

var $gwH93 = parcelRequire("gwH93");

var $hLPih = parcelRequire("hLPih");

var $cH6Qf = parcelRequire("cH6Qf");

var $eJrcF = parcelRequire("eJrcF");

var $bJscI = parcelRequire("bJscI");

var $aaLZH = parcelRequire("aaLZH");

var $2MmuH = parcelRequire("2MmuH");
const $21104aa9edc62ebc$var$getSearchInput = (projectKey, jql, filter)=>{
    const filterInput = (0, $82cqT.isFilterId)(filter) ? filter : (0, $hLPih.mapFilterToJql)(projectKey, filter);
    return (0, $3Ssg5.getSearchInput)(jql, filterInput);
};
const $21104aa9edc62ebc$var$getFilterForAnalytics = (filter)=>{
    return filter && ((0, $82cqT.isFilterId)(filter) || (0, $hLPih.isFilterKey)(filter)) ? filter : 'default';
};
const $21104aa9edc62ebc$var$useProjectAttributes = ()=>{
    const { data: projectContext } = (0, $eJrcF.useResource)((0, $dZRaT.projectContextResource));
    let resolvedProjectConfig;
    switch(projectContext?.simplified){
        case true:
            resolvedProjectConfig = (0, $FhXEJ.ProjectStyle).NEXT_GEN;
            break;
        case false:
            resolvedProjectConfig = (0, $FhXEJ.ProjectStyle).CLASSIC;
            break;
        default:
            resolvedProjectConfig = '';
    }
    const resolvedProjectType = projectContext?.projectType || '';
    return (0, $eJOHy.useMemo)(()=>({
            projectConfig: resolvedProjectConfig,
            projectType: resolvedProjectType
        }), [
        resolvedProjectConfig,
        resolvedProjectType
    ]);
};
const $21104aa9edc62ebc$var$useIssueTableProps = (projectKey, preloadedEntryPoints)=>{
    return (0, $eJOHy.useMemo)(()=>({
            projectContext: projectKey,
            isGroupingSupported: (0, $cxKOj.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false) && (0, $cxKOj.expVal)('jira_spreadsheet_component_grouping', 'isGroupingEnabled', false),
            preloadedEntryPoints: {
                nativeIssueTableEntryPoint: preloadedEntryPoints?.nativeIssueTableEntryPoint
            }
        }), [
        projectKey,
        preloadedEntryPoints?.nativeIssueTableEntryPoint
    ]);
};
const $21104aa9edc62ebc$var$useGlobalScopeEnrolment = ()=>{
    const { data: globalEnrolmentData } = (0, $eJrcF.useResource)((0, $dSkEC.isNinGlobalScopeEnrolmentEnabledResource));
    if ((0, $4cTDP.fg)('nin_remove_global_scope_enrolment')) return;
    if (globalEnrolmentData !== null && globalEnrolmentData !== undefined) (0, $dV4qk.setIsGlobalScopeEnrolmentEnabledInLocalStorage)(globalEnrolmentData);
};
/**
 * Default search input value for type safety when `jira_nin_last_used_jql_tech_changes` is enabled.
 * Remove on FG cleanup.
 */ const $21104aa9edc62ebc$var$deprecatedSearchInput = {
    jql: '',
    type: (0, $iRahl.SearchInputTypes).JQL
};
const $21104aa9edc62ebc$var$MaybeReportErrors = (0, $bJscI.componentWithFG)('improve_nin_slo_events', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children), (0, $fGnU6.ReportErrors));
const $21104aa9edc62ebc$var$AsyncProjectIssueNavigatorWrapperOld = ({ filter: filter, jql: jqlParam, initialised: initialised, view: view, projectKey: projectKey, showNav3Header: showNav3Header = false, ...props })=>{
    const getServerTimeUFO = (0, $huMFD.useServerTimeUFO)();
    const defaultJql = (0, $hLPih.getDefaultJql)(projectKey);
    let onFilterKeyToJql;
    let searchInput;
    if ((0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        onFilterKeyToJql = (0, $eJOHy.useCallback)((filterToMap)=>(0, $hLPih.mapFilterToJql)(projectKey, filterToMap), [
            projectKey
        ]);
        searchInput = $21104aa9edc62ebc$var$deprecatedSearchInput;
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const onMutateJqlParam = (0, $3Ssg5.useUpdateUrlQueryParamCallback)('jql');
        const jql = (0, $3Ssg5.getJqlFromParamValues)(defaultJql, jqlParam, filter, (0, $hLPih.mapFilterToJql).bind(undefined, projectKey), onMutateJqlParam);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        searchInput = (0, $eJOHy.useMemo)(()=>$21104aa9edc62ebc$var$getSearchInput(projectKey, jql, filter), [
            projectKey,
            jql,
            filter
        ]);
    }
    const issueTableProps = $21104aa9edc62ebc$var$useIssueTableProps(projectKey, props.preloadedEntryPoints);
    const projectAttributes = $21104aa9edc62ebc$var$useProjectAttributes();
    $21104aa9edc62ebc$var$useGlobalScopeEnrolment();
    const response = (0, $9FYIg.useRelayResource)((0, $8k1uC.issueNavigatorRelayResource));
    const { queryReference: queryReference } = response;
    const filterResponse = (0, $9FYIg.useRelayResource)((0, $8k1uC.issueNavigatorFilterRelayResource));
    const filterQueryReference = filterResponse.queryReference;
    let hydrationQueryReference = null;
    let filterRefinementQueryReference = null;
    if ((0, $cxKOj.expVal)('list_lovability_improving_filters_exp', 'isEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const filterRefinementResponse = (0, $9FYIg.useRelayResource)((0, $8k1uC.issueNavigatorFilterRefinementRelayResource));
        filterRefinementQueryReference = filterRefinementResponse.queryReference;
    } else {
        const issueNavigatorHydrationRelayResource = (0, $4cTDP.fg)('render_jql_builder_in_ssr') ? (0, $8k1uC.issueNavigatorHydrationRelayResource) : (0, $8k1uC.issueNavigatorHydrationRelayResourceBrowserOnly);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const hydrationResponse = (0, $9FYIg.useRelayResource)(issueNavigatorHydrationRelayResource);
        hydrationQueryReference = hydrationResponse.queryReference;
    }
    const jqlBuilderProps = (0, $huMFD.useJqlBuilderProps)(hydrationQueryReference, props.preloadedEntryPoints, (0, $cxKOj.expVal)('list_lovability_improving_filters_exp', 'isEnabled', false) ? projectKey : undefined);
    const attributesNew = (0, $eJOHy.useMemo)(()=>(0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes') ? {
            navigatorScope: 'project',
            ...(0, $4cTDP.fg)('analytics_for_issue_key_included_in_nin_url') && {
                isIssueKeyPresent: !!props.issueKey
            },
            ...projectAttributes
        } : undefined, [
        projectAttributes,
        props.issueKey
    ]);
    // During SSR our issueNavigatorRelayResource must wait until the query finishes before returning the
    // queryReference as SSR does not support Suspense. We return the page skeleton as an intermediary state until
    // the query has resolved (or SSR times out and the query is loaded on the client).
    if (queryReference == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gwH93.ProjectIssueNavigatorSkeleton), null);
    // During SSR our issueNavigatorFilterRelayResource must wait until the query finishes before returning the
    // queryReference as SSR does not support Suspense. We return the page skeleton as an intermediary state until
    // the query has resolved (or SSR times out and the query is loaded on the client).
    if (filterQueryReference == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gwH93.ProjectIssueNavigatorSkeleton), null);
    // During SSR our issueNavigatorHydrationRelayResource must wait until the query finishes before returning the
    // queryReference as SSR does not support Suspense. We return the page skeleton as an intermediary state until
    // the query has resolved (or SSR times out and the query is loaded on the client).
    if (hydrationQueryReference == null && !(0, $cxKOj.expVal)('list_lovability_improving_filters_exp', 'isEnabled', false) && (0, $4cTDP.fg)('render_jql_builder_in_ssr')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gwH93.ProjectIssueNavigatorSkeleton), null);
    const attributes = (0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes') ? attributesNew : {
        navigatorScope: 'project',
        viewLayout: view || '',
        jql: !!jqlParam,
        filter: $21104aa9edc62ebc$var$getFilterForAnalytics(filter),
        ...projectAttributes
    };
    const extraInfo = {
        scope: 'project',
        filterId: $21104aa9edc62ebc$var$getFilterForAnalytics(filter),
        isJqlParamPresent: !!jqlParam,
        ...(0, $4cTDP.fg)('analytics_for_issue_key_included_in_nin_url') && {
            isIssueKeyPresent: !!props.issueKey
        },
        ...initialised && getServerTimeUFO?.(),
        ...attributes
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        attributes: attributes,
        ...filter !== null && filter !== undefined && ((0, $82cqT.isFilterId)(filter) || (0, $hLPih.isFilterKey)(filter)) && !(0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes') && {
            containers: {
                issueFilter: {
                    id: filter
                }
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($21104aa9edc62ebc$var$MaybeReportErrors, {
        id: "unhandled",
        packageName: "jiraSpaAppsProjectIssueNavigator",
        teamName: "empanada",
        sendToPrivacyUnsafeSplunk: true,
        attributes: (0, $c12HM.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "project-issue-navigator-app",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gwH93.ProjectIssueNavigatorSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($21104aa9edc62ebc$export$98541361bc463108, {
        isConditionalFormattingEnabled: (0, $4cTDP.fg)('jira_list_conditional_formatting'),
        isConditionalFormattingEditingEnabled: (0, $4cTDP.fg)('saved_list_view_technical_changes'),
        isSaveFilterButtonEnabled: !(0, $cxKOj.expVal)('jira-issue-navigator-saved-filters-menu', 'isEnabled', false),
        isProjectQuickstartOnboardingEnabled: (0, $4cTDP.fg)('jira_list_nin_merge'),
        isMakeSpaceForGlobalRovoButtonEnabled: (0, $4cTDP.fg)('global_rovo_button_in_jira')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzJIl.default), {
        ...props,
        showNav3Header: showNav3Header,
        projectKey: projectKey,
        defaultJql: defaultJql,
        queryReference: queryReference || undefined,
        filterQueryReference: filterQueryReference,
        searchInput: searchInput,
        onFilterKeyToJql: onFilterKeyToJql,
        issueTableProps: issueTableProps,
        issueAppEntryPoint: (0, $4cTDP.fg)('nin_issue_app_conditional_entrypoint') ? props.preloadedEntryPoints?.issueAppEntryPoint : undefined,
        isIssueHierarchySupportEnabled: (0, $cxKOj.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false),
        isHideDoneSupportEnabled: (0, $cxKOj.expVal)('jira_list_hide_done_items', 'isEnabled', false),
        isIssueRankingSupportEnabled: (0, $4cTDP.fg)('jsc_list_reranking_gate'),
        jqlBuilderProps: (0, $4cTDP.fg)('jql_builder_basic_ssr_stability_fixes') ? jqlBuilderProps : {
            maybeHydrationQueryReference: hydrationQueryReference || undefined
        },
        isMergedColumnSupportEnabled: (0, $4cTDP.fg)('jira_list_merged_column_gate'),
        isFrozenColumnSupportEnabled: (0, $4cTDP.fg)('issue_table_frozen_columns'),
        isGridNavigationEnabled: (0, $cxKOj.expVal)('nin_grid_navigation_experiment', 'isGridNavigationEnabled', false),
        isInlineFieldConfigEnabled: (0, $cxKOj.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false),
        isInBetweenColumnPickerEnabled: (0, $4cTDP.fg)('jira_inline_field_config_gate'),
        isPostOfficePlacementEnabled: !showNav3Header && (0, $4cTDP.fg)('jira_list_nin_merge'),
        isFilterRefinementEnabled: (0, $cxKOj.expVal)('list_lovability_improving_filters_exp', 'isEnabled', false),
        filterRefinementQueryReference: filterRefinementQueryReference
    })), (0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dghMS.IssueNavigatorSubmitApdex), {
        appName: "project-issue-navigator",
        attributes: attributes,
        scope: "project"
    }), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2MmuH.WelcomeModal), null)) : null))), initialised && !(0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUHqr.default), {
        appName: "project-issue-navigator",
        isExpectedToHaveSsr: true,
        withMarks: [
            (0, $2vBmG.appBundleReadyMark),
            (0, $2vBmG.prefetchApiReadyMark)
        ],
        ttrSlo: 3000,
        ttiSlo: 4000,
        extra: extraInfo,
        metric: (0, $fAgUF.NINPageLoad)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cH6Qf.SpaStatePageReady), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2MmuH.WelcomeModal), null)) : null);
};
const $21104aa9edc62ebc$var$AsyncProjectIssueNavigatorContent = (allProps)=>{
    const { filter: filter, jql: jqlParam, initialised: initialised, view: view, projectKey: projectKey, showNav3Header: showNav3Header = false, ...props } = allProps;
    const defaultJql = (0, $hLPih.getDefaultJql)(projectKey);
    let onFilterKeyToJql;
    let searchInput;
    if ((0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        onFilterKeyToJql = (0, $eJOHy.useCallback)((filterToMap)=>(0, $hLPih.mapFilterToJql)(projectKey, filterToMap), [
            projectKey
        ]);
        searchInput = $21104aa9edc62ebc$var$deprecatedSearchInput;
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const onMutateJqlParam = (0, $3Ssg5.useUpdateUrlQueryParamCallback)('jql');
        const jql = (0, $3Ssg5.getJqlFromParamValues)(defaultJql, jqlParam, filter, (0, $hLPih.mapFilterToJql).bind(undefined, projectKey), onMutateJqlParam);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        searchInput = (0, $eJOHy.useMemo)(()=>$21104aa9edc62ebc$var$getSearchInput(projectKey, jql, filter), [
            projectKey,
            jql,
            filter
        ]);
    }
    const issueTableProps = $21104aa9edc62ebc$var$useIssueTableProps(projectKey, props.preloadedEntryPoints);
    const projectAttributes = $21104aa9edc62ebc$var$useProjectAttributes();
    $21104aa9edc62ebc$var$useGlobalScopeEnrolment();
    const { data: queryReference } = (0, $dydbT.useSuspenseResource)((0, $8k1uC.issueNavigatorRelayResource));
    const { data: filterQueryReference } = (0, $dydbT.useSuspenseResource)((0, $8k1uC.issueNavigatorFilterRelayResource));
    let hydrationQueryReference = null;
    let filterRefinementQueryReference = null;
    if ((0, $cxKOj.expVal)('list_lovability_improving_filters_exp', 'isEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const filterRefinementResponse = (0, $9FYIg.useRelayResource)((0, $8k1uC.issueNavigatorFilterRefinementRelayResource));
        filterRefinementQueryReference = filterRefinementResponse.queryReference;
    } else // eslint-disable-next-line react-hooks/rules-of-hooks
    hydrationQueryReference = (0, $dydbT.useSuspenseResource)((0, $8k1uC.issueNavigatorHydrationRelayResource)).data;
    const jqlBuilderProps = (0, $huMFD.useJqlBuilderProps)(hydrationQueryReference, props.preloadedEntryPoints, (0, $cxKOj.expVal)('list_lovability_improving_filters_exp', 'isEnabled', false) ? projectKey : undefined);
    const attributesNew = (0, $eJOHy.useMemo)(()=>(0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes') ? {
            navigatorScope: 'project',
            ...(0, $4cTDP.fg)('analytics_for_issue_key_included_in_nin_url') && {
                isIssueKeyPresent: !!props.issueKey
            },
            ...projectAttributes
        } : undefined, [
        projectAttributes,
        props.issueKey
    ]);
    // We use suspense for loading and error states, but a null reference is still sometimes returned from the resource
    // itself e.g. for anonymous in SSR.
    if (queryReference == null || filterQueryReference == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gwH93.ProjectIssueNavigatorSkeleton), null);
    if (hydrationQueryReference == null && !(0, $cxKOj.expVal)('list_lovability_improving_filters_exp', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gwH93.ProjectIssueNavigatorSkeleton), null);
    const attributes = (0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes') ? attributesNew : {
        navigatorScope: 'project',
        viewLayout: view || '',
        jql: !!jqlParam,
        filter: $21104aa9edc62ebc$var$getFilterForAnalytics(filter),
        ...projectAttributes
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($21104aa9edc62ebc$export$98541361bc463108, {
        isConditionalFormattingEnabled: (0, $4cTDP.fg)('jira_list_conditional_formatting'),
        isConditionalFormattingEditingEnabled: (0, $4cTDP.fg)('saved_list_view_technical_changes'),
        isSaveFilterButtonEnabled: !(0, $cxKOj.expVal)('jira-issue-navigator-saved-filters-menu', 'isEnabled', false),
        isProjectQuickstartOnboardingEnabled: (0, $4cTDP.fg)('jira_list_nin_merge'),
        isMakeSpaceForGlobalRovoButtonEnabled: (0, $4cTDP.fg)('global_rovo_button_in_jira')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzJIl.default), {
        ...props,
        showNav3Header: showNav3Header,
        projectKey: projectKey,
        defaultJql: defaultJql,
        queryReference: queryReference || undefined,
        filterQueryReference: filterQueryReference,
        searchInput: searchInput,
        onFilterKeyToJql: onFilterKeyToJql,
        issueTableProps: issueTableProps,
        issueAppEntryPoint: (0, $4cTDP.fg)('nin_issue_app_conditional_entrypoint') ? props.preloadedEntryPoints?.issueAppEntryPoint : undefined,
        isIssueHierarchySupportEnabled: (0, $cxKOj.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false),
        isHideDoneSupportEnabled: (0, $cxKOj.expVal)('jira_list_hide_done_items', 'isEnabled', false),
        isIssueRankingSupportEnabled: (0, $4cTDP.fg)('jsc_list_reranking_gate'),
        jqlBuilderProps: (0, $4cTDP.fg)('jql_builder_basic_ssr_stability_fixes') ? jqlBuilderProps : {
            maybeHydrationQueryReference: hydrationQueryReference || undefined
        },
        isMergedColumnSupportEnabled: (0, $4cTDP.fg)('jira_list_merged_column_gate'),
        isFrozenColumnSupportEnabled: (0, $4cTDP.fg)('issue_table_frozen_columns'),
        isGridNavigationEnabled: (0, $cxKOj.expVal)('nin_grid_navigation_experiment', 'isGridNavigationEnabled', false),
        isInlineFieldConfigEnabled: (0, $cxKOj.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false),
        isInBetweenColumnPickerEnabled: (0, $4cTDP.fg)('jira_inline_field_config_gate'),
        isPostOfficePlacementEnabled: !showNav3Header && (0, $4cTDP.fg)('jira_list_nin_merge'),
        isFilterRefinementEnabled: (0, $cxKOj.expVal)('list_lovability_improving_filters_exp', 'isEnabled', false),
        filterRefinementQueryReference: filterRefinementQueryReference
    })), (0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dghMS.IssueNavigatorSubmitApdex), {
        appName: "project-issue-navigator",
        attributes: attributes,
        scope: "project"
    }), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2MmuH.WelcomeModal), null)) : null);
};
const $21104aa9edc62ebc$var$AsyncProjectIssueNavigatorBoundaries = (allProps)=>{
    const { filter: filter, jql: jqlParam, initialised: initialised, view: view, projectKey: projectKey, ...props } = allProps;
    const getServerTimeUFO = (0, $huMFD.useServerTimeUFO)();
    const projectAttributes = $21104aa9edc62ebc$var$useProjectAttributes();
    $21104aa9edc62ebc$var$useGlobalScopeEnrolment();
    const attributesNew = (0, $eJOHy.useMemo)(()=>(0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes') ? {
            navigatorScope: 'project',
            ...(0, $4cTDP.fg)('analytics_for_issue_key_included_in_nin_url') && {
                isIssueKeyPresent: !!props.issueKey
            },
            ...projectAttributes
        } : undefined, [
        projectAttributes,
        props.issueKey
    ]);
    const attributes = (0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes') ? attributesNew : {
        navigatorScope: 'project',
        viewLayout: view || '',
        jql: !!jqlParam,
        filter: $21104aa9edc62ebc$var$getFilterForAnalytics(filter),
        ...projectAttributes
    };
    const extraInfo = {
        scope: 'project',
        filterId: $21104aa9edc62ebc$var$getFilterForAnalytics(filter),
        isJqlParamPresent: !!jqlParam,
        ...(0, $4cTDP.fg)('analytics_for_issue_key_included_in_nin_url') && {
            isIssueKeyPresent: !!props.issueKey
        },
        ...initialised && getServerTimeUFO?.(),
        ...attributes
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        attributes: attributes,
        ...filter !== null && filter !== undefined && ((0, $82cqT.isFilterId)(filter) || (0, $hLPih.isFilterKey)(filter)) && !(0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes') && {
            containers: {
                issueFilter: {
                    id: filter
                }
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($21104aa9edc62ebc$var$MaybeReportErrors, {
        id: "unhandled",
        packageName: "jiraSpaAppsProjectIssueNavigator",
        teamName: "empanada",
        sendToPrivacyUnsafeSplunk: true,
        attributes: (0, $c12HM.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "project-issue-navigator-app",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gwH93.ProjectIssueNavigatorSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($21104aa9edc62ebc$var$AsyncProjectIssueNavigatorContent, allProps))), initialised && !(0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUHqr.default), {
        appName: "project-issue-navigator",
        isExpectedToHaveSsr: true,
        withMarks: [
            (0, $2vBmG.appBundleReadyMark),
            (0, $2vBmG.prefetchApiReadyMark)
        ],
        ttrSlo: 3000,
        ttiSlo: 4000,
        extra: extraInfo,
        metric: (0, $fAgUF.NINPageLoad)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cH6Qf.SpaStatePageReady), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2MmuH.WelcomeModal), null)) : null);
};
const $21104aa9edc62ebc$var$AsyncProjectIssueNavigator = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jfp-magma-nin-post-hydration-fixes'), $21104aa9edc62ebc$var$AsyncProjectIssueNavigatorBoundaries, $21104aa9edc62ebc$var$AsyncProjectIssueNavigatorWrapperOld);
const $21104aa9edc62ebc$var$NoOp = ({ children: children })=>children;
const $21104aa9edc62ebc$export$98541361bc463108 = (0, $bJscI.componentWithFG)('jira_list_conditional_formatting', (0, $aaLZH.IssueNavigatorFeatureProvider), $21104aa9edc62ebc$var$NoOp);
var $21104aa9edc62ebc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($21104aa9edc62ebc$var$AsyncProjectIssueNavigator);

});
parcelRegister("c12HM", function(module, exports) {
$parcel$export(module.exports, "isLoaderErrorAttributes", () => $9743e4dc371f362f$export$c7209ce2e0d060ea);

var $7Jk3f = parcelRequire("7Jk3f");
const $9743e4dc371f362f$export$c7209ce2e0d060ea = (error)=>({
        isLoaderError: (0, $7Jk3f.isLoaderError)(error)
    });

});

parcelRegister("huMFD", function(module, exports) {
$parcel$export(module.exports, "useServerTimeUFO", () => $427e1e4f2cb07291$export$2f7ed9d4472b5578);
$parcel$export(module.exports, "useJqlBuilderProps", () => $427e1e4f2cb07291$export$a3c886ae4538cc12);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $cxKOj = parcelRequire("cxKOj");

var $7l3Zd = parcelRequire("7l3Zd");

var $7oCTu = parcelRequire("7oCTu");
/*
 * Approximates the server time for the query by first:
 * - checking the SSR-origin response time (if it doesn't time out),
 * - and then the client-origin response time.
 */ const $427e1e4f2cb07291$var$getServerTime = (queryName)=>{
    return globalThis?.window?.SPA_STATE?.['ssr/relay_fetch']?.[queryName]?.duration ?? globalThis?.window?.performance.getEntriesByType('measure').find(({ name: name })=>name.includes(queryName))?.duration;
};
const $427e1e4f2cb07291$export$2f7ed9d4472b5578 = ()=>{
    const serverTimeCallback = (0, $eJOHy.useCallback)(()=>{
        if (// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4cTDP.fg)('add_servertime_to_ufo_for_nin') && !false && globalThis?.window?.performance && globalThis?.window?.SPA_STATE) {
            const hydrationServerTime = $427e1e4f2cb07291$var$getServerTime((0, $7l3Zd.default).params.name);
            const searchServerTime = $427e1e4f2cb07291$var$getServerTime((0, $7oCTu.default).params.name);
            return {
                // Only add statsig ingested custom serverTime data if both server times are available
                serverTime: hydrationServerTime && searchServerTime ? hydrationServerTime + searchServerTime : undefined,
                hydrationServerTime: hydrationServerTime,
                searchServerTime: searchServerTime
            };
        }
        return {
            serverTime: undefined,
            hydrationServerTime: undefined,
            searchServerTime: undefined
        };
    }, []);
    return (0, $4cTDP.fg)('add_servertime_to_ufo_for_nin') ? serverTimeCallback : undefined;
};
const $427e1e4f2cb07291$export$a3c886ae4538cc12 = (hydrationQueryReference, preloadedEntryPoints, projectKey)=>{
    return (0, $eJOHy.useMemo)(()=>({
            maybeHydrationQueryReference: hydrationQueryReference || undefined,
            preloadedEntryPoints: {
                jqlBuilderWithAiEntryPoint: preloadedEntryPoints?.jqlBuilderWithAiEntryPoint
            },
            ...projectKey && (0, $cxKOj.expVal)('list_lovability_improving_filters_exp', 'isEnabled', false) ? {
                projectContext: projectKey
            } : {}
        }), [
        hydrationQueryReference,
        preloadedEntryPoints?.jqlBuilderWithAiEntryPoint,
        projectKey
    ]);
};

});

parcelRegister("dV4qk", function(module, exports) {
$parcel$export(module.exports, "getIsGlobalScopeEnrolmentEnabledFromLocalStorage", () => $0a39e098f20828aa$export$55632339cd4dae9c);
$parcel$export(module.exports, "getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage", () => $0a39e098f20828aa$export$7b78bfe0a111cecf);
$parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledInLocalStorage", () => $0a39e098f20828aa$export$82b2633cf7498c5e);
$parcel$export(module.exports, "setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage", () => $0a39e098f20828aa$export$458eda2352a1e223);

var $3hRxq = parcelRequire("3hRxq");

var $eSnSE = parcelRequire("eSnSE");
const $0a39e098f20828aa$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY = 'jira.nin.global.scope.enrolment';
const $0a39e098f20828aa$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY = 'jira.user.nin.global.scope.enrolment.flag.disabled';
const $0a39e098f20828aa$var$ninGlobalScopeEnrolmentLocalStorage = (0, $3hRxq.createLocalStorageProvider)('nin-changeboarding');
const $0a39e098f20828aa$export$34434fbbe40a8047 = ()=>$0a39e098f20828aa$var$ninGlobalScopeEnrolmentLocalStorage.remove($0a39e098f20828aa$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $0a39e098f20828aa$export$55632339cd4dae9c = ()=>$0a39e098f20828aa$var$ninGlobalScopeEnrolmentLocalStorage.get($0a39e098f20828aa$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $0a39e098f20828aa$export$7b78bfe0a111cecf = ()=>$0a39e098f20828aa$var$ninGlobalScopeEnrolmentLocalStorage.get($0a39e098f20828aa$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY);
const $0a39e098f20828aa$export$82b2633cf7498c5e = (isNINEnrolmentEnabled)=>{
    // In practice this is very unlikely to fail, as our local storage library checks that local storage is working
    // during initialisation. However in order to be robust we will catch any errors and recover by simply deleting the
    // existing local storage value (it's just a cache, so deleting it and delegating to the server will work fine)
    try {
        $0a39e098f20828aa$var$ninGlobalScopeEnrolmentLocalStorage.set($0a39e098f20828aa$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY, isNINEnrolmentEnabled);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $eSnSE.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage value, removing instead');
        $0a39e098f20828aa$export$34434fbbe40a8047();
    }
};
const $0a39e098f20828aa$export$458eda2352a1e223 = ()=>{
    try {
        $0a39e098f20828aa$var$ninGlobalScopeEnrolmentLocalStorage.set($0a39e098f20828aa$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY, false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $eSnSE.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage flag value');
    }
};

});

parcelRegister("fAgUF", function(module, exports) {
$parcel$export(module.exports, "marks", () => $b6c8c5a5805d3a77$export$3a8025f2f3e0c64);
$parcel$export(module.exports, "NINJqlBuilderAsyncLoad", () => $b6c8c5a5805d3a77$export$8ba5b9245ec3f6f9);
$parcel$export(module.exports, "NINPageLoad", () => $b6c8c5a5805d3a77$export$248c6c208e271182);
$parcel$export(module.exports, "NINEmbedPageLoad", () => $b6c8c5a5805d3a77$export$48368cea8238c302);
$parcel$export(module.exports, "markOnce", () => $b6c8c5a5805d3a77$export$243d158112bae094);

var $hqYEY = parcelRequire("hqYEY");

var $5fhUb = parcelRequire("5fhUb");
const $b6c8c5a5805d3a77$export$3a8025f2f3e0c64 = {
    ISSUE_NAVIGATOR_START: 'ISSUE_NAVIGATOR_START',
    ISSUE_NAVIGATOR_END: 'ISSUE_NAVIGATOR_END',
    ISSUE_NAVIGATOR_UI_START: 'ISSUE_NAVIGATOR_UI_START',
    ISSUE_NAVIGATOR_UI_END: 'ISSUE_NAVIGATOR_UI_END',
    PAGE_ACTIONS_START: 'PAGE_ACTIONS_START',
    PAGE_ACTIONS_END: 'PAGE_ACTIONS_END',
    PAGE_ACTIONS_VIEW_SWITCHER_START: 'PAGE_ACTIONS_VIEW_SWITCHER_START',
    PAGE_ACTIONS_VIEW_SWITCHER_END: 'PAGE_ACTIONS_VIEW_SWITCHER_END',
    REFINEMENT_START: 'REFINEMENT_START',
    REFINEMENT_END: 'REFINEMENT_END',
    ISSUE_RESULTS_START: 'ISSUE_RESULTS_START',
    ISSUE_RESULTS_END: 'ISSUE_RESULTS_END',
    ISSUE_RESULTS_DETAIL_VIEW_START: 'ISSUE_RESULTS_DETAIL_VIEW_START',
    ISSUE_RESULTS_DETAIL_VIEW_END: 'ISSUE_RESULTS_DETAIL_VIEW_END',
    ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_START: 'ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_START',
    ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_END: 'ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_END',
    ISSUE_RESULTS_LIST_VIEW_START: 'ISSUE_RESULTS_LIST_VIEW_START',
    ISSUE_RESULTS_LIST_VIEW_END: 'ISSUE_RESULTS_LIST_VIEW_END',
    ISSUE_RESULTS_LIST_VIEW_FOOTER_START: 'ISSUE_RESULTS_LIST_VIEW_FOOTER_START',
    ISSUE_RESULTS_LIST_VIEW_FOOTER_END: 'ISSUE_RESULTS_LIST_VIEW_FOOTER_END',
    ISSUE_APP_START: 'ISSUE_APP_START',
    ISSUE_APP_END: 'ISSUE_APP_END',
    ...(0, $5fhUb.JQL_BUILDER_PERFORMANCE_MARKS)
};
const $b6c8c5a5805d3a77$export$8ba5b9245ec3f6f9 = (0, $hqYEY.metrics).pageSegmentLoad({
    key: 'new-issue-navigator-jql-builder',
    timings: [
        {
            key: 'product/issue-navigator/ui/jql-builder',
            startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.JQL_BUILDER_START,
            endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.JQL_BUILDER_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/hydrate',
            startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.JQL_BUILDER_HYDRATE_START,
            endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.JQL_BUILDER_HYDRATE_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/jql-builder-basic',
            startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.JQL_BUILDER_BASIC_START,
            endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.JQL_BUILDER_BASIC_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/jql-builder-basic/js',
            startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.JQL_BUILDER_BASIC_JS_START,
            endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.JQL_BUILDER_BASIC_JS_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/jql-builder-advanced',
            startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.JQL_BUILDER_ADVANCED_START,
            endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.JQL_BUILDER_ADVANCED_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/jql-builder-advanced/js',
            startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.JQL_BUILDER_ADVANCED_JS_START,
            endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.JQL_BUILDER_ADVANCED_JS_END
        }
    ],
    histogram: {
        initial: {
            fmp: '100_200_500_1000_2500_3000_4000_5000_10000',
            tti: '100_200_500_1000_2500_3000_4000_5000_10000'
        },
        transition: {
            fmp: '100_200_500_1000_2500_3000_4000_5000_10000',
            tti: '100_200_500_1000_2500_3000_4000_5000_10000'
        }
    },
    featureFlags: []
});
const $b6c8c5a5805d3a77$export$8c9c137679bb68c8 = (key)=>(0, $hqYEY.metrics).pageLoad({
        key: key,
        slo: {
            fmp: {
                initial: {
                    threshold: 3000
                },
                transition: {
                    threshold: 3000
                }
            },
            tti: {
                initial: {
                    threshold: 4000
                },
                transition: {
                    threshold: 4000
                }
            }
        },
        ssr: {
            doneAsFmp: true
        },
        timings: [
            {
                key: 'product/issue-navigator',
                startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_NAVIGATOR_START,
                endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_NAVIGATOR_END
            },
            {
                key: 'product/issue-navigator/ui',
                startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_NAVIGATOR_UI_START,
                endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_NAVIGATOR_UI_END
            },
            {
                key: 'product/issue-navigator/ui/page-actions',
                startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.PAGE_ACTIONS_START,
                endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.PAGE_ACTIONS_END
            },
            {
                key: 'product/issue-navigator/ui/page-actions/view-switcher',
                startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.PAGE_ACTIONS_VIEW_SWITCHER_START,
                endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.PAGE_ACTIONS_VIEW_SWITCHER_END
            },
            {
                key: 'product/issue-navigator/ui/refinement',
                startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.REFINEMENT_START,
                endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.REFINEMENT_END
            },
            {
                key: 'product/issue-navigator/ui/issue-results',
                startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_RESULTS_START,
                endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_RESULTS_END
            },
            {
                key: 'product/issue-navigator/ui/issue-results/detail-view',
                startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_RESULTS_DETAIL_VIEW_START,
                endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_RESULTS_DETAIL_VIEW_END
            },
            {
                key: 'product/issue-navigator/ui/issue-results/detail-view/card-list',
                startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_START,
                endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_END
            },
            {
                key: 'product/issue-navigator/ui/issue-results/list-view',
                startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_RESULTS_LIST_VIEW_START,
                endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_RESULTS_LIST_VIEW_END
            },
            {
                key: 'product/issue-navigator/ui/issue-results/list-view/footer',
                startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_RESULTS_LIST_VIEW_FOOTER_START,
                endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_RESULTS_LIST_VIEW_FOOTER_END
            },
            {
                key: 'product/issue-navigator/ui/issue-app',
                startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_APP_START,
                endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_APP_END
            }
        ],
        featureFlags: []
    });
const $b6c8c5a5805d3a77$export$248c6c208e271182 = $b6c8c5a5805d3a77$export$8c9c137679bb68c8('new-issue-navigator');
const $b6c8c5a5805d3a77$export$48368cea8238c302 = $b6c8c5a5805d3a77$export$8c9c137679bb68c8('new-issue-navigator-embed');
const $b6c8c5a5805d3a77$var$consumedMarks = [];
const $b6c8c5a5805d3a77$export$243d158112bae094 = (mark)=>{
    if (!$b6c8c5a5805d3a77$var$consumedMarks.includes(mark)) {
        $b6c8c5a5805d3a77$var$consumedMarks.push(mark);
        $b6c8c5a5805d3a77$export$248c6c208e271182.mark(mark);
        $b6c8c5a5805d3a77$export$48368cea8238c302.mark(mark);
        $b6c8c5a5805d3a77$export$8ba5b9245ec3f6f9.mark(mark);
    }
};

});
parcelRegister("5fhUb", function(module, exports) {
$parcel$export(module.exports, "JQL_BUILDER_PERFORMANCE_MARKS", () => $f65791ff64431993$export$5fd6d8ece357700d);
// Performance marks
const $f65791ff64431993$var$JQL_BUILDER_START = 'JQL_BUILDER_START';
const $f65791ff64431993$var$JQL_BUILDER_END = 'JQL_BUILDER_END';
const $f65791ff64431993$var$JQL_BUILDER_HYDRATE_START = 'JQL_BUILDER_HYDRATE_START';
const $f65791ff64431993$var$JQL_BUILDER_HYDRATE_END = 'JQL_BUILDER_HYDRATE_END';
const $f65791ff64431993$var$JQL_BUILDER_BASIC_START = 'JQL_BUILDER_BASIC_START';
const $f65791ff64431993$var$JQL_BUILDER_BASIC_END = 'JQL_BUILDER_BASIC_END';
const $f65791ff64431993$var$JQL_BUILDER_BASIC_JS_START = 'JQL_BUILDER_BASIC_JS_START';
const $f65791ff64431993$var$JQL_BUILDER_BASIC_JS_END = 'JQL_BUILDER_BASIC_JS_END';
const $f65791ff64431993$var$JQL_BUILDER_ADVANCED_START = 'JQL_BUILDER_ADVANCED_START';
const $f65791ff64431993$var$JQL_BUILDER_ADVANCED_END = 'JQL_BUILDER_ADVANCED_END';
const $f65791ff64431993$var$JQL_BUILDER_ADVANCED_JS_START = 'JQL_BUILDER_ADVANCED_JS_START';
const $f65791ff64431993$var$JQL_BUILDER_ADVANCED_JS_END = 'JQL_BUILDER_ADVANCED_JS_END';
const $f65791ff64431993$export$5fd6d8ece357700d = {
    JQL_BUILDER_START: /**
	 * JQL_BUILDER
	 * Count how long it takes to load the JQL Builder,
	 * from first render of async component to ready to use
	 */ $f65791ff64431993$var$JQL_BUILDER_START,
    JQL_BUILDER_END: $f65791ff64431993$var$JQL_BUILDER_END,
    JQL_BUILDER_HYDRATE_START: /**
	 * JQL_BUILDER_HYDRATE
	 * Count how long it takes from first try to use hydrated data
	 * to the momento is actually ready to use
	 */ $f65791ff64431993$var$JQL_BUILDER_HYDRATE_START,
    JQL_BUILDER_HYDRATE_END: $f65791ff64431993$var$JQL_BUILDER_HYDRATE_END,
    JQL_BUILDER_BASIC_JS_START: /**
	 * JQL_BUILDER_BASIC_JS
	 * Count how long it takes from FE perspective to load the basic JQL Builder Basic js package
	 */ $f65791ff64431993$var$JQL_BUILDER_BASIC_JS_START,
    JQL_BUILDER_BASIC_JS_END: $f65791ff64431993$var$JQL_BUILDER_BASIC_JS_END,
    JQL_BUILDER_BASIC_START: /**
	 * JQL_BUILDER_BASIC
	 * Count how long it takes to load the JQL Builder Basic,
	 * from first render of async basic component to ready to use
	 */ $f65791ff64431993$var$JQL_BUILDER_BASIC_START,
    JQL_BUILDER_BASIC_END: $f65791ff64431993$var$JQL_BUILDER_BASIC_END,
    JQL_BUILDER_ADVANCED_JS_START: /**
	 * JQL_BUILDER_ADVANCED_JS
	 * Count how long it takes from FE perspective to load the basic JQL Builder Advanced js package
	 */ $f65791ff64431993$var$JQL_BUILDER_ADVANCED_JS_START,
    JQL_BUILDER_ADVANCED_JS_END: $f65791ff64431993$var$JQL_BUILDER_ADVANCED_JS_END,
    JQL_BUILDER_ADVANCED_START: /**
	 * JQL_BUILDER_BASIC
	 * Count how long it takes to load the JQL Builder Advnaced,
	 * from first render of async advanced component to ready to use
	 */ $f65791ff64431993$var$JQL_BUILDER_ADVANCED_START,
    JQL_BUILDER_ADVANCED_END: $f65791ff64431993$var$JQL_BUILDER_ADVANCED_END
};

});


parcelRegister("3Ssg5", function(module, exports) {
$parcel$export(module.exports, "getJqlFromParamValues", () => $71a1073bd460eeca$export$52de656da34011c3);
$parcel$export(module.exports, "getSearchInput", () => $71a1073bd460eeca$export$2fa22ca814667ff4);
$parcel$export(module.exports, "useUpdateUrlQueryParamCallback", () => $71a1073bd460eeca$export$f6b4f46bd8314b51);

var $eJOHy = parcelRequire("eJOHy");

var $82cqT = parcelRequire("82cqT");

var $95O7y = parcelRequire("95O7y");

var $iRahl = parcelRequire("iRahl");
const $71a1073bd460eeca$export$52de656da34011c3 = (defaultJql, jqlParam, filter, /**
	 * when `filter` has a value that is not a standard numeric filter ID, consumers can provide a
	 * customMapper function to transform the filter value to a jql string. For example this is used
	 * by Project Issue Navigator to map filter query params such as '?filter=myopenissues into jql
	 * strings without calling the backend API
	 */ customMapper, /**
	 * callback in the event of jql being returned is different to the jqlParam value, such as when
	 * it is undefined and the default jql is being returned. This allows the caller to sync the new
	 * jql value with the `?jql=...` url query param
	 */ onMutateJqlParam)=>{
    let jql = jqlParam;
    if (typeof jql === 'string') return jql;
    if ((0, $82cqT.isFilterId)(filter)) return undefined;
    if (typeof filter === 'string' && customMapper) jql = customMapper(filter);
    if (jql === undefined) jql = defaultJql;
    if (jql !== undefined && jql !== jqlParam) onMutateJqlParam?.(jql);
    return jql;
};
const $71a1073bd460eeca$var$getFilter = (filterInput)=>(0, $82cqT.isFilterId)(filterInput) ? {
        value: filterInput,
        type: (0, $iRahl.FilterTypes).ID
    } : {
        value: filterInput,
        type: (0, $iRahl.FilterTypes).JQL
    };
const $71a1073bd460eeca$export$2fa22ca814667ff4 = (jqlInput, filterInput)=>{
    const filter = filterInput !== undefined ? $71a1073bd460eeca$var$getFilter(filterInput) : undefined;
    if (jqlInput === undefined) {
        if (filter === undefined) throw new Error('filter is missing for search input');
        return filter;
    }
    if (filter === undefined) return {
        jql: jqlInput,
        type: (0, $iRahl.SearchInputTypes).JQL
    };
    return {
        jql: jqlInput,
        filter: filter,
        type: (0, $iRahl.SearchInputTypes).FILTER_AND_JQL
    };
};
const $71a1073bd460eeca$export$f6b4f46bd8314b51 = (queryParamKey)=>{
    const [_, setQueryParam] = (0, $95O7y.useQueryParam)(queryParamKey);
    const setJqlQueryParamCallback = (0, $eJOHy.useCallback)((value)=>setQueryParam(value, 'replace'), [
        setQueryParam
    ]);
    return setJqlQueryParamCallback;
};

});

parcelRegister("dzJIl", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb6d1f3dba33ce49$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $jmQek = parcelRequire("jmQek");

var $2UZ2Y = parcelRequire("2UZ2Y");

var $9I5E1 = parcelRequire("9I5E1");

var $2tWP9 = parcelRequire("2tWP9");

var $cHtIB = parcelRequire("cHtIB");

var $3nL89 = parcelRequire("3nL89");

var $4cTDP = parcelRequire("4cTDP");

var $bwFBc = parcelRequire("bwFBc");

var $foygf = parcelRequire("foygf");

var $epLyV = parcelRequire("epLyV");

var $7Nlco = parcelRequire("7Nlco");
const $cb6d1f3dba33ce49$var$ActionMenu = (customHeaderProps)=>{
    const { jql: jql, filterId: filterId, filterDetails: filterDetails, searchResultPageData: searchResultPageData, HierarchyToggle: HierarchyToggle, GroupByDropdown: GroupByDropdown, HideDoneToggle: HideDoneToggle, FiltersMenu: FiltersMenu, SaveResetViewSettingsButton: SaveResetViewSettingsButton, isHideDoneWorkItemsEnabled: isHideDoneWorkItemsEnabled, isGridNavigationEnabled: isGridNavigationEnabled, isConditionalFormattingEnabled: isConditionalFormattingEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, isModifiedFilter: isModifiedFilter, onChangeFilter: onChangeFilter, onChangeJqlAndGroupBy: onChangeJqlAndGroupBy } = customHeaderProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Nlco.default), {
        jql: jql,
        filterId: filterId,
        isModifiedFilter: (0, $4cTDP.fg)('visual-refresh-headers-buttons') ? isModifiedFilter : filterDetails?.jql !== jql,
        searchResultPageData: searchResultPageData,
        HierarchyToggle: HierarchyToggle,
        GroupByDropdown: GroupByDropdown,
        HideDoneToggle: HideDoneToggle,
        FiltersMenu: FiltersMenu,
        SaveResetViewSettingsButton: SaveResetViewSettingsButton,
        isHideDoneWorkItemsEnabled: isHideDoneWorkItemsEnabled,
        isConditionalFormattingEnabled: (0, $4cTDP.fg)('jira_list_conditional_formatting') ? isConditionalFormattingEnabled : undefined,
        isGridNavigationEnabled: isGridNavigationEnabled,
        isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
        onChangeFilter: onChangeFilter,
        onChangeJqlAndGroupBy: onChangeJqlAndGroupBy
    });
};
const $cb6d1f3dba33ce49$var$actionMenuWithHideDoneSupport = (isHideDoneSupportEnabled)=>{
    return (customHeaderProps)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Nlco.default), {
            ...customHeaderProps,
            isHideDoneSupportEnabled: isHideDoneSupportEnabled
        });
    };
};
const $cb6d1f3dba33ce49$var$ProjectIssueNavigator = ({ projectKey: projectKey, showNav3Header: showNav3Header = false, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isHideDoneSupportEnabled: isHideDoneSupportEnabled, isIssueRankingSupportEnabled: isIssueRankingSupportEnabled, isMergedColumnSupportEnabled: isMergedColumnSupportEnabled, isGridNavigationEnabled: isGridNavigationEnabled, isFilterRefinementEnabled: isFilterRefinementEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, ...rest })=>{
    const CustomHeader = (0, $eJOHy.useCallback)((customHeaderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $foygf.default), {
            projectKey: projectKey,
            ...customHeaderProps,
            isQuickFiltersDisabled: showNav3Header,
            isHideDoneSupportEnabled: isHideDoneSupportEnabled,
            isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled && (0, $4cTDP.fg)('ifc_export_for_jsm')
        }), [
        isHideDoneSupportEnabled,
        isInlineFieldConfigEnabled,
        isIssueHierarchySupportEnabled,
        projectKey,
        showNav3Header
    ]);
    const showNewNav = !showNav3Header;
    const [queryReference, loadQuery] = (0, $j4oe4.useQueryLoader)((0, $bwFBc.default));
    const cloudId = (0, $cHtIB.useCloudId)();
    (0, $eJOHy.useEffect)(()=>{
        loadQuery({
            projectKey: projectKey,
            cloudId: cloudId
        });
    }, [
        loadQuery,
        projectKey,
        cloudId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showNewNav && (queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $epLyV.default), {
        queryReference: queryReference
    }) : // eslint-disable-next-line @atlassian/a11y/document-title -- TODO: All pages must have a document title. See go/a11y-document-title for more details.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nL89.DocumentTitle), {
        title: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2UZ2Y.default), {
        ...!showNewNav && {
            CustomHeader: CustomHeader
        },
        ...showNewNav && {
            ActionMenu: (0, $4cTDP.fg)('jsc_bulk_edit_hide_done_work_items') ? $cb6d1f3dba33ce49$var$actionMenuWithHideDoneSupport(isHideDoneSupportEnabled) : $cb6d1f3dba33ce49$var$ActionMenu
        },
        HeaderSkeletonImage: (0, $2tWP9.ProjectIssueNavigatorHeaderSkeleton),
        isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
        isIssueRankingSupportEnabled: isIssueRankingSupportEnabled,
        isGridNavigationEnabled: isGridNavigationEnabled,
        isMergedColumnSupportEnabled: isMergedColumnSupportEnabled,
        isFilterRefinementEnabled: isFilterRefinementEnabled,
        isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
        ...rest
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jmQek.default), {
        hasServiceDeskAccess: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9I5E1.JsdGettingStartedPanelShouldRender), null)));
};
const $cb6d1f3dba33ce49$export$b008d460035de468 = ({ projectKey: projectKey, showNewNav: showNewNav })=>{
    const [queryReference, loadQuery] = (0, $j4oe4.useQueryLoader)((0, $bwFBc.default));
    const cloudId = (0, $cHtIB.useCloudId)();
    (0, $eJOHy.useEffect)(()=>{
        loadQuery({
            projectKey: projectKey,
            cloudId: cloudId
        });
    }, [
        loadQuery,
        projectKey,
        cloudId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showNewNav && (queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $epLyV.default), {
        queryReference: queryReference
    }) : // eslint-disable-next-line @atlassian/a11y/document-title -- TODO: All pages must have a document title. See go/a11y-document-title for more details.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nL89.DocumentTitle), {
        title: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jmQek.default), {
        hasServiceDeskAccess: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9I5E1.JsdGettingStartedPanelShouldRender), null)));
};
var $cb6d1f3dba33ce49$export$2e2bcd8739ae039 = $cb6d1f3dba33ce49$var$ProjectIssueNavigator;

});
parcelRegister("jmQek", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7838320445e919b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bJscI = parcelRequire("bJscI");

var $koAZ4 = parcelRequire("koAZ4");

var $5aeix = parcelRequire("5aeix");
const $e7838320445e919b$var$AppPermissionsCheckNew = ({ hasServiceDeskAccess: hasServiceDeskAccess, hasCoreAccess: hasCoreAccess, hasSoftwareAccess: hasSoftwareAccess, children: children })=>{
    const { appPermissions: appPermissions } = (0, $koAZ4.useTenantContext)();
    if (hasServiceDeskAccess !== undefined && appPermissions.hasServiceDeskAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    if (hasCoreAccess !== undefined && appPermissions.hasCoreAccess === hasCoreAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    if (hasSoftwareAccess !== undefined && appPermissions.hasSoftwareAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    if (hasServiceDeskAccess === undefined && hasCoreAccess === undefined && hasSoftwareAccess === undefined) {
        if ((0, $5aeix.isDevelopmentEnv)()) // eslint-disable-next-line no-console
        console.warn('AppPermissionsCheck should have defined at least one of access prop');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    }
    return null;
};
const $e7838320445e919b$var$AppPermissionsCheckOld = (props)=>{
    const { hasServiceDeskAccess: hasServiceDeskAccess, hasCoreAccess: hasCoreAccess, hasSoftwareAccess: hasSoftwareAccess, children: children } = props;
    const { appPermissions: appPermissions } = (0, $koAZ4.useTenantContext)();
    if (hasServiceDeskAccess !== undefined && appPermissions.hasServiceDeskAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    if (hasCoreAccess !== undefined && appPermissions.hasCoreAccess === hasCoreAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    if (hasSoftwareAccess !== undefined && appPermissions.hasSoftwareAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    if (hasServiceDeskAccess === undefined && hasCoreAccess === undefined && hasSoftwareAccess === undefined) {
        if ((0, $5aeix.isDevelopmentEnv)()) // eslint-disable-next-line no-console
        console.warn('AppPermissionsCheck should have defined at least one of access prop');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    }
    return null;
};
$e7838320445e919b$var$AppPermissionsCheckOld.defaultProps = {
    hasServiceDeskAccess: undefined,
    hasCoreAccess: undefined,
    hasSoftwareAccess: undefined
};
/**
 * Manages the visibility of child components based on user permissions within a multi-tenant environment.
 * It leverages the application's permission settings to determine access rights, ensuring components are only accessible to users with the appropriate permissions.
 * In development environments, it issues a warning when no access-related properties are provided, aiding in debug and development processes.
 */ const $e7838320445e919b$var$AppPermissionsCheck = (0, $bJscI.componentWithFG)('jira_removing_defaultprops', $e7838320445e919b$var$AppPermissionsCheckNew, $e7838320445e919b$var$AppPermissionsCheckOld);
var $e7838320445e919b$export$2e2bcd8739ae039 = $e7838320445e919b$var$AppPermissionsCheck;

});
parcelRegister("5aeix", function(module, exports) {
$parcel$export(module.exports, "isDevelopmentEnv", () => $b42edb9e31c9a622$export$48e5fb80244b95c5);
const $b42edb9e31c9a622$export$48e5fb80244b95c5 = ()=>false;

});


parcelRegister("2UZ2Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f5753a2111e6c64$export$2e2bcd8739ae039);

var $dEeWJ = parcelRequire("dEeWJ");

var $jTskH = parcelRequire("jTskH");

var $bkZ2q = parcelRequire("bkZ2q");

var $dHc6J = parcelRequire("dHc6J");

var $i9z6a = parcelRequire("i9z6a");

var $aH23d = parcelRequire("aH23d");

var $iOldl = parcelRequire("iOldl");

var $8RGOH = parcelRequire("8RGOH");

var $kVQr8 = parcelRequire("kVQr8");

var $59rbW = parcelRequire("59rbW");

var $lqJlp = parcelRequire("lqJlp");

var $7oCTu = parcelRequire("7oCTu");

var $40zUZ = parcelRequire("40zUZ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $grUFB = parcelRequire("grUFB");

var $4cTDP = parcelRequire("4cTDP");

var $bJscI = parcelRequire("bJscI");

var $gHKwt = parcelRequire("gHKwt");

var $l8Ydr = parcelRequire("l8Ydr");

var $a7IKn = parcelRequire("a7IKn");

var $iRahl = parcelRequire("iRahl");

var $fAgUF = parcelRequire("fAgUF");

var $61oZD = parcelRequire("61oZD");

var $fwKw5 = parcelRequire("fwKw5");

var $cJdYi = parcelRequire("cJdYi");

var $1Puj1 = parcelRequire("1Puj1");

var $2kVBT = parcelRequire("2kVBT");

var $7QuRk = parcelRequire("7QuRk");

var $2y1A0 = parcelRequire("2y1A0");

var $7emTO = parcelRequire("7emTO");

var $lvpZz = parcelRequire("lvpZz");

var $aaLZH = parcelRequire("aaLZH");

var $3YMzi = parcelRequire("3YMzi");

var $48isi = parcelRequire("48isi");
const $8f5753a2111e6c64$export$e111e6466962b82b = (0, $40zUZ.default);
// We memo as an optimisation to reduce forced re-renders when the immediate parent renders. In this case it's
// AppContextualAnalytics which will re-render when interacting with the JQL builder, e.g. opening picker.
const $8f5753a2111e6c64$var$FilterAndJqlProvider = /*#__PURE__*/ (0, $eJOHy.memo)(({ children: children, jql: jql, refetch: refetch, filterId: filterId, isFilterEditable: isFilterEditable, filterJql: filterJql })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cJdYi.FilterQueryProvider), {
        query: $8f5753a2111e6c64$export$e111e6466962b82b,
        refetch: refetch,
        filterId: filterId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fwKw5.ActiveJqlProvider), {
        filterId: filterId,
        filterJql: filterJql,
        jql: jql,
        isFilterEditable: isFilterEditable
    }, children)));
const $8f5753a2111e6c64$var$MaybeFilterAndJqlProvider = (0, $bJscI.componentWithFG)('jira_nin_last_used_jql_tech_changes', ({ children: children })=>children, $8f5753a2111e6c64$var$FilterAndJqlProvider);
const $8f5753a2111e6c64$var$MaybeIssueSearchInputProvider = (0, $bJscI.componentWithFG)('jira_nin_last_used_jql_tech_changes', (0, $3YMzi.IssueSearchInputProvider), ({ children: children })=>children);
const $8f5753a2111e6c64$var$getFilter = (searchParam)=>{
    if (searchParam?.type === (0, $iRahl.SearchInputTypes).JQL) return undefined;
    return searchParam.type === (0, $iRahl.SearchInputTypes).FILTER_AND_JQL ? searchParam.filter : searchParam;
};
const $8f5753a2111e6c64$var$IssueNavigator = ({ issueKey: issueKey, queryReference: queryReference, filterQueryReference: filterQueryReference, CustomHeader: CustomHeader, ActionMenu: ActionMenu, HeaderSkeletonImage: HeaderSkeletonImage, onChangeIssue: onChangeIssue, onChangeFilter: onChangeFilter, onRefinement: onRefinement, onChangeJqlAndGroupBy: onChangeJqlAndGroupBy, onPageDataLoad: onPageDataLoadProp, onChangeColumnConfiguration: onChangeColumnConfiguration, onChangeJql: onChangeJql, onSetView: onSetView, defaultJql: defaultJql, searchInput: searchInput, onFilterKeyToJql: onFilterKeyToJql, jqlBuilderProps: jqlBuilderProps, issueAppEntryPoint: issueAppEntryPoint, issueTableProps: issueTableProps, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isIssueRankingSupportEnabled: isIssueRankingSupportEnabled, isMergedColumnSupportEnabled: isMergedColumnSupportEnabled, isFrozenColumnSupportEnabled: isFrozenColumnSupportEnabled, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, isGridNavigationEnabled: isGridNavigationEnabled, isPostOfficePlacementEnabled: isPostOfficePlacementEnabled, isFilterRefinementEnabled: isFilterRefinementEnabled = false, filterRefinementQueryReference: filterRefinementQueryReference })=>{
    (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_NAVIGATOR_START);
    (0, $eJOHy.useLayoutEffect)(()=>{
        (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_NAVIGATOR_END);
    }, []);
    const [isInitialized, setIsInitialized] = (0, $eJOHy.useState)(false);
    const onPageDataLoad = (0, $eJOHy.useCallback)((...props)=>{
        if (!isInitialized) setIsInitialized(true);
        return onPageDataLoadProp?.(...props);
    }, [
        isInitialized,
        onPageDataLoadProp
    ]);
    const filterInput = searchInput ? $8f5753a2111e6c64$var$getFilter(searchInput) : undefined;
    const issueQuery = (0, $j4oe4.usePreloadedQuery)((0, $7oCTu.default), queryReference);
    const refetchQuery = (0, $j4oe4.useFragment)((0, $lqJlp.default), issueQuery);
    const [issueNavigatorRefetchDataNew, issueNavigatorRefetchNew] = (0, $j4oe4.useRefetchableFragment)((0, $59rbW.default), refetchQuery);
    const jiraViewData = issueNavigatorRefetchDataNew?.jira?.jiraIssueSearchView ?? null;
    const detailedViewPaginationFragmentOld = (0, $j4oe4.usePaginationFragment)((0, $kVQr8.default), jiraViewData?.__typename === 'JiraDetailedView' && !(0, $4cTDP.fg)('jira_nin_last_used_jql') ? jiraViewData : null);
    const jiraDetailedViewPaginationFragment = (0, $j4oe4.usePaginationFragment)((0, $8RGOH.default), jiraViewData?.__typename === 'JiraDetailedView' && (0, $4cTDP.fg)('jira_nin_last_used_jql') ? jiraViewData : null);
    const groupedListViewPaginationFragmentOld = (0, $j4oe4.usePaginationFragment)((0, $iOldl.default), jiraViewData?.__typename === 'JiraGroupedListView' && !(0, $4cTDP.fg)('jira_nin_last_used_jql') ? jiraViewData : null);
    const jiraGroupedListViewPaginationFragment = (0, $j4oe4.usePaginationFragment)((0, $aH23d.default), jiraViewData?.__typename === 'JiraGroupedListView' && (0, $4cTDP.fg)('jira_nin_last_used_jql') ? jiraViewData : null);
    const listViewPaginationFragmentOld = (0, $j4oe4.usePaginationFragment)((0, $i9z6a.default), jiraViewData?.__typename === 'JiraListView' && !(0, $4cTDP.fg)('jira_nin_last_used_jql') ? jiraViewData : null);
    const jiraListViewPaginationFragment = (0, $j4oe4.usePaginationFragment)((0, $dHc6J.default), jiraViewData?.__typename === 'JiraListView' && (0, $4cTDP.fg)('jira_nin_last_used_jql') ? jiraViewData : null);
    const detailedViewPaginationFragment = (0, $4cTDP.fg)('jira_nin_last_used_jql') ? jiraDetailedViewPaginationFragment : detailedViewPaginationFragmentOld;
    const groupedListViewPaginationFragment = (0, $4cTDP.fg)('jira_nin_last_used_jql') ? jiraGroupedListViewPaginationFragment : groupedListViewPaginationFragmentOld;
    const listViewPaginationFragment = (0, $4cTDP.fg)('jira_nin_last_used_jql') ? jiraListViewPaginationFragment : listViewPaginationFragmentOld;
    const userPreferencesData = (0, $j4oe4.useFragment)((0, $bkZ2q.default), issueQuery.jira?.userPreferences ?? null);
    const jqlBuilderWithAiData = (0, $j4oe4.useFragment)((0, $jTskH.default), issueQuery.jira);
    let activePaginationFragment = listViewPaginationFragment;
    let groupResultsData = null;
    let issueResultsData = listViewPaginationFragment?.data?.issues ?? null;
    if (detailedViewPaginationFragment.data) {
        activePaginationFragment = detailedViewPaginationFragment;
        issueResultsData = detailedViewPaginationFragment?.data?.issues ?? null;
    } else if (groupedListViewPaginationFragment.data) {
        activePaginationFragment = groupedListViewPaginationFragment;
        groupResultsData = groupedListViewPaginationFragment?.data?.groups ?? null;
    }
    const filterQuery = (0, $j4oe4.usePreloadedQuery)($8f5753a2111e6c64$export$e111e6466962b82b, filterQueryReference);
    /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ const [filterData, refetchFilter] = (0, $j4oe4.useRefetchableFragment)((0, $dEeWJ.default), filterQuery);
    /* eslint-enable @atlassian/relay/must-colocate-fragment-spreads */ /**
   * initialQueryAsJql remembers the initial query on mount
   */ const [initialQueryAsJql] = (0, $eJOHy.useState)(()=>{
        if (!(0, $4cTDP.fg)('jracloud_85520_hydration_ref_only_on_page_load') || (0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes')) return undefined;
        // Use base input for plain JQL input OR
        // If both filter and JQL are present, JQL takes precedence
        if (searchInput.type === (0, $iRahl.SearchInputTypes).JQL || searchInput.type === (0, $iRahl.SearchInputTypes).FILTER_AND_JQL) return searchInput.jql;
        // Use filter JQL for manually-mapped filters like we use in Project Scope
        if (filterInput?.type === (0, $iRahl.FilterTypes).JQL) return filterInput.value;
        // Otherwise, use the saved filter JQL as returned by the backend
        return filterData?.jira?.filter?.jql;
    });
    const { setFlatListIssues: setFlatListIssues } = (0, $lvpZz.useFlatListIssuesActions)();
    const handleIssueFlatListUpdated = (0, $eJOHy.useCallback)((newFlatKeyList)=>{
        setFlatListIssues(newFlatKeyList);
    }, [
        setFlatListIssues
    ]);
    const isConditionalFormattingEnabled = (0, $4cTDP.fg)('jira_list_conditional_formatting') && // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $aaLZH.useIssueNavigatorFeatures)().isConditionalFormattingEnabled;
    // Remove this when cleaning up saved_list_view_shadow_request
    (0, $48isi.useMainIssueNavigatorQueryShadowRequest)(queryReference.variables);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $61oZD.AppContextualAnalytics), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8f5753a2111e6c64$export$6d44d4a22d5bca7a, {
        isEnabled: isConditionalFormattingEnabled,
        project: issueQuery.jira?.jiraProjectByKey ?? null,
        view: isConditionalFormattingEnabled && (0, $4cTDP.fg)('saved_list_view_technical_changes') ? jiraViewData : null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gHKwt.SidebarContainer), {
        scope: (0, $iRahl.NIN_SIDEBAR_SCOPE),
        sidebarId: (0, $iRahl.ISSUE_NAVIGATOR_SIDEBAR_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8f5753a2111e6c64$var$MaybeIssueSearchInputProvider, {
        defaultJql: defaultJql,
        filterQuery: $8f5753a2111e6c64$export$e111e6466962b82b,
        jiraFilter: filterData?.jira?.filter ?? null,
        jiraView: jiraViewData,
        onFilterKeyToJql: onFilterKeyToJql,
        refetch: refetchFilter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8f5753a2111e6c64$var$MaybeFilterAndJqlProvider, {
        refetch: refetchFilter,
        filterId: filterInput?.type === (0, $iRahl.FilterTypes).ID ? filterInput?.value : undefined,
        filterJql: filterInput?.type === (0, $iRahl.FilterTypes).JQL ? filterInput?.value : filterData?.jira?.filter?.jql,
        isFilterEditable: filterData.jira?.filter?.isEditable !== null ? filterData.jira?.filter?.isEditable : undefined,
        jql: searchInput?.type === (0, $iRahl.SearchInputTypes).FILTER_AND_JQL || searchInput?.type === (0, $iRahl.SearchInputTypes).JQL ? searchInput?.jql : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Puj1.IssueSearch), {
        onPageDataLoad: onPageDataLoad,
        jiraView: jiraViewData,
        refetch: issueNavigatorRefetchNew,
        isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
        isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
        project: issueQuery.jira?.jiraProjectByKey ?? null,
        issueTableProps: issueTableProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7emTO.InfiniteScrollProvider), {
        onLoadNext: activePaginationFragment.loadNext,
        onLoadPrevious: activePaginationFragment.loadPrevious,
        isLoadingNext: activePaginationFragment.isLoadingNext,
        isLoadingPrevious: activePaginationFragment.isLoadingPrevious,
        hasNext: activePaginationFragment.hasNext,
        hasPrevious: activePaginationFragment.hasPrevious
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2y1A0.SelectedViewContainer), {
        onSetView: onSetView,
        jiraView: jiraViewData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7QuRk.SelectedIssue), {
        selectedIssueKey: issueKey,
        onChange: onChangeIssue,
        issues: issueResultsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2kVBT.default), {
        CustomHeader: CustomHeader,
        ActionMenu: ActionMenu,
        HeaderSkeletonImage: HeaderSkeletonImage,
        filter: filterData?.jira?.filter ?? null,
        onChangeIssue: onChangeIssue,
        onChangeFilter: onChangeFilter,
        onChangeJqlAndGroupBy: onChangeJqlAndGroupBy,
        onPageDataLoad: onPageDataLoad,
        onChangeColumnConfiguration: onChangeColumnConfiguration,
        onChangeJql: onChangeJql,
        onRefinement: onRefinement,
        defaultJql: defaultJql,
        issueResults: issueResultsData,
        groupResults: groupResultsData,
        project: issueQuery.jira?.jiraProjectByKey ?? null,
        userPreferences: userPreferencesData ?? null,
        jqlBuilderProps: jqlBuilderProps,
        issueAppEntryPoint: (0, $4cTDP.fg)('nin_issue_app_conditional_entrypoint') ? issueAppEntryPoint : undefined,
        jqlBuilderWithAiKey: jqlBuilderWithAiData ?? null,
        issueTableProps: issueTableProps,
        isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
        jiraView: jiraViewData,
        onIssueFlatListUpdated: handleIssueFlatListUpdated,
        initialQueryAsJql: initialQueryAsJql,
        isInitialized: isInitialized,
        isIssueRankingSupportEnabled: isIssueRankingSupportEnabled,
        isMergedColumnSupportEnabled: isMergedColumnSupportEnabled,
        isFrozenColumnSupportEnabled: isFrozenColumnSupportEnabled,
        isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
        isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
        isGridNavigationEnabled: isGridNavigationEnabled,
        isPostOfficePlacementEnabled: isPostOfficePlacementEnabled,
        isFilterRefinementEnabled: isFilterRefinementEnabled,
        filterRefinementQueryReference: filterRefinementQueryReference
    }))))))))), (0, $4cTDP.fg)('currency-field-d3-changeboarding') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $grUFB.default), null));
};
const $8f5753a2111e6c64$export$6d44d4a22d5bca7a = ({ isEnabled: isEnabled, project: project, view: view, children: children })=>{
    if ((0, $4cTDP.fg)('saved_list_view_technical_changes')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a7IKn.ConditionalFormattingSidebarContainer), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        project: project,
        isEnabled: isEnabled,
        view: view ?? null
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l8Ydr.ConditionalFormatting), {
        isEnabled: isEnabled,
        project: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        project
    }, children);
};
const $8f5753a2111e6c64$var$WithFlatListIssuesContainer = (Component)=>{
    const IssueNavigatorWithFlatListIssuesContainer = (props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvpZz.FlatListIssuesContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, props));
    };
    return IssueNavigatorWithFlatListIssuesContainer;
};
var $8f5753a2111e6c64$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($8f5753a2111e6c64$var$WithFlatListIssuesContainer($8f5753a2111e6c64$var$IssueNavigator));

});
parcelRegister("dEeWJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $6300bb8d47a912ac$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0db0de983744de81785a47f3a71540bb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $52mCm = parcelRequire("52mCm");
const $6300bb8d47a912ac$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "filterAri"
        },
        {
            "kind": "RootArgument",
            "name": "includeFilter"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [],
            "operation": (0, $52mCm.default)
        }
    },
    "name": "main_issueNavigator_IssueNavigator_filterQuery",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "condition": "includeFilter",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "id",
                                    "variableName": "filterAri"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "filter",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "jql"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEditable"
                                        }
                                    ],
                                    "type": "JiraCustomFilter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "IssueSearchInputProvider_jiraFilter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "main_issueNavigator_Header_filter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "topBar_issueNavigator_filter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_filter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "main_issueNavigator_ListView_filter"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$6300bb8d47a912ac$var$node.hash = "96adaeb0ea412a121f8c6bd7c6d18060";
var $6300bb8d47a912ac$export$2e2bcd8739ae039 = $6300bb8d47a912ac$var$node;

});
parcelRegister("52mCm", function(module, exports) {
$parcel$export(module.exports, "default", () => $8025a387287378ef$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f8315a29bd5c7e5a2f590bc33608bf78>>
 * @relayHash 03d0b36dbfc0f84b81e3ca48e36a6e7b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 04c1fba8df45d251a0f00e03bda2406c57347ce5fb839d27446ae6d7d61b8c00
const $8025a387287378ef$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeFilter"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FilterRefetchQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_filterQuery"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FilterRefetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeFilter",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "filterAri"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEditable"
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "filterId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "04c1fba8df45d251a0f00e03bda2406c57347ce5fb839d27446ae6d7d61b8c00",
            "metadata": {},
            "name": "FilterRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8025a387287378ef$var$node.hash = "96adaeb0ea412a121f8c6bd7c6d18060";
var $8025a387287378ef$export$2e2bcd8739ae039 = $8025a387287378ef$var$node;

});


parcelRegister("jTskH", function(module, exports) {
$parcel$export(module.exports, "default", () => $0de3a53c936dbb24$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9b849f64e4a61be907eaec3accbf05bb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0de3a53c936dbb24$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigator_jira",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueNavigatorUI_jqlBuilderWithAiKey"
        }
    ],
    "type": "JiraQuery"
};
$0de3a53c936dbb24$var$node.hash = "e871bd0eb341a6573bd1df76ea8e5df1";
var $0de3a53c936dbb24$export$2e2bcd8739ae039 = $0de3a53c936dbb24$var$node;

});

parcelRegister("bkZ2q", function(module, exports) {
$parcel$export(module.exports, "default", () => $3000162807bedb79$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1ecec124bc87c6002f2c45127804b4c1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3000162807bedb79$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigator_userPreferences",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueNavigatorUI_userPreferences"
        }
    ],
    "type": "JiraUserPreferences"
};
$3000162807bedb79$var$node.hash = "1143e00ad7112d3bc319370b0e0a4b27";
var $3000162807bedb79$export$2e2bcd8739ae039 = $3000162807bedb79$var$node;

});

parcelRegister("dHc6J", function(module, exports) {
$parcel$export(module.exports, "default", () => $75daabee05c602ca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<29b263912d41fd995fc884275ce9faa6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $hqvy5 = parcelRequire("hqvy5");
const $75daabee05c602ca$var$node = function() {
    var v0 = [
        "issues"
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "dynamicSearchKey"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "options"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "saveJQLToUserHistory"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "settings"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            },
            {
                "kind": "RootArgument",
                "name": "viewConfigInput"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "bidirectional",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": {
                        "count": "last",
                        "cursor": "before"
                    },
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $hqvy5.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "main_issueNavigator_IssueNavigator_jiraListViewData",
        "selections": [
            {
                "alias": "issues",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "__dynamicKey",
                        "variableName": "dynamicSearchKey"
                    },
                    {
                        "kind": "Variable",
                        "name": "scope",
                        "variableName": "scope"
                    }
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "__IssueNavigatorJiraListViewPagination__issues_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            },
                            {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "startCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasPreviousPage"
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "selectedIssue_issueNavigator"
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "isConditionalFormattingEnabled",
                                "variableName": "isConditionalFormattingEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKey",
                                "variableName": "projectKey"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKeys",
                                "variableName": "projectKeys"
                            },
                            {
                                "kind": "Variable",
                                "name": "shouldQueryHasChildren",
                                "variableName": "shouldQueryHasChildren"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_IssueNavigatorUI_issueResults"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "JiraListView"
    };
}();
$75daabee05c602ca$var$node.hash = "4202ce7787f357945fc9368f8c19f775";
var $75daabee05c602ca$export$2e2bcd8739ae039 = $75daabee05c602ca$var$node;

});
parcelRegister("hqvy5", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac64b2678217f671$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3a8ea5cd1585d57411d038fedbdcc572>>
 * @relayHash f450617db4b4b0c9150223529ed41add
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a04c9ba71f4ec5d0a39984669945e1eb287bfe1224b17654945bae7d8313c053

var $3Bt2F = parcelRequire("3Bt2F");

var $cqxuo = parcelRequire("cqxuo");

var $dexoz = parcelRequire("dexoz");

var $3jVIX = parcelRequire("3jVIX");

var $l6otE = parcelRequire("l6otE");

var $ad5K7 = parcelRequire("ad5K7");

var $hHOEN = parcelRequire("hHOEN");

var $hRj2m = parcelRequire("hRj2m");

var $cIDJo = parcelRequire("cIDJo");

var $6AioA = parcelRequire("6AioA");

var $04qit = parcelRequire("04qit");

var $jvWSl = parcelRequire("jvWSl");

var $j2Uha = parcelRequire("j2Uha");

var $kmr3r = parcelRequire("kmr3r");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $gDQIG = parcelRequire("gDQIG");

var $1fipb = parcelRequire("1fipb");

var $iOvkB = parcelRequire("iOvkB");

var $evjHZ = parcelRequire("evjHZ");

var $FU9UR = parcelRequire("FU9UR");
const $ac64b2678217f671$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "dynamicSearchKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "saveJQLToUserHistory"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "settings"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v17 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v18 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v19 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v20 = {
        "kind": "ScalarField",
        "name": "id"
    }, v21 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "options",
            "variableName": "options"
        },
        {
            "kind": "Variable",
            "name": "saveJQLToUserHistory",
            "variableName": "saveJQLToUserHistory"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        {
            "kind": "Variable",
            "name": "settings",
            "variableName": "settings"
        },
        {
            "kind": "Variable",
            "name": "viewConfigInput",
            "variableName": "viewConfigInput"
        }
    ], v22 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v23 = {
        "kind": "ScalarField",
        "name": "key"
    }, v24 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v25 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v27 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v28 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v27 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v29 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v28 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v30 = {
        "concreteType": "JiraStatusField",
        "kind": "LinkedField",
        "name": "statusField",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "name"
    }, v32 = [
        v31 /*: any*/ 
    ], v33 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v34 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v35 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v36 = {
        "kind": "ScalarField",
        "name": "type"
    }, v37 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v38 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v39 = {
        "kind": "ScalarField",
        "name": "value"
    }, v40 = [
        v39 /*: any*/ ,
        v20 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v41 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v42 = {
        "kind": "ClientExtension",
        "selections": [
            v41 /*: any*/ 
        ]
    }, v43 = {
        "kind": "ScalarField",
        "name": "message"
    }, v44 = [
        v43 /*: any*/ 
    ], v45 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v46 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v47 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v48 = {
        "kind": "ScalarField",
        "name": "date"
    }, v49 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v50 = {
        "kind": "ScalarField",
        "name": "text"
    }, v51 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v20 /*: any*/ 
        ]
    }, v52 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v53 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v54 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v55 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v56 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v57 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v58 = [
        {
            "kind": "ScalarField",
            "name": "appType"
        }
    ], v59 = [
        {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isUser"
        },
        {
            "kind": "InlineFragment",
            "selections": v58 /*: any*/ ,
            "type": "AppUser"
        }
    ], v60 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v61 = {
        "kind": "ClientExtension",
        "selections": [
            v33 /*: any*/ 
        ]
    }, v62 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeInSeconds"
            }
        ]
    }, v63 = {
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "timeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v64 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v65 = [
        v20 /*: any*/ 
    ], v66 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": v65 /*: any*/ 
    }, v67 = {
        "kind": "ScalarField",
        "name": "href"
    }, v68 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v69 = {
        "kind": "InlineFragment",
        "selections": [
            v48 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v70 = [
        v19 /*: any*/ ,
        v38 /*: any*/ ,
        v69 /*: any*/ ,
        v20 /*: any*/ 
    ], v71 = [
        v19 /*: any*/ ,
        v69 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": v65 /*: any*/ ,
            "type": "Node",
            "abstractKey": "__isNode"
        }
    ], v72 = [
        v19 /*: any*/ ,
        v20 /*: any*/ 
    ], v73 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v74 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v75 = [
        v73 /*: any*/ ,
        v22 /*: any*/ ,
        v74 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueNavigatorJiraListViewPaginationQuery",
            "selections": [
                {
                    "args": v17 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "isConditionalFormattingEnabled",
                                    "variableName": "isConditionalFormattingEnabled"
                                },
                                v18 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "projectKeys",
                                    "variableName": "projectKeys"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "shouldQueryHasChildren",
                                    "variableName": "shouldQueryHasChildren"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_IssueNavigator_jiraListViewData"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v5 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueNavigatorJiraListViewPaginationQuery",
            "selections": [
                {
                    "args": v17 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v19 /*: any*/ ,
                        v20 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v21 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v22 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        v24 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v25 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                },
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        v26 /*: any*/ ,
                                                        v30 /*: any*/ ,
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueTypeField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": v32 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                v33 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isHighlightedIssueRow"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v34 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueTypeField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v35 /*: any*/ ,
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": v32 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v19 /*: any*/ ,
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "first",
                                                            "value": 500
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v36 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldSetId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v37 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v20 /*: any*/ ,
                                                                                                v19 /*: any*/ ,
                                                                                                v38 /*: any*/ ,
                                                                                                v36 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "TypeDiscriminator",
                                                                                                    "abstractKey": "__isJiraIssueField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedAffectedServicesConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAffectedService",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "serviceId"
                                                                                                                                },
                                                                                                                                v31 /*: any*/ ,
                                                                                                                                v20 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraAffectedServicesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v31 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraCascadingOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "cascadingOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentOptionValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v40 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "childOptionValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v40 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v42 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraCascadingSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedCmdbObjectsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbObject",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "objectId"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "label"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbAvatar",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "avatar",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "mediaClientConfig",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "clientId"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "fileId"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "mediaBaseUrl"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "mediaJwtToken"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "url48"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "QueryError",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "errors",
                                                                                                                    "plural": true,
                                                                                                                    "selections": v44 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCMDBField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v31 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v45 /*: any*/ ,
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v46 /*: any*/ ,
                                                                                                                                v47 /*: any*/ ,
                                                                                                                                v20 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                        },
                                                                                                        v42 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v48 /*: any*/ ,
                                                                                                        v31 /*: any*/ ,
                                                                                                        v49 /*: any*/ ,
                                                                                                        v42 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDatePickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "dateTime"
                                                                                                        },
                                                                                                        v31 /*: any*/ ,
                                                                                                        v42 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDateTimePickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraEpic",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "epic",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v23 /*: any*/ ,
                                                                                                                v34 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "color"
                                                                                                                },
                                                                                                                v20 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraEpicLinkField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "renderedFieldHtml"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraFallbackField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v50 /*: any*/ ,
                                                                                                        v31 /*: any*/ ,
                                                                                                        v42 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "statusCategory",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v31 /*: any*/ ,
                                                                                                                v27 /*: any*/ ,
                                                                                                                v20 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatus",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "status",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v31 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "statusId"
                                                                                                                },
                                                                                                                v28 /*: any*/ ,
                                                                                                                v20 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v45 /*: any*/ ,
                                                                                                            "concreteType": "JiraLabelConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedLabelsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v37 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabelEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraLabel",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v31 /*: any*/ ,
                                                                                                                                v51 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                        },
                                                                                                        v31 /*: any*/ ,
                                                                                                        v42 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraLabelsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v35 /*: any*/ ,
                                                                                                                v31 /*: any*/ ,
                                                                                                                v20 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v23 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraColorField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueColorField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v51 /*: any*/ ,
                                                                                                                        v20 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueTypeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v52 /*: any*/ ,
                                                                                                                                v31 /*: any*/ ,
                                                                                                                                v20 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v20 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "summaryField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v50 /*: any*/ ,
                                                                                                                        v20 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v20 /*: any*/ ,
                                                                                                                v24 /*: any*/ ,
                                                                                                                v53 /*: any*/ ,
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "args": [
                                                                                                                                {
                                                                                                                                    "kind": "Literal",
                                                                                                                                    "name": "ids",
                                                                                                                                    "value": [
                                                                                                                                        "issuetype",
                                                                                                                                        "project",
                                                                                                                                        "summary",
                                                                                                                                        "status"
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "fieldsById",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "edges",
                                                                                                                                    "plural": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "node",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v19 /*: any*/ ,
                                                                                                                                                v20 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v38 /*: any*/ ,
                                                                                                                                                        v50 /*: any*/ 
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v38 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "issueType",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v20 /*: any*/ ,
                                                                                                                                                                v54 /*: any*/ ,
                                                                                                                                                                v31 /*: any*/ ,
                                                                                                                                                                v52 /*: any*/ ,
                                                                                                                                                                v25 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v38 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraStatus",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "status",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v20 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "statusCategory",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v20 /*: any*/ ,
                                                                                                                                                                        v27 /*: any*/ 
                                                                                                                                                                    ]
                                                                                                                                                                }
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraStatusField"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueTypeField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v38 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issueType",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v54 /*: any*/ ,
                                                                                                                                        v25 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSingleLineTextField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "summaryField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v38 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraStatusField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "statusField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v20 /*: any*/ ,
                                                                                                                                v38 /*: any*/ ,
                                                                                                                                v29 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v31 /*: any*/ ,
                                                                                                        v42 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraParentIssueField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v31 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "iconUrl"
                                                                                                                },
                                                                                                                v20 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v31 /*: any*/ ,
                                                                                                        v42 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v31 /*: any*/ ,
                                                                                                                v23 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "large"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v20 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraResolution",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "resolution",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v31 /*: any*/ ,
                                                                                                                v20 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraResolutionField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedSprintsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprintEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSprint",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v20 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "sprintId"
                                                                                                                                },
                                                                                                                                v31 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "state"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "endDate"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v31 /*: any*/ ,
                                                                                                        v42 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSprintField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v31 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "user",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                v31 /*: any*/ ,
                                                                                                                v55 /*: any*/ ,
                                                                                                                v56 /*: any*/ ,
                                                                                                                v20 /*: any*/ ,
                                                                                                                v57 /*: any*/ ,
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": v59 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": v58 /*: any*/ 
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "AppUser"
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": v59 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v49 /*: any*/ ,
                                                                                                        v42 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraRichText",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "richText",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraADF",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "adfValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "convertedPlainText",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "plainText"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraRichTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraServiceManagementRequestType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "requestType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v31 /*: any*/ ,
                                                                                                                v52 /*: any*/ ,
                                                                                                                v20 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraServiceManagementRequestTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": [
                                                                                                                {
                                                                                                                    "kind": "Literal",
                                                                                                                    "name": "first",
                                                                                                                    "value": 1
                                                                                                                }
                                                                                                            ],
                                                                                                            "concreteType": "JiraIssueLinkConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueLinkConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v37 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issue",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v53 /*: any*/ ,
                                                                                                                                        v23 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "args": [
                                                                                                                                                {
                                                                                                                                                    "kind": "Literal",
                                                                                                                                                    "name": "ids",
                                                                                                                                                    "value": [
                                                                                                                                                        "statusCategory"
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "fieldsById",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "edges",
                                                                                                                                                    "plural": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "node",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v19 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v28 /*: any*/ 
                                                                                                                                                                    ],
                                                                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                                                                },
                                                                                                                                                                v20 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                                                                                            "kind": "Condition",
                                                                                                                                            "passingValue": true,
                                                                                                                                            "selections": [
                                                                                                                                                v26 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v20 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "relationName"
                                                                                                                                },
                                                                                                                                v20 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "issueLinkConnection(first:1)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueLinkField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isStoryPointField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "number"
                                                                                                        },
                                                                                                        v31 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraNumberFieldFormatConfig",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "formatConfig",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "formatStyle"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "formatUnit"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v42 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraNumberField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCommentSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "commentSummary",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "canAddComment"
                                                                                                                },
                                                                                                                v37 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCommentSummaryField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v31 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "uri"
                                                                                                        },
                                                                                                        v42 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraUrlField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v31 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v39 /*: any*/ ,
                                                                                                                v51 /*: any*/ ,
                                                                                                                v20 /*: any*/ ,
                                                                                                                v60 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v42 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v31 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v20 /*: any*/ ,
                                                                                                                                v39 /*: any*/ ,
                                                                                                                                v60 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v42 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v31 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v20 /*: any*/ ,
                                                                                                                                v39 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v61 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v42 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v31 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraUserConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedUsersConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraUserEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v57 /*: any*/ ,
                                                                                                                                v31 /*: any*/ ,
                                                                                                                                v55 /*: any*/ ,
                                                                                                                                v20 /*: any*/ ,
                                                                                                                                v56 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "email"
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "AtlassianAccountUser"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v42 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v31 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraTeamView",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedTeam",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "jiraSuppliedId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "jiraSuppliedName"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v42 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraTeamViewField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraTimeTrackingField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "timeTrackingField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v20 /*: any*/ ,
                                                                                                                                v62 /*: any*/ ,
                                                                                                                                v63 /*: any*/ ,
                                                                                                                                v38 /*: any*/ ,
                                                                                                                                v31 /*: any*/ ,
                                                                                                                                v36 /*: any*/ ,
                                                                                                                                v42 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v20 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraOriginalTimeEstimateField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraTimeTrackingField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "timeTrackingField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v62 /*: any*/ ,
                                                                                                                                v63 /*: any*/ ,
                                                                                                                                v20 /*: any*/ ,
                                                                                                                                v38 /*: any*/ ,
                                                                                                                                v31 /*: any*/ ,
                                                                                                                                v36 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v20 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v42 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraOriginalTimeEstimateField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v31 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": "label",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "value"
                                                                                                                },
                                                                                                                v20 /*: any*/ ,
                                                                                                                v46 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v42 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraRadioSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v31 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v45 /*: any*/ ,
                                                                                                            "concreteType": "JiraVersionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedVersionsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersion",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v20 /*: any*/ ,
                                                                                                                                v31 /*: any*/ ,
                                                                                                                                v46 /*: any*/ ,
                                                                                                                                v47 /*: any*/ ,
                                                                                                                                v64 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                        },
                                                                                                        v42 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v31 /*: any*/ ,
                                                                                                        v66 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v45 /*: any*/ ,
                                                                                                            "concreteType": "JiraGoalConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedGoals",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGoalEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGoal",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v20 /*: any*/ ,
                                                                                                                                v23 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        v31 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "status"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v61 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "selectedGoals(first:1000)"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ClientExtension",
                                                                                                            "selections": [
                                                                                                                v33 /*: any*/ ,
                                                                                                                v41 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraGoalsField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v31 /*: any*/ ,
                                                                                                                v66 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isLinkEditable"
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraTownsquareProject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "project",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v20 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "alias": "atlasProjectName",
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "name"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "alias": "atlasProjectKey",
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "key"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "privateProject"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "hasPermission"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "isWorkspaceActive"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "iconName"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v42 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraTownsquareProjectField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v31 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v45 /*: any*/ ,
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "confluenceRemoteIssueLinks",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v20 /*: any*/ ,
                                                                                                                                v67 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "pageContent",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v19 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v67 /*: any*/ 
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraConfluencePageContentDetails"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v37 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                        },
                                                                                                        v42 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v31 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedGroupsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroupEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGroup",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v20 /*: any*/ ,
                                                                                                                                v31 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "groupId"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v42 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleGroupPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraFlag",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "flag",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isFlagged"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraFlagField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraWatch",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "watch",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "count"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isWatching"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraWatchesField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v20 /*: any*/ ,
                                                                                                                                v24 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issueTypeField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "issueType",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v31 /*: any*/ ,
                                                                                                                                                v25 /*: any*/ ,
                                                                                                                                                v20 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v20 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraParentIssueField",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "parentIssueField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "parentIssue",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v24 /*: any*/ ,
                                                                                                                                                v23 /*: any*/ ,
                                                                                                                                                v20 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v20 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v23 /*: any*/ ,
                                                                                                                                v30 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraSingleSelectUserPickerField",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "assigneeField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "user",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v19 /*: any*/ ,
                                                                                                                                                v55 /*: any*/ ,
                                                                                                                                                v20 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v20 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "args": v68 /*: any*/ ,
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "startDateViewField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": v70 /*: any*/ ,
                                                                                                                                    "storageKey": "startDateViewField(viewId:\"list_default\")"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "args": v68 /*: any*/ ,
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "endDateViewField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": v70 /*: any*/ ,
                                                                                                                                    "storageKey": "endDateViewField(viewId:\"list_default\")"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "aggregatedStartDateViewField",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": v71 /*: any*/ 
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "aggregatedEndDateViewField",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": v71 /*: any*/ 
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "JiraAggregatedTimelineField"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraTimelineVirtualField",
                                                                                                                    "abstractKey": "__isJiraTimelineVirtualField"
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraAggregatedTimelineField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v61 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v61 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "isConditionalFormattingEnabled",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSet",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fields",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "args": v45 /*: any*/ ,
                                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedComponentsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "componentId"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraComponentsField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraPriority",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "priority",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "priorityId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraPriorityField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraProject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "project",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "projectId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraProjectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "version",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v64 /*: any*/ ,
                                                                                                                        v20 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraSingleVersionPickerField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v54 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraIssueTypeField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v72 /*: any*/ 
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraSingleSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSelectableValueConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedValues",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSelectableValueEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": v72 /*: any*/ 
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraMultipleSelectField"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                },
                                                {
                                                    "condition": "shouldQueryHasChildren",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "filterByProjectKeys",
                                                                    "variableName": "projectKeys"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "hasChildren"
                                                        },
                                                        {
                                                            "args": [
                                                                v18 /*: any*/ 
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "canHaveChildIssues"
                                                        }
                                                    ]
                                                },
                                                v61 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasPreviousPage"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraIssueNavigatorPageInfo",
                                            "kind": "LinkedField",
                                            "name": "issueNavigatorPageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "firstIssuePosition"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "lastIssuePosition"
                                                }
                                            ]
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "maxCursors",
                                                    "value": 7
                                                }
                                            ],
                                            "concreteType": "JiraPageCursors",
                                            "kind": "LinkedField",
                                            "name": "pageCursors",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "around",
                                                    "plural": true,
                                                    "selections": v75 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "last",
                                                    "plural": false,
                                                    "selections": v75 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "first",
                                                    "plural": false,
                                                    "selections": [
                                                        v22 /*: any*/ ,
                                                        v73 /*: any*/ ,
                                                        v74 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "pageCursors(maxCursors:7)"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalIssueSearchResultCount"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "issueSearchError",
                                            "plural": false,
                                            "selections": [
                                                v19 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "messages"
                                                        }
                                                    ],
                                                    "type": "JiraInvalidJqlError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v43 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "errorType"
                                                        }
                                                    ],
                                                    "type": "JiraInvalidSyntaxError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v44 /*: any*/ ,
                                                    "type": "JiraServerError"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isCappingIssueSearchResult"
                                        },
                                        v61 /*: any*/ ,
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v34 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v21 /*: any*/ ,
                                    "filters": [
                                        "scope"
                                    ],
                                    "handle": "connection",
                                    "key": "IssueNavigatorJiraListViewPagination__issues",
                                    "kind": "LinkedHandle",
                                    "name": "issues",
                                    "dynamicKey": {
                                        "kind": "Variable",
                                        "name": "__dynamicKey",
                                        "variableName": "dynamicSearchKey"
                                    }
                                }
                            ],
                            "type": "JiraListView"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a04c9ba71f4ec5d0a39984669945e1eb287bfe1224b17654945bae7d8313c053",
            "metadata": {},
            "name": "IssueNavigatorJiraListViewPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider": (0, $cqxuo.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $kmr3r.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider": (0, $dexoz.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": (0, $l6otE.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": (0, $evjHZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": (0, $j2Uha.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $ad5K7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": (0, $04qit.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": (0, $6AioA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": (0, $1fipb.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider": (0, $cIDJo.default)
            }
        }
    };
}();
$ac64b2678217f671$var$node.hash = "4202ce7787f357945fc9368f8c19f775";
var $ac64b2678217f671$export$2e2bcd8739ae039 = $ac64b2678217f671$var$node;

});


parcelRegister("i9z6a", function(module, exports) {
$parcel$export(module.exports, "default", () => $bbd99d56b96405f8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c3e0f9d4a8bcf7869d491f4a2e95154d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $7OX52 = parcelRequire("7OX52");
const $bbd99d56b96405f8$var$node = function() {
    var v0 = [
        "issues"
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "options"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "saveJQLToUserHistory"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "settings"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            },
            {
                "kind": "RootArgument",
                "name": "viewConfigInput"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "bidirectional",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": {
                        "count": "last",
                        "cursor": "before"
                    },
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $7OX52.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "main_issueNavigator_IssueNavigator_listViewData",
        "selections": [
            {
                "alias": "issues",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "issueSearchInput",
                        "variableName": "issueSearchInput"
                    }
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "__IssueNavigatorListViewPagination__issues_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            },
                            {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "startCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasPreviousPage"
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "selectedIssue_issueNavigator"
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "isConditionalFormattingEnabled",
                                "variableName": "isConditionalFormattingEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKey",
                                "variableName": "projectKey"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKeys",
                                "variableName": "projectKeys"
                            },
                            {
                                "kind": "Variable",
                                "name": "shouldQueryHasChildren",
                                "variableName": "shouldQueryHasChildren"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_IssueNavigatorUI_issueResults"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "JiraListView"
    };
}();
$bbd99d56b96405f8$var$node.hash = "22a2814eefaacda9ce108e2fd8c70777";
var $bbd99d56b96405f8$export$2e2bcd8739ae039 = $bbd99d56b96405f8$var$node;

});
parcelRegister("7OX52", function(module, exports) {
$parcel$export(module.exports, "default", () => $703aedc9441552b1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5a2ce66a0569c36ac9d26ab05c0af203>>
 * @relayHash 15730465fe1389745466ccb7b543b38c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 215782df88678cb966f4a8b5505f5bab0da9d0e7af5203dd1e27e24f1aa8518e

var $3Bt2F = parcelRequire("3Bt2F");

var $cqxuo = parcelRequire("cqxuo");

var $dexoz = parcelRequire("dexoz");

var $3jVIX = parcelRequire("3jVIX");

var $l6otE = parcelRequire("l6otE");

var $ad5K7 = parcelRequire("ad5K7");

var $hHOEN = parcelRequire("hHOEN");

var $hRj2m = parcelRequire("hRj2m");

var $cIDJo = parcelRequire("cIDJo");

var $6AioA = parcelRequire("6AioA");

var $04qit = parcelRequire("04qit");

var $jvWSl = parcelRequire("jvWSl");

var $j2Uha = parcelRequire("j2Uha");

var $kmr3r = parcelRequire("kmr3r");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $gDQIG = parcelRequire("gDQIG");

var $1fipb = parcelRequire("1fipb");

var $iOvkB = parcelRequire("iOvkB");

var $evjHZ = parcelRequire("evjHZ");

var $FU9UR = parcelRequire("FU9UR");
const $703aedc9441552b1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "saveJQLToUserHistory"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "settings"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v16 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v17 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v18 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v19 = {
        "kind": "ScalarField",
        "name": "id"
    }, v20 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "options",
            "variableName": "options"
        },
        {
            "kind": "Variable",
            "name": "saveJQLToUserHistory",
            "variableName": "saveJQLToUserHistory"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        {
            "kind": "Variable",
            "name": "settings",
            "variableName": "settings"
        },
        {
            "kind": "Variable",
            "name": "viewConfigInput",
            "variableName": "viewConfigInput"
        }
    ], v21 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v22 = {
        "kind": "ScalarField",
        "name": "key"
    }, v23 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v24 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v26 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v27 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v26 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v28 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v27 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v29 = {
        "concreteType": "JiraStatusField",
        "kind": "LinkedField",
        "name": "statusField",
        "plural": false,
        "selections": [
            v28 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v30 = {
        "kind": "ScalarField",
        "name": "name"
    }, v31 = [
        v30 /*: any*/ 
    ], v32 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v33 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v34 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v35 = {
        "kind": "ScalarField",
        "name": "type"
    }, v36 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v37 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v38 = {
        "kind": "ScalarField",
        "name": "value"
    }, v39 = [
        v38 /*: any*/ ,
        v19 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v40 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v41 = {
        "kind": "ClientExtension",
        "selections": [
            v40 /*: any*/ 
        ]
    }, v42 = {
        "kind": "ScalarField",
        "name": "message"
    }, v43 = [
        v42 /*: any*/ 
    ], v44 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v45 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v46 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v47 = {
        "kind": "ScalarField",
        "name": "date"
    }, v48 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v49 = {
        "kind": "ScalarField",
        "name": "text"
    }, v50 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v19 /*: any*/ 
        ]
    }, v51 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v52 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v53 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v54 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v55 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v56 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v57 = [
        {
            "kind": "ScalarField",
            "name": "appType"
        }
    ], v58 = [
        {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isUser"
        },
        {
            "kind": "InlineFragment",
            "selections": v57 /*: any*/ ,
            "type": "AppUser"
        }
    ], v59 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v60 = {
        "kind": "ClientExtension",
        "selections": [
            v32 /*: any*/ 
        ]
    }, v61 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeInSeconds"
            }
        ]
    }, v62 = {
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "timeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v63 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v64 = [
        v19 /*: any*/ 
    ], v65 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": v64 /*: any*/ 
    }, v66 = {
        "kind": "ScalarField",
        "name": "href"
    }, v67 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v68 = {
        "kind": "InlineFragment",
        "selections": [
            v47 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v69 = [
        v18 /*: any*/ ,
        v37 /*: any*/ ,
        v68 /*: any*/ ,
        v19 /*: any*/ 
    ], v70 = [
        v18 /*: any*/ ,
        v68 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": v64 /*: any*/ ,
            "type": "Node",
            "abstractKey": "__isNode"
        }
    ], v71 = [
        v18 /*: any*/ ,
        v19 /*: any*/ 
    ], v72 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v73 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v74 = [
        v72 /*: any*/ ,
        v21 /*: any*/ ,
        v73 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueNavigatorListViewPaginationQuery",
            "selections": [
                {
                    "args": v16 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "isConditionalFormattingEnabled",
                                    "variableName": "isConditionalFormattingEnabled"
                                },
                                v17 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "projectKeys",
                                    "variableName": "projectKeys"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "shouldQueryHasChildren",
                                    "variableName": "shouldQueryHasChildren"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_IssueNavigator_listViewData"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueNavigatorListViewPaginationQuery",
            "selections": [
                {
                    "args": v16 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v20 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v21 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v24 /*: any*/ ,
                                                                        v19 /*: any*/ 
                                                                    ]
                                                                },
                                                                v19 /*: any*/ 
                                                            ]
                                                        },
                                                        v25 /*: any*/ ,
                                                        v29 /*: any*/ ,
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueTypeField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": v31 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                v32 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isHighlightedIssueRow"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v33 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueTypeField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": v31 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v18 /*: any*/ ,
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "first",
                                                            "value": 500
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v35 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldSetId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v36 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v19 /*: any*/ ,
                                                                                                v18 /*: any*/ ,
                                                                                                v37 /*: any*/ ,
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "TypeDiscriminator",
                                                                                                    "abstractKey": "__isJiraIssueField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedAffectedServicesConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAffectedService",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "serviceId"
                                                                                                                                },
                                                                                                                                v30 /*: any*/ ,
                                                                                                                                v19 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraAffectedServicesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v30 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraCascadingOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "cascadingOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentOptionValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v39 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "childOptionValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v39 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v41 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraCascadingSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedCmdbObjectsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbObject",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "objectId"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "label"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbAvatar",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "avatar",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "mediaClientConfig",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "clientId"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "fileId"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "mediaBaseUrl"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "mediaJwtToken"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "url48"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "QueryError",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "errors",
                                                                                                                    "plural": true,
                                                                                                                    "selections": v43 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCMDBField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v30 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v44 /*: any*/ ,
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v45 /*: any*/ ,
                                                                                                                                v46 /*: any*/ ,
                                                                                                                                v19 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                        },
                                                                                                        v41 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v47 /*: any*/ ,
                                                                                                        v30 /*: any*/ ,
                                                                                                        v48 /*: any*/ ,
                                                                                                        v41 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDatePickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "dateTime"
                                                                                                        },
                                                                                                        v30 /*: any*/ ,
                                                                                                        v41 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDateTimePickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraEpic",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "epic",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                v33 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "color"
                                                                                                                },
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraEpicLinkField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "renderedFieldHtml"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraFallbackField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v49 /*: any*/ ,
                                                                                                        v30 /*: any*/ ,
                                                                                                        v41 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "statusCategory",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v30 /*: any*/ ,
                                                                                                                v26 /*: any*/ ,
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatus",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "status",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v30 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "statusId"
                                                                                                                },
                                                                                                                v27 /*: any*/ ,
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v44 /*: any*/ ,
                                                                                                            "concreteType": "JiraLabelConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedLabelsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v36 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabelEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraLabel",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v30 /*: any*/ ,
                                                                                                                                v50 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                        },
                                                                                                        v30 /*: any*/ ,
                                                                                                        v41 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraLabelsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v34 /*: any*/ ,
                                                                                                                v30 /*: any*/ ,
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraColorField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueColorField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v50 /*: any*/ ,
                                                                                                                        v19 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueTypeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v51 /*: any*/ ,
                                                                                                                                v30 /*: any*/ ,
                                                                                                                                v19 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v19 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "summaryField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v49 /*: any*/ ,
                                                                                                                        v19 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v19 /*: any*/ ,
                                                                                                                v23 /*: any*/ ,
                                                                                                                v52 /*: any*/ ,
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "args": [
                                                                                                                                {
                                                                                                                                    "kind": "Literal",
                                                                                                                                    "name": "ids",
                                                                                                                                    "value": [
                                                                                                                                        "issuetype",
                                                                                                                                        "project",
                                                                                                                                        "summary",
                                                                                                                                        "status"
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "fieldsById",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "edges",
                                                                                                                                    "plural": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "node",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v18 /*: any*/ ,
                                                                                                                                                v19 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v37 /*: any*/ ,
                                                                                                                                                        v49 /*: any*/ 
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v37 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "issueType",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v19 /*: any*/ ,
                                                                                                                                                                v53 /*: any*/ ,
                                                                                                                                                                v30 /*: any*/ ,
                                                                                                                                                                v51 /*: any*/ ,
                                                                                                                                                                v24 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v37 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraStatus",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "status",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v19 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "statusCategory",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                                                        v26 /*: any*/ 
                                                                                                                                                                    ]
                                                                                                                                                                }
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraStatusField"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueTypeField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v37 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issueType",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v53 /*: any*/ ,
                                                                                                                                        v24 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSingleLineTextField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "summaryField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v37 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraStatusField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "statusField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v37 /*: any*/ ,
                                                                                                                                v28 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v30 /*: any*/ ,
                                                                                                        v41 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraParentIssueField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v30 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "iconUrl"
                                                                                                                },
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v30 /*: any*/ ,
                                                                                                        v41 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v30 /*: any*/ ,
                                                                                                                v22 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "large"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraResolution",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "resolution",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v30 /*: any*/ ,
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraResolutionField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedSprintsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprintEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSprint",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "sprintId"
                                                                                                                                },
                                                                                                                                v30 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "state"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "endDate"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v30 /*: any*/ ,
                                                                                                        v41 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSprintField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v30 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "user",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v18 /*: any*/ ,
                                                                                                                v30 /*: any*/ ,
                                                                                                                v54 /*: any*/ ,
                                                                                                                v55 /*: any*/ ,
                                                                                                                v19 /*: any*/ ,
                                                                                                                v56 /*: any*/ ,
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": v58 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": v57 /*: any*/ 
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "AppUser"
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": v58 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v48 /*: any*/ ,
                                                                                                        v41 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraRichText",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "richText",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraADF",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "adfValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "convertedPlainText",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "plainText"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraRichTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraServiceManagementRequestType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "requestType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v30 /*: any*/ ,
                                                                                                                v51 /*: any*/ ,
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraServiceManagementRequestTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": [
                                                                                                                {
                                                                                                                    "kind": "Literal",
                                                                                                                    "name": "first",
                                                                                                                    "value": 1
                                                                                                                }
                                                                                                            ],
                                                                                                            "concreteType": "JiraIssueLinkConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueLinkConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v36 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issue",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v52 /*: any*/ ,
                                                                                                                                        v22 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "args": [
                                                                                                                                                {
                                                                                                                                                    "kind": "Literal",
                                                                                                                                                    "name": "ids",
                                                                                                                                                    "value": [
                                                                                                                                                        "statusCategory"
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "fieldsById",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "edges",
                                                                                                                                                    "plural": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "node",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v18 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v27 /*: any*/ 
                                                                                                                                                                    ],
                                                                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                                                                },
                                                                                                                                                                v19 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                                                                                            "kind": "Condition",
                                                                                                                                            "passingValue": true,
                                                                                                                                            "selections": [
                                                                                                                                                v25 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v19 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "relationName"
                                                                                                                                },
                                                                                                                                v19 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "issueLinkConnection(first:1)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueLinkField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isStoryPointField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "number"
                                                                                                        },
                                                                                                        v30 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraNumberFieldFormatConfig",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "formatConfig",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "formatStyle"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "formatUnit"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v41 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraNumberField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCommentSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "commentSummary",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "canAddComment"
                                                                                                                },
                                                                                                                v36 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCommentSummaryField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v30 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "uri"
                                                                                                        },
                                                                                                        v41 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraUrlField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v30 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v38 /*: any*/ ,
                                                                                                                v50 /*: any*/ ,
                                                                                                                v19 /*: any*/ ,
                                                                                                                v59 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v41 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v30 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v38 /*: any*/ ,
                                                                                                                                v59 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v41 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v30 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v38 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v60 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v41 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v30 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraUserConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedUsersConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraUserEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                v56 /*: any*/ ,
                                                                                                                                v30 /*: any*/ ,
                                                                                                                                v54 /*: any*/ ,
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v55 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "email"
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "AtlassianAccountUser"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v41 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v30 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraTeamView",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedTeam",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "jiraSuppliedId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "jiraSuppliedName"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v41 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraTeamViewField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraTimeTrackingField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "timeTrackingField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v61 /*: any*/ ,
                                                                                                                                v62 /*: any*/ ,
                                                                                                                                v37 /*: any*/ ,
                                                                                                                                v30 /*: any*/ ,
                                                                                                                                v35 /*: any*/ ,
                                                                                                                                v41 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v19 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraOriginalTimeEstimateField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraTimeTrackingField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "timeTrackingField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v61 /*: any*/ ,
                                                                                                                                v62 /*: any*/ ,
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v37 /*: any*/ ,
                                                                                                                                v30 /*: any*/ ,
                                                                                                                                v35 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v19 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v41 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraOriginalTimeEstimateField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v30 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": "label",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "value"
                                                                                                                },
                                                                                                                v19 /*: any*/ ,
                                                                                                                v45 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v41 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraRadioSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v30 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v44 /*: any*/ ,
                                                                                                            "concreteType": "JiraVersionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedVersionsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersion",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v30 /*: any*/ ,
                                                                                                                                v45 /*: any*/ ,
                                                                                                                                v46 /*: any*/ ,
                                                                                                                                v63 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                        },
                                                                                                        v41 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v30 /*: any*/ ,
                                                                                                        v65 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v44 /*: any*/ ,
                                                                                                            "concreteType": "JiraGoalConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedGoals",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGoalEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGoal",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v22 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        v30 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "status"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v60 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "selectedGoals(first:1000)"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ClientExtension",
                                                                                                            "selections": [
                                                                                                                v32 /*: any*/ ,
                                                                                                                v40 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraGoalsField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v30 /*: any*/ ,
                                                                                                                v65 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isLinkEditable"
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraTownsquareProject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "project",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "alias": "atlasProjectName",
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "name"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "alias": "atlasProjectKey",
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "key"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "privateProject"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "hasPermission"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "isWorkspaceActive"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "iconName"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v41 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraTownsquareProjectField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v30 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v44 /*: any*/ ,
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "confluenceRemoteIssueLinks",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v66 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "pageContent",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v18 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v66 /*: any*/ 
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraConfluencePageContentDetails"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v36 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                        },
                                                                                                        v41 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v30 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedGroupsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroupEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGroup",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v30 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "groupId"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v41 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleGroupPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraFlag",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "flag",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isFlagged"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraFlagField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraWatch",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "watch",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "count"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isWatching"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraWatchesField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v23 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issueTypeField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "issueType",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v30 /*: any*/ ,
                                                                                                                                                v24 /*: any*/ ,
                                                                                                                                                v19 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v19 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraParentIssueField",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "parentIssueField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "parentIssue",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v23 /*: any*/ ,
                                                                                                                                                v22 /*: any*/ ,
                                                                                                                                                v19 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v19 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v22 /*: any*/ ,
                                                                                                                                v29 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraSingleSelectUserPickerField",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "assigneeField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "user",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v18 /*: any*/ ,
                                                                                                                                                v54 /*: any*/ ,
                                                                                                                                                v19 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v19 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "args": v67 /*: any*/ ,
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "startDateViewField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": v69 /*: any*/ ,
                                                                                                                                    "storageKey": "startDateViewField(viewId:\"list_default\")"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "args": v67 /*: any*/ ,
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "endDateViewField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": v69 /*: any*/ ,
                                                                                                                                    "storageKey": "endDateViewField(viewId:\"list_default\")"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "aggregatedStartDateViewField",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": v70 /*: any*/ 
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "aggregatedEndDateViewField",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": v70 /*: any*/ 
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "JiraAggregatedTimelineField"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraTimelineVirtualField",
                                                                                                                    "abstractKey": "__isJiraTimelineVirtualField"
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraAggregatedTimelineField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v60 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v60 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "isConditionalFormattingEnabled",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSet",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fields",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "args": v44 /*: any*/ ,
                                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedComponentsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "componentId"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraComponentsField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraPriority",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "priority",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "priorityId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraPriorityField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraProject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "project",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "projectId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraProjectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "version",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v63 /*: any*/ ,
                                                                                                                        v19 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraSingleVersionPickerField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v53 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraIssueTypeField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v71 /*: any*/ 
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraSingleSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSelectableValueConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedValues",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSelectableValueEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": v71 /*: any*/ 
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraMultipleSelectField"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                },
                                                {
                                                    "condition": "shouldQueryHasChildren",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "filterByProjectKeys",
                                                                    "variableName": "projectKeys"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "hasChildren"
                                                        },
                                                        {
                                                            "args": [
                                                                v17 /*: any*/ 
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "canHaveChildIssues"
                                                        }
                                                    ]
                                                },
                                                v60 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasPreviousPage"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraIssueNavigatorPageInfo",
                                            "kind": "LinkedField",
                                            "name": "issueNavigatorPageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "firstIssuePosition"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "lastIssuePosition"
                                                }
                                            ]
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "maxCursors",
                                                    "value": 7
                                                }
                                            ],
                                            "concreteType": "JiraPageCursors",
                                            "kind": "LinkedField",
                                            "name": "pageCursors",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "around",
                                                    "plural": true,
                                                    "selections": v74 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "last",
                                                    "plural": false,
                                                    "selections": v74 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "first",
                                                    "plural": false,
                                                    "selections": [
                                                        v21 /*: any*/ ,
                                                        v72 /*: any*/ ,
                                                        v73 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "pageCursors(maxCursors:7)"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalIssueSearchResultCount"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "issueSearchError",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "messages"
                                                        }
                                                    ],
                                                    "type": "JiraInvalidJqlError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v42 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "errorType"
                                                        }
                                                    ],
                                                    "type": "JiraInvalidSyntaxError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v43 /*: any*/ ,
                                                    "type": "JiraServerError"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isCappingIssueSearchResult"
                                        },
                                        v60 /*: any*/ ,
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v33 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v20 /*: any*/ ,
                                    "filters": [
                                        "issueSearchInput"
                                    ],
                                    "handle": "connection",
                                    "key": "IssueNavigatorListViewPagination__issues",
                                    "kind": "LinkedHandle",
                                    "name": "issues"
                                }
                            ],
                            "type": "JiraListView"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "215782df88678cb966f4a8b5505f5bab0da9d0e7af5203dd1e27e24f1aa8518e",
            "metadata": {},
            "name": "IssueNavigatorListViewPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider": (0, $cqxuo.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $kmr3r.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider": (0, $dexoz.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": (0, $l6otE.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": (0, $evjHZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": (0, $j2Uha.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $ad5K7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": (0, $04qit.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": (0, $6AioA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": (0, $1fipb.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider": (0, $cIDJo.default)
            }
        }
    };
}();
$703aedc9441552b1$var$node.hash = "22a2814eefaacda9ce108e2fd8c70777";
var $703aedc9441552b1$export$2e2bcd8739ae039 = $703aedc9441552b1$var$node;

});


parcelRegister("aH23d", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6d9f0d1a7266434$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b534faaaeafdc717ddce9506710fb700>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $hivfJ = parcelRequire("hivfJ");
const $f6d9f0d1a7266434$var$node = function() {
    var v0 = [
        "groups"
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "dynamicSearchKey"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsScope"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "groupBy"
            },
            {
                "kind": "RootArgument",
                "name": "isPaginating"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "saveJQLToUserHistory"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "settings"
            },
            {
                "kind": "RootArgument",
                "name": "viewConfigInput"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "bidirectional",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": {
                        "count": "last",
                        "cursor": "before"
                    },
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $hivfJ.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "main_issueNavigator_IssueNavigator_jiraGroupedListViewData",
        "selections": [
            {
                "alias": "groups",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "__dynamicKey",
                        "variableName": "dynamicSearchKey"
                    },
                    {
                        "kind": "Variable",
                        "name": "scope",
                        "variableName": "scope"
                    }
                ],
                "concreteType": "JiraSpreadsheetGroupConnection",
                "kind": "LinkedField",
                "name": "__IssueNavigatorJiraGroupedListViewPagination__groups_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSpreadsheetGroupEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            },
                            {
                                "concreteType": "JiraSpreadsheetGroup",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "startCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasPreviousPage"
                            }
                        ]
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "projectKey",
                                "variableName": "projectKey"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKeys",
                                "variableName": "projectKeys"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_IssueNavigatorUI_groupResults"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "JiraGroupedListView"
    };
}();
$f6d9f0d1a7266434$var$node.hash = "a3087f737b3cfd1d99f06c65f0e1b784";
var $f6d9f0d1a7266434$export$2e2bcd8739ae039 = $f6d9f0d1a7266434$var$node;

});
parcelRegister("hivfJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5e601b42b329449$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<41ca775b73814c61fdd493942ddd6906>>
 * @relayHash 181e55ed13d7f9dadf7c6d91e01102ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 54c0e76532ac95b919f7ab088428a532fc3d167f1cab5b8679a6c7479119261f

var $3Bt2F = parcelRequire("3Bt2F");

var $8jq8m = parcelRequire("8jq8m");

var $3jVIX = parcelRequire("3jVIX");

var $4GS9O = parcelRequire("4GS9O");

var $ad5K7 = parcelRequire("ad5K7");

var $hHOEN = parcelRequire("hHOEN");

var $hRj2m = parcelRequire("hRj2m");

var $6AioA = parcelRequire("6AioA");

var $04qit = parcelRequire("04qit");

var $jvWSl = parcelRequire("jvWSl");

var $j2Uha = parcelRequire("j2Uha");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $gDQIG = parcelRequire("gDQIG");

var $1fipb = parcelRequire("1fipb");

var $iOvkB = parcelRequire("iOvkB");

var $evjHZ = parcelRequire("evjHZ");

var $FU9UR = parcelRequire("FU9UR");
const $e5e601b42b329449$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "dynamicSearchKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsScope"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "groupBy"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isPaginating"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "saveJQLToUserHistory"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "settings"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v17 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v18 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v19 = {
        "kind": "ScalarField",
        "name": "id"
    }, v20 = {
        "kind": "Variable",
        "name": "settings",
        "variableName": "settings"
    }, v21 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "groupBy",
            "variableName": "groupBy"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "saveJQLToUserHistory",
            "variableName": "saveJQLToUserHistory"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        v20 /*: any*/ 
    ], v22 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v23 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v24 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v25 = {
        "kind": "ScalarField",
        "name": "fieldType"
    }, v26 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v27 = {
        "kind": "ScalarField",
        "name": "name"
    }, v28 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v29 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v30 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v31 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v32 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v33 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v19 /*: any*/ ,
            v32 /*: any*/ 
        ]
    }, v34 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v32 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v35 = {
        "kind": "ScalarField",
        "name": "number"
    }, v36 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v37 = {
        "kind": "ScalarField",
        "name": "value"
    }, v38 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v19 /*: any*/ 
        ]
    }, v39 = [
        v19 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "sprintId"
        },
        v27 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "state"
        },
        {
            "kind": "ScalarField",
            "name": "endDate"
        }
    ], v40 = [
        v27 /*: any*/ ,
        v38 /*: any*/ 
    ], v41 = {
        "kind": "ScalarField",
        "name": "groupId"
    }, v42 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v43 = {
        "kind": "ScalarField",
        "name": "status"
    }, v44 = {
        "kind": "ScalarField",
        "name": "key"
    }, v45 = {
        "kind": "ScalarField",
        "name": "privateProject"
    }, v46 = {
        "kind": "ScalarField",
        "name": "hasPermission"
    }, v47 = {
        "kind": "ScalarField",
        "name": "iconName"
    }, v48 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v49 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v50 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v51 = {
        "kind": "LinkedField",
        "name": "fieldValue",
        "plural": false,
        "selections": [
            v18 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "jqlTerm"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraPriority",
                        "kind": "LinkedField",
                        "name": "priority",
                        "plural": false,
                        "selections": [
                            v19 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "priorityId"
                            },
                            v27 /*: any*/ ,
                            v28 /*: any*/ 
                        ]
                    },
                    v29 /*: any*/ 
                ],
                "type": "JiraJqlPriorityFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v30 /*: any*/ ,
                            v27 /*: any*/ ,
                            v31 /*: any*/ 
                        ]
                    },
                    v29 /*: any*/ 
                ],
                "type": "JiraJqlUserFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": [
                            v19 /*: any*/ ,
                            v27 /*: any*/ ,
                            v33 /*: any*/ 
                        ]
                    },
                    v29 /*: any*/ ,
                    v34 /*: any*/ 
                ],
                "type": "JiraJqlStatusFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v35 /*: any*/ 
                ],
                "type": "JiraJqlNumberFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "option",
                        "plural": false,
                        "selections": [
                            v19 /*: any*/ ,
                            v36 /*: any*/ ,
                            v37 /*: any*/ ,
                            v38 /*: any*/ 
                        ]
                    },
                    v29 /*: any*/ 
                ],
                "type": "JiraJqlOptionFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraSprint",
                        "kind": "LinkedField",
                        "name": "sprint",
                        "plural": false,
                        "selections": v39 /*: any*/ 
                    },
                    v29 /*: any*/ 
                ],
                "type": "JiraJqlSprintFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraLabel",
                        "kind": "LinkedField",
                        "name": "label",
                        "plural": false,
                        "selections": v40 /*: any*/ 
                    }
                ],
                "type": "JiraJqlLabelFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraGroup",
                        "kind": "LinkedField",
                        "name": "group",
                        "plural": false,
                        "selections": [
                            v19 /*: any*/ ,
                            v41 /*: any*/ ,
                            v27 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraJqlGroupFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraVersion",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            v19 /*: any*/ ,
                            v42 /*: any*/ ,
                            v27 /*: any*/ 
                        ]
                    },
                    v29 /*: any*/ 
                ],
                "type": "JiraJqlVersionFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v29 /*: any*/ ,
                    {
                        "concreteType": "JiraGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                            v43 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "score"
                            },
                            v19 /*: any*/ ,
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    v44 /*: any*/ ,
                                    v27 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraJqlGoalsFieldValue"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraTownsquareProject",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": [
                                    v19 /*: any*/ ,
                                    v44 /*: any*/ ,
                                    v45 /*: any*/ ,
                                    v46 /*: any*/ ,
                                    v27 /*: any*/ ,
                                    v47 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlTownsquareProjectFieldValue"
                    }
                ]
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "issueTypes",
                        "plural": true,
                        "selections": [
                            v27 /*: any*/ ,
                            v48 /*: any*/ ,
                            v19 /*: any*/ ,
                            v49 /*: any*/ ,
                            v50 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraJqlIssueTypeFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v29 /*: any*/ ,
                    {
                        "concreteType": "JiraResolution",
                        "kind": "LinkedField",
                        "name": "resolution",
                        "plural": false,
                        "selections": [
                            v19 /*: any*/ ,
                            v27 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraJqlResolutionFieldValue"
            }
        ]
    }, v52 = {
        "kind": "ScalarField",
        "name": "issueCount"
    }, v53 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v54 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v55 = {
        "kind": "ScalarField",
        "name": "message"
    }, v56 = [
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "fieldSetsScope"
        },
        v20 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "viewConfigInput",
            "variableName": "viewConfigInput"
        }
    ], v57 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v58 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v59 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v34 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v60 = {
        "concreteType": "JiraStatusField",
        "kind": "LinkedField",
        "name": "statusField",
        "plural": false,
        "selections": [
            v59 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v61 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v62 = {
        "kind": "ScalarField",
        "name": "type"
    }, v63 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v64 = [
        v37 /*: any*/ ,
        v19 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v65 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v66 = {
        "kind": "ClientExtension",
        "selections": [
            v65 /*: any*/ 
        ]
    }, v67 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v68 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v69 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v70 = {
        "kind": "ScalarField",
        "name": "date"
    }, v71 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v72 = {
        "kind": "ScalarField",
        "name": "text"
    }, v73 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v74 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v75 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v76 = [
        {
            "kind": "ScalarField",
            "name": "appType"
        }
    ], v77 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeInSeconds"
            }
        ]
    }, v78 = {
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "timeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v79 = [
        v19 /*: any*/ 
    ], v80 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": v79 /*: any*/ 
    }, v81 = {
        "kind": "ClientExtension",
        "selections": [
            v61 /*: any*/ 
        ]
    }, v82 = {
        "kind": "ScalarField",
        "name": "href"
    }, v83 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v84 = {
        "kind": "InlineFragment",
        "selections": [
            v70 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v85 = [
        v18 /*: any*/ ,
        v24 /*: any*/ ,
        v84 /*: any*/ ,
        v19 /*: any*/ 
    ], v86 = [
        v18 /*: any*/ ,
        v84 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": v79 /*: any*/ ,
            "type": "Node",
            "abstractKey": "__isNode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueNavigatorJiraGroupedListViewPaginationQuery",
            "selections": [
                {
                    "args": v17 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "projectKey",
                                    "variableName": "projectKey"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "projectKeys",
                                    "variableName": "projectKeys"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_IssueNavigator_jiraGroupedListViewData"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v7 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueNavigatorJiraGroupedListViewPaginationQuery",
            "selections": [
                {
                    "args": v17 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v21 /*: any*/ ,
                                    "concreteType": "JiraSpreadsheetGroupConnection",
                                    "kind": "LinkedField",
                                    "name": "groups",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSpreadsheetGroupEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v22 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraSpreadsheetGroup",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        v51 /*: any*/ ,
                                                        v52 /*: any*/ 
                                                    ]
                                                },
                                                v18 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                v53 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startCursor"
                                                },
                                                v54 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasPreviousPage"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "groupByField"
                                        },
                                        v23 /*: any*/ ,
                                        {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "statusCode"
                                                        }
                                                    ]
                                                },
                                                v55 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "isPaginating",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSpreadsheetGroup",
                                                    "kind": "LinkedField",
                                                    "name": "firstGroup",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        {
                                                            "args": v56 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v18 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssue",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v18 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                v57 /*: any*/ ,
                                                                                v44 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issueTypeField",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v50 /*: any*/ ,
                                                                                                v19 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v58 /*: any*/ ,
                                                                                v60 /*: any*/ ,
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueTypeField",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ClientExtension",
                                                                                    "selections": [
                                                                                        v61 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "isHighlightedIssueRow"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "first",
                                                                                    "value": 500
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSets",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldSet",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v62 /*: any*/ ,
                                                                                                v26 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fields",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v63 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v24 /*: any*/ ,
                                                                                                                        v62 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "TypeDiscriminator",
                                                                                                                            "abstractKey": "__isJiraIssueField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedAffectedServicesConnection",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraAffectedService",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                            "name": "serviceId"
                                                                                                                                                        },
                                                                                                                                                        v27 /*: any*/ ,
                                                                                                                                                        v19 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraAffectedServicesField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCascadingOption",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "cascadingOption",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraOption",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "parentOptionValue",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": v64 /*: any*/ 
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraOption",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "childOptionValue",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": v64 /*: any*/ 
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v66 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraCascadingSelectField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedCmdbObjectsConnection",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraCmdbObject",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                            "name": "objectId"
                                                                                                                                                        },
                                                                                                                                                        {
                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                            "name": "label"
                                                                                                                                                        },
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraCmdbAvatar",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "avatar",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                {
                                                                                                                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "mediaClientConfig",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                                            "name": "clientId"
                                                                                                                                                                        },
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                                            "name": "fileId"
                                                                                                                                                                        },
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                                            "name": "mediaBaseUrl"
                                                                                                                                                                        },
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                                            "name": "mediaJwtToken"
                                                                                                                                                                        }
                                                                                                                                                                    ]
                                                                                                                                                                },
                                                                                                                                                                {
                                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                                    "name": "url48"
                                                                                                                                                                }
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "concreteType": "QueryError",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "errors",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                v55 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraCMDBField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": v67 /*: any*/ ,
                                                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedComponentsConnection",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v68 /*: any*/ ,
                                                                                                                                                        v69 /*: any*/ ,
                                                                                                                                                        v19 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                                                },
                                                                                                                                v66 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraComponentsField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v70 /*: any*/ ,
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v71 /*: any*/ ,
                                                                                                                                v66 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraDatePickerField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "dateTime"
                                                                                                                                },
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v66 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraDateTimePickerField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraEpic",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "epic",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v44 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "summary"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "color"
                                                                                                                                        },
                                                                                                                                        v19 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraEpicLinkField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "renderedFieldHtml"
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraFallbackField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v72 /*: any*/ ,
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v66 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "statusCategory",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v27 /*: any*/ ,
                                                                                                                                        v32 /*: any*/ ,
                                                                                                                                        v19 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraStatus",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "status",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v27 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "statusId"
                                                                                                                                        },
                                                                                                                                        v34 /*: any*/ ,
                                                                                                                                        v19 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraStatusField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "args": v67 /*: any*/ ,
                                                                                                                                    "concreteType": "JiraLabelConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedLabelsConnection",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v63 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraLabelEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraLabel",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": v40 /*: any*/ 
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                                                },
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v66 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraLabelsField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issueType",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v48 /*: any*/ ,
                                                                                                                                        v27 /*: any*/ ,
                                                                                                                                        v19 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "parentIssue",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v44 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraColorField",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "issueColorField",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v38 /*: any*/ ,
                                                                                                                                                v19 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "issueTypeField",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "issueType",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v73 /*: any*/ ,
                                                                                                                                                        v27 /*: any*/ ,
                                                                                                                                                        v19 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                },
                                                                                                                                                v19 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraSingleLineTextField",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "summaryField",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v72 /*: any*/ ,
                                                                                                                                                v19 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        v57 /*: any*/ ,
                                                                                                                                        v74 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                                                            "kind": "Condition",
                                                                                                                                            "passingValue": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "args": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "Literal",
                                                                                                                                                            "name": "ids",
                                                                                                                                                            "value": [
                                                                                                                                                                "issuetype",
                                                                                                                                                                "project",
                                                                                                                                                                "summary",
                                                                                                                                                                "status"
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ],
                                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "fieldsById",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "edges",
                                                                                                                                                            "plural": true,
                                                                                                                                                            "selections": [
                                                                                                                                                                {
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "node",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                                            "selections": [
                                                                                                                                                                                v24 /*: any*/ ,
                                                                                                                                                                                v72 /*: any*/ 
                                                                                                                                                                            ],
                                                                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                                                                        },
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                                            "selections": [
                                                                                                                                                                                v24 /*: any*/ ,
                                                                                                                                                                                {
                                                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                                    "name": "issueType",
                                                                                                                                                                                    "plural": false,
                                                                                                                                                                                    "selections": [
                                                                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                                                                        v49 /*: any*/ ,
                                                                                                                                                                                        v27 /*: any*/ ,
                                                                                                                                                                                        v73 /*: any*/ ,
                                                                                                                                                                                        v50 /*: any*/ 
                                                                                                                                                                                    ]
                                                                                                                                                                                }
                                                                                                                                                                            ],
                                                                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                                                                        },
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                                            "selections": [
                                                                                                                                                                                v24 /*: any*/ ,
                                                                                                                                                                                {
                                                                                                                                                                                    "concreteType": "JiraStatus",
                                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                                    "name": "status",
                                                                                                                                                                                    "plural": false,
                                                                                                                                                                                    "selections": [
                                                                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                                                                        v33 /*: any*/ 
                                                                                                                                                                                    ]
                                                                                                                                                                                }
                                                                                                                                                                            ],
                                                                                                                                                                            "type": "JiraStatusField"
                                                                                                                                                                        }
                                                                                                                                                                    ]
                                                                                                                                                                }
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ],
                                                                                                                                                    "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                                                            "kind": "Condition",
                                                                                                                                            "passingValue": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "issueTypeField",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v24 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "issueType",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v49 /*: any*/ ,
                                                                                                                                                                v50 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "summaryField",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v24 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraStatusField",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "statusField",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                                        v24 /*: any*/ ,
                                                                                                                                                        v59 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v66 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraParentIssueField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraPriority",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "priority",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v27 /*: any*/ ,
                                                                                                                                        v28 /*: any*/ ,
                                                                                                                                        v19 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v66 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraPriorityField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraProject",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "project",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v27 /*: any*/ ,
                                                                                                                                        v44 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraAvatar",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "avatar",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "large"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v19 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraProjectField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraResolution",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "resolution",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v27 /*: any*/ ,
                                                                                                                                        v19 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraResolutionField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraSprintConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedSprintsConnection",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraSprintEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraSprint",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": v39 /*: any*/ 
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v66 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraSprintField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "user",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                        v27 /*: any*/ ,
                                                                                                                                        v31 /*: any*/ ,
                                                                                                                                        v75 /*: any*/ ,
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        v30 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
                                                                                                                                            "kind": "Condition",
                                                                                                                                            "passingValue": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "TypeDiscriminator",
                                                                                                                                                    "abstractKey": "__isUser"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": v76 /*: any*/ ,
                                                                                                                                                    "type": "AppUser"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider",
                                                                                                                                                    "kind": "Condition",
                                                                                                                                                    "passingValue": true,
                                                                                                                                                    "selections": v76 /*: any*/ 
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "AppUser"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v71 /*: any*/ ,
                                                                                                                                v66 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraRichText",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "richText",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraADF",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "adfValue",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "convertedPlainText",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                            "name": "plainText"
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraRichTextField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraServiceManagementRequestType",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "requestType",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v27 /*: any*/ ,
                                                                                                                                        v73 /*: any*/ ,
                                                                                                                                        v19 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraServiceManagementRequestTypeField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "args": [
                                                                                                                                        {
                                                                                                                                            "kind": "Literal",
                                                                                                                                            "name": "first",
                                                                                                                                            "value": 1
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "concreteType": "JiraIssueLinkConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issueLinkConnection",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v63 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueLinkEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "issue",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v74 /*: any*/ ,
                                                                                                                                                                v44 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "args": [
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "Literal",
                                                                                                                                                                            "name": "ids",
                                                                                                                                                                            "value": [
                                                                                                                                                                                "statusCategory"
                                                                                                                                                                            ]
                                                                                                                                                                        }
                                                                                                                                                                    ],
                                                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "fieldsById",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        {
                                                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                                            "name": "edges",
                                                                                                                                                                            "plural": true,
                                                                                                                                                                            "selections": [
                                                                                                                                                                                {
                                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                                    "name": "node",
                                                                                                                                                                                    "plural": false,
                                                                                                                                                                                    "selections": [
                                                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                                                        {
                                                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                                                            "selections": [
                                                                                                                                                                                                v34 /*: any*/ 
                                                                                                                                                                                            ],
                                                                                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                                                                                        },
                                                                                                                                                                                        v19 /*: any*/ 
                                                                                                                                                                                    ]
                                                                                                                                                                                }
                                                                                                                                                                            ]
                                                                                                                                                                        }
                                                                                                                                                                    ],
                                                                                                                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                                                },
                                                                                                                                                                {
                                                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                                                                                                                    "kind": "Condition",
                                                                                                                                                                    "passingValue": true,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v58 /*: any*/ 
                                                                                                                                                                    ]
                                                                                                                                                                },
                                                                                                                                                                v19 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        },
                                                                                                                                                        {
                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                            "name": "relationName"
                                                                                                                                                        },
                                                                                                                                                        v19 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "issueLinkConnection(first:1)"
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraIssueLinkField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "isStoryPointField"
                                                                                                                                },
                                                                                                                                v35 /*: any*/ ,
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraNumberFieldFormatConfig",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "formatConfig",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "formatStyle"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "formatUnit"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v66 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraNumberField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCommentSummary",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "commentSummary",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "canAddComment"
                                                                                                                                        },
                                                                                                                                        v63 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraCommentSummaryField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "uri"
                                                                                                                                },
                                                                                                                                v66 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraUrlField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraOption",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "fieldOption",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v37 /*: any*/ ,
                                                                                                                                        v38 /*: any*/ ,
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        v36 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v66 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraSingleSelectField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedOptions",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraOption",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                                        v37 /*: any*/ ,
                                                                                                                                                        v36 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v66 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraMultipleSelectField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedOptions",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraOption",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                                        v37 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v66 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraCheckboxesField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraUserConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedUsersConnection",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraUserEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                        v30 /*: any*/ ,
                                                                                                                                                        v27 /*: any*/ ,
                                                                                                                                                        v31 /*: any*/ ,
                                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                                        v75 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                {
                                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                                    "name": "email"
                                                                                                                                                                }
                                                                                                                                                            ],
                                                                                                                                                            "type": "AtlassianAccountUser"
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v66 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraTeamView",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedTeam",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "jiraSuppliedId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "jiraSuppliedName"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v66 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraTeamViewField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "issue",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "timeTrackingField",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                                        v77 /*: any*/ ,
                                                                                                                                                        v78 /*: any*/ ,
                                                                                                                                                        v24 /*: any*/ ,
                                                                                                                                                        v27 /*: any*/ ,
                                                                                                                                                        v62 /*: any*/ ,
                                                                                                                                                        v66 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                },
                                                                                                                                                v19 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "issue",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "timeTrackingField",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v77 /*: any*/ ,
                                                                                                                                                        v78 /*: any*/ ,
                                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                                        v24 /*: any*/ ,
                                                                                                                                                        v27 /*: any*/ ,
                                                                                                                                                        v62 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                },
                                                                                                                                                v19 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v66 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraOption",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedOption",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "alias": "label",
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "value"
                                                                                                                                        },
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        v68 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v66 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraRadioSelectField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": v67 /*: any*/ ,
                                                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedVersionsConnection",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                                        v27 /*: any*/ ,
                                                                                                                                                        v68 /*: any*/ ,
                                                                                                                                                        v69 /*: any*/ ,
                                                                                                                                                        v42 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                                                },
                                                                                                                                v66 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v80 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": v67 /*: any*/ ,
                                                                                                                                    "concreteType": "JiraGoalConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedGoals",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraGoalEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraGoal",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                                        v44 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                                                                                                            "kind": "Condition",
                                                                                                                                                            "passingValue": true,
                                                                                                                                                            "selections": [
                                                                                                                                                                v27 /*: any*/ ,
                                                                                                                                                                v43 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v81 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ClientExtension",
                                                                                                                                    "selections": [
                                                                                                                                        v61 /*: any*/ ,
                                                                                                                                        v65 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraGoalsField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v27 /*: any*/ ,
                                                                                                                                        v80 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "isLinkEditable"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraTownsquareProject",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "project",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v19 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "alias": "atlasProjectName",
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "name"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "alias": "atlasProjectKey",
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "key"
                                                                                                                                                },
                                                                                                                                                v45 /*: any*/ ,
                                                                                                                                                v46 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "isWorkspaceActive"
                                                                                                                                                },
                                                                                                                                                v47 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v66 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "type": "JiraTownsquareProjectField"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": v67 /*: any*/ ,
                                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "confluenceRemoteIssueLinks",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                                        v82 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                                                                            "kind": "Condition",
                                                                                                                                                            "passingValue": true,
                                                                                                                                                            "selections": [
                                                                                                                                                                {
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "pageContent",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                                            "selections": [
                                                                                                                                                                                v82 /*: any*/ 
                                                                                                                                                                            ],
                                                                                                                                                                            "type": "JiraConfluencePageContentDetails"
                                                                                                                                                                        }
                                                                                                                                                                    ]
                                                                                                                                                                }
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v63 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                                                },
                                                                                                                                v66 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraGroupConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedGroupsConnection",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraGroupEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraGroup",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                                        v27 /*: any*/ ,
                                                                                                                                                        v41 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v66 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraMultipleGroupPickerField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraFlag",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "flag",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "isFlagged"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraFlagField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraWatch",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "watch",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "count"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "isWatching"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraWatchesField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "issue",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                                        v57 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "issueTypeField",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                {
                                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "issueType",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v27 /*: any*/ ,
                                                                                                                                                                        v50 /*: any*/ ,
                                                                                                                                                                        v19 /*: any*/ 
                                                                                                                                                                    ]
                                                                                                                                                                },
                                                                                                                                                                v19 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        },
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraParentIssueField",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "parentIssueField",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                {
                                                                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "parentIssue",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v57 /*: any*/ ,
                                                                                                                                                                        v44 /*: any*/ ,
                                                                                                                                                                        v19 /*: any*/ 
                                                                                                                                                                    ]
                                                                                                                                                                },
                                                                                                                                                                v19 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        },
                                                                                                                                                        v44 /*: any*/ ,
                                                                                                                                                        v60 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraSingleSelectUserPickerField",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "assigneeField",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                {
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "user",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                                        v31 /*: any*/ ,
                                                                                                                                                                        v19 /*: any*/ 
                                                                                                                                                                    ]
                                                                                                                                                                },
                                                                                                                                                                v19 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        },
                                                                                                                                                        {
                                                                                                                                                            "args": v83 /*: any*/ ,
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "startDateViewField",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": v85 /*: any*/ ,
                                                                                                                                                            "storageKey": "startDateViewField(viewId:\"list_default\")"
                                                                                                                                                        },
                                                                                                                                                        {
                                                                                                                                                            "args": v83 /*: any*/ ,
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "endDateViewField",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": v85 /*: any*/ ,
                                                                                                                                                            "storageKey": "endDateViewField(viewId:\"list_default\")"
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                                                                                                                                    "kind": "Condition",
                                                                                                                                                    "passingValue": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                {
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "aggregatedStartDateViewField",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": v86 /*: any*/ 
                                                                                                                                                                },
                                                                                                                                                                {
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "aggregatedEndDateViewField",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": v86 /*: any*/ 
                                                                                                                                                                }
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraAggregatedTimelineField"
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraTimelineVirtualField",
                                                                                                                                            "abstractKey": "__isJiraTimelineVirtualField"
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "JiraAggregatedTimelineField"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v81 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldSets(first:500)"
                                                                        },
                                                                        v81 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "PageInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "pageInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v53 /*: any*/ ,
                                                                        v54 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "totalIssueSearchResultCount"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isCappingIssueSearchResult"
                                                                },
                                                                v81 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v56 /*: any*/ ,
                                                            "filters": [
                                                                "viewConfigInput",
                                                                "fieldSetsInput",
                                                                "scope",
                                                                "settings"
                                                            ],
                                                            "handle": "connection",
                                                            "key": "firstGroupSection_nativeIssueTable__issues",
                                                            "kind": "LinkedHandle",
                                                            "name": "issues"
                                                        },
                                                        v23 /*: any*/ ,
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        v51 /*: any*/ ,
                                                        v52 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v81 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v21 /*: any*/ ,
                                    "filters": [
                                        "scope"
                                    ],
                                    "handle": "connection",
                                    "key": "IssueNavigatorJiraGroupedListViewPagination__groups",
                                    "kind": "LinkedHandle",
                                    "name": "groups",
                                    "dynamicKey": {
                                        "kind": "Variable",
                                        "name": "__dynamicKey",
                                        "variableName": "dynamicSearchKey"
                                    }
                                }
                            ],
                            "type": "JiraGroupedListView"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "54c0e76532ac95b919f7ab088428a532fc3d167f1cab5b8679a6c7479119261f",
            "metadata": {},
            "name": "IssueNavigatorJiraGroupedListViewPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": (0, $evjHZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": (0, $j2Uha.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider": (0, $4GS9O.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider": (0, $8jq8m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $ad5K7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": (0, $04qit.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": (0, $6AioA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": (0, $1fipb.default)
            }
        }
    };
}();
$e5e601b42b329449$var$node.hash = "a3087f737b3cfd1d99f06c65f0e1b784";
var $e5e601b42b329449$export$2e2bcd8739ae039 = $e5e601b42b329449$var$node;

});


parcelRegister("iOldl", function(module, exports) {
$parcel$export(module.exports, "default", () => $375164e6630009d5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<07357993a6109af7685de82228c0f0f8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $8frX1 = parcelRequire("8frX1");
const $375164e6630009d5$var$node = function() {
    var v0 = [
        "groups"
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsScope"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "groupBy"
            },
            {
                "kind": "RootArgument",
                "name": "isPaginating"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "saveJQLToUserHistory"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "settings"
            },
            {
                "kind": "RootArgument",
                "name": "viewConfigInput"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "bidirectional",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": {
                        "count": "last",
                        "cursor": "before"
                    },
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $8frX1.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "main_issueNavigator_IssueNavigator_groupedListViewData",
        "selections": [
            {
                "alias": "groups",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "issueSearchInput",
                        "variableName": "issueSearchInput"
                    }
                ],
                "concreteType": "JiraSpreadsheetGroupConnection",
                "kind": "LinkedField",
                "name": "__IssueNavigatorGroupedListViewPagination__groups_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSpreadsheetGroupEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            },
                            {
                                "concreteType": "JiraSpreadsheetGroup",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "startCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasPreviousPage"
                            }
                        ]
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "projectKey",
                                "variableName": "projectKey"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKeys",
                                "variableName": "projectKeys"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_IssueNavigatorUI_groupResults"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "JiraGroupedListView"
    };
}();
$375164e6630009d5$var$node.hash = "7ad0fe727d1d7bbb1a71e7c82422f2c4";
var $375164e6630009d5$export$2e2bcd8739ae039 = $375164e6630009d5$var$node;

});
parcelRegister("8frX1", function(module, exports) {
$parcel$export(module.exports, "default", () => $148399bd3c007356$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<685b5b04bf6b86c7c2bb4ff9b3099a09>>
 * @relayHash 7eaa7baabf43f17a109e3e6b50730557
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 64fbef4aba7f5fc9b39bf2d81d0e4ba27505e1d14df7a94ea0d68e03c3f972a0

var $3Bt2F = parcelRequire("3Bt2F");

var $8jq8m = parcelRequire("8jq8m");

var $3jVIX = parcelRequire("3jVIX");

var $4GS9O = parcelRequire("4GS9O");

var $ad5K7 = parcelRequire("ad5K7");

var $hHOEN = parcelRequire("hHOEN");

var $hRj2m = parcelRequire("hRj2m");

var $6AioA = parcelRequire("6AioA");

var $04qit = parcelRequire("04qit");

var $jvWSl = parcelRequire("jvWSl");

var $j2Uha = parcelRequire("j2Uha");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $gDQIG = parcelRequire("gDQIG");

var $1fipb = parcelRequire("1fipb");

var $iOvkB = parcelRequire("iOvkB");

var $evjHZ = parcelRequire("evjHZ");

var $FU9UR = parcelRequire("FU9UR");
const $148399bd3c007356$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsScope"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "groupBy"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isPaginating"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "saveJQLToUserHistory"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "settings"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v16 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v17 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v18 = {
        "kind": "ScalarField",
        "name": "id"
    }, v19 = {
        "kind": "Variable",
        "name": "settings",
        "variableName": "settings"
    }, v20 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "groupBy",
            "variableName": "groupBy"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "saveJQLToUserHistory",
            "variableName": "saveJQLToUserHistory"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        v19 /*: any*/ 
    ], v21 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v22 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v23 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v24 = {
        "kind": "ScalarField",
        "name": "fieldType"
    }, v25 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v26 = {
        "kind": "ScalarField",
        "name": "name"
    }, v27 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v28 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v29 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v30 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v31 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v32 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v18 /*: any*/ ,
            v31 /*: any*/ 
        ]
    }, v33 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v34 = {
        "kind": "ScalarField",
        "name": "number"
    }, v35 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v36 = {
        "kind": "ScalarField",
        "name": "value"
    }, v37 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v18 /*: any*/ 
        ]
    }, v38 = [
        v18 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "sprintId"
        },
        v26 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "state"
        },
        {
            "kind": "ScalarField",
            "name": "endDate"
        }
    ], v39 = [
        v26 /*: any*/ ,
        v37 /*: any*/ 
    ], v40 = {
        "kind": "ScalarField",
        "name": "groupId"
    }, v41 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v42 = {
        "kind": "ScalarField",
        "name": "status"
    }, v43 = {
        "kind": "ScalarField",
        "name": "key"
    }, v44 = {
        "kind": "ScalarField",
        "name": "privateProject"
    }, v45 = {
        "kind": "ScalarField",
        "name": "hasPermission"
    }, v46 = {
        "kind": "ScalarField",
        "name": "iconName"
    }, v47 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v48 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v49 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v50 = {
        "kind": "LinkedField",
        "name": "fieldValue",
        "plural": false,
        "selections": [
            v17 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "jqlTerm"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraPriority",
                        "kind": "LinkedField",
                        "name": "priority",
                        "plural": false,
                        "selections": [
                            v18 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "priorityId"
                            },
                            v26 /*: any*/ ,
                            v27 /*: any*/ 
                        ]
                    },
                    v28 /*: any*/ 
                ],
                "type": "JiraJqlPriorityFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v17 /*: any*/ ,
                            v18 /*: any*/ ,
                            v29 /*: any*/ ,
                            v26 /*: any*/ ,
                            v30 /*: any*/ 
                        ]
                    },
                    v28 /*: any*/ 
                ],
                "type": "JiraJqlUserFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": [
                            v18 /*: any*/ ,
                            v26 /*: any*/ ,
                            v32 /*: any*/ 
                        ]
                    },
                    v28 /*: any*/ ,
                    v33 /*: any*/ 
                ],
                "type": "JiraJqlStatusFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v34 /*: any*/ 
                ],
                "type": "JiraJqlNumberFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "option",
                        "plural": false,
                        "selections": [
                            v18 /*: any*/ ,
                            v35 /*: any*/ ,
                            v36 /*: any*/ ,
                            v37 /*: any*/ 
                        ]
                    },
                    v28 /*: any*/ 
                ],
                "type": "JiraJqlOptionFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraSprint",
                        "kind": "LinkedField",
                        "name": "sprint",
                        "plural": false,
                        "selections": v38 /*: any*/ 
                    },
                    v28 /*: any*/ 
                ],
                "type": "JiraJqlSprintFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraLabel",
                        "kind": "LinkedField",
                        "name": "label",
                        "plural": false,
                        "selections": v39 /*: any*/ 
                    }
                ],
                "type": "JiraJqlLabelFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraGroup",
                        "kind": "LinkedField",
                        "name": "group",
                        "plural": false,
                        "selections": [
                            v18 /*: any*/ ,
                            v40 /*: any*/ ,
                            v26 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraJqlGroupFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraVersion",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            v18 /*: any*/ ,
                            v41 /*: any*/ ,
                            v26 /*: any*/ 
                        ]
                    },
                    v28 /*: any*/ 
                ],
                "type": "JiraJqlVersionFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v28 /*: any*/ ,
                    {
                        "concreteType": "JiraGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                            v42 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "score"
                            },
                            v18 /*: any*/ ,
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    v43 /*: any*/ ,
                                    v26 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraJqlGoalsFieldValue"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraTownsquareProject",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": [
                                    v18 /*: any*/ ,
                                    v43 /*: any*/ ,
                                    v44 /*: any*/ ,
                                    v45 /*: any*/ ,
                                    v26 /*: any*/ ,
                                    v46 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlTownsquareProjectFieldValue"
                    }
                ]
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "issueTypes",
                        "plural": true,
                        "selections": [
                            v26 /*: any*/ ,
                            v47 /*: any*/ ,
                            v18 /*: any*/ ,
                            v48 /*: any*/ ,
                            v49 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraJqlIssueTypeFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v28 /*: any*/ ,
                    {
                        "concreteType": "JiraResolution",
                        "kind": "LinkedField",
                        "name": "resolution",
                        "plural": false,
                        "selections": [
                            v18 /*: any*/ ,
                            v26 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraJqlResolutionFieldValue"
            }
        ]
    }, v51 = {
        "kind": "ScalarField",
        "name": "issueCount"
    }, v52 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v53 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v54 = {
        "kind": "ScalarField",
        "name": "message"
    }, v55 = [
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "fieldSetsScope"
        },
        v19 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "viewConfigInput",
            "variableName": "viewConfigInput"
        }
    ], v56 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v57 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v58 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v33 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v59 = {
        "concreteType": "JiraStatusField",
        "kind": "LinkedField",
        "name": "statusField",
        "plural": false,
        "selections": [
            v58 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v60 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v61 = {
        "kind": "ScalarField",
        "name": "type"
    }, v62 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v63 = [
        v36 /*: any*/ ,
        v18 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v64 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v65 = {
        "kind": "ClientExtension",
        "selections": [
            v64 /*: any*/ 
        ]
    }, v66 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v67 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v68 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v69 = {
        "kind": "ScalarField",
        "name": "date"
    }, v70 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v71 = {
        "kind": "ScalarField",
        "name": "text"
    }, v72 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v73 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v74 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v75 = [
        {
            "kind": "ScalarField",
            "name": "appType"
        }
    ], v76 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeInSeconds"
            }
        ]
    }, v77 = {
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "timeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v78 = [
        v18 /*: any*/ 
    ], v79 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": v78 /*: any*/ 
    }, v80 = {
        "kind": "ClientExtension",
        "selections": [
            v60 /*: any*/ 
        ]
    }, v81 = {
        "kind": "ScalarField",
        "name": "href"
    }, v82 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v83 = {
        "kind": "InlineFragment",
        "selections": [
            v69 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v84 = [
        v17 /*: any*/ ,
        v23 /*: any*/ ,
        v83 /*: any*/ ,
        v18 /*: any*/ 
    ], v85 = [
        v17 /*: any*/ ,
        v83 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": v78 /*: any*/ ,
            "type": "Node",
            "abstractKey": "__isNode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueNavigatorGroupedListViewPaginationQuery",
            "selections": [
                {
                    "args": v16 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "projectKey",
                                    "variableName": "projectKey"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "projectKeys",
                                    "variableName": "projectKeys"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_IssueNavigator_groupedListViewData"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueNavigatorGroupedListViewPaginationQuery",
            "selections": [
                {
                    "args": v16 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v17 /*: any*/ ,
                        v18 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v20 /*: any*/ ,
                                    "concreteType": "JiraSpreadsheetGroupConnection",
                                    "kind": "LinkedField",
                                    "name": "groups",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSpreadsheetGroupEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v21 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraSpreadsheetGroup",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v50 /*: any*/ ,
                                                        v51 /*: any*/ 
                                                    ]
                                                },
                                                v17 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                v52 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startCursor"
                                                },
                                                v53 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasPreviousPage"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "groupByField"
                                        },
                                        v22 /*: any*/ ,
                                        {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "statusCode"
                                                        }
                                                    ]
                                                },
                                                v54 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "isPaginating",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSpreadsheetGroup",
                                                    "kind": "LinkedField",
                                                    "name": "firstGroup",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        {
                                                            "args": v55 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssue",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v17 /*: any*/ ,
                                                                                v18 /*: any*/ ,
                                                                                v56 /*: any*/ ,
                                                                                v43 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issueTypeField",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v49 /*: any*/ ,
                                                                                                v18 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v18 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v57 /*: any*/ ,
                                                                                v59 /*: any*/ ,
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueTypeField",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ClientExtension",
                                                                                    "selections": [
                                                                                        v60 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "isHighlightedIssueRow"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "first",
                                                                                    "value": 500
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSets",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldSet",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v61 /*: any*/ ,
                                                                                                v25 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fields",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v62 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v17 /*: any*/ ,
                                                                                                                        v23 /*: any*/ ,
                                                                                                                        v61 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "TypeDiscriminator",
                                                                                                                            "abstractKey": "__isJiraIssueField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedAffectedServicesConnection",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraAffectedService",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                            "name": "serviceId"
                                                                                                                                                        },
                                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                                        v18 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraAffectedServicesField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCascadingOption",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "cascadingOption",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraOption",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "parentOptionValue",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": v63 /*: any*/ 
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraOption",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "childOptionValue",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": v63 /*: any*/ 
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v65 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraCascadingSelectField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedCmdbObjectsConnection",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraCmdbObject",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                            "name": "objectId"
                                                                                                                                                        },
                                                                                                                                                        {
                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                            "name": "label"
                                                                                                                                                        },
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraCmdbAvatar",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "avatar",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                {
                                                                                                                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "mediaClientConfig",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                                            "name": "clientId"
                                                                                                                                                                        },
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                                            "name": "fileId"
                                                                                                                                                                        },
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                                            "name": "mediaBaseUrl"
                                                                                                                                                                        },
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                                            "name": "mediaJwtToken"
                                                                                                                                                                        }
                                                                                                                                                                    ]
                                                                                                                                                                },
                                                                                                                                                                {
                                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                                    "name": "url48"
                                                                                                                                                                }
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "concreteType": "QueryError",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "errors",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                v54 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraCMDBField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": v66 /*: any*/ ,
                                                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedComponentsConnection",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v67 /*: any*/ ,
                                                                                                                                                        v68 /*: any*/ ,
                                                                                                                                                        v18 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                                                },
                                                                                                                                v65 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraComponentsField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v69 /*: any*/ ,
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                v70 /*: any*/ ,
                                                                                                                                v65 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraDatePickerField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "dateTime"
                                                                                                                                },
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                v65 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraDateTimePickerField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraEpic",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "epic",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v43 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "summary"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "color"
                                                                                                                                        },
                                                                                                                                        v18 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraEpicLinkField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "renderedFieldHtml"
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraFallbackField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v71 /*: any*/ ,
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                v65 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "statusCategory",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        v31 /*: any*/ ,
                                                                                                                                        v18 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraStatus",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "status",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "statusId"
                                                                                                                                        },
                                                                                                                                        v33 /*: any*/ ,
                                                                                                                                        v18 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraStatusField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "args": v66 /*: any*/ ,
                                                                                                                                    "concreteType": "JiraLabelConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedLabelsConnection",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v62 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraLabelEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraLabel",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": v39 /*: any*/ 
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                                                },
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                v65 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraLabelsField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issueType",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v47 /*: any*/ ,
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        v18 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "parentIssue",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v43 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraColorField",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "issueColorField",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v37 /*: any*/ ,
                                                                                                                                                v18 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "issueTypeField",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "issueType",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v72 /*: any*/ ,
                                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                                        v18 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                },
                                                                                                                                                v18 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraSingleLineTextField",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "summaryField",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v71 /*: any*/ ,
                                                                                                                                                v18 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                        v56 /*: any*/ ,
                                                                                                                                        v73 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                                                            "kind": "Condition",
                                                                                                                                            "passingValue": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "args": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "Literal",
                                                                                                                                                            "name": "ids",
                                                                                                                                                            "value": [
                                                                                                                                                                "issuetype",
                                                                                                                                                                "project",
                                                                                                                                                                "summary",
                                                                                                                                                                "status"
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ],
                                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "fieldsById",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "edges",
                                                                                                                                                            "plural": true,
                                                                                                                                                            "selections": [
                                                                                                                                                                {
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "node",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v17 /*: any*/ ,
                                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                                            "selections": [
                                                                                                                                                                                v23 /*: any*/ ,
                                                                                                                                                                                v71 /*: any*/ 
                                                                                                                                                                            ],
                                                                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                                                                        },
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                                            "selections": [
                                                                                                                                                                                v23 /*: any*/ ,
                                                                                                                                                                                {
                                                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                                    "name": "issueType",
                                                                                                                                                                                    "plural": false,
                                                                                                                                                                                    "selections": [
                                                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                                                        v48 /*: any*/ ,
                                                                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                                                                        v72 /*: any*/ ,
                                                                                                                                                                                        v49 /*: any*/ 
                                                                                                                                                                                    ]
                                                                                                                                                                                }
                                                                                                                                                                            ],
                                                                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                                                                        },
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                                            "selections": [
                                                                                                                                                                                v23 /*: any*/ ,
                                                                                                                                                                                {
                                                                                                                                                                                    "concreteType": "JiraStatus",
                                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                                    "name": "status",
                                                                                                                                                                                    "plural": false,
                                                                                                                                                                                    "selections": [
                                                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                                                        v32 /*: any*/ 
                                                                                                                                                                                    ]
                                                                                                                                                                                }
                                                                                                                                                                            ],
                                                                                                                                                                            "type": "JiraStatusField"
                                                                                                                                                                        }
                                                                                                                                                                    ]
                                                                                                                                                                }
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ],
                                                                                                                                                    "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                                                            "kind": "Condition",
                                                                                                                                            "passingValue": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "issueTypeField",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v23 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "issueType",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v48 /*: any*/ ,
                                                                                                                                                                v49 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "summaryField",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v23 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraStatusField",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "statusField",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                        v23 /*: any*/ ,
                                                                                                                                                        v58 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                v65 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraParentIssueField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraPriority",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "priority",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        v27 /*: any*/ ,
                                                                                                                                        v18 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                v65 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraPriorityField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraProject",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "project",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        v43 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraAvatar",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "avatar",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "large"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v18 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraProjectField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraResolution",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "resolution",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        v18 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraResolutionField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraSprintConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedSprintsConnection",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraSprintEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraSprint",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": v38 /*: any*/ 
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                v65 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraSprintField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "user",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v17 /*: any*/ ,
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        v30 /*: any*/ ,
                                                                                                                                        v74 /*: any*/ ,
                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                        v29 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
                                                                                                                                            "kind": "Condition",
                                                                                                                                            "passingValue": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "TypeDiscriminator",
                                                                                                                                                    "abstractKey": "__isUser"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": v75 /*: any*/ ,
                                                                                                                                                    "type": "AppUser"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider",
                                                                                                                                                    "kind": "Condition",
                                                                                                                                                    "passingValue": true,
                                                                                                                                                    "selections": v75 /*: any*/ 
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "AppUser"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v70 /*: any*/ ,
                                                                                                                                v65 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraRichText",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "richText",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraADF",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "adfValue",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "convertedPlainText",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                            "name": "plainText"
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraRichTextField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraServiceManagementRequestType",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "requestType",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        v72 /*: any*/ ,
                                                                                                                                        v18 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraServiceManagementRequestTypeField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "args": [
                                                                                                                                        {
                                                                                                                                            "kind": "Literal",
                                                                                                                                            "name": "first",
                                                                                                                                            "value": 1
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "concreteType": "JiraIssueLinkConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issueLinkConnection",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v62 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueLinkEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "issue",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v73 /*: any*/ ,
                                                                                                                                                                v43 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "args": [
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "Literal",
                                                                                                                                                                            "name": "ids",
                                                                                                                                                                            "value": [
                                                                                                                                                                                "statusCategory"
                                                                                                                                                                            ]
                                                                                                                                                                        }
                                                                                                                                                                    ],
                                                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "fieldsById",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        {
                                                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                                            "name": "edges",
                                                                                                                                                                            "plural": true,
                                                                                                                                                                            "selections": [
                                                                                                                                                                                {
                                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                                    "name": "node",
                                                                                                                                                                                    "plural": false,
                                                                                                                                                                                    "selections": [
                                                                                                                                                                                        v17 /*: any*/ ,
                                                                                                                                                                                        {
                                                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                                                            "selections": [
                                                                                                                                                                                                v33 /*: any*/ 
                                                                                                                                                                                            ],
                                                                                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                                                                                        },
                                                                                                                                                                                        v18 /*: any*/ 
                                                                                                                                                                                    ]
                                                                                                                                                                                }
                                                                                                                                                                            ]
                                                                                                                                                                        }
                                                                                                                                                                    ],
                                                                                                                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                                                },
                                                                                                                                                                {
                                                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                                                                                                                    "kind": "Condition",
                                                                                                                                                                    "passingValue": true,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v57 /*: any*/ 
                                                                                                                                                                    ]
                                                                                                                                                                },
                                                                                                                                                                v18 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        },
                                                                                                                                                        {
                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                            "name": "relationName"
                                                                                                                                                        },
                                                                                                                                                        v18 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "issueLinkConnection(first:1)"
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraIssueLinkField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "isStoryPointField"
                                                                                                                                },
                                                                                                                                v34 /*: any*/ ,
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraNumberFieldFormatConfig",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "formatConfig",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "formatStyle"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "formatUnit"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v65 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraNumberField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCommentSummary",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "commentSummary",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "canAddComment"
                                                                                                                                        },
                                                                                                                                        v62 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraCommentSummaryField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "uri"
                                                                                                                                },
                                                                                                                                v65 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraUrlField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraOption",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "fieldOption",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v36 /*: any*/ ,
                                                                                                                                        v37 /*: any*/ ,
                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                        v35 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v65 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraSingleSelectField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedOptions",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraOption",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                        v36 /*: any*/ ,
                                                                                                                                                        v35 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v65 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraMultipleSelectField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedOptions",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraOption",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                        v36 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v65 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraCheckboxesField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraUserConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedUsersConnection",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraUserEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v17 /*: any*/ ,
                                                                                                                                                        v29 /*: any*/ ,
                                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                                        v30 /*: any*/ ,
                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                        v74 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                {
                                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                                    "name": "email"
                                                                                                                                                                }
                                                                                                                                                            ],
                                                                                                                                                            "type": "AtlassianAccountUser"
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v65 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraTeamView",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedTeam",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "jiraSuppliedId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "jiraSuppliedName"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v65 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraTeamViewField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "issue",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "timeTrackingField",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                        v76 /*: any*/ ,
                                                                                                                                                        v77 /*: any*/ ,
                                                                                                                                                        v23 /*: any*/ ,
                                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                                        v61 /*: any*/ ,
                                                                                                                                                        v65 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                },
                                                                                                                                                v18 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "issue",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "timeTrackingField",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v76 /*: any*/ ,
                                                                                                                                                        v77 /*: any*/ ,
                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                        v23 /*: any*/ ,
                                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                                        v61 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                },
                                                                                                                                                v18 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v65 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraOption",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedOption",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "alias": "label",
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "value"
                                                                                                                                        },
                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                        v67 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v65 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraRadioSelectField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": v66 /*: any*/ ,
                                                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedVersionsConnection",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                                        v67 /*: any*/ ,
                                                                                                                                                        v68 /*: any*/ ,
                                                                                                                                                        v41 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                                                },
                                                                                                                                v65 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                v79 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": v66 /*: any*/ ,
                                                                                                                                    "concreteType": "JiraGoalConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedGoals",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraGoalEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraGoal",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                        v43 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                                                                                                            "kind": "Condition",
                                                                                                                                                            "passingValue": true,
                                                                                                                                                            "selections": [
                                                                                                                                                                v26 /*: any*/ ,
                                                                                                                                                                v42 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v80 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ClientExtension",
                                                                                                                                    "selections": [
                                                                                                                                        v60 /*: any*/ ,
                                                                                                                                        v64 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraGoalsField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        v79 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "isLinkEditable"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraTownsquareProject",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "project",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v18 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "alias": "atlasProjectName",
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "name"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "alias": "atlasProjectKey",
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "key"
                                                                                                                                                },
                                                                                                                                                v44 /*: any*/ ,
                                                                                                                                                v45 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "isWorkspaceActive"
                                                                                                                                                },
                                                                                                                                                v46 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v65 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "type": "JiraTownsquareProjectField"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": v66 /*: any*/ ,
                                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "confluenceRemoteIssueLinks",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                        v81 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                                                                            "kind": "Condition",
                                                                                                                                                            "passingValue": true,
                                                                                                                                                            "selections": [
                                                                                                                                                                {
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "pageContent",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v17 /*: any*/ ,
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                                            "selections": [
                                                                                                                                                                                v81 /*: any*/ 
                                                                                                                                                                            ],
                                                                                                                                                                            "type": "JiraConfluencePageContentDetails"
                                                                                                                                                                        }
                                                                                                                                                                    ]
                                                                                                                                                                }
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v62 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                                                },
                                                                                                                                v65 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraGroupConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedGroupsConnection",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraGroupEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraGroup",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                                        v40 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v65 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraMultipleGroupPickerField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraFlag",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "flag",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "isFlagged"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraFlagField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraWatch",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "watch",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "count"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "isWatching"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraWatchesField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "issue",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                        v56 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "issueTypeField",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                {
                                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "issueType",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                                                        v49 /*: any*/ ,
                                                                                                                                                                        v18 /*: any*/ 
                                                                                                                                                                    ]
                                                                                                                                                                },
                                                                                                                                                                v18 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        },
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraParentIssueField",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "parentIssueField",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                {
                                                                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "parentIssue",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v56 /*: any*/ ,
                                                                                                                                                                        v43 /*: any*/ ,
                                                                                                                                                                        v18 /*: any*/ 
                                                                                                                                                                    ]
                                                                                                                                                                },
                                                                                                                                                                v18 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        },
                                                                                                                                                        v43 /*: any*/ ,
                                                                                                                                                        v59 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraSingleSelectUserPickerField",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "assigneeField",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                {
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "user",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v17 /*: any*/ ,
                                                                                                                                                                        v30 /*: any*/ ,
                                                                                                                                                                        v18 /*: any*/ 
                                                                                                                                                                    ]
                                                                                                                                                                },
                                                                                                                                                                v18 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        },
                                                                                                                                                        {
                                                                                                                                                            "args": v82 /*: any*/ ,
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "startDateViewField",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": v84 /*: any*/ ,
                                                                                                                                                            "storageKey": "startDateViewField(viewId:\"list_default\")"
                                                                                                                                                        },
                                                                                                                                                        {
                                                                                                                                                            "args": v82 /*: any*/ ,
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "endDateViewField",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": v84 /*: any*/ ,
                                                                                                                                                            "storageKey": "endDateViewField(viewId:\"list_default\")"
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                                                                                                                                    "kind": "Condition",
                                                                                                                                                    "passingValue": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                {
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "aggregatedStartDateViewField",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": v85 /*: any*/ 
                                                                                                                                                                },
                                                                                                                                                                {
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "aggregatedEndDateViewField",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": v85 /*: any*/ 
                                                                                                                                                                }
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraAggregatedTimelineField"
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraTimelineVirtualField",
                                                                                                                                            "abstractKey": "__isJiraTimelineVirtualField"
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "JiraAggregatedTimelineField"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v80 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldSets(first:500)"
                                                                        },
                                                                        v80 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "PageInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "pageInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v52 /*: any*/ ,
                                                                        v53 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "totalIssueSearchResultCount"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isCappingIssueSearchResult"
                                                                },
                                                                v80 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v55 /*: any*/ ,
                                                            "filters": [
                                                                "viewConfigInput",
                                                                "fieldSetsInput",
                                                                "scope",
                                                                "settings"
                                                            ],
                                                            "handle": "connection",
                                                            "key": "firstGroupSection_nativeIssueTable__issues",
                                                            "kind": "LinkedHandle",
                                                            "name": "issues"
                                                        },
                                                        v22 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v50 /*: any*/ ,
                                                        v51 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v80 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v20 /*: any*/ ,
                                    "filters": [
                                        "issueSearchInput"
                                    ],
                                    "handle": "connection",
                                    "key": "IssueNavigatorGroupedListViewPagination__groups",
                                    "kind": "LinkedHandle",
                                    "name": "groups"
                                }
                            ],
                            "type": "JiraGroupedListView"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "64fbef4aba7f5fc9b39bf2d81d0e4ba27505e1d14df7a94ea0d68e03c3f972a0",
            "metadata": {},
            "name": "IssueNavigatorGroupedListViewPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": (0, $evjHZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": (0, $j2Uha.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider": (0, $4GS9O.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider": (0, $8jq8m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $ad5K7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": (0, $04qit.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": (0, $6AioA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": (0, $1fipb.default)
            }
        }
    };
}();
$148399bd3c007356$var$node.hash = "7ad0fe727d1d7bbb1a71e7c82422f2c4";
var $148399bd3c007356$export$2e2bcd8739ae039 = $148399bd3c007356$var$node;

});


parcelRegister("8RGOH", function(module, exports) {
$parcel$export(module.exports, "default", () => $9cd3c424bff2086e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<98c4d9a45e9d35d7409a2ce844800c47>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $c6wEU = parcelRequire("c6wEU");
const $9cd3c424bff2086e$var$node = function() {
    var v0 = [
        "issues"
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "dynamicSearchKey"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "options"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "saveJQLToUserHistory"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "settings"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "bidirectional",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": {
                        "count": "last",
                        "cursor": "before"
                    },
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $c6wEU.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "main_issueNavigator_IssueNavigator_jiraDetailedViewData",
        "selections": [
            {
                "alias": "issues",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "__dynamicKey",
                        "variableName": "dynamicSearchKey"
                    },
                    {
                        "kind": "Variable",
                        "name": "scope",
                        "variableName": "scope"
                    }
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "__IssueNavigatorJiraDetailedViewPagination__issues_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            },
                            {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "startCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasPreviousPage"
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "selectedIssue_issueNavigator"
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "isConditionalFormattingEnabled",
                                "variableName": "isConditionalFormattingEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKey",
                                "variableName": "projectKey"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKeys",
                                "variableName": "projectKeys"
                            },
                            {
                                "kind": "Literal",
                                "name": "shouldQueryHasChildren",
                                "value": false
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_IssueNavigatorUI_issueResults"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "JiraDetailedView"
    };
}();
$9cd3c424bff2086e$var$node.hash = "27958eb44f28306eb84d2d7dca4b6970";
var $9cd3c424bff2086e$export$2e2bcd8739ae039 = $9cd3c424bff2086e$var$node;

});
parcelRegister("c6wEU", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7e3e61f59b98b78$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bc27f5048305cb1c5bf7ffee0e372368>>
 * @relayHash 6c005db37c94b75f5a659af33e109ffb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 862c92ef7fb9eeac5cb31a0bf3a983f9bde67a5e1dcaeb68a2208370b45811f0

var $3Bt2F = parcelRequire("3Bt2F");

var $cqxuo = parcelRequire("cqxuo");

var $dexoz = parcelRequire("dexoz");

var $3jVIX = parcelRequire("3jVIX");

var $l6otE = parcelRequire("l6otE");

var $ad5K7 = parcelRequire("ad5K7");

var $hHOEN = parcelRequire("hHOEN");

var $hRj2m = parcelRequire("hRj2m");

var $cIDJo = parcelRequire("cIDJo");

var $6AioA = parcelRequire("6AioA");

var $04qit = parcelRequire("04qit");

var $jvWSl = parcelRequire("jvWSl");

var $j2Uha = parcelRequire("j2Uha");

var $kmr3r = parcelRequire("kmr3r");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $gDQIG = parcelRequire("gDQIG");

var $1fipb = parcelRequire("1fipb");

var $iOvkB = parcelRequire("iOvkB");

var $evjHZ = parcelRequire("evjHZ");

var $FU9UR = parcelRequire("FU9UR");
const $b7e3e61f59b98b78$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "dynamicSearchKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "saveJQLToUserHistory"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "settings"
    }, v15 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "options",
            "variableName": "options"
        },
        {
            "kind": "Variable",
            "name": "saveJQLToUserHistory",
            "variableName": "saveJQLToUserHistory"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        {
            "kind": "Variable",
            "name": "settings",
            "variableName": "settings"
        }
    ], v19 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v20 = {
        "kind": "ScalarField",
        "name": "key"
    }, v21 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v22 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v24 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v25 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v24 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v26 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v27 = {
        "concreteType": "JiraStatusField",
        "kind": "LinkedField",
        "name": "statusField",
        "plural": false,
        "selections": [
            v26 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v28 = {
        "kind": "ScalarField",
        "name": "name"
    }, v29 = [
        v28 /*: any*/ 
    ], v30 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v31 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v32 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v33 = {
        "kind": "ScalarField",
        "name": "type"
    }, v34 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v35 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v36 = {
        "kind": "ScalarField",
        "name": "value"
    }, v37 = [
        v36 /*: any*/ ,
        v17 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v38 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v39 = {
        "kind": "ClientExtension",
        "selections": [
            v38 /*: any*/ 
        ]
    }, v40 = {
        "kind": "ScalarField",
        "name": "message"
    }, v41 = [
        v40 /*: any*/ 
    ], v42 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v43 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v44 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v45 = {
        "kind": "ScalarField",
        "name": "date"
    }, v46 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v47 = {
        "kind": "ScalarField",
        "name": "text"
    }, v48 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v17 /*: any*/ 
        ]
    }, v49 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v50 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v51 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v52 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v53 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v54 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v55 = [
        {
            "kind": "ScalarField",
            "name": "appType"
        }
    ], v56 = [
        {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isUser"
        },
        {
            "kind": "InlineFragment",
            "selections": v55 /*: any*/ ,
            "type": "AppUser"
        }
    ], v57 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v58 = {
        "kind": "ClientExtension",
        "selections": [
            v30 /*: any*/ 
        ]
    }, v59 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeInSeconds"
            }
        ]
    }, v60 = {
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "timeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v61 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v62 = [
        v17 /*: any*/ 
    ], v63 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": v62 /*: any*/ 
    }, v64 = {
        "kind": "ScalarField",
        "name": "href"
    }, v65 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v66 = {
        "kind": "InlineFragment",
        "selections": [
            v45 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v67 = [
        v16 /*: any*/ ,
        v35 /*: any*/ ,
        v66 /*: any*/ ,
        v17 /*: any*/ 
    ], v68 = [
        v16 /*: any*/ ,
        v66 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": v62 /*: any*/ ,
            "type": "Node",
            "abstractKey": "__isNode"
        }
    ], v69 = [
        v16 /*: any*/ ,
        v17 /*: any*/ 
    ], v70 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v71 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v72 = [
        v70 /*: any*/ ,
        v19 /*: any*/ ,
        v71 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueNavigatorJiraDetailedViewPaginationQuery",
            "selections": [
                {
                    "args": v15 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "isConditionalFormattingEnabled",
                                    "variableName": "isConditionalFormattingEnabled"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "projectKey",
                                    "variableName": "projectKey"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "projectKeys",
                                    "variableName": "projectKeys"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_IssueNavigator_jiraDetailedViewData"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v5 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueNavigatorJiraDetailedViewPaginationQuery",
            "selections": [
                {
                    "args": v15 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v18 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v19 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v22 /*: any*/ ,
                                                                        v17 /*: any*/ 
                                                                    ]
                                                                },
                                                                v17 /*: any*/ 
                                                            ]
                                                        },
                                                        v23 /*: any*/ ,
                                                        v27 /*: any*/ ,
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueTypeField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": v29 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                v30 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isHighlightedIssueRow"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v31 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueTypeField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v32 /*: any*/ ,
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": v29 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v16 /*: any*/ ,
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "first",
                                                            "value": 500
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v33 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldSetId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v17 /*: any*/ ,
                                                                                                v16 /*: any*/ ,
                                                                                                v35 /*: any*/ ,
                                                                                                v33 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "TypeDiscriminator",
                                                                                                    "abstractKey": "__isJiraIssueField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedAffectedServicesConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAffectedService",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "serviceId"
                                                                                                                                },
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                v17 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraAffectedServicesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraCascadingOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "cascadingOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentOptionValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v37 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "childOptionValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v37 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v39 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraCascadingSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedCmdbObjectsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbObject",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "objectId"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "label"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbAvatar",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "avatar",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "mediaClientConfig",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "clientId"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "fileId"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "mediaBaseUrl"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "mediaJwtToken"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "url48"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "QueryError",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "errors",
                                                                                                                    "plural": true,
                                                                                                                    "selections": v41 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCMDBField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v42 /*: any*/ ,
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v43 /*: any*/ ,
                                                                                                                                v44 /*: any*/ ,
                                                                                                                                v17 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                        },
                                                                                                        v39 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v45 /*: any*/ ,
                                                                                                        v28 /*: any*/ ,
                                                                                                        v46 /*: any*/ ,
                                                                                                        v39 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDatePickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "dateTime"
                                                                                                        },
                                                                                                        v28 /*: any*/ ,
                                                                                                        v39 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDateTimePickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraEpic",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "epic",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v20 /*: any*/ ,
                                                                                                                v31 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "color"
                                                                                                                },
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraEpicLinkField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "renderedFieldHtml"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraFallbackField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v47 /*: any*/ ,
                                                                                                        v28 /*: any*/ ,
                                                                                                        v39 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "statusCategory",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v28 /*: any*/ ,
                                                                                                                v24 /*: any*/ ,
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatus",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "status",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v28 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "statusId"
                                                                                                                },
                                                                                                                v25 /*: any*/ ,
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v42 /*: any*/ ,
                                                                                                            "concreteType": "JiraLabelConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedLabelsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v34 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabelEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraLabel",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                v48 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                        },
                                                                                                        v28 /*: any*/ ,
                                                                                                        v39 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraLabelsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v32 /*: any*/ ,
                                                                                                                v28 /*: any*/ ,
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v20 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraColorField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueColorField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v48 /*: any*/ ,
                                                                                                                        v17 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueTypeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v49 /*: any*/ ,
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                v17 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v17 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "summaryField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        v17 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v17 /*: any*/ ,
                                                                                                                v21 /*: any*/ ,
                                                                                                                v50 /*: any*/ ,
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "args": [
                                                                                                                                {
                                                                                                                                    "kind": "Literal",
                                                                                                                                    "name": "ids",
                                                                                                                                    "value": [
                                                                                                                                        "issuetype",
                                                                                                                                        "project",
                                                                                                                                        "summary",
                                                                                                                                        "status"
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "fieldsById",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "edges",
                                                                                                                                    "plural": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "node",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v16 /*: any*/ ,
                                                                                                                                                v17 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v35 /*: any*/ ,
                                                                                                                                                        v47 /*: any*/ 
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v35 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "issueType",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v17 /*: any*/ ,
                                                                                                                                                                v51 /*: any*/ ,
                                                                                                                                                                v28 /*: any*/ ,
                                                                                                                                                                v49 /*: any*/ ,
                                                                                                                                                                v22 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v35 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraStatus",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "status",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v17 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "statusCategory",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v17 /*: any*/ ,
                                                                                                                                                                        v24 /*: any*/ 
                                                                                                                                                                    ]
                                                                                                                                                                }
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraStatusField"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueTypeField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v35 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issueType",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v51 /*: any*/ ,
                                                                                                                                        v22 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSingleLineTextField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "summaryField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v35 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraStatusField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "statusField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v17 /*: any*/ ,
                                                                                                                                v35 /*: any*/ ,
                                                                                                                                v26 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v28 /*: any*/ ,
                                                                                                        v39 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraParentIssueField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v28 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "iconUrl"
                                                                                                                },
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v28 /*: any*/ ,
                                                                                                        v39 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v28 /*: any*/ ,
                                                                                                                v20 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "large"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraResolution",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "resolution",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v28 /*: any*/ ,
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraResolutionField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedSprintsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprintEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSprint",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v17 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "sprintId"
                                                                                                                                },
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "state"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "endDate"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v28 /*: any*/ ,
                                                                                                        v39 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSprintField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "user",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v16 /*: any*/ ,
                                                                                                                v28 /*: any*/ ,
                                                                                                                v52 /*: any*/ ,
                                                                                                                v53 /*: any*/ ,
                                                                                                                v17 /*: any*/ ,
                                                                                                                v54 /*: any*/ ,
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": v56 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": v55 /*: any*/ 
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "AppUser"
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": v56 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v46 /*: any*/ ,
                                                                                                        v39 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraRichText",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "richText",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraADF",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "adfValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "convertedPlainText",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "plainText"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraRichTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraServiceManagementRequestType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "requestType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v28 /*: any*/ ,
                                                                                                                v49 /*: any*/ ,
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraServiceManagementRequestTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": [
                                                                                                                {
                                                                                                                    "kind": "Literal",
                                                                                                                    "name": "first",
                                                                                                                    "value": 1
                                                                                                                }
                                                                                                            ],
                                                                                                            "concreteType": "JiraIssueLinkConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueLinkConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v34 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issue",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v50 /*: any*/ ,
                                                                                                                                        v20 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "args": [
                                                                                                                                                {
                                                                                                                                                    "kind": "Literal",
                                                                                                                                                    "name": "ids",
                                                                                                                                                    "value": [
                                                                                                                                                        "statusCategory"
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "fieldsById",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "edges",
                                                                                                                                                    "plural": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "node",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v16 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v25 /*: any*/ 
                                                                                                                                                                    ],
                                                                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                                                                },
                                                                                                                                                                v17 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                                                                                            "kind": "Condition",
                                                                                                                                            "passingValue": true,
                                                                                                                                            "selections": [
                                                                                                                                                v23 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v17 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "relationName"
                                                                                                                                },
                                                                                                                                v17 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "issueLinkConnection(first:1)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueLinkField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isStoryPointField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "number"
                                                                                                        },
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraNumberFieldFormatConfig",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "formatConfig",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "formatStyle"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "formatUnit"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v39 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraNumberField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCommentSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "commentSummary",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "canAddComment"
                                                                                                                },
                                                                                                                v34 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCommentSummaryField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "uri"
                                                                                                        },
                                                                                                        v39 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraUrlField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v36 /*: any*/ ,
                                                                                                                v48 /*: any*/ ,
                                                                                                                v17 /*: any*/ ,
                                                                                                                v57 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v39 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v17 /*: any*/ ,
                                                                                                                                v36 /*: any*/ ,
                                                                                                                                v57 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v39 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v17 /*: any*/ ,
                                                                                                                                v36 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v58 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v39 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraUserConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedUsersConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraUserEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v16 /*: any*/ ,
                                                                                                                                v54 /*: any*/ ,
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                v52 /*: any*/ ,
                                                                                                                                v17 /*: any*/ ,
                                                                                                                                v53 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "email"
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "AtlassianAccountUser"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v39 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraTeamView",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedTeam",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "jiraSuppliedId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "jiraSuppliedName"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v39 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraTeamViewField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraTimeTrackingField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "timeTrackingField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v17 /*: any*/ ,
                                                                                                                                v59 /*: any*/ ,
                                                                                                                                v60 /*: any*/ ,
                                                                                                                                v35 /*: any*/ ,
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                v33 /*: any*/ ,
                                                                                                                                v39 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v17 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraOriginalTimeEstimateField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraTimeTrackingField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "timeTrackingField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v59 /*: any*/ ,
                                                                                                                                v60 /*: any*/ ,
                                                                                                                                v17 /*: any*/ ,
                                                                                                                                v35 /*: any*/ ,
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                v33 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v17 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v39 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraOriginalTimeEstimateField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": "label",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "value"
                                                                                                                },
                                                                                                                v17 /*: any*/ ,
                                                                                                                v43 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v39 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraRadioSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v42 /*: any*/ ,
                                                                                                            "concreteType": "JiraVersionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedVersionsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersion",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v17 /*: any*/ ,
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                v43 /*: any*/ ,
                                                                                                                                v44 /*: any*/ ,
                                                                                                                                v61 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                        },
                                                                                                        v39 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        v63 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v42 /*: any*/ ,
                                                                                                            "concreteType": "JiraGoalConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedGoals",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGoalEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGoal",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v17 /*: any*/ ,
                                                                                                                                v20 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        v28 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "status"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v58 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "selectedGoals(first:1000)"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ClientExtension",
                                                                                                            "selections": [
                                                                                                                v30 /*: any*/ ,
                                                                                                                v38 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraGoalsField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v28 /*: any*/ ,
                                                                                                                v63 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isLinkEditable"
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraTownsquareProject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "project",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v17 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "alias": "atlasProjectName",
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "name"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "alias": "atlasProjectKey",
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "key"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "privateProject"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "hasPermission"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "isWorkspaceActive"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "iconName"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v39 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraTownsquareProjectField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v42 /*: any*/ ,
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "confluenceRemoteIssueLinks",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v17 /*: any*/ ,
                                                                                                                                v64 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "pageContent",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v16 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v64 /*: any*/ 
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraConfluencePageContentDetails"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v34 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                        },
                                                                                                        v39 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedGroupsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroupEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGroup",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v17 /*: any*/ ,
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "groupId"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v39 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleGroupPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraFlag",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "flag",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isFlagged"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraFlagField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraWatch",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "watch",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "count"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isWatching"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraWatchesField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v17 /*: any*/ ,
                                                                                                                                v21 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issueTypeField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "issueType",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v28 /*: any*/ ,
                                                                                                                                                v22 /*: any*/ ,
                                                                                                                                                v17 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v17 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraParentIssueField",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "parentIssueField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "parentIssue",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v21 /*: any*/ ,
                                                                                                                                                v20 /*: any*/ ,
                                                                                                                                                v17 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v17 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v20 /*: any*/ ,
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraSingleSelectUserPickerField",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "assigneeField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "user",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v16 /*: any*/ ,
                                                                                                                                                v52 /*: any*/ ,
                                                                                                                                                v17 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v17 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "args": v65 /*: any*/ ,
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "startDateViewField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": v67 /*: any*/ ,
                                                                                                                                    "storageKey": "startDateViewField(viewId:\"list_default\")"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "args": v65 /*: any*/ ,
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "endDateViewField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": v67 /*: any*/ ,
                                                                                                                                    "storageKey": "endDateViewField(viewId:\"list_default\")"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "aggregatedStartDateViewField",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": v68 /*: any*/ 
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "aggregatedEndDateViewField",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": v68 /*: any*/ 
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "JiraAggregatedTimelineField"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraTimelineVirtualField",
                                                                                                                    "abstractKey": "__isJiraTimelineVirtualField"
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraAggregatedTimelineField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v58 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v58 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "isConditionalFormattingEnabled",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSet",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fields",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "args": v42 /*: any*/ ,
                                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedComponentsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "componentId"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraComponentsField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraPriority",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "priority",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "priorityId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraPriorityField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraProject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "project",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "projectId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraProjectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "version",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v61 /*: any*/ ,
                                                                                                                        v17 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraSingleVersionPickerField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v51 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraIssueTypeField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v69 /*: any*/ 
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraSingleSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSelectableValueConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedValues",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSelectableValueEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": v69 /*: any*/ 
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraMultipleSelectField"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                },
                                                v58 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasPreviousPage"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraIssueNavigatorPageInfo",
                                            "kind": "LinkedField",
                                            "name": "issueNavigatorPageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "firstIssuePosition"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "lastIssuePosition"
                                                }
                                            ]
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "maxCursors",
                                                    "value": 7
                                                }
                                            ],
                                            "concreteType": "JiraPageCursors",
                                            "kind": "LinkedField",
                                            "name": "pageCursors",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "around",
                                                    "plural": true,
                                                    "selections": v72 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "last",
                                                    "plural": false,
                                                    "selections": v72 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "first",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        v70 /*: any*/ ,
                                                        v71 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "pageCursors(maxCursors:7)"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalIssueSearchResultCount"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "issueSearchError",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "messages"
                                                        }
                                                    ],
                                                    "type": "JiraInvalidJqlError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v40 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "errorType"
                                                        }
                                                    ],
                                                    "type": "JiraInvalidSyntaxError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v41 /*: any*/ ,
                                                    "type": "JiraServerError"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isCappingIssueSearchResult"
                                        },
                                        v58 /*: any*/ ,
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v31 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v18 /*: any*/ ,
                                    "filters": [
                                        "scope"
                                    ],
                                    "handle": "connection",
                                    "key": "IssueNavigatorJiraDetailedViewPagination__issues",
                                    "kind": "LinkedHandle",
                                    "name": "issues",
                                    "dynamicKey": {
                                        "kind": "Variable",
                                        "name": "__dynamicKey",
                                        "variableName": "dynamicSearchKey"
                                    }
                                }
                            ],
                            "type": "JiraDetailedView"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "862c92ef7fb9eeac5cb31a0bf3a983f9bde67a5e1dcaeb68a2208370b45811f0",
            "metadata": {},
            "name": "IssueNavigatorJiraDetailedViewPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider": (0, $cqxuo.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $kmr3r.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider": (0, $dexoz.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": (0, $l6otE.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": (0, $evjHZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": (0, $j2Uha.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $ad5K7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": (0, $04qit.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": (0, $6AioA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": (0, $1fipb.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider": (0, $cIDJo.default)
            }
        }
    };
}();
$b7e3e61f59b98b78$var$node.hash = "27958eb44f28306eb84d2d7dca4b6970";
var $b7e3e61f59b98b78$export$2e2bcd8739ae039 = $b7e3e61f59b98b78$var$node;

});


parcelRegister("kVQr8", function(module, exports) {
$parcel$export(module.exports, "default", () => $17326b2b4c50caf5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fa9214c1542fa735b5b526d1e402e5ba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $ayXuK = parcelRequire("ayXuK");
const $17326b2b4c50caf5$var$node = function() {
    var v0 = [
        "issues"
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "options"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "saveJQLToUserHistory"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "settings"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "bidirectional",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": {
                        "count": "last",
                        "cursor": "before"
                    },
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $ayXuK.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "main_issueNavigator_IssueNavigator_detailedViewData",
        "selections": [
            {
                "alias": "issues",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "issueSearchInput",
                        "variableName": "issueSearchInput"
                    }
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "__IssueNavigatorDetailedViewPagination__issues_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            },
                            {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "startCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasPreviousPage"
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "selectedIssue_issueNavigator"
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "isConditionalFormattingEnabled",
                                "variableName": "isConditionalFormattingEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKey",
                                "variableName": "projectKey"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKeys",
                                "variableName": "projectKeys"
                            },
                            {
                                "kind": "Literal",
                                "name": "shouldQueryHasChildren",
                                "value": false
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_IssueNavigatorUI_issueResults"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "JiraDetailedView"
    };
}();
$17326b2b4c50caf5$var$node.hash = "a94b8cf7516b80e2a57d7d4c570bbfaf";
var $17326b2b4c50caf5$export$2e2bcd8739ae039 = $17326b2b4c50caf5$var$node;

});
parcelRegister("ayXuK", function(module, exports) {
$parcel$export(module.exports, "default", () => $467f9442fbdd0e43$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2982c32ccdd45a70ad0da727635405a8>>
 * @relayHash 6378357df022fa2834a8e5edbfb9e018
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 802c994dd3bcf74e3816ff9ecf63d7d48d4d8975064ad30a16a62ac9da62d043

var $3Bt2F = parcelRequire("3Bt2F");

var $cqxuo = parcelRequire("cqxuo");

var $dexoz = parcelRequire("dexoz");

var $3jVIX = parcelRequire("3jVIX");

var $l6otE = parcelRequire("l6otE");

var $ad5K7 = parcelRequire("ad5K7");

var $hHOEN = parcelRequire("hHOEN");

var $hRj2m = parcelRequire("hRj2m");

var $cIDJo = parcelRequire("cIDJo");

var $6AioA = parcelRequire("6AioA");

var $04qit = parcelRequire("04qit");

var $jvWSl = parcelRequire("jvWSl");

var $j2Uha = parcelRequire("j2Uha");

var $kmr3r = parcelRequire("kmr3r");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $gDQIG = parcelRequire("gDQIG");

var $1fipb = parcelRequire("1fipb");

var $iOvkB = parcelRequire("iOvkB");

var $evjHZ = parcelRequire("evjHZ");

var $FU9UR = parcelRequire("FU9UR");
const $467f9442fbdd0e43$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "saveJQLToUserHistory"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "settings"
    }, v14 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v15 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v16 = {
        "kind": "ScalarField",
        "name": "id"
    }, v17 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "options",
            "variableName": "options"
        },
        {
            "kind": "Variable",
            "name": "saveJQLToUserHistory",
            "variableName": "saveJQLToUserHistory"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        {
            "kind": "Variable",
            "name": "settings",
            "variableName": "settings"
        }
    ], v18 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v19 = {
        "kind": "ScalarField",
        "name": "key"
    }, v20 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v21 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v23 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v24 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v23 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v25 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v24 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v26 = {
        "concreteType": "JiraStatusField",
        "kind": "LinkedField",
        "name": "statusField",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "name"
    }, v28 = [
        v27 /*: any*/ 
    ], v29 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v30 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v31 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v32 = {
        "kind": "ScalarField",
        "name": "type"
    }, v33 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v34 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v35 = {
        "kind": "ScalarField",
        "name": "value"
    }, v36 = [
        v35 /*: any*/ ,
        v16 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v37 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v38 = {
        "kind": "ClientExtension",
        "selections": [
            v37 /*: any*/ 
        ]
    }, v39 = {
        "kind": "ScalarField",
        "name": "message"
    }, v40 = [
        v39 /*: any*/ 
    ], v41 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v42 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v43 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v44 = {
        "kind": "ScalarField",
        "name": "date"
    }, v45 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v46 = {
        "kind": "ScalarField",
        "name": "text"
    }, v47 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v16 /*: any*/ 
        ]
    }, v48 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v49 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v50 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v51 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v52 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v53 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v54 = [
        {
            "kind": "ScalarField",
            "name": "appType"
        }
    ], v55 = [
        {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isUser"
        },
        {
            "kind": "InlineFragment",
            "selections": v54 /*: any*/ ,
            "type": "AppUser"
        }
    ], v56 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v57 = {
        "kind": "ClientExtension",
        "selections": [
            v29 /*: any*/ 
        ]
    }, v58 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeInSeconds"
            }
        ]
    }, v59 = {
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "timeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v60 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v61 = [
        v16 /*: any*/ 
    ], v62 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": v61 /*: any*/ 
    }, v63 = {
        "kind": "ScalarField",
        "name": "href"
    }, v64 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v65 = {
        "kind": "InlineFragment",
        "selections": [
            v44 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v66 = [
        v15 /*: any*/ ,
        v34 /*: any*/ ,
        v65 /*: any*/ ,
        v16 /*: any*/ 
    ], v67 = [
        v15 /*: any*/ ,
        v65 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": v61 /*: any*/ ,
            "type": "Node",
            "abstractKey": "__isNode"
        }
    ], v68 = [
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ], v69 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v70 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v71 = [
        v69 /*: any*/ ,
        v18 /*: any*/ ,
        v70 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueNavigatorDetailedViewPaginationQuery",
            "selections": [
                {
                    "args": v14 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "isConditionalFormattingEnabled",
                                    "variableName": "isConditionalFormattingEnabled"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "projectKey",
                                    "variableName": "projectKey"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "projectKeys",
                                    "variableName": "projectKeys"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_IssueNavigator_detailedViewData"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueNavigatorDetailedViewPaginationQuery",
            "selections": [
                {
                    "args": v14 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v17 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        v16 /*: any*/ 
                                                                    ]
                                                                },
                                                                v16 /*: any*/ 
                                                            ]
                                                        },
                                                        v22 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueTypeField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": v28 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isHighlightedIssueRow"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v30 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueTypeField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v31 /*: any*/ ,
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": v28 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v15 /*: any*/ ,
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "first",
                                                            "value": 500
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v32 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldSetId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v33 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v16 /*: any*/ ,
                                                                                                v15 /*: any*/ ,
                                                                                                v34 /*: any*/ ,
                                                                                                v32 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "TypeDiscriminator",
                                                                                                    "abstractKey": "__isJiraIssueField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedAffectedServicesConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAffectedService",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "serviceId"
                                                                                                                                },
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v16 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraAffectedServicesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraCascadingOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "cascadingOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentOptionValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v36 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "childOptionValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v36 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraCascadingSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedCmdbObjectsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbObject",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "objectId"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "label"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbAvatar",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "avatar",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "mediaClientConfig",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "clientId"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "fileId"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "mediaBaseUrl"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "mediaJwtToken"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "url48"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "QueryError",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "errors",
                                                                                                                    "plural": true,
                                                                                                                    "selections": v40 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCMDBField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v41 /*: any*/ ,
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v42 /*: any*/ ,
                                                                                                                                v43 /*: any*/ ,
                                                                                                                                v16 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                        },
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v44 /*: any*/ ,
                                                                                                        v27 /*: any*/ ,
                                                                                                        v45 /*: any*/ ,
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDatePickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "dateTime"
                                                                                                        },
                                                                                                        v27 /*: any*/ ,
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDateTimePickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraEpic",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "epic",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                v30 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "color"
                                                                                                                },
                                                                                                                v16 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraEpicLinkField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "renderedFieldHtml"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraFallbackField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v46 /*: any*/ ,
                                                                                                        v27 /*: any*/ ,
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "statusCategory",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v27 /*: any*/ ,
                                                                                                                v23 /*: any*/ ,
                                                                                                                v16 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatus",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "status",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v27 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "statusId"
                                                                                                                },
                                                                                                                v24 /*: any*/ ,
                                                                                                                v16 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v41 /*: any*/ ,
                                                                                                            "concreteType": "JiraLabelConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedLabelsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v33 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabelEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraLabel",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v47 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                        },
                                                                                                        v27 /*: any*/ ,
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraLabelsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v31 /*: any*/ ,
                                                                                                                v27 /*: any*/ ,
                                                                                                                v16 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraColorField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueColorField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        v16 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueTypeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v48 /*: any*/ ,
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v16 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v16 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "summaryField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v46 /*: any*/ ,
                                                                                                                        v16 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v16 /*: any*/ ,
                                                                                                                v20 /*: any*/ ,
                                                                                                                v49 /*: any*/ ,
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "args": [
                                                                                                                                {
                                                                                                                                    "kind": "Literal",
                                                                                                                                    "name": "ids",
                                                                                                                                    "value": [
                                                                                                                                        "issuetype",
                                                                                                                                        "project",
                                                                                                                                        "summary",
                                                                                                                                        "status"
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "fieldsById",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "edges",
                                                                                                                                    "plural": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "node",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v15 /*: any*/ ,
                                                                                                                                                v16 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v34 /*: any*/ ,
                                                                                                                                                        v46 /*: any*/ 
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v34 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "issueType",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v16 /*: any*/ ,
                                                                                                                                                                v50 /*: any*/ ,
                                                                                                                                                                v27 /*: any*/ ,
                                                                                                                                                                v48 /*: any*/ ,
                                                                                                                                                                v21 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v34 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraStatus",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "status",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v16 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "statusCategory",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v16 /*: any*/ ,
                                                                                                                                                                        v23 /*: any*/ 
                                                                                                                                                                    ]
                                                                                                                                                                }
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraStatusField"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueTypeField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v34 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issueType",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v50 /*: any*/ ,
                                                                                                                                        v21 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSingleLineTextField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "summaryField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v34 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraStatusField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "statusField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v16 /*: any*/ ,
                                                                                                                                v34 /*: any*/ ,
                                                                                                                                v25 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v27 /*: any*/ ,
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraParentIssueField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v27 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "iconUrl"
                                                                                                                },
                                                                                                                v16 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v27 /*: any*/ ,
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v27 /*: any*/ ,
                                                                                                                v19 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "large"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v16 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraResolution",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "resolution",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v27 /*: any*/ ,
                                                                                                                v16 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraResolutionField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedSprintsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprintEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSprint",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v16 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "sprintId"
                                                                                                                                },
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "state"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "endDate"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v27 /*: any*/ ,
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSprintField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "user",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v15 /*: any*/ ,
                                                                                                                v27 /*: any*/ ,
                                                                                                                v51 /*: any*/ ,
                                                                                                                v52 /*: any*/ ,
                                                                                                                v16 /*: any*/ ,
                                                                                                                v53 /*: any*/ ,
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": v55 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": v54 /*: any*/ 
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "AppUser"
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": v55 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v45 /*: any*/ ,
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraRichText",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "richText",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraADF",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "adfValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "convertedPlainText",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "plainText"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraRichTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraServiceManagementRequestType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "requestType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v27 /*: any*/ ,
                                                                                                                v48 /*: any*/ ,
                                                                                                                v16 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraServiceManagementRequestTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": [
                                                                                                                {
                                                                                                                    "kind": "Literal",
                                                                                                                    "name": "first",
                                                                                                                    "value": 1
                                                                                                                }
                                                                                                            ],
                                                                                                            "concreteType": "JiraIssueLinkConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueLinkConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v33 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issue",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v49 /*: any*/ ,
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "args": [
                                                                                                                                                {
                                                                                                                                                    "kind": "Literal",
                                                                                                                                                    "name": "ids",
                                                                                                                                                    "value": [
                                                                                                                                                        "statusCategory"
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "fieldsById",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "edges",
                                                                                                                                                    "plural": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "node",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v15 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v24 /*: any*/ 
                                                                                                                                                                    ],
                                                                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                                                                },
                                                                                                                                                                v16 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                                                                                            "kind": "Condition",
                                                                                                                                            "passingValue": true,
                                                                                                                                            "selections": [
                                                                                                                                                v22 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v16 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "relationName"
                                                                                                                                },
                                                                                                                                v16 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "issueLinkConnection(first:1)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueLinkField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isStoryPointField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "number"
                                                                                                        },
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraNumberFieldFormatConfig",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "formatConfig",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "formatStyle"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "formatUnit"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraNumberField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCommentSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "commentSummary",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "canAddComment"
                                                                                                                },
                                                                                                                v33 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCommentSummaryField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "uri"
                                                                                                        },
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraUrlField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v35 /*: any*/ ,
                                                                                                                v47 /*: any*/ ,
                                                                                                                v16 /*: any*/ ,
                                                                                                                v56 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v16 /*: any*/ ,
                                                                                                                                v35 /*: any*/ ,
                                                                                                                                v56 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v16 /*: any*/ ,
                                                                                                                                v35 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v57 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraUserConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedUsersConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraUserEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v15 /*: any*/ ,
                                                                                                                                v53 /*: any*/ ,
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v51 /*: any*/ ,
                                                                                                                                v16 /*: any*/ ,
                                                                                                                                v52 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "email"
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "AtlassianAccountUser"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraTeamView",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedTeam",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "jiraSuppliedId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "jiraSuppliedName"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraTeamViewField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraTimeTrackingField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "timeTrackingField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v16 /*: any*/ ,
                                                                                                                                v58 /*: any*/ ,
                                                                                                                                v59 /*: any*/ ,
                                                                                                                                v34 /*: any*/ ,
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v32 /*: any*/ ,
                                                                                                                                v38 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v16 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraOriginalTimeEstimateField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraTimeTrackingField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "timeTrackingField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v58 /*: any*/ ,
                                                                                                                                v59 /*: any*/ ,
                                                                                                                                v16 /*: any*/ ,
                                                                                                                                v34 /*: any*/ ,
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v32 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v16 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v38 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraOriginalTimeEstimateField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": "label",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "value"
                                                                                                                },
                                                                                                                v16 /*: any*/ ,
                                                                                                                v42 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraRadioSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v41 /*: any*/ ,
                                                                                                            "concreteType": "JiraVersionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedVersionsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersion",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v16 /*: any*/ ,
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v42 /*: any*/ ,
                                                                                                                                v43 /*: any*/ ,
                                                                                                                                v60 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                        },
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        v62 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v41 /*: any*/ ,
                                                                                                            "concreteType": "JiraGoalConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedGoals",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGoalEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGoal",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v16 /*: any*/ ,
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        v27 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "status"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v57 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "selectedGoals(first:1000)"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ClientExtension",
                                                                                                            "selections": [
                                                                                                                v29 /*: any*/ ,
                                                                                                                v37 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraGoalsField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v27 /*: any*/ ,
                                                                                                                v62 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isLinkEditable"
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraTownsquareProject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "project",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v16 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "alias": "atlasProjectName",
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "name"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "alias": "atlasProjectKey",
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "key"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "privateProject"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "hasPermission"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "isWorkspaceActive"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "iconName"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v38 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraTownsquareProjectField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v41 /*: any*/ ,
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "confluenceRemoteIssueLinks",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v16 /*: any*/ ,
                                                                                                                                v63 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "pageContent",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v15 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v63 /*: any*/ 
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraConfluencePageContentDetails"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v33 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                        },
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedGroupsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroupEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGroup",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v16 /*: any*/ ,
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "groupId"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleGroupPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraFlag",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "flag",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isFlagged"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraFlagField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraWatch",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "watch",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "count"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isWatching"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraWatchesField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v16 /*: any*/ ,
                                                                                                                                v20 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issueTypeField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "issueType",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v27 /*: any*/ ,
                                                                                                                                                v21 /*: any*/ ,
                                                                                                                                                v16 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v16 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraParentIssueField",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "parentIssueField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "parentIssue",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v20 /*: any*/ ,
                                                                                                                                                v19 /*: any*/ ,
                                                                                                                                                v16 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v16 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraSingleSelectUserPickerField",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "assigneeField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "user",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v15 /*: any*/ ,
                                                                                                                                                v51 /*: any*/ ,
                                                                                                                                                v16 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v16 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "args": v64 /*: any*/ ,
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "startDateViewField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": v66 /*: any*/ ,
                                                                                                                                    "storageKey": "startDateViewField(viewId:\"list_default\")"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "args": v64 /*: any*/ ,
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "endDateViewField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": v66 /*: any*/ ,
                                                                                                                                    "storageKey": "endDateViewField(viewId:\"list_default\")"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "aggregatedStartDateViewField",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": v67 /*: any*/ 
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "aggregatedEndDateViewField",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": v67 /*: any*/ 
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "JiraAggregatedTimelineField"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraTimelineVirtualField",
                                                                                                                    "abstractKey": "__isJiraTimelineVirtualField"
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraAggregatedTimelineField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v57 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v57 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "isConditionalFormattingEnabled",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSet",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fields",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "args": v41 /*: any*/ ,
                                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedComponentsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "componentId"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraComponentsField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraPriority",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "priority",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "priorityId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraPriorityField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraProject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "project",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "projectId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraProjectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "version",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v60 /*: any*/ ,
                                                                                                                        v16 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraSingleVersionPickerField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v50 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraIssueTypeField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v68 /*: any*/ 
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraSingleSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSelectableValueConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedValues",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSelectableValueEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": v68 /*: any*/ 
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraMultipleSelectField"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                },
                                                v57 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasPreviousPage"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraIssueNavigatorPageInfo",
                                            "kind": "LinkedField",
                                            "name": "issueNavigatorPageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "firstIssuePosition"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "lastIssuePosition"
                                                }
                                            ]
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "maxCursors",
                                                    "value": 7
                                                }
                                            ],
                                            "concreteType": "JiraPageCursors",
                                            "kind": "LinkedField",
                                            "name": "pageCursors",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "around",
                                                    "plural": true,
                                                    "selections": v71 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "last",
                                                    "plural": false,
                                                    "selections": v71 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "first",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        v69 /*: any*/ ,
                                                        v70 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "pageCursors(maxCursors:7)"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalIssueSearchResultCount"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "issueSearchError",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "messages"
                                                        }
                                                    ],
                                                    "type": "JiraInvalidJqlError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v39 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "errorType"
                                                        }
                                                    ],
                                                    "type": "JiraInvalidSyntaxError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v40 /*: any*/ ,
                                                    "type": "JiraServerError"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isCappingIssueSearchResult"
                                        },
                                        v57 /*: any*/ ,
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v30 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v17 /*: any*/ ,
                                    "filters": [
                                        "issueSearchInput"
                                    ],
                                    "handle": "connection",
                                    "key": "IssueNavigatorDetailedViewPagination__issues",
                                    "kind": "LinkedHandle",
                                    "name": "issues"
                                }
                            ],
                            "type": "JiraDetailedView"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "802c994dd3bcf74e3816ff9ecf63d7d48d4d8975064ad30a16a62ac9da62d043",
            "metadata": {},
            "name": "IssueNavigatorDetailedViewPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider": (0, $cqxuo.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $kmr3r.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider": (0, $dexoz.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": (0, $l6otE.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": (0, $evjHZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": (0, $j2Uha.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $ad5K7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": (0, $04qit.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": (0, $6AioA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": (0, $1fipb.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider": (0, $cIDJo.default)
            }
        }
    };
}();
$467f9442fbdd0e43$var$node.hash = "a94b8cf7516b80e2a57d7d4c570bbfaf";
var $467f9442fbdd0e43$export$2e2bcd8739ae039 = $467f9442fbdd0e43$var$node;

});


parcelRegister("59rbW", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d8ccfb7997ad323$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4b24c22462684d96e844639c180b4c69>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $eSK9M = parcelRequire("eSK9M");
const $6d8ccfb7997ad323$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "isConditionalFormattingEnabled",
        "variableName": "isConditionalFormattingEnabled"
    }, v1 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v2 = {
        "kind": "Variable",
        "name": "projectKeys",
        "variableName": "projectKeys"
    }, v3 = [
        v0 /*: any*/ ,
        v1 /*: any*/ ,
        v2 /*: any*/ 
    ], v4 = [
        v1 /*: any*/ ,
        v2 /*: any*/ 
    ], v5 = [
        v0 /*: any*/ ,
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "shouldQueryHasChildren",
            "variableName": "shouldQueryHasChildren"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "amountOfColumns"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "dynamicSearchKey"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsScope"
            },
            {
                "kind": "RootArgument",
                "name": "filterId"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "groupBy"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "isPaginating"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isSavedViewConditionalFormattingEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "jiraViewQueryInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "namespace"
            },
            {
                "kind": "RootArgument",
                "name": "options"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "saveJQLToUserHistory"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "settings"
            },
            {
                "kind": "RootArgument",
                "name": "shouldQueryHasChildren"
            },
            {
                "kind": "RootArgument",
                "name": "staticViewInput"
            },
            {
                "kind": "RootArgument",
                "name": "viewConfigInput"
            },
            {
                "kind": "RootArgument",
                "name": "viewId"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $eSK9M.default)
            }
        },
        "name": "main_issueNavigator_IssueNavigator_refetchQuery",
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            },
                            {
                                "kind": "Variable",
                                "name": "filterId",
                                "variableName": "filterId"
                            },
                            {
                                "kind": "Variable",
                                "name": "issueSearchInput",
                                "variableName": "issueSearchInput"
                            },
                            {
                                "kind": "Variable",
                                "name": "jiraViewQueryInput",
                                "variableName": "jiraViewQueryInput"
                            },
                            {
                                "kind": "Variable",
                                "name": "namespace",
                                "variableName": "namespace"
                            },
                            {
                                "kind": "Variable",
                                "name": "scope",
                                "variableName": "scope"
                            },
                            {
                                "kind": "Variable",
                                "name": "settings",
                                "variableName": "settings"
                            },
                            {
                                "kind": "Variable",
                                "name": "viewConfigInput",
                                "variableName": "staticViewInput"
                            },
                            {
                                "kind": "Variable",
                                "name": "viewId",
                                "variableName": "viewId"
                            }
                        ],
                        "kind": "LinkedField",
                        "name": "jiraIssueSearchView",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "__typename"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "IssueSearchInputProvider_jiraView"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "issueSearch_issueNavigatorGrouping"
                            },
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "isSavedViewConditionalFormattingEnabled",
                                        "variableName": "isSavedViewConditionalFormattingEnabled"
                                    }
                                ],
                                "kind": "FragmentSpread",
                                "name": "main_issueNavigator_IssueNavigatorUI_jiraView"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "selectedView_issueNavigator_SelectedViewContainer"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "condition": "isSavedViewConditionalFormattingEnabled",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "first",
                                                        "value": 20
                                                    }
                                                ],
                                                "kind": "FragmentSpread",
                                                "name": "ConditionalFormattingSidebarContainer_view"
                                            }
                                        ]
                                    }
                                ],
                                "type": "JiraSpreadsheetView",
                                "abstractKey": "__isJiraSpreadsheetView"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": v3 /*: any*/ ,
                                                "kind": "FragmentSpread",
                                                "name": "main_issueNavigator_IssueNavigator_jiraDetailedViewData"
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            {
                                                "args": v3 /*: any*/ ,
                                                "kind": "FragmentSpread",
                                                "name": "main_issueNavigator_IssueNavigator_detailedViewData"
                                            }
                                        ]
                                    }
                                ],
                                "type": "JiraDetailedView"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": v4 /*: any*/ ,
                                                "kind": "FragmentSpread",
                                                "name": "main_issueNavigator_IssueNavigator_jiraGroupedListViewData"
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            {
                                                "args": v4 /*: any*/ ,
                                                "kind": "FragmentSpread",
                                                "name": "main_issueNavigator_IssueNavigator_groupedListViewData"
                                            }
                                        ]
                                    }
                                ],
                                "type": "JiraGroupedListView"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": v5 /*: any*/ ,
                                                "kind": "FragmentSpread",
                                                "name": "main_issueNavigator_IssueNavigator_jiraListViewData"
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            {
                                                "args": v5 /*: any*/ ,
                                                "kind": "FragmentSpread",
                                                "name": "main_issueNavigator_IssueNavigator_listViewData"
                                            }
                                        ]
                                    }
                                ],
                                "type": "JiraListView"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$6d8ccfb7997ad323$var$node.hash = "890906db4f5f0af8b4eb588379287a51";
var $6d8ccfb7997ad323$export$2e2bcd8739ae039 = $6d8ccfb7997ad323$var$node;

});
parcelRegister("eSK9M", function(module, exports) {
$parcel$export(module.exports, "default", () => $f12c48543311749c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<38538424c961a777f45a85174bd5771b>>
 * @relayHash aed36709abb5dcf421737f7c2c1f5665
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6fc49fdfba24f923eb3361d369f22bbf6456628966c87e44feefb073f7c87cf1

var $3Bt2F = parcelRequire("3Bt2F");

var $cqxuo = parcelRequire("cqxuo");

var $dexoz = parcelRequire("dexoz");

var $8jq8m = parcelRequire("8jq8m");

var $3jVIX = parcelRequire("3jVIX");

var $4GS9O = parcelRequire("4GS9O");

var $l6otE = parcelRequire("l6otE");

var $lcRgI = parcelRequire("lcRgI");

var $ad5K7 = parcelRequire("ad5K7");

var $hHOEN = parcelRequire("hHOEN");

var $2Z4v6 = parcelRequire("2Z4v6");

var $alrjx = parcelRequire("alrjx");

var $eylLg = parcelRequire("eylLg");

var $iiQfx = parcelRequire("iiQfx");

var $hRj2m = parcelRequire("hRj2m");

var $cIDJo = parcelRequire("cIDJo");

var $6AioA = parcelRequire("6AioA");

var $04qit = parcelRequire("04qit");

var $jvWSl = parcelRequire("jvWSl");

var $j2Uha = parcelRequire("j2Uha");

var $kmr3r = parcelRequire("kmr3r");

var $hA9n6 = parcelRequire("hA9n6");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $gDQIG = parcelRequire("gDQIG");

var $1fipb = parcelRequire("1fipb");

var $8Qoc7 = parcelRequire("8Qoc7");

var $cqnj8 = parcelRequire("cqnj8");

var $iOvkB = parcelRequire("iOvkB");

var $evjHZ = parcelRequire("evjHZ");

var $FU9UR = parcelRequire("FU9UR");
const $f12c48543311749c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "dynamicSearchKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsScope"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "groupBy"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLastUsedJqlEnabled"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isPaginating"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSavedViewConditionalFormattingEnabled"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraViewQueryInput"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v19 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v20 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v21 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "saveJQLToUserHistory"
    }, v22 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v23 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "settings"
    }, v24 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v25 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "staticViewInput"
    }, v26 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v27 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v28 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v29 = {
        "kind": "Variable",
        "name": "issueSearchInput",
        "variableName": "issueSearchInput"
    }, v30 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v31 = {
        "kind": "Variable",
        "name": "settings",
        "variableName": "settings"
    }, v32 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v33 = {
        "kind": "ScalarField",
        "name": "message"
    }, v34 = [
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v32 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                }
            ]
        },
        v33 /*: any*/ 
    ], v35 = {
        "kind": "ScalarField",
        "name": "id"
    }, v36 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "fieldSetsScope"
    }, v37 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "fieldSetSelectedState": "SELECTED"
            }
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        },
        v36 /*: any*/ 
    ], v38 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v39 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v40 = {
        "kind": "ScalarField",
        "name": "savedViewId"
    }, v41 = {
        "args": [
            v31 /*: any*/ 
        ],
        "kind": "ScalarField",
        "name": "isViewConfigModified"
    }, v42 = {
        "kind": "Variable",
        "name": "groupBy",
        "variableName": "groupBy"
    }, v43 = [
        v42 /*: any*/ ,
        v29 /*: any*/ ,
        v31 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "staticViewInput",
            "variableName": "staticViewInput"
        }
    ], v44 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v45 = {
        "concreteType": "JiraSpreadsheetGroupByConfig",
        "kind": "LinkedField",
        "name": "groupByConfig",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraField",
                "kind": "LinkedField",
                "name": "groupByField",
                "plural": false,
                "selections": [
                    v44 /*: any*/ ,
                    v35 /*: any*/ 
                ]
            }
        ]
    }, v46 = {
        "kind": "ScalarField",
        "name": "hideDone"
    }, v47 = {
        "kind": "ScalarField",
        "name": "isHierarchyEnabled"
    }, v48 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v49 = {
        "kind": "ClientExtension",
        "selections": [
            v48 /*: any*/ 
        ]
    }, v50 = {
        "kind": "ScalarField",
        "name": "isGroupingEnabled"
    }, v51 = {
        "kind": "ScalarField",
        "name": "canEnableGrouping"
    }, v52 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v53 = {
        "kind": "ScalarField",
        "name": "type"
    }, v54 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v55 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v56 = {
        "kind": "ScalarField",
        "name": "canEnableHierarchy"
    }, v57 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v58 = {
        "kind": "ScalarField",
        "name": "value"
    }, v59 = {
        "kind": "InlineFragment",
        "selections": [
            v44 /*: any*/ ,
            {
                "alias": "singleValueOperator",
                "kind": "ScalarField",
                "name": "operator"
            },
            v58 /*: any*/ 
        ],
        "type": "JiraFormattingSingleValueOperand"
    }, v60 = {
        "kind": "InlineFragment",
        "selections": [
            v44 /*: any*/ ,
            {
                "alias": "multipleValueOperator",
                "kind": "ScalarField",
                "name": "operator"
            },
            {
                "kind": "ScalarField",
                "name": "values"
            }
        ],
        "type": "JiraFormattingMultipleValueOperand"
    }, v61 = {
        "kind": "InlineFragment",
        "selections": [
            v44 /*: any*/ ,
            {
                "alias": "noValueOperator",
                "kind": "ScalarField",
                "name": "operator"
            }
        ],
        "type": "JiraFormattingNoValueOperand"
    }, v62 = {
        "kind": "ScalarField",
        "name": "formattingArea"
    }, v63 = {
        "kind": "ScalarField",
        "name": "colorKey"
    }, v64 = {
        "kind": "ScalarField",
        "name": "name"
    }, v65 = [
        v63 /*: any*/ ,
        v35 /*: any*/ 
    ], v66 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v67 = {
        "kind": "Variable",
        "name": "before",
        "variableName": "before"
    }, v68 = {
        "kind": "Variable",
        "name": "fieldSetsInput",
        "variableName": "fieldSetsInput"
    }, v69 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v70 = {
        "kind": "Variable",
        "name": "last",
        "variableName": "last"
    }, v71 = {
        "kind": "Variable",
        "name": "options",
        "variableName": "options"
    }, v72 = {
        "kind": "Variable",
        "name": "saveJQLToUserHistory",
        "variableName": "saveJQLToUserHistory"
    }, v73 = [
        v66 /*: any*/ ,
        v67 /*: any*/ ,
        v68 /*: any*/ ,
        v69 /*: any*/ ,
        v29 /*: any*/ ,
        v70 /*: any*/ ,
        v71 /*: any*/ ,
        v72 /*: any*/ ,
        v30 /*: any*/ ,
        v31 /*: any*/ 
    ], v74 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v75 = {
        "kind": "ScalarField",
        "name": "key"
    }, v76 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v77 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v78 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v77 /*: any*/ ,
                    v35 /*: any*/ 
                ]
            },
            v35 /*: any*/ 
        ]
    }, v79 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v80 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v81 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v80 /*: any*/ ,
            v35 /*: any*/ 
        ]
    }, v82 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v81 /*: any*/ ,
            v35 /*: any*/ 
        ]
    }, v83 = {
        "concreteType": "JiraStatusField",
        "kind": "LinkedField",
        "name": "statusField",
        "plural": false,
        "selections": [
            v82 /*: any*/ ,
            v35 /*: any*/ 
        ]
    }, v84 = [
        v64 /*: any*/ 
    ], v85 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraIssueTypeField",
                "kind": "LinkedField",
                "name": "issueTypeField",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "issueType",
                        "plural": false,
                        "selections": v84 /*: any*/ 
                    }
                ]
            }
        ]
    }, v86 = {
        "kind": "ClientExtension",
        "selections": [
            v48 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isHighlightedIssueRow"
            }
        ]
    }, v87 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v88 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v89 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v32 /*: any*/ ,
            v35 /*: any*/ ,
            v75 /*: any*/ ,
            v76 /*: any*/ ,
            v78 /*: any*/ ,
            v79 /*: any*/ ,
            v83 /*: any*/ ,
            v85 /*: any*/ ,
            v86 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v87 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                    v88 /*: any*/ ,
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": v84 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v90 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v91 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v92 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v64 /*: any*/ ,
                                    v35 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v93 = [
        v58 /*: any*/ ,
        v35 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v94 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v95 = {
        "kind": "ClientExtension",
        "selections": [
            v94 /*: any*/ 
        ]
    }, v96 = {
        "kind": "InlineFragment",
        "selections": [
            v64 /*: any*/ ,
            {
                "concreteType": "JiraCascadingOption",
                "kind": "LinkedField",
                "name": "cascadingOption",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "parentOptionValue",
                        "plural": false,
                        "selections": v93 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "childOptionValue",
                        "plural": false,
                        "selections": v93 /*: any*/ 
                    }
                ]
            },
            v95 /*: any*/ 
        ],
        "type": "JiraCascadingSelectField"
    }, v97 = [
        v33 /*: any*/ 
    ], v98 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraCmdbMediaClientConfig",
                                                "kind": "LinkedField",
                                                "name": "mediaClientConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "clientId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fileId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaBaseUrl"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaJwtToken"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": v97 /*: any*/ 
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v99 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v100 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v101 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v102 = {
        "kind": "InlineFragment",
        "selections": [
            v64 /*: any*/ ,
            {
                "args": v99 /*: any*/ ,
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v100 /*: any*/ ,
                                    v101 /*: any*/ ,
                                    v35 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedComponentsConnection(first:1000)"
            },
            v95 /*: any*/ 
        ],
        "type": "JiraComponentsField"
    }, v103 = {
        "kind": "ScalarField",
        "name": "date"
    }, v104 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v105 = {
        "kind": "InlineFragment",
        "selections": [
            v103 /*: any*/ ,
            v64 /*: any*/ ,
            v104 /*: any*/ ,
            v95 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v106 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "dateTime"
            },
            v64 /*: any*/ ,
            v95 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v107 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v75 /*: any*/ ,
                    v87 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v35 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v108 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v109 = {
        "kind": "ScalarField",
        "name": "text"
    }, v110 = {
        "kind": "InlineFragment",
        "selections": [
            v109 /*: any*/ ,
            v64 /*: any*/ ,
            v95 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v111 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    v64 /*: any*/ ,
                    v80 /*: any*/ ,
                    v35 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusCategoryField"
    }, v112 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v64 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v81 /*: any*/ ,
                    v35 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v113 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": v65 /*: any*/ 
    }, v114 = [
        v64 /*: any*/ ,
        v113 /*: any*/ 
    ], v115 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v99 /*: any*/ ,
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    v52 /*: any*/ ,
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v114 /*: any*/ 
                            }
                        ]
                    }
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            v64 /*: any*/ ,
            v95 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v116 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v88 /*: any*/ ,
                    v64 /*: any*/ ,
                    v35 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v117 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v118 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v119 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v120 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v35 /*: any*/ ,
            v80 /*: any*/ 
        ]
    }, v121 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v75 /*: any*/ ,
                    {
                        "concreteType": "JiraColorField",
                        "kind": "LinkedField",
                        "name": "issueColorField",
                        "plural": false,
                        "selections": [
                            v113 /*: any*/ ,
                            v35 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                    v117 /*: any*/ ,
                                    v64 /*: any*/ ,
                                    v35 /*: any*/ 
                                ]
                            },
                            v35 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "JiraSingleLineTextField",
                        "kind": "LinkedField",
                        "name": "summaryField",
                        "plural": false,
                        "selections": [
                            v109 /*: any*/ ,
                            v35 /*: any*/ 
                        ]
                    },
                    v35 /*: any*/ ,
                    v76 /*: any*/ ,
                    v118 /*: any*/ ,
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                            "issuetype",
                                            "project",
                                            "summary",
                                            "status"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v32 /*: any*/ ,
                                                    v35 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v44 /*: any*/ ,
                                                            v109 /*: any*/ 
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v44 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    v35 /*: any*/ ,
                                                                    v119 /*: any*/ ,
                                                                    v64 /*: any*/ ,
                                                                    v117 /*: any*/ ,
                                                                    v77 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v44 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraStatus",
                                                                "kind": "LinkedField",
                                                                "name": "status",
                                                                "plural": false,
                                                                "selections": [
                                                                    v35 /*: any*/ ,
                                                                    v120 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusField"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                            }
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueTypeField",
                                "kind": "LinkedField",
                                "name": "issueTypeField",
                                "plural": false,
                                "selections": [
                                    v44 /*: any*/ ,
                                    {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "issueType",
                                        "plural": false,
                                        "selections": [
                                            v119 /*: any*/ ,
                                            v77 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            {
                                "concreteType": "JiraSingleLineTextField",
                                "kind": "LinkedField",
                                "name": "summaryField",
                                "plural": false,
                                "selections": [
                                    v44 /*: any*/ 
                                ]
                            },
                            {
                                "concreteType": "JiraStatusField",
                                "kind": "LinkedField",
                                "name": "statusField",
                                "plural": false,
                                "selections": [
                                    v35 /*: any*/ ,
                                    v44 /*: any*/ ,
                                    v82 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            v64 /*: any*/ ,
            v95 /*: any*/ 
        ],
        "type": "JiraParentIssueField"
    }, v122 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v123 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v64 /*: any*/ ,
                    v122 /*: any*/ ,
                    v35 /*: any*/ 
                ]
            },
            v64 /*: any*/ ,
            v95 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v124 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v64 /*: any*/ ,
                    v75 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v35 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v125 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": [
                    v64 /*: any*/ ,
                    v35 /*: any*/ 
                ]
            }
        ],
        "type": "JiraResolutionField"
    }, v126 = [
        v35 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "sprintId"
        },
        v64 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "state"
        },
        {
            "kind": "ScalarField",
            "name": "endDate"
        }
    ], v127 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v126 /*: any*/ 
                            }
                        ]
                    }
                ]
            },
            v64 /*: any*/ ,
            v95 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v128 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v129 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v130 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v131 = [
        {
            "kind": "ScalarField",
            "name": "appType"
        }
    ], v132 = [
        {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isUser"
        },
        {
            "kind": "InlineFragment",
            "selections": v131 /*: any*/ ,
            "type": "AppUser"
        }
    ], v133 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": v132 /*: any*/ 
    }, v134 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": v131 /*: any*/ 
            }
        ],
        "type": "AppUser"
    }, v135 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraAdfToConvertedPlainText",
                                "kind": "LinkedField",
                                "name": "convertedPlainText",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "plainText"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v136 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v64 /*: any*/ ,
                    v117 /*: any*/ ,
                    v35 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v137 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    v52 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            v118 /*: any*/ ,
                                            v75 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v32 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v81 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v35 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                    v79 /*: any*/ 
                                                ]
                                            },
                                            v35 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v35 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "issueLinkConnection(first:1)"
            }
        ],
        "type": "JiraIssueLinkField"
    }, v138 = {
        "kind": "ScalarField",
        "name": "number"
    }, v139 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isStoryPointField"
            },
            v138 /*: any*/ ,
            v64 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraNumberFieldFormatConfig",
                        "kind": "LinkedField",
                        "name": "formatConfig",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "formatStyle"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "formatUnit"
                            }
                        ]
                    }
                ]
            },
            v95 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v140 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCommentSummary",
                "kind": "LinkedField",
                "name": "commentSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "canAddComment"
                    },
                    v52 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCommentSummaryField"
    }, v141 = {
        "kind": "InlineFragment",
        "selections": [
            v64 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "uri"
            },
            v95 /*: any*/ 
        ],
        "type": "JiraUrlField"
    }, v142 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v143 = {
        "kind": "InlineFragment",
        "selections": [
            v64 /*: any*/ ,
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "fieldOption",
                "plural": false,
                "selections": [
                    v58 /*: any*/ ,
                    v113 /*: any*/ ,
                    v35 /*: any*/ ,
                    v142 /*: any*/ 
                ]
            },
            v95 /*: any*/ 
        ],
        "type": "JiraSingleSelectField"
    }, v144 = {
        "kind": "InlineFragment",
        "selections": [
            v64 /*: any*/ ,
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v35 /*: any*/ ,
                                    v58 /*: any*/ ,
                                    v142 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            v95 /*: any*/ 
        ],
        "type": "JiraMultipleSelectField"
    }, v145 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v35 /*: any*/ ,
            v58 /*: any*/ 
        ]
    }, v146 = {
        "kind": "InlineFragment",
        "selections": [
            v64 /*: any*/ ,
            {
                "concreteType": "JiraUserConnection",
                "kind": "LinkedField",
                "name": "selectedUsersConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraUserEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v32 /*: any*/ ,
                                    v130 /*: any*/ ,
                                    v64 /*: any*/ ,
                                    v128 /*: any*/ ,
                                    v35 /*: any*/ ,
                                    v129 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "email"
                                            }
                                        ],
                                        "type": "AtlassianAccountUser"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            v95 /*: any*/ 
        ],
        "type": "JiraMultipleSelectUserPickerField"
    }, v147 = {
        "kind": "InlineFragment",
        "selections": [
            v64 /*: any*/ ,
            {
                "concreteType": "JiraTeamView",
                "kind": "LinkedField",
                "name": "selectedTeam",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedName"
                    }
                ]
            },
            v95 /*: any*/ 
        ],
        "type": "JiraTeamViewField"
    }, v148 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeInSeconds"
            }
        ]
    }, v149 = {
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "timeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v150 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraTimeTrackingField",
                                "kind": "LinkedField",
                                "name": "timeTrackingField",
                                "plural": false,
                                "selections": [
                                    v35 /*: any*/ ,
                                    v148 /*: any*/ ,
                                    v149 /*: any*/ ,
                                    v44 /*: any*/ ,
                                    v64 /*: any*/ ,
                                    v53 /*: any*/ ,
                                    v95 /*: any*/ 
                                ]
                            },
                            v35 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraOriginalTimeEstimateField"
            }
        ]
    }, v151 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraTimeTrackingField",
                                "kind": "LinkedField",
                                "name": "timeTrackingField",
                                "plural": false,
                                "selections": [
                                    v148 /*: any*/ ,
                                    v149 /*: any*/ ,
                                    v35 /*: any*/ ,
                                    v44 /*: any*/ ,
                                    v64 /*: any*/ ,
                                    v53 /*: any*/ 
                                ]
                            },
                            v35 /*: any*/ 
                        ]
                    },
                    v95 /*: any*/ 
                ],
                "type": "JiraOriginalTimeEstimateField"
            }
        ]
    }, v152 = {
        "kind": "InlineFragment",
        "selections": [
            v64 /*: any*/ ,
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "selectedOption",
                "plural": false,
                "selections": [
                    {
                        "alias": "label",
                        "kind": "ScalarField",
                        "name": "value"
                    },
                    v35 /*: any*/ ,
                    v100 /*: any*/ 
                ]
            },
            v95 /*: any*/ 
        ],
        "type": "JiraRadioSelectField"
    }, v153 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v154 = {
        "kind": "InlineFragment",
        "selections": [
            v64 /*: any*/ ,
            {
                "args": v99 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v35 /*: any*/ ,
                                    v64 /*: any*/ ,
                                    v100 /*: any*/ ,
                                    v101 /*: any*/ ,
                                    v153 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            },
            v95 /*: any*/ 
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v155 = [
        v35 /*: any*/ 
    ], v156 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": v155 /*: any*/ 
    }, v157 = {
        "kind": "ScalarField",
        "name": "status"
    }, v158 = {
        "kind": "InlineFragment",
        "selections": [
            v64 /*: any*/ ,
            v156 /*: any*/ ,
            {
                "args": v99 /*: any*/ ,
                "concreteType": "JiraGoalConnection",
                "kind": "LinkedField",
                "name": "selectedGoals",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGoalEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGoal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v35 /*: any*/ ,
                                    v75 /*: any*/ ,
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            v64 /*: any*/ ,
                                            v157 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v49 /*: any*/ 
                ],
                "storageKey": "selectedGoals(first:1000)"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    v48 /*: any*/ ,
                    v94 /*: any*/ 
                ]
            }
        ],
        "type": "JiraGoalsField"
    }, v159 = {
        "kind": "ScalarField",
        "name": "privateProject"
    }, v160 = {
        "kind": "ScalarField",
        "name": "hasPermission"
    }, v161 = {
        "kind": "ScalarField",
        "name": "iconName"
    }, v162 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v64 /*: any*/ ,
                    v156 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isLinkEditable"
                    },
                    {
                        "concreteType": "JiraTownsquareProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                            v35 /*: any*/ ,
                            {
                                "alias": "atlasProjectName",
                                "kind": "ScalarField",
                                "name": "name"
                            },
                            {
                                "alias": "atlasProjectKey",
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            v159 /*: any*/ ,
                            v160 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "isWorkspaceActive"
                            },
                            v161 /*: any*/ 
                        ]
                    },
                    v95 /*: any*/ 
                ],
                "type": "JiraTownsquareProjectField"
            }
        ]
    }, v163 = {
        "kind": "ScalarField",
        "name": "href"
    }, v164 = {
        "kind": "InlineFragment",
        "selections": [
            v64 /*: any*/ ,
            {
                "args": v99 /*: any*/ ,
                "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                "kind": "LinkedField",
                "name": "confluenceRemoteIssueLinks",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v35 /*: any*/ ,
                                    v163 /*: any*/ ,
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "pageContent",
                                                "plural": false,
                                                "selections": [
                                                    v32 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v163 /*: any*/ 
                                                        ],
                                                        "type": "JiraConfluencePageContentDetails"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v52 /*: any*/ 
                ],
                "storageKey": "confluenceRemoteIssueLinks(first:1000)"
            },
            v95 /*: any*/ 
        ],
        "type": "JiraConfluenceRemoteIssueLinksField"
    }, v165 = {
        "kind": "ScalarField",
        "name": "groupId"
    }, v166 = {
        "kind": "InlineFragment",
        "selections": [
            v64 /*: any*/ ,
            {
                "concreteType": "JiraGroupConnection",
                "kind": "LinkedField",
                "name": "selectedGroupsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGroupEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGroup",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v35 /*: any*/ ,
                                    v64 /*: any*/ ,
                                    v165 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            v95 /*: any*/ 
        ],
        "type": "JiraMultipleGroupPickerField"
    }, v167 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraFlag",
                "kind": "LinkedField",
                "name": "flag",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isFlagged"
                    }
                ]
            }
        ],
        "type": "JiraFlagField"
    }, v168 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraWatch",
                "kind": "LinkedField",
                "name": "watch",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isWatching"
                    }
                ]
            }
        ],
        "type": "JiraWatchesField"
    }, v169 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v170 = {
        "kind": "InlineFragment",
        "selections": [
            v103 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v171 = [
        v32 /*: any*/ ,
        v44 /*: any*/ ,
        v170 /*: any*/ ,
        v35 /*: any*/ 
    ], v172 = [
        v32 /*: any*/ ,
        v170 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": v155 /*: any*/ ,
            "type": "Node",
            "abstractKey": "__isNode"
        }
    ], v173 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "issue",
                                "plural": false,
                                "selections": [
                                    v35 /*: any*/ ,
                                    v76 /*: any*/ ,
                                    {
                                        "concreteType": "JiraIssueTypeField",
                                        "kind": "LinkedField",
                                        "name": "issueTypeField",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueType",
                                                "kind": "LinkedField",
                                                "name": "issueType",
                                                "plural": false,
                                                "selections": [
                                                    v64 /*: any*/ ,
                                                    v77 /*: any*/ ,
                                                    v35 /*: any*/ 
                                                ]
                                            },
                                            v35 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraParentIssueField",
                                        "kind": "LinkedField",
                                        "name": "parentIssueField",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "parentIssue",
                                                "plural": false,
                                                "selections": [
                                                    v76 /*: any*/ ,
                                                    v75 /*: any*/ ,
                                                    v35 /*: any*/ 
                                                ]
                                            },
                                            v35 /*: any*/ 
                                        ]
                                    },
                                    v75 /*: any*/ ,
                                    v83 /*: any*/ ,
                                    {
                                        "concreteType": "JiraSingleSelectUserPickerField",
                                        "kind": "LinkedField",
                                        "name": "assigneeField",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": [
                                                    v32 /*: any*/ ,
                                                    v128 /*: any*/ ,
                                                    v35 /*: any*/ 
                                                ]
                                            },
                                            v35 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "args": v169 /*: any*/ ,
                                        "kind": "LinkedField",
                                        "name": "startDateViewField",
                                        "plural": false,
                                        "selections": v171 /*: any*/ ,
                                        "storageKey": "startDateViewField(viewId:\"list_default\")"
                                    },
                                    {
                                        "args": v169 /*: any*/ ,
                                        "kind": "LinkedField",
                                        "name": "endDateViewField",
                                        "plural": false,
                                        "selections": v171 /*: any*/ ,
                                        "storageKey": "endDateViewField(viewId:\"list_default\")"
                                    }
                                ]
                            },
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "aggregatedStartDateViewField",
                                                "plural": false,
                                                "selections": v172 /*: any*/ 
                                            },
                                            {
                                                "kind": "LinkedField",
                                                "name": "aggregatedEndDateViewField",
                                                "plural": false,
                                                "selections": v172 /*: any*/ 
                                            }
                                        ],
                                        "type": "JiraAggregatedTimelineField"
                                    }
                                ]
                            }
                        ],
                        "type": "JiraTimelineVirtualField",
                        "abstractKey": "__isJiraTimelineVirtualField"
                    }
                ],
                "type": "JiraAggregatedTimelineField"
            }
        ]
    }, v174 = {
        "kind": "ScalarField",
        "name": "priorityId"
    }, v175 = [
        v32 /*: any*/ ,
        v35 /*: any*/ 
    ], v176 = {
        "args": v90 /*: any*/ ,
        "concreteType": "JiraIssueFieldSetConnection",
        "kind": "LinkedField",
        "name": "fieldSets",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v53 /*: any*/ ,
                            v38 /*: any*/ ,
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    v52 /*: any*/ ,
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v35 /*: any*/ ,
                                                    v32 /*: any*/ ,
                                                    v44 /*: any*/ ,
                                                    v53 /*: any*/ ,
                                                    v91 /*: any*/ ,
                                                    v92 /*: any*/ ,
                                                    v96 /*: any*/ ,
                                                    v98 /*: any*/ ,
                                                    v102 /*: any*/ ,
                                                    v105 /*: any*/ ,
                                                    v106 /*: any*/ ,
                                                    v107 /*: any*/ ,
                                                    v108 /*: any*/ ,
                                                    v110 /*: any*/ ,
                                                    v111 /*: any*/ ,
                                                    v112 /*: any*/ ,
                                                    v115 /*: any*/ ,
                                                    v116 /*: any*/ ,
                                                    v121 /*: any*/ ,
                                                    v123 /*: any*/ ,
                                                    v124 /*: any*/ ,
                                                    v125 /*: any*/ ,
                                                    v127 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v64 /*: any*/ ,
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "user",
                                                                "plural": false,
                                                                "selections": [
                                                                    v32 /*: any*/ ,
                                                                    v64 /*: any*/ ,
                                                                    v128 /*: any*/ ,
                                                                    v129 /*: any*/ ,
                                                                    v35 /*: any*/ ,
                                                                    v130 /*: any*/ ,
                                                                    v133 /*: any*/ ,
                                                                    v134 /*: any*/ ,
                                                                    {
                                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider",
                                                                        "kind": "Condition",
                                                                        "passingValue": true,
                                                                        "selections": v132 /*: any*/ 
                                                                    }
                                                                ]
                                                            },
                                                            v104 /*: any*/ ,
                                                            v95 /*: any*/ 
                                                        ],
                                                        "type": "JiraSingleSelectUserPickerField"
                                                    },
                                                    v135 /*: any*/ ,
                                                    v136 /*: any*/ ,
                                                    v137 /*: any*/ ,
                                                    v139 /*: any*/ ,
                                                    v140 /*: any*/ ,
                                                    v141 /*: any*/ ,
                                                    v143 /*: any*/ ,
                                                    v144 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v64 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraOptionConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedOptions",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraOptionEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v145 /*: any*/ ,
                                                                            v49 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            v95 /*: any*/ 
                                                        ],
                                                        "type": "JiraCheckboxesField"
                                                    },
                                                    v146 /*: any*/ ,
                                                    v147 /*: any*/ ,
                                                    v150 /*: any*/ ,
                                                    v151 /*: any*/ ,
                                                    v152 /*: any*/ ,
                                                    v154 /*: any*/ ,
                                                    v158 /*: any*/ ,
                                                    v162 /*: any*/ ,
                                                    v164 /*: any*/ ,
                                                    v166 /*: any*/ ,
                                                    v167 /*: any*/ ,
                                                    v168 /*: any*/ ,
                                                    v173 /*: any*/ ,
                                                    v49 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            v49 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "isConditionalFormattingEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldConnection",
                                        "kind": "LinkedField",
                                        "name": "fields",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "args": v99 /*: any*/ ,
                                                                        "concreteType": "JiraComponentConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedComponentsConnection",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraComponentEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraComponent",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "componentId"
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "storageKey": "selectedComponentsConnection(first:1000)"
                                                                    }
                                                                ],
                                                                "type": "JiraComponentsField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraPriority",
                                                                        "kind": "LinkedField",
                                                                        "name": "priority",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v174 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraPriorityField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraProject",
                                                                        "kind": "LinkedField",
                                                                        "name": "project",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "projectId"
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraProjectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraVersion",
                                                                        "kind": "LinkedField",
                                                                        "name": "version",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v153 /*: any*/ ,
                                                                            v35 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraSingleVersionPickerField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueType",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v119 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraIssueTypeField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedValue",
                                                                        "plural": false,
                                                                        "selections": v175 /*: any*/ 
                                                                    }
                                                                ],
                                                                "type": "JiraSingleSelectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSelectableValueConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedValues",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraSelectableValueEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": v175 /*: any*/ 
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraMultipleSelectField"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "fieldSets(first:500)"
    }, v177 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v178 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v179 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v177 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "startCursor"
            },
            v178 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
            }
        ]
    }, v180 = {
        "concreteType": "JiraIssueNavigatorPageInfo",
        "kind": "LinkedField",
        "name": "issueNavigatorPageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "firstIssuePosition"
            },
            {
                "kind": "ScalarField",
                "name": "lastIssuePosition"
            }
        ]
    }, v181 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v182 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v183 = [
        v181 /*: any*/ ,
        v74 /*: any*/ ,
        v182 /*: any*/ 
    ], v184 = {
        "args": [
            {
                "kind": "Literal",
                "name": "maxCursors",
                "value": 7
            }
        ],
        "concreteType": "JiraPageCursors",
        "kind": "LinkedField",
        "name": "pageCursors",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "around",
                "plural": true,
                "selections": v183 /*: any*/ 
            },
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "last",
                "plural": false,
                "selections": v183 /*: any*/ 
            },
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "first",
                "plural": false,
                "selections": [
                    v74 /*: any*/ ,
                    v181 /*: any*/ ,
                    v182 /*: any*/ 
                ]
            }
        ],
        "storageKey": "pageCursors(maxCursors:7)"
    }, v185 = {
        "kind": "ScalarField",
        "name": "totalIssueSearchResultCount"
    }, v186 = {
        "kind": "LinkedField",
        "name": "issueSearchError",
        "plural": false,
        "selections": [
            v32 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "messages"
                    }
                ],
                "type": "JiraInvalidJqlError"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v33 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "errorType"
                    }
                ],
                "type": "JiraInvalidSyntaxError"
            },
            {
                "kind": "InlineFragment",
                "selections": v97 /*: any*/ ,
                "type": "JiraServerError"
            }
        ]
    }, v187 = {
        "kind": "ScalarField",
        "name": "isCappingIssueSearchResult"
    }, v188 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v87 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v189 = {
        "args": v73 /*: any*/ ,
        "concreteType": "JiraIssueConnection",
        "kind": "LinkedField",
        "name": "issues",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    v74 /*: any*/ ,
                    v89 /*: any*/ ,
                    v32 /*: any*/ ,
                    v176 /*: any*/ ,
                    v49 /*: any*/ 
                ]
            },
            v179 /*: any*/ ,
            v180 /*: any*/ ,
            v184 /*: any*/ ,
            v185 /*: any*/ ,
            v186 /*: any*/ ,
            v39 /*: any*/ ,
            v187 /*: any*/ ,
            v49 /*: any*/ ,
            v188 /*: any*/ 
        ]
    }, v190 = [
        "scope"
    ], v191 = {
        "kind": "Variable",
        "name": "__dynamicKey",
        "variableName": "dynamicSearchKey"
    }, v192 = [
        "issueSearchInput"
    ], v193 = [
        v66 /*: any*/ ,
        v67 /*: any*/ ,
        v69 /*: any*/ ,
        v42 /*: any*/ ,
        v29 /*: any*/ ,
        v70 /*: any*/ ,
        v72 /*: any*/ ,
        v30 /*: any*/ ,
        v31 /*: any*/ 
    ], v194 = {
        "kind": "ScalarField",
        "name": "fieldType"
    }, v195 = {
        "kind": "LinkedField",
        "name": "fieldValue",
        "plural": false,
        "selections": [
            v32 /*: any*/ ,
            v55 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraPriority",
                        "kind": "LinkedField",
                        "name": "priority",
                        "plural": false,
                        "selections": [
                            v35 /*: any*/ ,
                            v174 /*: any*/ ,
                            v64 /*: any*/ ,
                            v122 /*: any*/ 
                        ]
                    },
                    v54 /*: any*/ 
                ],
                "type": "JiraJqlPriorityFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v32 /*: any*/ ,
                            v35 /*: any*/ ,
                            v130 /*: any*/ ,
                            v64 /*: any*/ ,
                            v128 /*: any*/ 
                        ]
                    },
                    v54 /*: any*/ 
                ],
                "type": "JiraJqlUserFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": [
                            v35 /*: any*/ ,
                            v64 /*: any*/ ,
                            v120 /*: any*/ 
                        ]
                    },
                    v54 /*: any*/ ,
                    v81 /*: any*/ 
                ],
                "type": "JiraJqlStatusFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v138 /*: any*/ 
                ],
                "type": "JiraJqlNumberFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "option",
                        "plural": false,
                        "selections": [
                            v35 /*: any*/ ,
                            v142 /*: any*/ ,
                            v58 /*: any*/ ,
                            v113 /*: any*/ 
                        ]
                    },
                    v54 /*: any*/ 
                ],
                "type": "JiraJqlOptionFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraSprint",
                        "kind": "LinkedField",
                        "name": "sprint",
                        "plural": false,
                        "selections": v126 /*: any*/ 
                    },
                    v54 /*: any*/ 
                ],
                "type": "JiraJqlSprintFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraLabel",
                        "kind": "LinkedField",
                        "name": "label",
                        "plural": false,
                        "selections": v114 /*: any*/ 
                    }
                ],
                "type": "JiraJqlLabelFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraGroup",
                        "kind": "LinkedField",
                        "name": "group",
                        "plural": false,
                        "selections": [
                            v35 /*: any*/ ,
                            v165 /*: any*/ ,
                            v64 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraJqlGroupFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraVersion",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            v35 /*: any*/ ,
                            v153 /*: any*/ ,
                            v64 /*: any*/ 
                        ]
                    },
                    v54 /*: any*/ 
                ],
                "type": "JiraJqlVersionFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v54 /*: any*/ ,
                    {
                        "concreteType": "JiraGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                            v157 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "score"
                            },
                            v35 /*: any*/ ,
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    v75 /*: any*/ ,
                                    v64 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraJqlGoalsFieldValue"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraTownsquareProject",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": [
                                    v35 /*: any*/ ,
                                    v75 /*: any*/ ,
                                    v159 /*: any*/ ,
                                    v160 /*: any*/ ,
                                    v64 /*: any*/ ,
                                    v161 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlTownsquareProjectFieldValue"
                    }
                ]
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "issueTypes",
                        "plural": true,
                        "selections": [
                            v64 /*: any*/ ,
                            v88 /*: any*/ ,
                            v35 /*: any*/ ,
                            v119 /*: any*/ ,
                            v77 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraJqlIssueTypeFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v54 /*: any*/ ,
                    {
                        "concreteType": "JiraResolution",
                        "kind": "LinkedField",
                        "name": "resolution",
                        "plural": false,
                        "selections": [
                            v35 /*: any*/ ,
                            v64 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraJqlResolutionFieldValue"
            }
        ]
    }, v196 = {
        "kind": "ScalarField",
        "name": "issueCount"
    }, v197 = {
        "kind": "Variable",
        "name": "viewConfigInput",
        "variableName": "viewConfigInput"
    }, v198 = [
        v68 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        v36 /*: any*/ ,
        v31 /*: any*/ ,
        v197 /*: any*/ 
    ], v199 = {
        "args": v193 /*: any*/ ,
        "concreteType": "JiraSpreadsheetGroupConnection",
        "kind": "LinkedField",
        "name": "groups",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraSpreadsheetGroupEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    v74 /*: any*/ ,
                    {
                        "concreteType": "JiraSpreadsheetGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v32 /*: any*/ ,
                            v35 /*: any*/ ,
                            v39 /*: any*/ ,
                            v44 /*: any*/ ,
                            v194 /*: any*/ ,
                            v38 /*: any*/ ,
                            v195 /*: any*/ ,
                            v196 /*: any*/ 
                        ]
                    },
                    v32 /*: any*/ 
                ]
            },
            v179 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "groupByField"
            },
            v39 /*: any*/ ,
            {
                "concreteType": "QueryError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": v34 /*: any*/ 
            },
            {
                "condition": "isPaginating",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "JiraSpreadsheetGroup",
                        "kind": "LinkedField",
                        "name": "firstGroup",
                        "plural": false,
                        "selections": [
                            v35 /*: any*/ ,
                            {
                                "args": v198 /*: any*/ ,
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "issues",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            v32 /*: any*/ ,
                                            v74 /*: any*/ ,
                                            {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v32 /*: any*/ ,
                                                    v35 /*: any*/ ,
                                                    v76 /*: any*/ ,
                                                    v75 /*: any*/ ,
                                                    v78 /*: any*/ ,
                                                    v79 /*: any*/ ,
                                                    v83 /*: any*/ ,
                                                    v85 /*: any*/ ,
                                                    v86 /*: any*/ 
                                                ]
                                            },
                                            {
                                                "args": v90 /*: any*/ ,
                                                "concreteType": "JiraIssueFieldSetConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldSets",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldSetEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueFieldSet",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v53 /*: any*/ ,
                                                                    v38 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraIssueFieldConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "fields",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v52 /*: any*/ ,
                                                                            {
                                                                                "concreteType": "JiraIssueFieldEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v35 /*: any*/ ,
                                                                                            v32 /*: any*/ ,
                                                                                            v44 /*: any*/ ,
                                                                                            v53 /*: any*/ ,
                                                                                            v91 /*: any*/ ,
                                                                                            v92 /*: any*/ ,
                                                                                            v96 /*: any*/ ,
                                                                                            v98 /*: any*/ ,
                                                                                            v102 /*: any*/ ,
                                                                                            v105 /*: any*/ ,
                                                                                            v106 /*: any*/ ,
                                                                                            v107 /*: any*/ ,
                                                                                            v108 /*: any*/ ,
                                                                                            v110 /*: any*/ ,
                                                                                            v111 /*: any*/ ,
                                                                                            v112 /*: any*/ ,
                                                                                            v115 /*: any*/ ,
                                                                                            v116 /*: any*/ ,
                                                                                            v121 /*: any*/ ,
                                                                                            v123 /*: any*/ ,
                                                                                            v124 /*: any*/ ,
                                                                                            v125 /*: any*/ ,
                                                                                            v127 /*: any*/ ,
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    v64 /*: any*/ ,
                                                                                                    {
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "user",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            v32 /*: any*/ ,
                                                                                                            v64 /*: any*/ ,
                                                                                                            v128 /*: any*/ ,
                                                                                                            v129 /*: any*/ ,
                                                                                                            v35 /*: any*/ ,
                                                                                                            v130 /*: any*/ ,
                                                                                                            v133 /*: any*/ ,
                                                                                                            v134 /*: any*/ 
                                                                                                        ]
                                                                                                    },
                                                                                                    v104 /*: any*/ ,
                                                                                                    v95 /*: any*/ 
                                                                                                ],
                                                                                                "type": "JiraSingleSelectUserPickerField"
                                                                                            },
                                                                                            v135 /*: any*/ ,
                                                                                            v136 /*: any*/ ,
                                                                                            v137 /*: any*/ ,
                                                                                            v139 /*: any*/ ,
                                                                                            v140 /*: any*/ ,
                                                                                            v141 /*: any*/ ,
                                                                                            v143 /*: any*/ ,
                                                                                            v144 /*: any*/ ,
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    v64 /*: any*/ ,
                                                                                                    {
                                                                                                        "concreteType": "JiraOptionConnection",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "selectedOptions",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "concreteType": "JiraOptionEdge",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "edges",
                                                                                                                "plural": true,
                                                                                                                "selections": [
                                                                                                                    v145 /*: any*/ 
                                                                                                                ]
                                                                                                            }
                                                                                                        ]
                                                                                                    },
                                                                                                    v95 /*: any*/ 
                                                                                                ],
                                                                                                "type": "JiraCheckboxesField"
                                                                                            },
                                                                                            v146 /*: any*/ ,
                                                                                            v147 /*: any*/ ,
                                                                                            v150 /*: any*/ ,
                                                                                            v151 /*: any*/ ,
                                                                                            v152 /*: any*/ ,
                                                                                            v154 /*: any*/ ,
                                                                                            v158 /*: any*/ ,
                                                                                            v162 /*: any*/ ,
                                                                                            v164 /*: any*/ ,
                                                                                            v166 /*: any*/ ,
                                                                                            v167 /*: any*/ ,
                                                                                            v168 /*: any*/ ,
                                                                                            v173 /*: any*/ ,
                                                                                            v49 /*: any*/ 
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldSets(first:500)"
                                            },
                                            v49 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            v177 /*: any*/ ,
                                            v178 /*: any*/ 
                                        ]
                                    },
                                    v185 /*: any*/ ,
                                    v187 /*: any*/ ,
                                    v49 /*: any*/ 
                                ]
                            },
                            {
                                "args": v198 /*: any*/ ,
                                "filters": [
                                    "viewConfigInput",
                                    "fieldSetsInput",
                                    "scope",
                                    "settings"
                                ],
                                "handle": "connection",
                                "key": "firstGroupSection_nativeIssueTable__issues",
                                "kind": "LinkedHandle",
                                "name": "issues"
                            },
                            v39 /*: any*/ ,
                            v44 /*: any*/ ,
                            v194 /*: any*/ ,
                            v38 /*: any*/ ,
                            v195 /*: any*/ ,
                            v196 /*: any*/ 
                        ]
                    }
                ]
            },
            v49 /*: any*/ 
        ]
    }, v200 = [
        v66 /*: any*/ ,
        v67 /*: any*/ ,
        v68 /*: any*/ ,
        v69 /*: any*/ ,
        v29 /*: any*/ ,
        v70 /*: any*/ ,
        v71 /*: any*/ ,
        v72 /*: any*/ ,
        v30 /*: any*/ ,
        v31 /*: any*/ ,
        v197 /*: any*/ 
    ], v201 = {
        "args": v200 /*: any*/ ,
        "concreteType": "JiraIssueConnection",
        "kind": "LinkedField",
        "name": "issues",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    v74 /*: any*/ ,
                    v89 /*: any*/ ,
                    v32 /*: any*/ ,
                    v176 /*: any*/ ,
                    {
                        "condition": "shouldQueryHasChildren",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "filterByProjectKeys",
                                        "variableName": "projectKeys"
                                    }
                                ],
                                "kind": "ScalarField",
                                "name": "hasChildren"
                            },
                            {
                                "args": [
                                    v28 /*: any*/ 
                                ],
                                "kind": "ScalarField",
                                "name": "canHaveChildIssues"
                            }
                        ]
                    },
                    v49 /*: any*/ 
                ]
            },
            v179 /*: any*/ ,
            v180 /*: any*/ ,
            v184 /*: any*/ ,
            v185 /*: any*/ ,
            v186 /*: any*/ ,
            v39 /*: any*/ ,
            v187 /*: any*/ ,
            v49 /*: any*/ ,
            v188 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v25 /*: any*/ ,
                v26 /*: any*/ ,
                v27 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueNavigatorIssueSearchRefetchQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isConditionalFormattingEnabled",
                            "variableName": "isConditionalFormattingEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isSavedViewConditionalFormattingEnabled",
                            "variableName": "isSavedViewConditionalFormattingEnabled"
                        },
                        v28 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "projectKeys",
                            "variableName": "projectKeys"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_refetchQuery"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v25 /*: any*/ ,
                v26 /*: any*/ ,
                v27 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueNavigatorIssueSearchRefetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "filterId",
                                    "variableName": "filterId"
                                },
                                v29 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "jiraViewQueryInput",
                                    "variableName": "jiraViewQueryInput"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "namespace",
                                    "variableName": "namespace"
                                },
                                v30 /*: any*/ ,
                                v31 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "viewConfigInput",
                                    "variableName": "staticViewInput"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "viewId",
                                    "variableName": "viewId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "jiraIssueSearchView",
                            "plural": false,
                            "selections": [
                                v32 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraView"
                                },
                                {
                                    "concreteType": "QueryError",
                                    "kind": "LinkedField",
                                    "name": "error",
                                    "plural": false,
                                    "selections": v34 /*: any*/ 
                                },
                                v35 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "viewId"
                                        },
                                        {
                                            "args": v37 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraFieldSetPreferences",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetPreferences",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isFrozen"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                v39 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canPublishViewConfig"
                                                },
                                                v40 /*: any*/ ,
                                                v41 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v43 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                            "kind": "LinkedField",
                                                            "name": "viewSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                v45 /*: any*/ ,
                                                                v46 /*: any*/ ,
                                                                v47 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSpreadsheetView",
                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                },
                                                v49 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                v40 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "JiraIssueSearchViewMetadata",
                                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v43 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                            "kind": "LinkedField",
                                            "name": "viewSettings",
                                            "plural": false,
                                            "selections": [
                                                v50 /*: any*/ ,
                                                v51 /*: any*/ ,
                                                v45 /*: any*/ ,
                                                v47 /*: any*/ ,
                                                v46 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": [
                                                        v36 /*: any*/ 
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "hasDefaultFieldSets"
                                                },
                                                {
                                                    "args": v37 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v52 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraFieldSetPreferences",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetPreferences",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "width"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v53 /*: any*/ ,
                                                                        v54 /*: any*/ ,
                                                                        v55 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isSortable"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldType",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v54 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "aliases"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldsMetadata",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueSearchMetadataField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "canBeConfigured"
                                                                                                        },
                                                                                                        v44 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ClientExtension",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isPlaceHolderField"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v49 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v41 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v43 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                            "kind": "LinkedField",
                                                            "name": "viewSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                v47 /*: any*/ ,
                                                                v56 /*: any*/ ,
                                                                v50 /*: any*/ ,
                                                                v51 /*: any*/ ,
                                                                v46 /*: any*/ ,
                                                                v45 /*: any*/ ,
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canEnableReranking"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "args": v57 /*: any*/ ,
                                                                    "concreteType": "JiraFormattingRuleConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "conditionalFormattingRules",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraFormattingRuleEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraFormattingRule",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "expression",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v32 /*: any*/ ,
                                                                                                        v59 /*: any*/ ,
                                                                                                        v60 /*: any*/ ,
                                                                                                        v61 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v62 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraColor",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "formattingColor",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        v63 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v35 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "conditionalFormattingRules(first:20)"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSpreadsheetView",
                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                },
                                                v49 /*: any*/ 
                                            ],
                                            "type": "JiraIssueSearchViewMetadata",
                                            "abstractKey": "__isJiraIssueSearchViewMetadata"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v39 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "filterId"
                                                        },
                                                        {
                                                            "args": v43 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                            "kind": "LinkedField",
                                                            "name": "viewSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSpreadsheetGroupByConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "groupByConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraField",
                                                                            "kind": "LinkedField",
                                                                            "name": "groupByField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v64 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "typeKey"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSpreadsheetView",
                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                }
                                            ],
                                            "type": "JiraView",
                                            "abstractKey": "__isJiraView"
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v43 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                                    "kind": "LinkedField",
                                                    "name": "viewSettings",
                                                    "plural": false,
                                                    "selections": [
                                                        v56 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isSavedViewConditionalFormattingEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                v40 /*: any*/ ,
                                                {
                                                    "args": v57 /*: any*/ ,
                                                    "concreteType": "JiraFormattingRuleConnection",
                                                    "kind": "LinkedField",
                                                    "name": "conditionalFormattingRules",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraFormattingRuleEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraFormattingRule",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v35 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "expression",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v32 /*: any*/ ,
                                                                                v60 /*: any*/ ,
                                                                                v59 /*: any*/ ,
                                                                                v61 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraColor",
                                                                            "kind": "LinkedField",
                                                                            "name": "formattingColor",
                                                                            "plural": false,
                                                                            "selections": v65 /*: any*/ 
                                                                        },
                                                                        v62 /*: any*/ 
                                                                    ]
                                                                },
                                                                v32 /*: any*/ 
                                                            ]
                                                        },
                                                        v49 /*: any*/ 
                                                    ],
                                                    "storageKey": "conditionalFormattingRules(first:20)"
                                                },
                                                v49 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "JiraSpreadsheetView",
                                    "abstractKey": "__isJiraSpreadsheetView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                v189 /*: any*/ ,
                                                {
                                                    "args": v73 /*: any*/ ,
                                                    "filters": v190 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "IssueNavigatorJiraDetailedViewPagination__issues",
                                                    "kind": "LinkedHandle",
                                                    "name": "issues",
                                                    "dynamicKey": v191 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                v189 /*: any*/ ,
                                                {
                                                    "args": v73 /*: any*/ ,
                                                    "filters": v192 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "IssueNavigatorDetailedViewPagination__issues",
                                                    "kind": "LinkedHandle",
                                                    "name": "issues"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraDetailedView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                v199 /*: any*/ ,
                                                {
                                                    "args": v193 /*: any*/ ,
                                                    "filters": v190 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "IssueNavigatorJiraGroupedListViewPagination__groups",
                                                    "kind": "LinkedHandle",
                                                    "name": "groups",
                                                    "dynamicKey": v191 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                v199 /*: any*/ ,
                                                {
                                                    "args": v193 /*: any*/ ,
                                                    "filters": v192 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "IssueNavigatorGroupedListViewPagination__groups",
                                                    "kind": "LinkedHandle",
                                                    "name": "groups"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraGroupedListView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                v201 /*: any*/ ,
                                                {
                                                    "args": v200 /*: any*/ ,
                                                    "filters": v190 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "IssueNavigatorJiraListViewPagination__issues",
                                                    "kind": "LinkedHandle",
                                                    "name": "issues",
                                                    "dynamicKey": v191 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                v201 /*: any*/ ,
                                                {
                                                    "args": v200 /*: any*/ ,
                                                    "filters": v192 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "IssueNavigatorListViewPagination__issues",
                                                    "kind": "LinkedHandle",
                                                    "name": "issues"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraListView"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6fc49fdfba24f923eb3361d369f22bbf6456628966c87e44feefb073f7c87cf1",
            "metadata": {},
            "name": "IssueNavigatorIssueSearchRefetchQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "isLastUsedJqlEnabled": (0, $hA9n6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider": (0, $hA9n6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider": (0, $iiQfx.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx": (0, $lcRgI.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider": (0, $cqxuo.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider": (0, $eylLg.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider": (0, $cqnj8.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": (0, $8Qoc7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider": (0, $alrjx.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $kmr3r.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider": (0, $dexoz.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": (0, $l6otE.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": (0, $evjHZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": (0, $j2Uha.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $ad5K7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": (0, $04qit.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": (0, $6AioA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": (0, $1fipb.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider": (0, $cIDJo.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider": (0, $4GS9O.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider": (0, $8jq8m.default)
            }
        }
    };
}();
$f12c48543311749c$var$node.hash = "890906db4f5f0af8b4eb588379287a51";
var $f12c48543311749c$export$2e2bcd8739ae039 = $f12c48543311749c$var$node;

});


parcelRegister("lqJlp", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ceb4ed1827fb255$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2b80360d82ba779babaf36b26f7d81fc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7ceb4ed1827fb255$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isSavedViewConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigator_issueQuery",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isSavedViewConditionalFormattingEnabled",
                    "variableName": "isSavedViewConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                }
            ],
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueNavigator_refetchQuery"
        }
    ],
    "type": "Query"
};
$7ceb4ed1827fb255$var$node.hash = "3f42d45c043c603d1bcd96cba39f6a30";
var $7ceb4ed1827fb255$export$2e2bcd8739ae039 = $7ceb4ed1827fb255$var$node;

});

parcelRegister("grUFB", function(module, exports) {
$parcel$export(module.exports, "default", () => $235a1987ad12063d$export$2e2bcd8739ae039);
/* CmpCurrencyFormattingFlag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $5CSKW = parcelRequire("5CSKW");
var $Ay1uj = parcelRequire("Ay1uj");

var $806LH = parcelRequire("806LH");

var $6zhpo = parcelRequire("6zhpo");

var $fceQU = parcelRequire("fceQU");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $hkAXe = parcelRequire("hkAXe");

var $edFwB = parcelRequire("edFwB");

var $83DiZ = parcelRequire("83DiZ");

var $cSXp8 = parcelRequire("cSXp8");

var $5V25X = parcelRequire("5V25X");

var $85YEc = parcelRequire("85YEc");
const $235a1987ad12063d$var$EVENT_ID = 'jira-cmp-currency-field-changeboarding-trigger-id';
const $235a1987ad12063d$var$emitMessageEvent = (eventDetails)=>{
    const event = new CustomEvent($235a1987ad12063d$var$EVENT_ID, {
        detail: eventDetails
    });
    (0, $fceQU.getDocument)()?.dispatchEvent(event);
};
const $235a1987ad12063d$var$styles = {
    container: "_2rkolb4i _1bsb1mjv _bfhk1bhr _16qs1nax",
    content: "_ca0qpxbi _n3tdpxbi _19bvpxbi _u5f3pxbi",
    illustrationBackground: "_kqswh2mm",
    illustrationCoins: "_kqswstnw _t9ec1ooe _154i1ssb _1ltv1ssb _1pbykb7n"
};
const $235a1987ad12063d$var$CmpCurrencyFormattingFlag = ({ OpenSidebarButton: OpenSidebarButton })=>{
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const { showFlag: showFlag, dismissFlag: dismissFlag, hasFlag: hasFlag } = (0, $cSXp8.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [portalTarget, setPortalTarget] = (0, $eJOHy.useState)(null);
    const { isActive: isActive } = (0, $5V25X.useTrigger)($235a1987ad12063d$var$EVENT_ID);
    const handleShowMe = (0, $eJOHy.useCallback)(()=>{
        $235a1987ad12063d$var$emitMessageEvent({
            action: 'show-me'
        });
        push('/jira/settings/issues/fields?sidebarId=create&sidebarView=currency');
        dismissFlag($235a1987ad12063d$var$EVENT_ID);
    }, [
        dismissFlag,
        push
    ]);
    const handleDismiss = (0, $eJOHy.useCallback)(()=>{
        dismissFlag($235a1987ad12063d$var$EVENT_ID);
    }, [
        dismissFlag
    ]);
    const ShowMeButton = (0, $eJOHy.useCallback)(()=>OpenSidebarButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(OpenSidebarButton, {
            message: (0, $85YEc.default).showMe,
            eventId: $235a1987ad12063d$var$EVENT_ID,
            emitMessageEvent: $235a1987ad12063d$var$emitMessageEvent
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
            onClick: handleShowMe,
            appearance: "primary"
        }, formatMessage((0, $85YEc.default).showMe)), [
        OpenSidebarButton,
        formatMessage,
        handleShowMe
    ]);
    const ButtonStack = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ShowMeButton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        onClick: handleDismiss
    }, formatMessage((0, $85YEc.default).dismiss)));
    (0, $eJOHy.useEffect)(()=>{
        if (!hasFlag?.($235a1987ad12063d$var$EVENT_ID) && isActive && (0, $4cTDP.fg)('frontier-currency-field-d3')) showFlag({
            id: $235a1987ad12063d$var$EVENT_ID,
            messageId: 'cmp-currency-field-changeboarding.ui.components.show-flag.flag.show-flag',
            messageType: 'engagement',
            isAutoDismiss: false,
            render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($235a1987ad12063d$export$5e29d51274b0816c, {
                    onButtonContainerRender: (element)=>setPortalTarget(element),
                    onDismiss: handleDismiss
                })
        });
    }, [
        ShowMeButton,
        handleDismiss,
        handleShowMe,
        hasFlag,
        isActive,
        showFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, portalTarget && /*#__PURE__*/ (0, $aQK2r.createPortal)(ButtonStack, portalTarget));
};
const $235a1987ad12063d$export$5e29d51274b0816c = ({ onDismiss: onDismiss, onButtonContainerRender: onButtonContainerRender })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        xcss: $235a1987ad12063d$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        label: formatMessage((0, $85YEc.default).dismiss),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))),
        appearance: "subtle",
        onClick: onDismiss
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $235a1987ad12063d$var$styles.illustrationBackground
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hkAXe.default), {
        height: 126,
        width: 300,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $235a1987ad12063d$var$styles.illustrationCoins
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $edFwB.default), {
        height: 126,
        width: 200,
        alt: ""
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.200",
        xcss: $235a1987ad12063d$var$styles.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "small"
    }, formatMessage((0, $85YEc.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $85YEc.default).body, {
        b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                as: "strong"
            }, chunks)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.100",
        ref: (element)=>onButtonContainerRender(element)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null))));
};
var $235a1987ad12063d$export$2e2bcd8739ae039 = $235a1987ad12063d$var$CmpCurrencyFormattingFlag;

});
parcelRegister("hkAXe", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d74ffe904d74af6$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $iqMJK = parcelRequire("iqMJK");

var $gXvcY = parcelRequire("gXvcY");
const $5d74ffe904d74af6$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($gXvcY)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($iqMJK))
});
var $5d74ffe904d74af6$export$2e2bcd8739ae039 = $5d74ffe904d74af6$var$Illustration;
// for advanced use only
const $5d74ffe904d74af6$export$a179c88182cb9d56 = [
    0,
    0,
    960,
    540
];

});
parcelRegister("iqMJK", function(module, exports) {
module.exports = new URL("ambient-background-abstract-darkmode.972afcd9.svg", import.meta.url).toString();

});

parcelRegister("gXvcY", function(module, exports) {
module.exports = new URL("ambient-background-abstract.e16193e6.svg", import.meta.url).toString();

});


parcelRegister("edFwB", function(module, exports) {
$parcel$export(module.exports, "default", () => $429501f59e496d6a$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $fHjua = parcelRequire("fHjua");

var $78W7K = parcelRequire("78W7K");
const $429501f59e496d6a$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($78W7K)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($fHjua))
});
var $429501f59e496d6a$export$2e2bcd8739ae039 = $429501f59e496d6a$var$Illustration;
// for advanced use only
const $429501f59e496d6a$export$a179c88182cb9d56 = [
    0,
    0,
    275,
    275
];

});
parcelRegister("fHjua", function(module, exports) {
module.exports = new URL("coins-flat-darkmode.46361372.svg", import.meta.url).toString();

});

parcelRegister("78W7K", function(module, exports) {
module.exports = new URL("coins-flat.4191ca5b.svg", import.meta.url).toString();

});


parcelRegister("85YEc", function(module, exports) {
$parcel$export(module.exports, "default", () => $0712f5a316b4804e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0712f5a316b4804e$var$messages = (0, $7qGN1.defineMessages)({
    showMe: {
        "id": "cmp-currency-field-changeboarding-flag.show-me",
        "defaultMessage": "Show me"
    },
    dismiss: {
        "id": "cmp-currency-formatting-changeboarding-flag.dismiss",
        "defaultMessage": "Dismiss"
    },
    heading: {
        "id": "cmp-currency-formatting-changeboarding-flag.heading",
        "defaultMessage": "Currency and percentage formats"
    },
    body: {
        "id": "cmp-currency-formatting-changeboarding-flag.body",
        "defaultMessage": "You can now format a number field to show a currency ($) or percentage (%) to help track your team's budgets and spending."
    }
});
var $0712f5a316b4804e$export$2e2bcd8739ae039 = $0712f5a316b4804e$var$messages;

});


parcelRegister("gHKwt", function(module, exports) {
$parcel$export(module.exports, "SidebarContainer", () => $e04239c887251cad$export$f39f3f768bc98e3d);
$parcel$export(module.exports, "useSidebar", () => $e04239c887251cad$export$54c70f22f548bff8);
$parcel$export(module.exports, "useSidebarActions", () => $e04239c887251cad$export$685a45ff9d61633f);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $ftN6c = parcelRequire("ftN6c");


var $gRiLa = parcelRequire("gRiLa");
const $e04239c887251cad$export$dbc37fcbd226eb52 = (0, $6E16M.createContainer)();
const $e04239c887251cad$export$f39f3f768bc98e3d = ({ children: children, scope: scope, sidebarId: sidebarId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e04239c887251cad$export$dbc37fcbd226eb52, {
        scope: scope,
        sidebarId: sidebarId,
        createAnalyticsEvent: createAnalyticsEvent
    }, children);
};
const $e04239c887251cad$var$Store = (0, $GtRbT.createStore)({
    name: (0, $e8c1aaa176754652$export$cd79d01fb3d2f506),
    containedBy: $e04239c887251cad$export$dbc37fcbd226eb52,
    initialState: {
        id: null,
        content: null
    },
    actions: $gRiLa.actions
});
const $e04239c887251cad$export$54c70f22f548bff8 = (0, $iJq0l.createHook)($e04239c887251cad$var$Store);
const $e04239c887251cad$export$685a45ff9d61633f = (0, $iJq0l.createActionsHook)($e04239c887251cad$var$Store);

});
const $e8c1aaa176754652$export$cd79d01fb3d2f506 = 'JiraPlatformSidebarStore';
const $e8c1aaa176754652$export$b8b9d90f9e5bd72b = 'jiraPlatformSidebar';

parcelRegister("gRiLa", function(module, exports) {
$parcel$export(module.exports, "actions", () => $c346f43c05bbe3c6$export$e324594224ef24da);

var $kRgKj = parcelRequire("kRgKj");

var $eSnSE = parcelRequire("eSnSE");
const $c346f43c05bbe3c6$var$fireSidebarAnalytics = (experienceId, analyticsProps, eventType)=>{
    const { sidebarId: sidebarId, createAnalyticsEvent: createAnalyticsEvent } = analyticsProps;
    const sidebarLocationId = `jira${sidebarId}SidebarExperience`;
    try {
        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), `${sidebarLocationId} ${eventType}`, {
            experienceId: experienceId
        });
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraPlatformSidebar', error instanceof Error ? error.message : `Error firing analytics event for sidebar with id ${sidebarId}`);
    }
};
const $c346f43c05bbe3c6$var$fireStartSidebarAnalytics = (experienceId, analyticsProps)=>{
    $c346f43c05bbe3c6$var$fireSidebarAnalytics(experienceId, analyticsProps, 'started');
};
const $c346f43c05bbe3c6$var$fireCloseSidebarAnalytics = (experienceId, analyticsProps)=>{
    $c346f43c05bbe3c6$var$fireSidebarAnalytics(experienceId, analyticsProps, 'ended');
};
const $c346f43c05bbe3c6$var$setExperienceId = (id)=>({ setState: setState, getState: getState }, analyticsProps)=>{
        const state = getState();
        const newState = {
            id: id,
            content: null
        };
        const newId = newState.id;
        const previousId = state.id;
        if (analyticsProps.sidebarId) {
            $c346f43c05bbe3c6$var$fireStartSidebarAnalytics(newId, analyticsProps);
            if (previousId != null) $c346f43c05bbe3c6$var$fireCloseSidebarAnalytics(previousId, analyticsProps);
        }
        setState({
            ...state,
            ...newState
        });
    };
const $c346f43c05bbe3c6$var$closeSidebar = ()=>({ setState: setState, getState: getState }, analyticsProps)=>{
        const state = getState();
        const newState = {
            id: null,
            content: null
        };
        if (analyticsProps.sidebarId && state.id) $c346f43c05bbe3c6$var$fireCloseSidebarAnalytics(state.id, analyticsProps);
        setState({
            ...state,
            ...newState
        });
    };
const $c346f43c05bbe3c6$var$setStaticSidebarContent = (id, content)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            content: content,
            id: id
        });
    };
const $c346f43c05bbe3c6$export$e324594224ef24da = {
    setExperienceId: $c346f43c05bbe3c6$var$setExperienceId,
    closeSidebar: $c346f43c05bbe3c6$var$closeSidebar,
    setStaticSidebarContent: $c346f43c05bbe3c6$var$setStaticSidebarContent
};

});


parcelRegister("l8Ydr", function(module, exports) {
$parcel$export(module.exports, "ConditionalFormatting", () => $992f817aa72576bf$export$6d44d4a22d5bca7a);

var $i8ctm = parcelRequire("i8ctm");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $dQ1Tp = parcelRequire("dQ1Tp");
const $992f817aa72576bf$export$e0edc1ee012e4c7e = ({ project: project, children: children })=>{
    const projectData = (0, $j4oe4.useFragment)((0, $i8ctm.default), project);
    if (projectData?.key != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dQ1Tp.MaybeMemoConditionalFormattingEntryPointProvider), {
        project: projectData,
        projectKey: projectData.key
    }, children);
    return children;
};
const $992f817aa72576bf$export$6d44d4a22d5bca7a = ({ isEnabled: isEnabled, ...rest })=>{
    if (isEnabled && (0, $4cTDP.fg)('jira_list_conditional_formatting')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($992f817aa72576bf$export$e0edc1ee012e4c7e, rest);
    return rest.children;
};

});
parcelRegister("i8ctm", function(module, exports) {
$parcel$export(module.exports, "default", () => $00d2db43507fe8dd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7b637ffcb0e08eddc4ae6c6ce804392c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $00d2db43507fe8dd$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }
    ],
    "kind": "Fragment",
    "name": "container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                }
            ],
            "kind": "FragmentSpread",
            "name": "entrypointContext_issueNavigatorActionConditionalFormatting_ConditionalFormattingEntrypointProvider"
        }
    ],
    "type": "JiraProject"
};
$00d2db43507fe8dd$var$node.hash = "5fb1babc3ffe013540ee86e7cec73956";
var $00d2db43507fe8dd$export$2e2bcd8739ae039 = $00d2db43507fe8dd$var$node;

});

parcelRegister("dQ1Tp", function(module, exports) {
$parcel$export(module.exports, "MaybeMemoConditionalFormattingEntryPointProvider", () => $858a3a21e9efe6f6$export$bb104d692666a581);
$parcel$export(module.exports, "useConditionalFormattingEntryPoint", () => $858a3a21e9efe6f6$export$4dc7c6c366f5d2ba);

var $e7vh8 = parcelRequire("e7vh8");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $cSmYj = parcelRequire("cSmYj");

var $j4oe4 = parcelRequire("j4oe4");

var $LFmXM = parcelRequire("LFmXM");

var $f2JN3 = parcelRequire("f2JN3");

var $iWvkh = parcelRequire("iWvkh");

var $4cTDP = parcelRequire("4cTDP");

var $cHtIB = parcelRequire("cHtIB");

var $7IX73 = parcelRequire("7IX73");

var $glYyE = parcelRequire("glYyE");
const $858a3a21e9efe6f6$var$defaultEntrypointActions = {
    cancelPreload: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    load: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    preload: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    unload: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
const $858a3a21e9efe6f6$export$561daba77e18236 = (0, $LFmXM.default)((0, $7IX73.serialiseJql), (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj))));
const $858a3a21e9efe6f6$var$ConditionalFormattingEntryPointContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    getEntryPointActions: ()=>$858a3a21e9efe6f6$var$defaultEntrypointActions,
    entryPointReferenceSubject: {
        getValue: ()=>null,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        subscribe: ()=>()=>{}
    }
});
const $858a3a21e9efe6f6$export$ea15b2e6192c5d4b = ({ children: children, project: project, projectKey: // Passing key instead of extracting from fragment to not need to handle null case
projectKey })=>{
    const projectData = (0, $j4oe4.useFragment)((0, $e7vh8.default), project);
    const hydrateJql = (0, $eJOHy.useMemo)(()=>{
        const formattingRulesByProject = projectData?.conditionalFormattingRules;
        if (!formattingRulesByProject) return '';
        if ((projectData?.conditionalFormattingRules.edges?.length ?? 0) === 0) return '';
        const rulesJqlInput = {};
        formattingRulesByProject.edges?.forEach((edge)=>{
            const rule = edge?.node;
            if (rule == null) return;
            let fieldId = null;
            let value;
            switch(rule.expression.__typename){
                case 'JiraFormattingSingleValueOperand':
                    ({ value: value, fieldId: fieldId } = rule.expression);
                    break;
                case 'JiraFormattingMultipleValueOperand':
                    value = rule.expression.values;
                    fieldId = rule.expression.fieldId;
                    break;
                case 'JiraFormattingNoValueOperand':
                    fieldId = rule.expression.fieldId;
                    break;
                default:
                    break;
            }
            if (fieldId == null) return;
            // input to serialise jql input
            const DUMMY_VALUE = '-';
            if (!rulesJqlInput[fieldId]) rulesJqlInput[fieldId] = [];
            const values = Array.isArray(value) ? value : [
                value
            ];
            values.forEach((ruleValue)=>{
                if (fieldId) rulesJqlInput[fieldId]?.push({
                    value: ruleValue ?? DUMMY_VALUE,
                    label: ruleValue ?? DUMMY_VALUE
                });
            });
        });
        const jql = (0, $4cTDP.fg)('jira_list_conditional_formatting_memo_serialized') ? $858a3a21e9efe6f6$export$561daba77e18236(rulesJqlInput) : (0, $7IX73.serialiseJql)(rulesJqlInput);
        if (jql !== '') return `project = '${projectKey}' AND ${jql}`;
        return '';
    }, [
        projectData?.conditionalFormattingRules,
        projectKey
    ]);
    const cloudId = (0, $cHtIB.useCloudId)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $glYyE.conditionalFormattingSidebarEntryPoint), {
        projectKey: projectKey,
        cloudId: cloudId,
        hydrateJql: hydrateJql
    });
    const entryPointActionsRef = (0, $eJOHy.useRef)(entryPointActions);
    (0, $eJOHy.useEffect)(()=>{
        entryPointActionsRef.current = entryPointActions;
    }, [
        entryPointActions
    ]);
    const getEntryPointActions = (0, $eJOHy.useCallback)(()=>{
        return entryPointActionsRef.current;
    }, []);
    const value = (0, $eJOHy.useMemo)(()=>({
            entryPointReferenceSubject: entryPointReferenceSubject,
            getEntryPointActions: getEntryPointActions
        }), [
        entryPointReferenceSubject,
        getEntryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($858a3a21e9efe6f6$var$ConditionalFormattingEntryPointContext.Provider, {
        value: value
    }, children);
};
const $858a3a21e9efe6f6$var$MemoConditionalFormattingEntrypointProvider = /*#__PURE__*/ (0, $eJOHy.memo)($858a3a21e9efe6f6$export$ea15b2e6192c5d4b);
const $858a3a21e9efe6f6$export$bb104d692666a581 = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('jira_list_conditional_formatting_memo_serialized'), $858a3a21e9efe6f6$var$MemoConditionalFormattingEntrypointProvider, $858a3a21e9efe6f6$export$ea15b2e6192c5d4b);
const $858a3a21e9efe6f6$export$4dc7c6c366f5d2ba = ()=>(0, $eJOHy.useContext)($858a3a21e9efe6f6$var$ConditionalFormattingEntryPointContext);

});
parcelRegister("e7vh8", function(module, exports) {
$parcel$export(module.exports, "default", () => $76f26c9f13913c9f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<763d7e9510b79b6e949e27a32d6a46d0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $76f26c9f13913c9f$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "first"
            }
        ],
        "kind": "Fragment",
        "name": "entrypointContext_issueNavigatorActionConditionalFormatting_ConditionalFormattingEntrypointProvider",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "first"
                    }
                ],
                "concreteType": "JiraFormattingRuleConnection",
                "kind": "LinkedField",
                "name": "conditionalFormattingRules",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraFormattingRuleEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraFormattingRule",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "expression",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "value"
                                                    }
                                                ],
                                                "type": "JiraFormattingSingleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "values"
                                                    }
                                                ],
                                                "type": "JiraFormattingMultipleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ 
                                                ],
                                                "type": "JiraFormattingNoValueOperand"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraProject"
    };
}();
$76f26c9f13913c9f$var$node.hash = "31a078cda2cbef262e87df8f16169099";
var $76f26c9f13913c9f$export$2e2bcd8739ae039 = $76f26c9f13913c9f$var$node;

});

parcelRegister("7IX73", function(module, exports) {
$parcel$export(module.exports, "serialiseJql", () => $cbb24f8df5864967$export$e1718e1e441cb0f6);
$parcel$export(module.exports, "extractAnalyticsFilterDataFromJQL", () => $cbb24f8df5864967$export$9ee6085825c9cbfa);

var $8dH3d = parcelRequire("8dH3d");

var $9yn2r = parcelRequire("9yn2r");

var $8RQlO = parcelRequire("8RQlO");

var $bUEDu = parcelRequire("bUEDu");

var $f26C8 = parcelRequire("f26C8");
var $jPlb3 = parcelRequire("jPlb3");
var $1jiqw = parcelRequire("1jiqw");

var $d7m1k = parcelRequire("d7m1k");
const $cbb24f8df5864967$var$START_DATE_JQL = 'Start date[Date]';
const $cbb24f8df5864967$var$EMPTY = 'EMPTY';
const $cbb24f8df5864967$var$getQuotedFieldName = (fieldName)=>`"${fieldName}"`;
const $cbb24f8df5864967$var$getFieldNameForJqlRaw = (fieldName)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    if (fieldName.indexOf('customfield_') === 0) {
        const customFieldId = fieldName.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
    // the "to" fieldName for the date range will be transformed to "due" in the "serialiseJql" function
    // where "const toFieldName = fieldId === 'dateRange' ? 'due' : fieldName;"
    if (fieldName === 'dateRange') return $cbb24f8df5864967$var$START_DATE_JQL;
    return fieldName;
};
const $cbb24f8df5864967$var$getFieldNameForJql = (fieldName)=>$cbb24f8df5864967$var$getQuotedFieldName($cbb24f8df5864967$var$getFieldNameForJqlRaw(fieldName));
const $cbb24f8df5864967$var$getFieldIdFromJql = (rawFieldName, getShouldConvertCustomField)=>{
    const fieldName = (0, (/*@__PURE__*/$parcel$interopDefault($9yn2r)))(rawFieldName, '"');
    const shouldConvertCustomField = getShouldConvertCustomField ? getShouldConvertCustomField(fieldName) : true;
    // `cf[id]` -> `customfield_${id}`.
    if (fieldName.indexOf('cf[') === 0 && shouldConvertCustomField) {
        const extraction = new RegExp(/cf\[(.+)\]/).exec(fieldName);
        if (!extraction) return fieldName;
        const fieldId = extraction[1];
        return `customfield_${fieldId}`;
    }
    const startDateJql = $cbb24f8df5864967$var$START_DATE_JQL;
    // update this if we add a start date or due date filter
    if (fieldName === startDateJql || fieldName === 'due') return 'dateRange';
    return fieldName;
};
const $cbb24f8df5864967$var$sanitizeWord = (word)=>word.replace(/(["\\])/g, '\\$1');
const $cbb24f8df5864967$var$sanitizeWordOld = (word)=>word.replace(/'/g, "\\'");
const $cbb24f8df5864967$export$e1718e1e441cb0f6 = (filters)=>{
    const jqlQuery = (0, $f26C8.default).query();
    Object.entries(filters).filter(([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(options.value)))).forEach(([fieldId, options])=>{
        const fieldName = $cbb24f8df5864967$var$getFieldNameForJqlRaw(fieldId);
        if (!Array.isArray(options) && typeof options === 'object' && !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(options?.value)) {
            // one additional day will be added to jql 'to' date based on selected date, e.g. when due date is "2021-12-30"
            // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
            const toFieldName = fieldId === 'dateRange' ? 'due' : fieldName;
            if (options.value.to != null) {
                const toDate = (0, $bUEDu.default)((0, $8RQlO.default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
                jqlQuery.appendClause((0, $f26C8.default).terminalClause((0, $f26C8.default).field(toFieldName), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_LT)), (0, $f26C8.default).valueOperand(toDate)), (0, $f6415dda43b7f459$export$6d6d48d210d3ca97));
            }
            if (options.value.from != null) jqlQuery.appendClause((0, $f26C8.default).terminalClause((0, $f26C8.default).field(fieldName), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_GT_EQUALS)), (0, $f26C8.default).valueOperand(options.value.from)), (0, $f6415dda43b7f459$export$6d6d48d210d3ca97));
            return;
        }
        if (Array.isArray(options)) {
            const operands = options.map((option)=>{
                if (option.isEmptyOption) return (0, $f26C8.default).valueOperand((0, $862dfd240457f00b$export$1c46dca02aac24dd));
                if (option.value) // Currently, the AST does not sanatize all values correctly (no \ or JQL keywords), so we need to manually wrap in quotes
                // We can remove this once https://jplat.jira.atlassian.cloud/browse/EM-6563 is implemented
                return (0, $f26C8.default).byText.valueOperand(`"${$cbb24f8df5864967$var$sanitizeWord(option.value)}"`);
                return null;
            }).filter((operand)=>operand != null);
            if (operands.length === 1) jqlQuery.appendClause((0, $f26C8.default).terminalClause((0, $f26C8.default).field(fieldName), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_EQUALS)), operands[0]), (0, $f6415dda43b7f459$export$6d6d48d210d3ca97));
            else if (operands.length > 1) jqlQuery.appendClause((0, $f26C8.default).terminalClause((0, $f26C8.default).field(fieldName), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_IN)), (0, $f26C8.default).listOperand(operands)), (0, $f6415dda43b7f459$export$6d6d48d210d3ca97));
        }
    });
    const jast = (0, $f26C8.default).jast(jqlQuery);
    return (0, $1jiqw.print)(jast, {
        operatorCase: 'upper',
        printWidth: null
    });
};
const $cbb24f8df5864967$export$5bd6a523f48a18cd = (filters)=>{
    const pairs = Object.entries(filters).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(options.value)))) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map(([fieldId, options])=>{
        const fieldName = $cbb24f8df5864967$var$getFieldNameForJql(fieldId);
        if (!Array.isArray(options) && typeof options === 'object' && !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(options?.value)) {
            // one additional day will be added to jql 'to' date based on selected date, e.g. when due date is "2021-12-30"
            // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
            const toFieldName = fieldId === 'dateRange' ? $cbb24f8df5864967$var$getQuotedFieldName('due') : fieldName;
            let toDate;
            if (options.value.to) toDate = (0, $bUEDu.default)((0, $8RQlO.default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
            else toDate = options.value.to;
            if (options.value.from != null && options.value.to != null) return `${fieldName} >= ${options.value.from} AND ${toFieldName} < ${toDate}`;
            if (options.value.from != null) return `${fieldName} >= ${options.value.from}`;
            return `${toFieldName} < ${toDate}`;
        }
        if (Array.isArray(options)) {
            const values = options.map((option)=>// make sure we don't wrap EMPTY with quotation marks
                option.value === (0, $d7m1k.EMPTY_FILTER_VALUE) ? $cbb24f8df5864967$var$EMPTY : `'${$cbb24f8df5864967$var$sanitizeWordOld(option.value)}'`).join(',');
            if (options.length > 1) return `${fieldName} in (${values})`;
            if (options.length === 1) return `${fieldName} = ${values}`;
        }
        return null;
    });
    return pairs.join(' AND ');
};
const $cbb24f8df5864967$var$extractField = (statement)=>{
    let fieldId;
    const dateOperatorRegex = />=|</;
    if (dateOperatorRegex.test(statement)) {
        const operator = statement.includes('>=') ? ' >= ' : ' < ';
        [fieldId] = statement.split(operator);
    }
    if (statement.includes(' = ')) [fieldId] = statement.split(/ = /);
    if (statement.includes(' in ')) [fieldId] = statement.split(' in ');
    if (fieldId) return $cbb24f8df5864967$var$getFieldIdFromJql(fieldId);
};
const $cbb24f8df5864967$export$9ee6085825c9cbfa = (jql)=>{
    if (!jql) return {};
    return jql.split(/ AND | OR /).map($cbb24f8df5864967$var$extractField).reduce((acc, curr)=>{
        if (curr) acc[curr] = true;
        return acc;
    }, {});
};

});
parcelRegister("9yn2r", function(module, exports) {

var $wkcOI = parcelRequire("wkcOI");

var $d1tIC = parcelRequire("d1tIC");

var $j4Djm = parcelRequire("j4Djm");

var $goN3t = parcelRequire("goN3t");

var $8KovM = parcelRequire("8KovM");

var $gsm7J = parcelRequire("gsm7J");

var $cz1WF = parcelRequire("cz1WF");
/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */ function $6f4928facf5fd86d$var$trim(string, chars, guard) {
    string = $cz1WF(string);
    if (string && (guard || chars === undefined)) return $d1tIC(string);
    if (!string || !(chars = $wkcOI(chars))) return string;
    var strSymbols = $gsm7J(string), chrSymbols = $gsm7J(chars), start = $8KovM(strSymbols, chrSymbols), end = $goN3t(strSymbols, chrSymbols) + 1;
    return $j4Djm(strSymbols, start, end).join('');
}
module.exports = $6f4928facf5fd86d$var$trim;

});
parcelRegister("goN3t", function(module, exports) {

var $kEE3x = parcelRequire("kEE3x");
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */ function $bf04f089e91d946a$var$charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;
    while(index-- && $kEE3x(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $bf04f089e91d946a$var$charsEndIndex;

});

parcelRegister("8KovM", function(module, exports) {

var $kEE3x = parcelRequire("kEE3x");
/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */ function $65e5a21662e297d6$var$charsStartIndex(strSymbols, chrSymbols) {
    var index = -1, length = strSymbols.length;
    while(++index < length && $kEE3x(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $65e5a21662e297d6$var$charsStartIndex;

});


const $f6415dda43b7f459$export$6d6d48d210d3ca97 = 'and';
const $f6415dda43b7f459$export$7b8f0a728d79a753 = 'or';

const $862dfd240457f00b$export$38accfc5a5d1c113 = 'value';
const $862dfd240457f00b$export$f6049126fd97001f = 'keyword';
const $862dfd240457f00b$export$19c7c729db381f9d = 'function';
const $862dfd240457f00b$export$fabec4aebba3f4df = 'list';
const $862dfd240457f00b$export$1c46dca02aac24dd = 'empty';

parcelRegister("d7m1k", function(module, exports) {
$parcel$export(module.exports, "OPTIMISTIC_ID", () => $6e5c1ccb850ad968$export$6e40821019289c70);
$parcel$export(module.exports, "CREATE_FILTER_EXPERIENCE", () => $6e5c1ccb850ad968$export$d6ceedee35ae2c19);
$parcel$export(module.exports, "UPDATE_FILTER_EXPERIENCE", () => $6e5c1ccb850ad968$export$ca3691ea47eec823);
$parcel$export(module.exports, "DELETE_FILTER_EXPERIENCE", () => $6e5c1ccb850ad968$export$2a5fce320f18ac6c);
$parcel$export(module.exports, "STAR_FILTER_EXPERIENCE", () => $6e5c1ccb850ad968$export$b0ec8deb6068dc3b);
$parcel$export(module.exports, "SAVED_FILTER_EXPERIENCE", () => $6e5c1ccb850ad968$export$6c99c87a0ac0052a);
$parcel$export(module.exports, "EMPTY_FILTER_VALUE", () => $6e5c1ccb850ad968$export$9ebaf9fe814731d3);
$parcel$export(module.exports, "SIMPLE_SEARCH_PARAM", () => $6e5c1ccb850ad968$export$9b72011e2eb8d7d0);
const $6e5c1ccb850ad968$export$b8b9d90f9e5bd72b = 'jiraBusinessFilters';
const $6e5c1ccb850ad968$export$6e40821019289c70 = 'optimistic-filter-id';
const $6e5c1ccb850ad968$export$d6ceedee35ae2c19 = {
    experience: 'filtersCreateSavedFilters',
    packageName: $6e5c1ccb850ad968$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $6e5c1ccb850ad968$export$ca3691ea47eec823 = {
    experience: 'filtersUpdateSavedFilters',
    packageName: $6e5c1ccb850ad968$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $6e5c1ccb850ad968$export$2a5fce320f18ac6c = {
    experience: 'filtersDeleteSavedFilters',
    packageName: $6e5c1ccb850ad968$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $6e5c1ccb850ad968$export$b0ec8deb6068dc3b = {
    experience: 'filtersStarSavedFilters',
    packageName: $6e5c1ccb850ad968$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $6e5c1ccb850ad968$export$6c99c87a0ac0052a = {
    experience: 'filtersLoadSavedFilters',
    packageName: $6e5c1ccb850ad968$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $6e5c1ccb850ad968$export$9ebaf9fe814731d3 = null;
const $6e5c1ccb850ad968$export$9b72011e2eb8d7d0 = 'text';

});


parcelRegister("glYyE", function(module, exports) {
$parcel$export(module.exports, "conditionalFormattingSidebarEntryPoint", () => $59b5375152cbfeaa$export$99130db9e4ffd320);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $hGsHT = parcelRequire("hGsHT");

var $cJ1x4 = parcelRequire("cJ1x4");

const $59b5375152cbfeaa$export$99130db9e4ffd320 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("gkP69")), {
        moduleId: "3a70fb0d",
        priority: "interaction"
    }),
    getPreloadProps: ({ projectKey: projectKey, cloudId: cloudId, hydrateJql: hydrateJql })=>({
            queries: {
                listViewFormattingRulesQuery: {
                    parameters: (0, $cJ1x4.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: 20
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                },
                listViewFormattingRulesHydrateJqlQuery: {
                    parameters: (0, $hGsHT.default),
                    variables: {
                        cloudId: cloudId,
                        jql: hydrateJql
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("hGsHT", function(module, exports) {
$parcel$export(module.exports, "default", () => $80c9509a0ade3d5f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cf2a5937304c56bb7549189c31072c6d>>
 * @relayHash d8a8efd1cb47ad24fa1b3fa450a8af48
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 906d5c6c7bc5f1968ae4fdf299101b0f46b453ffda598a4e8bb0b8df1ecba23a
const $80c9509a0ade3d5f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "jql"
        }
    ], v4 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = [
        v8 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RuleListOldHydrateJqlQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v3 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "hydrateJqlQuery",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "FieldValueDataOld_query"
                                                        }
                                                    ],
                                                    "type": "JiraJqlHydratedQuery"
                                                },
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.jqlBuilder.hydrateJqlQuery"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RuleListOldHydrateJqlQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "hydrateJqlQuery",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraJqlField",
                                                                    "kind": "LinkedField",
                                                                    "name": "field",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "values",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "values",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v5 /*: any*/ ,
                                                                                        v6 /*: any*/ ,
                                                                                        v7 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v5 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "accountId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlUserFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "priorityId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlPriorityFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprint",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "sprint",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "sprintId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlSprintFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraGroup",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "group",
                                                                                                    "plural": false,
                                                                                                    "selections": v9 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlGroupFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "statusId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlStatusFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "projectId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlProjectFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueTypes",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "issueTypeId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraVersion",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "version",
                                                                                                    "plural": false,
                                                                                                    "selections": v9 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlVersionFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraComponent",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "component",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "componentId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlComponentFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "option",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "optionId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlOptionFieldValue"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraJqlQueryHydratedValue"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlQueryHydratedField"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlHydratedQuery"
                                        },
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "906d5c6c7bc5f1968ae4fdf299101b0f46b453ffda598a4e8bb0b8df1ecba23a",
            "metadata": {},
            "name": "RuleListOldHydrateJqlQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$80c9509a0ade3d5f$var$node.hash = "36901797867bdd80222eaa66a102d160";
var $80c9509a0ade3d5f$export$2e2bcd8739ae039 = $80c9509a0ade3d5f$var$node;

});

parcelRegister("cJ1x4", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff952cd915d9d5f0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<858f41d1580c23f32193e36a49d2af40>>
 * @relayHash 6626bf83d450628f75fb33f1947114a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f910d48577b9ef4ff80ae056284b71da3a925be565e0dac64fd7ad9797080692
const $ff952cd915d9d5f0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v8 = [
        v7 /*: any*/ 
    ], v9 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RuleListOldQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "args": v5 /*: any*/ ,
                                            "concreteType": "JiraFormattingRuleConnection",
                                            "kind": "LinkedField",
                                            "name": "conditionalFormattingRules",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFormattingRuleEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraFormattingRule",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "expression",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v8 /*: any*/ ,
                                                                            "type": "JiraFormattingMultipleValueOperand"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v8 /*: any*/ ,
                                                                            "type": "JiraFormattingSingleValueOperand"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v8 /*: any*/ ,
                                                                            "type": "JiraFormattingNoValueOperand"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "FragmentSpread",
                                                                    "name": "RuleItemOld_formatting_rule"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RuleListOldQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "JiraFormattingRuleConnection",
                                    "kind": "LinkedField",
                                    "name": "conditionalFormattingRules",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFormattingRuleEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFormattingRule",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "expression",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "alias": "multipleValueOperator",
                                                                            "kind": "ScalarField",
                                                                            "name": "operator"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "values"
                                                                        }
                                                                    ],
                                                                    "type": "JiraFormattingMultipleValueOperand"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "alias": "singleValueOperator",
                                                                            "kind": "ScalarField",
                                                                            "name": "operator"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "value"
                                                                        }
                                                                    ],
                                                                    "type": "JiraFormattingSingleValueOperand"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "alias": "noValueOperator",
                                                                            "kind": "ScalarField",
                                                                            "name": "operator"
                                                                        }
                                                                    ],
                                                                    "type": "JiraFormattingNoValueOperand"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraColor",
                                                            "kind": "LinkedField",
                                                            "name": "formattingColor",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "colorKey"
                                                                },
                                                                v6 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "formattingArea"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f910d48577b9ef4ff80ae056284b71da3a925be565e0dac64fd7ad9797080692",
            "metadata": {},
            "name": "RuleListOldQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ff952cd915d9d5f0$var$node.hash = "c3dbceccba6d7e1e2300a44caf482a55";
var $ff952cd915d9d5f0$export$2e2bcd8739ae039 = $ff952cd915d9d5f0$var$node;

});

parcelRegister("gkP69", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4pZBy").then(()=>parcelRequire('chwK5'));

});




parcelRegister("a7IKn", function(module, exports) {
$parcel$export(module.exports, "ConditionalFormattingSidebarContainer", () => $13344720a56255db$export$dfaa75aa91cf4532);

var $7ZfbN = parcelRequire("7ZfbN");

var $l18s9 = parcelRequire("l18s9");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $3R3DH = parcelRequire("3R3DH");
const $13344720a56255db$export$dbba6b660a937f11 = ({ project: project, children: children, view: view })=>{
    const projectData = (0, $j4oe4.useFragment)((0, $l18s9.default), project);
    const viewData = (0, $j4oe4.useFragment)((0, $7ZfbN.default), view);
    if (projectData?.key != null && view != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3R3DH.MaybeMemoConditionalFormattingEntryPointProvider), {
        projectKey: projectData.key,
        view: viewData ?? null
    }, children);
    return children;
};
const $13344720a56255db$export$dfaa75aa91cf4532 = ({ isEnabled: isEnabled, ...rest })=>{
    if (// eslint-disable-next-line jira/ff/no-preconditioning
    isEnabled && (0, $4cTDP.fg)('jira_list_conditional_formatting') && (0, $4cTDP.fg)('saved_list_view_technical_changes')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13344720a56255db$export$dbba6b660a937f11, rest);
    return rest.children;
};

});
parcelRegister("7ZfbN", function(module, exports) {
$parcel$export(module.exports, "default", () => $a496c8e7723afab9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<551d57d654a5c092cb6bd1b3897e2951>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a496c8e7723afab9$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }
    ],
    "kind": "Fragment",
    "name": "ConditionalFormattingSidebarContainer_view",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                }
            ],
            "kind": "FragmentSpread",
            "name": "ConditionalFormattingEntrypointProvider_view"
        }
    ],
    "type": "JiraSpreadsheetView",
    "abstractKey": "__isJiraSpreadsheetView"
};
$a496c8e7723afab9$var$node.hash = "3cc3ce39bcd2f953168d8cbd0ff16fef";
var $a496c8e7723afab9$export$2e2bcd8739ae039 = $a496c8e7723afab9$var$node;

});

parcelRegister("l18s9", function(module, exports) {
$parcel$export(module.exports, "default", () => $77d01efccf6ee637$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5fe6c2e179c4b5823712efae74527f95>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $77d01efccf6ee637$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConditionalFormattingSidebarContainer_project",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        }
    ],
    "type": "JiraProject"
};
$77d01efccf6ee637$var$node.hash = "f760c50423ac93ea44e63273b01a0d10";
var $77d01efccf6ee637$export$2e2bcd8739ae039 = $77d01efccf6ee637$var$node;

});

parcelRegister("3R3DH", function(module, exports) {
$parcel$export(module.exports, "MaybeMemoConditionalFormattingEntryPointProvider", () => $79a24181f6b537ef$export$bb104d692666a581);
$parcel$export(module.exports, "useConditionalFormattingEntryPoint", () => $79a24181f6b537ef$export$4dc7c6c366f5d2ba);

var $6BKWY = parcelRequire("6BKWY");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $cSmYj = parcelRequire("cSmYj");

var $j4oe4 = parcelRequire("j4oe4");

var $LFmXM = parcelRequire("LFmXM");

var $f2JN3 = parcelRequire("f2JN3");

var $iWvkh = parcelRequire("iWvkh");

var $4cTDP = parcelRequire("4cTDP");

var $cHtIB = parcelRequire("cHtIB");

var $7IX73 = parcelRequire("7IX73");

var $2htpQ = parcelRequire("2htpQ");
const $79a24181f6b537ef$var$defaultEntrypointActions = {
    cancelPreload: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    load: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    preload: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    unload: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
const $79a24181f6b537ef$export$561daba77e18236 = (0, $LFmXM.default)((0, $7IX73.serialiseJql), (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj))));
const $79a24181f6b537ef$var$ConditionalFormattingEntryPointContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    getEntryPointActions: ()=>$79a24181f6b537ef$var$defaultEntrypointActions,
    entryPointReferenceSubject: {
        getValue: ()=>null,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        subscribe: ()=>()=>{}
    }
});
const $79a24181f6b537ef$export$ea15b2e6192c5d4b = ({ children: children, projectKey: // Passing key instead of extracting from fragment to not need to handle null case
projectKey, view: view })=>{
    const viewData = (0, $j4oe4.useFragment)((0, $6BKWY.default), view);
    const hydrateJql = (0, $eJOHy.useMemo)(()=>{
        const conditionalFormattingRules = viewData?.conditionalFormattingRules;
        if (!conditionalFormattingRules) return '';
        if ((conditionalFormattingRules?.edges?.length ?? 0) === 0) return '';
        const rulesJqlInput = {};
        conditionalFormattingRules.edges?.forEach((edge)=>{
            const rule = edge?.node;
            if (rule == null) return;
            let fieldId = null;
            let value;
            switch(rule.expression.__typename){
                case 'JiraFormattingSingleValueOperand':
                    ({ value: value, fieldId: fieldId } = rule.expression);
                    break;
                case 'JiraFormattingMultipleValueOperand':
                    value = rule.expression.values;
                    fieldId = rule.expression.fieldId;
                    break;
                case 'JiraFormattingNoValueOperand':
                    fieldId = rule.expression.fieldId;
                    break;
                default:
                    break;
            }
            if (fieldId == null) return;
            // input to serialise jql input
            const DUMMY_VALUE = '-';
            if (!rulesJqlInput[fieldId]) rulesJqlInput[fieldId] = [];
            const values = Array.isArray(value) ? value : [
                value
            ];
            values.forEach((ruleValue)=>{
                if (fieldId) rulesJqlInput[fieldId]?.push({
                    value: ruleValue ?? DUMMY_VALUE,
                    label: ruleValue ?? DUMMY_VALUE
                });
            });
        });
        const jql = (0, $4cTDP.fg)('jira_list_conditional_formatting_memo_serialized') ? $79a24181f6b537ef$export$561daba77e18236(rulesJqlInput) : (0, $7IX73.serialiseJql)(rulesJqlInput);
        if (jql !== '') return `project = '${projectKey}' AND ${jql}`;
        return '';
    }, [
        projectKey,
        viewData?.conditionalFormattingRules
    ]);
    const cloudId = (0, $cHtIB.useCloudId)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $2htpQ.formatRulesEntryPoint), {
        cloudId: cloudId,
        hydrateJql: hydrateJql
    });
    const entryPointActionsRef = (0, $eJOHy.useRef)(entryPointActions);
    (0, $eJOHy.useEffect)(()=>{
        entryPointActionsRef.current = entryPointActions;
    }, [
        entryPointActions
    ]);
    const getEntryPointActions = (0, $eJOHy.useCallback)(()=>{
        return entryPointActionsRef.current;
    }, []);
    const value = (0, $eJOHy.useMemo)(()=>({
            entryPointReferenceSubject: entryPointReferenceSubject,
            getEntryPointActions: getEntryPointActions
        }), [
        entryPointReferenceSubject,
        getEntryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($79a24181f6b537ef$var$ConditionalFormattingEntryPointContext.Provider, {
        value: value
    }, children);
};
const $79a24181f6b537ef$var$MemoConditionalFormattingEntrypointProvider = /*#__PURE__*/ (0, $eJOHy.memo)($79a24181f6b537ef$export$ea15b2e6192c5d4b);
const $79a24181f6b537ef$export$bb104d692666a581 = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('jira_list_conditional_formatting_memo_serialized'), $79a24181f6b537ef$var$MemoConditionalFormattingEntrypointProvider, $79a24181f6b537ef$export$ea15b2e6192c5d4b);
const $79a24181f6b537ef$export$4dc7c6c366f5d2ba = ()=>(0, $eJOHy.useContext)($79a24181f6b537ef$var$ConditionalFormattingEntryPointContext);

});
parcelRegister("6BKWY", function(module, exports) {
$parcel$export(module.exports, "default", () => $a72d766bed8e197c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9f078481a5ae4b8568d06c4eb919c8eb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a72d766bed8e197c$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "first"
            }
        ],
        "kind": "Fragment",
        "name": "ConditionalFormattingEntrypointProvider_view",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "first"
                    }
                ],
                "concreteType": "JiraFormattingRuleConnection",
                "kind": "LinkedField",
                "name": "conditionalFormattingRules",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraFormattingRuleEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraFormattingRule",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "expression",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "value"
                                                    }
                                                ],
                                                "type": "JiraFormattingSingleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "values"
                                                    }
                                                ],
                                                "type": "JiraFormattingMultipleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ 
                                                ],
                                                "type": "JiraFormattingNoValueOperand"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraSpreadsheetView",
        "abstractKey": "__isJiraSpreadsheetView"
    };
}();
$a72d766bed8e197c$var$node.hash = "ce53295074ed8f1325839f27eefc3643";
var $a72d766bed8e197c$export$2e2bcd8739ae039 = $a72d766bed8e197c$var$node;

});

parcelRegister("2htpQ", function(module, exports) {
$parcel$export(module.exports, "formatRulesEntryPoint", () => $972985ca0bc81147$export$a812fb5060f92ae9);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $2fCac = parcelRequire("2fCac");

const $972985ca0bc81147$export$a812fb5060f92ae9 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("cmurZ")), {
        moduleId: "9979a94d",
        moduleName: "ConditionalFormattingSidebarApp",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, hydrateJql: hydrateJql })=>{
        return {
            queries: {
                listViewFormattingRulesHydrateJqlQuery: {
                    parameters: (0, $2fCac.default),
                    variables: {
                        cloudId: cloudId,
                        jql: hydrateJql
                    },
                    options: {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("2fCac", function(module, exports) {
$parcel$export(module.exports, "default", () => $caae944ae0231abd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a9dcbfd36cd4494260af60a432128e82>>
 * @relayHash 64bda5fe8f75c33ca5fe4775fbb35f30
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bffe80e7f34e038150f826b8f8ea18b117aece9dc9ebc1ec015a264da87e1275
const $caae944ae0231abd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "jql"
        }
    ], v4 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = [
        v8 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RuleListHydrateJqlQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v3 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "hydrateJqlQuery",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "FieldValueData_query"
                                                        }
                                                    ],
                                                    "type": "JiraJqlHydratedQuery"
                                                },
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.jqlBuilder.hydrateJqlQuery"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RuleListHydrateJqlQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "hydrateJqlQuery",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraJqlField",
                                                                    "kind": "LinkedField",
                                                                    "name": "field",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "values",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "values",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v5 /*: any*/ ,
                                                                                        v6 /*: any*/ ,
                                                                                        v7 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v5 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "accountId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlUserFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "priorityId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlPriorityFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprint",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "sprint",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "sprintId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlSprintFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraGroup",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "group",
                                                                                                    "plural": false,
                                                                                                    "selections": v9 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlGroupFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "statusId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlStatusFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "projectId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlProjectFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueTypes",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "issueTypeId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraVersion",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "version",
                                                                                                    "plural": false,
                                                                                                    "selections": v9 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlVersionFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraComponent",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "component",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "componentId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlComponentFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "option",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "optionId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlOptionFieldValue"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraJqlQueryHydratedValue"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlQueryHydratedField"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlHydratedQuery"
                                        },
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bffe80e7f34e038150f826b8f8ea18b117aece9dc9ebc1ec015a264da87e1275",
            "metadata": {},
            "name": "RuleListHydrateJqlQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$caae944ae0231abd$var$node.hash = "e75d55566094513eb3a65b01d3642bac";
var $caae944ae0231abd$export$2e2bcd8739ae039 = $caae944ae0231abd$var$node;

});

parcelRegister("cmurZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("krcPB").then(()=>parcelRequire('dugsO'));

});




parcelRegister("61oZD", function(module, exports) {
$parcel$export(module.exports, "useAppContextualAnalyticsActions", () => $e3511e28b01b7a77$export$8aad1a4e4d637906);
$parcel$export(module.exports, "AppContextualAnalytics", () => $e3511e28b01b7a77$export$2942dddca20a92ac);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $kGj4V = parcelRequire("kGj4V");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $e3511e28b01b7a77$var$Container = (0, $6E16M.createContainer)();
const $e3511e28b01b7a77$var$Store = (0, $GtRbT.createStore)({
    name: 'AppContextualAnalyticsStore',
    containedBy: $e3511e28b01b7a77$var$Container,
    initialState: {
        issueNavigatorSearchSessionId: undefined
    },
    actions: {
        onJourneyStart: ()=>({ setState: setState })=>{
                const issueNavigatorSearchSessionId = (0, $aXKmr.v4)();
                setState({
                    issueNavigatorSearchSessionId: issueNavigatorSearchSessionId
                });
                return {
                    issueNavigatorSearchSessionId: issueNavigatorSearchSessionId
                };
            }
    }
});
const $e3511e28b01b7a77$export$e1e7a4797df1a656 = (0, $iJq0l.createHook)($e3511e28b01b7a77$var$Store, {
    selector: (state)=>state.issueNavigatorSearchSessionId
});
const $e3511e28b01b7a77$export$8aad1a4e4d637906 = (0, $iJq0l.createActionsHook)($e3511e28b01b7a77$var$Store);
const $e3511e28b01b7a77$var$AppContextualAnalyticsData = ({ children: children })=>{
    const [issueNavigatorSearchSessionId] = $e3511e28b01b7a77$export$e1e7a4797df1a656();
    const attributes = (0, $eJOHy.useMemo)(()=>({
            issueNavigatorSearchSessionId: issueNavigatorSearchSessionId
        }), [
        issueNavigatorSearchSessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: "issueNavigator",
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        attributes: attributes
    }, children);
};
const $e3511e28b01b7a77$export$2942dddca20a92ac = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e3511e28b01b7a77$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e3511e28b01b7a77$var$AppContextualAnalyticsData, null, children));

});
// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("fwKw5", function(module, exports) {
$parcel$export(module.exports, "useActiveJql", () => $09ad01b3dea0b6f0$export$caeaf867313163e4);
$parcel$export(module.exports, "ActiveJqlProvider", () => $09ad01b3dea0b6f0$export$c69a9a3114157ae7);
$parcel$export(module.exports, "useResolvedJql", () => $09ad01b3dea0b6f0$export$23e17984875d36b4);

var $eJOHy = parcelRequire("eJOHy");

var $b5RwB = parcelRequire("b5RwB");

var $82cqT = parcelRequire("82cqT");

var $bJscI = parcelRequire("bJscI");
const $09ad01b3dea0b6f0$var$ActiveJqlContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    jql: ''
});
$09ad01b3dea0b6f0$var$ActiveJqlContext.displayName = 'ActiveJqlContext';
const $09ad01b3dea0b6f0$export$caeaf867313163e4 = ()=>(0, $eJOHy.useContext)($09ad01b3dea0b6f0$var$ActiveJqlContext);
const $09ad01b3dea0b6f0$var$ActiveJqlProviderNonMemo = ({ initialJql: initialJql, jql: jql, filterId: filterId, isFilterEditable: isFilterEditable, filterJql: filterJql, children: children })=>{
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            initialJql: initialJql,
            jql: jql,
            filterId: filterId,
            isFilterEditable: isFilterEditable,
            filterJql: filterJql
        }), [
        initialJql,
        jql,
        filterId,
        isFilterEditable,
        filterJql
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($09ad01b3dea0b6f0$var$ActiveJqlContext.Provider, {
        value: contextValue
    }, children);
};
const $09ad01b3dea0b6f0$export$c69a9a3114157ae7 = (0, $bJscI.componentWithFG)('jira_nin_last_used_jql_tech_changes', /*#__PURE__*/ (0, $eJOHy.memo)($09ad01b3dea0b6f0$var$ActiveJqlProviderNonMemo), $09ad01b3dea0b6f0$var$ActiveJqlProviderNonMemo);
const $09ad01b3dea0b6f0$export$23e17984875d36b4 = ()=>{
    const { jql: jql, filterJql: filterJql } = $09ad01b3dea0b6f0$export$caeaf867313163e4();
    const filter = filterJql !== undefined ? filterJql : '';
    return jql !== undefined ? jql : filter;
};
const $09ad01b3dea0b6f0$export$5d3c8489d1ae8bee = ()=>{
    const { filterId: filterId, jql: jql } = $09ad01b3dea0b6f0$export$caeaf867313163e4();
    return `/issues/?${(0, $b5RwB.stringify)({
        jql: jql,
        ...(0, $82cqT.isFilterId)(filterId) ? {
            filter: filterId
        } : {}
    })}`;
};

});

parcelRegister("cJdYi", function(module, exports) {
$parcel$export(module.exports, "useFilterQuery", () => $5ba88ead355bead9$export$5576614cd48b552);
$parcel$export(module.exports, "FilterQueryProvider", () => $5ba88ead355bead9$export$78b7af8c530bd7a4);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $82cqT = parcelRequire("82cqT");

var $l2h78 = parcelRequire("l2h78");

var $8oKDI = parcelRequire("8oKDI");

var $ftN6c = parcelRequire("ftN6c");

var $f2sjT = parcelRequire("f2sjT");

var $cHtIB = parcelRequire("cHtIB");

var $bJscI = parcelRequire("bJscI");
const $5ba88ead355bead9$var$FilterQueryContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    filterQueryIsFetching: false,
    filterQueryIsNetworkError: false
});
$5ba88ead355bead9$var$FilterQueryContext.displayName = 'FilterQueryContext';
const $5ba88ead355bead9$export$5576614cd48b552 = ()=>(0, $eJOHy.useContext)($5ba88ead355bead9$var$FilterQueryContext);
const $5ba88ead355bead9$var$FilterQueryProviderNonMemo = ({ refetch: refetch, query: query, children: children, filterId: filterId })=>{
    const [filterQueryIsFetching, setFilterQueryIsFetching] = (0, $eJOHy.useState)(false);
    const [filterQueryIsNetworkError, setFilterQueryNetworkError] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const activationId = (0, $f2sjT.useActivationId)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const inFlightRequest = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        if (filterId !== undefined && (0, $82cqT.isFilterId)(filterId)) {
            // Prevent race condition from multiple requests in progress
            // (ex. if user clicks quickly on different filters)
            inFlightRequest.current?.unsubscribe();
            const variables = {
                filterAri: (0, $8oKDI.createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'filter',
                    resourceId: filterId,
                    activationId: activationId
                }),
                includeFilter: true
            };
            setFilterQueryIsFetching(true);
            setFilterQueryNetworkError(false);
            inFlightRequest.current = (0, $j4oe4.fetchQuery)(environment, query, variables, {
                fetchPolicy: 'store-or-network'
            }).subscribe({
                complete: ()=>{
                    // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
                    refetch(variables, {
                        fetchPolicy: 'store-only'
                    });
                    setFilterQueryIsFetching(false);
                },
                error: ()=>{
                    setFilterQueryIsFetching(false);
                    setFilterQueryNetworkError(true);
                }
            });
        } else // Need to refetch when filter is undefined so it reset filterData to empty
        refetch({
            includeFilter: false,
            filterAri: ''
        }, {
            fetchPolicy: 'store-or-network'
        });
    }, [
        activationId,
        cloudId,
        environment,
        filterId,
        query,
        refetch,
        setFilterQueryIsFetching,
        setFilterQueryNetworkError
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (filterId !== undefined && (0, $82cqT.isFilterId)(filterId)) {
            const analyticsEvent = createAnalyticsEvent({});
            (0, $l2h78.addFilterToRecent)(filterId, analyticsEvent);
        }
    }, [
        filterId,
        createAnalyticsEvent
    ]);
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            filterQueryIsFetching: filterQueryIsFetching,
            filterQueryIsNetworkError: filterQueryIsNetworkError
        }), [
        filterQueryIsFetching,
        filterQueryIsNetworkError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5ba88ead355bead9$var$FilterQueryContext.Provider, {
        value: contextValue
    }, children);
};
const $5ba88ead355bead9$export$78b7af8c530bd7a4 = (0, $bJscI.componentWithFG)('jira_nin_last_used_jql_tech_changes', /*#__PURE__*/ (0, $eJOHy.memo)($5ba88ead355bead9$var$FilterQueryProviderNonMemo), $5ba88ead355bead9$var$FilterQueryProviderNonMemo);

});
parcelRegister("l2h78", function(module, exports) {
$parcel$export(module.exports, "addFilterToRecent", () => $a11574fb8c1677f2$export$1f166118234b128e);

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

const $a11574fb8c1677f2$export$1f166118234b128e = async (filterId, analyticsEvent)=>{
    try {
        await (0, $3ugTQ.performPostRequest)((0, $d179eb0ac817e6bb$export$3fdeac1311ebf841) + filterId);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            event: analyticsEvent,
            meta: {
                id: 'addFilterToRecent',
                packageName: 'jiraIssueNavigatorCustomFilters'
            }
        });
    }
};

});
const $d179eb0ac817e6bb$export$3fdeac1311ebf841 = '/rest/issueNav/1/history/saveFilter/';



parcelRegister("1Puj1", function(module, exports) {
$parcel$export(module.exports, "IssueSearch", () => $fe7de2c920d9c496$export$ce2913cefc6e57dc);

var $aosFH = parcelRequire("aosFH");

var $4zA0B = parcelRequire("4zA0B");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $jn1Cb = parcelRequire("jn1Cb");
var $cSXp8 = parcelRequire("cSXp8");

var $4cTDP = parcelRequire("4cTDP");

var $82cqT = parcelRequire("82cqT");

var $cHtIB = parcelRequire("cHtIB");

var $iZsVo = parcelRequire("iZsVo");

var $f2sjT = parcelRequire("f2sjT");

var $kfvK2 = parcelRequire("kfvK2");

var $cxKOj = parcelRequire("cxKOj");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $iRahl = parcelRequire("iRahl");

var $eibCx = parcelRequire("eibCx");

var $fwKw5 = parcelRequire("fwKw5");

var $5Ijz5 = parcelRequire("5Ijz5");

var $4o2sx = parcelRequire("4o2sx");

var $5lUfC = parcelRequire("5lUfC");

var $aaLZH = parcelRequire("aaLZH");

var $jHM2W = parcelRequire("jHM2W");
const $fe7de2c920d9c496$var$useNavigationItemId = (0, $kfvK2.createRouterSelector)((state)=>state.match?.params?.navigationItemId);
const $fe7de2c920d9c496$var$searchErrorFlagId = (0, $jn1Cb.toFlagId)('ISSUE_NAVIGATOR_SEARCH_ERROR_FLAG');
const $fe7de2c920d9c496$var$searchErrorFlag = {
    id: $fe7de2c920d9c496$var$searchErrorFlagId,
    type: 'error',
    title: (0, $jHM2W.default).searchFailedTitle,
    description: (0, $jHM2W.default).searchFailedDescription,
    messageId: `issue-navigator.ui.issue-search.searchErrorFlag.${$fe7de2c920d9c496$var$searchErrorFlagId}`,
    messageType: 'transactional'
};
const $fe7de2c920d9c496$var$isFieldPresentInJql = (query, fieldName)=>{
    const regex = new RegExp(`\\b${fieldName}\\s*(=\\s*[^\\s]+|IN\\s*\\([^\\)]+\\))`, 'i');
    return regex.test(query);
};
const $fe7de2c920d9c496$export$ce2913cefc6e57dc = ({ children: children, onPageDataLoad: onPageDataLoad, refetch: refetch, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, jiraView: jiraView, issueTableProps: issueTableProps, project: project })=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $cSXp8.useFlagsService)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const activationId = (0, $f2sjT.useActivationId)();
    const { jql: jql, filterId: filterId } = (0, $fwKw5.useActiveJql)();
    const issueSearchInput = (0, $eJOHy.useMemo)(()=>jql === undefined && (0, $82cqT.isFilterId)(filterId) ? {
            filterId: filterId
        } : {
            jql: jql
        }, [
        filterId,
        jql
    ]);
    if ((0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
        const isLabelsFieldPresentInJql = $fe7de2c920d9c496$var$isFieldPresentInJql(issueSearchInput?.jql || '', 'labels');
        isLabelsFieldPresentInJql && (0, $kRgKj.fireTrackAnalyticsDeferred)(createAnalyticsEvent({}), 'labelsFilter used');
    }
    const setSelectedView = (0, $5lUfC.useSelectedViewMutation)();
    const viewItemId = (0, $4cTDP.fg)('saved_list_view_technical_changes') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    $fe7de2c920d9c496$var$useNavigationItemId() : undefined;
    const jiraViewData = (0, $j4oe4.useFragment)((0, $4zA0B.default), jiraView);
    const projectData = (0, $j4oe4.useFragment)((0, $aosFH.default), project);
    const groupedByField = jiraViewData?.viewSettings?.groupByConfig?.groupByField?.fieldId ?? null;
    const isGroupingEnabled = Boolean(issueTableProps?.isGroupingSupported) && Boolean(jiraViewData?.viewSettings?.isGroupingEnabled) && Boolean(jiraViewData?.viewSettings?.canEnableGrouping);
    const isHierarchyEnabled = Boolean(isIssueHierarchySupportEnabled && jiraViewData?.viewSettings?.isHierarchyEnabled);
    const isHideDoneEnabled = Boolean(jiraViewData?.viewSettings?.hideDone);
    const maybeViewId = jiraViewData?.viewId;
    const onRefetchStart = (0, $eJOHy.useCallback)(()=>{
        // Hide any search error flags currently visible
        dismissFlag($fe7de2c920d9c496$var$searchErrorFlagId);
    }, [
        dismissFlag
    ]);
    const viewId = (0, $eibCx.parseIssueNavigatorViewIdOrDefault)(maybeViewId);
    const { onIssueSearchFail: onIssueSearchFail } = (0, $5Ijz5.useExperienceAnalytics)(onPageDataLoad, {
        ...isGroupingEnabled ? {
            experienceId: (0, $iRahl.GROUPED_LIST_EXPERIENCE_ID)
        } : {},
        isBifrost: !!(0, $iZsVo.ssr).getFeatureFlags()?.ssrViaBifrost
    });
    const onRefetchError = (0, $eJOHy.useCallback)((error, refetchView)=>{
        onIssueSearchFail(`${(0, $iRahl.PACKAGE_NAME)}.issue-search-refetch`, error, refetchView);
        showFlag($fe7de2c920d9c496$var$searchErrorFlag);
    }, [
        onIssueSearchFail,
        showFlag
    ]);
    const projectContext = issueTableProps?.projectContext;
    const isConditionalFormattingEnabled = (0, $4cTDP.fg)('jira_list_conditional_formatting') && // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $aaLZH.useIssueNavigatorFeatures)().isConditionalFormattingEnabled;
    const isSavedViewConditionalFormattingEnabled = isConditionalFormattingEnabled && (0, $4cTDP.fg)('saved_list_view_technical_changes');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4o2sx.IssueSearchServiceContainer), {
        cloudId: cloudId,
        environment: environment,
        issueSearchInput: issueSearchInput,
        viewId: viewId,
        filterId: filterId,
        onPageDataLoad: onPageDataLoad,
        onRefetchStart: onRefetchStart,
        onRefetchError: onRefetchError,
        onSelectedViewMutation: setSelectedView,
        refetch: refetch,
        projectContext: projectContext,
        isHierarchyEnabled: isHierarchyEnabled,
        isHideDoneEnabled: isHideDoneEnabled,
        groupedByField: groupedByField,
        isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
        isConditionalFormattingEnabled: isConditionalFormattingEnabled,
        isSavedViewConditionalFormattingEnabled: isSavedViewConditionalFormattingEnabled,
        isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
        activationId: activationId,
        projectId: projectData?.projectId,
        viewItemId: viewItemId
    }, children);
};

});
parcelRegister("aosFH", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4f12018b9396b69$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f10a0a888452e171e6262b4e268ff399>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e4f12018b9396b69$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingormergesupportenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "issueSearch_issueNavigatorProject",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingormergesupportenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "projectId"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$e4f12018b9396b69$var$node.hash = "025b324686c2ae9e075431d405c9a7eb";
var $e4f12018b9396b69$export$2e2bcd8739ae039 = $e4f12018b9396b69$var$node;

});

parcelRegister("4zA0B", function(module, exports) {
$parcel$export(module.exports, "default", () => $015034fcef527466$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<47c400dc6eb21c75f18a183597271b22>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $015034fcef527466$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "settings"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "issueSearch_issueNavigatorGrouping",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "viewId"
                }
            ],
            "type": "JiraIssueSearchViewMetadata",
            "abstractKey": "__isJiraIssueSearchViewMetadata"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "settings",
                            "variableName": "settings"
                        },
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isGroupingEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canEnableGrouping"
                        },
                        {
                            "concreteType": "JiraSpreadsheetGroupByConfig",
                            "kind": "LinkedField",
                            "name": "groupByConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraField",
                                    "kind": "LinkedField",
                                    "name": "groupByField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isHierarchyEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hideDone"
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        }
    ],
    "type": "JiraView",
    "abstractKey": "__isJiraView"
};
$015034fcef527466$var$node.hash = "81fbda7b72e3b8d3632b955fb3bccae3";
var $015034fcef527466$export$2e2bcd8739ae039 = $015034fcef527466$var$node;

});

parcelRegister("5Ijz5", function(module, exports) {
$parcel$export(module.exports, "useExperienceAnalytics", () => $df800b8d721dc559$export$523b242362f30838);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $cblKs = parcelRequire("cblKs");

var $lBYgs = parcelRequire("lBYgs");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $2aY2d = parcelRequire("2aY2d");

var $4cTDP = parcelRequire("4cTDP");

var $1BZ8a = parcelRequire("1BZ8a");

var $jiTA8 = parcelRequire("jiTA8");

var $bFY6o = parcelRequire("bFY6o");

var $7wFII = parcelRequire("7wFII");

var $iRahl = parcelRequire("iRahl");
/**
 * This debouncer is shared between both the success and fail calls so that the last one called in the current event
 * loop tick is the one that gets logged. This helps us overcome weaknesses in the Relay-based rendering where an error
 * being thrown taks an additional render cycle to reach the component managing the analytics.
 */ const $df800b8d721dc559$var$sharedDebouncer = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((action)=>action(), 0);
const $df800b8d721dc559$export$523b242362f30838 = (/**
	 * Event emitted when page data has loaded and the key experience is interactive.
	 */ onPageDataLoad, /**
	 * Analytics attributes to be emitted as part of success/fail experience events.
	 */ attributes)=>{
    let analyticsAttributes = attributes;
    const isEmbed = (0, $jiTA8.useIsEmbedMode)();
    analyticsAttributes = {
        ...analyticsAttributes,
        isEmbed: isEmbed
    };
    if ((0, $4cTDP.fg)('improve_nin_slo_events')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data: project } = (0, $2aY2d.useProjectContext)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const appEditions = (0, $1BZ8a.useAppEditions)();
        const application = project?.projectType ? (0, $lBYgs.getApplicationForProject)(project.projectType) : null;
        const edition = application ? (0, $cblKs.getEdition)(application, appEditions) : null;
        analyticsAttributes = {
            ...analyticsAttributes,
            application: application,
            edition: edition
        };
    }
    const onExperienceStart = (0, $8Uqf3.useExperienceStart)({
        experience: (0, $iRahl.EXPERIENCE_NAME),
        experienceId: undefined,
        analyticsSource: (0, $iRahl.ANALYTICS_SOURCE)
    });
    const onExperienceSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: (0, $iRahl.EXPERIENCE_NAME),
        attributes: analyticsAttributes
    });
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $iRahl.EXPERIENCE_NAME),
        attributes: analyticsAttributes
    });
    const onExperienceAbort = (0, $bFY6o.useExperienceAbort)({
        experience: (0, $iRahl.EXPERIENCE_NAME),
        attributes: analyticsAttributes
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onFireUIAnalyticsEvent = (0, $eJOHy.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'screen'
        });
        (0, $kRgKj.fireUIAnalytics)(event, 'issueSearchResults', attributes ?? {});
    }, [
        attributes,
        createAnalyticsEvent
    ]);
    const onIssueSearchSuccess = (0, $eJOHy.useCallback)((view)=>{
        $df800b8d721dc559$var$sharedDebouncer(()=>{
            onExperienceStart();
            onExperienceSuccess();
            onFireUIAnalyticsEvent();
        });
        onPageDataLoad && onPageDataLoad(view);
    }, [
        onExperienceStart,
        onExperienceSuccess,
        onFireUIAnalyticsEvent,
        onPageDataLoad
    ]);
    const onIssueSearchFail = (0, $eJOHy.useCallback)((location, error, view)=>{
        $df800b8d721dc559$var$sharedDebouncer(()=>{
            onExperienceStart();
            if ((0, $7wFII.isAbortableError)(error) && (0, $4cTDP.fg)('improve_abortable_errors_experience_tracker')) {
                onExperienceAbort(location, {
                    errorMessage: error.message,
                    location: location
                });
                return;
            }
            onExperienceFail(location, error);
        });
        onPageDataLoad && onPageDataLoad(view);
    }, [
        onExperienceFail,
        onExperienceAbort,
        onExperienceStart,
        onPageDataLoad
    ]);
    return {
        onIssueSearchSuccess: onIssueSearchSuccess,
        onIssueSearchFail: onIssueSearchFail
    };
};

});

parcelRegister("4o2sx", function(module, exports) {
$parcel$export(module.exports, "LifecycleContext", () => $4b62de4f25567cba$export$8e146b706b53e85a);
$parcel$export(module.exports, "IssueSearchServiceContainer", () => $4b62de4f25567cba$export$3744f0b7d0dd1936);
$parcel$export(module.exports, "Store", () => $4b62de4f25567cba$export$390f32400eaf98c9);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $aXKmr = parcelRequire("aXKmr");

var $fsisP = parcelRequire("fsisP");

var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $4cTDP = parcelRequire("4cTDP");

var $bJscI = parcelRequire("bJscI");

var $38YP1 = parcelRequire("38YP1");
const $4b62de4f25567cba$var$initialState = {
    disposables: [],
    isFetching: false,
    isFetchingView: false,
    isRefreshing: false,
    isNetworkError: false,
    searchKey: '',
    totalIssueCount: null,
    totalIssueCountIsFetching: false,
    totalIssueCountIsError: false,
    inFlightIssueSearchInput: null
};
const $4b62de4f25567cba$var$defaultLifecycleState = {
    isFetching: false,
    isFetchingView: false,
    isRefreshing: false,
    isNetworkError: false,
    searchKey: ''
};
const $4b62de4f25567cba$export$8e146b706b53e85a = /*#__PURE__*/ (0, $eJOHy.createContext)($4b62de4f25567cba$var$defaultLifecycleState);
const $4b62de4f25567cba$var$IssueSearchServiceWithLifecycle = (props)=>{
    const [value, setValue] = (0, $eJOHy.useState)(()=>({
            ...$4b62de4f25567cba$var$defaultLifecycleState,
            searchKey: (0, $aXKmr.v4)()
        }));
    const onLifecycleUpdate = (0, $eJOHy.useCallback)((newValue)=>{
        setValue((prev)=>({
                ...prev,
                ...newValue
            }));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4b62de4f25567cba$export$8e146b706b53e85a.Provider, {
        value: value
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4b62de4f25567cba$var$IssueSearchServiceContainerRSS, {
        ...props,
        onLifecycleUpdate: onLifecycleUpdate
    }));
};
const $4b62de4f25567cba$var$IssueSearchServiceContainerRSS = (0, $6E16M.createContainer)();
const $4b62de4f25567cba$export$3744f0b7d0dd1936 = (0, $bJscI.componentWithFG)('jira_nin_refetch_state_concurrency_fix', /*#__PURE__*/ (0, $eJOHy.memo)($4b62de4f25567cba$var$IssueSearchServiceWithLifecycle), (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4b62de4f25567cba$var$IssueSearchServiceContainerRSS, {
        ...props,
        onLifecycleUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    }));
const $4b62de4f25567cba$export$390f32400eaf98c9 = (0, $GtRbT.createStore)({
    name: 'IssueSearchServiceStore',
    initialState: $4b62de4f25567cba$var$initialState,
    actions: $38YP1.actions,
    containedBy: $4b62de4f25567cba$var$IssueSearchServiceContainerRSS,
    handlers: {
        onInit: ()=>({ setState: setState })=>{
                if (!(0, $4cTDP.fg)('jira_nin_refetch_state_concurrency_fix')) setState({
                    searchKey: (0, $aXKmr.v4)()
                });
            },
        onContainerUpdate: (nextProps, prevProps)=>({ dispatch: dispatch, getState: getState })=>{
                if ((0, $fsisP.isShallowEqual)(nextProps.issueSearchInput, getState().inFlightIssueSearchInput) && (0, $4cTDP.fg)('jira_list_nin_merge_technical_changes')) return;
                if (!(0, $fsisP.isShallowEqual)(nextProps.issueSearchInput, prevProps.issueSearchInput)) dispatch((0, $38YP1.handleSearchInputUpdate)());
            },
        onDestroy: ()=>({ getState: getState })=>{
                const { disposables: disposables } = getState();
                // Dispose of any manually retained operations when the container is unmounted
                disposables.forEach((disposable)=>disposable.dispose());
            }
    }
});

});
parcelRegister("38YP1", function(module, exports) {
$parcel$export(module.exports, "handleSearchInputUpdate", () => $9724564c3e5356c1$export$9c870f2e3983e32a);
$parcel$export(module.exports, "actions", () => $9724564c3e5356c1$export$e324594224ef24da);

var $64DKg = parcelRequire("64DKg");

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");

var $aXKmr = parcelRequire("aXKmr");

var $4cTDP = parcelRequire("4cTDP");

var $82cqT = parcelRequire("82cqT");

var $awWeA = parcelRequire("awWeA");

var $9S9Cb = parcelRequire("9S9Cb");

var $eSK9M = parcelRequire("eSK9M");

var $iRahl = parcelRequire("iRahl");

var $eibCx = parcelRequire("eibCx");

var $48isi = parcelRequire("48isi");
const $9724564c3e5356c1$export$9c870f2e3983e32a = ()=>({ dispatch: dispatch }, { issueSearchInput: issueSearchInput, filterId: filterId, viewId: viewId })=>{
        const shouldLoadWithFilterViewId = viewId !== 'detail' && issueSearchInput.filterId && (0, $82cqT.isCustomFilter)(issueSearchInput.filterId);
        const isCurrentViewIdInvalid = (0, $eibCx.isFilterViewId)(viewId) && viewId !== `list_filter_${filterId}`;
        let variables = {};
        if (issueSearchInput.filterId && shouldLoadWithFilterViewId) {
            const issueNavigatorViewId = (0, $eibCx.convertFilterIdToIssueNavigatorId)(issueSearchInput.filterId);
            variables = {
                viewId: issueNavigatorViewId,
                fieldSetsInput: {
                    viewInput: {
                        namespace: 'ISSUE_NAVIGATOR',
                        viewId: issueNavigatorViewId
                    }
                }
            };
        } else if (isCurrentViewIdInvalid) variables = {
            viewId: (0, $iRahl.DEFAULT_VIEW_ID),
            fieldSetsInput: {
                viewInput: {
                    namespace: 'ISSUE_NAVIGATOR',
                    viewId: (0, $iRahl.DEFAULT_VIEW_ID)
                }
            }
        };
        dispatch($9724564c3e5356c1$export$e324594224ef24da.refetch(variables));
    };
const $9724564c3e5356c1$export$9eb6b63e55022ba0 = ()=>({ setState: setState })=>{
        setState({
            totalIssueCount: null,
            totalIssueCountIsFetching: false,
            totalIssueCountIsError: false
        });
    };
const $9724564c3e5356c1$export$e324594224ef24da = {
    changeView: (viewId)=>({ dispatch: dispatch }, { onSelectedViewMutation: onSelectedViewMutation, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, activationId: activationId, cloudId: cloudId, projectId: projectId, viewItemId: viewItemId, issueSearchInput: issueSearchInput })=>{
            let viewARI = '';
            if ((0, $4cTDP.fg)('saved_list_view_technical_changes') || (0, $4cTDP.fg)('saved_list_view_merge_support')) {
                const layout = viewId === 'detail' ? 'detail' : 'list';
                viewARI = (0, $9S9Cb.createViewAri)({
                    activationId: activationId,
                    cloudId: cloudId,
                    layout: layout,
                    projectId: projectId,
                    viewItemId: viewItemId
                });
            }
            onSelectedViewMutation(viewId, viewARI);
            dispatch($9724564c3e5356c1$export$e324594224ef24da.refetch({
                viewId: viewId,
                fieldSetsInput: {
                    viewInput: {
                        namespace: 'ISSUE_NAVIGATOR',
                        viewId: viewId
                    }
                },
                ...(isIssueHierarchySupportEnabled || (0, $4cTDP.fg)('jsc_hide_done_view_config_fix')) && {
                    viewConfigInput: {
                        viewInput: {
                            namespace: 'ISSUE_NAVIGATOR',
                            viewId: viewId
                        }
                    },
                    shouldQueryHasChildren: isIssueHierarchySupportEnabled ? viewId !== 'detail' : false,
                    staticViewInput: null
                },
                ...(0, $4cTDP.fg)('saved_list_view_technical_changes') || (0, $4cTDP.fg)('saved_list_view_merge_support') ? {
                    settings: {
                        jql: issueSearchInput.jql
                    }
                } : {}
            }));
        },
    resetView: (onResetComplete)=>({ dispatch: dispatch }, { activationId: activationId, cloudId: cloudId, projectId: projectId, viewItemId: viewItemId })=>{
            dispatch($9724564c3e5356c1$export$e324594224ef24da.refetch({
                fieldSetsInput: {
                    viewInput: {
                        namespace: 'ISSUE_NAVIGATOR'
                    }
                },
                settings: null,
                staticViewInput: null,
                viewConfigInput: {
                    staticViewInput: {
                        isGroupingEnabled: null,
                        isHideDoneEnabled: null,
                        isHierarchyEnabled: null
                    }
                },
                jiraViewQueryInput: {
                    viewId: (0, $9S9Cb.createViewAri)({
                        activationId: activationId,
                        cloudId: cloudId,
                        projectId: projectId,
                        viewItemId: viewItemId
                    })
                }
            }, {
                onComplete: ()=>{
                    onResetComplete();
                }
            }));
        },
    changeHierarchy: (nextIsHierarchyEnabled)=>({ dispatch: dispatch }, { isHierarchyEnabled: isHierarchyEnabled, groupedByField: groupedByField, isHideDoneEnabled: isHideDoneEnabled, issueSearchInput: issueSearchInput })=>{
            if (nextIsHierarchyEnabled !== isHierarchyEnabled) {
                const staticViewInput = {
                    isHierarchyEnabled: nextIsHierarchyEnabled,
                    isGroupingEnabled: !!groupedByField,
                    ...(0, $4cTDP.fg)('jsc_list_hide_done_items') ? {
                        isHideDoneEnabled: isHideDoneEnabled
                    } : {}
                };
                const settings = {
                    hideDone: isHideDoneEnabled,
                    hierarchyEnabled: nextIsHierarchyEnabled,
                    groupBy: groupedByField,
                    jql: issueSearchInput.jql
                };
                dispatch($9724564c3e5356c1$export$e324594224ef24da.refetch({
                    staticViewInput: staticViewInput,
                    viewConfigInput: {
                        staticViewInput: staticViewInput
                    },
                    shouldQueryHasChildren: Boolean(nextIsHierarchyEnabled),
                    ...(0, $4cTDP.fg)('saved_list_view_technical_changes') || (0, $4cTDP.fg)('saved_list_view_merge_support') ? {
                        settings: settings
                    } : {}
                }));
            }
        },
    changeGroupedByField: (nextGroupedByField)=>({ dispatch: dispatch }, { isHierarchyEnabled: isHierarchyEnabled, isHideDoneEnabled: isHideDoneEnabled, issueSearchInput: issueSearchInput })=>{
            const staticViewInput = {
                isHierarchyEnabled: isHierarchyEnabled,
                isGroupingEnabled: !!nextGroupedByField,
                ...(0, $4cTDP.fg)('jsc_list_hide_done_items') ? {
                    isHideDoneEnabled: isHideDoneEnabled
                } : {}
            };
            const settings = {
                hideDone: isHideDoneEnabled,
                hierarchyEnabled: isHierarchyEnabled,
                groupBy: nextGroupedByField ?? null,
                jql: issueSearchInput.jql
            };
            dispatch($9724564c3e5356c1$export$e324594224ef24da.refetch({
                groupBy: nextGroupedByField,
                staticViewInput: staticViewInput,
                viewConfigInput: {
                    staticViewInput: staticViewInput
                },
                ...(0, $4cTDP.fg)('saved_list_view_technical_changes') || (0, $4cTDP.fg)('saved_list_view_merge_support') ? {
                    settings: settings
                } : {}
            }));
        },
    // Remove action when cleaning up jira_list_nin_merge_onboarding_modal
    changeGroupedByFieldAndJql: (nextGroupedByField, nextJql)=>({ dispatch: dispatch }, { isHierarchyEnabled: isHierarchyEnabled, isHideDoneEnabled: isHideDoneEnabled, issueSearchInput: issueSearchInput })=>{
            const staticViewInput = {
                isHierarchyEnabled: isHierarchyEnabled,
                isGroupingEnabled: !!nextGroupedByField,
                ...(0, $4cTDP.fg)('jsc_list_hide_done_items') ? {
                    isHideDoneEnabled: isHideDoneEnabled
                } : {}
            };
            const settings = {
                hideDone: isHideDoneEnabled,
                hierarchyEnabled: isHierarchyEnabled,
                groupBy: nextGroupedByField ?? null,
                jql: nextJql ?? issueSearchInput.jql
            };
            dispatch($9724564c3e5356c1$export$e324594224ef24da.refetch({
                groupBy: nextGroupedByField,
                staticViewInput: staticViewInput,
                viewConfigInput: {
                    staticViewInput: staticViewInput
                },
                ...(0, $4cTDP.fg)('saved_list_view_technical_changes') || (0, $4cTDP.fg)('saved_list_view_merge_support') ? {
                    settings: settings
                } : {},
                ...nextJql ? {
                    issueSearchInput: {
                        jql: nextJql
                    }
                } : {}
            }));
        },
    changeHideDone: (nextIsHideDoneEnabled)=>({ dispatch: dispatch }, { isHierarchyEnabled: isHierarchyEnabled, groupedByField: groupedByField, isHideDoneEnabled: isHideDoneEnabled, issueSearchInput: issueSearchInput })=>{
            if (nextIsHideDoneEnabled !== isHideDoneEnabled) {
                const staticViewInput = {
                    isHierarchyEnabled: isHierarchyEnabled,
                    isGroupingEnabled: !!groupedByField,
                    isHideDoneEnabled: nextIsHideDoneEnabled
                };
                const settings = {
                    hideDone: nextIsHideDoneEnabled,
                    hierarchyEnabled: isHierarchyEnabled,
                    groupBy: groupedByField,
                    jql: issueSearchInput.jql
                };
                dispatch($9724564c3e5356c1$export$e324594224ef24da.refetch({
                    staticViewInput: staticViewInput,
                    viewConfigInput: {
                        staticViewInput: staticViewInput
                    },
                    shouldQueryHasChildren: Boolean(isHierarchyEnabled),
                    ...(0, $4cTDP.fg)('saved_list_view_technical_changes') || (0, $4cTDP.fg)('saved_list_view_merge_support') ? {
                        settings: settings
                    } : {}
                }));
            }
        },
    refetch: (variables = {}, options = {})=>({ dispatch: dispatch, getState: getState, setState: setState }, { cloudId: cloudId, environment: environment, issueSearchInput: issueSearchInput, onRefetchStart: onRefetchStart, onRefetchError: onRefetchError, refetch: refetch, viewId: viewId, isHierarchyEnabled: isHierarchyEnabled, isConditionalFormattingEnabled: isConditionalFormattingEnabled, isSavedViewConditionalFormattingEnabled: isSavedViewConditionalFormattingEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, projectContext: projectContext, groupedByField: groupedByField, isHideDoneEnabled: isHideDoneEnabled, activationId: activationId, projectId: projectId, viewItemId: viewItemId, onLifecycleUpdate: onLifecycleUpdate })=>{
            let { inFlightRequest: inFlightRequest } = getState();
            // Some consumers may fire refetch queries before in-flight query
            // has been completed (e.g. while user is toggling columns on and off in
            // the column picker). In these situations, we always want to fetch latest
            // data from the API as column configuration may have changed for the user.
            // To do that, we disable Relay's automatic de-deduping of requests.
            inFlightRequest?.unsubscribe();
            const staticViewInput = {
                isHierarchyEnabled: isHierarchyEnabled,
                isGroupingEnabled: !!groupedByField,
                isHideDoneEnabled: isHideDoneEnabled
            };
            const settings = {
                hideDone: isHideDoneEnabled,
                hierarchyEnabled: isHierarchyEnabled,
                groupBy: groupedByField,
                jql: issueSearchInput.jql
            };
            let operationScope;
            if (isInlineFieldConfigEnabled) operationScope = (0, $awWeA.getOperationScope)(projectContext);
            else if (projectContext) operationScope = (0, $iRahl.NIN_PROJECT_OPERATION_SCOPE);
            else operationScope = (0, $iRahl.NIN_GLOBAL_OPERATION_SCOPE);
            const scope = {
                operationScope: operationScope
            };
            // Behavioural change from IFC. Previously we omitted the project key in embed view - which
            // means default global field sets would be loaded. Now we load field sets configured to the
            // project in both project and embed routes
            if ((0, $4cTDP.fg)('jira_nin_last_used_jql')) scope.projectKey = projectContext ?? null;
            else if (projectContext && isInlineFieldConfigEnabled) scope.projectKey = projectContext ?? null;
            let fieldSetsScope = null;
            if ((0, $4cTDP.fg)('jira_nin_last_used_jql')) fieldSetsScope = {
                operationScope: operationScope,
                projectKey: projectContext ?? null
            };
            else if (isInlineFieldConfigEnabled) fieldSetsScope = {
                operationScope: operationScope,
                projectKey: projectContext
            };
            const finalVariables = {
                cloudId: cloudId,
                issueSearchInput: issueSearchInput,
                first: (0, $iRahl.MAX_ISSUES_PER_PAGE),
                after: null,
                namespace: 'ISSUE_NAVIGATOR',
                viewId: viewId,
                options: null,
                shouldQueryHasChildren: isHierarchyEnabled || false,
                fieldSetsInput: {
                    viewInput: {
                        namespace: 'ISSUE_NAVIGATOR',
                        viewId: viewId
                    }
                },
                amountOfColumns: (0, $iRahl.MAX_AMOUNT_OF_COLUMNS),
                ...(0, $4cTDP.fg)('jsc_nin_operation_scope_fe') && {
                    scope: scope
                },
                filterId: null,
                staticViewInput: staticViewInput,
                viewConfigInput: {
                    staticViewInput: staticViewInput
                },
                ...(0, $4cTDP.fg)('saved_list_view_technical_changes') || (0, $4cTDP.fg)('saved_list_view_merge_support') ? {
                    settings: settings
                } : {},
                groupBy: groupedByField,
                isPaginating: false,
                projectKeys: projectContext ? [
                    projectContext
                ] : null,
                projectKey: projectContext ?? null,
                isConditionalFormattingEnabled: isConditionalFormattingEnabled,
                isSavedViewConditionalFormattingEnabled: isSavedViewConditionalFormattingEnabled,
                fieldSetsScope: fieldSetsScope,
                /*
      This key is used to generate a unique identity for the issue connection record in the Relay store when running a
      new search. This is to prevent concurrency related bugs occurring when performing a refetch that returns a new
      connection of results. Ordinarily this would be handled automatically when relevant query variables change (as
      these are used to form the connection key), however we override the default connection filters which allows us
      to modify variables during pagination operations without producing a new connection key.
       */ dynamicSearchKey: (0, $4cTDP.fg)('jira_nin_last_used_jql') ? (0, $aXKmr.v4)() : null,
                ...(0, $4cTDP.fg)('jira_nin_last_used_jql') ? {
                    saveJQLToUserHistory: true,
                    isLastUsedJqlEnabled: true
                } : {
                    saveJQLToUserHistory: false,
                    isLastUsedJqlEnabled: false
                },
                ...variables
            };
            if (finalVariables.jiraViewQueryInput == null && ((0, $4cTDP.fg)('saved_list_view_technical_changes') || (0, $4cTDP.fg)('saved_list_view_merge_support'))) {
                let layout = 'list';
                if (finalVariables.viewId === 'detail') layout = 'detail';
                else if (finalVariables.groupBy != null) layout = 'grouped';
                finalVariables.jiraViewQueryInput = {
                    viewId: (0, $9S9Cb.createViewAri)({
                        activationId: activationId,
                        cloudId: cloudId,
                        layout: layout,
                        projectId: projectId,
                        viewItemId: viewItemId
                    })
                };
            }
            inFlightRequest = (0, $37Ewn.fetchQuery)(environment, (0, $eSK9M.default), finalVariables, {
                fetchPolicy: 'network-only',
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            }).subscribe({
                complete: ()=>{
                    /**
         * fetchQuery will NOT retain the data for the query, meaning that it is not guaranteed that the
         * data will remain saved in the Relay store at any point after the request completes.
         * We need to explicitly retain the operation to ensure it doesn't get deleted.
         * See https://relay.dev/docs/api-reference/fetch-query/#behavior
         */ const operation = (0, $37Ewn.createOperationDescriptor)((0, $37Ewn.getRequest)((0, $eSK9M.default)), finalVariables);
                    const { disposables: disposables } = getState();
                    setState({
                        disposables: disposables.concat([
                            environment.retain(operation)
                        ])
                    });
                    let hasStoreRefetchCompleted = false;
                    const storeRefetch = ()=>{
                        refetch(finalVariables, {
                            fetchPolicy: 'store-only',
                            onComplete: ()=>{
                                /**
               * Relay will dispose the cached operation after a 5m timeout, in which case it will
               * refetch the query from the store and retrigger the onComplete callback. We need to
               * ensure this callback is invoked strictly once to prevent unexpected side effects,
               * e.g. https://jira.atlassian.com/browse/JRACLOUD-84106.
               */ if (hasStoreRefetchCompleted) return;
                                hasStoreRefetchCompleted = true;
                                /**
               * A very difficult to debug race condition emerges when setState is called in the same
               * update cycle as our refetch function. It appears to be related to useSyncExternalStore
               * (used internally by RSS) internal state becoming out of sync which prevents it from
               * correctly notifying listeners (i.e. hooks consumers) when an update is made. Scheduling
               * the update at the end of the event loop is the simplest way of mitigating the bug,
               * but we should revisit this once React concurrent rendering is enabled.
               *
               * Bug this fixes: When clicking "refresh" button multiple times, the shaded loading
               * state on the table will only appear the first time.
               */ queueMicrotask(()=>{
                                    if ((0, $4cTDP.fg)('jira_nin_refetch_state_concurrency_fix')) {
                                        if ((0, $4cTDP.fg)('jira_list_nin_merge_technical_changes')) setState({
                                            inFlightIssueSearchInput: null
                                        });
                                        // Relay executes various internal state updates within a transition. To prevent race conditions
                                        // from occurring (which can lead to stale fragment data being read), we ensure lifecycle related
                                        // state updates are scheduled to occur within the same render priority.
                                        (0, $eJOHy.startTransition)(()=>{
                                            onLifecycleUpdate({
                                                isFetching: false,
                                                isFetchingView: false,
                                                isRefreshing: false,
                                                searchKey: (0, $aXKmr.v4)()
                                            });
                                        });
                                    } else setState({
                                        isFetching: false,
                                        isFetchingView: false,
                                        searchKey: (0, $aXKmr.v4)(),
                                        ...(0, $4cTDP.fg)('jira_list_nin_merge_technical_changes') && {
                                            inFlightIssueSearchInput: null
                                        }
                                    });
                                    dispatch($9724564c3e5356c1$export$9eb6b63e55022ba0());
                                    options.onComplete?.();
                                });
                            }
                        });
                    };
                    /**
         * Delaying the store refetch until the next tick in order to avoid a race condition that occurs
         * when react concurrent mode is enabled. In the future (once concurrent mode rollout is
         * complete), we should replace this suspenseless refetch pattern with transitions.
         *
         * Bug this fixes: Features that perform state updates shortly after the refetch (like toggling
         * hierarchy or grouping) can result in a flicker between old results an new results.
         */ setTimeout(storeRefetch, 0);
                    if ((0, $4cTDP.fg)('saved_list_view_shadow_request')) (0, $48isi.fetchIssueNavigatorIssueSearchRefetchQueryShadow)(finalVariables);
                },
                error: (error)=>{
                    if ((0, $4cTDP.fg)('jira_nin_refetch_state_concurrency_fix')) {
                        if ((0, $4cTDP.fg)('jira_list_nin_merge_technical_changes')) setState({
                            inFlightIssueSearchInput: null
                        });
                        onLifecycleUpdate({
                            isFetching: false,
                            isFetchingView: false,
                            isNetworkError: true,
                            isRefreshing: false
                        });
                    } else setState({
                        isFetching: false,
                        isFetchingView: false,
                        isNetworkError: true,
                        ...(0, $4cTDP.fg)('jira_list_nin_merge_technical_changes') && {
                            inFlightIssueSearchInput: null
                        }
                    });
                    options.onError?.();
                    onRefetchError?.(error, (0, $eibCx.parseIssueNavigatorViewIdOrDefault)(finalVariables.viewId));
                },
                unsubscribe: ()=>{
                    options.onUnsubscribe?.();
                }
            });
            onRefetchStart?.();
            if ((0, $4cTDP.fg)('jira_nin_refetch_state_concurrency_fix')) {
                setState({
                    inFlightRequest: inFlightRequest,
                    ...(0, $4cTDP.fg)('jira_list_nin_merge_technical_changes') && {
                        inFlightIssueSearchInput: finalVariables.issueSearchInput
                    }
                });
                onLifecycleUpdate({
                    isFetching: true,
                    isFetchingView: viewId !== finalVariables.viewId,
                    isNetworkError: false
                });
            } else setState({
                inFlightRequest: inFlightRequest,
                isFetching: true,
                isFetchingView: viewId !== finalVariables.viewId,
                isNetworkError: false,
                ...(0, $4cTDP.fg)('jira_list_nin_merge_technical_changes') && {
                    inFlightIssueSearchInput: finalVariables.issueSearchInput
                }
            });
        },
    refresh: ()=>({ setState: setState, dispatch: dispatch }, { onLifecycleUpdate: onLifecycleUpdate })=>{
            if ((0, $4cTDP.fg)('jira_nin_refetch_state_concurrency_fix')) onLifecycleUpdate({
                isRefreshing: true
            });
            else setState({
                isRefreshing: true
            });
            const onFinish = ()=>{
                if (!(0, $4cTDP.fg)('jira_nin_refetch_state_concurrency_fix')) setState({
                    isRefreshing: false
                });
            };
            dispatch($9724564c3e5356c1$export$e324594224ef24da.refetch({}, {
                onComplete: onFinish,
                onError: onFinish,
                onUnsubscribe: onFinish
            }));
        },
    fetchTotalIssueCount: ()=>({ setState: setState }, { environment: environment, cloudId: cloudId, issueSearchInput: issueSearchInput, isHierarchyEnabled: isHierarchyEnabled, isHideDoneEnabled: isHideDoneEnabled, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled })=>{
            setState({
                totalIssueCount: null,
                totalIssueCountIsFetching: true,
                totalIssueCountIsError: false
            });
            const viewConfigInput = isIssueHierarchySupportEnabled || isHideDoneEnabled && (0, $4cTDP.fg)('jsc_list_hide_done_items') ? {
                staticViewInput: {
                    isHierarchyEnabled: isHierarchyEnabled,
                    isHideDoneEnabled: isHideDoneEnabled
                }
            } : null;
            (0, $37Ewn.fetchQuery)(environment, (0, $64DKg.default), {
                cloudId: cloudId,
                issueSearchInput: issueSearchInput,
                viewConfigInput: viewConfigInput
            }, {
                fetchPolicy: 'network-only',
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            }).subscribe({
                next: (data)=>{
                    const totalIssueCount = data?.jira?.issueSearchTotalCount ?? null;
                    const totalIssueCountIsError = totalIssueCount === null;
                    setState({
                        totalIssueCount: totalIssueCount,
                        totalIssueCountIsFetching: false,
                        totalIssueCountIsError: totalIssueCountIsError
                    });
                },
                error: ()=>{
                    setState({
                        totalIssueCount: null,
                        totalIssueCountIsFetching: false,
                        totalIssueCountIsError: true
                    });
                }
            });
        }
};

});
parcelRegister("64DKg", function(module, exports) {
$parcel$export(module.exports, "default", () => $24f4ba0fbf77aa8a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6b586419dca1877a7e11e7b8408f5c12>>
 * @relayHash de122fab1f76e33de979655b8a8c56c8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f9cc42e6580b3f106e3737ff40b96eca4407846844604fe1c42ce16bba8fc5d
const $24f4ba0fbf77aa8a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueSearchInput"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "viewConfigInput"
        }
    ], v1 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "viewConfigInput",
                            "variableName": "viewConfigInput"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "issueSearchTotalCount"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "actions_issueSearchTotalCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "actions_issueSearchTotalCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "2f9cc42e6580b3f106e3737ff40b96eca4407846844604fe1c42ce16bba8fc5d",
            "metadata": {},
            "name": "actions_issueSearchTotalCountQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$24f4ba0fbf77aa8a$var$node.hash = "82fd57c594d13d97ce59735d9e84149d";
var $24f4ba0fbf77aa8a$export$2e2bcd8739ae039 = $24f4ba0fbf77aa8a$var$node;

});

parcelRegister("48isi", function(module, exports) {
$parcel$export(module.exports, "fetchIssueNavigatorIssueSearchRefetchQueryShadow", () => $9869109181fc67fc$export$460584db8358ab3e);
$parcel$export(module.exports, "useMainIssueNavigatorQueryShadowRequest", () => $9869109181fc67fc$export$d0a69cc9f9c06a41);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $hgi0g = parcelRequire("hgi0g");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $iRahl = parcelRequire("iRahl");
const $9869109181fc67fc$export$a5981df6f2a66c20 = async (variables, query, operationName)=>{
    try {
        await (0, $hgi0g.default)('/gateway/api/graphql', {
            method: 'POST',
            headers: {
                'X-ExperimentalApi': 'JiraIssueSearch, JiraProject'
            },
            body: JSON.stringify({
                operationName: operationName,
                query: query,
                variables: {
                    ...variables,
                    namespace: 'ISSUE_NAVIGATOR',
                    amountOfColumns: 500,
                    scope: {
                        ...'scope' in variables && variables.scope,
                        operationScope: 'projectKey' in variables && variables.projectKey ? (0, $iRahl.NIN_PROJECT_SHADOW_REQUEST_OPERATION_SCOPE) : (0, $iRahl.NIN_GLOBAL_SHADOW_REQUEST_OPERATION_SCOPE)
                    },
                    isLinkRelationshipFieldEnabled: false,
                    isLastUsedJqlEnabled: (0, $4cTDP.fg)('jira_nin_last_used_jql'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcblockattachmentdownloadsegregationrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider: 1,
                    __relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiralistinlineeditingrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider: (0, $cxKOj.expVal)('jira-itr-m4-exp-3', 'isEnabled', false),
                    __relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingenabledrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingormergesupportenabledrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider: (0, $4cTDP.fg)('frontier-currency-field-d1'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider: (0, $4cTDP.fg)('dfo_remove_fields_by_id'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider: (0, $4cTDP.fg)('jira_timeline_analytics_harmonization'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider: (0, $4cTDP.fg)('jira_preview_panel_m_1_rollout'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider: (0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider: (0, $4cTDP.fg)('mimic_flatlist_rss_while_uninitialised'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider: (0, $4cTDP.fg)('jira_list_reduce_re_renders'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider: (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false),
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider: (0, $4cTDP.fg)('jira_nin_last_used_jql'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider: (0, $cxKOj.expValEquals)('atlassian_projects_-_native_integration', 'cohort', 'variation', 'control'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider: (0, $4cTDP.fg)('nin-strikethrough-resolution-update'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider: (0, $4cTDP.fg)('group_by_projects'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider: (0, $4cTDP.fg)('jira_ai_show_human_supervisor_avatar'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider: (0, $4cTDP.fg)('jira_paid_list_nin_merge_onboarding_modal'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider: (0, $4cTDP.fg)('jira-original-estimate-editable-fix'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider: (0, $4cTDP.fg)('frontier-formula-field-d1'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider: (0, $4cTDP.fg)('issue_preview_panel_issue_view_subtask'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider: (0, $4cTDP.fg)('goals_ssr_smart_card'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider: (0, $4cTDP.fg)('goal_group_header_smart_link_relay'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider: (0, $4cTDP.fg)('jira_timeline_rollups_technical_gate'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider: (0, $4cTDP.fg)('jira_ai_fetch_app_type_for_user_assignee')
                }
            })
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            attributes: {
                message: `Shadow request for nin issue search ${operationName} failed`
            },
            meta: {
                id: 'shadow-request-for-nin-issue-search',
                packageName: 'jiraIssueNavigator',
                teamName: 'empanada'
            }
        });
    }
};

const $9869109181fc67fc$var$getIssueNavigatorIssueSearchRefetchQueryShadowOperation = ()=>{
    const operation = (parcelRequire("zozlI")).then((module)=>{
        const operationName = 'SLV_SHADOW_REQUEST_IssueNavigatorIssueSearchRefetchQuery';
        return {
            operationName: operationName,
            operation: module.operation.replace('IssueNavigatorIssueSearchRefetchQuery', operationName)
        };
    });
    return operation;
};

const $9869109181fc67fc$var$getMainIssueNavigatorQueryShadowOperation = ()=>{
    const operation = (parcelRequire("a9rnC")).then((module)=>{
        const operationName = 'SLV_SHADOW_REQUEST_main_IssueNavigatorQuery';
        return {
            operationName: operationName,
            operation: module.operation.replace('main_IssueNavigatorQuery', operationName)
        };
    });
    return operation;
};
const $9869109181fc67fc$var$catchedCallback = (cb)=>{
    return (...args)=>{
        try {
            cb(...args);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: error,
                attributes: {
                    message: 'Queue shadow request for nin issue search failed'
                },
                meta: {
                    id: 'queue-shadow-request-for-nin-issue-search',
                    packageName: 'jiraIssueNavigator',
                    teamName: 'empanada'
                }
            });
        }
    };
};
const $9869109181fc67fc$var$catchedCallbackAsync = (cb)=>{
    return async (...args)=>{
        try {
            await cb(...args);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: error,
                attributes: {
                    message: 'Queue shadow request for nin issue search failed'
                },
                meta: {
                    id: 'queue-shadow-request-for-nin-issue-search',
                    packageName: 'jiraIssueNavigator',
                    teamName: 'empanada'
                }
            });
        }
    };
};
const $9869109181fc67fc$export$8ca28e57c08b20c8 = $9869109181fc67fc$var$catchedCallback((getOperation, variables)=>{
    if (false) return;
    // requestIdleCallback is not supported in Safari, so we need a workaround.
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback !== 'undefined') window.requestIdleCallback($9869109181fc67fc$var$catchedCallback(()=>setTimeout($9869109181fc67fc$var$catchedCallback(()=>{
            window.requestIdleCallback($9869109181fc67fc$var$catchedCallbackAsync(async ()=>{
                const query = await getOperation();
                $9869109181fc67fc$export$a5981df6f2a66c20(variables, query.operation, query.operationName);
            }));
        }), 5000)));
});
const $9869109181fc67fc$export$460584db8358ab3e = (variables)=>{
    $9869109181fc67fc$export$8ca28e57c08b20c8($9869109181fc67fc$var$getIssueNavigatorIssueSearchRefetchQueryShadowOperation, variables);
};
const $9869109181fc67fc$export$d0a69cc9f9c06a41 = (variables)=>{
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $4cTDP.fg)('saved_list_view_shadow_request')) $9869109181fc67fc$export$8ca28e57c08b20c8($9869109181fc67fc$var$getMainIssueNavigatorQueryShadowOperation, variables);
    // We only want to fetch the main query once, so we don't need to add any dependencies here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

});
parcelRegister("zozlI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gfsdl").then(()=>parcelRequire('7tlUM'));

});

parcelRegister("a9rnC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("c5rFF").then(()=>parcelRequire('6lj4W'));

});




parcelRegister("5lUfC", function(module, exports) {
$parcel$export(module.exports, "useSelectedViewMutation", () => $71afd6653e17f6b3$export$765f658bb8bac50f);

var $eYZgJ = parcelRequire("eYZgJ");

var $iWlON = parcelRequire("iWlON");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $4cTDP = parcelRequire("4cTDP");

var $cHtIB = parcelRequire("cHtIB");

var $iRahl = parcelRequire("iRahl");
const $71afd6653e17f6b3$export$5786a571e562003d = (view)=>view.startsWith('list_') ? 'LIST' : 'DETAIL';
const $71afd6653e17f6b3$export$765f658bb8bac50f = ()=>{
    const userCloudId = (0, $cHtIB.useCloudId)();
    const [commitMutation] = (0, $j4oe4.useMutation)((0, $iWlON.default));
    const [commit] = (0, $j4oe4.useMutation)((0, $eYZgJ.default));
    return (0, $eJOHy.useCallback)((view, viewARI)=>{
        if ((0, $4cTDP.fg)('saved_list_view_technical_changes')) commit({
            variables: {
                input: {
                    viewId: viewARI,
                    viewLayout: $71afd6653e17f6b3$export$5786a571e562003d(view)
                }
            },
            onError: (error)=>{
                (0, $9pTd3.fireErrorAnalytics)({
                    sendToPrivacyUnsafeSplunk: true,
                    error: error,
                    meta: {
                        id: 'mainSelectedViewMutation',
                        packageName: (0, $iRahl.PACKAGE_NAME),
                        teamName: (0, $iRahl.TEAM_NAME)
                    }
                });
            },
            optimisticResponse: {
                jira_setIssueSearchViewLayout: {
                    success: true,
                    errors: []
                }
            }
        });
        else commitMutation({
            variables: {
                cloudId: userCloudId,
                searchLayout: $71afd6653e17f6b3$export$5786a571e562003d(view)
            },
            onError: (error)=>{
                (0, $9pTd3.fireErrorAnalytics)({
                    sendToPrivacyUnsafeSplunk: true,
                    error: error,
                    meta: {
                        id: 'mainSelectedViewMutation',
                        packageName: (0, $iRahl.PACKAGE_NAME),
                        teamName: (0, $iRahl.TEAM_NAME)
                    }
                });
            },
            optimisticResponse: {
                jira: {
                    userPreferences: {
                        setIssueNavigatorSearchLayout: {
                            success: true,
                            errors: [],
                            issueNavigatorSearchLayout: $71afd6653e17f6b3$export$5786a571e562003d(view)
                        }
                    }
                }
            }
        });
    }, [
        commit,
        commitMutation,
        userCloudId
    ]);
};

});
parcelRegister("eYZgJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad2df38d0716e01d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e7189ca0884fb6a2778f8230b6eb5c66>>
 * @relayHash 741cb5df6adfcaa4c4e00bf870fcc0c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5f332c502a8d6c3f21250ad8d9e08058c42cb19c588d63f4ea5818ad100a18f9
const $ad2df38d0716e01d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "JiraSetIssueSearchViewLayoutPayload",
            "kind": "LinkedField",
            "name": "jira_setIssueSearchViewLayout",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSelectedViewMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSelectedViewMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "5f332c502a8d6c3f21250ad8d9e08058c42cb19c588d63f4ea5818ad100a18f9",
            "metadata": {},
            "name": "useSelectedViewMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$ad2df38d0716e01d$var$node.hash = "65b41e477de41628cbbb17392e93350d";
var $ad2df38d0716e01d$export$2e2bcd8739ae039 = $ad2df38d0716e01d$var$node;

});

parcelRegister("iWlON", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2b80c1ca9d6de88$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5a3bc6510292ce94117d6582f5f11dc6>>
 * @relayHash a9f32b8a40e62d50ea93109e8a20f2cc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fb739b5da2438ed07259ec682dabb897bf77f788cc0ef58a85897005e02467e5
const $a2b80c1ca9d6de88$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchLayout"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraUserPreferencesMutation",
                    "kind": "LinkedField",
                    "name": "userPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "searchLayout",
                                    "variableName": "searchLayout"
                                }
                            ],
                            "concreteType": "JiraIssueNavigatorSearchLayoutMutationPayload",
                            "kind": "LinkedField",
                            "name": "setIssueNavigatorSearchLayout",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "success"
                                },
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "issueNavigatorSearchLayout"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSelectedViewMutationOldMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSelectedViewMutationOldMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "fb739b5da2438ed07259ec682dabb897bf77f788cc0ef58a85897005e02467e5",
            "metadata": {},
            "name": "useSelectedViewMutationOldMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$a2b80c1ca9d6de88$var$node.hash = "fc5879cd5e3ff3110514f54a88b6d958";
var $a2b80c1ca9d6de88$export$2e2bcd8739ae039 = $a2b80c1ca9d6de88$var$node;

});


parcelRegister("aaLZH", function(module, exports) {
$parcel$export(module.exports, "useIssueNavigatorFeatures", () => $e6a83fe9a48197d6$export$403fe21e578d284c);
$parcel$export(module.exports, "useIssueNavigatorFeature", () => $e6a83fe9a48197d6$export$caa5cde5243e13a8);
$parcel$export(module.exports, "IssueNavigatorFeatureProvider", () => $e6a83fe9a48197d6$export$682e7a54b8447684);
$parcel$export(module.exports, "IssueNavigatorFeatureGuard", () => $e6a83fe9a48197d6$export$7b56b3a54a98f99c);

var $eJOHy = parcelRequire("eJOHy");
const $e6a83fe9a48197d6$var$defaultFeatureContext = {
    isViewSwitcherEnabled: true,
    isOnboardingEnabled: true,
    isExportMenuEnabled: true,
    isRowContextMenuEnabled: true,
    isSaveFilterButtonEnabled: true,
    isBulkChangeWorkItemsEnabled: true,
    isImportWorkItemsFromCSVEnabled: true,
    isViewAsChartEnabled: true,
    isConditionalFormattingEnabled: false,
    isConditionalFormattingEditingEnabled: false,
    isProjectQuickstartOnboardingEnabled: false,
    isMakeSpaceForGlobalRovoButtonEnabled: false
};
const $e6a83fe9a48197d6$var$IssueNavigatorFeatureContext = /*#__PURE__*/ (0, $eJOHy.createContext)($e6a83fe9a48197d6$var$defaultFeatureContext);
const $e6a83fe9a48197d6$export$403fe21e578d284c = ()=>(0, $eJOHy.useContext)($e6a83fe9a48197d6$var$IssueNavigatorFeatureContext);
const $e6a83fe9a48197d6$export$caa5cde5243e13a8 = (featureKey)=>$e6a83fe9a48197d6$export$403fe21e578d284c()[featureKey];
const $e6a83fe9a48197d6$export$682e7a54b8447684 = ({ children: children, isBulkChangeWorkItemsEnabled: isBulkChangeWorkItemsEnabled, isConditionalFormattingEnabled: isConditionalFormattingEnabled, isConditionalFormattingEditingEnabled: isConditionalFormattingEditingEnabled, isExportMenuEnabled: isExportMenuEnabled, isImportWorkItemsFromCSVEnabled: isImportWorkItemsFromCSVEnabled, isOnboardingEnabled: isOnboardingEnabled, isProjectQuickstartOnboardingEnabled: isProjectQuickstartOnboardingEnabled, isRowContextMenuEnabled: isRowContextMenuEnabled, isSaveFilterButtonEnabled: isSaveFilterButtonEnabled, isViewAsChartEnabled: isViewAsChartEnabled, isViewSwitcherEnabled: isViewSwitcherEnabled, isMakeSpaceForGlobalRovoButtonEnabled: isMakeSpaceForGlobalRovoButtonEnabled })=>{
    const value = (0, $eJOHy.useMemo)(()=>({
            isBulkChangeWorkItemsEnabled: isBulkChangeWorkItemsEnabled ?? $e6a83fe9a48197d6$var$defaultFeatureContext.isBulkChangeWorkItemsEnabled,
            isConditionalFormattingEnabled: isConditionalFormattingEnabled ?? $e6a83fe9a48197d6$var$defaultFeatureContext.isConditionalFormattingEnabled,
            isConditionalFormattingEditingEnabled: isConditionalFormattingEditingEnabled ?? $e6a83fe9a48197d6$var$defaultFeatureContext.isConditionalFormattingEditingEnabled,
            isExportMenuEnabled: isExportMenuEnabled ?? $e6a83fe9a48197d6$var$defaultFeatureContext.isExportMenuEnabled,
            isImportWorkItemsFromCSVEnabled: isImportWorkItemsFromCSVEnabled ?? $e6a83fe9a48197d6$var$defaultFeatureContext.isImportWorkItemsFromCSVEnabled,
            isOnboardingEnabled: isOnboardingEnabled ?? $e6a83fe9a48197d6$var$defaultFeatureContext.isOnboardingEnabled,
            isProjectQuickstartOnboardingEnabled: isProjectQuickstartOnboardingEnabled ?? $e6a83fe9a48197d6$var$defaultFeatureContext.isProjectQuickstartOnboardingEnabled,
            isRowContextMenuEnabled: isRowContextMenuEnabled ?? $e6a83fe9a48197d6$var$defaultFeatureContext.isRowContextMenuEnabled,
            isSaveFilterButtonEnabled: isSaveFilterButtonEnabled ?? $e6a83fe9a48197d6$var$defaultFeatureContext.isSaveFilterButtonEnabled,
            isViewAsChartEnabled: isViewAsChartEnabled ?? $e6a83fe9a48197d6$var$defaultFeatureContext.isViewAsChartEnabled,
            isViewSwitcherEnabled: isViewSwitcherEnabled ?? $e6a83fe9a48197d6$var$defaultFeatureContext.isViewSwitcherEnabled,
            isMakeSpaceForGlobalRovoButtonEnabled: isMakeSpaceForGlobalRovoButtonEnabled ?? $e6a83fe9a48197d6$var$defaultFeatureContext.isMakeSpaceForGlobalRovoButtonEnabled
        }), [
        isBulkChangeWorkItemsEnabled,
        isConditionalFormattingEnabled,
        isConditionalFormattingEditingEnabled,
        isExportMenuEnabled,
        isImportWorkItemsFromCSVEnabled,
        isOnboardingEnabled,
        isProjectQuickstartOnboardingEnabled,
        isRowContextMenuEnabled,
        isSaveFilterButtonEnabled,
        isViewAsChartEnabled,
        isViewSwitcherEnabled,
        isMakeSpaceForGlobalRovoButtonEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e6a83fe9a48197d6$var$IssueNavigatorFeatureContext.Provider, {
        value: value
    }, children);
};
const $e6a83fe9a48197d6$export$7b56b3a54a98f99c = ({ featureKey: featureKey, on: on, off: off })=>{
    const feature = $e6a83fe9a48197d6$export$caa5cde5243e13a8(featureKey);
    return feature ? on : off;
};

});

parcelRegister("jHM2W", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c7f4aafd27e2e4c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4c7f4aafd27e2e4c$var$messages = (0, $7qGN1.defineMessages)({
    searchFailedTitle: {
        "id": "issue-navigator.issue-search.search-failed-title",
        "defaultMessage": "We couldn't load your search results"
    },
    searchFailedDescription: {
        "id": "issue-navigator.issue-search.search-failed-description",
        "defaultMessage": "Refresh and try again."
    }
});
var $4c7f4aafd27e2e4c$export$2e2bcd8739ae039 = $4c7f4aafd27e2e4c$var$messages;

});


parcelRegister("2kVBT", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5861a3b1095a50f$export$2e2bcd8739ae039);

var $5Wwfj = parcelRequire("5Wwfj");

var $4El0O = parcelRequire("4El0O");

var $3AgIJ = parcelRequire("3AgIJ");

var $6zVHq = parcelRequire("6zVHq");

var $3c526 = parcelRequire("3c526");

var $eeC5x = parcelRequire("eeC5x");

var $4nnLT = parcelRequire("4nnLT");

var $6ZQGt = parcelRequire("6ZQGt");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $kyad3 = parcelRequire("kyad3");

var $ih4L6 = parcelRequire("ih4L6");

var $dLR8J = parcelRequire("dLR8J");

var $9RE4U = parcelRequire("9RE4U");

var $8l1NO = parcelRequire("8l1NO");

var $5wZfc = parcelRequire("5wZfc");

var $8nw3F = parcelRequire("8nw3F");

var $iZsVo = parcelRequire("iZsVo");

var $C81Q0 = parcelRequire("C81Q0");

var $iWvkh = parcelRequire("iWvkh");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $14RSn = parcelRequire("14RSn");

var $lRq8t = parcelRequire("lRq8t");

var $82cqT = parcelRequire("82cqT");

var $lHHP1 = parcelRequire("lHHP1");

var $3TtKq = parcelRequire("3TtKq");

var $6d9QY = parcelRequire("6d9QY");

var $eS29z = parcelRequire("eS29z");

var $9WMzW = parcelRequire("9WMzW");

var $9bIo2 = parcelRequire("9bIo2");

var $kbhn6 = parcelRequire("kbhn6");

var $iRahl = parcelRequire("iRahl");

var $cZHhU = parcelRequire("cZHhU");

var $fAgUF = parcelRequire("fAgUF");

var $51pSU = parcelRequire("51pSU");

var $1wL9i = parcelRequire("1wL9i");

var $HiS1C = parcelRequire("HiS1C");

var $fwKw5 = parcelRequire("fwKw5");

var $cJdYi = parcelRequire("cJdYi");

var $3kDjB = parcelRequire("3kDjB");

var $lvpZz = parcelRequire("lvpZz");

var $7EogO = parcelRequire("7EogO");

var $6Al27 = parcelRequire("6Al27");

var $aaLZH = parcelRequire("aaLZH");

var $b4JYg = parcelRequire("b4JYg");

var $dOpAp = parcelRequire("dOpAp");

var $cZQDI = parcelRequire("cZQDI");

var $7ZGNh = parcelRequire("7ZGNh");

var $cPfqZ = parcelRequire("cPfqZ");

var $e78V2 = parcelRequire("e78V2");

var $l5sqM = parcelRequire("l5sqM");

var $1TTSy = parcelRequire("1TTSy");

var $dpNFU = parcelRequire("dpNFU");

var $78img = parcelRequire("78img");

var $2cvR1 = parcelRequire("2cvR1");

var $f7hID = parcelRequire("f7hID");

var $5eCXQ = parcelRequire("5eCXQ");

var $8Eogd = parcelRequire("8Eogd");
const $a5861a3b1095a50f$var$SidebarLayout = ({ children: children, project: project, view: view })=>{
    const projectData = (0, $j4oe4.useFragment)((0, $6ZQGt.default), project);
    const viewData = (0, $j4oe4.useFragment)((0, $4nnLT.default), view);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9WMzW.SidebarLayout), {
        defaultRatio: 0.3,
        minWidth: 360,
        maxRatio: 0.75,
        teamName: "empanada",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7hID.SidebarExperienceRegistryWithErrorBoundary), {
            project: projectData ?? null,
            view: viewData ?? null
        })
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2cvR1.SidebarCloserController), null));
};
const $a5861a3b1095a50f$var$staticEntrypointParams = {
    cloudId: undefined,
    projectKey: undefined
};
const $a5861a3b1095a50f$export$397fa57fff06920f = ({ CustomHeader: CustomHeader, ActionMenu: ActionMenu, HeaderSkeletonImage: HeaderSkeletonImage, filter: filter, onChangeJqlAndGroupBy: onChangeJqlAndGroupBy, onPageDataLoad: onPageDataLoad, onChangeColumnConfiguration: onChangeColumnConfiguration, onChangeJql: onChangeJql, onChangeIssue: onChangeIssue, onChangeFilter: onChangeFilter, defaultJql: defaultJql, onRefinement: onRefinement, onIssueFlatListUpdated: onIssueFlatListUpdated, issueResults: issueResults, groupResults: groupResults, project: project, userPreferences: userPreferences, jqlBuilderProps: jqlBuilderProps, jqlBuilderWithAiKey: jqlBuilderWithAiKey, issueTableProps: issueTableProps, isGridNavigationEnabled: isGridNavigationEnabled, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isIssueRankingSupportEnabled: isIssueRankingSupportEnabled, isMergedColumnSupportEnabled: isMergedColumnSupportEnabled, isFrozenColumnSupportEnabled: isFrozenColumnSupportEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled, jiraView: jiraView, initialQueryAsJql: initialQueryAsJql, isInitialized: isInitialized, isPostOfficePlacementEnabled: isPostOfficePlacementEnabled, isFilterRefinementEnabled: isFilterRefinementEnabled, filterRefinementQueryReference: filterRefinementQueryReference, issueAppEntryPoint: issueAppEntryPoint })=>{
    (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_NAVIGATOR_UI_START);
    (0, $eJOHy.useLayoutEffect)(()=>{
        (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_NAVIGATOR_UI_END);
    }, []);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)(); // eslint-disable-next-line react-hooks/rules-of-hooks
    const setJql = (0, $4cTDP.fg)('saved_list_view_technical_changes') ? (0, $7EogO.useSetJql)() : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    const [caughtIssueSearchError, setCaughtIssueSearchError] = (0, $eJOHy.useState)();
    const { filterId: filterId } = (0, $fwKw5.useActiveJql)();
    const resolvedJql = (0, $fwKw5.useResolvedJql)();
    const { filterQueryIsFetching: filterQueryIsFetching } = (0, $cJdYi.useFilterQuery)();
    const searchKey = (0, $3kDjB.useSearchKey)();
    const previousData = (0, $6d9QY.usePrevious)(searchKey);
    const hasSearchChanged = Boolean(searchKey && searchKey !== previousData);
    const [{ view: selectedView }] = (0, $HiS1C.useSelectedViewState)();
    const issueResultsData = (0, $j4oe4.useFragment)((0, $eeC5x.default), issueResults);
    const groupResultsData = (0, $j4oe4.useFragment)((0, $3c526.default), groupResults);
    const jiraViewData = (0, $j4oe4.useFragment)((0, $6zVHq.default), jiraView);
    const hasStickyColumn = (0, $4cTDP.fg)('issue_table_frozen_columns') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>jiraViewData?.fieldSets?.edges?.some((edge)=>edge?.node?.fieldSetPreferences?.isFrozen === true) ?? false, [
        jiraViewData?.fieldSets?.edges
    ]) : false;
    const handleChangeJql = (0, $eJOHy.useCallback)((jql, clearFilter)=>{
        onChangeJql?.(jql, clearFilter);
        if ((0, $4cTDP.fg)('saved_list_view_technical_changes')) {
            const savedViewId = jiraViewData?.savedViewId;
            if (savedViewId == null) throw new Error('Missing saved view ID');
            setJql({
                jql: jql,
                viewARI: savedViewId
            });
        }
    }, [
        jiraViewData?.savedViewId,
        onChangeJql,
        setJql
    ]);
    const onChange = (0, $eJOHy.useCallback)((jql)=>{
        onRefinement && onRefinement();
        handleChangeJql(jql, !filterQueryIsFetching && filter === null && (0, $82cqT.isFilterId)(filterId));
    }, [
        filter,
        filterId,
        filterQueryIsFetching,
        handleChangeJql,
        onRefinement
    ]);
    const handleReset = (0, $eJOHy.useCallback)((isResetToFilter = false)=>{
        if (isResetToFilter) onChangeFilter && onChangeFilter();
        else handleChangeJql(defaultJql, true);
    }, [
        onChangeFilter,
        handleChangeJql,
        defaultJql
    ]);
    const viewResultError = (0, $eJOHy.useMemo)(()=>{
        if (!jiraViewData) return undefined;
        const message = jiraViewData.error?.message ?? '';
        const statusCode = jiraViewData.error?.extensions?.[0].statusCode;
        if (typeof statusCode !== 'number') return;
        return new (0, $14RSn.default)(statusCode, message);
    }, [
        jiraViewData
    ]);
    const userPreferencesData = (0, $j4oe4.useFragment)((0, $3AgIJ.default), userPreferences);
    const jqlBuilderWithAiData = (0, $j4oe4.useFragment)((0, $4El0O.default), jqlBuilderWithAiKey);
    const projectData = (0, $j4oe4.useFragment)((0, $5Wwfj.default), project);
    const isConditionalFormattingEnabled = (0, $4cTDP.fg)('jira_list_conditional_formatting') && // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $aaLZH.useIssueNavigatorFeatures)().isConditionalFormattingEnabled;
    const hasFormattingRules = ((0, $4cTDP.fg)('saved_list_view_technical_changes') ? jiraViewData?.conditionalFormattingRules?.edges?.length ?? 0 : projectData?.conditionalFormattingRules?.edges?.length ?? 0) > 0;
    const isGrouping = (0, $eJOHy.useMemo)(()=>issueTableProps?.isGroupingSupported && jiraViewData?.viewSettings?.isGroupingEnabled && jiraViewData?.viewSettings?.canEnableGrouping, [
        issueTableProps?.isGroupingSupported,
        jiraViewData?.viewSettings?.canEnableGrouping,
        jiraViewData?.viewSettings?.isGroupingEnabled
    ]);
    const hasPreviousPage = (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>issueResultsData?.pageInfo?.hasPreviousPage, [
        issueResultsData?.pageInfo?.hasPreviousPage
    ]) : undefined;
    const screenEventAttributes = (0, $eJOHy.useMemo)(()=>{
        return {
            ...(0, $4cTDP.fg)('jira_list_conditional_formatting') && {
                isConditionalFormattingEnabled: isConditionalFormattingEnabled,
                hasFormattingRules: hasFormattingRules
            },
            ...(0, $4cTDP.fg)('issue_table_frozen_columns') && {
                isFrozenColumnSupportEnabled: isFrozenColumnSupportEnabled,
                hasStickyColumn: hasStickyColumn
            },
            isGrouping: isGrouping
        };
    }, [
        hasFormattingRules,
        hasStickyColumn,
        isConditionalFormattingEnabled,
        isFrozenColumnSupportEnabled,
        isGrouping
    ]);
    const shouldAnnounceInfo = (0, $eJOHy.useMemo)(()=>hasSearchChanged && (isGrouping ? groupResultsData !== null : issueResultsData !== null && typeof issueResultsData?.totalIssueSearchResultCount === 'number'), [
        hasSearchChanged,
        isGrouping,
        groupResultsData,
        issueResultsData
    ]);
    const [isAiEnabled, setIsAiEnabled] = (0, $eJOHy.useState)(false);
    const onToggleAi = (0, $eJOHy.useCallback)((isEnabled)=>{
        setIsAiEnabled(isEnabled);
    }, []);
    const serverError = (0, $eJOHy.useMemo)(()=>{
        if (issueResultsData?.issueSearchError?.__typename === 'JiraServerError') return new Error(issueResultsData.issueSearchError.message ?? 'Unknown issue search error');
        if (groupResultsData?.errors?.length) {
            const firstError = groupResultsData.errors.find(({ extensions: extensions })=>!extensions?.some(({ statusCode: statusCode })=>typeof statusCode === 'number' && statusCode >= 400 && statusCode < 500));
            return firstError ? new Error(firstError.message ?? 'Unknown group results error') : undefined;
        }
    }, [
        groupResultsData?.errors,
        issueResultsData?.issueSearchError
    ]);
    const hasServerError = !!serverError;
    const hasViewNotFoundError = !!viewResultError && viewResultError.statusCode === 404;
    const noFilterReason = (0, $eJOHy.useMemo)(()=>{
        if (!filterQueryIsFetching && filter === null && (0, $82cqT.isFilterId)(filterId)) return 'Filter query mismatch';
        if (hasViewNotFoundError) return 'Filter not found in view result';
        return undefined;
    }, [
        filter,
        filterId,
        filterQueryIsFetching,
        hasViewNotFoundError
    ]);
    const IssueNavigatorTopBar = (0, $eJOHy.useMemo)(()=>{
        const jqlBuilder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e78V2.default), {
            onChangeJql: onChange,
            defaultJql: defaultJql,
            filter: filter,
            onReset: handleReset,
            onFilterSave: onChangeFilter,
            groupResults: groupResultsData ?? null,
            issueResults: issueResultsData ?? null,
            onToggleAi: onToggleAi,
            jqlBuilderWithAiKey: jqlBuilderWithAiData ?? null,
            jqlBuilderProps: jqlBuilderProps,
            initialQueryAsJql: initialQueryAsJql,
            disableBackToFilterButton: !!projectData,
            isFilterRefinementEnabled: isFilterRefinementEnabled,
            filterRefinementQueryReference: filterRefinementQueryReference
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $4cTDP.fg)('nin_blindspot_fixes_fy26') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
            name: "issue-navigator-top-bar",
            hold: !ActionMenu && !CustomHeader
        }), ActionMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78img.default), {
            ActionMenu: ActionMenu,
            isGroupingSupported: issueTableProps?.isGroupingSupported,
            filter: filter,
            issueResults: issueResultsData ?? null,
            HeaderSkeletonImage: HeaderSkeletonImage,
            jqlBuilder: jqlBuilder,
            jiraViewResult: jiraViewData ?? null,
            projectResult: projectData ?? null,
            onChangeFilter: onChangeFilter,
            onChangeJql: handleChangeJql,
            isGridNavigationEnabled: isGridNavigationEnabled,
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
            defaultJql: defaultJql,
            onChangeJqlAndGroupBy: onChangeJqlAndGroupBy
        }), CustomHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ZGNh.default), {
            CustomHeader: CustomHeader,
            filter: filter,
            issueResults: issueResultsData ?? null,
            HeaderSkeletonImage: HeaderSkeletonImage,
            jiraViewResult: jiraViewData ?? null,
            isGroupingSupported: issueTableProps?.isGroupingSupported,
            onChangeFilter: onChangeFilter,
            onChangeJql: handleChangeJql
        }), jqlBuilder));
    }, [
        onChange,
        defaultJql,
        filter,
        handleReset,
        onChangeFilter,
        groupResultsData,
        issueResultsData,
        onToggleAi,
        jqlBuilderWithAiData,
        jqlBuilderProps,
        initialQueryAsJql,
        projectData,
        isFilterRefinementEnabled,
        filterRefinementQueryReference,
        ActionMenu,
        CustomHeader,
        issueTableProps?.isGroupingSupported,
        HeaderSkeletonImage,
        jiraViewData,
        handleChangeJql,
        isGridNavigationEnabled,
        isInlineFieldConfigEnabled,
        onChangeJqlAndGroupBy
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $C81Q0.asyncBulkOpsCoreEntryPoint), $a5861a3b1095a50f$var$staticEntrypointParams);
    const { setFlatListIssueIds: setFlatListIssueIds } = (0, $lvpZz.useFlatListIssuesActions)();
    let setFlatListChildIssueIds = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    if ((0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ setFlatListChildIssueIds: setFlatListChildIssueIds } = (0, $lvpZz.useFlatListIssuesActions)());
    const hasListMigrationData = (0, $4cTDP.fg)('jira_list_nin_merge') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $b4JYg.useHasListMigrationDataForProject)(projectData?.projectId) : false;
    const handleIssueFlatListUpdated = (0, $eJOHy.useCallback)((newFlatKeyList, newFlatIdList, newFlatChildIdList)=>{
        setFlatListIssueIds(newFlatIdList);
        if ((0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false)) setFlatListChildIssueIds(newFlatChildIdList);
        if (onIssueFlatListUpdated) onIssueFlatListUpdated(newFlatKeyList, newFlatIdList, newFlatChildIdList);
    }, [
        setFlatListIssueIds,
        setFlatListChildIssueIds,
        onIssueFlatListUpdated
    ]);
    const { isDeleteIssueModalOpen: isDeleteIssueModalOpen, isDeletingIssue: isDeletingIssue, issueId: issueId, issueKey: issueKey, didIssueDeleteFail: didIssueDeleteFail, workType: workType, isIssueArchivalEnabled: isIssueArchivalEnabled, onTriggerDeleteRequest: onTriggerDeleteRequest } = (0, $8l1NO.useDeleteIssueModalStates)();
    const { closeDeleteIssueModal: closeDeleteIssueModal } = (0, $9bIo2.useDeleteIssueModalActions)();
    const isTriggeredFromNINView = (0, $eJOHy.useMemo)(()=>{
        return {
            isIssueArchivalEnabled: isIssueArchivalEnabled,
            isTriggeredFromNINView: true
        };
    }, [
        isIssueArchivalEnabled
    ]);
    const isPageHydrating = (0, $9RE4U.useIsHydrateRenderMode)();
    const displaySsrPlaceholderAttrs = (0, $9RE4U.useSsrPlaceholders)();
    let IssueNavigatorContent = (0, $eJOHy.useMemo)(()=>{
        const getAnnouncerMessage = ()=>{
            if (isGrouping) return formatMessage((0, $l5sqM.default).screenReaderGroupResultInfo);
            let message;
            if (issueResultsData?.isCappingIssueSearchResult) message = (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $l5sqM.default).screenReaderSearchResultMoreInfoIssueTermRefresh : (0, $l5sqM.default).screenReaderSearchResultMoreInfo;
            else message = (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $l5sqM.default).screenReaderSearchResultInfoIssueTermRefresh : (0, $l5sqM.default).screenReaderSearchResultInfo;
            return formatMessage(message, {
                total: issueResultsData?.totalIssueSearchResultCount
            });
        };
        const InlineFieldConfigProviderComponent = isInlineFieldConfigEnabled ? (0, $6Al27.IFCEntryPointContextProvider) : (0, $eJOHy.Fragment); // Remove all the IssueNavigatorSpotlight on clean up of 'remove_nin_changeboarding_rll_usages', should be showing as empty fragments already
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3TtKq.IssueTableSelectedIssuesContainer), {
            onIssueSelected: entryPointActions.load,
            ...(0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) && {
                shouldForceManualSelectAll: isGrouping || hasPreviousPage
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5wZfc.IssueFieldStatisticsEntrypointProvider), {
            jql: resolvedJql,
            view: selectedView
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a5861a3b1095a50f$var$SidebarLayout, {
            project: projectData ?? null,
            view: (0, $4cTDP.fg)('saved_list_view_technical_changes') ? jiraViewData ?? null : null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dOpAp.BulkOperationsWrapper // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        ), {
            // @ts-ignore - error TS2322: - type mismatch
            bulkOpsCoreEntryPointReference: entryPointReferenceSubject,
            fragmentRef: issueResultsData ?? null,
            ...(0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) && {
                jiraViewFragment: jiraViewData ?? null
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(InlineFieldConfigProviderComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a5861a3b1095a50f$var$IssueNavigatorContentContainer, {
            selectedView: selectedView,
            "data-vc": `issue-navigator-content${false && !isPageHydrating ? '-ssr' : ''}`,
            ...false && displaySsrPlaceholderAttrs && {
                'data-ssr-placeholder': 'issue-navigator-content-placeholder'
            },
            ...!false && displaySsrPlaceholderAttrs && {
                'data-ssr-placeholder-replace': 'issue-navigator-content-placeholder'
            }
        }, IssueNavigatorTopBar, !isFilterRefinementEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kbhn6.JQLPanelRenderSlotForWorkItemList), null), !filterQueryIsFetching && filter === null && (0, $82cqT.isFilterId)(filterId) || hasViewNotFoundError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cZHhU.NoFilter), {
            reason: noFilterReason
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nw3F.AnnouncerV2), {
            message: getAnnouncerMessage(),
            shouldAnnounce: shouldAnnounceInfo,
            testId: "issue-navigator.ui.search-announcer"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cPfqZ.default), {
            hasServerError: hasServerError,
            onChangeColumnConfiguration: onChangeColumnConfiguration,
            onChangeJql: handleChangeJql,
            onCaughtIssueSearchError: setCaughtIssueSearchError,
            issueResults: issueResultsData ?? null,
            jiraView: jiraViewData ?? null,
            project: projectData ?? null,
            rankField: jqlBuilderWithAiData ?? null,
            groupResults: groupResultsData ?? null,
            issueTableProps: issueTableProps,
            isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
            isIssueRankingSupportEnabled: isIssueRankingSupportEnabled,
            isMergedColumnSupportEnabled: isMergedColumnSupportEnabled,
            isFrozenColumnSupportEnabled: isFrozenColumnSupportEnabled,
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
            isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
            onIssueFlatListUpdated: handleIssueFlatListUpdated,
            filter: filter,
            issueAppEntryPoint: (0, $4cTDP.fg)('nin_issue_app_conditional_entrypoint') ? issueAppEntryPoint : undefined
        }), isPostOfficePlacementEnabled && // Disabled in SSR
        !false && (0, $4cTDP.fg)('jira_list_nin_merge') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kyad3.Placement), {
            isDetailedView: selectedView === 'detail',
            hasListPreference: hasListMigrationData,
            ...(0, $4cTDP.fg)('jira_paid_list_nin_merge_onboarding_modal') ? {
                projectName: projectData?.name
            } : {}
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dpNFU.default), {
            hasIssueResults: !!issueResultsData?.totalIssueSearchResultCount,
            userPreferences: userPreferencesData ?? null,
            isAiEnabled: isAiEnabled
        })))))));
    }, [
        isInlineFieldConfigEnabled,
        entryPointActions.load,
        isGrouping,
        hasPreviousPage,
        resolvedJql,
        selectedView,
        projectData,
        jiraViewData,
        entryPointReferenceSubject,
        issueResultsData,
        isPageHydrating,
        IssueNavigatorTopBar,
        isFilterRefinementEnabled,
        filterQueryIsFetching,
        filter,
        filterId,
        hasViewNotFoundError,
        noFilterReason,
        shouldAnnounceInfo,
        hasServerError,
        onChangeColumnConfiguration,
        handleChangeJql,
        jqlBuilderWithAiData,
        groupResultsData,
        issueTableProps,
        isIssueHierarchySupportEnabled,
        isIssueRankingSupportEnabled,
        isMergedColumnSupportEnabled,
        isFrozenColumnSupportEnabled,
        isInBetweenColumnPickerEnabled,
        handleIssueFlatListUpdated,
        issueAppEntryPoint,
        isPostOfficePlacementEnabled,
        hasListMigrationData,
        userPreferencesData,
        isAiEnabled,
        formatMessage,
        displaySsrPlaceholderAttrs
    ]);
    const isFullPageIssueAppMode = (0, $1wL9i.useIsFullPageIssueAppMode)();
    if (isFullPageIssueAppMode) {
        const view = jiraViewData && (0, $iRahl.isJiraIssueSearchViewMetadata)(jiraViewData) ? jiraViewData : null;
        IssueNavigatorContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cZQDI.default), {
            onChangeIssue: onChangeIssue,
            issueResults: issueResultsData ?? null,
            view: view,
            projectType: projectData?.projectType,
            issueAppEntryPoint: (0, $4cTDP.fg)('nin_issue_app_conditional_entrypoint') ? issueAppEntryPoint : undefined
        });
    }
    (0, $lHHP1.useGlobalScopeOptInFlag)();
    const hasIssueResultsData = !!issueResultsData;
    const hasGroupResultsData = !!groupResultsData;
    const hasJiraViewData = !!jiraViewData;
    const hasIssueSearchError = !!caughtIssueSearchError;
    const hasViewResultError = !!viewResultError;
    const hasSearchError = hasServerError || hasIssueSearchError;
    const hasSearchResults = hasIssueResultsData || hasGroupResultsData;
    const isFailedIssueSearch = !hasSearchResults || hasSearchError || !hasJiraViewData || !!viewResultError && viewResultError.statusCode !== 404;
    const isBifrost = !!(0, $iZsVo.ssr).getFeatureFlags()?.ssrViaBifrost;
    return (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, IssueNavigatorContent, (0, $4cTDP.fg)('jira_list_nin_merge') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5eCXQ.SpotlightExploreListClickListener), null), projectData && jiraViewData && (0, $4cTDP.fg)('jira_list_nin_merge') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Eogd.MigrateListConfigClickListener), {
            onChangeJqlAndGroupBy: onChangeJqlAndGroupBy,
            project: projectData,
            view: jiraViewData
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1TTSy.default), null), isInitialized && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), {
            attributes: screenEventAttributes
        }), isFailedIssueSearch ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $51pSU.IssueSearchFail), {
            location: `${(0, $iRahl.PACKAGE_NAME)}.ui`,
            error: caughtIssueSearchError || viewResultError || serverError || new Error('There was an unknown error searching for issues'),
            onPageDataLoad: onPageDataLoad,
            attributes: {
                isAiEnabled: isAiEnabled,
                ...isGrouping ? {
                    experienceId: (0, $iRahl.GROUPED_LIST_EXPERIENCE_ID)
                } : {},
                isBifrost: isBifrost,
                hasIssueSearchError: hasIssueSearchError,
                hasViewResultError: hasViewResultError,
                hasServerError: hasServerError,
                hasIssueResultsData: hasIssueResultsData,
                hasGroupResultsData: hasGroupResultsData,
                hasJiraViewData: hasJiraViewData
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $51pSU.IssueSearchSuccess), {
            onPageDataLoad: onPageDataLoad,
            attributes: {
                isAiEnabled: isAiEnabled,
                ...isGrouping ? {
                    experienceId: (0, $iRahl.GROUPED_LIST_EXPERIENCE_ID)
                } : {},
                isBifrost: isBifrost
            }
        }), (0, $4cTDP.fg)('issue_deletion_two_step_process_free_standard') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih4L6.default), {
            issueId: issueId,
            isDeleteIssueModalOpen: isDeleteIssueModalOpen,
            isDeletingIssue: isDeletingIssue,
            issueKey: issueKey,
            workTypeKey: workType,
            isSimplifiedProject: false,
            shouldShowChildSpecificCopy: true,
            didIssueDeleteFail: didIssueDeleteFail,
            triggerDeleteRequest: onTriggerDeleteRequest,
            triggerCloseDeleteIssueModal: closeDeleteIssueModal,
            onReduxDeleteSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onReduxDeleteFailure: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            ...(0, $4cTDP.fg)('additional-check-for-trigger-from-nin-view') ? {
                isTriggeredFromNINView: isTriggeredFromNINView
            } : {
                isIssueArchivalEnabled: isIssueArchivalEnabled
            }
        })), [
        IssueNavigatorContent,
        isInitialized,
        screenEventAttributes,
        isFailedIssueSearch,
        caughtIssueSearchError,
        viewResultError,
        serverError,
        onChangeJqlAndGroupBy,
        onPageDataLoad,
        projectData,
        isAiEnabled,
        isGrouping,
        isBifrost,
        hasIssueSearchError,
        hasViewResultError,
        hasServerError,
        hasIssueResultsData,
        hasGroupResultsData,
        hasJiraViewData,
        jiraViewData,
        issueId,
        isDeleteIssueModalOpen,
        isDeletingIssue,
        issueKey,
        workType,
        didIssueDeleteFail,
        onTriggerDeleteRequest,
        closeDeleteIssueModal,
        isTriggeredFromNINView,
        isIssueArchivalEnabled
    ]);
};
// re-render regression detection
$a5861a3b1095a50f$export$397fa57fff06920f.whyDidYouRender = true;
var $a5861a3b1095a50f$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eJOHy.memo)($a5861a3b1095a50f$export$397fa57fff06920f);
const $a5861a3b1095a50f$var$IssueNavigatorContentContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedView: selectedView, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _4t3i1osq _19pkidpf _2hwxxy5q _otyridpf _18u0xy5q",
            __cmplp.selectedView !== 'detail' && "_n3tdv47k _vchhusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5Wwfj", function(module, exports) {
$parcel$export(module.exports, "default", () => $17829e74d27dba0b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<341c19e5a80f5a4458ce9e468f278d02>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $17829e74d27dba0b$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "isConditionalFormattingEnabled",
        "variableName": "isConditionalFormattingEnabled"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isSavedViewConditionalFormattingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "main_issueNavigator_IssueNavigatorUI_project",
        "selections": [
            {
                "args": [
                    v0 /*: any*/ 
                ],
                "kind": "FragmentSpread",
                "name": "main_issueNavigator_IssueResults_project"
            },
            {
                "args": [
                    v0 /*: any*/ ,
                    {
                        "kind": "Variable",
                        "name": "isSavedViewConditionalFormattingEnabled",
                        "variableName": "isSavedViewConditionalFormattingEnabled"
                    }
                ],
                "kind": "FragmentSpread",
                "name": "main_issueNavigator_SidebarLayout_project"
            },
            {
                "kind": "FragmentSpread",
                "name": "topBar_issueNavigator_projectResult"
            },
            {
                "kind": "FragmentSpread",
                "name": "MigrateListConfigClickListener_JiraProject"
            },
            {
                "kind": "ScalarField",
                "name": "projectId"
            },
            {
                "kind": "ScalarField",
                "name": "projectType"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    }
                ]
            },
            {
                "condition": "isSavedViewConditionalFormattingEnabled",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "condition": "isConditionalFormattingEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    }
                                ],
                                "concreteType": "JiraFormattingRuleConnection",
                                "kind": "LinkedField",
                                "name": "conditionalFormattingRules",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraFormattingRuleEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "conditionalFormattingRules(first:20)"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraProject"
    };
}();
$17829e74d27dba0b$var$node.hash = "99c558857c1c6668f4d1a0a5652e87b8";
var $17829e74d27dba0b$export$2e2bcd8739ae039 = $17829e74d27dba0b$var$node;

});

parcelRegister("4El0O", function(module, exports) {
$parcel$export(module.exports, "default", () => $8730f2259a19d68a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3785c8aa73a3094fbd32da405a0fb86d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8730f2259a19d68a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_jqlBuilderWithAiKey",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_jqlBuilderWithAiKey"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueResults_rankField"
        }
    ],
    "type": "JiraQuery"
};
$8730f2259a19d68a$var$node.hash = "fc51caf86d12b11398947bb77ddb49ca";
var $8730f2259a19d68a$export$2e2bcd8739ae039 = $8730f2259a19d68a$var$node;

});

parcelRegister("3AgIJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d4fe458dae202c5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1da52f0913815b9fe1e6847953ff7bea>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5d4fe458dae202c5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_userPreferences",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "spotlight_issueNavigator_IssueNavigatorSpotlight"
        }
    ],
    "type": "JiraUserPreferences"
};
$5d4fe458dae202c5$var$node.hash = "aa84b2b1589fd8e695aa782c018fd60c";
var $5d4fe458dae202c5$export$2e2bcd8739ae039 = $5d4fe458dae202c5$var$node;

});

parcelRegister("6zVHq", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c7fb6b485dbb0b2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a17efcb5e0c41f304da35ba7c9f2a4f1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7c7fb6b485dbb0b2$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "amountOfColumns"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsScope"
            },
            {
                "kind": "RootArgument",
                "name": "groupBy"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isSavedViewConditionalFormattingEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "settings"
            },
            {
                "kind": "RootArgument",
                "name": "staticViewInput"
            }
        ],
        "kind": "Fragment",
        "name": "main_issueNavigator_IssueNavigatorUI_jiraView",
        "selections": [
            v0 /*: any*/ ,
            {
                "concreteType": "QueryError",
                "kind": "LinkedField",
                "name": "error",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "statusCode"
                            }
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "message"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "main_issueNavigator_Header_jiraViewResult"
            },
            {
                "kind": "FragmentSpread",
                "name": "main_issueNavigator_IssueResults_jiraView"
            },
            {
                "kind": "FragmentSpread",
                "name": "topBar_issueNavigator_jiraViewResult"
            },
            {
                "kind": "FragmentSpread",
                "name": "MigrateListConfigClickListener_JiraView"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_FullPageIssueApp_view"
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "savedViewId"
                            }
                        ]
                    },
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "filter",
                                "value": {
                                    "fieldSetSelectedState": "SELECTED"
                                }
                            },
                            {
                                "kind": "Variable",
                                "name": "first",
                                "variableName": "amountOfColumns"
                            },
                            {
                                "kind": "Variable",
                                "name": "scope",
                                "variableName": "fieldSetsScope"
                            }
                        ],
                        "concreteType": "JiraIssueSearchFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSets",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueSearchFieldSetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueSearchFieldSet",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraFieldSetPreferences",
                                                "kind": "LinkedField",
                                                "name": "fieldSetPreferences",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "isFrozen"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraIssueSearchViewMetadata",
                "abstractKey": "__isJiraIssueSearchViewMetadata"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "BulkOperationsWrapper_ViewSettings"
                            }
                        ]
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "isSavedViewConditionalFormattingEnabled",
                                "variableName": "isSavedViewConditionalFormattingEnabled"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_SidebarLayout_view"
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "groupBy",
                                "variableName": "groupBy"
                            },
                            {
                                "kind": "Variable",
                                "name": "issueSearchInput",
                                "variableName": "issueSearchInput"
                            },
                            {
                                "kind": "Variable",
                                "name": "settings",
                                "variableName": "settings"
                            },
                            {
                                "kind": "Variable",
                                "name": "staticViewInput",
                                "variableName": "staticViewInput"
                            }
                        ],
                        "concreteType": "JiraIssueSearchViewConfigSettings",
                        "kind": "LinkedField",
                        "name": "viewSettings",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isGroupingEnabled"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "canEnableGrouping"
                            }
                        ]
                    },
                    {
                        "condition": "isSavedViewConditionalFormattingEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    }
                                ],
                                "concreteType": "JiraFormattingRuleConnection",
                                "kind": "LinkedField",
                                "name": "conditionalFormattingRules",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraFormattingRuleEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            v0 /*: any*/ 
                                        ]
                                    }
                                ],
                                "storageKey": "conditionalFormattingRules(first:20)"
                            }
                        ]
                    }
                ],
                "type": "JiraSpreadsheetView",
                "abstractKey": "__isJiraSpreadsheetView"
            }
        ],
        "type": "JiraView",
        "abstractKey": "__isJiraView"
    };
}();
$7c7fb6b485dbb0b2$var$node.hash = "bbf84cd459284c7270eac4dcee2ad37a";
var $7c7fb6b485dbb0b2$export$2e2bcd8739ae039 = $7c7fb6b485dbb0b2$var$node;

});

parcelRegister("3c526", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad4ef0e8910051bf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bccaea827099599c35efdd1a65270e81>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ad4ef0e8910051bf$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_groupResults",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                }
            ],
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueResults_groupResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_groupResults"
        },
        {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$ad4ef0e8910051bf$var$node.hash = "5d6a696ce62196724f5906b5a505895e";
var $ad4ef0e8910051bf$export$2e2bcd8739ae039 = $ad4ef0e8910051bf$var$node;

});

parcelRegister("eeC5x", function(module, exports) {
$parcel$export(module.exports, "default", () => $216a9cdcac113380$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6a9b624843b528c318a9500e747839f2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $216a9cdcac113380$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_issueResults",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "topBar_issueNavigator_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_Header_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_issueResults"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueResults_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_FullPageIssueApp_issueResults"
        },
        {
            "kind": "LinkedField",
            "name": "issueSearchError",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ],
                    "type": "JiraServerError"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        },
        {
            "kind": "FragmentSpread",
            "name": "BulkOperationsWrapper"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasPreviousPage"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$216a9cdcac113380$var$node.hash = "85354c37c3da7037561e059e60c3b925";
var $216a9cdcac113380$export$2e2bcd8739ae039 = $216a9cdcac113380$var$node;

});

parcelRegister("4nnLT", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0763b5f71724a52$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<32d0f95854f22bda290f1a2cbcbb9639>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c0763b5f71724a52$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isSavedViewConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_SidebarLayout_view",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isSavedViewConditionalFormattingEnabled",
                    "variableName": "isSavedViewConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_view"
        }
    ],
    "type": "JiraSpreadsheetView",
    "abstractKey": "__isJiraSpreadsheetView"
};
$c0763b5f71724a52$var$node.hash = "f9655b70707eaa7da316ffe24682274f";
var $c0763b5f71724a52$export$2e2bcd8739ae039 = $c0763b5f71724a52$var$node;

});

parcelRegister("6ZQGt", function(module, exports) {
$parcel$export(module.exports, "default", () => $9fa79edfd2a8bed6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0e0d1ef8d96795a5ae26e4e46076a222>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9fa79edfd2a8bed6$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isSavedViewConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_SidebarLayout_project",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isSavedViewConditionalFormattingEnabled",
                    "variableName": "isSavedViewConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project"
        }
    ],
    "type": "JiraProject"
};
$9fa79edfd2a8bed6$var$node.hash = "9bc206d240f48026ed29dd23bb0b3787";
var $9fa79edfd2a8bed6$export$2e2bcd8739ae039 = $9fa79edfd2a8bed6$var$node;

});

parcelRegister("kyad3", function(module, exports) {
$parcel$export(module.exports, "Placement", () => $27e8e0d5dddc4b93$export$af2bcbdc04a2d456);

var $kCQ9z = parcelRequire("kCQ9z");

var $fScyw = parcelRequire("fScyw");

var $2N4RT = parcelRequire("2N4RT");

var $b5GNq = parcelRequire("b5GNq");

var $eO0S4 = parcelRequire("eO0S4");

var $fKmOn = parcelRequire("fKmOn");
const $27e8e0d5dddc4b93$var$messageBackends = [
    (0, $kCQ9z.MessageBackend)({
        messageTemplateId: 'jira-nin-list-merge-modal-onboarding-v2'
    }),
    (0, $fScyw.MessageBackend)({
        messageTemplateId: 'jira-nin-list-merge-spotlight-onboarding-v2'
    }),
    (0, $2N4RT.MessageBackend)({
        messageTemplateId: 'jira-nin-paid-list-merge-modal-onboarding'
    })
];
const $27e8e0d5dddc4b93$var$messageFrontends = [
    (0, $kCQ9z.MessageFrontend)({
        messageTemplateId: 'jira-nin-list-merge-modal-onboarding-v2'
    }),
    (0, $fScyw.MessageFrontend)({
        messageTemplateId: 'jira-nin-list-merge-spotlight-onboarding-v2'
    }),
    (0, $2N4RT.MessageFrontend)({
        messageTemplateId: 'jira-nin-paid-list-merge-modal-onboarding'
    })
];
const $27e8e0d5dddc4b93$export$fb7710cf8bc72648 = (0, $eO0S4.PlacementBackend).createPlacementBackend({
    messageTemplates: $27e8e0d5dddc4b93$var$messageBackends
});
const $27e8e0d5dddc4b93$export$7b621692a0aa2333 = (0, $eO0S4.PlacementFrontend).createPlacementFrontendComponent({
    messageTemplates: $27e8e0d5dddc4b93$var$messageFrontends
});
const $27e8e0d5dddc4b93$export$af2bcbdc04a2d456 = (0, $fKmOn.withI18n)($27e8e0d5dddc4b93$export$7b621692a0aa2333);
const $27e8e0d5dddc4b93$export$7d3d92a960f07a28 = $27e8e0d5dddc4b93$export$7b621692a0aa2333;
const $27e8e0d5dddc4b93$export$5a7767152ae0305f = $27e8e0d5dddc4b93$export$fb7710cf8bc72648((0, $b5GNq.productionRuntime));

});
parcelRegister("kCQ9z", function(module, exports) {
$parcel$export(module.exports, "MessageBackend", () => $8888d5c8f900eed2$export$e7843a8f64a8d87c);
$parcel$export(module.exports, "MessageFrontend", () => $8888d5c8f900eed2$export$fa9bb46961aca2cc);

var $gt9Am = parcelRequire("gt9Am");

var $9Uh9I = parcelRequire("9Uh9I");

var $eO0S4 = parcelRequire("eO0S4");

var $bLXJh = parcelRequire("bLXJh");
const $8888d5c8f900eed2$export$e7843a8f64a8d87c = (0, $eO0S4.PlacementBackend).createMessageBackend((0, $9Uh9I.defaultMessageBackend));
const $8888d5c8f900eed2$export$fa9bb46961aca2cc = (0, $eO0S4.PlacementFrontend).createMessageFrontend({
    render: {
        validate: (0, $9Uh9I.noValidation)(),
        Component: ({ hasListPreference: hasListPreference, isDetailedView: isDetailedView })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $bLXJh.HighImpactOnboarding), {
                hasListPreference: hasListPreference,
                isDetailedView: isDetailedView
            })
    }
});

});
parcelRegister("eO0S4", function(module, exports) {
$parcel$export(module.exports, "PlacementFrontend", () => $46141733a8061fc5$export$55486c2b6964dcf2);
$parcel$export(module.exports, "PlacementBackend", () => $46141733a8061fc5$export$d90b37843c84d1c3);

var $gt9Am = parcelRequire("gt9Am");

var $kX7CT = parcelRequire("kX7CT");

var $fuwhX = parcelRequire("fuwhX");

var $eJOHy = parcelRequire("eJOHy");
const { createFrontend: $46141733a8061fc5$export$81df3aa6753d44e2, createBackend: $46141733a8061fc5$export$da912f58cb37a643 } = (0, $kX7CT.createPlacement)({
    placementId: `issue-navigator-placement`,
    options: {
        choreographer: {
            isDefaultEnabled: true
        }
    }
});
const $46141733a8061fc5$export$55486c2b6964dcf2 = $46141733a8061fc5$export$81df3aa6753d44e2((Messages)=>(appProps)=>{
        const { data: data, error: error, isLoading: isLoading } = (0, $fuwhX.usePlacementApi)('/');
        const [messages, setMessages] = (0, $eJOHy.useState)([]);
        (0, $eJOHy.useEffect)(()=>{
            if (isLoading || error) return;
            setMessages(data.messages);
        }, [
            data,
            error,
            isLoading
        ]);
        if (error || isLoading || messages.length === 0) return null;
        return !isLoading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: messages?.map?.((props)=>/*#__PURE__*/ (0, $gt9Am.jsx)(Messages.render, {
                    ...props,
                    ...appProps
                }, props.messageInstanceId))
        });
    });
const $46141733a8061fc5$export$d90b37843c84d1c3 = $46141733a8061fc5$export$da912f58cb37a643();

});

parcelRegister("bLXJh", function(module, exports) {
$parcel$export(module.exports, "HighImpactOnboarding", () => $ea0b494b3c0150ee$export$a3f6bfbadcd19631);

var $gt9Am = parcelRequire("gt9Am");

var $fceQU = parcelRequire("fceQU");

var $58yRG = parcelRequire("58yRG");

var $5V25X = parcelRequire("5V25X");

var $k9r6D = parcelRequire("k9r6D");

var $eJOHy = parcelRequire("eJOHy");

var $fKWKJ = parcelRequire("fKWKJ");

var $kSKVt = parcelRequire("kSKVt");

var $4vqJJ = parcelRequire("4vqJJ");

var $gB43g = parcelRequire("gB43g");

var $bhxzP = parcelRequire("bhxzP");

const $ea0b494b3c0150ee$export$a3f6bfbadcd19631 = ({ hasListPreference: hasListPreference, isDetailedView: isDetailedView })=>{
    const [currentStep, setCurrentStep] = (0, $eJOHy.useState)(isDetailedView ? 'detail-view-spotlight' : 'modal');
    const [copyListSettings, setCopyListSettings] = (0, $eJOHy.useState)((0, $bf32e38eb26d885e$export$bb1d7bf832e1561e));
    const { messageInstanceClicked: messageInstanceClicked } = (0, $k9r6D.useMessageInstanceEvent)();
    const dismissMessage = (0, $eJOHy.useCallback)((isTourCompleted = false)=>{
        setCurrentStep('dismissed');
        messageInstanceClicked({
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {},
            clickedElement: {
                buttonType: 'secondary',
                clickedElement: 'button',
                clickIdentifier: isTourCompleted ? 'tourCompleted' : 'dismiss'
            },
            messageEventType: 'clicked'
        });
    }, [
        messageInstanceClicked
    ]);
    const fireExploreEvent = (0, $eJOHy.useCallback)(()=>{
        let clickIdentifier = 'exploreFilters';
        if (hasListPreference) clickIdentifier += copyListSettings === (0, $bf32e38eb26d885e$export$bb1d7bf832e1561e) ? 'WithCopyListSettings' : 'WithoutCopyListSettings';
        messageInstanceClicked({
            action: {
                actionType: 'open'
            },
            additionalMetadataFromFrontend: {},
            clickedElement: {
                buttonType: 'secondary',
                clickedElement: 'button',
                clickIdentifier: clickIdentifier
            },
            messageEventType: 'clicked'
        });
    }, [
        messageInstanceClicked,
        copyListSettings
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const handleEscape = (ev)=>{
            if (ev.key === 'Escape') dismissMessage();
        };
        (0, $fceQU.getDocument)()?.addEventListener('keydown', handleEscape);
        return ()=>{
            (0, $fceQU.getDocument)()?.removeEventListener('keydown', handleEscape);
        };
    }, [
        dismissMessage
    ]);
    const theme = (0, $58yRG.default)();
    const { fireTrigger: fireExploreListViewButtonTriggerWithCopyListSettings } = (0, $5V25X.useFirePostOfficeTrigger)({
        triggerId: 'jira-nin-list-merge-modal-onboarding-explore-list-view-button-clicked-with-copy-list-settings'
    });
    const { fireTrigger: fireExploreListViewButtonTriggerWithoutCopyListSettings } = (0, $5V25X.useFirePostOfficeTrigger)({
        triggerId: 'jira-nin-list-merge-modal-onboarding-explore-list-view-button-clicked-without-copy-list-settings'
    });
    const handleExploreListViewButtonClick = (0, $eJOHy.useCallback)(()=>{
        if (copyListSettings === (0, $bf32e38eb26d885e$export$bb1d7bf832e1561e)) fireExploreListViewButtonTriggerWithCopyListSettings({
            isActive: true
        });
        else fireExploreListViewButtonTriggerWithoutCopyListSettings({
            isActive: true
        });
        setCurrentStep('spotlight-tour');
        fireExploreEvent();
    }, [
        copyListSettings,
        fireExploreListViewButtonTriggerWithCopyListSettings,
        fireExploreListViewButtonTriggerWithoutCopyListSettings,
        fireExploreEvent
    ]);
    const isDarkMode = theme.colorMode === 'dark';
    const listMergeSpotlightIllustration = isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($gB43g))) : (0, (/*@__PURE__*/$parcel$interopDefault($bhxzP)));
    switch(currentStep){
        case 'detail-view-spotlight':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKWKJ.DetailViewSpotlight), {
                setNextStep: ()=>setCurrentStep('spotlight-tour'),
                onDismissed: dismissMessage,
                illustration: listMergeSpotlightIllustration
            });
        case 'modal':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kSKVt.HighImpactModal), {
                hasListPreference: hasListPreference,
                onClose: ()=>dismissMessage(),
                onExploreListViewButtonClick: handleExploreListViewButtonClick,
                copyListSettings: copyListSettings,
                setCopyListSettings: setCopyListSettings
            });
        case 'spotlight-tour':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4vqJJ.HighImpactSpotlightTour), {
                onDismiss: dismissMessage
            });
        default:
            return null;
    }
};

});
parcelRegister("fKWKJ", function(module, exports) {
$parcel$export(module.exports, "DetailViewSpotlight", () => $0494cb175f760c9f$export$855b545a8f028352);
// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package

var $gt9Am = parcelRequire("gt9Am");

var $bdRit = parcelRequire("bdRit");

var $5V25X = parcelRequire("5V25X");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $a8nED = parcelRequire("a8nED");
const $0494cb175f760c9f$export$855b545a8f028352 = ({ setNextStep: setNextStep, onDismissed: onDismissed, illustration: illustration })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { fireTrigger: fireTrigger } = (0, $5V25X.useFirePostOfficeTrigger)({
        triggerId: 'jira-nin-list-merge-modal-onboarding-explore-list-clicked'
    });
    const handleNext = (0, $eJOHy.useCallback)(()=>{
        setNextStep();
        fireTrigger({
            isActive: true
        });
    }, [
        fireTrigger,
        setNextStep
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bdRit.default), {
        actions: [
            {
                onClick: handleNext,
                text: formatMessage((0, $a8nED.messages).exploreListViewButtonLabel)
            },
            {
                onClick: onDismissed,
                text: formatMessage((0, $a8nED.messages).listMergeSpotlightDismiss),
                appearance: 'subtle'
            }
        ],
        heading: formatMessage((0, $a8nED.messages).listMergeSpotlightHeading),
        target: "project-issue-navigator.ui.page-actions.view-switcher",
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        targetRadius: 3,
        dialogWidth: 275,
        image: illustration,
        testId: "list-merge-spotlight",
        dialogPlacement: "left top",
        children: formatMessage((0, $a8nED.messages).listMergeSpotlightBody)
    }, "project-issue-navigator.ui.page-actions.view-switcher");
};

});
parcelRegister("a8nED", function(module, exports) {
$parcel$export(module.exports, "messages", () => $a0a4e6941c50529c$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $a0a4e6941c50529c$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    filterSpotlightMessage: {
        id: 'jira-nin-list-merge-modal-onboarding-v2.spotlight.filter',
        defaultMessage: 'One place to search work and filter results to find what you need.',
        description: 'Message for filter bar on Issue Table'
    },
    dismissButton: {
        id: 'jira-nin-list-merge-modal-onboarding-v2.spotlight.dismiss',
        defaultMessage: 'Dismiss',
        description: 'Dismiss button for the list merge spotlight'
    },
    nextButton: {
        id: 'jira-nin-list-merge-modal-onboarding-v2.spotlight.next',
        defaultMessage: 'Next',
        description: 'Next button for the list merge spotlight'
    },
    moreActionsSpotlightMessage: {
        id: 'jira-nin-list-merge-modal-onboarding-v2.spotlight.more-actions',
        defaultMessage: 'Dive deeper - view work items as a chart, use format rules to highlight key work, and more.',
        description: 'Message for more actions button on Issue Table'
    },
    okButton: {
        id: 'jira-nin-list-merge-modal-onboarding-v2.spotlight.ok',
        defaultMessage: 'OK',
        description: 'OK button for the list merge spotlight'
    },
    listMergeSpotlightHeading: {
        id: 'jira-nin-list-merge-modal-onboarding-v2.spotlight.heading',
        defaultMessage: "We've merged List and All Work views",
        description: 'Heading for the list merge spotlight'
    },
    listMergeSpotlightBody: {
        id: 'jira-nin-list-merge-modal-onboarding-v2.spotlight.body',
        defaultMessage: "We've merged the best of List and All Work into a faster, accessible experience. A new List view.",
        description: 'Body for the list merge spotlight'
    },
    exploreListViewButtonLabel: {
        id: 'jira-nin-list-merge-modal-onboarding-v2.spotlight.explore-list-view-button-label',
        defaultMessage: 'Explore List view',
        description: 'Explore List View button for the list merge spotlight'
    },
    listMergeSpotlightDismiss: {
        id: 'jira-nin-list-merge-modal-onboarding-v2.spotlight.dismiss',
        defaultMessage: 'Dismiss',
        description: 'Dismiss button for the list merge spotlight'
    },
    listMergeSpotlightTellMeMoreAriaLabel: {
        id: 'jira-nin-list-merge-modal-onboarding-v2.spotlight.tell-me-more-aria-label',
        defaultMessage: 'Read our community post about the merge of List and All Work views',
        description: 'Aria label for the tell me more button for the list merge spotlight'
    },
    heading: {
        id: 'jira-nin-list-merge-modal-onboarding-v2.heading',
        defaultMessage: "We've merged List and All Work",
        description: 'Heading for the list merge modal onboarding modal'
    },
    description: {
        id: 'jira-nin-list-merge-modal-onboarding-v2.description',
        defaultMessage: "We've merged the best of List and All Work into a faster, accessible experience. A new List view.",
        description: 'Description for the list merge modal onboarding modal'
    },
    learnMoreLink: {
        id: 'jira-nin-list-merge-modal-onboarding-v2.learnMoreLink',
        defaultMessage: 'Read our community post about the merge of List and All Work views',
        description: 'Link to learn more about the list merge modal onboarding modal'
    },
    closeButton: {
        id: 'jira-nin-list-merge-modal-onboarding-v2.closeButton',
        defaultMessage: 'Close',
        description: 'Label for the close button in the list merge modal onboarding modal'
    },
    filtersAndGroupsDescription: {
        id: 'jira-nin-list-merge-modal-onboarding-v2.filtersAndGroupsDescription',
        defaultMessage: 'Any existing filters and groups will be applied.',
        description: 'Description for the filters and groups in the list merge modal onboarding modal'
    },
    copyListSettingsYes: {
        id: 'jira-nin-list-merge-modal-onboarding-v2.copyListSettingsYes',
        defaultMessage: 'Yes',
        description: 'Label for the yes button in the list merge modal onboarding modal'
    },
    copyListSettingsNo: {
        id: 'jira-nin-list-merge-modal-onboarding-v2.copyListSettingsNo',
        defaultMessage: 'No',
        description: 'Label for the no button in the list merge modal onboarding modal'
    },
    copyListSettingsDescription: {
        id: 'jira-nin-list-merge-modal-onboarding-v2.copyListSettingsDescription',
        defaultMessage: 'Want us to apply your current filter and group settings to this new List view?',
        description: 'Description to allow user to choose to copy list settings to new List view'
    }
});

});


parcelRegister("kSKVt", function(module, exports) {
$parcel$export(module.exports, "HighImpactModal", () => $60a4fa4618b1f722$export$cfef29d0c2867291);
/* HighImpactModal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5CSKW = parcelRequire("5CSKW");

var $806LH = parcelRequire("806LH");

var $eJ9f5 = parcelRequire("eJ9f5");

var $lgMTT = parcelRequire("lgMTT");

var $gHHv2 = parcelRequire("gHHv2");

var $3cMgR = parcelRequire("3cMgR");

var $a6tuu = parcelRequire("a6tuu");

var $1wLnx = parcelRequire("1wLnx");

var $gr4vM = parcelRequire("gr4vM");

var $lRq8t = parcelRequire("lRq8t");

var $1vuxX = parcelRequire("1vuxX");

var $a8nED = parcelRequire("a8nED");

const $60a4fa4618b1f722$var$linkContainerStyles = null;
const $60a4fa4618b1f722$var$ModalContentWithListPreference = ({ copyListSettings: copyListSettings, setCopyListSettings: setCopyListSettings })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                children: formatMessage((0, $a8nED.messages).description)
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_1e0c1txw _1jc212b0 _1wij12b0 _ufn21i6y _40h81i6y"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                    href: (0, $bf32e38eb26d885e$export$36414237f2da9bd9),
                    target: "_blank",
                    children: formatMessage((0, $a8nED.messages).learnMoreLink)
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                weight: "bold",
                children: formatMessage((0, $a8nED.messages).copyListSettingsDescription)
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $a6tuu.default), {
                options: [
                    {
                        label: formatMessage((0, $a8nED.messages).copyListSettingsYes),
                        value: (0, $bf32e38eb26d885e$export$bb1d7bf832e1561e)
                    },
                    {
                        label: formatMessage((0, $a8nED.messages).copyListSettingsNo),
                        value: (0, $bf32e38eb26d885e$export$fed7c2c712a139d8)
                    }
                ],
                defaultValue: copyListSettings,
                onChange: (event)=>{
                    // eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-all-member-expressions
                    setCopyListSettings(event.target.value);
                }
            })
        ]
    });
};
const $60a4fa4618b1f722$var$ModalContentWithoutListPreference = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                children: formatMessage((0, $a8nED.messages).description)
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                children: formatMessage((0, $a8nED.messages).filtersAndGroupsDescription)
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_1e0c1txw _1jc212b0 _1wij12b0 _ufn21i6y _40h81i6y"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                    href: (0, $bf32e38eb26d885e$export$36414237f2da9bd9),
                    target: "_blank",
                    children: formatMessage((0, $a8nED.messages).learnMoreLink)
                })
            })
        ]
    });
};
const $60a4fa4618b1f722$export$cfef29d0c2867291 = ({ onClose: onClose, onExploreListViewButtonClick: onExploreListViewButtonClick, hasListPreference: hasListPreference, copyListSettings: copyListSettings, setCopyListSettings: setCopyListSettings })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $gr4vM.useFirePostOfficeAnalyticsEvents)();
    const exploreButtonRef = (0, $eJOHy.useRef)(null);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gHHv2.default), {
        width: (0, $bf32e38eb26d885e$export$3d931b64f46140b3),
        height: (0, $bf32e38eb26d885e$export$1dd7793cb602b5ab),
        onOpenComplete: ()=>{
            fireAnalyticsEvent({
                eventType: 'screen',
                name: 'jiraNinListMergeModalOnboardingViewed',
                attributes: {
                    hasListPreference: hasListPreference
                }
            });
        },
        onCloseComplete: ()=>{
            fireAnalyticsEvent({
                eventType: 'screen',
                name: 'jiraNinListMergeModalOnboardingClosed',
                attributes: {
                    hasListPreference: hasListPreference
                }
            });
        },
        testId: "high-impact-modal",
        autoFocus: exploreButtonRef,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1wLnx.Modal), {
            renderedInsideEntrypoint: true,
            title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                size: "medium",
                children: formatMessage((0, $a8nED.messages).heading)
            }),
            sideContent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1vuxX.ModalOnboardingImage), {
                onClose: onClose
            }),
            actions: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                appearance: "primary",
                onClick: onExploreListViewButtonClick,
                ref: exploreButtonRef,
                children: formatMessage((0, $a8nED.messages).exploreListViewButtonLabel)
            }),
            logo: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.JiraIcon), {
                appearance: "brand",
                shouldUseNewLogoDesign: true
            }),
            children: hasListPreference ? /*#__PURE__*/ (0, $gt9Am.jsx)($60a4fa4618b1f722$var$ModalContentWithListPreference, {
                copyListSettings: copyListSettings,
                setCopyListSettings: setCopyListSettings
            }) : /*#__PURE__*/ (0, $gt9Am.jsx)($60a4fa4618b1f722$var$ModalContentWithoutListPreference, {})
        })
    });
};

});
parcelRegister("a6tuu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $de7bef9bf1f92e14$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");

var $gl2vi = parcelRequire("gl2vi");

var $gPG64 = parcelRequire("gPG64");
const $de7bef9bf1f92e14$var$noOptions = [];
function $de7bef9bf1f92e14$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options = $de7bef9bf1f92e14$var$noOptions, value: propValue, defaultValue: defaultValue, id: id, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, labelId: labelId, onInvalid: onInvalid = (0, $3Vuhz.default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
    const uid = (0, $gl2vi.useId)();
    const [selectedValue, setSelectedValue] = (0, $eJOHy.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "radiogroup",
        // TODO: Make `aria-labelledby` a `never` in TS. See https://product-fabric.atlassian.net/browse/DSP-23009
        "aria-labelledby": labelId || ariaLabelledBy,
        "data-testid": testId,
        "aria-describedby": isInvalid ? `${id || uid}-error` : undefined,
        id: id || uid,
        children: options.map(({ ...optionProps }, index)=>{
            if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
            const isChecked = value !== null && optionProps.value === value;
            return /*#__PURE__*/ (0, $eJOHy.createElement)((0, $gPG64.default), {
                ...optionProps,
                name: name || optionProps.name,
                key: index,
                onChange: onRadioChange,
                onInvalid: onInvalid,
                isInvalid: isChecked && isInvalid,
                isChecked: isChecked,
                testId: optionProps.testId || testId,
                isRequired: isRequired,
                analyticsContext: analyticsContext
            });
        })
    });
}

});
parcelRegister("gPG64", function(module, exports) {
$parcel$export(module.exports, "default", () => $e69f9767f170f926$export$2e2bcd8739ae039);
/* radio.tsx generated by @compiled/babel-plugin v0.36.1 */ /// <reference types="node" />
// for typing `process`

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $eGOwo = parcelRequire("eGOwo");
const $e69f9767f170f926$var$packageName = "platform-pkg";
const $e69f9767f170f926$var$packageVersion = "0.0.0-use.local";
const $e69f9767f170f926$var$noop = (0, $3Vuhz.default);
const $e69f9767f170f926$var$labelPaddingStyles = null;
const $e69f9767f170f926$var$labelStyles = null;
const $e69f9767f170f926$var$radioStyles = null;
const $e69f9767f170f926$var$newRadioStyles = null;
const $e69f9767f170f926$var$InnerRadio = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, 'aria-labelledby': ariaLabelledBy, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, labelId: labelId, name: name, onChange: onChange = $e69f9767f170f926$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $e69f9767f170f926$var$packageName,
        packageVersion: $e69f9767f170f926$var$packageVersion
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $hcewu.default)([
            "_11c82smr _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazj3m3 _mqf81tvo _g7st13gf"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                ...rest,
                tabIndex: 0,
                "aria-label": ariaLabel,
                "aria-labelledby": labelId || ariaLabelledBy,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $hcewu.default)([
                    "_18s8ze3t _19it3vzd _2rko1qll _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6qmag2 _11511fmg _1s6w1qbb _tqbwidpf _t9ec1s1q _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1qll _qc5orqeg _z0ai1cbz _1qdg1cbz _18postnw _aetrb3bt _1peq1xmd _iosizyvw _11jyzyvw _f3ett94y _19ybk8x7 _1d7pk8x7 _j5dh13gf _scgf13gf _4fps13gf _5ry313gf _qep213gf _180n13gf _1gcs13gf _1x1a13gf _6hp813gf _4rya1y1w _o1bd1y1w _2kbk1y1w _6cyr1y1w _n8t01y1w _1o5r1y1w _nxi61y1w _neoe1y1w _1el21y1w _lekrzcs9 _11v7zcs9 _1if1zcs9 _bl0ezcs9 _92nazcs9 _awurzcs9 _1f8czcs9 _s2ftzcs9 _17a1zcs9 _x48a15t7 _1ib215t7 _wml015t7 _tusm15t7 _1c6f15t7 _qftt15t7 _1yk915t7 _gdmb15t7 _pmm415t7 _y2mvjdfc _1bg41l7b _6tjkjdfc _awqn1l7b _1rvq10ko _1p9j1fmg _x2tzhh5a _1iwzhh5a _sj8y1wq0 _jckox2ru _1dvd1fmg _60ak1dzn",
                    (0, $eGOwo.fg)('platform-visual-refresh-icons') && "_t9ec1soj _z0ai120g _1qdg120g"
                ])
            }),
            label ? /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                className: (0, $hcewu.default)([
                    "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
                ]),
                children: label
            }) : null
        ]
    });
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $e69f9767f170f926$var$Radio = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($e69f9767f170f926$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $e69f9767f170f926$export$2e2bcd8739ae039 = $e69f9767f170f926$var$Radio;

});


parcelRegister("1wLnx", function(module, exports) {
$parcel$export(module.exports, "Modal", () => $2f7b0f0f93e32b95$export$2b77a92f1a5ad772);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gxxFp = parcelRequire("gxxFp");
var $gHHv2 = parcelRequire("gHHv2");

var $8nu6j = parcelRequire("8nu6j");
var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $6efFi = parcelRequire("6efFi");

var $3b6ZN = parcelRequire("3b6ZN");

var $iwWiK = parcelRequire("iwWiK");

var $h249o = parcelRequire("h249o");
const $2f7b0f0f93e32b95$var$hasSideContentContainerStyles = (0, $1DXK0.xcss)({
    position: 'relative',
    overflowY: 'auto',
    height: '100%',
    borderRadius: 'radius.small',
    [(0, $6efFi.media).above.sm]: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr'
    }
});
const $2f7b0f0f93e32b95$var$baseContainerStyles = (0, $1DXK0.xcss)({
    position: 'relative'
});
const $2f7b0f0f93e32b95$var$stack = (0, $1DXK0.xcss)({
    height: '100%',
    padding: 'space.600',
    overflowY: 'auto'
});
const $2f7b0f0f93e32b95$var$sideContainer = (0, $1DXK0.xcss)({
    display: 'none',
    [(0, $6efFi.media).above.sm]: {
        backgroundColor: 'color.background.accent.gray.subtlest',
        display: 'flex',
        width: '100%',
        overflowY: 'auto'
    }
});
const $2f7b0f0f93e32b95$var$leftSideContainer = (0, $1DXK0.xcss)({
    [(0, $6efFi.media).above.sm]: {
        borderTopLeftRadius: 'radius.small',
        borderBottomLeftRadius: 'radius.small'
    }
});
const $2f7b0f0f93e32b95$var$rightSideContainer = (0, $1DXK0.xcss)({
    [(0, $6efFi.media).above.sm]: {
        borderTopRightRadius: 'radius.small',
        borderBottomRightRadius: 'radius.small'
    }
});
const $2f7b0f0f93e32b95$var$closeButtonStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    top: 'space.200',
    right: 'space.200',
    zIndex: '1'
});
const $2f7b0f0f93e32b95$export$2b77a92f1a5ad772 = ({ logo: logo, title: title, subtitle: subtitle, children: children, actions: actions, right: right, sideContent: sideContent, sideLocation: sideLocation = 'right', renderedInsideEntrypoint: renderedInsideEntrypoint, backgroundColor: backgroundColor, includeCloseButton: includeCloseButton = false, ...modalProps })=>{
    const hasSideContent = !!right || !!sideContent;
    const rightContent = right ?? (sideLocation === 'right' ? sideContent : undefined);
    const leftContent = !right && sideLocation === 'left' ? sideContent : undefined;
    const safeOnClose = typeof modalProps.onClose === 'function' ? modalProps.onClose : ()=>{};
    if (renderedInsideEntrypoint) return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8nu6j.default), {
        xcss: [
            $2f7b0f0f93e32b95$var$baseContainerStyles,
            hasSideContent ? $2f7b0f0f93e32b95$var$hasSideContentContainerStyles : undefined
        ],
        backgroundColor: backgroundColor,
        style: {
            height: modalProps.height
        },
        children: [
            includeCloseButton && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: $2f7b0f0f93e32b95$var$closeButtonStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gxxFp.CloseButton), {
                    testId: "modal-close-button",
                    onClick: safeOnClose
                })
            }),
            !!leftContent && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: [
                    $2f7b0f0f93e32b95$var$sideContainer,
                    $2f7b0f0f93e32b95$var$leftSideContainer
                ],
                children: leftContent
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dW738.default), {
                space: "space.400",
                xcss: $2f7b0f0f93e32b95$var$stack,
                children: [
                    logo,
                    /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dW738.default), {
                        space: "space.200",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h249o.ModalTitle), {
                                children: title
                            }),
                            subtitle ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                                color: "color.text.subtle",
                                size: "medium",
                                children: subtitle
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3b6ZN.ModalBody), {
                        children: children
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iwWiK.ModalFooter), {
                        children: actions
                    })
                ]
            }),
            !!rightContent && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: [
                    $2f7b0f0f93e32b95$var$sideContainer,
                    $2f7b0f0f93e32b95$var$rightSideContainer
                ],
                children: rightContent
            })
        ]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gHHv2.default), {
        width: hasSideContent ? 'x-large' : undefined,
        ...modalProps,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8nu6j.default), {
            xcss: [
                $2f7b0f0f93e32b95$var$baseContainerStyles,
                hasSideContent ? $2f7b0f0f93e32b95$var$hasSideContentContainerStyles : undefined
            ],
            backgroundColor: backgroundColor,
            children: [
                includeCloseButton && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                    xcss: $2f7b0f0f93e32b95$var$closeButtonStyles,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gxxFp.CloseButton), {
                        testId: "modal-close-button",
                        onClick: safeOnClose
                    })
                }),
                !!leftContent && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                    xcss: [
                        $2f7b0f0f93e32b95$var$sideContainer,
                        $2f7b0f0f93e32b95$var$leftSideContainer
                    ],
                    children: leftContent
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dW738.default), {
                    space: "space.400",
                    xcss: $2f7b0f0f93e32b95$var$stack,
                    children: [
                        logo,
                        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dW738.default), {
                            space: "space.200",
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h249o.ModalTitle), {
                                    children: title
                                }),
                                subtitle ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                                    color: "color.text.subtle",
                                    size: "medium",
                                    children: subtitle
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3b6ZN.ModalBody), {
                            children: children
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iwWiK.ModalFooter), {
                            children: actions
                        })
                    ]
                }),
                !!rightContent && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                    xcss: [
                        $2f7b0f0f93e32b95$var$sideContainer,
                        $2f7b0f0f93e32b95$var$rightSideContainer
                    ],
                    children: rightContent
                })
            ]
        })
    });
};

});
parcelRegister("3b6ZN", function(module, exports) {
$parcel$export(module.exports, "ModalBody", () => $9c6f2f6c9feb8038$export$cb540d8b0ef7906c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $ecYd5 = parcelRequire("ecYd5");

var $ioK9M = parcelRequire("ioK9M");

var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");
const $9c6f2f6c9feb8038$var$container = (0, $1DXK0.xcss)({
    flex: '1 1 auto',
    overflowY: 'auto'
});
const $9c6f2f6c9feb8038$export$cb540d8b0ef7906c = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $ioK9M.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ecYd5.TouchScrollable), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dW738.default), {
            space: "space.300",
            xcss: $9c6f2f6c9feb8038$var$container,
            testId: testId,
            children: children
        })
    });
};

});

parcelRegister("iwWiK", function(module, exports) {
$parcel$export(module.exports, "ModalFooter", () => $6cb057bc7f6eee09$export$519437715052e656);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $ioK9M = parcelRequire("ioK9M");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");
const $6cb057bc7f6eee09$var$wrapStyles = (0, $1DXK0.xcss)({
    flexWrap: 'wrap-reverse'
});
const $6cb057bc7f6eee09$export$519437715052e656 = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $ioK9M.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3Wh6p.default), {
        alignInline: "end",
        testId: testId,
        space: "space.150",
        xcss: $6cb057bc7f6eee09$var$wrapStyles,
        children: children
    });
};

});

parcelRegister("h249o", function(module, exports) {
$parcel$export(module.exports, "ModalTitle", () => $a3e1beabe7036c29$export$b26fae16ba5468aa);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $ioK9M = parcelRequire("ioK9M");
const $a3e1beabe7036c29$export$b26fae16ba5468aa = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { titleId: titleId, testId: modalTestId } = (0, $ioK9M.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
        testId: testId,
        size: "large",
        id: titleId,
        children: children
    });
};

});


parcelRegister("1vuxX", function(module, exports) {
$parcel$export(module.exports, "ModalOnboardingImage", () => $9c48c65283100895$export$a23f0cdca47d1d7c);
/* ModalOnboardingImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $Ay1uj = parcelRequire("Ay1uj");

var $6zhpo = parcelRequire("6zhpo");

var $8wyVH = parcelRequire("8wyVH");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $a8nED = parcelRequire("a8nED");

var $iGKqk = parcelRequire("iGKqk");

var $9C6nE = parcelRequire("9C6nE");
const $9c48c65283100895$var$imageStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden',
    position: 'relative',
    width: '100%'
});
const $9c48c65283100895$var$onboardingImageStyles = null;
const $9c48c65283100895$var$closeButtonContainerStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    top: 'space.100',
    right: 'space.100',
    zIndex: 'modal',
    borderWidth: "var(--ds-border-width, 1px)",
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $9c48c65283100895$export$a23f0cdca47d1d7c = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8nu6j.default), {
        xcss: $9c48c65283100895$var$imageStyles,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8wyVH.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($9C6nE))),
                srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($iGKqk))),
                className: (0, $hcewu.default)([
                    "_1bsb1osq"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: $9c48c65283100895$var$closeButtonContainerStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                    appearance: "subtle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))),
                    onClick: onClose,
                    label: formatMessage((0, $a8nED.messages).closeButton),
                    testId: "high-impact-modal-close-button"
                })
            })
        ]
    });
};

});
parcelRegister("iGKqk", function(module, exports) {
module.exports = new URL("list-merge-modal-dark.45013aa2.gif", import.meta.url).toString();

});

parcelRegister("9C6nE", function(module, exports) {
module.exports = new URL("list-merge-modal-light.8f13cf58.gif", import.meta.url).toString();

});


const $bf32e38eb26d885e$export$1dd7793cb602b5ab = 568;
const $bf32e38eb26d885e$export$3d931b64f46140b3 = 968;
const $bf32e38eb26d885e$export$71e890a4fd009236 = 'jira-nin-list-merge-modal-onboarding-explore-list-view-button-clicked-with-copy-list-settings';
const $bf32e38eb26d885e$export$f7ec866151f0b684 = 'jira-nin-list-merge-modal-onboarding-explore-list-view-button-clicked-without-copy-list-settings';
const $bf32e38eb26d885e$export$36414237f2da9bd9 = 'https://community.atlassian.com/forums/Jira-articles/We-re-merging-List-and-All-work-one-powerful-view-for-all-teams/ba-p/3090105';
const $bf32e38eb26d885e$export$bb1d7bf832e1561e = 'yes';
const $bf32e38eb26d885e$export$fed7c2c712a139d8 = 'no';


parcelRegister("4vqJJ", function(module, exports) {
$parcel$export(module.exports, "HighImpactSpotlightTour", () => $3dce8376ba2d5a8d$export$496fe117accb431d);
// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package

var $gt9Am = parcelRequire("gt9Am");

var $d2s5v = parcelRequire("d2s5v");

var $k9r6D = parcelRequire("k9r6D");

var $eJOHy = parcelRequire("eJOHy");

var $8sxVI = parcelRequire("8sxVI");

var $hdTQa = parcelRequire("hdTQa");
const $3dce8376ba2d5a8d$export$496fe117accb431d = ({ onDismiss: onDismiss })=>{
    const { messageInstanceClicked: messageInstanceClicked } = (0, $k9r6D.useMessageInstanceEvent)();
    const [activeSpotlight, setActiveSpotlight] = (0, $eJOHy.useState)(0);
    const next = ()=>{
        setActiveSpotlight((activeSpotlight || 0) + 1);
        messageInstanceClicked({
            action: {
                actionType: 'open'
            },
            additionalMetadataFromFrontend: {},
            clickedElement: {
                buttonType: 'secondary',
                clickedElement: 'button',
                clickIdentifier: 'exploreActions'
            },
            messageEventType: 'clicked'
        });
    };
    const endTour = (isTourCompleted = false)=>{
        setActiveSpotlight(null);
        onDismiss(isTourCompleted);
    };
    const renderActiveSpotlight = ()=>{
        const spotlights = [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8sxVI.FilterSpotlight), {
                onNext: next,
                onDismiss: endTour
            }, "filter-spotlight"),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hdTQa.MoreActionsSpotlight), {
                onFinish: endTour
            }, "more-actions-spotlight")
        ];
        if (activeSpotlight === null) return null;
        return spotlights[activeSpotlight];
    };
    if (activeSpotlight === null) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d2s5v.default), {
        children: renderActiveSpotlight()
    });
};

});
parcelRegister("8sxVI", function(module, exports) {
$parcel$export(module.exports, "FilterSpotlight", () => $5cfdbdac6dfa1308$export$4005bec6f6b919b);
// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package

var $gt9Am = parcelRequire("gt9Am");

var $bdRit = parcelRequire("bdRit");

var $lRq8t = parcelRequire("lRq8t");

var $a8nED = parcelRequire("a8nED");
const $5cfdbdac6dfa1308$export$4005bec6f6b919b = ({ onNext: onNext, onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bdRit.default), {
        actions: [
            {
                onClick: onNext,
                text: formatMessage((0, $a8nED.messages).nextButton)
            },
            {
                onClick: ()=>onDismiss(),
                text: formatMessage((0, $a8nED.messages).dismissButton),
                appearance: 'subtle'
            }
        ],
        target: "jql-builder.ui.jql-builder.editor",
        targetRadius: 3,
        dialogWidth: 285,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        actionsBeforeElement: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: "1/2"
        }),
        testId: "filter-spotlight",
        children: formatMessage((0, $a8nED.messages).filterSpotlightMessage)
    }, "jql-builder.ui.jql-builder.editor");
};

});

parcelRegister("hdTQa", function(module, exports) {
$parcel$export(module.exports, "MoreActionsSpotlight", () => $41fc5d5fc5552681$export$61de96b079e717f0);
// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package

var $gt9Am = parcelRequire("gt9Am");

var $bdRit = parcelRequire("bdRit");

var $lRq8t = parcelRequire("lRq8t");

var $a8nED = parcelRequire("a8nED");
const $41fc5d5fc5552681$export$61de96b079e717f0 = ({ onFinish: onFinish })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bdRit.default), {
        actions: [
            {
                onClick: ()=>onFinish(true),
                text: formatMessage((0, $a8nED.messages).okButton)
            }
        ],
        target: "project-issue-navigator.ui.page-actions.meatball-menu",
        targetRadius: 3,
        dialogWidth: 285,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        actionsBeforeElement: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: "2/2"
        }),
        testId: "more-actions-spotlight",
        dialogPlacement: "left top",
        children: formatMessage((0, $a8nED.messages).moreActionsSpotlightMessage)
    }, "project-issue-navigator.ui.page-actions.meatball-menu");
};

});


parcelRegister("gB43g", function(module, exports) {
module.exports = new URL("list-merge-spotlight-dark.79a7436a.gif", import.meta.url).toString();

});

parcelRegister("bhxzP", function(module, exports) {
module.exports = new URL("list-merge-spotlight-light.b81dbbfb.gif", import.meta.url).toString();

});



parcelRegister("fScyw", function(module, exports) {
$parcel$export(module.exports, "MessageBackend", () => $932d822659425491$export$e7843a8f64a8d87c);
$parcel$export(module.exports, "MessageFrontend", () => $932d822659425491$export$fa9bb46961aca2cc);

var $gt9Am = parcelRequire("gt9Am");

var $9Uh9I = parcelRequire("9Uh9I");

var $eO0S4 = parcelRequire("eO0S4");

var $ShYcT = parcelRequire("ShYcT");
const $932d822659425491$export$e7843a8f64a8d87c = (0, $eO0S4.PlacementBackend).createMessageBackend((0, $9Uh9I.defaultMessageBackend));
const $932d822659425491$export$fa9bb46961aca2cc = (0, $eO0S4.PlacementFrontend).createMessageFrontend({
    render: {
        validate: (0, $9Uh9I.noValidation)(),
        Component: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $ShYcT.ListMergeSpotlightTour), {})
    }
});

});
parcelRegister("ShYcT", function(module, exports) {
$parcel$export(module.exports, "ListMergeSpotlightTour", () => $075d96ed134bc764$export$da08849aaafc8b0d);

var $gt9Am = parcelRequire("gt9Am");

var $fceQU = parcelRequire("fceQU");

var $bdRit = parcelRequire("bdRit");
var $d2s5v = parcelRequire("d2s5v");

var $01wZP = parcelRequire("01wZP");

var $k9r6D = parcelRequire("k9r6D");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $1BvJ3 = parcelRequire("1BvJ3");

var $eH8FO = parcelRequire("eH8FO");

var $2P6We = parcelRequire("2P6We");
const $075d96ed134bc764$export$36414237f2da9bd9 = 'https://community.atlassian.com/forums/Jira-articles/We-re-merging-List-and-All-work-one-powerful-view-for-all-teams/ba-p/3090105';
const $075d96ed134bc764$export$da08849aaafc8b0d = ({ withIllustration: withIllustration = true })=>{
    const [isActive, setIsActive] = (0, $eJOHy.useState)(true);
    const { messageInstanceClicked: messageInstanceClicked } = (0, $k9r6D.useMessageInstanceEvent)();
    const isDarkMode = (0, $01wZP.default)().colorMode === 'dark';
    const Illustration = isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($eH8FO))) : (0, (/*@__PURE__*/$parcel$interopDefault($2P6We)));
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleDismiss = (0, $eJOHy.useCallback)(()=>{
        setIsActive(false);
        messageInstanceClicked({
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {},
            clickedElement: {
                buttonType: 'secondary',
                clickedElement: 'button',
                clickIdentifier: 'dismiss'
            },
            messageEventType: 'clicked'
        });
    }, [
        messageInstanceClicked
    ]);
    const handleTellMeMore = (0, $eJOHy.useCallback)(()=>{
        // eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-all-member-expressions
        window.open($075d96ed134bc764$export$36414237f2da9bd9);
        handleDismiss();
    }, [
        handleDismiss
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const handleEscape = (ev)=>{
            if (ev.key === 'Escape') handleDismiss();
        };
        (0, $fceQU.getDocument)()?.addEventListener('keydown', handleEscape);
        return ()=>{
            (0, $fceQU.getDocument)()?.removeEventListener('keydown', handleEscape);
        };
    }, [
        handleDismiss
    ]);
    return isActive && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d2s5v.default), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bdRit.default), {
            actions: [
                {
                    onClick: handleTellMeMore,
                    text: formatMessage((0, $1BvJ3.spotlightMessages).spotlightTellMeMore),
                    'aria-label': formatMessage((0, $1BvJ3.spotlightMessages).tellMeMoreAriaLabel)
                },
                {
                    onClick: handleDismiss,
                    text: formatMessage((0, $1BvJ3.spotlightMessages).spotlightDismiss),
                    appearance: 'subtle'
                }
            ],
            heading: formatMessage((0, $1BvJ3.spotlightMessages).spotlightHeading),
            target: "horizontal-nav-tabs.LIST",
            targetRadius: 3,
            targetBgColor: 'var(--project-background-input)',
            dialogWidth: 275,
            image: withIllustration ? Illustration : undefined,
            pulse: true,
            children: formatMessage((0, $1BvJ3.spotlightMessages).spotlightBody)
        }, "horizontal-nav-tabs.LIST")
    });
};
var $075d96ed134bc764$export$2e2bcd8739ae039 = $075d96ed134bc764$export$da08849aaafc8b0d;

});
parcelRegister("1BvJ3", function(module, exports) {
$parcel$export(module.exports, "spotlightMessages", () => $2e8e6a5153789b83$export$ba730283fc11b703);

var $7qGN1 = parcelRequire("7qGN1");
const $2e8e6a5153789b83$export$ba730283fc11b703 = (0, $7qGN1.defineMessages)({
    spotlightHeading: {
        id: 'jira-nin-list-merge-spotlight-onboarding.spotlight.heading',
        defaultMessage: "We've merged List and All Work views",
        description: 'Heading for the list merge spotlight'
    },
    spotlightBody: {
        id: 'jira-nin-list-merge-spotlight-onboarding.spotlight.body',
        defaultMessage: "We've merged the best of List and All Work into a faster, accessible experience.",
        description: 'Body for the list merge spotlight'
    },
    spotlightTellMeMore: {
        id: 'jira-nin-list-merge-spotlight-onboarding.spotlight.tell-me-more',
        defaultMessage: 'Tell me more',
        description: 'Tell me more button for the list merge spotlight'
    },
    spotlightDismiss: {
        id: 'jira-nin-list-merge-spotlight-onboarding.spotlight.dismiss',
        defaultMessage: 'Dismiss',
        description: 'Dismiss button for the list merge spotlight'
    },
    tellMeMoreAriaLabel: {
        id: 'jira-nin-list-merge-spotlight-onboarding.spotlight.tell-me-more-aria-label',
        defaultMessage: 'Read our community post about the merge of List and All Work views',
        description: 'Aria label for the tell me more button for the list merge spotlight'
    }
});

});

parcelRegister("eH8FO", function(module, exports) {
module.exports = new URL("list-merge-spotlight-dark.79a7436a.gif", import.meta.url).toString();

});

parcelRegister("2P6We", function(module, exports) {
module.exports = new URL("list-merge-spotlight-light.b81dbbfb.gif", import.meta.url).toString();

});



parcelRegister("2N4RT", function(module, exports) {
$parcel$export(module.exports, "MessageBackend", () => $36331821ab79ad3e$export$e7843a8f64a8d87c);
$parcel$export(module.exports, "MessageFrontend", () => $36331821ab79ad3e$export$fa9bb46961aca2cc);

var $gt9Am = parcelRequire("gt9Am");

var $9Uh9I = parcelRequire("9Uh9I");

var $eO0S4 = parcelRequire("eO0S4");

var $brNOA = parcelRequire("brNOA");
const $36331821ab79ad3e$var$hasConfiguredProjectsFromLocalStorage = ()=>{
    try {
        const regex = /^__storejs_jwm-view-preferences_(\d+)_list_(fieldsDetail|filter|groupBy)$/;
        return Object.keys(globalThis.localStorage).some((key)=>regex.test(key));
    } catch (error) {
        return false;
    }
};
const $36331821ab79ad3e$export$e7843a8f64a8d87c = (0, $eO0S4.PlacementBackend).createMessageBackend((0, $9Uh9I.defaultMessageBackend));
const $36331821ab79ad3e$export$fa9bb46961aca2cc = (0, $eO0S4.PlacementFrontend).createMessageFrontend({
    render: {
        validate: (0, $9Uh9I.noValidation)(),
        Component: ({ projectName: projectName, hasListPreference: hasListPreference })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $brNOA.HighImpactOnboarding), {
                hasListPreference: hasListPreference || $36331821ab79ad3e$var$hasConfiguredProjectsFromLocalStorage(),
                projectName: projectName
            })
    }
});

});
parcelRegister("brNOA", function(module, exports) {
$parcel$export(module.exports, "HighImpactOnboarding", () => $7255dee1141d88d9$export$a3f6bfbadcd19631);

var $gt9Am = parcelRequire("gt9Am");

var $fceQU = parcelRequire("fceQU");

var $5V25X = parcelRequire("5V25X");

var $k9r6D = parcelRequire("k9r6D");

var $eJOHy = parcelRequire("eJOHy");

var $ikwzO = parcelRequire("ikwzO");

var $f1mOK = parcelRequire("f1mOK");


var $gr4vM = parcelRequire("gr4vM");
// These triggers correspond to the Listener in the issue navigator package
// jira/src/packages/issue-navigator/issue-navigator/src/ui/spotlight/migrate-list-config-click-listener/MigrateListConfigClickListener.tsx
const $7255dee1141d88d9$var$MIGRATE_CONFIG_TRIGGER_PAID_CURRENT_SPACE = 'jira-nin-paid-list-merge-modal-onboarding-explore-list-view-button-clicked-migrate-current-space';
const $7255dee1141d88d9$var$MIGRATE_CONFIG_TRIGGER_PAID_ALL_SPACES = 'jira-nin-paid-list-merge-modal-onboarding-explore-list-view-button-clicked-migrate-all-spaces';
const $7255dee1141d88d9$export$a3f6bfbadcd19631 = ({ hasListPreference: hasListPreference, projectName: projectName })=>{
    const [currentStep, setCurrentStep] = (0, $eJOHy.useState)('modal');
    const [copyListSettings, setCopyListSettings] = (0, $eJOHy.useState)((0, $b3ae1037d777d6ef$export$246569ad15012cdd));
    const { messageInstanceClicked: messageInstanceClicked } = (0, $k9r6D.useMessageInstanceEvent)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $gr4vM.useFirePostOfficeAnalyticsEvents)();
    const dismissMessage = (0, $eJOHy.useCallback)((isTourCompleted = false)=>{
        setCurrentStep('dismissed');
        messageInstanceClicked({
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {},
            clickedElement: {
                buttonType: 'secondary',
                clickedElement: 'button',
                clickIdentifier: isTourCompleted ? 'tourCompleted' : 'dismiss'
            },
            messageEventType: 'clicked'
        });
        fireAnalyticsEvent({
            eventType: 'track',
            action: 'completed',
            actionSubject: 'jiraNinPaidListMergeTourCompleted',
            attributes: {
                didCompleteTour: isTourCompleted
            }
        });
    }, [
        messageInstanceClicked,
        fireAnalyticsEvent
    ]);
    const fireExploreEvent = (0, $eJOHy.useCallback)(()=>{
        let clickIdentifier = 'exploreFilters';
        let settingIdentifier = 'WithCopyListSettings';
        if (copyListSettings === (0, $b3ae1037d777d6ef$export$798fb63888e802b7)) settingIdentifier = 'WithCopyListSettingsAllSpaces';
        else if (copyListSettings === (0, $b3ae1037d777d6ef$export$fed7c2c712a139d8)) settingIdentifier = 'WithoutCopyListSettings';
        if (hasListPreference) clickIdentifier += settingIdentifier;
        messageInstanceClicked({
            action: {
                actionType: 'open'
            },
            additionalMetadataFromFrontend: {},
            clickedElement: {
                buttonType: 'secondary',
                clickedElement: 'button',
                clickIdentifier: clickIdentifier
            },
            messageEventType: 'clicked'
        });
    }, [
        messageInstanceClicked,
        copyListSettings
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const handleEscape = (ev)=>{
            if (ev.key === 'Escape') dismissMessage();
        };
        (0, $fceQU.getDocument)()?.addEventListener('keydown', handleEscape);
        return ()=>{
            (0, $fceQU.getDocument)()?.removeEventListener('keydown', handleEscape);
        };
    }, [
        dismissMessage
    ]);
    const { fireTrigger: fireExploreListViewButtonTriggerMigrateCurrentSpace } = (0, $5V25X.useFirePostOfficeTrigger)({
        triggerId: $7255dee1141d88d9$var$MIGRATE_CONFIG_TRIGGER_PAID_CURRENT_SPACE
    });
    const { fireTrigger: fireExploreListViewButtonTriggerMigrateAllSpaces } = (0, $5V25X.useFirePostOfficeTrigger)({
        triggerId: $7255dee1141d88d9$var$MIGRATE_CONFIG_TRIGGER_PAID_ALL_SPACES
    });
    const handleExploreListViewButtonClick = (0, $eJOHy.useCallback)(()=>{
        switch(copyListSettings){
            case 0, $b3ae1037d777d6ef$export$246569ad15012cdd:
                fireExploreListViewButtonTriggerMigrateCurrentSpace({
                    isActive: true
                });
                break;
            case 0, $b3ae1037d777d6ef$export$798fb63888e802b7:
                fireExploreListViewButtonTriggerMigrateAllSpaces({
                    isActive: true
                });
                break;
        }
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'jiraNinPaidListMergeExploreListViewButton',
            attributes: {
                copyListSettings: copyListSettings
            }
        });
        setCurrentStep('spotlight-tour');
        fireExploreEvent();
    }, [
        copyListSettings,
        fireExploreListViewButtonTriggerMigrateCurrentSpace,
        fireExploreListViewButtonTriggerMigrateAllSpaces,
        fireExploreEvent
    ]);
    switch(currentStep){
        case 'modal':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ikwzO.HighImpactModal), {
                hasListPreference: hasListPreference,
                onClose: ()=>dismissMessage(),
                onExploreListViewButtonClick: handleExploreListViewButtonClick,
                copyListSettings: copyListSettings,
                setCopyListSettings: setCopyListSettings,
                projectName: projectName
            });
        case 'spotlight-tour':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f1mOK.HighImpactSpotlightTour), {
                onDismiss: dismissMessage
            });
        default:
            return null;
    }
};

});
parcelRegister("ikwzO", function(module, exports) {
$parcel$export(module.exports, "HighImpactModal", () => $e256e064e5a8e42d$export$cfef29d0c2867291);
/* HighImpactModal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5CSKW = parcelRequire("5CSKW");

var $fKXve = parcelRequire("fKXve");

var $eJ9f5 = parcelRequire("eJ9f5");

var $lgMTT = parcelRequire("lgMTT");

var $gHHv2 = parcelRequire("gHHv2");

var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $gPG64 = parcelRequire("gPG64");

var $1wLnx = parcelRequire("1wLnx");

var $gr4vM = parcelRequire("gr4vM");

var $lRq8t = parcelRequire("lRq8t");

var $kDHNq = parcelRequire("kDHNq");

var $jD8rQ = parcelRequire("jD8rQ");

const $e256e064e5a8e42d$var$MODAL_WIDTH = 1062;
const $e256e064e5a8e42d$var$MODAL_HEIGHT = 523;
const $e256e064e5a8e42d$var$MODAL_HEIGHT_WITH_LIST_PREFERENCE = 680;
const $e256e064e5a8e42d$var$TELL_ME_MORE_URL = 'https://community.atlassian.com/forums/Jira-articles/We-re-merging-List-and-All-work-one-powerful-view-for-all-teams/ba-p/3090105';
const $e256e064e5a8e42d$var$linkContainerStyles = null;
const $e256e064e5a8e42d$var$ModalContentWithListPreference = ({ copyListSettings: copyListSettings, setCopyListSettings: setCopyListSettings, projectName: projectName })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onChange = (event)=>{
        // eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-all-member-expressions
        setCopyListSettings(event.target.value);
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                weight: "bold",
                children: formatMessage((0, $jD8rQ.messages).copyListSettingsDescription)
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPG64.default), {
                        label: projectName ? formatMessage((0, $jD8rQ.messages).copyListSettingsYesSingleSpace, {
                            spaceName: /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
                                children: projectName
                            })
                        }) : formatMessage((0, $jD8rQ.messages).copyListSettingsYesSingleSpace, {
                            spaceName: formatMessage((0, $jD8rQ.messages).spaceNameFallback)
                        }),
                        value: (0, $b3ae1037d777d6ef$export$246569ad15012cdd),
                        isChecked: copyListSettings === (0, $b3ae1037d777d6ef$export$246569ad15012cdd),
                        onChange: onChange
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPG64.default), {
                        label: formatMessage((0, $jD8rQ.messages).copyListSettingsYesAllSpaces),
                        value: (0, $b3ae1037d777d6ef$export$798fb63888e802b7),
                        isChecked: copyListSettings === (0, $b3ae1037d777d6ef$export$798fb63888e802b7),
                        onChange: onChange
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPG64.default), {
                        label: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                                    children: formatMessage((0, $jD8rQ.messages).copyListSettingsNo)
                                }),
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.HelperMessage), {
                                    children: formatMessage((0, $jD8rQ.messages).copyListSettingsNoDescription)
                                })
                            ]
                        }),
                        value: (0, $b3ae1037d777d6ef$export$fed7c2c712a139d8),
                        isChecked: copyListSettings === (0, $b3ae1037d777d6ef$export$fed7c2c712a139d8),
                        onChange: onChange
                    })
                ]
            })
        ]
    });
};
const $e256e064e5a8e42d$export$cfef29d0c2867291 = ({ onClose: onClose, onExploreListViewButtonClick: onExploreListViewButtonClick, hasListPreference: hasListPreference, copyListSettings: copyListSettings, projectName: projectName, setCopyListSettings: setCopyListSettings })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $gr4vM.useFirePostOfficeAnalyticsEvents)();
    const exploreButtonRef = (0, $eJOHy.useRef)(null);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gHHv2.default), {
        width: $e256e064e5a8e42d$var$MODAL_WIDTH,
        height: hasListPreference ? $e256e064e5a8e42d$var$MODAL_HEIGHT_WITH_LIST_PREFERENCE : $e256e064e5a8e42d$var$MODAL_HEIGHT,
        onOpenComplete: ()=>{
            fireAnalyticsEvent({
                eventType: 'screen',
                name: 'jiraNinPaidListMergeModalOnboardingViewed',
                attributes: {
                    hasListPreference: hasListPreference
                }
            });
        },
        onCloseComplete: ()=>{
            fireAnalyticsEvent({
                eventType: 'screen',
                name: 'jiraNinPaidListMergeModalOnboardingClosed',
                attributes: {
                    hasListPreference: hasListPreference
                }
            });
        },
        testId: "high-impact-modal",
        autoFocus: exploreButtonRef,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1wLnx.Modal), {
            renderedInsideEntrypoint: true,
            title: formatMessage((0, $jD8rQ.messages).heading),
            subtitle: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        children: formatMessage((0, $jD8rQ.messages).description)
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            "_19pkutpp _otyrx0bf _1e0c1txw _1jc212b0 _1wij12b0 _ufn21i6y _40h81i6y"
                        ]),
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                            href: $e256e064e5a8e42d$var$TELL_ME_MORE_URL,
                            target: "_blank",
                            children: formatMessage((0, $jD8rQ.messages).learnMoreLink)
                        })
                    })
                ]
            }),
            sideContent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDHNq.ModalOnboardingImage), {
                copyListSettings: copyListSettings
            }),
            actions: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                appearance: "primary",
                onClick: onExploreListViewButtonClick,
                ref: exploreButtonRef,
                children: formatMessage(hasListPreference ? (0, $jD8rQ.messages).applySettingsButtonLabel : (0, $jD8rQ.messages).exploreListViewButtonLabel)
            }),
            logo: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.JiraIcon), {
                appearance: "brand",
                shouldUseNewLogoDesign: true,
                size: "small"
            }),
            children: hasListPreference && /*#__PURE__*/ (0, $gt9Am.jsx)($e256e064e5a8e42d$var$ModalContentWithListPreference, {
                copyListSettings: copyListSettings,
                setCopyListSettings: setCopyListSettings,
                projectName: projectName
            })
        })
    });
};

});
parcelRegister("kDHNq", function(module, exports) {
$parcel$export(module.exports, "ModalOnboardingImage", () => $1338ac10bed3ea7e$export$a23f0cdca47d1d7c);
/* ModalOnboardingImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8wyVH = parcelRequire("8wyVH");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");


var $5gqPE = parcelRequire("5gqPE");

var $bK1Dh = parcelRequire("bK1Dh");

var $ioKRH = parcelRequire("ioKRH");

var $3rYy8 = parcelRequire("3rYy8");

var $k9sBf = parcelRequire("k9sBf");

var $68CN5 = parcelRequire("68CN5");

var $jD8rQ = parcelRequire("jD8rQ");
const $1338ac10bed3ea7e$var$MIN_WIDTH = 531;
const $1338ac10bed3ea7e$var$imageStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden',
    position: 'relative',
    width: '100%'
});
const $1338ac10bed3ea7e$var$onboardingImageStyles = null;
const $1338ac10bed3ea7e$export$a23f0cdca47d1d7c = ({ copyListSettings: copyListSettings })=>{
    let listMergeAnimation;
    let listMergeAnimationDark;
    let imageAltText;
    switch(copyListSettings){
        case 0, $b3ae1037d777d6ef$export$798fb63888e802b7:
            listMergeAnimation = (0, (/*@__PURE__*/$parcel$interopDefault($3rYy8)));
            listMergeAnimationDark = (0, (/*@__PURE__*/$parcel$interopDefault($ioKRH)));
            imageAltText = (0, $jD8rQ.messages).copyListSettingsImageAltText.defaultMessage;
            break;
        case 0, $b3ae1037d777d6ef$export$fed7c2c712a139d8:
            listMergeAnimation = (0, (/*@__PURE__*/$parcel$interopDefault($68CN5)));
            listMergeAnimationDark = (0, (/*@__PURE__*/$parcel$interopDefault($k9sBf)));
            imageAltText = (0, $jD8rQ.messages).copyListSettingsImageAltTextNo.defaultMessage;
            break;
        default:
            listMergeAnimation = (0, (/*@__PURE__*/$parcel$interopDefault($bK1Dh)));
            listMergeAnimationDark = (0, (/*@__PURE__*/$parcel$interopDefault($5gqPE)));
            imageAltText = (0, $jD8rQ.messages).copyListSettingsImageAltTextCurrentSpace.defaultMessage;
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        xcss: $1338ac10bed3ea7e$var$imageStyles,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8wyVH.default), {
            src: listMergeAnimation,
            srcDark: listMergeAnimationDark,
            alt: imageAltText,
            className: (0, $hcewu.default)([
                "_1bsb1osq _1ul9tw8n"
            ])
        })
    });
};

});
const $b3ae1037d777d6ef$export$246569ad15012cdd = 'yes-current-space';
const $b3ae1037d777d6ef$export$798fb63888e802b7 = 'yes-all-spaces';
const $b3ae1037d777d6ef$export$fed7c2c712a139d8 = 'no';

parcelRegister("5gqPE", function(module, exports) {
module.exports = new URL("list-merge-modal-single-project-dark.eb5e252c.gif", import.meta.url).toString();

});

parcelRegister("bK1Dh", function(module, exports) {
module.exports = new URL("list-merge-modal-single-project-light.604d6477.gif", import.meta.url).toString();

});

parcelRegister("ioKRH", function(module, exports) {
module.exports = new URL("list-merge-modal-multi-project-dark.e891dbcf.png", import.meta.url).toString();

});

parcelRegister("3rYy8", function(module, exports) {
module.exports = new URL("list-merge-modal-multi-project-light.9f0658d5.png", import.meta.url).toString();

});

parcelRegister("k9sBf", function(module, exports) {
module.exports = new URL("list-merge-modal-button-dark.4e0fa33b.png", import.meta.url).toString();

});

parcelRegister("68CN5", function(module, exports) {
module.exports = new URL("list-merge-modal-button-light.a31fc824.png", import.meta.url).toString();

});

parcelRegister("jD8rQ", function(module, exports) {
$parcel$export(module.exports, "messages", () => $dfc619a7804991f1$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $dfc619a7804991f1$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    filterSpotlightMessage: {
        id: 'jira-nin-paid-list-merge-modal-onboarding.spotlight.filter',
        defaultMessage: 'Search, filter, and group work items to quickly find what you need.',
        description: 'Message for filter bar on Issue Table'
    },
    dismissButton: {
        id: 'jira-nin-paid-list-merge-modal-onboarding.spotlight.dismiss',
        defaultMessage: 'Dismiss',
        description: 'Dismiss button for the list merge spotlight'
    },
    nextButton: {
        id: 'jira-nin-paid-list-merge-modal-onboarding.spotlight.next',
        defaultMessage: 'Next',
        description: 'Next button for the list merge spotlight'
    },
    moreActionsSpotlightMessage: {
        id: 'jira-nin-paid-list-merge-modal-onboarding.spotlight.more-actions',
        defaultMessage: 'Adjust how you visualise the work with charts and format rules. You can also apply your old list settings.',
        description: 'Message for more actions button on Issue Table'
    },
    okButton: {
        id: 'jira-nin-paid-list-merge-modal-onboarding.spotlight.ok',
        defaultMessage: 'OK',
        description: 'OK button for the list merge spotlight'
    },
    exploreListViewButtonLabel: {
        id: 'jira-nin-paid-list-merge-modal-onboarding.spotlight.explore-list-view-button-label',
        defaultMessage: 'Explore List view',
        description: 'Explore List View button for the list merge spotlight'
    },
    applySettingsButtonLabel: {
        id: 'jira-nin-paid-list-merge-modal-onboarding.spotlight.apply-settings-button-label',
        defaultMessage: 'Apply settings',
        description: 'Apply settings button for the list merge modal that begins the tour'
    },
    heading: {
        id: 'jira-nin-paid-list-merge-modal-onboarding.heading',
        defaultMessage: 'List and All Work are merging',
        description: 'Heading for the list merge modal onboarding modal'
    },
    description: {
        id: 'jira-nin-paid-list-merge-modal-onboarding.description',
        defaultMessage: "We've combined the best of List and All Work views to bring you one powerful, unified view for managing work.",
        description: 'Description for the list merge modal onboarding modal'
    },
    learnMoreLink: {
        id: 'jira-nin-paid-list-merge-modal-onboarding.learnMoreLink',
        defaultMessage: 'Read our announcement on Community',
        description: 'Link to learn more about the list merge modal onboarding modal'
    },
    copyListSettingsYesSingleSpace: {
        id: 'jira-nin-paid-list-merge-modal-onboarding.copyListSettingsYesSingleSpace',
        defaultMessage: 'Yes, apply settings from {spaceName} space',
        description: 'Label for the yes to migrating current space button in the list merge modal onboarding modal'
    },
    spaceNameFallback: {
        id: 'jira-nin-paid-list-merge-modal-onboarding.spaceNameFallback',
        defaultMessage: 'current',
        description: 'Fallback for the space name in the list merge modal onboarding modal'
    },
    copyListSettingsYesAllSpaces: {
        id: 'jira-nin-paid-list-merge-modal-onboarding.copyListSettingsYesAllSpaces',
        defaultMessage: 'Yes, apply settings from all Jira spaces',
        description: 'Label for the yes to migrating all spaces button in the list merge modal onboarding modal'
    },
    copyListSettingsNo: {
        id: 'jira-nin-paid-list-merge-modal-onboarding.copyListSettingsNo',
        defaultMessage: 'No, keep my settings from the All work view',
        description: 'Label for the no button in the list merge modal onboarding modal'
    },
    copyListSettingsNoDescription: {
        id: 'jira-nin-paid-list-merge-modal-onboarding.copyListSettingsNoDescription',
        defaultMessage: 'You can apply old List view settings later in the More actions (...) menu in the list.',
        description: 'Description for the no button in the list merge modal onboarding modal'
    },
    copyListSettingsDescription: {
        id: 'jira-nin-paid-list-merge-modal-onboarding.copyListSettingsDescription',
        defaultMessage: "We've applied your settings from All work view. Do you want to apply your settings from the old List view instead? This includes the filters, groups, and columns you've set.",
        description: 'Description to give context to the user so that they can choose which settings they want to use in the new view'
    },
    copyListSettingsImageAltText: {
        id: 'jira-nin-paid-list-merge-modal-onboarding.copyListSettingsImageAltText',
        defaultMessage: 'Illustration of multiple spaces stacked to show everything will migrate together.',
        description: 'Alt text for the image in the list merge modal onboarding modal from all spaces'
    },
    copyListSettingsImageAltTextCurrentSpace: {
        id: 'jira-nin-paid-list-merge-modal-onboarding.copyListSettingsImageAltTextCurrentSpace',
        defaultMessage: 'Illustration of a single space showing the list settings will migrate to the new view.',
        description: 'Alt text for the image in the list merge modal onboarding modal from current space'
    },
    copyListSettingsImageAltTextNo: {
        id: 'jira-nin-paid-list-merge-modal-onboarding.copyListSettingsImageAltTextNo',
        defaultMessage: 'Illustration of a cursor selecting the More actions menu to choose migrate later.',
        description: 'Alt text for the image in the list merge modal onboarding modal from no spaces'
    }
});

});



parcelRegister("f1mOK", function(module, exports) {
$parcel$export(module.exports, "HighImpactSpotlightTour", () => $982e64643b0e6d8b$export$496fe117accb431d);
// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package

var $gt9Am = parcelRequire("gt9Am");

var $d2s5v = parcelRequire("d2s5v");

var $k9r6D = parcelRequire("k9r6D");

var $eJOHy = parcelRequire("eJOHy");

var $2zghp = parcelRequire("2zghp");

var $8ZhLW = parcelRequire("8ZhLW");
const $982e64643b0e6d8b$export$496fe117accb431d = ({ onDismiss: onDismiss })=>{
    const { messageInstanceClicked: messageInstanceClicked } = (0, $k9r6D.useMessageInstanceEvent)();
    const [activeSpotlight, setActiveSpotlight] = (0, $eJOHy.useState)(0);
    const next = ()=>{
        setActiveSpotlight((activeSpotlight || 0) + 1);
        messageInstanceClicked({
            action: {
                actionType: 'open'
            },
            additionalMetadataFromFrontend: {},
            clickedElement: {
                buttonType: 'secondary',
                clickedElement: 'button',
                clickIdentifier: 'exploreActions'
            },
            messageEventType: 'clicked'
        });
    };
    const endTour = (isTourCompleted = false)=>{
        setActiveSpotlight(null);
        onDismiss(isTourCompleted);
    };
    const renderActiveSpotlight = ()=>{
        const spotlights = [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2zghp.FilterSpotlight), {
                onNext: next,
                onDismiss: endTour
            }, "filter-spotlight"),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8ZhLW.MoreActionsSpotlight), {
                onFinish: endTour
            }, "more-actions-spotlight")
        ];
        if (activeSpotlight === null) return null;
        return spotlights[activeSpotlight];
    };
    if (activeSpotlight === null) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d2s5v.default), {
        children: renderActiveSpotlight()
    });
};

});
parcelRegister("2zghp", function(module, exports) {
$parcel$export(module.exports, "FilterSpotlight", () => $200001852aa12937$export$4005bec6f6b919b);
// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package

var $gt9Am = parcelRequire("gt9Am");

var $bdRit = parcelRequire("bdRit");

var $lRq8t = parcelRequire("lRq8t");

var $jD8rQ = parcelRequire("jD8rQ");
const $200001852aa12937$export$4005bec6f6b919b = ({ onNext: onNext, onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bdRit.default), {
        actions: [
            {
                onClick: onNext,
                text: formatMessage((0, $jD8rQ.messages).nextButton)
            },
            {
                onClick: ()=>onDismiss(),
                text: formatMessage((0, $jD8rQ.messages).dismissButton),
                appearance: 'subtle'
            }
        ],
        target: "jql-builder.ui.jql-builder.editor",
        targetRadius: 3,
        dialogWidth: 285,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        actionsBeforeElement: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: "1/2"
        }),
        testId: "filter-spotlight",
        children: formatMessage((0, $jD8rQ.messages).filterSpotlightMessage)
    }, "jql-builder.ui.jql-builder.editor");
};

});

parcelRegister("8ZhLW", function(module, exports) {
$parcel$export(module.exports, "MoreActionsSpotlight", () => $86bbaaddb12a6eaf$export$61de96b079e717f0);
// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package

var $gt9Am = parcelRequire("gt9Am");

var $bdRit = parcelRequire("bdRit");

var $lRq8t = parcelRequire("lRq8t");

var $jD8rQ = parcelRequire("jD8rQ");
const $86bbaaddb12a6eaf$export$61de96b079e717f0 = ({ onFinish: onFinish })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bdRit.default), {
        actions: [
            {
                onClick: ()=>onFinish(true),
                text: formatMessage((0, $jD8rQ.messages).okButton)
            }
        ],
        target: "project-issue-navigator.ui.page-actions.meatball-menu",
        targetRadius: 3,
        dialogWidth: 285,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        actionsBeforeElement: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: "2/2"
        }),
        testId: "more-actions-spotlight",
        dialogPlacement: "left top",
        children: formatMessage((0, $jD8rQ.messages).moreActionsSpotlightMessage)
    }, "project-issue-navigator.ui.page-actions.meatball-menu");
};

});




parcelRegister("fKmOn", function(module, exports) {
$parcel$export(module.exports, "withI18n", () => $31b6b04f8cdf67d7$export$bfba3ccd9d9038f9);

var $4rvk5 = parcelRequire("4rvk5");

var $gqnrm = parcelRequire("gqnrm");

var $ekS74 = parcelRequire("ekS74");
const $31b6b04f8cdf67d7$export$bfba3ccd9d9038f9 = (0, $4rvk5.createWithI18n)((0, $ekS74.messagesLoader), (0, $gqnrm.messagesLoader));

});
parcelRegister("gqnrm", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $576ee218b0536de6$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $4yUCy = parcelRequire("4yUCy");

var $1n5fh = parcelRequire("1n5fh");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $576ee218b0536de6$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $576ee218b0536de6$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $1n5fh.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("jXqtc")));
        case 'da':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("dlTCl")));
        case 'de':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("aIMW9")));
        case 'en-GB':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("gXT5a")));
        case 'en-US':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("dZyqI")));
        case 'en-XA':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("arU8g")));
        case 'en-XB':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("1tCw0")));
        case 'en-ZZ':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("7LaTM")));
        case 'en':
            return $576ee218b0536de6$var$importHelper(await Promise.resolve((parcelRequire("4yUCy"))));
        case 'es':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("bJZ2S")));
        case 'et':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("8GAmc")));
        case 'fi':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("dlZFs")));
        case 'fr':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("1Lsnu")));
        case 'hr':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("8J9u9")));
        case 'hu':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("5Nhko")));
        case 'it':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("gcyKa")));
        case 'ja':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("3n1or")));
        case 'ko':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("3UeA1")));
        case 'nb':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("gHxXJ")));
        case 'nl':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("lUhEG")));
        case 'pl':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("gqDHX")));
        case 'pt-BR':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("dTReA")));
        case 'ro':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("cYvNj")));
        case 'ru':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("7VQvz")));
        case 'sl':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("kGqPS")));
        case 'sr-RS':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("h5FXk")));
        case 'sr-YR':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("luwv9")));
        case 'sr':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("7Q8Gw")));
        case 'sv':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("5bDxa")));
        case 'th':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("3W5ny")));
        case 'tr':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("bmmUl")));
        case 'uk':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("arHni")));
        case 'vi':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("iIiaO")));
        case 'zh-CN':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("kP9fV")));
        case 'zh-TW':
            return $576ee218b0536de6$var$importHelper(await (parcelRequire("c4Mgj")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($4yUCy));
    }
};

});
parcelRegister("4yUCy", function(module, exports) {
module.exports = JSON.parse("{\"export-issues-flyout-spotlight-tour.spotlight.body\":[{\"type\":0,\"value\":\"Export your work items in the format you need, right from the more actions menu.\"}],\"export-issues-flyout-spotlight-tour.spotlight.heading\":[{\"type\":0,\"value\":\"Export options have moved\"}],\"export-issues-flyout-spotlight-tour.spotlight.okButton\":[{\"type\":0,\"value\":\"OK\"}],\"jira-nin-list-merge-modal-onboarding-v2.closeButton\":[{\"type\":0,\"value\":\"Close\"}],\"jira-nin-list-merge-modal-onboarding-v2.copyListSettingsDescription\":[{\"type\":0,\"value\":\"Want us to apply your current filter and group settings to this new List view?\"}],\"jira-nin-list-merge-modal-onboarding-v2.copyListSettingsNo\":[{\"type\":0,\"value\":\"No\"}],\"jira-nin-list-merge-modal-onboarding-v2.copyListSettingsYes\":[{\"type\":0,\"value\":\"Yes\"}],\"jira-nin-list-merge-modal-onboarding-v2.description\":[{\"type\":0,\"value\":\"We've merged the best of List and All Work into a faster, accessible experience. A new List view.\"}],\"jira-nin-list-merge-modal-onboarding-v2.filtersAndGroupsDescription\":[{\"type\":0,\"value\":\"Any existing filters and groups will be applied.\"}],\"jira-nin-list-merge-modal-onboarding-v2.heading\":[{\"type\":0,\"value\":\"We've merged List and All Work\"}],\"jira-nin-list-merge-modal-onboarding-v2.learnMoreLink\":[{\"type\":0,\"value\":\"Read our community post about the merge of List and All Work views\"}],\"jira-nin-list-merge-modal-onboarding-v2.spotlight.body\":[{\"type\":0,\"value\":\"We've merged the best of List and All Work into a faster, accessible experience. A new List view.\"}],\"jira-nin-list-merge-modal-onboarding-v2.spotlight.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-nin-list-merge-modal-onboarding-v2.spotlight.explore-list-view-button-label\":[{\"type\":0,\"value\":\"Explore List view\"}],\"jira-nin-list-merge-modal-onboarding-v2.spotlight.filter\":[{\"type\":0,\"value\":\"One place to search work and filter results to find what you need.\"}],\"jira-nin-list-merge-modal-onboarding-v2.spotlight.heading\":[{\"type\":0,\"value\":\"We've merged List and All Work views\"}],\"jira-nin-list-merge-modal-onboarding-v2.spotlight.more-actions\":[{\"type\":0,\"value\":\"Dive deeper - view work items as a chart, use format rules to highlight key work, and more.\"}],\"jira-nin-list-merge-modal-onboarding-v2.spotlight.next\":[{\"type\":0,\"value\":\"Next\"}],\"jira-nin-list-merge-modal-onboarding-v2.spotlight.ok\":[{\"type\":0,\"value\":\"OK\"}],\"jira-nin-list-merge-modal-onboarding-v2.spotlight.tell-me-more-aria-label\":[{\"type\":0,\"value\":\"Read our community post about the merge of List and All Work views\"}],\"jira-nin-list-merge-spotlight-onboarding.spotlight.body\":[{\"type\":0,\"value\":\"We've merged the best of List and All Work into a faster, accessible experience.\"}],\"jira-nin-list-merge-spotlight-onboarding.spotlight.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-nin-list-merge-spotlight-onboarding.spotlight.heading\":[{\"type\":0,\"value\":\"We've merged List and All Work views\"}],\"jira-nin-list-merge-spotlight-onboarding.spotlight.tell-me-more\":[{\"type\":0,\"value\":\"Tell me more\"}],\"jira-nin-list-merge-spotlight-onboarding.spotlight.tell-me-more-aria-label\":[{\"type\":0,\"value\":\"Read our community post about the merge of List and All Work views\"}],\"jira.filter.refinement.filter-popup.changeboarding.description.filter\":[{\"type\":0,\"value\":\"You can now filter work items by status and priority, making it easier to find work.\"}],\"jira.filter.refinement.filter-popup.changeboarding.description.improvements\":[{\"type\":0,\"value\":\"More improvements to come.\"}],\"jira.filter.refinement.filter-popup.changeboarding.description.parent\":[{\"type\":0,\"value\":\"Use the parent filter to search for epics, as well as any other work items with child work items.\"}],\"jira.filter.refinement.filter-popup.changeboarding.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira.filter.refinement.filter-popup.changeboarding.next\":[{\"type\":0,\"value\":\"Next\"}],\"jira.filter.refinement.filter-popup.changeboarding.ok\":[{\"type\":0,\"value\":\"OK\"}],\"jira.filter.refinement.filter-popup.changeboarding.page2.title\":[{\"type\":0,\"value\":\"We've updated epic to parent\"}],\"jira.filter.refinement.filter-popup.changeboarding.title\":[{\"type\":0,\"value\":\"Introducing a new home for filters\"}]}");

});

parcelRegister("jXqtc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1FqRQ").then(()=>parcelRequire('iekCJ'));

});

parcelRegister("dlTCl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1YGpr").then(()=>parcelRequire('49I3w'));

});

parcelRegister("aIMW9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5cajC").then(()=>parcelRequire('i3wkz'));

});

parcelRegister("gXT5a", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fAsPT").then(()=>parcelRequire('9h7Hq'));

});

parcelRegister("dZyqI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dMXeF").then(()=>parcelRequire('gboCz'));

});

parcelRegister("arU8g", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("e376P").then(()=>parcelRequire('iYtFP'));

});

parcelRegister("1tCw0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bXavZ").then(()=>parcelRequire('ijb8R'));

});

parcelRegister("7LaTM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8juF1").then(()=>parcelRequire('haP7h'));

});

parcelRegister("bJZ2S", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cqWlH").then(()=>parcelRequire('4Y8D1'));

});

parcelRegister("8GAmc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kHyPI").then(()=>parcelRequire('3S6Pq'));

});

parcelRegister("dlZFs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cA2vu").then(()=>parcelRequire('78pH2'));

});

parcelRegister("1Lsnu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l27dd").then(()=>parcelRequire('8Pn84'));

});

parcelRegister("8J9u9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ivX4B").then(()=>parcelRequire('8sv7q'));

});

parcelRegister("5Nhko", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3thAq").then(()=>parcelRequire('fY7ig'));

});

parcelRegister("gcyKa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fv1N2").then(()=>parcelRequire('257oE'));

});

parcelRegister("3n1or", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9Jbnf").then(()=>parcelRequire('avxN6'));

});

parcelRegister("3UeA1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iZ6KJ").then(()=>parcelRequire('lIEfL'));

});

parcelRegister("gHxXJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4Voc1").then(()=>parcelRequire('AfoMu'));

});

parcelRegister("lUhEG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ei105").then(()=>parcelRequire('kpHCz'));

});

parcelRegister("gqDHX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("m5GRi").then(()=>parcelRequire('gq6dP'));

});

parcelRegister("dTReA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2uxyc").then(()=>parcelRequire('2BNCB'));

});

parcelRegister("cYvNj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("izz0R").then(()=>parcelRequire('7rVZ2'));

});

parcelRegister("7VQvz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9bJRP").then(()=>parcelRequire('l2ERc'));

});

parcelRegister("kGqPS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eQWl8").then(()=>parcelRequire('6PdLM'));

});

parcelRegister("h5FXk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kgEQN").then(()=>parcelRequire('52NTL'));

});

parcelRegister("luwv9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eTNAU").then(()=>parcelRequire('lH6SX'));

});

parcelRegister("7Q8Gw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("a2D4w").then(()=>parcelRequire('3agfw'));

});

parcelRegister("5bDxa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6j99f").then(()=>parcelRequire('8dVw9'));

});

parcelRegister("3W5ny", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fF1MD").then(()=>parcelRequire('9xzfy'));

});

parcelRegister("bmmUl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cKTv8").then(()=>parcelRequire('g1NL8'));

});

parcelRegister("arHni", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lkCP2").then(()=>parcelRequire('jYkEH'));

});

parcelRegister("iIiaO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2gRyj").then(()=>parcelRequire('79rNS'));

});

parcelRegister("kP9fV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5E9T2").then(()=>parcelRequire('fWDoI'));

});

parcelRegister("c4Mgj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cHqzJ").then(()=>parcelRequire('hZubM'));

});




parcelRegister("ih4L6", function(module, exports) {
$parcel$export(module.exports, "default", () => $68c1e08182c3d913$export$2e2bcd8739ae039);

var $jOcik = parcelRequire("jOcik");

var $hdPx2 = parcelRequire("hdPx2");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5W05x = parcelRequire("5W05x");

var $ftN6c = parcelRequire("ftN6c");

var $goZPP = parcelRequire("goZPP");

var $Ay1uj = parcelRequire("Ay1uj");

var $cDJ0f = parcelRequire("cDJ0f");

var $6zhpo = parcelRequire("6zhpo");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $aewX5 = parcelRequire("aewX5");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $sY9BV = parcelRequire("sY9BV");

var $14RSn = parcelRequire("14RSn");

var $eSnSE = parcelRequire("eSnSE");

var $a7u9w = parcelRequire("a7u9w");

var $fdpHV = parcelRequire("fdpHV");

var $guWba = parcelRequire("guWba");

var $4B7rn = parcelRequire("4B7rn");

var $h47gY = parcelRequire("h47gY");

var $4cTDP = parcelRequire("4cTDP");

var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $d8Kze = parcelRequire("d8Kze");

var $53YBU = parcelRequire("53YBU");

var $4FabQ = parcelRequire("4FabQ");

var $3ibpe = parcelRequire("3ibpe");

var $6d9QY = parcelRequire("6d9QY");

var $kRgKj = parcelRequire("kRgKj");

var $bNexr = parcelRequire("bNexr");

var $fgJkD = parcelRequire("fgJkD");

var $U4tkh = parcelRequire("U4tkh");

var $cxKOj = parcelRequire("cxKOj");

var $eaTQ3 = parcelRequire("eaTQ3");

var $3mZMJ = parcelRequire("3mZMJ");

var $8oKDI = parcelRequire("8oKDI");

var $cHtIB = parcelRequire("cHtIB");

var $fkc6h = parcelRequire("fkc6h");

var $4b0Nj = parcelRequire("4b0Nj");

var $6yWPS = parcelRequire("6yWPS");

var $8ohp7 = parcelRequire("8ohp7");

var $iZoG6 = parcelRequire("iZoG6");

const $68c1e08182c3d913$var$isTriggeredFromNINViewDefaults = {
    isIssueArchivalEnabled: false,
    isTriggeredFromNINView: false
};
const $68c1e08182c3d913$var$LOG_LOCATION = 'issue.delete.issue-delete-epic'; /** Custom hook for archive issue mutation */ 
const $68c1e08182c3d913$export$ef76c5569c303d6f = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)(); // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commitArchiveIssueMutation] = (0, $j4oe4.useMutation)((0, $hdPx2.default));
    const archiveIssue = (0, $eJOHy.useCallback)((issueID, onSuccess, onError)=>{
        commitArchiveIssueMutation({
            variables: {
                input: {
                    ids: [
                        (0, $8oKDI.createAri)({
                            resourceOwner: 'jira',
                            cloudId: cloudId,
                            resourceType: 'issue',
                            resourceId: issueID
                        })
                    ]
                }
            },
            onCompleted: (response)=>{
                if (response?.jira_archiveIssue?.success) onSuccess();
                else onError();
            },
            onError: ()=>onError()
        });
    }, [
        commitArchiveIssueMutation,
        cloudId
    ]);
    return {
        archiveIssue: archiveIssue
    };
};
/** New custom hook for mutation
 * TODO: Shift to using local state objects instead of calling existing actions from Redux.
 * Currently, only DELETE_ISSUE_REQUEST redux action has been made obsolete.
 * See /issue/issue-view-store/src/reducers/issue-delete-reducer.tsx for the state variables that can be pulled in as local state objects
 * Code flow : https://hello.atlassian.net/wiki/spaces/JIE/whiteboard/5677608177?atl_f=PAGETREE
 * */ const $68c1e08182c3d913$var$useDeleteIssueWithRelay = ()=>{
    const { enrichCommitWithIssueExperienceMonitoring: enrichCommitWithIssueExperienceMonitoring } = (0, $fkc6h.useIssueExperienceMonitoring)(); // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit, isMutationInFlight] = (0, $j4oe4.useMutation)((0, $jOcik.default));
    const currentIssueARI = (0, $5W05x.useIssueAri)();
    const deleteIssue = (0, $eJOHy.useCallback)(async (issueId, issueAri, issueKey, analyticsEvent, application, edition, triggerCloseDeleteIssueModal, onReduxDeleteSuccess, onReduxDeleteFailure, onIssueDeleteSuccess, onClose)=>{
        const issueARI = (0, $4cTDP.fg)('timline_delete_issue') ? issueAri || currentIssueARI : currentIssueARI;
        commit(enrichCommitWithIssueExperienceMonitoring({
            variables: {
                input: {
                    id: issueARI,
                    deleteSubtasks: true
                }
            },
            onCompleted: ()=>{
                (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'deleted issueDeleted'); // Resume Redux flow
                onReduxDeleteSuccess(issueKey);
                triggerCloseDeleteIssueModal(); // Execute post redux actions
                onIssueDeleteSuccess?.({
                    issueId: issueId,
                    issueKey: issueKey
                });
                onClose?.();
            },
            onError: (error)=>{
                const additionalAttributes = {};
                if (error.message) additionalAttributes.errorMessage = error.message;
                if (error instanceof (0, $14RSn.default)) {
                    if (error.traceId) additionalAttributes.traceId = error.traceId;
                    if (error.statusCode) additionalAttributes.statusCode = error.statusCode;
                }
                onReduxDeleteFailure(issueKey, error);
                (0, $eSnSE.default).safeErrorWithoutCustomerData($68c1e08182c3d913$var$LOG_LOCATION, 'Failed to delete issue', error);
                (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, 'delete failed', 'issueDeletedError', error);
            }
        }, 'DeleteIssueView_deleteIssue_Mutation', {
            overrideAttributesCallback: (isSuccess, mandatoryAttributes)=>{
                const taskOverride = isSuccess ? {
                    task: 'deleteIssueSucceeded',
                    action: 'taskSuccess'
                } : {
                    task: 'deleteIssueFailed',
                    action: 'taskFail'
                };
                return {
                    ...taskOverride,
                    additionalAttributes: {
                        ...mandatoryAttributes,
                        frameworkType: 'relay',
                        // This seems to be reported incorrectly as the current page by useIssueExperienceMonitoring
                        analyticsSource: 'issueDeleted',
                        application: application ?? 'unknown',
                        edition: edition ?? 'unknown'
                    }
                };
            }
        }));
    }, [
        commit,
        currentIssueARI,
        enrichCommitWithIssueExperienceMonitoring
    ]);
    return {
        deleteIssue: deleteIssue,
        isDeleting: isMutationInFlight
    };
};
const $68c1e08182c3d913$var$DeleteIssueViewWithErrorBoundaryOld = (0, $fdpHV.AnalyticsSource)('issueDelete', (0, $aa42ce8e355d58fa$export$1171103ea9083ffa))(({ issueId: issueId, issueAri: issueAri, isDeleteIssueModalOpen: isDeleteIssueModalOpen, isDeletingIssue: isDeletingIssue, issueKey: issueKey, isSimplifiedProject: isSimplifiedProject, shouldShowChildSpecificCopy: shouldShowChildSpecificCopy, didIssueDeleteFail: didIssueDeleteFail, triggerDeleteRequest: triggerDeleteRequest, triggerCloseDeleteIssueModal: triggerCloseDeleteIssueModal, onReduxDeleteSuccess: onReduxDeleteSuccess, onReduxDeleteFailure: onReduxDeleteFailure, deleteCancelAnalytics: deleteCancelAnalytics, deleteConfirmAnalytics: deleteConfirmAnalytics, onIssueDeleteSuccess: onIssueDeleteSuccess, onIssueDeleteFailure: onIssueDeleteFailure, onClose: onClose })=>{
    if (!isDeleteIssueModalOpen) return null;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const previousIsDeletingIssue = (0, $6d9QY.usePrevious)(isDeletingIssue);
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const application = (0, $bNexr.useApplication)(projectKey, true);
    const edition = (0, $bNexr.useEdition)(projectKey, true);
    const [workType] = (0, $U4tkh.useIssueTypeName)();
    const { getRetentionDeleteButtonText: getRetentionDeleteButtonText, getRetentionDeleteHeading: getRetentionDeleteHeading, getRetentionDeleteWarning: getRetentionDeleteWarning } = (0, $6yWPS.useIsDataRetentionEnabled)();
    (0, $eJOHy.useEffect)(()=>{
        const didDeletionFinish = !isDeletingIssue && previousIsDeletingIssue;
        if (didDeletionFinish) {
            if (!didIssueDeleteFail) {
                triggerCloseDeleteIssueModal();
                onIssueDeleteSuccess?.({
                    issueId: issueId,
                    issueKey: issueKey
                });
                onClose?.();
            } else onIssueDeleteFailure?.({
                issueId: issueId,
                issueKey: issueKey
            });
        }
    }, [
        didIssueDeleteFail,
        isDeletingIssue,
        issueId,
        issueKey,
        onClose,
        onIssueDeleteFailure,
        onIssueDeleteSuccess,
        previousIsDeletingIssue,
        triggerCloseDeleteIssueModal
    ]);
    const { deleteIssue: deleteIssue } = $68c1e08182c3d913$var$useDeleteIssueWithRelay();
    const onConfirmDeleteIssue = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        deleteConfirmAnalytics?.(analyticsEvent);
        if ((0, $4cTDP.fg)('relay-migration-issue-view-delete-issue')) deleteIssue(issueId, issueAri || '', issueKey, analyticsEvent, application, edition, triggerCloseDeleteIssueModal, onReduxDeleteSuccess, onReduxDeleteFailure, onIssueDeleteSuccess, onClose);
        triggerDeleteRequest(issueKey, analyticsEvent, application, edition);
    }, [
        deleteConfirmAnalytics,
        deleteIssue,
        issueId,
        issueAri,
        issueKey,
        application,
        edition,
        triggerCloseDeleteIssueModal,
        onReduxDeleteSuccess,
        onReduxDeleteFailure,
        onIssueDeleteSuccess,
        onClose,
        triggerDeleteRequest
    ]);
    const onCancel = (event, analyticsEvent)=>{
        deleteCancelAnalytics?.(analyticsEvent);
        triggerCloseDeleteIssueModal();
    };
    const getChildConditionalDeleteHeading = ()=>{
        const dataRetentionHeading = getRetentionDeleteHeading(false);
        if (dataRetentionHeading) return dataRetentionHeading;
        if (workType && (0, $cxKOj.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $4b0Nj.default).deleteHeadingIssueTerminologyRefreshM4;
        const deleteWithChildrenHeadingMessage = (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $4b0Nj.default).deleteWithChildrenHeadingIssueTermRefresh : (0, $4b0Nj.default).deleteWithChildrenHeading;
        if (shouldShowChildSpecificCopy) return isSimplifiedProject ? deleteWithChildrenHeadingMessage : (0, $4b0Nj.default).deleteWithSubtasksHeading;
        return (0, $4b0Nj.default).deleteHeading;
    };
    const getDeleteWithChildrenWarningMessage = ()=>{
        if (workType && (0, $cxKOj.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $4b0Nj.default).deleteWithChildrenWarningIssueTerminologyRefreshM4;
        if ((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3')) return (0, $4b0Nj.default).deleteWithChildrenWarningIssueTermRefresh;
        return (0, $4b0Nj.default).deleteWithChildrenWarning;
    };
    const getDeleteWithSubtasksWarningMessage = ()=>{
        if (workType && (0, $cxKOj.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $4b0Nj.default).deleteWithSubtasksWarningIssueTerminologyRefreshM4;
        if ((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3')) return (0, $4b0Nj.default).deleteWithSubtasksWarningIssueTermRefresh;
        return (0, $4b0Nj.default).deleteWithSubtasksWarning;
    };
    const getChildConditionalDeleteWarning = ()=>{
        if (shouldShowChildSpecificCopy) return isSimplifiedProject ? getDeleteWithChildrenWarningMessage() : getDeleteWithSubtasksWarningMessage();
        return (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $4b0Nj.default).deleteWarningIssueTermRefresh : (0, $4b0Nj.default).deleteWarning;
    };
    const cancelButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        onClick: onCancel,
        testId: "issue-view-foundation.issue-actions.delete-issue.cancel-button",
        isDisabled: isDeletingIssue,
        key: "cancelButton",
        interactionName: "auto-generated.issue.views.issue-base.foundation.issue-actions.delete-issue.cancel-button.button"
    }, formatMessage((0, $4b0Nj.default).cancel));
    const deleteButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "danger",
        onClick: onConfirmDeleteIssue,
        testId: "issue.views.issue-base.foundation.issue-actions.delete-issue.confirm-button",
        disabled: isDeletingIssue,
        iconAfter: isDeletingIssue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
            size: "small"
        }) : null,
        key: "deleteButton",
        interactionName: "auto-generated.issue.views.issue-base.foundation.issue-actions.delete-issue.confirm-button.button1"
    }, getRetentionDeleteButtonText() || formatMessage((0, $4b0Nj.default).delete));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guWba.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fgJkD.ModalDialog // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
    ), {
        messageId: "issue-view-foundation.issue-actions.delete-issue.modal-dialog",
        messageType: "transactional",
        width: "small",
        onClose: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
        hasCloseButton: (0, $4cTDP.fg)('issue-view-enghealth-40720-modal-close-button')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
        appearance: "danger"
    }, formatMessage(getChildConditionalDeleteHeading(), {
        issueKey: issueKey,
        workType: workType
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        as: "p"
    }, getRetentionDeleteWarning(workType) || formatMessage(getChildConditionalDeleteWarning(), {
        workType: workType
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        as: "p"
    }, !(0, $cxKOj.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false) && formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $4b0Nj.default).deleteRecommendationIssueTermRefresh : (0, $4b0Nj.default).deleteRecommendation))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, cancelButton, deleteButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a7u9w.MountEvent), {
        onMount: ()=>{
            (0, $3ibpe.sendExperienceAnalytics)({
                experience: 'issueViewDeleteIssueModalRender',
                wasExperienceSuccesful: true,
                analyticsSource: 'issueViewIssueActionsDeleteIssue',
                application: application ?? null,
                edition: edition ?? null
            });
        }
    }));
});
const $68c1e08182c3d913$var$DeleteIssueViewWithErrorBoundaryNew = (0, $fdpHV.AnalyticsSource)('issueDelete', (0, $aa42ce8e355d58fa$export$1171103ea9083ffa))(({ issueId: issueId, issueAri: issueAri, isDeleteIssueModalOpen: isDeleteIssueModalOpen, isDeletingIssue: isDeletingIssue, issueKey: issueKey, isSimplifiedProject: isSimplifiedProject, shouldShowChildSpecificCopy: shouldShowChildSpecificCopy, didIssueDeleteFail: didIssueDeleteFail, triggerDeleteRequest: triggerDeleteRequest, triggerCloseDeleteIssueModal: triggerCloseDeleteIssueModal, onReduxDeleteSuccess: onReduxDeleteSuccess, onReduxDeleteFailure: onReduxDeleteFailure, deleteCancelAnalytics: deleteCancelAnalytics, deleteConfirmAnalytics: deleteConfirmAnalytics, onIssueDeleteSuccess: onIssueDeleteSuccess, onIssueDeleteFailure: onIssueDeleteFailure, onClose: onClose, workTypeKey: workTypeKey, isIssueArchivalEnabled: isIssueArchivalEnabled = false, isTriggeredFromNINView: isTriggeredFromNINView = $68c1e08182c3d913$var$isTriggeredFromNINViewDefaults })=>{
    if (!isDeleteIssueModalOpen) return null;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const previousIsDeletingIssue = (0, $6d9QY.usePrevious)(isDeletingIssue);
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const application = (0, $bNexr.useApplication)(projectKey, true);
    const edition = (0, $bNexr.useEdition)(projectKey, true);
    const [inputValue, setInputValue] = (0, $eJOHy.useState)('');
    const { archiveIssue: archiveIssue } = (0, $53YBU.useArchiveIssue)();
    const { archiveIssue: archiveIssueWithRelay } = $68c1e08182c3d913$export$ef76c5569c303d6f();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isIssueArchivalFromNINViewEnabled = ((0, $4cTDP.fg)('additional-check-for-trigger-from-nin-view') ? isTriggeredFromNINView.isIssueArchivalEnabled : isIssueArchivalEnabled) && (0, $cxKOj.expVal)('issue_deletion_two_step_process_for_free_standard', 'isIssueDeleteExperimentFreemiumEnabled', false);
    const isDeleteIssueExperimentEnabled = (0, $8ohp7.useIsDeleteIssueExperimentEnabled)();
    const isEligibleForIssueArchival = (0, $4cTDP.fg)('additional-check-for-trigger-from-nin-view') ? !isTriggeredFromNINView?.isTriggeredFromNINView && isDeleteIssueExperimentEnabled || isIssueArchivalFromNINViewEnabled : isDeleteIssueExperimentEnabled || isIssueArchivalFromNINViewEnabled;
    const isTwoStepIssueDeleteFreemiumExperimentEnabled = (0, $4cTDP.fg)('issue_deletion_two_step_process_free_standard') && (0, $iZoG6.useIsTwoStepIssueDeleteFreemiumExperimentEnabled)({
        isIssueArchivalEnabled: isEligibleForIssueArchival
    });
    const { showFlag: showFlag } = (0, $cSXp8.useFlagService)();
    const archiveIssueUrl = (0, $d8Kze.useArchiveIssueUrl)();
    const [issueType] = (0, $eaTQ3.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $3mZMJ.ISSUE_TYPE)
    });
    const workType = issueType?.name || workTypeKey;
    const { getRetentionDeleteButtonText: getRetentionDeleteButtonText, getRetentionDeleteHeading: getRetentionDeleteHeading, getRetentionDeleteWarning: getRetentionDeleteWarning } = (0, $6yWPS.useIsDataRetentionEnabled)();
    (0, $eJOHy.useEffect)(()=>{
        const didDeletionFinish = !isDeletingIssue && previousIsDeletingIssue;
        if (didDeletionFinish) {
            if (!didIssueDeleteFail) {
                triggerCloseDeleteIssueModal();
                onIssueDeleteSuccess?.({
                    issueId: issueId,
                    issueKey: issueKey
                });
                onClose?.();
            } else onIssueDeleteFailure?.({
                issueId: issueId,
                issueKey: issueKey
            });
        }
    }, [
        didIssueDeleteFail,
        isDeletingIssue,
        issueId,
        issueKey,
        onClose,
        onIssueDeleteFailure,
        onIssueDeleteSuccess,
        previousIsDeletingIssue,
        triggerCloseDeleteIssueModal
    ]);
    const { deleteIssue: deleteIssue } = $68c1e08182c3d913$var$useDeleteIssueWithRelay();
    const onConfirmDeleteIssue = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        deleteConfirmAnalytics?.(analyticsEvent);
        if ((0, $4cTDP.fg)('relay-migration-issue-view-delete-issue')) deleteIssue(issueId, issueAri || '', issueKey, analyticsEvent, application, edition, triggerCloseDeleteIssueModal, onReduxDeleteSuccess, onReduxDeleteFailure, onIssueDeleteSuccess, onClose);
        triggerDeleteRequest(issueKey, analyticsEvent, application, edition);
    }, [
        application,
        deleteConfirmAnalytics,
        deleteIssue,
        edition,
        issueAri,
        issueId,
        issueKey,
        onClose,
        onIssueDeleteSuccess,
        onReduxDeleteFailure,
        onReduxDeleteSuccess,
        triggerCloseDeleteIssueModal,
        triggerDeleteRequest
    ]);
    const onCancel = (event, analyticsEvent)=>{
        (0, $4cTDP.fg)('issue_deletion_two_step_process_free_standard') && (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'CancelButton');
        deleteCancelAnalytics?.(analyticsEvent);
        triggerCloseDeleteIssueModal();
    };
    const onArchivalFailure = ()=>{
        showFlag({
            // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
            messageId: 'issue-view-foundation.issue-actions.delete-issue.show-flag.error.issue-archival-error',
            messageType: 'transactional',
            type: 'error',
            title: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $4b0Nj.default).issueArchivalErrorFlagTitleIssueTermRefresh : (0, $4b0Nj.default).issueArchivalErrorFlagTitle, {
                issueKey: issueKey
            }),
            testId: 'jira-issue-archive.modal.error-flag'
        });
        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({
            action: 'archived',
            actionSubject: 'issue',
            attributes: {
                triggerPointKey: 'DeleteIssueModal'
            }
        }), 'archiveIssue Failed');
        triggerCloseDeleteIssueModal();
    };
    const onArchivalSuccess = ()=>{
        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({
            action: 'archived',
            actionSubject: 'issue',
            attributes: {
                triggerPointKey: 'DeleteIssueModal'
            }
        }), 'archiveIssue Successful');
        if ((0, $4FabQ.isIssueViewPage)()) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.reload();
        showFlag({
            // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
            messageId: 'issue-view-foundation.issue-actions.delete-issue.show-flag.success.issue-archival-success',
            messageType: 'transactional',
            type: 'success',
            title: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $4b0Nj.default).issueArchivalSuccessFlagTitleIssueTermRefresh : (0, $4b0Nj.default).issueArchivalSuccessFlagTitle, {
                issueKey: issueKey
            }),
            testId: 'jira-issue-archive.modal.success-flag',
            actions: [
                {
                    content: (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $4b0Nj.default).issueArchivalSuccessFlagActionViewIssueIssueTermRefresh : (0, $4b0Nj.default).issueArchivalSuccessFlagActionViewIssue,
                    href: `/browse/${issueKey}`
                },
                {
                    content: (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $4b0Nj.default).issueArchivalSuccessFlagActionViewInArchiveIssueTermRefresh : (0, $4b0Nj.default).issueArchivalSuccessFlagActionViewInArchive,
                    href: archiveIssueUrl
                }
            ]
        });
        onIssueDeleteSuccess?.({
            issueId: issueId,
            issueKey: issueKey
        });
    };
    const onArchive = ()=>{
        if ((0, $4cTDP.fg)('relay-migration-archival')) archiveIssueWithRelay(issueId, onArchivalSuccess, onArchivalFailure);
        else archiveIssue([
            issueKey
        ], onArchivalSuccess, onArchivalFailure);
        onClose?.();
        triggerCloseDeleteIssueModal();
    };
    const getChildConditionalDeleteWarning = ()=>{
        const deleteWithChildrenWarningMessage = (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $4b0Nj.default).deleteOrArchiveWithChildrenWarningIssueTermRefresh : (0, $4b0Nj.default).deleteOrArchiveWithChildrenWarning;
        const deleteWithSubtasksWarningMessage = (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $4b0Nj.default).deleteOrArchiveWithSubtasksWarningIssueTermRefresh : (0, $4b0Nj.default).deleteOrArchiveWithSubtasksWarning;
        if (isTwoStepIssueDeleteFreemiumExperimentEnabled) {
            if ((0, $4cTDP.fg)('project-term-refresh_ga')) return (0, $4b0Nj.default).deleteWarningForTwoStepDeleteFreemiumExperimentGalaxia;
            return (0, $4b0Nj.default).deleteWarningForTwoStepDeleteFreemiumExperiment;
        }
        if (shouldShowChildSpecificCopy) return isSimplifiedProject ? deleteWithChildrenWarningMessage : deleteWithSubtasksWarningMessage;
        return (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $4b0Nj.default).deleteOrArchiveWarningIssueTermRefresh : (0, $4b0Nj.default).deleteOrArchiveWarning;
    };
    const archiveButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        onClick: onArchive,
        testId: "issue.views.issue-base.foundation.issue-actions.delete-issue.archive-button" // @ts-expect-error - TS2322 - Type '{ children: string; appearance: "subtle"; onClick: (event: SyntheticEvent<Element, Event>, analyticsEvent: UIAnalyticsEventInterface) => void; testId: string; disabled: boolean; }' is not assignable to type 'IntrinsicAttributes & ButtonProps & RefAttributes<HTMLElement>'.
        ,
        disabled: isDeletingIssue,
        key: "archiveButton",
        interactionName: "auto-generated.issue.views.issue-base.foundation.issue-actions.delete-issue.archive-button.button"
    }, formatMessage((0, $4b0Nj.default).archive));
    const cancelButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        onClick: onCancel,
        testId: "issue-view-foundation.issue-actions.delete-issue.cancel-button",
        isDisabled: isDeletingIssue,
        key: "cancelButton",
        interactionName: "auto-generated.issue.views.issue-base.foundation.issue-actions.delete-issue.cancel-button.button"
    }, formatMessage((0, $4b0Nj.default).cancel));
    const handleInputChange = (e)=>{
        const value = e.target.value;
        setInputValue(value);
    };
    const deleteButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: inputValue.trim().toLowerCase() !== formatMessage((0, $4b0Nj.default).deleteTextToEquateForTextbox).toLowerCase() ? 'primary' : 'danger',
        isDisabled: inputValue.trim().toLowerCase() !== formatMessage((0, $4b0Nj.default).deleteTextToEquateForTextbox).toLowerCase() || isDeletingIssue,
        onClick: onConfirmDeleteIssue,
        testId: "issue.views.issue-base.foundation.issue-actions.delete-issue.confirm-button",
        disabled: isDeletingIssue,
        iconAfter: isDeletingIssue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
            size: "small"
        }) : null,
        key: "deleteButton",
        interactionName: "auto-generated.issue.views.issue-base.foundation.issue-actions.delete-issue.confirm-button.button1"
    }, getRetentionDeleteButtonText() || formatMessage((0, $4b0Nj.default).delete));
    if (!isEligibleForIssueArchival && !isTwoStepIssueDeleteFreemiumExperimentEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($68c1e08182c3d913$var$DeleteIssueViewWithErrorBoundaryOld, {
        issueId: issueId,
        issueAri: issueAri,
        isDeleteIssueModalOpen: isDeleteIssueModalOpen,
        isDeletingIssue: isDeletingIssue,
        issueKey: issueKey,
        isSimplifiedProject: isSimplifiedProject,
        shouldShowChildSpecificCopy: shouldShowChildSpecificCopy,
        didIssueDeleteFail: didIssueDeleteFail,
        onReduxDeleteSuccess: onReduxDeleteSuccess,
        onReduxDeleteFailure: onReduxDeleteFailure,
        triggerDeleteRequest: triggerDeleteRequest,
        triggerCloseDeleteIssueModal: triggerCloseDeleteIssueModal,
        deleteCancelAnalytics: deleteCancelAnalytics,
        deleteConfirmAnalytics: deleteConfirmAnalytics,
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        onIssueDeleteFailure: onIssueDeleteFailure,
        onClose: onClose
    });
    if (isTwoStepIssueDeleteFreemiumExperimentEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guWba.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fgJkD.ModalDialog // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
    ), {
        messageId: "issue-view-foundation.issue-actions.delete-issue.modal-dialog.two-step-delete",
        messageType: "transactional",
        width: "small",
        onClose: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
        hasCloseButton: (0, $4cTDP.fg)('issue-view-enghealth-40720-modal-close-button')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aewX5.default), {
        gap: "space.250",
        templateAreas: [
            'title close'
        ],
        xcss: $68c1e08182c3d913$var$gridStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: $68c1e08182c3d913$var$titleContainerStyles,
        justifyContent: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
        appearance: "danger"
    }, getRetentionDeleteHeading(true) || formatMessage((0, $4b0Nj.default).deleteHeadingWithWorkType, {
        workType: workType,
        issueKey: issueKey
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        as: "p"
    }, getRetentionDeleteWarning(workType) || formatMessage(getChildConditionalDeleteWarning(), {
        workType: workType
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlockStart: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        as: "p"
    }, formatMessage((0, $4cTDP.fg)('project-term-refresh_ga') ? (0, $4b0Nj.default).deleteConfirmationForTwoStepDeleteFreemiumExperimentGalaxia : (0, $4b0Nj.default).deleteConfirmationForTwoStepDeleteFreemiumExperiment, {
        workType: workType
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDJ0f.Label), {
        htmlFor: "Textfield"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_k48pi7a9"
        ])
    }, formatMessage((0, $4b0Nj.default).deleteTextFieldLabelMessage, {
        strong: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
                size: "small",
                as: "strong"
            }, chunks.join(''))
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
        label: formatMessage((0, $4b0Nj.default).deleteTextFieldLabelMessage),
        value: inputValue,
        onChange: handleInputChange,
        width: "352",
        height: "36",
        id: "Textfield",
        testId: (0, $d54faf1fa9641b6a$export$a97e1a5849845ab3)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, cancelButton, deleteButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a7u9w.MountEvent), {
        onMount: ()=>{
            (0, $3ibpe.sendExperienceAnalytics)({
                experience: 'issueViewDeleteIssueModalRender',
                wasExperienceSuccesful: true,
                analyticsSource: 'issueViewIssueActionsDeleteIssue',
                application: application ?? null,
                edition: edition ?? null
            });
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guWba.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fgJkD.ModalDialog // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
    ), {
        messageId: "issue-view-foundation.issue-actions.delete-issue.modal-dialog.new",
        messageType: "transactional",
        width: "small",
        onClose: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
        hasCloseButton: (0, $4cTDP.fg)('issue-view-enghealth-40720-modal-close-button')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aewX5.default), {
        gap: "space.250",
        templateAreas: [
            'title close'
        ],
        xcss: $68c1e08182c3d913$var$gridStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: $68c1e08182c3d913$var$titleContainerStyles,
        justifyContent: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
        appearance: "danger"
    }, getRetentionDeleteHeading(true) || formatMessage((0, $4b0Nj.default).deleteOrArchiveHeading, {
        issueKey: issueKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: $68c1e08182c3d913$var$closeContainerStyles,
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))),
        label: formatMessage((0, $4b0Nj.default).iconButtonLabel),
        onClick: onCancel
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        as: "p"
    }, getRetentionDeleteWarning(workType) || formatMessage(getChildConditionalDeleteWarning())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDJ0f.Label), {
        htmlFor: "Textfield"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        className: (0, $hcewu.default)([
            "_k48pi7a9"
        ])
    }, formatMessage((0, $4b0Nj.default).deleteTextFieldLabelMessage, {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        strong: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
                size: "small",
                as: "strong"
            }, chunks.join(''))
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
        label: formatMessage((0, $4b0Nj.default).deleteTextFieldLabelMessage),
        value: inputValue,
        onChange: handleInputChange,
        width: "352",
        height: "36",
        testId: (0, $d54faf1fa9641b6a$export$a97e1a5849845ab3)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, archiveButton, deleteButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a7u9w.MountEvent), {
        onMount: ()=>{
            (0, $3ibpe.sendExperienceAnalytics)({
                experience: 'issueViewDeleteIssueModalRender',
                wasExperienceSuccesful: true,
                analyticsSource: 'issueViewIssueActionsDeleteIssue',
                application: application ?? null,
                edition: edition ?? null
            });
        }
    }));
});
const $68c1e08182c3d913$export$7836eafbab9e4b99 = (0, $fdpHV.AnalyticsSource)('issueDelete', (0, $aa42ce8e355d58fa$export$1171103ea9083ffa))((props)=>{
    const { issueKey: issueKey } = props;
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const application = (0, $bNexr.useApplication)(projectKey, true);
    const edition = (0, $bNexr.useEdition)(projectKey, true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "issue.issue-view-foundation.issue-actions.delete-issue",
        onError: (location, error, attributes)=>{
            const { componentStack: componentStack } = attributes;
            (0, $3ibpe.sendExperienceAnalytics)({
                experience: 'issueViewDeleteIssueModalRender',
                wasExperienceSuccesful: false,
                analyticsSource: 'issueViewIssueActionsDeleteIssue',
                application: application ?? null,
                edition: edition ?? null,
                additionalAttributes: {
                    errorMessage: error?.message || 'UNKNOWN_ERROR',
                    location: location,
                    ...componentStack && {
                        componentStack: componentStack
                    }
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($68c1e08182c3d913$var$DeleteIssueViewWithErrorBoundaryNew, props));
});
var $68c1e08182c3d913$export$2e2bcd8739ae039 = $68c1e08182c3d913$export$7836eafbab9e4b99;
const $68c1e08182c3d913$var$SpanStyle = null;
const $68c1e08182c3d913$var$closeContainerStyles = (0, $1DXK0.xcss)({
    gridArea: 'close'
});
const $68c1e08182c3d913$var$titleContainerStyles = (0, $1DXK0.xcss)({
    gridArea: 'title'
});
const $68c1e08182c3d913$var$gridStyles = (0, $1DXK0.xcss)({
    width: '100%'
});

});
parcelRegister("jOcik", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a332f38b7f2e535$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<47d0bcce75a38dbae4de7e3775f1e5f7>>
 * @relayHash 9e6bae8a1942ce883a3d1fc7f5b26901
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e0bf4c698824530ba4bb0e11da2085d347499bce2d6efad6337c1a84ab677d7
const $5a332f38b7f2e535$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "deleteIssueView_deleteIssue_Mutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraIssueDeletePayload",
                    "kind": "LinkedField",
                    "name": "jira_deleteIssue",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "deleteIssueView_deleteIssue_Mutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraIssueDeletePayload",
                    "kind": "LinkedField",
                    "name": "jira_deleteIssue",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3e0bf4c698824530ba4bb0e11da2085d347499bce2d6efad6337c1a84ab677d7",
            "metadata": {},
            "name": "deleteIssueView_deleteIssue_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$5a332f38b7f2e535$var$node.hash = "ece7ea5729fe469a4366ac87e287255e";
var $5a332f38b7f2e535$export$2e2bcd8739ae039 = $5a332f38b7f2e535$var$node;

});

parcelRegister("hdPx2", function(module, exports) {
$parcel$export(module.exports, "default", () => $f33ffad0ba543ec5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dc18591c06566421a31985e1997234e7>>
 * @relayHash 2d25988a99ccf3cb7f148576013eb15f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9f862449f05f03d050cb713bb981af544d0403aff0ea69b00762a41d6e9c89c2
const $f33ffad0ba543ec5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "JiraIssueArchivePayload",
            "kind": "LinkedField",
            "name": "jira_archiveIssue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "deleteIssueView_ArchiveIssueMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "deleteIssueView_ArchiveIssueMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "9f862449f05f03d050cb713bb981af544d0403aff0ea69b00762a41d6e9c89c2",
            "metadata": {},
            "name": "deleteIssueView_ArchiveIssueMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$f33ffad0ba543ec5$var$node.hash = "eb25f7061b0d8c61387a7905e70e6d53";
var $f33ffad0ba543ec5$export$2e2bcd8739ae039 = $f33ffad0ba543ec5$var$node;

});

parcelRegister("5W05x", function(module, exports) {
$parcel$export(module.exports, "useIssueAri", () => $fabcf1a9fe62ebaf$export$f56776f1b409b56d);

var $bmoS1 = parcelRequire("bmoS1");

var $8oKDI = parcelRequire("8oKDI");

var $cHtIB = parcelRequire("cHtIB");
const $fabcf1a9fe62ebaf$export$f56776f1b409b56d = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const issueId = (0, $bmoS1.useIssueId)();
    return (0, $8oKDI.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId ?? ''
    });
};

});

parcelRegister("a7u9w", function(module, exports) {
$parcel$export(module.exports, "MountEvent", () => $ca85b8e348ac962b$export$2c6963927dbc68f1);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4J0ad = parcelRequire("4J0ad");
class $ca85b8e348ac962b$var$MountEventComponent extends (0, $eJOHy.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $ca85b8e348ac962b$var$MountEventComponentWithHOC = (0, $4J0ad.default)()($ca85b8e348ac962b$var$MountEventComponent);
const $ca85b8e348ac962b$export$2c6963927dbc68f1 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)($ca85b8e348ac962b$var$MountEventComponentWithHOC, {
        ...props
    });

});

parcelRegister("d8Kze", function(module, exports) {
$parcel$export(module.exports, "useArchiveIssueUrl", () => $e0381d0b5b1855ef$export$d1ca368e1ad6dfeb);

var $FhXEJ = parcelRequire("FhXEJ");

var $2aY2d = parcelRequire("2aY2d");
const $e0381d0b5b1855ef$export$d1ca368e1ad6dfeb = ()=>{
    // TODO: Check if this is the correct way to get the project context and will always be available, it shouldn't be behind any feature flag
    const { data: projectContext } = (0, $2aY2d.useProjectContext)();
    const { projectType: projectType, simplified: simplified, projectKey: projectKey } = projectContext || {};
    switch(projectType){
        case 0, $FhXEJ.SOFTWARE_PROJECT:
            if (simplified) return `/jira/software/projects/${projectKey}/archived-work-items`;
            return `/jira/software/c/projects/${projectKey}/archived-work-items`;
        case 0, $FhXEJ.SERVICE_DESK_PROJECT:
            return `/jira/servicedesk/projects/${projectKey}/archived-work-items`;
        case 0, $FhXEJ.CORE_PROJECT:
            return `/jira/core/projects/${projectKey}/archived-work-items`;
        case 0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT:
            return `/jira/product-discovery/projects/${projectKey}/issues/archive`;
        default:
            // TODO: Throw an error
            return '/jira/issues/archive';
    }
};

});

parcelRegister("53YBU", function(module, exports) {
$parcel$export(module.exports, "useArchiveIssue", () => $a28cfc5b847f0c99$export$8726fa65ba085232);

var $fDq3k = parcelRequire("fDq3k");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3ugTQ = parcelRequire("3ugTQ");

var $eBhI6 = parcelRequire("eBhI6");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $cHtIB = parcelRequire("cHtIB");

var $7BKle = parcelRequire("7BKle");
const $a28cfc5b847f0c99$var$MAXIMUM_POLL_DURATION = 300000;
const $a28cfc5b847f0c99$var$DEFAULT_POLLING_DURATION = 2000;
const $a28cfc5b847f0c99$var$HTTP_ACCEPTED_STATUS_CODE = 202;
const $a28cfc5b847f0c99$export$8726fa65ba085232 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const cloudId = (0, $cHtIB.useCloudId)();
    // GraphQL mutation for async archive
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commitArchiveIssueAsyncMutation] = (0, $j4oe4.useMutation)((0, $fDq3k.default));
    const pollForArchiveTaskStatus = (0, $eJOHy.useCallback)((urlForPollingStatus, onSuccess, onError, analyticsEvent, isRelayMigrationArchivalEnabled = false)=>{
        const pollingStartTime = Date.now();
        let isPollingCompleted = false;
        const intervalId = setInterval(async ()=>{
            try {
                const pollingStatus = await (0, $3ugTQ.performGetRequest)(urlForPollingStatus);
                if (pollingStatus?.status === 'COMPLETED' || pollingStatus?.progress >= 100) {
                    clearInterval(intervalId);
                    onSuccess(analyticsEvent, isRelayMigrationArchivalEnabled);
                    isPollingCompleted = true;
                } else if (pollingStatus?.status === 'FAILED') {
                    clearInterval(intervalId);
                    onError(analyticsEvent, isRelayMigrationArchivalEnabled);
                    isPollingCompleted = true;
                }
                if (Date.now() - pollingStartTime >= $a28cfc5b847f0c99$var$MAXIMUM_POLL_DURATION) {
                    clearInterval(intervalId);
                    isPollingCompleted = true;
                }
            } catch  {
                clearInterval(intervalId);
                onError(analyticsEvent, isRelayMigrationArchivalEnabled);
                isPollingCompleted = true;
            }
        }, $a28cfc5b847f0c99$var$DEFAULT_POLLING_DURATION);
        if (isPollingCompleted) (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'polling completed', {
            action: 'issueArchivalUsingJQL',
            duration: Date.now() - pollingStartTime
        });
    }, [
        createAnalyticsEvent
    ]);
    const archiveAlongWithChildIssuesUsingJQL = (0, $eJOHy.useCallback)(async (parentIssueKey, onSuccess, onError, analyticsEvent)=>{
        try {
            const response = await fetch((0, $7BKle.ISSUE_ARCHIVE_API), {
                method: 'POST',
                ...(0, $eBhI6.getDefaultOptions)((0, $7BKle.ISSUE_ARCHIVE_API)),
                body: JSON.stringify({
                    jql: `parent = ${parentIssueKey} OR issue = ${parentIssueKey}`
                })
            });
            const responseStatus = response.status;
            if (responseStatus !== $a28cfc5b847f0c99$var$HTTP_ACCEPTED_STATUS_CODE) {
                onError(analyticsEvent);
                return;
            }
            const urlForPollingStatus = await response.text();
            pollForArchiveTaskStatus(urlForPollingStatus, onSuccess, onError, analyticsEvent);
        } catch  {
            onError(analyticsEvent);
        }
    }, [
        pollForArchiveTaskStatus
    ]);
    const archiveIssue = (0, $eJOHy.useCallback)(async (issueKeys, onSuccess, onError, analyticsEvent)=>{
        try {
            await (0, $3ugTQ.performPutRequest)((0, $7BKle.ISSUE_ARCHIVE_API), {
                body: JSON.stringify({
                    issueIdsOrKeys: issueKeys
                })
            });
            onSuccess(analyticsEvent);
        } catch  {
            onError(analyticsEvent);
        }
    }, []);
    /**
   * Archives issues asynchronously using GraphQL mutation with JQL query.
   * This function calls the jira_archiveIssueAsync mutation and handles polling
   * for task completion, similar to archiveAlongWithChildIssuesUsingJQL.
   *
   * @param parentIssueKey - The parent issue key to archive along with child issues
   * @param onSuccess - Callback function called when archiving succeeds
   * @param onError - Callback function called when archiving fails
   * @param analyticsEvent - Optional analytics event for tracking
   */ const archiveIssueAsync = (0, $eJOHy.useCallback)((parentIssueKey, onSuccess, onError, analyticsEvent)=>{
        commitArchiveIssueAsyncMutation({
            variables: {
                cloudId: cloudId,
                input: {
                    jql: `parent = ${parentIssueKey} OR issue = ${parentIssueKey}`
                }
            },
            onCompleted: (response)=>{
                const taskId = response?.jira_archiveIssueAsync?.taskId;
                if (response?.jira_archiveIssueAsync?.success && taskId) pollForArchiveTaskStatus(`/rest/api/3/task/${taskId}`, onSuccess, onError, analyticsEvent, true);
                else onError(analyticsEvent);
            },
            onError: ()=>{
                onError(analyticsEvent);
            }
        });
    }, [
        commitArchiveIssueAsyncMutation,
        cloudId,
        pollForArchiveTaskStatus
    ]);
    return {
        archiveIssue: archiveIssue,
        archiveAlongWithChildIssuesUsingJQL: archiveAlongWithChildIssuesUsingJQL,
        archiveIssueAsync: archiveIssueAsync
    };
};

});
parcelRegister("fDq3k", function(module, exports) {
$parcel$export(module.exports, "default", () => $799f6b605c2d8644$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<54dedfb03f2d5d4edbfeb558b41ec502>>
 * @relayHash 0b57255e6b2f4a82c11628bc8708dc5a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID de28ee6acd3c594568c536cb9b6b698a26a773f55ef20e585472ceefde7122cb
const $799f6b605c2d8644$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "taskId"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "services_archiveIssueAsyncMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraIssueArchiveAsyncPayload",
                    "kind": "LinkedField",
                    "name": "jira_archiveIssueAsync",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ],
                                            "type": "JiraIssueArchiveAsyncErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        },
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "services_archiveIssueAsyncMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraIssueArchiveAsyncPayload",
                    "kind": "LinkedField",
                    "name": "jira_archiveIssueAsync",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v4 /*: any*/ 
                                            ],
                                            "type": "JiraIssueArchiveAsyncErrorExtension"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        },
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "de28ee6acd3c594568c536cb9b6b698a26a773f55ef20e585472ceefde7122cb",
            "metadata": {},
            "name": "services_archiveIssueAsyncMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$799f6b605c2d8644$var$node.hash = "e594e539ecd7bb3cb018b62ed8278301";
var $799f6b605c2d8644$export$2e2bcd8739ae039 = $799f6b605c2d8644$var$node;

});

parcelRegister("7BKle", function(module, exports) {
$parcel$export(module.exports, "ARCHIVE_ISSUE_MODAL_WIDTH_CATEGORY", () => $2582ae2409307da1$export$2ac06baa43be057);
$parcel$export(module.exports, "ESC_KEY", () => $2582ae2409307da1$export$45f4d5e73efcfde8);
$parcel$export(module.exports, "ISSUE_VIEW_URL_REGEX", () => $2582ae2409307da1$export$cbf34536d6076514);
$parcel$export(module.exports, "ISSUE_ARCHIVE_API", () => $2582ae2409307da1$export$1c9d135d7bb1047);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_ISSUE_VIEW", () => $2582ae2409307da1$export$501c618f5224bbb);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_ISSUE_NAVIGATOR", () => $2582ae2409307da1$export$f64573f447a64548);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_BOARD_VIEW", () => $2582ae2409307da1$export$a1eb5fb00be2a7d1);
const $2582ae2409307da1$export$2ac06baa43be057 = 'small';
const $2582ae2409307da1$export$45f4d5e73efcfde8 = 'Escape';
const $2582ae2409307da1$export$cbf34536d6076514 = /.*\/browse\/[^/]+/;
const $2582ae2409307da1$export$1c9d135d7bb1047 = '/rest/api/2/issue/archive';
const $2582ae2409307da1$export$501c618f5224bbb = 'issue-view';
const $2582ae2409307da1$export$f64573f447a64548 = 'issue-navigator';
const $2582ae2409307da1$export$a1eb5fb00be2a7d1 = 'board-view';

});


parcelRegister("4FabQ", function(module, exports) {
$parcel$export(module.exports, "isIssueViewPage", () => $71da4e2a837c85d3$export$d121412a48c6ebc0);

var $gRw8I = parcelRequire("gRw8I");

var $7BKle = parcelRequire("7BKle");
const $71da4e2a837c85d3$export$d121412a48c6ebc0 = ()=>{
    (0, $gRw8I.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.location.pathname.match((0, $7BKle.ISSUE_VIEW_URL_REGEX));
};

});

parcelRegister("eaTQ3", function(module, exports) {
$parcel$export(module.exports, "useFieldValue", () => $626f51b4fb1f2379$export$b79fae7fbe3ac392);
$parcel$export(module.exports, "useFieldsValues", () => $626f51b4fb1f2379$export$25b73e671fe7a8fa);
$parcel$export(module.exports, "useMultiFieldValuesForIssues", () => $626f51b4fb1f2379$export$915cdeec521b54f7);
$parcel$export(module.exports, "FieldValueSubscriber", () => $626f51b4fb1f2379$export$4e5f1f4ed08d155e);
$parcel$export(module.exports, "useFieldsValuesActions", () => $626f51b4fb1f2379$export$612d9bcb0c9d8976);

var $eJOHy = parcelRequire("eJOHy");

var $1O6Yz = parcelRequire("1O6Yz");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");
const $626f51b4fb1f2379$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: fields
        });
    };
const $626f51b4fb1f2379$var$setIssues = (issues)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState(newIssues);
    };
const $626f51b4fb1f2379$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: value
            }
        });
    };
const $626f51b4fb1f2379$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
        const issueFieldValues = getState()[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
const $626f51b4fb1f2379$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, getState()[issueKey], fields)
        });
    };
const $626f51b4fb1f2379$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
        if (issues.length === 0) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, getState(), newIssues));
    };
const $626f51b4fb1f2379$var$actions = {
    setFieldValue: $626f51b4fb1f2379$var$setFieldValue,
    getFieldValue: $626f51b4fb1f2379$var$getFieldValue,
    setIssue: $626f51b4fb1f2379$var$setIssue,
    mergeIssue: $626f51b4fb1f2379$var$mergeIssue,
    setIssues: $626f51b4fb1f2379$var$setIssues,
    mergeIssues: $626f51b4fb1f2379$export$11aa02e14fdf7753
};
// this is a global store
const $626f51b4fb1f2379$var$store = (0, $GtRbT.createStore)({
    name: 'issue-fields',
    initialState: {},
    actions: $626f51b4fb1f2379$var$actions
});
const $626f51b4fb1f2379$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
    const issueFieldValues = state[issueKey];
    return issueFieldValues && issueFieldValues[fieldKey];
};
const $626f51b4fb1f2379$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$626f51b4fb1f2379$var$getFieldValueSelector(state, {
            fieldKey: fieldKey,
            issueKey: issueKey
        }));
const $626f51b4fb1f2379$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
        if (!state[issueKey]) return accumulator;
        const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
            acc[fieldKey] = $626f51b4fb1f2379$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            });
            return acc;
        }, {});
        accumulator[issueKey] = fieldValue;
        return accumulator;
    }, {});
const $626f51b4fb1f2379$var$getAllFields = (state, issueKey)=>state[issueKey];
const $626f51b4fb1f2379$export$b79fae7fbe3ac392 = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getFieldValueSelector
});
const $626f51b4fb1f2379$export$25b73e671fe7a8fa = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getAllFields
});
const $626f51b4fb1f2379$export$ac289b84121829df = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getFieldValuesForIssuesSelector
});
const $626f51b4fb1f2379$export$915cdeec521b54f7 = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getMultiFieldValuesForIssuesSelector
});
const $626f51b4fb1f2379$export$4e5f1f4ed08d155e = (0, $ht3nQ.createSubscriber)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getFieldValueSelector
});
const $626f51b4fb1f2379$var$useFieldValueStoreActions = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: null
});
const $626f51b4fb1f2379$export$612d9bcb0c9d8976 = ()=>{
    const [, fieldValueStoreActions] = $626f51b4fb1f2379$var$useFieldValueStoreActions();
    const fieldsValuesActions = (0, $eJOHy.useMemo)(()=>{
        const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
        const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
        const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
        const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
        const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
        return {
            setIssue: setIssueAction,
            setFieldValue: setFieldValueAction,
            getFieldValue: getFieldValueAction,
            mergeIssue: mergeIssueAction,
            setIssues: setIssuesAction,
            mergeIssues: mergeIssuesAction
        };
    }, [
        fieldValueStoreActions
    ]);
    return [
        null,
        fieldsValuesActions
    ];
};

});

parcelRegister("fkc6h", function(module, exports) {
$parcel$export(module.exports, "isAGGResponse", () => $512cbef46162db63$export$8e0a55d0fb901cc0);
$parcel$export(module.exports, "extractError", () => $512cbef46162db63$export$54a2e2e305599171);
$parcel$export(module.exports, "useIssueExperienceMonitoring", () => $512cbef46162db63$export$316dd354b9e65dba);

var $eJOHy = parcelRequire("eJOHy");

var $d0Gew = parcelRequire("d0Gew");

var $2QO3b = parcelRequire("2QO3b");

var $2gvG4 = parcelRequire("2gvG4");

var $mjinE = parcelRequire("mjinE");

var $bpkMB = parcelRequire("bpkMB");

var $14RSn = parcelRequire("14RSn");

var $ePvyd = parcelRequire("ePvyd");

var $bNexr = parcelRequire("bNexr");

var $bmoS1 = parcelRequire("bmoS1");

var $7wFII = parcelRequire("7wFII");

var $3ibpe = parcelRequire("3ibpe");

var $e9OSL = parcelRequire("e9OSL");
const $512cbef46162db63$var$isExtensions = (value)=>{
    return typeof value === 'object' && value !== null && 'gateway' in value && typeof value.gateway === 'object' && value.gateway !== null && 'trace_id' in value.gateway && typeof value.gateway.trace_id === 'string';
};
const $512cbef46162db63$export$8e0a55d0fb901cc0 = (value)=>{
    return typeof value === 'object' && value !== null && ('jira' in value && typeof value.jira === 'object' && value.jira !== null || 'errors' in value && typeof value.errors === 'object');
};
const $512cbef46162db63$export$54a2e2e305599171 = (response)=>{
    if (response.errors) return response.errors;
    for(const key in response.jira)if (response.jira[key]) {
        const value = response.jira[key];
        if (value.errors) return value.errors;
    }
    return [];
};
const $512cbef46162db63$var$stopCapturingAndGetTraceId = (mutationName)=>{
    const [extensions] = (0, $ePvyd.getExtensions)(mutationName);
    (0, $ePvyd.stopCapturingExtensions)(mutationName);
    return $512cbef46162db63$var$isExtensions(extensions) ? extensions.gateway.trace_id : 'unknown';
};
const $512cbef46162db63$var$isAbortableStatusCode = (statusCode)=>{
    return statusCode && statusCode >= 400 && statusCode < 500;
};
const $512cbef46162db63$var$stopCapturingAndGetMetaData = (mutationName, response, error)=>{
    const traceId = $512cbef46162db63$var$stopCapturingAndGetTraceId(mutationName);
    const aggError = error?.[0] || (response ? $512cbef46162db63$export$54a2e2e305599171(response)[0] : undefined);
    const statusCode = aggError?.extensions?.statusCode;
    const errorMessage = aggError?.message;
    return {
        traceId: traceId,
        errorMessage: errorMessage,
        statusCode: statusCode,
        aggError: aggError
    };
};
const $512cbef46162db63$var$maybeSendUFOErrorAndReleaseHold = (activeInteraction, ufoHoldCleanup, traceId, sendUFOEvent, hasError, statusCode, errorMessage)=>{
    if (sendUFOEvent) {
        if (hasError && activeInteraction?.ufoName) {
            (0, $2gvG4.addUFOCustomData)({
                traceId: traceId,
                statusCode: statusCode
            });
            (0, $bpkMB.setInteractionError)(activeInteraction?.ufoName, {
                errorMessage: errorMessage || 'unknown',
                name: errorMessage || 'unknown'
            });
        }
        ufoHoldCleanup?.();
    }
};
const $512cbef46162db63$export$316dd354b9e65dba = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const application = (0, $bNexr.useApplication)(projectKey, true);
    const edition = (0, $bNexr.useEdition)(projectKey, true);
    const analyticsSource = (0, $bmoS1.useAnalyticsSource)();
    const context = (0, $eJOHy.useContext)((0, $d0Gew.default));
    /**
	 * Enriches React Relay mutation commits with comprehensive experience monitoring and analytics.
	 *
	 * This function wraps Relay mutation configurations to automatically:
	 * - Capture gateway trace IDs for debugging
	 * - Send UFO (performance) events with error handling
	 * - Track experience analytics with success/failure states
	 * - Handle both AGG API responses and network errors
	 *
	 * @param commitArgs - The original React Relay mutation configuration
	 * @param mutationName - Unique identifier for the mutation (used for trace capture)
	 * @param options - Configuration object for monitoring behavior
	 * @param options.sendUFOEvent - Whether to send UFO performance events (default: false)
	 * @param options.additionalAttributes - Extra analytics attributes to include
	 * @param options.task - Experience name for analytics (string or function that takes success boolean)
	 * @param options.overrideAttributesCallback - !Use with CAUTION! Function to override entire analytics attributes based on error and success attributes
	 *   Called with (isSuccess, mandatoryAttributes, errorObjects) and should return additional attributes.
	 *   Use this to add context-specific data like field names, validation errors, or business logic results.
	 * @param shouldWrapWithAnalytics - Function to conditionally enable monitoring (default: () => true)
	 *
	 * @returns Enhanced configuration for Relay commit with monitoring wrapped around onCompleted/onError
	 *
	 * @example
	 * ```tsx
	 * const [commit] = useMutation(UpdateIssueMutation);
	 * const { enrichCommitWithIssueExperienceMonitoring } = useIssueExperienceMonitoring();
	 *
	 * const handleUpdate = () => {
	 *   commit(enrichCommitWithIssueExperienceMonitoring({
	 *     variables: { input: { issueId, status: 'Done' } },
	 *     onCompleted: (response) => console.log('Success!'),
	 *   }, 'updateIssueStatus', {
	 *     sendUFOEvent: true,
	 *     task: 'issue.update.status',
	 *     additionalAttributes: { statusType: 'Done' }
	 *   }));
	 * };
	 * ```
	 */ const enrichCommitWithIssueExperienceMonitoring = (0, $eJOHy.useCallback)((commitArgs, mutationName, { sendUFOEvent: sendUFOEvent, additionalAttributes: additionalAttributes, task: task, overrideAttributesCallback: overrideAttributesCallback } = {}, shouldWrapWithAnalytics = ()=>true)=>{
        if (!shouldWrapWithAnalytics()) return commitArgs;
        (0, $ePvyd.startCapturingExtensions)(mutationName);
        let activeInteraction;
        let ufoHoldCleanup;
        if (sendUFOEvent) {
            activeInteraction = (0, $2QO3b.getActiveInteraction)();
            ufoHoldCleanup = context?.hold(activeInteraction?.ufoName);
            (0, $2gvG4.addUFOCustomData)({
                application: (0, $mjinE.transformApplication)(application || null),
                edition: (0, $mjinE.transformEdition)(edition || null)
            });
        }
        const defaultExperienceArgs = {
            analyticsSource: analyticsSource || 'unknown',
            application: application || null,
            edition: edition || null,
            additionalAttributes: additionalAttributes
        };
        return {
            ...commitArgs,
            onCompleted: (response, error)=>{
                const aggResponse = $512cbef46162db63$export$8e0a55d0fb901cc0(response) ? response : undefined;
                const { traceId: traceId, aggError: aggError, errorMessage: errorMessage, statusCode: statusCode } = $512cbef46162db63$var$stopCapturingAndGetMetaData(mutationName, aggResponse, error);
                let action = 'taskSuccess';
                if (aggError) action = $512cbef46162db63$var$isAbortableStatusCode(statusCode) ? 'taskAbort' : 'taskFail';
                commitArgs.onCompleted?.(response, error);
                $512cbef46162db63$var$maybeSendUFOErrorAndReleaseHold(activeInteraction, ufoHoldCleanup, traceId, sendUFOEvent, !!aggError, statusCode, errorMessage);
                const additionalAttributesWithErrorProperties = {
                    ...additionalAttributes,
                    ...action !== 'taskSuccess' && {
                        traceId: traceId,
                        ...errorMessage !== undefined && {
                            errorMessage: errorMessage
                        },
                        ...statusCode !== undefined && {
                            statusCode: statusCode
                        }
                    }
                };
                const overrideAttributes = overrideAttributesCallback ? overrideAttributesCallback(!aggError, additionalAttributesWithErrorProperties, {}) : {};
                if (task || overrideAttributes?.task) (0, $3ibpe.sendExperienceAnalytics)({
                    ...defaultExperienceArgs,
                    experience: task || String(overrideAttributes?.task),
                    action: action,
                    additionalAttributes: additionalAttributesWithErrorProperties,
                    ...overrideAttributes
                });
            },
            onError: (error)=>{
                const traceId = $512cbef46162db63$var$stopCapturingAndGetTraceId(mutationName);
                const aggError = (0, $e9OSL.extractFirstErrorFromRelayError)(error);
                const errorMessage = aggError?.message || error?.message;
                const statusCode = (0, $14RSn.isFetchError)(error) ? error?.statusCode : aggError?.statusCode;
                const hasError = !!aggError || !!(0, $14RSn.isFetchError)(error);
                const action = (0, $7wFII.isAbortableError)(error) || $512cbef46162db63$var$isAbortableStatusCode(statusCode) ? 'taskAbort' : 'taskFail';
                commitArgs.onError?.(error);
                $512cbef46162db63$var$maybeSendUFOErrorAndReleaseHold(activeInteraction, ufoHoldCleanup, traceId, sendUFOEvent, hasError, statusCode, errorMessage);
                const overrideAttributes = overrideAttributesCallback ? overrideAttributesCallback(false, additionalAttributes, {
                    aggError: aggError,
                    networkError: hasError,
                    statusCode: statusCode,
                    rawError: error
                }) : {};
                if (task || overrideAttributes?.task) (0, $3ibpe.sendExperienceAnalytics)({
                    ...defaultExperienceArgs,
                    experience: task || String(overrideAttributes.task),
                    action: action,
                    additionalAttributes: {
                        ...additionalAttributes,
                        traceId: traceId,
                        ...errorMessage !== undefined && {
                            errorMessage: errorMessage
                        },
                        ...statusCode !== undefined && {
                            statusCode: statusCode
                        }
                    },
                    ...overrideAttributes
                });
            }
        };
    }, [
        analyticsSource,
        application,
        edition,
        context
    ]);
    return {
        enrichCommitWithIssueExperienceMonitoring: enrichCommitWithIssueExperienceMonitoring
    };
};

});
parcelRegister("e9OSL", function(module, exports) {
$parcel$export(module.exports, "useFieldExperienceTracking", () => $4a9350ba25b6d2c6$export$94c85d2216d24740);
$parcel$export(module.exports, "extractFirstErrorFromRelayError", () => $4a9350ba25b6d2c6$export$1e49248e7b3f98d6);
/**
 * Based on jira/src/packages/issue/issue-view/src/epics/experience-tracking/field-experience-tracking-epic.tsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $7wFII = parcelRequire("7wFII");

var $bmoS1 = parcelRequire("bmoS1");

var $3ibpe = parcelRequire("3ibpe");

var $bNexr = parcelRequire("bNexr");
const $4a9350ba25b6d2c6$export$94c85d2216d24740 = ({ fieldId: fieldId })=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const application = (0, $bNexr.useApplication)(projectKey, true);
    const edition = (0, $bNexr.useEdition)(projectKey, true);
    const analyticsSource = (0, $bmoS1.useAnalyticsSource)();
    const getEditEventPayload = (0, $eJOHy.useCallback)(({ hasSuccess: hasSuccess, hasEdit: hasEdit, errorMessage: errorMessage, traceId: traceId, statusCode: statusCode, action: action })=>{
        const additionalAttributes = {};
        if (errorMessage != null) additionalAttributes.errorMessage = errorMessage;
        if (traceId != null) additionalAttributes.traceId = traceId;
        if (statusCode) additionalAttributes.statusCode = statusCode;
        return {
            experience: 'editIssue',
            analyticsSource: analyticsSource || 'unknown',
            application: application || null,
            edition: edition || null,
            wasExperienceSuccesful: hasSuccess,
            field: fieldId,
            hasEdit: hasEdit,
            additionalAttributes: additionalAttributes,
            action: action
        };
    }, [
        analyticsSource,
        application,
        edition,
        fieldId
    ]);
    const sendSubmitSucceededExperienceEvent = (0, $eJOHy.useCallback)(()=>{
        (0, $3ibpe.sendExperienceAnalytics)(getEditEventPayload({
            hasSuccess: true,
            hasEdit: true
        }));
    }, [
        getEditEventPayload
    ]);
    const sendSubmitFailedExperienceEvent = (0, $eJOHy.useCallback)((error)=>{
        if (!error) return;
        const match = error?.message?.match(/response: (\d+)/);
        const statusCode = match ? parseInt(match[1], 10) : undefined;
        if (statusCode && statusCode >= 400 && statusCode < 500) (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'issue.issue-view.editIssue',
                teamName: 'obsidian'
            },
            attributes: {
                experience: 'editIssue',
                analyticsSource: analyticsSource || 'unknown',
                application: application || null,
                edition: edition || null,
                wasExperienceSuccesful: false,
                field: fieldId,
                hasEdit: true,
                traceId: 'traceId' in error ? String(error?.traceId) : undefined
            }
        });
        const action = (0, $7wFII.isAbortableError)(error) ? 'taskAbort' : 'taskFail';
        (0, $3ibpe.sendExperienceAnalytics)(getEditEventPayload({
            hasSuccess: (0, $7wFII.isAbortableError)(error),
            hasEdit: true,
            errorMessage: 'statusCode' in error ? `${error.statusCode} - ${error.message}` : error.message,
            traceId: 'traceId' in error ? String(error?.traceId) : undefined,
            statusCode: 'statusCode' in error && typeof error?.statusCode === 'number' ? error.statusCode : undefined,
            action: action
        }));
    }, [
        getEditEventPayload,
        analyticsSource,
        application,
        edition,
        fieldId
    ]);
    const sendEditCancelExperienceEvent = (0, $eJOHy.useCallback)(()=>{
        (0, $3ibpe.sendExperienceAnalytics)(getEditEventPayload({
            hasSuccess: true,
            hasEdit: false
        }));
    }, [
        getEditEventPayload
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            sendSubmitSucceededExperienceEvent: sendSubmitSucceededExperienceEvent,
            sendSubmitFailedExperienceEvent: sendSubmitFailedExperienceEvent,
            sendEditCancelExperienceEvent: sendEditCancelExperienceEvent
        }), [
        sendEditCancelExperienceEvent,
        sendSubmitFailedExperienceEvent,
        sendSubmitSucceededExperienceEvent
    ]);
};
const $4a9350ba25b6d2c6$export$1e49248e7b3f98d6 = (error)=>{
    if (!('source' in error)) return null;
    const errorSource = error.source;
    const errors = typeof errorSource === 'object' && errorSource != null && 'errors' in errorSource && errorSource.errors;
    const firstError = Array.isArray(errors) ? errors[0] : null;
    const statusCode = firstError?.extensions?.statusCode;
    const message = firstError?.message;
    return statusCode ? {
        statusCode: statusCode,
        message: message
    } : null;
};

});


parcelRegister("4b0Nj", function(module, exports) {
$parcel$export(module.exports, "default", () => $921b3b8ff93769df$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction

var $7qGN1 = parcelRequire("7qGN1");
const $921b3b8ff93769df$var$messages = (0, $7qGN1.defineMessages)({
    archive: {
        "id": "issue.archive.confirm",
        "defaultMessage": "Archive"
    },
    delete: {
        "id": "issue.delete.confirm",
        "defaultMessage": "Delete"
    },
    deleteDataRetention: {
        "id": "issue.data-retention.delete.confirm",
        "defaultMessage": "Delete anyway"
    },
    deleteHeading: {
        "id": "issue.delete-heading",
        "defaultMessage": "Delete {issueKey}?"
    },
    deleteHeadingDataRetention: {
        "id": "issue.data-retention.delete-heading",
        "defaultMessage": "Override data retention?"
    },
    deleteHeadingWithWorkType: {
        "id": "issue.delete-heading-with-issue-type",
        "defaultMessage": "Delete {workType} {issueKey}"
    },
    deleteHeadingIssueTerminologyRefreshM4: {
        "id": "issue.delete-heading.issue-terminology-refresh-m4",
        "defaultMessage": "Permanently delete {workType} {issueKey}?"
    },
    deleteOrArchiveHeading: {
        "id": "issue.delete-or-archive-heading",
        "defaultMessage": "Delete or archive {issueKey}?"
    },
    deleteWithSubtasksHeading: {
        "id": "issue.delete-with-subtasks-heading",
        "defaultMessage": "Delete {issueKey} and its subtasks?"
    },
    deleteWithChildrenHeading: {
        "id": "issue.delete-with-children-heading",
        "defaultMessage": "Delete {issueKey} and its child issues?"
    },
    cancel: {
        "id": "issue.delete.cancel",
        "defaultMessage": "Cancel"
    },
    deleteWarning: {
        "id": "issue.delete-warning",
        "defaultMessage": "You're about to permanently delete this issue, its comments and attachments, and all of its data."
    },
    deleteWarningDataRetention: {
        "id": "issue.data-retention.delete-warning",
        "defaultMessage": "This {workType} is tagged for data retention. Deleting content may go against your organization\u2019s policies. This action will be logged."
    },
    deleteOrArchiveWarning: {
        "id": "issue.delete-or-archive-warning",
        "defaultMessage": "You can choose to delete or archive this issue. Deleting is irreversible. It permanently removes the issue, comments and attachments."
    },
    deleteOrArchiveWarningIssueTermRefresh: {
        "id": "issue.delete-or-archive-warning-issue-term-refresh",
        "defaultMessage": "You can choose to delete or archive this work item. Deleting is irreversible. It permanently removes the work item, comments and attachments."
    },
    deleteWithSubtasksWarning: {
        "id": "issue.delete-with-subtasks-warning",
        "defaultMessage": "You're about to permanently delete this issue and all its subtasks, its comments and attachments, and all of its data. You should move any subtasks you don't want to delete to another parent issue."
    },
    deleteWithChildrenWarning: {
        "id": "issue.delete-with-children-warning",
        "defaultMessage": "You're about to permanently delete this issue and all its child issues, its comments and attachments, and all of its data. You should move any child issues you don't want to delete to another parent issue."
    },
    deleteRecommendation: {
        "id": "issue.delete-recommendation",
        "defaultMessage": "If you're not sure, you can resolve or close this issue instead."
    },
    deleteWithChildrenHeadingIssueTermRefresh: {
        "id": "issue.delete-with-children-heading-issue-term-refresh",
        "defaultMessage": "Delete {issueKey} and its child work items?"
    },
    deleteWarningIssueTermRefresh: {
        "id": "issue.delete-warning-issue-term-refresh",
        "defaultMessage": "You're about to permanently delete this work item, its comments and attachments, and all of its data."
    },
    deleteWarningForTwoStepDeleteFreemiumExperiment: {
        "id": "issue.delete.two-step-delete-freemium",
        "defaultMessage": "You're about to permanently delete this work item, its comments and attachments, and all its data. This is irreversible."
    },
    deleteWarningForTwoStepDeleteFreemiumExperimentGalaxia: {
        "id": "issue.delete.two-step-delete-freemium-galaxia",
        "defaultMessage": "You're about to permanently delete this {workType}, its comments and attachments, and all its data. This is irreversible."
    },
    deleteConfirmationForTwoStepDeleteFreemiumExperiment: {
        "id": "issue.delete-warning.two-step-delete-freemium",
        "defaultMessage": "If you're not sure, you can resolve or close this item instead."
    },
    deleteConfirmationForTwoStepDeleteFreemiumExperimentGalaxia: {
        "id": "issue.delete-warning.two-step-delete-freemium-galaxia",
        "defaultMessage": "If you're not sure, you can resolve or close this {workType} instead."
    },
    deleteWithSubtasksWarningIssueTermRefresh: {
        "id": "issue.delete-with-subtasks-warning-issue-term-refresh",
        "defaultMessage": "You're about to permanently delete this work item and all its subtasks, comments and attachments, and data. You should move any subtasks you don't want to delete to another work item."
    },
    deleteWithSubtasksWarningIssueTerminologyRefreshM4: {
        "id": "issue.delete-with-subtasks-warning-issue-terminology-refresh-m4",
        "defaultMessage": "This {workType} and all its subtasks, comments, attachments, and data will be permanently deleted. Move any subtasks you don\u2019t want to delete."
    },
    deleteOrArchiveWithSubtasksWarning: {
        "id": "issue.delete-or-archive-with-subtasks-warning",
        "defaultMessage": "You can choose to delete or archive this issue and all its subtasks. Deleting is irreversible. It permanently removes the issue, subtasks, comments and attachments. To keep subtasks move them to a different parent."
    },
    deleteOrArchiveWithSubtasksWarningIssueTermRefresh: {
        "id": "issue.delete-or-archive-with-subtasks-warning-issue-term-refresh",
        "defaultMessage": "You can choose to delete or archive this work item and all its subtasks. Deleting is irreversible. It permanently removes the work item, subtasks, comments and attachments. To keep subtasks move them to a different parent."
    },
    deleteWithChildrenWarningIssueTermRefresh: {
        "id": "issue.delete-with-children-warning-issue-term-refresh",
        "defaultMessage": "You're about to permanently delete this work item and all its child work items, comments and attachments, and data. You should move any child work items you don't want to delete to another work items."
    },
    deleteWithChildrenWarningIssueTerminologyRefreshM4: {
        "id": "issue.delete-with-children-warning-issue-terminology-refresh-m4",
        "defaultMessage": "This {workType} and all its child work items, comments, attachments, and data will be permanently deleted. Move any child work item you don\u2019t want to delete."
    },
    deleteOrArchiveWithChildrenWarning: {
        "id": "issue.delete-or-archive-with-children-warning",
        "defaultMessage": "You can choose to delete or archive this issue and all its child issues. Deleting is irreversible. It permanently removes the issue, child issues, comments and attachments. To keep child issues move them to a different parent."
    },
    deleteOrArchiveWithChildrenWarningIssueTermRefresh: {
        "id": "issue.delete-or-archive-with-children-warning-issue-term-refresh",
        "defaultMessage": "You can choose to delete or archive this work item and all its child work items. Deleting is irreversible. It permanently removes the work item, child work items, comments and attachments. To keep child work items move them to a different parent."
    },
    deleteRecommendationIssueTermRefresh: {
        "id": "issue.delete-recommendation-issue-term-refresh",
        "defaultMessage": "If you're not sure, you can resolve or close this work item instead."
    },
    deleteErrorMessage: {
        "id": "issue.delete-error-message",
        "defaultMessage": "The value entered does not match"
    },
    deleteTextFieldLabelMessage: {
        "id": "issue.delete-textfield-label-message",
        "defaultMessage": "Type <strong>delete</strong> to continue"
    },
    deleteLabelMessage: {
        "id": "issue.delete-label-message",
        "defaultMessage": "Type delete to continue"
    },
    iconButtonLabel: {
        "id": "issue.icon-button-label",
        "defaultMessage": "Close Modal"
    },
    issueArchivalSuccessFlagTitle: {
        "id": "issue-archival-modal.issue-archival-success-flag-title",
        "defaultMessage": "We've archived the issue {issueKey}."
    },
    issueArchivalSuccessFlagTitleIssueTermRefresh: {
        "id": "issue-archival-modal.issue-archival-success-flag-title-issue-term-refresh",
        "defaultMessage": "We've archived the work item {issueKey}."
    },
    issueArchivalSuccessFlagActionViewIssue: {
        "id": "issue-archival-modal.issue-archival-success-flag-action-view-issue",
        "defaultMessage": "View issue"
    },
    issueArchivalSuccessFlagActionViewIssueIssueTermRefresh: {
        "id": "issue-archival-modal.issue-archival-success-flag-action-view-issue-issue-term-refresh",
        "defaultMessage": "View work item"
    },
    issueArchivalSuccessFlagActionViewInArchive: {
        "id": "issue-archival-modal.issue-archival-success-flag-action-view-in-archive",
        "defaultMessage": "View all archived issues"
    },
    issueArchivalSuccessFlagActionViewInArchiveIssueTermRefresh: {
        "id": "issue-archival-modal.issue-archival-success-flag-action-view-in-archive-issue-term-refresh",
        "defaultMessage": "View all archived work items"
    },
    issueArchivalErrorFlagTitle: {
        "id": "issue-archival-modal.issue-archival-error-flag-title",
        "defaultMessage": "We couldn\u2019t archive the issue {issueKey}. Wait a few moments, then try again."
    },
    issueArchivalErrorFlagTitleIssueTermRefresh: {
        "id": "issue-archival-modal.issue-archival-error-flag-title-issue-term-refresh",
        "defaultMessage": "We couldn\u2019t archive the work item {issueKey}. Wait a few moments, then try again."
    },
    deleteTextToEquateForTextbox: {
        "id": "issue-delete-modal.issue-delete-text-to-equate-for-textbox",
        "defaultMessage": "delete"
    }
});
var $921b3b8ff93769df$export$2e2bcd8739ae039 = $921b3b8ff93769df$var$messages;

});

parcelRegister("6yWPS", function(module, exports) {
$parcel$export(module.exports, "useIsDataRetentionEnabled", () => $61f4b214160b414d$export$87500958424f122);

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $4b0Nj = parcelRequire("4b0Nj");
function $61f4b214160b414d$export$87500958424f122() {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const getRetentionDeleteButtonText = ()=>{
        if ((0, $4cTDP.fg)('block-delete-jira')) return formatMessage((0, $4b0Nj.default).deleteDataRetention);
        return null;
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const getRetentionDeleteHeading = (formatted)=>{
        if ((0, $4cTDP.fg)('block-delete-jira')) return formatted ? formatMessage((0, $4b0Nj.default).deleteHeadingDataRetention) : (0, $4b0Nj.default).deleteHeadingDataRetention;
        return null;
    };
    const getRetentionDeleteWarning = (workType)=>{
        if ((0, $4cTDP.fg)('block-delete-jira')) return formatMessage((0, $4b0Nj.default).deleteWarningDataRetention, {
            workType: workType?.toLowerCase()
        });
        return null;
    };
    return {
        getRetentionDeleteButtonText: getRetentionDeleteButtonText,
        getRetentionDeleteHeading: getRetentionDeleteHeading,
        getRetentionDeleteWarning: getRetentionDeleteWarning
    };
}

});

parcelRegister("8ohp7", function(module, exports) {
$parcel$export(module.exports, "useIsDeleteIssueExperimentEnabled", () => $3c13eae414a36169$export$5f61d2ccec0586e);

var $cblKs = parcelRequire("cblKs");

var $cxKOj = parcelRequire("cxKOj");

var $bmoS1 = parcelRequire("bmoS1");

var $bmoS1 = parcelRequire("bmoS1");

var $eaTQ3 = parcelRequire("eaTQ3");

var $bNexr = parcelRequire("bNexr");

var $f5OzW = parcelRequire("f5OzW");

var $4cTDP = parcelRequire("4cTDP");
const $3c13eae414a36169$export$5f61d2ccec0586e = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const edition = (0, $bNexr.useEdition)(projectKey, true);
    const isPremium = edition === (0, $cblKs.PREMIUM_EDITION);
    const [permissions] = (0, $f5OzW.useProjectPermissions)(projectKey);
    const isArchived = (0, $bmoS1.useIsArchived)();
    const [issueType] = (0, $eaTQ3.useFieldValue)({
        issueKey: issueKey,
        fieldKey: 'issuetype'
    });
    const isSubtask = issueType?.subtask;
    const isEligibleForArchivalWithoutLicenseCheck = !isSubtask && !isArchived && permissions.canArchiveIssue;
    const isEligibleForArchivalWithLicenseCheck = !isSubtask && !isArchived && permissions.canArchiveIssue && isPremium;
    const isEligibleForIssueArchival = (0, $4cTDP.fg)('extend_issue_archival_for_free_and_standard') ? isEligibleForArchivalWithoutLicenseCheck : isEligibleForArchivalWithLicenseCheck;
    return isEligibleForIssueArchival && (0, $cxKOj.expVal)('issue_deletion_a_two_step_process_ga', 'isDeleteTwoStepGaEnabled', false);
};

});
parcelRegister("f5OzW", function(module, exports) {
$parcel$export(module.exports, "useProjectPermissions", () => $9392c16d11e1d8d6$export$c6c6b35628cf47a8);
$parcel$export(module.exports, "useCanAdministerProject", () => $9392c16d11e1d8d6$export$f39ed5a161efa614);
$parcel$export(module.exports, "useCanAdministerJira", () => $9392c16d11e1d8d6$export$ec12ddafd19b95ac);
$parcel$export(module.exports, "useCanConfigureIssue", () => $9392c16d11e1d8d6$export$e7267b8a084eadb3);
$parcel$export(module.exports, "useCanUseServiceDeskAgentFeatures", () => $9392c16d11e1d8d6$export$756d7c97077a2f76);
$parcel$export(module.exports, "useCanUseCustomerServiceAgentFeatures", () => $9392c16d11e1d8d6$export$a9aa002e3fe96518);
$parcel$export(module.exports, "useCanDownloadAttachments", () => $9392c16d11e1d8d6$export$d47dad3a7e3265ea);
$parcel$export(module.exports, "useProjectPermissionsActions", () => $9392c16d11e1d8d6$export$86c656cdb87052cd);

var $eJOHy = parcelRequire("eJOHy");

var $koAZ4 = parcelRequire("koAZ4");

var $6PAED = parcelRequire("6PAED");

var $cmy2V = parcelRequire("cmy2V");
const $9392c16d11e1d8d6$export$c6c6b35628cf47a8 = (projectKey)=>{
    const [permissions, { setProjectPermissions: setProjectPermissions }] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const actions = (0, $eJOHy.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        permissions,
        actions
    ];
};
const $9392c16d11e1d8d6$export$f39ed5a161efa614 = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerProject;
};
const $9392c16d11e1d8d6$export$ec12ddafd19b95ac = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerJira;
};
const $9392c16d11e1d8d6$export$e7267b8a084eadb3 = (projectKey)=>{
    const canConfigureAdministerProject = $9392c16d11e1d8d6$export$f39ed5a161efa614(projectKey);
    const canAdministerJira = $9392c16d11e1d8d6$export$ec12ddafd19b95ac(projectKey);
    return canConfigureAdministerProject || canAdministerJira;
};
const $9392c16d11e1d8d6$export$756d7c97077a2f76 = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const { appPermissions: appPermissions } = (0, $koAZ4.useTenantContext)();
    return permissions.canUseServiceDeskAgentFeatures && appPermissions?.hasServiceDeskAccess;
};
const $9392c16d11e1d8d6$export$a9aa002e3fe96518 = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const { hasCustomerServiceAccess: hasCustomerServiceAccess } = (0, $6PAED.useApplicationPermissions)();
    return permissions.canUseServiceDeskAgentFeatures && hasCustomerServiceAccess;
};
const $9392c16d11e1d8d6$export$d47dad3a7e3265ea = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canExportIssue;
};
const $9392c16d11e1d8d6$export$86c656cdb87052cd = ()=>{
    const [, { setProjectPermissions: setProjectPermissions }] = (0, $cmy2V.useProjectPermissionsStoreActions)();
    const actions = (0, $eJOHy.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("cmy2V", function(module, exports) {
$parcel$export(module.exports, "defaultPermissions", () => $872d4887d895f20d$export$ccfee65526b322ca);
$parcel$export(module.exports, "useProjectPermissionsStore", () => $872d4887d895f20d$export$4919fa09a3d81224);
$parcel$export(module.exports, "useProjectPermissionsStoreActions", () => $872d4887d895f20d$export$e8436ef485b33bdb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $g2Hwr = parcelRequire("g2Hwr");
const $872d4887d895f20d$export$ccfee65526b322ca = {
    canAddComments: false,
    canAdministerJira: false,
    canAdministerProject: false,
    canAssignIssues: false,
    canBeAssignedToIssues: false,
    canCloneIssue: false,
    canCreateAttachments: false,
    canCreateChildren: false,
    canCreateSubtask: false,
    canDeleteAllAttachments: false,
    canDeleteAllComments: false,
    canDeleteAllWorklogs: false,
    canDeleteIssue: false,
    canDeleteOwnAttachments: false,
    canDeleteOwnComments: false,
    canDeleteOwnWorklogs: false,
    canEditAllComments: false,
    canEditAllWorklogs: false,
    canEditIssues: false,
    canEditOwnComments: false,
    canEditOwnWorklogs: false,
    canLinkIssues: false,
    canLogWork: false,
    canManageWatchers: false,
    canMoveIssue: false,
    canModifyReporter: false,
    canScheduleIssues: false,
    canUseServiceDeskAgentFeatures: false,
    canBrowseUsers: false,
    canViewDevTools: false,
    canViewWatchers: false,
    canViewVoters: false,
    canCreateIssuesInClassicProjectEpic: false,
    canResolveIssues: false,
    canExportIssue: false,
    canArchiveIssue: false,
    canUnarchiveIssue: false
};
const $872d4887d895f20d$var$store = (0, $GtRbT.createStore)({
    name: 'project-permissions',
    initialState: {},
    actions: $g2Hwr
});
const $872d4887d895f20d$var$getProjectPermissionSelector = (state, { projectKey: projectKey })=>state[projectKey] || $872d4887d895f20d$export$ccfee65526b322ca;
const $872d4887d895f20d$export$4919fa09a3d81224 = (0, $iJq0l.createHook)($872d4887d895f20d$var$store, {
    selector: $872d4887d895f20d$var$getProjectPermissionSelector
});
const $872d4887d895f20d$export$e8436ef485b33bdb = (0, $iJq0l.createHook)($872d4887d895f20d$var$store, {
    selector: null
});

});
parcelRegister("g2Hwr", function(module, exports) {
$parcel$export(module.exports, "setProjectPermissions", () => $d904843c11c916e5$export$53f5cc27627e5fe3);
const $d904843c11c916e5$export$53f5cc27627e5fe3 = (projectKey, permissions)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [projectKey]: permissions
        });
    };

});




parcelRegister("iZoG6", function(module, exports) {
$parcel$export(module.exports, "useIsTwoStepIssueDeleteFreemiumExperimentEnabled", () => $86bad56f8c53cdb4$export$484c253d81a91400);

var $cblKs = parcelRequire("cblKs");

var $4cTDP = parcelRequire("4cTDP");

var $cxKOj = parcelRequire("cxKOj");

var $bmoS1 = parcelRequire("bmoS1");

var $bNexr = parcelRequire("bNexr");

var $f5OzW = parcelRequire("f5OzW");

var $eaTQ3 = parcelRequire("eaTQ3");
const $86bad56f8c53cdb4$export$484c253d81a91400 = ({ isIssueArchivalEnabled: isIssueArchivalEnabled = false })=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const edition = (0, $bNexr.useEdition)(projectKey, true);
    const isArchived = (0, $bmoS1.useIsArchived)();
    const [issueType] = (0, $eaTQ3.useFieldValue)({
        issueKey: issueKey,
        fieldKey: 'issuetype'
    });
    const [permissions] = (0, $f5OzW.useProjectPermissions)(projectKey);
    const isSubtask = issueType?.subtask;
    const isUneligibleForArchivalWithLicenseCheck = edition === (0, $cblKs.FREE_EDITION) || edition === (0, $cblKs.STANDARD_EDITION) || !isIssueArchivalEnabled;
    const isUneligibleForArchivalWithoutLicenseCheck = !(permissions.canArchiveIssue && !isSubtask && !isArchived) && !isIssueArchivalEnabled;
    const isUneligibleForIssueArchival = (0, $4cTDP.fg)('extend_issue_archival_for_free_and_standard') ? isUneligibleForArchivalWithoutLicenseCheck : isUneligibleForArchivalWithLicenseCheck;
    return isUneligibleForIssueArchival && (0, $cxKOj.expVal)('issue_deletion_two_step_process_for_free_standard', 'isIssueDeleteExperimentFreemiumEnabled', false);
};

});

const $d54faf1fa9641b6a$export$a97e1a5849845ab3 = 'issue-view-foundation.issue-actions.delete-issue.textfield';


parcelRegister("8l1NO", function(module, exports) {
$parcel$export(module.exports, "useDeleteIssueModalStates", () => $5bc5b9600e63a861$export$d45f9f69a51ec7b1);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $9bIo2 = parcelRequire("9bIo2");
const $5bc5b9600e63a861$export$d45f9f69a51ec7b1 = (0, $iJq0l.createStateHook)((0, $9bIo2.DeleteIssueModalStore));

});
parcelRegister("9bIo2", function(module, exports) {
$parcel$export(module.exports, "DeleteIssueModalStore", () => $f7f926b9046bb506$export$d1e440480df04);
$parcel$export(module.exports, "useDeleteIssueModalActions", () => $f7f926b9046bb506$export$ec8cd1345f95f9aa);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $ha2c5 = parcelRequire("ha2c5");

var $koLmH = parcelRequire("koLmH");
const $f7f926b9046bb506$export$d1e440480df04 = (0, $GtRbT.createStore)({
    initialState: $koLmH.initialState,
    actions: (0, $ha2c5.DeleteIssueModalActions),
    name: 'DeleteIssueModalStore'
});
const $f7f926b9046bb506$export$ec8cd1345f95f9aa = (0, $iJq0l.createActionsHook)($f7f926b9046bb506$export$d1e440480df04);

});
parcelRegister("ha2c5", function(module, exports) {
$parcel$export(module.exports, "DeleteIssueModalActions", () => $b92588e4aaa777f4$export$af54eec6d7dd9751);
const $b92588e4aaa777f4$var$noop = ()=>{
    return null;
};
const $b92588e4aaa777f4$export$af54eec6d7dd9751 = {
    openDeleteIssueModal: ({ isIssueArchivalEnabled: isIssueArchivalEnabled, workType: workType, issueKey: issueKey, issueId: issueId, onIssueDeleteSuccess: onIssueDeleteSuccess, onIssueDeleteFailure: onIssueDeleteFailure, onTriggerDeleteRequest: onTriggerDeleteRequest })=>({ setState: setState })=>{
            setState({
                isDeleteIssueModalOpen: true,
                isIssueArchivalEnabled: isIssueArchivalEnabled,
                workType: workType,
                issueKey: issueKey,
                issueId: issueId,
                onIssueDeleteSuccess: onIssueDeleteSuccess,
                onIssueDeleteFailure: onIssueDeleteFailure,
                onTriggerDeleteRequest: onTriggerDeleteRequest
            });
        },
    closeDeleteIssueModal: ()=>({ setState: setState })=>{
            setState({
                isDeleteIssueModalOpen: false,
                didIssueDeleteFail: false,
                isDeletingIssue: false,
                issueKey: '',
                issueId: '',
                isIssueArchivalEnabled: false,
                workType: null,
                onIssueDeleteSuccess: $b92588e4aaa777f4$var$noop,
                onIssueDeleteFailure: $b92588e4aaa777f4$var$noop,
                onTriggerDeleteRequest: $b92588e4aaa777f4$var$noop
            });
        },
    startDeleteIssue: ()=>({ setState: setState })=>{
            setState({
                isDeletingIssue: true
            });
        },
    endDeleteIssue: ({ didIssueDeleteFail: didIssueDeleteFail })=>({ setState: setState })=>{
            setState({
                isDeletingIssue: false,
                didIssueDeleteFail: didIssueDeleteFail
            });
        }
};

});

parcelRegister("koLmH", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $a810b026a0078b26$export$d4c72bab9d6cc13a);
const $a810b026a0078b26$var$noop = ()=>{
    return null;
};
const $a810b026a0078b26$export$d4c72bab9d6cc13a = {
    isDeleteIssueModalOpen: false,
    didIssueDeleteFail: false,
    isDeletingIssue: false,
    issueKey: '',
    issueId: '',
    workType: null,
    isIssueArchivalEnabled: false,
    onIssueDeleteSuccess: $a810b026a0078b26$var$noop,
    onIssueDeleteFailure: $a810b026a0078b26$var$noop,
    onTriggerDeleteRequest: $a810b026a0078b26$var$noop
};

});



parcelRegister("5wZfc", function(module, exports) {
$parcel$export(module.exports, "IssueFieldStatisticsEntrypointProvider", () => $aa03ead9a51cd198$export$2043a5b19c8c0e7f);
$parcel$export(module.exports, "useIssueFieldStatisticsEntryPoint", () => $aa03ead9a51cd198$export$8e48443ccac1a85f);

var $eJOHy = parcelRequire("eJOHy");

var $iWvkh = parcelRequire("iWvkh");

var $cHtIB = parcelRequire("cHtIB");

var $8slLo = parcelRequire("8slLo");

var $kxXHK = parcelRequire("kxXHK");

var $9OKW6 = parcelRequire("9OKW6");
const $aa03ead9a51cd198$var$IssueFieldStatisticsEntrypointContext = (0, $8slLo.createUseEntryPointContext)();
const $aa03ead9a51cd198$export$2043a5b19c8c0e7f = ({ children: children, jql: jql, view: view })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            jql: jql,
            view: view,
            namespace: (0, $kxXHK.ISSUE_SEARCH_NAMESPACE)
        }), [
        cloudId,
        jql,
        view
    ]);
    const createObjectEntryPoint = (0, $iWvkh.useEntryPoint)((0, $9OKW6.issueFieldStatisticsStatisticsSidebarEntryPoint), entryPointParams);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa03ead9a51cd198$var$IssueFieldStatisticsEntrypointContext.Provider, {
        value: createObjectEntryPoint
    }, children);
};
const $aa03ead9a51cd198$export$8e48443ccac1a85f = ()=>(0, $eJOHy.useContext)($aa03ead9a51cd198$var$IssueFieldStatisticsEntrypointContext);

});
parcelRegister("8slLo", function(module, exports) {
$parcel$export(module.exports, "createUseEntryPointContext", () => $ffc50fa7ddd4407e$export$41bce2223126846b);

var $eJOHy = parcelRequire("eJOHy");
const $ffc50fa7ddd4407e$export$41bce2223126846b = ()=>/*#__PURE__*/ (0, $eJOHy.createContext)({
        entryPointActions: {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            cancelPreload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            load () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            preload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            unload () {}
        },
        entryPointReferenceSubject: {
            getValue: ()=>null,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            subscribe: ()=>()=>{}
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stopMetric () {}
    });

});

parcelRegister("kxXHK", function(module, exports) {
$parcel$export(module.exports, "SIDEBAR_EXPERIENCE_NAME", () => $e8f10c94b288c89a$export$716d68d214fad041);
$parcel$export(module.exports, "ISSUE_SEARCH_NAMESPACE", () => $e8f10c94b288c89a$export$de2495608df10495);

var $7mF43 = parcelRequire("7mF43");
const $e8f10c94b288c89a$export$716d68d214fad041 = 'issue-field-statistics';
const $e8f10c94b288c89a$export$6d9ce65a72493aac = 'statistics';
const $e8f10c94b288c89a$export$de2495608df10495 = 'ISSUE_NAVIGATOR';
const $e8f10c94b288c89a$var$AUTO_OPEN_SIDEBAR_KEY = 'sidebar';
const $e8f10c94b288c89a$export$b229a6bf782d77e7 = 'statistics-field';
const $e8f10c94b288c89a$export$c4ec2849fcb32515 = 'statistics-chart';
const $e8f10c94b288c89a$export$70a91e824238865d = (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))($e8f10c94b288c89a$export$b229a6bf782d77e7);
const $e8f10c94b288c89a$export$60179bff81db3578 = (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))($e8f10c94b288c89a$export$c4ec2849fcb32515);
const $e8f10c94b288c89a$export$1816113812ed602d = Object.freeze({
    [$e8f10c94b288c89a$var$AUTO_OPEN_SIDEBAR_KEY]: undefined,
    [$e8f10c94b288c89a$export$70a91e824238865d]: undefined,
    [$e8f10c94b288c89a$export$60179bff81db3578]: undefined
});

});

parcelRegister("9OKW6", function(module, exports) {
$parcel$export(module.exports, "issueFieldStatisticsStatisticsSidebarEntryPoint", () => $60b1efd9ec0a629d$export$89d0b9a4111dd3ef);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $aMYSz = parcelRequire("aMYSz");

const $60b1efd9ec0a629d$export$89d0b9a4111dd3ef = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("evwNC")), {
        moduleId: "ab72f17f",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, jql: jql, view: view, namespace: namespace })=>({
            queries: {
                issueFieldStatistics: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $aMYSz.default,
                    variables: {
                        cloudId: cloudId,
                        jql: jql,
                        view: view,
                        namespace: namespace
                    }
                }
            }
        })
});

});
parcelRegister("aMYSz", function(module, exports) {
$parcel$export(module.exports, "default", () => $156404c18fc02aed$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2a8004fa45eb0b812b77be54fd002799>>
 * @relayHash f30148119addea651a9b8860c7c557f6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7b33dff432f340c6c68b9ae784353feca7ff3fcc20bd2bcdf7edabe537ad1a7b
const $156404c18fc02aed$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "7b33dff432f340c6c68b9ae784353feca7ff3fcc20bd2bcdf7edabe537ad1a7b",
        "metadata": {},
        "name": "ui_StatisticsSidebarQuery",
        "operationKind": "query",
        "text": null
    }
};
var $156404c18fc02aed$export$2e2bcd8739ae039 = $156404c18fc02aed$var$node;

});

parcelRegister("evwNC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1bKd7").then(()=>parcelRequire('dY8bj'));

});



parcelRegister("C81Q0", function(module, exports) {
$parcel$export(module.exports, "asyncBulkOpsCoreEntryPoint", () => $085cd2d3be43b631$export$d90d57132636bb1);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $085cd2d3be43b631$export$d90d57132636bb1 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("8vYW1")), {
        moduleId: "f81933b6",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8vYW1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6X94G").then(()=>parcelRequire('9YtPn'));

});


parcelRegister("lHHP1", function(module, exports) {
$parcel$export(module.exports, "NinChangeboardingContext", () => $c026bf20b22e170d$export$b349f970aff316d8);
$parcel$export(module.exports, "EnableNinChangeboardingProvider", () => $c026bf20b22e170d$export$dd1deacfc61c978a);
$parcel$export(module.exports, "NinChangeboardingTourTarget", () => $c026bf20b22e170d$export$eb95770b90ecc1f3);
$parcel$export(module.exports, "NinChangeboardingTourCard", () => $c026bf20b22e170d$export$7c27d65549066b5);
$parcel$export(module.exports, "useGlobalScopeOptInFlag", () => $c026bf20b22e170d$export$9e9f507adee88e58);

var $eJOHy = parcelRequire("eJOHy");

var $cxKOj = parcelRequire("cxKOj");

var $cSXp8 = parcelRequire("cSXp8");

var $ezJEv = parcelRequire("ezJEv");

var $8tIrO = parcelRequire("8tIrO");

var $4cTDP = parcelRequire("4cTDP");

var $9ncIL = parcelRequire("9ncIL");

var $5Rrlj = parcelRequire("5Rrlj");

var $hqX3Z = parcelRequire("hqX3Z");

var $5gIAR = parcelRequire("5gIAR");
const $c026bf20b22e170d$var$sessionStorageProvider = (0, $8tIrO.createSessionStorageProvider)('', false);
const $c026bf20b22e170d$export$b349f970aff316d8 = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const $c026bf20b22e170d$export$dd1deacfc61c978a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c026bf20b22e170d$export$b349f970aff316d8.Provider, {
        value: true
    }, children);
const $c026bf20b22e170d$export$eb95770b90ecc1f3 = ({ children: children, engagementId: engagementId })=>{
    const isTourEnabled = (0, $eJOHy.useContext)($c026bf20b22e170d$export$b349f970aff316d8);
    if (!isTourEnabled || (0, $4cTDP.fg)('remove_nin_changeboarding_rll_usages')) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hqX3Z.default), {
        engagementId: engagementId
    }, children);
};
const $c026bf20b22e170d$export$7c27d65549066b5 = ({ mode: mode, view: view, hasIssueResults: hasIssueResults, isAiEnabled: isAiEnabled })=>{
    const isTourEnabled = (0, $eJOHy.useContext)($c026bf20b22e170d$export$b349f970aff316d8);
    return !isTourEnabled || (0, $4cTDP.fg)('remove_nin_changeboarding_rll_usages') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Rrlj.AsyncSpotlightCard), {
        mode: mode,
        view: view,
        hasIssueResults: hasIssueResults,
        isAiEnabled: isAiEnabled
    });
};
const $c026bf20b22e170d$export$9e9f507adee88e58 = ()=>{
    const isFlagEnabled = (0, $eJOHy.useContext)($c026bf20b22e170d$export$b349f970aff316d8);
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const onOpenInProductHelpArticle = (0, $ezJEv.useHelpPanelLink)();
    const onLearnMore = (0, $eJOHy.useCallback)(()=>{
        onOpenInProductHelpArticle((0, $9ncIL.LEARN_MORE_IPH_ARTICLE_ID));
    }, [
        onOpenInProductHelpArticle
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const shouldShowOptInFlag = (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration') ? $c026bf20b22e170d$var$sessionStorageProvider.get('showNinOptInFlag') : sessionStorage.getItem('showNinOptInFlag');
        if (isFlagEnabled && shouldShowOptInFlag === 'true') {
            showFlag({
                type: 'success',
                title: (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5gIAR.default).successOptInTitleIssueTermRefresh : (0, $5gIAR.default).successOptInTitle,
                description: (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5gIAR.default).successOptInDescIssueTermRefresh : (0, $5gIAR.default).successOptInDesc,
                messageId: 'issue-navigator-changeboarding.controllers.enable-nin-changeboarding.show-flag.success',
                messageType: 'transactional',
                actions: [
                    {
                        content: (0, $5gIAR.default).successActionLearnMoreLink,
                        onClick: onLearnMore
                    }
                ],
                isAutoDismiss: false,
                testId: 'issue-navigator-changeboarding.optin-success-flag'
            });
            (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration') ? $c026bf20b22e170d$var$sessionStorageProvider.remove('showNinOptInFlag') : sessionStorage.removeItem('showNinOptInFlag');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

});
parcelRegister("ezJEv", function(module, exports) {
$parcel$export(module.exports, "useHelpPanelLink", () => $906804a52fd3782f$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "HelpPanelLink", () => $906804a52fd3782f$export$5a09250ffddd7fd1);
$parcel$export(module.exports, "default", () => $906804a52fd3782f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");


var $3VPsL = parcelRequire("3VPsL");

var $dfP3D = parcelRequire("dfP3D");

var $cxKOj = parcelRequire("cxKOj");
const $906804a52fd3782f$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $3VPsL.useHelpPanelActions)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $60b564818f0d5fed$export$e99efa3985fa3c26), (0, $60b564818f0d5fed$export$23aa6670f346c214), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: type
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: type
            }
        });
    };
    return handleOnClick;
};
const $906804a52fd3782f$export$5a09250ffddd7fd1 = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, onClick: onClick, href: href, fallbackComponent: fallbackComponent, // unused, but needs to be here so it's not passed to Link/Button in the ...props splat
...props })=>{
    const onOpenInProductHelpArticle = $906804a52fd3782f$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle(articleId, type);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        ...props,
        appearance: props.appearance === 'subtle-link' && (0, $cxKOj.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') ? 'link' : props.appearance,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $hcewu.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            props.appearance === 'subtle-link' && (0, $cxKOj.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') && "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnx8stv _jf4cnqa1"
        ])
    }, children);
};
var /**
 * @deprecated Use named export instead.
 */ $906804a52fd3782f$export$2e2bcd8739ae039 = $906804a52fd3782f$export$5a09250ffddd7fd1;
const $906804a52fd3782f$var$buttonWrapperStyles = null;
const $906804a52fd3782f$var$buttonWrapperSubtleStyles = null;

});
const $60b564818f0d5fed$export$c43c7444da662fa1 = '1';
const $60b564818f0d5fed$export$e99efa3985fa3c26 = 'helpPanel';
const $60b564818f0d5fed$export$23aa6670f346c214 = 368;


parcelRegister("9ncIL", function(module, exports) {
$parcel$export(module.exports, "FALLBACK_SUPPORT_ARTICLE", () => $1b1bba2c09c1943d$export$ff66aa7a4971d979);
$parcel$export(module.exports, "LEARN_MORE_IPH_ARTICLE_ID", () => $1b1bba2c09c1943d$export$88d16e35389ab3c6);
$parcel$export(module.exports, "getEngagementPlatformlMessageId", () => $1b1bba2c09c1943d$export$91074f0ada4f4533);
$parcel$export(module.exports, "TOUR_MESSAGE_ID", () => $1b1bba2c09c1943d$export$4ac775bda929f47);
$parcel$export(module.exports, "views", () => $1b1bba2c09c1943d$export$d0079916fe6800ac);
const $1b1bba2c09c1943d$export$ff66aa7a4971d979 = 'https://support.atlassian.com/jira-software-cloud/docs/search-for-issues-in-jira/';
const $1b1bba2c09c1943d$export$88d16e35389ab3c6 = '3FGQv6n7fB93yWWTYqY0hq';
const $1b1bba2c09c1943d$export$91074f0ada4f4533 = (id)=>`${id}-march2024`;
const $1b1bba2c09c1943d$export$4ac775bda929f47 = 'nin-changeboarding-start';
const $1b1bba2c09c1943d$export$6c69c3d1b5f6fe55 = {
    basic: 'basic',
    advanced: 'advanced'
};
const $1b1bba2c09c1943d$export$d0079916fe6800ac = {
    list: 'list-view',
    detail: 'split-view'
};

});

parcelRegister("5Rrlj", function(module, exports) {
$parcel$export(module.exports, "AsyncSpotlightCard", () => $09a720f6524e2b48$export$40e85aa59c198f98);
// Remove this file on clean up of 'remove_nin_changeboarding_rll_usages'

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $09a720f6524e2b48$var$SpotlightCard = (0, $bQWwW.lazy)(// we want both these types of spotlights to be within the same webpack chunk
()=>(parcelRequire("dgDG6")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/changeboarding/src/common/ui/spotlight/spotlight-card/index.tsx"
});
const $09a720f6524e2b48$export$40e85aa59c198f98 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-spotlight-card",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-spotlight-card",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($09a720f6524e2b48$var$SpotlightCard, props)));

});
parcelRegister("dgDG6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("2ymnl")
]).then(()=>parcelRequire('knqHM'));

});


parcelRegister("hqX3Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $a165742ed253731e$export$2e2bcd8739ae039);
// Remove this file on clean up of 'remove_nin_changeboarding_rll_usages'

var $eJOHy = parcelRequire("eJOHy");

var $guChT = parcelRequire("guChT");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $bJscI = parcelRequire("bJscI");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a165742ed253731e$var$EngagementSpotlightAsync = (0, $bQWwW.lazy)(()=>(parcelRequire("fbCP6")).then(({ EngagementSpotlight: EngagementSpotlight })=>EngagementSpotlight), {
    ssr: false,
    moduleId: "../platform/packages/personalization/engagekit-ts/src/index.ts"
});
const $a165742ed253731e$var$OldSpotlightTourTarget = ({ children: children, engagementId: engagementId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: engagementId
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-engagement-spotlight",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-engagement-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a165742ed253731e$var$EngagementSpotlightAsync, {
        engagementId: engagementId
    }))));
const $a165742ed253731e$var$SpotlightTourTarget = (0, $bJscI.componentWithFG)('remove_nin_changeboarding_rll_usages', ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null), $a165742ed253731e$var$OldSpotlightTourTarget);
var $a165742ed253731e$export$2e2bcd8739ae039 = $a165742ed253731e$var$SpotlightTourTarget;

});
parcelRegister("fbCP6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("66OvY")
]).then(()=>parcelRequire('cf0I9'));

});


parcelRegister("5gIAR", function(module, exports) {
$parcel$export(module.exports, "default", () => $b48b63ba324164d9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b48b63ba324164d9$var$messages = (0, $7qGN1.defineMessages)({
    successOptInTitle: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-title",
        "defaultMessage": "You've switched to the new issue search"
    },
    successOptInDesc: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-desc",
        "defaultMessage": "Say hello to a faster, cleaner, and more intuitive experience while searching for issues across Jira."
    },
    successActionLearnMoreLink: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-action-learn-more-link",
        "defaultMessage": "Learn more"
    },
    successOptInTitleIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-title-issue-term-refresh",
        "defaultMessage": "You've switched to the new search"
    },
    successOptInDescIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-desc-issue-term-refresh",
        "defaultMessage": "Say hello to a faster, cleaner, and more intuitive experience while searching for work across Jira."
    }
});
var $b48b63ba324164d9$export$2e2bcd8739ae039 = $b48b63ba324164d9$var$messages;

});


parcelRegister("3TtKq", function(module, exports) {
$parcel$export(module.exports, "IssueTableSelectedIssuesContainer", () => $8531abba95832313$export$b11112517798dbed);
$parcel$export(module.exports, "useIssueTableSelectedIssuesActions", () => $8531abba95832313$export$b4602482fdfd31ed);
$parcel$export(module.exports, "useIssueTableSelectedIssues", () => $8531abba95832313$export$ad5f97924b14314b);
$parcel$export(module.exports, "useSelectedIssuesState", () => $8531abba95832313$export$b1fbb226d385face);
$parcel$export(module.exports, "useIssueTableSelectAllTotalSelected", () => $8531abba95832313$export$dc4b7e7d055a0e6c);
$parcel$export(module.exports, "useIsIssueSelectedOld", () => $8531abba95832313$export$f1f122caeb05df26);
$parcel$export(module.exports, "useIsIssueSelected", () => $8531abba95832313$export$cfefd69fc8a5ac52);
$parcel$export(module.exports, "useAreAllIssuesSelected", () => $8531abba95832313$export$949e47631f4a60a5);
$parcel$export(module.exports, "useIsHeaderCheckboxIndeterminate", () => $8531abba95832313$export$c5603c18b2a7ed7a);
$parcel$export(module.exports, "useIsSelectingAll", () => $8531abba95832313$export$815cd134b5001b40);
$parcel$export(module.exports, "useExcludedIssueIds", () => $8531abba95832313$export$f8e8cd326aec0190);

var $cSmYj = parcelRequire("cSmYj");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $cxKOj = parcelRequire("cxKOj");


var $1hqwo = parcelRequire("1hqwo");
const $8531abba95832313$export$b11112517798dbed = (0, $6E16M.createContainer)();
const $8531abba95832313$var$Store = (0, $GtRbT.createStore)({
    initialState: $1hqwo.initialState,
    actions: $1hqwo.actions,
    name: 'jira-native-issue-table-selected-issues-state',
    containedBy: $8531abba95832313$export$b11112517798dbed
});
const $8531abba95832313$export$b4602482fdfd31ed = (0, $iJq0l.createActionsHook)($8531abba95832313$var$Store);
const $8531abba95832313$var$getSelectedIssueIdsSelector = (state)=>{
    return Array.from(state.selectedIssueIds);
};
const $8531abba95832313$export$ad5f97924b14314b = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getSelectedIssueIdsSelector
});
const $8531abba95832313$var$getSelectedState = (state)=>{
    return state;
};
const $8531abba95832313$export$b1fbb226d385face = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getSelectedState
});
const $8531abba95832313$var$getSelectAllTotalSelected = (state, totalIssueSearchResultCount)=>{
    const limitedTotalIssueSearchResultCount = totalIssueSearchResultCount > (0, $ac0d9865d010f3a9$export$bccea427639cacb7) ? (0, $ac0d9865d010f3a9$export$bccea427639cacb7) : totalIssueSearchResultCount;
    return limitedTotalIssueSearchResultCount + state.selectedIssueIds.size - (limitedTotalIssueSearchResultCount >= (0, $ac0d9865d010f3a9$export$bccea427639cacb7) ? state.exclusionCount : 0) - state.excludedIssueIds.size;
};
const $8531abba95832313$export$dc4b7e7d055a0e6c = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getSelectAllTotalSelected
});
const $8531abba95832313$var$getIsIssueIdSelectedSelector = (state, { rowIndex: rowIndex, issueId: issueId, depth: depth })=>{
    // issueId is a uuid when optimistically created via inline create and therefore NaN
    const isOptimisticIssueId = Number.isNaN(Number(issueId)) && (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false);
    if (isOptimisticIssueId) return false;
    const selectLimit = (0, $ac0d9865d010f3a9$export$bccea427639cacb7) - state.exclusionCount;
    if (state.isSelectingAll && (rowIndex > selectLimit - 1 || state.excludedIssueIds.has(issueId)) && !state.selectedIssueIds.has(issueId)) return false;
    return state.isSelectingAll && !depth || state.selectedIssueIds.has(issueId);
};
const $8531abba95832313$var$getIsIssueIdSelectedSelectorOld = (state, issueId)=>{
    return state.selectedIssueIds.has(issueId);
};
const $8531abba95832313$export$f1f122caeb05df26 = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getIsIssueIdSelectedSelectorOld
});
const $8531abba95832313$export$cfefd69fc8a5ac52 = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getIsIssueIdSelectedSelector
});
const $8531abba95832313$var$getAreAllIssuesSelectedSelector = (state, issueIds)=>{
    if (state.isSelectingAll && (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false)) // everything is selected unless there are issues in excludedIssueIds
    return state.excludedIssueIds.size === 0;
    if (!issueIds) return false;
    return issueIds.length > 0 && issueIds.every((issueId)=>state.selectedIssueIds.has(issueId));
};
const $8531abba95832313$export$949e47631f4a60a5 = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getAreAllIssuesSelectedSelector
});
const $8531abba95832313$var$getIsHeaderCheckboxIndeterminate = (state, { isChecked: isChecked, allUnloadedOrLoadedChilds: allUnloadedOrLoadedChilds })=>{
    const { isSelectingAll: isSelectingAll, totalIssueSearchResultCount: totalIssueSearchResultCount, excludedIssueIds: excludedIssueIds, selectedIssueIds: selectedIssueIds } = state;
    if (isSelectingAll) {
        const isOverSelectAllLimit = totalIssueSearchResultCount && totalIssueSearchResultCount >= (0, $ac0d9865d010f3a9$export$bccea427639cacb7);
        const hasExcludedIssuesAndNotAllExcluded = excludedIssueIds.size > 0 && totalIssueSearchResultCount !== excludedIssueIds.size;
        const hasUnselectedExpandedChild = !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(selectedIssueIds, allUnloadedOrLoadedChilds);
        return isOverSelectAllLimit || hasExcludedIssuesAndNotAllExcluded || hasUnselectedExpandedChild;
    }
    return !isChecked && selectedIssueIds.size > 0;
};
const $8531abba95832313$export$c5603c18b2a7ed7a = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getIsHeaderCheckboxIndeterminate
});
const $8531abba95832313$var$getIsSelectingAll = (state)=>{
    return state.isSelectingAll;
};
const $8531abba95832313$export$815cd134b5001b40 = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getIsSelectingAll
});
const $8531abba95832313$var$getExcludedIssueIds = (state)=>{
    return Array.from(state.excludedIssueIds);
};
const $8531abba95832313$export$f8e8cd326aec0190 = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getExcludedIssueIds
});

});
const $ac0d9865d010f3a9$export$ed483e23b857a8f6 = 'edit-button';
const $ac0d9865d010f3a9$export$c9fe64c29742060e = 'sidebar-header';
const $ac0d9865d010f3a9$export$8789cbfc17809729 = 'sidebar-search';
const $ac0d9865d010f3a9$export$9d8014b892bf6344 = 'sidebar-field';
const $ac0d9865d010f3a9$export$f08be8cd81d9f623 = 382;
const $ac0d9865d010f3a9$export$3a2b34d7e17c7646 = 448;
const $ac0d9865d010f3a9$export$9c1c16e5827224e9 = 'bulkMenu';
const $ac0d9865d010f3a9$export$e9a6cdc6ca093f61 = 'bulkEdit';
const $ac0d9865d010f3a9$export$2de0d879ab3de42d = 'bulkTransition';
const $ac0d9865d010f3a9$export$bccea427639cacb7 = 1000;

parcelRegister("1hqwo", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $d2b10d6e7ee3216e$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "actions", () => $d2b10d6e7ee3216e$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state


var $cxKOj = parcelRequire("cxKOj");
const $d2b10d6e7ee3216e$export$d4c72bab9d6cc13a = {
    isSelectingAll: false,
    exclusionCount: 0,
    selectedIssueIds: new Set([]),
    excludedIssueIds: new Set([]),
    lastSelectedRowIndex: null,
    totalIssueSearchResultCount: null
};
const $d2b10d6e7ee3216e$export$e324594224ef24da = {
    selectAllIssues: (data)=>({ dispatch: dispatch, setState: setState }, { onIssueSelected: onIssueSelected, shouldForceManualSelectAll: shouldForceManualSelectAll })=>{
            const { childIds: childIds, count: count, visibleIds: visibleIds } = data;
            const hasReachedLimit = (visibleIds.length ?? 0) >= (0, $ac0d9865d010f3a9$export$bccea427639cacb7);
            const limitedVisibleIds = hasReachedLimit ? visibleIds.slice(0, (0, $ac0d9865d010f3a9$export$bccea427639cacb7)) : visibleIds;
            if (shouldForceManualSelectAll || hasReachedLimit) // when grouping is enabled or the first page is not loaded we should disable "true" select all functionality
            // and fallback to selecting all the loaded issue ids
            dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.insertSelectedIssueIds(limitedVisibleIds));
            else {
                // otherwise conditions are met for true select all
                onIssueSelected?.([]);
                setState({
                    isSelectingAll: true,
                    exclusionCount: childIds?.length ?? 0,
                    selectedIssueIds: new Set(childIds ?? []),
                    excludedIssueIds: new Set([]),
                    totalIssueSearchResultCount: count
                });
            }
        },
    checkIssueRowSelectAll: (selectedIssueIds, isChecked, isShiftPressed, flatList, currentCheckedIndex, depth)=>({ dispatch: dispatch, getState: getState, setState: setState })=>{
            const currentState = getState();
            if (isShiftPressed && currentState.lastSelectedRowIndex !== null) {
                const beyondLimitIssueIds = selectedIssueIds.filter((id)=>{
                    const idx = flatList.findIndex((flatId)=>flatId === id);
                    return idx > (0, $ac0d9865d010f3a9$export$bccea427639cacb7) - 1;
                });
                const withinLimitIssueIds = selectedIssueIds.filter((id)=>{
                    const idx = flatList.findIndex((flatId)=>flatId === id);
                    return idx < (0, $ac0d9865d010f3a9$export$bccea427639cacb7);
                });
                if (isChecked) {
                    const updatedExcludedIssueIds = new Set(currentState.excludedIssueIds);
                    withinLimitIssueIds.forEach((id)=>updatedExcludedIssueIds.delete(id));
                    setState({
                        selectedIssueIds: new Set([
                            ...currentState.selectedIssueIds,
                            ...beyondLimitIssueIds
                        ]),
                        excludedIssueIds: updatedExcludedIssueIds
                    });
                } else {
                    const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
                    beyondLimitIssueIds.forEach((id)=>updatedSelectedIssueIds.delete(id));
                    const updatedExcludedIssueIds = new Set([
                        ...currentState.excludedIssueIds,
                        ...withinLimitIssueIds
                    ]);
                    setState({
                        selectedIssueIds: updatedSelectedIssueIds,
                        excludedIssueIds: updatedExcludedIssueIds
                    });
                    // if all issues have been excluded, we are not selecting all anymore
                    if (updatedExcludedIssueIds.size === currentState.totalIssueSearchResultCount) dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.reset());
                }
                return;
            }
            if (isChecked) dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.addToSelectAllIssues(selectedIssueIds, currentCheckedIndex, depth));
            else dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.excludeFromSelectAllIssues(selectedIssueIds, currentCheckedIndex, depth));
        },
    excludeFromSelectAllIssues: (issueIds, rowIndex, depth = 0)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const currentState = getState();
            if (rowIndex <= (0, $ac0d9865d010f3a9$export$bccea427639cacb7) - 1 && depth === 0) {
                const updatedExcludedIssueIds = new Set([
                    ...currentState.excludedIssueIds,
                    ...issueIds
                ]);
                setState({
                    excludedIssueIds: updatedExcludedIssueIds
                });
                // if all issues have been excluded, we are not selecting all anymore
                if (updatedExcludedIssueIds.size === currentState.totalIssueSearchResultCount) dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.reset());
            } else {
                const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
                issueIds.forEach((issueId)=>updatedSelectedIssueIds.delete(issueId));
                setState({
                    selectedIssueIds: updatedSelectedIssueIds
                });
            }
        },
    addToSelectAllIssues: (issueIds, rowIndex, depth = 0)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (rowIndex > (0, $ac0d9865d010f3a9$export$bccea427639cacb7) - 1 || depth > 0) setState({
                selectedIssueIds: new Set([
                    ...currentState.selectedIssueIds,
                    ...issueIds
                ])
            });
            else {
                const updatedExcludedIssueIds = new Set(currentState.excludedIssueIds);
                issueIds.forEach((issueId)=>updatedExcludedIssueIds.delete(issueId));
                setState({
                    excludedIssueIds: updatedExcludedIssueIds
                });
            }
        },
    insertSelectedIssueIds: (selectedIssueIds)=>({ setState: setState, getState: getState }, { onIssueSelected: onIssueSelected })=>{
            const currentState = getState();
            onIssueSelected?.(selectedIssueIds);
            setState({
                selectedIssueIds: new Set([
                    ...currentState.selectedIssueIds,
                    ...selectedIssueIds
                ])
            });
        },
    removeSelectedIssueIds: (selectedIssueIds)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
            selectedIssueIds.forEach((selectedIssueId)=>{
                updatedSelectedIssueIds.delete(selectedIssueId);
            });
            setState({
                selectedIssueIds: updatedSelectedIssueIds
            });
        },
    insertSelectedIssueId: (selectedIssueId)=>({ setState: setState, getState: getState }, { onIssueSelected: onIssueSelected })=>{
            const currentState = getState();
            const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
            updatedSelectedIssueIds.add(selectedIssueId);
            onIssueSelected?.([
                selectedIssueId
            ]);
            setState({
                selectedIssueIds: updatedSelectedIssueIds
            });
        },
    removeSelectedIssueId: (selectedIssueId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
            updatedSelectedIssueIds.delete(selectedIssueId);
            setState({
                selectedIssueIds: updatedSelectedIssueIds
            });
        },
    selectedOnlyIssueId: (selectedIssueId)=>({ setState: setState }, { onIssueSelected: onIssueSelected })=>{
            onIssueSelected?.([
                selectedIssueId
            ]);
            setState({
                selectedIssueIds: new Set([
                    selectedIssueId
                ])
            });
        },
    updateLastSelectedRowIndex: (lastSelectedRowIndex)=>({ setState: setState })=>{
            setState({
                lastSelectedRowIndex: lastSelectedRowIndex
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState($d2b10d6e7ee3216e$export$d4c72bab9d6cc13a);
        },
    checkIssueRow: (issueId, isChecked, isShiftPressed, flatList, depth)=>({ dispatch: dispatch, getState: getState })=>{
            // issueId is a uuid when optimistically created via inline create and therefore NaN
            const isOptimisticIssueId = Number.isNaN(Number(issueId)) && (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false);
            if (isOptimisticIssueId) return;
            const selectedIssueIds = [
                issueId
            ];
            const currentState = getState();
            const currentCheckedIndex = flatList.findIndex((id)=>id === issueId);
            if (isShiftPressed && currentState.lastSelectedRowIndex !== null) {
                const start = Math.min(currentState.lastSelectedRowIndex, currentCheckedIndex);
                const end = Math.max(currentState.lastSelectedRowIndex, currentCheckedIndex);
                selectedIssueIds.push(...flatList.slice(start, end + 1).filter((id)=>id !== issueId));
            }
            dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.updateLastSelectedRowIndex(currentCheckedIndex));
            if (currentState.isSelectingAll && (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false)) dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.checkIssueRowSelectAll(selectedIssueIds, isChecked, isShiftPressed, flatList, currentCheckedIndex, depth));
            else if (isChecked) dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.insertSelectedIssueIds(selectedIssueIds));
            else dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.removeSelectedIssueIds(selectedIssueIds));
        }
};

});


parcelRegister("9WMzW", function(module, exports) {
$parcel$export(module.exports, "SidebarLayout", () => $3d4052942a7691d5$export$8295a33ab8a36876);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");

var $d5C8k = parcelRequire("d5C8k");

var $5vQ2T = parcelRequire("5vQ2T");

var $gHKwt = parcelRequire("gHKwt");

const $3d4052942a7691d5$export$8295a33ab8a36876 = ({ children: children, content: content, teamName: teamName, defaultRatio: defaultRatio, minWidth: minWidth, minRatio: minRatio, maxRatio: maxRatio })=>{
    const [{ id: id }, { closeSidebar: closeSidebar }] = (0, $gHKwt.useSidebar)();
    // reset sidebar content on view unmount
    (0, $eJOHy.useEffect)(()=>()=>{
            closeSidebar();
        }, [
        closeSidebar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        testId: "platform-sidebar.ui.sidebar-layout",
        xcss: $3d4052942a7691d5$var$styles.wrapper,
        direction: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $3d4052942a7691d5$var$styles.childContentContainer
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "sidebarWrapper",
        packageName: (0, $e8c1aaa176754652$export$b8b9d90f9e5bd72b),
        teamName: teamName,
        fallback: "flag",
        attributes: {
            sidebarExperienceId: id
        }
    }, id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d5C8k.default), {
        defaultRatio: defaultRatio,
        minWidth: minWidth,
        minRatio: minRatio,
        maxRatio: maxRatio
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            ...props,
            className: (0, $hcewu.default)([
                $3d4052942a7691d5$var$styles.sidebarContentContainer
            ])
        }, content)) : null));
};
const $3d4052942a7691d5$var$styles = {
    wrapper: "_4t3i1osq _18m91wug",
    sidebarContentContainer: "_16qs130s _18u0xmi2",
    childContentContainer: "_16jlkb7n _1o9zkb7n _i0dlidpf _18m91wug"
};

});
parcelRegister("d5C8k", function(module, exports) {
$parcel$export(module.exports, "default", () => $7012978e78c939c3$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kjGDT = parcelRequire("kjGDT");

var $4nS5e = parcelRequire("4nS5e");

var $9NK7W = parcelRequire("9NK7W");
var $7012978e78c939c3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
    const { children: children, ...resizerProps } = props;
    const { minRatio: minRatio = 0, maxRatio: maxRatio = 1, minWidth: minWidth, maxWidth: maxWidth, initialRatio: initialRatio, defaultRatio: defaultRatio, extraWidth: extraWidth, position: position = 'left', resizeHandleAsOverlay: resizeHandleAsOverlay, collapsed: collapsed, additionalStyles: additionalStyles } = resizerProps;
    // Ensure the ratio which is initially set to the flex-basis style is bounded between the min/max ratios
    // The css properties handles max-width and min-width
    const ratio = (0, $eJOHy.useRef)((0, $4nS5e.clampValue)({
        value: initialRatio ?? defaultRatio,
        minValue: minRatio,
        maxValue: maxRatio
    }));
    /** If resizer is expanded and the ratio is 0, set the ratio to the initial ratio.
   *  This logic would need to change if we allow users to "uncollapse" the resizer manually, because currently this code will reset the ratio to the initial ratio.
   */ if (!collapsed && ratio.current === 0) ratio.current = (0, $4nS5e.clampValue)({
        value: initialRatio ?? defaultRatio,
        minValue: minRatio,
        maxValue: maxRatio
    });
    const container = (0, $eJOHy.useRef)(null);
    const renderHandle = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9NK7W.default), {
            additionalStyles: additionalStyles,
            ...resizerProps,
            ...initialRatio !== undefined ? {
                initialRatio: ratio.current,
                defaultRatio: (0, $4nS5e.clampValue)({
                    value: defaultRatio,
                    minValue: minRatio,
                    maxValue: maxRatio
                })
            } : {
                defaultRatio: ratio.current
            },
            childrenContainerRef: container
        });
    const renderResizer = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, position === 'left' && renderHandle(), typeof children === 'function' ? children({
            ref: (r)=>{
                container.current = r;
            },
            style: (0, $4nS5e.getChildrenStyle)(ratio.current, minWidth, maxWidth, extraWidth, collapsed)
        }) : children, position === 'right' && renderHandle());
    return resizeHandleAsOverlay ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7012978e78c939c3$export$c7990a6594835e51, {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $4nS5e.getChildrenStyle)(ratio.current, minWidth, maxWidth, extraWidth, collapsed),
        ref: container,
        "data-testid": "flex-resizer.ui.resize-wrapper"
    }, renderResizer()) : renderResizer();
});
const $7012978e78c939c3$export$c7990a6594835e51 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _1e0c1txw _lcxv1wug _q0u0kb7n _2e98kb7n _12rof1ug",
            __cmplp.className
        ])
    });
});
const $7012978e78c939c3$export$70af81d424c0709 = (0, $kjGDT.resizerStyleOverrides);

});
parcelRegister("kjGDT", function(module, exports) {
$parcel$export(module.exports, "resizerStyleOverrides", () => $ff0b8bd6b1597acb$export$70af81d424c0709);
const $ff0b8bd6b1597acb$export$70af81d424c0709 = {
    ISSUE_VIEW_MARGIN_OFFSET: 'issue-view-margin-offset'
};

});

parcelRegister("4nS5e", function(module, exports) {
$parcel$export(module.exports, "RESIZE_HANDLE_WIDTH", () => $a93c3f899c271ccd$export$45f504201feb6ea6);
$parcel$export(module.exports, "useAnimationFrameThrottle", () => $a93c3f899c271ccd$export$9d3ed311e5db6a6f);
$parcel$export(module.exports, "useDoubleClick", () => $a93c3f899c271ccd$export$b1d0a5c81935127f);
$parcel$export(module.exports, "clampValue", () => $a93c3f899c271ccd$export$31ee16100cde6ce2);
$parcel$export(module.exports, "calculateNewRatio", () => $a93c3f899c271ccd$export$58e1996e98bfba9e);
$parcel$export(module.exports, "getChildrenStyle", () => $a93c3f899c271ccd$export$f2a5e228fabed40b);

var $eJOHy = parcelRequire("eJOHy");
const $a93c3f899c271ccd$export$45f504201feb6ea6 = 26;
const $a93c3f899c271ccd$export$9d3ed311e5db6a6f = (callback)=>{
    const token = (0, $eJOHy.useRef)(null);
    const lastArgs = (0, $eJOHy.useRef)(null);
    const hasTriggered = (0, $eJOHy.useRef)(false);
    const handleFrame = (0, $eJOHy.useCallback)(()=>{
        lastArgs.current = null;
        hasTriggered.current = false;
    }, []);
    const throttle = (0, $eJOHy.useCallback)((...args)=>{
        lastArgs.current = args;
        if (hasTriggered.current) return;
        callback(...args);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        token.current = window.requestAnimationFrame(handleFrame);
        hasTriggered.current = true;
    }, [
        handleFrame,
        callback
    ]);
    const cancel = (0, $eJOHy.useCallback)(()=>{
        if (token.current) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.cancelAnimationFrame(token.current);
        if (!hasTriggered.current && lastArgs.current !== null) callback(...lastArgs.current);
        token.current = null;
        lastArgs.current = null;
        hasTriggered.current = false;
    }, [
        callback
    ]);
    (0, $eJOHy.useEffect)(()=>()=>cancel(), [
        callback,
        cancel
    ]);
    return [
        throttle,
        cancel
    ];
};
const $a93c3f899c271ccd$export$b1d0a5c81935127f = (callback)=>{
    const lastClickTime = (0, $eJOHy.useRef)(0);
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        const now = Date.now();
        if (now - lastClickTime.current < 500) {
            lastClickTime.current = 0;
            callback();
            return true;
        }
        lastClickTime.current = now;
        return false;
    }, [
        callback
    ]);
    return handleClick;
};
const $a93c3f899c271ccd$export$29ae71364f84a225 = (element)=>{
    const style = getComputedStyle(element);
    const paddingX = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
    return paddingX;
};
const $a93c3f899c271ccd$export$31ee16100cde6ce2 = ({ value: value, minValue: minValue, maxValue: maxValue })=>Math.min(Math.max(value, minValue), maxValue);
const $a93c3f899c271ccd$export$58e1996e98bfba9e = ({ parentWidth: parentWidth, currentWidth: currentWidth, deltaX: deltaX, minWidth: minWidth, minRatio: minRatio, maxWidth: maxWidth, maxRatio: maxRatio, baseWidth: baseWidth, position: position })=>{
    const targetWidth = Math.min(Math.max(currentWidth - baseWidth + (position === 'left' ? deltaX : deltaX * -1), minWidth), maxWidth);
    return $a93c3f899c271ccd$export$31ee16100cde6ce2({
        value: targetWidth / parentWidth,
        minValue: minRatio,
        maxValue: maxRatio
    });
};
const $a93c3f899c271ccd$export$f2a5e228fabed40b = (ratio, minWidth, maxWidth, extraWidth = 0, collapsed = false)=>({
        boxSizing: 'border-box',
        flexGrow: 0,
        flexShrink: 1,
        flexBasis: (()=>{
            if (collapsed) return '0%';
            return extraWidth > 0 ? `calc(${ratio * 100}% + ${extraWidth}px)` : `${ratio * 100}%`;
        })(),
        minWidth: (()=>{
            if (collapsed) return 0;
            return minWidth !== undefined ? minWidth : null;
        })(),
        maxWidth: (()=>{
            if (collapsed) return 0;
            return maxWidth !== undefined ? maxWidth : null;
        })()
    });

});

parcelRegister("9NK7W", function(module, exports) {
$parcel$export(module.exports, "default", () => $83bac0df6a44b069$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $bJscI = parcelRequire("bJscI");

var $36Qom = parcelRequire("36Qom");

var $jJktB = parcelRequire("jJktB");

var $gV40x = parcelRequire("gV40x");
const $83bac0df6a44b069$var$ResizeHandle = (0, $bJscI.componentWithFG)('jfp-magma-hydration-resizer', (0, $jJktB.ResizeHandle), (0, $gV40x.ResizeHandleOld));
var $83bac0df6a44b069$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "async.issue.view.resizer",
        packageName: "async.issue.view.resizer",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($83bac0df6a44b069$var$ResizeHandle, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $36Qom.default), props)));

});
parcelRegister("36Qom", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ae4e693bfab32cf$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $o0Fzr = parcelRequire("o0Fzr");

var $cQxBL = parcelRequire("cQxBL");

var $8PCRQ = parcelRequire("8PCRQ");

var $k71qx = parcelRequire("k71qx");

var $6fs4r = parcelRequire("6fs4r");

var $lRq8t = parcelRequire("lRq8t");

var $6d9QY = parcelRequire("6d9QY");

var $bJscI = parcelRequire("bJscI");

var $hbF3h = parcelRequire("hbF3h");

var $4cTDP = parcelRequire("4cTDP");

var $4nS5e = parcelRequire("4nS5e");

var $guiml = parcelRequire("guiml");

var $eIXlM = parcelRequire("eIXlM");

var $gJzIA = parcelRequire("gJzIA");

var $jJktB = parcelRequire("jJktB");

var $gV40x = parcelRequire("gV40x");
const $0ae4e693bfab32cf$var$useId = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jira-react-uid-to-use-id-migration'), (0, $eJOHy.useId), (0, $o0Fzr.useUID));
const $0ae4e693bfab32cf$var$ResizeHandle = (0, $bJscI.componentWithFG)('jfp-magma-hydration-resizer', (0, $jJktB.ResizeHandle), (0, $gV40x.ResizeHandleOld));
const $0ae4e693bfab32cf$var$RESIZE_ICON_TEST_ID = 'flex-resizer.ui.handle.resize-icon';
const $0ae4e693bfab32cf$var$RESIZE_CHEVRON_ICON = 'flex-resizer.ui.handle.chevron-';
const $0ae4e693bfab32cf$var$resizeCursorCollapsed = null;
const $0ae4e693bfab32cf$var$resizeCursor = null;
const $0ae4e693bfab32cf$var$grabAreaStyles = {
    root: "_1bsbo7ao _4t3i1osq _kqswstnw _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _syaz3acm _bfhk18uv _k8m01ylx _1oec1yx9 _1lww5cps _vp7g1v1w _30l31v1w _1dr21ylx _1s5z1ylx _1cg4fnf5 _le1bfnf5 _1gglglyw _9h8h1v1w"
};
const $0ae4e693bfab32cf$var$lineStyles = {
    root: "_kqswstnw _1e0c1ule _1bsbyh40 _4t3i1osq _syaz1kw7 _bfhk1r31 _1e02cy7w"
};
const $0ae4e693bfab32cf$var$TooltipWrapper = ({ toolTipContent: toolTipContent, children: children })=>{
    if (toolTipContent !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: toolTipContent,
        hideTooltipOnClick: true
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $0ae4e693bfab32cf$var$Resizer = ({ childrenContainerRef: childrenContainerRef, initialRatio: initialRatio, defaultRatio: defaultRatio, minWidth: minWidth, minRatio: minRatio = 0, maxWidth: maxWidth, maxRatio: maxRatio = 1, extraWidth: extraWidth = 0, position: position = 'left', resizeHandleAsOverlay: resizeHandleAsOverlay, resizeHandleZIndex: resizeHandleZIndex, onRatioChange: onRatioChange, onRatioReset: onRatioReset, onResizeStart: onResizeStart, chevronDirection: chevronDirection, persistResizeIcon: persistResizeIcon, onResizeHandleClick: onResizeHandleClick, collapsed: collapsed, minWidthLeftContainer: minWidthLeftContainer, minWidthRightContainer: minWidthRightContainer, toolTipContent: toolTipContent })=>{
    const startX = (0, $eJOHy.useRef)(0);
    const startWidth = (0, $eJOHy.useRef)(0);
    const parentWidth = (0, $eJOHy.useRef)(0);
    const onResizeStartStableRef = (0, $eJOHy.useRef)(onResizeStart);
    const onResizeEndStableRef = (0, $eJOHy.useRef)(onRatioChange);
    const [rangeInputValue, setRangeInputValue] = (0, $eJOHy.useState)(maxRatio - (initialRatio ?? defaultRatio));
    const [inputRange, setInputRange] = (0, $eJOHy.useState)({
        min: 0,
        max: 1
    }); /*
           onRatioChange calls setFlexBasisProp from the parent component. Even if the slider value changes to 0 there are
        chances the line splitter can min go upto 0.2. If, user performs keyboard navigation the user will not see any movement
        if the value was 0 unless it reaches to 0.2 lets say
      	  To avoid this, lineSplitterRef.current.getBoundingClientRect -> returns width giving the exact position of the line and we
        can thus update the ratio which we are doing on handleSliderFocus
      */ 
    const lineSplitterRef = (0, $eJOHy.useRef)(null);
    const [keyboardResizeManager] = (0, $eJOHy.useState)(()=>(0, $gJzIA.createKeyboardResizeManager)({
            onResizeStart: ()=>onResizeStartStableRef.current?.(),
            onResizeEnd: (...args)=>{
                return onResizeEndStableRef.current?.(...args);
            }
        }));
    const prevChevronDirection = (0, $6d9QY.usePreviousWithInitial)(chevronDirection);
    const nextRatio = (0, $eJOHy.useRef)(initialRatio ?? defaultRatio);
    const styleElement = (0, $eJOHy.useRef)(null);
    const labelId = $0ae4e693bfab32cf$var$useId();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $eJOHy.useEffect)(()=>{
        /*
    initialRatio is 0 means Panel splitter is completely closed
          When it is collapsed and initialRatio is 0, next time when we expand,
    range should take defaultRatio
           Else
           If initialRatio is > 0, when we collapse the panel and expand, range should take initialRatio.
          */ if (collapsed) // eslint-disable-next-line react-you-might-not-need-an-effect/no-derived-state
        setRangeInputValue(maxRatio - (initialRatio && initialRatio !== 0 ? initialRatio : defaultRatio));
    }, [
        collapsed,
        initialRatio,
        defaultRatio,
        maxRatio
    ]);
    const setFlexBasisProp = (0, $eJOHy.useCallback)((ratio, setNextRatio)=>{
        // This will force-fix any in consistencies in the ratio value if ratio is set from parent components
        if (setNextRatio !== undefined) nextRatio.current = setNextRatio;
        if (childrenContainerRef.current) childrenContainerRef.current.style.setProperty('flex-basis', extraWidth > 0 ? `calc(${ratio * 100}% + ${extraWidth}px)` : `${ratio * 100}%`);
    }, [
        childrenContainerRef,
        extraWidth
    ]);
    const resetDetector = (0, $4nS5e.useDoubleClick)((0, $eJOHy.useCallback)(()=>{
        const targetRatio = (0, $4nS5e.clampValue)({
            value: defaultRatio * parentWidth.current,
            minValue: Math.max(minWidth ?? 0, minRatio * parentWidth.current),
            maxValue: Math.min(maxWidth ?? Infinity, maxRatio * parentWidth.current)
        }) / parentWidth.current;
        nextRatio.current = targetRatio;
        setFlexBasisProp(targetRatio);
        onRatioReset?.(targetRatio);
    }, [
        defaultRatio,
        minWidth,
        minRatio,
        maxWidth,
        maxRatio,
        setFlexBasisProp,
        onRatioReset
    ]));
    const [onPointerMoveThrottled, cancelPointerMove] = (0, $4nS5e.useAnimationFrameThrottle)((0, $eJOHy.useCallback)((e)=>{
        const r = (0, $4nS5e.calculateNewRatio)({
            parentWidth: parentWidth.current,
            currentWidth: startWidth.current,
            deltaX: startX.current - e.pageX,
            minWidth: minWidth ?? 0,
            minRatio: minRatio,
            maxWidth: maxWidth ?? Infinity,
            maxRatio: maxRatio,
            baseWidth: extraWidth,
            position: position
        });
        nextRatio.current = r;
        setFlexBasisProp(r);
    }, [
        extraWidth,
        maxRatio,
        maxWidth,
        minRatio,
        minWidth,
        position,
        setFlexBasisProp
    ]));
    const onPointerMove = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        onPointerMoveThrottled(e);
    }, [
        onPointerMoveThrottled
    ]);
    const onPointerUp = (0, $eJOHy.useCallback)(()=>{
        const r = nextRatio.current;
        const resetTriggered = resetDetector();
        if (!resetTriggered) onRatioChange?.(r, nextRatio.current * parentWidth.current, setFlexBasisProp);
         // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('pointermove', onPointerMove, {
            capture: true
        }); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('pointerup', onPointerUp, {
            capture: true
        });
        const stylesheet = styleElement.current?.sheet;
        if (stylesheet) {
            stylesheet.deleteRule(1);
            stylesheet.deleteRule(0);
        }
        cancelPointerMove();
        setRangeInputValue(maxRatio - r);
    }, [
        cancelPointerMove,
        onPointerMove,
        onRatioChange,
        resetDetector,
        setFlexBasisProp,
        maxRatio
    ]);
    const onPointerDown = (0, $eJOHy.useCallback)((e)=>{
        // Check if the chevron icon was clicked and prevent dragging
        if (onResizeHandleClick && e.target instanceof HTMLElement) {
            const target = (e.target.getAttribute('data-testid') || '').indexOf($0ae4e693bfab32cf$var$RESIZE_CHEVRON_ICON) > -1 ? 'chevron' : 'resizer';
            if (!onResizeHandleClick?.(target, setFlexBasisProp, e)) {
                e.preventDefault();
                return;
            }
        } // Prevent resize when the resizer is collapsed
        if (collapsed) return; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('pointermove', onPointerMove, {
            capture: true
        }); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('pointerup', onPointerUp, {
            capture: true
        });
        const stylesheet = styleElement.current?.sheet;
        if (stylesheet) {
            // There is a chromium bug which forces all scrollbars to be visible when 'pointer-events: none' is added.
            // Chromium bug: https://bugs.chromium.org/p/chromium/issues/detail?id=1280013&q=pointer-events%20scrollbar&can=2
            // The previously implemented workarounds for this issue didn't solve all use cases, i.e., horizontal scrollbars,
            // thus, 'user-select: none' is used to prevent text-highlighting but allows hover events, unlike 'pointer-events'.
            stylesheet.insertRule('body { user-select: none; }', 0); // Set the dragging cursor (higher than disabled pointer events)
            stylesheet.insertRule('#jira { cursor: ew-resize; }', 1);
        }
        const currentContainer = childrenContainerRef.current;
        const parentContainer = currentContainer?.parentElement;
        if (!currentContainer || !parentContainer) return;
        startWidth.current = currentContainer.getBoundingClientRect().width;
        parentWidth.current = parentContainer.getBoundingClientRect().width ?? 0;
        onResizeStart?.();
        startX.current = e.pageX; // This is preventing popups from closing when the resize handle is dragged
        if (!onResizeHandleClick) e.preventDefault();
    }, [
        onPointerMove,
        onPointerUp,
        childrenContainerRef,
        onResizeStart,
        onResizeHandleClick,
        collapsed,
        setFlexBasisProp
    ]);
    const handleSliderFocus = (0, $eJOHy.useCallback)(()=>{
        const stylesheet = styleElement.current?.sheet;
        if (stylesheet) {
            // There is a chromium bug which forces all scrollbars to be visible when 'pointer-events: none' is added.
            // Chromium bug: https://bugs.chromium.org/p/chromium/issues/detail?id=1280013&q=pointer-events%20scrollbar&can=2
            // The previously implemented workarounds for this issue didn't solve all use cases, i.e., horizontal scrollbars,
            // thus, 'user-select: none' is used to prevent text-highlighting but allows hover events, unlike 'pointer-events'.
            stylesheet.insertRule('body { user-select: none; }', 0); // Set the dragging cursor (higher than disabled pointer events)
            stylesheet.insertRule('#jira { cursor: ew-resize; }', 1);
        }
        const currentContainer = childrenContainerRef.current;
        const parentContainer = currentContainer?.parentElement;
        if (!currentContainer || !parentContainer) return;
        startWidth.current = currentContainer.getBoundingClientRect().width;
        parentWidth.current = parentContainer.getBoundingClientRect().width ?? 0; /*
                                                                                    calculate the range only when the user actually wants navigate via
                                                                                    keyboard and save the computation at initial render
                                                                                    */ 
        setInputRange((prev)=>({
                ...prev,
                min: minWidthLeftContainer ? minWidthLeftContainer / parentWidth.current : minRatio,
                max: minWidthRightContainer ? maxRatio - minWidthRightContainer / parentWidth.current : maxRatio
            }));
        onResizeStart?.();
    }, [
        onResizeStart,
        childrenContainerRef,
        maxRatio,
        minRatio,
        minWidthLeftContainer,
        minWidthRightContainer
    ]);
    const handleSliderInputChange = (0, $eJOHy.useCallback)((e)=>{
        const value = parseFloat(e.target.value);
        setRangeInputValue(value); // doing this maxRatio - value because current drag has left as 100% and right as 0% alternative to input range
        nextRatio.current = maxRatio - value;
        setFlexBasisProp(maxRatio - value);
        keyboardResizeManager.onResize({
            ratio: maxRatio - value,
            width: (maxRatio - value) * parentWidth.current,
            flexBasis: setFlexBasisProp
        });
    }, [
        setFlexBasisProp,
        maxRatio,
        keyboardResizeManager
    ]);
    const handleSliderBlur = (0, $eJOHy.useCallback)(()=>{
        const r = maxRatio - nextRatio.current;
        const resetTriggered = resetDetector();
        if (!resetTriggered) onRatioChange?.(r, r * parentWidth.current, setFlexBasisProp);
        const stylesheet = styleElement.current?.sheet;
        if (stylesheet) {
            const ruleCount = stylesheet.cssRules.length; // Delete rules safely by checking the number of existing rules
            if (ruleCount > 1) stylesheet.deleteRule(1);
            if (ruleCount > 0) stylesheet.deleteRule(0);
        }
    }, [
        onRatioChange,
        resetDetector,
        setFlexBasisProp,
        maxRatio
    ]);
    const ariaValueText = (0, $eJOHy.useMemo)(()=>`${(0, $eIXlM.getPercentageWithinPixelBounds)({
            currentWidth: collapsed ? maxRatio : rangeInputValue,
            minRatio: minRatio,
            maxRatio: maxRatio
        })}% width`, [
        rangeInputValue,
        minRatio,
        maxRatio,
        collapsed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0ae4e693bfab32cf$var$ResizeHandle, {
        "data-testid": "flex-resizer.ui.handle.resizer" // remove on FG cleanup jfp-magma-hydration-resizer
        ,
        onPointerDown: onPointerDown,
        position: position,
        resizeHandleZIndex: resizeHandleZIndex,
        resizeHandleAsOverlay: resizeHandleAsOverlay,
        collapsed: collapsed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ref: lineSplitterRef,
        className: (0, $hcewu.default)([
            $0ae4e693bfab32cf$var$grabAreaStyles.root,
            collapsed ? "_1gavfnf5" : "_d0aluf7j _1gavfnf5"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6fs4r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        id: labelId,
        type: "range",
        value: rangeInputValue,
        step: "0.01",
        min: inputRange.min,
        max: inputRange.max,
        "aria-valuetext": ariaValueText,
        onChange: handleSliderInputChange,
        onFocus: handleSliderFocus,
        onBlur: handleSliderBlur
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("label", {
        htmlFor: labelId
    }, formatMessage((0, $guiml.default).resizer))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        className: (0, $hcewu.default)([
            $0ae4e693bfab32cf$var$lineStyles.root
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gV40x.ResizeBorder), {
        triggerAnimation: chevronDirection !== prevChevronDirection,
        collapsed: collapsed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0ae4e693bfab32cf$var$TooltipWrapper, {
        toolTipContent: toolTipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gV40x.ResizeIcon), {
        triggerAnimation: chevronDirection !== prevChevronDirection,
        "data-testid": $0ae4e693bfab32cf$var$RESIZE_ICON_TEST_ID,
        persistResizeIcon: persistResizeIcon,
        onResizeHandleClick: onResizeHandleClick
    }, chevronDirection === 'LEFT' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8PCRQ))), {
        spacing: "spacious",
        label: "",
        testId: `${$0ae4e693bfab32cf$var$RESIZE_CHEVRON_ICON}left`,
        size: "small"
    }), chevronDirection === 'RIGHT' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
        spacing: "spacious",
        label: "",
        testId: `${$0ae4e693bfab32cf$var$RESIZE_CHEVRON_ICON}right`,
        size: "small"
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("style", {
        ref: styleElement
    }));
};
var $0ae4e693bfab32cf$export$2e2bcd8739ae039 = $0ae4e693bfab32cf$var$Resizer;

});
parcelRegister("8PCRQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ee9ad5072a30451ff7ca2ddc0961d03>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66e13c6de5d90262$var$_react = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $66e13c6de5d90262$var$_baseNew = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $66e13c6de5d90262$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66e13c6de5d90262$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $66e13c6de5d90262$var$_react.default.createElement($66e13c6de5d90262$var$_baseNew.default, Object.assign({
        name: "ChevronLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$66e13c6de5d90262$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $66e13c6de5d90262$var$_default = module.exports.default = $66e13c6de5d90262$var$ChevronLeftIcon;

});

parcelRegister("guiml", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9b256e157596d2c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b9b256e157596d2c$var$messages = (0, $7qGN1.defineMessages)({
    resizer: {
        "id": "flex-resizer.handle.resizer",
        "defaultMessage": "Resize work item view side panel"
    }
});
var $b9b256e157596d2c$export$2e2bcd8739ae039 = $b9b256e157596d2c$var$messages;

});

parcelRegister("eIXlM", function(module, exports) {
$parcel$export(module.exports, "getPercentageWithinPixelBounds", () => $533a4d0abeef5763$export$b5423678cdf09f5);
function $533a4d0abeef5763$export$b5423678cdf09f5({ currentWidth: currentWidth, minRatio: minRatio, maxRatio: maxRatio }) {
    const resizeRange = maxRatio - minRatio;
    const widthAsPercentage = (currentWidth - minRatio) / resizeRange * 100;
    if (widthAsPercentage < 0) return 0;
    if (widthAsPercentage > 100) return 100;
    return Math.floor(widthAsPercentage);
}

});

parcelRegister("gJzIA", function(module, exports) {
$parcel$export(module.exports, "createKeyboardResizeManager", () => $465d5cbfeab08391$export$f7d3d5dae65f74aa);
/**
 * The debounce time for the PanelSplitter resize callback functions.
 *
 * - For `onResizeStart`, it will call the callback immediately, but not
 * again until the user stops resizing and this wait time has passed.
 * - For `onResizeEnd`, it will call the callback only after this time has
 * passed since the last resize event.
 */ const $465d5cbfeab08391$var$resizeCallbackDebounceTimeMs = 500;
function $465d5cbfeab08391$export$f7d3d5dae65f74aa({ onResizeStart: onResizeStart, onResizeEnd: onResizeEnd }) {
    let resizingState = {
        type: 'idle'
    };
    /**
	 * Starts a timer to reset the state to idle and call `onResizeEnd` after a wait time.
	 */ function startResizeEndTimer({ ratio: ratio, width: width, flexBasis: flexBasis }) {
        const markResizeAsEndedTimeout = setTimeout(()=>{
            onResizeEnd?.(ratio, width, flexBasis);
            resizingState = {
                type: 'idle'
            };
        }, $465d5cbfeab08391$var$resizeCallbackDebounceTimeMs);
        resizingState = {
            type: 'resizing',
            initialWidth: width,
            abort () {
                clearTimeout(markResizeAsEndedTimeout);
            }
        };
    }
    function onResize({ ratio: ratio, width: width, flexBasis: flexBasis }) {
        if (resizingState.type === 'idle') {
            // If the state was idle, this counts as a resize start event.
            onResizeStart();
            startResizeEndTimer({
                ratio: ratio,
                width: width,
                flexBasis: flexBasis
            });
            return;
        }
        if (resizingState.type === 'resizing') {
            // If the state was already resizing, clear the existing timeout and start a new one.
            resizingState.abort();
            startResizeEndTimer({
                ratio: ratio,
                width: width,
                flexBasis: flexBasis
            });
        }
    }
    return {
        onResize: onResize
    };
}

});

parcelRegister("jJktB", function(module, exports) {
$parcel$export(module.exports, "ResizeHandle", () => $f57a2795f2c1e87a$export$33f2411a0ad35be7);
/* ResizeHandle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cxKOj = parcelRequire("cxKOj");
const $f57a2795f2c1e87a$var$baseStyles = null;
const $f57a2795f2c1e87a$var$collapsedStyles = null;
const $f57a2795f2c1e87a$var$nonCollapsedStyles = null;
const $f57a2795f2c1e87a$var$positionStyles = {
    left: "_1ltvidpf",
    right: "_1xi2idpf"
};
const $f57a2795f2c1e87a$var$resizeStyles = {
    base: "_4t3i1osq _kqswstnw _154iidpf",
    left: "_t9ec13v8",
    right: "_t9ecpvys"
};
const $f57a2795f2c1e87a$var$scrollFixStyles = null;
const $f57a2795f2c1e87a$export$33f2411a0ad35be7 = ({ children: children, collapsed: collapsed = false, onPointerDown: onPointerDown, resizeHandleAsOverlay: resizeHandleAsOverlay = false, resizeHandleZIndex: resizeHandleZIndex, position: position = 'right' })=>/*#__PURE__*/ $eJOHy.createElement("div", {
        "data-component-selector": "jira-issue-view-common-component-resize-handle",
        "data-testid": "flex-resizer.ui.handle.resizer",
        onPointerDown: onPointerDown,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            zIndex: resizeHandleZIndex
        },
        className: (0, $hcewu.default)([
            "_1wpz1fhb _1e0c1txw _16jlidpf _1o9zidpf _1bah1h6o _1xi2idpf _1bsb1ejb _nt751r31 _49pcglyw _1hvw1o36",
            collapsed ? "_80omtlke _2hwx1ejb" : "_80omuf7j",
            $f57a2795f2c1e87a$var$positionStyles[position],
            resizeHandleAsOverlay && $f57a2795f2c1e87a$var$resizeStyles.base,
            resizeHandleAsOverlay && $f57a2795f2c1e87a$var$resizeStyles[position],
            !resizeHandleAsOverlay && (0, $cxKOj.expVal)('sunsetting_bulk_edit', 'isEnabled', false) && "_kqswh2mm"
        ])
    }, children);

});

parcelRegister("gV40x", function(module, exports) {
$parcel$export(module.exports, "ResizeHandleOld", () => $025d21548e404657$export$be9da3111ad61150);
$parcel$export(module.exports, "ResizeIcon", () => $025d21548e404657$export$8a1e762806b47a07);
$parcel$export(module.exports, "ResizeBorder", () => $025d21548e404657$export$a6c16750034505be);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $cxKOj = parcelRequire("cxKOj");
const $025d21548e404657$var$resizeHandleSelectorName = 'jira-issue-view-common-component-resize-handle';
const $025d21548e404657$export$3cd44ff7e3089142 = `[data-component-selector="${$025d21548e404657$var$resizeHandleSelectorName}"]`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $025d21548e404657$var$ResizeHandleComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { collapsed: collapsed, scrollFix: scrollFix, resizeHandleAsOverlay: resizeHandleAsOverlay, resizeHandleZIndex: resizeHandleZIndex, position: position, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_yzp60g": (0, $awdRS.default)(__cmplp.collapsed && "var(--ds-space-300, 24px)"),
            "--_1ravlqm": (0, $awdRS.default)(__cmplp.resizeHandleZIndex),
            "--_1o4cubd": (0, $awdRS.default)(__cmplp.position === 'left' ? 'translate3d(-50%, 0, 0)' : 'translate3d(50%, 0, 0)')
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _1bsb1ejb _1wpz1fhb _1e0c1txw _1bah1h6o _2hwxyrq6 _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.collapsed ? "_80omtlke" : "_80omuf7j",
            __cmplp.scrollFix && !__cmplp.resizeHandleAsOverlay && (0, $cxKOj.expVal)('sunsetting_bulk_edit', 'isEnabled', false) && "_kqswh2mm",
            __cmplp.resizeHandleZIndex && "_1pby7mzf",
            __cmplp.position === 'left' ? "_1ltvidpf" : "_1xi2idpf",
            __cmplp.resizeHandleAsOverlay && "_154iidpf _kqswstnw _4t3i1osq _t9ec1jw3",
            __cmplp.className
        ])
    });
});
const $025d21548e404657$export$be9da3111ad61150 = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($025d21548e404657$var$ResizeHandleComponent, {
        "data-component-selector": $025d21548e404657$var$resizeHandleSelectorName,
        scrollFix: (0, $cxKOj.expVal)('sunsetting_bulk_edit', 'isEnabled', false),
        ...props
    }));
const $025d21548e404657$var$appearAnimationBorder = null;
const $025d21548e404657$var$appearAnimationIcon = null;
const $025d21548e404657$var$ResizeIconBaseStyles = null;
const $025d21548e404657$var$ResizeIconRefreshStyles = null;
const $025d21548e404657$var$PointerStyle = null;
const $025d21548e404657$var$OpacityStyle1 = null;
const $025d21548e404657$var$OpacityStyle0 = null;
const $025d21548e404657$var$AnimationDuration1S = null;
const $025d21548e404657$var$AnimationDuration0S = null;
const $025d21548e404657$var$ResizeIconCompiled = ({ isRefreshVariant: isRefreshVariant = false, triggerAnimation: triggerAnimation, persistResizeIcon: persistResizeIcon, children: children, onResizeHandleClick: onResizeHandleClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_2rko1rr0 _kqswstnw _154ixy5q _4t3i1tcg _1bsb1tcg _1ltvxmi2 _16qs130s _j7hq1s2f _1pgl1ytf _bfhkvuon _irr319i6",
            isRefreshVariant && "_1e0c1txw _4cvr1h6o _1bah1h6o",
            triggerAnimation && "_5sag9cwz",
            !triggerAnimation && "_5sagru3m",
            persistResizeIcon && "_tzy4kb7n",
            !persistResizeIcon && "_tzy4idpf",
            !!onResizeHandleClick && "_80omtlke"
        ])
    }, children);
};
const $025d21548e404657$export$8a1e762806b47a07 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($025d21548e404657$var$ResizeIconCompiled, {
        isRefreshVariant: true,
        ...props
    });
const $025d21548e404657$export$a6c16750034505be = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { triggerAnimation: triggerAnimation, collapsed: collapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v56419xe _1bsbyh40 _1wpz1fhb _j7hq1f9b _1pgl1ytf _kqswh2mm _17cdkb7n _vhr0kb7n _1sankb7n _lew41v1w _1ld91v1w _18fi1v1w",
            __cmplp.triggerAnimation ? "_5sag9cwz" : "_5sagru3m",
            __cmplp.collapsed ? "_bfhk1l7x" : "_bfhk1v1w",
            __cmplp.collapsed ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.className
        ])
    });
});

});





parcelRegister("kbhn6", function(module, exports) {
$parcel$export(module.exports, "JQLTabDebuggerPanel", () => $30ee3d17c3a559f0$export$acb1c493eb504105);
$parcel$export(module.exports, "JQLPanelRenderSlotForJQLEditor", () => $30ee3d17c3a559f0$export$79179285687e80ca);
$parcel$export(module.exports, "JQLPanelRenderSlotForWorkItemList", () => $30ee3d17c3a559f0$export$dd4c9a4dfe8e7fc6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1DXK0 = parcelRequire("1DXK0");

var $880Uc = parcelRequire("880Uc");

var $8IeH1 = parcelRequire("8IeH1");
var $fUDzs = parcelRequire("fUDzs");

var $5vQ2T = parcelRequire("5vQ2T");

var $bUnif = parcelRequire("bUnif");

var $lfAG2 = parcelRequire("lfAG2");

var $k0Jpn = parcelRequire("k0Jpn");

var $13f5n = parcelRequire("13f5n");

var $lg8UF = parcelRequire("lg8UF");
const $30ee3d17c3a559f0$var$styles = {
    container: "_ca0qu2gc _1bsb1osq"
};
function $30ee3d17c3a559f0$var$JqlDebuggerLayoutSwitcher(props) {
    const layoutQuery = props.fullWidthLayout ? 'below.lg' : 'above.lg';
    const showProp = (0, $eJOHy.useMemo)(()=>props.fullWidthLayout ? {
            below: 'lg'
        } : {
            above: 'lg'
        }, [
        props.fullWidthLayout
    ]);
    const [matches, setMatches] = (0, $eJOHy.useState)(null);
    const mq = (0, $fUDzs.UNSAFE_useMediaQuery)(layoutQuery, (e)=>{
        setMatches(e.matches);
    });
    return matches ?? mq?.matches ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $880Uc.Show), {
        ...showProp,
        xcss: props.xcss ? [
            $30ee3d17c3a559f0$var$showContainerStyles,
            props.xcss
        ] : $30ee3d17c3a559f0$var$showContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k0Jpn.JQLDebuggerCommonEntry), null)) : null;
}
const $30ee3d17c3a559f0$export$acb1c493eb504105 = (props)=>{
    const { errorMessages: errorMessages, testId: testId, validationId: validationId } = props;
    const jqlDebuggerStoreActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    const [isReady] = (0, $lfAG2.useIsContextReady)();
    const renderSyncActions = (0, $lfAG2.useRenderSynchronizerStoreActions)();
    const [isAiEnabled] = (0, $bUnif.useIsAiEnabled)();
    const [status] = (0, $bUnif.useDebuggerStatus)();
    /**
   * When the JQL Editor unmounts for whatever reason, we want to mark jql editor as not ready
   * So that JQLPanelRenderSlotForWorkItemList doesn't try to accidentally render any error messages
   *
   * For example, this happens when we enter NL-to-JQL AI mode while the regular JQL editor has an error
   */ (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            renderSyncActions.setJqlEditorReady(false);
        };
    }, [
        renderSyncActions
    ]);
    if (!errorMessages?.length || !isReady || !isAiEnabled || status === 'UNRECOVERABLE_ERROR') {
        renderSyncActions.setJqlEditorReady(false);
        return props.children;
    }
    jqlDebuggerStoreActions.setJqlErrors(errorMessages.map((0, $lg8UF.extractTextFromReactElement)));
    jqlDebuggerStoreActions.setErrorComponentTestId(testId);
    jqlDebuggerStoreActions.setErrorComponentValidationId(validationId);
    renderSyncActions.setJqlEditorReady(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $30ee3d17c3a559f0$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k0Jpn.JQLDebuggerCommonEntry), null));
};
const $30ee3d17c3a559f0$export$793a24421ebe4e74 = (props)=>{
    const { errorMessages: errorMessages, testId: testId, validationId: validationId } = props;
    const jqlDebuggerStoreActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    const [isReady] = (0, $lfAG2.useIsContextReady)();
    const renderSyncActions = (0, $lfAG2.useRenderSynchronizerStoreActions)();
    const [isAiEnabled] = (0, $bUnif.useIsAiEnabled)();
    const [status] = (0, $bUnif.useDebuggerStatus)();
    /**
   * When the JQL Editor unmounts for whatever reason, we want to mark jql editor as not ready
   * So that JQLPanelRenderSlotForWorkItemList doesn't try to accidentally render any error messages
   *
   * For example, this happens when we enter NL-to-JQL AI mode while the regular JQL editor has an error
   */ (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            renderSyncActions.setJqlEditorReady(false);
        };
    }, [
        renderSyncActions
    ]);
    if (!errorMessages?.length || !isReady || !isAiEnabled || status === 'UNRECOVERABLE_ERROR') {
        renderSyncActions.setJqlEditorReady(false);
        return props.children;
    }
    jqlDebuggerStoreActions.setJqlErrors(errorMessages.map((0, $lg8UF.extractTextFromReactElement)));
    jqlDebuggerStoreActions.setErrorComponentTestId(testId);
    jqlDebuggerStoreActions.setErrorComponentValidationId(validationId);
    renderSyncActions.setJqlEditorReady(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($30ee3d17c3a559f0$var$JqlDebuggerLayoutSwitcher, {
        fullWidthLayout: false,
        xcss: $30ee3d17c3a559f0$var$jqlBuilderContainerStyles
    });
};
const $30ee3d17c3a559f0$export$79179285687e80ca = (props)=>{
    const { children: children } = props;
    const ChildrenFallback = (0, $eJOHy.useCallback)(()=>children, [
        children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        packageName: (0, $13f5n.PACKAGE_NAME_JQL_DEBUGGER),
        id: (0, $13f5n.ERROR_BOUNDARY_IDS).COMMON_ENTRY_JQL_BUILDER,
        teamName: (0, $13f5n.TEAM_NAME),
        fallback: ChildrenFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($30ee3d17c3a559f0$export$793a24421ebe4e74, props));
};
const $30ee3d17c3a559f0$export$dd4c9a4dfe8e7fc6 = ()=>{
    const [isReady] = (0, $lfAG2.useIsContextReady)();
    const [isJqlEditorReady] = (0, $lfAG2.useIsJqlEditorReady)();
    const storeActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    if (!isReady || !isJqlEditorReady) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        packageName: (0, $13f5n.PACKAGE_NAME_JQL_DEBUGGER),
        id: (0, $13f5n.ERROR_BOUNDARY_IDS).COMMON_ENTRY_ISSUE_VIEW,
        teamName: (0, $13f5n.TEAM_NAME),
        fallback: ()=>null,
        onError: ()=>{
            storeActions.setStatus('UNRECOVERABLE_ERROR');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($30ee3d17c3a559f0$var$JqlDebuggerLayoutSwitcher, {
        fullWidthLayout: true,
        xcss: $30ee3d17c3a559f0$var$issueViewContainerStyles
    }));
};
const $30ee3d17c3a559f0$var$jqlBuilderContainerStyles = (0, $1DXK0.xcss)({
    // When we are rendering in JQL builder, we want to add the space between the editor and panel
    // This space is already present in the issue view
    marginTop: 'space.100'
});
const $30ee3d17c3a559f0$var$issueViewContainerStyles = (0, $1DXK0.xcss)({
    // When we are rendering in JQL builder, we want to add the space between the editor and panel
    // This space is already present in the issue view
    marginTop: 'space.negative.100'
});
const $30ee3d17c3a559f0$var$showContainerStyles = (0, $1DXK0.xcss)({
    width: '100%',
    marginBottom: 'space.100'
});

});
parcelRegister("880Uc", function(module, exports) {
$parcel$export(module.exports, "Show", () => $f800bab042621a59$export$f6a3d19be20f5819);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1NIU8 = parcelRequire("1NIU8");

var $1DXK0 = parcelRequire("1DXK0");

var $j14qM = parcelRequire("j14qM");
function $f800bab042621a59$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f800bab042621a59$var$showAboveQueries = (0, $j14qM.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $f800bab042621a59$var$showBelowQueries = (0, $j14qM.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $f800bab042621a59$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $f800bab042621a59$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $1DXK0.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $1NIU8.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $f800bab042621a59$var$defaultHiddenStyles,
            above && $f800bab042621a59$var$showAboveQueries[above],
            below && $f800bab042621a59$var$showBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};

});
parcelRegister("j14qM", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", () => $58139abb853d4481$export$918f8818cfbbeb2c);
$parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", () => $58139abb853d4481$export$b2a4e2b0c6417297);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $fvncH = parcelRequire("fvncH");

var $6efFi = parcelRequire("6efFi");
const $58139abb853d4481$export$918f8818cfbbeb2c = (input)=>{
    return (0, $fvncH.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $1NIU8.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $6efFi.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
const $58139abb853d4481$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $fvncH.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $1NIU8.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $6efFi.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};

});
parcelRegister("fvncH", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", () => $5a3422a08c082ecc$export$2d293d9871c38e91);
const $5a3422a08c082ecc$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $5a3422a08c082ecc$export$2d293d9871c38e91 = Object.keys($5a3422a08c082ecc$export$e5ee4fe8b989fd09);
const $5a3422a08c082ecc$export$b7ed752a57b4177b = $5a3422a08c082ecc$export$2d293d9871c38e91[0];

});



parcelRegister("bUnif", function(module, exports) {
$parcel$export(module.exports, "useJqlDebuggerStoreActions", () => $225b1cd3961a99bb$export$661ee98a2d30a450);
$parcel$export(module.exports, "useStoreData", () => $225b1cd3961a99bb$export$544efe5ac05fc17);
$parcel$export(module.exports, "useDebuggerStatus", () => $225b1cd3961a99bb$export$e4c2322c66a3dea5);
$parcel$export(module.exports, "useJqlErrors", () => $225b1cd3961a99bb$export$d959fd60596bfa67);
$parcel$export(module.exports, "useJqlEditorOnSearch", () => $225b1cd3961a99bb$export$ba3a4678e5df092c);
$parcel$export(module.exports, "useJqlQuery", () => $225b1cd3961a99bb$export$ec027c329b94fe67);
$parcel$export(module.exports, "useIsAiEnabled", () => $225b1cd3961a99bb$export$742ce7b41314d513);
$parcel$export(module.exports, "useErrorComponentTestId", () => $225b1cd3961a99bb$export$afd1b99522ddeae9);
$parcel$export(module.exports, "useErrorComponentValidationId", () => $225b1cd3961a99bb$export$9c84149290836e7);
$parcel$export(module.exports, "useIsReadyForProactive", () => $225b1cd3961a99bb$export$1da2ac60b06e42d1);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4cTDP = parcelRequire("4cTDP");

var $hh2hg = parcelRequire("hh2hg");
const $225b1cd3961a99bb$var$initialState = {
    jqlQuery: '',
    userQueryError: [],
    onSearch: ()=>undefined,
    status: 'INIT',
    jqlDiffTokens: [],
    isAiEnabled: false,
    syntaxCorrectionAttemptErrors: [],
    singleInstrumentationID: '',
    errorSectionTestId: '',
    onAiInteractionDismissed () {
    // do nothing
    },
    exitNaturalLanguageMode () {
    // do nothing
    },
    onJsError () {
    // do nothing
    },
    jqlErrors: [],
    errorComponentValidationId: '',
    errorComponentTestId: '',
    isReadyForProactive: false
};
const $225b1cd3961a99bb$var$Store = (0, $GtRbT.createStore)({
    initialState: $225b1cd3961a99bb$var$initialState,
    // actions that trigger store mutation
    actions: {
        setJqlQuery: (jqlQuery)=>({ setState: setState })=>{
                setState({
                    jqlQuery: jqlQuery
                });
            },
        setOnSearch: (onSearch)=>({ setState: setState })=>{
                setState({
                    onSearch: onSearch
                });
            },
        setStatus: (status)=>({ setState: setState, getState: getState })=>{
                if (status === 'JS_ERROR') getState().onJsError();
                setState({
                    status: status
                });
            },
        setIssueNavigatorSearchMode: (issueNavigatorSearchMode)=>({ setState: setState })=>{
                setState({
                    issueNavigatorSearchMode: issueNavigatorSearchMode
                });
            },
        resetStatus: (source, newJqlQuery)=>({ setState: setState, getState: getState })=>{
                if (source === 'ON_ENTER_NL_MODE') setState({
                    issueNavigatorSearchMode: 'NL2JQL'
                });
                if (getState().status !== 'INIT') {
                    if (source !== 'ACCEPT_FIX') // AI modal gets dismissed when we accept a suggestion
                    // However, we don't want to fire the `aiInteraction Dismissed` event in that case
                    // On a new JQL search, we do not dismiss the AI interaction if the JQL query hasn't changed
                    {
                        if (!(source === 'ON_NEW_JQL_SEARCH' && getState().jqlQuery === newJqlQuery)) getState().onAiInteractionDismissed(source);
                    }
                    // Reset the status and aiInteractionDismissed handler so that duplicate events won't be fired
                    setState({
                        status: 'INIT',
                        onAiInteractionDismissed: $225b1cd3961a99bb$var$initialState.onAiInteractionDismissed
                    });
                    if ((0, $4cTDP.fg)('jql_fixer_analytics_fixes')) (0, $hh2hg.nonReactiveSingleton)().renewSingleInstrumentationId();
                }
            },
        setStateOnFeatureInvoke: (initialDataOnInvoke)=>({ setState: setState })=>{
                setState({
                    ...initialDataOnInvoke,
                    status: 'LOADING_RESULT'
                });
            },
        setJqlErorCorrectionData: (data)=>({ setState: setState })=>{
                setState({
                    ...data,
                    status: 'VIEW_RESULT'
                });
            },
        setIsAiEnabled: (isAiEnabled)=>({ setState: setState })=>{
                setState({
                    isAiEnabled: isAiEnabled
                });
            },
        setOnAiInteractionDismissed: (onAiInteractionDismissed)=>({ setState: setState })=>{
                setState({
                    onAiInteractionDismissed: onAiInteractionDismissed
                });
            },
        setOnJsError: (onJsError)=>({ setState: setState })=>{
                setState({
                    onJsError: onJsError
                });
            },
        exitNaturalLanguageMode: ()=>({ getState: getState })=>{
                getState().exitNaturalLanguageMode?.();
            },
        setExitNaturalLanguageMode: (exitNaturalLanguageMode)=>({ setState: setState })=>{
                setState({
                    exitNaturalLanguageMode: exitNaturalLanguageMode
                });
            },
        setJqlErrors: (jqlErrors)=>({ setState: setState })=>setState({
                    jqlErrors: jqlErrors
                }),
        setErrorComponentValidationId: (errorComponentValidationId)=>({ setState: setState })=>setState({
                    errorComponentValidationId: errorComponentValidationId
                }),
        setErrorComponentTestId: (errorComponentValidationId)=>({ setState: setState })=>setState({
                    errorComponentValidationId: errorComponentValidationId
                }),
        setIsReadyForProactive: (isReadyForProactive)=>({ setState: setState })=>{
                setState({
                    isReadyForProactive: isReadyForProactive
                });
            }
    }
});
const $225b1cd3961a99bb$export$661ee98a2d30a450 = (0, $iJq0l.createActionsHook)($225b1cd3961a99bb$var$Store);
const $225b1cd3961a99bb$export$544efe5ac05fc17 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store);
const $225b1cd3961a99bb$export$e4c2322c66a3dea5 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.status
});
const $225b1cd3961a99bb$export$d959fd60596bfa67 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.jqlErrors
});
const $225b1cd3961a99bb$export$ba3a4678e5df092c = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.onSearch
});
const $225b1cd3961a99bb$export$ec027c329b94fe67 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.jqlQuery
});
const $225b1cd3961a99bb$export$742ce7b41314d513 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.isAiEnabled
});
const $225b1cd3961a99bb$export$afd1b99522ddeae9 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.errorComponentTestId
});
const $225b1cd3961a99bb$export$9c84149290836e7 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.errorComponentValidationId
});
const $225b1cd3961a99bb$export$1da2ac60b06e42d1 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.isReadyForProactive && state.issueNavigatorSearchMode !== 'NL2JQL'
});
const $225b1cd3961a99bb$export$a416100e9df4f9b1 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.syntaxCorrectionAttemptErrors
});

});
parcelRegister("hh2hg", function(module, exports) {
$parcel$export(module.exports, "nonReactiveSingleton", () => $fa17c1147c4b2c49$export$1769ee823f4b046a);

var $aXKmr = parcelRequire("aXKmr");
function $fa17c1147c4b2c49$var$createNonReactiveStore() {
    const state = {
        jqlBuilderOnSearch: ()=>({}),
        singleInstrumentationID: ''
    };
    function getJqlBuilderOnSearch() {
        return state.jqlBuilderOnSearch;
    }
    function setJqlBuilderOnSearch(onSearch) {
        state.jqlBuilderOnSearch = onSearch;
    }
    function renewSingleInstrumentationId() {
        state.singleInstrumentationID = (0, $aXKmr.v4)();
    }
    function getSingleInstrumentationId() {
        if (state.singleInstrumentationID === '') renewSingleInstrumentationId();
        return state.singleInstrumentationID;
    }
    return {
        getJqlBuilderOnSearch: getJqlBuilderOnSearch,
        setJqlBuilderOnSearch: setJqlBuilderOnSearch,
        getSingleInstrumentationId: getSingleInstrumentationId,
        renewSingleInstrumentationId: renewSingleInstrumentationId
    };
}
const $fa17c1147c4b2c49$export$1769ee823f4b046a = (()=>{
    let instance = null;
    return ()=>{
        if (!instance) instance = $fa17c1147c4b2c49$var$createNonReactiveStore();
        return instance;
    };
})();

});


parcelRegister("lfAG2", function(module, exports) {
$parcel$export(module.exports, "useRenderSynchronizerStoreActions", () => $7b22efe6dcaae164$export$60f8cec0dff6824c);
$parcel$export(module.exports, "useIsContextReady", () => $7b22efe6dcaae164$export$7668b8e8d8c22896);
$parcel$export(module.exports, "useIsJqlEditorReady", () => $7b22efe6dcaae164$export$7f34a2b12380537d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $7b22efe6dcaae164$var$initialState = {
    isContextReady: false,
    isJqlEditorReady: false
};
const $7b22efe6dcaae164$var$Store = (0, $GtRbT.createStore)({
    initialState: $7b22efe6dcaae164$var$initialState,
    actions: {
        setIsContextReady: (isContextReady)=>({ setState: setState })=>{
                setState({
                    isContextReady: isContextReady
                });
            },
        setJqlEditorReady: (isJqlEditorReady)=>({ setState: setState })=>{
                setState({
                    isJqlEditorReady: isJqlEditorReady
                });
            }
    }
});
const $7b22efe6dcaae164$export$60f8cec0dff6824c = (0, $iJq0l.createActionsHook)($7b22efe6dcaae164$var$Store);
const $7b22efe6dcaae164$export$7668b8e8d8c22896 = (0, $iJq0l.createHook)($7b22efe6dcaae164$var$Store, {
    selector: (state)=>state.isContextReady
});
const $7b22efe6dcaae164$export$7f34a2b12380537d = (0, $iJq0l.createHook)($7b22efe6dcaae164$var$Store, {
    selector: (state)=>state.isJqlEditorReady
});

});

parcelRegister("k0Jpn", function(module, exports) {
$parcel$export(module.exports, "JQLDebuggerCommonEntry", () => $182505dbe4321118$export$61b6653f41aa971b);

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $9skjA = parcelRequire("9skjA");

var $iWvkh = parcelRequire("iWvkh");

var $cBavF = parcelRequire("cBavF");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $bJscI = parcelRequire("bJscI");

var $4cTDP = parcelRequire("4cTDP");

var $cxKOj = parcelRequire("cxKOj");

var $bUnif = parcelRequire("bUnif");

var $bqGal = parcelRequire("bqGal");

var $iNmbB = parcelRequire("iNmbB");

var $13f5n = parcelRequire("13f5n");

var $awW5u = parcelRequire("awW5u");

var $9n5mq = parcelRequire("9n5mq");
function $182505dbe4321118$var$OnError() {
    const debuggerActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    (0, $eJOHy.useEffect)(()=>{
        // On error, set the feature state to be JS_ERROR, so that such scenarios can be handled without
        // interfering with the feature initial state nor with the AI event instrumentation
        debuggerActions.setStatus('JS_ERROR');
    }, [
        debuggerActions
    ]);
    return null;
}
const $182505dbe4321118$var$JQLDebuggerCommonEntryComponent = ()=>{
    const [status] = (0, $bUnif.useDebuggerStatus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const debuggerStoreActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    const [query] = (0, $bUnif.useJqlQuery)();
    const [jqlErrors] = (0, $bUnif.useJqlErrors)();
    const [onSearch_] = (0, $bUnif.useJqlEditorOnSearch)();
    const [isReadyForProactive] = (0, $bUnif.useIsReadyForProactive)();
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $iWvkh.useEntryPoint)((0, $iNmbB.SuggestedFixContentEntrypoint), {});
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $4cTDP.fg)('jql_fixer_analytics_fixes')) (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiExperience_jqlFixer viewed', (0, $9n5mq.getAiAttributes)({}));
    }, [
        query,
        createAnalyticsEvent
    ]);
    const onSearch = (0, $4cTDP.fg)('jql_fixer_analytics_fixes') ? undefined : onSearch_;
    // For the proactive experience, we call the API through a useEffect for each applicable render
    (0, $eJOHy.useEffect)(()=>{
        if (status === 'INIT') {
            if (!isReadyForProactive) {
                if ((0, $4cTDP.fg)('jql-fixer-cost-reduction-targeting-gate')) // Preload the API call only when the experiment variant is CONTROL
                {
                    if (!(0, $cxKOj.expVal)('jql_fixer_cost_reduction', 'isEnabled', false)) (0, $awW5u.preloadApiCallNew)(createAnalyticsEvent, query, jqlErrors);
                } else (0, $awW5u.preloadApiCall)(query, jqlErrors);
            } else (0, $awW5u.onClick)({
                testId: 'jql-debugger-common-entry',
                createAnalyticsEvent: createAnalyticsEvent,
                debuggerStoreActions: debuggerStoreActions,
                query: query,
                jqlErrors: jqlErrors,
                onSearch: onSearch,
                isReadyForProactive: isReadyForProactive
            });
        }
    }, [
        isReadyForProactive,
        status,
        createAnalyticsEvent,
        debuggerStoreActions,
        jqlErrors,
        onSearch,
        query
    ]);
    /*
		We load the entrypoint conditionally here as the JQL debugger panel is rendered underneath the JQL builder for large screen sizes,
		and across the issue view for smaller screen sizes - their visibilty is controlled by a <Show>, but they are two separately
		rendered components. As a result, if we are switching from one screen size or issue view to another, the newly rendered version of the
		JQL debugger will not have a loaded entry point, so we load it here to ensure the content is still visible across different views.

		Example of behaviour without this conditional:
		https://www.loom.com/share/725438e2ea16481591bbe510815e9ca3?sid=b3dc286e-9c37-4cf9-a2c9-f55d3561a166
	*/ if (status !== 'INIT') entryPointActions?.load();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9skjA.default), {
        spacing: "none",
        hasNewBorderExperience: true,
        shouldFitContainer: true,
        isLoading: status === 'LOADING_RESULT'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        padding: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bqGal.ErrorSection), {
        entryPointActions: entryPointActions
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: {},
        packageName: (0, $13f5n.PACKAGE_NAME_JQL_DEBUGGER),
        id: (0, $13f5n.ERROR_BOUNDARY_IDS).FIX_WITH_AI_MODAL,
        teamName: (0, $13f5n.TEAM_NAME),
        fallback: null,
        errorFallback: $182505dbe4321118$var$OnError
    }));
};
const $182505dbe4321118$var$JQLDebuggerCommonEntryMemoized = /*#__PURE__*/ (0, $eJOHy.memo)($182505dbe4321118$var$JQLDebuggerCommonEntryComponent);
const $182505dbe4321118$export$61b6653f41aa971b = (0, $bJscI.componentWithFG)('jql_fixer_analytics_fixes', $182505dbe4321118$var$JQLDebuggerCommonEntryMemoized, $182505dbe4321118$var$JQLDebuggerCommonEntryComponent);

});
parcelRegister("9skjA", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c22c6f11d6c3191$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $1jVV7 = parcelRequire("1jVV7");

var $58yRG = parcelRequire("58yRG");

var $4cTDP = parcelRequire("4cTDP");
let $7c22c6f11d6c3191$var$namespaceUUID = 0;
const $7c22c6f11d6c3191$var$newPalette = {
    dark: {
        blue: '#0468FF',
        teal: '#BF63F3',
        yellow: '#FFA900'
    },
    light: {
        blue: '#0468FF',
        teal: '#BF63F3',
        yellow: '#FFA900'
    }
};
const $7c22c6f11d6c3191$var$AFTER_LOAD_DURATION = 3000;
const $7c22c6f11d6c3191$var$useNamespaceId = ()=>{
    if ((0, $4cTDP.fg)('jfp_magma_jira-namespaceid-svg')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $eJOHy.useId)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const namespaceId = (0, $eJOHy.useRef)();
    if (namespaceId.current === undefined) {
        namespaceId.current = $7c22c6f11d6c3191$var$namespaceUUID;
        $7c22c6f11d6c3191$var$namespaceUUID += 1;
    }
    return namespaceId.current;
};
const $7c22c6f11d6c3191$var$AnimatedSvgContainer = ({ isLoading: isLoading, isBlurred: isBlurred, isShadow: isShadow, isBorderGrey: isBorderGrey, hasNewBorderExperience: hasNewBorderExperience, components: { SvgComponent: SvgComponent = $7c22c6f11d6c3191$var$SvgContainer } = {} })=>{
    const { colorMode: colorMode } = (0, $58yRG.default)();
    const svgRef = (0, $eJOHy.useRef)(null);
    const namespaceId = $7c22c6f11d6c3191$var$useNamespaceId();
    const [showRainbowBorder, setShowRainbowBorder] = (0, $eJOHy.useState)(false);
    const paletteForTheme = colorMode === 'dark' ? $7c22c6f11d6c3191$var$newPalette.dark : $7c22c6f11d6c3191$var$newPalette.light;
    (0, $eJOHy.useEffect)(()=>{
        if (isLoading) {
            const svg = svgRef.current; // eslint-disable-next-line react-you-might-not-need-an-effect/no-adjust-state-on-prop-change
            hasNewBorderExperience && setShowRainbowBorder(true); // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isLoading,
        hasNewBorderExperience
    ]);
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-reset-all-state-on-prop-change
    (0, $eJOHy.useEffect)(()=>{
        // we keep the rainbow border without animations for at 3 seconds after load. After that we show the grey border
        if (hasNewBorderExperience && !isLoading && showRainbowBorder) {
            const timeoutId = setTimeout(()=>setShowRainbowBorder(false), $7c22c6f11d6c3191$var$AFTER_LOAD_DURATION);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        hasNewBorderExperience,
        showRainbowBorder,
        isLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SvgComponent, {
        isBlurred: isBlurred,
        isShadow: isShadow,
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: `${namespaceId}_lg1`,
        gradientUnits: "userSpaceOnUse",
        x1: "0%",
        y1: "0",
        x2: "400%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "0%",
        to: "400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "400%",
        to: "800%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: `${namespaceId}_lg2`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "-100%",
        x2: "0",
        y2: "300%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "-100%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "300%",
        to: "700%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: `${namespaceId}_lg3`,
        gradientUnits: "userSpaceOnUse",
        x1: "300%",
        y1: "0",
        x2: "700%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "300%",
        to: "-100%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "700%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: `${namespaceId}_lg4`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "400%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "0%",
        to: "-400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "400%",
        to: "0%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    }))), isBorderGrey || hasNewBorderExperience && !showRainbowBorder && !isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        strokeWidth: "16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        stroke: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
        d: "M0 0h24v24H0Z",
        vectorEffect: "non-scaling-stroke",
        fill: "none"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        strokeWidth: "16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        stroke: `url(#${namespaceId}_lg1)`,
        d: "M0 0h24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        stroke: `url(#${namespaceId}_lg2)`,
        d: "M24 0v24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        stroke: `url(#${namespaceId}_lg3)`,
        d: "M24 24H0",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        stroke: `url(#${namespaceId}_lg4)`,
        d: "M0 24V0",
        vectorEffect: "non-scaling-stroke"
    }))));
};
const $7c22c6f11d6c3191$var$AIContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, isLoading: isLoading, isShadow: isShadow = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', testId: testId, isBorderGrey: isBorderGrey, components: { ContainerComponent: ContainerComponent = $7c22c6f11d6c3191$var$Container, ContentComponent: ContentComponent = $7c22c6f11d6c3191$var$Content, SvgComponent: SvgComponent = $7c22c6f11d6c3191$var$SvgContainer } = {}, hasNewBorderExperience: hasNewBorderExperience = false, borderless: borderless = false, zIndex: zIndex = (0, $1jVV7.layers).card }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ContainerComponent, {
        "data-testid": testId,
        testId: testId,
        shouldFitContainer: shouldFitContainer,
        zIndex: zIndex
    }, (!(0, $4cTDP.fg)('similar_items_in_gic_ui_fixes') || !borderless) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c22c6f11d6c3191$var$AnimatedSvgContainer, {
        isShadow: isShadow,
        isLoading: isLoading,
        isBorderGrey: isBorderGrey,
        hasNewBorderExperience: hasNewBorderExperience,
        components: {
            SvgComponent: SvgComponent
        }
    }), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c22c6f11d6c3191$var$AnimatedSvgContainer, {
        isLoading: isLoading,
        isBlurred: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ContentComponent, {
        ref: ref,
        spacing: spacing
    }, children));
});
var $7c22c6f11d6c3191$export$2e2bcd8739ae039 = $7c22c6f11d6c3191$var$AIContainer;
$7c22c6f11d6c3191$var$AIContainer.displayName = 'AIContainer'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c22c6f11d6c3191$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainer: shouldFitContainer, zIndex: zIndex, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_w1vr8s": (0, $awdRS.default)(__cmplp.zIndex || (0, $1jVV7.layers).card)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1pbypt6a",
            __cmplp.shouldFitContainer ? "_1bsb1wug" : "_1bsb1ns9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c22c6f11d6c3191$var$Content = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { zIndex: zIndex, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_w1vr8s": (0, $awdRS.default)(__cmplp.zIndex || (0, $1jVV7.layers).card)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1qi0 _bfhkvuon _16jlkb7n _1pbypt6a _1bsb1osq",
            __cmplp.spacing === 'default' && "_ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c22c6f11d6c3191$var$SvgContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isShadow: isShadow, isBlurred: isBlurred, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1mok _kqswstnw",
            __cmplp.isShadow ? "_16qs1nax" : "_16qsglyw",
            __cmplp.isBlurred ? "_1bsb5cnj _4t3i5cnj _154iu2gc _1ltvu2gc _kdam7b89" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7c22c6f11d6c3191$export$71abc632aa29e6fe = {
    ContainerComponent: $7c22c6f11d6c3191$var$Container,
    ContentComponent: $7c22c6f11d6c3191$var$Content,
    SvgComponent: $7c22c6f11d6c3191$var$SvgContainer
};

});

parcelRegister("bqGal", function(module, exports) {
$parcel$export(module.exports, "ErrorSection", () => $a9f0cd966e577c81$export$b0bceea2ea86179a);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $80DPg = parcelRequire("80DPg");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");

var $f6eza = parcelRequire("f6eza");

var $bUnif = parcelRequire("bUnif");

var $fHqkT = parcelRequire("fHqkT");
function $a9f0cd966e577c81$export$b0bceea2ea86179a(props) {
    const { entryPointActions: entryPointActions } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [query] = (0, $bUnif.useJqlQuery)();
    const [status] = (0, $bUnif.useDebuggerStatus)();
    const [jqlErrors] = (0, $bUnif.useJqlErrors)();
    const [onSearch] = (0, $bUnif.useJqlEditorOnSearch)();
    const [errorComponentTestId] = (0, $bUnif.useErrorComponentTestId)();
    const [errorComponentValidationId] = (0, $bUnif.useErrorComponentValidationId)();
    const [isReadyForProactive] = (0, $bUnif.useIsReadyForProactive)();
    // The Fix error button should be shown when:
    // The user has not invoked any action to make the experience ready for proactive, or
    // the user returns from dismissing a proactive AI result
    const showFixErrorButton = (0, $4cTDP.fg)('jql-fixer-analytics-fixes') ? status === 'INIT' && !isReadyForProactive : status === 'RESULT_DISCARDED' || status === 'INIT' && !isReadyForProactive;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        spread: "space-between",
        space: "space.200",
        xcss: $a9f0cd966e577c81$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "start",
        spread: "space-between",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "h5",
        xcss: $a9f0cd966e577c81$var$jqlErrorHeadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        color: "var(--ds-icon, #292A2E)",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        weight: "bold"
    }, formatMessage(jqlErrors?.length > 1 ? (0, $fHqkT.default).jqlDebuggerHeadingPluralNonFinal : (0, $fHqkT.default).jqlDebuggerHeadingNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: errorComponentTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        role: "alert",
        id: errorComponentValidationId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "ul",
        xcss: $a9f0cd966e577c81$var$errorBoxStyles,
        testId: "jql-debugger.ui.error-section.error-list"
    }, jqlErrors.map((error)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            as: "li",
            key: error,
            xcss: $a9f0cd966e577c81$var$listItemStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            color: "color.text.accent.red"
        }, error))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $a9f0cd966e577c81$var$headerEndStyles
    }, showFixErrorButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f6eza.FixErrorButton), {
        testId: "jql-debugger.ui.error-section.trigger-button",
        jqlErrors: jqlErrors,
        onSearch: onSearch,
        query: query,
        entryPointActions: entryPointActions
    })));
}
const $a9f0cd966e577c81$var$containerStyles = (0, $1DXK0.xcss)({
    minHeight: "var(--ds-space-400, 32px)"
});
const $a9f0cd966e577c81$var$errorBoxStyles = (0, $1DXK0.xcss)({
    flex: 1,
    marginBlockStart: '0',
    paddingInlineStart: 'space.025'
});
const $a9f0cd966e577c81$var$headerEndStyles = (0, $1DXK0.xcss)({
    alignSelf: 'flex-start'
});
const $a9f0cd966e577c81$var$listItemStyle = (0, $1DXK0.xcss)({
    listStyle: 'none'
});
const $a9f0cd966e577c81$var$jqlErrorHeadingStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    whiteSpace: 'nowrap',
    alignItems: 'center',
    gap: 'space.075'
});

});
parcelRegister("f6eza", function(module, exports) {
$parcel$export(module.exports, "FixErrorButton", () => $048c101372748c1a$export$94f98890cd333316);

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $gn1zL = parcelRequire("gn1zL");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $bUnif = parcelRequire("bUnif");

var $29xoF = parcelRequire("29xoF");

function $048c101372748c1a$var$useImportOnClickHandler() {
    const importer = (0, $eJOHy.useCallback)(()=>{
        return Promise.resolve((parcelRequire("awW5u")));
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        importer();
    }, [
        importer
    ]);
    return importer;
}
function $048c101372748c1a$export$94f98890cd333316(props) {
    const { testId: testId, jqlErrors: jqlErrors, onSearch: onSearch, query: query, entryPointActions: entryPointActions } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const debuggerStoreActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    const importer = $048c101372748c1a$var$useImportOnClickHandler();
    const [isReadyForProactive] = (0, $bUnif.useIsReadyForProactive)();
    (0, $eJOHy.useEffect)(()=>{
        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'fixWithAiButton viewed', {
            debuggerPanel: true
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "primary",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($gn1zL))),
        onMouseOver: ()=>{
            entryPointActions?.preload();
        },
        testId: "jql-debugger.ui.fix-error-button.button",
        onClick: async ()=>{
            entryPointActions?.load();
            const { onClick: onClick } = await importer();
            onClick({
                testId: testId,
                query: query || '',
                jqlErrors: jqlErrors,
                onSearch: onSearch,
                createAnalyticsEvent: createAnalyticsEvent,
                debuggerStoreActions: debuggerStoreActions,
                isReadyForProactive: isReadyForProactive
            });
        }
    }, formatMessage((0, $29xoF.default).fixErrorWithAiNonFinal));
}

});
parcelRegister("29xoF", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fbc607cb38fb1a6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4fbc607cb38fb1a6$var$messages = (0, $7qGN1.defineMessages)({
    fixErrorWithAiNonFinal: {
        "id": "jql-debugger.trigger-button.fix-error-with-ai-non-final",
        "defaultMessage": "Fix error"
    },
    jsErrorNonFinal: {
        "id": "jql-debugger.trigger-button.js-error-non-final",
        "defaultMessage": "Something went wrong"
    },
    errorIconLabelNonFinal: {
        "id": "jql-debugger.trigger-button.error-icon-label-non-final",
        "defaultMessage": "Error Icon"
    }
});
var $4fbc607cb38fb1a6$export$2e2bcd8739ae039 = $4fbc607cb38fb1a6$var$messages;

});

parcelRegister("awW5u", function(module, exports) {
$parcel$export(module.exports, "endpoint", () => $bfd85cc389cc53db$export$125e2b775860041f);
$parcel$export(module.exports, "apiCache", () => $bfd85cc389cc53db$export$fd9779c86130d7b0);
$parcel$export(module.exports, "preloadApiCall", () => $bfd85cc389cc53db$export$2797ffd2e0fc155);
$parcel$export(module.exports, "preloadApiCallNew", () => $bfd85cc389cc53db$export$d3033c936bb6c028);
$parcel$export(module.exports, "onClick", () => $bfd85cc389cc53db$export$1d5a917feb871989);

var $aXKmr = parcelRequire("aXKmr");

var $9pTd3 = parcelRequire("9pTd3");

var $kRgKj = parcelRequire("kRgKj");

var $4cTDP = parcelRequire("4cTDP");

var $9n5mq = parcelRequire("9n5mq");

var $13f5n = parcelRequire("13f5n");

var $gPSc4 = parcelRequire("gPSc4");

var $gJUBb = parcelRequire("gJUBb");
const $bfd85cc389cc53db$export$125e2b775860041f = (0, $gPSc4.createConvoAiEndpoint)({
    url: '/gateway/api/assist/api/v1/plugin/execute',
    method: 'POST',
    experienceId: 'jira-nl-to-jql-errors',
    product: 'jira'
});
const $bfd85cc389cc53db$export$fd9779c86130d7b0 = (0, $gJUBb.LruCache)();
const $bfd85cc389cc53db$export$2797ffd2e0fc155 = (query, jqlErrors, abortController = new AbortController())=>{
    const promise = $bfd85cc389cc53db$export$fd9779c86130d7b0.get(query)?.value || $bfd85cc389cc53db$export$125e2b775860041f({
        name: 'jirajqldebug',
        schema: {
            type: 'jirajqldebug',
            userQuery: query,
            userQueryError: jqlErrors?.join('. \n') || ''
        }
    }, {
        abortControllerSignal: abortController.signal
    });
    $bfd85cc389cc53db$export$fd9779c86130d7b0.set(query, promise);
    return promise;
};
const $bfd85cc389cc53db$export$d3033c936bb6c028 = (createAnalyticsEvent, query, jqlErrors, abortController = new AbortController())=>{
    const cachedApiCall = $bfd85cc389cc53db$export$fd9779c86130d7b0.get(query)?.value;
    if ((0, $4cTDP.fg)('jql-fixer-cost-reduction-targeting-gate')) {
        if (!cachedApiCall) (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'jqlFixerApiCall initiated', {});
    }
    const promise = cachedApiCall || $bfd85cc389cc53db$export$125e2b775860041f({
        name: 'jirajqldebug',
        schema: {
            type: 'jirajqldebug',
            userQuery: query,
            userQueryError: jqlErrors?.join('. \n') || ''
        }
    }, {
        abortControllerSignal: abortController.signal
    });
    $bfd85cc389cc53db$export$fd9779c86130d7b0.set(query, promise);
    return promise;
};
async function $bfd85cc389cc53db$export$1d5a917feb871989({ testId: testId, createAnalyticsEvent: createAnalyticsEvent, query: query, debuggerStoreActions: debuggerStoreActions, jqlErrors: jqlErrors, onSearch: onSearch, isReadyForProactive: isReadyForProactive = false }) {
    const singleInstrumentationID = (0, $aXKmr.v4)(); // TODO - remove with the fg cleanup of jql_fixer_analytics_fixes
    try {
        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiInteraction initiated', (0, $9n5mq.getAiAttributes)({
            singleInstrumentationID: singleInstrumentationID,
            isReadyForProactive: isReadyForProactive
        }));
        const abortController = new AbortController();
        // When we trigger the JQL Debugger within NL-to-JQL, we want to exit the natural language mode
        // This is because two AI features cannot be nested within each other
        // Attempting to show two AI features at once also interferes with non functional aspects such as loading states, analytics and feedback collector
        debuggerStoreActions.exitNaturalLanguageMode();
        debuggerStoreActions.setStateOnFeatureInvoke({
            jqlQuery: query,
            singleInstrumentationID: singleInstrumentationID,
            errorSectionTestId: testId
        });
        // Register callback to be called when there is a javascript error
        // Currently all it does is aborting any pending API calls
        debuggerStoreActions.setOnJsError(()=>{
            abortController?.abort(new DOMException((0, $13f5n.CLOSED_AI_MODAL_ABORT_REASON_MESSAGE), (0, $13f5n.JS_ERROR_ABORT_REASON_NAME)));
        });
        // Register callback to be used when the AI modal is dismissed
        debuggerStoreActions.setOnAiInteractionDismissed((dismissReason)=>{
            // Abort any pending API calls
            abortController?.abort(new DOMException((0, $13f5n.CLOSED_AI_MODAL_ABORT_REASON_MESSAGE), (0, $13f5n.CLOSED_AI_MODAL_ABORT_REASON_NAME)));
            // Fire the singleInstrumentation event
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiInteraction dismissed', {
                ...(0, $9n5mq.getAiAttributes)({
                    singleInstrumentationID: singleInstrumentationID,
                    isReadyForProactive: isReadyForProactive
                }),
                dismissReason: dismissReason
            });
        });
        /**
		 * Set the API response data on the store, so that the data can be consumed by the JQLDebuggerRenderSlot
		 *
		 * This is because the trigger and the render slot are used in two different packages
		 *  - Trigger is rendered inside the JQL Builder
		 *  - Render slot is in Issue Navigator
		 *
		 * By keeping these two components loosely coupled, we can style them independent of each other
		 * Yet they are highly cohesive, so that one can be controlled by the other by updating data on the store
		 *
		 * This approach also allows us to minimise the javascript bundles loaded for each component in their specific circumstances
		 * For example, the render-slot chunk is not loaded until the users hover over the trigger button
		 * Similarly the trigger-button chunk is not loaded unless there are errors in the jql-editor
		 */ const response = (0, $4cTDP.fg)('jql-fixer-cost-reduction-targeting-gate') ? await $bfd85cc389cc53db$export$d3033c936bb6c028(createAnalyticsEvent, query, jqlErrors, abortController) : await $bfd85cc389cc53db$export$2797ffd2e0fc155(query, jqlErrors, abortController);
        const syntaxCorrectionAttemptErrors = response?.metadata?.value?.errors || [];
        if (syntaxCorrectionAttemptErrors.length) (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult error', {
            ...(0, $9n5mq.getAiAttributes)({
                singleInstrumentationID: singleInstrumentationID,
                isReadyForProactive: isReadyForProactive
            }),
            aiResultErrorCategory: (0, $13f5n.AI_RESULT_ERROR_CATEGORIES).FIXED_JQL_HAS_ERRORS
        });
        debuggerStoreActions.setJqlErorCorrectionData({
            userQueryError: jqlErrors || [],
            onSearch: onSearch || (()=>undefined),
            jqlDiffTokens: response?.metadata?.value?.diff || [],
            syntaxCorrectionAttemptErrors: syntaxCorrectionAttemptErrors
        });
    } catch (e) {
        $bfd85cc389cc53db$export$fd9779c86130d7b0.delete(query);
        const isNetworkCallAbort = e instanceof DOMException;
        (0, $9pTd3.fireErrorAnalytics)({
            event: createAnalyticsEvent({}),
            meta: {
                id: 'JQL_Debugger',
                packageName: '@atlassian/jira-jql-debugger',
                teamName: 'gravity-ai'
            },
            attributes: {
                ...(0, $9n5mq.getAiAttributes)({
                    singleInstrumentationID: singleInstrumentationID,
                    isReadyForProactive: isReadyForProactive
                }),
                isNetworkCallAbort: isNetworkCallAbort
            },
            error: e instanceof Error ? e : undefined,
            // When the network call is aborted due to dismissing the modal, then we don't want to send the error to Sentry as
            // it is not necessarily an error (e.g, a user could simply be searching for a different query)
            skipSentry: isNetworkCallAbort && e.name === (0, $13f5n.CLOSED_AI_MODAL_ABORT_REASON_NAME)
        });
        if (isNetworkCallAbort) {
            // When network call is aborted due to a javascript error, then don't change the feature state
            if (e.name === (0, $13f5n.JS_ERROR_ABORT_REASON_NAME)) return;
            // When network call is aborted due to dismissing the modal, then we reset the feature state to initial state
            if (e.name === (0, $13f5n.CLOSED_AI_MODAL_ABORT_REASON_NAME)) {
                debuggerStoreActions.resetStatus('NETWORK_CALL_ABORT');
                return;
            }
        }
        // Do not fire the unified ai anlytics event for aiResult error when the API call is aborted
        // i.e. the interaction was dismissed, but not necessarily resulted in an error
        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult error', {
            ...(0, $9n5mq.getAiAttributes)({
                singleInstrumentationID: singleInstrumentationID,
                isReadyForProactive: isReadyForProactive
            }),
            aiResultErrorCategory: (0, $13f5n.AI_RESULT_ERROR_CATEGORIES).SERVER_ERROR
        });
        // Explicitly update the status to be RESULT_ERROR in the fallthrough case
        debuggerStoreActions.setStatus('RESULT_ERROR');
    }
}

});
parcelRegister("9n5mq", function(module, exports) {
$parcel$export(module.exports, "getAiAttributes", () => $93c2edddc4531c15$export$1dc69577c8d8f632);

var $4cTDP = parcelRequire("4cTDP");

var $hh2hg = parcelRequire("hh2hg");
function $93c2edddc4531c15$export$1dc69577c8d8f632({ singleInstrumentationID: singleInstrumentationID_, isReadyForProactive: isReadyForProactive = false }) {
    const userGeneratedAI = isReadyForProactive ? 0 : 1;
    const proactiveAIGenerated = isReadyForProactive ? 1 : 0;
    const singleInstrumentationID = (0, $4cTDP.fg)('jql_fixer_analytics_fixes') ? (0, $hh2hg.nonReactiveSingleton)().getSingleInstrumentationId() : singleInstrumentationID_;
    return {
        aiFeatureName: 'JQL_Debugger',
        userGeneratedAI: userGeneratedAI,
        proactiveAIGenerated: proactiveAIGenerated,
        isAIFeature: 1,
        singleInstrumentationID: singleInstrumentationID
    };
}

});

parcelRegister("13f5n", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME_JQL_DEBUGGER", () => $4d08bf51bcedf53e$export$efcb4634ee5c0cb9);
$parcel$export(module.exports, "TEAM_NAME", () => $4d08bf51bcedf53e$export$d57b6b390e78d90f);
$parcel$export(module.exports, "ERROR_BOUNDARY_IDS", () => $4d08bf51bcedf53e$export$2d2d5df8a192a41a);
$parcel$export(module.exports, "CLOSED_AI_MODAL_ABORT_REASON_MESSAGE", () => $4d08bf51bcedf53e$export$8714ae84b437fe97);
$parcel$export(module.exports, "CLOSED_AI_MODAL_ABORT_REASON_NAME", () => $4d08bf51bcedf53e$export$1e71032fcb7b8730);
$parcel$export(module.exports, "JS_ERROR_ABORT_REASON_NAME", () => $4d08bf51bcedf53e$export$64c672172b01336);
$parcel$export(module.exports, "AI_RESULT_ERROR_CATEGORIES", () => $4d08bf51bcedf53e$export$ad3b2223714b1ed9);
const $4d08bf51bcedf53e$export$efcb4634ee5c0cb9 = 'jira-jql-debugger';
const $4d08bf51bcedf53e$export$d57b6b390e78d90f = 'jira-ai-gravity';
const $4d08bf51bcedf53e$export$2d2d5df8a192a41a = {
    TRIGGER_BUTTON: 'jira-jql-debugger-trigger-button',
    FIX_WITH_AI_MODAL: 'jira-jql-debugger-fix-with-ai-modal',
    COMMON_ENTRY_JQL_BUILDER: 'jira-jql-debugger-common-entry-jql-builder',
    COMMON_ENTRY_ISSUE_VIEW: 'jira-jql-debugger-common-entry-issue-view'
};
const $4d08bf51bcedf53e$export$8714ae84b437fe97 = 'AI Modal was closed before the fetch completed';
const $4d08bf51bcedf53e$export$1e71032fcb7b8730 = 'AI_MODAL_CLOSED';
const $4d08bf51bcedf53e$export$64c672172b01336 = 'JS_ERROR';
const $4d08bf51bcedf53e$export$ad3b2223714b1ed9 = {
    FIXED_JQL_HAS_ERRORS: 'fixed-jql-has-errors',
    SERVER_ERROR: 'server-error'
};

});

parcelRegister("gPSc4", function(module, exports) {
$parcel$export(module.exports, "createConvoAiEndpoint", () => $78102f89db9e576c$export$f8ba6757167c2aba);
const $78102f89db9e576c$export$f8ba6757167c2aba = (initArgs)=>async (body, options)=>{
        const response = await fetch(initArgs.url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Product': initArgs.product,
                'X-Experience-Id': initArgs.experienceId
            },
            body: JSON.stringify(body),
            signal: options.abortControllerSignal
        });
        if (!response.ok) throw new Error(`API call failed: ${response.status}`);
        const result = await response.json();
        return result;
    };

});

parcelRegister("gJUBb", function(module, exports) {
$parcel$export(module.exports, "LruCache", () => $3a4833cdaf1c1f06$export$ec63a4108685a0aa);
function $3a4833cdaf1c1f06$export$ec63a4108685a0aa(limit = 5) {
    const cache = new Map();
    return {
        get: (key)=>cache.get(key),
        set: (key, value)=>{
            cache.set(key, {
                lastAccessed: Date.now(),
                value: value
            });
            if (cache.size <= limit) return;
            // limit the cache size based on the oldest entry based on lastAccessed time
            let oldestKey = null;
            let oldestLastAccessed = null;
            for (const [key_, value_] of cache.entries())if (oldestLastAccessed === null || value_.lastAccessed < oldestLastAccessed) {
                oldestKey = key_;
                oldestLastAccessed = value_.lastAccessed;
            }
            if (oldestKey) cache.delete(oldestKey);
        },
        delete: (key)=>{
            cache.delete(key);
        },
        clear: ()=>{
            cache.clear();
        }
    };
}

});



parcelRegister("fHqkT", function(module, exports) {
$parcel$export(module.exports, "default", () => $0dfe1ae393dfab8a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0dfe1ae393dfab8a$var$messages = (0, $7qGN1.defineMessages)({
    jqlDebuggerHeadingNonFinal: {
        "id": "jql-debugger-panel.header.text-non-final",
        "defaultMessage": "JQL error"
    },
    jqlDebuggerHeadingPluralNonFinal: {
        "id": "jql-debugger-panel.header.plural-text-non-final",
        "defaultMessage": "JQL errors"
    },
    jqlDebuggerLoadingNonFinal: {
        "id": "jql-debugger-panel.header.loading-non-final",
        "defaultMessage": "Generating query fixes"
    },
    betaLozenge: {
        "id": "jql-debugger-panel.header.beta-lozenge",
        "defaultMessage": "Beta"
    },
    discardSuggestionNonFinal: {
        "id": "jql-debugger-panel.error-section.discard-suggestion-non-final",
        "defaultMessage": "Discard and close"
    }
});
var $0dfe1ae393dfab8a$export$2e2bcd8739ae039 = $0dfe1ae393dfab8a$var$messages;

});


parcelRegister("iNmbB", function(module, exports) {
$parcel$export(module.exports, "SuggestedFixContentEntrypoint", () => $5a5654ca917f495c$export$9b2c3d0b37e41ae9);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $5a5654ca917f495c$export$9b2c3d0b37e41ae9 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("fA9m5")), {
        moduleId: "2d263a55",
        priority: "interaction"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("fA9m5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("66nqw").then(()=>parcelRequire('d16oc'));

});



parcelRegister("lg8UF", function(module, exports) {
$parcel$export(module.exports, "extractTextFromReactElement", () => $91bb6ebc41ba1a5e$export$98ee087174ba8894);

var $eJOHy = parcelRequire("eJOHy");
function $91bb6ebc41ba1a5e$export$98ee087174ba8894(element) {
    let result = '';
    function traverse(node) {
        if (typeof node === 'string' || typeof node === 'number') result += node.toString();
        else if (/*#__PURE__*/ (0, $eJOHy.isValidElement)(node)) (0, $eJOHy.Children).forEach(node.props.children, (child)=>{
            traverse(child);
        });
    }
    traverse(element);
    return result;
}

});


parcelRegister("cZHhU", function(module, exports) {
$parcel$export(module.exports, "NoFilter", () => $acf3a3ec36143335$export$fba2cdeecf4e314d);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6MnLl = parcelRequire("6MnLl");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $cxKOj = parcelRequire("cxKOj");

var $kKCMK = parcelRequire("kKCMK");

var $lRq8t = parcelRequire("lRq8t");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");

var $4cTDP = parcelRequire("4cTDP");

var $2dA31 = parcelRequire("2dA31");
const $acf3a3ec36143335$var$ANOTHER_FILTER_LINK = '/jira/filters';
const $acf3a3ec36143335$export$fba2cdeecf4e314d = ({ reason: reason })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: "noFilter",
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), {
        attributes: reason ? {
            reason: reason
        } : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        header: formatMessage((0, $2dA31.default).weCouldntFindThisFilter),
        description: (0, $4cTDP.fg)('jfp-magma-hydration-no-filter') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
            as: "span",
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            as: "span"
        }, formatMessage((0, $2dA31.default).filterNoExistOrNoPermissions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            as: "span"
        }, formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2dA31.default).tryAnotherFilterIssueTermRefresh : (0, $2dA31.default).tryAnotherFilter))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $2dA31.default).filterNoExistOrNoPermissions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2dA31.default).tryAnotherFilterIssueTermRefresh : (0, $2dA31.default).tryAnotherFilter))),
        secondaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            href: $acf3a3ec36143335$var$ANOTHER_FILTER_LINK
        }, formatMessage((0, $2dA31.default).viewFilters)),
        primaryAction: // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "primary",
            href: window.location.pathname
        }, formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2dA31.default).searchIssuesIssueTermRefresh : (0, $2dA31.default).searchIssues)),
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $acf3a3ec36143335$var$ImageWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kKCMK.default), {
                alt: ""
            }))
    }));
};
var $acf3a3ec36143335$export$2e2bcd8739ae039 = $acf3a3ec36143335$export$fba2cdeecf4e314d;
const $acf3a3ec36143335$var$ImageWrapperStyles = (0, $1DXK0.xcss)({
    maxHeight: '165px',
    maxWidth: '150px',
    margin: 'auto',
    marginBottom: 'space.300'
});

});
parcelRegister("kKCMK", function(module, exports) {
$parcel$export(module.exports, "default", () => $aaae219acd4147f1$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $c4huj = parcelRequire("c4huj");

var $js5cg = parcelRequire("js5cg");

var $hj82Y = parcelRequire("hj82Y");
const $aaae219acd4147f1$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($hj82Y)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($js5cg))
});
var $aaae219acd4147f1$export$2e2bcd8739ae039 = $aaae219acd4147f1$var$Illustration;
// for advanced use only
const $aaae219acd4147f1$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    184
];

});
parcelRegister("js5cg", function(module, exports) {
module.exports = new URL("search-no-results-darkmode.c66ae5fb.svg", import.meta.url).toString();

});

parcelRegister("hj82Y", function(module, exports) {
module.exports = new URL("search-no-results.1d478205.svg", import.meta.url).toString();

});


parcelRegister("2dA31", function(module, exports) {
$parcel$export(module.exports, "default", () => $590b7368a30ac0df$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $590b7368a30ac0df$var$messages = (0, $7qGN1.defineMessages)({
    weCouldntFindThisFilter: {
        "id": "issue-navigator.common.no-filter.we-couldnt-find-this-filter",
        "defaultMessage": "We couldn't find this filter"
    },
    filterNoExistOrNoPermissions: {
        "id": "issue-navigator.common.no-filter.filter-no-exist-or-no-permissions",
        "defaultMessage": "This filter may not exist, or you don\u2019t have permissions to view it."
    },
    tryAnotherFilter: {
        "id": "issue-navigator.common.no-filter.try-another-filter",
        "defaultMessage": "Try searching for another filter, or start a new issue search."
    },
    viewFilters: {
        "id": "issue-navigator.common.no-filter.view-filters",
        "defaultMessage": "View filters"
    },
    searchIssues: {
        "id": "issue-navigator.common.no-filter.search-issues",
        "defaultMessage": "Search issues"
    },
    tryAnotherFilterIssueTermRefresh: {
        "id": "issue-navigator.common.no-filter.try-another-filter-issue-term-refresh",
        "defaultMessage": "Try searching for another filter, or start a new search."
    },
    searchIssuesIssueTermRefresh: {
        "id": "issue-navigator.common.no-filter.search-issues-issue-term-refresh",
        "defaultMessage": "Search work items"
    }
});
var $590b7368a30ac0df$export$2e2bcd8739ae039 = $590b7368a30ac0df$var$messages;

});


parcelRegister("51pSU", function(module, exports) {
$parcel$export(module.exports, "IssueSearchSuccess", () => $e264e4f6ae230ba0$export$3ee6d2830e5ead03);
$parcel$export(module.exports, "IssueSearchFail", () => $e264e4f6ae230ba0$export$91886a55521e4fad);

var $eJOHy = parcelRequire("eJOHy");

var $6d9QY = parcelRequire("6d9QY");

var $5Ijz5 = parcelRequire("5Ijz5");

var $3kDjB = parcelRequire("3kDjB");

var $HiS1C = parcelRequire("HiS1C");
const $e264e4f6ae230ba0$export$3ee6d2830e5ead03 = ({ attributes: attributes, onPageDataLoad: onPageDataLoad })=>{
    const [{ view: view }] = (0, $HiS1C.useSelectedViewState)();
    const { onIssueSearchSuccess: onIssueSearchSuccess } = (0, $5Ijz5.useExperienceAnalytics)(onPageDataLoad, attributes);
    const isFetching = (0, $3kDjB.useIsFetching)();
    const isNetworkError = (0, $3kDjB.useIsNetworkError)();
    const prevIsFetching = (0, $6d9QY.usePrevious)(isFetching);
    (0, $eJOHy.useEffect)(()=>{
        if (prevIsFetching !== isFetching && !isFetching && !isNetworkError) onIssueSearchSuccess(view);
    }, [
        isFetching,
        isNetworkError,
        onIssueSearchSuccess,
        prevIsFetching,
        view
    ]);
    return null;
};
const $e264e4f6ae230ba0$export$91886a55521e4fad = ({ attributes: attributes, location: location, error: error, onPageDataLoad: onPageDataLoad })=>{
    const [{ view: view }] = (0, $HiS1C.useSelectedViewState)();
    const { onIssueSearchFail: onIssueSearchFail } = (0, $5Ijz5.useExperienceAnalytics)(onPageDataLoad, attributes);
    const isFetching = (0, $3kDjB.useIsFetching)();
    const prevIsFetching = (0, $6d9QY.usePrevious)(isFetching);
    (0, $eJOHy.useEffect)(()=>{
        if (prevIsFetching !== isFetching && !isFetching) onIssueSearchFail(location, error, view);
    }, [
        error,
        isFetching,
        location,
        onIssueSearchFail,
        prevIsFetching,
        view
    ]);
    return null;
};

});
parcelRegister("3kDjB", function(module, exports) {
$parcel$export(module.exports, "useSearchKey", () => $c05fb16140fafdb8$export$89b7d8d2a901e7f3);
$parcel$export(module.exports, "useIsFetching", () => $c05fb16140fafdb8$export$625b2ff71316bcd3);
$parcel$export(module.exports, "useIsFetchingView", () => $c05fb16140fafdb8$export$bb4d69b04e77d5fc);
$parcel$export(module.exports, "useIsNetworkError", () => $c05fb16140fafdb8$export$e42540e6c753cf0d);
$parcel$export(module.exports, "useIsRefreshing", () => $c05fb16140fafdb8$export$f0abaf46a1fbe05d);
$parcel$export(module.exports, "useTotalIssueCount", () => $c05fb16140fafdb8$export$2913c5459976c260);
$parcel$export(module.exports, "useTotalIssueCountIsFetching", () => $c05fb16140fafdb8$export$597fd4c2a21a6427);
$parcel$export(module.exports, "useTotalIssueCountIsError", () => $c05fb16140fafdb8$export$8ca94746675b8a5f);
$parcel$export(module.exports, "useIssueSearchActions", () => $c05fb16140fafdb8$export$77a801a298598c57);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");

var $hbF3h = parcelRequire("hbF3h");

var $4cTDP = parcelRequire("4cTDP");

var $4o2sx = parcelRequire("4o2sx");
const $c05fb16140fafdb8$var$useSearchKeyContext = ()=>(0, $eJOHy.useContext)((0, $4o2sx.LifecycleContext)).searchKey;
const $c05fb16140fafdb8$var$useIsFetchingContext = ()=>(0, $eJOHy.useContext)((0, $4o2sx.LifecycleContext)).isFetching;
const $c05fb16140fafdb8$var$useIsFetchingViewContext = ()=>(0, $eJOHy.useContext)((0, $4o2sx.LifecycleContext)).isFetchingView;
const $c05fb16140fafdb8$var$useIsNetworkErrorContext = ()=>(0, $eJOHy.useContext)((0, $4o2sx.LifecycleContext)).isNetworkError;
const $c05fb16140fafdb8$var$useIsRefreshingContext = ()=>(0, $eJOHy.useContext)((0, $4o2sx.LifecycleContext)).isRefreshing;
const $c05fb16140fafdb8$var$useSearchKeyRSS = (0, $iJq0l.createStateHook)((0, $4o2sx.Store), {
    selector: (state)=>state.searchKey
});
const $c05fb16140fafdb8$var$useIsFetchingRSS = (0, $iJq0l.createStateHook)((0, $4o2sx.Store), {
    selector: (state)=>state.isFetching
});
const $c05fb16140fafdb8$var$useIsFetchingViewRSS = (0, $iJq0l.createStateHook)((0, $4o2sx.Store), {
    selector: (state)=>state.isFetchingView
});
const $c05fb16140fafdb8$var$useIsNetworkErrorRSS = (0, $iJq0l.createStateHook)((0, $4o2sx.Store), {
    selector: (state)=>state.isNetworkError
});
const $c05fb16140fafdb8$var$useIsRefreshingRSS = (0, $iJq0l.createStateHook)((0, $4o2sx.Store), {
    selector: (state)=>state.isRefreshing
});
const $c05fb16140fafdb8$export$89b7d8d2a901e7f3 = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jira_nin_refetch_state_concurrency_fix'), $c05fb16140fafdb8$var$useSearchKeyContext, $c05fb16140fafdb8$var$useSearchKeyRSS);
const $c05fb16140fafdb8$export$625b2ff71316bcd3 = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jira_nin_refetch_state_concurrency_fix'), $c05fb16140fafdb8$var$useIsFetchingContext, $c05fb16140fafdb8$var$useIsFetchingRSS);
const $c05fb16140fafdb8$export$bb4d69b04e77d5fc = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jira_nin_refetch_state_concurrency_fix'), $c05fb16140fafdb8$var$useIsFetchingViewContext, $c05fb16140fafdb8$var$useIsFetchingViewRSS);
const $c05fb16140fafdb8$export$e42540e6c753cf0d = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jira_nin_refetch_state_concurrency_fix'), $c05fb16140fafdb8$var$useIsNetworkErrorContext, $c05fb16140fafdb8$var$useIsNetworkErrorRSS);
const $c05fb16140fafdb8$export$f0abaf46a1fbe05d = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jira_nin_refetch_state_concurrency_fix'), $c05fb16140fafdb8$var$useIsRefreshingContext, $c05fb16140fafdb8$var$useIsRefreshingRSS);
const $c05fb16140fafdb8$export$2913c5459976c260 = (0, $iJq0l.createStateHook)((0, $4o2sx.Store), {
    selector: (state)=>state.totalIssueCount
});
const $c05fb16140fafdb8$export$597fd4c2a21a6427 = (0, $iJq0l.createStateHook)((0, $4o2sx.Store), {
    selector: (state)=>state.totalIssueCountIsFetching
});
const $c05fb16140fafdb8$export$8ca94746675b8a5f = (0, $iJq0l.createStateHook)((0, $4o2sx.Store), {
    selector: (state)=>state.totalIssueCountIsError
});
const $c05fb16140fafdb8$export$77a801a298598c57 = (0, $iJq0l.createActionsHook)((0, $4o2sx.Store));

});

parcelRegister("HiS1C", function(module, exports) {
$parcel$export(module.exports, "Container", () => $908d0d6f8a933313$export$42a852a2b6b56249);
$parcel$export(module.exports, "useSelectedViewState", () => $908d0d6f8a933313$export$b94206faaa871f9e);
$parcel$export(module.exports, "useSelectedViewActions", () => $908d0d6f8a933313$export$15849666d3b54d24);
$parcel$export(module.exports, "useSelectedView", () => $908d0d6f8a933313$export$639584d6e9163827);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $iRahl = parcelRequire("iRahl");
const $908d0d6f8a933313$export$42a852a2b6b56249 = (0, $6E16M.createContainer)();
const $908d0d6f8a933313$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        view: (0, $iRahl.DEFAULT_VIEW_ID)
    },
    containedBy: $908d0d6f8a933313$export$42a852a2b6b56249,
    actions: {
        setView: (view, issueKey)=>({ setState: setState }, { onSetView: onSetView, onIssueSearchForView: onIssueSearchForView })=>{
                setState({
                    view: view
                });
                onSetView(view, issueKey);
                onIssueSearchForView && onIssueSearchForView(view);
            }
    },
    handlers: {
        onInit: ()=>({ setState: setState }, { view: view })=>{
                setState({
                    view: view
                });
            },
        onContainerUpdate: (nextProps, prevProps)=>({ setState: setState })=>{
                if (nextProps.view !== prevProps.view) setState({
                    view: nextProps.view
                });
            }
    },
    name: 'IssueNavigatorSelectedViewStateNew'
});
const $908d0d6f8a933313$export$b94206faaa871f9e = (0, $iJq0l.createHook)($908d0d6f8a933313$var$Store);
const $908d0d6f8a933313$export$15849666d3b54d24 = (0, $iJq0l.createActionsHook)($908d0d6f8a933313$var$Store);
const $908d0d6f8a933313$export$639584d6e9163827 = (0, $iJq0l.createStateHook)($908d0d6f8a933313$var$Store, {
    selector: (state)=>state.view
});

});


parcelRegister("1wL9i", function(module, exports) {
$parcel$export(module.exports, "useSelectedIssueIndex", () => $d13b4ab197b94f75$export$a4b375f8f9b094ad);
$parcel$export(module.exports, "useNextIssueKey", () => $d13b4ab197b94f75$export$a357f91232534409);
$parcel$export(module.exports, "usePreviousIssueKey", () => $d13b4ab197b94f75$export$ee05f65713c12ae3);
$parcel$export(module.exports, "useIssuesCount", () => $d13b4ab197b94f75$export$b8578d9ea1fc9bc);
$parcel$export(module.exports, "useSelectedIssueKey", () => $d13b4ab197b94f75$export$7cedcbfb2da7e49d);
$parcel$export(module.exports, "useIsSelectedIssue", () => $d13b4ab197b94f75$export$ccd07516e284d793);
$parcel$export(module.exports, "useSelectedIssueDebouncedState", () => $d13b4ab197b94f75$export$ed5cb04ac9d88e95);
$parcel$export(module.exports, "useIssueKeys", () => $d13b4ab197b94f75$export$a5d72277eb099991);
$parcel$export(module.exports, "useIsFullPageIssueAppMode", () => $d13b4ab197b94f75$export$988cbddd89e853c0);
$parcel$export(module.exports, "useSelectedIssueActions", () => $d13b4ab197b94f75$export$d1c4608e18de4f02);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $eibCx = parcelRequire("eibCx");

var $7681X = parcelRequire("7681X");

var $6fUhZ = parcelRequire("6fUhZ");
const $d13b4ab197b94f75$export$a4b375f8f9b094ad = (0, $iJq0l.createStateHook)((0, $7681X.Store), {
    selector: (0, $6fUhZ.getSelectedIssueIndex)
});
const $d13b4ab197b94f75$export$a357f91232534409 = (0, $iJq0l.createStateHook)((0, $7681X.Store), {
    selector: (0, $6fUhZ.getNextIssueKey)
});
const $d13b4ab197b94f75$export$ee05f65713c12ae3 = (0, $iJq0l.createStateHook)((0, $7681X.Store), {
    selector: (0, $6fUhZ.getPreviousIssueKey)
});
const $d13b4ab197b94f75$export$b8578d9ea1fc9bc = (0, $iJq0l.createStateHook)((0, $7681X.Store), {
    selector: (0, $6fUhZ.getIssuesCount)
});
const $d13b4ab197b94f75$export$7cedcbfb2da7e49d = (0, $iJq0l.createStateHook)((0, $7681X.Store), {
    selector: ({ selectedIssueKey: selectedIssueKey })=>selectedIssueKey
});
const $d13b4ab197b94f75$export$ccd07516e284d793 = (0, $iJq0l.createStateHook)((0, $7681X.Store), {
    selector: ({ selectedIssueKey: selectedIssueKey }, issueKey)=>selectedIssueKey === issueKey
});
const $d13b4ab197b94f75$export$ed5cb04ac9d88e95 = (0, $iJq0l.createStateHook)((0, $7681X.Store), {
    selector: (0, $eibCx.createRememoizeSelector)((state)=>state, ({ selectedIssueKey: selectedIssueKey })=>selectedIssueKey)
});
const $d13b4ab197b94f75$export$a5d72277eb099991 = (0, $iJq0l.createStateHook)((0, $7681X.Store), {
    selector: ({ issueKeys: issueKeys })=>issueKeys
});
const $d13b4ab197b94f75$export$988cbddd89e853c0 = (0, $iJq0l.createStateHook)((0, $7681X.Store), {
    selector: ({ isFullPageIssueAppMode: isFullPageIssueAppMode })=>isFullPageIssueAppMode
});
const $d13b4ab197b94f75$export$d1c4608e18de4f02 = (0, $iJq0l.createActionsHook)((0, $7681X.Store));

});
parcelRegister("7681X", function(module, exports) {
$parcel$export(module.exports, "SelectedIssueContainer", () => $49e7deabafdde676$export$8b7bb55917259a5d);
$parcel$export(module.exports, "Store", () => $49e7deabafdde676$export$390f32400eaf98c9);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $iRahl = parcelRequire("iRahl");

var $31wJU = parcelRequire("31wJU");
const $49e7deabafdde676$export$8b7bb55917259a5d = (0, $6E16M.createContainer)();
const $49e7deabafdde676$var$initialState = {
    _rememoize: Date.now(),
    selectedIssueKey: '',
    isFullPageIssueAppMode: false,
    issueKeys: []
};
const $49e7deabafdde676$export$390f32400eaf98c9 = (0, $GtRbT.createStore)({
    name: 'SelectedIssueStore',
    containedBy: $49e7deabafdde676$export$8b7bb55917259a5d,
    initialState: $49e7deabafdde676$var$initialState,
    actions: $31wJU.default,
    handlers: {
        onInit: ()=>({ setState: setState, dispatch: dispatch }, { selectedIssueKey: selectedIssueKey, view: view, issueKeys: issueKeys })=>{
                dispatch((0, $31wJU.privateActions).onContainerUpdate());
                const isFullPageIssueAppMode = Boolean(selectedIssueKey) && view === (0, $iRahl.views).list;
                const initialIssueKey = selectedIssueKey || issueKeys[0] || '';
                setState({
                    _rememoize: Date.now(),
                    selectedIssueKey: initialIssueKey,
                    isFullPageIssueAppMode: isFullPageIssueAppMode
                });
            },
        onContainerUpdate: ({ searchKey: searchKey, selectedIssueKey: selectedIssueKey }, prevProps)=>({ dispatch: dispatch })=>{
                dispatch((0, $31wJU.privateActions).onContainerUpdate());
                if (searchKey !== prevProps.searchKey) dispatch((0, $31wJU.privateActions).resetSelectedIssue());
                else if (selectedIssueKey && selectedIssueKey !== prevProps.selectedIssueKey) {
                    dispatch($49e7deabafdde676$export$390f32400eaf98c9.actions.setSelectedIssueByKey(selectedIssueKey, {
                        shouldDebounce: false,
                        shouldNotifyOnChange: false,
                        isSelectedByUserInteraction: false
                    }));
                    // If an issue key has been specified while in list view then enter full page issue app mode.
                    if (dispatch((0, $31wJU.privateActions).isListViewWithoutIssueApp())) dispatch($49e7deabafdde676$export$390f32400eaf98c9.actions.enterFullPageIssueAppMode());
                // TODO JSC-185 Fetch next/previous page when last/first issue is selected
                } else if (!selectedIssueKey && dispatch((0, $31wJU.privateActions).isListViewWithIssueAppAndKey())) dispatch($49e7deabafdde676$export$390f32400eaf98c9.actions.exitFullPageIssueAppMode());
            }
    }
});

});
parcelRegister("31wJU", function(module, exports) {
$parcel$export(module.exports, "privateActions", () => $5de2eb3fb1196457$export$3f1be494d407b77a);
$parcel$export(module.exports, "default", () => $5de2eb3fb1196457$export$2e2bcd8739ae039);

var $3s8bj = parcelRequire("3s8bj");

var $iRahl = parcelRequire("iRahl");

var $6fUhZ = parcelRequire("6fUhZ");
const $5de2eb3fb1196457$var$doSideEffectUpdate = ({ getState: getState, setState: setState }, { onChange: onChange, shouldNotifyOnChange: shouldNotifyOnChange = true, isSelectedByUserInteraction: isSelectedByUserInteraction = true, viewActivity: viewActivity })=>{
    const { selectedIssueKey: selectedIssueKey } = getState();
    setState({
        _rememoize: Date.now()
    });
    shouldNotifyOnChange && onChange && onChange(selectedIssueKey, isSelectedByUserInteraction, viewActivity);
};
const $5de2eb3fb1196457$var$doDebouncedSideEffectUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))($5de2eb3fb1196457$var$doSideEffectUpdate, 600);
const $5de2eb3fb1196457$var$doSideEffectUpdates = (actions, options)=>{
    options.shouldDebounce ? $5de2eb3fb1196457$var$doDebouncedSideEffectUpdate(actions, options) : $5de2eb3fb1196457$var$doSideEffectUpdate(actions, options);
};
const $5de2eb3fb1196457$var$setSelectedIssueByKey = (selectedIssueKey, options = {})=>(actions, { onChange: onChange })=>{
        if (!selectedIssueKey.length) return false;
        actions.setState({
            selectedIssueKey: selectedIssueKey
        });
        $5de2eb3fb1196457$var$doSideEffectUpdates(actions, {
            ...options,
            onChange: onChange
        });
        return true;
    };
const $5de2eb3fb1196457$var$setSelectedIssueByIndex = (issueIndex, options)=>({ dispatch: dispatch }, { issueKeys: issueKeys })=>{
        return dispatch($5de2eb3fb1196457$var$setSelectedIssueByKey(issueKeys[issueIndex] ?? '', options));
    };
/**
 * Select the next issue in the search results (if there is a valid selection). Returns `true` if an issue was selected,
 * otherwise `false`.
 */ const $5de2eb3fb1196457$var$selectNextIssue = (shouldDebounce)=>({ dispatch: dispatch, getState: getState })=>{
        return dispatch($5de2eb3fb1196457$var$setSelectedIssueByKey((0, $6fUhZ.getNextIssueKey)(getState()) ?? '', {
            shouldDebounce: shouldDebounce
        }));
    };
/**
 * Select the previous issue in the search results (if there is a valid selection). Returns `true` if an issue was
 * selected, otherwise `false`.
 */ const $5de2eb3fb1196457$var$selectPreviousIssue = (shouldDebounce)=>({ dispatch: dispatch, getState: getState })=>{
        return dispatch($5de2eb3fb1196457$var$setSelectedIssueByKey((0, $6fUhZ.getPreviousIssueKey)(getState()) ?? '', {
            shouldDebounce: shouldDebounce
        }));
    };
const $5de2eb3fb1196457$var$deselectIssue = (options)=>(actions, { onChange: onChange })=>{
        actions.setState({
            selectedIssueKey: ''
        });
        $5de2eb3fb1196457$var$doSideEffectUpdates(actions, {
            ...options,
            onChange: onChange
        });
    };
const $5de2eb3fb1196457$var$enterFullPageIssueAppMode = ()=>({ setState: setState })=>setState({
            isFullPageIssueAppMode: true
        });
const $5de2eb3fb1196457$var$exitFullPageIssueAppMode = ()=>({ setState: setState })=>setState({
            isFullPageIssueAppMode: false
        });
/**
 * Return true if we're in default list view mode without the full page issue app visible.
 */ const $5de2eb3fb1196457$var$isListViewWithoutIssueApp = ()=>({ getState: getState }, { view: view })=>{
        const { isFullPageIssueAppMode: isFullPageIssueAppMode } = getState();
        return view === (0, $iRahl.views).list && !isFullPageIssueAppMode;
    };
/**
 * Return true if we're in default list view mode with the full page issue app visible and a selected issue key.
 */ const $5de2eb3fb1196457$var$isListViewWithIssueAppAndKey = ()=>({ getState: getState }, { view: view })=>{
        const { isFullPageIssueAppMode: isFullPageIssueAppMode, selectedIssueKey: selectedIssueKey } = getState();
        return view === (0, $iRahl.views).list && isFullPageIssueAppMode && !!selectedIssueKey;
    };
/**
 * Reset the selected issue to the first issue in the connection.
 */ const $5de2eb3fb1196457$var$resetSelectedIssue = ()=>({ dispatch: dispatch })=>{
        // We only want to update issue key in the URL if our view mode uses external issue key selection, i.e. detail
        // view or full page issue app in list view. For the default list view mode we want to keep the selected issue
        // state internal.
        const shouldNotifyOnChange = !dispatch($5de2eb3fb1196457$var$isListViewWithoutIssueApp());
        dispatch($5de2eb3fb1196457$var$setSelectedIssueByIndex(0, {
            shouldDebounce: false,
            shouldNotifyOnChange: shouldNotifyOnChange,
            isSelectedByUserInteraction: false
        }));
    };
const $5de2eb3fb1196457$export$ab8f0de40a3a2d2d = ()=>({ setState: setState }, { issueKeys: issueKeys })=>{
        setState({
            issueKeys: issueKeys
        });
    };
const $5de2eb3fb1196457$export$e324594224ef24da = {
    setSelectedIssueByKey: $5de2eb3fb1196457$var$setSelectedIssueByKey,
    setSelectedIssueByIndex: $5de2eb3fb1196457$var$setSelectedIssueByIndex,
    selectNextIssue: $5de2eb3fb1196457$var$selectNextIssue,
    selectPreviousIssue: $5de2eb3fb1196457$var$selectPreviousIssue,
    deselectIssue: $5de2eb3fb1196457$var$deselectIssue,
    enterFullPageIssueAppMode: $5de2eb3fb1196457$var$enterFullPageIssueAppMode,
    exitFullPageIssueAppMode: $5de2eb3fb1196457$var$exitFullPageIssueAppMode
};
const $5de2eb3fb1196457$export$3f1be494d407b77a = {
    isListViewWithoutIssueApp: $5de2eb3fb1196457$var$isListViewWithoutIssueApp,
    isListViewWithIssueAppAndKey: $5de2eb3fb1196457$var$isListViewWithIssueAppAndKey,
    resetSelectedIssue: $5de2eb3fb1196457$var$resetSelectedIssue,
    onContainerUpdate: $5de2eb3fb1196457$export$ab8f0de40a3a2d2d
};
var $5de2eb3fb1196457$export$2e2bcd8739ae039 = $5de2eb3fb1196457$export$e324594224ef24da;

});
parcelRegister("6fUhZ", function(module, exports) {
$parcel$export(module.exports, "getSelectedIssueIndex", () => $b490591c01d668ee$export$b5bba5025e9754c0);
$parcel$export(module.exports, "getNextIssueKey", () => $b490591c01d668ee$export$2a413bfa3aeed781);
$parcel$export(module.exports, "getPreviousIssueKey", () => $b490591c01d668ee$export$5e257a264fce89f7);
$parcel$export(module.exports, "getIssuesCount", () => $b490591c01d668ee$export$af7642e9bc434b70);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4MchI = parcelRequire("4MchI");
const $b490591c01d668ee$export$b5bba5025e9754c0 = (0, $4MchI.createSelector)((state)=>state.selectedIssueKey, (state)=>state.issueKeys, (selectedIssueKey, issueKeys)=>issueKeys.indexOf(selectedIssueKey));
const $b490591c01d668ee$export$2a413bfa3aeed781 = (state)=>{
    const index = $b490591c01d668ee$export$b5bba5025e9754c0(state);
    const { issueKeys: issueKeys } = state;
    return index > -1 && index < issueKeys.length - 1 ? issueKeys[index + 1] : null;
};
const $b490591c01d668ee$export$5e257a264fce89f7 = (state)=>{
    const index = $b490591c01d668ee$export$b5bba5025e9754c0(state);
    const { issueKeys: issueKeys } = state;
    return index > 0 ? issueKeys[index - 1] : null;
};
const $b490591c01d668ee$export$af7642e9bc434b70 = (state)=>{
    return state.issueKeys.length;
};

});




parcelRegister("lvpZz", function(module, exports) {
$parcel$export(module.exports, "FlatListIssuesContainer", () => $b8491aab06161461$export$60cae405c8bdaa87);
$parcel$export(module.exports, "useFlatListIssuesActions", () => $b8491aab06161461$export$14d48bac80618630);
$parcel$export(module.exports, "useFlatListIssues", () => $b8491aab06161461$export$a53e6810bcedfe4d);
$parcel$export(module.exports, "useFlatListIssueIds", () => $b8491aab06161461$export$440fc5b87687d980);
$parcel$export(module.exports, "useFlatListChildIssueIds", () => $b8491aab06161461$export$674a7e9a564d6c04);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $b8491aab06161461$export$60cae405c8bdaa87 = (0, $6E16M.createContainer)();
const $b8491aab06161461$var$initialState = {
    flatListIssues: [],
    flatListIssueIds: [],
    flatListChildIssueIds: []
};
const $b8491aab06161461$var$actions = {
    setFlatListIssueIds: (flatListIssueIds)=>({ setState: setState })=>{
            setState({
                flatListIssueIds: flatListIssueIds
            });
        },
    setFlatListIssues: (flatListIssues)=>({ setState: setState })=>{
            setState({
                flatListIssues: flatListIssues
            });
        },
    mergeFlatListIssues: (flatListIssues)=>({ setState: setState, getState: getState })=>{
            const existingIssues = getState().flatListIssues;
            if (existingIssues.length === 0) {
                setState({
                    flatListIssues: flatListIssues
                });
                return;
            }
            // Filter out existing issues
            const existingIssuesSet = new Set(existingIssues);
            const uniqueNewIssues = flatListIssues.filter((issue)=>!existingIssuesSet.has(issue));
            if (uniqueNewIssues.length === 0) return;
            // Determine if new issues have been added to the beginning or end of the list and prepend/append accordingly
            if (existingIssues[0] !== flatListIssues[0]) setState({
                flatListIssues: uniqueNewIssues.concat(existingIssues)
            });
            else setState({
                flatListIssues: existingIssues.concat(uniqueNewIssues)
            });
        },
    setFlatListChildIssueIds: (flatListChildIssueIds)=>({ setState: setState })=>{
            setState({
                flatListChildIssueIds: flatListChildIssueIds
            });
        }
};
const $b8491aab06161461$var$Store = (0, $GtRbT.createStore)({
    containedBy: $b8491aab06161461$export$60cae405c8bdaa87,
    initialState: $b8491aab06161461$var$initialState,
    actions: $b8491aab06161461$var$actions,
    name: 'jira-native-issue-table-flat-list-issues-store'
});
const $b8491aab06161461$export$14d48bac80618630 = (0, $iJq0l.createActionsHook)($b8491aab06161461$var$Store);
const $b8491aab06161461$export$2868636f0c1a29ec = (0, $iJq0l.createHook)($b8491aab06161461$var$Store);
const $b8491aab06161461$var$getFlatListIssuesSelector = (state)=>state.flatListIssues;
const $b8491aab06161461$export$a53e6810bcedfe4d = (0, $iJq0l.createStateHook)($b8491aab06161461$var$Store, {
    selector: $b8491aab06161461$var$getFlatListIssuesSelector
});
const $b8491aab06161461$var$getFlatListIssueIdsSelector = (state)=>state.flatListIssueIds;
const $b8491aab06161461$export$440fc5b87687d980 = (0, $iJq0l.createStateHook)($b8491aab06161461$var$Store, {
    selector: $b8491aab06161461$var$getFlatListIssueIdsSelector
});
const $b8491aab06161461$var$getFlatListChildIssueIdsSelector = (state)=>state.flatListChildIssueIds;
const $b8491aab06161461$export$674a7e9a564d6c04 = (0, $iJq0l.createStateHook)($b8491aab06161461$var$Store, {
    selector: $b8491aab06161461$var$getFlatListChildIssueIdsSelector
});

});

parcelRegister("7EogO", function(module, exports) {
$parcel$export(module.exports, "useSetJql", () => $2eab1b44c4fd2709$export$9d7223d88c9d8536);

var $aYIvf = parcelRequire("aYIvf");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $K4WWF = parcelRequire("K4WWF");
const $2eab1b44c4fd2709$export$9d7223d88c9d8536 = ()=>{
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $aYIvf.default));
    return (0, $eJOHy.useCallback)(({ jql: jql, viewARI: viewARI })=>{
        const handleError = (error)=>{
            (0, $9pTd3.fireErrorAnalytics)({
                sendToPrivacyUnsafeSplunk: true,
                error: error,
                meta: {
                    id: 'setJqlMutation',
                    packageName: 'jiraIssueNavigator',
                    teamName: 'empanada'
                }
            });
        };
        commit({
            variables: {
                input: {
                    jql: jql,
                    viewId: viewARI
                }
            },
            onError: handleError,
            onCompleted (response) {
                if (response.jira_setIssueSearchJql?.success !== true) {
                    const error = response.jira_setIssueSearchJql?.errors?.[0];
                    const statusCode = error?.extensions?.statusCode ?? 0;
                    const isClientError = statusCode >= 400 && statusCode < 500;
                    /*
           * The mutation will return a validation error if the provided JQL string is not syntactically correct.
           * This is already handled by the filter component, so we don't need to handle it here.
           */ if (!isClientError) {
                        const mutationError = new (0, $K4WWF.MutationErrorCollection)(response.jira_setIssueSearchJql?.errors);
                        handleError(mutationError);
                    }
                }
            }
        });
    }, [
        commit
    ]);
};

});
parcelRegister("aYIvf", function(module, exports) {
$parcel$export(module.exports, "default", () => $affc64bde34e5c6f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cce1804fdef0b42eb3a31531aed52f55>>
 * @relayHash 050c4c1a18ae3e6423b1092f20b0a143
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9740d3bdc782b2bd679b29fe3690aa38460f5633d020ea9c91f52f6308c116a5
const $affc64bde34e5c6f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "setJqlMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraSetIssueSearchJqlPayload",
                    "kind": "LinkedField",
                    "name": "jira_setIssueSearchJql",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "setJqlMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraSetIssueSearchJqlPayload",
                    "kind": "LinkedField",
                    "name": "jira_setIssueSearchJql",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9740d3bdc782b2bd679b29fe3690aa38460f5633d020ea9c91f52f6308c116a5",
            "metadata": {},
            "name": "setJqlMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$affc64bde34e5c6f$var$node.hash = "3c85daac11a42bc3abe49021df8b3785";
var $affc64bde34e5c6f$export$2e2bcd8739ae039 = $affc64bde34e5c6f$var$node;

});

parcelRegister("K4WWF", function(module, exports) {
$parcel$export(module.exports, "MutationErrorCollection", () => $2cd8a73f7b8deda9$export$d22c6cedeb9f13e);

var $emHXA = parcelRequire("emHXA");
class $2cd8a73f7b8deda9$export$d22c6cedeb9f13e extends Error {
    constructor(errors){
        const errorMessage = (0, $emHXA.combineErrorMessages)(errors) ?? 'Unknown error';
        super(errorMessage);
        this.message = errorMessage;
    }
}

});
parcelRegister("emHXA", function(module, exports) {
$parcel$export(module.exports, "combineErrorMessages", () => $fbde4ab0161d07a6$export$8a753d214a739485);
/**
 * Formats a mutation error payload into a readable error message string.
 *
 * @param error - The mutation error payload which can be of type `MutationErrorPayload`, `null`, or `undefined`.
 * @returns A formatted error message string.
 *
 * The formatted message includes:
 * - The `__typename` from the `extensions` property, if available, enclosed in parentheses.
 * - The `errorType` from the `extensions` property, if available, enclosed in square brackets.
 * - The `statusCode` from the `extensions` property, if available, prefixed with "HTTP".
 * - The main error message.
 *
 * The parts are concatenated with spaces and any `null` or `undefined` values are filtered out.
 */ function $fbde4ab0161d07a6$var$formatErrorMessage(error) {
    const { message: message, extensions: extensions } = error ?? {};
    return [
        extensions?.__typename && `(${extensions.__typename})`,
        extensions?.errorType && `[${extensions.errorType}]`,
        extensions?.statusCode && `HTTP ${extensions.statusCode}:`,
        message
    ].filter(Boolean).join(' ').trim();
}
function $fbde4ab0161d07a6$export$8a753d214a739485(errors) {
    return errors?.map($fbde4ab0161d07a6$var$formatErrorMessage)?.filter(Boolean)?.join('; ') || undefined;
}

});



parcelRegister("6Al27", function(module, exports) {
$parcel$export(module.exports, "IFCEntryPointContextProvider", () => $c662cbd253f72d54$export$b1528524caf51b8b);
$parcel$export(module.exports, "useIFCEntryPointContext", () => $c662cbd253f72d54$export$caffdf0d268fddd7);

var $eJOHy = parcelRequire("eJOHy");

var $8slLo = parcelRequire("8slLo");

var $iWvkh = parcelRequire("iWvkh");

var $hwgUG = parcelRequire("hwgUG");
const $c662cbd253f72d54$export$ed5ff4845085aae5 = (0, $8slLo.createUseEntryPointContext)();
const $c662cbd253f72d54$var$entryPointParams = {};
const $c662cbd253f72d54$export$b1528524caf51b8b = ({ children: children })=>{
    const entryPointResult = (0, $iWvkh.useEntryPoint)((0, $hwgUG.ifcEntryPoint), $c662cbd253f72d54$var$entryPointParams);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c662cbd253f72d54$export$ed5ff4845085aae5.Provider, {
        value: entryPointResult
    }, children);
};
const $c662cbd253f72d54$export$caffdf0d268fddd7 = ()=>{
    return (0, $eJOHy.useContext)($c662cbd253f72d54$export$ed5ff4845085aae5);
};

});
parcelRegister("hwgUG", function(module, exports) {
$parcel$export(module.exports, "ifcEntryPoint", () => $00a87beeb64e5a63$export$26521842160defa7);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $00a87beeb64e5a63$export$26521842160defa7 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("4nhh5")), {
        moduleId: "6c18a40d",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4nhh5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("lyxWA")
]).then(()=>parcelRequire('dEmav'));

});



parcelRegister("b4JYg", function(module, exports) {
$parcel$export(module.exports, "useHasListMigrationDataForProject", () => $c66ae4a12e06b0ed$export$3579e67fe52b70ed);

var $eJOHy = parcelRequire("eJOHy");

var $3NnH8 = parcelRequire("3NnH8");
const $c66ae4a12e06b0ed$export$3579e67fe52b70ed = (projectId)=>{
    return (0, $eJOHy.useMemo)(()=>projectId ? (0, $3NnH8.hasMigrationDataForProject)(projectId) : false, [
        projectId
    ]);
};

});
parcelRegister("3NnH8", function(module, exports) {
$parcel$export(module.exports, "getMigrationDataForProject", () => $d2a6b2bca13710cf$export$720e45948f360582);
$parcel$export(module.exports, "getPaidMigrationDataForProject", () => $d2a6b2bca13710cf$export$14d40d05024d1482);
$parcel$export(module.exports, "hasMigrationDataForProject", () => $d2a6b2bca13710cf$export$a6ceb96238f0b33);
$parcel$export(module.exports, "getJqlFromMigrationData", () => $d2a6b2bca13710cf$export$698a96f23aa65f93);
$parcel$export(module.exports, "getPaidJqlFromMigrationData", () => $d2a6b2bca13710cf$export$856a85ad96c21d44);
$parcel$export(module.exports, "getConfiguredProjectIdsFromLocalStorage", () => $d2a6b2bca13710cf$export$882bc5ee5a160efd);

var $9pTd3 = parcelRequire("9pTd3");

var $gnzG6 = parcelRequire("gnzG6");

var $iRahl = parcelRequire("iRahl");
const $d2a6b2bca13710cf$var$DEFAULT_LIST_VIEW_ORDER_FIELD = 'rank';
const $d2a6b2bca13710cf$var$DEFAULT_LIST_VIEW_SORT_DIRECTION = (0, $iRahl.sortDirections).ASC;
const $d2a6b2bca13710cf$var$PROJECT_ID_REGEX = /^__storejs_jwm-view-preferences_(\d+)_list_(fieldsDetail|filter|groupBy)$/;
const $d2a6b2bca13710cf$var$parsePreferenceValue = (value)=>{
    if (typeof value === 'string') return value;
    if (value === null || value === undefined) return null;
    try {
        return JSON.stringify(value);
    } catch  {
        return String(value);
    }
};
const $d2a6b2bca13710cf$var$parseSortingPreferenceValue = (value)=>{
    if (typeof value !== 'object' || value === null) return null;
    return value ?? null;
};
const $d2a6b2bca13710cf$export$720e45948f360582 = (projectId)=>{
    try {
        const groupByValue = (0, $gnzG6.getPreference)(projectId, 'list', 'groupBy');
        const filterValue = (0, $gnzG6.getPreference)(projectId, 'list', 'filter');
        const sortingValue = (0, $gnzG6.getPreference)(projectId, 'list', 'sorting');
        return {
            projectId: projectId,
            groupBy: $d2a6b2bca13710cf$var$parsePreferenceValue(groupByValue),
            filter: $d2a6b2bca13710cf$var$parsePreferenceValue(filterValue),
            sorting: $d2a6b2bca13710cf$var$parseSortingPreferenceValue(sortingValue)
        };
    } catch (error) {
        return {
            projectId: projectId,
            groupBy: null,
            filter: null,
            sorting: null
        };
    }
};
const $d2a6b2bca13710cf$export$14d40d05024d1482 = (projectId)=>{
    try {
        const groupByValue = (0, $gnzG6.getPreference)(projectId, 'list', 'groupBy');
        const filterValue = (0, $gnzG6.getPreference)(projectId, 'list', 'filter');
        const sortingValue = (0, $gnzG6.getPreference)(projectId, 'list', 'sorting');
        const fieldsDetailValue = (0, $gnzG6.getPreference)(projectId, 'list', 'fieldsDetail');
        return {
            projectId: projectId,
            groupBy: groupByValue,
            filter: filterValue,
            sorting: sortingValue,
            fieldsDetail: fieldsDetailValue
        };
    } catch (error) {
        return {
            projectId: projectId,
            groupBy: null,
            filter: null,
            sorting: null,
            fieldsDetail: null
        };
    }
};
const $d2a6b2bca13710cf$export$a6ceb96238f0b33 = (projectId)=>{
    const migrationData = $d2a6b2bca13710cf$export$720e45948f360582(projectId);
    return migrationData.groupBy !== null || migrationData.filter !== null || migrationData.sorting !== null;
};
const $d2a6b2bca13710cf$export$98f64a342a585b79 = (projectKey, filter)=>`project = "${projectKey}" AND ${filter} ORDER BY ${$d2a6b2bca13710cf$var$DEFAULT_LIST_VIEW_ORDER_FIELD} ${$d2a6b2bca13710cf$var$DEFAULT_LIST_VIEW_SORT_DIRECTION}`;
const $d2a6b2bca13710cf$export$1bc17a83b56b1c64 = (projectKey)=>`project = "${projectKey}" ORDER BY ${$d2a6b2bca13710cf$var$DEFAULT_LIST_VIEW_ORDER_FIELD} ${$d2a6b2bca13710cf$var$DEFAULT_LIST_VIEW_SORT_DIRECTION}`;
const $d2a6b2bca13710cf$export$c6992b339074c608 = (projectKey, sorting)=>`project = "${projectKey}" ORDER BY ${sorting.sortBy} ${sorting.direction}, ${$d2a6b2bca13710cf$var$DEFAULT_LIST_VIEW_ORDER_FIELD} ${sorting.direction}`;
const $d2a6b2bca13710cf$export$58881907c2531bb2 = (projectKey, filter, sorting)=>`project = "${projectKey}" AND ${filter} ORDER BY ${sorting.sortBy} ${sorting.direction}, ${$d2a6b2bca13710cf$var$DEFAULT_LIST_VIEW_ORDER_FIELD} ${sorting.direction}`;
const $d2a6b2bca13710cf$export$698a96f23aa65f93 = (migrationData, projectKey)=>{
    const { filter: filter, sorting: sorting } = migrationData;
    if (filter && sorting) return $d2a6b2bca13710cf$export$58881907c2531bb2(projectKey, filter, sorting);
    if (filter) return $d2a6b2bca13710cf$export$98f64a342a585b79(projectKey, filter);
    if (sorting) return $d2a6b2bca13710cf$export$c6992b339074c608(projectKey, sorting);
    return $d2a6b2bca13710cf$export$1bc17a83b56b1c64(projectKey);
};
// ----------------------- Paid Changboarding Utils -----------------------
// Following utiliies construct JQL without project scoping; Project scoping will be completed by the BE.
const $d2a6b2bca13710cf$var$getPaidJqlWithFilterAndSorting = (filter, sorting)=>`AND ${filter} ORDER BY ${sorting.sortBy} ${sorting.direction}, ${$d2a6b2bca13710cf$var$DEFAULT_LIST_VIEW_ORDER_FIELD} ${sorting.direction}`;
const $d2a6b2bca13710cf$var$getPaidJqlWithFilter = (filter)=>`AND ${filter} ORDER BY ${$d2a6b2bca13710cf$var$DEFAULT_LIST_VIEW_ORDER_FIELD} ${$d2a6b2bca13710cf$var$DEFAULT_LIST_VIEW_SORT_DIRECTION}`;
const $d2a6b2bca13710cf$var$getPaidJqlWithSorting = (sorting)=>`ORDER BY ${sorting.sortBy} ${sorting.direction}, ${$d2a6b2bca13710cf$var$DEFAULT_LIST_VIEW_ORDER_FIELD} ${sorting.direction}`;
const $d2a6b2bca13710cf$var$getDefaultPaidJql = ()=>`ORDER BY ${$d2a6b2bca13710cf$var$DEFAULT_LIST_VIEW_ORDER_FIELD} ${$d2a6b2bca13710cf$var$DEFAULT_LIST_VIEW_SORT_DIRECTION}`;
const $d2a6b2bca13710cf$export$856a85ad96c21d44 = (migrationData)=>{
    const { filter: filter, sorting: sorting } = migrationData;
    if (filter && sorting) return $d2a6b2bca13710cf$var$getPaidJqlWithFilterAndSorting(filter, sorting);
    if (filter) return $d2a6b2bca13710cf$var$getPaidJqlWithFilter(filter);
    if (sorting) return $d2a6b2bca13710cf$var$getPaidJqlWithSorting(sorting);
    return $d2a6b2bca13710cf$var$getDefaultPaidJql();
};
const $d2a6b2bca13710cf$export$882bc5ee5a160efd = ()=>{
    try {
        return Array.from(new Set(Object.keys(localStorage).map((key)=>key.match($d2a6b2bca13710cf$var$PROJECT_ID_REGEX)?.[1]).filter((id)=>id !== undefined)));
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'paidListNINConfigMigration',
                packageName: (0, $iRahl.PACKAGE_NAME),
                teamName: (0, $iRahl.TEAM_NAME)
            },
            error: error instanceof Error ? error : new Error('Failed to get configured project ids from localStorage'),
            sendToPrivacyUnsafeSplunk: true
        });
        return [];
    }
};

});
parcelRegister("gnzG6", function(module, exports) {
$parcel$export(module.exports, "setPreference", () => $067cc0be98e222a8$export$c6483f3cdc3e51e1);
$parcel$export(module.exports, "getPreference", () => $067cc0be98e222a8$export$5fa261395d19a143);

var $3hRxq = parcelRequire("3hRxq");
const $067cc0be98e222a8$var$store = (0, $3hRxq.createLocalStorageProvider)('jwm-view-preferences');
const $067cc0be98e222a8$var$buildPreferenceKey = (entityId, viewId, preferenceId)=>`${entityId}_${viewId}_${preferenceId}`;
const $067cc0be98e222a8$export$c6483f3cdc3e51e1 = (entityId, viewId, preferenceId, value)=>{
    const key = $067cc0be98e222a8$var$buildPreferenceKey(entityId, viewId, preferenceId);
    $067cc0be98e222a8$var$store.set(key, value);
};
const $067cc0be98e222a8$export$5fa261395d19a143 = (entityId, viewId, preferenceId)=>{
    const key = $067cc0be98e222a8$var$buildPreferenceKey(entityId, viewId, preferenceId);
    return $067cc0be98e222a8$var$store.get(key);
};

});



parcelRegister("dOpAp", function(module, exports) {
$parcel$export(module.exports, "BulkOperationsWrapper", () => $b6b91bb1d8110a40$export$88a2a475d15f0a71);

var $ffUDv = parcelRequire("ffUDv");

var $jVCfj = parcelRequire("jVCfj");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $gkScf = parcelRequire("gkScf");

var $i8Pje = parcelRequire("i8Pje");

var $3TtKq = parcelRequire("3TtKq");

var $6d9QY = parcelRequire("6d9QY");

var $cxKOj = parcelRequire("cxKOj");

var $lvpZz = parcelRequire("lvpZz");

var $HiS1C = parcelRequire("HiS1C");

var $fwKw5 = parcelRequire("fwKw5");
const $b6b91bb1d8110a40$var$EMPTY_ARRAY = [];
const $b6b91bb1d8110a40$var$LoadBulkOpsCore = ({ bulkOpsCoreEntryPointReference: bulkOpsCoreEntryPointReference, fragmentRef: fragmentRef, jiraViewFragment: jiraViewFragment })=>{
    const selectedIssues = (0, $3TtKq.useIssueTableSelectedIssues)();
    const excludedIssueIds = (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3TtKq.useExcludedIssueIds)() : undefined;
    const areAllIssuesSelected = (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3TtKq.useIsSelectingAll)() : undefined;
    const { reset: reset, insertSelectedIssueIds: insertSelectedIssueIds, selectAllIssues: selectAllIssues } = (0, $3TtKq.useIssueTableSelectedIssuesActions)();
    const view = (0, $HiS1C.useSelectedView)();
    const { jql: jql } = (0, $fwKw5.useActiveJql)();
    const filterJql = (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $fwKw5.useResolvedJql)() : undefined;
    const previousJql = (0, $6d9QY.usePrevious)(jql);
    const childIssueIds = (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $lvpZz.useFlatListChildIssueIds)() : $b6b91bb1d8110a40$var$EMPTY_ARRAY;
    const data = (0, $j4oe4.useFragment)((0, $jVCfj.default), fragmentRef);
    const viewData = (0, $j4oe4.useFragment)((0, $ffUDv.default), jiraViewFragment);
    let hideDone;
    let isHierarchyEnabled;
    let canEnableHierarchy;
    if ((0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false)) {
        hideDone = viewData?.viewSettings?.hideDone;
        isHierarchyEnabled = viewData?.viewSettings?.isHierarchyEnabled;
        canEnableHierarchy = viewData?.viewSettings?.canEnableHierarchy;
        const groupedByFieldId = viewData?.viewSettings?.groupByConfig?.groupByField?.fieldId || null;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const isInitialized = (0, $eJOHy.useRef)(false);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const previousGroupedByFieldId = (0, $6d9QY.usePrevious)(groupedByFieldId);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const previousHideDone = (0, $6d9QY.usePrevious)(hideDone);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const previousIsHierarchyEnabled = (0, $6d9QY.usePrevious)(isHierarchyEnabled);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eJOHy.useEffect)(()=>{
            if (!isInitialized.current) {
                isInitialized.current = true;
                return;
            }
            const groupByFieldIdChanged = previousGroupedByFieldId !== groupedByFieldId;
            const hideDoneChanged = previousHideDone !== hideDone;
            const isHierarchyEnabledChanged = previousIsHierarchyEnabled !== isHierarchyEnabled;
            if (groupByFieldIdChanged || hideDoneChanged || isHierarchyEnabledChanged) reset();
        }, [
            reset,
            groupedByFieldId,
            previousGroupedByFieldId,
            previousHideDone,
            hideDone,
            previousIsHierarchyEnabled,
            isHierarchyEnabled
        ]);
    }
    const totalIssueSearchResultCount = data?.totalIssueSearchResultCount ?? 0;
    const selectAllTotalSelected = (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3TtKq.useIssueTableSelectAllTotalSelected)(totalIssueSearchResultCount) : undefined;
    (0, $eJOHy.useEffect)(()=>{
        if (jql !== previousJql && previousJql !== undefined) reset();
    }, [
        jql,
        previousJql,
        reset
    ]);
    const issuesFlatListIds = (0, $lvpZz.useFlatListIssueIds)();
    // we don't need to read issueIds for grouping from the query because we already have them in the flat list
    const issueIds = (0, $eJOHy.useMemo)(()=>{
        return {
            strings: issuesFlatListIds,
            numbers: issuesFlatListIds.map((issueId)=>Number(issueId))
        };
    }, [
        issuesFlatListIds
    ]);
    const onSelectAll = (0, $eJOHy.useCallback)(()=>{
        selectAllIssues({
            childIds: childIssueIds,
            visibleIds: issueIds.strings,
            count: totalIssueSearchResultCount
        });
    }, [
        issueIds.strings,
        childIssueIds,
        selectAllIssues,
        totalIssueSearchResultCount
    ]);
    const onSelectAllOld = (0, $eJOHy.useCallback)(()=>{
        insertSelectedIssueIds(issueIds.strings);
    }, [
        issueIds.strings,
        insertSelectedIssueIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8Pje.AsyncBulkOpsCoreFull), {
        bulkOpsCoreEntryPointReference: bulkOpsCoreEntryPointReference,
        selectedIssueIds: selectedIssues.map((issue)=>Number(issue)),
        onClearAll: reset,
        onSelectAll: (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? onSelectAll : onSelectAllOld,
        selectableIssueIds: issueIds.numbers,
        onClearAllVisible: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        shouldHideToolbar: view === 'detail',
        ...(0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) && {
            shouldSelectAllIssues: areAllIssuesSelected,
            selectAllTotalSelected: selectAllTotalSelected,
            activeJql: jql ?? filterJql,
            hideDone: hideDone,
            isHierarchyEnabled: canEnableHierarchy && isHierarchyEnabled,
            excludedIssueIds: excludedIssueIds,
            totalIssueSearchResultCount: totalIssueSearchResultCount
        }
    });
};
const $b6b91bb1d8110a40$export$88a2a475d15f0a71 = ({ children: children, bulkOpsCoreEntryPointReference: bulkOpsCoreEntryPointReference, fragmentRef: fragmentRef, jiraViewFragment: jiraViewFragment })=>{
    const isBulkOpsInProgress = (0, $gkScf.useIsBulkOperationsInProgress)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: $b6b91bb1d8110a40$var$wrapperStyles,
        direction: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $b6b91bb1d8110a40$var$childContainerStyles,
            isBulkOpsInProgress && $b6b91bb1d8110a40$var$childContainerDisabledStyles
        ]
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b6b91bb1d8110a40$var$LoadBulkOpsCore, {
        fragmentRef: fragmentRef,
        jiraViewFragment: jiraViewFragment,
        bulkOpsCoreEntryPointReference: bulkOpsCoreEntryPointReference
    }));
};
const $b6b91bb1d8110a40$var$wrapperStyles = (0, $1DXK0.xcss)({
    height: '100%',
    overflowY: 'auto'
});
const $b6b91bb1d8110a40$var$childContainerStyles = (0, $1DXK0.xcss)({
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    overflowY: 'auto'
});
const $b6b91bb1d8110a40$var$childContainerDisabledStyles = (0, $1DXK0.xcss)({
    opacity: 0.5,
    pointerEvents: 'none'
});

});
parcelRegister("ffUDv", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5eaebb553af02a5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b96efcaef4476d84edd6bda4ae90585a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d5eaebb553af02a5$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "settings"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "BulkOperationsWrapper_ViewSettings",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "groupBy",
                    "variableName": "groupBy"
                },
                {
                    "kind": "Variable",
                    "name": "issueSearchInput",
                    "variableName": "issueSearchInput"
                },
                {
                    "kind": "Variable",
                    "name": "settings",
                    "variableName": "settings"
                },
                {
                    "kind": "Variable",
                    "name": "staticViewInput",
                    "variableName": "staticViewInput"
                }
            ],
            "concreteType": "JiraIssueSearchViewConfigSettings",
            "kind": "LinkedField",
            "name": "viewSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isHierarchyEnabled"
                },
                {
                    "kind": "ScalarField",
                    "name": "canEnableHierarchy"
                },
                {
                    "kind": "ScalarField",
                    "name": "hideDone"
                },
                {
                    "concreteType": "JiraSpreadsheetGroupByConfig",
                    "kind": "LinkedField",
                    "name": "groupByConfig",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraField",
                            "kind": "LinkedField",
                            "name": "groupByField",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fieldId"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetView",
    "abstractKey": "__isJiraSpreadsheetView"
};
$d5eaebb553af02a5$var$node.hash = "6dfeb4e8f579b8a450e56aed8e8280ae";
var $d5eaebb553af02a5$export$2e2bcd8739ae039 = $d5eaebb553af02a5$var$node;

});

parcelRegister("jVCfj", function(module, exports) {
$parcel$export(module.exports, "default", () => $21fac3c7685c9e5a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0c45560e35a412dd7fd518b3d064b669>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $21fac3c7685c9e5a$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "BulkOperationsWrapper",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "totalIssueSearchResultCount"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$21fac3c7685c9e5a$var$node.hash = "6b27d39e5a7bf796e3e7def05054ed18";
var $21fac3c7685c9e5a$export$2e2bcd8739ae039 = $21fac3c7685c9e5a$var$node;

});

parcelRegister("gkScf", function(module, exports) {
$parcel$export(module.exports, "useBulkOperations", () => $1ef65add752592bf$export$940587be18a93fc4);
$parcel$export(module.exports, "useBulkOperationsActions", () => $1ef65add752592bf$export$355499dfde532d1a);
$parcel$export(module.exports, "useIsBulkOperationsInProgress", () => $1ef65add752592bf$export$760458c2204457a1);
$parcel$export(module.exports, "useShouldRenderSpotlight", () => $1ef65add752592bf$export$4a165cf2377f023a);
$parcel$export(module.exports, "useBulkTransitionsStage", () => $1ef65add752592bf$export$b3afff39a0c663ad);
$parcel$export(module.exports, "useBulkOperationInForm", () => $1ef65add752592bf$export$6794339387d6d562);
$parcel$export(module.exports, "useBulkOperationType", () => $1ef65add752592bf$export$4289f82da677ffac);
$parcel$export(module.exports, "useCancelDialogTrigger", () => $1ef65add752592bf$export$babceeeb2408337b);
$parcel$export(module.exports, "useCurrentView", () => $1ef65add752592bf$export$8ce7af7b2f8c770);

var $kRgKj = parcelRequire("kRgKj");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $1oPJB = parcelRequire("1oPJB");

var $d9gBN = parcelRequire("d9gBN");
const $1ef65add752592bf$export$d4c72bab9d6cc13a = {
    operationType: null,
    isSidebarOpen: false,
    cancelDialogTrigger: undefined,
    currentView: 'edit',
    firstFieldId: undefined,
    operationStartTime: null,
    isInProgress: false
};
const $1ef65add752592bf$var$actions = {
    setSummaryView: ()=>({ setState: setState })=>{
            setState({
                currentView: 'summary'
            });
        },
    setFirstFieldId: (firstFieldId)=>({ setState: setState })=>{
            setState({
                firstFieldId: firstFieldId
            });
        },
    setEditView: ()=>({ setState: setState })=>{
            setState({
                currentView: 'edit'
            });
        },
    setCancelDialogTrigger: (newTrigger = 'user-triggered')=>({ setState: setState, getState: getState })=>{
            const { cancelDialogTrigger: currentTrigger } = getState();
            /* Sometimes both events can be fired (route change & onclick) in one loop
					We need to prioritise route-change event  */ if (currentTrigger === 'route-change' && newTrigger === 'user-triggered') return;
            setState({
                cancelDialogTrigger: newTrigger
            });
        },
    clearDialogTrigger: ()=>({ setState: setState })=>{
            setState({
                cancelDialogTrigger: undefined
            });
        },
    startEdit: (args)=>({ setState: setState })=>{
            const { shouldRenderSpotlight: shouldRenderSpotlight } = args || {
                shouldRenderSpotlight: false
            };
            setState({
                operationType: {
                    type: (0, $d9gBN.BulkOperationsTypes).BULK_EDIT
                },
                shouldRenderSpotlight: shouldRenderSpotlight,
                isSidebarOpen: true,
                operationStartTime: performance.now(),
                isInProgress: true
            });
        },
    loadTransitions: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $d9gBN.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $d9gBN.BulkTransitionsStage).LOAD_BULK_TRANSITIONS
                },
                isSidebarOpen: false,
                isInProgress: true
            });
        },
    startQuickTransitions: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $d9gBN.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $d9gBN.BulkTransitionsStage).START_QUICK_TRANSITIONS
                },
                isSidebarOpen: false,
                operationStartTime: performance.now(),
                isInProgress: true
            });
        },
    startSidebarTransition: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $d9gBN.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $d9gBN.BulkTransitionsStage).START_SIDEBAR_TRANSITION
                },
                isSidebarOpen: true,
                operationStartTime: performance.now(),
                isInProgress: true
            });
        },
    startTransitionScreen: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $d9gBN.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $d9gBN.BulkTransitionsStage).START_TRANSITION_SCREEN
                },
                isSidebarOpen: true,
                isInProgress: true
            });
        },
    dismissBulkOperation: ({ createAnalyticsEvent: createAnalyticsEvent, dismissType: dismissType })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const analyticsEvent = createAnalyticsEvent({});
            const operationEndTime = performance.now();
            const operationTimeTaken = currentState.operationStartTime ? operationEndTime - currentState.operationStartTime : null;
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'dismissed bulkOperations', {
                dismissType: dismissType,
                operationTimeTaken: operationTimeTaken
            });
            (0, $1oPJB.extraFormDataService).clear();
            // we want the operation type to persist after a submit
            // so that is still available for the success flag analytics
            // so we are only toggling isInProgress here to make the UI interactable again
            if ((0, $d9gBN.BulkOperationsDismissSubmit).includes(dismissType)) setState({
                ...currentState,
                isInProgress: false
            });
            else setState($1ef65add752592bf$export$d4c72bab9d6cc13a);
        },
    setBulkOperation: (bulkOperationType)=>({ setState: setState })=>{
            setState({
                isSidebarOpen: false,
                operationType: {
                    type: bulkOperationType
                },
                operationStartTime: performance.now(),
                isInProgress: true
            });
        },
    resetState: ()=>({ setState: setState })=>{
            setState($1ef65add752592bf$export$d4c72bab9d6cc13a);
        }
};
const $1ef65add752592bf$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    initialState: $1ef65add752592bf$export$d4c72bab9d6cc13a,
    actions: $1ef65add752592bf$var$actions,
    name: 'bulk-operations-store'
});
const $1ef65add752592bf$export$940587be18a93fc4 = (0, $iJq0l.createHook)($1ef65add752592bf$export$6f57813fe9f31bf9);
const $1ef65add752592bf$export$355499dfde532d1a = (0, $iJq0l.createActionsHook)($1ef65add752592bf$export$6f57813fe9f31bf9);
const $1ef65add752592bf$export$760458c2204457a1 = (0, $iJq0l.createStateHook)($1ef65add752592bf$export$6f57813fe9f31bf9, {
    selector: (state)=>state.isInProgress
});
const $1ef65add752592bf$export$4a165cf2377f023a = (0, $iJq0l.createStateHook)($1ef65add752592bf$export$6f57813fe9f31bf9, {
    selector: (state)=>!!state.shouldRenderSpotlight
});
const $1ef65add752592bf$export$b3afff39a0c663ad = (0, $iJq0l.createStateHook)($1ef65add752592bf$export$6f57813fe9f31bf9, {
    selector: (state)=>{
        const { operationType: operationType } = state;
        if (operationType?.type === (0, $d9gBN.BulkOperationsTypes).BULK_TRANSITION) return operationType.stage;
        return null;
    }
});
const $1ef65add752592bf$export$6794339387d6d562 = (0, $iJq0l.createStateHook)($1ef65add752592bf$export$6f57813fe9f31bf9, {
    selector: (state)=>{
        if (state.isSidebarOpen && state.isInProgress) return state.operationType.type;
        return null;
    }
});
const $1ef65add752592bf$export$4289f82da677ffac = (0, $iJq0l.createStateHook)($1ef65add752592bf$export$6f57813fe9f31bf9, {
    selector: (state)=>state.operationType
});
const $1ef65add752592bf$export$babceeeb2408337b = (0, $iJq0l.createStateHook)($1ef65add752592bf$export$6f57813fe9f31bf9, {
    selector: (state)=>state.cancelDialogTrigger
});
const $1ef65add752592bf$export$8ce7af7b2f8c770 = (0, $iJq0l.createStateHook)($1ef65add752592bf$export$6f57813fe9f31bf9, {
    selector: (state)=>state.currentView
});

});
parcelRegister("1oPJB", function(module, exports) {
$parcel$export(module.exports, "extraFormDataService", () => $a326de00f3659dc2$export$3cd9d97d155e8e66);
class $a326de00f3659dc2$var$ExtraFormData {
    clear() {
        this.data = {};
    }
    addByKey(key, value) {
        this.data[key] = value;
    }
    getByKey(key) {
        return this.data[key];
    }
    getAll() {
        return this.data;
    }
    constructor(){
        this.data = {};
    }
}
const $a326de00f3659dc2$var$extraFormData = new $a326de00f3659dc2$var$ExtraFormData();
const $a326de00f3659dc2$var$addDataByKey = (key, value)=>{
    $a326de00f3659dc2$var$extraFormData.addByKey(key, value);
};
const $a326de00f3659dc2$var$clear = ()=>{
    $a326de00f3659dc2$var$extraFormData.clear();
};
const $a326de00f3659dc2$var$getDataByKey = (key)=>$a326de00f3659dc2$var$extraFormData.getByKey(key);
const $a326de00f3659dc2$var$getData = ()=>$a326de00f3659dc2$var$extraFormData.getAll();
const $a326de00f3659dc2$export$3cd9d97d155e8e66 = {
    addDataByKey: $a326de00f3659dc2$var$addDataByKey,
    getDataByKey: $a326de00f3659dc2$var$getDataByKey,
    clear: $a326de00f3659dc2$var$clear,
    getData: $a326de00f3659dc2$var$getData
};

});

parcelRegister("d9gBN", function(module, exports) {
$parcel$export(module.exports, "BulkOperationsTypes", () => $16677cc8a1f3f684$export$7ec2782f56bb6e02);
$parcel$export(module.exports, "BulkTransitionsStage", () => $16677cc8a1f3f684$export$a6f51fa6c8971716);
$parcel$export(module.exports, "BulkOperationsDismissSubmit", () => $16677cc8a1f3f684$export$b3f88f42a8b7de67);
const $16677cc8a1f3f684$export$7ec2782f56bb6e02 = {
    BULK_EDIT: 'BULK_EDIT',
    BULK_TRANSITION: 'BULK_TRANSITION',
    BULK_DELETE: 'BULK_DELETE',
    BULK_WATCH: 'BULK_WATCH',
    BULK_UNWATCH: 'BULK_UNWATCH'
};
const $16677cc8a1f3f684$export$a6f51fa6c8971716 = {
    LOAD_BULK_TRANSITIONS: 'LOAD_BULK_TRANSITIONS',
    START_QUICK_TRANSITIONS: 'START_QUICK_TRANSITIONS',
    START_SIDEBAR_TRANSITION: 'START_SIDEBAR_TRANSITION',
    START_TRANSITION_SCREEN: 'START_TRANSITION_SCREEN'
};
const $16677cc8a1f3f684$export$1550a2cc6d56ae33 = {
    // ERRORS //
    ERROR_BULK_EDIT: 'ERROR_BULK_EDIT',
    ERROR_BULK_TRANSITION: 'ERROR_BULK_TRANSITION',
    ERROR_BULK_TRANSITION_SCREEN_MOUNT: 'ERROR_BULK_TRANSITION_SCREEN_MOUNT',
    ERROR_BULK_DELETE: 'ERROR_BULK_DELETE',
    // BULK EDIT //
    EDIT_FORM_PRISTINE_CANCEL: 'EDIT_FORM_PRISTINE_CANCEL',
    EDIT_FORM_DIRTY_CANCEL: 'EDIT_FORM_DIRTY_CANCEL',
    EDIT_FORM_SUMMARY_CANCEL: 'EDIT_FORM_SUMMARY_CANCEL',
    EDIT_ATTEMPT_SUBMIT: 'EDIT_ATTEMPT_SUBMIT',
    // TRANSITION DIALOG //
    TRANSITION_DIALOG_PRISTINE_CANCEL: 'TRANSITION_DIALOG_PRISTINE_CANCEL',
    TRANSITION_DIALOG_DIRTY_CANCEL: 'TRANSITION_DIALOG_DIRTY_CANCEL',
    TRANSITION_DIALOG_CANT_CONTINUE_WARNING: 'TRANSITION_DIALOG_CANT_CONTINUE_WARNING',
    TRANSITION_DIALOG_ATTEMPT_SUBMIT: 'TRANSITION_DIALOG_ATTEMPT_SUBMIT',
    // TRANSITION FORM //
    TRANSITION_FORM_PRISTINE_CANCEL: 'TRANSITION_FORM_PRISTINE_CANCEL',
    TRANSITION_FORM_DIRTY_CANCEL: 'TRANSITION_FORM_DIRTY_CANCEL',
    TRANSITION_FORM_ATTEMPT_SUBMIT: 'TRANSITION_FORM_ATTEMPT_SUBMIT',
    // TRANSITION WITH SCREEN //
    TRANSITION_WITH_SCREEN_LEGACY_LINK: 'TRANSITION_WITH_SCREEN_LEGACY_LINK',
    TRANSITION_WITH_SCREEN_SUMMARY_CANCEL: 'TRANSITION_WITH_SCREEN_SUMMARY_CANCEL',
    TRANSITION_WITH_SCREEN_CANCEL: 'TRANSITION_WITH_SCREEN_CANCEL',
    TRANSITION_WITH_SCREEN_CANCEL_REQUIRED_ERROR: 'TRANSITION_WITH_SCREEN_CANCEL_REQUIRED_ERROR',
    // BULK DELETE //
    DELETE_ATTEMPT_SUBMIT: 'DELETE_ATTEMPT_SUBMIT',
    DELETE_ATTEMPT_CANCEL: 'DELETE_CANCEL',
    // BULK WATCH //
    WATCH_ATTEMPT_SUBMIT: 'WATCH_ATTEMPT_SUBMIT',
    // BULK UNWATCH //
    UNWATCH_ATTEMPT_SUBMIT: 'UNWATCH_ATTEMPT_SUBMIT',
    // OTHER //
    NAVIGATION: 'NAVIGATION',
    DESELECT_ALL_ISSUES: 'DESELECT_ALL_ISSUES',
    ERROR_SELECT_ALL_QUERY: 'ERROR_SELECT_ALL_QUERY'
};
const $16677cc8a1f3f684$export$b3f88f42a8b7de67 = [
    'EDIT_ATTEMPT_SUBMIT',
    'TRANSITION_DIALOG_ATTEMPT_SUBMIT',
    'TRANSITION_FORM_ATTEMPT_SUBMIT',
    'DELETE_ATTEMPT_SUBMIT',
    'DESELECT_ALL_ISSUES',
    'WATCH_ATTEMPT_SUBMIT',
    'UNWATCH_ATTEMPT_SUBMIT'
];

});


parcelRegister("i8Pje", function(module, exports) {
$parcel$export(module.exports, "AsyncBulkOpsCoreFull", () => $28aacd361882ee10$export$5a522923c01d18f2);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $cHtIB = parcelRequire("cHtIB");

var $6dASY = parcelRequire("6dASY");
const $28aacd361882ee10$export$5a522923c01d18f2 = (props)=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $6dASY.asyncBulkOpsCoreFullEntryPoint), entryPointParams);
    // This type conversion fixes the below CI build error
    // Type 'Omit<BulkOperationsCoreLoader<TEntryPoint>, "hasBulkEditPermission">' is not assignable to type 'Omit<BulkOperationsCoreLoader<AnyEntryPoint | undefined>, "hasBulkEditPermission">'
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const fixedEntryPointReferenceSubject = entryPointReferenceSubject;
    // this is to reduce the load to NIN when adding bulk ops
    // we should revisit later to remove this and load bulk ops same as the way backlog loads
    // https://hello.jira.atlassian.cloud/browse/DEE-6353
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "jira.backlog.bulk.operations.core.full",
        packageName: "jiraBulkOperationsCoreFull",
        entryPointReferenceSubject: fixedEntryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
        runtimeProps: props
    });
};

});
parcelRegister("6dASY", function(module, exports) {
$parcel$export(module.exports, "asyncBulkOpsCoreFullEntryPoint", () => $c8340555c6e3ab55$export$4586bee469e9f8fc);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $jYGv5 = parcelRequire("jYGv5");

const $c8340555c6e3ab55$export$4586bee469e9f8fc = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("l5cuW")), {
        moduleId: "6ba164f7",
        moduleName: "EntryPointContent",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                permissionsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $jYGv5.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("jYGv5", function(module, exports) {
$parcel$export(module.exports, "default", () => $2643f6483b9cac4c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2ff206ebda9a705400bfa93f15db0e6c>>
 * @relayHash 47b6bed432e93d293b71d554de9d22cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8e6818c1b5edb7793a16ffa9f89aef19e1986ebf11c163e4b84b6c6c60cf8d8d
const $2643f6483b9cac4c$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8e6818c1b5edb7793a16ffa9f89aef19e1986ebf11c163e4b84b6c6c60cf8d8d",
        "metadata": {},
        "name": "EntryPointContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $2643f6483b9cac4c$export$2e2bcd8739ae039 = $2643f6483b9cac4c$var$node;

});

parcelRegister("l5cuW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l0KDU").then(()=>parcelRequire('bxZ8e'));

});




parcelRegister("cZQDI", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4d70ecffed600f0$export$2e2bcd8739ae039);

var $eruSo = parcelRequire("eruSo");

var $7WBTX = parcelRequire("7WBTX");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $b5RwB = parcelRequire("b5RwB");

var $FhXEJ = parcelRequire("FhXEJ");

var $cblKs = parcelRequire("cblKs");

var $goZPP = parcelRequire("goZPP");

var $fo3wk = parcelRequire("fo3wk");

var $lRq8t = parcelRequire("lRq8t");

var $kGj4V = parcelRequire("kGj4V");
var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4Oene = parcelRequire("4Oene");

var $1BZ8a = parcelRequire("1BZ8a");

var $4cTDP = parcelRequire("4cTDP");

var $ivzXw = parcelRequire("ivzXw");

var $6d9QY = parcelRequire("6d9QY");

var $iRahl = parcelRequire("iRahl");

var $6Bi4o = parcelRequire("6Bi4o");

var $1wL9i = parcelRequire("1wL9i");

var $7emTO = parcelRequire("7emTO");

var $3kDjB = parcelRequire("3kDjB");

var $lvpZz = parcelRequire("lvpZz");

var $bICwA = parcelRequire("bICwA");
const $c4d70ecffed600f0$var$useAnalyticsAttributes = (type)=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    return (0, $eJOHy.useMemo)(()=>{
        if (!type) return;
        const projectType = (0, $FhXEJ.toProjectType)(type.toLowerCase());
        if (!projectType) return;
        const edition = (0, $cblKs.getEditionForProject)(projectType, appEditions);
        if (!edition) return;
        return {
            edition: edition
        };
    }, [
        appEditions,
        type
    ]);
};
const $c4d70ecffed600f0$var$FullPageIssueApp = ({ onChangeIssue: onChangeIssue, issueResults: issueResults, view: view, projectType: projectType, routePathname: routePathname, routeSearch: routeSearch, issueAppEntryPoint: issueAppEntryPoint })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isFetching = (0, $3kDjB.useIsFetching)();
    const { exitFullPageIssueAppMode: exitFullPageIssueAppMode, selectNextIssue: selectNextIssue, selectPreviousIssue: selectPreviousIssue } = (0, $1wL9i.useSelectedIssueActions)();
    const { mergeFlatListIssues: mergeFlatListIssues } = (0, $lvpZz.useFlatListIssuesActions)();
    const onBackToSearch = (0, $eJOHy.useCallback)(()=>{
        // Clear the selected issue key from the URL and return to normal view mode
        onChangeIssue('', true);
        exitFullPageIssueAppMode();
    }, [
        exitFullPageIssueAppMode,
        onChangeIssue
    ]);
    const onBackToSearchByButton = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        // @ts-expect-error - Argument of type 'UIAnalyticsEvent | null' is not assignable to parameter of type 'UIAnalyticsEvent'.
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent.clone(), 'returnToSearch');
        onBackToSearch();
    }, [
        onBackToSearch
    ]);
    const onBackToSearchByKeyboardShortcut = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'issue'
        }), 'returnToSearch', {
            keyPressed: 'z',
            keyboardShortcut: true
        });
        onBackToSearch();
    }, [
        onBackToSearch,
        createAnalyticsEvent
    ]);
    const onNextIssue = (0, $eJOHy.useCallback)(()=>{
        if (selectNextIssue()) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'nextIssue', {
            keyboardShortcut: true
        });
    }, [
        createAnalyticsEvent,
        selectNextIssue
    ]);
    const onPreviousIssue = (0, $eJOHy.useCallback)(()=>{
        if (selectPreviousIssue()) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'previousIssue', {
            keyboardShortcut: true
        });
    }, [
        createAnalyticsEvent,
        selectPreviousIssue
    ]);
    // If a new search is being run and we do not have forced issue selection (i.e. issue app pagination) then return to
    // normal view mode. This can happen when a filter is clicked in the sidebar or browser history navigation.
    (0, $eJOHy.useEffect)(()=>{
        if (isFetching) exitFullPageIssueAppMode();
    }, [
        exitFullPageIssueAppMode,
        isFetching
    ]);
    const backToSearch = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        testId: "issue-navigator.ui.full-page-issue-app.return-to-search",
        onClick: onBackToSearchByButton,
        interactionName: "issue-navigator-full-page-issue-app-return-to-search"
    }, formatMessage((0, $bICwA.default).returnText));
    const issueResultsData = (0, $j4oe4.useFragment)((0, $7WBTX.default), issueResults);
    const viewData = (0, $j4oe4.useFragment)((0, $eruSo.default), view);
    const fieldSetIds = (0, $eJOHy.useMemo)(()=>viewData?.fieldSets?.edges?.map((edge)=>edge?.node?.fieldSetId).filter(Boolean) ?? [], [
        viewData?.fieldSets?.edges
    ]);
    const { hasPrevious: hasPrevious, isLoadingPrevious: isLoadingPrevious, onLoadPrevious: onLoadPrevious, hasNext: hasNext, isLoadingNext: isLoadingNext, onLoadNext: onLoadNext } = (0, $7emTO.useInfiniteScroll)({
        fieldSetIds: fieldSetIds,
        view: null
    });
    const issueKeys = (0, $eJOHy.useMemo)(()=>issueResultsData?.edges?.map((edge)=>edge?.node?.key).filter(Boolean), [
        issueResultsData?.edges
    ]);
    const prevIssueKeysLength = (0, $6d9QY.usePrevious)(issueKeys?.length);
    if (issueKeys && prevIssueKeysLength !== issueKeys.length) mergeFlatListIssues(issueKeys);
    const selectedIssueKey = (0, $1wL9i.useSelectedIssueKey)();
    const edges = issueResultsData?.edges ?? [];
    const isFirstIssueSelected = edges[0]?.node?.key === selectedIssueKey;
    const isLastIssueSelected = edges[edges.length - 1]?.node?.key === selectedIssueKey;
    // Automatically fetch previous and next pages while navigating issues in full page mode
    (0, $eJOHy.useEffect)(()=>{
        if (isFirstIssueSelected && hasPrevious && !isLoadingPrevious) onLoadPrevious?.();
    }, [
        hasPrevious,
        isFirstIssueSelected,
        isLoadingPrevious,
        onLoadPrevious
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isLastIssueSelected && hasNext && !isLoadingNext) onLoadNext?.();
    }, [
        hasNext,
        isLastIssueSelected,
        isLoadingNext,
        onLoadNext
    ]);
    const attributes = $c4d70ecffed600f0$var$useAnalyticsAttributes(projectType);
    let backButtonUrl;
    if ((0, $4cTDP.fg)('empanada_nin_migrate_full_page_issue_nav')) // eslint-disable-next-line react-hooks/rules-of-hooks
    backButtonUrl = (0, $eJOHy.useMemo)(()=>{
        // Not using browser parsing API because it changes spaces to `+`
        const params = (0, $b5RwB.parse)(routeSearch);
        delete params.selectedIssue;
        return `${routePathname}?${(0, $b5RwB.stringify)(params)}`;
    }, [
        routeSearch,
        routePathname
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
        name: "full-page-issue-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: (0, $iRahl.ANALYTICS_LIST_VIEW_SOURCE_NAME),
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        ...attributes ? {
            attributes: attributes
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fo3wk.default), {
        keyMap: {
            z: {
                callback: onBackToSearchByKeyboardShortcut
            },
            j: {
                callback: onNextIssue
            },
            k: {
                callback: onPreviousIssue
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6Bi4o.default), {
        isEmbedView: false,
        extraHeaderActions: backToSearch,
        issueResults: issueResultsData ?? null,
        view: viewData ?? null,
        backButtonUrl: backButtonUrl,
        routePathname: routePathname,
        routeSearch: routeSearch,
        ...(0, $4cTDP.fg)('nin_fix_document_title_in_detail_view') && {
            analyticsSource: (0, $iRahl.ANALYTICS_SOURCE)
        },
        issueAppEntryPoint: (0, $4cTDP.fg)('nin_issue_app_conditional_entrypoint') ? issueAppEntryPoint : undefined
    })));
};
const $c4d70ecffed600f0$var$MemoizedFullPageIssueApp = /*#__PURE__*/ (0, $eJOHy.memo)($c4d70ecffed600f0$var$FullPageIssueApp);
const $c4d70ecffed600f0$var$FullPageIssueAppWithRouter = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivzXw.RouterSubscriber), null, ({ location: location })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c4d70ecffed600f0$var$MemoizedFullPageIssueApp, {
            ...props,
            routePathname: location.pathname,
            routeSearch: location.search
        });
    });
};
var $c4d70ecffed600f0$export$2e2bcd8739ae039 = $c4d70ecffed600f0$var$FullPageIssueAppWithRouter;

});
parcelRegister("eruSo", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d73bcf9b3e5e011$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c6ce74782ae0a54866642080a61a9fa9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4d73bcf9b3e5e011$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "amountOfColumns"
        },
        {
            "kind": "RootArgument",
            "name": "fieldSetsScope"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_FullPageIssueApp_view",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueAppWithData_view"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "fieldSetSelectedState": "SELECTED"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "amountOfColumns"
                },
                {
                    "kind": "Variable",
                    "name": "scope",
                    "variableName": "fieldSetsScope"
                }
            ],
            "concreteType": "JiraIssueSearchFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSets",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueSearchFieldSetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fieldSetId"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$4d73bcf9b3e5e011$var$node.hash = "064f112e625b1650c56fe569682b1195";
var $4d73bcf9b3e5e011$export$2e2bcd8739ae039 = $4d73bcf9b3e5e011$var$node;

});

parcelRegister("7WBTX", function(module, exports) {
$parcel$export(module.exports, "default", () => $83796e031c4e24d5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e191fe8f978a91a8364f661a75b25c8f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $83796e031c4e24d5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_FullPageIssueApp_issueResults",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueAppWithData_issueResults"
        }
    ],
    "type": "JiraIssueConnection"
};
$83796e031c4e24d5$var$node.hash = "c76ea1c159a6e1be56c13b6262324ca3";
var $83796e031c4e24d5$export$2e2bcd8739ae039 = $83796e031c4e24d5$var$node;

});

parcelRegister("fo3wk", function(module, exports) {
$parcel$export(module.exports, "default", () => $4454c8bb14df47ef$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $hrKgE = parcelRequire("hrKgE");

var $9ltuT = parcelRequire("9ltuT");

var $lObif = parcelRequire("lObif");

var $5R5jr = parcelRequire("5R5jr");

var $d94A4 = parcelRequire("d94A4");

var $4B7rn = parcelRequire("4B7rn");

var $8gJRB = parcelRequire("8gJRB");
let $4454c8bb14df47ef$var$shortcutsCount = 0;
let $4454c8bb14df47ef$var$subscription = null;
const $4454c8bb14df47ef$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $eJOHy.useContext)((0, $4B7rn.ShortcutRegistryContext)) || (0, $d94A4.rootRegistry);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const addKeyMap = (0, $eJOHy.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $8gJRB.bindKeyMapWithErrorHandling)(keyMap, location, createAnalyticsEvent({
                    action: 'pressed',
                    actionSubject: 'keyboardShortcut'
                })),
                label: label
            })), [
        parentRegistry,
        keyMap,
        location,
        createAnalyticsEvent,
        label
    ]);
    (0, $eJOHy.useEffect)(()=>{
        $4454c8bb14df47ef$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $4454c8bb14df47ef$var$shortcutsCount -= 1;
            if ($4454c8bb14df47ef$var$subscription && $4454c8bb14df47ef$var$shortcutsCount === 0) {
                $4454c8bb14df47ef$var$subscription.unsubscribe();
                $4454c8bb14df47ef$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $eJOHy.useEffect)(()=>{
        $4454c8bb14df47ef$var$subscription = $4454c8bb14df47ef$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $5R5jr.default)().subscribe((0, $lObif.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
const $4454c8bb14df47ef$var$Shortcuts = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $9ltuT.useKeyboardShortcutsToggle), ...unstableProps })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    const props = (0, $hrKgE.useShallowStableReference)(unstableProps, true);
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4454c8bb14df47ef$var$ShortcutsSubscriber, props) : null;
};
var $4454c8bb14df47ef$export$2e2bcd8739ae039 = $4454c8bb14df47ef$var$Shortcuts;

});
parcelRegister("9ltuT", function(module, exports) {
$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $08e42e851d357ae1$export$a33a81f1fc5458ad);

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $hWeHP = parcelRequire("hWeHP");

var $kRgKj = parcelRequire("kRgKj");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $08e42e851d357ae1$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $08e42e851d357ae1$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$08e42e851d357ae1$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $3ugTQ.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $08e42e851d357ae1$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $hWeHP.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $08e42e851d357ae1$export$b62f67be35e65859
    }
});
const $08e42e851d357ae1$export$a33a81f1fc5458ad = (0, $iJq0l.createHook)($08e42e851d357ae1$var$Store);

});

parcelRegister("lObif", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6eea6b4ddedc8b9$export$2e2bcd8739ae039);

var $5R5jr = parcelRequire("5R5jr");

var $d94A4 = parcelRequire("d94A4");
const $f6eea6b4ddedc8b9$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
/**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ const $f6eea6b4ddedc8b9$var$handler = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $d94A4.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $5R5jr.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($f6eea6b4ddedc8b9$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $5R5jr.flush)();
    }
};
var $f6eea6b4ddedc8b9$export$2e2bcd8739ae039 = $f6eea6b4ddedc8b9$var$handler;

});
parcelRegister("5R5jr", function(module, exports) {
$parcel$export(module.exports, "flush", () => $6bc56ab68fad194d$export$4909b86c8034bf73);
$parcel$export(module.exports, "default", () => $6bc56ab68fad194d$export$2e2bcd8739ae039);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $7kixv = parcelRequire("7kixv");

var $6WhQS = parcelRequire("6WhQS");
parcelRequire("7SsGX");
parcelRequire("hnYRz");
parcelRequire("llumX");
parcelRequire("lVRem");
parcelRequire("1o2WJ");
parcelRequire("8rm0O");
parcelRequire("9Zsih");
parcelRequire("lf3vd");

var $gPrdS = parcelRequire("gPrdS");

var $6ju76 = parcelRequire("6ju76");
const $6bc56ab68fad194d$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $6bc56ab68fad194d$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6bc56ab68fad194d$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$6bc56ab68fad194d$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6bc56ab68fad194d$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$6bc56ab68fad194d$var$isEditable(e.target) && !$6bc56ab68fad194d$var$ignoredKeys[e.key]);
let $6bc56ab68fad194d$var$key$;
const $6bc56ab68fad194d$var$flush$ = new (0, $6WhQS.Subject)();
const $6bc56ab68fad194d$var$createSequences = ()=>{
    if (!$6bc56ab68fad194d$var$key$) {
        $6bc56ab68fad194d$var$key$ = false ? new (0, $6WhQS.Subject)() : (0, $7kixv.Observable).fromEvent(document, 'keydown').filter($6bc56ab68fad194d$var$isRelevantKeyEvent).filter((0, $6ju76.isLegacyAuiBlanketClosed)).map((0, $gPrdS.toKeyWithModifiers));
        const sequence$ = $6bc56ab68fad194d$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $6bc56ab68fad194d$var$key$ = $6bc56ab68fad194d$var$key$.debounceTime(1000).startWith(null).merge($6bc56ab68fad194d$var$flush$).switchMapTo(sequence$);
    }
    return $6bc56ab68fad194d$var$key$;
};
const $6bc56ab68fad194d$export$4909b86c8034bf73 = ()=>{
    $6bc56ab68fad194d$var$flush$.next();
};
var $6bc56ab68fad194d$export$2e2bcd8739ae039 = $6bc56ab68fad194d$var$createSequences;

});


parcelRegister("8gJRB", function(module, exports) {
$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $91e416a701a8c178$export$77477772a9b904da);

var $eSnSE = parcelRequire("eSnSE");

var $kRgKj = parcelRequire("kRgKj");
const $91e416a701a8c178$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common', analyticsEvent)=>(e)=>{
        try {
            if (analyticsEvent) (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'keyboardShortcut pressed', {
                key: key
            });
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $91e416a701a8c178$export$77477772a9b904da = (keyMap, location, analyticsEvent)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $91e416a701a8c178$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location, analyticsEvent)
            }
        }), {});

});


parcelRegister("6Bi4o", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3917d6bd4592205$export$2e2bcd8739ae039);

var $l4JQl = parcelRequire("l4JQl");

var $5FNrk = parcelRequire("5FNrk");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $b5RwB = parcelRequire("b5RwB");

var $R5dK3 = parcelRequire("R5dK3");

var $4EKqI = parcelRequire("4EKqI");

var $5tyYu = parcelRequire("5tyYu");

var $87NxD = parcelRequire("87NxD");

var $d6KFY = parcelRequire("d6KFY");

var $juAwR = parcelRequire("juAwR");

var $kGj4V = parcelRequire("kGj4V");

var $cH6Qf = parcelRequire("cH6Qf");

var $bQWwW = parcelRequire("bQWwW");

var $4cTDP = parcelRequire("4cTDP");

var $bJscI = parcelRequire("bJscI");

var $bmoS1 = parcelRequire("bmoS1");

var $6d9QY = parcelRequire("6d9QY");

var $2dBpR = parcelRequire("2dBpR");

var $5vQ2T = parcelRequire("5vQ2T");

var $j2oKY = parcelRequire("j2oKY");

var $1wL9i = parcelRequire("1wL9i");

var $ijD5s = parcelRequire("ijD5s");

var $1aawv = parcelRequire("1aawv");

var $iRahl = parcelRequire("iRahl");

var $fAgUF = parcelRequire("fAgUF");

var $ccZ0S = parcelRequire("ccZ0S");

var $6IA67 = parcelRequire("6IA67");
const $f3917d6bd4592205$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-app-container"
    }, children), (0, $eJOHy.Fragment)); // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences

const $f3917d6bd4592205$var$AsyncIssueAppComponent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("54hXx")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $f3917d6bd4592205$var$IssueAppWithConditionalEntrypoint = ({ isEmbedView: isEmbedView, issueAppEntryPoint: issueAppEntryPoint, ...rest })=>{
    if (issueAppEntryPoint) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-app-entrypoint"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "issue-app-entrypoint",
        packageName: "issue-navigator",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5tyYu.UnknownErrorView), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dBpR.EntryPointReferencePlaceholder), {
        name: "issue-app",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $R5dK3.IssueViewSkeleton), {
            isEmbedView: isEmbedView
        }),
        entryPointReference: issueAppEntryPoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.EntryPointContainer), {
        entryPointReference: issueAppEntryPoint,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: rest
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f3917d6bd4592205$var$AsyncIssueAppUsingLoadingPhases, {
        isEmbedView: isEmbedView,
        ...rest
    });
};
const $f3917d6bd4592205$var$AsyncIssueAppUsingLoadingPhases = ({ isEmbedView: isEmbedView, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d6KFY.IssueBoundary), {
        packageName: "issue-navigator",
        isEmbedView: isEmbedView,
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5tyYu.UnknownErrorView), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f3917d6bd4592205$var$AsyncIssueAppComponent, rest));
const $f3917d6bd4592205$var$IssueAppFG = (0, $bJscI.componentWithFG)('nin_issue_app_conditional_entrypoint', $f3917d6bd4592205$var$IssueAppWithConditionalEntrypoint, $f3917d6bd4592205$var$AsyncIssueAppUsingLoadingPhases); // oxlint-disable-next-line prefer-set-has
const $f3917d6bd4592205$var$issueCardChangeExcludedEventTypes = [
    (0, $87NxD.ChangeEventTypes).FIELD_CHANGE_REQUESTED,
    (0, $87NxD.ChangeEventTypes).FIELD_CHANGE_FAILED,
    (0, $87NxD.ChangeEventTypes).CHILD_ISSUE_ADDED,
    (0, $87NxD.ChangeEventTypes).ISSUE_CHILDREN_ORDER_CHANGED
];
const $f3917d6bd4592205$var$useJSCM1CompatibleActions = (connectionId, fieldSetIds)=>{
    const { deselectIssue: deselectIssue, exitFullPageIssueAppMode: exitFullPageIssueAppMode, setSelectedIssueByKey: setSelectedIssueByKey } = (0, $1wL9i.useSelectedIssueActions)();
    const onDeleteIssue = (0, $ijD5s.useOnDeleteIssue)(connectionId);
    const onIssueByFieldsRefetch = (0, $1aawv.useIssueByFieldsRefetch)(fieldSetIds);
    return {
        deselectIssue: deselectIssue,
        exitFullPageIssueAppMode: exitFullPageIssueAppMode,
        setSelectedIssueByKey: setSelectedIssueByKey,
        onDeleteIssue: onDeleteIssue,
        onIssueByFieldsRefetch: onIssueByFieldsRefetch
    };
};
const $f3917d6bd4592205$var$IssueAppWithData = ({ IssueApp: IssueApp = $f3917d6bd4592205$var$IssueAppFG, analyticsSource: analyticsSource, extraHeaderActions: extraHeaderActions, isEmbedView: isEmbedView, issueResults: issueResults, view: view, backButtonUrl: backButtonUrl, routePathname: routePathname, routeSearch: routeSearch, issueAppEntryPoint: issueAppEntryPoint })=>{
    (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_APP_START);
    (0, $eJOHy.useLayoutEffect)(()=>{
        (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_APP_END);
    }, []);
    const selectedIssueKey = (0, $1wL9i.useSelectedIssueDebouncedState)();
    const [, issueContextActions] = (0, $bmoS1.useIssueContextActions)();
    const issueResultsData = (0, $j4oe4.useFragment)((0, $5FNrk.default), issueResults);
    const viewData = (0, $j4oe4.useFragment)((0, $l4JQl.default), view);
    const fieldSetIds = (0, $eJOHy.useMemo)(()=>viewData?.fieldSets?.edges?.map((edge)=>edge?.node?.fieldSetId).filter(Boolean) ?? [], [
        viewData?.fieldSets?.edges
    ]);
    const { onInteractive: onInteractive } = (0, $j2oKY.useStartNinIssueAppAnalytics)(selectedIssueKey);
    const issueAppMetrics = (0, $eJOHy.useMemo)(()=>({
            onInteractive: onInteractive
        }), [
        onInteractive
    ]);
    const { deselectIssue: deselectIssue, exitFullPageIssueAppMode: exitFullPageIssueAppMode, setSelectedIssueByKey: setSelectedIssueByKey, onDeleteIssue: onDeleteIssue, onIssueByFieldsRefetch: onIssueByFieldsRefetch } = $f3917d6bd4592205$var$useJSCM1CompatibleActions(issueResultsData?.__id, fieldSetIds);
    const refetchCallback = (0, $eJOHy.useRef)(onIssueByFieldsRefetch);
    refetchCallback.current = onIssueByFieldsRefetch;
    const onIssueDeleteSuccess = (0, $eJOHy.useCallback)(({ issueKey: deletedIssueKey })=>{
        const issueKeyToSelect = onDeleteIssue(deletedIssueKey);
        if (!issueKeyToSelect.length) {
            deselectIssue(); // Return to list view if we were in full page mode
            exitFullPageIssueAppMode();
        } else setSelectedIssueByKey(issueKeyToSelect);
    }, [
        deselectIssue,
        exitFullPageIssueAppMode,
        onDeleteIssue,
        setSelectedIssueByKey
    ]);
    const onIssueKeyChange = (0, $eJOHy.useCallback)((issueKeys)=>{
        setSelectedIssueByKey(issueKeys.toIssueKey);
    }, [
        setSelectedIssueByKey
    ]); // When we're in non-embedded view (i.e. full page) we need to define a max width to ensure correct full page
    // styling within the issue app.
    const maxWidth = !isEmbedView ? (0, $juAwR.getIssueContainerIncreasedMaxWidth)() : undefined;
    const shouldWrapMargin = !(0, $1wL9i.useIsFullPageIssueAppMode)();
    (0, $6IA67.useScrollToActivityFeed)(selectedIssueKey);
    let issueNavigatorData;
    if ((0, $4cTDP.fg)('empanada_nin_migrate_full_page_issue_nav')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const getIssueUrl = (0, $eJOHy.useCallback)((issueKey)=>{
            // Not using browser parsing API because it changes spaces to `+`
            const params = (0, $b5RwB.parse)(routeSearch);
            params.selectedIssue = issueKey;
            return `${routePathname}?${(0, $b5RwB.stringify)(params)}`;
        }, [
            routeSearch,
            routePathname
        ]); // eslint-disable-next-line react-hooks/rules-of-hooks
        const issueKeys = (0, $1wL9i.useIssueKeys)(); // eslint-disable-next-line react-hooks/rules-of-hooks
        const issuesCount = (0, $1wL9i.useIssuesCount)(); // eslint-disable-next-line react-hooks/rules-of-hooks
        issueNavigatorData = (0, $eJOHy.useMemo)(()=>({
                issueKey: selectedIssueKey,
                issueKeys: issueKeys,
                knownIssueKeys: issueKeys,
                issuesCount: issuesCount,
                getIssueUrl: getIssueUrl
            }), [
            selectedIssueKey,
            issueKeys,
            issuesCount,
            getIssueUrl
        ]);
    }
    const prevIssueNavigatorData = (0, $6d9QY.usePrevious)(issueNavigatorData);
    if (issueNavigatorData && prevIssueNavigatorData !== issueNavigatorData) issueContextActions.mergeIssueContext?.({
        issueNavigatorData: issueNavigatorData
    });
    if (!selectedIssueKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cH6Qf.SpaStatePageErrorReady), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f3917d6bd4592205$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f3917d6bd4592205$var$IssueAppContainer, {
        "data-vc": "issue-app-container",
        isEmbedView: isEmbedView || (0, $4cTDP.fg)('empanada_nin_migrate_full_page_issue_nav'),
        shouldWrapMargin: shouldWrapMargin
    }, !(0, $4cTDP.fg)('empanada_nin_migrate_full_page_issue_nav') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ccZ0S.default), {
        issueResults: issueResultsData ?? null,
        extraHeaderActions: extraHeaderActions,
        isEmbedView: isEmbedView,
        maxWidth: maxWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f3917d6bd4592205$var$IssueAppHeightAdjustment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: "issueNavigatorEmbeddedIssueView",
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(IssueApp, {
        metrics: issueAppMetrics,
        key: selectedIssueKey,
        isEmbedView: isEmbedView,
        analyticsSource: (0, $4cTDP.fg)('nin_fix_document_title_in_detail_view') ? analyticsSource || (0, $iRahl.ANALYTICS_SOURCE) : (0, $iRahl.ANALYTICS_SOURCE),
        issueKey: selectedIssueKey,
        issueMaxWidth: maxWidth,
        onIssueKeyChange: onIssueKeyChange,
        onChange: (event)=>{
            if (event && !$f3917d6bd4592205$var$issueCardChangeExcludedEventTypes.includes(event.type)) refetchCallback.current(String(selectedIssueKey));
        },
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        shouldSetInitialFocus: false,
        backButtonUrl: backButtonUrl,
        issueNavigatorData: issueNavigatorData,
        issueAppEntryPoint: issueAppEntryPoint
    })))));
};
var $f3917d6bd4592205$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $f3917d6bd4592205$var$IssueAppWithData;
const $f3917d6bd4592205$var$IssueAppContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldWrapMargin: shouldWrapMargin, isEmbedView: isEmbedView, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _16jlkb7n _4t3i1osq _1ul9idpf _1e0c1txw _2lx21bp4 _vchhusvi",
            __cmplp.shouldWrapMargin && "_2hwx10v4",
            !__cmplp.isEmbedView && "_ca0qxy5q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f3917d6bd4592205$var$IssueAppHeightAdjustment = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq _1tkeidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("l4JQl", function(module, exports) {
$parcel$export(module.exports, "default", () => $b487a3fb097c9a98$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b57212afd88a65d6ab1b44dd40c60183>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b487a3fb097c9a98$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "amountOfColumns"
        },
        {
            "kind": "RootArgument",
            "name": "fieldSetsScope"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueAppWithData_view",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "fieldSetSelectedState": "SELECTED"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "amountOfColumns"
                },
                {
                    "kind": "Variable",
                    "name": "scope",
                    "variableName": "fieldSetsScope"
                }
            ],
            "concreteType": "JiraIssueSearchFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSets",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueSearchFieldSetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fieldSetId"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$b487a3fb097c9a98$var$node.hash = "741c31d0c1ebc1e3fdeb37896e791449";
var $b487a3fb097c9a98$export$2e2bcd8739ae039 = $b487a3fb097c9a98$var$node;

});

parcelRegister("5FNrk", function(module, exports) {
$parcel$export(module.exports, "default", () => $f49c83245d0dcb01$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1eb167471fb64a02bbc7a0985243c9bc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f49c83245d0dcb01$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueAppWithData_issueResults",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "headerActions_issueNavigator"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$f49c83245d0dcb01$var$node.hash = "267fadd3844f360bfc7e5d9f255f3ee7";
var $f49c83245d0dcb01$export$2e2bcd8739ae039 = $f49c83245d0dcb01$var$node;

});

parcelRegister("R5dK3", function(module, exports) {
$parcel$export(module.exports, "IssueViewSkeleton", () => $f52809f20d23afc1$export$49addbcdecb6e6ff);
/* IssueViewSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $biWZb = parcelRequire("biWZb");

var $f2JN3 = parcelRequire("f2JN3");

var $cxKOj = parcelRequire("cxKOj");

var $2nmMZ = parcelRequire("2nmMZ");

var $8gkGI = parcelRequire("8gkGI");
const $f52809f20d23afc1$var$fullpageStyles = null;
const $f52809f20d23afc1$var$modalStyles = null;
const $f52809f20d23afc1$var$customSpacingStyles = null;
/**
 * Renders a placeholder for the Issue View that adapts its layout and styling to different contexts such as embedding or modal presentation, ensuring a consistent user experience during content loading.
 */ const $f52809f20d23afc1$var$IssueViewSkeletonWithRightStatus = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
    // same as getIssueContainerMaxWidth
    const customCss = [
        $f52809f20d23afc1$var$customSpacingStyles,
        isEmbedView !== true && isModalView !== true ? $f52809f20d23afc1$var$fullpageStyles : null,
        isModalView === true ? $f52809f20d23afc1$var$modalStyles : null
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $biWZb.CompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2nmMZ))),
        className: (0, $hcewu.default)([
            "_p12f107j _19pkze3t _2hwx1wug _otyrze3t _18u01wug _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
            isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
            isModalView === true && "_19pk10j7"
        ])
    }));
};
const $f52809f20d23afc1$var$IssueViewSkeletonWithLeftStatus = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
    // same as getIssueContainerMaxWidth
    const customCss = [
        $f52809f20d23afc1$var$customSpacingStyles,
        isEmbedView !== true && isModalView !== true ? $f52809f20d23afc1$var$fullpageStyles : null,
        isModalView === true ? $f52809f20d23afc1$var$modalStyles : null
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $biWZb.CompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8gkGI))),
        className: (0, $hcewu.default)([
            "_p12f107j _19pkze3t _2hwx1wug _otyrze3t _18u01wug _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
            isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
            isModalView === true && "_19pk10j7"
        ])
    }));
};
const $f52809f20d23afc1$export$49addbcdecb6e6ff = (0, $f2JN3.componentWithCondition)(()=>(0, $cxKOj.expVal)('move_status_to_summary_ga', 'isEnabled', false), $f52809f20d23afc1$var$IssueViewSkeletonWithLeftStatus, $f52809f20d23afc1$var$IssueViewSkeletonWithRightStatus);

});
parcelRegister("biWZb", function(module, exports) {
$parcel$export(module.exports, "CompactModeContext", () => $b77d47f9e4eb67f9$export$37eeac5cc5245b18);
$parcel$export(module.exports, "CompactModeProvider", () => $b77d47f9e4eb67f9$export$10cf42790e523b8e);
$parcel$export(module.exports, "CompactModeConsumer", () => $b77d47f9e4eb67f9$export$20feb77b5b617e44);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");


var $8BpnG = parcelRequire("8BpnG");

var $gCY1z = parcelRequire("gCY1z");

var $coXKe = parcelRequire("coXKe");

var $cZpx8 = parcelRequire("cZpx8");
const $b77d47f9e4eb67f9$export$37eeac5cc5245b18 = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const { Provider: $b77d47f9e4eb67f9$var$Provider, Consumer: $b77d47f9e4eb67f9$var$Consumer } = $b77d47f9e4eb67f9$export$37eeac5cc5245b18;
const $b77d47f9e4eb67f9$export$55a90a8e865a39b5 = 700;
const $b77d47f9e4eb67f9$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY = `(max-width: ${$b77d47f9e4eb67f9$export$55a90a8e865a39b5}px)`;
const $b77d47f9e4eb67f9$export$ddd398a95f85cd75 = 850;
const $b77d47f9e4eb67f9$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY_SIDE_PANEL = `(max-width: ${$b77d47f9e4eb67f9$export$ddd398a95f85cd75}px)`;
/**
 * A utility hook which returns a key based on the route
 */ function $b77d47f9e4eb67f9$var$useRouteKey() {
    const [routeState] = (0, $gCY1z.useRouter)();
    const { match: { path: path, params: params } } = routeState;
    // handle case where JSM doesn't have an issueKey on their route
    const hasIssueKey = params?.issueKey !== undefined;
    return `${path}${hasIssueKey ? '/hasIssueKey' : ''}`;
}
const $b77d47f9e4eb67f9$export$10cf42790e523b8e = ({ children: children })=>{
    const key = $b77d47f9e4eb67f9$var$useRouteKey();
    (0, $cZpx8.invalidateCacheIfRouteChanged)(key);
    let defaultState = (0, $cZpx8.getCachedIsCompactValue)(key);
    // in case there is no state change triggered
    if (defaultState === undefined) {
        defaultState = (0, $548198843509795c$export$ee15e0cd1efafcb4);
        (0, $cZpx8.setCachedIsCompactValue)(defaultState, key);
    }
    const { isInDiscussionLayoutExperiment: isInDiscussionLayoutExperiment } = (0, $coXKe.useUserPreferredWorkItemLayout)();
    const query = isInDiscussionLayoutExperiment ? $b77d47f9e4eb67f9$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY_SIDE_PANEL : $b77d47f9e4eb67f9$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY;
    const [isCompact, setIsCompact] = (0, $eJOHy.useState)(defaultState);
    const onChange = (0, $eJOHy.useCallback)((state)=>{
        (0, $cZpx8.setCachedIsCompactValue)(state, key);
        setIsCompact(state);
    }, [
        key
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b77d47f9e4eb67f9$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8BpnG.ContainerQueryObserver), {
        query: query,
        onChange: onChange,
        defaultState: defaultState
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b77d47f9e4eb67f9$var$Provider, {
        value: isCompact
    }, children));
};
const $b77d47f9e4eb67f9$export$20feb77b5b617e44 = $b77d47f9e4eb67f9$var$Consumer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b77d47f9e4eb67f9$var$StyledWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
const $548198843509795c$export$ee15e0cd1efafcb4 = false;

parcelRegister("8BpnG", function(module, exports) {
$parcel$export(module.exports, "ContainerQueryObserver", () => $b45aeffccc0e4b84$export$e9574287678b8467);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $EzBXZ = parcelRequire("EzBXZ");

const $b45aeffccc0e4b84$var$QueryContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
let $b45aeffccc0e4b84$var$currentIdSeed = 0;
function $b45aeffccc0e4b84$var$generateAttributeValue() {
    return `indicator-span-${$b45aeffccc0e4b84$var$currentIdSeed++}`;
}
function $b45aeffccc0e4b84$export$e9574287678b8467({ children: children, query: query, onChange: onChange, defaultState: defaultState = (0, $548198843509795c$export$ee15e0cd1efafcb4) }) {
    const [active, setActive] = (0, $eJOHy.useState)(defaultState);
    const handleQueryStatusChange = (0, $eJOHy.useCallback)((isContainerQueryActive)=>{
        onChange?.(isContainerQueryActive);
        setActive(isContainerQueryActive);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b45aeffccc0e4b84$var$QueryContext.Provider, {
        value: active
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $EzBXZ.RenderOnClient), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b45aeffccc0e4b84$var$IntersectionIndicator, {
        query: query,
        notifyIntersectionStatusChanged: handleQueryStatusChange
    })), children);
}
function $b45aeffccc0e4b84$export$b66a67697973e01() {
    const currentState = (0, $eJOHy.useContext)($b45aeffccc0e4b84$var$QueryContext);
    if (currentState === undefined) throw new Error('The component must be wrapped in a ContainerQueryObserver to use useContainerQueryState');
    return currentState;
}
function $b45aeffccc0e4b84$var$IntersectionIndicator({ notifyIntersectionStatusChanged: handleChange, query: query }) {
    const attributeValue = (0, $eJOHy.useMemo)(()=>$b45aeffccc0e4b84$var$generateAttributeValue(), []);
    const spanRef = (0, $eJOHy.useRef)(null);
    const containerRef = (0, $eJOHy.useRef)(null);
    const currentState = $b45aeffccc0e4b84$export$b66a67697973e01();
    (0, $eJOHy.useLayoutEffect)(()=>{
        const queryStatusChangedCallback = (entries)=>{
            // This means that the parent container is either empty or loading, we should not notify of any change in this case.
            if (!containerRef.current || containerRef.current.clientWidth === 0) return;
            if (entries.length > 0) {
                // only ever going to be one entry max
                const isContainerQueryActive = entries[0].isIntersecting;
                if (isContainerQueryActive !== currentState) handleChange(isContainerQueryActive);
            }
        };
        const intersectionObserver = new IntersectionObserver(queryStatusChangedCallback);
        const spanElement = spanRef.current;
        spanElement && intersectionObserver.observe(spanElement);
        return ()=>{
            spanElement && intersectionObserver.unobserve(spanElement);
            intersectionObserver.disconnect();
        };
    }, [
        currentState,
        handleChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b45aeffccc0e4b84$var$ContainerToBeQueried, {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("style", {
        type: "text/css"
    }, `
                    [data-container-query-indicator-id="${attributeValue}"] {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh;
                        pointer-events: none;
                    }
                    @container ${query} {
                        [data-container-query-indicator-id="${attributeValue}"] {
                            display: inherit;
                        }
                    }`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        ref: spanRef,
        "data-container-query-indicator-id": attributeValue
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b45aeffccc0e4b84$var$ContainerToBeQueried = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqsw1if8 _lcxvglyw _154iidpf _7ccakre2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("coXKe", function(module, exports) {
$parcel$export(module.exports, "useIssueLayoutContainers", () => $3b984a26137eed7b$export$d146dfa0384f99a3);
$parcel$export(module.exports, "useLayoutContainerByType", () => $3b984a26137eed7b$export$5f49a43487b268);
$parcel$export(module.exports, "useLayoutContainerByTypeMemoised", () => $3b984a26137eed7b$export$ef5966e43b13b4a9);
$parcel$export(module.exports, "useIssueLayoutGlance", () => $3b984a26137eed7b$export$fd7f0cc3d2b405e6);
$parcel$export(module.exports, "useIssueLayoutContextPanel", () => $3b984a26137eed7b$export$5962da0433486667);
$parcel$export(module.exports, "useUserPreferredWorkItemLayout", () => $3b984a26137eed7b$export$9889eea62fdfa091);
$parcel$export(module.exports, "useIssueLayoutActions", () => $3b984a26137eed7b$export$1e5e9fc877a47cd9);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $pz0Wh = parcelRequire("pz0Wh");

var $kfvK2 = parcelRequire("kfvK2");

var $cxKOj = parcelRequire("cxKOj");

var $cs58I = parcelRequire("cs58I");

var $hbF3h = parcelRequire("hbF3h");

var $bmoS1 = parcelRequire("bmoS1");

var $1M2hR = parcelRequire("1M2hR");


var $bNexr = parcelRequire("bNexr");

var $4cTDP = parcelRequire("4cTDP");

var $eSnSE = parcelRequire("eSnSE");

var $l7Alo = parcelRequire("l7Alo");

var $lpEwy = parcelRequire("lpEwy");

var $co62F = parcelRequire("co62F");
const $3b984a26137eed7b$var$Tabs = {
    Description: 'description',
    WorkItems: 'workItems',
    Resources: 'resources',
    Integrations: 'integrations'
};
const $3b984a26137eed7b$var$defaultActiveTab = $3b984a26137eed7b$var$Tabs.Description;
const $3b984a26137eed7b$export$d146dfa0384f99a3 = (issueKey)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    return [
        containers
    ];
};
const $3b984a26137eed7b$export$5f49a43487b268 = (issueKey, type)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    // Forge app with UI Modifications module can hide selected fields using
    // UI modifications Field API. We are removing them here from the layout fields
    const fieldsHiddenByUim = (0, $pz0Wh.useEnabledHiddenFields)();
    return (0, $eJOHy.useMemo)(()=>[
            (0, $co62F.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim)
        ], [
        container?.items.nodes,
        fieldsHiddenByUim
    ]);
};
const $3b984a26137eed7b$export$ef5966e43b13b4a9 = (issueKey, type)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    const fieldsHiddenByUim = (0, $pz0Wh.useEnabledHiddenFields)();
    const filteredItems = (0, $eJOHy.useMemo)(()=>{
        return (0, $co62F.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim);
    }, [
        container,
        fieldsHiddenByUim
    ]);
    return [
        filteredItems
    ];
};
const $3b984a26137eed7b$export$fd7f0cc3d2b405e6 = (issueKey)=>{
    const [glance] = (0, $lpEwy.useIssueLayoutGlanceStore)(issueKey);
    return [
        glance
    ];
};
const $3b984a26137eed7b$export$5962da0433486667 = (issueKey)=>{
    const [contextPanel] = (0, $lpEwy.useIssueLayoutContextPanelStore)(issueKey);
    return [
        contextPanel
    ];
};
const $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOn = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    const isFullIssueView = (0, $bmoS1.useIsFullPageIssueView)();
    const [userPreferredLayout] = (0, $cs58I.useUserPreferencesValue)((0, $e8c5fe022e7e442a$export$39aaf586c7ee5202));
    const isMobile = (0, $l7Alo.default)();
    const locale = (0, $1M2hR.useLocale)();
    try {
        // if neither tab layout nor issue view layout experiment is enabled return defaults
        if (!(0, $4cTDP.fg)('issue_view_layout_experiment_feature_gate') && !(0, $4cTDP.fg)('issue_view_tab_layout_feature_gate')) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isSoftwareOrBusiness = projectType === (0, $FhXEJ.SOFTWARE_PROJECT) || projectType === (0, $FhXEJ.CORE_PROJECT);
        const shouldBeInLayoutExperiment = !isMobile && isSoftwareOrBusiness && isFullIssueView;
        const shouldBeInLayoutExperimentAndTabLayoutEnabled = (0, $4cTDP.fg)('issue_view_tab_layout_feature_gate') && shouldBeInLayoutExperiment;
        if (!shouldBeInLayoutExperiment) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isInTabLayoutExperiment = shouldBeInLayoutExperimentAndTabLayoutEnabled && (0, $cxKOj.expVal)('issue_view_tab_layout_experiment', 'isTabLayoutEnabled', false);
        const isInWideLayoutExperiment = shouldBeInLayoutExperiment && (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false);
        const isInDiscussionLayoutExperiment = shouldBeInLayoutExperiment && (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false);
        const isInLayoutExperiment = isInWideLayoutExperiment || isInDiscussionLayoutExperiment || isInTabLayoutExperiment;
        const userLayoutType = isInLayoutExperiment && userPreferredLayout && typeof userPreferredLayout === 'string' ? JSON.parse(userPreferredLayout)?.layoutType : null;
        let userSelectedLayout = userLayoutType;
        if (!(0, $4cTDP.fg)('thor-make-layout-options-work-together')) {
            if (isInLayoutExperiment && isInDiscussionLayoutExperiment && userLayoutType === 'WIDE') userSelectedLayout = 'STANDARD';
            if (isInLayoutExperiment && isInWideLayoutExperiment && userLayoutType === 'DISCUSSION') userSelectedLayout = 'STANDARD';
        }
        // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
        // but we keep it to avoid making too many changes in the codebase
        const isActivityInVerticalSidePanel = isInDiscussionLayoutExperiment && userSelectedLayout === 'DISCUSSION';
        return {
            isInDiscussionLayoutExperiment: Boolean(isInDiscussionLayoutExperiment),
            isInWideLayoutExperiment: Boolean(isInWideLayoutExperiment),
            isInLayoutExperiment: Boolean(isInLayoutExperiment),
            // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
            // but we keep it to avoid making too many changes in the codebase
            isActivityInVerticalSidePanel: Boolean(isActivityInVerticalSidePanel),
            userPreferredLayout: userSelectedLayout
        };
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `Error in useUserPreferredWorkItemLayout : ${JSON.stringify({
            error: error,
            isMobile: isMobile,
            isFullIssueView: isFullIssueView,
            isIssueKeyNull: issueKey === null,
            isProjectKeyNull: projectKey === null,
            isProjectTypeNull: projectType === null,
            userPreferredLayout: userPreferredLayout,
            locale: locale,
            isInWideLayoutExperiment: (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false),
            isInDiscussionLayoutExperiment: (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false)
        })}`);
        return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
    }
};
const $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOff = ()=>{
    try {
        // if neither tab layout nor issue view layout experiment is enabled return defaults
        if (!(0, $4cTDP.fg)('issue_view_layout_experiment_feature_gate') && !(0, $4cTDP.fg)('issue_view_tab_layout_feature_gate')) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        /* eslint-disable react-hooks/rules-of-hooks */ const issueKey = (0, $bmoS1.useIssueKey)();
        const projectKey = (0, $bNexr.useProjectKey)(issueKey);
        const projectType = (0, $bNexr.useProjectType)(projectKey);
        const isFullIssueView = (0, $bmoS1.useIsFullPageIssueView)();
        const [userPreferredLayout] = (0, $cs58I.useUserPreferencesValue)((0, $e8c5fe022e7e442a$export$39aaf586c7ee5202));
        const isMobile = (0, $l7Alo.default)();
        const isSoftwareOrBusiness = projectType === (0, $FhXEJ.SOFTWARE_PROJECT) || projectType === (0, $FhXEJ.CORE_PROJECT);
        const shouldBeInLayoutExperiment = !isMobile && isSoftwareOrBusiness && isFullIssueView;
        const shouldBeInLayoutExperimentAndTabLayoutEnabled = (0, $4cTDP.fg)('issue_view_tab_layout_feature_gate') && shouldBeInLayoutExperiment;
        if (!shouldBeInLayoutExperiment) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isInTabLayoutExperiment = shouldBeInLayoutExperimentAndTabLayoutEnabled && (0, $cxKOj.expVal)('issue_view_tab_layout_experiment', 'isTabLayoutEnabled', false);
        const isInWideLayoutExperiment = shouldBeInLayoutExperiment && (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false);
        const isInDiscussionLayoutExperiment = shouldBeInLayoutExperiment && (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false);
        const isInLayoutExperiment = isInWideLayoutExperiment || isInDiscussionLayoutExperiment || isInTabLayoutExperiment;
        const userLayoutType = isInLayoutExperiment && userPreferredLayout && typeof userPreferredLayout === 'string' ? JSON.parse(userPreferredLayout)?.layoutType : null;
        /* eslint-enable react-hooks/rules-of-hooks */ let userSelectedLayout = userLayoutType;
        if (!(0, $4cTDP.fg)('thor-make-layout-options-work-together')) {
            if (isInLayoutExperiment && isInDiscussionLayoutExperiment && userLayoutType === 'WIDE') userSelectedLayout = 'STANDARD';
            if (isInLayoutExperiment && isInWideLayoutExperiment && userLayoutType === 'DISCUSSION') userSelectedLayout = 'STANDARD';
        }
        // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
        // but we keep it to avoid making too many changes in the codebase
        const isActivityInVerticalSidePanel = isInDiscussionLayoutExperiment && userSelectedLayout === 'DISCUSSION';
        return {
            isInDiscussionLayoutExperiment: Boolean(isInDiscussionLayoutExperiment),
            isInWideLayoutExperiment: Boolean(isInWideLayoutExperiment),
            isInLayoutExperiment: Boolean(isInLayoutExperiment),
            // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
            // but we keep it to avoid making too many changes in the codebase
            isActivityInVerticalSidePanel: Boolean(isActivityInVerticalSidePanel),
            userPreferredLayout: userSelectedLayout
        };
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `Error in useUserPreferredWorkItemLayout : ${error}`);
        return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
    }
};
const $3b984a26137eed7b$export$9889eea62fdfa091 = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('issue_layout_rule_of_hook_fix'), $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOn, $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOff);
const $3b984a26137eed7b$export$1e5e9fc877a47cd9 = ()=>{
    const [, actions] = (0, $lpEwy.useIssueLayoutActionsStore)();
    const setIssueViewContainersLayout = (0, $eJOHy.useCallback)((issueKey, containersByType)=>{
        actions.setIssueViewContainersLayout(issueKey, containersByType);
    }, [
        actions
    ]);
    const setIssueViewLayoutGlance = (0, $eJOHy.useCallback)((issueKey, glance)=>{
        actions.setIssueViewLayoutGlance(issueKey, glance);
    }, [
        actions
    ]);
    const setIssueViewLayoutContextPanel = (0, $eJOHy.useCallback)((issueKey, newContextPanel)=>{
        actions.setIssueViewLayoutContextPanel(issueKey, newContextPanel);
    }, [
        actions
    ]);
    return [
        null,
        {
            setIssueViewContainersLayout: setIssueViewContainersLayout,
            setIssueViewLayoutGlance: setIssueViewLayoutGlance,
            setIssueViewLayoutContextPanel: setIssueViewLayoutContextPanel
        }
    ];
};
/**
 * useRouteToGetQueryParams hook
 * This hook retrieves the current query parameters from the router state.
 * It is used to access the active tab and other query parameters in the issue view layout.
 */ const $3b984a26137eed7b$var$useRouteToGetQueryParams = (0, $kfvK2.createRouterSelector)((state)=>{
    return state.query;
});
const $3b984a26137eed7b$export$b027791af8c9b114 = ()=>{
    const { activeTab: activeTab = $3b984a26137eed7b$var$defaultActiveTab, ...otherQueryParams } = $3b984a26137eed7b$var$useRouteToGetQueryParams();
    const { updateQueryParam: updateQueryParam } = (0, $kfvK2.useRouterStoreActions)();
    const setActiveTab = (0, $eJOHy.useCallback)((tab)=>{
        if (activeTab !== tab) updateQueryParam({
            ...otherQueryParams,
            activeTab: tab
        }, 'replace');
    }, [
        activeTab,
        otherQueryParams,
        updateQueryParam
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            setDescriptionAsActive: ()=>setActiveTab($3b984a26137eed7b$var$Tabs.Description),
            setWorkItemsAsActive: ()=>setActiveTab($3b984a26137eed7b$var$Tabs.WorkItems),
            setIntegrationsAsActive: ()=>setActiveTab($3b984a26137eed7b$var$Tabs.Integrations),
            setResourcesAsActive: ()=>setActiveTab($3b984a26137eed7b$var$Tabs.Resources),
            currentActiveTab: activeTab
        }), [
        activeTab,
        setActiveTab
    ]);
};

});
parcelRegister("pz0Wh", function(module, exports) {
$parcel$export(module.exports, "useEnabledHiddenFields", () => $437c493a8e065bc6$export$bb6c2b9159c3f32b);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $i7n3g = parcelRequire("i7n3g");

var $4Swsy = parcelRequire("4Swsy");
const $437c493a8e065bc6$export$bb6c2b9159c3f32b = ()=>{
    (0, $gRw8I.di)((0, $i7n3g.useAdjustmentsEnabled), (0, $4Swsy.useHiddenFields));
    const adjustmentsAreEnabled = (0, $i7n3g.useAdjustmentsEnabled)();
    const hiddenFields = (0, $4Swsy.useHiddenFields)();
    return (0, $eJOHy.useMemo)(()=>{
        if (!adjustmentsAreEnabled) return [];
        return hiddenFields;
    }, [
        adjustmentsAreEnabled,
        hiddenFields
    ]);
};

});
parcelRegister("i7n3g", function(module, exports) {
$parcel$export(module.exports, "store", () => $35b1fa370eb6f514$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustmentsEnabled", () => $35b1fa370eb6f514$export$358ad850b2f6d6fe);
$parcel$export(module.exports, "useAdjustmentsContextActions", () => $35b1fa370eb6f514$export$4f2729981f4b81d2);
$parcel$export(module.exports, "UiModificationContextContainer", () => $35b1fa370eb6f514$export$5eb9c167b683d125);

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $35b1fa370eb6f514$var$initialState = {
    shouldUiModificationsLoad: 'unknown',
    hasFinishedLoading: false,
    adjustmentsAreEnabled: false,
    uiModificationsConsentStatus: {}
};
const $35b1fa370eb6f514$export$e324594224ef24da = {
    resetAdjustmentContext: ()=>({ setState: setState })=>{
            setState($35b1fa370eb6f514$var$initialState);
        },
    setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
            setState({
                shouldUiModificationsLoad: status
            });
        },
    setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
            setState({
                hasFinishedLoading: hasFinishedLoading
            });
        },
    setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
            setState({
                adjustmentsAreEnabled: enabled
            });
        },
    setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
            const currentConsentState = getState().uiModificationsConsentStatus;
            setState({
                uiModificationsConsentStatus: {
                    ...currentConsentState,
                    [appId]: status
                }
            });
        }
};
const $35b1fa370eb6f514$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'issue-adjustments-context',
    initialState: $35b1fa370eb6f514$var$initialState,
    actions: $35b1fa370eb6f514$export$e324594224ef24da
});
const $35b1fa370eb6f514$export$a12f82a132dee079 = (0, $iJq0l.createHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9);
const $35b1fa370eb6f514$export$358ad850b2f6d6fe = (0, $iJq0l.createStateHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9, {
    selector: (state)=>state.adjustmentsAreEnabled
});
const $35b1fa370eb6f514$export$4f2729981f4b81d2 = (0, $iJq0l.createActionsHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9);
const $35b1fa370eb6f514$export$5eb9c167b683d125 = (0, $6E16M.createContainer)($35b1fa370eb6f514$export$6f57813fe9f31bf9, {
    displayName: 'UiModificationContextContainer'
});

});

parcelRegister("4Swsy", function(module, exports) {
$parcel$export(module.exports, "useHiddenFields", () => $8e2f20b0b0e23b91$export$de6fdc67c945e596);

var $4MchI = parcelRequire("4MchI");
var $iJq0l = parcelRequire("iJq0l");

var $ixrOr = parcelRequire("ixrOr");
const $8e2f20b0b0e23b91$var$selectHiddenFields = (0, $4MchI.createSelector)((state)=>state.formData, (state)=>state.appliedChanges, (formData, appliedChanges)=>{
    if (formData === null) return [];
    return Object.entries(formData).filter(([fieldId, field])=>appliedChanges?.[fieldId]?.isVisible !== undefined ? !appliedChanges[fieldId].isVisible : !field.isVisible).map(([fieldId])=>fieldId);
});
const $8e2f20b0b0e23b91$export$de6fdc67c945e596 = (0, $iJq0l.createStateHook)((0, $ixrOr.store), {
    selector: $8e2f20b0b0e23b91$var$selectHiddenFields
});

});
parcelRegister("ixrOr", function(module, exports) {
$parcel$export(module.exports, "store", () => $3142574379bc5921$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustedField", () => $3142574379bc5921$export$df4b0714e8177e0e);
$parcel$export(module.exports, "useIssueAdjustmentsActions", () => $3142574379bc5921$export$cb9a014ec14556d8);
$parcel$export(module.exports, "useAdjustedScreenTabs", () => $3142574379bc5921$export$677b3e34bd14c681);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4XahM = parcelRequire("4XahM");

var $4CM51 = parcelRequire("4CM51");

var $aub9z = parcelRequire("aub9z");

var $cJU1r = parcelRequire("cJU1r");

var $2A1rz = parcelRequire("2A1rz");

var $jfSsT = parcelRequire("jfSsT");

var $hUz0e = parcelRequire("hUz0e");

var $8ZmJu = parcelRequire("8ZmJu");

var $cXMA2 = parcelRequire("cXMA2");

var $5qpxn = parcelRequire("5qpxn");

var $9w3dh = parcelRequire("9w3dh");

var $fkUIk = parcelRequire("fkUIk");

var $bfBqP = parcelRequire("bfBqP");

var $fY47y = parcelRequire("fY47y");

var $dmz3j = parcelRequire("dmz3j");
const $3142574379bc5921$var$name = 'issue-adjustments';
const $3142574379bc5921$export$d4c72bab9d6cc13a = {
    formData: null,
    screenTabs: null,
    appliedChanges: null,
    error: null,
    registeredFieldsDeprecated: {},
    registeredFields: {},
    triggerFieldInitializationKey: 0,
    // Selector checks if this is not equal 0 in the useFieldReady
    numberOfSupportedFields: 0,
    internalFormMetadata: {},
    viewType: null,
    experienceDataIsLoading: false,
    lastProcessedChange: null,
    fieldsInitialization: {
        startTime: null,
        timeoutId: undefined,
        status: 'notStarted'
    },
    appliedChangesHistory: {},
    appsErrors: {},
    notification: null
};
// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
const { triggerFieldInitializationKey: $3142574379bc5921$var$triggerFieldInitializationKey, viewType: $3142574379bc5921$var$scopedViewType, numberOfSupportedFields: $3142574379bc5921$var$numberOfSupportedFields, ...$3142574379bc5921$var$stateForResetAllFields } = $3142574379bc5921$export$d4c72bab9d6cc13a;
const $3142574379bc5921$export$e324594224ef24da = {
    triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
            setState({
                triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
            });
        },
    processChange: $5qpxn.processChange,
    setFieldValue: $fkUIk.setFieldValue,
    initializeField: $jfSsT.initializeField,
    initializeFields: $jfSsT.initializeFields,
    startFieldsInitialisationTimeout: $2A1rz.startFieldsInitialisationTimeout,
    successFieldsInitalisation: $2A1rz.successFieldsInitalisation,
    registerFields: $9w3dh.registerFields,
    unregisterFields: $9w3dh.unregisterFields,
    updateFields: $fY47y.updateFields,
    clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appliedChanges || {};
            if (previousState[fieldId]) {
                const { value: value, ...otherFieldChanges } = previousState[fieldId];
                setState({
                    appliedChanges: {
                        ...previousState,
                        [fieldId]: otherFieldChanges
                    }
                });
            }
        },
    resetAllFields: ()=>({ setState: setState, getState: getState })=>{
            // Clear the fieldsInitialization timeout to avoid potetianl side effects.
            clearTimeout(getState().fieldsInitialization.timeoutId);
            setState($3142574379bc5921$var$stateForResetAllFields);
        },
    setError: $cJU1r.setError,
    resetError: $cJU1r.resetError,
    setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
            setState({
                numberOfSupportedFields: numberOfAllSupportedFields
            });
        },
    /**
	 * This is used to block onInit for specific case like Issue View background refresh loading.
	 */ setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
            setState({
                experienceDataIsLoading: experienceDataIsLoading
            });
        },
    setAppErrors: $4XahM.setAppErrors,
    resetAppErrors: $4XahM.resetAppErrors,
    addAppsErrors: $4XahM.addAppsErrors,
    initializeNoScreenTab: $hUz0e.initializeNoScreenTab,
    initializeScreenTabs: $8ZmJu.initializeScreenTabs,
    updateScreenTabs: $dmz3j.updateScreenTabs,
    updateActiveScreenTab: $bfBqP.updateActiveScreenTab,
    detectAppliedChangesConflicts: $4CM51.detectAppliedChangesConflicts,
    collectScreenTabsAppliedChangesHistory: $aub9z.collectScreenTabsAppliedChangesHistory,
    collectFieldsAppliedChangesHistory: $aub9z.collectFieldsAppliedChangesHistory,
    setNotification: $cXMA2.setNotification,
    resetNotification: $cXMA2.resetNotification
};
const $3142574379bc5921$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: $3142574379bc5921$var$name,
    initialState: $3142574379bc5921$export$d4c72bab9d6cc13a,
    actions: $3142574379bc5921$export$e324594224ef24da
});
const $3142574379bc5921$export$37792a602e748c08 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9);
const $3142574379bc5921$var$stableEmptyFieldFromIframe = {};
const $3142574379bc5921$export$c76e674a29843e21 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state)=>state.appliedChanges
});
const $3142574379bc5921$export$df4b0714e8177e0e = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state, fieldId)=>state.appliedChanges?.[fieldId] || $3142574379bc5921$var$stableEmptyFieldFromIframe
});
const $3142574379bc5921$export$cb9a014ec14556d8 = (0, $iJq0l.createActionsHook)($3142574379bc5921$export$6f57813fe9f31bf9);
const $3142574379bc5921$export$677b3e34bd14c681 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state)=>state.screenTabs
});

});
parcelRegister("4XahM", function(module, exports) {
$parcel$export(module.exports, "setAppErrors", () => $5579267a84760bc0$export$7054e2f8e68cf0dd);
$parcel$export(module.exports, "addAppsErrors", () => $5579267a84760bc0$export$903d525e420c7d00);
$parcel$export(module.exports, "resetAppErrors", () => $5579267a84760bc0$export$24c821207687a907);
const $5579267a84760bc0$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: errors
            }
        });
    };
const $5579267a84760bc0$export$903d525e420c7d00 = ({ errors: errors })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        const appsErrors = Object.entries(errors).reduce((acc, [appId, appErrors])=>{
            acc[appId] = [
                ...acc[appId] ?? [],
                ...appErrors
            ];
            return acc;
        }, {
            ...previousState
        });
        setState({
            appsErrors: appsErrors
        });
    };
const $5579267a84760bc0$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: null
            }
        });
    };

});

parcelRegister("4CM51", function(module, exports) {
$parcel$export(module.exports, "detectAppliedChangesConflicts", () => $8731ff5311f46f9c$export$90d94f20d157e756);

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");


var $4XahM = parcelRequire("4XahM");

var $cXMA2 = parcelRequire("cXMA2");

var $7Agw7 = parcelRequire("7Agw7");
const $8731ff5311f46f9c$var$HISTORY_LOG_TTL = 60000;
/**
 * Tidies up applied changes history by removing old entries by TTL.
 * It keeps the current changeId in history.
 */ const $8731ff5311f46f9c$var$tidyUpAppliedChangesHistory = (appliedChangesHistory, changeId)=>Object.fromEntries(Object.entries(appliedChangesHistory).filter(([existingChangeId, history])=>{
        return Date.now() - history.createdAt <= $8731ff5311f46f9c$var$HISTORY_LOG_TTL || existingChangeId === changeId;
    }));
const $8731ff5311f46f9c$export$90d94f20d157e756 = ({ appId: appId, changeId: changeId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        const tidyAppliedChangesHistory = $8731ff5311f46f9c$var$tidyUpAppliedChangesHistory(appliedChangesHistory, changeId);
        setState({
            appliedChangesHistory: tidyAppliedChangesHistory
        });
        const appliedChangesHistoryChangeId = tidyAppliedChangesHistory[changeId];
        const newChanges = appliedChangesHistoryChangeId?.apps[appId];
        if (!appliedChangesHistoryChangeId || !newChanges || // No need to run conflicts checks for the first item in history
        Object.keys(appliedChangesHistoryChangeId.apps).length <= 1) return;
        const lifecycleHook = changeId === (0, $e65702a72ab5ec3d$export$415cc1afa6445f90) ? 'onInit' : 'onChange';
        const { appErrorsMap: appErrorsMap, conflicts: conflicts } = (0, $7Agw7.collectConflicts)({
            appliedChangesHistory: appliedChangesHistoryChangeId.apps,
            newChanges: newChanges,
            appIdOfNewChanges: appId,
            lifecycleHook: lifecycleHook
        });
        if (conflicts.length) {
            (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'conflicted',
                actionSubject: 'jiraUiModifications.appliedChangesHistory',
                attributes: {
                    conflictsCount: conflicts.length,
                    conflicts: conflicts,
                    conflictedApps: Object.keys(appErrorsMap),
                    viewType: viewType
                }
            });
            dispatch((0, $4XahM.addAppsErrors)({
                errors: appErrorsMap
            }));
            dispatch((0, $cXMA2.setNotification)({
                type: 'MULTIPLE_APPS_CONFLICTS'
            }));
        }
    };

});
parcelRegister("jgvEH", function(module, exports) {
$parcel$export(module.exports, "fireOperationalEvent", () => $cbc5413d6b6dbcfa$export$a1fb57756f0de62b);

var $5fWw9 = parcelRequire("5fWw9");


const $cbc5413d6b6dbcfa$export$a1fb57756f0de62b = (createAnalyticsEvent, eventPayload)=>{
    (0, $5fWw9.default)((0, $0390845c0b61b1a1$export$8280e5c6104c5b40))({
        ...eventPayload,
        analyticsType: (0, $e9db81972dce4ebc$export$12346a674644c156)
    })(createAnalyticsEvent);
};

});
const $e9db81972dce4ebc$export$f636b5b56f1d624a = 'Screen';
const $e9db81972dce4ebc$export$9d2de6eebf7462b5 = 'Drawer';
const $e9db81972dce4ebc$export$1171103ea9083ffa = 'Modal';
const $e9db81972dce4ebc$export$cae2783c9279926 = 'InlineDialog';
const $e9db81972dce4ebc$export$d1123261ca8831d2 = 'Dropdown';
const $e9db81972dce4ebc$export$a1562d08625f5d7e = 'UI';
const $e9db81972dce4ebc$export$947dac6c72b26f81 = 'TRACK';
const $e9db81972dce4ebc$export$f1d537d508d2945a = 'SCREEN';
const $e9db81972dce4ebc$export$12346a674644c156 = 'OPERATIONAL';
const $e9db81972dce4ebc$export$2ceccf177fae277c = 'analyticsBridge';

const $0390845c0b61b1a1$export$8280e5c6104c5b40 = 'ui-modifications';


const $e65702a72ab5ec3d$export$415cc1afa6445f90 = 'onInitChangeId';
const $e65702a72ab5ec3d$export$811b7f067a43b422 = 'jira:uiModifications';

parcelRegister("cXMA2", function(module, exports) {
$parcel$export(module.exports, "setNotification", () => $c89e780a89ca3c37$export$b9c5e783593ff01d);
$parcel$export(module.exports, "resetNotification", () => $c89e780a89ca3c37$export$caafa3945f199bc7);
const $c89e780a89ca3c37$export$b9c5e783593ff01d = (notificationProperties)=>({ setState: setState })=>{
        setState({
            notification: {
                type: notificationProperties.type
            }
        });
    };
const $c89e780a89ca3c37$export$caafa3945f199bc7 = ()=>({ setState: setState })=>{
        setState({
            notification: null
        });
    };

});

parcelRegister("7Agw7", function(module, exports) {
$parcel$export(module.exports, "collectConflicts", () => $6ecf22ae7e9f4956$export$a06103ec99e4e394);

var $jFHCE = parcelRequire("jFHCE");


var $5sAot = parcelRequire("5sAot");

const $6ecf22ae7e9f4956$var$MESSAGE_SUFFIX = 'Modifications have been applied, but it may lead to inconsistency for the user.';
const $6ecf22ae7e9f4956$var$mapToAppErrors = ({ conflicts: conflicts, lifecycleHook: lifecycleHook })=>{
    const appErrors = conflicts.map((change)=>{
        if (change.type === (0, $702a64456849b1c0$export$f674b7a3bbd94b5)) return {
            type: (0, $585e8f7167f61808$export$2a3fdceaae2188d5),
            cause: (0, $585e8f7167f61808$export$877da1000325f8b5),
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified screen tabs in the '${lifecycleHook}' at the same trigger. ${$6ecf22ae7e9f4956$var$MESSAGE_SUFFIX}`
        };
        const { fieldId: fieldId, fieldType: fieldType, property: property } = change;
        const method = (0, $5sAot.mapFieldPropertyToApiMethod)(property);
        return {
            type: (0, $585e8f7167f61808$export$2a3fdceaae2188d5),
            cause: (0, $585e8f7167f61808$export$e4ac32edd5da2ee7),
            fieldId: fieldId,
            fieldType: fieldType,
            method: method,
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified the same field: '${fieldId}' by its method: '${method}' in the '${lifecycleHook}' at the same trigger. ${$6ecf22ae7e9f4956$var$MESSAGE_SUFFIX}`
        };
    });
    return appErrors;
};
const $6ecf22ae7e9f4956$export$a06103ec99e4e394 = ({ appliedChangesHistory: appliedChangesHistory, newChanges: newChanges, appIdOfNewChanges: appIdOfNewChanges, lifecycleHook: lifecycleHook })=>{
    return Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(appliedChangesHistory, appIdOfNewChanges)).reduce((acc, [appId, previousChanges])=>{
        const previousChangesKeys = Object.keys(previousChanges);
        // Compares previous changes with new changes keys
        const conflicts = Object.entries(newChanges).filter(([changeKey, _])=>previousChangesKeys.includes(changeKey)).map(([_, change])=>({
                ...change,
                lifecycleHook: lifecycleHook,
                appIds: [
                    appId,
                    appIdOfNewChanges
                ]
            }));
        acc.conflicts.push(...conflicts);
        // Maps conflicts to app errors
        const appErrors = $6ecf22ae7e9f4956$var$mapToAppErrors({
            conflicts: conflicts,
            lifecycleHook: lifecycleHook
        });
        if (appErrors.length > 0) {
            acc.appErrorsMap[appId] = appErrors;
            // App errors for `appIdOfNewChanges` may already exists from the previous iteration.
            // We need to merge them to avoid overwriting and keep all errors.
            acc.appErrorsMap[appIdOfNewChanges] = [
                ...acc.appErrorsMap[appIdOfNewChanges] ?? [],
                ...appErrors
            ];
        }
        return acc;
    }, {
        appErrorsMap: {},
        conflicts: []
    });
};

});
const $585e8f7167f61808$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $585e8f7167f61808$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $585e8f7167f61808$export$8042247b663edbcc = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
const $585e8f7167f61808$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $585e8f7167f61808$export$e4ac32edd5da2ee7 = 'FIELD';
const $585e8f7167f61808$export$877da1000325f8b5 = 'SCREENTABS';

parcelRegister("5sAot", function(module, exports) {
$parcel$export(module.exports, "mapFieldPropertyToApiMethod", () => $2728f69de31c50a0$export$e1cc7da28a1c4bb7);
const $2728f69de31c50a0$var$SET_NAME_METHOD = 'setName';
const $2728f69de31c50a0$var$SET_DESCRIPTION_METHOD = 'setDescription';
const $2728f69de31c50a0$var$SET_VISIBLE_METHOD = 'setVisible';
const $2728f69de31c50a0$var$SET_READ_ONLY_METHOD = 'setReadOnly';
const $2728f69de31c50a0$var$SET_VALUE_METHOD = 'setValue';
const $2728f69de31c50a0$var$SET_REQUIRED_METHOD = 'setRequired';
const $2728f69de31c50a0$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
const $2728f69de31c50a0$export$8325709d137b2606 = {
    fieldName: $2728f69de31c50a0$var$SET_NAME_METHOD,
    description: $2728f69de31c50a0$var$SET_DESCRIPTION_METHOD,
    isVisible: $2728f69de31c50a0$var$SET_VISIBLE_METHOD,
    isReadOnly: $2728f69de31c50a0$var$SET_READ_ONLY_METHOD,
    value: $2728f69de31c50a0$var$SET_VALUE_METHOD,
    isRequired: $2728f69de31c50a0$var$SET_REQUIRED_METHOD,
    optionsVisibility: $2728f69de31c50a0$var$SET_OPTIONS_VISIBILITY_METHOD
};
const $2728f69de31c50a0$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
    const method = $2728f69de31c50a0$export$8325709d137b2606[fieldProperty];
    if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
    return method;
};

});

const $702a64456849b1c0$export$f674b7a3bbd94b5 = 'SCREEN_TABS';
const $702a64456849b1c0$export$4a9f236a0db33834 = 'FIELD';



parcelRegister("aub9z", function(module, exports) {
$parcel$export(module.exports, "collectScreenTabsAppliedChangesHistory", () => $94bb1a042906c320$export$1d2b7abeeea36239);
$parcel$export(module.exports, "collectFieldsAppliedChangesHistory", () => $94bb1a042906c320$export$7d0f534e5b16dcc9);


var $gD9lZ = parcelRequire("gD9lZ");
const $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange = ({ currentAppliedChangesHistory: currentAppliedChangesHistory, appId: appId, changeId: changeId, newSingleAppChange: newSingleAppChange })=>{
    const appliedChangesHistoryChangeId = currentAppliedChangesHistory[changeId] ?? {};
    const appliedChangesHistoryChangeIdApp = appliedChangesHistoryChangeId.apps?.[appId] ?? {};
    return {
        ...currentAppliedChangesHistory,
        [changeId]: {
            apps: {
                ...appliedChangesHistoryChangeId.apps,
                [appId]: {
                    ...appliedChangesHistoryChangeIdApp,
                    ...newSingleAppChange
                }
            },
            createdAt: appliedChangesHistoryChangeId.createdAt ?? Date.now()
        }
    };
};
const $94bb1a042906c320$export$1d2b7abeeea36239 = ({ appId: appId, changeId: changeId, screenTabs: screenTabs })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        if (!screenTabs.length) return;
        const newAppliedChangesHistory = $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: {
                tabs: {
                    type: (0, $702a64456849b1c0$export$f674b7a3bbd94b5)
                }
            }
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };
const $94bb1a042906c320$export$7d0f534e5b16dcc9 = ({ appId: appId, changeId: changeId, fieldsChanges: fieldsChanges })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory, internalFormMetadata: internalFormMetadata } = getState();
        const singleAppChange = (0, $gD9lZ.normalizeFieldsAppliedChangesForHistory)({
            fieldsChanges: fieldsChanges,
            internalFormMetadata: internalFormMetadata
        });
        const newAppliedChangesHistory = $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: singleAppChange
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };

});
parcelRegister("gD9lZ", function(module, exports) {
$parcel$export(module.exports, "normalizeFieldsAppliedChangesForHistory", () => $b80c31bd414cd9d4$export$8a23b3e9a1749620);

const $b80c31bd414cd9d4$var$normalizeFieldForHistory = (fieldId, fieldChanges, fieldMetadata)=>{
    // Can't type Object.keys in a better way
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(fieldChanges).reduce((acc, property)=>{
        const normalizedKey = `${fieldId}|${property}`;
        acc[normalizedKey] = {
            fieldId: fieldId,
            fieldType: fieldMetadata.fieldType,
            property: property,
            type: (0, $702a64456849b1c0$export$4a9f236a0db33834)
        };
        return acc;
    }, {});
};
const $b80c31bd414cd9d4$export$8a23b3e9a1749620 = ({ fieldsChanges: fieldsChanges, internalFormMetadata: internalFormMetadata })=>{
    return Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldChanges])=>{
        const fieldMetadata = internalFormMetadata[fieldId];
        if (!fieldMetadata) return acc;
        const normalizedFieldHistory = $b80c31bd414cd9d4$var$normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata);
        Object.assign(acc, normalizedFieldHistory);
        return acc;
    }, {});
};

});


parcelRegister("cJU1r", function(module, exports) {
$parcel$export(module.exports, "setError", () => $60a309f31f0bb435$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "resetError", () => $60a309f31f0bb435$export$7e5930c6217b1d4e);
const $60a309f31f0bb435$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
        setState({
            error: {
                errorCode: errorProperties.errorCode,
                fieldName: errorProperties.fieldName
            }
        });
    };
const $60a309f31f0bb435$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
        setState({
            error: null
        });
    };

});

parcelRegister("2A1rz", function(module, exports) {
$parcel$export(module.exports, "startFieldsInitialisationTimeout", () => $601c25cd313fe741$export$2c0f020b89dfa30b);
$parcel$export(module.exports, "successFieldsInitalisation", () => $601c25cd313fe741$export$cf768a695e83eefa);

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");

var $ieQ0v = parcelRequire("ieQ0v");

var $cJU1r = parcelRequire("cJU1r");
const $601c25cd313fe741$var$getTimeout = ()=>50000;
const $601c25cd313fe741$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
const $601c25cd313fe741$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
const $601c25cd313fe741$export$2c0f020b89dfa30b = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { fieldsInitialization: fieldsInitialization } = getState();
        if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
            const timeoutId = setTimeout(()=>dispatch($601c25cd313fe741$export$8ce83a9201590a5e({
                    createAnalyticsEvent: createAnalyticsEvent
                })), $601c25cd313fe741$var$getTimeout());
            setState({
                fieldsInitialization: {
                    startTime: performance.now(),
                    timeoutId: timeoutId,
                    status: 'inProgress'
                }
            });
        }
    };
const $601c25cd313fe741$export$8ce83a9201590a5e = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { startTime: startTime, status: status } = fieldsInitialization;
        if ($601c25cd313fe741$var$isFieldInitialisationComplete(status) || (0, $ieQ0v.selectReadyPublicDataForOnInit)(getState(), {
            viewType: viewType
        }) !== null) return;
        dispatch((0, $cJU1r.setError)({
            errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
        }));
        (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'timedOut',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                configuredTimeout: $601c25cd313fe741$var$getTimeout(),
                fieldsInitializationTime: $601c25cd313fe741$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: Object.keys(formData ?? {}).length,
                experienceDataIsLoading: experienceDataIsLoading,
                supportedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'timedOut'
            }
        });
    };
const $601c25cd313fe741$export$cf768a695e83eefa = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { status: status } = getState().fieldsInitialization;
        if ($601c25cd313fe741$var$isFieldInitialisationComplete(status)) return;
        const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
        clearTimeout(timeoutId);
        (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                fieldsInitializationTime: $601c25cd313fe741$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'success'
            }
        });
    };

});
parcelRegister("ieQ0v", function(module, exports) {
$parcel$export(module.exports, "selectReadyPublicDataForOnInit", () => $d3350efc4111ec81$export$4cadeedb8c3f31f7);

var $4MchI = parcelRequire("4MchI");
const $d3350efc4111ec81$export$4cadeedb8c3f31f7 = (0, $4MchI.createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
    if (formData !== null && screenTabsData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: screenTabsData
    };
    return null;
});

});


parcelRegister("jfSsT", function(module, exports) {
$parcel$export(module.exports, "initializeField", () => $a40b94674a995fd7$export$6b51e123e61a9615);
$parcel$export(module.exports, "initializeFields", () => $a40b94674a995fd7$export$4a6b4707110b0552);

var $37MnT = parcelRequire("37MnT");
const $a40b94674a995fd7$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
        const fieldMetadata = {
            allowedValues: field.allowedValues,
            isReadOnlyBySystem: field.isReadOnly,
            isRequiredBySystem: field.isRequired,
            fieldRenderer: metadata?.fieldRenderer,
            fieldType: field.fieldType
        };
        const publicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
            fieldMetadata: fieldMetadata,
            internalFieldValue: field.value,
            fieldType: field.fieldType,
            viewType: viewType
        });
        setState({
            formData: {
                ...formData,
                [field.fieldId]: {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                }
            },
            internalFormMetadata: {
                ...internalFormMetadata,
                [field.fieldId]: fieldMetadata
            }
        });
    };
const $a40b94674a995fd7$export$4a6b4707110b0552 = (fields)=>({ setState: setState }, { viewType: viewType })=>{
        const { formData: formData, internalFormMetadata: internalFormMetadata } = fields.reduce((acc, { field: field, metadata: metadata })=>{
            const fieldMetadata = {
                allowedValues: field.allowedValues,
                isReadOnlyBySystem: field.isReadOnly,
                isRequiredBySystem: field.isRequired,
                fieldRenderer: metadata?.fieldRenderer,
                fieldType: field.fieldType
            };
            const publicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
                fieldMetadata: fieldMetadata,
                internalFieldValue: field.value,
                fieldType: field.fieldType,
                viewType: viewType
            });
            acc.formData[field.fieldId] = {
                fieldId: field.fieldId,
                fieldName: field.fieldName,
                description: field.description,
                isVisible: field.isVisible,
                fieldType: field.fieldType,
                isReadOnly: field.isReadOnly,
                isRequired: field.isRequired,
                value: publicValue,
                optionsVisibility: undefined
            };
            acc.internalFormMetadata[field.fieldId] = fieldMetadata;
            return acc;
        }, {
            internalFormMetadata: {},
            formData: {}
        });
        setState({
            formData: formData,
            internalFormMetadata: internalFormMetadata,
            numberOfSupportedFields: fields.length
        });
    };

});
parcelRegister("37MnT", function(module, exports) {
$parcel$export(module.exports, "mapFieldValueFromInternalToPublic", () => $cc8ab347810a3948$export$50806045b617d116);

var $gRw8I = parcelRequire("gRw8I");

var $1qarT = parcelRequire("1qarT");

var $82wKS = parcelRequire("82wKS");
const $cc8ab347810a3948$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
    (0, $gRw8I.di)((0, $1qarT.fireErrorAnalytics), (0, $82wKS.getSupportedFieldConfiguration));
    if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
    let value = internalFieldValue;
    try {
        const valueTransformer = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType)?.internalToPublicTransformers.value;
        if (valueTransformer) /**
			 * We trust that the internal field data is in the correct shape.
			 * Data that is in the incorrect shape will result in error events
			 * being logged for further investigation. In this error case we will
			 * pass `null` as the value to unblock onInit for the apps
			 *
			 * The `fieldRenderer` passed to the `valueTransformer` is used only for
			 * rich text fields and will be `undefined` for most of the executions
			 */ value = valueTransformer(internalFieldValue, fieldMetadata?.fieldRenderer);
    } catch (error) {
        value = null;
        (0, $1qarT.fireErrorAnalytics)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return value;
};

});
parcelRegister("1qarT", function(module, exports) {
$parcel$export(module.exports, "fireErrorAnalytics", () => $7486f28a569b9ec0$export$a27c21aa3ed8f0f1);

var $7U6OJ = parcelRequire("7U6OJ");

var $cMdIN = parcelRequire("cMdIN");
const $7486f28a569b9ec0$export$1bee4e6be783dd26 = (message)=>message.replaceAll(/\w+@[\w.]+/gi, '***@***');
const $7486f28a569b9ec0$export$a27c21aa3ed8f0f1 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $cMdIN.getErrorType)(error);
    const packageName = `${viewType}jiraUiModifications`;
    (0, $7U6OJ.fireErrorAnalytics)({
        event: event,
        meta: {
            id: id,
            packageName: packageName,
            teamName: 'unbox'
        },
        error: error,
        attributes: {
            errorType: errorType,
            errorMessage: typeof error.message === 'string' ? $7486f28a569b9ec0$export$1bee4e6be783dd26(error.message) : error.message,
            ...attributes
        }
    });
};

});
parcelRegister("cMdIN", function(module, exports) {
$parcel$export(module.exports, "getErrorType", () => $c511a0dff3897a12$export$e19f9f08a6d79fd2);

var $l58EO = parcelRequire("l58EO");
const $c511a0dff3897a12$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $c511a0dff3897a12$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $c511a0dff3897a12$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $c511a0dff3897a12$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $c511a0dff3897a12$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $c511a0dff3897a12$export$89a175d4190df42e = 'Invoke value functions failed:';
const $c511a0dff3897a12$export$215c097832f3122d = 'AGG_UNDERLYING_SERVICE_TIMEOUT';
const $c511a0dff3897a12$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $c511a0dff3897a12$var$BAD_REQUEST = 400;
const $c511a0dff3897a12$var$REQUEST_TIMEOUT = 408;
const $c511a0dff3897a12$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if (typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $c511a0dff3897a12$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $c511a0dff3897a12$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $c511a0dff3897a12$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($c511a0dff3897a12$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const aggUnderlyingServiceTimeoutRegex = new RegExp('The underlying service call timed out', 'i');
    if (aggUnderlyingServiceTimeoutRegex.test(message)) return $c511a0dff3897a12$export$215c097832f3122d;
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($c511a0dff3897a12$export$89a175d4190df42e, 'i');
    /**
	 * In case when we get bad request(400) from the BE it should be treated as an app error as there
	 * are many ways to fail the value function
	 */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === $c511a0dff3897a12$var$BAD_REQUEST;
    /**
	 * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
	 * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
	 */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === $c511a0dff3897a12$var$REQUEST_TIMEOUT;
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
	 * 	Whole message:
	 *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
	 */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
	 * 	Whole message:
	 *	Invoke value functions failed: Error server response: 429
	 */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $c511a0dff3897a12$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($c511a0dff3897a12$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($c511a0dff3897a12$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $l58EO.isClientFetchError)(error)) return $c511a0dff3897a12$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("l58EO", function(module, exports) {
$parcel$export(module.exports, "isClientFetchError", () => $cd5265fc67dbb6eb$export$2e7adc44463c3f4f);
// Copied from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Exclude client connectivity and HTTP client network errors as a SLO failure
// e.g. during quick SPA transition when a network call haven't finished yet,
// or when the user's internet connection drops out.
const $cd5265fc67dbb6eb$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $cd5265fc67dbb6eb$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $cd5265fc67dbb6eb$var$isClientFetchErrorMessage = (message)=>Boolean(message) && $cd5265fc67dbb6eb$export$c748438cec453c9f.some((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $cd5265fc67dbb6eb$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($cd5265fc67dbb6eb$export$3876cb851aa46193.includes(error.name) || $cd5265fc67dbb6eb$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($cd5265fc67dbb6eb$export$3876cb851aa46193.includes(error.cause.name) || $cd5265fc67dbb6eb$var$isClientFetchErrorMessage(error.cause.message)));

});



parcelRegister("82wKS", function(module, exports) {
$parcel$export(module.exports, "getSupportedFieldConfiguration", () => $0757a5b98ef450f3$export$8fc8d6775f1842b8);
$parcel$export(module.exports, "isFieldTypeSupported", () => $0757a5b98ef450f3$export$b47920a5dd99844f);
$parcel$export(module.exports, "getConsentMessage", () => $0757a5b98ef450f3$export$20eabd2b3ada6bf3);
$parcel$export(module.exports, "isExecutionContextSupported", () => $0757a5b98ef450f3$export$b768d6a95f7a930);
$parcel$export(module.exports, "getAnalytics", () => $0757a5b98ef450f3$export$b0297573c90085aa);
$parcel$export(module.exports, "isTriggerPointSupported", () => $0757a5b98ef450f3$export$ef45e4471aa21b27);

var $1qarT = parcelRequire("1qarT");

var $6beFf = parcelRequire("6beFf");
const $0757a5b98ef450f3$var$isKeyOf = (key, object)=>object[key] !== undefined;
const $0757a5b98ef450f3$var$getConfigurationByViewType = ({ viewType: viewType })=>{
    const viewConfiguration = (0, $6beFf.getViewConfiguration)(viewType);
    if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
    return viewConfiguration;
};
function $0757a5b98ef450f3$export$8fc8d6775f1842b8(viewType, fieldType) {
    const fieldsConfiguration = $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldsConfiguration();
    if (!$0757a5b98ef450f3$var$isKeyOf(fieldType, fieldsConfiguration)) {
        (0, $1qarT.fireErrorAnalytics)({
            error: new Error('Unsupported field type.'),
            id: 'getSupportedFieldConfiguration',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
        return undefined;
    }
    return fieldsConfiguration[fieldType];
}
const $0757a5b98ef450f3$export$e4330d77fd93d1de = (viewType)=>$0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldTypes();
function $0757a5b98ef450f3$export$b47920a5dd99844f(viewType, fieldType) {
    return fieldType !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $0757a5b98ef450f3$export$e4330d77fd93d1de(viewType).includes(fieldType);
}
function $0757a5b98ef450f3$export$20eabd2b3ada6bf3(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getConsentMessage();
}
function $0757a5b98ef450f3$export$b768d6a95f7a930(context) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: context.viewType
    }).isExecutionContextSupported({
        context: context
    });
}
function $0757a5b98ef450f3$export$b0297573c90085aa(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getAnalytics();
}
function $0757a5b98ef450f3$export$c0728caa743a409e(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedTriggerPointsConfiguration();
}
const $0757a5b98ef450f3$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $0757a5b98ef450f3$export$c0728caa743a409e(viewType).has(triggerPoint);

});
parcelRegister("6beFf", function(module, exports) {
$parcel$export(module.exports, "getViewConfiguration", () => $9cd8cd98b7c2eeee$export$176b6e68da08ffa2);
$parcel$export(module.exports, "useLoadViewConfigurationLegacy", () => $9cd8cd98b7c2eeee$export$b3752f1148ab95f);
$parcel$export(module.exports, "useLoadViewConfiguration", () => $9cd8cd98b7c2eeee$export$f0022a21ccd1f6be);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");
const $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS = new Map();
const $9cd8cd98b7c2eeee$export$cda1ad403b37fe70 = (viewType, configuration)=>{
    if (!$9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.has(viewType)) $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.set(viewType, configuration);
};
const $9cd8cd98b7c2eeee$export$176b6e68da08ffa2 = (viewType)=>$9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.get(viewType);
const $9cd8cd98b7c2eeee$export$e8091eff40c4f16e = ()=>{
    $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.clear();
};
const $9cd8cd98b7c2eeee$export$b3752f1148ab95f = (viewType, configurationClass)=>{
    (0, $gRw8I.di)($9cd8cd98b7c2eeee$export$cda1ad403b37fe70);
    /**
	 * Uses useState to load view configuration.
	 */ (0, $eJOHy.useState)(()=>{
        $9cd8cd98b7c2eeee$export$cda1ad403b37fe70(viewType, new configurationClass());
    });
};
const $9cd8cd98b7c2eeee$export$f0022a21ccd1f6be = (viewType, configurationClass)=>{
    (0, $gRw8I.di)($9cd8cd98b7c2eeee$export$cda1ad403b37fe70);
    /**
	 * Uses useMemo to load view configuration during the first render, before mount.
	 */ (0, $eJOHy.useMemo)(()=>{
        $9cd8cd98b7c2eeee$export$cda1ad403b37fe70(viewType, new configurationClass());
    }, [
        viewType,
        configurationClass
    ]);
};

});




parcelRegister("hUz0e", function(module, exports) {
$parcel$export(module.exports, "initializeNoScreenTab", () => $7faac090c61abadc$export$93459ad9bfd6c380);
const $7faac090c61abadc$export$93459ad9bfd6c380 = ()=>({ setState: setState })=>{
        setState({
            screenTabs: []
        });
    };

});

parcelRegister("8ZmJu", function(module, exports) {
$parcel$export(module.exports, "initializeScreenTabs", () => $5faefcecd8cba222$export$7f7be235f64f029b);
const $5faefcecd8cba222$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: internalScreenTabs } = getState();
        const previouslySelected = internalScreenTabs?.findIndex((tab)=>tab.isActive);
        setState({
            screenTabs: tabs.map(({ id: id }, index)=>({
                    id: id,
                    isVisible: true,
                    isActive: index === selected || index === previouslySelected
                }))
        });
    };

});

parcelRegister("5qpxn", function(module, exports) {
$parcel$export(module.exports, "processChange", () => $bbbbfc09b273134e$export$352dfcce04d66748);

var $9UJzd = parcelRequire("9UJzd");

var $gRw8I = parcelRequire("gRw8I");

var $82wKS = parcelRequire("82wKS");

var $5ldku = parcelRequire("5ldku");
const $bbbbfc09b273134e$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, (/*@__PURE__*/$parcel$interopDefault($9UJzd))));
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        const fieldType = internalFormMetadata[fieldId]?.fieldType;
        if (!fieldType) return;
        const emitChangeOn = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType)?.emitChangeOn;
        if (emitChangeOn !== eventType) return;
        const nextFormData = (0, $5ldku.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        /**
		 * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
		 * Otherwise, UIM app may not be notified about every single change.
		 */ setTimeout(()=>{
            const changeId = (0, (/*@__PURE__*/$parcel$interopDefault($9UJzd)))();
            setState({
                lastProcessedChange: {
                    fieldId: fieldId,
                    changeId: changeId
                },
                formData: nextFormData
            });
        }, 0);
    };

});
parcelRegister("9UJzd", function(module, exports) {

var $cz1WF = parcelRequire("cz1WF");
/** Used to generate unique IDs. */ var $737cb0a939387270$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $737cb0a939387270$var$uniqueId(prefix) {
    var id = ++$737cb0a939387270$var$idCounter;
    return $cz1WF(prefix) + id;
}
module.exports = $737cb0a939387270$var$uniqueId;

});

parcelRegister("5ldku", function(module, exports) {
$parcel$export(module.exports, "calculateNextFormValue", () => $e9fdc7a6e4eab5b9$export$25441a03bb8f1cb0);

var $cSmYj = parcelRequire("cSmYj");

var $37MnT = parcelRequire("37MnT");
const $e9fdc7a6e4eab5b9$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (formData === null) return null;
    let newPublicValue;
    try {
        newPublicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
            fieldMetadata: internalFormMetadata[fieldId],
            internalFieldValue: fieldValue,
            fieldType: fieldType,
            viewType: viewType
        });
    } catch (e) {
        return null;
    }
    const currentPublicValue = formData[fieldId]?.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(newPublicValue, currentPublicValue)) return null;
    return {
        ...formData,
        [fieldId]: {
            ...formData[fieldId],
            value: newPublicValue
        }
    };
};

});


parcelRegister("9w3dh", function(module, exports) {
$parcel$export(module.exports, "registerFields", () => $60e092cfdd3e6be9$export$d4eb181b231cf88d);
$parcel$export(module.exports, "unregisterFields", () => $60e092cfdd3e6be9$export$1ca69a85bb7273de);

var $jFHCE = parcelRequire("jFHCE");

var $jvwCK = parcelRequire("jvwCK");
const $60e092cfdd3e6be9$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
        if (!Array.isArray(fieldsToBeRegistered)) return;
        const { registeredFields: registeredFields } = getState();
        const appFields = registeredFields[appId] ?? {};
        const appChangeIdFields = appFields[changeId] ?? [];
        const nextRegisteredFields = {
            ...registeredFields,
            [appId]: {
                ...appFields,
                [changeId]: (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))([
                    ...appChangeIdFields,
                    ...fieldsToBeRegistered
                ])
            }
        };
        setState({
            registeredFields: nextRegisteredFields
        });
    };
const $60e092cfdd3e6be9$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
        const { registeredFields: registeredFields } = getState();
        const registeredAppFields = registeredFields[appId] ?? {};
        const nextRegisteredAppFields = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(registeredAppFields, changeId);
        setState({
            registeredFields: {
                ...registeredFields,
                [appId]: nextRegisteredAppFields
            }
        });
    };

});

parcelRegister("fkUIk", function(module, exports) {
$parcel$export(module.exports, "setFieldValue", () => $adb039aa861139a2$export$6556d46d2662453c);

var $5ldku = parcelRequire("5ldku");
const $adb039aa861139a2$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        /**
		 * We can set new field value only if the field was initialized.
		 * This checks the field metedata that indicates the successfull initialization.
		 */ if (!internalFormMetadata[fieldId]) return;
        const nextFormData = (0, $5ldku.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        setState({
            formData: nextFormData
        });
    };

});

parcelRegister("bfBqP", function(module, exports) {
$parcel$export(module.exports, "updateActiveScreenTab", () => $910f8611d1056e54$export$21363496760d39cd);
const $910f8611d1056e54$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: screenTabs } = getState();
        if (screenTabs) setState({
            screenTabs: screenTabs.map((tab, index)=>({
                    ...tab,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("fY47y", function(module, exports) {
$parcel$export(module.exports, "updateFields", () => $e5c83e79d4f29b58$export$cceae62fd4d1ef0a);

var $8dH3d = parcelRequire("8dH3d");

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");


var $6PplZ = parcelRequire("6PplZ");

var $81O8J = parcelRequire("81O8J");

var $cfL5m = parcelRequire("cfL5m");

var $3JMvu = parcelRequire("3JMvu");

var $82idB = parcelRequire("82idB");

var $lKslV = parcelRequire("lKslV");

var $4XahM = parcelRequire("4XahM");

var $aub9z = parcelRequire("aub9z");

var $TiFiE = parcelRequire("TiFiE");
const $e5c83e79d4f29b58$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, executionContext: executionContext, environment: environment, appId: appId, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $aub9z.collectFieldsAppliedChangesHistory));
        const appliedChanges = getState().appliedChanges ?? {};
        const formData = getState().formData ?? {};
        const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields, lastProcessedChange: lastProcessedChange } = getState();
        let isSameFieldValueChanged = false;
        const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField, newAppliedChangesPublic: newAppliedChangesPublic } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
            // Do not update fields that are not inside initialized data.
            // Validates if the field that comes from Iframe is supported
            // - because we add to formData only the supported ones.
            const fieldData = formData[fieldId];
            const internalMetadata = internalFormMetadata[fieldId];
            const fieldIsRegistered = (0, $cfL5m.fieldWasRegistered)(registeredFields, changeId, fieldId, appId);
            // Only registered field Ids can be updated.
            if (!fieldIsRegistered || !fieldData) {
                const { fieldType: fieldType } = fieldData ?? {};
                dispatch((0, $4XahM.addAppsErrors)({
                    errors: {
                        [appId]: [
                            {
                                fieldType: fieldType,
                                fieldId: fieldId,
                                type: 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD',
                                message: 'Application tried to apply changes to unregistered field'
                            }
                        ]
                    }
                }));
                (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'unregisteredField',
                    actionSubject: 'jiraUiModifications.applyChanges',
                    attributes: {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId,
                        viewType: viewType
                    }
                });
                return acc;
            }
            const lookupData = {
                [(0, $7f80bdb4337734ff$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                [(0, $7f80bdb4337734ff$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $7f80bdb4337734ff$export$3a106242c8f57ac2],
                [(0, $7f80bdb4337734ff$export$e10d4d251d909c59)]: lookupDataFromApi[0, $7f80bdb4337734ff$export$e10d4d251d909c59]
            };
            // It updates properties in each field to avoid removing unchanged props for
            // selected field by another app or another onChange update.
            // Only supported properties are allowed.
            const supportedFieldChanges = await (0, $TiFiE.transformFieldChangesToInternalShape)({
                fieldType: fieldData.fieldType,
                fieldId: fieldId,
                fieldFromIframe: fieldsChanges?.[fieldId],
                lookupData: lookupData,
                viewType: viewType,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                intl: intl
            });
            if (supportedFieldChanges.isValid === false) {
                (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                return acc;
            }
            // It converts changes to 'public' format to update the formData
            const publicShapeChanges = (0, $lKslV.transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
            const transformedFieldChanges = (0, $3JMvu.mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
            isSameFieldValueChanged = (0, $6PplZ.checkSameFieldValueChanged)(fieldsChanges, lastProcessedChange, changeId);
            const combinedChangesToApply = {
                ...appliedChanges[fieldId],
                ...transformedFieldChanges,
                isSameFieldValueChanged: isSameFieldValueChanged
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(combinedChangesToApply)) {
                (await acc).newAppliedChangesPublic[fieldId] = publicShapeChanges;
                (await acc).changesToApply[fieldId] = combinedChangesToApply;
                (await acc).incomingFormData[fieldId] = {
                    ...formData[fieldId],
                    ...publicShapeChanges
                };
            }
            return acc;
        }, Promise.resolve({
            changesToApply: {
                ...appliedChanges
            },
            incomingFormData: {
                ...formData
            },
            newAppliedChangesPublic: {},
            errorsByField: {}
        }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(errorsByField)) throw new (0, $81O8J.UiModificationsFieldsValidationError)('Transformation failed', {
            errors: (0, $82idB.prepareErrorsArray)(errorsByField)
        });
        setState({
            appliedChanges: changesToApply,
            formData: incomingFormData
        });
        dispatch((0, $aub9z.collectFieldsAppliedChangesHistory)({
            appId: appId,
            changeId: changeId,
            fieldsChanges: newAppliedChangesPublic
        }));
    };

});
const $7f80bdb4337734ff$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $7f80bdb4337734ff$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $7f80bdb4337734ff$export$e10d4d251d909c59 = 'LOOKUP_SOURCE_PROJECTS_ASYNC_DATA';
const $7f80bdb4337734ff$export$f5d5f6bb902f1027 = '-1';
const $7f80bdb4337734ff$export$106087dcfd4fb129 = 100;

parcelRegister("6PplZ", function(module, exports) {
$parcel$export(module.exports, "checkSameFieldValueChanged", () => $520d86b9433cc3c6$export$4027d961191df7c3);

var $eGOwo = parcelRequire("eGOwo");
function $520d86b9433cc3c6$export$4027d961191df7c3(fieldsChanges, lastProcessedChange, changeId) {
    if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $eGOwo.fg)('ditto_uim_new_attributes_for_uim_use_submit') && fieldsChanges && lastProcessedChange?.changeId === changeId) {
        const fid = lastProcessedChange?.fieldId;
        const change = fieldsChanges[fid];
        return !!change && change.hasOwnProperty('value');
    }
    return false;
}

});

parcelRegister("81O8J", function(module, exports) {
$parcel$export(module.exports, "UiModificationsFieldsValidationError", () => $b784ee4f71bce498$export$9e8b5e552e255163);

var $607Dw = parcelRequire("607Dw");
class $b784ee4f71bce498$export$9e8b5e552e255163 extends (0, $607Dw.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'fields', cause);
    }
}

});
parcelRegister("607Dw", function(module, exports) {
$parcel$export(module.exports, "UiModificationsValidationError", () => $8683b9e27ffb2718$export$6e8165c81a6a65df);
class $8683b9e27ffb2718$export$6e8165c81a6a65df extends Error {
    constructor(message, attributes, validationErrorType, cause){
        super(message, cause);
        this.attributes = attributes;
        this.validationErrorType = validationErrorType;
    }
}

});


parcelRegister("cfL5m", function(module, exports) {
$parcel$export(module.exports, "fieldWasRegistered", () => $84902f345f4d9ec2$export$fbe9157c12cb4e7b);
const $84902f345f4d9ec2$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>!!registeredFields[appId]?.[changeId]?.includes(fieldId);

});

parcelRegister("3JMvu", function(module, exports) {
$parcel$export(module.exports, "mapFieldPropertyNamesToInternal", () => $7a07bba1139035a5$export$460820f27643954e);

var $82wKS = parcelRequire("82wKS");
const $7a07bba1139035a5$export$460820f27643954e = (properties, viewType, fieldType)=>{
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const propertyMapping = fieldConfiguration?.propertyMapping;
    if (!propertyMapping) return properties;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(properties).reduce((acc, propertyName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const propertyMappingValue = propertyMapping[propertyName];
        acc[propertyMappingValue ?? propertyName] = properties[propertyName];
        return acc;
    }, {});
};

});

parcelRegister("82idB", function(module, exports) {
$parcel$export(module.exports, "prepareErrorsArray", () => $b396c3e05312c1f7$export$e1fce51bc5be90b7);
const $b396c3e05312c1f7$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();

});

parcelRegister("lKslV", function(module, exports) {
$parcel$export(module.exports, "transformFieldToIframe", () => $fb1c6d2f11d8a679$export$aa453854f74fab);

var $1qarT = parcelRequire("1qarT");

var $82wKS = parcelRequire("82wKS");
const $fb1c6d2f11d8a679$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldInternalToPublicTransformers = fieldConfiguration?.internalToPublicTransformers;
    const publicShapeField = {
        ...fieldChanges
    };
    if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers?.value) try {
        publicShapeField.value = fieldInternalToPublicTransformers?.value(fieldChanges.value, fieldMetadata.fieldRenderer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $1qarT.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers?.optionsVisibility) try {
        const lookupSource = fieldConfiguration?.lookupSource;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - lookupData is not types on CI somehow
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        publicShapeField.optionsVisibility = fieldInternalToPublicTransformers?.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $1qarT.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicOptionsVisibilityTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return publicShapeField;
};

});

parcelRegister("TiFiE", function(module, exports) {
$parcel$export(module.exports, "transformFieldChangesToInternalShape", () => $0fdd9846971f3713$export$d14f85c01e334a1);

var $8dH3d = parcelRequire("8dH3d");

var $gRw8I = parcelRequire("gRw8I");

var $6rtzq = parcelRequire("6rtzq");

var $82wKS = parcelRequire("82wKS");


var $5sAot = parcelRequire("5sAot");

var $gOp4r = parcelRequire("gOp4r");

var $i9dWk = parcelRequire("i9dWk");
const $0fdd9846971f3713$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, executionContext: executionContext, environment: environment, intl: intl })=>{
    (0, $gRw8I.di)((0, $82wKS.getSupportedFieldConfiguration));
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration?.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
        ...(0, $gOp4r.VALID_RESULT),
        data: {}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration?.lookupSource;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - lookupData is not types on CI somehow
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
        if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, $gOp4r.VALID_RESULT;
        const propertyValue = fieldFromIframe[propertyName];
        const transformer = fieldTransformers[propertyName];
        const fieldContext = {
            fieldId: fieldId
        };
        // We need to catch lookup values discrepancies and react accordingly
        // to how we react to validation errors - throw an error
        // if the set value wasn't found in the array of lookupValues
        try {
            const data = transformer ? await transformer(propertyValue, lookupValues, {
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                fieldContext: fieldContext,
                intl: intl
            }) : propertyValue;
            return {
                isValid: true,
                data: {
                    [propertyName]: data
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // FieldValueLookupError will be thrown from the transformer
            // when the lookup value wasn't found
            if (err instanceof (0, $6rtzq.FieldValueLookupError)) {
                // For single value fields its straightforward to just pass
                // the faulty propertyValue into error message,
                // but for multi value fields we should find out the faulty values from the array
                // thats why we should propagate the faulty values as a comma separated string
                // by using the error's message
                const faultyValue = err.message || propertyValue;
                return {
                    isValid: false,
                    error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: (0, $585e8f7167f61808$export$d1996cb46a690190),
                        method: (0, $5sAot.mapFieldPropertyToApiMethod)(propertyName),
                        message: `Invalid IDs provided: ${faultyValue}`
                    }
                };
            }
            throw err;
        }
    }));
    const invalidTransformationResults = (0, $i9dWk.filterInvalidResults)(fieldTransformationResults);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(invalidTransformationResults)) return {
        isValid: false,
        errors: invalidTransformationResults.map((result)=>result.error)
    };
    return (0, $i9dWk.mapValidResultsToFieldInternalShape)(fieldTransformationResults);
};

});
parcelRegister("6rtzq", function(module, exports) {
$parcel$export(module.exports, "FieldValueLookupError", () => $2f73a6dce6bcf96a$export$73c2f0689b6c4a5a);
class $2f73a6dce6bcf96a$export$73c2f0689b6c4a5a extends Error {
}

});

parcelRegister("gOp4r", function(module, exports) {
$parcel$export(module.exports, "VALID_RESULT", () => $af0c126b48130091$export$ee79e3ab53b8db79);
const $af0c126b48130091$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("i9dWk", function(module, exports) {
$parcel$export(module.exports, "mapValidResultsToFieldInternalShape", () => $d76dab7db88ac392$export$a60dd8f1b025f23d);
$parcel$export(module.exports, "filterInvalidResults", () => $d76dab7db88ac392$export$ddd005554aecd409);
const $d76dab7db88ac392$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
            ...acc.data,
            ...result.data
        };
        return acc;
    }, {
        isValid: true,
        data: {}
    });
const $d76dab7db88ac392$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);

});



parcelRegister("dmz3j", function(module, exports) {
$parcel$export(module.exports, "updateScreenTabs", () => $d4a266f6d4506eb1$export$131c67fd312b8a11);

var $gRw8I = parcelRequire("gRw8I");

var $9WNAv = parcelRequire("9WNAv");

var $iGhbB = parcelRequire("iGhbB");

var $aub9z = parcelRequire("aub9z");

var $2TFQ7 = parcelRequire("2TFQ7");
const $d4a266f6d4506eb1$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, changeId: changeId, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        (0, $gRw8I.di)((0, $aub9z.collectScreenTabsAppliedChangesHistory), (0, $2TFQ7.getScreenTabsPublicToInternalValidationErrors));
        const { screenTabs: internalScreenTabs } = getState();
        // If screenTabsFromIframe is empty it means that the app does not provide srceenTabs changes.
        if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) return;
        if (internalScreenTabs && (0, $2TFQ7.screenTabsPublicToInternalValidator)(internalScreenTabs, screenTabsFromIframe)) {
            const newScreenTabs = (0, $2TFQ7.screenTabsPublicToInternalTransformer)(internalScreenTabs, screenTabsFromIframe);
            setState({
                screenTabs: newScreenTabs
            });
            dispatch((0, $aub9z.collectScreenTabsAppliedChangesHistory)({
                appId: appId,
                changeId: changeId,
                screenTabs: newScreenTabs
            }));
        } else throw new (0, $9WNAv.UiModificationsScreenTabsValidationError)('Transformation failed', {
            errors: (0, $2TFQ7.getScreenTabsPublicToInternalValidationErrors)(internalScreenTabs, screenTabsFromIframe).map((0, $iGhbB.toScreenTabsValidationError))
        });
    };

});
parcelRegister("9WNAv", function(module, exports) {
$parcel$export(module.exports, "UiModificationsScreenTabsValidationError", () => $5a1018b8bae0ac45$export$faf1f1824ee0a136);

var $607Dw = parcelRequire("607Dw");
class $5a1018b8bae0ac45$export$faf1f1824ee0a136 extends (0, $607Dw.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'screenTabs', cause);
    }
}

});

parcelRegister("iGhbB", function(module, exports) {
$parcel$export(module.exports, "toScreenTabsValidationError", () => $609355188438e567$export$b2675440ade984fb);

const $609355188438e567$export$b2675440ade984fb = (message)=>({
        message: message,
        type: (0, $585e8f7167f61808$export$fd26696d109785a0)
    });

});

parcelRegister("2TFQ7", function(module, exports) {
$parcel$export(module.exports, "screenTabsPublicToInternalTransformer", () => $e157d25468b560b0$export$9ca9b35e7b6a8bbc);
$parcel$export(module.exports, "screenTabsPublicToInternalValidator", () => $e157d25468b560b0$export$e7a91e7e430e691a);
$parcel$export(module.exports, "getScreenTabsPublicToInternalValidationErrors", () => $e157d25468b560b0$export$62d63af83dac7315);

var $eGOwo = parcelRequire("eGOwo");
const $e157d25468b560b0$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';
const $e157d25468b560b0$var$isValidScreenTabId = (internalScreenTabs, id)=>$e157d25468b560b0$export$582443c7ead02173(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
const $e157d25468b560b0$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
const $e157d25468b560b0$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
const $e157d25468b560b0$var$isValidScreenTabData = (internalScreenTabs, { id: id, isVisible: isVisible, isActive: isActive })=>$e157d25468b560b0$var$isValidScreenTabId(internalScreenTabs, id) && $e157d25468b560b0$var$isValidScreenTabIsVisible(isVisible) && $e157d25468b560b0$var$isValidScreenTabIsActive(isActive);
const $e157d25468b560b0$var$countNumberOfActiveScreenTabs = (acc, { isActive: isActive })=>{
    if ($e157d25468b560b0$var$isValidScreenTabIsActive(isActive) && isActive) return acc + 1;
    return acc;
};
const $e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs = (acc, { isActive: isActive, isVisible: isVisible })=>{
    if ($e157d25468b560b0$var$isValidScreenTabIsActive(isActive) && isActive && $e157d25468b560b0$var$isValidScreenTabIsVisible(isVisible) && !isVisible) return acc + 1;
    return acc;
};
const $e157d25468b560b0$export$9ca9b35e7b6a8bbc = (internalScreenTabs, screenTabsFromApp)=>{
    let numberOfActiveScreenTabs = 0;
    const internalActiveScreenTabIndex = internalScreenTabs.findIndex((tab)=>tab.isActive === true);
    const screenTabsInternalUpdated = internalScreenTabs.map((screenTabInternal)=>{
        const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
        if (!screenTabFromApp) return screenTabInternal;
        numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
        return {
            id: screenTabInternal.id,
            isVisible: screenTabFromApp.isVisible ?? true,
            isActive: screenTabFromApp.isActive
        };
    });
    // if no active tab is specified. default to the first
    if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof screenTabsInternalUpdated[0]?.isActive !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
    return screenTabsInternalUpdated;
};
const $e157d25468b560b0$export$e7a91e7e430e691a = (internalScreenTabs, screenTabsFromApp)=>{
    if (!Array.isArray(screenTabsFromApp)) return false;
    const screenTabsFromAppFiltered = screenTabsFromApp.filter((data)=>$e157d25468b560b0$var$isValidScreenTabData(internalScreenTabs, data));
    const numberOfActiveScreenTabs = screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfActiveScreenTabs, 0);
    const numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs, 0);
    return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
};
const $e157d25468b560b0$export$62d63af83dac7315 = (internalScreenTabs, screenTabsFromApp)=>{
    if (!internalScreenTabs) return [
        'There are no screen tabs in the current view.'
    ];
    if (!Array.isArray(screenTabsFromApp)) return [
        'Your app must return screen tabs as an array.'
    ];
    const errors = [];
    if ((0, $eGOwo.fg)('ditto_uim_error_cb_screen_tabs')) screenTabsFromApp.forEach((tab)=>{
        if (!$e157d25468b560b0$var$isValidScreenTabData(internalScreenTabs, tab)) {
            if (!$e157d25468b560b0$var$isValidScreenTabId(internalScreenTabs, tab.id)) errors.push(`Screen tab with id ${tab.id} does not exist in the current view.`);
            if (!$e157d25468b560b0$var$isValidScreenTabIsVisible(tab.isVisible)) errors.push(`Visible state for tab with id ${tab.id} should be a boolean.`);
            if (!$e157d25468b560b0$var$isValidScreenTabIsActive(tab.isActive)) errors.push(`Active state for tab with id ${tab.id} should be a boolean.`);
        }
    });
    if (screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfActiveScreenTabs, 0) > 1) errors.push('Only one screen tab can be in focus.');
    if (screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs, 0) > 0) errors.push("You can't hide a screen tab that's currently in focus.");
    return errors;
};

});





parcelRegister("cs58I", function(module, exports) {
$parcel$export(module.exports, "useUserPreferencesValue", () => $22623340bdbf14f6$export$8bd3660b16415efd);
$parcel$export(module.exports, "useUserPreferencesActions", () => $22623340bdbf14f6$export$eefe4b2985e8203e);

var $eJOHy = parcelRequire("eJOHy");

var $cxKOj = parcelRequire("cxKOj");

var $jkWf0 = parcelRequire("jkWf0");

var $etbP7 = parcelRequire("etbP7");
const $22623340bdbf14f6$export$8bd3660b16415efd = (userPreferenceKey)=>{
    const [value, { setUserPreferenceValue: setUserPreferenceValue, deleteUserPreferenceValue: deleteUserPreferenceValue }] = (0, $jkWf0.useUserPreferencesStoreValue)(userPreferenceKey);
    /**
	 * persist: boolean - if true, save the value to the server ,else just update the local state and return a promise with the new value
	 */ const setValue = (0, $eJOHy.useCallback)((newValue, persist = true)=>{
        setUserPreferenceValue(userPreferenceKey, newValue);
        if (!persist) return Promise.resolve(newValue);
        return (0, $etbP7.saveUserPreferenceValue)(userPreferenceKey, newValue);
    }, [
        setUserPreferenceValue,
        userPreferenceKey
    ]);
    const deleteValue = (0, $eJOHy.useCallback)(()=>{
        deleteUserPreferenceValue(userPreferenceKey);
        return (0, $etbP7.removeUserPreferenceValue)(userPreferenceKey);
    }, [
        deleteUserPreferenceValue,
        userPreferenceKey
    ]);
    // As part of an experiment (jiv-21227_dev_panel_collapsibility_exp) we are introducing collapsibility to the dev panel
    // However, we need to iterate on the backend change that would see the userPreference for our collapsed state of the dev panel
    // come through Relay/Agg.
    // This fetchUserPreferenceValue is a temporary measure to be able to run our initial experiment - if successful, we will remove the below and implement the backend change
    // Please don't use this for anything else except this experiment. Reach out to https://atlassian.enterprise.slack.com/archives/C093S7Q436E
    // Please see the JIRA ticket https://jplat.atlassian.net/browse/JIV-21315 for more details.
    const fetchValue = (0, $eJOHy.useCallback)(async ()=>{
        try {
            if ((0, $cxKOj.expVal)('jiv-21227_dev_panel_collapsibility_exp', 'isEnabled', false)) {
                const serverValue = await (0, $etbP7.fetchUserPreferenceValue)(userPreferenceKey);
                if (serverValue !== null) {
                    const parsedValue = typeof serverValue === 'string' ? JSON.parse(serverValue) : serverValue;
                    setUserPreferenceValue(userPreferenceKey, parsedValue);
                    return parsedValue;
                }
            }
            return null;
        } catch (error) {
            return null;
        }
    }, [
        userPreferenceKey,
        setUserPreferenceValue
    ]);
    const setUserPreferences = (0, $eJOHy.useMemo)(()=>({
            setValue: setValue,
            deleteValue: deleteValue,
            fetchValue: fetchValue
        }), [
        setValue,
        deleteValue,
        fetchValue
    ]);
    return [
        value,
        setUserPreferences
    ];
};
const $22623340bdbf14f6$export$eefe4b2985e8203e = ()=>{
    const [, actions] = (0, $jkWf0.useUserPreferencesStoreActions)();
    const userPreferenceActions = (0, $eJOHy.useMemo)(()=>{
        const setUserPreferenceValue = (userPreferenceKey, value)=>{
            actions.setUserPreferenceValue(userPreferenceKey, value);
            (0, $etbP7.saveUserPreferenceValue)(userPreferenceKey, value);
        };
        const deleteUserPreferenceValue = (userPreferenceKey)=>{
            actions.deleteUserPreferenceValue(userPreferenceKey);
            (0, $etbP7.removeUserPreferenceValue)(userPreferenceKey);
        };
        const setUserPreferences = (userPreferences)=>{
            userPreferences && Object.keys(userPreferences).length !== 0 && actions.setUserPreferences(userPreferences);
        };
        return {
            setUserPreferenceValue: setUserPreferenceValue,
            setUserPreferences: setUserPreferences,
            deleteUserPreferenceValue: deleteUserPreferenceValue,
            getUserPreferenceValue: actions.getUserPreferenceValue
        };
    }, [
        actions
    ]);
    return [
        null,
        userPreferenceActions
    ];
};

});
parcelRegister("jkWf0", function(module, exports) {
$parcel$export(module.exports, "useUserPreferencesStoreValue", () => $97758271cd46a4b8$export$46e7eeb2fc34fab8);
$parcel$export(module.exports, "useUserPreferencesStoreActions", () => $97758271cd46a4b8$export$4d156074562bac9a);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $i64h0 = parcelRequire("i64h0");
const $97758271cd46a4b8$var$store = (0, $GtRbT.createStore)({
    name: 'user-preferences',
    initialState: {
        preferences: {}
    },
    actions: $i64h0.actions
});
const $97758271cd46a4b8$var$getUserPreference = (state, userPreferenceKey)=>state.preferences[userPreferenceKey];
const $97758271cd46a4b8$export$46e7eeb2fc34fab8 = (0, $iJq0l.createHook)($97758271cd46a4b8$var$store, {
    selector: $97758271cd46a4b8$var$getUserPreference
});
const $97758271cd46a4b8$export$4d156074562bac9a = (0, $iJq0l.createHook)($97758271cd46a4b8$var$store, {
    selector: null
});

});
parcelRegister("i64h0", function(module, exports) {
$parcel$export(module.exports, "actions", () => $343d470acbc8bd87$export$e324594224ef24da);
const $343d470acbc8bd87$var$setUserPreferenceValue = (key, value)=>({ setState: setState, getState: getState })=>{
        setState({
            preferences: {
                ...getState().preferences,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [key]: value
            }
        });
    };
const $343d470acbc8bd87$var$deleteUserPreferenceValue = (key)=>({ setState: setState, getState: getState })=>{
        const { [key]: _, ...preferences } = getState().preferences;
        setState({
            preferences: preferences
        });
    };
const $343d470acbc8bd87$var$setUserPreferences = (state)=>({ setState: setState })=>{
        setState({
            preferences: state
        });
    };
const $343d470acbc8bd87$var$getUserPreferenceValue = (key)=>({ getState: getState })=>{
        const { preferences: preferences } = getState();
        return preferences[key];
    };
const $343d470acbc8bd87$export$e324594224ef24da = {
    setUserPreferenceValue: $343d470acbc8bd87$var$setUserPreferenceValue,
    deleteUserPreferenceValue: $343d470acbc8bd87$var$deleteUserPreferenceValue,
    setUserPreferences: $343d470acbc8bd87$var$setUserPreferences,
    getUserPreferenceValue: $343d470acbc8bd87$var$getUserPreferenceValue
};

});


parcelRegister("etbP7", function(module, exports) {
$parcel$export(module.exports, "saveUserPreferenceValue", () => $a9cf1c440643deff$export$bebe1b9e9f4cbf16);
$parcel$export(module.exports, "fetchUserPreferenceValue", () => $a9cf1c440643deff$export$a3e5f8cedb0374ad);
$parcel$export(module.exports, "removeUserPreferenceValue", () => $a9cf1c440643deff$export$a60a810760d07867);

var $keOPi = parcelRequire("keOPi");

var $cxKOj = parcelRequire("cxKOj");
const $a9cf1c440643deff$export$bebe1b9e9f4cbf16 = async (userPreferenceKey, value)=>(0, $keOPi.performIssuePutRequest)(`/rest/api/2/mypreferences?key=${userPreferenceKey}`, {
        body: value
    }, 'user-preferences-services/src/utils');
const $a9cf1c440643deff$export$a3e5f8cedb0374ad = async (userPreferenceKey)=>{
    try {
        if ((0, $cxKOj.expVal)('jiv-21227_dev_panel_collapsibility_exp', 'isEnabled', false)) {
            const response = await (0, $keOPi.performIssueGetRequest)(`/rest/api/2/mypreferences?key=${userPreferenceKey}`, undefined, 'user-preferences-services/src/utils');
            return response;
        }
        return null;
    } catch (error) {
        // If the preference doesn't exist, return null
        return null;
    }
};
const $a9cf1c440643deff$export$a60a810760d07867 = async (userPreferenceKey)=>(0, $keOPi.performIssueDeleteRequest)(`/rest/api/2/mypreferences?key=${userPreferenceKey}`, undefined, 'user-preferences-services/src/utils');

});
parcelRegister("keOPi", function(module, exports) {
$parcel$export(module.exports, "performIssuePostRequest", () => $1d9dfe6a518cff33$export$f0d7c3d034d5811a);
$parcel$export(module.exports, "performIssuePutRequest", () => $1d9dfe6a518cff33$export$2167f099a5e216f1);
$parcel$export(module.exports, "performIssueDeleteRequest", () => $1d9dfe6a518cff33$export$cf3e603eb3bc78ab);
$parcel$export(module.exports, "performIssueGetRequest", () => $1d9dfe6a518cff33$export$36671e08961872af);
// Stryker disable all

var $3ugTQ = parcelRequire("3ugTQ");

var $4cTDP = parcelRequire("4cTDP");

var $biGll = parcelRequire("biGll");
const $1d9dfe6a518cff33$export$f0d7c3d034d5811a = async (url, options = {}, path)=>{
    if ((0, $4cTDP.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $3ugTQ.performPostRequest), url, options, path);
    // eslint-disable-next-line jira/js/no-jira-fetch
    return (0, $3ugTQ.performPostRequest)(url, options);
};
const $1d9dfe6a518cff33$export$2167f099a5e216f1 = async (url, options = {}, path)=>{
    if ((0, $4cTDP.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $3ugTQ.performPutRequest), url, options, path);
    // eslint-disable-next-line jira/js/no-jira-fetch
    return (0, $3ugTQ.performPutRequest)(url, options);
};
const $1d9dfe6a518cff33$export$cf3e603eb3bc78ab = async (url, options = {}, path)=>{
    if ((0, $4cTDP.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $3ugTQ.performDeleteRequest), url, options, path);
    // eslint-disable-next-line jira/js/no-jira-fetch
    return (0, $3ugTQ.performDeleteRequest)(url, options);
};
const $1d9dfe6a518cff33$export$36671e08961872af = async (url, options = {}, path)=>{
    if ((0, $4cTDP.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $3ugTQ.performGetRequest), url, options, path);
    // eslint-disable-next-line jira/js/no-jira-fetch
    return (0, $3ugTQ.performGetRequest)(url, options);
};

});
parcelRegister("biGll", function(module, exports) {
$parcel$export(module.exports, "performIssueRequest", () => $00dfaa7a2eaf401f$export$2fba6590b0f30cb2);
// Stryker disable all

var $3ibpe = parcelRequire("3ibpe");

var $14RSn = parcelRequire("14RSn");
const $00dfaa7a2eaf401f$var$isGiraUrl = (url)=>url.startsWith('/rest/gira/1/');
const $00dfaa7a2eaf401f$export$2fba6590b0f30cb2 = async (requestFn, url, options = {}, path = 'unknown')=>{
    const defaultExperienceDescription = {
        experience: $00dfaa7a2eaf401f$var$isGiraUrl(url) ? 'issueGira' : 'issueRest',
        analyticsSource: $00dfaa7a2eaf401f$var$isGiraUrl(url) ? 'issue-gira' : 'issue-rest',
        application: null,
        edition: null
    };
    try {
        const response = await requestFn(url, options);
        return response;
    } catch (error) {
        let traceId;
        let statusCode;
        let errorMessage;
        if (error instanceof Error || error instanceof (0, $14RSn.default) || error instanceof (0, $14RSn.ValidationError) || error instanceof TypeError) errorMessage = error.message;
        if (error instanceof (0, $14RSn.default) || error instanceof (0, $14RSn.ValidationError)) {
            traceId = error.traceId;
            statusCode = error.statusCode;
        }
        const additionalAttributes = {
            statusCode: statusCode || 0,
            errorMessage: errorMessage || 'unknown',
            traceId: traceId || 'unknown',
            path: path
        };
        if (statusCode && statusCode >= 400 && statusCode < 500 || error instanceof Error && error.cause instanceof TypeError) {
            (0, $3ibpe.sendExperienceAnalytics)({
                ...defaultExperienceDescription,
                action: 'taskAbort',
                additionalAttributes: additionalAttributes
            });
            throw error;
        }
        (0, $3ibpe.sendExperienceAnalytics)({
            ...defaultExperienceDescription,
            action: 'taskFail',
            additionalAttributes: additionalAttributes
        });
        throw error;
    }
};

});




const $e8c5fe022e7e442a$export$8c6b5c30f78ab338 = 'jira.user.issue.changeboarding.lastinteracted';
const $e8c5fe022e7e442a$export$5530d4ea250d4125 = 'jira.user.issue.attachment.view';
const $e8c5fe022e7e442a$export$a274dca8eb47fc4a = 'jira.user.issue.sidebar.resize-ratio';
const $e8c5fe022e7e442a$export$4c9f7f9f8a4000e1 = 'jira.user.issue.filter.hide-done-subtasks';
const $e8c5fe022e7e442a$export$39aaf586c7ee5202 = 'jira.user.issue.user-preferred-layouts';
const $e8c5fe022e7e442a$export$25f5ee1223725a65 = 'jira.user.issue.comment-summaries.enabled';
const $e8c5fe022e7e442a$export$4936b1621439c095 = 'jira.user.issue.details.details-panel-fields-order';
const $e8c5fe022e7e442a$export$32a0b5eafccd5141 = 'jira.user.issue.comment-slack-flag.dismissed';
const $e8c5fe022e7e442a$export$ca0c9f1b6d9d892c = 'jira.user.issue.details.context-panel-fields-order';

parcelRegister("lpEwy", function(module, exports) {
$parcel$export(module.exports, "useIssueLayoutContainersStore", () => $e029db5d7fe89f63$export$5c4a1f63cea7b5b3);
$parcel$export(module.exports, "useIssueLayoutGlanceStore", () => $e029db5d7fe89f63$export$769bbe2bda9a43ce);
$parcel$export(module.exports, "useIssueLayoutContextPanelStore", () => $e029db5d7fe89f63$export$3aa9017e11451546);
$parcel$export(module.exports, "useIssueLayoutActionsStore", () => $e029db5d7fe89f63$export$5513f3c310d101f5);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $5TQFX = parcelRequire("5TQFX");
const $e029db5d7fe89f63$var$STABLE_EMPTY_CONTAINER_ARRAY = [];
const $e029db5d7fe89f63$var$getIssueViewLayoutContainers = (state, issueKey)=>state[String(issueKey)]?.containers || $e029db5d7fe89f63$var$STABLE_EMPTY_CONTAINER_ARRAY;
const $e029db5d7fe89f63$var$getIssueViewLayoutGlance = (state, issueKey)=>state[String(issueKey)]?.glance;
const $e029db5d7fe89f63$var$getIssueViewLayoutContextPanel = (state, issueKey)=>state[String(issueKey)]?.contextPanel;
// this is a global state
const $e029db5d7fe89f63$var$store = (0, $GtRbT.createStore)({
    name: 'issue-view-layout-service',
    initialState: {},
    actions: $5TQFX
});
const $e029db5d7fe89f63$export$5c4a1f63cea7b5b3 = (0, $iJq0l.createHook)($e029db5d7fe89f63$var$store, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutContainers
});
const $e029db5d7fe89f63$export$769bbe2bda9a43ce = (0, $iJq0l.createHook)($e029db5d7fe89f63$var$store, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutGlance
});
const $e029db5d7fe89f63$export$3aa9017e11451546 = (0, $iJq0l.createHook)($e029db5d7fe89f63$var$store, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutContextPanel
});
const $e029db5d7fe89f63$export$5513f3c310d101f5 = (0, $iJq0l.createHook)($e029db5d7fe89f63$var$store, {
    selector: null
});

});
parcelRegister("5TQFX", function(module, exports) {
$parcel$export(module.exports, "setIssueViewContainersLayout", () => $1fee7e98aeef55ea$export$e956c64a7167b73a);
$parcel$export(module.exports, "setIssueViewLayoutGlance", () => $1fee7e98aeef55ea$export$6a9b24c2efe66bb7);
$parcel$export(module.exports, "setIssueViewLayoutContextPanel", () => $1fee7e98aeef55ea$export$9a04e4b958ebc410);
const $1fee7e98aeef55ea$export$e956c64a7167b73a = (issueKey, containersByType)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                containers: containersByType?.containers || []
            }
        });
    };
const $1fee7e98aeef55ea$export$6a9b24c2efe66bb7 = (issueKey, glance)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                glance: glance
            }
        });
    };
const $1fee7e98aeef55ea$export$9a04e4b958ebc410 = (issueKey, contextPanel)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                contextPanel: contextPanel
            }
        });
    };

});


parcelRegister("co62F", function(module, exports) {
$parcel$export(module.exports, "getLayoutItemId", () => $f780ca908cc08c0e$export$fec1c0749fa149f4);
$parcel$export(module.exports, "filterOutItemsWithProvidedIds", () => $f780ca908cc08c0e$export$355607dae809ec65);

var $5OyZl = parcelRequire("5OyZl");
const $f780ca908cc08c0e$export$fec1c0749fa149f4 = (layoutItem)=>{
    switch(layoutItem.type){
        case (0, $5OyZl.layoutContainerItemTypes).field:
            return layoutItem.fieldItemId;
        case (0, $5OyZl.layoutContainerItemTypes).panel:
            return layoutItem.panelItemId;
        case (0, $5OyZl.layoutContainerItemTypes).tab:
            return layoutItem.tabContainerId;
        default:
            return layoutItem.id;
    }
};
const $f780ca908cc08c0e$export$355607dae809ec65 = (items, idsToBeFilteredOut)=>{
    const filteredOutIdsSet = new Set(idsToBeFilteredOut);
    return items// Filter out items with the provided Ids
    .filter((item)=>!filteredOutIdsSet.has($f780ca908cc08c0e$export$fec1c0749fa149f4(item)))// Filter out items with the provided Ids nested in the container tab items
    .map((item)=>{
        if (item.type === (0, $5OyZl.layoutContainerItemTypes).tab && item.items?.nodes) return {
            ...item,
            items: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                nodes: $f780ca908cc08c0e$export$355607dae809ec65(item.items.nodes, idsToBeFilteredOut)
            }
        };
        return item;
    });
};

});
parcelRegister("5OyZl", function(module, exports) {
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $37dff345eecb4f05$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $37dff345eecb4f05$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $37dff345eecb4f05$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "FORGE_CONTEXT_TYPE", () => $37dff345eecb4f05$export$be8e68fb1aed253e);
$parcel$export(module.exports, "CONTEXT_AREA", () => $37dff345eecb4f05$export$7bf561e6ab380ea1);
$parcel$export(module.exports, "CONTENT_AREA", () => $37dff345eecb4f05$export$f42c11634d75863e);
$parcel$export(module.exports, "CONTENT_REQUEST_AREA", () => $37dff345eecb4f05$export$b38842736b6dbc1d);
$parcel$export(module.exports, "REACT_KEY_SUMMARY", () => $37dff345eecb4f05$export$605c43f1b33ab69);
$parcel$export(module.exports, "CUSTOM_ITEM_TYPE", () => $37dff345eecb4f05$export$e655b77b9efe622f);
$parcel$export(module.exports, "layoutContainerItemTypes", () => $37dff345eecb4f05$export$5507f31126c8b283);
$parcel$export(module.exports, "isLayoutContainerTabItem", () => $37dff345eecb4f05$export$ad3536b13febb432);
const $37dff345eecb4f05$export$99ad62164189f781 = 'ecosystemGlance';
const $37dff345eecb4f05$export$7719ef6e9283671 = 'forgeGlance';
const $37dff345eecb4f05$export$bfebea5ce2e1887a = 'ecosystemContext';
const $37dff345eecb4f05$export$be8e68fb1aed253e = 'forgeContext';
const $37dff345eecb4f05$export$7bf561e6ab380ea1 = 'context';
const $37dff345eecb4f05$export$f42c11634d75863e = 'content';
const $37dff345eecb4f05$export$b38842736b6dbc1d = 'content-request';
const $37dff345eecb4f05$export$bc9fa2d93b5fabae = 'FIELD';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$STATUS_TYPE = 'STATUS';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$TAB_TYPE = 'TAB';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$PANEL_TYPE = 'PANEL';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$ECOSYSTEM_TYPE = 'ECOSYSTEM';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$FORGE_TYPE = 'FORGE';
const $37dff345eecb4f05$export$605c43f1b33ab69 = 'SUMMARY';
const $37dff345eecb4f05$export$e655b77b9efe622f = 'CustomItem';
const $37dff345eecb4f05$export$5cf403de05e9bea = 'FieldSectionItem';
const $37dff345eecb4f05$export$30f7f9a86f182492 = 'TabLayout';
const $37dff345eecb4f05$export$196e597ad9a97f7a = 'PanelSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$ECOSYSTEM_SECTION_ITEM = 'EcosystemSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$FORGE_SECTION_ITEM = 'ForgeSectionItem';
const $37dff345eecb4f05$export$5507f31126c8b283 = {
    field: 'JiraIssueItemFieldItem',
    panel: 'JiraIssueItemPanelItem',
    tab: 'JiraIssueItemTabContainer'
};
const $37dff345eecb4f05$export$ad3536b13febb432 = (node)=>node.type === $37dff345eecb4f05$export$5507f31126c8b283.tab;

});



parcelRegister("cZpx8", function(module, exports) {
$parcel$export(module.exports, "getCachedIsCompactValue", () => $ae6f6bc492f6f5be$export$c47621d55d10906c);
$parcel$export(module.exports, "setCachedIsCompactValue", () => $ae6f6bc492f6f5be$export$568b2dd75c2027b4);
$parcel$export(module.exports, "invalidateCacheIfRouteChanged", () => $ae6f6bc492f6f5be$export$a81477a3594bcaab);
// Cleared on window refresh, unique to each window
const $ae6f6bc492f6f5be$var$cachedIsCompactValues = {};
let $ae6f6bc492f6f5be$var$previousRouteKey;
function $ae6f6bc492f6f5be$export$c47621d55d10906c(key) {
    return $ae6f6bc492f6f5be$var$cachedIsCompactValues[key];
}
function $ae6f6bc492f6f5be$export$568b2dd75c2027b4(isCompactValue, key) {
    $ae6f6bc492f6f5be$var$cachedIsCompactValues[key] = isCompactValue;
}
function $ae6f6bc492f6f5be$export$a81477a3594bcaab(currentRouteKey) {
    // If we navigate away from the route we can't assume that the cached value will stay valid when we come back
    if (currentRouteKey !== $ae6f6bc492f6f5be$var$previousRouteKey) {
        $ae6f6bc492f6f5be$var$previousRouteKey = currentRouteKey;
        delete $ae6f6bc492f6f5be$var$cachedIsCompactValues[$ae6f6bc492f6f5be$var$previousRouteKey];
    }
}

});


parcelRegister("2nmMZ", function(module, exports) {
module.exports = new URL("issue-app-skeleton.tpl.e425fdce.svg", import.meta.url).toString();

});

parcelRegister("8gkGI", function(module, exports) {
module.exports = new URL("issue-app-skeleton.exp.tpl.4aeaad6d.svg", import.meta.url).toString();

});


parcelRegister("5tyYu", function(module, exports) {
$parcel$export(module.exports, "UnknownErrorView", () => $3321c5fa4308c9dc$export$f23f26771420affd);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6MnLl = parcelRequire("6MnLl");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $djHV9 = parcelRequire("djHV9");

var $lRq8t = parcelRequire("lRq8t");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");

var $9fUwN = parcelRequire("9fUwN");

var $cxWcr = parcelRequire("cxWcr");
const $3321c5fa4308c9dc$var$ErrorImage = ()=>{
    return (0, $4cTDP.fg)('replace_error_display_with_empty_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $3321c5fa4308c9dc$var$imageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $djHV9.default), {
        width: 90,
        height: 130,
        alt: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $djHV9.default), {
        width: 90,
        height: 130,
        alt: ""
    });
};
const $3321c5fa4308c9dc$export$f23f26771420affd = ()=>{
    const unknownErrorDescriptionIssueTermRefreshGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $cxWcr.messages).unknownErrorDescriptionIssueTermRefreshGalaxia : (0, $cxWcr.messages).unknownErrorDescriptionIssueTermRefresh;
    const intl = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: "unknownError",
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        attributes: {
            errorType: 'unknown',
            source: globalThis.window?.location?.pathname ?? '',
            referrer: globalThis.document?.referrer ?? '',
            timestamp: new Date().toISOString(),
            userAgent: globalThis.navigator?.userAgent ?? '',
            route: `${globalThis.window?.location?.pathname ?? ''}${globalThis.window?.location?.search ?? ''}`
        }
    }, (0, $4cTDP.fg)('replace_error_display_with_empty_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        testId: "issue-view-errors.ui.unknown-error-view.unknown-error-view",
        header: intl.formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cxWcr.messages).unknownErrorHeaderIssueTermRefresh : (0, $cxWcr.messages).unknownErrorHeader),
        description: intl.formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? unknownErrorDescriptionIssueTermRefreshGalaxia : (0, $cxWcr.messages).unknownErrorDescription),
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3321c5fa4308c9dc$var$ErrorImage, null)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9fUwN.ErrorDisplay), {
        header: intl.formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cxWcr.messages).unknownErrorHeaderIssueTermRefresh : (0, $cxWcr.messages).unknownErrorHeader),
        description: intl.formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? unknownErrorDescriptionIssueTermRefreshGalaxia : (0, $cxWcr.messages).unknownErrorDescription),
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3321c5fa4308c9dc$var$ErrorImage, null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null));
};
const $3321c5fa4308c9dc$var$imageWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});

});
parcelRegister("djHV9", function(module, exports) {
$parcel$export(module.exports, "default", () => $c86612ca91962ff4$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $e1jMX = parcelRequire("e1jMX");
const $c86612ca91962ff4$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($e1jMX)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($e1jMX))
});
var $c86612ca91962ff4$export$2e2bcd8739ae039 = $c86612ca91962ff4$var$Illustration;
// for advanced use only
const $c86612ca91962ff4$export$a179c88182cb9d56 = [
    0,
    0,
    104,
    140
];

});
parcelRegister("e1jMX", function(module, exports) {
module.exports = new URL("empty-search-error-colour.f0aa9e5e.svg", import.meta.url).toString();

});


parcelRegister("9fUwN", function(module, exports) {
$parcel$export(module.exports, "ErrorDisplay", () => $eeb20530bb997417$export$d56b0569bceb92ae);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $eeb20530bb997417$export$d56b0569bceb92ae = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($eeb20530bb997417$var$Container, {
        "data-testid": "issue-view-errors.common.ui.error-display.permission-error-display"
    }, props.image, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($eeb20530bb997417$var$Heading, null, props.header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($eeb20530bb997417$var$Description, null, props.description), props.children);
$eeb20530bb997417$export$d56b0569bceb92ae.defaultProps = {
    description: undefined,
    children: null
};
/**
 * Duplicated from `src/packages/issue/issue-view/src/views/issue-details/issue-modal/styled.tsx`
 *
 * TODO: Derive properly on `src/packages/issue/issue-view/src/views/issue-details/error` cleanup
 */ const $eeb20530bb997417$var$modalDialogContainerSelectorName = 'jira.issue-view.issue-details.modal-dialog-container';
const $eeb20530bb997417$var$MODAL_DIALOG_CONTAINER_COMPONENT_SELECTOR = `[data-component-selector="${$eeb20530bb997417$var$modalDialogContainerSelectorName}"]`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eeb20530bb997417$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_y3gn1h6o _2lx21bp4 _syazi7uo _1e0c1txw _1bah1h6o _4cvr1h6o _ca0qxncg _17ipxncg _1ksgidpf",
            __cmplp.className
        ])
    });
});
const $eeb20530bb997417$var$Heading = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8lodh _19pkutpp _otyrutpp _p12f1osq",
            __cmplp.className
        ])
    });
});
const $eeb20530bb997417$var$Description = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_p12f1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("cxWcr", function(module, exports) {
$parcel$export(module.exports, "messages", () => $cb0f4ae2f63ad8b4$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $cb0f4ae2f63ad8b4$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    unknownErrorHeader: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-header",
        "defaultMessage": "We couldn't connect to that issue"
    },
    unknownErrorDescription: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-description",
        "defaultMessage": "Make sure that this issue actually exists in that project. If it does, try again in a few minutes. If you still can't link to the issue, contact your Jira admin."
    },
    unknownErrorHeaderIssueTermRefresh: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-header-issue-term-refresh",
        "defaultMessage": "We couldn't connect to that work item."
    },
    unknownErrorDescriptionIssueTermRefresh: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-description-issue-term-refresh",
        "defaultMessage": "Make sure that this work item actually exists in that project. If it does, try again in a few minutes. If you still can't link to the work item, contact your Jira admin."
    },
    unknownErrorDescriptionIssueTermRefreshGalaxia: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-description-issue-term-refresh-galaxia",
        "defaultMessage": "Make sure that this work item actually exists in that space. If it does, try again in a few minutes. If you still can't link to the work item, contact your Jira admin."
    }
});

});


parcelRegister("87NxD", function(module, exports) {
$parcel$export(module.exports, "ChangeEventTypes", () => $bd046dbdd7555f37$export$8db21fc94823e1cc);
const $bd046dbdd7555f37$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $bd046dbdd7555f37$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $bd046dbdd7555f37$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $bd046dbdd7555f37$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
const $bd046dbdd7555f37$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
const $bd046dbdd7555f37$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
const $bd046dbdd7555f37$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
const $bd046dbdd7555f37$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
const $bd046dbdd7555f37$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
const $bd046dbdd7555f37$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
const $bd046dbdd7555f37$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
const $bd046dbdd7555f37$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $bd046dbdd7555f37$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $bd046dbdd7555f37$export$8db21fc94823e1cc = {
    [$bd046dbdd7555f37$var$FIELD_CHANGE_REQUESTED]: $bd046dbdd7555f37$var$FIELD_CHANGE_REQUESTED,
    [$bd046dbdd7555f37$var$FIELD_CHANGE_FAILED]: $bd046dbdd7555f37$var$FIELD_CHANGE_FAILED,
    [$bd046dbdd7555f37$var$FIELD_CHANGED]: $bd046dbdd7555f37$var$FIELD_CHANGED,
    [$bd046dbdd7555f37$var$ISSUE_TYPE_CHANGED]: $bd046dbdd7555f37$var$ISSUE_TYPE_CHANGED,
    [$bd046dbdd7555f37$var$ISSUE_RELATIONSHIP_UPDATED]: $bd046dbdd7555f37$var$ISSUE_RELATIONSHIP_UPDATED,
    [$bd046dbdd7555f37$var$ISSUE_LINKS_CREATED]: $bd046dbdd7555f37$var$ISSUE_LINKS_CREATED,
    [$bd046dbdd7555f37$var$ISSUE_LINK_DELETED]: $bd046dbdd7555f37$var$ISSUE_LINK_DELETED,
    [$bd046dbdd7555f37$var$CHILD_ISSUE_ADDED]: $bd046dbdd7555f37$var$CHILD_ISSUE_ADDED,
    [$bd046dbdd7555f37$var$SUBTASK_ADDED]: $bd046dbdd7555f37$var$SUBTASK_ADDED,
    [$bd046dbdd7555f37$var$ISSUE_CHILDREN_ORDER_CHANGED]: $bd046dbdd7555f37$var$ISSUE_CHILDREN_ORDER_CHANGED,
    [$bd046dbdd7555f37$var$CHILD_ISSUE_FIELD_UPDATED]: $bd046dbdd7555f37$var$CHILD_ISSUE_FIELD_UPDATED,
    [$bd046dbdd7555f37$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $bd046dbdd7555f37$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
    [$bd046dbdd7555f37$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $bd046dbdd7555f37$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
};

});

parcelRegister("d6KFY", function(module, exports) {
$parcel$export(module.exports, "IssueBoundary", () => $124bf401a6603e60$export$fbf48ede0cf52b5a);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $R5dK3 = parcelRequire("R5dK3");

var $h47gY = parcelRequire("h47gY");

var $2imLM = parcelRequire("2imLM");
const $124bf401a6603e60$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "issue",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "issue-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $R5dK3.IssueViewSkeleton), {
            isEmbedView: isEmbedView
        })
    }, children));

});

parcelRegister("juAwR", function(module, exports) {
$parcel$export(module.exports, "defaultRatioRightColumn", () => $72456224b1981159$export$7fec582ac43ca9da);
$parcel$export(module.exports, "largeScreenRatioRightColumn", () => $72456224b1981159$export$28d7967aa38f2f87);
$parcel$export(module.exports, "activitySidePanelRatio", () => $72456224b1981159$export$6695481d80b63521);
$parcel$export(module.exports, "getIssueContainerIncreasedMaxWidth", () => $72456224b1981159$export$9d883719bd435511);
$parcel$export(module.exports, "ACTIVITY_SIDE_PANEL_MIN_WIDTH", () => $72456224b1981159$export$dd2feff7666e1f68);
const $72456224b1981159$export$7fec582ac43ca9da = 0.35;
const $72456224b1981159$export$28d7967aa38f2f87 = 0.4;
const $72456224b1981159$export$6695481d80b63521 = 0.4;
const $72456224b1981159$export$9d883719bd435511 = ()=>1920;
const $72456224b1981159$export$dd2feff7666e1f68 = 400;

});

parcelRegister("j2oKY", function(module, exports) {
$parcel$export(module.exports, "useStartNinIssueAppAnalytics", () => $d562bf0afb5d23f6$export$39482b240f0b451f);

var $eJOHy = parcelRequire("eJOHy");

var $hqYEY = parcelRequire("hqYEY");

var $6d9QY = parcelRequire("6d9QY");

var $HiS1C = parcelRequire("HiS1C");
const $d562bf0afb5d23f6$export$b9b395b52bdc3f4a = (0, $hqYEY.metrics).pageSegmentLoad({
    key: 'new-issue-navigator.issue-app'
});
const $d562bf0afb5d23f6$export$39482b240f0b451f = (issueKey)=>{
    const [{ view: view }] = (0, $HiS1C.useSelectedViewState)();
    const previousIssueKey = (0, $6d9QY.usePrevious)(issueKey);
    // We explicitly start during render instead of an effect hook as onInteractive can be fired before the effect hook
    // has run for cached issues.
    if (issueKey !== previousIssueKey) $d562bf0afb5d23f6$export$b9b395b52bdc3f4a.start();
    const onInteractive = (0, $eJOHy.useCallback)(()=>{
        $d562bf0afb5d23f6$export$b9b395b52bdc3f4a.stop({
            customData: {
                view: view
            }
        });
    }, [
        view
    ]);
    return {
        onInteractive: onInteractive
    };
};

});

parcelRegister("ijD5s", function(module, exports) {
$parcel$export(module.exports, "useOnDeleteIssue", () => $e6a0a9ccae3b9301$export$45e2b3c3de4980ed);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");
const $e6a0a9ccae3b9301$var$getKeyForEdge = (edge)=>{
    const { NODE: NODE } = (0, $37Ewn.ConnectionInterface).get();
    return edge?.getLinkedRecord(NODE)?.getValue('key');
};
const $e6a0a9ccae3b9301$var$getFirstEdgeCursor = (connectionRecord)=>{
    const { CURSOR: CURSOR, EDGES: EDGES } = (0, $37Ewn.ConnectionInterface).get();
    const edges = connectionRecord.getLinkedRecords(EDGES) ?? [];
    const cursor = edges[0]?.getValue(CURSOR);
    return cursor ? String(cursor) : null;
};
const $e6a0a9ccae3b9301$var$getLastEdgeCursor = (connectionRecord)=>{
    const { CURSOR: CURSOR, EDGES: EDGES } = (0, $37Ewn.ConnectionInterface).get();
    const edges = connectionRecord.getLinkedRecords(EDGES) ?? [];
    const cursor = edges[edges.length - 1]?.getValue(CURSOR);
    return cursor ? String(cursor) : null;
};
const $e6a0a9ccae3b9301$var$updatePageInfoCursor = (pageInfo, pageInfoField, replacementCursor, edgeToDelete)=>{
    if (!pageInfo || !replacementCursor) return;
    const { CURSOR: CURSOR } = (0, $37Ewn.ConnectionInterface).get();
    const pageInfoCursor = pageInfo.getValue(pageInfoField);
    if (pageInfoCursor && pageInfoCursor === edgeToDelete.getValue(CURSOR)) pageInfo.setValue(replacementCursor, pageInfoField);
};
const $e6a0a9ccae3b9301$var$updatePageInfo = (connectionRecord, edgeToDelete)=>{
    const { START_CURSOR: START_CURSOR, END_CURSOR: END_CURSOR, PAGE_INFO: PAGE_INFO } = (0, $37Ewn.ConnectionInterface).get();
    const pageInfo = connectionRecord.getLinkedRecord(PAGE_INFO);
    $e6a0a9ccae3b9301$var$updatePageInfoCursor(pageInfo, START_CURSOR, $e6a0a9ccae3b9301$var$getFirstEdgeCursor(connectionRecord), edgeToDelete);
    $e6a0a9ccae3b9301$var$updatePageInfoCursor(pageInfo, END_CURSOR, $e6a0a9ccae3b9301$var$getLastEdgeCursor(connectionRecord), edgeToDelete);
};
const $e6a0a9ccae3b9301$export$45e2b3c3de4980ed = (connectionId)=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return (0, $eJOHy.useCallback)((issueKeyToDelete)=>{
        let previousIssueKey;
        let nextIssueKey;
        (0, $37Ewn.commitLocalUpdate)(environment, (store)=>{
            const connectionRecord = connectionId ? store.get(connectionId) : undefined;
            if (!connectionRecord) return;
            const { EDGES: EDGES } = (0, $37Ewn.ConnectionInterface).get();
            const edges = connectionRecord.getLinkedRecords(EDGES) ?? [];
            const index = edges.findIndex((edge)=>$e6a0a9ccae3b9301$var$getKeyForEdge(edge) === issueKeyToDelete);
            if (index > -1) {
                nextIssueKey = $e6a0a9ccae3b9301$var$getKeyForEdge(edges[index + 1]);
                previousIssueKey = $e6a0a9ccae3b9301$var$getKeyForEdge(edges[index - 1]);
                // Filter out deleted record from our connection
                connectionRecord.setLinkedRecords(edges.slice(0, index).concat(edges.slice(index + 1)), EDGES);
                // Update page start/end cursors if necessary following record delete
                $e6a0a9ccae3b9301$var$updatePageInfo(connectionRecord, edges[index]);
                // Decrement the total count
                const totalCount = connectionRecord.getValue('totalIssueSearchResultCount');
                if (typeof totalCount === 'number') connectionRecord.setValue(totalCount - 1, 'totalIssueSearchResultCount');
            }
        });
        // Return the next issue key to select. If there is no next issue key then return the previous key.
        return nextIssueKey ?? previousIssueKey ?? '';
    }, [
        environment,
        connectionId
    ]);
};

});

parcelRegister("1aawv", function(module, exports) {
$parcel$export(module.exports, "useIssueByFieldsRefetch", () => $cb3ec1bae6313c34$export$a3f7fddb3e08cea5);

var $10TkD = parcelRequire("10TkD");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");

var $koAZ4 = parcelRequire("koAZ4");

var $4cTDP = parcelRequire("4cTDP");

var $iRahl = parcelRequire("iRahl");

var $aaLZH = parcelRequire("aaLZH");
const $cb3ec1bae6313c34$export$a3f7fddb3e08cea5 = (fieldSets)=>{
    const { cloudId: cloudId } = (0, $koAZ4.useTenantContext)();
    const isConditionalFormattingEnabled = (0, $4cTDP.fg)('jira_list_conditional_formatting') && // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $aaLZH.useIssueNavigatorFeatures)().isConditionalFormattingEnabled;
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return (0, $eJOHy.useCallback)((issuekey)=>(0, $37Ewn.fetchQuery)(environment, /* eslint-disable @atlassian/relay/unused-fields, @atlassian/relay/must-colocate-fragment-spreads */ // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
        (0, $10TkD.default), /* eslint-enable @atlassian/relay/unused-fields, @atlassian/relay/must-colocate-fragment-spreads */ {
            cloudId: cloudId,
            issueSearchInput: {
                jql: `issueKey=${issuekey}`
            },
            fieldSetIds: fieldSets,
            amountOfColumns: (0, $iRahl.MAX_AMOUNT_OF_COLUMNS),
            isConditionalFormattingEnabled: isConditionalFormattingEnabled,
            isTimelineEnabled: false
        }, {
            fetchPolicy: 'network-only'
        }).toPromise(), [
        cloudId,
        environment,
        fieldSets,
        isConditionalFormattingEnabled
    ]);
};

});
parcelRegister("10TkD", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d9a1f1543f67f6c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8572a969e8c4ea0662bc868192409ad8>>
 * @relayHash e160197d20ab55343047be2fc7275120
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8db5294e6b0b510591bf222bf93da3f810599ec37234f0c2d8154bae739e8237

var $3Bt2F = parcelRequire("3Bt2F");

var $3jVIX = parcelRequire("3jVIX");

var $hRj2m = parcelRequire("hRj2m");

var $cIDJo = parcelRequire("cIDJo");

var $6AioA = parcelRequire("6AioA");

var $04qit = parcelRequire("04qit");

var $jvWSl = parcelRequire("jvWSl");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $1fipb = parcelRequire("1fipb");

var $FU9UR = parcelRequire("FU9UR");
const $3d9a1f1543f67f6c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTimelineEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v6 = {
        "kind": "Literal",
        "name": "first",
        "value": 1
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        v6 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "fieldSetIds",
            "variableName": "fieldSetIds"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v13 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "name"
    }, v15 = {
        "kind": "ScalarField",
        "name": "value"
    }, v16 = [
        v15 /*: any*/ ,
        v11 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v17 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v18 = {
        "kind": "ClientExtension",
        "selections": [
            v17 /*: any*/ 
        ]
    }, v19 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v20 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v21 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v22 = {
        "kind": "ScalarField",
        "name": "date"
    }, v23 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "key"
    }, v25 = {
        "kind": "ScalarField",
        "name": "text"
    }, v26 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v27 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v26 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v28 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v11 /*: any*/ 
        ]
    }, v29 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v30 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v31 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v32 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v33 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v34 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v27 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v35 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v36 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v37 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v38 = [
        {
            "kind": "ScalarField",
            "name": "appType"
        }
    ], v39 = [
        {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isUser"
        },
        {
            "kind": "InlineFragment",
            "selections": v38 /*: any*/ ,
            "type": "AppUser"
        }
    ], v40 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v41 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeInSeconds"
            }
        ]
    }, v42 = {
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "timeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v43 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v44 = [
        v11 /*: any*/ 
    ], v45 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": v44 /*: any*/ 
    }, v46 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v47 = {
        "kind": "ClientExtension",
        "selections": [
            v46 /*: any*/ 
        ]
    }, v48 = {
        "kind": "ScalarField",
        "name": "href"
    }, v49 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v50 = {
        "kind": "InlineFragment",
        "selections": [
            v22 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v51 = [
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        v50 /*: any*/ ,
        v11 /*: any*/ 
    ], v52 = [
        v12 /*: any*/ ,
        v50 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": v44 /*: any*/ ,
            "type": "Node",
            "abstractKey": "__isNode"
        }
    ], v53 = [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "issue",
                    "plural": false,
                    "selections": [
                        v11 /*: any*/ ,
                        v30 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueTypeField",
                            "kind": "LinkedField",
                            "name": "issueTypeField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        v33 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraParentIssueField",
                            "kind": "LinkedField",
                            "name": "parentIssueField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "parentIssue",
                                    "plural": false,
                                    "selections": [
                                        v30 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ 
                            ]
                        },
                        v24 /*: any*/ ,
                        {
                            "concreteType": "JiraStatusField",
                            "kind": "LinkedField",
                            "name": "statusField",
                            "plural": false,
                            "selections": [
                                v34 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraSingleSelectUserPickerField",
                            "kind": "LinkedField",
                            "name": "assigneeField",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ ,
                                        v35 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ 
                            ]
                        },
                        {
                            "args": v49 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "startDateViewField",
                            "plural": false,
                            "selections": v51 /*: any*/ ,
                            "storageKey": "startDateViewField(viewId:\"list_default\")"
                        },
                        {
                            "args": v49 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "endDateViewField",
                            "plural": false,
                            "selections": v51 /*: any*/ ,
                            "storageKey": "endDateViewField(viewId:\"list_default\")"
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "aggregatedStartDateViewField",
                                    "plural": false,
                                    "selections": v52 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "aggregatedEndDateViewField",
                                    "plural": false,
                                    "selections": v52 /*: any*/ 
                                }
                            ],
                            "type": "JiraAggregatedTimelineField"
                        }
                    ]
                }
            ],
            "type": "JiraTimelineVirtualField",
            "abstractKey": "__isJiraTimelineVirtualField"
        }
    ], v54 = [
        v12 /*: any*/ ,
        v11 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "refetchIssue_IssueNavigatorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v8 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSetsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "isConditionalFormattingEnabled",
                                                                    "variableName": "isConditionalFormattingEnabled"
                                                                },
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "isDensityFull",
                                                                    "value": false
                                                                },
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "isEditableSyncLoaded",
                                                                    "value": false
                                                                },
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "isInlineEditingEnabled",
                                                                    "value": true
                                                                },
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "isLinkRelationshipFieldEnabled",
                                                                    "value": false
                                                                },
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "isTimelineEnabled",
                                                                    "variableName": "isTimelineEnabled"
                                                                }
                                                            ],
                                                            "kind": "FragmentSpread",
                                                            "name": "IssueRow_fieldSets"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "main_issueNavigator_Card_fieldSets"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "refetchIssue_IssueNavigatorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v8 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSetsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v9 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldSetId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v10 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v11 /*: any*/ ,
                                                                                                v12 /*: any*/ ,
                                                                                                v13 /*: any*/ ,
                                                                                                v9 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "TypeDiscriminator",
                                                                                                    "abstractKey": "__isJiraIssueField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedAffectedServicesConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAffectedService",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "serviceId"
                                                                                                                                },
                                                                                                                                v14 /*: any*/ ,
                                                                                                                                v11 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraAffectedServicesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v14 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraCascadingOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "cascadingOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentOptionValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v16 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "childOptionValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v16 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v18 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraCascadingSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedCmdbObjectsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbObject",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "objectId"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "label"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbAvatar",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "avatar",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "mediaClientConfig",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "clientId"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "fileId"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "mediaBaseUrl"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "mediaJwtToken"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "url48"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "QueryError",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "errors",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "message"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCMDBField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v14 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v19 /*: any*/ ,
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v20 /*: any*/ ,
                                                                                                                                v21 /*: any*/ ,
                                                                                                                                v11 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                        },
                                                                                                        v18 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v22 /*: any*/ ,
                                                                                                        v14 /*: any*/ ,
                                                                                                        v23 /*: any*/ ,
                                                                                                        v18 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDatePickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "dateTime"
                                                                                                        },
                                                                                                        v14 /*: any*/ ,
                                                                                                        v18 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDateTimePickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraEpic",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "epic",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v24 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "summary"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "color"
                                                                                                                },
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraEpicLinkField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "renderedFieldHtml"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraFallbackField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        v14 /*: any*/ ,
                                                                                                        v18 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "statusCategory",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v14 /*: any*/ ,
                                                                                                                v26 /*: any*/ ,
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatus",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "status",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v14 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "statusId"
                                                                                                                },
                                                                                                                v27 /*: any*/ ,
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v19 /*: any*/ ,
                                                                                                            "concreteType": "JiraLabelConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedLabelsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v10 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabelEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraLabel",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v14 /*: any*/ ,
                                                                                                                                v28 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                        },
                                                                                                        v14 /*: any*/ ,
                                                                                                        v18 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraLabelsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "small"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v14 /*: any*/ ,
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v24 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraColorField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueColorField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v11 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueTypeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v29 /*: any*/ ,
                                                                                                                                v14 /*: any*/ ,
                                                                                                                                v11 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v11 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "summaryField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v25 /*: any*/ ,
                                                                                                                        v11 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v11 /*: any*/ ,
                                                                                                                v30 /*: any*/ ,
                                                                                                                v31 /*: any*/ ,
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "args": [
                                                                                                                                {
                                                                                                                                    "kind": "Literal",
                                                                                                                                    "name": "ids",
                                                                                                                                    "value": [
                                                                                                                                        "issuetype",
                                                                                                                                        "project",
                                                                                                                                        "summary",
                                                                                                                                        "status"
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "fieldsById",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "edges",
                                                                                                                                    "plural": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "node",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v12 /*: any*/ ,
                                                                                                                                                v11 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v13 /*: any*/ ,
                                                                                                                                                        v25 /*: any*/ 
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v13 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "issueType",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v11 /*: any*/ ,
                                                                                                                                                                v32 /*: any*/ ,
                                                                                                                                                                v14 /*: any*/ ,
                                                                                                                                                                v29 /*: any*/ ,
                                                                                                                                                                v33 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v13 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraStatus",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "status",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v11 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "statusCategory",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v11 /*: any*/ ,
                                                                                                                                                                        v26 /*: any*/ 
                                                                                                                                                                    ]
                                                                                                                                                                }
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraStatusField"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueTypeField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v13 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issueType",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v32 /*: any*/ ,
                                                                                                                                        v33 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSingleLineTextField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "summaryField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v13 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraStatusField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "statusField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v13 /*: any*/ ,
                                                                                                                                v34 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v14 /*: any*/ ,
                                                                                                        v18 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraParentIssueField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v14 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "iconUrl"
                                                                                                                },
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v14 /*: any*/ ,
                                                                                                        v18 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v14 /*: any*/ ,
                                                                                                                v24 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "large"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraResolution",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "resolution",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v14 /*: any*/ ,
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraResolutionField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedSprintsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprintEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSprint",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "sprintId"
                                                                                                                                },
                                                                                                                                v14 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "state"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "endDate"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v14 /*: any*/ ,
                                                                                                        v18 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSprintField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v14 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "user",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v12 /*: any*/ ,
                                                                                                                v14 /*: any*/ ,
                                                                                                                v35 /*: any*/ ,
                                                                                                                v36 /*: any*/ ,
                                                                                                                v11 /*: any*/ ,
                                                                                                                v37 /*: any*/ ,
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": v39 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": v38 /*: any*/ 
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "AppUser"
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": v39 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v23 /*: any*/ ,
                                                                                                        v18 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraRichText",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "richText",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraADF",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "adfValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "convertedPlainText",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "plainText"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraRichTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraServiceManagementRequestType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "requestType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v14 /*: any*/ ,
                                                                                                                v29 /*: any*/ ,
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraServiceManagementRequestTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": [
                                                                                                                v6 /*: any*/ 
                                                                                                            ],
                                                                                                            "concreteType": "JiraIssueLinkConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueLinkConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v10 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issue",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v31 /*: any*/ ,
                                                                                                                                        v24 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "args": [
                                                                                                                                                {
                                                                                                                                                    "kind": "Literal",
                                                                                                                                                    "name": "ids",
                                                                                                                                                    "value": [
                                                                                                                                                        "statusCategory"
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "fieldsById",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "edges",
                                                                                                                                                    "plural": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "node",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v12 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v27 /*: any*/ 
                                                                                                                                                                    ],
                                                                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                                                                },
                                                                                                                                                                v11 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                                                                                            "kind": "Condition",
                                                                                                                                            "passingValue": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "isResolved"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v11 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "relationName"
                                                                                                                                },
                                                                                                                                v11 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "issueLinkConnection(first:1)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueLinkField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isStoryPointField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "number"
                                                                                                        },
                                                                                                        v14 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraNumberFieldFormatConfig",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "formatConfig",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "formatStyle"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "formatUnit"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v18 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraNumberField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCommentSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "commentSummary",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "canAddComment"
                                                                                                                },
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCommentSummaryField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v14 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "uri"
                                                                                                        },
                                                                                                        v18 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraUrlField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v14 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v15 /*: any*/ ,
                                                                                                                v28 /*: any*/ ,
                                                                                                                v11 /*: any*/ ,
                                                                                                                v40 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v18 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v14 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v15 /*: any*/ ,
                                                                                                                                v40 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v18 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v14 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v15 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v18 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v14 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraUserConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedUsersConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraUserEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v12 /*: any*/ ,
                                                                                                                                v37 /*: any*/ ,
                                                                                                                                v14 /*: any*/ ,
                                                                                                                                v35 /*: any*/ ,
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v36 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "email"
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "AtlassianAccountUser"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v18 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v14 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraTeamView",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedTeam",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "jiraSuppliedId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "jiraSuppliedName"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v18 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraTeamViewField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraTimeTrackingField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "timeTrackingField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v41 /*: any*/ ,
                                                                                                                                v42 /*: any*/ ,
                                                                                                                                v13 /*: any*/ ,
                                                                                                                                v14 /*: any*/ ,
                                                                                                                                v9 /*: any*/ ,
                                                                                                                                v18 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v11 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraOriginalTimeEstimateField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraTimeTrackingField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "timeTrackingField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v41 /*: any*/ ,
                                                                                                                                v42 /*: any*/ ,
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v13 /*: any*/ ,
                                                                                                                                v14 /*: any*/ ,
                                                                                                                                v9 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v11 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v18 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraOriginalTimeEstimateField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v14 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": "label",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "value"
                                                                                                                },
                                                                                                                v11 /*: any*/ ,
                                                                                                                v20 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v18 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraRadioSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v14 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v19 /*: any*/ ,
                                                                                                            "concreteType": "JiraVersionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedVersionsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersion",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v14 /*: any*/ ,
                                                                                                                                v20 /*: any*/ ,
                                                                                                                                v21 /*: any*/ ,
                                                                                                                                v43 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                        },
                                                                                                        v18 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v14 /*: any*/ ,
                                                                                                        v45 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v19 /*: any*/ ,
                                                                                                            "concreteType": "JiraGoalConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedGoals",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGoalEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGoal",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v24 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        v14 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "status"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v47 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "selectedGoals(first:1000)"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ClientExtension",
                                                                                                            "selections": [
                                                                                                                v46 /*: any*/ ,
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraGoalsField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v14 /*: any*/ ,
                                                                                                                v45 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isLinkEditable"
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraTownsquareProject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "project",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v11 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "alias": "atlasProjectName",
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "name"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "alias": "atlasProjectKey",
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "key"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "privateProject"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "hasPermission"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "isWorkspaceActive"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "iconName"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v18 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraTownsquareProjectField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v14 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v19 /*: any*/ ,
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "confluenceRemoteIssueLinks",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v48 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "pageContent",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v12 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v48 /*: any*/ 
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraConfluencePageContentDetails"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v10 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                        },
                                                                                                        v18 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v14 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedGroupsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroupEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGroup",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v14 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "groupId"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v18 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleGroupPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraFlag",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "flag",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isFlagged"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraFlagField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraWatch",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "watch",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "count"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isWatching"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraWatchesField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "isTimelineEnabled",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": v53 /*: any*/ ,
                                                                                                            "type": "JiraTimelineField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": v53 /*: any*/ ,
                                                                                                            "type": "JiraAggregatedTimelineField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v47 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "isConditionalFormattingEnabled",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSet",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fields",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "args": v19 /*: any*/ ,
                                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedComponentsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "componentId"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraComponentsField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraPriority",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "priority",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "priorityId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraPriorityField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraProject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "project",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "projectId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraProjectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "version",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v43 /*: any*/ ,
                                                                                                                        v11 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraSingleVersionPickerField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v32 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraIssueTypeField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v54 /*: any*/ 
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraSingleSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSelectableValueConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedValues",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSelectableValueEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": v54 /*: any*/ 
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraMultipleSelectField"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8db5294e6b0b510591bf222bf93da3f810599ec37234f0c2d8154bae739e8237",
            "metadata": {},
            "name": "refetchIssue_IssueNavigatorQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": (0, $04qit.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": (0, $6AioA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": (0, $1fipb.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider": (0, $cIDJo.default)
            }
        }
    };
}();
$3d9a1f1543f67f6c$var$node.hash = "eb9611f7c3632bd87bdb160381b49249";
var $3d9a1f1543f67f6c$export$2e2bcd8739ae039 = $3d9a1f1543f67f6c$var$node;

});


parcelRegister("ccZ0S", function(module, exports) {
$parcel$export(module.exports, "default", () => $860e6b9a205b1e93$export$2e2bcd8739ae039);

var $1OvKN = parcelRequire("1OvKN");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $j4oe4 = parcelRequire("j4oe4");

var $8hzPW = parcelRequire("8hzPW");

var $1wL9i = parcelRequire("1wL9i");

var $04djv = parcelRequire("04djv");
/**
 * Render extraHeaderActions if provided or otherwise return an empty render.
 */ const $860e6b9a205b1e93$var$HeaderActionsFallback = ({ extraHeaderActions: extraHeaderActions, isEmbedView: isEmbedView, maxWidth: maxWidth })=>extraHeaderActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($860e6b9a205b1e93$var$HeaderActionsContainer, {
        maxWidth: maxWidth,
        isEmbedView: isEmbedView
    }, extraHeaderActions) : null;
/**
 * Render issue pagination controls and extraHeaderActions if provided.
 */ const $860e6b9a205b1e93$var$HeaderActions = (props)=>{
    const { extraHeaderActions: extraHeaderActions, issueResults: issueResults, maxWidth: maxWidth, isEmbedView: isEmbedView } = props;
    const issueResultsData = (0, $j4oe4.useFragment)((0, $1OvKN.default), issueResults);
    const issuesCount = (0, $1wL9i.useIssuesCount)();
    const selectedIssueIndex = (0, $1wL9i.useSelectedIssueIndex)(); // If selectedIssueIndex is negative then our selected issue key does not exist in the result set, so there
    // are no pagination controls to show.
    // If issueResultsData is null and issuesCount is not zero it means the grouping is enabled
    if (selectedIssueIndex === -1 || issueResultsData == null && issuesCount === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($860e6b9a205b1e93$var$HeaderActionsFallback, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($860e6b9a205b1e93$var$HeaderActionsContainer, {
        maxWidth: maxWidth,
        isEmbedView: isEmbedView
    }, extraHeaderActions ?? null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $04djv.default), {
        issueResults: issueResultsData ?? null
    }));
};
var $860e6b9a205b1e93$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $8hzPW.withRecoverableErrorBoundary)($860e6b9a205b1e93$var$HeaderActions, {
    recoveryProp: 'issueResults',
    Fallback: $860e6b9a205b1e93$var$HeaderActionsFallback
});
const $860e6b9a205b1e93$var$HeaderActionsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEmbedView: isEmbedView, maxWidth: maxWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $awdRS.default)(__cmplp.maxWidth, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _4cvr1h6o _1bahesu3 _1e0c1txw _1bsb1osq _vchhusvi _7zw61ejb _10nju2gc",
            __cmplp.isEmbedView && "_n3tdu2gc",
            __cmplp.maxWidth && "_p12f1ayu",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1OvKN", function(module, exports) {
$parcel$export(module.exports, "default", () => $881706d30cb48e52$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0bc51f9494de5d6fa2940f677e3da0a2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $881706d30cb48e52$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "headerActions_issueNavigator",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "issuePagination_issueNavigator"
        }
    ],
    "type": "JiraIssueConnection"
};
$881706d30cb48e52$var$node.hash = "701bdde8a1a96783e68d573053dd8362";
var $881706d30cb48e52$export$2e2bcd8739ae039 = $881706d30cb48e52$var$node;

});

parcelRegister("8hzPW", function(module, exports) {
$parcel$export(module.exports, "withRecoverableErrorBoundary", () => $b418e197f50ff828$export$c25a1c850f00ce39);

var $2UJ5S = parcelRequire("2UJ5S");
const $b418e197f50ff828$export$c25a1c850f00ce39 = (0, $2UJ5S.withRecoverableErrorBoundary);

});
parcelRegister("2UJ5S", function(module, exports) {
$parcel$export(module.exports, "withRecoverableErrorBoundary", () => $a350b1a80c0725b2$export$c25a1c850f00ce39);

var $eJOHy = parcelRequire("eJOHy");
function $a350b1a80c0725b2$export$c25a1c850f00ce39(WrappedComponent, { recoveryProp: recoveryProp, Fallback: Fallback }) {
    class RecoverableErrorBoundary extends (0, $eJOHy.Component) {
        componentDidUpdate(prevProps) {
            if (this.state.errorProps && prevProps[recoveryProp] !== this.props[recoveryProp]) this.setState({
                errorProps: null
            });
        }
        componentDidCatch(error, errorInfo) {
            this.setState({
                errorProps: {
                    error: error,
                    errorInfo: errorInfo
                }
            });
        }
        render() {
            if (this.state.errorProps) return Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Fallback, {
                ...this.props,
                ...this.state.errorProps
            }) : null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, this.props);
        }
        constructor(...args){
            super(...args), this.state = {
                errorProps: null
            };
        }
    }
    return RecoverableErrorBoundary;
}

});


parcelRegister("04djv", function(module, exports) {
$parcel$export(module.exports, "default", () => $072cb017efc64f88$export$2e2bcd8739ae039);

var $hZSix = parcelRequire("hZSix");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $48q59 = parcelRequire("48q59");

var $1wL9i = parcelRequire("1wL9i");

var $6mNq3 = parcelRequire("6mNq3");

var $9Ei7s = parcelRequire("9Ei7s");
const $072cb017efc64f88$var$IssuePagination = ({ issueResults: issueResults })=>{
    const issuesCount = (0, $1wL9i.useIssuesCount)();
    const issueResultsData = (0, $j4oe4.useFragment)((0, $hZSix.default), issueResults);
    const isCappingIssueSearchResult = issueResultsData?.isCappingIssueSearchResult ?? false;
    const totalIssueSearchResultCount = issueResultsData?.totalIssueSearchResultCount || issuesCount;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Ei7s.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6mNq3.default), {
        totalResultCount: totalIssueSearchResultCount,
        isCappingIssueSearchResult: isCappingIssueSearchResult
    })));
};
var $072cb017efc64f88$export$2e2bcd8739ae039 = $072cb017efc64f88$var$IssuePagination;

});
parcelRegister("hZSix", function(module, exports) {
$parcel$export(module.exports, "default", () => $686f0e2ef3fb988a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cdeacb15335634351a83b6eeb614c997>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $686f0e2ef3fb988a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issuePagination_issueNavigator",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
            },
            "action": "THROW",
            "path": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        }
    ],
    "type": "JiraIssueConnection"
};
$686f0e2ef3fb988a$var$node.hash = "252cad0134e2ce14b78595c597895b8f";
var $686f0e2ef3fb988a$export$2e2bcd8739ae039 = $686f0e2ef3fb988a$var$node;

});

parcelRegister("6mNq3", function(module, exports) {
$parcel$export(module.exports, "default", () => $43d358f5802b3035$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $1OQKp = parcelRequire("1OQKp");

var $Ay1uj = parcelRequire("Ay1uj");

var $k71qx = parcelRequire("k71qx");

var $3LCex = parcelRequire("3LCex");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $1wL9i = parcelRequire("1wL9i");

var $c3Udj = parcelRequire("c3Udj");
const $43d358f5802b3035$var$TooltipTag = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($43d358f5802b3035$var$StyledTooltipTag, {
        ref: ref,
        ...props
    }));
const $43d358f5802b3035$var$IssuePaginationNextButton = ({ totalResultCount: totalResultCount, isCappingIssueSearchResult: isCappingIssueSearchResult })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const actions = (0, $1wL9i.useSelectedIssueActions)();
    const selectNextIssue = actions.selectNextIssue;
    const issueKey = (0, $1wL9i.useNextIssueKey)();
    const isDisabled = !issueKey;
    const nextIssueMessage = issueKey ? formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $c3Udj.default).nextIssueTooltipIssueTermRefresh : (0, $c3Udj.default).nextIssueTooltip, {
        issueKey: issueKey
    }) : formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $c3Udj.default).nextIssueWithoutKeyTooltipIssueTermRefresh : (0, $c3Udj.default).nextIssueWithoutKeyTooltip);
    const onClick = (0, $eJOHy.useCallback)((_, analyticsEvent)=>{
        if (selectNextIssue()) (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'nextIssue');
    }, [
        selectNextIssue
    ]);
    if (isDisabled && isCappingIssueSearchResult) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $c3Udj.default).disabledButtonTooltipIssueTermRefresh : (0, $c3Udj.default).disabledButtonTooltip),
        tag: $43d358f5802b3035$var$TooltipTag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3LCex.default), {
        tabIndex: 0,
        isDisabled: true,
        "data-testid": "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.next-button.next-disabled-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $c3Udj.default).disabledButtonTooltipIssueTermRefresh : (0, $c3Udj.default).disabledButtonTooltip),
        onClick: onClick,
        appearance: "subtle",
        testId: "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.next-button",
        isDisabled: isDisabled,
        spacing: "compact"
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
                ...iconProps,
                size: "small"
            }),
        label: isDisabled ? formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $c3Udj.default).disabledButtonLabelIssueTermRefresh : (0, $c3Udj.default).disabledButtonLabel, {
            issueCount: totalResultCount
        }) : nextIssueMessage,
        onClick: onClick,
        appearance: "subtle",
        testId: "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.next-button",
        isDisabled: isDisabled,
        spacing: "compact",
        isTooltipDisabled: isDisabled
    });
};
var $43d358f5802b3035$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $43d358f5802b3035$var$IssuePaginationNextButton;
const $43d358f5802b3035$var$StyledTooltipTag = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3LCex", function(module, exports) {
$parcel$export(module.exports, "default", () => $0be296db7657e907$export$2e2bcd8739ae039);

var $cdbP5 = parcelRequire("cdbP5");
/**
 * When the @atlaskit/button component is disabled it prevents mouse events being fired for the button, which prevents
 * tooltips showing https://atlassian.design/components/button/usage#disabled-buttons.
 * When you require a disabled button to show a tooltip on hover then the button should be wrapped in this element.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0be296db7657e907$var$DisabledButtonWithTooltip = /*#__PURE__*/ (0, $cdbP5.default).span.withConfig({
    componentId: "yhjexx-0"
})({
    display: 'inline-flex'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isDisabled ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    (0, $cdbP5.css)({
        cursor: 'not-allowed',
        // Disable pointer events for the button element which means 'event.preventDefault()' will not be
        // called from AK. This allows pointer events to bubble from our wrapping span element.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> button': {
            pointerEvents: 'none'
        }
    }) : '');
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$0be296db7657e907$export$2e2bcd8739ae039 = $0be296db7657e907$var$DisabledButtonWithTooltip;

});

parcelRegister("c3Udj", function(module, exports) {
$parcel$export(module.exports, "default", () => $febe232ee4404552$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $febe232ee4404552$var$messages = (0, $7qGN1.defineMessages)({
    nextIssueTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.next-issue-tooltip",
        "defaultMessage": "Next issue ''{issueKey}'' (Type 'j')"
    },
    nextIssueWithoutKeyTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.next-issue-without-key-tooltip",
        "defaultMessage": "Next issue (Type 'j')"
    },
    disabledButtonTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.disabled-button-tooltip",
        "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more issues."
    },
    disabledButtonLabel: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.disabled-button-label",
        "defaultMessage": "{issueCount} of {issueCount} issues, select previous issues to go back"
    },
    disabledButtonLabelIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.disabled-button-label-issue-term-refresh",
        "defaultMessage": "{issueCount} of {issueCount} work items, select previous work items to go back"
    },
    nextIssueTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.next-issue-tooltip-issue-term-refresh",
        "defaultMessage": "Next work item ''{issueKey}'' (Type 'j')"
    },
    nextIssueWithoutKeyTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.next-issue-without-key-tooltip-issue-term-refresh",
        "defaultMessage": "Next work item (Type 'j')"
    },
    disabledButtonTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.disabled-button-tooltip-issue-term-refresh",
        "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more work items."
    }
});
var $febe232ee4404552$export$2e2bcd8739ae039 = $febe232ee4404552$var$messages;

});


parcelRegister("9Ei7s", function(module, exports) {
$parcel$export(module.exports, "default", () => $29eddce1ee594519$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1vA1E = parcelRequire("1vA1E");

var $Ay1uj = parcelRequire("Ay1uj");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $1wL9i = parcelRequire("1wL9i");

var $gEghF = parcelRequire("gEghF");
const $29eddce1ee594519$var$IssuePaginationPreviousButton = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const actions = (0, $1wL9i.useSelectedIssueActions)();
    const selectPreviousIssue = actions.selectPreviousIssue;
    const issueKey = (0, $1wL9i.usePreviousIssueKey)();
    const isDisabled = !issueKey;
    const previousIssueMessage = issueKey ? formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gEghF.default).previousIssueTooltipIssueTermRefresh : (0, $gEghF.default).previousIssueTooltip, {
        issueKey: issueKey
    }) : formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gEghF.default).previousIssueWithoutKeyTooltipIssueTermRefresh : (0, $gEghF.default).previousIssueWithoutKeyTooltip);
    const onClick = (0, $eJOHy.useCallback)((_, analyticsEvent)=>{
        if (selectPreviousIssue()) (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'previousIssue');
    }, [
        selectPreviousIssue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1vA1E))), {
                ...iconProps,
                size: "small"
            }),
        label: isDisabled ? formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gEghF.default).disabledButtonLabelIssueTermRefresh : (0, $gEghF.default).disabledButtonLabel) : previousIssueMessage,
        onClick: onClick,
        appearance: "subtle",
        testId: "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.previous-button",
        isDisabled: isDisabled,
        spacing: "compact",
        isTooltipDisabled: isDisabled
    });
};
var $29eddce1ee594519$export$2e2bcd8739ae039 = $29eddce1ee594519$var$IssuePaginationPreviousButton;

});
parcelRegister("gEghF", function(module, exports) {
$parcel$export(module.exports, "default", () => $33fd8162de69a63e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $33fd8162de69a63e$var$messages = (0, $7qGN1.defineMessages)({
    previousIssueTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-tooltip",
        "defaultMessage": "Previous issue ''{issueKey}'' (Type 'k')"
    },
    previousIssueWithoutKeyTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-without-key-tooltip",
        "defaultMessage": "Previous issue (Type 'k')"
    },
    disabledButtonLabel: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.disabled-button-label",
        "defaultMessage": "No previous issue, select next issue"
    },
    disabledButtonLabelIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.disabled-button-label-issue-term-refresh",
        "defaultMessage": "No previous work item, select next work item"
    },
    previousIssueTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-tooltip-issue-term-refresh",
        "defaultMessage": "Previous work item ''{issueKey}'' (Type 'k')"
    },
    previousIssueWithoutKeyTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-without-key-tooltip-issue-term-refresh",
        "defaultMessage": "Previous work item (Type 'k')"
    }
});
var $33fd8162de69a63e$export$2e2bcd8739ae039 = $33fd8162de69a63e$var$messages;

});




parcelRegister("6IA67", function(module, exports) {
$parcel$export(module.exports, "useScrollToActivityFeed", () => $bdcc23b81973c095$export$5322fd37f123913);

var $eJOHy = parcelRequire("eJOHy");

var $95O7y = parcelRequire("95O7y");
const $bdcc23b81973c095$var$ELID_ISSUE_ACTIVITY_FEED = 'jira-issue-activity-feed';
const $bdcc23b81973c095$var$INTERVAL = 100;
const $bdcc23b81973c095$var$TIMEOUT = 10000;
const $bdcc23b81973c095$export$f0c653cfd7dea798 = ()=>{
    return globalThis.document.getElementById($bdcc23b81973c095$var$ELID_ISSUE_ACTIVITY_FEED);
};
const $bdcc23b81973c095$export$5322fd37f123913 = (issueKey)=>{
    const viewActivity = (0, $95O7y.useQueryParam)('viewActivity')[0] === 'true';
    const intervalId = (0, $eJOHy.useRef)();
    const timeoutId = (0, $eJOHy.useRef)();
    const isTimeout = (0, $eJOHy.useRef)(false);
    const waitForElement = (0, $eJOHy.useCallback)(()=>{
        if (isTimeout.current) return;
        const ref = $bdcc23b81973c095$export$f0c653cfd7dea798();
        if (ref) // sometimes the browser can't immediately scroll,
        // so we add a small timeout here to let it render Bento first
        setTimeout(()=>{
            ref.scrollIntoView({
                block: 'start',
                inline: 'nearest'
            });
        }, 300);
        else intervalId.current = setTimeout(waitForElement, $bdcc23b81973c095$var$INTERVAL);
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if (!viewActivity) return;
        clearTimeout(intervalId.current);
        clearTimeout(timeoutId.current);
        isTimeout.current = false;
        // clear the interval in case comments section never shows up
        timeoutId.current = setTimeout(()=>{
            isTimeout.current = true;
        }, $bdcc23b81973c095$var$TIMEOUT);
        // kick off the interval if issueKey changes + on mount
        intervalId.current = setTimeout(waitForElement, $bdcc23b81973c095$var$INTERVAL);
        // clear interval on unmount
        return ()=>{
            clearTimeout(intervalId.current);
            clearTimeout(timeoutId.current);
        };
    }, [
        waitForElement,
        issueKey,
        viewActivity
    ]);
};

});

parcelRegister("54hXx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");









module.exports = Promise.all([
    (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $ewTvA("116M9")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("dZIaf")
        ]);
    }),
    (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $ewTvA("116M9")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("dZIaf")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20591-renderer-rerenders-fix-refactor', function() {
        return Promise.all([
            $ewTvA("fo1Iu"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("2tXQt"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_amplitude_sr', function() {
        return Promise.all([
            $ewTvA("5g4nt"),
            $ewTvA("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("j3b6X")
        ]);
    }),
    (parcelRequire("g81qY"))('ssring_affected_services_in_issue_view', function() {
        return Promise.all([
            $ewTvA("72RZh"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("a1MLa")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20508-remove-height-animation-dev-panel', function() {
        return Promise.all([
            $ewTvA("iQLT5")
        ]);
    }, function() {
        return Promise.all([]);
    }),
    (parcelRequire("g81qY"))('jira_assignable_agent_session_experience', function() {
        return Promise.all([
            $ewTvA("b8PAb"),
            $ewTvA("l253H"),
            $ewTvA("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("52Thk")
        ]);
    }),
    (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
        return Promise.all([
            $ewTvA("8LUjY")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
                return Promise.all([
                    $ewTvA("lpg1K"),
                    $ewTvA("kvRbA"),
                    $ewTvA("ffQaD")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("8D3kc"),
                    $ewTvA("kvRbA"),
                    $ewTvA("ffQaD"),
                    $ewTvA("kVX56")
                ]);
            }),
            $ewTvA("jbyHU")
        ]);
    }),
    $ewTvA("3yAl4"),
    $ewTvA("jbxE1"),
    $ewTvA("7imUH"),
    $ewTvA("fliVL"),
    $ewTvA("kVX56"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kNFvF"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("lDuOD")
]).then(()=>parcelRequire('kq6nk'));

});
parcelRegister("g81qY", function(module, exports) {
"use strict";

var $9VDxJ = parcelRequire("9VDxJ");
var $bbde81794392820b$require$getBundleURL = $9VDxJ.getBundleURL;

var $iTG8W = parcelRequire("iTG8W");
var $bbde81794392820b$require$resolve = $iTG8W.resolve;
module.exports = function loadCond(cond, ifTrue, ifFalse, fallback) {
    let result = globalThis.__MCOND(cond);
    try {
        return result ? ifTrue() : ifFalse();
    } catch (err) {
        if (fallback) {
            globalThis.__ATLASPACK_ERRORS = globalThis.__ATLASPACK_ERRORS || [];
            globalThis.__ATLASPACK_ERRORS.push(new Error(`Sync dependency fallback triggered for condition "${cond}": ${err.message}`));
            for (const id of fallback.i)fallback.l(new URL($bbde81794392820b$require$resolve(id), $bbde81794392820b$require$getBundleURL(id)).toString());
            return result ? ifTrue() : ifFalse();
        } else throw err;
    }
};

});
parcelRegister("9VDxJ", function(module, exports) {
$parcel$export(module.exports, "getBundleURL", () => $73a81c5f1e1fde26$export$bdfd709ae4826697, (v) => $73a81c5f1e1fde26$export$bdfd709ae4826697 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73a81c5f1e1fde26$export$5a759dc7a1cfb72a;
var $73a81c5f1e1fde26$export$bdfd709ae4826697;
var $73a81c5f1e1fde26$export$c9e73fbda7da57b6;
"use strict";
const $73a81c5f1e1fde26$var$stackTraceUrlRegexp = /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g;
const $73a81c5f1e1fde26$var$bundleURL = {};
/**
 * Retrieves the cached bundle URL for a given identifier.
 * If the URL is not cached, it computes and stores it in the cache.
 *
 * @param {string} id - The identifier for the bundle.
 * @param {Error?} inputError - An error object to extract the stack trace from
 * (for testing purposes).
 * @returns {string} The URL of the bundle, without file name.
 */ function $73a81c5f1e1fde26$var$getBundleURLCached(id, inputError) {
    let value = $73a81c5f1e1fde26$var$bundleURL[id];
    if (!value) {
        value = $73a81c5f1e1fde26$var$getBundleURL(inputError);
        $73a81c5f1e1fde26$var$bundleURL[id] = value;
    }
    return value;
}
/** Get the URL without the filename (last / segment)
 *
 * @param {string} url
 * @returns {string} The URL with the file name removed
 */ function $73a81c5f1e1fde26$var$getBaseURL(url) {
    return url.slice(0, url.lastIndexOf('/')) + '/';
}
function $73a81c5f1e1fde26$var$getBundleURL(inputError) {
    try {
        throw inputError ?? new Error();
    } catch (err) {
        var matches = ('' + err.stack).match($73a81c5f1e1fde26$var$stackTraceUrlRegexp);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $73a81c5f1e1fde26$var$getBaseURL(matches[2]);
    }
    return '/';
}
/**
 * @param {string} url
 * @returns {string}
 */ function $73a81c5f1e1fde26$var$getOrigin(url) {
    return new URL(url).origin;
}
$73a81c5f1e1fde26$export$5a759dc7a1cfb72a = $73a81c5f1e1fde26$var$getOrigin;
$73a81c5f1e1fde26$export$bdfd709ae4826697 = $73a81c5f1e1fde26$var$getBundleURLCached;
$73a81c5f1e1fde26$export$c9e73fbda7da57b6 = $73a81c5f1e1fde26$var$getBaseURL;

});




parcelRegister("7emTO", function(module, exports) {
$parcel$export(module.exports, "InfiniteScrollProvider", () => $dcea404e26c8c740$export$f4ede5143c1d55e9);
$parcel$export(module.exports, "useInfiniteScroll", () => $dcea404e26c8c740$export$a973cef5093a8d22);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $h6i8k = parcelRequire("h6i8k");

var $4cTDP = parcelRequire("4cTDP");

var $8jOO7 = parcelRequire("8jOO7");

var $iRahl = parcelRequire("iRahl");

var $fwKw5 = parcelRequire("fwKw5");
const $dcea404e26c8c740$var$INFINITE_SCROLL_DEFAULT_OPTIONS = {
    pageSize: (0, $iRahl.MAX_ISSUES_PER_PAGE),
    threshold: 5 * (0, $8jOO7.ROW_HEIGHT)
};
const $dcea404e26c8c740$var$INFINITE_SCROLL_INTERACTION_NAME = 'issue-navigator.infinite-scroll';
const $dcea404e26c8c740$var$InfiniteScrollContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    onLoadNext: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onLoadPrevious: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    isLoadingNext: false,
    isLoadingPrevious: false,
    hasNext: false,
    hasPrevious: false
});
const $dcea404e26c8c740$export$f4ede5143c1d55e9 = ({ onLoadNext: onLoadNext, onLoadPrevious: onLoadPrevious, isLoadingNext: isLoadingNext, isLoadingPrevious: isLoadingPrevious, hasNext: hasNext, hasPrevious: hasPrevious, children: children })=>{
    const value = (0, $eJOHy.useMemo)(()=>({
            onLoadNext: onLoadNext,
            onLoadPrevious: onLoadPrevious,
            isLoadingNext: isLoadingNext,
            isLoadingPrevious: isLoadingPrevious,
            hasNext: hasNext,
            hasPrevious: hasPrevious
        }), [
        onLoadNext,
        onLoadPrevious,
        isLoadingNext,
        isLoadingPrevious,
        hasNext,
        hasPrevious
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dcea404e26c8c740$var$InfiniteScrollContext.Provider, {
        value: value
    }, children);
};
function $dcea404e26c8c740$export$a973cef5093a8d22({ fieldSetIds: fieldSetIds, view: view, groupBy: groupBy, options: options, isHierarchyEnabled: isHierarchyEnabled, isHideDoneEnabled: isHideDoneEnabled, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled }) {
    const { pageSize: pageSize, threshold: threshold } = {
        ...$dcea404e26c8c740$var$INFINITE_SCROLL_DEFAULT_OPTIONS,
        ...options
    };
    const { onLoadNext: onLoadNextProp, onLoadPrevious: onLoadPreviousProp, ...rest } = (0, $eJOHy.useContext)($dcea404e26c8c740$var$InfiniteScrollContext);
    const jql = (0, $4cTDP.fg)('saved_list_view_technical_changes') || (0, $4cTDP.fg)('saved_list_view_merge_support') || (0, $4cTDP.fg)('jira_nin_last_used_jql') ? (0, $fwKw5.useResolvedJql)() : '';
    // Extra static variables to ensure consistent field set results are returned during pagination.
    const staticPaginationVariables = (0, $eJOHy.useMemo)(()=>({
            ...(0, $4cTDP.fg)('jira_nin_last_used_jql') && {
                // Ensure resolved JQL is consistent during pagination, e.g. when searching by last used JQL
                issueSearchInput: {
                    jql: jql
                }
            },
            ...isIssueHierarchySupportEnabled && {
                viewConfigInput: {
                    staticViewInput: {
                        isHierarchyEnabled: isHierarchyEnabled || false,
                        ...(0, $4cTDP.fg)('jsc_list_hide_done_items') ? {
                            isHideDoneEnabled: isHideDoneEnabled
                        } : {}
                    }
                }
            },
            fieldSetsInput: {
                fieldSetIds: fieldSetIds
            },
            groupBy: groupBy,
            isPaginating: true,
            ...(0, $4cTDP.fg)('saved_list_view_technical_changes') && {
                settings: {
                    groupBy: groupBy ?? null,
                    hideDone: Boolean(isHideDoneEnabled),
                    hierarchyEnabled: Boolean(isHierarchyEnabled),
                    jql: jql ?? null
                }
            }
        }), [
        fieldSetIds,
        groupBy,
        isHideDoneEnabled,
        isHierarchyEnabled,
        isIssueHierarchySupportEnabled,
        jql
    ]);
    const onLoadNext = (0, $eJOHy.useCallback)(()=>{
        if (view && (0, $4cTDP.fg)('add_nin_press_interactions')) (0, $h6i8k.default)(`${$dcea404e26c8c740$var$INFINITE_SCROLL_INTERACTION_NAME}.${view}`);
        return onLoadNextProp(pageSize, {
            UNSTABLE_extraVariables: staticPaginationVariables
        });
    }, [
        onLoadNextProp,
        pageSize,
        staticPaginationVariables,
        view
    ]);
    const onLoadPrevious = (0, $eJOHy.useCallback)(()=>{
        if (view && (0, $4cTDP.fg)('add_nin_press_interactions')) (0, $h6i8k.default)(`${$dcea404e26c8c740$var$INFINITE_SCROLL_INTERACTION_NAME}.${view}`);
        onLoadPreviousProp(pageSize, {
            UNSTABLE_extraVariables: staticPaginationVariables
        });
    }, [
        onLoadPreviousProp,
        pageSize,
        staticPaginationVariables,
        view
    ]);
    const infiniteScrollProps = (0, $eJOHy.useMemo)(()=>({
            onLoadNext: onLoadNext,
            onLoadPrevious: onLoadPrevious,
            activationThreshold: threshold,
            ...rest
        }), [
        onLoadNext,
        onLoadPrevious,
        threshold,
        rest
    ]);
    return infiniteScrollProps;
}

});

parcelRegister("bICwA", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8fe4cead58850e2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $f8fe4cead58850e2$var$messages = (0, $7qGN1.defineMessages)({
    returnText: {
        "id": "issue-navigator.full-page-issue-app.return-text",
        "defaultMessage": "Return to search"
    }
});
var $f8fe4cead58850e2$export$2e2bcd8739ae039 = $f8fe4cead58850e2$var$messages;

});


parcelRegister("7ZGNh", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6e25c697d3b0513$export$2e2bcd8739ae039);

var $kRmEu = parcelRequire("kRmEu");

var $eSh3F = parcelRequire("eSh3F");

var $52sUJ = parcelRequire("52sUJ");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $c12HM = parcelRequire("c12HM");

var $1tPTE = parcelRequire("1tPTE");

var $4Oene = parcelRequire("4Oene");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $2nr0r = parcelRequire("2nr0r");

var $3TtKq = parcelRequire("3TtKq");

var $a9bnL = parcelRequire("a9bnL");

var $iRahl = parcelRequire("iRahl");

var $7E6oZ = parcelRequire("7E6oZ");

var $2UTIe = parcelRequire("2UTIe");

var $HiS1C = parcelRequire("HiS1C");

var $fwKw5 = parcelRequire("fwKw5");

var $cJdYi = parcelRequire("cJdYi");

var $3kDjB = parcelRequire("3kDjB");

var $3Ssg5 = parcelRequire("3Ssg5");
const $e6e25c697d3b0513$var$getLastPage = (pageCursors)=>{
    if (pageCursors?.last) return pageCursors.last.pageNumber;
    if (pageCursors?.around?.length) return pageCursors.around[pageCursors.around.length - 1]?.pageNumber;
    return undefined;
};
const $e6e25c697d3b0513$var$Header = ({ CustomHeader: CustomHeader, filter: filter, issueResults: issueResults, HeaderSkeletonImage: HeaderSkeletonImage, jiraViewResult: jiraViewResult, isGroupingSupported: isGroupingSupported, onChangeFilter: onChangeFilter, onChangeJql: onChangeJql })=>{
    const issueResultsData = (0, $j4oe4.useFragment)((0, $52sUJ.default), issueResults);
    // Compute page data for our search results which is needed when requesting items for the legacy meatball menu
    const offset = (issueResultsData?.issueNavigatorPageInfo?.firstIssuePosition ?? 1) - 1; // offset is 0 based so subtract 1
    const pages = $e6e25c697d3b0513$var$getLastPage(issueResultsData?.pageCursors) ?? 0;
    const total = issueResultsData?.totalIssueSearchResultCount ?? 0;
    const searchResultPageData = (0, $eJOHy.useMemo)(()=>({
            offset: offset,
            pages: pages,
            total: total
        }), [
        offset,
        pages,
        total
    ]);
    const { filterId: filterId } = (0, $fwKw5.useActiveJql)();
    const jql = (0, $fwKw5.useResolvedJql)();
    const { filterQueryIsFetching: filterQueryIsFetching } = (0, $cJdYi.useFilterQuery)();
    const filterData = (0, $j4oe4.useFragment)((0, $eSh3F.default), filter);
    const jiraViewData = (0, $j4oe4.useFragment)((0, $kRmEu.default), jiraViewResult);
    const filterDetails = (0, $eJOHy.useMemo)(()=>filterData ? {
            filterId: filterData.filterId,
            name: filterData.name,
            jql: filterData.jql,
            isFavourite: Boolean(filterData.isFavourite)
        } : undefined, [
        filterData
    ]);
    const [{ view: view }] = (0, $HiS1C.useSelectedViewState)();
    const jiraViewResultData = jiraViewData;
    let changeHierarchy = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    let changeGroupedByField = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    let changeHideDone = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    let resetView = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    if ((0, $cxKOj.expVal)('saved_list_view', 'isEnabled', false)) ({ changeHierarchy: changeHierarchy, changeGroupedByField: changeGroupedByField, changeHideDone: changeHideDone, resetView: resetView } = // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3kDjB.useIssueSearchActions)());
    const updateGroupByParam = (0, $3Ssg5.useUpdateUrlQueryParamCallback)('groupBy');
    const onChangeGroupedByField = (0, $eJOHy.useCallback)((nextGroupedByField)=>{
        changeGroupedByField(nextGroupedByField);
        updateGroupByParam(nextGroupedByField ?? undefined);
    }, [
        changeGroupedByField,
        updateGroupByParam
    ]);
    let hideDone = false;
    if ((0, $4cTDP.fg)('jsc_bulk_edit_hide_done_work_items')) hideDone = jiraViewData?.viewSettings?.hideDone ?? false;
    const HierarchyToggle = jiraViewResultData && view !== 'detail' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7E6oZ.HierarchyToggleItem), {
        isGroupingSupported: isGroupingSupported,
        viewResult: jiraViewResultData,
        onChangeHierarchy: changeHierarchy
    }) : null;
    let onResetSelectedIssues = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    if ((0, $4cTDP.fg)('jsc_list_hide_done_items')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ reset: onResetSelectedIssues } = (0, $3TtKq.useIssueTableSelectedIssuesActions)());
    const HideDoneToggle = jiraViewResultData && view !== 'detail' && (0, $4cTDP.fg)('jsc_list_hide_done_items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2nr0r.HideDoneItemsToggle), {
        isSavedViewsEnabled: (0, $4cTDP.fg)('saved_list_view_technical_changes'),
        viewResult: jiraViewResultData,
        onChangeHideDone: changeHideDone,
        onResetSelectedIssues: onResetSelectedIssues
    }) : null;
    const GroupByDropdown = isGroupingSupported && jiraViewData && (0, $iRahl.isJiraSpreadsheetView)(jiraViewData) && view !== 'detail' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1tPTE.GroupByDropdown), {
        onChangeGroupedByField: onChangeGroupedByField,
        spreadsheetView: jiraViewData
    }) : null;
    const saveResetViewSettingsButton = jiraViewResultData && (0, $cxKOj.expVal)('saved_list_view', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9bnL.SaveResetViewSettingsButton), {
        jql: jql,
        onChangeJql: onChangeJql,
        onReset: resetView,
        viewFragment: jiraViewResultData
    });
    if (filterQueryIsFetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(HeaderSkeletonImage, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
        name: "header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CustomHeader, {
        jql: jql,
        filterId: filterId,
        filterDetails: filterDetails,
        searchResultPageData: searchResultPageData,
        HierarchyToggle: HierarchyToggle,
        GroupByDropdown: GroupByDropdown,
        HideDoneToggle: HideDoneToggle,
        SaveResetViewSettingsButton: saveResetViewSettingsButton,
        isHideDoneWorkItemsEnabled: hideDone,
        onChangeFilter: onChangeFilter,
        isModifiedFilter: filterDetails?.jql !== jql
    }));
};
var $e6e25c697d3b0513$export$2e2bcd8739ae039 = (0, $2UTIe.withReportErrors)($e6e25c697d3b0513$var$Header, {
    id: 'ui.header.unhandled',
    packageName: (0, $iRahl.PACKAGE_NAME),
    teamName: (0, $iRahl.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $c12HM.isLoaderErrorAttributes)
});

});
parcelRegister("kRmEu", function(module, exports) {
$parcel$export(module.exports, "default", () => $77b8255c3e81d94a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e0ecf8b66a502c81f301e7c70bcf5670>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $77b8255c3e81d94a$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "settings"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_Header_jiraViewResult",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "GroupByDropdown"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isSavedViewsEnabled",
                            "variableName": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "settings",
                            "variableName": "settings"
                        },
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hideDone"
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "SaveResetViewSettingsButton"
                        }
                    ]
                }
            ],
            "type": "JiraIssueSearchViewMetadata",
            "abstractKey": "__isJiraIssueSearchViewMetadata"
        }
    ],
    "type": "JiraView",
    "abstractKey": "__isJiraView"
};
$77b8255c3e81d94a$var$node.hash = "1532da0c021995be568c5cbd61d8cb4c";
var $77b8255c3e81d94a$export$2e2bcd8739ae039 = $77b8255c3e81d94a$var$node;

});

parcelRegister("eSh3F", function(module, exports) {
$parcel$export(module.exports, "default", () => $de6f26426b82ced3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a59decce3d17ede33536b0b36f9eb2f1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $de6f26426b82ced3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_Header_filter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$de6f26426b82ced3$var$node.hash = "49ae72938f954e62114776575c662bd8";
var $de6f26426b82ced3$export$2e2bcd8739ae039 = $de6f26426b82ced3$var$node;

});

parcelRegister("52sUJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $871df7a86cff31c5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<904e0d39da2e4e2100f94fcd59ddca44>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $871df7a86cff31c5$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "main_issueNavigator_Header_issueResults",
        "selections": [
            {
                "concreteType": "JiraIssueNavigatorPageInfo",
                "kind": "LinkedField",
                "name": "issueNavigatorPageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "firstIssuePosition"
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                    }
                ],
                "concreteType": "JiraPageCursors",
                "kind": "LinkedField",
                "name": "pageCursors",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "last",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "storageKey": "pageCursors(maxCursors:7)"
            },
            {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$871df7a86cff31c5$var$node.hash = "a6845643ea9e8dc218ebb8df7988c3f7";
var $871df7a86cff31c5$export$2e2bcd8739ae039 = $871df7a86cff31c5$var$node;

});

parcelRegister("1tPTE", function(module, exports) {
$parcel$export(module.exports, "GroupByDropdown", () => $27bda80728028e25$export$84685e583ac84574);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");


var $9lDcB = parcelRequire("9lDcB");
const $27bda80728028e25$export$84685e583ac84574 = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "unmount",
        id: "issue-table-group-by-dropdown",
        packageName: (0, $8e6e35a2682b0ead$export$b8b9d90f9e5bd72b),
        teamName: (0, $8e6e35a2682b0ead$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9lDcB.GroupByDropdown), props)));

});
const $8e6e35a2682b0ead$export$b8b9d90f9e5bd72b = 'jiraIssueTableGroupByDropdown';
const $8e6e35a2682b0ead$export$d57b6b390e78d90f = 'jira-yurree';
const $8e6e35a2682b0ead$export$5979c086684d2404 = 'loadGroupByOptions';
const $8e6e35a2682b0ead$export$f7109619a5e9e0d6 = 'jira-native-issue-table';
const $8e6e35a2682b0ead$export$64d8bb86ca32b86 = 'changeGroupByField';
const $8e6e35a2682b0ead$export$50d7c3ca7f7b9b40 = 'groupByDropdownLoadMoreTrigger';
const $8e6e35a2682b0ead$export$5871373bb32128e8 = 'groupByDropdownSearch';

parcelRegister("9lDcB", function(module, exports) {
$parcel$export(module.exports, "GroupByDropdown", () => $9953671bbd01655a$export$84685e583ac84574);

var $jLVAI = parcelRequire("jLVAI");

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $j4oe4 = parcelRequire("j4oe4");

var $e2Zbt = parcelRequire("e2Zbt");

var $9pTd3 = parcelRequire("9pTd3");

var $5CSKW = parcelRequire("5CSKW");

var $7rjYb = parcelRequire("7rjYb");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $2gvG4 = parcelRequire("2gvG4");

var $guChT = parcelRequire("guChT");

var $cxKOj = parcelRequire("cxKOj");

var $dZ3jN = parcelRequire("dZ3jN");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $b8OI0 = parcelRequire("b8OI0");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $4cTDP = parcelRequire("4cTDP");


var $ggyb9 = parcelRequire("ggyb9");

var $65Ij3 = parcelRequire("65Ij3");

var $5b5GI = parcelRequire("5b5GI");

var $lehTD = parcelRequire("lehTD");
const $9953671bbd01655a$export$84685e583ac84574 = ({ spreadsheetView: spreadsheetView, onChangeGroupedByField: onChangeGroupedByField })=>{
    const cantGroupIssuesContentIssueTermRefreshGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $lehTD.default).cantGroupIssuesContentIssueTermRefreshGalaxia : (0, $lehTD.default).cantGroupIssuesContentIssueTermRefresh;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onExperienceStart = (0, $8Uqf3.useExperienceStart)({
        experience: (0, $8e6e35a2682b0ead$export$5979c086684d2404),
        analyticsSource: (0, $8e6e35a2682b0ead$export$f7109619a5e9e0d6)
    });
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $8e6e35a2682b0ead$export$5979c086684d2404)
    });
    (0, $eJOHy.useEffect)(()=>{
        onExperienceStart();
    }, [
        onExperienceStart
    ]);
    const data = (0, $j4oe4.useFragment)((0, $jLVAI.default), spreadsheetView);
    const groupByFieldFromQuery = (0, $eJOHy.useMemo)(()=>data?.viewSettings?.groupByConfig?.groupByField ? {
            fieldId: data.viewSettings.groupByConfig.groupByField.fieldId,
            name: data.viewSettings.groupByConfig.groupByField.name
        } : null, [
        data?.viewSettings?.groupByConfig?.groupByField
    ]);
    const prevGroupByFieldFromQuery = (0, $eJOHy.useRef)(groupByFieldFromQuery);
    const [groupByField, setGroupByField] = (0, $eJOHy.useState)(groupByFieldFromQuery);
    // If group by field changes in the query response, update local state to keep it in sync
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(groupByFieldFromQuery, prevGroupByFieldFromQuery.current)) {
        prevGroupByFieldFromQuery.current = groupByFieldFromQuery;
        setGroupByField(groupByFieldFromQuery);
    }
    const onUpdateGroupByFieldAndRefetch = (0, $eJOHy.useCallback)((newGroupByField)=>{
        if (groupByField?.fieldId !== newGroupByField?.fieldId) {
            setGroupByField(newGroupByField ?? null);
            onChangeGroupedByField(newGroupByField?.fieldId);
        }
    }, [
        groupByField,
        onChangeGroupedByField
    ]);
    const issueSearchInput = data?.filterId && {
        filterId: data.filterId
    } || data?.jql && {
        jql: data.jql
    } || undefined;
    const groupByFieldId = groupByField?.fieldId;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $65Ij3.groupByDropdownEntryPoint), {
        nodeId: data.id,
        selectedFieldId: groupByFieldId,
        issueSearchInput: issueSearchInput
    });
    const buttonTrigger = (0, $dZ3jN.useEntryPointButtonTrigger)(entryPointActions);
    (0, $2gvG4.addUFOCustomData)({
        groupByFieldId: data?.viewSettings?.groupByConfig?.groupByField?.typeKey,
        isGrouping: data?.viewSettings?.isGroupingEnabled
    });
    const errorFallback = (0, $eJOHy.useCallback)(({ error: error })=>{
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'issue-table-group-by-dropdown',
                packageName: (0, $8e6e35a2682b0ead$export$b8b9d90f9e5bd72b),
                teamName: (0, $8e6e35a2682b0ead$export$d57b6b390e78d90f)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        onExperienceFail((0, $8e6e35a2682b0ead$export$b8b9d90f9e5bd72b), error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $9953671bbd01655a$var$errorFallbackStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), null, formatMessage((0, $lehTD.default).entrypointErrorContent)));
    }, [
        formatMessage,
        onExperienceFail
    ]);
    if (!data?.viewSettings?.canEnableGrouping) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        trigger: ({ triggerRef: triggerRef, onClick: onClick, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
                ...triggerProps,
                ref: triggerRef,
                onClick: (event, analyticsEvent)=>{
                    (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'button clicked', 'issueTableGroupByDropdownDisabledTrigger');
                    onClick && onClick(event);
                }
            }, formatMessage((0, $lehTD.default).groupByLabelWithoutSelection)),
        placement: "bottom-end",
        shouldRenderToParent: true,
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9953671bbd01655a$var$cantGroupIssuesStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), null, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? cantGroupIssuesContentIssueTermRefreshGalaxia : (0, $lehTD.default).cantGroupIssuesContent))));
    if ((0, $4cTDP.fg)('group_by_any_field')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b8OI0.PopupTrigger), {
        entryPoint: (0, $5b5GI.groupByDropdownWithSearchEntryPoint),
        entryPointParams: {
            nodeId: data.id,
            issueSearchInput: issueSearchInput
        },
        entryPointProps: {
            selectedFieldId: groupByFieldId,
            onUpdateGroupByFieldAndRefetch: onUpdateGroupByFieldAndRefetch,
            savedViewId: data?.savedViewId,
            issueSearchInput: issueSearchInput
        },
        shouldRenderToParent: true,
        placement: "bottom-end",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ggyb9.LoadingContent), null),
        errorFallback: errorFallback,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
                name: "group-by-any-field-dropdown"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
                ...triggerProps,
                isSelected: Boolean(groupByField) || triggerProps['aria-expanded'],
                testId: "issue-table-group-by-dropdown.ui.group-by-dropdown",
                onClick: (_, analyticsEvent)=>{
                    (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'button clicked', 'issueTableGroupByDropdownTrigger', {
                        isGroupByAnyFieldExperimentEnabled: true
                    });
                }
            }, groupByField?.name ? formatMessage((0, $lehTD.default).groupByLabelWithASelection, {
                groupByField: groupByField.name
            }) : formatMessage((0, $lehTD.default).groupByLabelWithoutSelection)))
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        trigger: ({ triggerRef: triggerRef, onClick: onClick, isSelected: isSelected, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
                ...triggerProps,
                isSelected: Boolean(groupByField) || isSelected,
                testId: "issue-table-group-by-dropdown.ui.group-by-dropdown",
                ref: (0, $e2Zbt.mergeRefs)([
                    triggerRef,
                    buttonTrigger
                ]),
                onClick: (event, analyticsEvent)=>{
                    (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'button clicked', 'issueTableGroupByDropdownTrigger');
                    onClick && onClick(event);
                }
            }, groupByField?.name ? formatMessage((0, $lehTD.default).groupByLabelWithASelection, {
                groupByField: groupByField.name
            }) : formatMessage((0, $lehTD.default).groupByLabelWithoutSelection)),
        placement: "bottom-end",
        shouldRenderToParent: true,
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "async-jira-spreadsheet-group-by-dropdown",
        packageName: (0, $8e6e35a2682b0ead$export$b8b9d90f9e5bd72b),
        teamName: (0, $8e6e35a2682b0ead$export$d57b6b390e78d90f),
        errorFallback: errorFallback,
        runtimeProps: {
            onUpdateGroupByFieldAndRefetch: onUpdateGroupByFieldAndRefetch,
            savedViewId: data?.savedViewId
        },
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ggyb9.LoadingContent), null)
    }));
};
const $9953671bbd01655a$var$cantGroupIssuesStyles = (0, $1DXK0.xcss)({
    marginInline: 'space.300',
    marginBlock: 'space.200',
    width: '250px',
    whiteSpace: 'initial'
});
const $9953671bbd01655a$var$errorFallbackStyles = (0, $1DXK0.xcss)({
    padding: 'space.200',
    width: '250px'
});

});
parcelRegister("jLVAI", function(module, exports) {
$parcel$export(module.exports, "default", () => $137bdf7f28275f67$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<33bcb9e5fc387f3bd75257360c4c5407>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $137bdf7f28275f67$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "settings"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "GroupByDropdown",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "jql"
                },
                {
                    "kind": "ScalarField",
                    "name": "filterId"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "settings",
                            "variableName": "settings"
                        },
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "canEnableGrouping"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isGroupingEnabled"
                        },
                        {
                            "concreteType": "JiraSpreadsheetGroupByConfig",
                            "kind": "LinkedField",
                            "name": "groupByConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraField",
                                    "kind": "LinkedField",
                                    "name": "groupByField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "typeKey"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "savedViewId"
                        }
                    ]
                }
            ],
            "type": "JiraIssueSearchViewMetadata",
            "abstractKey": "__isJiraIssueSearchViewMetadata"
        }
    ],
    "type": "JiraView",
    "abstractKey": "__isJiraView"
};
$137bdf7f28275f67$var$node.hash = "2476ed6bbfd0c1c943d8b898805ab5cf";
var $137bdf7f28275f67$export$2e2bcd8739ae039 = $137bdf7f28275f67$var$node;

});

parcelRegister("ggyb9", function(module, exports) {
$parcel$export(module.exports, "LoadingContent", () => $050382b58c1f7d8d$export$4ab3512e4872e6ff);

var $eJOHy = parcelRequire("eJOHy");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");
const $050382b58c1f7d8d$export$4ab3512e4872e6ff = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $050382b58c1f7d8d$var$loadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "large"
    }));
const $050382b58c1f7d8d$var$loadingStyles = (0, $1DXK0.xcss)({
    width: '250px',
    paddingBlock: 'space.500'
});

});

parcelRegister("65Ij3", function(module, exports) {
$parcel$export(module.exports, "groupByDropdownEntryPoint", () => $52f38d8054b7f8e0$export$427ad501ef456b18);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $5eGBi = parcelRequire("5eGBi");

const $52f38d8054b7f8e0$export$427ad501ef456b18 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("1HtBO")), {
        moduleId: "9655b1ba",
        priority: "interaction"
    }),
    getPreloadProps: ({ nodeId: nodeId, selectedFieldId: selectedFieldId, issueSearchInput: issueSearchInput })=>({
            queries: {
                groupByDropdownQuery: {
                    parameters: (0, $5eGBi.default),
                    variables: {
                        nodeId: nodeId,
                        issueSearchInput: issueSearchInput
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            },
            extraProps: {
                selectedFieldId: selectedFieldId
            }
        })
});

});
parcelRegister("5eGBi", function(module, exports) {
$parcel$export(module.exports, "default", () => $3afcbc8b2013d091$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a8be77f092b59bbe44267f3713c916c6>>
 * @relayHash 2cff3b81ad990dfa636ab5263e0ce2aa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 331596c1f4968f863f62b9350444ffc690e6bf1e0cdb60eca4a697d599789147
const $3afcbc8b2013d091$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "nodeId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "nodeId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "typeKey"
    }, v9 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v10 = [
        {
            "kind": "RequiredField",
            "field": v4 /*: any*/ ,
            "action": "THROW",
            "path": "node.id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraIssueSearchViewConfigSettings",
                "kind": "LinkedField",
                "name": "viewSettings",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraSpreadsheetGroupByConfig",
                            "kind": "LinkedField",
                            "name": "groupByConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v5 /*: any*/ ,
                                        "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
                                        "kind": "LinkedField",
                                        "name": "availableGroupByFieldOptions",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraField",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v6 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions.edges.node.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v7 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions.edges.node.fieldId"
                                                                },
                                                                v8 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions.edges.node"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "node.viewSettings.groupByConfig"
                    }
                ]
            },
            "action": "THROW",
            "path": "node.viewSettings"
        }
    ], v11 = [
        {
            "concreteType": "JiraIssueSearchViewConfigSettings",
            "kind": "LinkedField",
            "name": "viewSettings",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraSpreadsheetGroupByConfig",
                    "kind": "LinkedField",
                    "name": "groupByConfig",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
                            "kind": "LinkedField",
                            "name": "availableGroupByFieldOptions",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraField",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GroupByDropdownQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": v10 /*: any*/ ,
                            "type": "JiraGroupedListView"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v10 /*: any*/ ,
                            "type": "JiraListView"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "GroupByDropdownQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": v11 /*: any*/ ,
                            "type": "JiraGroupedListView"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v11 /*: any*/ ,
                            "type": "JiraListView"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "331596c1f4968f863f62b9350444ffc690e6bf1e0cdb60eca4a697d599789147",
            "metadata": {},
            "name": "GroupByDropdownQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3afcbc8b2013d091$var$node.hash = "8945ecb0462c3fb7e83ba8aecf17cfd4";
var $3afcbc8b2013d091$export$2e2bcd8739ae039 = $3afcbc8b2013d091$var$node;

});

parcelRegister("1HtBO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3I48u").then(()=>parcelRequire('hTzue'));

});


parcelRegister("5b5GI", function(module, exports) {
$parcel$export(module.exports, "groupByDropdownWithSearchEntryPoint", () => $55b821bd946c6219$export$413fb55bbc4cc5ba);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $ciGOg = parcelRequire("ciGOg");

const $55b821bd946c6219$export$413fb55bbc4cc5ba = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("kUJG9")), {
        moduleId: "f78c7a64",
        priority: "interaction"
    }),
    getPreloadProps: ({ nodeId: nodeId, issueSearchInput: issueSearchInput })=>({
            queries: {
                groupByDropdownQuery: {
                    parameters: (0, $ciGOg.default),
                    variables: {
                        nodeId: nodeId,
                        issueSearchInput: issueSearchInput
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("ciGOg", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3edcb2b24fff483$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c86b55ed9ca5e1020ac3f6f3182a28f7>>
 * @relayHash a38ddcf32892cfe84f6c7e4dbd966d8a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f35c4e176ac1b0c02a04adf37a70d34dcdaa280369cdcbfd9f93ac923fe30d14
const $f3edcb2b24fff483$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "nodeId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "nodeId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "kind": "FragmentSpread",
            "name": "GroupByDropdownWithSearch_viewSettings"
        },
        {
            "concreteType": "JiraIssueSearchViewConfigSettings",
            "kind": "LinkedField",
            "name": "viewSettings",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraSpreadsheetGroupByConfig",
                    "kind": "LinkedField",
                    "name": "groupByConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "GroupByDropdownWithSearch"
                        }
                    ]
                }
            ]
        }
    ], v6 = {
        "kind": "Variable",
        "name": "issueSearchInput",
        "variableName": "issueSearchInput"
    }, v7 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "name"
    }, v9 = {
        "kind": "ScalarField",
        "name": "typeKey"
    }, v10 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        },
        v6 /*: any*/ 
    ], v11 = [
        {
            "concreteType": "JiraIssueSearchViewConfigSettings",
            "kind": "LinkedField",
            "name": "viewSettings",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraSpreadsheetGroupByConfig",
                    "kind": "LinkedField",
                    "name": "groupByConfig",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 5
                                },
                                v6 /*: any*/ 
                            ],
                            "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
                            "kind": "LinkedField",
                            "name": "recentlyUsed",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraField",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraSpreadsheetGroupByConfig",
                            "kind": "LinkedField",
                            "name": "groupByConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "availableGroupByFieldOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraField",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v3 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v10 /*: any*/ ,
                                    "filters": [
                                        "issueSearchInput",
                                        "filter"
                                    ],
                                    "handle": "connection",
                                    "key": "RefetchIssueTableGroupByOptionsQuery_availableGroupByFieldOptions",
                                    "kind": "LinkedHandle",
                                    "name": "availableGroupByFieldOptions"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GroupByDropdownWithSearchQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": v5 /*: any*/ ,
                            "type": "JiraGroupedListView"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v5 /*: any*/ ,
                            "type": "JiraListView"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "GroupByDropdownWithSearchQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": v11 /*: any*/ ,
                            "type": "JiraGroupedListView"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v11 /*: any*/ ,
                            "type": "JiraListView"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f35c4e176ac1b0c02a04adf37a70d34dcdaa280369cdcbfd9f93ac923fe30d14",
            "metadata": {},
            "name": "GroupByDropdownWithSearchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f3edcb2b24fff483$var$node.hash = "7fa6cbed6e0d28e4e4a9043f5c254599";
var $f3edcb2b24fff483$export$2e2bcd8739ae039 = $f3edcb2b24fff483$var$node;

});

parcelRegister("kUJG9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("Syszu").then(()=>parcelRequire('6O5BX'));

});


parcelRegister("lehTD", function(module, exports) {
$parcel$export(module.exports, "default", () => $da8ad8f060855b12$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $da8ad8f060855b12$var$messages = (0, $7qGN1.defineMessages)({
    groupByLabelWithoutSelection: {
        "id": "issue-table-group-by-dropdown.group-by-label-without-selection",
        "defaultMessage": "Group"
    },
    groupByLabelWithASelection: {
        "id": "issue-table-group-by-dropdown.group-by-label-with-a-selection",
        "defaultMessage": "Group: {groupByField}"
    },
    cantGroupIssuesContent: {
        "id": "issue-table-group-by-dropdown.cant-group-issues-content",
        "defaultMessage": "We can only group issues when you filter issues from one project. Update your JQL filter and try again."
    },
    cantGroupIssuesContentIssueTermRefresh: {
        "id": "issue-table-group-by-dropdown.cant-group-issues-content-issue-term-refresh",
        "defaultMessage": "We can only group work items when you filter work items from one project. Update your JQL filter and try again."
    },
    entrypointErrorContent: {
        "id": "issue-table-group-by-dropdown.entrypoint-error-content",
        "defaultMessage": "Something went wrong. Try loading the content again."
    },
    cantGroupIssuesContentIssueTermRefreshGalaxia: {
        "id": "issue-table-group-by-dropdown.cant-group-issues-content-issue-term-refresh-galaxia",
        "defaultMessage": "We can only group work items when you filter work items from one space. Update your JQL filter and try again."
    }
});
var $da8ad8f060855b12$export$2e2bcd8739ae039 = $da8ad8f060855b12$var$messages;

});



parcelRegister("2nr0r", function(module, exports) {
$parcel$export(module.exports, "HideDoneItemsToggle", () => $4c9fec0bc043f3fe$export$b7b414a8403ed1a2);

var $dTJMe = parcelRequire("dTJMe");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5vQ2T = parcelRequire("5vQ2T");

var $bnGsL = parcelRequire("bnGsL");

const $4c9fec0bc043f3fe$export$b7b414a8403ed1a2 = (props)=>{
    const viewResultData = (0, $j4oe4.useFragment)((0, $dTJMe.default), props.viewResult);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "unmount",
        id: "issue-table-hide-done-toggle",
        packageName: (0, $54713f11448e89c8$export$b8b9d90f9e5bd72b),
        teamName: (0, $54713f11448e89c8$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bnGsL.HideDoneItemsToggle), {
        isSavedViewsEnabled: props.isSavedViewsEnabled,
        viewResult: viewResultData,
        onChangeHideDone: props.onChangeHideDone,
        onResetSelectedIssues: props.onResetSelectedIssues,
        label: props.label
    }));
};

});
parcelRegister("dTJMe", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb301cd16cb8a9cf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<defb070029cd0c67f0fab86a4f6609b1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fb301cd16cb8a9cf$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isSavedViewsEnabled"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isSavedViewsEnabled",
                    "variableName": "isSavedViewsEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "staticViewInput",
                    "variableName": "staticViewInput"
                }
            ],
            "kind": "FragmentSpread",
            "name": "HideDoneItemsToggle"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$fb301cd16cb8a9cf$var$node.hash = "2308ca6a9ae8c654cb7cfefd8e7aa49b";
var $fb301cd16cb8a9cf$export$2e2bcd8739ae039 = $fb301cd16cb8a9cf$var$node;

});

parcelRegister("bnGsL", function(module, exports) {
$parcel$export(module.exports, "HideDoneItemsToggle", () => $3bde87ef85792065$export$b7b414a8403ed1a2);

var $gM2Lq = parcelRequire("gM2Lq");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");

var $8CBYv = parcelRequire("8CBYv");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $95O7y = parcelRequire("95O7y");

var $keRDt = parcelRequire("keRDt");

var $5dWic = parcelRequire("5dWic");
const $3bde87ef85792065$export$b7b414a8403ed1a2 = ({ isSavedViewsEnabled: isSavedViewsEnabled, viewResult: viewResult, onChangeHideDone: onChangeHideDone, onResetSelectedIssues: onResetSelectedIssues, label: label })=>{
    const viewResultData = (0, $j4oe4.useFragment)((0, $gM2Lq.default), viewResult);
    const { viewSettings: viewSettings, id: id, viewId: viewId, __id: issueSearchViewId, savedViewId: savedViewId } = viewResultData;
    const { hideDone: hideDone } = viewSettings ?? {};
    const [hideDoneIsChecked, setHideDoneIsChecked] = (0, $eJOHy.useState)(hideDone);
    const [, setHideDoneParam] = (0, $95O7y.useQueryParam)('hideDone');
    const [updateHideDone, updateHideDoneOld] = (0, $keRDt.useUpdateHideDoneMutation)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onChange = (0, $eJOHy.useCallback)(()=>{
        if (id) {
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'toggle clicked', 'hideDoneItems', {
                hideDone: !hideDone
            });
            setHideDoneIsChecked(!hideDone);
            setHideDoneParam(hideDone ? 'false' : 'true');
            if (isSavedViewsEnabled) {
                if (savedViewId == null) throw new Error('Missing saved view ID');
                updateHideDone({
                    isHideDoneEnabled: !hideDone,
                    issueSearchViewId: issueSearchViewId,
                    onChangeHideDone: onChangeHideDone,
                    viewARI: savedViewId
                });
            } else updateHideDoneOld({
                isHideDoneEnabled: !hideDone,
                issueSearchViewId: issueSearchViewId,
                issueSearchViewResultAri: id,
                onChangeHideDone: onChangeHideDone
            });
            // reset the selected issue for the bulk operations when chaging the toggle
            onResetSelectedIssues && onResetSelectedIssues();
        }
    }, [
        createAnalyticsEvent,
        hideDone,
        id,
        issueSearchViewId,
        onChangeHideDone,
        onResetSelectedIssues,
        savedViewId,
        setHideDoneParam,
        updateHideDone,
        updateHideDoneOld,
        isSavedViewsEnabled
    ]);
    const toggleId = `${viewId}_hide_done_toggle`;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const toggleLabel = (0, $5dWic.default).showHideDoneItems;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("label", {
        htmlFor: toggleId
    }, label || formatMessage(toggleLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8CBYv.default), {
        size: (0, $4cTDP.fg)('jsc-1730-adjust_toggle_size') ? undefined : 'large',
        id: toggleId,
        onChange: onChange,
        isChecked: Boolean(hideDoneIsChecked)
    })));
};

});
parcelRegister("gM2Lq", function(module, exports) {
$parcel$export(module.exports, "default", () => $384018667e83bb38$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<317fc8d7d2460533be0b488e23485f20>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $384018667e83bb38$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isSavedViewsEnabled"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "settings"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "HideDoneItemsToggle",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "viewId"
        },
        {
            "condition": "isSavedViewsEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "savedViewId"
                }
            ]
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "settings",
                            "variableName": "settings"
                        },
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hideDone"
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$384018667e83bb38$var$node.hash = "4aa09a710242afb396f907a7400aec11";
var $384018667e83bb38$export$2e2bcd8739ae039 = $384018667e83bb38$var$node;

});

parcelRegister("8CBYv", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b71259385cf6352$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $gl2vi = parcelRequire("gl2vi");

var $6XkOW = parcelRequire("6XkOW");

var $5wxTT = parcelRequire("5wxTT");

var $eGOwo = parcelRequire("eGOwo");

var $7ep4S = parcelRequire("7ep4S");

var $6fs4r = parcelRequire("6fs4r");

var $hqCmO = parcelRequire("hqCmO");
const $8b71259385cf6352$var$LOADING_LABEL = ', Loading';
const $8b71259385cf6352$var$basicStyles = null;
const $8b71259385cf6352$var$iconStyles = null;
const $8b71259385cf6352$var$sizeStyles = {
    regular: "_2rkopxbi _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rkov47k _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
const $8b71259385cf6352$var$noop = (0, $3Vuhz.default);
const $8b71259385cf6352$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $8b71259385cf6352$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $8b71259385cf6352$var$Toggle = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $8b71259385cf6352$var$noop, onChange: providedChange = $8b71259385cf6352$var$noop, onFocus: providedFocus = $8b71259385cf6352$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, isLoading: isLoading, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $eJOHy.useState)(defaultChecked);
    const loadingLabelId = (0, $gl2vi.useId)();
    const handleBlur = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$8b71259385cf6352$var$analyticsAttributes
    });
    const handleFocus = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$8b71259385cf6352$var$analyticsAttributes
    });
    const handleChange = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$8b71259385cf6352$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined
    };
    const legacyIconSize = $8b71259385cf6352$var$iconSizeMap[size];
    const labelId = (0, $gl2vi.useId)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("label", {
        ...controlProps,
        className: (0, $hcewu.default)([
            "_v564kete _1h6d3acm _1dqonqa1 _189e1dm9 _1e0c1o8l _vchh18uv _kqswh2mm _1y1m1ntv _bfhk76s1 _syaz5w2r _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31qll _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1ys4194a _krlfnqa1 _ju3ddkaa _1bki1y1w _1flt1y1w _3xv21y1w _9471g4a2 _ucab5w2r _mqf815t7 _3dj215t7 _1dl915t7 _1div5w2r _1il8kb7n _y54d5w2r _irr353wy _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1plud4ly _1uo853wy _178c1y1w _16rslghj _i5ec1w7i",
            size === 'large' && !(0, $eGOwo.fg)('platform-visual-refresh-icons') && "_1n82gktf _19vpgktf",
            $8b71259385cf6352$var$sizeStyles[size]
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                id: labelId,
                hidden: true,
                children: isLoading ? `${label}${$8b71259385cf6352$var$LOADING_LABEL}` : label
            }) : null,
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": isLoading && label ? `${labelId} ${loadingLabelId}` : label ? labelId : undefined,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hqCmO.default), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                children: isLoading && shouldChecked ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                    size: "xsmall",
                    appearance: "invert"
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6XkOW))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-check-icon`,
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hqCmO.default), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                children: isLoading && !shouldChecked ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                    size: "xsmall",
                    appearance: "invert"
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5wxTT))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-cross-icon`,
                    size: "small"
                })
            }),
            isLoading && !label && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
                id: loadingLabelId,
                children: $8b71259385cf6352$var$LOADING_LABEL
            })
        ]
    });
}));
$8b71259385cf6352$var$Toggle.displayName = 'Toggle';
var $8b71259385cf6352$export$2e2bcd8739ae039 = $8b71259385cf6352$var$Toggle;

});
parcelRegister("6XkOW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::600b8f5df6a73844cbfa316238c6d2e9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5108674e45de2f8c$var$_react = $5108674e45de2f8c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5108674e45de2f8c$var$_checkMark = $5108674e45de2f8c$var$_interopRequireDefault((parcelRequire("lwpci")));

var $5108674e45de2f8c$var$_done = $5108674e45de2f8c$var$_interopRequireDefault((parcelRequire("37Ug4")));
function $5108674e45de2f8c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5108674e45de2f8c$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5108674e45de2f8c$var$_react.default.createElement($5108674e45de2f8c$var$_checkMark.default, Object.assign({
        name: "CheckMarkIcon",
        LEGACY_fallbackIcon: $5108674e45de2f8c$var$_done.default
    }, props));
$5108674e45de2f8c$var$CheckMarkIcon.displayName = 'CheckMarkIconMigration';
var $5108674e45de2f8c$var$_default = module.exports.default = $5108674e45de2f8c$var$CheckMarkIcon;

});
parcelRegister("lwpci", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf60af7e41b379d3a36d6fe455c57ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fab021c59a8f6419$var$_react = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fab021c59a8f6419$var$_baseNew = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $fab021c59a8f6419$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fab021c59a8f6419$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $fab021c59a8f6419$var$_react.default.createElement($fab021c59a8f6419$var$_baseNew.default, Object.assign({
        name: "CheckMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$fab021c59a8f6419$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $fab021c59a8f6419$var$_default = module.exports.default = $fab021c59a8f6419$var$CheckMarkIcon;

});

parcelRegister("37Ug4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $246daa468c067835$var$_react = $246daa468c067835$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $246daa468c067835$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $246daa468c067835$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $246daa468c067835$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props));
$246daa468c067835$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $246daa468c067835$var$_default = module.exports.default = $246daa468c067835$var$EditorDoneIcon;

});


parcelRegister("5wxTT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::18cd44b40ff8809efea24ae850576bc8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $405a3cd7d6c6872a$var$_react = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $405a3cd7d6c6872a$var$_cross = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("6zhpo")));

var $405a3cd7d6c6872a$var$_close = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("6OLN4")));
function $405a3cd7d6c6872a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $405a3cd7d6c6872a$var$CrossIcon = (props)=>/*#__PURE__*/ $405a3cd7d6c6872a$var$_react.default.createElement($405a3cd7d6c6872a$var$_cross.default, Object.assign({
        name: "CrossIcon",
        LEGACY_fallbackIcon: $405a3cd7d6c6872a$var$_close.default
    }, props));
$405a3cd7d6c6872a$var$CrossIcon.displayName = 'CrossIconMigration';
var $405a3cd7d6c6872a$var$_default = module.exports.default = $405a3cd7d6c6872a$var$CrossIcon;

});
parcelRegister("6OLN4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f6c7bc606f2d15e$var$_react = $4f6c7bc606f2d15e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $4f6c7bc606f2d15e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f6c7bc606f2d15e$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $4f6c7bc606f2d15e$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props));
$4f6c7bc606f2d15e$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $4f6c7bc606f2d15e$var$_default = module.exports.default = $4f6c7bc606f2d15e$var$EditorCloseIcon;

});


parcelRegister("hqCmO", function(module, exports) {
$parcel$export(module.exports, "default", () => $d938694e808b84dc$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
const $d938694e808b84dc$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $d938694e808b84dc$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        xcss: (0, $6qaBj.cx)($d938694e808b84dc$var$styles.iconContainer, isHidden && (0, $eGOwo.fg)('platform-visual-refresh-icons') && $d938694e808b84dc$var$styles.hidden, size === 'regular' && $d938694e808b84dc$var$styles.iconContainerRegular, size === 'large' && $d938694e808b84dc$var$styles.iconContainerLarge, position === 'left' && $d938694e808b84dc$var$styles.left, position === 'right' && $d938694e808b84dc$var$styles.right),
        children: children
    });
};
var $d938694e808b84dc$export$2e2bcd8739ae039 = $d938694e808b84dc$var$IconContainer;

});


parcelRegister("keRDt", function(module, exports) {
$parcel$export(module.exports, "useUpdateHideDoneMutation", () => $65ad3be5a7bae7eb$export$1d65880c4ddc0209);

var $i9peI = parcelRequire("i9peI");

var $9HL95 = parcelRequire("9HL95");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $4SjAP = parcelRequire("4SjAP");

var $lRq8t = parcelRequire("lRq8t");

var $cSXp8 = parcelRequire("cSXp8");

var $8Uqf3 = parcelRequire("8Uqf3");

var $aqnJa = parcelRequire("aqnJa");

var $4ctwv = parcelRequire("4ctwv");

var $kh7bJ = parcelRequire("kh7bJ");


var $4knN1 = parcelRequire("4knN1");
const $65ad3be5a7bae7eb$export$1d65880c4ddc0209 = ()=>{
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    const onExperienceStart = (0, $8Uqf3.useExperienceStart)({
        experience: (0, $54713f11448e89c8$export$6a7d6ab86cfdfcdc),
        analyticsSource: (0, $54713f11448e89c8$export$f7109619a5e9e0d6)
    });
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $54713f11448e89c8$export$6a7d6ab86cfdfcdc)
    });
    const onExperienceSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: (0, $54713f11448e89c8$export$6a7d6ab86cfdfcdc)
    });
    const [commitOld] = (0, $j4oe4.useMutation)((0, $9HL95.default));
    const [commit] = (0, $j4oe4.useMutation)((0, $i9peI.default));
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleError = (0, $eJOHy.useCallback)((error)=>{
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'issue-table-hide-done-toggle',
                packageName: (0, $54713f11448e89c8$export$b8b9d90f9e5bd72b),
                teamName: (0, $54713f11448e89c8$export$d57b6b390e78d90f)
            },
            error: error
        });
        onExperienceFail((0, $54713f11448e89c8$export$b8b9d90f9e5bd72b), error);
        showFlag({
            messageId: 'issue-table-hide-done-toggle.services.update-hide-done-toggle.show-flag.error',
            messageType: 'transactional',
            id: 'hideDoneToggleError',
            title: formatMessage((0, $4knN1.default).hideDoneErrorFlagTitle),
            description: formatMessage((0, $4knN1.default).hideDoneErrorFlagDescription),
            isAutoDismiss: true,
            type: 'error'
        });
    }, [
        formatMessage,
        onExperienceFail,
        showFlag
    ]);
    const storeUpdater = (0, $eJOHy.useCallback)(({ isHideDoneEnabled: isHideDoneEnabled, store: store, issueSearchViewId: issueSearchViewId })=>{
        const issueSearchRecord = store.get(issueSearchViewId);
        if (issueSearchRecord) {
            const viewSettingsRecord = issueSearchRecord.getLinkedRecord('viewSettings');
            if (viewSettingsRecord) viewSettingsRecord.setValue(isHideDoneEnabled, 'hideDone');
        }
    }, []);
    const updateHideDone = (0, $eJOHy.useCallback)(({ issueSearchViewId: issueSearchViewId, isHideDoneEnabled: isHideDoneEnabled, onChangeHideDone: onChangeHideDone, viewARI: viewARI })=>{
        if (isAnonymous) {
            onChangeHideDone(isHideDoneEnabled);
            return;
        }
        onExperienceStart();
        commit({
            variables: {
                input: {
                    viewId: viewARI,
                    hideDoneItems: isHideDoneEnabled
                }
            },
            optimisticUpdater (store) {
                storeUpdater({
                    store: store,
                    isHideDoneEnabled: isHideDoneEnabled,
                    issueSearchViewId: issueSearchViewId
                });
            },
            updater: (store)=>{
                storeUpdater({
                    store: store,
                    issueSearchViewId: issueSearchViewId,
                    isHideDoneEnabled: isHideDoneEnabled
                });
            },
            onCompleted: (response)=>{
                const { errors: errors } = response?.jira_setIssueSearchHideDoneItems ?? {};
                if (errors && errors.length > 0) {
                    const error = new (0, $4SjAP.MutationError)(errors[0]);
                    handleError(error);
                    return;
                }
                onExperienceSuccess();
            },
            onError: handleError
        });
        onChangeHideDone(isHideDoneEnabled);
    }, [
        commit,
        handleError,
        isAnonymous,
        onExperienceStart,
        onExperienceSuccess,
        storeUpdater
    ]);
    const updateHideDoneOld = (0, $eJOHy.useCallback)(({ issueSearchViewResultAri: issueSearchViewResultAri, issueSearchViewId: issueSearchViewId, isHideDoneEnabled: isHideDoneEnabled, onChangeHideDone: onChangeHideDone })=>{
        if (isAnonymous) {
            onChangeHideDone(isHideDoneEnabled);
            return;
        }
        onExperienceStart();
        commitOld({
            variables: {
                viewId: issueSearchViewResultAri,
                isHideDoneEnabled: isHideDoneEnabled
            },
            optimisticUpdater (store) {
                storeUpdater({
                    store: store,
                    isHideDoneEnabled: isHideDoneEnabled,
                    issueSearchViewId: issueSearchViewId
                });
            },
            updater: (store)=>{
                storeUpdater({
                    store: store,
                    issueSearchViewId: issueSearchViewId,
                    isHideDoneEnabled: isHideDoneEnabled
                });
            },
            onCompleted: (response)=>{
                const { errors: errors } = response?.jira?.updateIssueSearchHideDonePreference ?? {};
                if (errors && errors.length > 0) {
                    const error = new (0, $4SjAP.MutationError)(errors[0]);
                    handleError(error);
                    return;
                }
                onExperienceSuccess();
            },
            onError: handleError
        });
        onChangeHideDone(isHideDoneEnabled);
    }, [
        commitOld,
        handleError,
        isAnonymous,
        onExperienceStart,
        onExperienceSuccess,
        storeUpdater
    ]);
    return [
        updateHideDone,
        updateHideDoneOld
    ];
};

});
parcelRegister("i9peI", function(module, exports) {
$parcel$export(module.exports, "default", () => $282bd6a6851ecad1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3bfebb3bf678e0e1b69c5244627ea4c6>>
 * @relayHash 8c2a28b2742e975df8df865d5d95c688
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0eeabc09ee887c36e9f8864d01bf22bb46773618fb12f5da9972c2f73408a9fe
const $282bd6a6851ecad1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useUpdateHideDoneMutation234Mutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraSetIssueSearchHideDoneItemsPayload",
                    "kind": "LinkedField",
                    "name": "jira_setIssueSearchHideDoneItems",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useUpdateHideDoneMutation234Mutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraSetIssueSearchHideDoneItemsPayload",
                    "kind": "LinkedField",
                    "name": "jira_setIssueSearchHideDoneItems",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0eeabc09ee887c36e9f8864d01bf22bb46773618fb12f5da9972c2f73408a9fe",
            "metadata": {},
            "name": "useUpdateHideDoneMutation234Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$282bd6a6851ecad1$var$node.hash = "08f9d1b39c2b08023c47064c6e435618";
var $282bd6a6851ecad1$export$2e2bcd8739ae039 = $282bd6a6851ecad1$var$node;

});

parcelRegister("9HL95", function(module, exports) {
$parcel$export(module.exports, "default", () => $508702be347cff0a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<11d49272643540d05658343d6d358874>>
 * @relayHash 47a9a8fe991f766b2d21dcac0ef54a1c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cfe06b3d5b20c6d7101a421841c277d54d17c626f47566864f17bfb88f39a093
const $508702be347cff0a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isHideDoneEnabled"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "isHideDoneEnabled",
            "variableName": "isHideDoneEnabled"
        },
        {
            "kind": "Variable",
            "name": "viewId",
            "variableName": "viewId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUpdateHideDoneMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraIssueSearchHideDonePreferenceMutationPayload",
                            "kind": "LinkedField",
                            "name": "updateIssueSearchHideDonePreference",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useUpdateHideDoneMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraIssueSearchHideDonePreferenceMutationPayload",
                            "kind": "LinkedField",
                            "name": "updateIssueSearchHideDonePreference",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "cfe06b3d5b20c6d7101a421841c277d54d17c626f47566864f17bfb88f39a093",
            "metadata": {},
            "name": "useUpdateHideDoneMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$508702be347cff0a$var$node.hash = "d5e39e06e60c261494c6de5b9d3d8d64";
var $508702be347cff0a$export$2e2bcd8739ae039 = $508702be347cff0a$var$node;

});

const $54713f11448e89c8$export$b8b9d90f9e5bd72b = 'jiraIssueTableHideDoneToggle';
const $54713f11448e89c8$export$d57b6b390e78d90f = 'keystone';
const $54713f11448e89c8$export$6a7d6ab86cfdfcdc = 'hideDoneToggle';
const $54713f11448e89c8$export$f7109619a5e9e0d6 = 'jira-native-issue-table';

parcelRegister("4knN1", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ed3ad91b53f3861$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4ed3ad91b53f3861$var$messages = (0, $7qGN1.defineMessages)({
    hideDoneErrorFlagTitle: {
        "id": "issue-table-hide-done-error-flag-title",
        "defaultMessage": "Hide done preference could not be updated."
    },
    hideDoneErrorFlagDescription: {
        "id": "issue-table-hide-done-error-flag-description",
        "defaultMessage": "Something went wrong. Please try again."
    }
});
var $4ed3ad91b53f3861$export$2e2bcd8739ae039 = $4ed3ad91b53f3861$var$messages;

});


parcelRegister("5dWic", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd6f7dcc32af4979$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $bd6f7dcc32af4979$var$messages = (0, $7qGN1.defineMessages)({
    showHideDoneItems: {
        "id": "issue-table-hide-done-items",
        "defaultMessage": "Hide done work items"
    },
    showHideDoneItemsOldTerminology: {
        "id": "issue-table-hide-done-items.old-terminology",
        "defaultMessage": "Hide done"
    }
});
var $bd6f7dcc32af4979$export$2e2bcd8739ae039 = $bd6f7dcc32af4979$var$messages;

});



parcelRegister("a9bnL", function(module, exports) {
$parcel$export(module.exports, "SaveResetViewSettingsButton", () => $0bd9b24ae4cf01c6$export$2a684f25916e98c1);

var $960Vc = parcelRequire("960Vc");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5vQ2T = parcelRequire("5vQ2T");


var $j7OgC = parcelRequire("j7OgC");
const $0bd9b24ae4cf01c6$export$2a684f25916e98c1 = /*#__PURE__*/ (0, $eJOHy.memo)(({ onReset: onReset, viewFragment: viewFragment, jql: jql, onChangeJql: onChangeJql })=>{
    const viewMetadata = (0, $j4oe4.useFragment)((0, $960Vc.default), viewFragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "unmount",
        id: "issue-navigator-save-reset-view-settings-button",
        packageName: (0, $d59435c9c2a78ff3$export$b8b9d90f9e5bd72b),
        teamName: (0, $d59435c9c2a78ff3$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j7OgC.SaveResetViewSettingsButtonCollapsible), {
        jql: jql,
        onReset: onReset,
        onChangeJql: onChangeJql,
        viewFragment: viewMetadata
    }));
});

});
parcelRegister("960Vc", function(module, exports) {
$parcel$export(module.exports, "default", () => $eca09f1b93a6d610$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2db70b5d990949deb789516bf2bf00fe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $eca09f1b93a6d610$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SaveResetViewSettingsButton",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SaveResetViewSettingsButtonCollapsible"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$eca09f1b93a6d610$var$node.hash = "1b783a6984cd893232aea5d467008ee0";
var $eca09f1b93a6d610$export$2e2bcd8739ae039 = $eca09f1b93a6d610$var$node;

});

const $d59435c9c2a78ff3$export$b8b9d90f9e5bd72b = 'jiraIssueNavigatorSaveResetViewSettingsButton';
const $d59435c9c2a78ff3$export$d57b6b390e78d90f = 'wanjel';

parcelRegister("j7OgC", function(module, exports) {
$parcel$export(module.exports, "SaveResetViewSettingsButtonCollapsible", () => $0f37f611ad0613ee$export$987a12b060ce1a28);

var $7nPBn = parcelRequire("7nPBn");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kLorN = parcelRequire("kLorN");

var $7zccN = parcelRequire("7zccN");
const $0f37f611ad0613ee$export$987a12b060ce1a28 = /*#__PURE__*/ (0, $eJOHy.memo)(({ onReset: onReset, onChangeJql: onChangeJql, viewFragment: viewFragment, jql: jql })=>{
    const viewMetadata = (0, $j4oe4.useFragment)((0, $7nPBn.default), viewFragment);
    return /*#__PURE__*/ $eJOHy.createElement((0, $kLorN.Collapsible), {
        animationDuration: 260,
        direction: "horizontal",
        isExpanded: viewMetadata.isViewConfigModified ?? false
    }, /*#__PURE__*/ $eJOHy.createElement((0, $7zccN.SaveResetViewSettingsButtonUI), {
        jql: jql,
        onReset: onReset,
        onChangeJql: onChangeJql,
        viewFragment: viewMetadata
    }));
});

});
parcelRegister("7nPBn", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea781feb85ee4599$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d4a5de047dc708886fdd9d9f95771dc2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ea781feb85ee4599$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "settings"
        }
    ],
    "kind": "Fragment",
    "name": "SaveResetViewSettingsButtonCollapsible",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SaveResetViewSettingsButtonUI"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "settings",
                    "variableName": "settings"
                }
            ],
            "kind": "ScalarField",
            "name": "isViewConfigModified"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$ea781feb85ee4599$var$node.hash = "47d082e0772298390cd17586b8b85111";
var $ea781feb85ee4599$export$2e2bcd8739ae039 = $ea781feb85ee4599$var$node;

});

parcelRegister("kLorN", function(module, exports) {
$parcel$export(module.exports, "Collapsible", () => $26678bfdf015c2d9$export$6eb0f7ddcda6131f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");
const $26678bfdf015c2d9$var$getSize = (element, direction)=>{
    return direction === 'horizontal' ? element.scrollWidth : element.scrollHeight;
};
const $26678bfdf015c2d9$var$setCollapsedStyle = (wrapper, direction)=>{
    // set max width to 0 and opacity to 0
    wrapper.style.setProperty(`max-${direction === 'horizontal' ? 'width' : 'height'}`, '0px');
    wrapper.style.setProperty('opacity', '0');
    wrapper.style.setProperty('overflow', 'hidden');
};
const $26678bfdf015c2d9$var$setExpandedStyle = (wrapper, content, direction)=>{
    // set the max size to content size and opacity to 1
    wrapper.style.setProperty(`max-${direction === 'horizontal' ? 'width' : 'height'}`, `${$26678bfdf015c2d9$var$getSize(content, direction)}px`);
    wrapper.style.setProperty('opacity', '1');
};
const $26678bfdf015c2d9$var$resetStyle = (wrapper, direction, resetOverflow)=>{
    wrapper.style.removeProperty(`max-${direction === 'horizontal' ? 'width' : 'height'}`);
    wrapper.style.removeProperty('opacity');
    if (resetOverflow) wrapper.style.removeProperty('overflow');
};
const $26678bfdf015c2d9$export$6eb0f7ddcda6131f = ({ animationDuration: animationDuration = 250, children: children, direction: direction = 'vertical', id: id, isExpanded: isExpanded, resetOverflow: resetOverflow = true })=>{
    const didMountRef = (0, $eJOHy.useRef)(false);
    const wrapperRef = (0, $eJOHy.useRef)(null);
    const contentRef = (0, $eJOHy.useRef)(null);
    const [isRendered, setIsRendered] = (0, $eJOHy.useState)(isExpanded);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!wrapperRef.current) return;
        // add the transition to the wrapper
        wrapperRef.current.style.setProperty('transition', `max-${direction === 'horizontal' ? 'width' : 'height'} ${animationDuration}ms ease-in-out, opacity ${animationDuration}ms ease-in-out`);
        if (!resetOverflow) wrapperRef.current.style.setProperty('overflow', 'hidden');
        if (!isExpanded) $26678bfdf015c2d9$var$setCollapsedStyle(wrapperRef.current, direction);
    // initial render only
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }
        if (isExpanded) {
            if (!isRendered) setIsRendered(true);
            else requestAnimationFrame(()=>{
                if (!wrapperRef.current || !contentRef.current) return;
                $26678bfdf015c2d9$var$setExpandedStyle(wrapperRef.current, contentRef.current, direction);
                // wait for the animation to finish before removing the overflow
                Promise.all(wrapperRef.current.getAnimations().map((animation)=>animation.finished) ?? []).then(()=>{
                    wrapperRef.current && $26678bfdf015c2d9$var$resetStyle(wrapperRef.current, direction, resetOverflow);
                });
            });
        } else if (isRendered) {
            if (!wrapperRef.current || !contentRef.current) return;
            $26678bfdf015c2d9$var$setExpandedStyle(wrapperRef.current, contentRef.current, direction);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!wrapperRef.current) return;
                    $26678bfdf015c2d9$var$setCollapsedStyle(wrapperRef.current, direction);
                    // wait for the animation to finish before removing the content
                    Promise.all(wrapperRef.current.getAnimations().map((animation)=>animation.finished) ?? []).then(()=>{
                        setIsRendered(false);
                    });
                });
            });
        }
    }, [
        direction,
        isExpanded,
        isRendered,
        resetOverflow
    ]);
    return /*#__PURE__*/ $eJOHy.createElement("div", {
        id: id,
        ref: wrapperRef
    }, isRendered && /*#__PURE__*/ $eJOHy.createElement("div", {
        ref: contentRef
    }, children));
};

});

parcelRegister("7zccN", function(module, exports) {
$parcel$export(module.exports, "SaveResetViewSettingsButtonUI", () => $78c2efdc833859eb$export$808d70defde8c5d8);

var $fd0q0 = parcelRequire("fd0q0");

var $gVMlj = parcelRequire("gVMlj");

var $lEb91 = parcelRequire("lEb91");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $2WT2V = parcelRequire("2WT2V");

var $5CSKW = parcelRequire("5CSKW");
var $Ay1uj = parcelRequire("Ay1uj");

var $9Gyb2 = parcelRequire("9Gyb2");

var $fwcMD = parcelRequire("fwcMD");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $gHHv2 = parcelRequire("gHHv2");
var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");
var $956it = parcelRequire("956it");

var $54CI2 = parcelRequire("54CI2");
var $guChT = parcelRequire("guChT");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $cSXp8 = parcelRequire("cSXp8");

var $kfvK2 = parcelRequire("kfvK2");

var $2dw1l = parcelRequire("2dw1l");

var $1UVkF = parcelRequire("1UVkF");

var $65jes = parcelRequire("65jes");
const $78c2efdc833859eb$var$tooltipOptions = {
    hideTooltipOnClick: true
};
const $78c2efdc833859eb$export$808d70defde8c5d8 = /*#__PURE__*/ (0, $eJOHy.memo)(({ onReset: onReset, onChangeJql: onChangeJql, viewFragment: viewFragment, jql: jql })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isModalOpen, setModalOpen] = (0, $eJOHy.useState)(false);
    const openModal = (0, $eJOHy.useCallback)(()=>setModalOpen(true), []);
    const closeModal = (0, $eJOHy.useCallback)(()=>setModalOpen(false), []);
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)(); // TODO: SLV-286 - delete this file during spotlight cleanup
    const [isOnboardingVisible, markAsSeen] = (0, $2dw1l.useSavedViewsSpotlightOnboarding)(); // TODO: SLV-286 - remove dropdown controlled state during spotlight cleanup
    const [isDropdownOpen, setIsDropdownOpen] = (0, $eJOHy.useState)(false);
    const { updateQueryParam: updateQueryParam } = (0, $kfvK2.useRouterStoreActions)();
    const viewMetadata = (0, $j4oe4.useFragment)((0, $lEb91.default), viewFragment);
    const canPublishViewConfig = viewMetadata.canPublishViewConfig;
    const savedViewId = viewMetadata.savedViewId;
    if (savedViewId == null) throw new Error('Missing saved view ID');
    const [publish, publishing] = (0, $j4oe4.useMutation)((0, $gVMlj.default));
    const [discard, discarding] = (0, $j4oe4.useMutation)((0, $fd0q0.default));
    const onClickSave = (0, $eJOHy.useCallback)(()=>{
        const saveSettingsSuccessMessageGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $1UVkF.default).saveSettingsSuccessMessageGalaxia : (0, $1UVkF.default).saveSettingsSuccessMessage;
        closeModal();
        const showFailureFlag = ()=>{
            showFlag({
                messageId: 'issue-navigator-save-reset-view-settings-button.ui.show-flag.error.save-settings-failed',
                messageType: 'transactional',
                title: (0, $1UVkF.default).saveSettingsFailedTitle,
                description: (0, $1UVkF.default).saveSettingsFailedMessage,
                type: 'error'
            });
        };
        const viewSettings = viewMetadata.viewSettings;
        const settings = {
            groupBy: viewSettings?.groupByConfig?.groupByField?.fieldId ?? null,
            hideDone: viewSettings?.hideDone,
            hierarchyEnabled: viewSettings?.isHierarchyEnabled,
            jql: jql
        };
        publish({
            variables: {
                input: {
                    viewId: savedViewId,
                    settings: settings
                },
                settings: settings
            },
            /*
       * This updater imperatively updates the isViewConfigModified record to handle the
       * scenario where the variables provided to isViewConfigModified in the preloaded query
       * differ from the variables provided in refetches.
       *
       * This ensures the save/reset view button is correctly hidden when publishing the view
       * immediately after a page refresh.
       *
       * In all other scenarios we can rely on Relay writing the network response to the store
       * via spreading a fragment which contains the isViewConfigModified field.
       */ updater: (store, response)=>{
                const isViewConfigModified = response?.jira_publishIssueSearchConfig?.view?.isViewConfigModified;
                if (response?.jira_publishIssueSearchConfig?.success !== true || isViewConfigModified == null) return;
                const viewRecord = store.get(viewMetadata.__id);
                if (viewRecord == null) return;
                (0, $2WT2V.setIsViewConfigModifiedRecord)({
                    isViewConfigModified: isViewConfigModified,
                    viewRecord: viewRecord
                });
            },
            onError () {
                showFailureFlag();
            },
            onCompleted (response) {
                if (response.jira_publishIssueSearchConfig?.success !== true) {
                    showFailureFlag();
                    return;
                }
                showFlag({
                    messageId: 'issue-navigator-save-reset-view-settings-button.ui.show-flag.success.header.save-reset-view-settings.show-flag.success.save-settings-success',
                    messageType: 'transactional',
                    title: (0, $1UVkF.default).saveSettingsSuccessTitle,
                    description: saveSettingsSuccessMessageGalaxia,
                    type: 'success'
                });
                (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'viewSettings saved');
            }
        });
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'saveSettings');
    }, [
        closeModal,
        createAnalyticsEvent,
        jql,
        publish,
        savedViewId,
        showFlag,
        viewMetadata.__id,
        viewMetadata.viewSettings
    ]);
    const onClickReset = (0, $eJOHy.useCallback)(()=>{
        const showFailureFlag = ()=>{
            showFlag({
                messageId: 'issue-navigator-save-reset-view-settings-button.ui.show-flag.error.header.save-reset-view-settings.show-flag.error.reset-settings-failed',
                messageType: 'transactional',
                title: (0, $1UVkF.default).resetSettingsFailedTitle,
                description: (0, $1UVkF.default).resetSettingsFailedMessage,
                type: 'error'
            });
        };
        discard({
            variables: {
                input: {
                    viewId: savedViewId
                }
            },
            onError () {
                showFailureFlag();
            },
            onCompleted (response) {
                if (response.jira_discardUserIssueSearchConfig?.success !== true || response.jira_discardUserIssueSearchConfig?.view == null) {
                    showFailureFlag();
                    return;
                }
                const savedJql = response.jira_discardUserIssueSearchConfig.view.jql;
                const hideDone = response.jira_discardUserIssueSearchConfig.view.viewSettings?.hideDone;
                const groupBy = response.jira_discardUserIssueSearchConfig.view.viewSettings?.groupByConfig?.groupByField?.fieldId;
                onReset(()=>{
                    if (savedJql && onChangeJql) onChangeJql(savedJql);
                    let hideDoneParam;
                    if (typeof hideDone === 'boolean') hideDoneParam = hideDone ? 'true' : 'false';
                    else hideDoneParam = undefined;
                    updateQueryParam({
                        hideDone: hideDoneParam,
                        groupBy: groupBy ?? undefined
                    }, 'replace');
                });
                (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'viewSettings reset');
            }
        });
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'resetSettings', {
            isProjectAdmin: canPublishViewConfig
        });
    }, [
        canPublishViewConfig,
        createAnalyticsEvent,
        discard,
        onChangeJql,
        onReset,
        savedViewId,
        showFlag,
        updateQueryParam
    ]);
    // TODO: SLV-286 - delete SpotlightManager, SpotlightTarget wrappers during spotlight cleanup
    if (!canPublishViewConfig) return /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            $78c2efdc833859eb$var$styles.root
        ])
    }, /*#__PURE__*/ $eJOHy.createElement((0, $54CI2.default), {
        blanketIsTinted: false
    }, /*#__PURE__*/ $eJOHy.createElement((0, $65jes.SavedViewsOnboarding), {
        isOnboardingVisible: isOnboardingVisible,
        markAsSeen: markAsSeen
    }, /*#__PURE__*/ $eJOHy.createElement((0, $guChT.default), {
        name: "jira-nin-saved-views-dropdown-content"
    }, /*#__PURE__*/ $eJOHy.createElement((0, $Ay1uj.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fwcMD))),
        isLoading: discarding,
        isTooltipDisabled: false,
        label: formatMessage((0, $1UVkF.default).resetViewSettingsButton),
        onClick: ()=>{
            setIsDropdownOpen(false); // TODO: SLV-286 - remove during spotlight cleanup
            onClickReset();
        },
        tooltip: $78c2efdc833859eb$var$tooltipOptions
    })))));
     // TODO: SLV-286 - delete SpotlightManager, SpotlightTarget wrappers during spotlight cleanup
    return /*#__PURE__*/ $eJOHy.createElement((0, $54CI2.default), {
        blanketIsTinted: false
    }, /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            $78c2efdc833859eb$var$styles.root
        ])
    }, /*#__PURE__*/ $eJOHy.createElement((0, $7rjYb.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $eJOHy.createElement((0, $65jes.SavedViewsOnboarding), {
                isAdmin: true,
                isOnboardingVisible: isOnboardingVisible,
                markAsSeen: markAsSeen
            }, /*#__PURE__*/ $eJOHy.createElement((0, $Ay1uj.default), {
                ...props,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9Gyb2))),
                isLoading: discarding || publishing,
                isTooltipDisabled: false,
                label: formatMessage((0, $1UVkF.default).saveOrResetViewSettingsButton),
                ref: triggerRef,
                tooltip: $78c2efdc833859eb$var$tooltipOptions,
                onClick: ()=>{
                    setIsDropdownOpen(!isDropdownOpen);
                }
            })),
        shouldRenderToParent: false,
        placement: "bottom-end" // TODO: SLV-286 - remove dropdown controlled state during spotlight cleanup
        ,
        isOpen: isDropdownOpen,
        onOpenChange: ({ isOpen: isOpen, event: event })=>{
            if (isOnboardingVisible && !isOpen && event != null) return;
            setIsDropdownOpen(isOpen);
        }
    }, /*#__PURE__*/ $eJOHy.createElement((0, $guChT.default), {
        name: "jira-nin-saved-views-dropdown-content"
    }, /*#__PURE__*/ $eJOHy.createElement((0, $aLJ1L.default), null, /*#__PURE__*/ $eJOHy.createElement((0, $jYYbf.default), {
        onClick: ()=>{
            setIsDropdownOpen(false); // TODO: SLV-286 - remove during spotlight cleanup
            openModal();
        }
    }, formatMessage((0, $1UVkF.default).saveViewSettingsMenuItem)), /*#__PURE__*/ $eJOHy.createElement((0, $jYYbf.default), {
        onClick: ()=>{
            setIsDropdownOpen(false); // TODO: SLV-286 - remove during spotlight cleanup
            onClickReset();
        }
    }, formatMessage((0, $1UVkF.default).resetViewSettingsMenuItem))))), /*#__PURE__*/ $eJOHy.createElement((0, $956it.default), null, isModalOpen && /*#__PURE__*/ $eJOHy.createElement((0, $gHHv2.default), {
        onClose: closeModal,
        width: "small"
    }, /*#__PURE__*/ $eJOHy.createElement((0, $2qG7I.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $eJOHy.createElement((0, $5a9Ro.default), null, formatMessage((0, $1UVkF.default).saveConfirmationModalTitle))), /*#__PURE__*/ $eJOHy.createElement((0, $ik0CA.default), null, formatMessage((0, $1UVkF.default).saveConfirmationModalBody)), /*#__PURE__*/ $eJOHy.createElement((0, $kseeK.default), null, /*#__PURE__*/ $eJOHy.createElement((0, $5CSKW.default), {
        appearance: "subtle",
        onClick: closeModal
    }, formatMessage((0, $1UVkF.default).cancelButton)), /*#__PURE__*/ $eJOHy.createElement((0, $5CSKW.default), {
        appearance: "primary",
        onClick: onClickSave
    }, formatMessage((0, $1UVkF.default).saveButton)))))));
});
const $78c2efdc833859eb$var$styles = {
    root: "_1e0c1txw _19bvu2gc _1bsbzwfg"
};

});
parcelRegister("fd0q0", function(module, exports) {
$parcel$export(module.exports, "default", () => $20dcdac479f63fc0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f0f2116637caf4d70c85986583cdf45c>>
 * @relayHash 1dd0f4fa67e936e37aa78ff1b8f233bc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e8bfcb2fd4ca60cab5a228217932ed9db4d79fb1cdde8dfa6c2c662b15f0e3ec
const $20dcdac479f63fc0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "groupBy"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "settings"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "staticViewInput"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "success"
    }, v7 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "JiraDetailedView"
    }, v9 = [
        {
            "kind": "Variable",
            "name": "groupBy",
            "variableName": "groupBy"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "settings",
            "variableName": "settings"
        },
        {
            "kind": "Variable",
            "name": "staticViewInput",
            "variableName": "staticViewInput"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v11 = {
        "kind": "ScalarField",
        "name": "hideDone"
    }, v12 = {
        "kind": "ScalarField",
        "name": "message"
    }, v13 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v14 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v15 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v16 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SaveResetViewSettingsButtonUIDiscardSettingsMutation",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "JiraDiscardUserIssueSearchConfigPayload",
                    "kind": "LinkedField",
                    "name": "jira_discardUserIssueSearchConfig",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "view",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "args": v9 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                            "kind": "LinkedField",
                                            "name": "viewSettings",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSpreadsheetGroupByConfig",
                                                    "kind": "LinkedField",
                                                    "name": "groupByConfig",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraField",
                                                            "kind": "LinkedField",
                                                            "name": "groupByField",
                                                            "plural": false,
                                                            "selections": [
                                                                v10 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "JiraSpreadsheetView",
                                    "abstractKey": "__isJiraSpreadsheetView"
                                }
                            ]
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v12 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SaveResetViewSettingsButtonUIDiscardSettingsMutation",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "JiraDiscardUserIssueSearchConfigPayload",
                    "kind": "LinkedField",
                    "name": "jira_discardUserIssueSearchConfig",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "view",
                            "plural": false,
                            "selections": [
                                v15 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "args": v9 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                            "kind": "LinkedField",
                                            "name": "viewSettings",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSpreadsheetGroupByConfig",
                                                    "kind": "LinkedField",
                                                    "name": "groupByConfig",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraField",
                                                            "kind": "LinkedField",
                                                            "name": "groupByField",
                                                            "plural": false,
                                                            "selections": [
                                                                v10 /*: any*/ ,
                                                                v16 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "JiraSpreadsheetView",
                                    "abstractKey": "__isJiraSpreadsheetView"
                                },
                                v16 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v12 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v15 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v16 /*: any*/ 
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e8bfcb2fd4ca60cab5a228217932ed9db4d79fb1cdde8dfa6c2c662b15f0e3ec",
            "metadata": {},
            "name": "SaveResetViewSettingsButtonUIDiscardSettingsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$20dcdac479f63fc0$var$node.hash = "07530cd995027111d1f5090a8420d18a";
var $20dcdac479f63fc0$export$2e2bcd8739ae039 = $20dcdac479f63fc0$var$node;

});

parcelRegister("gVMlj", function(module, exports) {
$parcel$export(module.exports, "default", () => $87c45edfd8644c36$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e28b011599dfee63044e1e6c067ad3c3>>
 * @relayHash b7fe9e3a9581e46fe58c3e059b876f61
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d2901ab941a501b9202f377e700aee390c406c8eb7c58206a2be75c896781185
const $87c45edfd8644c36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "groupBy"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueSearchInput"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "settings"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "staticViewInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "Variable",
        "name": "settings",
        "variableName": "settings"
    }, v4 = {
        "args": [
            v3 /*: any*/ 
        ],
        "kind": "ScalarField",
        "name": "isViewConfigModified"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SaveResetViewSettingsButtonUIPublishSettingsMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraPublishIssueSearchConfigPayload",
                    "kind": "LinkedField",
                    "name": "jira_publishIssueSearchConfig",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "view",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "SaveResetViewSettingsButtonCollapsible"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "JiraIssueSearchViewMetadata",
                                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                                }
                            ]
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SaveResetViewSettingsButtonUIPublishSettingsMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraPublishIssueSearchConfigPayload",
                    "kind": "LinkedField",
                    "name": "jira_publishIssueSearchConfig",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "view",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canPublishViewConfig"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "savedViewId"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "groupBy",
                                                            "variableName": "groupBy"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "issueSearchInput",
                                                            "variableName": "issueSearchInput"
                                                        },
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "Variable",
                                                            "name": "staticViewInput",
                                                            "variableName": "staticViewInput"
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                                    "kind": "LinkedField",
                                                    "name": "viewSettings",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSpreadsheetGroupByConfig",
                                                            "kind": "LinkedField",
                                                            "name": "groupByConfig",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraField",
                                                                    "kind": "LinkedField",
                                                                    "name": "groupByField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldId"
                                                                        },
                                                                        v9 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hideDone"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHierarchyEnabled"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraSpreadsheetView",
                                            "abstractKey": "__isJiraSpreadsheetView"
                                        },
                                        {
                                            "kind": "ClientExtension",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__id"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraIssueSearchViewMetadata",
                                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                                }
                            ]
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v9 /*: any*/ 
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d2901ab941a501b9202f377e700aee390c406c8eb7c58206a2be75c896781185",
            "metadata": {},
            "name": "SaveResetViewSettingsButtonUIPublishSettingsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$87c45edfd8644c36$var$node.hash = "875ef4cc18b596f3f9249b400fadd7b0";
var $87c45edfd8644c36$export$2e2bcd8739ae039 = $87c45edfd8644c36$var$node;

});

parcelRegister("lEb91", function(module, exports) {
$parcel$export(module.exports, "default", () => $250d80c5b0d100bd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0093079dda8555ea76ee7e4f732bd360>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $250d80c5b0d100bd$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "settings"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "SaveResetViewSettingsButtonUI",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "canPublishViewConfig"
        },
        {
            "kind": "ScalarField",
            "name": "savedViewId"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "settings",
                            "variableName": "settings"
                        },
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraSpreadsheetGroupByConfig",
                            "kind": "LinkedField",
                            "name": "groupByConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraField",
                                    "kind": "LinkedField",
                                    "name": "groupByField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hideDone"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isHierarchyEnabled"
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$250d80c5b0d100bd$var$node.hash = "8e03e83b0ec61a8b38bf4421fdc354b3";
var $250d80c5b0d100bd$export$2e2bcd8739ae039 = $250d80c5b0d100bd$var$node;

});

parcelRegister("2WT2V", function(module, exports) {
$parcel$export(module.exports, "setIsViewConfigModifiedRecord", () => $b5dd7842aa9f7a8a$export$d39688cf9418e78a);

var $b5RwB = parcelRequire("b5RwB");

var $gRw8I = parcelRequire("gRw8I");
const $b5dd7842aa9f7a8a$export$d39688cf9418e78a = ({ isViewConfigModified: isViewConfigModified, viewRecord: viewRecord })=>{
    (0, $gRw8I.di)(globalThis);
    const { groupBy: groupBy, hideDone: hideDone, jql: jql } = (0, $b5RwB.parse)(globalThis.location.search);
    // Updates the isViewConfigModified field that is set when resetting the view
    // We do not provide settings overrides in the reset flow because we want to reset
    // to the last published view settings
    viewRecord.setValue(isViewConfigModified, 'isViewConfigModified');
    // Updates the isViewConfigModified field that is set when preloading the view
    // via hovering over the view's navigation item in the horizontal nav.
    // In this scenario we do not have any settings overrides via query params
    // so we set settings to an empty object
    viewRecord.setValue(isViewConfigModified, 'isViewConfigModified', {
        settings: {}
    });
    // Updates the isViewConfigModified field that is set during the preloaded query
    // The settings provided here match the settings used in the query parameters
    viewRecord.setValue(isViewConfigModified, 'isViewConfigModified', {
        settings: {
            groupBy: groupBy,
            hideDone: hideDone === 'true' || hideDone === 'false' ? hideDone === 'true' : undefined,
            jql: jql
        }
    });
};

});

parcelRegister("9Gyb2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::840e9064aa0761adacec2a7ce2dee628>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $70d28c23e264903d$var$_react = $70d28c23e264903d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $70d28c23e264903d$var$_baseNew = $70d28c23e264903d$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $70d28c23e264903d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sync".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for syncing changes and save operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $70d28c23e264903d$var$SyncIcon = (props)=>/*#__PURE__*/ $70d28c23e264903d$var$_react.default.createElement($70d28c23e264903d$var$_baseNew.default, Object.assign({
        name: "SyncIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 .5h4.25a.75.75 0 0 1 .75.75V5.5H5.5V2.941a9 9 0 0 0-1.094.916C3.42 4.83 2.5 6.214 2.5 8c0 1.813.817 3.18 1.871 4.11 1.079.95 2.346 1.39 3.129 1.39V15c-1.217 0-2.825-.623-4.121-1.765C2.058 12.07 1 10.312 1 8c0-2.339 1.21-4.084 2.354-5.211.308-.304.615-.567.9-.789H2zm10.621 2.266C13.942 3.93 15 5.688 15 8c0 2.338-1.204 4.079-2.344 5.201-.304.3-.607.56-.889.78H14v1.5H9.75a.75.75 0 0 1-.75-.75v-4.25h1.5v2.573a9 9 0 0 0 1.104-.921C12.584 11.166 13.5 9.787 13.5 8c0-1.813-.817-3.18-1.871-4.11C10.551 2.94 9.283 2.5 8.5 2.5V1c1.217 0 2.825.623 4.121 1.766" clip-rule="evenodd"/>`
    }, props));
$70d28c23e264903d$var$SyncIcon.displayName = 'SyncIcon';
var $70d28c23e264903d$var$_default = module.exports.default = $70d28c23e264903d$var$SyncIcon;

});

parcelRegister("fwcMD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd1cfcbb5080c9044de22389be7f741e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4c3c2af49004355$var$_react = $b4c3c2af49004355$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b4c3c2af49004355$var$_baseNew = $b4c3c2af49004355$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $b4c3c2af49004355$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Undo".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for undo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4c3c2af49004355$var$UndoIcon = (props)=>/*#__PURE__*/ $b4c3c2af49004355$var$_react.default.createElement($b4c3c2af49004355$var$_baseNew.default, Object.assign({
        name: "UndoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 4.72 3.5-3.5 1.06 1.06L3.56 4.5h6.69a4.75 4.75 0 1 1 0 9.5H8v-1.5h2.25a3.25 3.25 0 0 0 0-6.5H3.56l2.22 2.22-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$b4c3c2af49004355$var$UndoIcon.displayName = 'UndoIcon';
var $b4c3c2af49004355$var$_default = module.exports.default = $b4c3c2af49004355$var$UndoIcon;

});

parcelRegister("2dw1l", function(module, exports) {
$parcel$export(module.exports, "useSavedViewsSpotlightOnboarding", () => $2f336cb0116d1295$export$bfaf99e65d7aee60);

var $eJOHy = parcelRequire("eJOHy");

var $7ORWh = parcelRequire("7ORWh");

var $4cTDP = parcelRequire("4cTDP");
const $2f336cb0116d1295$var$TTL_SEEN = 31536000000; // ~ 365 days
const $2f336cb0116d1295$var$SEEN_ONBOARDING = 'saved-views-dropdown';
const $2f336cb0116d1295$export$bfaf99e65d7aee60 = ()=>{
    const [isOnboardingVisible, setIsOnboardingVisible] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (false || !(0, $4cTDP.fg)('saved_list_view_changeboarding')) return;
        (0, $7ORWh.getFlags)({
            [$2f336cb0116d1295$var$SEEN_ONBOARDING]: {}
        }).then((seenItResponse)=>{
            const isOnboardingSeen = seenItResponse[$2f336cb0116d1295$var$SEEN_ONBOARDING]?.status;
            if (isOnboardingSeen !== true) setIsOnboardingVisible(true);
        }).catch(()=>{
        // Ignore errors
        });
    }, []);
    const markAsSeen = (0, $eJOHy.useCallback)(()=>{
        setIsOnboardingVisible(false);
        (0, $7ORWh.setFlag)($2f336cb0116d1295$var$SEEN_ONBOARDING, $2f336cb0116d1295$var$TTL_SEEN);
    }, []);
    return [
        isOnboardingVisible,
        markAsSeen
    ];
};

});
parcelRegister("7ORWh", function(module, exports) {
$parcel$export(module.exports, "getFlags", () => $dd5b2cabf6e9979e$export$d5815430bcc75df0);
$parcel$export(module.exports, "setFlag", () => $dd5b2cabf6e9979e$export$5e165df1e30a1331);

var $huH03 = parcelRequire("huH03");

var $iM97n = parcelRequire("iM97n");

var $aYncF = parcelRequire("aYncF");

var $ab28W = parcelRequire("ab28W");

var $gqIfB = parcelRequire("gqIfB");
const $dd5b2cabf6e9979e$export$442e3330dfabd1f5 = 3600000; // 1 hour
const $dd5b2cabf6e9979e$export$4d45fa66d41a8ca9 = 2592000000; // ~1 month
const $dd5b2cabf6e9979e$export$d5815430bcc75df0 = async (request)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const flagKeys = Object.keys(request);
    const retrieveFlagKeysLookup = (0, (/*@__PURE__*/$parcel$interopDefault($iM97n)))(flagKeys);
    if (!atlassianAccountId || isAnonymous) return (0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(retrieveFlagKeysLookup, ()=>({
            status: true,
            lastSeenDate: null
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flags = {};
    if (0, $gqIfB.default) flagKeys.forEach((flagKey)=>{
        // @ts-expect-error - Object is possibly 'null'.
        const value = (0, $gqIfB.default).get(flagKey);
        if (value) {
            delete retrieveFlagKeysLookup[flagKey];
            flags[flagKey] = value;
        }
    });
    const retrieveFlagKeys = Object.keys(retrieveFlagKeysLookup);
    if (retrieveFlagKeys.length > 0) Object.assign(flags, await (0, $ab28W.getFlags)(atlassianAccountId, retrieveFlagKeys));
    if (0, $gqIfB.default) {
        const now = Date.now();
        retrieveFlagKeys.forEach((flagKey)=>{
            // Not sure whats going wrong here - but i assume `apiGetFlags` may not always return all `retrieveFalgKeys`
            // and so `flags[flagKey]` can be undefined - so we have to guard against it
            if (!flags[flagKey]) return;
            const { status: status } = flags[flagKey];
            const ttlNotSeen = request[flagKey].ttlNotSeen || $dd5b2cabf6e9979e$export$442e3330dfabd1f5;
            const ttlSeen = request[flagKey].ttlSeen || $dd5b2cabf6e9979e$export$4d45fa66d41a8ca9;
            // @ts-expect-error - TS2531: Object is possibly 'null'.
            (0, $gqIfB.default).set(flagKey, flags[flagKey], now + (status ? ttlSeen : ttlNotSeen));
        });
    }
    return flags;
};
const $dd5b2cabf6e9979e$export$5e165df1e30a1331 = async (flagKey, ttl = $dd5b2cabf6e9979e$export$4d45fa66d41a8ca9)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (!atlassianAccountId || isAnonymous) return;
    if (0, $gqIfB.default) {
        const value = (0, $gqIfB.default).get(flagKey);
        if (value && value.status) return;
        const now = new Date();
        (0, $gqIfB.default).set(flagKey, {
            status: true,
            lastSeenDate: now.toISOString()
        }, now.getTime() + ttl);
    }
    await (0, $ab28W.setFlag)(atlassianAccountId, flagKey);
};

});
parcelRegister("huH03", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $75Jcs = parcelRequire("75Jcs");

var $1lM9j = parcelRequire("1lM9j");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $cbc697e9f663ba19$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $1lM9j(iteratee, 3);
    $75Jcs(object, function(value, key, object) {
        $iBJlb(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $cbc697e9f663ba19$var$mapValues;

});

parcelRegister("iM97n", function(module, exports) {

var $7Nmeo = parcelRequire("7Nmeo");

var $978nZ = parcelRequire("978nZ");
/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */ function $0387075c3bf2db78$var$zipObject(props, values) {
    return $978nZ(props || [], values || [], $7Nmeo);
}
module.exports = $0387075c3bf2db78$var$zipObject;

});
parcelRegister("978nZ", function(module, exports) {
/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */ function $01b66017c538f749$var$baseZipObject(props, values, assignFunc) {
    var index = -1, length = props.length, valsLength = values.length, result = {};
    while(++index < length){
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
    }
    return result;
}
module.exports = $01b66017c538f749$var$baseZipObject;

});


parcelRegister("ab28W", function(module, exports) {
$parcel$export(module.exports, "setFlag", () => $06244fcb1f03854f$export$5e165df1e30a1331);
$parcel$export(module.exports, "getFlags", () => $06244fcb1f03854f$export$d5815430bcc75df0);

var $huH03 = parcelRequire("huH03");

var $14RSn = parcelRequire("14RSn");
const $06244fcb1f03854f$export$c1f083639d344e75 = 'https://have-i-seen-it.us-east-1.prod.public.atl-paas.net';
const $06244fcb1f03854f$export$5e165df1e30a1331 = (userKey, flagKey)=>{
    const data = {
        userKey: userKey,
        flagKey: flagKey
    };
    return fetch(`${$06244fcb1f03854f$export$c1f083639d344e75}/flag`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then((response)=>{
        if (!response.ok) throw new (0, $14RSn.default)(response.status, response.statusText);
        return undefined;
    });
};
const $06244fcb1f03854f$var$convertToDates = (response)=>(0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(response, ({ status: status, lastSeenDate: lastSeenDate })=>({
            status: status,
            lastSeenDate: lastSeenDate ? new Date(lastSeenDate) : null
        }));
const $06244fcb1f03854f$export$d5815430bcc75df0 = (userKey, flagKeys)=>{
    const params = new URLSearchParams();
    flagKeys.forEach((flagKey)=>params.append('flagKey', flagKey));
    params.append('userKey', userKey);
    return fetch(`${$06244fcb1f03854f$export$c1f083639d344e75}/flags?${params.toString()}`).then((response)=>{
        if (!response.ok) throw new (0, $14RSn.default)(response.status, response.statusText);
        return response.json();
    }).then((response)=>$06244fcb1f03854f$var$convertToDates(response));
};

});

parcelRegister("gqIfB", function(module, exports) {
$parcel$export(module.exports, "default", () => $b981d8ccba5a63f4$export$2e2bcd8739ae039);

var $8tIrO = parcelRequire("8tIrO");

var $aYncF = parcelRequire("aYncF");

var $eSnSE = parcelRequire("eSnSE");
/**
 * Return an ExpirableStorage to be used with the "have i seen it" service.
 *
 * If the user is anonymous, return null.
 */ const $b981d8ccba5a63f4$var$createStorage = ()=>{
    let storage = null;
    try {
        let context;
        try {
            context = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            return storage;
        }
        const { atlassianAccountId: atlassianAccountId } = context;
        if (atlassianAccountId) storage = (0, $8tIrO.createSessionExpirableStorageProvider)(`have-i-seen-it-${atlassianAccountId.replace(/:/g, '_')}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('have-i-seen-it.storage', 'Failed to initialize storage.');
    }
    return storage;
};
var $b981d8ccba5a63f4$export$2e2bcd8739ae039 = $b981d8ccba5a63f4$var$createStorage();

});



parcelRegister("1UVkF", function(module, exports) {
$parcel$export(module.exports, "default", () => $88f7902fb7f15fb3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $88f7902fb7f15fb3$var$messages = (0, $7qGN1.defineMessages)({
    resetViewSettingsButton: {
        "id": "issue-navigator-save-reset-view-settings-button.reset-view-settings-button",
        "defaultMessage": "Reset list back to default"
    },
    saveOrResetViewSettingsButton: {
        "id": "issue-navigator-save-reset-view-settings-button.save-or-reset-view-settings-button",
        "defaultMessage": "Save or reset view settings"
    },
    saveViewSettingsMenuItem: {
        "id": "issue-navigator-save-reset-view-settings-button.save-view-settings-menu-item",
        "defaultMessage": "Save list"
    },
    resetViewSettingsMenuItem: {
        "id": "issue-navigator-save-reset-view-settings-button.reset-view-settings-menu-item",
        "defaultMessage": "Reset to last saved"
    },
    saveSettingsSuccessTitle: {
        "id": "issue-navigator-save-reset-view-settings-button.save-settings-success-title",
        "defaultMessage": "List view saved"
    },
    saveSettingsSuccessMessage: {
        "id": "issue-navigator-save-reset-view-settings-button.save-settings-success-message",
        "defaultMessage": "This view has been updated for everyone in this project."
    },
    saveSettingsFailedTitle: {
        "id": "issue-navigator-save-reset-view-settings-button.save-settings-failed-title",
        "defaultMessage": "Unable to save your settings"
    },
    saveSettingsFailedMessage: {
        "id": "issue-navigator-save-reset-view-settings-button.save-settings-failed-message",
        "defaultMessage": "We couldn't save your settings, try refreshing the page or try again later."
    },
    resetSettingsFailedTitle: {
        "id": "issue-navigator-save-reset-view-settings-button.reset-settings-failed-title",
        "defaultMessage": "Unable to reset your settings"
    },
    resetSettingsFailedMessage: {
        "id": "issue-navigator-save-reset-view-settings-button.reset-settings-failed-message",
        "defaultMessage": "We couldn't reset your settings, try refreshing the page or try again later."
    },
    saveConfirmationModalTitle: {
        "id": "issue-navigator-save-reset-view-settings-button.save-confirmation-modal-title",
        "defaultMessage": "Save list view"
    },
    saveConfirmationModalBody: {
        "id": "issue-navigator-save-reset-view-settings-button.save-confirmation-modal-body",
        "defaultMessage": "The list will be saved for everyone in the project. They'll see the applied filters, grouping, fields, and columns."
    },
    saveButton: {
        "id": "issue-navigator-save-reset-view-settings-button.save-button",
        "defaultMessage": "Save"
    },
    cancelButton: {
        "id": "issue-navigator-save-reset-view-settings-button.cancel-button",
        "defaultMessage": "Cancel"
    },
    saveSettingsSuccessMessageGalaxia: {
        "id": "issue-navigator-save-reset-view-settings-button.save-settings-success-message-galaxia",
        "defaultMessage": "This view has been updated for everyone in this space."
    }
});
var $88f7902fb7f15fb3$export$2e2bcd8739ae039 = $88f7902fb7f15fb3$var$messages;

});

parcelRegister("65jes", function(module, exports) {
$parcel$export(module.exports, "SavedViewsOnboarding", () => $39bcc78f7fe56acf$export$4ec6394517d76cb4);

var $eJOHy = parcelRequire("eJOHy");

var $bdRit = parcelRequire("bdRit");
var $fBe2p = parcelRequire("fBe2p");
var $d2s5v = parcelRequire("d2s5v");

var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $cami4 = parcelRequire("cami4");
const $39bcc78f7fe56acf$export$4ec6394517d76cb4 = /*#__PURE__*/ (0, $eJOHy.memo)(({ children: children, isAdmin: isAdmin = false, isOnboardingVisible: isOnboardingVisible, markAsSeen: markAsSeen })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fBe2p.Pulse), {
        radius: 3,
        pulse: isOnboardingVisible
    }, children), isOnboardingVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bdRit.default), {
        actions: [
            {
                onClick: ()=>{
                    markAsSeen();
                },
                text: formatMessage((0, $cami4.default).spotlightDismissButton)
            },
            {
                onClick: ()=>{
                    markAsSeen();
                // TODO: SLV-275 - add link to documentation
                },
                text: formatMessage((0, $cami4.default).spotlightLearnMoreButton)
            }
        ],
        heading: formatMessage(isAdmin ? (0, $cami4.default).adminSpotlightTitle : (0, $cami4.default).spotlightTitle),
        target: "jira-nin-saved-views-dropdown-content",
        targetRadius: 3,
        dialogWidth: 275,
        pulse: false,
        dialogPlacement: isAdmin ? 'left top' : 'bottom right'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.100"
    }, formatMessage(isAdmin ? (0, $cami4.default).adminSpotlightMessage : (0, $cami4.default).spotlightMessage, {
        p: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                as: "p"
            }, chunks)
    })))));
});

});
parcelRegister("cami4", function(module, exports) {
$parcel$export(module.exports, "default", () => $ffda6f734e09c520$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ffda6f734e09c520$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    adminSpotlightTitle: {
        "id": "issue-navigator-save-reset-view-settings-button.SavedViewsOnboarding.messages.admin-spotlight-title",
        "defaultMessage": "Save and reset your list view"
    },
    adminSpotlightMessage: {
        "id": "issue-navigator-save-reset-view-settings-button.SavedViewsOnboarding.messages.admin-spotlight-message",
        "defaultMessage": "<p>Saved views are now in list view.</p><p>Save your view for everyone in the project or reset it back to the default settings.</p>"
    },
    spotlightTitle: {
        "id": "issue-navigator-save-reset-view-settings-button.SavedViewsOnboarding.messages.spotlight-title",
        "defaultMessage": "Reset your view"
    },
    spotlightMessage: {
        "id": "issue-navigator-save-reset-view-settings-button.SavedViewsOnboarding.messages.spotlight-message",
        "defaultMessage": "<p>Saved views are now in list view. Your admin set up a view to help make collaboration easier.</p><p>You can make changes to your view or reset to the admin's view anytime.</p>"
    },
    spotlightLearnMoreButton: {
        "id": "issue-navigator-save-reset-view-settings-button.SavedViewsOnboarding.messages.spotlight-learn-more-button",
        "defaultMessage": "More about saved views"
    },
    spotlightDismissButton: {
        "id": "issue-navigator-save-reset-view-settings-button.SavedViewsOnboarding.messages.spotlight-dismiss-button",
        "defaultMessage": "OK"
    }
});

});





parcelRegister("7E6oZ", function(module, exports) {
$parcel$export(module.exports, "HierarchyToggleItem", () => $8259c4c6f12994fb$export$357080ffd90225cc);

var $5CNsj = parcelRequire("5CNsj");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $dG1on = parcelRequire("dG1on");
const $8259c4c6f12994fb$export$357080ffd90225cc = ({ viewResult: viewResult, isGroupingSupported: isGroupingSupported, onChangeHierarchy: onChangeHierarchy })=>{
    const viewResultData = (0, $j4oe4.useFragment)((0, $5CNsj.default), viewResult);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dG1on.HierarchyToggle), {
        isGroupingSupported: isGroupingSupported,
        viewResult: viewResultData,
        onChangeHierarchy: onChangeHierarchy
    });
};

});
parcelRegister("5CNsj", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec9a4280b5dd242a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<151b6ff9d28df7a94eb8f1723bc0a9c4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ec9a4280b5dd242a$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "staticViewInput",
                    "variableName": "staticViewInput"
                }
            ],
            "kind": "FragmentSpread",
            "name": "HierarchyToggle"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$ec9a4280b5dd242a$var$node.hash = "c2d6e38da80c7d1e0b4bbac437a0faf0";
var $ec9a4280b5dd242a$export$2e2bcd8739ae039 = $ec9a4280b5dd242a$var$node;

});

parcelRegister("dG1on", function(module, exports) {
$parcel$export(module.exports, "HierarchyToggle", () => $8ca4d80cc7a8c775$export$3954d500c5aed66);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");


var $6TY1h = parcelRequire("6TY1h");
const $8ca4d80cc7a8c775$export$3954d500c5aed66 = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "unmount",
        id: "issue-table-hierarchy-toggle",
        packageName: (0, $a1c91d451c498211$export$b8b9d90f9e5bd72b),
        teamName: (0, $a1c91d451c498211$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6TY1h.HierarchyToggle), props)));

});
const $a1c91d451c498211$export$b8b9d90f9e5bd72b = 'jiraIssueTableHierarchyToggle';
const $a1c91d451c498211$export$d57b6b390e78d90f = 'empanada';

parcelRegister("6TY1h", function(module, exports) {
$parcel$export(module.exports, "HierarchyToggle", () => $3e7aee01315576e4$export$3954d500c5aed66);

var $8GL8o = parcelRequire("8GL8o");

var $2GPLm = parcelRequire("2GPLm");

var $gzdDs = parcelRequire("gzdDs");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $8CBYv = parcelRequire("8CBYv");

var $4cTDP = parcelRequire("4cTDP");

var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $kh7bJ = parcelRequire("kh7bJ");


var $f3Dol = parcelRequire("f3Dol");
const $3e7aee01315576e4$export$3954d500c5aed66 = ({ viewResult: viewResult, forwardRef: forwardRef, isGroupingSupported: isGroupingSupported, onChangeHierarchy: onChangeHierarchy })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const viewResultData = (0, $j4oe4.useFragment)((0, $gzdDs.default), viewResult);
    const { viewSettings: viewSettings, id: id, viewId: viewId } = viewResultData;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const toggleIssueHierarchy = $3e7aee01315576e4$export$fb4258c5b554d925();
    const { isGroupingEnabled: isGroupingEnabled, canEnableGrouping: canEnableGrouping, isHierarchyEnabled: isHierarchyEnabled, canEnableHierarchy: canEnableHierarchy } = viewSettings ?? {};
    const [checked, setChecked] = (0, $eJOHy.useState)(isHierarchyEnabled);
    const updateHierarchy = (0, $eJOHy.useCallback)((hierarchyPreference)=>{
        setChecked(hierarchyPreference);
        onChangeHierarchy && onChangeHierarchy(hierarchyPreference);
    }, [
        onChangeHierarchy
    ]);
    const onChange = (0, $eJOHy.useCallback)(()=>{
        let viewAri = id;
        if ((0, $4cTDP.fg)('saved_list_view_technical_changes')) {
            if (!viewResultData.savedViewId) throw new Error('Missing saved view ID');
            viewAri = viewResultData.savedViewId;
        }
        if (viewAri) {
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'hierarchyToggle clicked', {
                isHierarchyEnabled: !isHierarchyEnabled
            });
            toggleIssueHierarchy({
                viewAri: viewAri,
                isHierarchyEnabled: !isHierarchyEnabled,
                updateHierarchy: updateHierarchy
            });
        }
    }, [
        viewResultData.savedViewId,
        id,
        createAnalyticsEvent,
        isHierarchyEnabled,
        toggleIssueHierarchy,
        updateHierarchy
    ]);
    const isGrouping = isGroupingSupported && isGroupingEnabled && canEnableGrouping;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("label", {
        htmlFor: `${viewId}_hierarchy_toggle`
    }, formatMessage((0, $f3Dol.default).showHierarchy)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8CBYv.default), {
        isDisabled: !canEnableHierarchy,
        isChecked: Boolean(checked && canEnableHierarchy),
        id: `${viewId}_hierarchy_toggle`,
        ref: forwardRef,
        onChange: onChange,
        size: (0, $4cTDP.fg)('jsc-1730-adjust_toggle_size') ? undefined : 'large'
    })), !canEnableHierarchy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        color: "color.text.subtlest",
        size: "small"
    }, isGrouping ? formatMessage((0, $f3Dol.default).hierarchyDisabledReasonGroupingAndFilters) : formatMessage((0, $f3Dol.default).hierarchyDisabledReasonFilters)));
};
const $3e7aee01315576e4$export$fb4258c5b554d925 = ()=>{
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    const [commitOld] = (0, $j4oe4.useMutation)((0, $2GPLm.default));
    const [commit] = (0, $j4oe4.useMutation)((0, $8GL8o.default));
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const commitMutation = (0, $eJOHy.useCallback)(({ viewAri: viewAri, isHierarchyEnabled: isHierarchyEnabled, updateHierarchy: updateHierarchy })=>{
        if (isAnonymous) {
            updateHierarchy(isHierarchyEnabled);
            return;
        }
        if ((0, $4cTDP.fg)('saved_list_view_technical_changes')) {
            commit({
                variables: {
                    input: {
                        viewId: viewAri,
                        hierarchyEnabled: isHierarchyEnabled
                    }
                },
                onError: (error)=>{
                    (0, $9pTd3.fireErrorAnalytics)({
                        meta: {
                            id: 'issue-table-hierarchy-toggle',
                            packageName: (0, $a1c91d451c498211$export$b8b9d90f9e5bd72b),
                            teamName: (0, $a1c91d451c498211$export$d57b6b390e78d90f)
                        },
                        error: error
                    });
                    showFlag({
                        id: 'hierarchyToggleError',
                        title: formatMessage((0, $f3Dol.default).hierarchyErrorFlagTitle),
                        description: formatMessage((0, $f3Dol.default).hierarchyErrorFlagDescription),
                        isAutoDismiss: true,
                        type: 'error',
                        messageId: 'issue-table-hierarchy-toggle.ui.show-flag.error.hierarchy-toggle-error',
                        messageType: 'transactional'
                    });
                }
            });
            updateHierarchy(isHierarchyEnabled);
        } else {
            commitOld({
                variables: {
                    viewId: viewAri,
                    isHierarchyEnabled: isHierarchyEnabled
                },
                onError: (error)=>{
                    (0, $9pTd3.fireErrorAnalytics)({
                        meta: {
                            id: 'issue-table-hierarchy-toggle',
                            packageName: (0, $a1c91d451c498211$export$b8b9d90f9e5bd72b),
                            teamName: (0, $a1c91d451c498211$export$d57b6b390e78d90f)
                        },
                        error: error
                    });
                    showFlag({
                        id: 'hierarchyToggleError',
                        title: formatMessage((0, $f3Dol.default).hierarchyErrorFlagTitle),
                        description: formatMessage((0, $f3Dol.default).hierarchyErrorFlagDescription),
                        isAutoDismiss: true,
                        type: 'error',
                        messageId: 'issue-table-hierarchy-toggle.ui.show-flag.error.hierarchy-toggle-error.1',
                        messageType: 'transactional'
                    });
                }
            });
            updateHierarchy(isHierarchyEnabled);
        }
    }, [
        commit,
        commitOld,
        formatMessage,
        isAnonymous,
        showFlag
    ]);
    return commitMutation;
};

});
parcelRegister("8GL8o", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e1fdc2e4e153c02$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cc3cf2a64f747164169cdfdc5c104932>>
 * @relayHash 08015e7d270186615e5e441b5ba5b19e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d484fd375d5517a59ee15571537b85c70a57ff8635724fdb1a1ee38a8d22ac6e
const $0e1fdc2e4e153c02$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "JiraSetIssueSearchHierarchyEnabledPayload",
            "kind": "LinkedField",
            "name": "jira_setIssueSearchHierarchyEnabled",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "HierarchyToggleMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "HierarchyToggleMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "d484fd375d5517a59ee15571537b85c70a57ff8635724fdb1a1ee38a8d22ac6e",
            "metadata": {},
            "name": "HierarchyToggleMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$0e1fdc2e4e153c02$var$node.hash = "ca11cf70f3dd72232cb01be6b2d6279f";
var $0e1fdc2e4e153c02$export$2e2bcd8739ae039 = $0e1fdc2e4e153c02$var$node;

});

parcelRegister("2GPLm", function(module, exports) {
$parcel$export(module.exports, "default", () => $7178304b3253c7c2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0d8d1c4041b8c571d78025185651bbc0>>
 * @relayHash 303db69a62b21a40b9f93c2e58eb9bbe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 84fefa0f8f50aa6bb57e6fe4de08b1a51c3b1c9ecc65d539bea2cc0ca96cb33e
const $7178304b3253c7c2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isHierarchyEnabled"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v2 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isHierarchyEnabled",
                            "variableName": "isHierarchyEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "viewId",
                            "variableName": "viewId"
                        }
                    ],
                    "concreteType": "JiraIssueSearchHierarchyPreferenceMutationPayload",
                    "kind": "LinkedField",
                    "name": "updateIssueSearchHierarchyPreference",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HierarchyToggleOldMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "HierarchyToggleOldMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "84fefa0f8f50aa6bb57e6fe4de08b1a51c3b1c9ecc65d539bea2cc0ca96cb33e",
            "metadata": {},
            "name": "HierarchyToggleOldMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$7178304b3253c7c2$var$node.hash = "4458c9cdea960a19efa33d2951c511cf";
var $7178304b3253c7c2$export$2e2bcd8739ae039 = $7178304b3253c7c2$var$node;

});

parcelRegister("gzdDs", function(module, exports) {
$parcel$export(module.exports, "default", () => $2adfb2be09ae62d8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<49fcf5c3936fe6b11278ea782106be9b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2adfb2be09ae62d8$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "settings"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "HierarchyToggle",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "viewId"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "savedViewId"
                }
            ]
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "settings",
                            "variableName": "settings"
                        },
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isHierarchyEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canEnableHierarchy"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isGroupingEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canEnableGrouping"
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$2adfb2be09ae62d8$var$node.hash = "7c40360e3fec51825715d6ea525947b9";
var $2adfb2be09ae62d8$export$2e2bcd8739ae039 = $2adfb2be09ae62d8$var$node;

});

parcelRegister("f3Dol", function(module, exports) {
$parcel$export(module.exports, "default", () => $105858db56aca5b7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $105858db56aca5b7$var$messages = (0, $7qGN1.defineMessages)({
    showHierarchy: {
        "id": "issue-table-show-hierarchy",
        "defaultMessage": "Show hierarchy"
    },
    hierarchyDisabledReasonGroupingAndFilters: {
        "id": "issue-table-hierarchy-disabled-reason-grouping-and-filters",
        "defaultMessage": "Clear grouping and filters to show hierarchy"
    },
    hierarchyDisabledReasonFilters: {
        "id": "issue-table-hierarchy-disabled-reason-filters",
        "defaultMessage": "Clear filters to show hierarchy"
    },
    hierarchyErrorFlagTitle: {
        "id": "issue-table-hierarchy-error-flag-title",
        "defaultMessage": "Hierarchy preference could not be updated."
    },
    hierarchyErrorFlagDescription: {
        "id": "issue-table-hierarchy-error-flag-description",
        "defaultMessage": "Something went wrong. Please try again."
    }
});
var $105858db56aca5b7$export$2e2bcd8739ae039 = $105858db56aca5b7$var$messages;

});




parcelRegister("2UTIe", function(module, exports) {
$parcel$export(module.exports, "withReportErrors", () => $dfb8967bd81832b8$export$89614e972c8b110);

var $eJOHy = parcelRequire("eJOHy");

var $fGnU6 = parcelRequire("fGnU6");
const $dfb8967bd81832b8$export$89614e972c8b110 = (WrappedComponent, config)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fGnU6.ReportErrors), config, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, props));

});


parcelRegister("cPfqZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d772b08080c721e9$export$2e2bcd8739ae039);

var $djBxK = parcelRequire("djBxK");

var $80tI9 = parcelRequire("80tI9");

var $gQnh7 = parcelRequire("gQnh7");

var $kicHt = parcelRequire("kicHt");

var $eCMFn = parcelRequire("eCMFn");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $FhXEJ = parcelRequire("FhXEJ");

var $c12HM = parcelRequire("c12HM");

var $cblKs = parcelRequire("cblKs");

var $3aa9n = parcelRequire("3aa9n");

var $14RSn = parcelRequire("14RSn");

var $kGj4V = parcelRequire("kGj4V");

var $4Oene = parcelRequire("4Oene");

var $83DiZ = parcelRequire("83DiZ");

var $1BZ8a = parcelRequire("1BZ8a");

var $4cTDP = parcelRequire("4cTDP");

var $iRahl = parcelRequire("iRahl");

var $eUlQe = parcelRequire("eUlQe");

var $2UTIe = parcelRequire("2UTIe");

var $eibCx = parcelRequire("eibCx");

var $fAgUF = parcelRequire("fAgUF");

var $1wL9i = parcelRequire("1wL9i");

var $HiS1C = parcelRequire("HiS1C");

var $dTsrC = parcelRequire("dTsrC");

var $fwKw5 = parcelRequire("fwKw5");

var $3kDjB = parcelRequire("3kDjB");

var $aSDxj = parcelRequire("aSDxj");

var $gNBTz = parcelRequire("gNBTz");

var $bR878 = parcelRequire("bR878");
const $d772b08080c721e9$var$useAnalyticsAttributes = (type)=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    return (0, $eJOHy.useMemo)(()=>{
        if (!type) return;
        const projectType = (0, $FhXEJ.toProjectType)(type.toLowerCase());
        if (!projectType) return;
        const edition = (0, $cblKs.getEditionForProject)(projectType, appEditions);
        if (!edition) return;
        return {
            edition: edition
        };
    }, [
        appEditions,
        type
    ]);
};
const $d772b08080c721e9$var$IssueResults = ({ hasServerError: hasServerError = false, onChangeColumnConfiguration: onChangeColumnConfiguration, onChangeJql: onChangeJql, onCaughtIssueSearchError: onCaughtIssueSearchError, onIssueFlatListUpdated: onIssueFlatListUpdated, issueResults: issueResults, groupResults: groupResults, jiraView: jiraView, project: project, rankField: rankField, issueTableProps: issueTableProps, filter: filter, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isIssueRankingSupportEnabled: isIssueRankingSupportEnabled, isMergedColumnSupportEnabled: isMergedColumnSupportEnabled, isFrozenColumnSupportEnabled: isFrozenColumnSupportEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled, issueAppEntryPoint: issueAppEntryPoint })=>{
    (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_RESULTS_START);
    const [{ view: selectedView }] = (0, $HiS1C.useSelectedViewState)();
    const jql = (0, $fwKw5.useResolvedJql)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const { setSelectedIssueByIndex: setSelectedIssueByIndex } = (0, $1wL9i.useSelectedIssueActions)();
    const onSelectedRowChange = (0, $eJOHy.useCallback)((rowIndex)=>{
        setSelectedIssueByIndex(rowIndex, {
            shouldDebounce: false,
            shouldNotifyOnChange: false,
            isSelectedByUserInteraction: true
        });
    }, [
        setSelectedIssueByIndex
    ]);
    const isFetching = (0, $3kDjB.useIsFetching)();
    const issueResultsData = (0, $j4oe4.useFragment)((0, $eCMFn.default), issueResults);
    const groupResultsData = (0, $j4oe4.useFragment)((0, $kicHt.default), groupResults);
    const jiraViewData = (0, $j4oe4.useFragment)((0, $gQnh7.default), jiraView);
    const projectData = (0, $j4oe4.useFragment)((0, $80tI9.default), project);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $djBxK.default), rankField);
    const attributes = $d772b08080c721e9$var$useAnalyticsAttributes(projectData?.projectType);
    const viewResultError = (0, $eJOHy.useMemo)(()=>{
        if (!jiraViewData) return undefined;
        const message = jiraViewData.error?.message ?? '';
        const statusCode = jiraViewData.error?.extensions?.[0].statusCode;
        if (typeof statusCode !== 'number') return;
        return new (0, $14RSn.default)(statusCode, message);
    }, [
        jiraViewData
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_RESULTS_END);
    }, []);
    const onNavigateToIssue = (0, $eJOHy.useCallback)((issueKey)=>push(`/browse/${issueKey}`), [
        push
    ]);
    const sourceName = selectedView === 'detail' ? (0, $iRahl.ANALYTICS_DETAIL_VIEW_SOURCE_NAME) : (0, $iRahl.ANALYTICS_LIST_VIEW_SOURCE_NAME);
    let viewContent = null;
    const resultsFragment = (0, $eibCx.exclusiveGroupResultsOrIssueResultsFragment)({
        groupResults: groupResultsData ?? null,
        issueResults: issueResultsData ?? null
    });
    if (!hasServerError && jiraViewData && !jiraViewData.error) {
        if (selectedView === 'detail' && jiraViewData.__typename === 'JiraDetailedView' && resultsFragment?.issueResults) viewContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aSDxj.default), {
            loading: isFetching,
            onNavigateToIssue: onNavigateToIssue,
            issueResults: resultsFragment.issueResults,
            view: jiraViewData,
            issueAppEntryPoint: (0, $4cTDP.fg)('nin_issue_app_conditional_entrypoint') ? issueAppEntryPoint : undefined
        });
        else if (selectedView !== 'detail' && (0, $iRahl.isJiraSpreadsheetView)(jiraViewData) && resultsFragment) viewContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bR878.default), {
            viewResultError: viewResultError,
            loading: isFetching,
            onSelectedRowChange: onSelectedRowChange,
            onIssueFlatListUpdated: onIssueFlatListUpdated,
            view: jiraViewData,
            project: projectData ?? null,
            rankField: rankFieldData ?? null,
            onChangeColumnConfiguration: onChangeColumnConfiguration,
            issueTableProps: issueTableProps,
            isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
            isIssueRankingSupportEnabled: isIssueRankingSupportEnabled,
            isMergedColumnSupportEnabled: isMergedColumnSupportEnabled,
            isFrozenColumnSupportEnabled: isFrozenColumnSupportEnabled,
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
            isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
            filter: filter,
            ...resultsFragment
        });
    }
    if (!viewContent) return isFetching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eUlQe.ListViewSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gNBTz.default), {
        error: viewResultError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
        name: "issue-results"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: sourceName,
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        ...attributes ? {
            attributes: attributes
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gNBTz.RecoverableErrorViewBoundary), {
        recoveryProp: isFetching,
        onCaughtIssueSearchError: onCaughtIssueSearchError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dTsrC.SortContainer), {
        jql: jql,
        onChangeJql: onChangeJql
    }, viewContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3aa9n.default), {
        op: ()=>{
            onCaughtIssueSearchError && onCaughtIssueSearchError(undefined);
        }
    }))));
};
var $d772b08080c721e9$export$2e2bcd8739ae039 = (0, $2UTIe.withReportErrors)($d772b08080c721e9$var$IssueResults, {
    id: 'ui.issue-results.unhandled',
    packageName: (0, $iRahl.PACKAGE_NAME),
    teamName: (0, $iRahl.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $c12HM.isLoaderErrorAttributes)
});

});
parcelRegister("djBxK", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c19237012125383$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b9c7354c69be3b347d84955aa12a6686>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2c19237012125383$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueResults_rankField",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_ListView_rankField"
        }
    ],
    "type": "JiraQuery"
};
$2c19237012125383$var$node.hash = "6841e7e8e6eb501774888d028077731e";
var $2c19237012125383$export$2e2bcd8739ae039 = $2c19237012125383$var$node;

});

parcelRegister("80tI9", function(module, exports) {
$parcel$export(module.exports, "default", () => $99400261d0648815$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4d5d381d62bc1a932f2c9a73cda20d66>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $99400261d0648815$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueResults_project",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_ListView_project"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        }
    ],
    "type": "JiraProject"
};
$99400261d0648815$var$node.hash = "70bd33938dc6049ba8077772bdfb1c96";
var $99400261d0648815$export$2e2bcd8739ae039 = $99400261d0648815$var$node;

});

parcelRegister("gQnh7", function(module, exports) {
$parcel$export(module.exports, "default", () => $f13748d8695f32e3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4aa67d431503e89ed559c9796911ad7f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f13748d8695f32e3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueResults_jiraView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "error",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_DetailView_view"
                }
            ],
            "type": "JiraDetailedView"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_ListView_view"
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        }
    ],
    "type": "JiraView",
    "abstractKey": "__isJiraView"
};
$f13748d8695f32e3$var$node.hash = "d1bfcbf5b50637766f970894f71c262d";
var $f13748d8695f32e3$export$2e2bcd8739ae039 = $f13748d8695f32e3$var$node;

});

parcelRegister("kicHt", function(module, exports) {
$parcel$export(module.exports, "default", () => $82cd5029b6619739$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8181ceb1b33ce238044f09e55f544564>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $82cd5029b6619739$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isPaginating"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueResults_groupResults",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isPaginating",
                    "variableName": "isPaginating"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                }
            ],
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_ListView_groupResults"
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$82cd5029b6619739$var$node.hash = "36093a29e9613109da41814cc200e024";
var $82cd5029b6619739$export$2e2bcd8739ae039 = $82cd5029b6619739$var$node;

});

parcelRegister("eCMFn", function(module, exports) {
$parcel$export(module.exports, "default", () => $edd3ee8e7870f1a6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2453f2f447e1334e18243d95ba4a6511>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $edd3ee8e7870f1a6$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueResults_issueResults",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_ListView_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_DetailView_issueResults"
        }
    ],
    "type": "JiraIssueConnection"
};
$edd3ee8e7870f1a6$var$node.hash = "fe345a65c78509e001254c068f756164";
var $edd3ee8e7870f1a6$export$2e2bcd8739ae039 = $edd3ee8e7870f1a6$var$node;

});

parcelRegister("eUlQe", function(module, exports) {
$parcel$export(module.exports, "ListViewSkeleton", () => $16db559737cf802c$export$8465c21c33452ecb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $coBPg = parcelRequire("coBPg");
const $16db559737cf802c$export$8465c21c33452ecb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16db559737cf802c$var$StyledListViewContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $coBPg.NativeIssueTableSkeleton), null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16db559737cf802c$var$StyledListViewContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("coBPg", function(module, exports) {
$parcel$export(module.exports, "NativeIssueTableSkeleton", () => $f004264ba9491c9c$export$309a6db85e3f2aaa);
/* NativeIssueTableSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $9co9i = parcelRequire("9co9i");
const $f004264ba9491c9c$var$customCssStyles = null;
const $f004264ba9491c9c$var$containerStyles = {
    height: '448px'
};
const $f004264ba9491c9c$export$309a6db85e3f2aaa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9co9i))),
        containerStyles: $f004264ba9491c9c$var$containerStyles,
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("9co9i", function(module, exports) {
module.exports = new URL("native-issue-table-skeleton.tpl.e6209376.svg", import.meta.url).toString();

});



parcelRegister("dTsrC", function(module, exports) {
$parcel$export(module.exports, "SortContainer", () => $e5ed7a8c52259a33$export$f2d9f14f583efb1a);
$parcel$export(module.exports, "useSortFieldAndDirection", () => $e5ed7a8c52259a33$export$951ead8cec7da319);

var $eJOHy = parcelRequire("eJOHy");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4cTDP = parcelRequire("4cTDP");
const $e5ed7a8c52259a33$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        field: 'created',
        direction: 'DESC'
    },
    actions: {
        setField: (field, aliases)=>({ getState: getState, setState: setState }, { onChangeJql: onChangeJql, jql: jql, JqlUtilsInstance: JqlUtilsInstance })=>{
                const { field: prevField } = getState();
                if (field !== prevField) {
                    setState({
                        field: field
                    });
                    const newJql = JqlUtilsInstance?.jql(jql).setPrimarySortField(field, undefined, aliases).toJql();
                    typeof newJql === 'string' && onChangeJql && onChangeJql(newJql);
                }
            },
        setFieldAndDirection: (field, direction, aliases)=>({ getState: getState, setState: setState }, { onChangeJql: onChangeJql, jql: jql, JqlUtilsInstance: JqlUtilsInstance })=>{
                const { field: prevField, direction: prevDirection } = getState();
                if (field !== prevField || direction !== prevDirection) {
                    setState({
                        field: field,
                        direction: direction
                    });
                    if (direction !== 'NONE' || (0, $4cTDP.fg)('jsc_list_reranking_gate')) {
                        const newJql = JqlUtilsInstance?.jql(jql).setPrimarySortField(field, direction, aliases).toJql();
                        typeof newJql === 'string' && onChangeJql && onChangeJql(newJql);
                    }
                }
            }
    },
    name: 'IssueNavigatorSelectedViewState'
});
const $e5ed7a8c52259a33$export$f4b3414b22b0750b = ()=>({ getState: getState, setState: setState }, { jql: jql, JqlUtilsInstance: JqlUtilsInstance })=>{
        const field = JqlUtilsInstance?.jql(jql).getPrimarySortField();
        const direction = JqlUtilsInstance?.jql(jql).getPrimarySortDirection();
        const { field: prevField, direction: prevDirection } = getState();
        if (field !== prevField || direction !== prevDirection) setState({
            field: field,
            direction: direction
        });
    };
const $e5ed7a8c52259a33$export$42a852a2b6b56249 = (0, $6E16M.createContainer)($e5ed7a8c52259a33$var$Store, {
    onInit: $e5ed7a8c52259a33$export$f4b3414b22b0750b,
    onUpdate: $e5ed7a8c52259a33$export$f4b3414b22b0750b
});


const $e5ed7a8c52259a33$var$useJqlUtils = (parcelRequire("l1x4O")).default;
const $e5ed7a8c52259a33$export$f2d9f14f583efb1a = (props)=>{
    const Utils = $e5ed7a8c52259a33$var$useJqlUtils();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e5ed7a8c52259a33$export$42a852a2b6b56249, {
        JqlUtilsInstance: Utils,
        ...props
    });
};
const $e5ed7a8c52259a33$export$951ead8cec7da319 = (0, $iJq0l.createHook)($e5ed7a8c52259a33$var$Store, {
    selector: ({ field: field, direction: direction })=>({
            field: field,
            direction: direction
        })
});

});
parcelRegister("l1x4O", function(module, exports) {


module.exports = (parcelRequire("g81qY"))('load_jql_utils_directly', function() {
    return parcelRequire('imx7a');
}, function() {
    return parcelRequire('675bx');
}, {
    l: (parcelRequire("bbrhz")),
    i: [
        "h9R5C",
        "2VWwz"
    ]
});

});
parcelRegister("bbrhz", function(module, exports) {
"use strict";
module.exports = function loadJSBundle(bundle) {
    // Don't insert the same script twice (e.g. if it was already in the HTML)
    let existingScripts = document.getElementsByTagName('script');
    let isCurrentBundle = function(script) {
        return script.src === bundle;
    };
    if ([].concat(existingScripts).some(isCurrentBundle)) return;
    // Request using XHR because it's synchronous and we can't use promises here
    // This has extremely poor performance because we're idle during this fetch, so we only use this so that the app won't crash
    const xhr = new XMLHttpRequest();
    xhr.open('GET', bundle, false);
    try {
        xhr.send();
        if (xhr.status === 200) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.text = xhr.responseText;
            // Execute the script synchronously
            document.head.appendChild(script);
        } else throw new TypeError(`Failed to fetch dynamically imported module: ${bundle}. Status: ${xhr.status}`);
    } catch (e) {
        throw new TypeError(`Failed to fetch dynamically imported module: ${bundle}. Error: ${e.message}`);
    }
};

});



parcelRegister("aSDxj", function(module, exports) {
$parcel$export(module.exports, "default", () => $067998940c1c16ee$export$2e2bcd8739ae039);

var $iNNDf = parcelRequire("iNNDf");

var $9UIdV = parcelRequire("9UIdV");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $c12HM = parcelRequire("c12HM");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $kbYhH = parcelRequire("kbYhH");

var $eS29z = parcelRequire("eS29z");

var $4Oene = parcelRequire("4Oene");

var $ivzXw = parcelRequire("ivzXw");

var $4cTDP = parcelRequire("4cTDP");


var $iRahl = parcelRequire("iRahl");

var $6Bi4o = parcelRequire("6Bi4o");

var $2UTIe = parcelRequire("2UTIe");

var $fAgUF = parcelRequire("fAgUF");

var $e1kKr = parcelRequire("e1kKr");

var $2Jpfu = parcelRequire("2Jpfu");
const $067998940c1c16ee$var$ConditionalContentContainer = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $067998940c1c16ee$var$ContentContainerStyles
    }, children);
const $067998940c1c16ee$var$DetailView = ({ IssueApp: IssueApp = (0, $6Bi4o.default), issueResults: issueResults, view: view, issueAppEntryPoint: issueAppEntryPoint, ...props })=>{
    const listRef = (0, $eJOHy.useRef)(null);
    (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_RESULTS_DETAIL_VIEW_START);
    (0, $eJOHy.useLayoutEffect)(()=>{
        (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_RESULTS_DETAIL_VIEW_END);
    }, []);
    const detailViewData = (0, $j4oe4.useFragment)((0, $9UIdV.default), issueResults);
    const viewData = (0, $j4oe4.useFragment)((0, $iNNDf.default), view);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
        name: "detail-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($067998940c1c16ee$var$ConditionalContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kbYhH.ElementSizeProvider), {
        elementRef: listRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e1kKr.default), {
        issueResults: detailViewData,
        view: viewData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Jpfu.default), {
        fragment: detailViewData,
        ...props,
        listRef: listRef
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivzXw.RouterSubscriber), null, ({ location: location })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(IssueApp, {
            isEmbedView: true,
            issueResults: detailViewData,
            view: viewData,
            routePathname: location.pathname,
            routeSearch: location.search,
            ...(0, $4cTDP.fg)('nin_fix_document_title_in_detail_view') && {
                analyticsSource: (0, $1791521efc556332$export$cd2e8394c029507b)
            },
            issueAppEntryPoint: (0, $4cTDP.fg)('nin_issue_app_conditional_entrypoint') ? issueAppEntryPoint : undefined
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null)));
};
// re-render regression detection
$067998940c1c16ee$var$DetailView.whyDidYouRender = true;
var $067998940c1c16ee$export$2e2bcd8739ae039 = (0, $2UTIe.withReportErrors)($067998940c1c16ee$var$DetailView, {
    id: 'ui.issue-results.detail-view.unhandled',
    packageName: (0, $iRahl.PACKAGE_NAME),
    teamName: (0, $iRahl.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $c12HM.isLoaderErrorAttributes)
});
const $067998940c1c16ee$var$ContentContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    height: '100%',
    flexGrow: 1,
    overflow: 'hidden',
    flexBasis: 0
});

});
parcelRegister("iNNDf", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a1ce2e0ec005456$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<413e774d04809c5372ccc3674da92a96>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5a1ce2e0ec005456$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_DetailView_view",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "cardContainer_issueNavigator_view"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueAppWithData_view"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$5a1ce2e0ec005456$var$node.hash = "68ca158b865b96f58c529de1ab919b9b";
var $5a1ce2e0ec005456$export$2e2bcd8739ae039 = $5a1ce2e0ec005456$var$node;

});

parcelRegister("9UIdV", function(module, exports) {
$parcel$export(module.exports, "default", () => $e80a13f79824537b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c6d20b50d30d33e809ff675bbd13cffa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e80a13f79824537b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_DetailView_issueResults",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_CardList_fragment"
        },
        {
            "kind": "FragmentSpread",
            "name": "cardContainer_issueNavigator_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueAppWithData_issueResults"
        }
    ],
    "type": "JiraIssueConnection"
};
$e80a13f79824537b$var$node.hash = "6b64dddb99a963cc9fea8872d644dae0";
var $e80a13f79824537b$export$2e2bcd8739ae039 = $e80a13f79824537b$var$node;

});

parcelRegister("kbYhH", function(module, exports) {
$parcel$export(module.exports, "useElementSizeSelector", () => $815a2426d7099138$export$6af5bd31f067d7e5);
$parcel$export(module.exports, "ElementSizeProvider", () => $815a2426d7099138$export$73bf76c50625186);

var $eJOHy = parcelRequire("eJOHy");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $815a2426d7099138$export$e4c0458e30711294 = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0
};
const $815a2426d7099138$export$638cf470f916deb7 = (0, $6E16M.createContainer)({
    getIsConcurrentSafe: ()=>true
});
const $815a2426d7099138$export$3378d8ea7d02abd0 = {
    height: 0,
    width: 0
};
const $815a2426d7099138$var$actions = {
    update: (newState)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                ...newState
            });
        }
};
const $815a2426d7099138$var$Store = (0, $GtRbT.createStore)({
    containedBy: $815a2426d7099138$export$638cf470f916deb7,
    initialState: $815a2426d7099138$export$3378d8ea7d02abd0,
    name: 'ElementSize',
    actions: $815a2426d7099138$var$actions,
    handlers: {
        onInit: ()=>({ setState: setState, getState: getState }, { width: width, height: height })=>{
                const state = getState();
                setState({
                    ...state,
                    width: width,
                    height: height
                });
            },
        onContainerUpdate: ()=>({ setState: setState, getState: getState }, { width: width, height: height })=>{
                const state = getState();
                setState({
                    ...state,
                    width: width,
                    height: height
                });
            }
    }
});
const $815a2426d7099138$export$6af5bd31f067d7e5 = (0, $iJq0l.createStateHook)($815a2426d7099138$var$Store, {
    selector: (state, cb)=>cb(state)
});
const $815a2426d7099138$export$2b86bedf890eab8 = (elementRef)=>{
    const [size, setSize] = (0, $eJOHy.useState)($815a2426d7099138$export$e4c0458e30711294);
    (0, $eJOHy.useEffect)(()=>{
        const element = elementRef.current;
        if (element) {
            const resizeObserver = new ResizeObserver(()=>{
                setSize({
                    height: element.clientHeight,
                    width: element.clientWidth,
                    scrollHeight: element.scrollHeight,
                    scrollWidth: element.scrollWidth
                });
            });
            resizeObserver.observe(element);
            return ()=>{
                resizeObserver.disconnect();
            };
        }
    }, [
        elementRef
    ]);
    return size;
};
const $815a2426d7099138$export$73bf76c50625186 = ({ elementRef: elementRef, children: children })=>{
    const { width: width, height: height } = $815a2426d7099138$export$2b86bedf890eab8(elementRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($815a2426d7099138$export$638cf470f916deb7, {
        width: width,
        height: height
    }, children);
};

});

const $1791521efc556332$export$53d41ff2666118e1 = 'agility-backlog';
const $1791521efc556332$export$7552fe2669628499 = 'bitbucket-issue';
const $1791521efc556332$export$41a718da0a8636f4 = 'connect-issue';
const $1791521efc556332$export$cebf0bc8b2ccaf57 = 'core-issue';
const $1791521efc556332$export$5e91e17726e54450 = 'jiraCalendar';
const $1791521efc556332$export$2dac1950892123f5 = 'jiraTimeline';
const $1791521efc556332$export$82540942fb014b0a = 'business-calendar';
const $1791521efc556332$export$7ca28938a07e0c33 = 'business-list';
const $1791521efc556332$export$f6cf06aaaeb58a54 = 'business-timeline';
const $1791521efc556332$export$b2c0462ff17aa26e = 'business-board';
const $1791521efc556332$export$a607850ebccd28ac = 'business-approvals';
const $1791521efc556332$export$1da6cede3561048f = 'business-files';
const $1791521efc556332$export$b19f949fb9713614 = 'full-issue';
const $1791521efc556332$export$a5132300c5214280 = 'embed-issue';
const $1791521efc556332$export$710114090a811b37 = 'global-issue-navigator-issue';
const $1791521efc556332$export$ce88447986394f2d = 'mobile-issue';
const $1791521efc556332$export$6a90d9196d330040 = 'project-issue-navigator';
const $1791521efc556332$export$2247c9059c171db1 = 'roadmap-issue';
const $1791521efc556332$export$cd16d39c55c569d0 = 'simple-software-board';
const $1791521efc556332$export$f72626bf0d75dfad = 'software-backlog-issue';
const $1791521efc556332$export$778b4609e784cb27 = 'software-deployments-issue';
const $1791521efc556332$export$5b73d694a6048002 = 'version-detail-issue';
const $1791521efc556332$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $1791521efc556332$export$21b5b7189add7861 = 'software-incidents-issue';
const $1791521efc556332$export$9c5d81b901471b27 = 'software-issue';
const $1791521efc556332$export$1735f6ad917dc411 = 'change-calendar';
const $1791521efc556332$export$7063ee6d0035a982 = 'queues-issue-view';
const $1791521efc556332$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $1791521efc556332$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $1791521efc556332$export$14a8072f422804fd = 'issue-navigator-next';
const $1791521efc556332$export$cd2e8394c029507b = 'issue-navigator-detail-view';
const $1791521efc556332$export$5f3c20fe2ff6c0a2 = 'staffing-issue';
const $1791521efc556332$export$9dac02c804d7acd8 = 'classic-software-board';

parcelRegister("e1kKr", function(module, exports) {
$parcel$export(module.exports, "default", () => $b50a670862cb3fb4$export$2e2bcd8739ae039);

var $eAfmW = parcelRequire("eAfmW");

var $cgbgR = parcelRequire("cgbgR");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $7khpH = parcelRequire("7khpH");

var $7n9BS = parcelRequire("7n9BS");

var $iRahl = parcelRequire("iRahl");

var $6K4cv = parcelRequire("6K4cv");

var $gRqFV = parcelRequire("gRqFV");

var $7emTO = parcelRequire("7emTO");

var $haEEA = parcelRequire("haEEA");

var $eqaMC = parcelRequire("eqaMC");

var $8X4cC = parcelRequire("8X4cC");
const $b50a670862cb3fb4$var$infiniteScrollOptions = {
    threshold: 350 // Approximately 5 min-height cards tall
};
const $b50a670862cb3fb4$var$CardContainer = ({ children: children, issueResults: issueResults, view: view })=>{
    const data = (0, $j4oe4.useFragment)((0, $cgbgR.default), issueResults);
    const viewData = (0, $j4oe4.useFragment)((0, $eAfmW.default), view);
    const fieldSetIds = (0, $eJOHy.useMemo)(()=>viewData?.fieldSets?.edges?.map((edge)=>edge?.node?.fieldSetId).filter(Boolean) ?? [], [
        viewData?.fieldSets?.edges
    ]);
    const infiniteScrollProps = (0, $7emTO.useInfiniteScroll)({
        fieldSetIds: fieldSetIds,
        options: $b50a670862cb3fb4$var$infiniteScrollOptions,
        view: (0, $iRahl.views).detail
    });
    const { isLoadingPrevious: isLoadingPrevious, isLoadingNext: isLoadingNext } = infiniteScrollProps;
    const { onScroll: onScroll, onLoadingThresholdCheck: onLoadingThresholdCheck } = (0, $7khpH.useInfiniteScrollHandler)(infiniteScrollProps);
    const scrollContainerRef = (0, $eJOHy.useRef)(null);
    const totalIssues = data.totalIssueSearchResultCount ?? 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        grow: "fill",
        xcss: $b50a670862cb3fb4$var$containerStyles,
        testId: "issue-navigator.ui.issue-results.detail-view.card-container.styled-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.050",
        xcss: $b50a670862cb3fb4$var$headerStyles,
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eqaMC.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8X4cC.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gRqFV.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7n9BS.ScrollStateProvider), {
        scrollRef: scrollContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        grow: "fill",
        xcss: $b50a670862cb3fb4$var$loadingIndicatorContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        ref: scrollContainerRef,
        xcss: $b50a670862cb3fb4$var$cardListStyles,
        onScroll: onScroll,
        testId: "issue-navigator.ui.issue-results.detail-view.card-container.scroll-container"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $haEEA.LoadingManager), {
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        onLoadingThresholdCheck: onLoadingThresholdCheck
    }))), totalIssues != null && totalIssues > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        alignInline: "center",
        xcss: $b50a670862cb3fb4$var$footerStyles,
        testId: "issue-navigator.ui.issue-results.detail-view.card-container.total-count"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6K4cv.default), {
        startIssueRange: -1,
        endIssueRange: -1,
        total: totalIssues,
        countExceedsMaxResults: !!data.isCappingIssueSearchResult,
        loadedIssuesCount: data.edges?.length ?? 0,
        isInfiniteScrollEnabled: true
    })));
};
var $b50a670862cb3fb4$export$2e2bcd8739ae039 = $b50a670862cb3fb4$var$CardContainer;
const $b50a670862cb3fb4$var$containerStyles = (0, $1DXK0.xcss)({
    borderRadius: "var(--ds-radius-small, 4px)",
    backgroundColor: 'elevation.surface.sunken',
    boxSizing: 'content-box',
    paddingInline: 'space.025',
    marginBottom: 'space.100',
    marginRight: 'space.200',
    minWidth: '256px',
    maxWidth: '256px'
});
const $b50a670862cb3fb4$var$headerStyles = (0, $1DXK0.xcss)({
    flexGrow: 1,
    flexShrink: 0,
    height: '40px',
    marginBottom: 'space.negative.025',
    // Cards require small margin to show box shadow. This negative margin recenters the header.
    paddingInline: 'space.025'
});
const $b50a670862cb3fb4$var$loadingIndicatorContainerStyles = (0, $1DXK0.xcss)({
    flexGrow: '1',
    flexShrink: '1',
    flexBasis: '100vh',
    overflow: 'hidden',
    position: 'relative' // Required in order to contain loading indicator
});
const $b50a670862cb3fb4$var$cardListStyles = (0, $1DXK0.xcss)({
    flexGrow: '1',
    overflow: 'auto'
});
const $b50a670862cb3fb4$var$footerStyles = (0, $1DXK0.xcss)({
    color: 'color.text.subtlest',
    paddingBlock: 'space.050',
    textAlign: 'center'
});

});
parcelRegister("eAfmW", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9f4e65c6aaf00f0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<92fae5f50256e3386fc71e04131d3a3e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b9f4e65c6aaf00f0$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "amountOfColumns"
        },
        {
            "kind": "RootArgument",
            "name": "fieldSetsScope"
        }
    ],
    "kind": "Fragment",
    "name": "cardContainer_issueNavigator_view",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "fieldSetSelectedState": "SELECTED"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "amountOfColumns"
                },
                {
                    "kind": "Variable",
                    "name": "scope",
                    "variableName": "fieldSetsScope"
                }
            ],
            "concreteType": "JiraIssueSearchFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSets",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueSearchFieldSetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fieldSetId"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$b9f4e65c6aaf00f0$var$node.hash = "dd030a7b614f7ff3b54a4b31d5671be2";
var $b9f4e65c6aaf00f0$export$2e2bcd8739ae039 = $b9f4e65c6aaf00f0$var$node;

});

parcelRegister("cgbgR", function(module, exports) {
$parcel$export(module.exports, "default", () => $63c8038186a8fdc3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<49a8b04fc3798cc5e42bb64eb7cfe233>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $63c8038186a8fdc3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "cardContainer_issueNavigator_issueResults",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        }
    ],
    "type": "JiraIssueConnection"
};
$63c8038186a8fdc3$var$node.hash = "a51c85a8ee17bb574907b5cd760bad2f";
var $63c8038186a8fdc3$export$2e2bcd8739ae039 = $63c8038186a8fdc3$var$node;

});

parcelRegister("7khpH", function(module, exports) {
$parcel$export(module.exports, "useInfiniteScrollHandler", () => $8f8e5c1656e840b4$export$ee8d81e7d8c9f22d);

var $eJOHy = parcelRequire("eJOHy");

var $8jOO7 = parcelRequire("8jOO7");

var $5M8i8 = parcelRequire("5M8i8");
const $8f8e5c1656e840b4$var$DEFAULT_ACTIVATION_THRESHOLD = 10 * (0, $8jOO7.ROW_HEIGHT);
const $8f8e5c1656e840b4$export$ee8d81e7d8c9f22d = ({ onLoadNext: onLoadNextProp, onLoadPrevious: onLoadPreviousProp, ...dataProps })=>{
    // Keep props as ref so the callback is stable across rerenders.
    const dataPropsRef = (0, $eJOHy.useRef)(dataProps);
    dataPropsRef.current = dataProps;
    const onLoadNext = (0, $5M8i8.useThrottle)(onLoadNextProp);
    const onLoadPrevious = (0, $5M8i8.useThrottle)(onLoadPreviousProp);
    const onLoadingThresholdCheck = (0, $eJOHy.useCallback)(({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop })=>{
        const { isLoadingNext: isLoadingNext, isLoadingPrevious: isLoadingPrevious, hasNext: hasNext, hasPrevious: hasPrevious, activationThreshold: activationThreshold = $8f8e5c1656e840b4$var$DEFAULT_ACTIVATION_THRESHOLD } = dataPropsRef.current;
        const scrollBottom = scrollHeight - clientHeight - scrollTop;
        const isLoading = isLoadingNext || isLoadingPrevious;
        // Prioritising loading next over loading previous to fill results downwards first,
        // to hopefully feel more natural.
        if (hasNext && !isLoading && scrollBottom <= activationThreshold) onLoadNext?.();
        else if (hasPrevious && !isLoading && scrollTop <= activationThreshold) onLoadPrevious?.();
    }, // Ensure that the callback is not recreated when props change.
    // onLoadNext & onLoadPrevious should be throttled & stable.
    [
        onLoadNext,
        onLoadPrevious
    ]);
    const onScroll = (0, $eJOHy.useCallback)((event)=>{
        onLoadingThresholdCheck(event.currentTarget);
    }, // Ensure that the callback is not recreated when props change.
    // onLoadingThresholdCheck should be stable.
    [
        onLoadingThresholdCheck
    ]);
    return {
        onLoadingThresholdCheck: onLoadingThresholdCheck,
        onScroll: onScroll
    };
};

});
parcelRegister("5M8i8", function(module, exports) {
$parcel$export(module.exports, "useThrottle", () => $47c0698a2db18423$export$8b7b9481d6186f21);

var $eJOHy = parcelRequire("eJOHy");
const $47c0698a2db18423$export$8b7b9481d6186f21 = (fn, wait = 100)=>{
    const fnRef = (0, $eJOHy.useRef)(fn);
    fnRef.current = fn;
    const waitRef = (0, $eJOHy.useRef)(wait);
    waitRef.current = wait;
    const timeout = (0, $eJOHy.useRef)(undefined);
    const throttled = (0, $eJOHy.useCallback)(()=>{
        if (timeout.current !== undefined) return;
        fnRef.current?.();
        timeout.current = setTimeout(()=>{
            timeout.current = undefined;
        }, waitRef.current);
    // Ensure the callback is not recreated when props change,
    // dependency array should be empty.
    }, []);
    // Cleanup the timeout on unmount.
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (timeout.current !== undefined) clearTimeout(timeout.current);
        };
    }, []);
    return throttled;
};

});


parcelRegister("7n9BS", function(module, exports) {
$parcel$export(module.exports, "useScrollStateActions", () => $fb5e49bfa6da600b$export$f4fa046095d4d6af);
$parcel$export(module.exports, "useScrollStateSelector", () => $fb5e49bfa6da600b$export$a2d79f83724ed591);
$parcel$export(module.exports, "useScrollElement", () => $fb5e49bfa6da600b$export$fae04c81b2201f65);
$parcel$export(module.exports, "ScrollStateProvider", () => $fb5e49bfa6da600b$export$9f9741e7dc6bdb9b);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $8jOO7 = parcelRequire("8jOO7");
const $fb5e49bfa6da600b$export$50b6b7783d156e1b = 200;
const $fb5e49bfa6da600b$export$f9abcb6f103965a2 = (0, $6E16M.createContainer)();
const $fb5e49bfa6da600b$var$INITIAL_SCROLL_STATE = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0,
    scrollTop: 0,
    scrollLeft: 0,
    isScrolling: false,
    scrollElement: null,
    hasScrolled: false
};
const $fb5e49bfa6da600b$var$actions = {
    update: (newState)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                ...newState
            });
        },
    getScrollInfo: ()=>({ getState: getState })=>{
            const { scrollElement: scrollElement, isScrolling: isScrolling, width: width } = getState();
            return {
                isScrolling: isScrolling,
                scrollElement: scrollElement,
                // Calculated by adding the scroll container’s left and right positions relative to the viewport to the table width to get the total horizontal space
                isSmallScreen: width + (scrollElement?.getBoundingClientRect().left ?? 0) + (scrollElement?.getBoundingClientRect().right ?? 0) < (0, $8jOO7.SMALL_SCREEN_WIDTH) && width !== 0
            };
        }
};
const $fb5e49bfa6da600b$var$Store = (0, $GtRbT.createStore)({
    containedBy: $fb5e49bfa6da600b$export$f9abcb6f103965a2,
    initialState: $fb5e49bfa6da600b$var$INITIAL_SCROLL_STATE,
    name: 'ScrollStateManager',
    actions: $fb5e49bfa6da600b$var$actions
});
const $fb5e49bfa6da600b$export$f4fa046095d4d6af = (0, $iJq0l.createActionsHook)($fb5e49bfa6da600b$var$Store);
const $fb5e49bfa6da600b$export$a2d79f83724ed591 = (0, $iJq0l.createStateHook)($fb5e49bfa6da600b$var$Store, {
    selector: (state, cb)=>cb(state)
});
const $fb5e49bfa6da600b$export$fae04c81b2201f65 = (0, $iJq0l.createStateHook)($fb5e49bfa6da600b$var$Store, {
    selector: (state)=>state.scrollElement
});
const $fb5e49bfa6da600b$var$attachResizeObserver = (callback, targetEl)=>{
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    if (!targetEl) return ()=>{};
    let resizeObserver = null;
    // SSR fix. Do not instantiate for SSR
    if (typeof ResizeObserver !== 'undefined') resizeObserver = new ResizeObserver(()=>callback());
    // When mounting our listener, if its the Window object, treat it as such.
    // This can happen in Storybook but not in any other scenario
    if (targetEl instanceof Window) targetEl.addEventListener('resize', callback);
    else resizeObserver?.observe(targetEl);
    return ()=>{
        // Cleanup the resize callback we have attached
        if (targetEl instanceof Window) targetEl.removeEventListener('resize', callback);
        else resizeObserver?.disconnect();
    };
};
/**
 * Listens for scroll events on the `HTMLElement` `scrollRef.current` and updates a state
 * variable with the scroll state, which is returned.
 */ const $fb5e49bfa6da600b$var$useElementScrollState = (scrollRef)=>{
    const { update: update } = $fb5e49bfa6da600b$export$f4fa046095d4d6af();
    (0, $eJOHy.useEffect)(()=>{
        const targetEl = scrollRef.current;
        // The element should always exists as the useEffect triggers after the reference is assigned.
        if (!targetEl) return undefined;
        let clearScrollingTimeoutId;
        const onScroll = ()=>{
            update({
                scrollWidth: targetEl.scrollWidth,
                scrollTop: targetEl.scrollTop,
                scrollLeft: targetEl.scrollLeft,
                isScrolling: true,
                hasScrolled: true
            });
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                update({
                    scrollWidth: targetEl.scrollWidth,
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    isScrolling: false
                });
            }, $fb5e49bfa6da600b$export$50b6b7783d156e1b);
        };
        const onResize = ()=>{
            update({
                scrollTop: targetEl.scrollTop,
                scrollLeft: targetEl.scrollLeft,
                height: targetEl.clientHeight,
                width: targetEl.clientWidth,
                scrollHeight: targetEl.scrollHeight,
                scrollWidth: targetEl.scrollWidth,
                isScrolling: true
            });
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                update({
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    isScrolling: false
                });
            }, $fb5e49bfa6da600b$export$50b6b7783d156e1b);
        };
        // We want to know when the scroll element/container itself resizes as this impacts
        // the number of rows we show
        const cleanupResizeObserver = $fb5e49bfa6da600b$var$attachResizeObserver(onResize, targetEl);
        targetEl.addEventListener('scroll', onScroll);
        update({
            height: targetEl.clientHeight,
            width: targetEl.clientWidth,
            scrollHeight: targetEl.scrollHeight,
            scrollWidth: targetEl.scrollWidth,
            scrollTop: targetEl.scrollTop,
            scrollLeft: targetEl.scrollLeft,
            isScrolling: false,
            scrollElement: targetEl
        });
        return ()=>{
            targetEl.removeEventListener('scroll', onScroll);
            cleanupResizeObserver();
            clearTimeout(clearScrollingTimeoutId);
        };
    }, [
        scrollRef,
        update
    ]);
};
const $fb5e49bfa6da600b$var$ScrollStateProviderInner = ({ scrollRef: scrollRef, children: children })=>{
    $fb5e49bfa6da600b$var$useElementScrollState(scrollRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $fb5e49bfa6da600b$export$9f9741e7dc6bdb9b = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fb5e49bfa6da600b$export$f9abcb6f103965a2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fb5e49bfa6da600b$var$ScrollStateProviderInner, props));
};

});

parcelRegister("6K4cv", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9107f8cdbcabb4f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $4hQDI = parcelRequire("4hQDI");

var $g2A1K = parcelRequire("g2A1K");
const $d9107f8cdbcabb4f$var$PageText = ({ startIssueRange: startIssueRange, endIssueRange: endIssueRange, loadedIssuesCount: loadedIssuesCount, total: total, countExceedsMaxResults: countExceedsMaxResults, isInfiniteScrollEnabled: isInfiniteScrollEnabled // This is not the experiment; This is if the feature is enabled
 })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isTotalUnknown = total <= 0;
    if (isInfiniteScrollEnabled) {
        if (isTotalUnknown) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, loadedIssuesCount);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4hQDI.default), {
            prependMessage: (0, $g2A1K.default).loadedIssuesTotalKnown,
            prependMessageValues: {
                loadedIssuesCount: loadedIssuesCount
            },
            stableCount: total,
            isCapped: countExceedsMaxResults
        });
    }
    if (isTotalUnknown) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $g2A1K.default).issueRangeUnknown, {
        startIssueRange: startIssueRange,
        endIssueRange: endIssueRange
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4hQDI.default), {
        prependMessage: (0, $g2A1K.default).issueRangeKnown,
        prependMessageValues: {
            startIssueRange: startIssueRange,
            endIssueRange: endIssueRange
        },
        stableCount: total,
        isCapped: countExceedsMaxResults
    });
};
var $d9107f8cdbcabb4f$export$2e2bcd8739ae039 = $d9107f8cdbcabb4f$var$PageText;

});
parcelRegister("4hQDI", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b1f20e946ddee1c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $lRq8t = parcelRequire("lRq8t");

var $1Qv0G = parcelRequire("1Qv0G");
/**
 * Display the total number of issues from a search with the ability to toggle from stable to unstable values.
 *
 * Stable vs Unstable
 *  - the **stable count** is returned from the issueSearchStable query. It will be capped at 1000 if
 *    there are more than 1000 results. This is the default count that is displayed
 *
 *  - the **unstable count** is returned from the totalIssueCountQuery query. It is the true number of results
 *    for a search and does not have a cap. This value must be requested by the user via button click.
 */ const $3b1f20e946ddee1c$var$TotalIssueCountWrapper = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "TotalIssueCount",
        packageName: "jiraIssueNavigator",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage(props.prependMessage, {
                ...props.prependMessageValues,
                totalNumberIssues: props.isCapped ? `${props.stableCount}+` : props.stableCount
            })),
        sendToPrivacyUnsafeSplunk: true,
        teamName: "empanada"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Qv0G.default), props));
};
var $3b1f20e946ddee1c$export$2e2bcd8739ae039 = $3b1f20e946ddee1c$var$TotalIssueCountWrapper;

});
parcelRegister("1Qv0G", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3e48f1c27257a80$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $80DPg = parcelRequire("80DPg");

var $8IeH1 = parcelRequire("8IeH1");

var $7ep4S = parcelRequire("7ep4S");

var $k71qx = parcelRequire("k71qx");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $eS29z = parcelRequire("eS29z");

var $3kDjB = parcelRequire("3kDjB");

var $ald06 = parcelRequire("ald06");

var $eTKLi = parcelRequire("eTKLi");
const $a3e48f1c27257a80$var$TotalIssueCount = ({ prependMessage: prependMessage, prependMessageValues: prependMessageValues, isCapped: isCapped, stableCount: stableCount })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const totalIssueCount = (0, $3kDjB.useTotalIssueCount)();
    const totalIssueCountIsFetching = (0, $3kDjB.useTotalIssueCountIsFetching)();
    const totalIssueCountIsError = (0, $3kDjB.useTotalIssueCountIsError)();
    const { fetchTotalIssueCount: fetchTotalIssueCount } = (0, $3kDjB.useIssueSearchActions)();
    if (isCapped) {
        if (totalIssueCountIsError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            as: "span"
        }, formatMessage(prependMessage, {
            ...prependMessageValues,
            totalNumberIssues: `${stableCount}+`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            position: "top",
            content: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eTKLi.default).errorTooltipTextIssueTermRefresh : (0, $eTKLi.default).errorTooltipText)
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a3e48f1c27257a80$var$ErrorIconContainer, {
                ...tooltipProps,
                "data-testid": "issue-navigator.common.ui.total-issue-count.error-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
                spacing: "spacious",
                label: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eTKLi.default).errorIconLabelIssueTermRefresh : (0, $eTKLi.default).errorIconLabel)
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireUiAnalytics), {
            action: "viewed",
            actionSubject: "errorIcon",
            actionSubjectId: "totalIssueCount"
        }));
        if (totalIssueCountIsFetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            as: "span"
        }, formatMessage(prependMessage, {
            ...prependMessageValues,
            totalNumberIssues: ''
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a3e48f1c27257a80$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
            size: "small",
            testId: "issue-navigator.common.ui.total-issue-count.spinner"
        })));
        if (!totalIssueCount) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            as: "span"
        }, formatMessage(prependMessage, {
            ...prependMessageValues,
            totalNumberIssues: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ald06.default), {
                displayText: `${stableCount}+`,
                onFetchCount: fetchTotalIssueCount
            })
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            as: "span"
        }, formatMessage(prependMessage, {
            ...prependMessageValues,
            totalNumberIssues: totalIssueCount
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        as: "span"
    }, formatMessage(prependMessage, {
        ...prependMessageValues,
        totalNumberIssues: stableCount
    }));
};
var $a3e48f1c27257a80$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eJOHy.memo)($a3e48f1c27257a80$var$TotalIssueCount);
const $a3e48f1c27257a80$var$ErrorIconContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1o8l _4t3i1tcg _syaz1rpy",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3e48f1c27257a80$var$SpinnerContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1o8l _otyr1l7b _18u01b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ald06", function(module, exports) {
$parcel$export(module.exports, "default", () => $c44b18b79e6584e9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $k71qx = parcelRequire("k71qx");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $eTKLi = parcelRequire("eTKLi");
const $c44b18b79e6584e9$var$LoadUncappedCountButton = ({ onFetchCount: onFetchCount, displayText: displayText })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const fetchCount = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        onFetchCount();
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'totalIssueCountButton');
    }, [
        onFetchCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eTKLi.default).cappedCountTooltipIssueTermRefresh : (0, $eTKLi.default).cappedCountTooltip),
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        tabIndex: 0,
        appearance: "link",
        spacing: "none",
        onClick: fetchCount,
        "aria-label": formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eTKLi.default).cappedCountButtonLabelIssueTermRefresh : (0, $eTKLi.default).cappedCountButtonLabel, {
            count: displayText
        }),
        testId: "issue-navigator.common.ui.total-issue-count.load-uncapped-count-button.button"
    }, displayText));
};
var $c44b18b79e6584e9$export$2e2bcd8739ae039 = $c44b18b79e6584e9$var$LoadUncappedCountButton;

});
parcelRegister("eTKLi", function(module, exports) {
$parcel$export(module.exports, "default", () => $673f93c64d67cc98$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $673f93c64d67cc98$var$messages = (0, $7qGN1.defineMessages)({
    errorTooltipText: {
        "id": "issue-navigator.common.total-issue-count.error-tooltip-text",
        "defaultMessage": "We couldn\u2019t load the total number of issues. Refresh to try again."
    },
    errorIconLabel: {
        "id": "issue-navigator.common.total-issue-count.error-icon-label",
        "defaultMessage": "Error loading total issue count"
    },
    cappedCountTooltip: {
        "id": "issue-navigator.common.total-issue-count.capped-count-tooltip",
        "defaultMessage": "See the total number of issues."
    },
    errorTooltipTextIssueTermRefresh: {
        "id": "issue-navigator.common.total-issue-count.error-tooltip-text-issue-term-refresh",
        "defaultMessage": "We couldn\u2019t load the total number of work items. Refresh to try again."
    },
    errorIconLabelIssueTermRefresh: {
        "id": "issue-navigator.common.total-issue-count.error-icon-label-issue-term-refresh",
        "defaultMessage": "Error loading total work item count"
    },
    cappedCountTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.total-issue-count.capped-count-tooltip-issue-term-refresh",
        "defaultMessage": "See the total number of work items."
    },
    cappedCountButtonLabel: {
        "id": "issue-navigator.common.total-issue-count.capped-count-button-label",
        "defaultMessage": "{count} See the total number of issues."
    },
    cappedCountButtonLabelIssueTermRefresh: {
        "id": "issue-navigator.common.total-issue-count.capped-count-button-label-issue-term-refresh",
        "defaultMessage": "{count} See the total number of work items."
    }
});
var $673f93c64d67cc98$export$2e2bcd8739ae039 = $673f93c64d67cc98$var$messages;

});




parcelRegister("g2A1K", function(module, exports) {
$parcel$export(module.exports, "default", () => $74cbac8c41f7e98a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $74cbac8c41f7e98a$var$messages = (0, $7qGN1.defineMessages)({
    loadedIssuesTotalKnown: {
        "id": "issue-navigator.common.page-text.loaded-issues-total-known",
        "defaultMessage": "{loadedIssuesCount} of {totalNumberIssues}"
    },
    issueRangeKnown: {
        "id": "issue-navigator.card-container.paginator.issue-range-known",
        "defaultMessage": "{startIssueRange}-{endIssueRange} of {totalNumberIssues}"
    },
    issueRangeUnknown: {
        "id": "issue-navigator.card-container.paginator.issue-range-unknown",
        "defaultMessage": "{startIssueRange}-{endIssueRange}"
    }
});
var $74cbac8c41f7e98a$export$2e2bcd8739ae039 = $74cbac8c41f7e98a$var$messages;

});


parcelRegister("gRqFV", function(module, exports) {
$parcel$export(module.exports, "default", () => $399b0ebc2f4d4ea9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $yJU5w = parcelRequire("yJU5w");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $3kDjB = parcelRequire("3kDjB");

var $fg4DB = parcelRequire("fg4DB");
const $399b0ebc2f4d4ea9$var$RefreshButton = ()=>{
    const isRefreshing = (0, $3kDjB.useIsRefreshing)();
    const { refresh: refresh } = (0, $3kDjB.useIssueSearchActions)();
    const handleClick = (0, $eJOHy.useCallback)((_, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'reloadIssueListButton');
        refresh();
    }, [
        refresh
    ]);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        appearance: "subtle",
        onClick: handleClick,
        testId: "issue-navigator.common.ui.refresh-button.refresh-button",
        label: formatMessage((0, $fg4DB.default).tooltip),
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($yJU5w))), {
                ...iconProps,
                color: "var(--ds-icon-subtle, #505258)",
                LEGACY_primaryColor: "color.icon.subtle"
            }),
        isLoading: isRefreshing
    });
};
var $399b0ebc2f4d4ea9$export$2e2bcd8739ae039 = $399b0ebc2f4d4ea9$var$RefreshButton;

});
parcelRegister("yJU5w", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bacc7e4688824042b7c7acb7148b6a10>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0686c89929896566$var$_react = $0686c89929896566$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0686c89929896566$var$_baseNew = $0686c89929896566$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $0686c89929896566$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0686c89929896566$var$RefreshIcon = (props)=>/*#__PURE__*/ $0686c89929896566$var$_react.default.createElement($0686c89929896566$var$_baseNew.default, Object.assign({
        name: "RefreshIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 3.67V1H1v5c0 .414.336.75.75.75H6.5v-1.5H3.236a5.5 5.5 0 1 1-.666 3.63l-1.48.24A7.002 7.002 0 0 0 15 8 7 7 0 0 0 2.5 3.67" clip-rule="evenodd"/>`
    }, props));
$0686c89929896566$var$RefreshIcon.displayName = 'RefreshIcon';
var $0686c89929896566$var$_default = module.exports.default = $0686c89929896566$var$RefreshIcon;

});

parcelRegister("fg4DB", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e0439daacbe1e8b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
// TODO - Port i18n string translations to new module ID keys
const $0e0439daacbe1e8b$var$messages = (0, $7qGN1.defineMessages)({
    tooltip: {
        "id": "issue-navigator.refresh-button.tooltip",
        "defaultMessage": "Refresh"
    },
    loading: {
        "id": "issue-navigator.refresh-button.loading",
        "defaultMessage": "Loading"
    }
});
var $0e0439daacbe1e8b$export$2e2bcd8739ae039 = $0e0439daacbe1e8b$var$messages;

});


parcelRegister("haEEA", function(module, exports) {
$parcel$export(module.exports, "LoadingManager", () => $71f8d6b49558d935$export$99cc795e99919eed);

var $eJOHy = parcelRequire("eJOHy");

var $9cbmy = parcelRequire("9cbmy");

var $lRq8t = parcelRequire("lRq8t");

var $kbYhH = parcelRequire("kbYhH");

var $7n9BS = parcelRequire("7n9BS");

var $6d9QY = parcelRequire("6d9QY");

var $4cTDP = parcelRequire("4cTDP");

var $3VBEh = parcelRequire("3VBEh");

var $kKJ20 = parcelRequire("kKJ20");
const $71f8d6b49558d935$export$99cc795e99919eed = ({ isLoadingPrevious: isLoadingPrevious, isLoadingNext: isLoadingNext, onLoadingThresholdCheck: onLoadingThresholdCheck })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    // List has height 0 during first render due to virtualization. Some checks need to wait for the list to have a height.
    const hasListHeight = (0, $kbYhH.useElementSizeSelector)((listElm)=>Boolean(listElm.height));
    const scrollContainerHeight = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.height);
    const scrollElement = (0, $7n9BS.useScrollElement)();
    // #region After-load Handler
    /**
   * After initial render and any subsequent loading events, make sure that we continue loading in more issues if
   * necessary because a single load may not have enough issues to fill the scroll container.
   */ (0, $eJOHy.useEffect)(()=>{
        if (scrollElement && onLoadingThresholdCheck && hasListHeight && !isLoadingPrevious && !isLoadingNext) // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        onLoadingThresholdCheck(scrollElement);
    }, [
        hasListHeight,
        isLoadingPrevious,
        isLoadingNext,
        onLoadingThresholdCheck,
        scrollElement
    ]);
    // #endregion
    // #region Resize Handler
    /**
   * Check the loading boundaries when resizing the scroll container, as the new size may require loading more issues.
   */ const prevHeight = (0, $6d9QY.usePreviousWithInitial)(scrollContainerHeight);
    (0, $eJOHy.useEffect)(()=>{
        if (scrollElement && onLoadingThresholdCheck && hasListHeight && scrollContainerHeight > prevHeight) // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        onLoadingThresholdCheck(scrollElement);
    }, [
        hasListHeight,
        scrollContainerHeight,
        prevHeight,
        onLoadingThresholdCheck,
        scrollElement
    ]);
    // #endregion
    // #region Top Scroll Handler
    /**
   * A component that ensures that the scroll position is kept stable when loading previous issues.
   * This is necessary because sometimes the browser does scroll to keep existing rows in view when new rows are prepended.
   *
   * Without this, we may see issues like continuously loading all previous issues until there are none left.
   */ const prevIsLoadingPrevious = (0, $6d9QY.usePreviousWithInitial)(isLoadingPrevious);
    const hasStartedLoadingPrevious = !prevIsLoadingPrevious && isLoadingPrevious;
    const hasFinishedLoadingPrevious = prevIsLoadingPrevious && !isLoadingPrevious;
    // Hook's scrollHeight doesn't update the height information when the scroll height changes due to DOM mutations
    // Need to track this separately when loading starts
    const scrollHeightRef = (0, $eJOHy.useRef)(0);
    (0, $eJOHy.useEffect)(()=>{
        if (scrollElement && hasStartedLoadingPrevious) scrollHeightRef.current = scrollElement.scrollHeight;
    }, [
        hasStartedLoadingPrevious,
        scrollElement
    ]);
    // Ensure that the scroll is kept in place after loading previous issues - browser doesn't always handle this properly
    // Using a layout effect to make sure this happens as quickly as possible to reduce visible movement
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (scrollElement && hasFinishedLoadingPrevious) {
            const newScrollHeight = scrollElement.scrollHeight;
            if (newScrollHeight > scrollHeightRef.current) {
                const heightIncrease = newScrollHeight - scrollHeightRef.current;
                scrollElement.scrollBy(0, heightIncrease);
            }
            scrollHeightRef.current = newScrollHeight;
        }
    }, [
        hasFinishedLoadingPrevious,
        scrollElement
    ]);
    // #endregion
    // #region Loading A11y
    const prevIsLoadingNext = (0, $6d9QY.usePreviousWithInitial)(isLoadingNext);
    const hasFinishedLoadingNext = prevIsLoadingNext && !isLoadingNext;
    const loadingCompleteLiveMessage = (0, $eJOHy.useRef)(undefined);
    if (isLoadingPrevious) loadingCompleteLiveMessage.current = (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $kKJ20.default).loadStartA11YMessageTopIssueTermRefresh : (0, $kKJ20.default).loadStartA11YMessageTop;
    else if (hasFinishedLoadingPrevious) loadingCompleteLiveMessage.current = (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $kKJ20.default).loadEndA11YMessageTopIssueTermRefresh : (0, $kKJ20.default).loadEndA11YMessageTop;
    else if (isLoadingNext) loadingCompleteLiveMessage.current = (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $kKJ20.default).loadStartA11YMessageBottomIssueTermRefresh : (0, $kKJ20.default).loadStartA11YMessageBottom;
    else if (hasFinishedLoadingNext) loadingCompleteLiveMessage.current = (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $kKJ20.default).loadEndA11YMessageBottomIssueTermRefresh : (0, $kKJ20.default).loadEndA11YMessageBottom;
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isLoadingPrevious && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3VBEh.LoadingIndicator), {
        position: "top"
    }), isLoadingNext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3VBEh.LoadingIndicator), {
        position: "bottom"
    }), loadingCompleteLiveMessage.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), {
        role: "alert",
        "aria-live": "polite"
    }, formatMessage(loadingCompleteLiveMessage.current)));
};

});
parcelRegister("3VBEh", function(module, exports) {
$parcel$export(module.exports, "LoadingIndicator", () => $871efb7dc0251ef8$export$7c20be4c1d342248);

var $eJOHy = parcelRequire("eJOHy");

var $3Wh6p = parcelRequire("3Wh6p");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $2QkAA = parcelRequire("2QkAA");
const $871efb7dc0251ef8$export$7c20be4c1d342248 = ({ position: position })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignInline: "center",
        xcss: [
            $871efb7dc0251ef8$var$containerStyles,
            position === 'top' ? $871efb7dc0251ef8$var$positionTopStyles : $871efb7dc0251ef8$var$positionBottomStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        alignBlock: "center",
        grow: "hug",
        xcss: $871efb7dc0251ef8$var$loadingIndicatorStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        appearance: "invert",
        size: "small",
        interactionName: (0, $4cTDP.fg)('add_nin_press_interactions') ? 'nin-detail-view-infinite-scroll-loading' : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        color: "color.text.inverse"
    }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $2QkAA.default).loadingMessageIssueTermRefresh : (0, $2QkAA.default).loadingMessage))));
};
const $871efb7dc0251ef8$var$positionTopStyles = (0, $1DXK0.xcss)({
    top: 'space.0'
});
const $871efb7dc0251ef8$var$positionBottomStyles = (0, $1DXK0.xcss)({
    bottom: 'space.0'
});
const $871efb7dc0251ef8$var$loadingIndicatorStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.neutral.bold',
    borderRadius: 'radius.small',
    boxShadow: 'elevation.shadow.overlay',
    color: 'color.text.inverse',
    marginBlock: 'space.200',
    padding: 'space.100'
});
const $871efb7dc0251ef8$var$containerStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    width: '100%'
});

});
parcelRegister("2QkAA", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d90748bc6480da0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $1d90748bc6480da0$var$messages = (0, $7qGN1.defineMessages)({
    loadingMessage: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.loading-indicator.loading-message",
        "defaultMessage": "Loading more issues"
    },
    loadingMessageIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.loading-indicator.loading-message-issue-term-refresh",
        "defaultMessage": "Loading more work items"
    }
});
var $1d90748bc6480da0$export$2e2bcd8739ae039 = $1d90748bc6480da0$var$messages;

});


parcelRegister("kKJ20", function(module, exports) {
$parcel$export(module.exports, "default", () => $16f25f2ae945dfd7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $16f25f2ae945dfd7$var$messages = (0, $7qGN1.defineMessages)({
    loadStartA11YMessageTop: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-start-a-11-y-message-top",
        "defaultMessage": "Loading more issues at the top of the list."
    },
    loadEndA11YMessageTop: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-end-a-11-y-message-top",
        "defaultMessage": "Finished loading more issues at the top of the list."
    },
    loadStartA11YMessageBottom: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-start-a-11-y-message-bottom",
        "defaultMessage": "Loading more issues at the bottom of the list."
    },
    loadEndA11YMessageBottom: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-end-a-11-y-message-bottom",
        "defaultMessage": "Finished loading more issues at the bottom of the list."
    },
    loadStartA11YMessageTopIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-start-a-11-y-message-top-issue-term-refresh",
        "defaultMessage": "Loading more work items at the top of the list."
    },
    loadEndA11YMessageTopIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-end-a-11-y-message-top-issue-term-refresh",
        "defaultMessage": "Finished loading more work items at the top of the list."
    },
    loadStartA11YMessageBottomIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-start-a-11-y-message-bottom-issue-term-refresh",
        "defaultMessage": "Loading more work items at the bottom of the list."
    },
    loadEndA11YMessageBottomIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-end-a-11-y-message-bottom-issue-term-refresh",
        "defaultMessage": "Finished loading more work items at the bottom of the list."
    }
});
var $16f25f2ae945dfd7$export$2e2bcd8739ae039 = $16f25f2ae945dfd7$var$messages;

});


parcelRegister("eqaMC", function(module, exports) {
$parcel$export(module.exports, "default", () => $20c0ff6ce7988817$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $1OQKp = parcelRequire("1OQKp");

var $goZPP = parcelRequire("goZPP");

var $7rjYb = parcelRequire("7rjYb");
var $1pKTL = parcelRequire("1pKTL");
var $6TtH3 = parcelRequire("6TtH3");

var $as6H2 = parcelRequire("as6H2");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $dTocu = parcelRequire("dTocu");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $iRahl = parcelRequire("iRahl");

var $eibCx = parcelRequire("eibCx");

var $91UnK = parcelRequire("91UnK");

var $dTsrC = parcelRequire("dTsrC");

var $dTg5r = parcelRequire("dTg5r");
const $20c0ff6ce7988817$export$e813e910f52c9aab = {
    appearance: 'subtle',
    'data-testid': 'issue-navigator.ui.issue-results.detail-view.card-container.order-dropdown.button'
};
const $20c0ff6ce7988817$var$customFieldIdPattern = /^cf\[\d+\]$/;
const $20c0ff6ce7988817$var$DropdownItemRadioWithAnalytics = (0, $as6H2.default)('dropdownItemRadio', {
    onClick: 'clicked'
})((0, $1pKTL.default));
class $20c0ff6ce7988817$export$50f2c227513bcdb7 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    onItemClick(order, aliases) {
        const { onChange: onChange, onBlur: onBlur } = this.props;
        onChange(order, aliases);
        onBlur();
    }
    renderItems() {
        const { intl: { formatMessage: formatMessage }, orderField: orderField } = this.props;
        return Object.values((0, $iRahl.supportedOrderFields)).filter((0, $eibCx.isNonNullish)).map(({ jqlTerm: jqlTerm, aliases: aliases })=>{
            let jqlTermForMessage = jqlTerm;
            if ([
                'issuetype'
            ].includes(jqlTermForMessage)) jqlTermForMessage = `${jqlTerm}${(0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? 'IssueTermRefresh' : ''}`;
            const messageDescriptor = (0, $dTg5r.messageLookup)[jqlTermForMessage];
            const fieldName = messageDescriptor ? formatMessage(messageDescriptor) : jqlTerm;
            const props = {
                id: jqlTerm,
                onClick: ()=>{
                    this.onItemClick(jqlTerm, aliases);
                },
                isSelected: jqlTerm === orderField || orderField && aliases.includes(orderField)
            };
            return /* @ts-expect-error - Type '{ children: string; id: string; onClick: () => void; isSelected: boolean | "" | undefined; key: string; }' is not assignable to type 'Omit<{ children: ReactNode; description?: string | Element | undefined; isDisabled?: boolean | undefined; shouldTitleWrap?: boolean | undefined; shouldDescriptionWrap?: boolean | undefined; ... 5 more ...; testId?: string | undefined; }, keyof WithAnalyticsEventsProps>'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($20c0ff6ce7988817$var$DropdownItemRadioWithAnalytics, {
                key: jqlTerm,
                ...props
            }, fieldName);
        });
    }
    render() {
        const { intl: { formatMessage: formatMessage }, orderField: orderField, isOpen: isOpen, className: className } = this.props;
        let fallbackMessage = '';
        let fieldName = '';
        if (typeof orderField === 'string') {
            const isCustomFieldId = $20c0ff6ce7988817$var$customFieldIdPattern.test(orderField);
            const expectedOrderField = (0, $iRahl.supportedOrderFields)[(0, $iRahl.getSupportedFieldForAlias)(orderField) ?? orderField];
            const fallbackMessageDescriptor = expectedOrderField ? (0, $dTg5r.messageLookup)[expectedOrderField.jqlTerm] : null;
            if (isCustomFieldId) fallbackMessage = formatMessage((0, $dTg5r.default).customField);
            else if (expectedOrderField && fallbackMessageDescriptor) fallbackMessage = formatMessage(fallbackMessageDescriptor);
            else fieldName = orderField;
        } else fallbackMessage = formatMessage((0, $dTg5r.default).defaultLabel);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($20c0ff6ce7988817$var$StyledContainer // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: className
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
            isOpen: isOpen,
            onOpenChange: this.onOpenChange,
            testId: "issue-navigator.ui.issue-results.detail-view.card-container.order-dropdown",
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($20c0ff6ce7988817$var$StyledButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                    ...props,
                    appearance: "subtle",
                    ref: triggerRef,
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
                        label: (0, $4cTDP.fg)('jfp-a11y-ai-remediation-1-1-1-g8') ? '' : formatMessage((0, $dTg5r.default).defaultLabel),
                        size: "small"
                    })
                }, fieldName || fallbackMessage)),
            shouldFlip: true,
            placement: "bottom-start",
            shouldRenderToParent: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($20c0ff6ce7988817$var$StyledDropdownMenuContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6TtH3.default), {
            id: "sort-field-group",
            title: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $dTg5r.default).fieldGroupIssueTermRefresh : (0, $dTg5r.default).fieldGroup)
        }, this.renderItems()))));
    }
    constructor(...args){
        super(...args), this.onOpenChange = ({ isOpen: isOpen } = {
            isOpen: false
        })=>{
            if (isOpen) this.props.onFocus();
            else this.props.onBlur();
        };
    }
}
const $20c0ff6ce7988817$export$f6d8103ec9453c7f = ()=>{
    const [{ isOpen: isOpen }, { open: open, close: close }] = (0, $91UnK.useOrderByOpenState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const intl = (0, $dTocu.useIntlV2)();
    const [{ field: field, direction: direction }, { setFieldAndDirection: setFieldAndDirection }] = (0, $dTsrC.useSortFieldAndDirection)();
    const handleOnChange = (0, $eJOHy.useCallback)((orderField, aliases)=>{
        setFieldAndDirection(orderField, direction, aliases);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItemRadio'
        });
        const { fieldType: fieldType = null } = (0, $iRahl.supportedOrderFields)[(0, $iRahl.getSupportedFieldForAlias)(orderField) ?? orderField] ?? {};
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'sortFieldDropdownItemRadio', {
            fieldType: fieldType,
            order: direction
        });
    }, [
        createAnalyticsEvent,
        direction,
        setFieldAndDirection
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($20c0ff6ce7988817$export$50f2c227513bcdb7, {
        orderField: field,
        onChange: handleOnChange,
        isOpen: isOpen,
        onFocus: open,
        onBlur: close,
        intl: intl
    });
};
var $20c0ff6ce7988817$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
 = $20c0ff6ce7988817$export$f6d8103ec9453c7f;
const $20c0ff6ce7988817$var$StyledButtonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1s3g12gs",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $20c0ff6ce7988817$var$StyledDropdownMenuContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3inklw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $20c0ff6ce7988817$var$StyledContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1pKTL", function(module, exports) {
$parcel$export(module.exports, "default", () => $f10c7c87bfc587de$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");

var $dQDjy = parcelRequire("dQDjy");

var $7saMl = parcelRequire("7saMl");

var $6fs4r = parcelRequire("6fs4r");

var $kQUry = parcelRequire("kQUry");

var $k3dg7 = parcelRequire("k3dg7");

var $5kbaW = parcelRequire("5kbaW");

var $igDjg = parcelRequire("igDjg");
/**
 * __Dropdown item radio__
 *
 * A dropdown item radio displays groups that have a single selection.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/usage)
 */ const $f10c7c87bfc587de$var$DropdownItemRadio = ({ children: children, defaultSelected: defaultSelected, testId: testId, id: id, title: title, description: description, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $3Vuhz.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $igDjg;
    const [selected, setSelected] = (0, $k3dg7.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $eJOHy.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $5kbaW.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dQDjy.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7saMl.default), {
                "aria-checked": selected,
                "aria-describedby": `${id}-radio`,
                description: description,
                iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kQUry.default), {
                    checked: selected
                }),
                id: id,
                isDisabled: isDisabled,
                isSelected: selected,
                onClick: onClickHandler,
                ref: itemRef,
                role: "menuitemradio",
                shouldDescriptionWrap: shouldDescriptionWrap,
                shouldTitleWrap: shouldTitleWrap,
                testId: testId,
                // Thanks to spread props, this attribute are passed to ButtonItem, even though
                // it's not in the component's prop types.
                // @ts-expect-error
                title: title,
                interactionName: interactionName,
                ...rest,
                children: children
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6fs4r.default), {
                id: `${id}-radio`,
                children: [
                    "radio button ",
                    selected
                ]
            })
        ]
    });
};
var $f10c7c87bfc587de$export$2e2bcd8739ae039 = $f10c7c87bfc587de$var$DropdownItemRadio;

});
parcelRegister("kQUry", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed10ac7e81691fb9$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $2Swhg = parcelRequire("2Swhg");

var $eGOwo = parcelRequire("eGOwo");

/**
 * __Radio icon__
 *
 * Used to visually represent the selected state in DropdownItemRadio
 *
 * @internal
 */ const $ed10ac7e81691fb9$var$RadioIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        label: "",
        size: "medium",
        primaryColor: checked ? `var(--ds-background-selected-bold, ${0, $7bb4c1736002a04a$export$b3de0ae08da2ce64})` : `var(--ds-background-input, ${0, $7bb4c1736002a04a$export$e655ef011c4aa1a2})`,
        secondaryColor: checked ? `var(--ds-icon-inverse, ${0, $7bb4c1736002a04a$export$e655ef011c4aa1a2})` : 'transparent',
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
            fillRule: "evenodd",
            children: (0, $eGOwo.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
                        cx: "12",
                        cy: "12",
                        r: "7.5",
                        fill: "currentColor",
                        stroke: checked ? `var(--ds-border-selected, ${0, $7bb4c1736002a04a$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $7bb4c1736002a04a$export$d6447c357493214f})`,
                        strokeWidth: "1"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
                        cx: "12",
                        cy: "12",
                        r: "3",
                        fill: "inherit"
                    })
                ]
            }) : /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
                        fill: "currentColor",
                        cx: "12",
                        cy: "12",
                        r: "6",
                        stroke: checked ? `var(--ds-border-selected, ${0, $7bb4c1736002a04a$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $7bb4c1736002a04a$export$d6447c357493214f})`,
                        strokeWidth: 1
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
                        fill: "inherit",
                        cx: "12",
                        cy: "12",
                        r: "2"
                    })
                ]
            })
        })
    });
};
var $ed10ac7e81691fb9$export$2e2bcd8739ae039 = $ed10ac7e81691fb9$var$RadioIcon;

});
parcelRegister("2Swhg", function(module, exports) {
$parcel$export(module.exports, "default", () => $526f6d5cb228b26e$export$2e2bcd8739ae039);
/* svg.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $526f6d5cb228b26e$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $526f6d5cb228b26e$var$svgStyles = null;
/**
 * __SVG__
 *
 * @deprecated Custom SVG is deprecated and will be removed from `atlaskit/icon` in an upcoming major release. Please use either an existing icon from @atlaskit/icon or @atlaskit/icon-lab, or contributing to @atlaskit/icon-lab directly. For third party logos, use an SVG element along with a label.
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
 */ const $526f6d5cb228b26e$var$SVG = /*#__PURE__*/ (0, $eJOHy.memo)(function SVG({ size: size = 'medium', label: label, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, testId: testId, children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fill: secondaryColor
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        "data-testid": testId,
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw _vc881r31",
            $526f6d5cb228b26e$var$sizeStyles[size]
        ]),
        children: children
    });
});
var $526f6d5cb228b26e$export$2e2bcd8739ae039 = $526f6d5cb228b26e$var$SVG;

});

var $7bb4c1736002a04a$exports = {};
$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';


parcelRegister("k3dg7", function(module, exports) {
$parcel$export(module.exports, "default", () => $b17873ad70f9fe56$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6TtH3 = parcelRequire("6TtH3");

var $cdbUz = parcelRequire("cdbUz");
function $b17873ad70f9fe56$var$useRadioState({ id: id, isSelected: isSelected, defaultSelected: defaultSelected }) {
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $eJOHy.useContext)((0, $cdbUz.SelectionStoreContext));
    const { id: group, radioGroupState: radioGroupState, selectRadioItem: selectRadioItem } = (0, $eJOHy.useContext)((0, $6TtH3.RadioGroupContext));
    const persistedIsSelected = radioGroupState[id];
    const [localIsSelected, setLocalIsSelected] = (0, $eJOHy.useState)(()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $eJOHy.useCallback)((newValue)=>{
        if (!persistedIsSelected) {
            const nextValue = newValue(persistedIsSelected);
            selectRadioItem(id, nextValue);
            setLocalIsSelected(nextValue);
        }
    }, [
        persistedIsSelected,
        id,
        selectRadioItem
    ]);
    /**
	 * - radio state changes any time a radio child is changed
	 * - when it changes we want all radio buttons to update their local state
	 * - it takes the value from radio group state and applies it locally if it exists which it will only exist, if it is selected
	 */ (0, $eJOHy.useEffect)(()=>{
        setLocalIsSelected(()=>{
            const existing = radioGroupState[id];
            return existing !== undefined ? existing : defaultSelected || false;
        });
    }, [
        radioGroupState,
        group,
        id,
        defaultSelected
    ]);
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    /**
	 * Set the initial state of the context provider's store,
	 * if it doesn't already have a persisted value for this id.
	 */ if (persistedIsSelected === undefined) {
        const existing = getGroupState(group);
        const newGroupState = {
            ...existing,
            [id]: defaultSelected || false
        };
        setGroupState(group, newGroupState);
    }
    return [
        localIsSelected,
        setLocalState
    ];
}
var $b17873ad70f9fe56$export$2e2bcd8739ae039 = $b17873ad70f9fe56$var$useRadioState;

});
parcelRegister("6TtH3", function(module, exports) {
$parcel$export(module.exports, "RadioGroupContext", () => $e70e0c2f62936089$export$a79eda4ff50e30b6);
$parcel$export(module.exports, "default", () => $e70e0c2f62936089$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");

var $gl2vi = parcelRequire("gl2vi");

var $6YEko = parcelRequire("6YEko");

var $8cNLI = parcelRequire("8cNLI");

var $cdbUz = parcelRequire("cdbUz");

var $9X4aS = parcelRequire("9X4aS");
const $e70e0c2f62936089$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    id: '',
    radioGroupState: {},
    selectRadioItem: (0, $3Vuhz.default)
});
/**
 * __Dropdown item radio group__
 *  Store which manages the selection state for each DropdownItemRadio
 *  across mount and unmounts.
 *
 */ const $e70e0c2f62936089$var$DropdownItemRadioGroup = ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, testId: testId, title: title, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $eJOHy.useContext)((0, $cdbUz.SelectionStoreContext));
    const uid = (0, $gl2vi.useId)();
    const titleId = `dropdown-menu-item-radio-group-title-${uid}`;
    /**
	 *  - initially `radioGroupState` is from selection store, so it's safe to update without re-rendering
	 *  - we flush a render by updating this local radio group state
	 */ const [radioGroupState, setRadioGroupState] = (0, $eJOHy.useState)(()=>getGroupState(id));
    const selectRadioItem = (childId, value)=>{
        const newValue = {
            ...(0, $9X4aS.default)(getGroupState(id)),
            [childId]: value
        };
        setRadioGroupState(newValue);
        setGroupState(id, newValue);
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)($e70e0c2f62936089$export$a79eda4ff50e30b6.Provider, {
        value: {
            id: id,
            radioGroupState: radioGroupState,
            selectRadioItem: selectRadioItem
        },
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6YEko.default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            testId: testId,
            titleId: title ? titleId : undefined,
            ...rest,
            children: [
                title && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8cNLI.default), {
                    id: titleId,
                    title: title
                }),
                children
            ]
        })
    });
};
var $e70e0c2f62936089$export$2e2bcd8739ae039 = $e70e0c2f62936089$var$DropdownItemRadioGroup;

});
parcelRegister("9X4aS", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7b7c26355fa18d4$export$2e2bcd8739ae039);
const $c7b7c26355fa18d4$var$resetOptionsInGroup = (group)=>{
    return Object.keys(group || {}).reduce((accumulator, current)=>({
            ...accumulator,
            [current]: typeof group[current] === 'undefined' ? undefined : false
        }), {});
};
var $c7b7c26355fa18d4$export$2e2bcd8739ae039 = $c7b7c26355fa18d4$var$resetOptionsInGroup;

});




parcelRegister("91UnK", function(module, exports) {
$parcel$export(module.exports, "useOrderByOpenState", () => $2986628a64ee2132$export$32869ae0582ab3ff);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");
const $2986628a64ee2132$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        isOpen: false
    },
    actions: {
        open: ()=>({ setState: setState })=>{
                setState({
                    isOpen: true
                });
            },
        close: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false
                });
            }
    },
    name: 'IssueNavigatorOrderByOpenState'
});
const $2986628a64ee2132$export$2ba8216bf1290828 = (0, $ht3nQ.createSubscriber)($2986628a64ee2132$var$Store);
const $2986628a64ee2132$export$32869ae0582ab3ff = (0, $iJq0l.createHook)($2986628a64ee2132$var$Store);

});

parcelRegister("dTg5r", function(module, exports) {
$parcel$export(module.exports, "default", () => $dedaaba772b36be6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "messageLookup", () => $dedaaba772b36be6$export$3a16bd55b6aaaf91);

var $7qGN1 = parcelRequire("7qGN1");
const $dedaaba772b36be6$var$messages = (0, $7qGN1.defineMessages)({
    loading: {
        "id": "issue-navigator.card-container.order-dropdown.loading",
        "defaultMessage": "Loading"
    },
    fieldGroup: {
        "id": "issue-navigator.card-container.order-dropdown.field-group",
        "defaultMessage": "Order issues by"
    },
    created: {
        "id": "issue-navigator.card-container.order-dropdown.created",
        "defaultMessage": "Created"
    },
    updated: {
        "id": "issue-navigator.card-container.order-dropdown.updated",
        "defaultMessage": "Updated"
    },
    lastviewed: {
        "id": "issue-navigator.card-container.order-dropdown.lastviewed",
        "defaultMessage": "Last viewed"
    },
    status: {
        "id": "issue-navigator.card-container.order-dropdown.status",
        "defaultMessage": "Status"
    },
    priority: {
        "id": "issue-navigator.card-container.order-dropdown.priority",
        "defaultMessage": "Priority"
    },
    assignee: {
        "id": "issue-navigator.card-container.order-dropdown.assignee",
        "defaultMessage": "Assignee"
    },
    resolved: {
        "id": "issue-navigator.card-container.order-dropdown.resolved",
        "defaultMessage": "Resolved"
    },
    issuekey: {
        "id": "issue-navigator.card-container.order-dropdown.issuekey",
        "defaultMessage": "Key"
    },
    key: {
        "id": "issue-navigator.card-container.order-dropdown.key",
        "defaultMessage": "Key"
    },
    issuetype: {
        "id": "issue-navigator.card-container.order-dropdown.issuetype",
        "defaultMessage": "Issue Type"
    },
    duedate: {
        "id": "issue-navigator.card-container.order-dropdown.duedate",
        "defaultMessage": "Due date"
    },
    summary: {
        "id": "issue-navigator.card-container.order-dropdown.summary",
        "defaultMessage": "Summary"
    },
    reporter: {
        "id": "issue-navigator.card-container.order-dropdown.reporter",
        "defaultMessage": "Reporter"
    },
    customField: {
        "id": "issue-navigator.card-container.order-dropdown.custom-field",
        "defaultMessage": "Custom field"
    },
    defaultLabel: {
        "id": "issue-navigator.card-container.order-dropdown.default-label",
        "defaultMessage": "Order by"
    },
    fieldGroupIssueTermRefresh: {
        "id": "issue-navigator.card-container.order-dropdown.field-group-issue-term-refresh",
        "defaultMessage": "Order work items by"
    },
    issuetypeIssueTermRefresh: {
        "id": "issue-navigator.card-container.order-dropdown.issuetype-issue-term-refresh",
        "defaultMessage": "Work type"
    }
});
var $dedaaba772b36be6$export$2e2bcd8739ae039 = $dedaaba772b36be6$var$messages;
const $dedaaba772b36be6$export$3a16bd55b6aaaf91 = $dedaaba772b36be6$var$messages;

});


parcelRegister("8X4cC", function(module, exports) {
$parcel$export(module.exports, "default", () => $a48f351f24839396$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $Ay1uj = parcelRequire("Ay1uj");

var $1GtTj = parcelRequire("1GtTj");

var $g48F1 = parcelRequire("g48F1");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $iRahl = parcelRequire("iRahl");

var $dTsrC = parcelRequire("dTsrC");

var $4jM8K = parcelRequire("4jM8K");
class $a48f351f24839396$export$e464399b18ba2124 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            onSort: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    shouldComponentUpdate(nextProps) {
        return this.props.sortDirection !== nextProps.sortDirection || this.props.isDisabled !== nextProps.isDisabled;
    }
    render() {
        const { intl: { formatMessage: formatMessage }, sortDirection: sortDirection, isDisabled: isDisabled } = this.props;
        const tooltipText = sortDirection === (0, $iRahl.sortDirections).ASC ? formatMessage((0, $4jM8K.default).tooltipAsc) : formatMessage((0, $4jM8K.default).tooltipDesc);
        const SortIcon = sortDirection === (0, $iRahl.sortDirections).ASC ? (0, (/*@__PURE__*/$parcel$interopDefault($1GtTj))) : (0, (/*@__PURE__*/$parcel$interopDefault($g48F1)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: tooltipText
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
            appearance: "subtle",
            onClick: this.onClick,
            testId: "issue-navigator.ui.issue-results.detail-view.card-container.sort-button.sort-button",
            isDisabled: isDisabled,
            icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SortIcon, {
                    ...props,
                    color: "currentColor"
                }),
            label: tooltipText
        }));
    }
    constructor(...args){
        super(...args), this.onClick = ()=>{
            const { onSort: onSort, sortDirection: sortDirection } = this.props;
            const newSortDirection = sortDirection === (0, $iRahl.sortDirections).ASC ? (0, $iRahl.sortDirections).DESC : (0, $iRahl.sortDirections).ASC;
            onSort(newSortDirection);
        };
    }
}
const $a48f351f24839396$export$86b24d49f595c6f2 = (props)=>{
    const intl = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ field: field, direction: direction }, { setFieldAndDirection: setFieldAndDirection }] = (0, $dTsrC.useSortFieldAndDirection)();
    const handleOnSort = (0, $eJOHy.useCallback)((newSortDirection)=>{
        typeof field === 'string' && setFieldAndDirection(field, newSortDirection, []);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const orderField = field ? (0, $iRahl.supportedOrderFields)[(0, $iRahl.getSupportedFieldForAlias)(field) ?? field] : undefined;
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'sortOrderChangeButton', {
            fieldType: orderField?.fieldType ?? null,
            sortOrder: newSortDirection
        });
        return true;
    }, [
        createAnalyticsEvent,
        field,
        setFieldAndDirection
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a48f351f24839396$export$e464399b18ba2124, {
        isDisabled: typeof field !== 'string',
        sortDirection: direction,
        onSort: handleOnSort,
        ...props,
        intl: intl
    });
};
var $a48f351f24839396$export$2e2bcd8739ae039 = $a48f351f24839396$export$86b24d49f595c6f2;

});
parcelRegister("1GtTj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61f2cd3b3ce75546535a34edc6c6a407>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $13a0e6777fbb52a1$var$_react = $13a0e6777fbb52a1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $13a0e6777fbb52a1$var$_baseNew = $13a0e6777fbb52a1$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $13a0e6777fbb52a1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SortAscending".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sorting data.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $13a0e6777fbb52a1$var$SortAscendingIcon = (props)=>/*#__PURE__*/ $13a0e6777fbb52a1$var$_react.default.createElement($13a0e6777fbb52a1$var$_baseNew.default, Object.assign({
        name: "SortAscendingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 12.5H1V14h14zm-1.75-3.75V3.56l1.72 1.72 1.06-1.06-3-3a.75.75 0 0 0-1.06 0l-3 3 1.06 1.06 1.72-1.72v5.19zM8 7.25H1v1.5h7zM6 2H1v1.5h5z" clip-rule="evenodd"/>`
    }, props));
$13a0e6777fbb52a1$var$SortAscendingIcon.displayName = 'SortAscendingIcon';
var $13a0e6777fbb52a1$var$_default = module.exports.default = $13a0e6777fbb52a1$var$SortAscendingIcon;

});

parcelRegister("g48F1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3aa40f37165b56c780c43a081b97fc51>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb23bce3061d7b5e$var$_react = $bb23bce3061d7b5e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $bb23bce3061d7b5e$var$_baseNew = $bb23bce3061d7b5e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $bb23bce3061d7b5e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SortDescending".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sorting data.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb23bce3061d7b5e$var$SortDescendingIcon = (props)=>/*#__PURE__*/ $bb23bce3061d7b5e$var$_react.default.createElement($bb23bce3061d7b5e$var$_baseNew.default, Object.assign({
        name: "SortDescendingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-1.75 3.75v5.19l1.72-1.72 1.06 1.06-3 3a.75.75 0 0 1-1.06 0l-3-3 1.06-1.06 1.72 1.72V7.25zM8 8.75H1v-1.5h7zM6 14H1v-1.5h5z" clip-rule="evenodd"/>`
    }, props));
$bb23bce3061d7b5e$var$SortDescendingIcon.displayName = 'SortDescendingIcon';
var $bb23bce3061d7b5e$var$_default = module.exports.default = $bb23bce3061d7b5e$var$SortDescendingIcon;

});

parcelRegister("4jM8K", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c7a5e017ecb67e6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $5c7a5e017ecb67e6$var$messages = (0, $7qGN1.defineMessages)({
    tooltipAsc: {
        "id": "issue-navigator.card-container.sort-button.tooltip-asc",
        "defaultMessage": "Sort ascending"
    },
    tooltipDesc: {
        "id": "issue-navigator.card-container.sort-button.tooltip-desc",
        "defaultMessage": "Sort descending"
    }
});
var $5c7a5e017ecb67e6$export$2e2bcd8739ae039 = $5c7a5e017ecb67e6$var$messages;

});



parcelRegister("2Jpfu", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad8de669773f4513$export$2e2bcd8739ae039);

var $3x2JR = parcelRequire("3x2JR");

var $f4Gqq = parcelRequire("f4Gqq");

var $3b3PS = parcelRequire("3b3PS");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $iRahl = parcelRequire("iRahl");

var $eibCx = parcelRequire("eibCx");

var $fAgUF = parcelRequire("fAgUF");

var $1wL9i = parcelRequire("1wL9i");

var $ahkvg = parcelRequire("ahkvg");

var $2nPlv = parcelRequire("2nPlv");

var $hvJLL = parcelRequire("hvJLL");

var $42ws0 = parcelRequire("42ws0");

var $3KwXP = parcelRequire("3KwXP");

var $1Gp6c = parcelRequire("1Gp6c");
const $ad8de669773f4513$var$BLANK_CARD_ANALYTICS_ID = 'blankIssueCard';
const $ad8de669773f4513$var$ISSUE_CARD_ANALYTICS_ID = 'issueCard';
const $ad8de669773f4513$var$CardWithSelectedIssue = ({ issue: issue, fieldSets: fieldSets, isFocused: isFocused, onFocus: onFocus, onBlur: onBlur })=>{
    const issueData = (0, $j4oe4.useFragment)((0, $3b3PS.default), issue);
    const fieldSetsData = (0, $j4oe4.useFragment)((0, $f4Gqq.default), fieldSets);
    const { key: key } = issueData;
    const isSelected = (0, $1wL9i.useIsSelectedIssue)(key);
    const { setSelectedIssueByKey: setSelectedIssueByKey } = (0, $1wL9i.useSelectedIssueActions)();
    const onCardFocus = (0, $eJOHy.useCallback)(()=>{
        onFocus(key);
        setSelectedIssueByKey(key, {
            shouldDebounce: true
        });
    }, [
        key,
        onFocus,
        setSelectedIssueByKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad8de669773f4513$var$CardWithAnalytics, {
        issue: issueData,
        fieldSets: fieldSetsData ?? null,
        isFocused: isFocused,
        isSelected: isSelected,
        onFocus: onCardFocus,
        onBlur: onBlur
    });
};
const $ad8de669773f4513$var$CardWithAnalytics = ({ isFocused: isFocused, isSelected: isSelected, issue: issue, fieldSets: fieldSets, onFocus: onFocus, onBlur: onBlur })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const cardRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (isSelected) {
            // Scroll to the card whenever it is selected and focus on it
            cardRef.current?.scrollIntoView && cardRef.current?.scrollIntoView({
                block: 'nearest'
            });
            isFocused && cardRef.current?.focus();
        }
    }, [
        isSelected,
        isFocused
    ]);
    const onClickWithAnalytics = (0, $eJOHy.useCallback)((event)=>{
        const id = issue ? $ad8de669773f4513$var$ISSUE_CARD_ANALYTICS_ID : $ad8de669773f4513$var$BLANK_CARD_ANALYTICS_ID;
        const attributes = {
            keyboardShortcut: false
        };
        if ((0, $eibCx.isNormalClick)(event)) {
            event.preventDefault();
            const analyticsEvent = createAnalyticsEvent({
                action: 'selected',
                actionSubject: 'card'
            });
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, id, attributes);
        } else {
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'card'
            });
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, id, attributes);
        }
    }, [
        createAnalyticsEvent,
        issue
    ]);
    const onContextMenuHandler = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'contextMenu clicked',
            actionSubject: 'card'
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, $ad8de669773f4513$var$ISSUE_CARD_ANALYTICS_ID, {
            keyboardShortcut: false
        });
    }, [
        createAnalyticsEvent
    ]);
    return issue == null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hvJLL.default), {
        ref: cardRef,
        isSelected: isSelected,
        onClick: onClickWithAnalytics,
        onFocus: onFocus
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $42ws0.default), {
        ref: cardRef,
        issue: issue,
        fieldSets: fieldSets,
        onClick: onClickWithAnalytics,
        onFocus: onFocus,
        onBlur: onBlur,
        isSelected: isSelected,
        onContextMenu: onContextMenuHandler
    });
};
const $ad8de669773f4513$export$4683131014ccb7f3 = ()=>(0, $eJOHy.useState)(null);
const $ad8de669773f4513$var$CardList = ({ fragment: fragment, loading: loading, onNavigateToIssue: onNavigateToIssue, listRef: listRef })=>{
    (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_START); // Analytics
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)(); // Main
    const [focusedIssueKey, setFocusedIssueKey] = $ad8de669773f4513$export$4683131014ccb7f3();
    const maxIssuesPerPage = (0, $iRahl.getMaxIssuesPerPage)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_END);
    }, []);
    const fragmentData = (0, $j4oe4.useFragment)((0, $3x2JR.default), fragment);
    const onIssueChangeEvent = (0, $eJOHy.useCallback)((issueKey)=>{
        if (issueKey) setFocusedIssueKey(issueKey);
        const id = issueKey ? $ad8de669773f4513$var$ISSUE_CARD_ANALYTICS_ID : $ad8de669773f4513$var$BLANK_CARD_ANALYTICS_ID;
        const analyticsEvent = createAnalyticsEvent({
            action: 'selected',
            actionSubject: 'card'
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, id, {
            keyboardShortcut: true
        });
    }, [
        createAnalyticsEvent,
        setFocusedIssueKey
    ]);
    const cards = (0, $eJOHy.useMemo)(()=>fragmentData?.edges?.map((edge)=>edge?.node && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad8de669773f4513$var$CardWithSelectedIssue, {
                key: edge.node.key,
                isFocused: edge.node.key === focusedIssueKey,
                issue: edge.node,
                fieldSets: edge.fieldSets ?? null,
                onFocus: setFocusedIssueKey,
                onBlur: ()=>setFocusedIssueKey(null)
            })) ?? [], [
        fragmentData?.edges,
        focusedIssueKey,
        setFocusedIssueKey
    ]);
    const focusedIssue = (0, $eJOHy.useMemo)(()=>{
        if ((0, $cxKOj.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return fragmentData?.edges?.find((edge)=>edge?.node?.key === focusedIssueKey)?.node ?? null;
        return null;
    }, [
        focusedIssueKey,
        fragmentData?.edges
    ]);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad8de669773f4513$export$22a81bdd3a723b46, {
        "aria-label": formatMessage((0, $1Gp6c.default).issues)
    }, [
        ...Array(maxIssuesPerPage)
    ].map((__, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2nPlv.default), {
            key: index,
            issueIndex: index
        })));
    if (cards.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ahkvg.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3KwXP.default), {
        focusedIssueKey: focusedIssueKey,
        onIssueChangeEvent: onIssueChangeEvent,
        onNavigateToIssue: onNavigateToIssue,
        disableListControls: loading,
        focusedIssue: focusedIssue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad8de669773f4513$export$22a81bdd3a723b46, {
        ref: listRef,
        "aria-label": formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1Gp6c.default).issuesIssueTermRefresh : (0, $1Gp6c.default).issues)
    }, cards));
};
var $ad8de669773f4513$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $ad8de669773f4513$var$CardList;
const $ad8de669773f4513$export$22a81bdd3a723b46 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_qtt8glyw _19bvidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3x2JR", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38df14b7d06e11e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<91a26a6ac2094feef90cf1527c78a5ec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b38df14b7d06e11e$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_CardList_fragment",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_Card_issue"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_CardWithSelectedIssue_issue"
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "keyboardShortcuts_issueNavigator"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 500
                        }
                    ],
                    "concreteType": "JiraIssueFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSets",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_Card_fieldSets"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_CardWithSelectedIssue_fieldSets"
                        }
                    ],
                    "storageKey": "fieldSets(first:500)"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$b38df14b7d06e11e$var$node.hash = "c325676a12fa6072040143369b5cb3e8";
var $b38df14b7d06e11e$export$2e2bcd8739ae039 = $b38df14b7d06e11e$var$node;

});

parcelRegister("f4Gqq", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa000e624d8bb5b4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<624714bc7d64cade4aaede35e606ffae>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fa000e624d8bb5b4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_CardWithSelectedIssue_fieldSets",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_Card_fieldSets"
        }
    ],
    "type": "JiraIssueFieldSetConnection"
};
$fa000e624d8bb5b4$var$node.hash = "5d80b931b560f2c418fca0d9f032c9a0";
var $fa000e624d8bb5b4$export$2e2bcd8739ae039 = $fa000e624d8bb5b4$var$node;

});

parcelRegister("3b3PS", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae74f3b8d3342f75$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ef67c1b29917e04b29ae418c9bcc3e9d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ae74f3b8d3342f75$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_CardWithSelectedIssue_issue",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_Card_issue"
        }
    ],
    "type": "JiraIssue"
};
$ae74f3b8d3342f75$var$node.hash = "8eb4cdf2fd848d8fc193cb41d7f7d67f";
var $ae74f3b8d3342f75$export$2e2bcd8739ae039 = $ae74f3b8d3342f75$var$node;

});

parcelRegister("ahkvg", function(module, exports) {
$parcel$export(module.exports, "default", () => $8019a59b70b3caca$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gS02k = parcelRequire("gS02k");
const $8019a59b70b3caca$export$36d139f95680ab4e = ()=>// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8019a59b70b3caca$var$StyledContainer, {
        "data-testid": "issue-navigator.issue-results.detail-view.card-list.card-empty-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gS02k.default), null));
var $8019a59b70b3caca$export$2e2bcd8739ae039 = $8019a59b70b3caca$export$36d139f95680ab4e;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8019a59b70b3caca$var$StyledContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o _4t3i1osq _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gS02k", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e6ac68d670762ec$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $cxKOj = parcelRequire("cxKOj");

var $kKCMK = parcelRequire("kKCMK");

var $idGBm = parcelRequire("idGBm");

var $a2bEL = parcelRequire("a2bEL");
const $9e6ac68d670762ec$export$f3f2e7ed2b6256b1 = ({ intl: { formatMessage: formatMessage } })=>{
    const noIssues = formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $a2bEL.default).noIssuesIssueTermRefresh : (0, $a2bEL.default).noIssues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9e6ac68d670762ec$var$ImageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kKCMK.default), {
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, noIssues));
};
var /* eslint-disable-next-line jira/js/no-inject-intl-if-functional-component */ $9e6ac68d670762ec$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($9e6ac68d670762ec$export$f3f2e7ed2b6256b1);
const $9e6ac68d670762ec$var$ImageWrapperStyles = (0, $1DXK0.xcss)({
    height: '165px',
    width: '150px'
});

});
parcelRegister("a2bEL", function(module, exports) {
$parcel$export(module.exports, "default", () => $d80e5c8b576dbb4b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d80e5c8b576dbb4b$var$messages = (0, $7qGN1.defineMessages)({
    noIssues: {
        "id": "issue-navigator.common.empty-list-icon.no-issues",
        "defaultMessage": "No issues were found matching your search"
    },
    noIssuesIssueTermRefresh: {
        "id": "issue-navigator.common.empty-list-icon.no-issues-issue-term-refresh",
        "defaultMessage": "There's nothing matching your search"
    }
});
var $d80e5c8b576dbb4b$export$2e2bcd8739ae039 = $d80e5c8b576dbb4b$var$messages;

});



parcelRegister("2nPlv", function(module, exports) {
$parcel$export(module.exports, "default", () => $4961dd20e06734be$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $80DPg = parcelRequire("80DPg");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");

var $OrRUJ = parcelRequire("OrRUJ");

var $1vRb5 = parcelRequire("1vRb5");

var $7kd9e = parcelRequire("7kd9e");

var $ezozv = parcelRequire("ezozv");
const $4961dd20e06734be$var$shimmer = null;
// eslint-disable-next-line jira/styled/styled-component-order, @atlaskit/ui-styling-standard/no-styled
const $4961dd20e06734be$var$SkeletonBackground = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasError: hasError, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_5sag126j _1o51q7pw _j7hq1en8 _1pglp3kn _bfhkvkf5 _1itk7tku _12vemgnk _kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf",
            __cmplp.hasError ? "_tip8idpf" : "_tip812c5",
            __cmplp.className
        ])
    });
});
const $4961dd20e06734be$var$defaultIssueCardHeight = 97; // eslint-disable-next-line jira/styled/styled-component-order, @atlaskit/ui-styling-standard/no-styled
const $4961dd20e06734be$var$SkeletonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1rbs _1e0c1txw _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $4961dd20e06734be$var$IssueCardSkeleton = ({ hasError: hasError = false, issueIndex: issueIndex })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "li",
        xcss: $4961dd20e06734be$var$ListItemStyle,
        "aria-label": formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $7kd9e.default).issueLoadingLabelIssueTermRefresh : (0, $7kd9e.default).issueLoadingLabel, {
            number: issueIndex
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$CardContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$SkeletonBackground, {
        hasError: hasError,
        "data-component-selector": (0, $ezozv.skeletonBackgroundSelector)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$ColumnMask, {
        "data-component-selector": (0, $ezozv.columnMaskSelector)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$SummaryMask, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$TextLineMask, {
        fontSize: 20,
        lineHeight: 24,
        intrusion: 20
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$TextLineMask, {
        fontSize: 20,
        lineHeight: 24,
        intrusion: 60
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$FooterMask, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$TypeMask, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$SeparatorMask, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$IssueKeyMask, null), hasError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$ErrorIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        spacing: "spacious",
        color: "var(--ds-icon-danger, #C9372C)",
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$BlankMask, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$ErrorWrapper, {
        "data-component-selector": (0, $ezozv.errorWrapperSelector)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1vRb5.default), null)))));
};
var $4961dd20e06734be$export$2e2bcd8739ae039 = $4961dd20e06734be$var$IssueCardSkeleton;
const $4961dd20e06734be$var$ListItemStyle = (0, $1DXK0.xcss)({
    marginBlockStart: 'space.0',
    marginBlockEnd: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4961dd20e06734be$var$CardContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $OrRUJ.CardBaseStyle), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4961dd20e06734be$var$ErrorWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0cglyw _1bsb1osq _4cvr1h6o _18u0u2gc _2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4961dd20e06734be$var$ErrorIconContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_bfhkvuon _16jlkb7n _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4961dd20e06734be$var$BlankMask = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _bfhkvuon _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4961dd20e06734be$var$SeparatorMask = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbftgi _bfhkvuon",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4961dd20e06734be$var$IssueKeyMask = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _4t3i1tcg _1bsb16xz",
            __cmplp.className
        ])
    });
});
const $4961dd20e06734be$var$TypeMask = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _4t3i1tcg _1bsb1tcg _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $4961dd20e06734be$var$TextLineMask = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { intrusion: intrusion, lineHeight: lineHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_rjhebn": (0, $awdRS.default)(__cmplp.fontSize, "px"),
            "--_1oqupad": (0, $awdRS.default)(__cmplp.intrusion, "px"),
            "--_c633pi": (0, $awdRS.default)((__cmplp.lineHeight - __cmplp.fontSize) / 2, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1s7z87mc _x3do1cy7 _n7zl1cy7 _kqswh2mm _4t3i3gti",
            __cmplp.className
        ])
    });
});
const $4961dd20e06734be$var$FooterMask = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_n7zl1ps9 _x3do16sd _1e0c1txw _2lx2vrvc _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $4961dd20e06734be$var$SummaryMask = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_n7zl15mc",
            __cmplp.className
        ])
    });
});
const $4961dd20e06734be$var$ColumnMask = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1kl715mc _1s7z15mc _kqswh2mm _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("OrRUJ", function(module, exports) {
$parcel$export(module.exports, "CardBaseStyle", () => $1893a6410747b475$export$d10d52f6c0613cc3);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $3LCex = parcelRequire("3LCex");
const $1893a6410747b475$export$d10d52f6c0613cc3 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_17wxfjt": (0, $awdRS.default)(__cmplp.isSelected ? "var(--ds-background-accent-blue-subtlest, #E9F2FE)" : "var(--ds-surface-raised, #FFFFFF)")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko12b0 _1e0c1ule _1q51utpp _85i5utpp _bozgutpp _y4tiutpp _vchhusvi _16qst7xp _1pfhv77o _6rthv77o _ahbqv77o _12l2v77o _bfhkt1hr _1a3b18uv _4fprglyw _5goinqa1 _nt751r31 _49pcglyw _1hvw1o36 _7ehiksal _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $1893a6410747b475$export$b15a6cf2987e4b39 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $3LCex.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1vRb5", function(module, exports) {
$parcel$export(module.exports, "default", () => $fcbea75727fe8bd3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $goZPP = parcelRequire("goZPP");

var $cxKOj = parcelRequire("cxKOj");

var $idGBm = parcelRequire("idGBm");

var $iMWU7 = parcelRequire("iMWU7");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-empty-styled-expression
const $fcbea75727fe8bd3$var$InfoMessage = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.className
        ])
    });
});
const $fcbea75727fe8bd3$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1kw7 _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
class $fcbea75727fe8bd3$export$e8132eb38e030ec6 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            onResetErrors: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    render() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fcbea75727fe8bd3$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fcbea75727fe8bd3$var$InfoMessage, null, formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iMWU7.default).infoTextIssueTermRefresh : (0, $iMWU7.default).infoText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "link",
            onClick: this.onReloadIssueClick,
            spacing: "none"
        }, formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iMWU7.default).reloadIssueIssueTermRefresh : (0, $iMWU7.default).reloadIssue)));
    }
    constructor(...args){
        super(...args), // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onReloadIssueClick = (...attrs)=>{
            const analyticsEvent = attrs.pop();
            this.props.onResetErrors(analyticsEvent);
        };
    }
}
var $fcbea75727fe8bd3$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($fcbea75727fe8bd3$export$e8132eb38e030ec6);

});
parcelRegister("iMWU7", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bd31243763fa77e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $2bd31243763fa77e$var$messages = (0, $7qGN1.defineMessages)({
    infoText: {
        "id": "issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.info-text",
        "defaultMessage": "We couldn't load this issue."
    },
    reloadIssue: {
        "id": "issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.reload-issue",
        "defaultMessage": "Reload issue"
    },
    infoTextIssueTermRefresh: {
        "id": "issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.info-text-issue-term-refresh",
        "defaultMessage": "We couldn't load this work item."
    },
    reloadIssueIssueTermRefresh: {
        "id": "issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.reload-issue-issue-term-refresh",
        "defaultMessage": "Reload work item"
    }
});
var $2bd31243763fa77e$export$2e2bcd8739ae039 = $2bd31243763fa77e$var$messages;

});


parcelRegister("7kd9e", function(module, exports) {
$parcel$export(module.exports, "default", () => $8839731a5f0f0b99$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $8839731a5f0f0b99$var$messages = (0, $7qGN1.defineMessages)({
    issueLoadingLabel: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card-skeleton.issue-loading-label",
        "defaultMessage": "Issue card {number} loading"
    },
    issueLoadingLabelIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card-skeleton.issue-loading-label-issue-term-refresh",
        "defaultMessage": "Work item card {number} loading"
    }
});
var $8839731a5f0f0b99$export$2e2bcd8739ae039 = $8839731a5f0f0b99$var$messages;

});

parcelRegister("ezozv", function(module, exports) {
$parcel$export(module.exports, "errorWrapperSelector", () => $d2d6f5b7a758abdd$export$a03455d77d6a4ea);
$parcel$export(module.exports, "skeletonBackgroundSelector", () => $d2d6f5b7a758abdd$export$85fe8f1edff78b98);
$parcel$export(module.exports, "columnMaskSelector", () => $d2d6f5b7a758abdd$export$67b279fb398d016e);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $d2d6f5b7a758abdd$var$defaultIssueCardHeight = 97;
const $d2d6f5b7a758abdd$export$66b8cea0c448285 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1rbs _1e0c1txw _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $d2d6f5b7a758abdd$var$shimmer = null;
const $d2d6f5b7a758abdd$export$c3b0ebed856b8b1a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasError: hasError, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_5sag126j _1o51q7pw _j7hq1en8 _1pglp3kn _bfhkvkf5 _1itk7tku _12vemgnk _kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf",
            __cmplp.hasError ? "_tip8idpf" : "_tip812c5",
            __cmplp.className
        ])
    });
});
const $d2d6f5b7a758abdd$export$439b7c87164a9b43 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1kl715mc _1s7z15mc _kqswh2mm _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $d2d6f5b7a758abdd$export$792e72b41c80f830 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_n7zl15mc",
            __cmplp.className
        ])
    });
});
const $d2d6f5b7a758abdd$export$ab3fe3ddc5c7354f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_n7zl1ps9 _x3do16sd _1e0c1txw _2lx2vrvc _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $d2d6f5b7a758abdd$export$f3e0fd2d5209f88b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { intrusion: intrusion, lineHeight: lineHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_rjhebn": (0, $awdRS.default)(__cmplp.fontSize, "px"),
            "--_1oqupad": (0, $awdRS.default)(__cmplp.intrusion, "px"),
            "--_c633pi": (0, $awdRS.default)((__cmplp.lineHeight - __cmplp.fontSize) / 2, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1s7z87mc _x3do1cy7 _n7zl1cy7 _kqswh2mm _4t3i3gti",
            __cmplp.className
        ])
    });
});
const $d2d6f5b7a758abdd$export$59d16c2cd3bc3a2 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _4t3i1tcg _1bsb1tcg _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $d2d6f5b7a758abdd$export$ca1c048394ed3dbb = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _4t3i1tcg _1bsb16xz",
            __cmplp.className
        ])
    });
});
const $d2d6f5b7a758abdd$export$bdc7d72765b181c3 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbftgi _bfhkvuon",
            __cmplp.className
        ])
    });
});
const $d2d6f5b7a758abdd$export$a1b9063b4cbc0844 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _bfhkvuon _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});
const $d2d6f5b7a758abdd$export$90993d2d9550d725 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_bfhkvuon _16jlkb7n _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});
const $d2d6f5b7a758abdd$export$bb27b7e39840238f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0cglyw _1bsb1osq _4cvr1h6o _18u0u2gc _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $d2d6f5b7a758abdd$export$a03455d77d6a4ea = 'jira-issue-navigator-card-skeleton-error-wrapper';
const $d2d6f5b7a758abdd$export$85fe8f1edff78b98 = 'jira-issue-navigator-card-skeleton-skeleton-background';
const $d2d6f5b7a758abdd$export$67b279fb398d016e = 'jira-issue-navigator-card-skeleton-column-mask';

});


parcelRegister("hvJLL", function(module, exports) {
$parcel$export(module.exports, "default", () => $295f831da4c8a82d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $eS29z = parcelRequire("eS29z");

var $OrRUJ = parcelRequire("OrRUJ");

var $jGquF = parcelRequire("jGquF");
const $295f831da4c8a82d$var$EmptyCard = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isSelected: isSelected = false, onClick: onClick, onFocus: onFocus }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "li",
        xcss: $295f831da4c8a82d$var$ListItemStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($295f831da4c8a82d$var$EmptyCardContainer, {
        tabIndex: isSelected ? 0 : -1,
        ref: ref ?? undefined,
        isSelected: isSelected,
        onClick: onClick,
        href: "#",
        onFocus: onFocus
    }, formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jGquF.default).emptyCardTextIssueTermRefresh : (0, $jGquF.default).emptyCardText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "blankIssue"
    })));
});
var $295f831da4c8a82d$export$2e2bcd8739ae039 = $295f831da4c8a82d$var$EmptyCard;
const $295f831da4c8a82d$var$textColorActiveState = "var(--ds-text-selected, #1868DB)";
const $295f831da4c8a82d$var$textColor = "var(--ds-text, #292A2E)"; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $295f831da4c8a82d$var$EmptyCardContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $OrRUJ.CardBaseStyle), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81o8v _80omtlke",
            __cmplp.isSelected ? "_syaz6x5g" : "_syazi7uo",
            __cmplp.isSelected ? "_f8pj6x5g _30l36x5g" : "_f8pji7uo _30l3i7uo",
            __cmplp.className
        ])
    });
});
const $295f831da4c8a82d$var$ListItemStyle = (0, $1DXK0.xcss)({
    marginBlockStart: 'space.0'
});

});
parcelRegister("jGquF", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6d48f93b7036221$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $f6d48f93b7036221$var$messages = (0, $7qGN1.defineMessages)({
    blankText: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.blank-text",
        "defaultMessage": "We can't display this issue"
    },
    emptyCardText: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.empty-card-text",
        "defaultMessage": "This issue cannot be opened because it may have been deleted or you do not have access to it"
    },
    tooltip: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.tooltip",
        "defaultMessage": "Either this issue has been deleted, or you don\u2019t have access to it."
    },
    blankTextIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.blank-text-issue-term-refresh",
        "defaultMessage": "We can't display this work item"
    },
    emptyCardTextIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.empty-card-text-issue-term-refresh",
        "defaultMessage": "This work item cannot be opened because it may have been deleted or you do not have access to it"
    },
    tooltipIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.tooltip-issue-term-refresh",
        "defaultMessage": "Either this work item has been deleted, or you don\u2019t have access to it."
    }
});
var $f6d48f93b7036221$export$2e2bcd8739ae039 = $f6d48f93b7036221$var$messages;

});


parcelRegister("42ws0", function(module, exports) {
$parcel$export(module.exports, "default", () => $763439f866532d4e$export$2e2bcd8739ae039);

var $jg6lT = parcelRequire("jg6lT");

var $eK0sf = parcelRequire("eK0sf");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $OrRUJ = parcelRequire("OrRUJ");

var $2xt4x = parcelRequire("2xt4x");
const $763439f866532d4e$var$backgroundColorSelected = "var(--ds-background-selected, #E9F2FE)";
const $763439f866532d4e$var$backgroundColorHovered = "var(--ds-background-neutral-subtle-hovered, #0515240F)"; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $763439f866532d4e$var$StyledListElement = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _otyr1b66",
            __cmplp.className
        ])
    });
});
const $763439f866532d4e$export$1d41361302b577a1 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $OrRUJ.CardBaseStyle), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _f8pj1kw7 _30l31kw7",
            __cmplp.isSelected ? "_syaz6x5g" : "_syaz1kw7",
            __cmplp.isSelected ? "_irr315s3" : "_irr31dpa",
            __cmplp.className
        ])
    });
});
const $763439f866532d4e$export$c3fc4c88db352deb = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_slp31hna _1i4q1hna _1nmz1hna _otyru2gc",
            __cmplp.className
        ])
    });
});
const $763439f866532d4e$var$Card = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ style: style, onMounted: onMounted, onClick: onClick, onFocus: onFocus, onBlur: onBlur, issue: issue, fieldSets: fieldSetsFragment, isSelected: isSelected, onContextMenu: onContextMenu }, ref)=>{
    const fragmentData = (0, $j4oe4.useFragment)((0, $eK0sf.default), issue);
    const fieldSets = fieldSetsFragment;
    const fieldSetsData = (0, $j4oe4.useFragment)((0, $jg6lT.default), fieldSets);
    const issueKey = fragmentData.key; // eslint-disable-next-line react-you-might-not-need-an-effect/no-manage-parent
    (0, $eJOHy.useEffect)(()=>{
        onMounted && onMounted();
    }, [
        onMounted
    ]);
    const fieldEdges = fieldSetsData?.edges ?? null;
    const summary = (0, $2xt4x.byFieldId)(fieldEdges, 'summary', (summaryEdge)=>summaryEdge?.node?.text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($763439f866532d4e$var$StyledListElement, {
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-list.card.list-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($763439f866532d4e$export$1d41361302b577a1 // @ts-expect-error incorrect ref type
    , {
        ref: ref ?? undefined,
        onContextMenu: onContextMenu,
        isSelected: isSelected,
        onBlur: onBlur,
        tabIndex: isSelected ? 0 : -1,
        onClick: onClick,
        onFocus: onFocus,
        style: style,
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-list.card",
        href: `/browse/${issueKey}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($763439f866532d4e$export$c3fc4c88db352deb, {
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-list.card.summary"
    }, summary), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2xt4x.Footer), {
        issueKey: issueKey,
        isResolved: fragmentData.isResolved,
        fieldSets: fieldSetsData ?? null,
        isSelected: isSelected
    })));
});
var $763439f866532d4e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($763439f866532d4e$var$Card);

});
parcelRegister("jg6lT", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ec0f2b0c3c7c721$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<665198baf0f9c2c411158353f00d7520>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2ec0f2b0c3c7c721$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_Card_fieldSets",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "footer_issueNavigator_FooterInternal"
        },
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fieldId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "text"
                                                        }
                                                    ],
                                                    "type": "JiraSingleLineTextField"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueFieldSetConnection"
};
$2ec0f2b0c3c7c721$var$node.hash = "606cafbbef903d4ec28da2ea50226fe2";
var $2ec0f2b0c3c7c721$export$2e2bcd8739ae039 = $2ec0f2b0c3c7c721$var$node;

});

parcelRegister("eK0sf", function(module, exports) {
$parcel$export(module.exports, "default", () => $b54f0a3afdabdeb4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9095b5dd69b4238d53bbc2293313a78a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b54f0a3afdabdeb4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_Card_issue",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        },
        {
            "kind": "ScalarField",
            "name": "isResolved"
        }
    ],
    "type": "JiraIssue"
};
$b54f0a3afdabdeb4$var$node.hash = "e3f34b125801c49c601cb9bbb61a7a14";
var $b54f0a3afdabdeb4$export$2e2bcd8739ae039 = $b54f0a3afdabdeb4$var$node;

});

parcelRegister("2xt4x", function(module, exports) {
$parcel$export(module.exports, "byFieldId", () => $3bf34cae533b6687$export$7a6e1e67b4eca178);
$parcel$export(module.exports, "Footer", () => $3bf34cae533b6687$export$a06f1c675e846f6f);

var $k9j69 = parcelRequire("k9j69");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $jx0Vw = parcelRequire("jx0Vw");

var $5DgXR = parcelRequire("5DgXR");

var $k71qx = parcelRequire("k71qx");

var $ktHCr = parcelRequire("ktHCr");

var $9cbmy = parcelRequire("9cbmy");

var $4cTDP = parcelRequire("4cTDP");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $jCEKQ = parcelRequire("jCEKQ");

var $eibCx = parcelRequire("eibCx");

var $aIyl4 = parcelRequire("aIyl4");
const $3bf34cae533b6687$export$7a6e1e67b4eca178 = (edges, fieldId, mapperFn)=>edges?.map((edge)=>edge?.node?.fields?.edges?.[0]).filter((edge)=>edge?.node?.fieldId === fieldId).filter((0, $eibCx.isNonNullish)).map(mapperFn)[0];
const $3bf34cae533b6687$var$FooterInternal = ({ issueKey: issueKey, isResolved: isResolvedProp, isSelected: isSelected, fieldSets: fieldSets })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const fieldSetsData = (0, $j4oe4.useFragment)((0, $k9j69.default), fieldSets);
    const fieldSetEdges = fieldSetsData?.edges;
    const assignee = $3bf34cae533b6687$export$7a6e1e67b4eca178(fieldSetEdges, 'assignee', (assigneeEdge)=>assigneeEdge?.node?.user);
    const issueType = $3bf34cae533b6687$export$7a6e1e67b4eca178(fieldSetEdges, 'issuetype', (issueTypeEdge)=>issueTypeEdge?.node?.issueType);
    const statusCategoryId = $3bf34cae533b6687$export$7a6e1e67b4eca178(fieldSetEdges, 'statusCategory', (statusCategoryEdge)=>statusCategoryEdge?.node?.statusCategory?.statusCategoryId);
    const isResolved = (0, $jCEKQ.shouldDisplayStrikethrough)(isResolvedProp ?? undefined, (0, $jx0Vw.statusCategoryForId)(statusCategoryId));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3bf34cae533b6687$var$StyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3bf34cae533b6687$var$TypeIcon, {
        src: issueType?.avatar?.small ?? undefined,
        alt: issueType?.name ?? undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3bf34cae533b6687$export$263c092b561e7355, {
        isSelected: isSelected,
        isResolved: isResolved
    }, issueKey, isResolved && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), {
        role: "status"
    }, formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $aIyl4.default).screenReaderFooterKeyResolvedIssueTermRefresh : (0, $aIyl4.default).screenReaderFooterKeyResolved, {
        issueKey: issueKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3bf34cae533b6687$var$AvatarStyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: assignee?.name
    }, (0, $4cTDP.fg)('jira_ai_agent_avatar_single_user_picker_nin') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ktHCr.AvatarRelay), {
        userFragment: assignee ?? null,
        name: assignee?.name ?? '',
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        src: assignee?.picture,
        name: assignee?.name,
        size: "small"
    }))));
};
const $3bf34cae533b6687$export$a06f1c675e846f6f = /*#__PURE__*/ (0, $eJOHy.memo)($3bf34cae533b6687$var$FooterInternal); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3bf34cae533b6687$var$StyledContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3bf34cae533b6687$var$TypeIcon = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkolb4i _1bsb7vkz _4t3i7vkz _2hwx1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3bf34cae533b6687$var$AvatarStyledContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1f4h _19bvu2gc _18u01wug _80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3bf34cae533b6687$export$263c092b561e7355 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, isResolved: isResolved, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _kqswh2mm _k48p1wq8",
            __cmplp.isSelected ? "_syaz6x5g" : "_syazazsu",
            __cmplp.isResolved ? "_4bfu18uv _1hms1911 _ajmmnqa1" : "_4bfu18uv _1hmsglyw _ajmmnqa1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("k9j69", function(module, exports) {
$parcel$export(module.exports, "default", () => $65bbfd837387c60e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6b707b9118724cbec18a2f2a8b89c699>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $65bbfd837387c60e$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider"
            }
        ],
        "kind": "Fragment",
        "name": "footer_issueNavigator_FooterInternal",
        "selections": [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "text"
                                                            }
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            v1 /*: any*/ ,
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "user",
                                                                "plural": false,
                                                                "selections": [
                                                                    v1 /*: any*/ ,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "picture"
                                                                    },
                                                                    {
                                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider",
                                                                        "kind": "Condition",
                                                                        "passingValue": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "FragmentSpread",
                                                                                "name": "avatarRelay_user"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectUserPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    v1 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraAvatar",
                                                                        "kind": "LinkedField",
                                                                        "name": "avatar",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "small"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraStatusCategory",
                                                                "kind": "LinkedField",
                                                                "name": "statusCategory",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "statusCategoryId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusCategoryField"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$65bbfd837387c60e$var$node.hash = "f1c5049954d01e29536045c28278d105";
var $65bbfd837387c60e$export$2e2bcd8739ae039 = $65bbfd837387c60e$var$node;

});

parcelRegister("jx0Vw", function(module, exports) {
$parcel$export(module.exports, "UNDEFINED", () => $89523e1d4dcff547$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $89523e1d4dcff547$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $89523e1d4dcff547$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $89523e1d4dcff547$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $89523e1d4dcff547$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $89523e1d4dcff547$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $89523e1d4dcff547$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $89523e1d4dcff547$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $89523e1d4dcff547$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $89523e1d4dcff547$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $89523e1d4dcff547$export$d928f247c903643a);
const $89523e1d4dcff547$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $89523e1d4dcff547$export$aa456a5030160740 = 'TODO';
const $89523e1d4dcff547$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $89523e1d4dcff547$export$71efb3495f6084f2 = 'DONE';
const $89523e1d4dcff547$export$d9119300f9d9a815 = [
    $89523e1d4dcff547$export$6db089fe7b26f5b6,
    $89523e1d4dcff547$export$aa456a5030160740,
    $89523e1d4dcff547$export$5a9ac66c2785cc13,
    $89523e1d4dcff547$export$71efb3495f6084f2
];
const $89523e1d4dcff547$var$statusCategories = [
    {
        id: '1',
        statusCategory: $89523e1d4dcff547$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $89523e1d4dcff547$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $89523e1d4dcff547$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $89523e1d4dcff547$export$71efb3495f6084f2
    }
];
const $89523e1d4dcff547$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $89523e1d4dcff547$export$3f42f49c284d5b58 = Object.freeze({
    [$89523e1d4dcff547$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$89523e1d4dcff547$export$5d42a08d46cffe7.NEW]: 2,
    [$89523e1d4dcff547$export$5d42a08d46cffe7.DONE]: 3,
    [$89523e1d4dcff547$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $89523e1d4dcff547$export$f3f919dc0f56d9eb = Object.values($89523e1d4dcff547$export$5d42a08d46cffe7);
const $89523e1d4dcff547$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $89523e1d4dcff547$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $89523e1d4dcff547$export$6db089fe7b26f5b6;
};
const $89523e1d4dcff547$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $89523e1d4dcff547$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $89523e1d4dcff547$export$d928f247c903643a = (key)=>$89523e1d4dcff547$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});

parcelRegister("ktHCr", function(module, exports) {
$parcel$export(module.exports, "AvatarRelay", () => $0519fe7e6928deb5$export$4bc8bcb977dc5ae2);

var $gt9Am = parcelRequire("gt9Am");

var $1GQCB = parcelRequire("1GQCB");
parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5DgXR = parcelRequire("5DgXR");

var $64Lg2 = parcelRequire("64Lg2");
const $0519fe7e6928deb5$export$4bc8bcb977dc5ae2 = ({ userFragment: userFragment, label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, presence: presence, size: size, status: status, stackIndex: stackIndex, tabIndex: tabIndex, target: target, onClick: onClick, testId: testId, analyticsContext: analyticsContext, as: as, isDecorative: isDecorative, imgLoading: imgLoading })=>{
    const user = (0, $j4oe4.useFragment)((0, $1GQCB.default), userFragment);
    const appearance = (0, $64Lg2.getAppearanceForAppType)(user?.appType);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5DgXR.default), {
        // from relay fragment
        src: user?.picture,
        appearance: appearance,
        // prop-drill from AvatarRelayProps
        label: label,
        borderColor: borderColor,
        children: children,
        href: href,
        isDisabled: isDisabled,
        name: name,
        presence: presence,
        size: size,
        status: status,
        stackIndex: stackIndex,
        tabIndex: tabIndex,
        target: target,
        onClick: onClick,
        testId: testId,
        analyticsContext: analyticsContext,
        as: as,
        isDecorative: isDecorative,
        imgLoading: imgLoading
    });
};

});
parcelRegister("1GQCB", function(module, exports) {
$parcel$export(module.exports, "default", () => $b62b7476b2a6b4bd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2146d5ab1ff461c0333e3630e508c9c9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b62b7476b2a6b4bd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "avatarRelay_user",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "picture"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "appType"
                }
            ],
            "type": "AppUser"
        }
    ],
    "type": "User",
    "abstractKey": "__isUser"
};
$b62b7476b2a6b4bd$var$node.hash = "507292d34580d58c48df1e1edacc7bad";
var $b62b7476b2a6b4bd$export$2e2bcd8739ae039 = $b62b7476b2a6b4bd$var$node;

});

parcelRegister("64Lg2", function(module, exports) {
$parcel$export(module.exports, "getAppearanceForAppType", () => $987717cec5ca10b3$export$6b45b5bd2259198a);
function $987717cec5ca10b3$export$6b45b5bd2259198a(appType) {
    switch(appType){
        case 'agent':
            return 'hexagon';
        case 'team':
            // @TODO investigate if team comes from appType or if it is a separate way to detect
            return 'square';
        case 'user':
        case 'system':
        default:
            return 'circle';
    }
}

});


parcelRegister("jCEKQ", function(module, exports) {
$parcel$export(module.exports, "shouldDisplayStrikethrough", () => $71a3d2c694c5502c$export$1e1e848245d3a6f7);

var $jx0Vw = parcelRequire("jx0Vw");
const { DONE: $71a3d2c694c5502c$var$DONE } = (0, $jx0Vw);
const $71a3d2c694c5502c$export$1e1e848245d3a6f7 = (isResolved, statusCategory)=>{
    if (isResolved !== undefined) return isResolved;
    // In JSW, the strikethrough must now only depend on resolution. However we have to keep
    // this logic because there is a consumer of issue-line-card in JSM that displays
    // the strikethrough based on status src/packages/servicedesk/post-incident-review/src/ui/primary-incident/index.tsx
    return statusCategory === $71a3d2c694c5502c$var$DONE;
};

});

parcelRegister("aIyl4", function(module, exports) {
$parcel$export(module.exports, "default", () => $559b2086345b8bef$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $559b2086345b8bef$var$messages = (0, $7qGN1.defineMessages)({
    screenReaderFooterKeyResolved: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.footer.screen-reader-footer-key-resolved",
        "defaultMessage": "Resolved issue: {issueKey}"
    },
    screenReaderFooterKeyDone: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.footer.screen-reader-footer-key-done",
        "defaultMessage": "Done issue: {issueKey}"
    },
    screenReaderFooterKeyResolvedIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.footer.screen-reader-footer-key-resolved-issue-term-refresh",
        "defaultMessage": "Resolved issue: {issueKey}"
    },
    screenReaderFooterKeyDoneIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.footer.screen-reader-footer-key-done-issue-term-refresh",
        "defaultMessage": "Done work item: {issueKey}"
    }
});
var $559b2086345b8bef$export$2e2bcd8739ae039 = $559b2086345b8bef$var$messages;

});



parcelRegister("3KwXP", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ec36b011b8ea78a$export$2e2bcd8739ae039);

var $c8Ee3 = parcelRequire("c8Ee3");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $fo3wk = parcelRequire("fo3wk");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $91UnK = parcelRequire("91UnK");

var $1wL9i = parcelRequire("1wL9i");

var $hKTLi = parcelRequire("hKTLi");
const $6ec36b011b8ea78a$var$useUpdatingRef = (value)=>{
    const ref = (0, $eJOHy.useRef)(value);
    ref.current = value;
    return ref;
};
const $6ec36b011b8ea78a$var$KeyboardShortcuts = (props)=>{
    const issueData = (0, $j4oe4.useFragment)((0, $c8Ee3.default), props.focusedIssue);
    const workType = issueData?.issueTypeField?.issueType?.name;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const propsRef = $6ec36b011b8ea78a$var$useUpdatingRef(props);
    const openStateRef = $6ec36b011b8ea78a$var$useUpdatingRef((0, $91UnK.useOrderByOpenState)());
    const selectedIssueKey = (0, $1wL9i.useSelectedIssueKey)();
    const selectedIssueKeyRef = $6ec36b011b8ea78a$var$useUpdatingRef(selectedIssueKey);
    const { selectNextIssue: selectNextIssue, selectPreviousIssue: selectPreviousIssue } = (0, $1wL9i.useSelectedIssueActions)();
    const nextIssueKey = (0, $1wL9i.useNextIssueKey)() ?? '';
    const nextIssueKeyRef = (0, $eJOHy.useRef)(nextIssueKey);
    nextIssueKeyRef.current = nextIssueKey;
    const handleNext = (0, $eJOHy.useCallback)(()=>{
        const { onIssueChangeEvent: onIssueChangeEvent } = propsRef.current;
        if (selectNextIssue(true)) onIssueChangeEvent && onIssueChangeEvent(nextIssueKeyRef.current);
    // Dependencies must be stable as downstream useMemo has an empty dependencies array
    }, [
        propsRef,
        selectNextIssue
    ]);
    const previousIssueKey = (0, $1wL9i.usePreviousIssueKey)() ?? '';
    const previousIssueKeyRef = (0, $eJOHy.useRef)(previousIssueKey);
    previousIssueKeyRef.current = previousIssueKey;
    const handlePrevious = (0, $eJOHy.useCallback)(()=>{
        const { onIssueChangeEvent: onIssueChangeEvent } = propsRef.current;
        if (selectPreviousIssue(true)) onIssueChangeEvent && onIssueChangeEvent(previousIssueKeyRef.current);
    // Dependencies must be stable as downstream useMemo has an empty dependencies array
    }, [
        propsRef,
        selectPreviousIssue
    ]);
    const openIssueFullScreenMessage = (()=>{
        if (workType && (0, $cxKOj.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return formatMessage((0, $hKTLi.default).openIssueFullScreenIssueTerminologyRefreshM4, {
            workType: workType
        });
        return formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hKTLi.default).openIssueFullScreenIssueTermRefresh : (0, $hKTLi.default).openIssueFullScreen);
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fo3wk.default), {
        keyMap: (0, $eJOHy.useMemo)(()=>({
                j: {
                    callback: ()=>{
                        const { disableListControls: disableListControls } = propsRef.current;
                        if (disableListControls === true) return;
                        // handleNext needs to be a stable function references as useMemo has an empty dependencies array
                        handleNext();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hKTLi.default).nextIssueIssueTermRefresh : (0, $hKTLi.default).nextIssue))
                },
                k: {
                    callback: ()=>{
                        const { disableListControls: disableListControls } = propsRef.current;
                        if (disableListControls === true) return;
                        // handlePrevious needs to be a stable function references as useMemo has an empty dependencies array
                        handlePrevious();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hKTLi.default).previousIssueIssueTermRefresh : (0, $hKTLi.default).previousIssue))
                },
                y: {
                    callback: ()=>{
                        const [{ isOpen: isOpen }, { open: open, close: close }] = openStateRef.current;
                        isOpen ? close() : open();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, formatMessage((0, $hKTLi.default).displaySortFields))
                },
                z: {
                    callback: ()=>{
                        if (selectedIssueKeyRef.current) propsRef.current.onNavigateToIssue(selectedIssueKeyRef.current);
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, openIssueFullScreenMessage)
                },
                arrowup: {
                    callback: ()=>{
                        const { disableListControls: disableListControls, focusedIssueKey: focusedIssueKey } = propsRef.current;
                        if (disableListControls === true) return;
                        const isSelectedIssueFocused = focusedIssueKey !== null && focusedIssueKey === selectedIssueKeyRef.current;
                        if (isSelectedIssueFocused) handlePrevious();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hKTLi.default).previousIssueIssueTermRefresh : (0, $hKTLi.default).previousIssue))
                },
                arrowdown: {
                    callback: ()=>{
                        const { disableListControls: disableListControls, focusedIssueKey: focusedIssueKey } = propsRef.current;
                        if (disableListControls === true) return;
                        const isSelectedIssueFocused = focusedIssueKey !== null && focusedIssueKey === selectedIssueKeyRef.current;
                        if (isSelectedIssueFocused) handleNext();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hKTLi.default).nextIssueIssueTermRefresh : (0, $hKTLi.default).nextIssue))
                }
            }), [] // eslint-disable-line react-hooks/exhaustive-deps
        )
    });
};
$6ec36b011b8ea78a$var$KeyboardShortcuts.defaultProps = {
    disableListControls: false
};
var $6ec36b011b8ea78a$export$2e2bcd8739ae039 = $6ec36b011b8ea78a$var$KeyboardShortcuts;

});
parcelRegister("c8Ee3", function(module, exports) {
$parcel$export(module.exports, "default", () => $25dfc67a6a5e74ac$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2314afbcde7d8980ae1e76ca96f70867>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $25dfc67a6a5e74ac$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "keyboardShortcuts_issueNavigator",
    "selections": [
        {
            "concreteType": "JiraIssueTypeField",
            "kind": "LinkedField",
            "name": "issueTypeField",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "issueType",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$25dfc67a6a5e74ac$var$node.hash = "b6db91587551c3c9c628860986b56a99";
var $25dfc67a6a5e74ac$export$2e2bcd8739ae039 = $25dfc67a6a5e74ac$var$node;

});

parcelRegister("hKTLi", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ce29e05b5c8244f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $9ce29e05b5c8244f$var$messages = (0, $7qGN1.defineMessages)({
    nextIssue: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.next-issue",
        "defaultMessage": "Next issue"
    },
    previousIssue: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.previous-issue",
        "defaultMessage": "Previous issue"
    },
    displaySortFields: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.display-sort-fields",
        "defaultMessage": "Detail view order by"
    },
    openIssueFullScreen: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.open-issue-full-screen",
        "defaultMessage": "Open issue fullscreen"
    },
    nextIssueIssueTermRefresh: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.next-issue-issue-term-refresh",
        "defaultMessage": "Next work item"
    },
    previousIssueIssueTermRefresh: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.previous-issue-issue-term-refresh",
        "defaultMessage": "Previous work item"
    },
    openIssueFullScreenIssueTermRefresh: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.open-issue-full-screen-issue-term-refresh",
        "defaultMessage": "Open the work item in fullscreen"
    },
    openIssueFullScreenIssueTerminologyRefreshM4: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.open-issue-full-screen-issue-terminology-refresh-m4",
        "defaultMessage": "Open the {workType} in fullscreen"
    }
});
var $9ce29e05b5c8244f$export$2e2bcd8739ae039 = $9ce29e05b5c8244f$var$messages;

});


parcelRegister("1Gp6c", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc3de5d2e75e68e6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $bc3de5d2e75e68e6$var$messages = (0, $7qGN1.defineMessages)({
    issues: {
        "id": "issue-navigator.issue-results.detail-view.card-list.issues",
        "defaultMessage": "Issues"
    },
    issuesIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.issues-issue-term-refresh",
        "defaultMessage": "Work items"
    }
});
var $bc3de5d2e75e68e6$export$2e2bcd8739ae039 = $bc3de5d2e75e68e6$var$messages;

});



parcelRegister("gNBTz", function(module, exports) {
$parcel$export(module.exports, "default", () => $17d1e620d8155487$export$2e2bcd8739ae039);
$parcel$export(module.exports, "RecoverableErrorViewBoundary", () => $17d1e620d8155487$export$d42c1f6e3e564ee9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $6MnLl = parcelRequire("6MnLl");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $8hzPW = parcelRequire("8hzPW");

var $kKCMK = parcelRequire("kKCMK");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $eS29z = parcelRequire("eS29z");

var $3kDjB = parcelRequire("3kDjB");

var $3wQlR = parcelRequire("3wQlR");
const $17d1e620d8155487$var$ErrorView = ({ onCaughtIssueSearchError: onCaughtIssueSearchError, error: errorProp })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { refresh: refresh } = (0, $3kDjB.useIssueSearchActions)();
    const onClick = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        // @ts-expect-error - Argument of type 'UIAnalyticsEvent | null' is not assignable to parameter of type 'UIAnalyticsEvent'.
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent.clone(), 'refreshFromError');
        refresh();
    }, [
        refresh
    ]);
    const error = (0, $eJOHy.useMemo)(()=>errorProp || new Error('There was an error searching for issues'), [
        errorProp
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        onCaughtIssueSearchError && onCaughtIssueSearchError(error);
    }, [
        onCaughtIssueSearchError,
        error
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($17d1e620d8155487$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        header: formatMessage((0, $3wQlR.default).emptyStateErrorHeader),
        description: formatMessage((0, $3wQlR.default).emptyStateErrorDescription),
        testId: "issue-navigator.ui.issue-results.error-view.error-message",
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "primary",
            onClick: onClick
        }, formatMessage((0, $3wQlR.default).emptyStateErrorAction)),
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $17d1e620d8155487$var$ImageWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kKCMK.default), {
                alt: ""
            }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "screen",
        actionSubjectId: "issueSearchError"
    }));
};
var $17d1e620d8155487$export$2e2bcd8739ae039 = $17d1e620d8155487$var$ErrorView;
const $17d1e620d8155487$export$d42c1f6e3e564ee9 = (0, $8hzPW.withRecoverableErrorBoundary)(({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children), {
    recoveryProp: 'recoveryProp',
    Fallback: $17d1e620d8155487$var$ErrorView
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $17d1e620d8155487$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _16jlkb7n _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $17d1e620d8155487$var$ImageWrapperStyles = (0, $1DXK0.xcss)({
    maxHeight: '165px',
    maxWidth: '150px',
    margin: 'auto',
    marginBottom: 'space.300'
});

});
parcelRegister("3wQlR", function(module, exports) {
$parcel$export(module.exports, "default", () => $faa7481be7905ff9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $faa7481be7905ff9$var$messages = (0, $7qGN1.defineMessages)({
    emptyStateErrorHeader: {
        "id": "issue-navigator.issue-results.error-view.empty-state-error-header",
        "defaultMessage": "We couldn\u2019t load your search results"
    },
    emptyStateErrorDescription: {
        "id": "issue-navigator.issue-results.error-view.empty-state-error-description",
        "defaultMessage": "Refresh to try again."
    },
    emptyStateErrorAction: {
        "id": "issue-navigator.issue-results.error-view.empty-state-error-action",
        "defaultMessage": "Refresh"
    }
});
var $faa7481be7905ff9$export$2e2bcd8739ae039 = $faa7481be7905ff9$var$messages;

});


parcelRegister("bR878", function(module, exports) {
$parcel$export(module.exports, "default", () => $a32fd0fc63cfc134$export$2e2bcd8739ae039);

var $40EJa = parcelRequire("40EJa");

var $eFy4J = parcelRequire("eFy4J");

var $glwcG = parcelRequire("glwcG");

var $6JLeN = parcelRequire("6JLeN");

var $f7xI3 = parcelRequire("f7xI3");

var $aVrHl = parcelRequire("aVrHl");

var $8WH6X = parcelRequire("8WH6X");

var $45LXf = parcelRequire("45LXf");

var $iDMnF = parcelRequire("iDMnF");

var $hxlpC = parcelRequire("hxlpC");

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $j4oe4 = parcelRequire("j4oe4");

var $6TdgS = parcelRequire("6TdgS");

var $2WT2V = parcelRequire("2WT2V");

var $c12HM = parcelRequire("c12HM");

var $9pTd3 = parcelRequire("9pTd3");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $cxKOj = parcelRequire("cxKOj");

var $cSXp8 = parcelRequire("cSXp8");

var $3aisD = parcelRequire("3aisD");

var $cTddL = parcelRequire("cTddL");

var $awWeA = parcelRequire("awWeA");

var $d8Dow = parcelRequire("d8Dow");

var $8jOO7 = parcelRequire("8jOO7");

var $P01So = parcelRequire("P01So");

var $9Z7uc = parcelRequire("9Z7uc");

var $aJqsk = parcelRequire("aJqsk");

var $j6nGi = parcelRequire("j6nGi");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");
var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $cHtIB = parcelRequire("cHtIB");

var $kh7bJ = parcelRequire("kh7bJ");

var $4Oene = parcelRequire("4Oene");

var $4cTDP = parcelRequire("4cTDP");

var $bJscI = parcelRequire("bJscI");

var $aaLZH = parcelRequire("aaLZH");

var $iRahl = parcelRequire("iRahl");

var $2UTIe = parcelRequire("2UTIe");

var $eibCx = parcelRequire("eibCx");

var $fAgUF = parcelRequire("fAgUF");

var $7auhX = parcelRequire("7auhX");

var $gTm2i = parcelRequire("gTm2i");

var $1wL9i = parcelRequire("1wL9i");

var $HiS1C = parcelRequire("HiS1C");

var $dTsrC = parcelRequire("dTsrC");

var $fwKw5 = parcelRequire("fwKw5");

var $kGfUm = parcelRequire("kGfUm");

var $7emTO = parcelRequire("7emTO");

var $3kDjB = parcelRequire("3kDjB");

var $i99kJ = parcelRequire("i99kJ");

var $4ciTX = parcelRequire("4ciTX");

var $iZH8P = parcelRequire("iZH8P");

var $i5UAP = parcelRequire("i5UAP");

var $fOH9z = parcelRequire("fOH9z");

var $b2VjA = parcelRequire("b2VjA");

var $kg3EI = parcelRequire("kg3EI");

var $ghzkC = parcelRequire("ghzkC");

var $2PY5Q = parcelRequire("2PY5Q");

var $fwdeI = parcelRequire("fwdeI");

var $jOc90 = parcelRequire("jOc90");

var $aaQkY = parcelRequire("aaQkY");
const $a32fd0fc63cfc134$var$reorderColumnsErrorFlag = {
    type: 'error',
    title: (0, $kg3EI.default).reorderColumnsErrorTitle,
    description: (0, $kg3EI.default).columnConfigMutationErrorDescription,
    isAutoDismiss: true,
    messageId: 'issue-navigator.ui.issue-results.list-view.reorder-columns-error-flag.error',
    messageType: 'transactional'
};
const $a32fd0fc63cfc134$var$resetColumnsErrorFlag = {
    type: 'error',
    title: (0, $kg3EI.default).resetColumnsErrorTitle,
    description: (0, $kg3EI.default).columnConfigMutationErrorDescription,
    isAutoDismiss: true,
    messageId: 'issue-navigator.ui.issue-results.list-view.reset-columns-error-flag.error',
    messageType: 'transactional'
};
const $a32fd0fc63cfc134$var$TableContainer = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $a32fd0fc63cfc134$var$TableContainerStyles
    }, children);
const $a32fd0fc63cfc134$var$DialogContextContainerWithGate = (0, $bJscI.componentWithFG)('empanada_nin_convert_issue_ops_to_entrypoint', (0, $eJOHy.Fragment), (0, $cTddL.DialogContextContainer));
const $a32fd0fc63cfc134$export$b4f6a715a9e57e85 = ()=>{
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    const { isFilterEditable: isFilterEditable } = (0, $fwKw5.useActiveJql)();
    const [{ view: view }] = (0, $HiS1C.useSelectedViewState)();
    const { isLoading: isLoading } = (0, $7auhX.useColumnPickerLoadingContext)();
    return !isAnonymous && (!(0, $eibCx.isFilterViewId)(view) || isFilterEditable === true) && !isLoading;
};
const $a32fd0fc63cfc134$export$539ae4acd804b244 = (onRestoreDefaultColumns, hasDefaultFieldSets, viewdataId)=>{
    const { isFilterEditable: isFilterEditable } = (0, $fwKw5.useActiveJql)();
    const [{ view: selectedView }] = (0, $HiS1C.useSelectedViewState)();
    if ((0, $4cTDP.fg)('jira_inline_field_config_gate')) return !((0, $eibCx.isFilterViewId)(selectedView) && isFilterEditable === false) && hasDefaultFieldSets === false && // check that the view id from state and store is the same
    viewdataId === selectedView ? onRestoreDefaultColumns : undefined;
    return !((0, $eibCx.isFilterViewId)(selectedView) && isFilterEditable === false) && hasDefaultFieldSets === false ? onRestoreDefaultColumns : undefined;
};
const $a32fd0fc63cfc134$export$3e7a75a1659bbaae = (onColumnsChange)=>{
    const canEditColumns = $a32fd0fc63cfc134$export$b4f6a715a9e57e85();
    return canEditColumns ? onColumnsChange : undefined;
};
const $a32fd0fc63cfc134$export$d7623a323994e4cc = (selectedColumns, isIFCEnabled, projectContext, savedViewId)=>{
    let [{ view: selectedView }] = (0, $HiS1C.useSelectedViewState)();
    const canEditColumns = $a32fd0fc63cfc134$export$b4f6a715a9e57e85();
    if (projectContext != null && (0, $4cTDP.fg)('saved_list_view_technical_changes')) selectedView = 'list_default';
    return (0, $kGfUm.useColumnLoader)(selectedView, canEditColumns, selectedColumns, (0, $4cTDP.fg)('jira_inline_field_config_gate'), isIFCEnabled, projectContext, savedViewId);
};
const $a32fd0fc63cfc134$export$90b784197d8a906f = ()=>{
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    return !isAnonymous ? $a32fd0fc63cfc134$export$d7623a323994e4cc : undefined;
};
const $a32fd0fc63cfc134$var$ListView = ({ loading: loading, onChangeColumnConfiguration: onChangeColumnConfiguration, onSelectedRowChange: onSelectedRowChange, issueResults: issueResults, groupResults: groupResults, view: view, project: project, rankField: rankField, issueTableProps: issueTableProps, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isIssueRankingSupportEnabled: isIssueRankingSupportEnabled, isMergedColumnSupportEnabled: isMergedColumnSupportEnabled, isFrozenColumnSupportEnabled: isFrozenColumnSupportEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled, filter: filter, onIssueFlatListUpdated: onIssueFlatListUpdated, viewResultError: viewResultError })=>{
    (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_RESULTS_LIST_VIEW_START);
    (0, $eJOHy.useLayoutEffect)(()=>{
        (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_RESULTS_LIST_VIEW_END);
    }, []);
    const resolvedJql = (0, $fwKw5.useResolvedJql)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const features = (0, $aaLZH.useIssueNavigatorFeatures)();
    const isRowContextMenuEnabled = features.isRowContextMenuEnabled;
    /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ const issueResultsData = (0, $j4oe4.useFragment)((0, $hxlpC.default), issueResults);
    const groupResultsData = (0, $j4oe4.useFragment)((0, $iDMnF.default), groupResults);
    const viewData = (0, $j4oe4.useFragment)((0, $45LXf.default), view);
    // manually throw error when fieldsets is null
    if (viewData.fieldSets == null) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'NinNullFieldSets',
                packageName: (0, $iRahl.PACKAGE_NAME),
                teamName: (0, $iRahl.TEAM_NAME)
            },
            sendToPrivacyUnsafeSplunk: false,
            skipSentry: true,
            attributes: {
                viewId: viewData.viewId,
                hasDefaultFieldSets: viewData.hasDefaultFieldSets,
                hasIssueResults: issueResultsData != null,
                hasView: view != null,
                typeName: viewData.__typename,
                viewResultError: viewResultError != null ? `${viewResultError?.statusCode} ${viewResultError?.message}` : false,
                ...(isInlineFieldConfigEnabled || (0, $4cTDP.fg)('jira_nin_last_used_jql')) && {
                    fieldSetsScope: {
                        operationScope: (0, $awWeA.getOperationScope)(issueTableProps?.projectContext),
                        projectKey: issueTableProps?.projectContext != null
                    }
                }
            }
        });
        throw new Error("Relay: Missing @required value at path 'fieldSets' in 'main_issueNavigator_ListView_view'.");
    }
    const projectData = (0, $j4oe4.useFragment)((0, $8WH6X.default), project);
    const filterData = (0, $j4oe4.useFragment)((0, $aVrHl.default), filter);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $f7xI3.default), rankField);
    const selectedIssueKey = (0, $1wL9i.useSelectedIssueKey)();
    const selectedIssueIndex = (0, $1wL9i.useSelectedIssueIndex)();
    const currentPage = (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? Math.ceil((issueResultsData?.issueNavigatorPageInfo?.firstIssuePosition ?? (0, $iRahl.MAX_ISSUES_PER_PAGE)) / (0, $iRahl.MAX_ISSUES_PER_PAGE)) : issueResultsData?.pageCursors?.around?.find((cursor)=>cursor?.isCurrent)?.pageNumber ?? 1;
    const [{ field: field, direction: direction }, { setFieldAndDirection: setFieldAndDirection }] = (0, $dTsrC.useSortFieldAndDirection)();
    // TODO JSC-242 Need to figure out appropriate refetch behaviour, e.g. do we want to try keep visible issues in view?
    const { refetch: onIssueSearchForColumnConfig, refresh: refresh } = (0, $3kDjB.useIssueSearchActions)();
    const { isLoading: isColumnPickerLoading, setIsRestoringDefaultColumns: setIsRestoringDefaultColumns } = (0, $7auhX.useColumnPickerLoadingContext)();
    const onModifyColumns = (0, $eJOHy.useCallback)(()=>{
        onChangeColumnConfiguration && onChangeColumnConfiguration();
        onIssueSearchForColumnConfig();
    }, [
        onChangeColumnConfiguration,
        onIssueSearchForColumnConfig
    ]);
    const fieldSetIds = (0, $eJOHy.useMemo)(()=>viewData.fieldSets?.edges?.map((edge)=>edge?.node?.fieldSetId).filter(Boolean) ?? [], [
        viewData.fieldSets?.edges
    ]);
    const stickyColumnIds = isFrozenColumnSupportEnabled && (0, $4cTDP.fg)('issue_table_frozen_columns') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>viewData.fieldSets?.edges?.filter((edge)=>edge?.node?.fieldSetPreferences?.isFrozen === true).map((edge)=>edge?.node?.fieldSetId).filter(Boolean) ?? [], [
        viewData.fieldSets.edges
    ]) : [];
    const eventHandlers = (0, $aaQkY.useEventHandlers)(issueResultsData?.__id, fieldSetIds);
    const overriddenTableComponents = issueTableProps?.components;
    const projectContext = issueTableProps?.projectContext;
    const isGroupingSupported = issueTableProps?.isGroupingSupported;
    const viewSettings = viewData?.viewSettings;
    /**
   * isHierarchyEnabled reflects user preference in the current page,
   * canEnableHierarchy reflects whether the hierarchy can be enabled based on the JQL / other settings,
   * isIssueHierarchySupportEnabled reflects whether the hierarchy is supported in the experience.
   * The combination of these three values determines whether issue hierarchy is enabled in issue table.
   */ const isHierarchyEnabled = viewSettings?.isHierarchyEnabled && viewSettings.canEnableHierarchy && isIssueHierarchySupportEnabled;
    const isHideDoneEnabled = viewSettings?.hideDone ?? false;
    const groupByFieldId = viewData?.viewSettings?.groupByConfig?.groupByField?.fieldId;
    const infiniteScrollProps = (0, $7emTO.useInfiniteScroll)({
        isHierarchyEnabled: isHierarchyEnabled,
        fieldSetIds: fieldSetIds,
        groupBy: isGroupingSupported ? groupByFieldId : undefined,
        view: (0, $iRahl.views).list,
        isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
        isHideDoneEnabled: isHideDoneEnabled
    });
    const onSortOrderChange = (0, $eJOHy.useCallback)((sortField, sortDirection, aliases = [])=>setFieldAndDirection(sortField, sortDirection, aliases), [
        setFieldAndDirection
    ]);
    const hasMaxSelectedColumns = viewData?.fieldSets?.totalCount ? viewData?.fieldSets?.totalCount >= (0, $8jOO7.MAX_COLUMNS) : false;
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagService)();
    const [replaceSpreadsheetViewFieldSetsOld] = (0, $j4oe4.useMutation)((0, $6JLeN.default));
    const [replaceSpreadsheetViewFieldSets] = (0, $j4oe4.useMutation)((0, $glwcG.default));
    /*
   * This updater imperatively updates the isViewConfigModified record to handle the
   * scenario where the variables provided to isViewConfigModified in the preloaded query
   * differ from the variables provided in refetches.
   *
   * This ensures the save/reset view button is correctly hidden when publishing the view
   * immediately after a page refresh.
   *
   * In all other scenarios we can rely on Relay writing the network response to the store
   * via spreading a fragment which contains the isViewConfigModified field.
   */ const replaceSpreadsheetViewFieldSetsUpdater = (0, $eJOHy.useCallback)((store, response)=>{
        const isViewConfigModified = response?.jira?.replaceSpreadsheetViewFieldSets?.view?.isViewConfigModified;
        if (response?.jira?.replaceSpreadsheetViewFieldSets?.success !== true || isViewConfigModified == null) return;
        const viewRecord = store.get(viewData.__id);
        if (viewRecord == null) return;
        (0, $2WT2V.setIsViewConfigModifiedRecord)({
            isViewConfigModified: isViewConfigModified,
            viewRecord: viewRecord
        });
    }, [
        viewData.__id
    ]);
    const onColumnsChange = (0, $eJOHy.useCallback)((columnIds, changeType, optimisticFieldSets, onSuccessCallback, onErrorCallback, retries = 0, analyticsAttributes, skipRefetch)=>{
        let attempts = 0;
        // This handler can be called from a native event listener hence React does not batch state updates.
        // We manually batch this update for better rendering performance and more accurate measurement of
        // drag-and-drop interaction performance. We can remove this with React 18's automatic batching.
        (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).unstable_batchedUpdates(()=>{
            if (changeType === (0, $8jOO7.REORDER_COLUMNS)) (0, $jOc90.dragAndDropExperience).start();
            const handleCompleted = (success)=>{
                if (success) {
                    const canSkipRefetch = skipRefetch && (0, $4cTDP.fg)('jira_inline_field_config_gate');
                    if (changeType === (0, $8jOO7.MODIFY_COLUMNS) && !canSkipRefetch) onModifyColumns();
                    else if (changeType === (0, $8jOO7.REORDER_COLUMNS)) (0, $jOc90.dragAndDropExperience).success();
                    if ((0, $4cTDP.fg)('jira_inline_field_config_gate')) {
                        const eventAttributes = {
                            ...analyticsAttributes,
                            operationScope: (0, $awWeA.getOperationScope)(projectContext)
                        };
                        if (changeType === (0, $8jOO7.MODIFY_COLUMNS)) (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTableColumns updated', eventAttributes || {});
                        else if (changeType === (0, $8jOO7.REORDER_COLUMNS)) (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTableColumns updated', {
                            actionType: (0, $8jOO7.REORDER_COLUMNS),
                            operationScope: (0, $awWeA.getOperationScope)(projectContext)
                        });
                    } else {
                        const totalCount = viewData?.fieldSets?.totalCount;
                        if (changeType === (0, $8jOO7.MODIFY_COLUMNS)) (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTableColumns updated', {
                            isInline: false,
                            actionType: columnIds.length < (totalCount ?? 0) ? (0, $d8Dow.REMOVE_COLUMNS) : (0, $d8Dow.ADD_COLUMNS)
                        });
                        else if (changeType === (0, $8jOO7.REORDER_COLUMNS)) (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTableColumns updated', {
                            actionType: (0, $8jOO7.REORDER_COLUMNS)
                        });
                    }
                    if ((0, $4cTDP.fg)('jira_inline_field_config_gate')) onSuccessCallback?.();
                } else {
                    const showError = !(0, $4cTDP.fg)('jira_inline_field_config_gate') || attempts === retries;
                    if (showError) {
                        showFlag($a32fd0fc63cfc134$var$reorderColumnsErrorFlag);
                        (0, $9pTd3.fireErrorAnalytics)({
                            meta: {
                                id: 'commitReplaceListViewFieldSetsMutationUnsuccessful',
                                packageName: (0, $iRahl.PACKAGE_NAME),
                                teamName: (0, $iRahl.TEAM_NAME)
                            },
                            sendToPrivacyUnsafeSplunk: true,
                            attributes: {
                                changeType: changeType,
                                retries: retries
                            }
                        });
                        if (changeType === (0, $8jOO7.REORDER_COLUMNS)) (0, $jOc90.dragAndDropExperience).failure();
                        if ((0, $4cTDP.fg)('jira_inline_field_config_gate')) onErrorCallback?.();
                    } else {
                        attempts++;
                        commitFieldSets();
                    }
                }
            };
            const handleError = (error)=>{
                const showError = !(0, $4cTDP.fg)('jira_inline_field_config_gate') || attempts === retries;
                if (showError) {
                    showFlag($a32fd0fc63cfc134$var$reorderColumnsErrorFlag);
                    (0, $9pTd3.fireErrorAnalytics)({
                        meta: {
                            id: 'commitReplaceListViewFieldSetsMutationError',
                            packageName: (0, $iRahl.PACKAGE_NAME),
                            teamName: (0, $iRahl.TEAM_NAME)
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true,
                        attributes: {
                            changeType: changeType
                        }
                    });
                    if (changeType === (0, $8jOO7.REORDER_COLUMNS)) (0, $jOc90.dragAndDropExperience).failure();
                    if ((0, $4cTDP.fg)('jira_inline_field_config_gate')) onErrorCallback?.();
                } else {
                    attempts++;
                    commitFieldSets();
                }
            };
            const commitFieldSets = ()=>{
                if ((0, $4cTDP.fg)('saved_list_view_technical_changes')) {
                    const savedViewId = viewData.savedViewId;
                    if (savedViewId == null) throw new Error('Missing saved view ID');
                    const variables = {
                        id: savedViewId,
                        amountOfColumns: (0, $8jOO7.MAX_COLUMNS),
                        fieldSetsInput: {
                            replaceFieldSetsInput: {
                                nodes: columnIds,
                                ...projectData?.projectId && (0, $4cTDP.fg)('jira_nin_last_used_jql') && {
                                    context: {
                                        projectContext: {
                                            project: projectData?.projectId
                                        }
                                    }
                                },
                                ...isInlineFieldConfigEnabled && !(0, $4cTDP.fg)('jira_nin_last_used_jql') && {
                                    context: {
                                        projectContext: {
                                            project: projectData?.projectId
                                        }
                                    }
                                }
                            }
                        },
                        includeView: changeType === (0, $8jOO7.REORDER_COLUMNS),
                        ...(0, $4cTDP.fg)('jira_nin_last_used_jql') && {
                            fieldSetsScope: {
                                operationScope: (0, $awWeA.getOperationScope)(projectContext),
                                projectKey: projectData?.key ?? null
                            }
                        },
                        ...isInlineFieldConfigEnabled && !(0, $4cTDP.fg)('jira_nin_last_used_jql') && {
                            fieldSetsScope: {
                                operationScope: (0, $awWeA.getOperationScope)(projectContext),
                                projectKey: projectData?.key
                            }
                        },
                        settings: {
                            groupBy: viewSettings?.groupByConfig?.groupByField?.fieldId ?? null,
                            hideDone: Boolean(viewSettings?.hideDone),
                            hierarchyEnabled: Boolean(viewSettings?.isHierarchyEnabled),
                            jql: resolvedJql
                        }
                    };
                    replaceSpreadsheetViewFieldSets({
                        variables: variables,
                        optimisticResponse: changeType === (0, $8jOO7.REORDER_COLUMNS) && optimisticFieldSets ? {
                            jira: {
                                replaceSpreadsheetViewFieldSets: {
                                    success: true,
                                    view: {
                                        __typename: viewData.__typename,
                                        id: viewData.id,
                                        hasDefaultFieldSets: viewData.hasDefaultFieldSets,
                                        fieldSets: {
                                            ...optimisticFieldSets
                                        },
                                        isViewConfigModified: viewData.isViewConfigModified
                                    }
                                }
                            }
                        } : undefined,
                        updater: replaceSpreadsheetViewFieldSetsUpdater,
                        onCompleted (data) {
                            handleCompleted(data.jira?.replaceSpreadsheetViewFieldSets?.success);
                        },
                        onError (error) {
                            handleError(error);
                        }
                    });
                } else {
                    const variables = {
                        id: viewData.id,
                        amountOfColumns: (0, $8jOO7.MAX_COLUMNS),
                        fieldSetsInput: {
                            replaceFieldSetsInput: {
                                nodes: columnIds,
                                ...projectData?.projectId && (0, $4cTDP.fg)('jira_nin_last_used_jql') && {
                                    context: {
                                        projectContext: {
                                            project: projectData?.projectId
                                        }
                                    }
                                },
                                ...isInlineFieldConfigEnabled && !(0, $4cTDP.fg)('jira_nin_last_used_jql') && {
                                    context: {
                                        projectContext: {
                                            project: projectData?.projectId
                                        }
                                    }
                                }
                            }
                        },
                        includeView: changeType === (0, $8jOO7.REORDER_COLUMNS),
                        ...(0, $4cTDP.fg)('jira_nin_last_used_jql') && {
                            fieldSetsScope: {
                                operationScope: (0, $awWeA.getOperationScope)(projectContext),
                                projectKey: projectData?.key ?? null
                            }
                        },
                        ...isInlineFieldConfigEnabled && !(0, $4cTDP.fg)('jira_nin_last_used_jql') && {
                            fieldSetsScope: {
                                operationScope: (0, $awWeA.getOperationScope)(projectContext),
                                projectKey: projectData?.key
                            }
                        }
                    };
                    replaceSpreadsheetViewFieldSetsOld({
                        variables: variables,
                        optimisticResponse: changeType === (0, $8jOO7.REORDER_COLUMNS) && optimisticFieldSets ? {
                            jira: {
                                replaceSpreadsheetViewFieldSets: {
                                    success: true,
                                    view: {
                                        __typename: viewData.__typename,
                                        id: viewData.id,
                                        hasDefaultFieldSets: viewData.hasDefaultFieldSets,
                                        fieldSets: {
                                            ...optimisticFieldSets
                                        }
                                    }
                                }
                            }
                        } : undefined,
                        onCompleted (data) {
                            handleCompleted(data.jira?.replaceSpreadsheetViewFieldSets?.success);
                        },
                        onError (error) {
                            handleError(error);
                        }
                    });
                }
            };
            commitFieldSets();
        });
    }, [
        onModifyColumns,
        projectContext,
        createAnalyticsEvent,
        viewData?.fieldSets?.totalCount,
        viewData.savedViewId,
        viewData.__typename,
        viewData.id,
        viewData.hasDefaultFieldSets,
        viewData.isViewConfigModified,
        showFlag,
        isInlineFieldConfigEnabled,
        projectData?.projectId,
        projectData?.key,
        viewSettings?.groupByConfig?.groupByField?.fieldId,
        viewSettings?.hideDone,
        viewSettings?.isHierarchyEnabled,
        resolvedJql,
        replaceSpreadsheetViewFieldSets,
        replaceSpreadsheetViewFieldSetsUpdater,
        replaceSpreadsheetViewFieldSetsOld
    ]);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [updateFieldSetPreferencesOld] = (0, $j4oe4.useMutation)((0, $eFy4J.default));
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [updateFieldSetPreferences] = (0, $j4oe4.useMutation)((0, $40EJa.default));
    const cloudId = (0, $cHtIB.useCloudId)();
    const updateColumnWidth = (0, $9Z7uc.useColumnWidthUpdater)(viewData.fieldSets?.__id);
    const updateColumnIsFrozen = (0, $4cTDP.fg)('issue_table_frozen_columns') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $aJqsk.useColumnIsFrozenUpdater)(viewData.fieldSets?.__id) : undefined;
    const { commitUpdateFieldSetPreferences: commitUpdateFieldSetPreferences, commitUpdateFieldSetPreferencesOld: commitUpdateFieldSetPreferencesOld } = (0, $4ciTX.useCommitFieldSetPreferences)({
        cloudId: cloudId,
        projectId: projectData?.projectId,
        viewId: viewData.id,
        isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
        updateFieldSetPreferences: updateFieldSetPreferences,
        updateFieldSetPreferencesOld: updateFieldSetPreferencesOld,
        settings: {
            groupBy: viewSettings?.groupByConfig?.groupByField?.fieldId ?? null,
            hideDone: Boolean(viewSettings?.hideDone),
            hierarchyEnabled: Boolean(viewSettings?.isHierarchyEnabled),
            jql: resolvedJql
        },
        relayViewId: viewData.__id
    });
    const onColumnFreeze = (0, $eJOHy.useCallback)((payload)=>{
        if (!isAnonymous) {
            if ((0, $4cTDP.fg)('saved_list_view_technical_changes')) {
                const savedViewId = viewData.savedViewId;
                if (savedViewId == null) throw new Error('Missing saved view ID');
                commitUpdateFieldSetPreferences(savedViewId, payload, 'isFrozen');
            } else commitUpdateFieldSetPreferencesOld(payload, 'isFrozen');
        }
        // commit local update to the store independently of the mutation result to preserve user's desired frozen state
        updateColumnIsFrozen?.(payload);
    }, [
        commitUpdateFieldSetPreferences,
        commitUpdateFieldSetPreferencesOld,
        isAnonymous,
        updateColumnIsFrozen,
        viewData.savedViewId
    ]);
    const onColumnResize = (0, $eJOHy.useCallback)((columnId, width)=>{
        // skip mutation for anonymous users as they don't have access to user preferences
        if (!isAnonymous) {
            // we intentionally don't optimistically update the store to avoid rolling back column widths
            // in case of a mutation error, which would be very jarring for the user
            if ((0, $4cTDP.fg)('saved_list_view_technical_changes')) {
                const savedViewId = viewData.savedViewId;
                if (savedViewId == null) throw new Error('Missing saved view ID');
                commitUpdateFieldSetPreferences(savedViewId, [
                    {
                        fieldSetId: columnId,
                        width: width ?? null
                    }
                ], 'width');
            } else commitUpdateFieldSetPreferencesOld([
                {
                    fieldSetId: columnId,
                    width: width ?? null
                }
            ], 'width');
        }
        // commit local update to the store independently of the mutation result to preserve user's desired width
        updateColumnWidth(columnId, width);
    }, [
        isAnonymous,
        updateColumnWidth,
        viewData.savedViewId,
        commitUpdateFieldSetPreferences,
        commitUpdateFieldSetPreferencesOld
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        (0, $jOc90.dragAndDropExperience).markInlineResponse();
    });
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            hasMaxSelectedColumns: hasMaxSelectedColumns,
            filterName: filterData?.name
        }), [
        filterData?.name,
        hasMaxSelectedColumns
    ]);
    const onRestoreDefaultColumns = (0, $eJOHy.useCallback)(()=>{
        setIsRestoringDefaultColumns(true);
        const handleCompleted = (success)=>{
            setIsRestoringDefaultColumns(false);
            if (success) {
                (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTableColumns updated', {
                    actionType: (0, $8jOO7.RESTORE_COLUMNS),
                    operationScope: (0, $awWeA.getOperationScope)(projectContext)
                });
                refresh();
            } else {
                showFlag($a32fd0fc63cfc134$var$resetColumnsErrorFlag);
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: 'commitReplaceListViewUsingResetFieldSetsMutationUnsuccessful',
                        packageName: (0, $iRahl.PACKAGE_NAME),
                        teamName: (0, $iRahl.TEAM_NAME)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
        const handleError = (error)=>{
            setIsRestoringDefaultColumns(false);
            showFlag($a32fd0fc63cfc134$var$resetColumnsErrorFlag);
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'commitReplaceListViewUsingResetFieldSetsMutationError',
                    packageName: (0, $iRahl.PACKAGE_NAME),
                    teamName: (0, $iRahl.TEAM_NAME)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        };
        if ((0, $4cTDP.fg)('saved_list_view_technical_changes')) {
            const savedViewId = viewData.savedViewId;
            if (savedViewId == null) throw new Error('Missing saved view ID');
            const variables = {
                id: savedViewId,
                amountOfColumns: (0, $8jOO7.MAX_COLUMNS),
                includeView: true,
                ...isInlineFieldConfigEnabled ? {
                    fieldSetsInput: {
                        scopedResetToDefaultFieldSets: {
                            doReset: true,
                            context: {
                                projectContext: {
                                    project: projectData?.projectId
                                }
                            }
                        }
                    }
                } : {
                    fieldSetsInput: {
                        resetToDefaultFieldSets: true
                    }
                },
                settings: {
                    groupBy: viewSettings?.groupByConfig?.groupByField?.fieldId ?? null,
                    hideDone: Boolean(viewSettings?.hideDone),
                    hierarchyEnabled: Boolean(viewSettings?.isHierarchyEnabled),
                    jql: resolvedJql
                }
            };
            replaceSpreadsheetViewFieldSets({
                variables: variables,
                updater: replaceSpreadsheetViewFieldSetsUpdater,
                onCompleted (data) {
                    handleCompleted(data.jira?.replaceSpreadsheetViewFieldSets?.success);
                },
                onError (error) {
                    handleError(error);
                }
            });
        } else {
            const variables = {
                id: viewData.id,
                amountOfColumns: (0, $8jOO7.MAX_COLUMNS),
                includeView: true,
                ...isInlineFieldConfigEnabled ? {
                    fieldSetsInput: {
                        scopedResetToDefaultFieldSets: {
                            doReset: true,
                            context: {
                                projectContext: {
                                    project: projectData?.projectId
                                }
                            }
                        }
                    }
                } : {
                    fieldSetsInput: {
                        resetToDefaultFieldSets: true
                    }
                }
            };
            replaceSpreadsheetViewFieldSetsOld({
                variables: variables,
                onCompleted (data) {
                    handleCompleted(data.jira?.replaceSpreadsheetViewFieldSets?.success);
                },
                onError (error) {
                    handleError(error);
                }
            });
        }
    }, [
        setIsRestoringDefaultColumns,
        createAnalyticsEvent,
        projectContext,
        refresh,
        showFlag,
        viewData.savedViewId,
        viewData.id,
        isInlineFieldConfigEnabled,
        projectData?.projectId,
        viewSettings?.groupByConfig?.groupByField?.fieldId,
        viewSettings?.hideDone,
        viewSettings?.isHierarchyEnabled,
        resolvedJql,
        replaceSpreadsheetViewFieldSets,
        replaceSpreadsheetViewFieldSetsUpdater,
        replaceSpreadsheetViewFieldSetsOld
    ]);
    /**
   * returns undefined if there are default field sets
   * returns undefined if the user is on filter tab but cannot edit filter
   */ const conditionalOnRestoreDefaults = $a32fd0fc63cfc134$export$539ae4acd804b244(onRestoreDefaultColumns, viewData?.hasDefaultFieldSets, (0, $4cTDP.fg)('jira_inline_field_config_gate') ? viewData?.viewId : undefined);
    const tableComponents = (0, $eJOHy.useMemo)(// We shallow merge these objects to make it easier for issue-navigator consumers to revert custom column
    // picker components, which are very NIN specific. This decision can be reconsidered if we need to introduce
    // additional nested custom components in the issue table and make those available to all consumers.
    ()=>({
            columnPicker: {
                Container: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i5UAP.ColumnPickerRemountManager), {
                        viewIdFromResponse: (0, $eibCx.parseIssueNavigatorViewIdOrDefault)(viewData.viewId)
                    }, children),
                // eslint-disable-next-line jira/ff/no-preconditioning
                ...(0, $4cTDP.fg)('saved_list_view_technical_changes') && projectContext ? {} : {
                    PopupComponent: (0, $4cTDP.fg)('jira_inline_field_config_gate') ? (0, $iZH8P.createPopupComponent)(conditionalOnRestoreDefaults) : (0, $iZH8P.default)
                }
            },
            IssueCount: $b2VjA.IssueCount,
            NoColumns: $ghzkC.NoColumns,
            NoIssues: $2PY5Q.NoIssues,
            ...overriddenTableComponents,
            ConnectionsSubscriber: ({ connections: connections, updateConnectionDetails: updateConnectionDetails })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fOH9z.BulkOpsConnectionsSubscriber), {
                    connections: connections,
                    updateConnectionDetails: updateConnectionDetails,
                    fragmentRef: issueResultsData || groupResultsData?.firstGroup?.issues || null
                })
        }), [
        projectContext,
        conditionalOnRestoreDefaults,
        overriddenTableComponents,
        viewData.viewId,
        issueResultsData,
        groupResultsData?.firstGroup?.issues
    ]);
    const conditionalOnChange = $a32fd0fc63cfc134$export$3e7a75a1659bbaae(onColumnsChange);
    const conditionalColumnLoader = $a32fd0fc63cfc134$export$90b784197d8a906f();
    const [isIFCEnabled, ifcConfig] = isInlineFieldConfigEnabled ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $i99kJ.useIFCSidebar)({
        projectKey: projectData?.key,
        projectId: projectData?.projectId,
        issues: issueResultsData ?? undefined,
        shouldShowFormulaField: (0, $4cTDP.fg)('frontier-formula-field-nin')
    }) : [
        false,
        undefined
    ];
    const resultsFragment = (0, $P01So.exclusiveGroupsOrIssuesFragment)({
        groups: groupResultsData ?? null,
        issues: issueResultsData ?? null
    });
    const isConditionalFormattingEnabled = features.isConditionalFormattingEnabled && (0, $4cTDP.fg)('jira_list_conditional_formatting');
    const formattingRules = isConditionalFormattingEnabled && (0, $4cTDP.fg)('saved_list_view_technical_changes') ? viewData?.conditionalFormattingRules ?? null : null;
    if (!resultsFragment) throw new Error('Missing groups or issues data');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
        name: "list-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32fd0fc63cfc134$var$DialogContextContainerWithGate, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        attributes: {
            currentPage: currentPage,
            isAnonymous: isAnonymous
        }
    }, resultsFragment.issues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fwdeI.AsyncRegisterShortcutDialogActions), {
        issues: resultsFragment.issues,
        selectedIssueKey: selectedIssueKey,
        eventHandlers: eventHandlers
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gTm2i.ColumnPickerMessageContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32fd0fc63cfc134$var$TableContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j6nGi.default), {
        view: (0, $4cTDP.fg)('saved_list_view_technical_changes') ? viewData : null,
        columns: viewData.fieldSets,
        onColumnsChange: conditionalOnChange,
        onRestoreDefaultColumns: conditionalOnRestoreDefaults,
        useColumnLoader: conditionalColumnLoader,
        loading: loading,
        eventHandlers: eventHandlers,
        onSelectedRowChange: onSelectedRowChange,
        selectedRow: selectedIssueIndex,
        sortField: field,
        sortDirection: direction,
        onSortChange: onSortOrderChange,
        onRefetch: onIssueSearchForColumnConfig,
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        components: tableComponents,
        issueSearchBaseUrl: "" // Relative to current route rendering the issue navigator
        ,
        isColumnPickerLoading: isColumnPickerLoading,
        projectContext: projectContext,
        isGroupingSupported: isGroupingSupported,
        isIssueCreateEnabled: true // It's already tied to the project context
        ,
        onColumnResize: onColumnResize,
        project: projectData,
        rankField: rankFieldData?.rankField,
        isIssueHierarchyEnabled: Boolean(isHierarchyEnabled),
        isGridNavigationEnabled: (0, $cxKOj.expVal)('nin_grid_navigation_experiment', 'isGridNavigationEnabled', false),
        isInlineEditingExtendedFieldSupportEnabled: (0, $cxKOj.expVal)('jira_list_inline_editing', 'isInlineEditingEnabled', false),
        isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
        isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
        ifcConfig: isIFCEnabled || (0, $4cTDP.fg)('jsc_list_category_editing_in_nin') ? ifcConfig : undefined,
        onIssueFlatListUpdated: onIssueFlatListUpdated,
        jql: resolvedJql,
        enableMultiSelect: true,
        ...(0, $cxKOj.expVal)('jira_list_reparenting', 'isReparentingEnabled', false) && {
            isReparentingEnabled: true
        },
        isSingleLineRowHeightEnabled: true,
        ...(0, $cxKOj.expVal)('jira_list_hide_done_items', 'isEnabled', false) && {
            isHideDoneItemsEnabled: isHideDoneEnabled
        },
        isMergedColumnEnabled: isMergedColumnSupportEnabled && (0, $4cTDP.fg)('jira_list_merged_column_gate'),
        formattingRules: formattingRules,
        ...infiniteScrollProps,
        ...resultsFragment,
        preloadedEntryPoints: issueTableProps?.preloadedEntryPoints,
        ...(0, $4cTDP.fg)('jsc_list_reranking_gate') && {
            isIssueRankingEnabled: (isIssueRankingSupportEnabled && viewSettings?.canEnableReranking) ?? false
        },
        isIssueOperationMeatballMenuEnabled: isRowContextMenuEnabled,
        ...isFrozenColumnSupportEnabled && (0, $4cTDP.fg)('issue_table_frozen_columns') && {
            isStickyColumnsEnabled: true,
            stickyColumnIds: stickyColumnIds,
            onColumnFreeze: onColumnFreeze,
            enableAutoUnstickyOnSmallScreen: true
        },
        isConditionalFormattingEnabled: isConditionalFormattingEnabled,
        isProjectQuickstartOnboardingEnabled: features.isProjectQuickstartOnboardingEnabled && (0, $4cTDP.fg)('jira_list_nin_merge'),
        isMakeSpaceForGlobalRovoButtonEnabled: features.isMakeSpaceForGlobalRovoButtonEnabled && (0, $4cTDP.fg)('global_rovo_button_in_jira')
    })), projectData?.projectId && projectData?.key && (0, $4cTDP.fg)('in_context_config_sidebar_changeboarding') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6TdgS.NumberFormattingChangeboardingWrapper), {
        projectId: String(projectData.projectId),
        projectKey: projectData.key
    }))), !(0, $4cTDP.fg)('empanada_nin_convert_issue_ops_to_entrypoint') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3aisD.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null)));
};
// re-render regression detection
$a32fd0fc63cfc134$var$ListView.whyDidYouRender = true;
const $a32fd0fc63cfc134$var$ListViewWithColumnPickerContext = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7auhX.ColumnPickerLoadingContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32fd0fc63cfc134$var$ListView, props));
var $a32fd0fc63cfc134$export$2e2bcd8739ae039 = (0, $2UTIe.withReportErrors)($a32fd0fc63cfc134$var$ListViewWithColumnPickerContext, {
    id: 'ui.issue-results.list-view.unhandled',
    packageName: (0, $iRahl.PACKAGE_NAME),
    teamName: (0, $iRahl.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $c12HM.isLoaderErrorAttributes)
});
const $a32fd0fc63cfc134$var$TableContainerStyles = (0, $1DXK0.xcss)({
    flexGrow: 1,
    flexBasis: 0,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    flexDirection: 'column'
});

});
parcelRegister("40EJa", function(module, exports) {
$parcel$export(module.exports, "default", () => $7628095111a7e379$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<57749c6f4b58bdec67cede0c275f7d48>>
 * @relayHash 95e90ebeebc33fb4193641faa01c7d28
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 51ba935dd2a63cc3f7e0f9ed6322d6308c1fe5a956c0ea38b7bd88929a1c328c
const $7628095111a7e379$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "context"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "settings"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "context",
            "variableName": "context"
        },
        {
            "kind": "Variable",
            "name": "fieldSetPreferencesInput",
            "variableName": "input"
        },
        {
            "kind": "Variable",
            "name": "viewId",
            "variableName": "viewId"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "success"
    }, v7 = {
        "kind": "ScalarField",
        "name": "message"
    }, v8 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v9 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "settings",
                        "variableName": "settings"
                    }
                ],
                "kind": "ScalarField",
                "name": "isViewConfigModified"
            }
        ],
        "type": "JiraIssueSearchViewMetadata",
        "abstractKey": "__isJiraIssueSearchViewMetadata"
    }, v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_updateFieldSetPreferencesMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraFieldSetPreferencesUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateUserFieldSetPreferences",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "view",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "main_updateFieldSetPreferencesMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraFieldSetPreferencesUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateUserFieldSetPreferences",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "view",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "51ba935dd2a63cc3f7e0f9ed6322d6308c1fe5a956c0ea38b7bd88929a1c328c",
            "metadata": {},
            "name": "main_updateFieldSetPreferencesMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$7628095111a7e379$var$node.hash = "b60b49cc5a0a1e4323f0c3ed83da042f";
var $7628095111a7e379$export$2e2bcd8739ae039 = $7628095111a7e379$var$node;

});

parcelRegister("eFy4J", function(module, exports) {
$parcel$export(module.exports, "default", () => $6921b4609fe0770f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7926b7f40bab48224fd58648fac831f4>>
 * @relayHash 1f76887d80ab54c5ed58b9cac736e99c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 18799054b9f9df47ee35aa2417ce2a89320a98ac0173871a1d2c3c5699487081
const $6921b4609fe0770f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "context"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v4 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "context",
                            "variableName": "context"
                        },
                        {
                            "kind": "Variable",
                            "name": "fieldSetPreferencesInput",
                            "variableName": "input"
                        },
                        {
                            "kind": "Variable",
                            "name": "viewId",
                            "variableName": "viewId"
                        }
                    ],
                    "concreteType": "JiraFieldSetPreferencesUpdatePayload",
                    "kind": "LinkedField",
                    "name": "updateUserFieldSetPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_updateFieldSetPreferencesOldMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "main_updateFieldSetPreferencesOldMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "id": "18799054b9f9df47ee35aa2417ce2a89320a98ac0173871a1d2c3c5699487081",
            "metadata": {},
            "name": "main_updateFieldSetPreferencesOldMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$6921b4609fe0770f$var$node.hash = "79dafbbd02110a6070a65f2d9ad7f6a9";
var $6921b4609fe0770f$export$2e2bcd8739ae039 = $6921b4609fe0770f$var$node;

});

parcelRegister("glwcG", function(module, exports) {
$parcel$export(module.exports, "default", () => $d62e7868c66628ea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<37e2eaeacf71cc1fec888d41c414ed04>>
 * @relayHash 9a8a41306aed62f87ed69c35a497e9d0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 47de39dc842a82a8f805b878a607d9665051e82a56f85fed777727cea0de24fb

var $2Z4v6 = parcelRequire("2Z4v6");

var $8Qoc7 = parcelRequire("8Qoc7");
const $d62e7868c66628ea$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsScope"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeView"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "settings"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "success"
    }, v8 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "fieldSetsScope"
    }, v9 = {
        "args": [
            v8 /*: any*/ 
        ],
        "kind": "ScalarField",
        "name": "hasDefaultFieldSets"
    }, v10 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "fieldSetSelectedState": "SELECTED"
            }
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        },
        v8 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v12 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v13 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v14 = {
        "args": [
            {
                "kind": "Variable",
                "name": "settings",
                "variableName": "settings"
            }
        ],
        "kind": "ScalarField",
        "name": "isViewConfigModified"
    }, v15 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_replaceSpreadsheetViewFieldSetsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraSpreadsheetViewPayload",
                            "kind": "LinkedField",
                            "name": "replaceSpreadsheetViewFieldSets",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "condition": "includeView",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "view",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "args": v10 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v12 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "NativeIssueTableWithSelectedIssuesProvider_columns"
                                                        },
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "view",
                                    "plural": false,
                                    "selections": [
                                        v14 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "main_replaceSpreadsheetViewFieldSetsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraSpreadsheetViewPayload",
                            "kind": "LinkedField",
                            "name": "replaceSpreadsheetViewFieldSets",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "view",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeView",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "view",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "args": v10 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v12 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        },
                                                                        v15 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jqlTerm"
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "aliases"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isSortable"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldSetPreferences",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetPreferences",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "width"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldsMetadata",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueSearchMetadataField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "canBeConfigured"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "fieldId"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ClientExtension",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isPlaceHolderField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldType",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v15 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "47de39dc842a82a8f805b878a607d9665051e82a56f85fed777727cea0de24fb",
            "metadata": {},
            "name": "main_replaceSpreadsheetViewFieldSetsMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": (0, $8Qoc7.default)
            }
        }
    };
}();
$d62e7868c66628ea$var$node.hash = "06de1521c52d260c740e37830e5352ea";
var $d62e7868c66628ea$export$2e2bcd8739ae039 = $d62e7868c66628ea$var$node;

});

parcelRegister("6JLeN", function(module, exports) {
$parcel$export(module.exports, "default", () => $57f1419744ed268a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3b9b59a6298ef12fc98adba527d34891>>
 * @relayHash 49115defa30d971af69ad892e8f10a63
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0d3f9ea5551b8c97bd70bc9f0b3330d2a290adaf294dd79bb415b6555645ad56

var $2Z4v6 = parcelRequire("2Z4v6");

var $8Qoc7 = parcelRequire("8Qoc7");
const $57f1419744ed268a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsScope"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeView"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "success"
    }, v7 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "fieldSetsScope"
    }, v8 = {
        "args": [
            v7 /*: any*/ 
        ],
        "kind": "ScalarField",
        "name": "hasDefaultFieldSets"
    }, v9 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "fieldSetSelectedState": "SELECTED"
            }
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        },
        v7 /*: any*/ 
    ], v10 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v11 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v12 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_replaceSpreadsheetViewFieldSetsOldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraSpreadsheetViewPayload",
                            "kind": "LinkedField",
                            "name": "replaceSpreadsheetViewFieldSets",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "condition": "includeView",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "view",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "args": v9 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v11 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "NativeIssueTableWithSelectedIssuesProvider_columns"
                                                        },
                                                        v12 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "main_replaceSpreadsheetViewFieldSetsOldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraSpreadsheetViewPayload",
                            "kind": "LinkedField",
                            "name": "replaceSpreadsheetViewFieldSets",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "condition": "includeView",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "view",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "args": v9 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        },
                                                                        v13 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jqlTerm"
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "aliases"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isSortable"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldSetPreferences",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetPreferences",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "width"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldsMetadata",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueSearchMetadataField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "canBeConfigured"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "fieldId"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ClientExtension",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isPlaceHolderField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldType",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v13 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0d3f9ea5551b8c97bd70bc9f0b3330d2a290adaf294dd79bb415b6555645ad56",
            "metadata": {},
            "name": "main_replaceSpreadsheetViewFieldSetsOldMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": (0, $8Qoc7.default)
            }
        }
    };
}();
$57f1419744ed268a$var$node.hash = "8b47ebf89470f9c9344f5f4f4886fd1a";
var $57f1419744ed268a$export$2e2bcd8739ae039 = $57f1419744ed268a$var$node;

});

parcelRegister("f7xI3", function(module, exports) {
$parcel$export(module.exports, "default", () => $e48ef5e4e11b0346$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8a5ad82a479f5ac2e6af06064471dd3c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e48ef5e4e11b0346$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_ListView_rankField",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraJqlFieldWithAliases",
                    "kind": "LinkedField",
                    "name": "rankField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "NativeIssueTableWithSelectedIssuesProvider_rankField"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$e48ef5e4e11b0346$var$node.hash = "5917ccfddd568a4d072c5c55fdc08be7";
var $e48ef5e4e11b0346$export$2e2bcd8739ae039 = $e48ef5e4e11b0346$var$node;

});

parcelRegister("aVrHl", function(module, exports) {
$parcel$export(module.exports, "default", () => $27c814dcf9f3e2f2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b1ac4ee09aa06d0c162ef3bdadd8c445>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $27c814dcf9f3e2f2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_ListView_filter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$27c814dcf9f3e2f2$var$node.hash = "42fd583d4b19e59270b0aa45271f2d67";
var $27c814dcf9f3e2f2$export$2e2bcd8739ae039 = $27c814dcf9f3e2f2$var$node;

});

parcelRegister("8WH6X", function(module, exports) {
$parcel$export(module.exports, "default", () => $6427f0ea21e6b572$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6464b78bb2c25bea540b39889b343b3e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6427f0ea21e6b572$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_ListView_project",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "NativeIssueTableWithSelectedIssuesProvider_project"
        }
    ],
    "type": "JiraProject"
};
$6427f0ea21e6b572$var$node.hash = "8429ee65a98f4c29a945e4ef4746727a";
var $6427f0ea21e6b572$export$2e2bcd8739ae039 = $6427f0ea21e6b572$var$node;

});

parcelRegister("45LXf", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9cce5e943aa7c98$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<82a12dc557334dbded420fabfdb9222b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c9cce5e943aa7c98$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "settings",
        "variableName": "settings"
    }, v1 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "fieldSetsScope"
    }, v2 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "amountOfColumns"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsScope"
            },
            {
                "kind": "RootArgument",
                "name": "groupBy"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "settings"
            },
            {
                "kind": "RootArgument",
                "name": "staticViewInput"
            }
        ],
        "kind": "Fragment",
        "name": "main_issueNavigator_ListView_view",
        "selections": [
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "NativeIssueTableWithSelectedIssuesProvider"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "savedViewId"
                    },
                    {
                        "args": [
                            v0 /*: any*/ 
                        ],
                        "kind": "ScalarField",
                        "name": "isViewConfigModified"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "viewId"
                },
                "action": "THROW",
                "path": "viewId"
            },
            {
                "args": [
                    v1 /*: any*/ 
                ],
                "kind": "ScalarField",
                "name": "hasDefaultFieldSets"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                            "fieldSetSelectedState": "SELECTED"
                        }
                    },
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "amountOfColumns"
                    },
                    v1 /*: any*/ 
                ],
                "concreteType": "JiraIssueSearchFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSets",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "totalCount"
                    },
                    {
                        "concreteType": "JiraIssueSearchFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueSearchFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "fieldSetId"
                                    },
                                    {
                                        "concreteType": "JiraFieldSetPreferences",
                                        "kind": "LinkedField",
                                        "name": "fieldSetPreferences",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isFrozen"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "NativeIssueTableWithSelectedIssuesProvider_columns"
                    },
                    v2 /*: any*/ 
                ]
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "groupBy",
                                "variableName": "groupBy"
                            },
                            {
                                "kind": "Variable",
                                "name": "issueSearchInput",
                                "variableName": "issueSearchInput"
                            },
                            v0 /*: any*/ ,
                            {
                                "kind": "Variable",
                                "name": "staticViewInput",
                                "variableName": "staticViewInput"
                            }
                        ],
                        "concreteType": "JiraIssueSearchViewConfigSettings",
                        "kind": "LinkedField",
                        "name": "viewSettings",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "canEnableHierarchy"
                            },
                            {
                                "concreteType": "JiraSpreadsheetGroupByConfig",
                                "kind": "LinkedField",
                                "name": "groupByConfig",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraField",
                                        "kind": "LinkedField",
                                        "name": "groupByField",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "fieldId"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isHierarchyEnabled"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hideDone"
                            },
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "canEnableReranking"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    }
                                ],
                                "concreteType": "JiraFormattingRuleConnection",
                                "kind": "LinkedField",
                                "name": "conditionalFormattingRules",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "NativeIssueTableWithSelectedIssuesProvider_rules"
                                    }
                                ],
                                "storageKey": "conditionalFormattingRules(first:20)"
                            }
                        ]
                    }
                ],
                "type": "JiraSpreadsheetView",
                "abstractKey": "__isJiraSpreadsheetView"
            },
            v2 /*: any*/ 
        ],
        "type": "JiraIssueSearchViewMetadata",
        "abstractKey": "__isJiraIssueSearchViewMetadata"
    };
}();
$c9cce5e943aa7c98$var$node.hash = "47cd678fe015cb5887c2804f7e15dbca";
var $c9cce5e943aa7c98$export$2e2bcd8739ae039 = $c9cce5e943aa7c98$var$node;

});

parcelRegister("iDMnF", function(module, exports) {
$parcel$export(module.exports, "default", () => $5faa479f78158c32$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4653926638fbdd2add09b9d89d412ba2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5faa479f78158c32$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "viewConfigInput",
        "variableName": "viewConfigInput"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsScope"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isPaginating"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "settings"
            },
            {
                "kind": "RootArgument",
                "name": "viewConfigInput"
            }
        ],
        "kind": "Fragment",
        "name": "main_issueNavigator_ListView_groupResults",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "isPaginating",
                        "variableName": "isPaginating"
                    },
                    {
                        "kind": "Variable",
                        "name": "projectKey",
                        "variableName": "projectKey"
                    },
                    {
                        "kind": "Variable",
                        "name": "projectKeys",
                        "variableName": "projectKeys"
                    },
                    v0 /*: any*/ 
                ],
                "kind": "FragmentSpread",
                "name": "NativeIssueTableWithSelectedIssuesProvider_group"
            },
            {
                "condition": "isPaginating",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "JiraSpreadsheetGroup",
                        "kind": "LinkedField",
                        "name": "firstGroup",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "fieldSetsInput",
                                        "variableName": "fieldSetsInput"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 50
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "scope",
                                        "variableName": "fieldSetsScope"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "settings",
                                        "variableName": "settings"
                                    },
                                    v0 /*: any*/ 
                                ],
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "issues",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ui_issueNavigatorBulkOperationsConnectionsSubscriber_BulkOpsConnectionsSubscriber"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraSpreadsheetGroupConnection"
    };
}();
$5faa479f78158c32$var$node.hash = "e6b6bb177338755314ae9f53f351e67f";
var $5faa479f78158c32$export$2e2bcd8739ae039 = $5faa479f78158c32$var$node;

});

parcelRegister("hxlpC", function(module, exports) {
$parcel$export(module.exports, "default", () => $0aab94da33569269$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<87191c990e3944a970bd3e7cfbb3949d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0aab94da33569269$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_ListView_issueResults",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "registerShortcutDialogActions_issueNavigator_RegisterShortcutsDialogActions"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "NativeIssueTableWithSelectedIssuesProvider_issues"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "maxCursors",
                            "value": 7
                        }
                    ],
                    "concreteType": "JiraPageCursors",
                    "kind": "LinkedField",
                    "name": "pageCursors",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraPageCursor",
                            "kind": "LinkedField",
                            "name": "around",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "pageNumber"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCurrent"
                                }
                            ]
                        }
                    ],
                    "storageKey": "pageCursors(maxCursors:7)"
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "JiraIssueNavigatorPageInfo",
                    "kind": "LinkedField",
                    "name": "issueNavigatorPageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "firstIssuePosition"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_issueNavigatorBulkOperationsConnectionsSubscriber_BulkOpsConnectionsSubscriber"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "InlineFieldConfigContentCreate"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "InlineFieldConfigContentEdit"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$0aab94da33569269$var$node.hash = "79d164d2d38323c645f6c5522c7f92bc";
var $0aab94da33569269$export$2e2bcd8739ae039 = $0aab94da33569269$var$node;

});

parcelRegister("6TdgS", function(module, exports) {
$parcel$export(module.exports, "NumberFormattingChangeboardingWrapper", () => $5e8d75e58d8638ec$export$10ed3f5d34ac7576);

var $eJOHy = parcelRequire("eJOHy");

var $iWvkh = parcelRequire("iWvkh");

var $5V25X = parcelRequire("5V25X");

var $5vQ2T = parcelRequire("5vQ2T");

var $cBavF = parcelRequire("cBavF");

var $eU7vk = parcelRequire("eU7vk");

var $5Q8dn = parcelRequire("5Q8dn");

var $4cTDP = parcelRequire("4cTDP");

var $67Hrv = parcelRequire("67Hrv");

var $iMQSg = parcelRequire("iMQSg");


var $4gH81 = parcelRequire("4gH81");
const $5e8d75e58d8638ec$var$NumberFormattingChangeboarding = ({ projectId: projectId, projectKey: projectKey })=>{
    const { isActive: isActive } = (0, $5V25X.useTrigger)((0, $009a72c63c9d7dca$export$c2ff6ab935be7852));
    const data = (0, $iMQSg.useFetchCriteria)(projectId, projectKey, isActive && (0, $4cTDP.fg)('in_context_config_sidebar_changeboarding'));
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $67Hrv.asyncNumberFormattingFlagEntryPoint), {});
    const meetsCriteria = data !== undefined && data?.hasExistingNumberFieldWithFormatStyle !== true && data?.isProjectAdmin && data?.isTMP;
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (!meetsCriteria) {
            (0, $4gH81.emitMessageEvent)({
                action: 'filter'
            });
            return;
        }
        if (isActive && !(0, $4cTDP.fg)('in_context_config_sidebar_changeboarding')) {
            (0, $4gH81.emitMessageEvent)({
                action: 'snooze'
            });
            return;
        }
        entryPointActions.load();
    }, [
        entryPointActions,
        meetsCriteria,
        data,
        isActive
    ]);
    if (!meetsCriteria || !isActive) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "number-currency-formatting-changeboarding-flag",
        packageName: "@jira/number-currency-formatting-changeboarding-flag",
        teamName: "a4t-tanuki",
        fallback: null,
        errorFallback: "unmount",
        runtimeProps: {
            projectKey: projectKey,
            projectType: data.projectType ?? undefined
        }
    });
};
const $5e8d75e58d8638ec$export$10ed3f5d34ac7576 = ({ projectId: projectId, projectKey: projectKey })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "public-forms-changeboarding-modal",
        packageName: "@atlassian/jira-public-forms-changeboarding-modal",
        teamName: "a4t-tanuki",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eU7vk.ApolloClientProvider), {
        client: (0, $5Q8dn.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5e8d75e58d8638ec$var$NumberFormattingChangeboarding, {
        projectId: projectId,
        projectKey: projectKey
    })));
};

});
parcelRegister("eU7vk", function(module, exports) {
$parcel$export(module.exports, "resetCache", () => $fbd5fc7ffb4125dd$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "resetCacheAsync", () => $fbd5fc7ffb4125dd$export$cd62f60830f74ae2);
$parcel$export(module.exports, "getClient", () => $fbd5fc7ffb4125dd$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $fbd5fc7ffb4125dd$export$8e363dbef886ff17);

var $eJOHy = parcelRequire("eJOHy");

var $9Dhvc = parcelRequire("9Dhvc");

var $688i3 = parcelRequire("688i3");
const $fbd5fc7ffb4125dd$var$CLIENTS_CACHE = {};
const $fbd5fc7ffb4125dd$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[clientId];
};
const $fbd5fc7ffb4125dd$export$cd62f60830f74ae2 = async (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    const client = $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[clientId];
    delete $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[clientId];
    await client?.clearStore();
};
const $fbd5fc7ffb4125dd$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($fbd5fc7ffb4125dd$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[key].extract()
        }), {});
const $fbd5fc7ffb4125dd$export$6bb76d6eba7e258c = ({ clientId: clientId, clientCreator: clientCreator })=>{
    let client = $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator();
        $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $fbd5fc7ffb4125dd$export$8e363dbef886ff17 extends (0, $eJOHy.Component) {
    getClient() {
        return $fbd5fc7ffb4125dd$export$6bb76d6eba7e258c(this.props.client);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        const client = this.getClient();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $688i3.ApolloProvider), {
            client: client
        }, children);
    }
}

});
parcelRegister("688i3", function(module, exports) {
$parcel$export(module.exports, "getApolloContext", () => $4769ebafec57fcc9$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $4769ebafec57fcc9$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $4769ebafec57fcc9$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $4769ebafec57fcc9$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $4769ebafec57fcc9$export$8f49e4af10703ce3);

var $eJOHy = parcelRequire("eJOHy");

var $lDEi6 = parcelRequire("lDEi6");
var $4769ebafec57fcc9$var$apolloContext;
function $4769ebafec57fcc9$export$a47505d961ee3a1() {
    if (!$4769ebafec57fcc9$var$apolloContext) $4769ebafec57fcc9$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({});
    return $4769ebafec57fcc9$var$apolloContext;
}
function $4769ebafec57fcc9$export$c2ee824bcc89ca6a() {
    $4769ebafec57fcc9$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({});
}
var $4769ebafec57fcc9$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $4769ebafec57fcc9$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $lDEi6.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $4769ebafec57fcc9$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $4769ebafec57fcc9$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $lDEi6.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $4769ebafec57fcc9$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($4769ebafec57fcc9$export$d1d99cf900472499 || ($4769ebafec57fcc9$export$d1d99cf900472499 = {}));
var $4769ebafec57fcc9$var$cache = new Map();
function $4769ebafec57fcc9$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $4769ebafec57fcc9$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $4769ebafec57fcc9$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $4769ebafec57fcc9$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $4769ebafec57fcc9$export$8f49e4af10703ce3(document) {
    var cached = $4769ebafec57fcc9$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $lDEi6.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $lDEi6.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $lDEi6.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $4769ebafec57fcc9$export$d1d99cf900472499.Query : $4769ebafec57fcc9$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $4769ebafec57fcc9$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $lDEi6.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $4769ebafec57fcc9$var$cache.set(document, payload);
    return payload;
}

});


parcelRegister("5Q8dn", function(module, exports) {
$parcel$export(module.exports, "default", () => $2939e4856f212b8f$export$2e2bcd8739ae039);

var $9Dhvc = parcelRequire("9Dhvc");

var $ifBQy = parcelRequire("ifBQy");

var $eezJL = parcelRequire("eezJL");

var $7oe8F = parcelRequire("7oe8F");

var $i8eSF = parcelRequire("i8eSF");

var $eHpnE = parcelRequire("eHpnE");

var $a6bRt = parcelRequire("a6bRt");

var $g4okI = parcelRequire("g4okI");

var $eSnSE = parcelRequire("eSnSE");

var $1fQNI = parcelRequire("1fQNI");

var $dk1mg = parcelRequire("dk1mg");

var $gLqE0 = parcelRequire("gLqE0");


const $2939e4856f212b8f$var$GIRA_APOLLO_CLIENT_ID = 'gira';
const $2939e4856f212b8f$var$CACHE_NAME = `apollo-cache/${$2939e4856f212b8f$var$GIRA_APOLLO_CLIENT_ID}`;
const $2939e4856f212b8f$var$LOG_NAMESPACE = `apollo.${$2939e4856f212b8f$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $2939e4856f212b8f$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
const $2939e4856f212b8f$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
const $2939e4856f212b8f$export$851a7159daf49c89 = new (0, $ifBQy.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($dk1mg))
});
const $2939e4856f212b8f$var$errorLink = (0, $i8eSF.onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    // Ignore network errors as they will be logged in the retry link
    (0, $gLqE0.reportErrors)({
        graphQLErrors: graphQLErrors,
        operation: operation
    });
    // Skip default error logging if analytics context data is defined for the query.
    const errorAnalytics = (0, $gLqE0.getErrorAnalyticsContext)(operation.getContext());
    if (errorAnalytics !== undefined) return;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, $eSnSE.default).safeErrorWithoutCustomerData($2939e4856f212b8f$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                message: JSON.stringify(message),
                path: JSON.stringify(path),
                locations: JSON.stringify(locations)
            }));
        else (0, $eSnSE.default).safeErrorWithoutCustomerData($2939e4856f212b8f$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
            message: JSON.stringify(graphQLErrors)
        });
    }
    if (networkError) {
        const occuredNetworkErrorsBefore = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(operation.getContext(), [
            $2939e4856f212b8f$var$NETWORK_ERRORS_COUNTER_KEY
        ], 0);
        (0, $eSnSE.default).safeErrorWithoutCustomerData($2939e4856f212b8f$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
        operation.setContext({
            [$2939e4856f212b8f$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
        });
    }
});
const $2939e4856f212b8f$var$retryLinkWithFama = new (0, $a6bRt.RetryLink)({
    delay: {
        initial: 300,
        max: 120000,
        jitter: true
    },
    attempts: (count, operation, networkError)=>{
        const retry = count < 5 && networkError && !networkError.statusCode;
        // Don't report any error if we're going to attempt a retry
        if (!retry) (0, $gLqE0.reportErrors)({
            networkError: networkError,
            operation: operation
        });
        return retry;
    }
});
class $2939e4856f212b8f$var$CancelableRequestLink extends (0, $7oe8F.ApolloLink) {
    constructor(){
        super();
        this.inFlightRequestControllers = {};
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request(operation, forward) {
        const context = operation.getContext();
        if (!context.cancelable) return forward(operation);
        const key = JSON.stringify([
            operation.operationName,
            operation.query
        ]); // Equivalent to `operation.toKey` less the _actual_ variables
        this.inFlightRequestControllers[key]?.abort(); // Always abort the previous request
        const abortController = new AbortController();
        operation.setContext({
            ...context,
            fetchOptions: {
                signal: abortController.signal
            } // HttpLink passes this directly to fetch implementation
        });
        this.inFlightRequestControllers[key] = abortController;
        const cleanup = ()=>{
            // This callback may be called long after the request is replaced
            if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new (0, $7oe8F.Observable)((observer)=>{
            const subscription = forward(operation).subscribe({
                next: observer.next.bind(observer),
                // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
                error: (error)=>{
                    observer.error(error);
                    cleanup();
                },
                complete: observer.complete.bind(observer)
            });
            return ()=>{
                subscription?.unsubscribe();
                cleanup();
            };
        });
    }
}
const $2939e4856f212b8f$var$cache = new (0, $ifBQy.InMemoryCache)({
    cacheRedirects: {
        Query: {
            ...(0, $g4okI.fragmentCacheRedirect)()
        }
    },
    fragmentMatcher: $2939e4856f212b8f$export$851a7159daf49c89,
    dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
})// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
.restore(!$2939e4856f212b8f$var$isSsrSuccessful() && window.SPA_STATE[$2939e4856f212b8f$var$CACHE_NAME] || {});
const $2939e4856f212b8f$export$de66868aab9e79ea = (originUrl = '')=>new (0, $eezJL.ApolloClient)({
        name: $2939e4856f212b8f$var$GIRA_APOLLO_CLIENT_ID,
        ssrMode: $2939e4856f212b8f$var$isSsrSuccessful(),
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; ssrMode: boolean; addTypename: boolean; link: ApolloLink; cache: InMemoryCache; connectToDevTools: boolean; }' is not assignable to parameter of type 'ApolloClientOptions<NormalizedCacheObject>'.
        addTypename: true,
        link: (0, $7oe8F.ApolloLink).from([
            $2939e4856f212b8f$var$retryLinkWithFama,
            $2939e4856f212b8f$var$errorLink,
            (0, $1fQNI.UFOLoggerLink),
            (0, $g4okI.fragmentLinkState)($2939e4856f212b8f$var$cache),
            ...!$2939e4856f212b8f$var$isSsrSuccessful() ? [
                new $2939e4856f212b8f$var$CancelableRequestLink()
            ] : [],
            new (0, $eHpnE.HttpLink)({
                uri: ({ operationName: operationName })=>`${originUrl}/rest/${$2939e4856f212b8f$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                credentials: 'same-origin',
                // @ts-expect-error - TS2345 - Argument of type '{ uri: ({ operationName }: Operation) => string; credentials: string; abortErrorDoesNotCauseError: boolean; }' is not assignable to parameter of type 'Options'.
                abortErrorDoesNotCauseError: !$2939e4856f212b8f$var$isSsrSuccessful()
            })
        ].filter(Boolean)),
        cache: $2939e4856f212b8f$var$cache,
        connectToDevTools: false
    });
var $2939e4856f212b8f$export$2e2bcd8739ae039 = {
    clientId: $2939e4856f212b8f$var$GIRA_APOLLO_CLIENT_ID,
    clientCreator: $2939e4856f212b8f$export$de66868aab9e79ea
};

});
parcelRegister("ifBQy", function(module, exports) {
$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $d496fc3ebf2f1ece$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $d496fc3ebf2f1ece$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $d496fc3ebf2f1ece$export$467265324939f47f);

var $dnskZ = parcelRequire("dnskZ");

var $8haCz = parcelRequire("8haCz");

var $jFDfc = parcelRequire("jFDfc");
var $hR4hP = parcelRequire("hR4hP");

var $9WJrj = parcelRequire("9WJrj");

var $lDEi6 = parcelRequire("lDEi6");
var $d496fc3ebf2f1ece$var$haveWarned = false;
function $d496fc3ebf2f1ece$var$shouldWarn() {
    var answer = !$d496fc3ebf2f1ece$var$haveWarned;
    if (!(0, $jFDfc.isTest)()) $d496fc3ebf2f1ece$var$haveWarned = true;
    return answer;
}
var $d496fc3ebf2f1ece$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $d496fc3ebf2f1ece$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $d496fc3ebf2f1ece$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $d496fc3ebf2f1ece$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $lDEi6.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $lDEi6.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $d496fc3ebf2f1ece$var$hasOwn = Object.prototype.hasOwnProperty;
var $d496fc3ebf2f1ece$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $9WJrj.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($d496fc3ebf2f1ece$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$d496fc3ebf2f1ece$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $d496fc3ebf2f1ece$var$defaultNormalizedCacheFactory(seed) {
    return new $d496fc3ebf2f1ece$var$DepTrackingCache(seed);
}
var $d496fc3ebf2f1ece$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $9WJrj.KeyTrie)((0, $jFDfc.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $9WJrj.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $d496fc3ebf2f1ece$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $9WJrj.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d496fc3ebf2f1ece$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $9WJrj.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d496fc3ebf2f1ece$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $jFDfc.getQueryDefinition)(query);
        variables = (0, $jFDfc.assign)({}, (0, $jFDfc.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $lDEi6.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $hR4hP.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $d496fc3ebf2f1ece$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $jFDfc.getMainDefinition)(query);
        var fragments = (0, $jFDfc.getFragmentDefinitions)(query);
        var fragmentMap = (0, $jFDfc.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jFDfc.shouldInclude)(selection, variables)) return;
            if ((0, $jFDfc.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $jFDfc.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $jFDfc.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $lDEi6.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $jFDfc.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $jFDfc.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $jFDfc.resultKeyNameFromField)(field),
            directives: (0, $jFDfc.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $d496fc3ebf2f1ece$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $d496fc3ebf2f1ece$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $d496fc3ebf2f1ece$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $d496fc3ebf2f1ece$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $jFDfc.isIdValue)(value)) throw new (0, $lDEi6.InvariantError)(10);
}
function $d496fc3ebf2f1ece$var$defaultFragmentMatcher() {
    return true;
}
function $d496fc3ebf2f1ece$export$7a4899fe13f33235(idValue) {
    (0, $lDEi6.invariant)((0, $jFDfc.isIdValue)(idValue), 11);
}
function $d496fc3ebf2f1ece$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $jFDfc.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $jFDfc.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $jFDfc.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $d496fc3ebf2f1ece$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $d496fc3ebf2f1ece$export$7e2b40d1002de152(seed) {
    return new $d496fc3ebf2f1ece$export$ee7258b8691956a3(seed);
}
var $d496fc3ebf2f1ece$export$de4e6870dc6ac801 = function(_super) {
    (0, $dnskZ.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $d496fc3ebf2f1ece$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $d496fc3ebf2f1ece$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $d496fc3ebf2f1ece$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $d496fc3ebf2f1ece$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $d496fc3ebf2f1ece$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $jFDfc.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $jFDfc.assign)({}, (0, $jFDfc.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $jFDfc.createFragmentMap)((0, $jFDfc.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $d496fc3ebf2f1ece$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jFDfc.shouldInclude)(selection, variables)) return;
            if ((0, $jFDfc.isField)(selection)) {
                var resultFieldKey = (0, $jFDfc.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $jFDfc.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $lDEi6.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $jFDfc.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $d496fc3ebf2f1ece$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $jFDfc.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $jFDfc.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$d496fc3ebf2f1ece$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $lDEi6.invariant)(!semanticId || !$d496fc3ebf2f1ece$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d496fc3ebf2f1ece$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $jFDfc.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $jFDfc.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $lDEi6.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $lDEi6.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $d496fc3ebf2f1ece$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $hR4hP.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d496fc3ebf2f1ece$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $jFDfc.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $d496fc3ebf2f1ece$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $d496fc3ebf2f1ece$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $jFDfc.isIdValue)(value) && $d496fc3ebf2f1ece$var$isGeneratedId(value.id) && (0, $jFDfc.isIdValue)(realValue) && !(0, $hR4hP.equal)(value, realValue) && $d496fc3ebf2f1ece$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, generated), real);
    if ((0, $hR4hP.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $d496fc3ebf2f1ece$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $d496fc3ebf2f1ece$var$defaultConfig = {
    fragmentMatcher: new $d496fc3ebf2f1ece$export$5d3fcf53267091de(),
    dataIdFromObject: $d496fc3ebf2f1ece$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $d496fc3ebf2f1ece$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $d496fc3ebf2f1ece$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $d496fc3ebf2f1ece$var$OptimisticCacheLayer = function(_super) {
    (0, $dnskZ.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $d496fc3ebf2f1ece$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($d496fc3ebf2f1ece$export$ee7258b8691956a3);
var $d496fc3ebf2f1ece$export$467265324939f47f = function(_super) {
    (0, $dnskZ.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $9WJrj.KeyTrie)((0, $jFDfc.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, $d496fc3ebf2f1ece$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $d496fc3ebf2f1ece$var$DepTrackingCache() : new $d496fc3ebf2f1ece$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $d496fc3ebf2f1ece$export$eb8361c5d132fb8f();
        _this.storeReader = new $d496fc3ebf2f1ece$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $9WJrj.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $d496fc3ebf2f1ece$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $lDEi6.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $d496fc3ebf2f1ece$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $d496fc3ebf2f1ece$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $jFDfc.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $8haCz.ApolloCache));

});
parcelRegister("8haCz", function(module, exports) {
$parcel$export(module.exports, "ApolloCache", () => $60682668fc3daa4e$export$5fc74f25506aa9c);

var $jFDfc = parcelRequire("jFDfc");
function $60682668fc3daa4e$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $60682668fc3daa4e$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $60682668fc3daa4e$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $60682668fc3daa4e$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $60682668fc3daa4e$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $60682668fc3daa4e$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $60682668fc3daa4e$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $60682668fc3daa4e$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $60682668fc3daa4e$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $jFDfc.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $jFDfc.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $60682668fc3daa4e$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $60682668fc3daa4e$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $60682668fc3daa4e$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $60682668fc3daa4e$export$94affb487e701bf2;
$60682668fc3daa4e$export$94affb487e701bf2 || ($60682668fc3daa4e$export$94affb487e701bf2 = {});

});

parcelRegister("9WJrj", function(module, exports) {
$parcel$export(module.exports, "KeyTrie", () => $73dcc72a68d15397$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $73dcc72a68d15397$export$4997ffc0176396a6);

var $hUWo2 = parcelRequire("hUWo2");
function $73dcc72a68d15397$var$defaultDispose() {}
var $73dcc72a68d15397$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $73dcc72a68d15397$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $73dcc72a68d15397$var$parentEntrySlot = new (0, $hUWo2.Slot)();
var $73dcc72a68d15397$var$reusableEmptyArray = [];
var $73dcc72a68d15397$var$emptySetPool = [];
var $73dcc72a68d15397$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $73dcc72a68d15397$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $73dcc72a68d15397$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $73dcc72a68d15397$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $73dcc72a68d15397$var$valueCopy(value) {
    return value.slice(0);
}
var $73dcc72a68d15397$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $73dcc72a68d15397$var$assert(!this.recomputing, "already recomputing");
        if (!$73dcc72a68d15397$var$rememberParent(this) && $73dcc72a68d15397$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $73dcc72a68d15397$var$mightBeDirty(this) ? $73dcc72a68d15397$var$reallyRecompute(this) : $73dcc72a68d15397$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $73dcc72a68d15397$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $73dcc72a68d15397$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $73dcc72a68d15397$var$forgetChildren(this).forEach($73dcc72a68d15397$var$maybeReportOrphan);
        $73dcc72a68d15397$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $73dcc72a68d15397$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $73dcc72a68d15397$var$rememberParent(child) {
    var parent = $73dcc72a68d15397$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($73dcc72a68d15397$var$mightBeDirty(child)) $73dcc72a68d15397$var$reportDirtyChild(parent, child);
        else $73dcc72a68d15397$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $73dcc72a68d15397$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $73dcc72a68d15397$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $73dcc72a68d15397$var$parentEntrySlot.withValue(entry, $73dcc72a68d15397$var$recomputeNewValue, [
        entry
    ]);
    if ($73dcc72a68d15397$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $73dcc72a68d15397$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($73dcc72a68d15397$var$maybeReportOrphan);
    return $73dcc72a68d15397$var$valueGet(entry.value);
}
function $73dcc72a68d15397$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $73dcc72a68d15397$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $73dcc72a68d15397$var$setClean(entry) {
    entry.dirty = false;
    if ($73dcc72a68d15397$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $73dcc72a68d15397$var$reportClean(entry);
}
function $73dcc72a68d15397$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $73dcc72a68d15397$var$reportDirtyChild(parent, child);
    });
}
function $73dcc72a68d15397$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $73dcc72a68d15397$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $73dcc72a68d15397$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $73dcc72a68d15397$var$assert(parent.childValues.has(child));
    $73dcc72a68d15397$var$assert($73dcc72a68d15397$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $73dcc72a68d15397$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $73dcc72a68d15397$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $73dcc72a68d15397$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $73dcc72a68d15397$var$assert(parent.childValues.has(child));
    $73dcc72a68d15397$var$assert(!$73dcc72a68d15397$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $73dcc72a68d15397$var$valueCopy(child.value));
    else if (!$73dcc72a68d15397$var$valueIs(childValue, child.value)) parent.setDirty();
    $73dcc72a68d15397$var$removeDirtyChild(parent, child);
    if ($73dcc72a68d15397$var$mightBeDirty(parent)) return;
    $73dcc72a68d15397$var$reportClean(parent);
}
function $73dcc72a68d15397$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($73dcc72a68d15397$var$emptySetPool.length < $73dcc72a68d15397$var$POOL_TARGET_SIZE) $73dcc72a68d15397$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $73dcc72a68d15397$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $73dcc72a68d15397$var$forgetChildren(parent) {
    var children = $73dcc72a68d15397$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $73dcc72a68d15397$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $73dcc72a68d15397$var$assert(parent.dirtyChildren === null);
    return children;
}
function $73dcc72a68d15397$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $73dcc72a68d15397$var$removeDirtyChild(parent, child);
}
function $73dcc72a68d15397$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $73dcc72a68d15397$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $73dcc72a68d15397$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $73dcc72a68d15397$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $73dcc72a68d15397$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $73dcc72a68d15397$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $73dcc72a68d15397$var$keyTrie = new $73dcc72a68d15397$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $73dcc72a68d15397$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $73dcc72a68d15397$var$keyTrie.lookupArray(args);
}
var $73dcc72a68d15397$var$caches = new Set();
function $73dcc72a68d15397$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $73dcc72a68d15397$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $73dcc72a68d15397$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$73dcc72a68d15397$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $73dcc72a68d15397$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $73dcc72a68d15397$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$73dcc72a68d15397$var$parentEntrySlot.hasValue()) {
            $73dcc72a68d15397$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $73dcc72a68d15397$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("hUWo2", function(module, exports) {
$parcel$export(module.exports, "Slot", () => $d0b4f509668bceb7$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $d0b4f509668bceb7$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $d0b4f509668bceb7$var$MISSING_VALUE = {};
var $d0b4f509668bceb7$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $d0b4f509668bceb7$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $d0b4f509668bceb7$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $d0b4f509668bceb7$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $d0b4f509668bceb7$var$MISSING_VALUE) break;
                if (context_1 !== $d0b4f509668bceb7$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $d0b4f509668bceb7$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($d0b4f509668bceb7$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $d0b4f509668bceb7$var$currentContext.slots[this.id] = $d0b4f509668bceb7$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $d0b4f509668bceb7$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $d0b4f509668bceb7$var$currentContext;
            $d0b4f509668bceb7$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $d0b4f509668bceb7$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $d0b4f509668bceb7$var$currentContext;
            return function() {
                var saved = $d0b4f509668bceb7$var$currentContext;
                try {
                    $d0b4f509668bceb7$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $d0b4f509668bceb7$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($d0b4f509668bceb7$var$currentContext) {
                var saved = $d0b4f509668bceb7$var$currentContext;
                try {
                    $d0b4f509668bceb7$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $d0b4f509668bceb7$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $d0b4f509668bceb7$var$globalKey = "@wry/context:Slot";
var $d0b4f509668bceb7$var$host = Array;
var $d0b4f509668bceb7$export$8c6ed5c666ac1360 = $d0b4f509668bceb7$var$host[$d0b4f509668bceb7$var$globalKey] || function() {
    var Slot = $d0b4f509668bceb7$var$makeSlotClass();
    try {
        Object.defineProperty($d0b4f509668bceb7$var$host, $d0b4f509668bceb7$var$globalKey, {
            value: $d0b4f509668bceb7$var$host[$d0b4f509668bceb7$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $d0b4f509668bceb7$export$2385a24977818dd0 = $d0b4f509668bceb7$export$8c6ed5c666ac1360.bind, $d0b4f509668bceb7$export$9fa6f2e300a97f8 = $d0b4f509668bceb7$export$8c6ed5c666ac1360.noContext;
function $d0b4f509668bceb7$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($d0b4f509668bceb7$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $d0b4f509668bceb7$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $d0b4f509668bceb7$export$2385a24977818dd0(gen.next);
        var boundThrow = $d0b4f509668bceb7$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($d0b4f509668bceb7$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $d0b4f509668bceb7$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $d0b4f509668bceb7$var$wrappedFibers = [];
function $d0b4f509668bceb7$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($d0b4f509668bceb7$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $d0b4f509668bceb7$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $d0b4f509668bceb7$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("i8eSF", function(module, exports) {
$parcel$export(module.exports, "onError", () => $d334845f424573c9$export$2288787135a8f66e);

var $dnskZ = parcelRequire("dnskZ");

var $7oe8F = parcelRequire("7oe8F");
function $d334845f424573c9$export$2288787135a8f66e(errorHandler) {
    return new (0, $7oe8F.ApolloLink)(function(operation, forward) {
        return new (0, $7oe8F.Observable)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $d334845f424573c9$export$d2c8415987899609 = function(_super) {
    (0, $dnskZ.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $d334845f424573c9$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $7oe8F.ApolloLink));

});

parcelRegister("eHpnE", function(module, exports) {
$parcel$export(module.exports, "HttpLink", () => $ab38c4d93356db03$export$f4bbf1aec241cc1);

var $dnskZ = parcelRequire("dnskZ");

var $7oe8F = parcelRequire("7oe8F");

var $1pDgh = parcelRequire("1pDgh");
var $ab38c4d93356db03$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $dnskZ.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $1pDgh.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $7oe8F.ApolloLink)(function(operation) {
        var chosenURI = (0, $1pDgh.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $dnskZ.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $1pDgh.selectHttpOptionsAndBody)(operation, (0, $1pDgh.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $1pDgh.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $ab38c4d93356db03$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $7oe8F.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $1pDgh.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $7oe8F.fromError)(parseError);
        }
        return new (0, $7oe8F.Observable)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $1pDgh.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $ab38c4d93356db03$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $1pDgh.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $1pDgh.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $ab38c4d93356db03$export$f4bbf1aec241cc1 = function(_super) {
    (0, $dnskZ.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $ab38c4d93356db03$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $7oe8F.ApolloLink));

});
parcelRegister("1pDgh", function(module, exports) {
$parcel$export(module.exports, "fallbackHttpConfig", () => $107694c730f3c7b9$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $107694c730f3c7b9$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $107694c730f3c7b9$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $107694c730f3c7b9$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $107694c730f3c7b9$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $107694c730f3c7b9$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $107694c730f3c7b9$export$63ccc2571850f81a);

var $dnskZ = parcelRequire("dnskZ");

var $6NFTG = parcelRequire("6NFTG");

var $lDEi6 = parcelRequire("lDEi6");
var $107694c730f3c7b9$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $107694c730f3c7b9$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $107694c730f3c7b9$var$defaultOptions = {
    method: 'POST'
};
var $107694c730f3c7b9$export$dd86f00dc866e75d = {
    http: $107694c730f3c7b9$var$defaultHttpOptions,
    headers: $107694c730f3c7b9$var$defaultHeaders,
    options: $107694c730f3c7b9$var$defaultOptions
};
var $107694c730f3c7b9$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $107694c730f3c7b9$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $107694c730f3c7b9$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $107694c730f3c7b9$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $107694c730f3c7b9$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $lDEi6.InvariantError)(1);
    }
};
var $107694c730f3c7b9$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $107694c730f3c7b9$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $dnskZ.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $dnskZ.__assign)({}, options, config.options, {
            headers: (0, $dnskZ.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $dnskZ.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $6NFTG.print)(query);
    return {
        options: options,
        body: body
    };
};
var $107694c730f3c7b9$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $lDEi6.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $107694c730f3c7b9$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});


parcelRegister("a6bRt", function(module, exports) {
$parcel$export(module.exports, "RetryLink", () => $75a3aa60951dc58d$export$943d544ad120494a);

var $dnskZ = parcelRequire("dnskZ");

var $7oe8F = parcelRequire("7oe8F");
function $75a3aa60951dc58d$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $75a3aa60951dc58d$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $75a3aa60951dc58d$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $dnskZ.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $dnskZ.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $75a3aa60951dc58d$export$943d544ad120494a = function(_super) {
    (0, $dnskZ.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $75a3aa60951dc58d$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $75a3aa60951dc58d$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $75a3aa60951dc58d$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $7oe8F.Observable)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $7oe8F.ApolloLink));

});

parcelRegister("g4okI", function(module, exports) {
$parcel$export(module.exports, "fragmentCacheRedirect", () => $bb2fe5188907aceb$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $bb2fe5188907aceb$export$3f9ecfb4d42ab23d);

var $jFDfc = parcelRequire("jFDfc");

var $fT6ea = parcelRequire("fT6ea");

var $ifBQy = parcelRequire("ifBQy");
function $bb2fe5188907aceb$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $ifBQy.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $jFDfc.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $bb2fe5188907aceb$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $fT6ea.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("fT6ea", function(module, exports) {
$parcel$export(module.exports, "withClientState", () => $b910d2b7906fe912$export$a13f755900e15d9e);

var $7oe8F = parcelRequire("7oe8F");

var $jFDfc = parcelRequire("jFDfc");

var $aW6ai = parcelRequire("aW6ai");

var $fhjWZ = parcelRequire("fhjWZ");
var $b910d2b7906fe912$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b910d2b7906fe912$var$graphql = $aW6ai.graphql;
var $b910d2b7906fe912$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $b910d2b7906fe912$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $b910d2b7906fe912$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $7oe8F.Observable).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $fhjWZ.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $jFDfc.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $fhjWZ.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $b910d2b7906fe912$var$capitalizeFirstLetter(((0, $jFDfc.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $7oe8F.Observable).of({
                data: {}
            });
            return new (0, $7oe8F.Observable)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $b910d2b7906fe912$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $7oe8F.ApolloLink)))();
};

});
parcelRegister("aW6ai", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dnskZ = parcelRequire("dnskZ");

var $jFDfc = parcelRequire("jFDfc");

var $mY9dA = parcelRequire("mY9dA");
function $7f641a6fdcb80040$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jFDfc.getMainDefinition(document);
    var fragments = $jFDfc.getFragmentDefinitions(document);
    var fragmentMap = $jFDfc.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $7f641a6fdcb80040$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $7f641a6fdcb80040$var$graphql;
function $7f641a6fdcb80040$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $dnskZ.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $dnskZ.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $dnskZ.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $dnskZ.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$jFDfc.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$jFDfc.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $7f641a6fdcb80040$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $jFDfc.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $mY9dA.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($jFDfc.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $7f641a6fdcb80040$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $mY9dA.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $7f641a6fdcb80040$var$executeField(field, rootValue, execContext) {
    return $dnskZ.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $dnskZ.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $jFDfc.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $jFDfc.resultKeyNameFromField(field),
                        directives: $jFDfc.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $7f641a6fdcb80040$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $7f641a6fdcb80040$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $7f641a6fdcb80040$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $7f641a6fdcb80040$var$executeSubSelectedArray(field, item, execContext);
        return $7f641a6fdcb80040$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("mY9dA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jFDfc = parcelRequire("jFDfc");
function $0450b643c808decc$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jFDfc.getMainDefinition(document);
    var fragments = $jFDfc.getFragmentDefinitions(document);
    var fragmentMap = $jFDfc.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $0450b643c808decc$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $0450b643c808decc$var$graphql;
function $0450b643c808decc$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$jFDfc.shouldInclude(selection, variables)) return;
        if ($jFDfc.isField(selection)) {
            var fieldResult = $0450b643c808decc$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $jFDfc.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $0450b643c808decc$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($jFDfc.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $0450b643c808decc$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $0450b643c808decc$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $0450b643c808decc$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $jFDfc.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $jFDfc.resultKeyNameFromField(field),
        directives: $jFDfc.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $0450b643c808decc$var$executeSubSelectedArray(field, result, execContext);
    return $0450b643c808decc$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $0450b643c808decc$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $0450b643c808decc$var$executeSubSelectedArray(field, item, execContext);
        return $0450b643c808decc$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $0450b643c808decc$var$hasOwn = Object.prototype.hasOwnProperty;
function $0450b643c808decc$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$0450b643c808decc$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $0450b643c808decc$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $0450b643c808decc$var$merge;

});


parcelRegister("fhjWZ", function(module, exports) {
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $b1f7eb4fa92dcb3d$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $b1f7eb4fa92dcb3d$export$467f9c465e4ace4e);

var $6NFTG = parcelRequire("6NFTG");

var $jFDfc = parcelRequire("jFDfc");
var $b1f7eb4fa92dcb3d$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $b1f7eb4fa92dcb3d$var$removed = new Map();
function $b1f7eb4fa92dcb3d$export$8eae69e876ee321e(query) {
    var cached = $b1f7eb4fa92dcb3d$var$removed.get(query);
    if (cached) return cached;
    (0, $jFDfc.checkDocument)(query);
    var docClone = (0, $jFDfc.removeDirectivesFromDocument)([
        $b1f7eb4fa92dcb3d$var$connectionRemoveConfig
    ], query);
    $b1f7eb4fa92dcb3d$var$removed.set(query, docClone);
    return docClone;
}
function $b1f7eb4fa92dcb3d$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $6NFTG.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("1fQNI", function(module, exports) {
$parcel$export(module.exports, "UFOLoggerLink", () => $a01de03b371744d9$export$fb326ed954631f3f);

var $7oe8F = parcelRequire("7oe8F");

var $2QO3b = parcelRequire("2QO3b");
const $a01de03b371744d9$export$fb326ed954631f3f = new (0, $7oe8F.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $2QO3b.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("dk1mg", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAggregatedDate\",\"possibleTypes\":[{\"name\":\"JiraDatePickerField\"},{\"name\":\"JiraDateTimePickerField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"JiraHistoryItem\"},{\"name\":\"JiraCommentItem\"},{\"name\":\"JiraWorklogItem\"},{\"name\":\"JiraApprovalItem\"},{\"name\":\"JiraHiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraApplySuggestionActionPayloadResponse\",\"possibleTypes\":[{\"name\":\"JiraMergeIssuesPayload\"}]},{\"kind\":\"UNION\",\"name\":\"JiraApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"JiraApprovalCreated\"},{\"name\":\"JiraApproverDecision\"},{\"name\":\"JiraApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBoardResult\",\"possibleTypes\":[{\"name\":\"JiraBoard\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBoardViewLayout\",\"possibleTypes\":[{\"name\":\"JiraBoardViewColumnLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraConfluencePageContent\",\"possibleTypes\":[{\"name\":\"JiraConfluencePageContentDetails\"},{\"name\":\"JiraConfluencePageContentError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraContainerNavigationResult\",\"possibleTypes\":[{\"name\":\"JiraContainerNavigation\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraDefaultUnsplashImagesPageResult\",\"possibleTypes\":[{\"name\":\"JiraDefaultUnsplashImagesPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldFormatConfig\",\"possibleTypes\":[{\"name\":\"JiraNumberFieldFormatConfig\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldSetViewResult\",\"possibleTypes\":[{\"name\":\"JiraFieldSetView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormattingExpression\",\"possibleTypes\":[{\"name\":\"JiraFormattingSingleValueOperand\"},{\"name\":\"JiraFormattingTwoValueOperand\"},{\"name\":\"JiraFormattingMultipleValueOperand\"},{\"name\":\"JiraFormattingNoValueOperand\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormulaFieldValue\",\"possibleTypes\":[{\"name\":\"JiraFormulaFieldTextValue\"},{\"name\":\"JiraFormulaFieldNumberValue\"},{\"name\":\"JiraFormulaFieldDateValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraHistoryValue\",\"possibleTypes\":[{\"name\":\"JiraHistoryAssigneeFieldValue\"},{\"name\":\"JiraHistoryPriorityFieldValue\"},{\"name\":\"JiraHistoryStatusFieldValue\"},{\"name\":\"JiraHistoryWorkLogFieldValue\"},{\"name\":\"JiraHistoryRespondersFieldValue\"},{\"name\":\"JiraHistoryGenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueAISummaryResult\",\"possibleTypes\":[{\"name\":\"JiraIssueAISummary\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueError\",\"possibleTypes\":[{\"name\":\"JiraRemoteLinkedIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueExportEvent\",\"possibleTypes\":[{\"name\":\"JiraIssueExportTaskSubmitted\"},{\"name\":\"JiraIssueExportTaskProgress\"},{\"name\":\"JiraIssueExportTaskCompleted\"},{\"name\":\"JiraIssueExportTaskTerminated\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueFieldsByContainerTypesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueFieldsByContainerTypes\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyItem\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkItem\"},{\"name\":\"JiraJourneyStatusDependency\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyParentIssueValueType\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyTriggerConfiguration\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkdayIntegrationTriggerConfiguration\"},{\"name\":\"JiraJourneyParentIssueTriggerConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMergeIssuesOperationProgressResult\",\"possibleTypes\":[{\"name\":\"JiraMergeIssuesOperationProgress\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectLevelSidebarMenuCustomizationResult\",\"possibleTypes\":[{\"name\":\"JiraProjectLevelSidebarMenuCustomization\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRecommendedActionEntity\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"JiraProject\"},{\"name\":\"JiraPlatformComment\"},{\"name\":\"JiraServiceManagementComment\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraPlan\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSpreadsheetGroupFieldValue\",\"possibleTypes\":[{\"name\":\"AtlassianAccountUser\"},{\"name\":\"JiraOption\"},{\"name\":\"JiraStatus\"},{\"name\":\"JiraPriority\"},{\"name\":\"JiraStoryPoint\"},{\"name\":\"JiraGoal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraUnsplashImageSearchPageResult\",\"possibleTypes\":[{\"name\":\"JiraUnsplashImageSearchPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraViewResult\",\"possibleTypes\":[{\"name\":\"JiraBoardView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteJiraIssueLinkResult\",\"possibleTypes\":[{\"name\":\"RemoteJiraIssueLinkResultSuccess\"},{\"name\":\"RemoteJiraIssueLinkResultError\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");

});

parcelRegister("gLqE0", function(module, exports) {
$parcel$export(module.exports, "getErrorAnalyticsContext", () => $b5b943618371ee76$export$bd030713895ed5e2);
$parcel$export(module.exports, "reportErrors", () => $b5b943618371ee76$export$a78ebe1911f50d41);

var $9Dhvc = parcelRequire("9Dhvc");

var $eezJL = parcelRequire("eezJL");

var $9pTd3 = parcelRequire("9pTd3");
const $b5b943618371ee76$export$15d632fe38832073 = 'giraErrorAnalytics';
const $b5b943618371ee76$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
        ...context,
        [$b5b943618371ee76$export$15d632fe38832073]: errorAnalytics
    });
const $b5b943618371ee76$export$bd030713895ed5e2 = (context)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const errorAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(context, [
        $b5b943618371ee76$export$15d632fe38832073
    ], undefined);
    if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
        id: errorAnalytics.id,
        packageName: errorAnalytics.packageName,
        teamName: errorAnalytics.teamName,
        attributes: errorAnalytics.attributes,
        sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
    };
    return undefined;
};
const $b5b943618371ee76$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    const errorAnalytics = $b5b943618371ee76$export$bd030713895ed5e2(operation.getContext());
    // Refine mixed type to Array | void
    if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
    const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
    const hasNetworkError = networkError !== undefined;
    // Only report errors using the JFE analytics pipeline if analytics context data is defined for the query.
    if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
    const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
    const error = new (0, $eezJL.ApolloError)({
        // Above Array.isArray check will refine the type to a read-only array. We need this spread to keep flow happy.
        graphQLErrors: graphQLErrors ? [
            ...graphQLErrors
        ] : undefined,
        networkError: networkError
    });
    const attributesWithOperationName = {
        ...attributes,
        operationName: operation.operationName,
        hasGraphQLError: hasGraphQLError,
        hasNetworkError: hasNetworkError
    };
    (0, $9pTd3.fireErrorAnalytics)({
        error: error,
        meta: {
            id: id,
            packageName: packageName,
            teamName: teamName
        },
        attributes: attributesWithOperationName,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    });
};

});


parcelRegister("67Hrv", function(module, exports) {
$parcel$export(module.exports, "asyncNumberFormattingFlagEntryPoint", () => $5b4b7b0c33d7fdf8$export$a19a68721891aaaa);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $5b4b7b0c33d7fdf8$export$a19a68721891aaaa = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("lRBxl")), {
        moduleId: "744236cd",
        moduleName: "NumberFormattingFlag",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lRBxl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lsIY1").then(()=>parcelRequire('aLDUW'));

});


parcelRegister("iMQSg", function(module, exports) {
$parcel$export(module.exports, "useFetchCriteria", () => $992d850866bd2002$export$2c480b00ea27264d);

var $1fMqv = parcelRequire("1fMqv");

var $cHtIB = parcelRequire("cHtIB");

var $3osLr = parcelRequire("3osLr");

var $6fDoI = parcelRequire("6fDoI");
const $992d850866bd2002$var$getURLPrefix = (projectType)=>{
    if (projectType === 'SOFTWARE') return 'software';
    if (projectType === 'BUSINESS') return 'core';
    return null;
};
const $992d850866bd2002$export$2c480b00ea27264d = (projectId, projectKey, enabled)=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const projectAri = (0, $3osLr.JiraProjectAri).create({
        siteId: cloudId,
        projectId: projectId
    });
    const { data: data } = (0, $1fMqv.useQuery)((0, $6fDoI.GET_NUMBER_CURRENCY_FORMATTING_CHANGEBOARDING_CRITIERA_QUERY), {
        variables: {
            projectAri: projectAri.toString(),
            projectKey: projectKey,
            first: 100
        },
        fetchPolicy: 'network-only',
        skip: !enabled
    });
    if (!data) return undefined;
    const isProjectAdmin = data.jira?.jiraProject?.administerProject?.canPerform ?? false;
    // Check if there already exists a JiraNumberField with a truthy formatConfig. This means an admin has already interacted with the new feature.
    const hasExistingNumberFieldWithFormatStyle = data.jiraBusinessAvailableFields?.edges?.some((edge)=>{
        return edge?.node?.fields?.edges?.some((fieldEdge)=>{
            const field = fieldEdge?.node;
            return field?.__typename === 'JiraNumberField' && field?.formatConfig?.formatStyle != null;
        });
    }) ?? false;
    const projectType = $992d850866bd2002$var$getURLPrefix(data.jira?.jiraProject?.projectType);
    const isTMP = Boolean(data.jira?.jiraProject?.tmpBoardId);
    return {
        isProjectAdmin: isProjectAdmin,
        hasExistingNumberFieldWithFormatStyle: hasExistingNumberFieldWithFormatStyle,
        projectType: projectType,
        isTMP: isTMP
    };
};

});
parcelRegister("1fMqv", function(module, exports) {
$parcel$export(module.exports, "useQuery", () => $0e9cc1ab166e5529$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $0e9cc1ab166e5529$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $0e9cc1ab166e5529$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $0e9cc1ab166e5529$export$eb9a56e7a29e494);

var $688i3 = parcelRequire("688i3");

var $dnskZ = parcelRequire("dnskZ");

var $eJOHy = parcelRequire("eJOHy");

var $eezJL = parcelRequire("eezJL");

var $hR4hP = parcelRequire("hR4hP");

var $lDEi6 = parcelRequire("lDEi6");
var $0e9cc1ab166e5529$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $hR4hP.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $lDEi6.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $688i3.parser)(document);
        var requiredOperationName = (0, $688i3.operationName)(type);
        var usedOperationName = (0, $688i3.operationName)(operation.type);
        (0, $lDEi6.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $0e9cc1ab166e5529$var$QueryData = function(_super) {
    (0, $dnskZ.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $eezJL.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $eezJL.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $688i3.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $dnskZ.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $hR4hP.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $hR4hP.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $hR4hP.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $eezJL.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $eezJL.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $hR4hP.equal)(this.previousOptions.query, query) && (0, $hR4hP.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($0e9cc1ab166e5529$var$OperationData);
function $0e9cc1ab166e5529$var$useDeepMemo(memoFn, key) {
    var ref = (0, $eJOHy.useRef)();
    if (!ref.current || !(0, $hR4hP.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $0e9cc1ab166e5529$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $eJOHy.useContext)((0, $688i3.getApolloContext)());
    var _a = (0, $eJOHy.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $eJOHy.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $0e9cc1ab166e5529$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $0e9cc1ab166e5529$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $eJOHy.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $eJOHy.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $0e9cc1ab166e5529$export$dd0a697e1782aedd(query, options) {
    return $0e9cc1ab166e5529$var$useBaseQuery(query, options, false);
}
function $0e9cc1ab166e5529$export$fd83eea6ecd2d8fa(query, options) {
    return $0e9cc1ab166e5529$var$useBaseQuery(query, options, true);
}
var $0e9cc1ab166e5529$var$MutationData = function(_super) {
    (0, $dnskZ.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $688i3.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $688i3.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $dnskZ.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $dnskZ.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $eezJL.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $hR4hP.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($0e9cc1ab166e5529$var$OperationData);
function $0e9cc1ab166e5529$export$609860bf8b0084c(mutation, options) {
    var context = (0, $eJOHy.useContext)((0, $688i3.getApolloContext)());
    var _a = (0, $eJOHy.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $eJOHy.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $0e9cc1ab166e5529$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $eJOHy.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $0e9cc1ab166e5529$var$SubscriptionData = function(_super) {
    (0, $dnskZ.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $hR4hP.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($0e9cc1ab166e5529$var$OperationData);
function $0e9cc1ab166e5529$export$368b4214baeb914c(subscription, options) {
    var context = (0, $eJOHy.useContext)((0, $688i3.getApolloContext)());
    var updatedOptions = options ? (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $eJOHy.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $eJOHy.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $0e9cc1ab166e5529$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $eJOHy.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $eJOHy.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $0e9cc1ab166e5529$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $688i3.getApolloContext)()).client;
    (0, $lDEi6.invariant)(client, 1);
    return client;
}
function $0e9cc1ab166e5529$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $0e9cc1ab166e5529$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $0e9cc1ab166e5529$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});

parcelRegister("6fDoI", function(module, exports) {
$parcel$export(module.exports, "GET_NUMBER_CURRENCY_FORMATTING_CHANGEBOARDING_CRITIERA_QUERY", () => $5ff57059212c09df$export$375d6e56d498fe2f);
// eslint-disable-next-line jira/restricted/graphql-tag

var $kuAvn = parcelRequire("kuAvn");
const $5ff57059212c09df$export$375d6e56d498fe2f = (0, $kuAvn.default)`
	query getNumberCurrencyFormattingChangeboardingCriteria ($projectAri: ID!, $projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
		jira {
			jiraProject(id: $projectAri) {
				id
				projectId
				key
				name
				projectType
				tmpBoardId
				administerProject: action(type: EDIT_PROJECT_CONFIG) {
					canPerform
				}
			}
		}
		jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
			edges {
				node {
					issueType {
						issueTypeId
					}
					fields {
						edges {
							node {
								fieldId
								type
								... on JiraNumberField {
									fieldConfig {
										isRequired
										isEditable
									}
									formatConfig {
										... on JiraNumberFieldFormatConfig {
											formatStyle
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
`;

});


const $009a72c63c9d7dca$export$c2ff6ab935be7852 = 'jira-in-context-config-sidebar-changeboarding-trigger-id';
const $009a72c63c9d7dca$export$89bbc91416db6670 = 'jira-in-context-config-sidebar-changeboarding-event-id';

parcelRegister("4gH81", function(module, exports) {
$parcel$export(module.exports, "emitMessageEvent", () => $8c7b64ba40cdc0b2$export$3d0d0251b849dca6);

var $fceQU = parcelRequire("fceQU");

const $8c7b64ba40cdc0b2$export$3d0d0251b849dca6 = (eventDetails)=>{
    const event = new CustomEvent((0, $009a72c63c9d7dca$export$89bbc91416db6670), {
        detail: eventDetails
    });
    (0, $fceQU.getDocument)()?.dispatchEvent(event);
};

});


parcelRegister("3aisD", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e68baeabf38849c$export$2e2bcd8739ae039);
// To remove with cleanup of empanada_nin_convert_issue_ops_to_entrypoint as we are moving this AttachFileDialog to an entrypoint

var $eJOHy = parcelRequire("eJOHy");

var $3W2wI = parcelRequire("3W2wI");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1e68baeabf38849c$var$AsyncAttachFileModal = (0, $bQWwW.lazy)(()=>(parcelRequire("4Ifwc")), {
    moduleId: "./src/packages/issue-navigator/issue-operations/dialogs/attach-file-dialog/src/ui/index.tsx"
});
const $1e68baeabf38849c$var$LazyAttachFileModal = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3W2wI.ModalBoundary), {
        id: "attach-file-dialog",
        packageName: "native-issue-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1e68baeabf38849c$var$AsyncAttachFileModal, null));
var $1e68baeabf38849c$export$2e2bcd8739ae039 = $1e68baeabf38849c$var$LazyAttachFileModal;

});
parcelRegister("4Ifwc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7RRcE").then(()=>parcelRequire('2gnbS'));

});


parcelRegister("cTddL", function(module, exports) {
$parcel$export(module.exports, "DialogContextContainer", () => $d4ef871676e174ab$export$8e9ef3fae6d51d86);
$parcel$export(module.exports, "useIssueOperationsDialogContext", () => $d4ef871676e174ab$export$a2a00ec2da7337e);
// Remove references to Dialog Context Provider on clean up of empanada_nin_convert_issue_ops_to_entrypoint
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $d4ef871676e174ab$var$initialState = {
    openDialog: null,
    issueKey: null,
    issueId: null,
    workType: null,
    mediaUploadContext: null
};
const $d4ef871676e174ab$var$actions = {
    setDialogContext: (openDialog, issueId, issueKey, mediaUploadContext, workType)=>({ setState: setState })=>{
            setState({
                openDialog: openDialog,
                issueId: issueId,
                issueKey: issueKey,
                mediaUploadContext: mediaUploadContext,
                workType: workType
            });
        }
};
const $d4ef871676e174ab$var$Store = (0, $GtRbT.createStore)({
    initialState: $d4ef871676e174ab$var$initialState,
    actions: $d4ef871676e174ab$var$actions,
    name: 'IssueNavigatorIssueOperationsDialogContext'
});
const $d4ef871676e174ab$export$8e9ef3fae6d51d86 = (0, $6E16M.createContainer)($d4ef871676e174ab$var$Store);
const $d4ef871676e174ab$export$a2a00ec2da7337e = (0, $iJq0l.createHook)($d4ef871676e174ab$var$Store);

});

parcelRegister("d8Dow", function(module, exports) {
$parcel$export(module.exports, "MAX_COLUMNS", () => $0ea88860b9e82601$export$7ec4af037f372df4);
$parcel$export(module.exports, "createDebouncedColumnLoader", () => $0ea88860b9e82601$export$a6cff24b97727de1);
$parcel$export(module.exports, "REMOVE_COLUMNS", () => $0ea88860b9e82601$export$191e3e934175a609);
$parcel$export(module.exports, "ADD_COLUMNS", () => $0ea88860b9e82601$export$ccf17692f1fc979a);

var $3Zpjn = parcelRequire("3Zpjn");

const $0ea88860b9e82601$export$7ec4af037f372df4 = 500;
const $0ea88860b9e82601$export$a6cff24b97727de1 = (0, $3Zpjn.createGenericDebouncableDataLoader);
const $0ea88860b9e82601$export$191e3e934175a609 = 'REMOVE_COLUMNS';
const $0ea88860b9e82601$export$ccf17692f1fc979a = 'ADD_COLUMNS';

});
parcelRegister("3Zpjn", function(module, exports) {
$parcel$export(module.exports, "createGenericDebouncableDataLoader", () => $515f3085be272897$export$ea63a11564958c9e);

var $3s8bj = parcelRequire("3s8bj");
const $515f3085be272897$export$ea63a11564958c9e = (dataLoader)=>{
    const debouncedDataLoader = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((search, enableFullList, endCursor, cb)=>dataLoader(search, enableFullList, endCursor).then((data)=>{
            cb(data);
            return data;
        }), 500);
    return (search, enableFullList, endCursor, cb)=>{
        // No need to debounce When no search string is provided.
        // We want the initial list displaying as quickly as possible when a user reopens the dropdown.
        // It will be cached by the GraphQL client and debouncing will show an unneccessary spinner.
        if (!search) {
            debouncedDataLoader.cancel();
            return dataLoader(search, enableFullList, endCursor).then((data)=>{
                cb(data);
                return data;
            });
        }
        return debouncedDataLoader(search, enableFullList, endCursor, cb);
    };
};
var $515f3085be272897$export$2e2bcd8739ae039 = $515f3085be272897$export$ea63a11564958c9e;

});


parcelRegister("P01So", function(module, exports) {
$parcel$export(module.exports, "isNonNullish", () => $a4f78649e91890cd$export$70573498ee17fe1d);
$parcel$export(module.exports, "isKnownColumnType", () => $a4f78649e91890cd$export$e8280bcdc1c3f84);
$parcel$export(module.exports, "exclusiveGroupsOrIssuesFragment", () => $a4f78649e91890cd$export$7ac78cf15a1a4ba3);
$parcel$export(module.exports, "getProjectKeyFromIssueKey", () => $a4f78649e91890cd$export$defe38779a6b81d2);
$parcel$export(module.exports, "escapeBackslashes", () => $a4f78649e91890cd$export$fbd15c27bb7e257c);
$parcel$export(module.exports, "desanitizeField", () => $a4f78649e91890cd$export$261830fe943e88ac);

var $j8Km1 = parcelRequire("j8Km1");

function $a4f78649e91890cd$export$70573498ee17fe1d(value) {
    return value != null;
}
function $a4f78649e91890cd$export$e8280bcdc1c3f84(value) {
    return value !== undefined && Object.values((0, $j8Km1.KNOWN_COLUMN_TYPES)).includes(value);
}
function $a4f78649e91890cd$export$7ac78cf15a1a4ba3({ groups: groups, issues: issues }) {
    if (issues) return {
        groups: null,
        issues: issues
    };
    if (groups) return {
        groups: groups,
        issues: null
    };
    return null;
}
function $a4f78649e91890cd$export$defe38779a6b81d2(issueKey) {
    return issueKey.split('-')[0];
}
const $a4f78649e91890cd$export$fbd15c27bb7e257c = (text)=>text.replace(/\\/g, '\\\\');
const $a4f78649e91890cd$export$261830fe943e88ac = (field)=>{
    const firstChar = field[0];
    const lastChar = field[field.length - 1];
    if ((firstChar === '"' || firstChar === "'") && firstChar === lastChar) return field.slice(1, -1).toLowerCase();
    return field.toLowerCase();
};

});

parcelRegister("9Z7uc", function(module, exports) {
$parcel$export(module.exports, "useColumnWidthUpdater", () => $ff43ba53dfdeb1f7$export$e54397ae25183faf);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");
const $ff43ba53dfdeb1f7$export$e54397ae25183faf = (connectionId)=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return (0, $eJOHy.useCallback)((columnId, width)=>{
        (0, $37Ewn.commitLocalUpdate)(environment, (store)=>{
            const connection = store.get(connectionId);
            const fieldSetEdges = connection?.getLinkedRecords('edges') ?? [];
            const fieldSetEdge = fieldSetEdges.find((edge)=>{
                const fieldSetId = edge?.getLinkedRecord('node')?.getValue('fieldSetId');
                return columnId === fieldSetId;
            });
            if (!fieldSetEdge) return;
            const fieldSetNode = fieldSetEdge.getLinkedRecord('node');
            if (!fieldSetNode) return;
            if (width == null) {
                fieldSetNode.setValue(null, 'fieldSetPreferences');
                return;
            }
            const fieldSetPreferences = fieldSetNode.getOrCreateLinkedRecord('fieldSetPreferences', 'JiraFieldSetPreferences');
            fieldSetPreferences.setValue(width, 'width');
        });
    }, [
        connectionId,
        environment
    ]);
};

});

parcelRegister("aJqsk", function(module, exports) {
$parcel$export(module.exports, "useColumnIsFrozenUpdater", () => $98d0ffd7ed5d8b81$export$f2cce0fcc63ce339);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");
const $98d0ffd7ed5d8b81$export$f2cce0fcc63ce339 = (connectionId)=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return (0, $eJOHy.useCallback)((updatedColumns)=>{
        (0, $37Ewn.commitLocalUpdate)(environment, (store)=>{
            const connection = store.get(connectionId);
            if (!connection) return;
            const fieldSetEdges = connection.getLinkedRecords('edges') ?? [];
            updatedColumns.forEach(({ fieldSetId: fieldSetId, isFrozen: isFrozen })=>{
                const fieldSetEdge = fieldSetEdges.find((edge)=>{
                    const id = edge?.getLinkedRecord('node')?.getValue('fieldSetId');
                    return fieldSetId === id;
                });
                if (!fieldSetEdge) return;
                const fieldSetNode = fieldSetEdge.getLinkedRecord('node');
                if (!fieldSetNode) return;
                const fieldSetPreferences = fieldSetNode.getOrCreateLinkedRecord('fieldSetPreferences', 'JiraFieldSetPreferences');
                fieldSetPreferences.setValue(isFrozen, 'isFrozen');
            });
        });
    }, [
        connectionId,
        environment
    ]);
};

});

parcelRegister("j6nGi", function(module, exports) {
$parcel$export(module.exports, "default", () => $0eaa6cd95847cbf4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $fGnU6 = parcelRequire("fGnU6");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $4EKqI = parcelRequire("4EKqI");

var $5vQ2T = parcelRequire("5vQ2T");

var $2dBpR = parcelRequire("2dBpR");

var $4cTDP = parcelRequire("4cTDP");

var $kmIYY = parcelRequire("kmIYY");

const $0eaa6cd95847cbf4$var$AsyncNativeIssueTable = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("eCn39")), {
    moduleId: "./src/packages/platform/ui/issue-table/issue-table/src/ui/NativeIssueTableWithSelectedIssuesProvider.tsx"
});
const $0eaa6cd95847cbf4$var$AsyncNativeIssueTableOld = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kmIYY.IssueTableSkeleton), null),
        name: "async-native-issue-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0eaa6cd95847cbf4$var$AsyncNativeIssueTable, props)));
const $0eaa6cd95847cbf4$var$AsyncNativeIssueTableNew = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
    const entryPointReference = props.preloadedEntryPoints?.nativeIssueTableEntryPoint;
    const ErrorBoundary = (0, $4cTDP.fg)('improve_nin_slo_events') ? (0, $fGnU6.ReportErrors) : (0, $5vQ2T.JSErrorBoundary);
    if (entryPointReference) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "native-issue-table-entrypoint"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ErrorBoundary, {
        id: "native-issue-table-entrypoint",
        packageName: "jiraNativeIssueTable"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dBpR.EntryPointReferencePlaceholder), {
        name: "native-issue-table",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kmIYY.IssueTableSkeleton), null),
        entryPointReference: entryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.EntryPointContainer), {
        entryPointReference: entryPointReference,
        // EntryPointContainer can't infer the type of props from entryPointReference correctly
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: props
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0eaa6cd95847cbf4$var$AsyncNativeIssueTableOld, props);
});
var $0eaa6cd95847cbf4$export$2e2bcd8739ae039 = $0eaa6cd95847cbf4$var$AsyncNativeIssueTableNew;

});
parcelRegister("kmIYY", function(module, exports) {
$parcel$export(module.exports, "IssueTableSkeleton", () => $d01bd5b1473e1c91$export$32020b6a5557f03e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $coBPg = parcelRequire("coBPg");
const $d01bd5b1473e1c91$export$32020b6a5557f03e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d01bd5b1473e1c91$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $coBPg.NativeIssueTableSkeleton), null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d01bd5b1473e1c91$var$SkeletonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ])
    });
});

});

parcelRegister("eCn39", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_nin_convert_issue_ops_to_entrypoint', function() {
        return Promise.all([
            $ewTvA("gD3cg")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("e01ok")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_timeline_sticky_assignee_status_columns', function() {
        return Promise.all([
            $ewTvA("56xKj")
        ]);
    }, function() {
        return Promise.all([]);
    }),
    $ewTvA("kNFvF"),
    $ewTvA("fliVL"),
    $ewTvA("jr04i")
]).then(()=>parcelRequire('3CqQm'));

});


parcelRegister("7auhX", function(module, exports) {
$parcel$export(module.exports, "useColumnPickerLoadingContext", () => $2142b09d72cf7255$export$bd7ab5278af9a7dd);
$parcel$export(module.exports, "ColumnPickerLoadingContextProvider", () => $2142b09d72cf7255$export$9e9936dbd6aef092);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $3kDjB = parcelRequire("3kDjB");
const $2142b09d72cf7255$var$defaultState = {
    isLoading: false,
    setIsRestoringDefaultColumns: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
const $2142b09d72cf7255$var$ColumnPickerLoadingContext = /*#__PURE__*/ (0, $eJOHy.createContext)($2142b09d72cf7255$var$defaultState);
const $2142b09d72cf7255$export$bd7ab5278af9a7dd = ()=>(0, $eJOHy.useContext)($2142b09d72cf7255$var$ColumnPickerLoadingContext);
const $2142b09d72cf7255$export$9e9936dbd6aef092 = ({ children: children })=>{
    const [isRestoringDefaultColumns, setIsRestoringDefaultColumns] = (0, $eJOHy.useState)(false);
    const isFetchingView = (0, $3kDjB.useIsFetchingView)();
    const isRefreshing = (0, $3kDjB.useIsRefreshing)();
    const isLoading = isRestoringDefaultColumns || isFetchingView || isRefreshing;
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            isLoading: isLoading,
            setIsRestoringDefaultColumns: setIsRestoringDefaultColumns
        }), [
        isLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2142b09d72cf7255$var$ColumnPickerLoadingContext.Provider, {
        value: contextValue
    }, children);
};

});

parcelRegister("gTm2i", function(module, exports) {
$parcel$export(module.exports, "ColumnPickerMessageContext", () => $24ec8e0d51fae54f$export$2f14e8286acf4660);

var $eJOHy = parcelRequire("eJOHy");
const $24ec8e0d51fae54f$var$defaultMessageContext = {
    hasMaxSelectedColumns: false
};
const $24ec8e0d51fae54f$export$2f14e8286acf4660 = /*#__PURE__*/ (0, $eJOHy.createContext)($24ec8e0d51fae54f$var$defaultMessageContext);

});

parcelRegister("kGfUm", function(module, exports) {
$parcel$export(module.exports, "useColumnLoader", () => $e32ebbab3934b1d3$export$6dc2ac601f90aafc);

var $l6GvB = parcelRequire("l6GvB");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $99mLG = parcelRequire("99mLG");

var $9pTd3 = parcelRequire("9pTd3");

var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $d8Dow = parcelRequire("d8Dow");

var $cjRWP = parcelRequire("cjRWP");

var $cHtIB = parcelRequire("cHtIB");

var $awWeA = parcelRequire("awWeA");

var $4cTDP = parcelRequire("4cTDP");

var $3mZMJ = parcelRequire("3mZMJ");

var $fwKw5 = parcelRequire("fwKw5");

var $iRahl = parcelRequire("iRahl");

var $eibCx = parcelRequire("eibCx");

var $1RINH = parcelRequire("1RINH");

var $iT8nA = parcelRequire("iT8nA");
const $e32ebbab3934b1d3$var$mapColumnPickerOptions = (data, search, intl, selectedColumns, canEditColumns, isColumnPickerChangesEnabled)=>{
    let totalCount = 0;
    let edges;
    let endCursor;
    const shouldUseOldQuery = !isColumnPickerChangesEnabled;
    if (shouldUseOldQuery && data?.jira.issueSearchViewByNamespaceAndViewId?.fieldSets) {
        totalCount = data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets.totalCount;
        edges = data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges;
        endCursor = data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets.pageInfo?.endCursor ? data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets.pageInfo.endCursor : undefined;
    }
    if (isColumnPickerChangesEnabled && data?.jira.jiraIssueSearchView?.fieldSets) {
        totalCount = data?.jira.jiraIssueSearchView.fieldSets.totalCount;
        edges = data?.jira.jiraIssueSearchView.fieldSets.edges;
        endCursor = data?.jira.jiraIssueSearchView.fieldSets.pageInfo?.endCursor ? data?.jira.jiraIssueSearchView.fieldSets.pageInfo.endCursor : undefined;
    }
    const options = edges?.filter((0, $eibCx.isNonNullish)).filter((edge)=>(0, $4cTDP.fg)('frontier-formula-field-nin') ? true : edge.node.type !== (0, $3mZMJ.FORMULA_NUMBER_CF_TYPE)).map((edge)=>{
        const fieldTypeDisplayName = edge.node.fieldType?.displayName;
        const icon = edge.node.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99mLG.FieldTypeIcon), {
            type: edge.node.type,
            size: "small"
        }) : undefined;
        const isOnlyUnselectable = (0, $iT8nA.isOnlyUnselectableField)(edge.node.type, canEditColumns);
        return {
            optionType: 'option',
            cursor: edge.cursor,
            value: edge.node.fieldSetId,
            label: edge.node.displayName,
            secondaryLabel: fieldTypeDisplayName && icon ? (0, $cjRWP.getSecondaryLabelWithIcon)(icon, fieldTypeDisplayName) : undefined,
            ...isOnlyUnselectable && {
                isOnlyUnselectable: isOnlyUnselectable,
                disabledMessage: intl.formatMessage((0, $1RINH.default).deprecatedParentyLinkMessage, {
                    field: edge.node.displayName,
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                            as: "strong",
                            color: "inherit",
                            size: "UNSAFE_small"
                        }, chunks)
                })
            },
            ...isColumnPickerChangesEnabled && {
                customWidth: edge.node.fieldSetPreferences?.width,
                type: edge.node.type
            }
        };
    });
    if (!options?.length) return {
        options: [],
        totalCount: 0
    };
    if (search.length) return {
        options: options,
        totalCount: totalCount,
        endCursor: endCursor
    };
    // total count is the count of unselected options for non-search queries
    totalCount += selectedColumns.length;
    return {
        options: [
            {
                id: (0, $iRahl.ALL_COLUMNS_ID),
                label: intl.formatMessage((0, $1RINH.default).columnGroupHeader),
                optionType: 'group',
                options: options
            }
        ],
        totalCount: totalCount,
        endCursor: endCursor
    };
};
const $e32ebbab3934b1d3$export$6dc2ac601f90aafc = (viewId, canEditColumns, selectedColumns, isColumnPickerChangesEnabled, isIFCEnabled, projectContext, savedViewId)=>{
    const intl = (0, $lRq8t.default)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const resolvedJql = isColumnPickerChangesEnabled ? (0, $fwKw5.useResolvedJql)() : '';
    // refs for selectedColumns, endCursor and search prevent outdated data in the relay store from being used
    // in cases when selected options changes & picker is paginated
    const columnsRef = (0, $eJOHy.useRef)(selectedColumns);
    const endCursorRef = (0, $eJOHy.useRef)();
    const searchRef = (0, $eJOHy.useRef)();
    const loadedOptionsRef = (0, $eJOHy.useRef)();
    return (0, $eJOHy.useMemo)(()=>(0, $d8Dow.createDebouncedColumnLoader)(async (search, renderInitialValues, endCursor)=>{
            let cursor = endCursor;
            if (!canEditColumns) {
                const options = selectedColumns ? selectedColumns.filter((col)=>col.optionType === 'option' && (search ? col.label.toLocaleLowerCase().includes(search.toLocaleLowerCase()) : true)) : [];
                return Promise.resolve({
                    options: options,
                    totalCount: options.length
                });
            }
            // calculate cursor from edges, since endCursor might not be valid anymore when last option was selected
            if (endCursor !== undefined && loadedOptionsRef.current && selectedColumns) cursor = (0, $iT8nA.getCursorOfLastUnselectedOption)(loadedOptionsRef.current, selectedColumns, search, endCursor);
            try {
                const result = await (0, $j4oe4.fetchQuery)(environment, (0, $l6GvB.default), {
                    cloudId: cloudId,
                    namespace: (0, $iRahl.ISSUE_SEARCH_NAMESPACE),
                    viewId: viewId,
                    first: 25,
                    after: cursor,
                    filter: {
                        searchString: search,
                        fieldSetSelectedState: !search ? 'NON_SELECTED' : 'ALL'
                    },
                    shouldUseNewQuery: !!isColumnPickerChangesEnabled,
                    jql: resolvedJql,
                    ...(0, $4cTDP.fg)('jira_nin_last_used_jql') ? {
                        scope: {
                            operationScope: (0, $awWeA.getOperationScope)(projectContext),
                            projectKey: projectContext ?? null
                        }
                    } : {},
                    ...isIFCEnabled && projectContext && !(0, $4cTDP.fg)('jira_nin_last_used_jql') ? {
                        scope: {
                            operationScope: (0, $awWeA.getOperationScope)(projectContext),
                            projectKey: projectContext
                        }
                    } : {},
                    ...savedViewId && !!isColumnPickerChangesEnabled ? {
                        jiraViewQueryInput: {
                            viewId: savedViewId
                        }
                    } : {}
                }, {
                    fetchPolicy: columnsRef.current !== selectedColumns || endCursorRef.current !== cursor || searchRef.current !== search ? 'network-only' : 'store-or-network'
                }).toPromise();
                columnsRef.current = selectedColumns;
                endCursorRef.current = cursor;
                searchRef.current = search;
                const pickerOptions = $e32ebbab3934b1d3$var$mapColumnPickerOptions(result, search, intl, selectedColumns, canEditColumns, isColumnPickerChangesEnabled);
                loadedOptionsRef.current = pickerOptions.options || undefined;
                return pickerOptions;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: 'fetchColumnPickerOptions',
                        packageName: (0, $iRahl.PACKAGE_NAME),
                        teamName: (0, $iRahl.TEAM_NAME)
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                loadedOptionsRef.current = undefined;
                return {
                    options: [
                        {
                            optionType: 'error',
                            error: error,
                            onRetry: ()=>undefined
                        }
                    ],
                    totalCount: 0
                };
            }
        }), [
        canEditColumns,
        selectedColumns,
        environment,
        cloudId,
        viewId,
        isColumnPickerChangesEnabled,
        resolvedJql,
        isIFCEnabled,
        projectContext,
        intl,
        savedViewId
    ]);
};

});
parcelRegister("l6GvB", function(module, exports) {
$parcel$export(module.exports, "default", () => $c58299c71227997c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<56de70402784140f9ea757a11796c3e1>>
 * @relayHash 1a6ee940b59f13263fb0433f4d4a4419
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 272634a6bad5f4495beb14443ac52d9b9a4e0be5253252159abbdb36fd238b15
const $c58299c71227997c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraViewQueryInput"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldUseNewQuery"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v10 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v11 = {
        "kind": "Variable",
        "name": "namespace",
        "variableName": "namespace"
    }, v12 = {
        "kind": "Variable",
        "name": "viewId",
        "variableName": "viewId"
    }, v13 = [
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ 
    ], v14 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v15 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v16 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v17 = [
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ], v18 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v19 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v21 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v22 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v23 = {
        "kind": "ScalarField",
        "name": "type"
    }, v24 = {
        "concreteType": "JiraFieldType",
        "kind": "LinkedField",
        "name": "fieldType",
        "plural": false,
        "selections": [
            v22 /*: any*/ 
        ]
    }, v25 = [
        v10 /*: any*/ ,
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "jql",
                    "variableName": "jql"
                }
            ],
            "kind": "ObjectValue",
            "name": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "jiraViewQueryInput",
            "variableName": "jiraViewQueryInput"
        },
        v11 /*: any*/ ,
        v12 /*: any*/ 
    ], v26 = [
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        }
    ], v27 = {
        "concreteType": "JiraFieldSetPreferences",
        "kind": "LinkedField",
        "name": "fieldSetPreferences",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "width"
            }
        ]
    }, v28 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "fetchColumnPickerOptionsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "shouldUseNewQuery",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v13 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchView",
                                            "kind": "LinkedField",
                                            "name": "issueSearchViewByNamespaceAndViewId",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "args": v17 /*: any*/ ,
                                                        "concreteType": "JiraIssueSearchFieldSetConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fieldSets",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v18 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.totalCount"
                                                            },
                                                            v19 /*: any*/ ,
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v20 /*: any*/ ,
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "concreteType": "JiraIssueSearchFieldSet",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v21 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node.fieldSetId"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v22 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node.displayName"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v23 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node.type"
                                                                                    },
                                                                                    v24 /*: any*/ 
                                                                                ]
                                                                            },
                                                                            "action": "THROW",
                                                                            "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "THROW",
                                                                "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.issueSearchViewByNamespaceAndViewId"
                                    }
                                ]
                            },
                            {
                                "condition": "shouldUseNewQuery",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v25 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "jiraIssueSearchView",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v26 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldSets",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v18 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.jiraIssueSearchView.fieldSets.totalCount"
                                                                },
                                                                v19 /*: any*/ ,
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraIssueSearchFieldSetEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v20 /*: any*/ ,
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": {
                                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v21 /*: any*/ ,
                                                                                            "action": "THROW",
                                                                                            "path": "jira.jiraIssueSearchView.fieldSets.edges.node.fieldSetId"
                                                                                        },
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v22 /*: any*/ ,
                                                                                            "action": "THROW",
                                                                                            "path": "jira.jiraIssueSearchView.fieldSets.edges.node.displayName"
                                                                                        },
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v23 /*: any*/ ,
                                                                                            "action": "THROW",
                                                                                            "path": "jira.jiraIssueSearchView.fieldSets.edges.node.type"
                                                                                        },
                                                                                        v24 /*: any*/ ,
                                                                                        v27 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                "action": "THROW",
                                                                                "path": "jira.jiraIssueSearchView.fieldSets.edges.node"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "jira.jiraIssueSearchView.fieldSets.edges"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSpreadsheetView",
                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.jiraIssueSearchView"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v6 /*: any*/ ,
                v9 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v8 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "fetchColumnPickerOptionsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "shouldUseNewQuery",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v13 /*: any*/ ,
                                    "concreteType": "JiraIssueSearchView",
                                    "kind": "LinkedField",
                                    "name": "issueSearchViewByNamespaceAndViewId",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v17 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        v20 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                v22 /*: any*/ ,
                                                                v23 /*: any*/ ,
                                                                v24 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v28 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "shouldUseNewQuery",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v25 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "jiraIssueSearchView",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": v26 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v27 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraSpreadsheetView",
                                            "abstractKey": "__isJiraSpreadsheetView"
                                        },
                                        v28 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "272634a6bad5f4495beb14443ac52d9b9a4e0be5253252159abbdb36fd238b15",
            "metadata": {},
            "name": "fetchColumnPickerOptionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c58299c71227997c$var$node.hash = "2ce388ada0acb5edb4e205aa2242a1d0";
var $c58299c71227997c$export$2e2bcd8739ae039 = $c58299c71227997c$var$node;

});

parcelRegister("99mLG", function(module, exports) {
$parcel$export(module.exports, "fieldTypesIcons", () => $fdaf5e373b76ddd5$export$67f993f3bbfb364d);
$parcel$export(module.exports, "panelIcons", () => $fdaf5e373b76ddd5$export$4641b622f6c36f58);
$parcel$export(module.exports, "allFieldTypeGlyphs", () => $fdaf5e373b76ddd5$export$14355977bfae6aaa);
$parcel$export(module.exports, "StrictFieldTypeIcon", () => $fdaf5e373b76ddd5$export$aaac7dbe01e6025d);
$parcel$export(module.exports, "FieldTypeIcon", () => $fdaf5e373b76ddd5$export$87c5289d8835f589);
$parcel$export(module.exports, "default", () => $fdaf5e373b76ddd5$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $leHbU = parcelRequire("leHbU");

var $fL0In = parcelRequire("fL0In");

var $bpdtz = parcelRequire("bpdtz");

var $kcLaf = parcelRequire("kcLaf");

var $ePxSL = parcelRequire("ePxSL");

var $jjCK0 = parcelRequire("jjCK0");

var $btkTq = parcelRequire("btkTq");

var $hagIH = parcelRequire("hagIH");

var $i5stJ = parcelRequire("i5stJ");

var $gDKBr = parcelRequire("gDKBr");

var $6zhpo = parcelRequire("6zhpo");

var $bAn7e = parcelRequire("bAn7e");

var $50VmZ = parcelRequire("50VmZ");

var $fRjRq = parcelRequire("fRjRq");

var $dCT0T = parcelRequire("dCT0T");

var $9qes7 = parcelRequire("9qes7");

var $hJIkn = parcelRequire("hJIkn");

var $b8g57 = parcelRequire("b8g57");

var $jPgjO = parcelRequire("jPgjO");

var $hxN6p = parcelRequire("hxN6p");

var $gm7H7 = parcelRequire("gm7H7");

var $2qERs = parcelRequire("2qERs");

var $lmJ87 = parcelRequire("lmJ87");

var $4bKh1 = parcelRequire("4bKh1");

var $8Hdu4 = parcelRequire("8Hdu4");

var $3fGoc = parcelRequire("3fGoc");

var $awZZu = parcelRequire("awZZu");

var $1x1T9 = parcelRequire("1x1T9");

var $787ZT = parcelRequire("787ZT");

var $eALjj = parcelRequire("eALjj");

var $6F4i5 = parcelRequire("6F4i5");

var $6vumB = parcelRequire("6vumB");

var $jGzMk = parcelRequire("jGzMk");

var $3mZMJ = parcelRequire("3mZMJ");

var $4cTDP = parcelRequire("4cTDP");

var $itRkB = parcelRequire("itRkB");
// @ts-expect-error - TS2322 - Type '(props: { [key: string]: string; }) => ReactElement<any, string | JSXElementConstructor<any>>' is not assignable to type 'ComponentType<CustomGlyphProps> | undefined'.
// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
const $fdaf5e373b76ddd5$var$ResizedIcon = ({ glyph: glyph })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        label: "",
        glyph: glyph,
        size: "medium"
    });
const $fdaf5e373b76ddd5$var$TeamCfTypeIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eALjj)));
const $fdaf5e373b76ddd5$var$AddonIcon = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kcLaf))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.addonGlyph)
    });
const $fdaf5e373b76ddd5$var$ArrowRightIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ePxSL))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.arrowRightGlyph)
    });
const $fdaf5e373b76ddd5$var$AttachmentIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jjCK0))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.attachmentGlyph)
    });
const $fdaf5e373b76ddd5$var$BulletListIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hJIkn))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.bulletListGlyph)
    });
const $fdaf5e373b76ddd5$var$CheckboxIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hagIH))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.checkboxGlyph)
    });
const $fdaf5e373b76ddd5$var$CloseIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.closeGlyph)
    });
const $fdaf5e373b76ddd5$var$CommentIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDKBr))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.commentGlyph)
    });
const $fdaf5e373b76ddd5$var$DateIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($btkTq))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dateGlyph)
    });
const $fdaf5e373b76ddd5$var$DropdownIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($50VmZ))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    });
const $fdaf5e373b76ddd5$var$DoubleDropdownIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $itRkB.DoubleDropdownCustomIcon), {
        label: "",
        primaryColor: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.doubleDropdownGlyph)
    });
const $fdaf5e373b76ddd5$var$LabelIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($787ZT))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.labelGlyph)
    });
const $fdaf5e373b76ddd5$var$OfficeBuildingIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jPgjO))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.officeBuildingGlyph)
    });
const $fdaf5e373b76ddd5$var$ParagraphIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bpdtz))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.paragraphGlyph)
    });
const $fdaf5e373b76ddd5$var$PeopleIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gm7H7))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.peopleGlyph)
    });
const $fdaf5e373b76ddd5$var$PeopleGroupIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hxN6p))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.peopleGroupGlyph)
    });
const $fdaf5e373b76ddd5$var$PriorityIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6vumB))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.priorityGlyph)
    });
const $fdaf5e373b76ddd5$var$RadioIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4bKh1))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.radioGlyph)
    });
const $fdaf5e373b76ddd5$var$ScreenIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fGoc))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.screenGlyph)
    });
const $fdaf5e373b76ddd5$var$ShipIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8Hdu4))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.shipGlyph)
    });
const $fdaf5e373b76ddd5$var$ShortTextIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jGzMk))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.shortTextGlyph)
    });
const $fdaf5e373b76ddd5$var$TimeStampIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i5stJ))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.timeStampGlyph)
    });
const $fdaf5e373b76ddd5$var$TimeTrackingIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1x1T9))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.timeTrackingGlyph)
    });
const $fdaf5e373b76ddd5$var$OriginalTimeEstimateIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i5stJ))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.originalTimeEstimateGlyph)
    });
const $fdaf5e373b76ddd5$var$AppAccessIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2qERs))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.appAccessGlyph)
    });
const $fdaf5e373b76ddd5$var$FolderIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dCT0T))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.folderGlyph)
    });
const $fdaf5e373b76ddd5$var$CustomFieldIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fRjRq))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.customFieldGlyph)
    });
const $fdaf5e373b76ddd5$var$JwmCategoryIconWrapper = ()=>(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b8g57))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.jwmCategoryGlyph)
    });
const $fdaf5e373b76ddd5$var$NumberIconWrapper = ()=>!(0, $4cTDP.fg)('enghealth-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bAn7e))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.numberGlyph)
    });
const $fdaf5e373b76ddd5$var$checkedFieldTypesIcons = {
    [(0, $3mZMJ.NUMBER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$NumberIconWrapper, null),
    [(0, $3mZMJ.STORY_POINT_ESTIMATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$NumberIconWrapper, null),
    [(0, $3mZMJ.LABELS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$LabelIconWrapper, null),
    [(0, $3mZMJ.DATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$DateIconWrapper, null),
    [(0, $3mZMJ.DATETIME_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$TimeStampIconWrapper, null),
    [(0, $3mZMJ.RADIO_BUTTONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$RadioIconWrapper, null),
    [(0, $3mZMJ.SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$DropdownIconWrapper, null),
    [(0, $3mZMJ.MULTI_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$DropdownIconWrapper, null),
    [(0, $3mZMJ.CASCADING_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$DoubleDropdownIconWrapper, null),
    [(0, $3mZMJ.MULTI_VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$DropdownIconWrapper, null),
    [(0, $3mZMJ.VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$DropdownIconWrapper, null),
    [(0, $3mZMJ.GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$DropdownIconWrapper, null),
    [(0, $3mZMJ.MULTI_GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$DropdownIconWrapper, null),
    [(0, $3mZMJ.USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$PeopleIconWrapper, null),
    [(0, $leHbU.USERPICKER_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$PeopleIconWrapper, null),
    [(0, $3mZMJ.MULTI_USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$PeopleIconWrapper, null),
    [(0, $leHbU.MULTIUSERPICKER_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$PeopleIconWrapper, null),
    [(0, $3mZMJ.PEOPLE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$PeopleIconWrapper, null),
    [(0, $3mZMJ.FLAGGED_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$TimeStampIconWrapper, null),
    [(0, $3mZMJ.URL_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$CustomFieldIconWrapper, null),
    [(0, $3mZMJ.TEAM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$CustomFieldIconWrapper, null),
    // <ResizedIcon /> was introduced when SWIFT had a limited number of supported field types,
    // but it's no longer a scalable option. We should be using icons directly provided by @atlaskit,
    // and if it does not match our design constraints, then we'll need to investigate contributing to a new @atlaskit icon set.
    [(0, $3mZMJ.TEAMS_PLATFORM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$TeamCfTypeIcon, {
        spacing: "spacious",
        label: ""
    }),
    [(0, $3mZMJ.PARENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$CustomFieldIconWrapper, null),
    [(0, $3mZMJ.BASELINE_START_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$DateIconWrapper, null),
    [(0, $3mZMJ.BASELINE_END_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$DateIconWrapper, null),
    [(0, $3mZMJ.SPRINT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ShipIconWrapper, null),
    [(0, $3mZMJ.REQUEST_PARTICIPANTS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$PeopleGroupIconWrapper, null),
    [(0, $3mZMJ.ORGANIZATIONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$OfficeBuildingIconWrapper, null),
    [(0, $3mZMJ.REPORTER_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$PeopleIconWrapper, null),
    [(0, $3mZMJ.ATTACHMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$AttachmentIconWrapper, null),
    [(0, $3mZMJ.ASSIGNEE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$PeopleIconWrapper, null),
    [(0, $3mZMJ.LABELS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$LabelIconWrapper, null),
    [(0, $3mZMJ.PRIORITY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$PriorityIconWrapper, null),
    [(0, $3mZMJ.DUE_DATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$DateIconWrapper, null),
    [(0, $3mZMJ.TIME_ESTIMATE_CONFIG_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$TimeStampIconWrapper, null),
    [(0, $3mZMJ.TIME_TRACKING_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$TimeTrackingIconWrapper, null),
    [(0, $3mZMJ.TIME_ESTIMATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$OriginalTimeEstimateIconWrapper, null),
    [(0, $3mZMJ.ASSETS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ScreenIconWrapper, null),
    [(0, $3mZMJ.SERVICE_ENTITY_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$LabelIconWrapper, null),
    [(0, $3mZMJ.STATUS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ArrowRightIconWrapper, null),
    [(0, $3mZMJ.SUMMARY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ShortTextIconWrapper, null),
    [(0, $leHbU.DESCRIPTION_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ParagraphIconWrapper, null),
    [(0, $3mZMJ.TEXT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ShortTextIconWrapper, null),
    [(0, $leHbU.TEXT_AREA_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ParagraphIconWrapper, null),
    [(0, $3mZMJ.MULTI_CHECKBOXES_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$CheckboxIconWrapper, null),
    [(0, $3mZMJ.ISSUE_LINKS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$CustomFieldIconWrapper, null),
    [(0, $leHbU.ENVIRONMENT_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ParagraphIconWrapper, null),
    [(0, $3mZMJ.FIX_VERSIONS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$DropdownIconWrapper, null),
    [(0, $3mZMJ.COMMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$CommentIconWrapper, null),
    [(0, $3mZMJ.APPROVERS_LIST_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$AppAccessIconWrapper, null),
    [(0, $3mZMJ.APPROVALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$AppAccessIconWrapper, null),
    [(0, $3mZMJ.PROJECT_PICKER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$FolderIconWrapper, null),
    [(0, $3mZMJ.MESSAGE_EDIT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ParagraphIconWrapper, null),
    [(0, $3mZMJ.MESSAGE_VIEW_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ParagraphIconWrapper, null),
    [(0, $3mZMJ.CATEGORY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$JwmCategoryIconWrapper, null),
    [(0, $3mZMJ.ENTITLEMENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$DropdownIconWrapper, null),
    [(0, $3mZMJ.SENTIMENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$CustomFieldIconWrapper, null),
    [(0, $3mZMJ.GOALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9qes7))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }),
    [(0, $3mZMJ.ATLAS_PROJECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lmJ87))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    }),
    [(0, $3mZMJ.ORGANIZATION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$CustomFieldIconWrapper, null),
    [(0, $3mZMJ.FORMULA_NUMBER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6F4i5))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    })
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
({
    ...$fdaf5e373b76ddd5$var$checkedFieldTypesIcons
});
const $fdaf5e373b76ddd5$export$67f993f3bbfb364d = $fdaf5e373b76ddd5$var$checkedFieldTypesIcons;
const $fdaf5e373b76ddd5$export$4641b622f6c36f58 = {
    development: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($awZZu))), {
        label: "",
        spacing: "spacious"
    }),
    devSummary: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($awZZu))), {
        label: "",
        spacing: "spacious"
    }),
    timetracking: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1x1T9))), {
        label: "",
        spacing: "spacious"
    })
};
/**
 * @deprecated - consider using allFieldTypeGlyphs or FieldTypeIcon instead
 */ const $fdaf5e373b76ddd5$var$allIcons = {
    ...$fdaf5e373b76ddd5$export$67f993f3bbfb364d,
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ParagraphIconWrapper, null),
    number: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$NumberIconWrapper, null),
    date: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$DateIconWrapper, null),
    datetime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$TimeStampIconWrapper, null),
    dropdown: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$DropdownIconWrapper, null),
    addon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$AddonIcon, null),
    checkbox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$CheckboxIconWrapper, null),
    user: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$PeopleIconWrapper, null),
    radio: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$RadioIconWrapper, null),
    time: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$TimeStampIconWrapper, null),
    message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$CommentIconWrapper, null),
    bulletList: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$BulletListIconWrapper, null),
    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$LabelIconWrapper, null),
    labelpicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$LabelIconWrapper, null),
    close: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$CloseIconWrapper, null),
    assetspicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ScreenIconWrapper, null),
    select: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$DropdownIconWrapper, null),
    multiselect: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$DropdownIconWrapper, null),
    cascadingselect: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$DoubleDropdownIconWrapper, null),
    multigrouppicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$DropdownIconWrapper, null),
    grouppicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$DropdownIconWrapper, null),
    multiversion: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$DropdownIconWrapper, null),
    version: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$DropdownIconWrapper, null),
    projectpicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$DropdownIconWrapper, null),
    customField: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$CustomFieldIconWrapper, null)
};
const $fdaf5e373b76ddd5$var$checkedFieldTypesGlyphs = {
    [(0, $3mZMJ.NUMBER_CF_TYPE)]: (0, $itRkB.numberGlyph),
    [(0, $3mZMJ.STORY_POINT_ESTIMATE_CF_TYPE)]: (0, $itRkB.numberGlyph),
    [(0, $3mZMJ.LABELS_CF_TYPE)]: (0, $itRkB.labelGlyph),
    [(0, $3mZMJ.DATE_CF_TYPE)]: (0, $itRkB.dateGlyph),
    [(0, $3mZMJ.DATETIME_CF_TYPE)]: (0, $itRkB.timeStampGlyph),
    [(0, $3mZMJ.RADIO_BUTTONS_CF_TYPE)]: (0, $itRkB.radioGlyph),
    [(0, $3mZMJ.SELECT_CF_TYPE)]: (0, $itRkB.dropdownGlyph),
    [(0, $3mZMJ.MULTI_SELECT_CF_TYPE)]: (0, $itRkB.dropdownGlyph),
    [(0, $3mZMJ.CASCADING_SELECT_CF_TYPE)]: (0, $itRkB.doubleDropdownGlyph),
    [(0, $3mZMJ.MULTI_VERSION_CF_TYPE)]: (0, $itRkB.dropdownGlyph),
    [(0, $3mZMJ.VERSION_CF_TYPE)]: (0, $itRkB.dropdownGlyph),
    [(0, $3mZMJ.GROUP_CF_TYPE)]: (0, $itRkB.dropdownGlyph),
    [(0, $3mZMJ.MULTI_GROUP_CF_TYPE)]: (0, $itRkB.dropdownGlyph),
    [(0, $3mZMJ.USER_CF_TYPE)]: (0, $itRkB.peopleGlyph),
    [(0, $leHbU.USERPICKER_FIELD_TYPE)]: (0, $itRkB.peopleGlyph),
    [(0, $3mZMJ.MULTI_USER_CF_TYPE)]: (0, $itRkB.peopleGlyph),
    [(0, $leHbU.MULTIUSERPICKER_FIELD_TYPE)]: (0, $itRkB.peopleGlyph),
    [(0, $3mZMJ.PEOPLE_CF_TYPE)]: (0, $itRkB.peopleGlyph),
    [(0, $3mZMJ.FLAGGED_CF_TYPE)]: (0, $itRkB.timeStampGlyph),
    [(0, $3mZMJ.URL_CF_TYPE)]: (0, $itRkB.customFieldGlyph),
    [(0, $3mZMJ.TEAM_CF_TYPE)]: (0, $itRkB.customFieldGlyph),
    [(0, $3mZMJ.PARENT_CF_TYPE)]: (0, $itRkB.customFieldGlyph),
    [(0, $3mZMJ.BASELINE_START_CF_TYPE)]: (0, $itRkB.dateGlyph),
    [(0, $3mZMJ.BASELINE_END_CF_TYPE)]: (0, $itRkB.dateGlyph),
    [(0, $3mZMJ.SPRINT_TYPE)]: (0, $itRkB.shipGlyph),
    [(0, $3mZMJ.REQUEST_PARTICIPANTS_CF_TYPE)]: (0, $itRkB.peopleGroupGlyph),
    [(0, $3mZMJ.ORGANIZATIONS_CF_TYPE)]: (0, $itRkB.officeBuildingGlyph),
    [(0, $3mZMJ.REPORTER_TYPE)]: (0, $itRkB.peopleGlyph),
    [(0, $3mZMJ.ATTACHMENT_TYPE)]: (0, $itRkB.attachmentGlyph),
    [(0, $3mZMJ.ASSIGNEE_TYPE)]: (0, $itRkB.peopleGlyph),
    [(0, $3mZMJ.LABELS_TYPE)]: (0, $itRkB.labelGlyph),
    [(0, $3mZMJ.PRIORITY_TYPE)]: (0, $itRkB.priorityGlyph),
    [(0, $3mZMJ.DUE_DATE_TYPE)]: (0, $itRkB.dateGlyph),
    [(0, $3mZMJ.TIME_ESTIMATE_CONFIG_TYPE)]: (0, $itRkB.timeStampGlyph),
    [(0, $3mZMJ.TIME_TRACKING_TYPE)]: (0, $itRkB.timeTrackingGlyph),
    [(0, $3mZMJ.TIME_ESTIMATE_TYPE)]: (0, $itRkB.originalTimeEstimateGlyph),
    [(0, $3mZMJ.ASSETS_CF_TYPE)]: (0, $itRkB.screenGlyph),
    [(0, $3mZMJ.SERVICE_ENTITY_CF_TYPE)]: (0, $itRkB.labelGlyph),
    [(0, $3mZMJ.STATUS_TYPE)]: (0, $itRkB.arrowRightGlyph),
    [(0, $3mZMJ.SUMMARY_TYPE)]: (0, $itRkB.shortTextGlyph),
    [(0, $leHbU.DESCRIPTION_FIELD_TYPE)]: (0, $itRkB.paragraphGlyph),
    [(0, $3mZMJ.TEXT_CF_TYPE)]: (0, $itRkB.shortTextGlyph),
    [(0, $leHbU.TEXT_AREA_CF_TYPE)]: (0, $itRkB.paragraphGlyph),
    [(0, $3mZMJ.MULTI_CHECKBOXES_CF_TYPE)]: (0, $itRkB.checkboxGlyph),
    [(0, $3mZMJ.ISSUE_LINKS_TYPE)]: (0, $itRkB.customFieldGlyph),
    [(0, $leHbU.ENVIRONMENT_FIELD_TYPE)]: (0, $itRkB.paragraphGlyph),
    [(0, $3mZMJ.FIX_VERSIONS_TYPE)]: (0, $itRkB.dropdownGlyph),
    [(0, $3mZMJ.COMMENT_TYPE)]: (0, $itRkB.commentGlyph),
    [(0, $3mZMJ.APPROVERS_LIST_CF_TYPE)]: (0, $itRkB.appAccessGlyph),
    [(0, $3mZMJ.APPROVALS_CF_TYPE)]: (0, $itRkB.appAccessGlyph),
    [(0, $3mZMJ.PROJECT_PICKER_CF_TYPE)]: (0, $itRkB.folderGlyph),
    [(0, $3mZMJ.MESSAGE_EDIT_CF_TYPE)]: (0, $itRkB.paragraphGlyph),
    [(0, $3mZMJ.MESSAGE_VIEW_CF_TYPE)]: (0, $itRkB.paragraphGlyph),
    [(0, $3mZMJ.CATEGORY_TYPE)]: (0, $itRkB.jwmCategoryGlyph),
    [(0, $3mZMJ.ENTITLEMENT_CF_TYPE)]: (0, $itRkB.dropdownGlyph),
    [(0, $3mZMJ.SENTIMENT_CF_TYPE)]: (0, $itRkB.customFieldGlyph),
    [(0, $3mZMJ.ORGANIZATION_CF_TYPE)]: (0, $itRkB.customFieldGlyph),
    [(0, $3mZMJ.ATLAS_PROJECT_CF_TYPE)]: (0, $itRkB.customFieldGlyph)
};
const $fdaf5e373b76ddd5$export$14355977bfae6aaa = {
    ...$fdaf5e373b76ddd5$var$checkedFieldTypesGlyphs,
    text: (0, $itRkB.paragraphGlyph),
    number: (0, $itRkB.numberGlyph),
    date: (0, $itRkB.dateGlyph),
    datetime: (0, $itRkB.timeStampGlyph),
    dropdown: (0, $itRkB.dropdownGlyph),
    addon: (0, $itRkB.addonGlyph),
    checkbox: (0, $itRkB.checkboxGlyph),
    user: (0, $itRkB.peopleGlyph),
    radio: (0, $itRkB.radioGlyph),
    time: (0, $itRkB.timeStampGlyph),
    message: (0, $itRkB.commentGlyph),
    bulletList: (0, $itRkB.bulletListGlyph),
    label: (0, $itRkB.labelGlyph),
    labelpicker: (0, $itRkB.labelGlyph),
    close: (0, $itRkB.closeGlyph),
    assetspicker: (0, $itRkB.screenGlyph),
    select: (0, $itRkB.dropdownGlyph),
    multiselect: (0, $itRkB.dropdownGlyph),
    cascadingselect: (0, $itRkB.doubleDropdownGlyph),
    multigrouppicker: (0, $itRkB.dropdownGlyph),
    grouppicker: (0, $itRkB.dropdownGlyph),
    multiversion: (0, $itRkB.dropdownGlyph),
    version: (0, $itRkB.dropdownGlyph),
    projectpicker: (0, $itRkB.dropdownGlyph),
    customField: (0, $itRkB.customFieldGlyph)
};
const $fdaf5e373b76ddd5$var$newIconMapping = {
    [(0, $3mZMJ.NUMBER_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bAn7e))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.STORY_POINT_ESTIMATE_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bAn7e))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.LABELS_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($787ZT))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.LABELS_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($787ZT))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.SERVICE_ENTITY_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($787ZT))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.DATE_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($btkTq))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.DUE_DATE_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($btkTq))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.BASELINE_START_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($btkTq))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.BASELINE_END_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($btkTq))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.DATETIME_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i5stJ))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.FLAGGED_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i5stJ))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.TIME_ESTIMATE_CONFIG_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i5stJ))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.TIME_ESTIMATE_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i5stJ))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.RADIO_BUTTONS_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4bKh1))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.SELECT_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($50VmZ))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.MULTI_SELECT_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($50VmZ))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.MULTI_VERSION_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($50VmZ))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.VERSION_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($50VmZ))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.GROUP_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($50VmZ))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.MULTI_GROUP_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($50VmZ))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.FIX_VERSIONS_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($50VmZ))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.ENTITLEMENT_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($50VmZ))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.CASCADING_SELECT_CF_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $itRkB.DoubleDropdownCustomIcon), {
            label: "",
            primaryColor: "var(--ds-icon, #292A2E)"
        }),
    [(0, $3mZMJ.USER_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gm7H7))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $leHbU.USERPICKER_FIELD_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gm7H7))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.MULTI_USER_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gm7H7))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $leHbU.MULTIUSERPICKER_FIELD_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gm7H7))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.PEOPLE_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gm7H7))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.REPORTER_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gm7H7))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.ASSIGNEE_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gm7H7))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.URL_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fRjRq))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.TEAM_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fRjRq))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.PARENT_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fRjRq))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.ISSUE_LINKS_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fRjRq))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.SENTIMENT_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fRjRq))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.ORGANIZATION_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fRjRq))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.SPRINT_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8Hdu4))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.REQUEST_PARTICIPANTS_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hxN6p))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.ORGANIZATIONS_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jPgjO))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.ATTACHMENT_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jjCK0))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.PRIORITY_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6vumB))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.TIME_TRACKING_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1x1T9))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.ASSETS_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fGoc))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.STATUS_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ePxSL))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.SUMMARY_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jGzMk))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.TEXT_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jGzMk))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $leHbU.DESCRIPTION_FIELD_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bpdtz))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $leHbU.TEXT_AREA_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bpdtz))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $leHbU.ENVIRONMENT_FIELD_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bpdtz))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.MESSAGE_EDIT_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bpdtz))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.MESSAGE_VIEW_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bpdtz))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.MULTI_CHECKBOXES_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hagIH))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.COMMENT_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDKBr))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.APPROVERS_LIST_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2qERs))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.APPROVALS_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2qERs))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.PROJECT_PICKER_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dCT0T))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.CATEGORY_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b8g57))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.TEAMS_PLATFORM_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eALjj))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            size: size
        }),
    [(0, $3mZMJ.GOALS_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9qes7))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.ATLAS_PROJECT_CF_TYPE)]: (size, testId)=>(0, $4cTDP.fg)('atlassian_projects_admin_icon') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lmJ87))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fRjRq))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        }),
    [(0, $3mZMJ.FORMULA_NUMBER_CF_TYPE)]: (size, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6F4i5))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)",
            size: size
        })
};
const $fdaf5e373b76ddd5$var$getNewIconForType = (type, size, testId)=>{
    const iconRenderer = $fdaf5e373b76ddd5$var$newIconMapping[type];
    if (!iconRenderer) return null;
    return iconRenderer(size, testId);
};
const $fdaf5e373b76ddd5$export$aaac7dbe01e6025d = /*#__PURE__*/ (0, $eJOHy.memo)(({ type: type, size: size = 'medium', testId: testId })=>{
    if ((0, $4cTDP.fg)('enghealth-custom-icon-migration')) {
        const newIcon = $fdaf5e373b76ddd5$var$getNewIconForType(type, size, testId);
        if (newIcon) return newIcon;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fRjRq))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)"
        });
    }
    if (type === (0, $3mZMJ.TEAMS_PLATFORM_CF_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eALjj))), {
        label: "",
        size: size,
        spacing: "spacious",
        testId: testId
    });
    if (type === (0, $3mZMJ.GOALS_CF_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9qes7))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #292A2E)"
    });
    if (type === (0, $3mZMJ.ATLAS_PROJECT_CF_TYPE) && (0, $4cTDP.fg)('atlassian_projects_admin_icon')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lmJ87))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #292A2E)"
    });
    if (type === (0, $3mZMJ.FORMULA_NUMBER_CF_TYPE) && (0, $4cTDP.fg)('frontier-formula-field-d1')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6F4i5))), {
        label: "",
        testId: testId,
        color: "var(--ds-icon, #292A2E)"
    });
    return(// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        label: "",
        glyph: $fdaf5e373b76ddd5$var$checkedFieldTypesGlyphs[type] || $fdaf5e373b76ddd5$var$checkedFieldTypesGlyphs.customField,
        size: size,
        testId: testId
    }));
});
const $fdaf5e373b76ddd5$export$87c5289d8835f589 = /*#__PURE__*/ (0, $eJOHy.memo)(({ type: type, size: size = 'medium', testId: testId })=>{
    if ((0, $4cTDP.fg)('enghealth-custom-icon-migration')) {
        const newIcon = $fdaf5e373b76ddd5$var$getNewIconForType(type, size, testId);
        if (newIcon) return newIcon;
        // Fallback to default field icon
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fRjRq))), {
            label: "",
            spacing: "spacious",
            testId: testId,
            color: "var(--ds-icon, #292A2E)"
        });
    }
    // Legacy behavior when feature gate is disabled
    if (type === (0, $3mZMJ.TEAMS_PLATFORM_CF_TYPE)) {
        const iconSpacing = size === 'small' ? 'compact' : 'spacious';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eALjj))), {
            label: "",
            size: size,
            spacing: iconSpacing,
            testId: testId
        });
    }
    if (type === (0, $3mZMJ.GOALS_CF_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9qes7))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #292A2E)"
    });
    if (type === (0, $3mZMJ.ATLAS_PROJECT_CF_TYPE) && (0, $4cTDP.fg)('atlassian_projects_admin_icon')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lmJ87))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #292A2E)"
    });
    if (type === (0, $3mZMJ.FORMULA_NUMBER_CF_TYPE) && (0, $4cTDP.fg)('frontier-formula-field-d1')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6F4i5))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    });
    return(// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        label: "",
        glyph: $fdaf5e373b76ddd5$export$14355977bfae6aaa[type] || $fdaf5e373b76ddd5$export$14355977bfae6aaa.customField,
        size: size,
        testId: testId
    }));
});
var /**
 * @deprecated - Use allFieldTypeGlyphs or FieldTypeIcon instead.
 */ $fdaf5e373b76ddd5$export$2e2bcd8739ae039 = $fdaf5e373b76ddd5$var$allIcons;

});
parcelRegister("ePxSL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::702c7642ca2bbc12ec1dc2b75efbc1ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acc01c6bd1fc51c7$var$_react = $acc01c6bd1fc51c7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $acc01c6bd1fc51c7$var$_baseNew = $acc01c6bd1fc51c7$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $acc01c6bd1fc51c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $acc01c6bd1fc51c7$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $acc01c6bd1fc51c7$var$_react.default.createElement($acc01c6bd1fc51c7$var$_baseNew.default, Object.assign({
        name: "ArrowRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$acc01c6bd1fc51c7$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $acc01c6bd1fc51c7$var$_default = module.exports.default = $acc01c6bd1fc51c7$var$ArrowRightIcon;

});

parcelRegister("jjCK0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1df8f3604b71bb3b07e9fa53eb6c9031>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e0fdd7d84e8bb8da$var$_react = $e0fdd7d84e8bb8da$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e0fdd7d84e8bb8da$var$_baseNew = $e0fdd7d84e8bb8da$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e0fdd7d84e8bb8da$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Attachment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for attaching files to work types or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e0fdd7d84e8bb8da$var$AttachmentIcon = (props)=>/*#__PURE__*/ $e0fdd7d84e8bb8da$var$_react.default.createElement($e0fdd7d84e8bb8da$var$_baseNew.default, Object.assign({
        name: "AttachmentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m5.22 8.47 4.5-4.5 1.06 1.06-4.5 4.5a.664.664 0 0 0 .94.94l4.5-4.5a2.079 2.079 0 0 0-2.94-2.94l-4.5 4.5a3.492 3.492 0 0 0 4.94 4.94l2.5-2.5 1.06 1.06-2.5 2.5a4.993 4.993 0 0 1-7.06-7.06l4.5-4.5a3.578 3.578 0 0 1 5.06 5.06l-4.5 4.5a2.165 2.165 0 0 1-3.06-3.06"/>`
    }, props));
$e0fdd7d84e8bb8da$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $e0fdd7d84e8bb8da$var$_default = module.exports.default = $e0fdd7d84e8bb8da$var$AttachmentIcon;

});

parcelRegister("btkTq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c44ca3af5d99d99573761123bc1c1f79>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85a29c08b1b7d658$var$_react = $85a29c08b1b7d658$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $85a29c08b1b7d658$var$_baseNew = $85a29c08b1b7d658$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $85a29c08b1b7d658$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $85a29c08b1b7d658$var$CalendarIcon = (props)=>/*#__PURE__*/ $85a29c08b1b7d658$var$_react.default.createElement($85a29c08b1b7d658$var$_baseNew.default, Object.assign({
        name: "CalendarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$85a29c08b1b7d658$var$CalendarIcon.displayName = 'CalendarIcon';
var $85a29c08b1b7d658$var$_default = module.exports.default = $85a29c08b1b7d658$var$CalendarIcon;

});

parcelRegister("hagIH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3cffb1e2896c4c9b0f7d38ebabc4260>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7f057169373f605$var$_react = $c7f057169373f605$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c7f057169373f605$var$_baseNew = $c7f057169373f605$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c7f057169373f605$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7f057169373f605$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $c7f057169373f605$var$_react.default.createElement($c7f057169373f605$var$_baseNew.default, Object.assign({
        name: "CheckboxCheckedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$c7f057169373f605$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $c7f057169373f605$var$_default = module.exports.default = $c7f057169373f605$var$CheckboxCheckedIcon;

});

parcelRegister("bAn7e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5ce11e14058ccd074504e3c8591c7cbb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86f4fccfbbb95621$var$_react = $86f4fccfbbb95621$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $86f4fccfbbb95621$var$_baseNew = $86f4fccfbbb95621$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $86f4fccfbbb95621$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DataNumber".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Representing number datatype fields in Proforma and databases.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $86f4fccfbbb95621$var$DataNumberIcon = (props)=>/*#__PURE__*/ $86f4fccfbbb95621$var$_react.default.createElement($86f4fccfbbb95621$var$_baseNew.default, Object.assign({
        name: "DataNumberIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.75 4h2a.75.75 0 0 1 .75.75V12H2V5.5H.75zM5 4h3.13c.76 0 1.38.62 1.38 1.38v2c0 .76-.62 1.38-1.37 1.38H6.5v1.75h3V12H5.75a.75.75 0 0 1-.75-.75V8.63c0-.76.62-1.37 1.38-1.37H8V5.5H5zm6 0h3.13c.76 0 1.38.62 1.38 1.38v5.25c0 .76-.62 1.38-1.37 1.38H11v-1.5h3V8.75h-3v-1.5h3V5.5h-3z" clip-rule="evenodd"/>`
    }, props));
$86f4fccfbbb95621$var$DataNumberIcon.displayName = 'DataNumberIcon';
var $86f4fccfbbb95621$var$_default = module.exports.default = $86f4fccfbbb95621$var$DataNumberIcon;

});

parcelRegister("50VmZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b9586fb5efe71b6941b8bd5aa4e67c1a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a69744c8bf0b664$var$_react = $3a69744c8bf0b664$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $3a69744c8bf0b664$var$_baseNew = $3a69744c8bf0b664$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $3a69744c8bf0b664$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldDropdown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Dropdown field type in Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a69744c8bf0b664$var$FieldDropdownIcon = (props)=>/*#__PURE__*/ $3a69744c8bf0b664$var$_react.default.createElement($3a69744c8bf0b664$var$_baseNew.default, Object.assign({
        name: "FieldDropdownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 3.5H0V2h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H0v-1.5h14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5M9 8.19 7.03 6.22 5.97 7.28l2.5 2.5a.75.75 0 0 0 1.06 0l2.5-2.5-1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$3a69744c8bf0b664$var$FieldDropdownIcon.displayName = 'FieldDropdownIcon';
var $3a69744c8bf0b664$var$_default = module.exports.default = $3a69744c8bf0b664$var$FieldDropdownIcon;

});

parcelRegister("fRjRq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::663e27e9cbfa2b4d992cb1e55c9c3afb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b8bb362ff868ed95$var$_react = $b8bb362ff868ed95$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b8bb362ff868ed95$var$_baseNew = $b8bb362ff868ed95$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $b8bb362ff868ed95$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Field".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Field suggestions provided by Atlassian Intelligence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b8bb362ff868ed95$var$FieldIcon = (props)=>/*#__PURE__*/ $b8bb362ff868ed95$var$_react.default.createElement($b8bb362ff868ed95$var$_baseNew.default, Object.assign({
        name: "FieldIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 3.5H0V2h6zM0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$b8bb362ff868ed95$var$FieldIcon.displayName = 'FieldIcon';
var $b8bb362ff868ed95$var$_default = module.exports.default = $b8bb362ff868ed95$var$FieldIcon;

});

parcelRegister("dCT0T", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::329ffe53264930b81eb140b6c3cd31f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9eb97f7a872c0087$var$_react = $9eb97f7a872c0087$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9eb97f7a872c0087$var$_baseNew = $9eb97f7a872c0087$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $9eb97f7a872c0087$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FolderClosed".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9eb97f7a872c0087$var$FolderClosedIcon = (props)=>/*#__PURE__*/ $9eb97f7a872c0087$var$_react.default.createElement($9eb97f7a872c0087$var$_baseNew.default, Object.assign({
        name: "FolderClosedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v3h11V4.75a.5.5 0 0 0-.5-.5H7.69L5.94 2.5zm10.5 5h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h3.56l1.75 1.75H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$9eb97f7a872c0087$var$FolderClosedIcon.displayName = 'FolderClosedIcon';
var $9eb97f7a872c0087$var$_default = module.exports.default = $9eb97f7a872c0087$var$FolderClosedIcon;

});

parcelRegister("b8g57", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ba900c72212c64dae6bc7b16bbe38cce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81acea8a8fedcfd4$var$_react = $81acea8a8fedcfd4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $81acea8a8fedcfd4$var$_baseNew = $81acea8a8fedcfd4$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $81acea8a8fedcfd4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Menu".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for accessing the menu in global app navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $81acea8a8fedcfd4$var$MenuIcon = (props)=>/*#__PURE__*/ $81acea8a8fedcfd4$var$_react.default.createElement($81acea8a8fedcfd4$var$_baseNew.default, Object.assign({
        name: "MenuIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M15 12.5V14H1v-1.5zm0-5.25v1.5H1v-1.5zM15 2v1.5H1V2z"/>`
    }, props));
$81acea8a8fedcfd4$var$MenuIcon.displayName = 'MenuIcon';
var $81acea8a8fedcfd4$var$_default = module.exports.default = $81acea8a8fedcfd4$var$MenuIcon;

});

parcelRegister("jPgjO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61e479f96d30ea6369ef34d699ad08b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6ef7042ada3add3$var$_react = $e6ef7042ada3add3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e6ef7042ada3add3$var$_baseNew = $e6ef7042ada3add3$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e6ef7042ada3add3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "OfficeBuilding".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6ef7042ada3add3$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $e6ef7042ada3add3$var$_react.default.createElement($e6ef7042ada3add3$var$_baseNew.default, Object.assign({
        name: "OfficeBuildingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12.5h1V16H1v-1.5h1zm1.5 12.5h2v-3.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v3.75h2V2a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5zm5.5 0v-3H7v3zm-2-10H5V3h2zm4 0H9V3h2zM5 6h2v1.5H5zm4 0h2v1.5H9z" clip-rule="evenodd"/>`
    }, props));
$e6ef7042ada3add3$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $e6ef7042ada3add3$var$_default = module.exports.default = $e6ef7042ada3add3$var$OfficeBuildingIcon;

});

parcelRegister("2qERs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c984ce41c65c1282842203d88da9a773>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1c4db4a83ea38937$var$_react = $1c4db4a83ea38937$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $1c4db4a83ea38937$var$_baseNew = $1c4db4a83ea38937$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $1c4db4a83ea38937$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdded".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for a user added to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1c4db4a83ea38937$var$PersonAddedIcon = (props)=>/*#__PURE__*/ $1c4db4a83ea38937$var$_react.default.createElement($1c4db4a83ea38937$var$_baseNew.default, Object.assign({
        name: "PersonAddedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m14.877 2.03-4 4a.75.75 0 0 1-1.051.01L8.98 8.262l1.04-1.08 1.316 1.267 3.48-3.48zM3.75 10.5a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.52a3.75 3.75 0 0 1 3.75 3.75V15h-1.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$1c4db4a83ea38937$var$PersonAddedIcon.displayName = 'PersonAddedIcon';
var $1c4db4a83ea38937$var$_default = module.exports.default = $1c4db4a83ea38937$var$PersonAddedIcon;

});

parcelRegister("4bKh1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::87b94670fd4bfa0886206b088d0c3b5d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30cc157d45e3093e$var$_react = $30cc157d45e3093e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $30cc157d45e3093e$var$_baseNew = $30cc157d45e3093e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $30cc157d45e3093e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RadioChecked".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for the selected state of radio controls.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30cc157d45e3093e$var$RadioCheckedIcon = (props)=>/*#__PURE__*/ $30cc157d45e3093e$var$_react.default.createElement($30cc157d45e3093e$var$_baseNew.default, Object.assign({
        name: "RadioCheckedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
    }, props));
$30cc157d45e3093e$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
var $30cc157d45e3093e$var$_default = module.exports.default = $30cc157d45e3093e$var$RadioCheckedIcon;

});

parcelRegister("3fGoc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7c3928c64a97db38eb981c4055c674e5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25e3a76f3acc4c37$var$_react = $25e3a76f3acc4c37$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $25e3a76f3acc4c37$var$_baseNew = $25e3a76f3acc4c37$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $25e3a76f3acc4c37$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Screen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: assets in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25e3a76f3acc4c37$var$ScreenIcon = (props)=>/*#__PURE__*/ $25e3a76f3acc4c37$var$_react.default.createElement($25e3a76f3acc4c37$var$_baseNew.default, Object.assign({
        name: "ScreenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H8.75v1.5H12V15H4v-1.5h3.25V12H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$25e3a76f3acc4c37$var$ScreenIcon.displayName = 'ScreenIcon';
var $25e3a76f3acc4c37$var$_default = module.exports.default = $25e3a76f3acc4c37$var$ScreenIcon;

});

parcelRegister("awZZu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5d8d971bf9def65ea3fd98a53d2a797b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7aacfa98324a1e60$var$_react = $7aacfa98324a1e60$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7aacfa98324a1e60$var$_baseNew = $7aacfa98324a1e60$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7aacfa98324a1e60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7aacfa98324a1e60$var$BranchIcon = (props)=>/*#__PURE__*/ $7aacfa98324a1e60$var$_react.default.createElement($7aacfa98324a1e60$var$_baseNew.default, Object.assign({
        name: "BranchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$7aacfa98324a1e60$var$BranchIcon.displayName = 'BranchIcon';
var $7aacfa98324a1e60$var$_default = module.exports.default = $7aacfa98324a1e60$var$BranchIcon;

});

parcelRegister("1x1T9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::151fe33e88b0ee8f745faaf0f04d86d9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $11da568a8257a9ac$var$_react = $11da568a8257a9ac$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $11da568a8257a9ac$var$_baseNew = $11da568a8257a9ac$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $11da568a8257a9ac$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Stopwatch".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: timer in Confluence Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $11da568a8257a9ac$var$StopwatchIcon = (props)=>/*#__PURE__*/ $11da568a8257a9ac$var$_react.default.createElement($11da568a8257a9ac$var$_baseNew.default, Object.assign({
        name: "StopwatchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 0h6v1.5H8.75v1.543a6.47 6.47 0 0 1 3.06 1.19l1.137-1.24 1.106 1.014-1.137 1.24a6.5 6.5 0 1 1-9.832 0l-1.137-1.24 1.106-1.014 1.137 1.24a6.47 6.47 0 0 1 3.06-1.19V1.5H5zm3 4.5a4.98 4.98 0 0 0-3.378 1.314A5 5 0 1 0 8 4.5m2.842 3.01-2.541 2.75-1.102-1.02 2.542-2.75z" clip-rule="evenodd"/>`
    }, props));
$11da568a8257a9ac$var$StopwatchIcon.displayName = 'StopwatchIcon';
var $11da568a8257a9ac$var$_default = module.exports.default = $11da568a8257a9ac$var$StopwatchIcon;

});

parcelRegister("6F4i5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32871a9e1205ad83473907533912c2d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4d99e67988431e9e$var$_react = $4d99e67988431e9e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4d99e67988431e9e$var$_baseNew = $4d99e67988431e9e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $4d99e67988431e9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DataFormula".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for data formulas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4d99e67988431e9e$var$DataFormulaIcon = (props)=>/*#__PURE__*/ $4d99e67988431e9e$var$_react.default.createElement($4d99e67988431e9e$var$_baseNew.default, Object.assign({
        name: "DataFormulaIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9 0a2.5 2.5 0 0 1 2.5 2.5H10a1 1 0 0 0-1-1h-.12a1.12 1.12 0 0 0-1.11.967L7.354 5.5H10V7H7.146l-.93 6.738A2.62 2.62 0 0 1 1 13.38V13h1.5v.38a1.12 1.12 0 0 0 2.23.153L5.63 7H4V5.5h1.838l.446-3.238A2.62 2.62 0 0 1 8.88 0z"/><path fill="currentcolor" d="m15.052 9.008-2.392 2.598 1.948 2.706-1.216.877-1.768-2.456-2.322 2.525-1.104-1.016 2.53-2.752-1.836-2.552 1.216-.876 1.658 2.301 2.182-2.37z"/>`
    }, props));
$4d99e67988431e9e$var$DataFormulaIcon.displayName = 'DataFormulaIcon';
var $4d99e67988431e9e$var$_default = module.exports.default = $4d99e67988431e9e$var$DataFormulaIcon;

});

parcelRegister("6vumB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c4f2fef1ec35c36d4cfeace658ed86fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4bcd30e80e247968$var$_react = $4bcd30e80e247968$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4bcd30e80e247968$var$_baseNew = $4bcd30e80e247968$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $4bcd30e80e247968$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SortOptions".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for accessing sorting options.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4bcd30e80e247968$var$SortOptionsIcon = (props)=>/*#__PURE__*/ $4bcd30e80e247968$var$_react.default.createElement($4bcd30e80e247968$var$_baseNew.default, Object.assign({
        name: "SortOptionsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.22 1.22a.75.75 0 0 1 1.06 0l3.25 3.25-1.06 1.06L5.5 3.56V14H4V3.56L2.03 5.53.97 4.47zm6.28 11.22V2H12v10.44l1.97-1.97 1.06 1.06-3.25 3.25a.75.75 0 0 1-1.06 0l-3.25-3.25 1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$4bcd30e80e247968$var$SortOptionsIcon.displayName = 'SortOptionsIcon';
var $4bcd30e80e247968$var$_default = module.exports.default = $4bcd30e80e247968$var$SortOptionsIcon;

});

parcelRegister("jGzMk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e437ff979ed52fe3fc89de1b184e851d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e54db1713eaf5b0e$var$_react = $e54db1713eaf5b0e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e54db1713eaf5b0e$var$_baseNew = $e54db1713eaf5b0e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e54db1713eaf5b0e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextLetterCase".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for letter casing and text-transform
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e54db1713eaf5b0e$var$TextLetterCaseIcon = (props)=>/*#__PURE__*/ $e54db1713eaf5b0e$var$_react.default.createElement($e54db1713eaf5b0e$var$_baseNew.default, Object.assign({
        name: "TextLetterCaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 13h-1.5v-.38a3.1 3.1 0 0 1-1.87.63c-1.95 0-3.37-1.78-3.37-3.75s1.42-3.75 3.38-3.75c.71 0 1.35.24 1.88.63v-.63H16zm-3.37-5.75c-.94 0-1.87.91-1.87 2.25s.93 2.25 1.88 2.25 1.86-.91 1.86-2.25-.93-2.25-1.87-2.25M5.71 3.51 8.92 13H7.33l-.84-2.5H2.51L1.67 13H.09l3.2-9.49.17-.51h2.08zM3.02 9h2.96L4.5 4.61z" clip-rule="evenodd"/>`
    }, props));
$e54db1713eaf5b0e$var$TextLetterCaseIcon.displayName = 'TextLetterCaseIcon';
var $e54db1713eaf5b0e$var$_default = module.exports.default = $e54db1713eaf5b0e$var$TextLetterCaseIcon;

});

parcelRegister("itRkB", function(module, exports) {
$parcel$export(module.exports, "numberGlyph", () => $c548f0a472b13f77$export$b368272069fe93ea);
$parcel$export(module.exports, "checkboxGlyph", () => $c548f0a472b13f77$export$747056db840f2e62);
$parcel$export(module.exports, "folderGlyph", () => $c548f0a472b13f77$export$fc939f15c0ac57d8);
$parcel$export(module.exports, "dateGlyph", () => $c548f0a472b13f77$export$54ae6633cc16eed1);
$parcel$export(module.exports, "dropdownGlyph", () => $c548f0a472b13f77$export$d298f123ec74117c);
$parcel$export(module.exports, "doubleDropdownGlyph", () => $c548f0a472b13f77$export$b3ea0fc10228ca3e);
$parcel$export(module.exports, "DoubleDropdownCustomIcon", () => $c548f0a472b13f77$export$cd14f50bd919de37);
$parcel$export(module.exports, "labelGlyph", () => $c548f0a472b13f77$export$fc64eea29ed0831d);
$parcel$export(module.exports, "paragraphGlyph", () => $c548f0a472b13f77$export$cbee9ded46569696);
$parcel$export(module.exports, "peopleGlyph", () => $c548f0a472b13f77$export$2ade78849d2113ea);
$parcel$export(module.exports, "shortTextGlyph", () => $c548f0a472b13f77$export$1c6cf19eb34bcc14);
$parcel$export(module.exports, "timeStampGlyph", () => $c548f0a472b13f77$export$98a4a461fe316fce);
$parcel$export(module.exports, "timeTrackingGlyph", () => $c548f0a472b13f77$export$637d50811e2b7176);
$parcel$export(module.exports, "originalTimeEstimateGlyph", () => $c548f0a472b13f77$export$bc2bb299bed9df91);
$parcel$export(module.exports, "arrowRightGlyph", () => $c548f0a472b13f77$export$3a9d3f1c52f4dab9);
$parcel$export(module.exports, "addonGlyph", () => $c548f0a472b13f77$export$a4cdad58220c405a);
$parcel$export(module.exports, "attachmentGlyph", () => $c548f0a472b13f77$export$e6e85f1bc2e23bd4);
$parcel$export(module.exports, "bulletListGlyph", () => $c548f0a472b13f77$export$a6a7f7b7c0399a2a);
$parcel$export(module.exports, "commentGlyph", () => $c548f0a472b13f77$export$835d228e2a9d6a93);
$parcel$export(module.exports, "officeBuildingGlyph", () => $c548f0a472b13f77$export$fdad804cb16a6544);
$parcel$export(module.exports, "peopleGroupGlyph", () => $c548f0a472b13f77$export$a20644de4b67f161);
$parcel$export(module.exports, "radioGlyph", () => $c548f0a472b13f77$export$ce87e45dceec205d);
$parcel$export(module.exports, "shipGlyph", () => $c548f0a472b13f77$export$d95e2215202c8556);
$parcel$export(module.exports, "priorityGlyph", () => $c548f0a472b13f77$export$3062e49c5521698d);
$parcel$export(module.exports, "screenGlyph", () => $c548f0a472b13f77$export$17d48fc8b753df77);
$parcel$export(module.exports, "closeGlyph", () => $c548f0a472b13f77$export$cbbe21ca62a58ed6);
$parcel$export(module.exports, "appAccessGlyph", () => $c548f0a472b13f77$export$8fd991b9da3a43e5);
$parcel$export(module.exports, "jwmCategoryGlyph", () => $c548f0a472b13f77$export$f21213fb7b480582);
$parcel$export(module.exports, "customFieldGlyph", () => $c548f0a472b13f77$export$88453606d7da6ff7);
/* shortTextGlyph.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
const $c548f0a472b13f77$export$b368272069fe93ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M7 4h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm.417 10.636h1.15V9.141H7.42L6 10.12v1.07l1.348-.93h.069v4.376zm1.923-3.85v.02h1.067v-.024c0-.506.365-.857.898-.857.503 0 .861.313.861.755 0 .357-.194.643-.967 1.397l-1.794 1.756v.803h3.964v-.955h-2.406v-.069l1.05-1.002c.953-.895 1.277-1.409 1.277-2.007 0-.944-.8-1.603-1.947-1.603-1.188 0-2.003.724-2.003 1.786zm5.811 1.466h.682c.617 0 .994.297.994.777 0 .469-.4.792-.975.792-.59 0-.983-.293-1.017-.757h-1.1c.05 1.035.88 1.713 2.106 1.713 1.253 0 2.159-.697 2.159-1.66 0-.724-.472-1.226-1.226-1.31v-.069c.613-.125 1.013-.62 1.013-1.257 0-.864-.811-1.481-1.939-1.481-1.2 0-1.972.655-2.01 1.695H14.9c.03-.476.385-.777.918-.777.537 0 .88.282.88.723 0 .45-.355.754-.876.754h-.67v.857z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$747056db840f2e62 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4 5.994C4 4.893 4.895 4 5.994 4h12.012C19.107 4 20 4.895 20 5.994v12.012A1.995 1.995 0 0 1 18.006 20H5.994A1.995 1.995 0 0 1 4 18.006V5.994zm5.707 5.299a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$fc939f15c0ac57d8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M20 19V8h-9.154l-.503-1.258-.455-1.136C9.778 5.33 9.291 5 9.003 5H3.997C4.002 5 4 19 4 19h16zM12.2 6h7.809C21.109 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.991 1.992H3.991C2.891 21 2 20.107 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862L12.2 6z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$54ae6633cc16eed1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M8.667 6.167V7A.834.834 0 0 1 7 7V5.333a.834.834 0 0 1 1.667 0v.834zm6.666 0v-.834a.834.834 0 0 1 1.667 0V7a.834.834 0 0 1-1.667 0v-.833zm2.5 0h.005c.918 0 1.662.745 1.662 1.661v10.01c0 .918-.743 1.662-1.662 1.662H6.161A1.663 1.663 0 0 1 4.5 17.838V7.828c0-.917.743-1.661 1.662-1.661h.005V7c0 .927.746 1.667 1.666 1.667C8.76 8.667 9.5 7.92 9.5 7v-.833h5V7c0 .927.746 1.667 1.667 1.667.927 0 1.666-.747 1.666-1.667v-.833zm-10 6.667H9.5v-1.667H7.833v1.667zm0 3.334H9.5V14.5H7.833v1.668zm3.334-3.334h1.666v-1.667h-1.666v1.667zm0 3.334h1.666V14.5h-1.666v1.668zm3.333-3.334h1.667v-1.667H14.5v1.667zm0 3.334h1.667V14.5H14.5v1.668z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$d298f123ec74117c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM15.708 11.723L12.779 14.678C12.566 14.893 12.288 15 12.009 15C11.73 15 11.449 14.893 11.231 14.678L8.291 11.713C7.903 11.321 7.903 10.686 8.291 10.294C8.679 9.902 9.309 9.902 9.698 10.294L12.005 12.621L14.303 10.304C14.69 9.912 15.32 9.912 15.708 10.304C16.097 10.696 16.097 11.331 15.708 11.723Z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$b3ea0fc10228ca3e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM10.0543 7.95865C9.72121 7.63948 9.17412 7.63199 8.83238 7.94192C8.49064 8.25184 8.48365 8.76182 8.81678 9.08099L11.3658 11.5232C11.5389 11.689 11.7698 11.7707 11.9997 11.7675C12.2295 11.7707 12.4604 11.689 12.6335 11.5232L15.1825 9.08099C15.5156 8.76182 15.5087 8.25184 15.1669 7.94192C14.8252 7.63199 14.2781 7.63948 13.945 7.95865L11.9997 9.82242L10.0543 7.95865ZM8.83238 12.3333C9.17412 12.0234 9.72121 12.0309 10.0543 12.35L11.9997 14.2138L13.945 12.35C14.2781 12.0309 14.8252 12.0234 15.1669 12.3333C15.5087 12.6432 15.5156 13.1532 15.1825 13.4724L12.6335 15.9146C12.4604 16.0804 12.2295 16.1621 11.9997 16.1588C11.7698 16.1621 11.5389 16.0804 11.3658 15.9146L8.81678 13.4724C8.48365 13.1532 8.49064 12.6432 8.83238 12.3333Z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $c548f0a472b13f77$var$svgStyles = null;
const $c548f0a472b13f77$export$cd14f50bd919de37 = ({ label: label, size: size = 'medium', primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, testId: testId, className: className })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw",
            size && $c548f0a472b13f77$var$sizeStyles[size],
            className
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM10.0543 7.95865C9.72121 7.63948 9.17412 7.63199 8.83238 7.94192C8.49064 8.25184 8.48365 8.76182 8.81678 9.08099L11.3658 11.5232C11.5389 11.689 11.7698 11.7707 11.9997 11.7675C12.2295 11.7707 12.4604 11.689 12.6335 11.5232L15.1825 9.08099C15.5156 8.76182 15.5087 8.25184 15.1669 7.94192C14.8252 7.63199 14.2781 7.63948 13.945 7.95865L11.9997 9.82242L10.0543 7.95865ZM8.83238 12.3333C9.17412 12.0234 9.72121 12.0309 10.0543 12.35L11.9997 14.2138L13.945 12.35C14.2781 12.0309 14.8252 12.0234 15.1669 12.3333C15.5087 12.6432 15.5156 13.1532 15.1825 13.4724L12.6335 15.9146C12.4604 16.0804 12.2295 16.1621 11.9997 16.1588C11.7698 16.1621 11.5389 16.0804 11.3658 15.9146L8.81678 13.4724C8.48365 13.1532 8.49064 12.6432 8.83238 12.3333Z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$fc64eea29ed0831d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M11.433 5.428l-4.207.6a2 2 0 0 0-1.697 1.698l-.601 4.207a1 1 0 0 0 .283.849l6.894 6.894a1 1 0 0 0 1.414 0l5.657-5.657a1 1 0 0 0 0-1.414L12.282 5.71a1 1 0 0 0-.849-.283zm-.647 5.858a1.667 1.667 0 1 1-2.357-2.357 1.667 1.667 0 0 1 2.357 2.357z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$cbee9ded46569696 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M7 7h11a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2zm0 4h11a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zm0 4h6a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$2ade78849d2113ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.12 20.249a8.398 8.398 0 0 1-.39-.003A8.25 8.25 0 0 1 3.75 12 8.25 8.25 0 0 1 12 3.75 8.25 8.25 0 0 1 20.25 12a8.25 8.25 0 0 1-8.13 8.25v-.001zm4.463-3.762A6.396 6.396 0 0 0 18.417 12 6.424 6.424 0 0 0 12 5.583 6.424 6.424 0 0 0 5.583 12c0 1.745.7 3.33 1.834 4.487v-1.27a2.291 2.291 0 0 1 2.292-2.292h4.582a2.292 2.292 0 0 1 2.292 2.291v1.27zM12 12a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$1c6cf19eb34bcc14 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6.72 7.178l-2.93 8.627a.5.5 0 0 0 .473.661h.842a.75.75 0 0 0 .716-.53l.581-1.887h3.425l.58 1.887a.75.75 0 0 0 .717.53h.916a.5.5 0 0 0 .473-.66L9.578 7.177a1 1 0 0 0-.946-.678h-.966a1 1 0 0 0-.947.678zm1.37 1.228h.047l1.25 4.082H6.841l1.25-4.082zm10.187 1.872v-.23a.986.986 0 1 1 1.972 0v5.433a.986.986 0 0 1-1.972 0v-.217h-.08c-.36.802-1.13 1.32-2.217 1.32-1.81 0-2.952-1.479-2.952-3.834 0-2.334 1.149-3.805 2.952-3.805 1.075 0 1.858.546 2.216 1.333h.08zm-.04 2.486c0-1.347-.63-2.203-1.61-2.203-.978 0-1.58.843-1.58 2.203 0 1.368.602 2.196 1.58 2.196.988 0 1.61-.836 1.61-2.196z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$98a4a461fe316fce = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm.787-7.674V8.944c0-.52-.402-.944-.893-.944-.492 0-.894.425-.894.944v3.777c0 .263.104.5.269.672l2.207 2.332a.862.862 0 0 0 1.263 0 .985.985 0 0 0 0-1.336l-1.952-2.063z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$637d50811e2b7176 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M17.476 9.067A6.552 6.552 0 0 1 19 13.263C19 16.983 15.866 20 12 20s-7-3.016-7-6.737c0-1.587.57-3.045 1.524-4.196l-.383-.402a.82.82 0 0 1 .054-1.19.9.9 0 0 1 1.237.052l.345.363a7.116 7.116 0 0 1 3.348-1.312v-.894h-.438a.43.43 0 0 1-.437-.42V4.42a.43.43 0 0 1 .438-.42h2.624a.43.43 0 0 1 .438.421v.842a.43.43 0 0 1-.438.421h-.437v.894a7.116 7.116 0 0 1 3.348 1.312l.345-.363a.9.9 0 0 1 1.237-.052.82.82 0 0 1 .054 1.19l-.383.402zM12 18.316c2.9 0 5.25-2.262 5.25-5.053 0-2.79-2.35-5.052-5.25-5.052s-5.25 2.262-5.25 5.052c0 2.79 2.35 5.053 5.25 5.053zm.645-4.562a.9.9 0 0 1-1.237-.02.82.82 0 0 1 .02-1.19l2.588-2.412a.9.9 0 0 1 1.238.02.82.82 0 0 1-.02 1.19l-2.589 2.412z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$bc2bb299bed9df91 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 14.222A6.23 6.23 0 015.778 12 6.23 6.23 0 0112 5.778 6.23 6.23 0 0118.222 12 6.23 6.23 0 0112 18.222zm.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.891.891 0 001.257 0 .891.891 0 000-1.256l-1.942-1.943z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$3a9d3f1c52f4dab9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.268 4.934a.919.919 0 0 0 0 1.296l4.852 4.853H4.668A.92.92 0 0 0 3.75 12a.92.92 0 0 0 .917.917H17.12l-4.856 4.855a.917.917 0 0 0 1.296 1.296l6.416-6.415c.002 0 .003-.003.006-.004a.914.914 0 0 0 .267-.65.915.915 0 0 0-.274-.653l-6.412-6.412a.915.915 0 0 0-.648-.267.915.915 0 0 0-.648.267z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$a4cdad58220c405a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M5.928 6.917l4.81-2.846c.727-.429 1.8-.427 2.523 0l4.811 2.846c.726.43 1.261 1.382 1.261 2.238v5.69c0 .859-.537 1.81-1.26 2.238L13.26 19.93c-.726.429-1.799.427-2.522 0l-4.811-2.846c-.726-.43-1.261-1.382-1.261-2.238v-5.69c0-.859.537-1.81 1.26-2.238zm6.408-1.204c-.152-.09-.52-.09-.672 0L6.853 8.558c-.152.09-.336.416-.336.597v5.69c0 .18.183.507.336.597l4.81 2.845c.153.09.52.09.673 0l4.811-2.845c.152-.09.336-.416.336-.597v-5.69c0-.18-.183-.507-.336-.597l-4.81-2.845zM12 15.667a3.667 3.667 0 1 1 0-7.334 3.667 3.667 0 0 1 0 7.334zm0-1.834a1.833 1.833 0 1 0 0-3.666 1.833 1.833 0 0 0 0 3.666z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$e6e85f1bc2e23bd4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.672 17.468c-1.402 1.37-3.68 1.37-5.08.004a3.458 3.458 0 0 1 .002-4.962l6.552-6.402a2.123 2.123 0 0 1 2.964-.003c.818.8.82 2.092.003 2.89L10.968 15a.599.599 0 0 1-.838-.008.568.568 0 0 1 0-.827l5.71-5.58a.863.863 0 0 0 0-1.24.912.912 0 0 0-1.268 0l-5.71 5.58a2.294 2.294 0 0 0 0 3.307 2.423 2.423 0 0 0 3.375.008l6.145-6.005a3.735 3.735 0 0 0-.003-5.37 3.947 3.947 0 0 0-5.502.003L6.325 11.27a5.184 5.184 0 0 0-.001 7.442c2.1 2.052 5.514 2.051 7.617-.004l6.13-5.99a.863.863 0 0 0 0-1.24.912.912 0 0 0-1.27 0l-6.129 5.99z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$a6a7f7b7c0399a2a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M5.5 7.59a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.008v.152A1 1 0 0 1 6.659 8.75h-.152A1 1 0 0 1 5.5 7.743V7.59zm4.333 8.667a.999.999 0 0 1 .995-1.007h6.678c.549 0 .994.438.994 1.007v.152a.999.999 0 0 1-.994 1.008h-6.678a.993.993 0 0 1-.995-1.008v-.152zm-4.333 0a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.007v.152a1 1 0 0 1-1.008 1.008h-.152A1 1 0 0 1 5.5 16.409v-.152zm4.333-4.333a.999.999 0 0 1 .995-1.007h6.678c.549 0 .994.438.994 1.007v.152a.999.999 0 0 1-.994 1.007h-6.678a.993.993 0 0 1-.995-1.007v-.152zm-4.333 0a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.007v.152a1 1 0 0 1-1.008 1.007h-.152A1 1 0 0 1 5.5 12.076v-.152zM9.833 7.59a.999.999 0 0 1 .995-1.008h6.678c.549 0 .994.439.994 1.008v.152a.999.999 0 0 1-.994 1.007h-6.678a.993.993 0 0 1-.995-1.007V7.59z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$835d228e2a9d6a93 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51 3.861 0 7.002 2.472 7.002 5.51 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51zm14.84 7.771v-.002s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.524.524 0 0 0 .164.033.515.515 0 0 0 .474-.716zM7 10c0-.552.456-1 .995-1h8.01c.55 0 .995.444.995 1 0 .552-.456 1-.995 1h-8.01A.995.995 0 0 1 7 10zm0 3c0-.552.444-1 1-1h3c.552 0 1 .444 1 1 0 .552-.444 1-1 1H8c-.552 0-1-.444-1-1z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$fdad804cb16a6544 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M8.444 14.667V20H5.785C4.8 20 4 19.146 4 18.09V8.577c0-1.055.802-1.91 1.785-1.91h2.66v3.556H6.666V12h1.777v.889H6.667v1.778h1.777zm.89-8.894A1.78 1.78 0 0 1 11.119 4h7.096A1.78 1.78 0 0 1 20 5.773v12.454c0 .979-.802 1.773-1.785 1.773H9.333V5.773zM12 7.556v1.777h1.778V7.556H12zm0 2.666V12h1.778v-1.778H12zm0 2.667v1.778h1.778v-1.778H12zm1.778 2.667v2.666h1.778v-2.666h-1.778zm1.778-8v1.777h1.777V7.556h-1.777zm0 2.666V12h1.777v-1.778h-1.777zm0 2.667v1.778h1.777v-1.778h-1.777z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$a20644de4b67f161 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 12a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm-3.228-1.667A3.333 3.333 0 0 0 9.795 12H9.5A2.501 2.501 0 0 0 7 14.497v2.469c-1.771-.147-3.333-.766-3.333-1.858V12c0-.92.74-1.667 1.666-1.667h3.439zm6.456 0h3.439c.92 0 1.666.738 1.666 1.667v3.108c0 1.092-1.562 1.711-3.333 1.858v-2.47A2.5 2.5 0 0 0 14.5 12h-.295a3.333 3.333 0 0 0 1.023-1.667zM10.306 6.63A3.332 3.332 0 0 0 8.67 9.357a2.5 2.5 0 1 1 1.636-2.728zm5.024 2.728a3.328 3.328 0 0 0-1.636-2.73 2.5 2.5 0 1 1 1.636 2.73zm-7.497 5.456c0-1.093.892-1.98 1.996-1.98h4.342a2 2 0 0 1 1.996 1.994v2.781c0 2.523-8.334 2.523-8.334 0v-2.795z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$ce87e45dceec205d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$d95e2215202c8556 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6.5 12h7.333v-1.833H6.5V12zM4.667 9.242c0-.502.417-.909.919-.909h9.162c.507 0 .919.414.919.909v4.591h-11V9.242zm.458 7.341h12.828l.919-2.75H4.795l.33 2.75zm-2.287-3.677A.79.79 0 0 1 3.643 12h16.86c.504 0 .786.382.625.865l-1.565 4.686c-.16.478-.695.866-1.205.866H4.415c-.506 0-.964-.402-1.025-.906l-.552-4.605zM6.5 7.42c0-1.015.823-1.838 1.831-1.838h1.838c1.011 0 1.831.82 1.831 1.838v2.746H6.5V7.42zm3.667 0v-.004H8.331c.005 0 .002.002.002.004v.912h1.834V7.42z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$3062e49c5521698d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M7.959 15.833V8.474l-2.868 2.868a.541.541 0 1 1-.766-.766l3.79-3.789.001-.004a.544.544 0 0 1 .77.003l3.791 3.792a.543.543 0 0 1 0 .766.543.543 0 0 1-.765 0l-2.87-2.87v7.36a.543.543 0 0 1-.541.541.543.543 0 0 1-.542-.542zm7-6.666v7.359l-2.868-2.868a.541.541 0 1 0-.766.766l3.79 3.789.001.004a.544.544 0 0 0 .77-.003l3.791-3.792a.543.543 0 0 0 0-.766.543.543 0 0 0-.765 0l-2.87 2.87v-7.36a.543.543 0 0 0-.541-.541.543.543 0 0 0-.542.542z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: ".5",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$17d48fc8b753df77 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4 6.772C4 5.793 4.793 5 5.773 5h12.454C19.206 5 20 5.796 20 6.772v7.044c0 .979-.793 1.772-1.773 1.772H5.773A1.774 1.774 0 0 1 4 13.816V6.772zm1.778 7.052h12.444v-7.06H5.778v7.06zm8 5.294h.452c.241 0 .437.204.437.44V20H9.333v-.441c0-.244.203-.441.437-.441h.452V16.47h3.556v2.647z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$cbbe21ca62a58ed6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M16.244 6.244a.833.833 0 1 1 1.179 1.179l-4.412 4.41 4.412 4.411a.834.834 0 0 1 .074 1.093l-.074.086a.833.833 0 0 1-1.179 0l-4.411-4.412-4.41 4.412a.834.834 0 0 1-1.094.074l-.085-.074a.833.833 0 0 1 0-1.179l4.411-4.411-4.41-4.41a.834.834 0 0 1-.076-1.094l.075-.085a.833.833 0 0 1 1.179 0l4.41 4.411z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$8fd991b9da3a43e5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.682 12H5.01A2.006 2.006 0 0 0 3 14v4.446c0 2.162 4.836 2.951 8.368 2.368A5.975 5.975 0 0 1 10 17a5.994 5.994 0 0 1 2.682-5z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        fill: "currentColor",
        cx: "9",
        cy: "7",
        r: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        fill: "currentColor",
        cx: "16",
        cy: "17",
        r: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M14.674 19.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3l1.406 1.405z",
        fill: "inherit"
    })));
const $c548f0a472b13f77$export$f21213fb7b480582 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6 12c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 12zm0 4c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 16zm0-8c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 8z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$88453606d7da6ff7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        role: "presentation",
        focusable: "false",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M3 6C2.44772 6 2 6.44772 2 7C2 7.55228 2.44772 8 3 8H11C11.5523 8 12 7.55228 12 7C12 6.44772 11.5523 6 11 6H3ZM4 16V12H20V16H4ZM2 12C2 10.8954 2.89543 10 4 10H20C21.1046 10 22 10.8954 22 12V16C22 17.1046 21.1046 18 20 18H4C2.89543 18 2 17.1046 2 16V12Z",
        fill: "currentColor"
    })));

});


parcelRegister("cjRWP", function(module, exports) {
$parcel$export(module.exports, "getSecondaryLabelWithIcon", () => $fe2515622481ebd0$export$de24d837eb50c435);

var $eJOHy = parcelRequire("eJOHy");
const $fe2515622481ebd0$export$de24d837eb50c435 = (icon, fieldTypeDisplayName)=>({
        label: fieldTypeDisplayName,
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, icon, fieldTypeDisplayName)
    });

});

parcelRegister("1RINH", function(module, exports) {
$parcel$export(module.exports, "default", () => $bacb51745455db16$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $bacb51745455db16$var$messages = (0, $7qGN1.defineMessages)({
    columnGroupHeader: {
        "id": "issue-table-column-picker.common.column-group-header",
        "defaultMessage": "All columns"
    },
    deprecatedParentyLinkMessage: {
        "id": "issue-navigator.services.fetch-column-picker-options.deprecated-parenty-link-message",
        "defaultMessage": "<strong>{field}</strong> is replaced by <strong>Parent</strong>. Use the <strong>Parent</strong> field instead."
    }
});
var $bacb51745455db16$export$2e2bcd8739ae039 = $bacb51745455db16$var$messages;

});

parcelRegister("iT8nA", function(module, exports) {
$parcel$export(module.exports, "getCursorOfLastUnselectedOption", () => $2ca386a0fde885aa$export$5918fea5c056698b);
$parcel$export(module.exports, "isOnlyUnselectableField", () => $2ca386a0fde885aa$export$bf5bbd6344a5f1aa);

var $4SJ2a = parcelRequire("4SJ2a");

var $gMbEk = parcelRequire("gMbEk");

var $iRahl = parcelRequire("iRahl");
const $2ca386a0fde885aa$var$isNotinSelectedList = (selectedOptions, option)=>{
    const optionFound = selectedOptions.find((select)=>(0, $gMbEk.isSingleValueOption)(select) && (0, $gMbEk.isSingleValueOption)(option) && select.cursor === option.cursor);
    return optionFound === undefined;
};
const $2ca386a0fde885aa$export$5918fea5c056698b = (options, selectedOptions, search, endCursor)=>{
    const flatten = options.flatMap((option)=>option.optionType === 'group' ? option.options : option);
    const lastUnselectedOption = (0, (/*@__PURE__*/$parcel$interopDefault($4SJ2a)))(flatten, (option)=>(0, $gMbEk.isSingleValueOption)(option) && !!option.cursor && $2ca386a0fde885aa$var$isNotinSelectedList(selectedOptions, option));
    let cursor = lastUnselectedOption && (0, $gMbEk.isSingleValueOption)(lastUnselectedOption) ? lastUnselectedOption?.cursor : undefined;
    // with a given search input, don't set cursor to undefined when there are only selected options in the list, because we query with 'ALL' options
    if (search && cursor === undefined && endCursor) cursor = endCursor;
    return cursor;
};
const $2ca386a0fde885aa$export$bf5bbd6344a5f1aa = (fieldType, canEditColumns)=>{
    if (fieldType === (0, $iRahl.COLUMN_TYPE_EPIC_LINK)) return canEditColumns;
    if (fieldType === (0, $iRahl.COLUMN_TYPE_PARENT_LINK)) return canEditColumns;
    return false;
};

});
parcelRegister("4SJ2a", function(module, exports) {

var $dSzgR = parcelRequire("dSzgR");

var $l1N9H = parcelRequire("l1N9H");
/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */ var $38df235f722de22b$var$findLast = $dSzgR($l1N9H);
module.exports = $38df235f722de22b$var$findLast;

});
parcelRegister("dSzgR", function(module, exports) {

var $1lM9j = parcelRequire("1lM9j");

var $7H30b = parcelRequire("7H30b");

var $4c94y = parcelRequire("4c94y");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $a1abad92a1851e60$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$7H30b(collection)) {
            var iteratee = $1lM9j(predicate, 3);
            collection = $4c94y(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $a1abad92a1851e60$var$createFind;

});

parcelRegister("l1N9H", function(module, exports) {

var $9gUEB = parcelRequire("9gUEB");

var $1lM9j = parcelRequire("1lM9j");

var $c9FP3 = parcelRequire("c9FP3");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f4efd23be3b4e43d$var$nativeMax = Math.max, $f4efd23be3b4e43d$var$nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function $f4efd23be3b4e43d$var$findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = $c9FP3(fromIndex);
        index = fromIndex < 0 ? $f4efd23be3b4e43d$var$nativeMax(length + index, 0) : $f4efd23be3b4e43d$var$nativeMin(index, length - 1);
    }
    return $9gUEB(array, $1lM9j(predicate, 3), index, true);
}
module.exports = $f4efd23be3b4e43d$var$findLastIndex;

});


parcelRegister("gMbEk", function(module, exports) {
$parcel$export(module.exports, "isSingleValueOption", () => $282a6706fedd463a$export$35faed52a6bc243e);
const $282a6706fedd463a$export$35faed52a6bc243e = (option)=>option.optionType === 'option' || option.optionType === 'avatar' || option.optionType === 'lozenge' || option.optionType === 'field';

});



parcelRegister("i99kJ", function(module, exports) {
$parcel$export(module.exports, "useIFCSidebar", () => $bfe03d5b75afff40$export$50b7b16d5dcf708b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");

var $7ep4S = parcelRequire("7ep4S");

var $gHKwt = parcelRequire("gHKwt");

var $cBavF = parcelRequire("cBavF");

var $2aY2d = parcelRequire("2aY2d");

var $kAwwe = parcelRequire("kAwwe");

var $dZ3jN = parcelRequire("dZ3jN");

var $4cTDP = parcelRequire("4cTDP");

var $6Al27 = parcelRequire("6Al27");
const $bfe03d5b75afff40$var$useIsProjectAdmin = ()=>{
    const { data: data } = (0, $2aY2d.useProjectContext)();
    return !!data?.isProjectAdmin;
};
const $bfe03d5b75afff40$var$IFCTriggerRef = ({ children: children })=>{
    const { entryPointActions: entryPointActions } = (0, $6Al27.useIFCEntryPointContext)();
    const triggerRef = (0, $dZ3jN.useEntryPointButtonTrigger)(entryPointActions);
    return children({
        triggerRef: triggerRef
    });
};
const $bfe03d5b75afff40$export$50b7b16d5dcf708b = ({ projectId: projectId, projectKey: projectKey, issues: issues, shouldShowFormulaField: shouldShowFormulaField })=>{
    const ifcContext = (0, $6Al27.useIFCEntryPointContext)();
    const [, { setStaticSidebarContent: setStaticSidebarContent, closeSidebar: closeSidebar }] = (0, $gHKwt.useSidebar)();
    const isJiraAdmin = (0, $kAwwe.useIsAdmin)();
    const isProjectAdmin = $bfe03d5b75afff40$var$useIsProjectAdmin();
    const isAdmin = isJiraAdmin || isProjectAdmin;
    const { data: project } = (0, $2aY2d.useProjectContext)();
    const isIFCEnabled = Boolean(isAdmin && project?.simplified);
    const isEnabledForCategoryField = isIFCEnabled || isAdmin && (0, $4cTDP.fg)('jsc_list_category_editing_in_nin');
    const onUpdate = (0, $eJOHy.useCallback)(({ fieldId: fieldId, onFieldDeleted: onFieldDeleted, onFieldUpdated: onFieldUpdated, onStartFieldUpdate: onStartFieldUpdate, onFieldUpdateError: onFieldUpdateError })=>{
        if (projectId && projectKey) setStaticSidebarContent?.('ifc-sidebar-edit', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            xcss: $bfe03d5b75afff40$var$styles.sidebarContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            entryPointReferenceSubject: ifcContext.entryPointReferenceSubject,
            id: "jira-nin-inline-field-config-sidebar",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
                size: "medium"
            })),
            runtimeProps: {
                projectId: projectId,
                projectKey: projectKey,
                onClose: closeSidebar,
                fieldId: fieldId,
                mode: 'edit',
                onFieldDeleted: onFieldDeleted,
                onFieldUpdated: onFieldUpdated,
                onStartFieldUpdate: onStartFieldUpdate,
                onFieldUpdateError: onFieldUpdateError,
                issues: issues,
                shouldShowFormulaField: shouldShowFormulaField
            }
        })));
    }, [
        closeSidebar,
        ifcContext.entryPointReferenceSubject,
        projectId,
        projectKey,
        setStaticSidebarContent,
        issues,
        shouldShowFormulaField
    ]);
    const onCreate = (0, $eJOHy.useCallback)((createArgs)=>{
        if (projectId && projectKey) setStaticSidebarContent?.('ifc-sidebar-create', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            xcss: $bfe03d5b75afff40$var$styles.sidebarContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            entryPointReferenceSubject: ifcContext.entryPointReferenceSubject,
            id: "jira-nin-inline-field-config-sidebar",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
                size: "medium"
            })),
            runtimeProps: {
                projectId: projectId,
                projectKey: projectKey,
                onClose: closeSidebar,
                onStartFieldCreate: createArgs?.onStartFieldCreate,
                onFieldCreated: createArgs?.onFieldCreated,
                onFieldCreateError: createArgs?.onFieldCreateError,
                mode: 'create',
                issues: issues,
                shouldShowFormulaField: shouldShowFormulaField
            }
        })));
    }, [
        closeSidebar,
        ifcContext.entryPointReferenceSubject,
        projectId,
        projectKey,
        setStaticSidebarContent,
        issues,
        shouldShowFormulaField
    ]);
    return (0, $eJOHy.useMemo)(()=>[
            isIFCEnabled,
            {
                isEnabledForProject: isIFCEnabled,
                isEnabledForCategoryField: isEnabledForCategoryField,
                IFCTriggerRef: $bfe03d5b75afff40$var$IFCTriggerRef,
                onCreate: onCreate,
                onUpdate: onUpdate
            }
        ], [
        isIFCEnabled,
        isEnabledForCategoryField,
        onCreate,
        onUpdate
    ]);
};
const $bfe03d5b75afff40$var$styles = {
    sidebarContent: "_4t3i1osq _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};

});

parcelRegister("4ciTX", function(module, exports) {
$parcel$export(module.exports, "useCommitFieldSetPreferences", () => $a839eff91073c65d$export$180c6ccdc36e4c73);

var $eJOHy = parcelRequire("eJOHy");

var $2WT2V = parcelRequire("2WT2V");

var $9pTd3 = parcelRequire("9pTd3");

var $K4WWF = parcelRequire("K4WWF");

var $iRahl = parcelRequire("iRahl");
const $a839eff91073c65d$export$180c6ccdc36e4c73 = ({ cloudId: cloudId, projectId: projectId, viewId: viewId, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, updateFieldSetPreferences: updateFieldSetPreferences, updateFieldSetPreferencesOld: updateFieldSetPreferencesOld, settings: settings, relayViewId: relayViewId })=>{
    const commitUpdateFieldSetPreferencesOld = (0, $eJOHy.useCallback)((payload, updateType)=>{
        updateFieldSetPreferencesOld({
            variables: {
                cloudId: cloudId,
                input: {
                    nodes: payload
                },
                ...isInlineFieldConfigEnabled && {
                    context: {
                        projectContext: {
                            project: projectId
                        }
                    },
                    viewId: viewId
                }
            },
            onCompleted (data) {
                if (!data.jira?.updateUserFieldSetPreferences?.success) (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: 'commitUpdateFieldSetPreferencesMutationUnsuccessful',
                        packageName: (0, $iRahl.PACKAGE_NAME),
                        teamName: (0, $iRahl.TEAM_NAME)
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    ...updateType ? {
                        attributes: {
                            updateType: updateType
                        }
                    } : {}
                });
            },
            onError (error) {
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: 'commitUpdateFieldSetPreferencesMutationError',
                        packageName: (0, $iRahl.PACKAGE_NAME),
                        teamName: (0, $iRahl.TEAM_NAME)
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true,
                    ...updateType ? {
                        attributes: {
                            updateType: updateType
                        }
                    } : {}
                });
            }
        });
    }, [
        cloudId,
        isInlineFieldConfigEnabled,
        projectId,
        updateFieldSetPreferencesOld,
        viewId
    ]);
    const commitUpdateFieldSetPreferences = (0, $eJOHy.useCallback)((savedViewId, payload, updateType)=>{
        updateFieldSetPreferences({
            variables: {
                cloudId: cloudId,
                viewId: savedViewId,
                input: {
                    nodes: payload
                },
                settings: settings
            },
            /*
				 * This updater imperatively updates the isViewConfigModified record to handle the
				 * scenario where the variables provided to isViewConfigModified in the preloaded query
				 * differ from the variables provided in refetches.
				 *
				 * This ensures the save/reset view button is correctly hidden when publishing the view
				 * immediately after a page refresh.
				 *
				 * In all other scenarios we can rely on Relay writing the network response to the store
				 * via spreading a fragment which contains the isViewConfigModified field.
				 */ updater: (store, response)=>{
                const isViewConfigModified = response?.jira?.updateUserFieldSetPreferences?.view?.isViewConfigModified;
                if (response?.jira?.updateUserFieldSetPreferences?.success !== true || isViewConfigModified == null) return;
                const viewRecord = store.get(relayViewId);
                if (viewRecord == null) return;
                (0, $2WT2V.setIsViewConfigModifiedRecord)({
                    isViewConfigModified: isViewConfigModified,
                    viewRecord: viewRecord
                });
            },
            onCompleted (data) {
                if (!data.jira?.updateUserFieldSetPreferences?.success) {
                    const errors = new (0, $K4WWF.MutationErrorCollection)(data.jira?.updateUserFieldSetPreferences?.errors);
                    // silently fail as column will remain at the desired width until the next page load
                    (0, $9pTd3.fireErrorAnalytics)({
                        meta: {
                            id: 'commitUpdateFieldSetPreferencesMutationUnsuccessful',
                            packageName: (0, $iRahl.PACKAGE_NAME),
                            teamName: (0, $iRahl.TEAM_NAME)
                        },
                        ...updateType ? {
                            attributes: {
                                updateType: updateType
                            }
                        } : {},
                        error: errors,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            },
            onError (error) {
                // silently fail as column will remain at the desired width until the next page load
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: 'commitUpdateFieldSetPreferencesMutationError',
                        packageName: (0, $iRahl.PACKAGE_NAME),
                        teamName: (0, $iRahl.TEAM_NAME)
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true,
                    ...updateType ? {
                        attributes: {
                            updateType: updateType
                        }
                    } : {}
                });
            }
        });
    }, [
        cloudId,
        relayViewId,
        settings,
        updateFieldSetPreferences
    ]);
    return {
        commitUpdateFieldSetPreferences: commitUpdateFieldSetPreferences,
        commitUpdateFieldSetPreferencesOld: commitUpdateFieldSetPreferencesOld
    };
};

});

parcelRegister("iZH8P", function(module, exports) {
$parcel$export(module.exports, "createPopupComponent", () => $267f7120253f5ea5$export$7b08561157a7df33);
$parcel$export(module.exports, "default", () => $267f7120253f5ea5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $eJ9f5 = parcelRequire("eJ9f5");

var $kDaaB = parcelRequire("kDaaB");

var $4cTDP = parcelRequire("4cTDP");

var $gTm2i = parcelRequire("gTm2i");

var $HiS1C = parcelRequire("HiS1C");

var $fwKw5 = parcelRequire("fwKw5");

var $h1uuU = parcelRequire("h1uuU");

var $3Ag3S = parcelRequire("3Ag3S");

var $W3OFR = parcelRequire("W3OFR");

var $cV5SD = parcelRequire("cV5SD");
const $267f7120253f5ea5$var$styles = {
    childrenContainer: "_1q51u2gc"
};
const $267f7120253f5ea5$var$ColumnPickerPopupComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(// @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
({ children: children, onRestoreDefaults: onRestoreDefaults, ...props }, ref)=>{
    const { filterId: filterId, isFilterEditable: isFilterEditable } = (0, $fwKw5.useActiveJql)();
    const [{ view: view }] = (0, $HiS1C.useSelectedViewState)();
    const { hasMaxSelectedColumns: hasMaxSelectedColumns, filterName: filterName } = (0, $eJOHy.useContext)((0, $gTm2i.ColumnPickerMessageContext));
    let bannerMessage = null;
    if (hasMaxSelectedColumns) bannerMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Ag3S.ColumnPickerMaxSelectedColumns), null);
    else if (view === 'list_system') bannerMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h1uuU.ColumnPickerBannerMessage), {
        bannerMessage: (0, $4cTDP.fg)('jira_inline_field_config_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $cV5SD.default).listSystemWarningMessageNew) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $cV5SD.default).listSystemWarningMessage),
        type: "warning"
    });
    else if (view === `list_filter_${filterId}`) {
        if (isFilterEditable === false) bannerMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h1uuU.ColumnPickerBannerMessage), {
            type: "info",
            bannerMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
                ...(0, $cV5SD.default).listNonEditableFilterInfoMessage,
                values: {
                    // To remove @ts-expect-error below we need to upgrade intl to v6
                    // https://stackoverflow.com/questions/67884173/formattedmessage-values-chunks-using-typescript
                    // @ts-expect-error TS2322: Type '(chunks: ReactNode[]) => JSX.Element' is not assignable to type 'ReactNode'.
                    link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                            href: `/jira/filters${filterName ? `?name="${encodeURIComponent(filterName)}"` : ''}`,
                            target: "_blank"
                        }, chunks)
                }
            })
        });
        else bannerMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h1uuU.ColumnPickerBannerMessage), {
            bannerMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $cV5SD.default).listFilterWarningMessage),
            type: "warning"
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($267f7120253f5ea5$var$PopupComponentContainer, {
        ...props,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $W3OFR.default), {
        onRestoreDefaults: (0, $4cTDP.fg)('jira_inline_field_config_gate') ? onRestoreDefaults : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($267f7120253f5ea5$var$TabsContentContainer, null, bannerMessage, (0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $267f7120253f5ea5$var$styles.childrenContainer
    }, children) : children)));
});
const $267f7120253f5ea5$export$7b08561157a7df33 = (onRestoreDefaultColumns)=>/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($267f7120253f5ea5$var$ColumnPickerPopupComponent, {
            ...props,
            ref: ref,
            onRestoreDefaults: onRestoreDefaultColumns
        }));
var $267f7120253f5ea5$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $267f7120253f5ea5$var$ColumnPickerPopupComponent;
const $267f7120253f5ea5$var$PopupComponentContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _1bsb1mjv _bfhk1bhr _16qs130s _1pby1nn1 _ca0q1b66 _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $267f7120253f5ea5$var$TabsContentContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h1uuU", function(module, exports) {
$parcel$export(module.exports, "ColumnPickerBannerMessage", () => $2d27289c01044f61$export$3ccab74b576df308);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $2R0ne = parcelRequire("2R0ne");

var $d8UFE = parcelRequire("d8UFE");
const $2d27289c01044f61$export$3ccab74b576df308 = ({ bannerMessage: bannerMessage, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2d27289c01044f61$var$BannerContent, {
        type: type
    }, type === 'warning' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d8UFE))), {
        spacing: "spacious",
        label: "",
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))), {
        spacing: "spacious",
        label: "",
        color: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2d27289c01044f61$var$BannerMessage, null, bannerMessage));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2d27289c01044f61$var$BannerContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _syazazsu",
            __cmplp.type === 'warning' ? "_bfhk1917" : "_bfhk19ip",
            __cmplp.className
        ])
    });
});
const $2d27289c01044f61$var$BannerMessage = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81o8v _19pkidpf _2hwxidpf _otyridpf _18u0u2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3Ag3S", function(module, exports) {
$parcel$export(module.exports, "ColumnPickerMaxSelectedColumns", () => $c8dc02c422e2966a$export$3ec21851fe32329c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $2R0ne = parcelRequire("2R0ne");

var $lRq8t = parcelRequire("lRq8t");

var $8jOO7 = parcelRequire("8jOO7");

var $eS29z = parcelRequire("eS29z");

var $1fdzB = parcelRequire("1fdzB");
const $c8dc02c422e2966a$export$3ec21851fe32329c = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c8dc02c422e2966a$var$MessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))), {
        spacing: "spacious",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c8dc02c422e2966a$var$Message, null, formatMessage((0, $1fdzB.default).maxSelectedColumns, {
        maxColumns: (0, $8jOO7.MAX_COLUMNS)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireUiAnalytics), {
        actionSubject: "maxSelectedFieldsMessage",
        action: "viewed",
        actionSubjectId: "columnPicker"
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c8dc02c422e2966a$var$MessageContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _bfhki8nm _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _syazazsu _19pku2gc",
            __cmplp.className
        ])
    });
});
const $c8dc02c422e2966a$var$Message = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81o8v _19pkidpf _2hwxidpf _otyridpf _18u0u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1fdzB", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a524063f2082454$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $6a524063f2082454$var$messages = (0, $7qGN1.defineMessages)({
    maxSelectedColumns: {
        "id": "issue-navigator.issue-results.list-view.column-picker-max-selected-columns.max-selected-columns",
        "defaultMessage": "The column limit is {maxColumns, number}. Remove and add the most important ones to your view."
    }
});
var $6a524063f2082454$export$2e2bcd8739ae039 = $6a524063f2082454$var$messages;

});


parcelRegister("W3OFR", function(module, exports) {
$parcel$export(module.exports, "default", () => $a65c6ff45df8b715$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $cpHe2 = parcelRequire("cpHe2");
var $7oCv0 = parcelRequire("7oCv0");
var $lcHWu = parcelRequire("lcHWu");

var $lRq8t = parcelRequire("lRq8t");

var $82cqT = parcelRequire("82cqT");

var $kRgKj = parcelRequire("kRgKj");

var $kAwwe = parcelRequire("kAwwe");

var $2aY2d = parcelRequire("2aY2d");

var $4cTDP = parcelRequire("4cTDP");

var $eibCx = parcelRequire("eibCx");

var $HiS1C = parcelRequire("HiS1C");

var $fwKw5 = parcelRequire("fwKw5");

var $5YHRB = parcelRequire("5YHRB");

var $fEOqD = parcelRequire("fEOqD");
const $a65c6ff45df8b715$var$CustomTabPanel = ({ children: children })=>{
    /**
   * We can omit the tab index as our panel always contains a focusable input as the first element https://www.w3.org/WAI/ARIA/apg/example-index/tabs/tabs-automatic#accessibilityfeatures.
   * > It is recommended that all tabpanel elements in a tab set are focusable if there are any panels in the set that
   * > contain content where the first element in the panel is not focusable.
   */ const { tabIndex: tabIndex, ...tabPanelAttributes } = (0, $lcHWu.useTabPanel)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", tabPanelAttributes, children);
};
const $a65c6ff45df8b715$var$ColumnPickerTabs = ({ children: children, onRestoreDefaults: onRestoreDefaults })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { filterId: filterId } = (0, $fwKw5.useActiveJql)();
    const isAdmin = (0, $kAwwe.useIsAdmin)();
    const [{ view: view }, { setView: setView }] = (0, $HiS1C.useSelectedViewState)();
    const isFilterTabEnabled = filterId != null && (0, $82cqT.isCustomFilter)(filterId);
    const { data: project } = (0, $4cTDP.fg)('jira_inline_field_config_gate') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $2aY2d.useProjectContext)() : {
        data: null
    };
    const showRestoreDefaults = project == null || (0, $4cTDP.fg)('ifc_hide_restore_until_ready');
    const tabsMetaData = (0, $eJOHy.useMemo)(()=>{
        const resultTabs = [
            {
                key: 'Default',
                label: formatMessage((0, $5YHRB.default).pickerTabTextDefault),
                view: 'list_default',
                ...showRestoreDefaults && (0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    onRestoreDefaults: onRestoreDefaults
                }
            }
        ];
        if (isFilterTabEnabled) {
            const filterViewId = (0, $eibCx.convertFilterIdToIssueNavigatorId)(filterId);
            if (filterViewId != null) resultTabs.push({
                key: 'Filter',
                label: formatMessage((0, $5YHRB.default).pickerTabTextFilter),
                view: filterViewId,
                onRestoreDefaults: onRestoreDefaults
            });
        }
        if (isAdmin) resultTabs.push({
            key: 'System',
            label: formatMessage((0, $5YHRB.default).pickerTabTextSystem),
            view: 'list_system',
            ...showRestoreDefaults && (0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                onRestoreDefaults: onRestoreDefaults
            }
        });
        return resultTabs;
    }, [
        formatMessage,
        showRestoreDefaults,
        onRestoreDefaults,
        isFilterTabEnabled,
        isAdmin,
        filterId
    ]);
    const handleUpdate = (0, $eJOHy.useCallback)((index, event)=>{
        if (view !== tabsMetaData[index].view) {
            (0, $kRgKj.fireUIAnalytics)(event, 'columnPickerTabs', {
                tab: tabsMetaData[index].view
            });
            setView(tabsMetaData[index].view, '');
        }
    }, [
        setView,
        tabsMetaData,
        view
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cpHe2.default), {
        id: "issue-table-column-picker.ui.column-picker.picker-tabs",
        onChange: handleUpdate,
        selected: tabsMetaData.findIndex((tab)=>tab.view === view),
        shouldUnmountTabPanelOnChange: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7oCv0.default), null, tabsMetaData.map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fEOqD.default), {
            key: tab.key,
            label: tab.label,
            maxWidth: `${Math.floor(100 / (tabsMetaData.length || 1))}%`,
            onRestoreDefaults: tab.onRestoreDefaults
        })))), tabsMetaData.map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a65c6ff45df8b715$var$CustomTabPanel, {
            key: tab.key
        }, children)));
};
var $a65c6ff45df8b715$export$2e2bcd8739ae039 = $a65c6ff45df8b715$var$ColumnPickerTabs;

});
parcelRegister("cpHe2", function(module, exports) {
$parcel$export(module.exports, "default", () => $03090e4bd6ee746b$export$2e2bcd8739ae039);
/* tabs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jrFnt = parcelRequire("jrFnt");

var $4OxCz = parcelRequire("4OxCz");
const $03090e4bd6ee746b$var$baseStyles = null;
const $03090e4bd6ee746b$var$tabsStyles = null;
const $03090e4bd6ee746b$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $03090e4bd6ee746b$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4OxCz.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        children: tabPanel
    }, index); /**
                                * __Tabs__
                                *
                                * Tabs acts as a container for all Tab components.
                                *
                                * - [Examples](https://atlassian.design/components/tabs/examples)
                                * - [Code](https://atlassian.design/components/tabs/code)
                                * - [Usage](https://atlassian.design/components/tabs/usage)
                                */ 
const $03090e4bd6ee746b$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $eJOHy.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $eJOHy.Children).toArray(children) // Don't include any conditional children
    .filter((child)=>Boolean(child)); // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray; // Keep track of visited and add to a set
    const visited = (0, $eJOHy.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $eJOHy.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$03090e4bd6ee746b$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $03090e4bd6ee746b$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$03090e4bd6ee746b$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _p12f1osq _1tkeidpf _i0dl1osq _2lx21bp4 _16jlkb7n",
            "_1c3y1txw _ftfaidpf _18i0kb7n _185bglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4OxCz.TabListContext).Provider, {
                value: {
                    selected: selected,
                    onChange: onChangeAnalytics,
                    tabsId: id
                },
                children: tabList
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
                children: tabPanelsWithContext
            })
        ]
    });
};
var $03090e4bd6ee746b$export$2e2bcd8739ae039 = $03090e4bd6ee746b$var$Tabs;

});
parcelRegister("4OxCz", function(module, exports) {
$parcel$export(module.exports, "TabContext", () => $079a819a44225d4e$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $079a819a44225d4e$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $079a819a44225d4e$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $eJOHy = parcelRequire("eJOHy");
const $079a819a44225d4e$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $079a819a44225d4e$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $079a819a44225d4e$export$2054129d247c3102 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);

});


parcelRegister("7oCv0", function(module, exports) {
$parcel$export(module.exports, "default", () => $b96e2c7b7779acd6$export$2e2bcd8739ae039);
/* tab-list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lcHWu = parcelRequire("lcHWu");

var $4OxCz = parcelRequire("4OxCz");
const $b96e2c7b7779acd6$var$baseStyles = null;
const $b96e2c7b7779acd6$var$tabListStyles = null;
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $b96e2c7b7779acd6$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $lcHWu.useTabList)();
    const ref = /*#__PURE__*/ (0, $eJOHy.createRef)();
    // Don't include any conditional children
    const childrenArray = (0, $eJOHy.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $eJOHy.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $eJOHy.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $eJOHy.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4OxCz.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            children: tab
        }, index), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "tablist",
        ref: ref,
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswh2mm _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _1lzu8wxv _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1b8d8wxv _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _rsmzwg2n _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _1mp41kw7 _kfgte4h9 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc"
        ]),
        children: childrenArray.map((child, index)=>getTabWithContext({
                tab: child,
                index: index,
                isSelected: index === selected
            }))
    });
};
var $b96e2c7b7779acd6$export$2e2bcd8739ae039 = $b96e2c7b7779acd6$var$TabList;

});
parcelRegister("lcHWu", function(module, exports) {
$parcel$export(module.exports, "useTab", () => $91221b4997543842$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $91221b4997543842$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $91221b4997543842$export$fae0121b5afe572d);

var $eJOHy = parcelRequire("eJOHy");

var $4OxCz = parcelRequire("4OxCz");
const $91221b4997543842$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $eJOHy.useContext)((0, $4OxCz.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $91221b4997543842$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $eJOHy.useContext)((0, $4OxCz.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $91221b4997543842$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $eJOHy.useContext)((0, $4OxCz.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("5YHRB", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1982d1480a5b002$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d1982d1480a5b002$var$messages = (0, $7qGN1.defineMessages)({
    pickerTabTextDefault: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.column-picker-tabs.picker-tab-text-default",
        "defaultMessage": "My defaults"
    },
    pickerTabTextFilter: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.column-picker-tabs.picker-tab-text-filter",
        "defaultMessage": "Filter"
    },
    pickerTabTextSystem: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.column-picker-tabs.picker-tab-text-system",
        "defaultMessage": "System"
    }
});
var $d1982d1480a5b002$export$2e2bcd8739ae039 = $d1982d1480a5b002$var$messages;

});

parcelRegister("fEOqD", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb7509b0df7f984b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lcHWu = parcelRequire("lcHWu");

var $Ay1uj = parcelRequire("Ay1uj");

var $8pnTC = parcelRequire("8pnTC");

var $buJG5 = parcelRequire("buJG5");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $kyUe2 = parcelRequire("kyUe2");

var $jZRDj = parcelRequire("jZRDj");
const $fb7509b0df7f984b$var$Tab = ({ label: label, maxWidth: maxWidth = '100%', onRestoreDefaults: onRestoreDefaults })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { labelOverflows: labelOverflows, onLabelRef: onLabelRef } = (0, $jZRDj.useLabelOverflow)();
    const tabAttributes = (0, $lcHWu.useTab)();
    const handleRestoreDefaults = (0, $eJOHy.useCallback)((mouseEvent, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'filterSearchRestoreDefaults', {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: mouseEvent.detail === 0
        });
        onRestoreDefaults && typeof onRestoreDefaults === 'function' && onRestoreDefaults();
    }, [
        onRestoreDefaults
    ]);
    if ((0, $4cTDP.fg)('jira_inline_field_config_gate')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fb7509b0df7f984b$var$TabStyled, {
        maxWidthValue: maxWidth,
        ...tabAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $buJG5.ConditionalTooltip), {
        condition: labelOverflows,
        content: label,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $fb7509b0df7f984b$var$tabStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        ref: onLabelRef,
        xcss: $fb7509b0df7f984b$var$textStyles
    }, label), onRestoreDefaults !== undefined && typeof onRestoreDefaults === 'function' && tabAttributes['aria-selected'] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8pnTC))),
        onClick: handleRestoreDefaults,
        label: formatMessage((0, $kyUe2.default).restoreDefaults),
        appearance: "subtle",
        spacing: "compact",
        isTooltipDisabled: false
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fb7509b0df7f984b$var$TabStyled, {
        maxWidthValue: maxWidth,
        ...tabAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $buJG5.ConditionalTooltip), {
        condition: labelOverflows,
        content: label,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        ref: onLabelRef,
        xcss: $fb7509b0df7f984b$var$textStyles
    }, label)));
};
const $fb7509b0df7f984b$var$textStyles = (0, $1DXK0.xcss)({
    textOverflow: 'ellipsis',
    overflow: 'hidden'
});
const $fb7509b0df7f984b$var$tabStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fb7509b0df7f984b$var$TabStyled = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { maxWidthValue: maxWidthValue, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ocvhpw": (0, $awdRS.default)(__cmplp.maxWidthValue)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_p12fd0nw _vchhusvi _ae4v1h6o",
            __cmplp.className
        ])
    });
});
var $fb7509b0df7f984b$export$2e2bcd8739ae039 = $fb7509b0df7f984b$var$Tab;

});
parcelRegister("8pnTC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::88b78ca28318b361f543778979c0dbc2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61f331c8b661ffec$var$_react = $61f331c8b661ffec$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $61f331c8b661ffec$var$_baseNew = $61f331c8b661ffec$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $61f331c8b661ffec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Retry".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for retry.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $61f331c8b661ffec$var$RetryIcon = (props)=>/*#__PURE__*/ $61f331c8b661ffec$var$_react.default.createElement($61f331c8b661ffec$var$_baseNew.default, Object.assign({
        name: "RetryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 8a7 7 0 0 1 12.5-4.33V1H15v5a.75.75 0 0 1-.75.75H9.5v-1.5h3.264a5.5 5.5 0 1 0 .665 3.63l1.482.24A7.002 7.002 0 0 1 1 8" clip-rule="evenodd"/>`
    }, props));
$61f331c8b661ffec$var$RetryIcon.displayName = 'RetryIcon';
var $61f331c8b661ffec$var$_default = module.exports.default = $61f331c8b661ffec$var$RetryIcon;

});

parcelRegister("buJG5", function(module, exports) {
$parcel$export(module.exports, "ConditionalTooltip", () => $f134232f4e230d4e$export$d8abb7a1cfbd4b6b);

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");
const $f134232f4e230d4e$export$d8abb7a1cfbd4b6b = ({ condition: condition, children: children, ...rest })=>// @ts-expect-error - TS2322 Typescript 5.9.2 upgrade
    condition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), rest, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);

});

parcelRegister("kyUe2", function(module, exports) {
$parcel$export(module.exports, "default", () => $a34ba8f32ea7be9c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a34ba8f32ea7be9c$var$messages = (0, $7qGN1.defineMessages)({
    restoreDefaults: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.column-picker-tabs.tab.restore-defaults",
        "defaultMessage": "Restore defaults"
    }
});
var $a34ba8f32ea7be9c$export$2e2bcd8739ae039 = $a34ba8f32ea7be9c$var$messages;

});

parcelRegister("jZRDj", function(module, exports) {
$parcel$export(module.exports, "useLabelOverflow", () => $e72c7cfe8cc09d91$export$96d540e3e625885f);

var $eJOHy = parcelRequire("eJOHy");
const $e72c7cfe8cc09d91$export$96d540e3e625885f = ()=>{
    const [labelOverflows, setLabelOverflows] = (0, $eJOHy.useState)(false);
    const onLabelRef = (0, $eJOHy.useCallback)((node)=>{
        if (node != null) {
            const isOverflow = Boolean(node.offsetWidth < node.scrollWidth);
            isOverflow !== labelOverflows && setLabelOverflows(isOverflow);
        }
    }, [
        labelOverflows
    ]);
    return {
        labelOverflows: labelOverflows,
        onLabelRef: onLabelRef,
        setLabelOverflows: setLabelOverflows
    };
};

});



parcelRegister("cV5SD", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d00fa6b7cfb4279$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4d00fa6b7cfb4279$var$messages = (0, $7qGN1.defineMessages)({
    listSystemWarningMessage: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.list-system-warning-message",
        "defaultMessage": "Any changes here will modify columns for all users."
    },
    listSystemWarningMessageNew: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.list-system-warning-message-new",
        "defaultMessage": "Changes will apply to everyone."
    },
    listFilterWarningMessage: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.list-filter-warning-message",
        "defaultMessage": "Any changes here will affect all users of this filter."
    },
    listNonEditableFilterInfoMessage: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.list-non-editable-filter-info-message",
        "defaultMessage": "You can\u2019t modify this filter. Contact the owner using the <link>Filters directory</link> for edit permission."
    }
});
var $4d00fa6b7cfb4279$export$2e2bcd8739ae039 = $4d00fa6b7cfb4279$var$messages;

});


parcelRegister("i5UAP", function(module, exports) {
$parcel$export(module.exports, "ColumnPickerRemountManager", () => $1884d3b6cc36bf23$export$a4237a5d372a0de2);

var $eJOHy = parcelRequire("eJOHy");

var $7auhX = parcelRequire("7auhX");

var $HiS1C = parcelRequire("HiS1C");
const $1884d3b6cc36bf23$export$a4237a5d372a0de2 = ({ children: children, viewIdFromResponse: viewIdFromResponse })=>{
    const [{ view: optimisticViewId }] = (0, $HiS1C.useSelectedViewState)();
    const { isLoading: isLoading } = (0, $7auhX.useColumnPickerLoadingContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), {
        key: isLoading ? 'loading' : `${optimisticViewId}${viewIdFromResponse}`
    }, children);
};

});

parcelRegister("fOH9z", function(module, exports) {
$parcel$export(module.exports, "BulkOpsConnectionsSubscriber", () => $3966942deaa09f8a$export$e722c6c8da1d5a1a);

var $eJOHy = parcelRequire("eJOHy");

var $3TtKq = parcelRequire("3TtKq");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $9wOi6 = parcelRequire("9wOi6");
const $3966942deaa09f8a$var$entryPointParams = {};
const $3966942deaa09f8a$export$e722c6c8da1d5a1a = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
    const selectedIssues = (0, $3TtKq.useIssueTableSelectedIssues)();
    const [hasSelectedAtLeastOnce, setHasSelectedAtLeastOnce] = (0, $eJOHy.useState)(false);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $9wOi6.bulkOperationsConnectionsSubscriberEntryPoint), $3966942deaa09f8a$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (!hasSelectedAtLeastOnce && selectedIssues.length > 0) {
            setHasSelectedAtLeastOnce(true);
            entryPointActions.load();
        }
    }, [
        entryPointActions,
        hasSelectedAtLeastOnce,
        selectedIssues.length
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "jira.nin-bulk.operations.connections.subscriber",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
});

});
parcelRegister("9wOi6", function(module, exports) {
$parcel$export(module.exports, "bulkOperationsConnectionsSubscriberEntryPoint", () => $595e7d22fd976a14$export$f0e5693d80379467);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $595e7d22fd976a14$export$f0e5693d80379467 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("68Zby")), {
        moduleId: "a230f98b",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("68Zby", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("V5vNT").then(()=>parcelRequire('3xmZq'));

});



parcelRegister("b2VjA", function(module, exports) {
$parcel$export(module.exports, "IssueCount", () => $0e1e995c74e3ea46$export$542fba90cc9c1bd1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6K4cv = parcelRequire("6K4cv");

var $gRqFV = parcelRequire("gRqFV");
const $0e1e995c74e3ea46$export$542fba90cc9c1bd1 = (issueCountProps)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0e1e995c74e3ea46$var$IssueCountContainer, {
        "data-testid": "issue-navigator.ui.issue-results.list-view.issue-count",
        isFlexEnd: issueCountProps.isNewFooterOrderEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        testId: "issue-navigator.ui.issue-results.list-view.issue-count.text",
        xcss: $0e1e995c74e3ea46$var$textStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6K4cv.default), issueCountProps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gRqFV.default), null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0e1e995c74e3ea46$var$IssueCountContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlexEnd: isFlexEnd, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _zulp1b66 _1e0c1txw _4cvr1h6o _k48p1pd9",
            __cmplp.isFlexEnd ? "_1bahesu3" : "_1bah1h6o",
            __cmplp.className
        ])
    });
});
const $0e1e995c74e3ea46$var$textStyles = (0, $1DXK0.xcss)({
    fontWeight: 'font.weight.medium',
    color: 'color.text.subtle'
});

});

parcelRegister("kg3EI", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ca75450ec188479$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $7ca75450ec188479$var$messages = (0, $7qGN1.defineMessages)({
    reorderColumnsErrorTitle: {
        "id": "issue-navigator.issue-results.list-view.reorder-columns-error-title",
        "defaultMessage": "We couldn't reorder your columns"
    },
    resetColumnsErrorTitle: {
        "id": "issue-navigator.issue-results.list-view.reset-columns-error-title",
        "defaultMessage": "We couldn't restore your default columns"
    },
    columnConfigMutationErrorDescription: {
        "id": "issue-navigator.issue-results.list-view.column-config-mutation-error-description",
        "defaultMessage": "Refresh and try again."
    }
});
var $7ca75450ec188479$export$2e2bcd8739ae039 = $7ca75450ec188479$var$messages;

});

parcelRegister("ghzkC", function(module, exports) {
$parcel$export(module.exports, "NoColumns", () => $4928523630d37d70$export$a0e9f6d02eee4aa4);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6MnLl = parcelRequire("6MnLl");

var $8IeH1 = parcelRequire("8IeH1");

var $cxKOj = parcelRequire("cxKOj");

var $hKp9p = parcelRequire("hKp9p");

var $lRq8t = parcelRequire("lRq8t");

var $53prN = parcelRequire("53prN");

var $kRgKj = parcelRequire("kRgKj");

var $kh7bJ = parcelRequire("kh7bJ");

var $HiS1C = parcelRequire("HiS1C");

var $iT6a0 = parcelRequire("iT6a0");
const $4928523630d37d70$var$Bold = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("b", null, children);
const $4928523630d37d70$var$NoColumnsAnonymous = ({ defaultNoColumnsGlyph: defaultNoColumnsGlyph })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [, { setView: setView }] = (0, $HiS1C.useSelectedViewState)();
    const onClick = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'button clicked', 'noColumnsButton', {
            isAnon: true
        });
        setView('detail', '');
    }, [
        setView
    ]);
    const component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        header: formatMessage((0, $iT6a0.default).noColumnsHeaderAnonymous),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hKp9p.FormattedI18nMessage), {
            componentsMapping: {
                bold: $4928523630d37d70$var$Bold
            },
            message: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iT6a0.default).noColumnsDescriptionAnonymousIssueTermRefresh : (0, $iT6a0.default).noColumnsDescriptionAnonymous, {
                boldStart: '{boldStart}',
                boldEnd: '{boldEnd}'
            })
        }),
        testId: "issue-navigator.ui.issue-results.list-view.no-columns.no-columns-anonymous",
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "primary",
            onClick: onClick
        }, formatMessage((0, $iT6a0.default).switchView)),
        renderImage: ()=>defaultNoColumnsGlyph
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        paddingBlock: "space.800"
    }, component);
};
const $4928523630d37d70$export$a0e9f6d02eee4aa4 = ({ defaultNoColumnsGlyph: defaultNoColumnsGlyph, hasColumnConfiguration: hasColumnConfiguration })=>{
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    return isAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4928523630d37d70$var$NoColumnsAnonymous, {
        defaultNoColumnsGlyph: defaultNoColumnsGlyph
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $53prN.components).NoColumns, {
        defaultNoColumnsGlyph: defaultNoColumnsGlyph,
        hasColumnConfiguration: hasColumnConfiguration
    });
};

});
parcelRegister("hKp9p", function(module, exports) {
$parcel$export(module.exports, "FormattedI18nMessage", () => $4a944b9f8e1bdcd5$export$200d7bd7633253ce);

var $eJOHy = parcelRequire("eJOHy");

var $kDXuS = parcelRequire("kDXuS");

var $iG6Da = parcelRequire("iG6Da");
const $4a944b9f8e1bdcd5$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $eJOHy.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $iG6Da.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $iG6Da.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $iG6Da.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $kDXuS.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $iG6Da.isCloseTagDelimiter)(letter) && (0, $iG6Da.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $kDXuS.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $iG6Da.isCloseTagDelimiter)(letter) && (0, $iG6Da.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $kDXuS.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $kDXuS.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $kDXuS.MalformedMessageError)) {
                (0, $kDXuS.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $kDXuS.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("kDXuS", function(module, exports) {
$parcel$export(module.exports, "getMalformedMessage", () => $472e049a457e3e08$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $472e049a457e3e08$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $472e049a457e3e08$export$40d900e818b9630e);

var $9pTd3 = parcelRequire("9pTd3");

var $eSnSE = parcelRequire("eSnSE");

const $472e049a457e3e08$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $472e049a457e3e08$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                packageName: packageName,
                id: (0, $87f91af7ca94ba6f$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $87f91af7ca94ba6f$export$f3390a0e172fee41)}`;
        (0, $eSnSE.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $472e049a457e3e08$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $87f91af7ca94ba6f$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("iG6Da", function(module, exports) {
$parcel$export(module.exports, "getTags", () => $68578e605e3d042e$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $68578e605e3d042e$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $68578e605e3d042e$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $68578e605e3d042e$export$d5170904651e91b1);

const $68578e605e3d042e$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $68578e605e3d042e$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $68578e605e3d042e$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $68578e605e3d042e$export$d5170904651e91b1 = (letter)=>letter === (0, $d1a759ca3dd7ec52$export$a10c567c3288a6b4);

});
const $d1a759ca3dd7ec52$export$a10c567c3288a6b4 = '}';



parcelRegister("53prN", function(module, exports) {
$parcel$export(module.exports, "components", () => $30d976bd0a41653c$export$9b5ac10f59f76296);

var $luhKv = parcelRequire("luhKv");

var $4ohGb = parcelRequire("4ohGb");

var $dK9Sm = parcelRequire("dK9Sm");
const $30d976bd0a41653c$export$9b5ac10f59f76296 = {
    columnPicker: $luhKv.components,
    Footer: $4ohGb.Footer,
    NoColumns: $dK9Sm.NoColumns
};

});
parcelRegister("luhKv", function(module, exports) {
$parcel$export(module.exports, "components", () => $8762592adb027c9e$export$9b5ac10f59f76296);

var $7JbAM = parcelRequire("7JbAM");
const $8762592adb027c9e$export$9b5ac10f59f76296 = {
    NoOptionsMessage: $7JbAM.default
};

});
parcelRegister("7JbAM", function(module, exports) {
$parcel$export(module.exports, "default", () => $bae9d594d2745981$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $80DPg = parcelRequire("80DPg");

var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $eS29z = parcelRequire("eS29z");

var $3ycj9 = parcelRequire("3ycj9");
const $bae9d594d2745981$var$MessageContainer = ({ icon: icon, children: children })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.150",
        xcss: $bae9d594d2745981$var$stackStyles,
        alignInline: "center"
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        color: "color.text"
    }, formatMessage((0, $3ycj9.default).noOptionsPrimaryMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        color: "color.text.subtle",
        size: "small"
    }, formatMessage((0, $3ycj9.default).noOptionsSecondaryMessage)), children);
};
/**
 * Custom message to show when no options are visible in the column picker. This allows additional help text/content to
 * be rendered using the children prop.
 */ const $bae9d594d2745981$var$NoOptionsMessage = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bae9d594d2745981$var$MessageContainer, {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
            label: "",
            color: "var(--ds-icon, #292A2E)",
            LEGACY_primaryColor: "currentColor"
        })
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireUiAnalytics), {
        actionSubject: "emptyState",
        action: "viewed",
        actionSubjectId: "columnPicker"
    }));
};
var $bae9d594d2745981$export$2e2bcd8739ae039 = $bae9d594d2745981$var$NoOptionsMessage;
const $bae9d594d2745981$var$stackStyles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.150',
    paddingInline: 'space.100',
    // this is for the children additional help text/content
    color: 'color.text.subtlest'
});

});
parcelRegister("3ycj9", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bd552da9271bc32$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $6bd552da9271bc32$var$messages = (0, $7qGN1.defineMessages)({
    noOptionsPrimaryMessage: {
        "id": "issue-table-column-picker.common.no-options-message.no-options-primary-message",
        "defaultMessage": "We couldn't find what you're looking for"
    },
    noOptionsSecondaryMessage: {
        "id": "issue-table-column-picker.common.no-options-message.no-options-secondary-message",
        "defaultMessage": "Try using different search terms."
    }
});
var $6bd552da9271bc32$export$2e2bcd8739ae039 = $6bd552da9271bc32$var$messages;

});



parcelRegister("4ohGb", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $74e7263cd9d59bbd$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $kbYhH = parcelRequire("kbYhH");

var $7n9BS = parcelRequire("7n9BS");
const $74e7263cd9d59bbd$export$a06f1c675e846f6f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ start: start = $74e7263cd9d59bbd$var$SpacerElement, center: center = $74e7263cd9d59bbd$var$SpacerElement, end: end = $74e7263cd9d59bbd$var$SpacerElement }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$var$FooterBase, {
        ref: ref
    }, start, center, end);
});
const $74e7263cd9d59bbd$var$FooterBase = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children }, ref)=>{
    const tableHeight = (0, $kbYhH.useElementSizeSelector)((size)=>size.height);
    const hasShadow = (0, $7n9BS.useScrollStateSelector)((scrollState)=>{
        const { height: containerHeight, scrollTop: scrollTop } = scrollState;
        // Scroll measurements are fractional, while height measurements are integer, so we need to round before comparing
        return containerHeight < tableHeight && Math.round(scrollTop) < tableHeight - containerHeight;
    });
    return (0, $4cTDP.fg)('reduce_size_of_scroll_container_shadow') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$var$FooterWrapper, null, hasShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$var$FooterShadow, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$var$FooterContainer, {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ref: ref,
        "data-testid": "native-issue-table.common.ui.components.footer.footer-container",
        hasShadow: false
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$var$FooterContainer, {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ref: ref,
        "data-testid": "native-issue-table.common.ui.components.footer.footer-container",
        hasShadow: hasShadow
    }, children);
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $74e7263cd9d59bbd$var$FooterWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $74e7263cd9d59bbd$var$FooterShadow = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _4t3i1y44 _lcxvglyw _16qs1nax",
            __cmplp.className
        ])
    });
});
const $74e7263cd9d59bbd$var$FooterContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasShadow: hasShadow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_x3doj0fz _1e0c1txw _2lx2vrvc _1n261q9c _kqsw1if8 _1ltvidpf _94n5idpf _bfhkvuon _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.hasShadow && "_16qs2iat",
            __cmplp.className
        ])
    });
});
const $74e7263cd9d59bbd$export$d7a54cba636a8cd6 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $74e7263cd9d59bbd$var$SpacerElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$export$d7a54cba636a8cd6, null);

});

parcelRegister("dK9Sm", function(module, exports) {
$parcel$export(module.exports, "NoColumns", () => $edb4c92fc13b3452$export$a0e9f6d02eee4aa4);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6MnLl = parcelRequire("6MnLl");

var $8IeH1 = parcelRequire("8IeH1");

var $lRq8t = parcelRequire("lRq8t");

var $PETi0 = parcelRequire("PETi0");

var $kRgKj = parcelRequire("kRgKj");

var $5F0C9 = parcelRequire("5F0C9");
const $edb4c92fc13b3452$export$a0e9f6d02eee4aa4 = ({ defaultNoColumnsGlyph: defaultNoColumnsGlyph, hasColumnConfiguration: hasColumnConfiguration })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [{ isOpen: isOpen }, actions] = (0, $PETi0.useColumnPickerOpenState)();
    const onOpenColumnPicker = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'button clicked', 'noColumnsButton');
        if (!isOpen) actions.open();
    }, [
        isOpen,
        actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        paddingBlock: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        header: formatMessage((0, $5F0C9.default).noColumnsHeaderText),
        description: formatMessage((0, $5F0C9.default).noColumnsDescriptionText),
        testId: "native-issue-table.common.ui.components.no-columns.no-columns",
        primaryAction: hasColumnConfiguration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "primary",
            onClick: onOpenColumnPicker
        }, formatMessage((0, $5F0C9.default).configureColumns)) : undefined,
        renderImage: ()=>defaultNoColumnsGlyph
    }));
};

});
parcelRegister("PETi0", function(module, exports) {
$parcel$export(module.exports, "ColumnPickerContainer", () => $3bc985482a1599b5$export$e1286e1cb3fa0dec);
$parcel$export(module.exports, "useColumnPickerOpenState", () => $3bc985482a1599b5$export$81588ffe8d9d4add);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $3bc985482a1599b5$export$e1286e1cb3fa0dec = (0, $6E16M.createContainer)();
const $3bc985482a1599b5$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        isOpen: false
    },
    actions: {
        open: ()=>({ setState: setState })=>{
                setState({
                    isOpen: true
                });
            },
        close: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false
                });
            }
    },
    name: 'ColumnPickerOpenState',
    containedBy: $3bc985482a1599b5$export$e1286e1cb3fa0dec
});
const $3bc985482a1599b5$export$81588ffe8d9d4add = (0, $iJq0l.createHook)($3bc985482a1599b5$var$Store);

});

parcelRegister("5F0C9", function(module, exports) {
$parcel$export(module.exports, "default", () => $eacbcb43f37199f6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $eacbcb43f37199f6$var$messages = (0, $7qGN1.defineMessages)({
    noColumnsHeaderText: {
        "id": "native-issue-table.issue-table.no-columns.no-columns-header-text",
        "defaultMessage": "Configure your columns"
    },
    noColumnsDescriptionText: {
        "id": "native-issue-table.issue-table.no-columns.no-columns-description-text",
        "defaultMessage": "You haven't configured any columns yet. Add fields as columns to see search results and their information."
    },
    configureColumns: {
        "id": "native-issue-table.issue-table.no-columns.configure-columns",
        "defaultMessage": "Configure columns"
    }
});
var $eacbcb43f37199f6$export$2e2bcd8739ae039 = $eacbcb43f37199f6$var$messages;

});



parcelRegister("iT6a0", function(module, exports) {
$parcel$export(module.exports, "default", () => $473705edd52aae5f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $473705edd52aae5f$var$messages = (0, $7qGN1.defineMessages)({
    noColumnsHeaderAnonymous: {
        "id": "issue-navigator.issue-results.list-view.issue-table-no-columns-anonymous.no-columns-header-anonymous",
        "defaultMessage": "The admin hasn't configured any columns"
    },
    noColumnsDescriptionAnonymous: {
        "id": "issue-navigator.issue-results.list-view.issue-table-no-columns-anonymous.no-columns-description-anonymous",
        "defaultMessage": "Switch to {boldStart}Detail view{boldEnd} to see issues and their information."
    },
    switchView: {
        "id": "issue-navigator.issue-results.list-view.issue-table-no-columns-anonymous.switch-view",
        "defaultMessage": "Switch to detail view"
    },
    noColumnsDescriptionAnonymousIssueTermRefresh: {
        "id": "issue-navigator.issue-results.list-view.issue-table-no-columns-anonymous.no-columns-description-anonymous-issue-term-refresh",
        "defaultMessage": "Switch to {boldStart}Detail view{boldEnd} to see work items and their information."
    }
});
var $473705edd52aae5f$export$2e2bcd8739ae039 = $473705edd52aae5f$var$messages;

});


parcelRegister("2PY5Q", function(module, exports) {
$parcel$export(module.exports, "NoIssues", () => $b374b99ab61e2d81$export$a7a61a727a1d891b);

var $eJOHy = parcelRequire("eJOHy");

var $6MnLl = parcelRequire("6MnLl");

var $8IeH1 = parcelRequire("8IeH1");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $ip1XF = parcelRequire("ip1XF");
const $b374b99ab61e2d81$export$a7a61a727a1d891b = ({ defaultNoIssuesGlyph: defaultNoIssuesGlyph })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        paddingBlock: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        header: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $ip1XF.default).noIssuesIssueTermRefresh : (0, $ip1XF.default).noIssues),
        renderImage: ()=>defaultNoIssuesGlyph,
        testId: "issue-navigator.ui.issue-results.list-view.no-issues.empty-state"
    }));
};

});
parcelRegister("ip1XF", function(module, exports) {
$parcel$export(module.exports, "default", () => $747b132590479e9d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $747b132590479e9d$var$messages = (0, $7qGN1.defineMessages)({
    noIssues: {
        "id": "issue-navigator.common.empty-list-icon.no-issues",
        "defaultMessage": "No issues were found matching your search"
    },
    noIssuesIssueTermRefresh: {
        "id": "issue-navigator.issue-results.list-view.no-issues.no-issues-issue-term-refresh",
        "defaultMessage": "There's nothing matching your search"
    }
});
var $747b132590479e9d$export$2e2bcd8739ae039 = $747b132590479e9d$var$messages;

});


parcelRegister("fwdeI", function(module, exports) {
$parcel$export(module.exports, "AsyncRegisterShortcutDialogActions", () => $cde7bd4836a70214$export$53d5920188b673b6);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bHRpp = parcelRequire("bHRpp");

var $bQWwW = parcelRequire("bQWwW");
var $fathc = parcelRequire("fathc");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $cde7bd4836a70214$var$LazyRegisterShortcutDialogActions = (0, $bQWwW.lazy)(()=>(parcelRequire("hVSGn")), {
    moduleId: "./src/packages/issue-navigator/issue-navigator/src/ui/issue-results/list-view/register-shortcut-dialog-actions/index.tsx"
});
const $cde7bd4836a70214$export$53d5920188b673b6 = (props)=>{
    const [{ isShortcutsDialogVisible: isShortcutsDialogVisible }] = (0, $bHRpp.useShortcuts)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        packageName: "jiraIssueNavigator",
        id: "register-issue-actions-worklflow-shortcuts-dialog",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fathc.LazyWait), {
        until: isShortcutsDialogVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "register-shortcut-dialog-actions",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cde7bd4836a70214$var$LazyRegisterShortcutDialogActions, props))));
};

});
parcelRegister("bHRpp", function(module, exports) {
$parcel$export(module.exports, "useShortcuts", () => $5ec870659f2b42dd$export$a1ca853c6e4bb6fb);
$parcel$export(module.exports, "useShortcutsActions", () => $5ec870659f2b42dd$export$b331ee6e87b9104c);

var $fgHZ8 = parcelRequire("fgHZ8");
const $5ec870659f2b42dd$export$a1ca853c6e4bb6fb = ()=>(0, $fgHZ8.useShortcutsStore)();
const $5ec870659f2b42dd$export$b331ee6e87b9104c = ()=>{
    const [, actions] = (0, $fgHZ8.useShortcutsActionsStore)();
    return [
        undefined,
        actions
    ];
};

});
parcelRegister("fgHZ8", function(module, exports) {
$parcel$export(module.exports, "useShortcutsStore", () => $1037d55a513c4cd3$export$a14646bfc7ba8d81);
$parcel$export(module.exports, "useShortcutsActionsStore", () => $1037d55a513c4cd3$export$1a29bfef7fa09838);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $9rMca = parcelRequire("9rMca");
const $1037d55a513c4cd3$export$d4c72bab9d6cc13a = {
    shortcuts: {
        admin: {
            key: 'admin',
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            label: 'ADMIN',
            options: [],
            isLoaded: false
        }
    },
    isShortcutsDialogVisible: false,
    isShortcutsLoading: false,
    hasError: false,
    isAdminLoading: false,
    selectedItemKey: null,
    header: null,
    title: undefined
};
const $1037d55a513c4cd3$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'shortcuts',
    initialState: // @ts-expect-error - TS2322 - Type '{ readonly shortcuts: { readonly admin: { readonly key: "admin"; readonly label: "ADMIN"; readonly options: readonly []; readonly isLoaded: false; }; }; readonly isShortcutsDialogVisible: false; readonly isShortcutsLoading: false; ... 4 more ...; readonly title: undefined; }' is not assignable to type 'State'.
    $1037d55a513c4cd3$export$d4c72bab9d6cc13a,
    actions: $9rMca
});
const $1037d55a513c4cd3$export$a14646bfc7ba8d81 = (0, $iJq0l.createHook)($1037d55a513c4cd3$export$6f57813fe9f31bf9);
const $1037d55a513c4cd3$export$1a29bfef7fa09838 = (0, $iJq0l.createHook)($1037d55a513c4cd3$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("9rMca", function(module, exports) {
$parcel$export(module.exports, "registerShortcuts", () => $bd65986ef711b2b7$export$598ec0e6047cbdca);
$parcel$export(module.exports, "setShortcutsDialogVisibility", () => $bd65986ef711b2b7$export$80ab1e79e32c3021);
$parcel$export(module.exports, "setShortcutsLoading", () => $bd65986ef711b2b7$export$7ed2ac8328423043);
$parcel$export(module.exports, "setHasError", () => $bd65986ef711b2b7$export$645a7c7453685186);
$parcel$export(module.exports, "setHeader", () => $bd65986ef711b2b7$export$604ed74fb893f0e2);
$parcel$export(module.exports, "fetchAdminSections", () => $bd65986ef711b2b7$export$aec87c8c9bde62e6);
$parcel$export(module.exports, "setSelectedItemKey", () => $bd65986ef711b2b7$export$249c9d5b49cd9712);
$parcel$export(module.exports, "dropShortcutsByKeys", () => $bd65986ef711b2b7$export$9cf39adf0dec984);

var $2zs80 = parcelRequire("2zs80");

var $9FV9P = parcelRequire("9FV9P");

var $2TCxE = parcelRequire("2TCxE");
const $bd65986ef711b2b7$export$598ec0e6047cbdca = (shortcuts)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const newShortcuts = shortcuts.reduce((acc, current)=>{
            acc[current.key] = current;
            return acc;
        }, {
            ...currentState.shortcuts
        });
        setState({
            ...currentState,
            shortcuts: newShortcuts,
            isShortcutsLoading: false
        });
    };
const $bd65986ef711b2b7$export$80ab1e79e32c3021 = (isVisible)=>({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            isShortcutsDialogVisible: isVisible
        });
    };
const $bd65986ef711b2b7$export$7ed2ac8328423043 = (isLoading)=>({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            isShortcutsLoading: isLoading
        });
    };
const $bd65986ef711b2b7$export$645a7c7453685186 = (hasError)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            hasError: hasError
        });
    };
const $bd65986ef711b2b7$export$604ed74fb893f0e2 = (header, title)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            header: header,
            title: title
        });
    };
const $bd65986ef711b2b7$export$aec87c8c9bde62e6 = ()=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            isAdminLoading: true
        });
        const result = await (0, $9FV9P.default)();
        const shortcuts = result ? (0, $2TCxE.buildAdminSections)(result) : [];
        const newState = getState();
        setState({
            ...newState,
            shortcuts: {
                ...newState.shortcuts,
                admin: {
                    ...newState.shortcuts.admin,
                    key: 'admin',
                    options: shortcuts,
                    isLoaded: true
                }
            },
            hasError: currentState.hasError || !result,
            isAdminLoading: false
        });
    };
const $bd65986ef711b2b7$export$249c9d5b49cd9712 = (item)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            selectedItemKey: item
        });
    };
const $bd65986ef711b2b7$export$9cf39adf0dec984 = (keys)=>({ getState: getState, setState: setState })=>{
        if (!keys.length) return;
        const { shortcuts: shortcuts, ...rest } = getState();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newShortcuts = (0, (/*@__PURE__*/$parcel$interopDefault($2zs80)))(Object.keys(shortcuts), keys).reduce((acc, key)=>{
            acc[key] = shortcuts[key];
            return acc;
        }, {});
        setState({
            ...rest,
            shortcuts: newShortcuts,
            isShortcutsLoading: false
        });
    };

});
parcelRegister("9FV9P", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9cd1634918b3cd3$export$2e2bcd8739ae039);

var $eSnSE = parcelRequire("eSnSE");

var $hgi0g = parcelRequire("hgi0g");
const $e9cd1634918b3cd3$var$fetchAdminLinks = async ()=>{
    try {
        return await (0, $hgi0g.default)('/rest/adminquicksearch/latest/links/default');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('shortcuts-dialog.fetch-admin-links', error.toString());
        return null;
    }
};
var $e9cd1634918b3cd3$export$2e2bcd8739ae039 = $e9cd1634918b3cd3$var$fetchAdminLinks;

});

parcelRegister("2TCxE", function(module, exports) {
$parcel$export(module.exports, "buildAdminSections", () => $8b2ef73b57082485$export$5f8c94ecd4c9eb76);
const $8b2ef73b57082485$export$5f8c94ecd4c9eb76 = (parent, result = [])=>{
    if (parent.sections && parent.sections.length) parent.sections.forEach((s)=>$8b2ef73b57082485$export$5f8c94ecd4c9eb76(s, result));
    if (parent.items && parent.items.length) parent.items.forEach((i)=>result.push({
            key: i.key,
            label: i.label,
            // @ts-expect-error - TS2322 - Type '() => void' is not assignable to type '(event?: Event | undefined) => Promise<undefined> | undefined'.
            onClick: ()=>{
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.location.href = i.linkUrl;
            }
        }));
    return result;
};

});




parcelRegister("hVSGn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kQMAD").then(()=>parcelRequire('cFlWj'));

});


parcelRegister("jOc90", function(module, exports) {
$parcel$export(module.exports, "dragAndDropExperience", () => $c40c00dcaf6b3661$export$c1eb53e51d4d0ab3);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");
const $c40c00dcaf6b3661$export$c1eb53e51d4d0ab3 = new (0, $f39LL.UFOExperience)('jira-issue-navigator.list-view.drag-and-drop', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("aaQkY", function(module, exports) {
$parcel$export(module.exports, "useEventHandlers", () => $f78e58290b5b5276$export$8ce912bc34d0dbea);

var $eJOHy = parcelRequire("eJOHy");

var $1wL9i = parcelRequire("1wL9i");

var $ijD5s = parcelRequire("ijD5s");

var $1aawv = parcelRequire("1aawv");
const $f78e58290b5b5276$export$8ce912bc34d0dbea = (connectionId, fieldSetIds)=>{
    const { setSelectedIssueByKey: setSelectedIssueByKey, deselectIssue: deselectIssue } = (0, $1wL9i.useSelectedIssueActions)();
    const onDeleteIssue = (0, $ijD5s.useOnDeleteIssue)(connectionId);
    const onIssueByFieldsRefetch = (0, $1aawv.useIssueByFieldsRefetch)(fieldSetIds);
    const onIssueRefetch = onIssueByFieldsRefetch;
    // While we don't have a mutation setup for inline editing, use issue refetch as a substitute
    const onUpdateCache = onIssueByFieldsRefetch;
    const onIssueDelete = (0, $eJOHy.useCallback)((deletedIssueKey)=>{
        const issueKeyToSelect = onDeleteIssue(deletedIssueKey);
        if (!issueKeyToSelect.length) {
            deselectIssue({
                shouldDebounce: false,
                shouldNotifyOnChange: false,
                isSelectedByUserInteraction: false
            });
            return;
        }
        setSelectedIssueByKey(issueKeyToSelect, {
            shouldDebounce: false,
            shouldNotifyOnChange: false,
            isSelectedByUserInteraction: false
        });
    }, [
        onDeleteIssue,
        setSelectedIssueByKey,
        deselectIssue
    ]);
    const onIssueLinkSelected = (0, $eJOHy.useCallback)((issueKey, viewActivity)=>{
        setSelectedIssueByKey(issueKey, {
            viewActivity: viewActivity
        });
        return true;
    }, [
        setSelectedIssueByKey
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            onIssueRefetch: onIssueRefetch,
            onUpdateCache: onUpdateCache,
            onIssueDelete: onIssueDelete,
            onIssueLinkSelected: onIssueLinkSelected
        }), [
        onIssueRefetch,
        onUpdateCache,
        onIssueDelete,
        onIssueLinkSelected
    ]);
};

});



parcelRegister("e78V2", function(module, exports) {
$parcel$export(module.exports, "default", () => $223373443ce3803e$export$2e2bcd8739ae039);

var $ikc1o = parcelRequire("ikc1o");

var $kqHfo = parcelRequire("kqHfo");

var $4sjRg = parcelRequire("4sjRg");

var $dqj1A = parcelRequire("dqj1A");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $c12HM = parcelRequire("c12HM");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $5vQ2T = parcelRequire("5vQ2T");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $5i1j5 = parcelRequire("5i1j5");

var $lzg2Z = parcelRequire("lzg2Z");

var $gVAWF = parcelRequire("gVAWF");

var $5ekXO = parcelRequire("5ekXO");

var $56qWy = parcelRequire("56qWy");

var $J0ugN = parcelRequire("J0ugN");

var $kh7bJ = parcelRequire("kh7bJ");

var $4EKqI = parcelRequire("4EKqI");

var $cxKOj = parcelRequire("cxKOj");

var $iRahl = parcelRequire("iRahl");

var $eibCx = parcelRequire("eibCx");

var $fAgUF = parcelRequire("fAgUF");

var $61oZD = parcelRequire("61oZD");

var $4COCY = parcelRequire("4COCY");

var $1fmSG = parcelRequire("1fmSG");

var $fwKw5 = parcelRequire("fwKw5");

var $3kDjB = parcelRequire("3kDjB");

var $aaLZH = parcelRequire("aaLZH");

var $a8Oge = parcelRequire("a8Oge");

var $3d17F = parcelRequire("3d17F");

var $in3H6 = parcelRequire("in3H6");

var $beKwt = parcelRequire("beKwt");

var $5B9jk = parcelRequire("5B9jk");

const $223373443ce3803e$var$JQLBuilderWrapper = ({ defaultJql: defaultJql, onFilterSave: onFilterSave, onReset: onReset, onChangeJql: onChangeJql, onToggleAi: onToggleAi, groupResults: groupResults, issueResults: issueResults, filter: filter, jqlBuilderProps: jqlBuilderProps, jqlBuilderWithAiKey: jqlBuilderWithAiKey, initialQueryAsJql: initialQueryAsJql, disableBackToFilterButton: disableBackToFilterButton, isFilterRefinementEnabled: isFilterRefinementEnabled, filterRefinementQueryReference: filterRefinementQueryReference })=>{
    const { startJqlBuilderMetric: startJqlBuilderMetric, stopJqlBuilderMetric: stopJqlBuilderMetric, markJqlBuilderMetric: markJqlBuilderMetric } = (0, $beKwt.useJqlBuilderInstrumentation)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        startJqlBuilderMetric();
        markJqlBuilderMetric((0, $fAgUF.marks).JQL_BUILDER_START);
    }, [
        startJqlBuilderMetric,
        markJqlBuilderMetric
    ]);
    const { query: query, onSearch: onSearch } = (0, $1fmSG.useJqlSearch)(onChangeJql);
    const { maybeHydrationQueryReference: maybeHydrationQueryReference, ...restJqlBuilderProps } = jqlBuilderProps ?? {
        maybeHydrationQueryReference: undefined
    };
    const { jql: jql, filterJql: filterJql, filterId: filterId, initialJql: initialJql } = (0, $fwKw5.useActiveJql)(); /**
                       * We will only utilise a router resource HydrationQueryReference if it is the
                       * first time the component is mounted on page load.
                       * So we check whether the query hasn't changed between page load and component mount
                       */ 
    const [hydrationQueryReferenceRef] = (0, $eJOHy.useState)(()=>{
        if (!(0, $4cTDP.fg)('jracloud_85520_hydration_ref_only_on_page_load')) return undefined;
        const initialQuery = (0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes') ? initialJql : initialQueryAsJql;
        return initialQuery === query ? maybeHydrationQueryReference : undefined;
    });
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    const isSaveFilterButtonEnabled = (0, $aaLZH.useIssueNavigatorFeatures)().isSaveFilterButtonEnabled;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isFetching = (0, $3kDjB.useIsFetching)();
    const groupResultsData = (0, $j4oe4.useFragment)((0, $dqj1A.default), groupResults);
    const issueResultsData = (0, $j4oe4.useFragment)((0, $4sjRg.default), issueResults);
    const issueSearchError = issueResultsData?.issueSearchError ?? null;
    const jqlErrors = (0, $eJOHy.useMemo)(()=>{
        const groupConnectionClientErrors = (groupResultsData?.errors ?? []).filter(({ extensions: extensions })=>extensions?.some(({ statusCode: statusCode })=>typeof statusCode === 'number' && statusCode >= 400 && statusCode < 500));
        if (!isFetching) {
            if (issueSearchError) {
                if (issueSearchError.__typename === 'JiraInvalidJqlError') return issueSearchError.messages?.filter((0, $eibCx.isNonNullish)).map((message)=>({
                        type: 'error',
                        message: message
                    })) ?? [];
                if (issueSearchError.__typename === 'JiraInvalidSyntaxError' && issueSearchError.message != null) return [
                    {
                        type: 'error',
                        message: issueSearchError.message,
                        errorType: issueSearchError.errorType ?? undefined
                    }
                ];
            } else if (groupConnectionClientErrors.length) return groupConnectionClientErrors.map(({ message: message })=>({
                    message: message,
                    type: 'error'
                }));
        }
        return undefined;
    }, [
        groupResultsData?.errors,
        isFetching,
        issueSearchError
    ]);
    const filterData = (0, $j4oe4.useFragment)((0, $kqHfo.default), filter);
    const ResetButtonControl = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $in3H6.default), {
            onReset: onReset
        }), [
        onReset
    ]);
    const GoBackToFilterButtonControl = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $in3H6.default), {
            onReset: onReset,
            isResetToFilter: true
        }), [
        onReset
    ]);
    const SaveFilterControl = (0, $eJOHy.useCallback)(({ searchMode: searchMode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($223373443ce3803e$var$SaveFilterWrapper, {
            "data-testid": "issue-navigator.ui.jql-builder.save-filter-control",
            "data-vc": "jql-builder-ui-save-filter-control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $J0ugN.SaveFilterDialog), {
            jql: query,
            attributes: {
                isAdvancedModeEnabled: searchMode === (0, $56qWy.SEARCH_MODE_ADVANCED)
            },
            onFilterSave: onFilterSave,
            buttonText: formatMessage((0, $a8Oge.default).saveFilterButton),
            title: formatMessage((0, $a8Oge.default).saveFilterDialogTitle)
        })), [
        onFilterSave,
        query,
        formatMessage
    ]);
    const SaveFilterDropdownControl = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($223373443ce3803e$var$SaveFilterWrapper, {
            "data-testid": "issue-navigator.ui.jql-builder.save-filter-dropdown-control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5i1j5.SaveFilterDropdown), {
            query: query,
            filterId: filterId,
            onFilterSave: onFilterSave
        })), [
        filterId,
        query,
        onFilterSave
    ]);
    const CopyFilterControl = (0, $eJOHy.useCallback)(({ searchMode: searchMode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($223373443ce3803e$var$SaveFilterWrapper, {
            "data-testid": "issue-navigator.ui.jql-builder.copy-filter-control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $J0ugN.SaveFilterDialog), {
            jql: query,
            filterId: filterId,
            attributes: {
                isAdvancedModeEnabled: searchMode === (0, $56qWy.SEARCH_MODE_ADVANCED)
            },
            onFilterSave: onFilterSave,
            buttonText: formatMessage((0, $a8Oge.default).copyFilterButton),
            title: formatMessage((0, $a8Oge.default).copyFilterDialogTitle)
        })), [
        onFilterSave,
        query,
        filterId,
        formatMessage
    ]);
    const renderFilterControls = (0, $eJOHy.useCallback)(()=>{
        const extraControls = []; // Button nor dropdown should be shown when user is anonymous
        if (!isAnonymous && isSaveFilterButtonEnabled) {
            if (filterData) {
                const { isEditable: isEditable } = filterData; // Should not show neither the button nor the dropdown if jql errors
                if (!jqlErrors || jqlErrors.length === 0) {
                    if ((0, $5B9jk.isFilterJqlModified)({
                        filterJql: filterJql,
                        query: query
                    })) {
                        if (isEditable === true) extraControls.push(SaveFilterDropdownControl);
                        else extraControls.push(SaveFilterControl);
                    } else extraControls.push(CopyFilterControl);
                }
            } else extraControls.push(SaveFilterControl);
        }
        return extraControls;
    }, [
        CopyFilterControl,
        SaveFilterControl,
        SaveFilterDropdownControl,
        filterData,
        filterJql,
        isAnonymous,
        isSaveFilterButtonEnabled,
        jqlErrors,
        query
    ]);
    const showResetButton = (0, $eJOHy.useMemo)(()=>disableBackToFilterButton && (0, $5B9jk.jqlIsDifferentToDefault)(jql, defaultJql) && (0, $cxKOj.expVal)('jira-issue-navigator-saved-filters-menu', 'isEnabled', false) || (0, $5B9jk.isOnlyJqlAndDifferentToDefault)(jql, defaultJql, filterJql) || (0, $5B9jk.isOnlyFilterAndDifferentToDefault)(jql, defaultJql, filterJql) || (0, $5B9jk.filterAndJqlIsTheSameAndDifferentToDefault)(jql, defaultJql, filterJql), [
        defaultJql,
        disableBackToFilterButton,
        filterJql,
        jql
    ]);
    const renderExtraControls = (0, $eJOHy.useCallback)(()=>{
        const extraControls = [];
        const showGoBackToFilterButton = disableBackToFilterButton && (0, $cxKOj.expVal)('jira-issue-navigator-saved-filters-menu', 'isEnabled', false) ? false : (0, $5B9jk.jqlIsDifferentToFilter)(jql, filterJql);
        const addResetButton = ()=>showGoBackToFilterButton || showResetButton;
        if (addResetButton()) extraControls.push(showResetButton ? ResetButtonControl : GoBackToFilterButtonControl);
        extraControls.push(...renderFilterControls());
        return extraControls;
    }, [
        disableBackToFilterButton,
        jql,
        filterJql,
        renderFilterControls,
        showResetButton,
        ResetButtonControl,
        GoBackToFilterButtonControl
    ]);
    const { messages: jqlInfos } = (0, $4COCY.useJqlSearchStatus)({
        query: query,
        isSearching: isFetching
    });
    const jqlMessages = (0, $eJOHy.useMemo)(()=>[
            ...jqlErrors || [],
            ...jqlInfos || []
        ], [
        jqlErrors,
        jqlInfos
    ]);
    const onLoad = (0, $eJOHy.useCallback)((mode)=>{
        if (mode === (0, $56qWy.SEARCH_MODE_BASIC)) markJqlBuilderMetric((0, $fAgUF.marks).JQL_BUILDER_BASIC_START);
        else markJqlBuilderMetric((0, $fAgUF.marks).JQL_BUILDER_ADVANCED_START);
    }, [
        markJqlBuilderMetric
    ]);
    const onReady = (0, $eJOHy.useCallback)((mode)=>{
        if (mode === (0, $56qWy.SEARCH_MODE_BASIC)) {
            markJqlBuilderMetric((0, $fAgUF.marks).JQL_BUILDER_BASIC_END);
            markJqlBuilderMetric((0, $fAgUF.marks).JQL_BUILDER_END);
        } else {
            markJqlBuilderMetric((0, $fAgUF.marks).JQL_BUILDER_ADVANCED_END);
            markJqlBuilderMetric((0, $fAgUF.marks).JQL_BUILDER_END);
        }
        stopJqlBuilderMetric();
    }, [
        stopJqlBuilderMetric,
        markJqlBuilderMetric
    ]);
    const aiBuilderOverrides = (0, $eJOHy.useMemo)(()=>({
            // Only render filter controls (no reset action) for the AI embedded JQL builder
            renderExtraControls: renderFilterControls
        }), [
        renderFilterControls
    ]); /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ 
    const jqlBuilderWithAiData = (0, $j4oe4.useFragment)((0, $ikc1o.default), jqlBuilderWithAiKey); /* eslint-enable @atlassian/relay/must-colocate-fragment-spreads */ 
    const { onJourneyStart: onJourneyStart } = (0, $61oZD.useAppContextualAnalyticsActions)();
    const handlePerformanceMark = (0, $eJOHy.useCallback)(({ mark: mark })=>{
        markJqlBuilderMetric(mark);
    }, [
        markJqlBuilderMetric
    ]);
    const handleOnResetFilterRefinement = (0, $eJOHy.useCallback)(()=>(0, $4cTDP.fg)('list_lovability_improving_filters') ? onReset?.(false) : undefined, [
        onReset
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            !isFilterRefinementEnabled && $223373443ce3803e$var$wrapperStyles,
            $223373443ce3803e$var$newWrapperStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lzg2Z.ShortcutsDialogIntegrationProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5ekXO.default), {
        analyticsSource: (0, $iRahl.ANALYTICS_SOURCE),
        query: query,
        onSearch: onSearch,
        renderExtraControls: renderExtraControls,
        jqlMessages: jqlMessages,
        isSearching: isFetching,
        onReady: onReady,
        onLoad: onLoad,
        onJourneyStart: onJourneyStart,
        NoOptionComponent: (0, $3d17F.NoOptionsMessage),
        aiBuilderOverrides: aiBuilderOverrides,
        onToggleAi: onToggleAi,
        fragmentKey: jqlBuilderWithAiData ?? null,
        onPerformanceMark: handlePerformanceMark,
        ...(0, $4cTDP.fg)('jracloud_85520_hydration_ref_only_on_page_load') ? {
            maybeHydrationQueryReference: hydrationQueryReferenceRef,
            ...restJqlBuilderProps
        } : jqlBuilderProps,
        preloadedEntryPoints: {
            jqlBuilderWithAiEntryPoint: jqlBuilderProps?.preloadedEntryPoints?.jqlBuilderWithAiEntryPoint
        },
        isFilterRefinementEnabled: isFilterRefinementEnabled,
        filterRefinementQueryReference: filterRefinementQueryReference,
        onReset: showResetButton && (0, $4cTDP.fg)('list_lovability_improving_filters') ? handleOnResetFilterRefinement : undefined
    })));
};
const $223373443ce3803e$var$JQLBuilderWrapperWithErrorBoundary = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-navigator-jql-builder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "ui.jql-builder.error-boundary",
        packageName: (0, $iRahl.PACKAGE_NAME),
        teamName: (0, $iRahl.TEAM_NAME),
        sendToPrivacyUnsafeSplunk: true,
        attributes: (0, $c12HM.isLoaderErrorAttributes),
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gVAWF.JQLBuilderErrorBoundryFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($223373443ce3803e$var$JQLBuilderWrapper, props)));
var $223373443ce3803e$export$2e2bcd8739ae039 = $223373443ce3803e$var$JQLBuilderWrapperWithErrorBoundary;
const $223373443ce3803e$var$wrapperStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.negative.025',
    marginBottom: 'space.0'
});
const $223373443ce3803e$var$newWrapperStyles = (0, $1DXK0.xcss)({
    flexGrow: 'var(--jql-wrapper-grow, 0)',
    maxHeight: 'min-content'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $223373443ce3803e$var$SaveFilterWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ikc1o", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1a62e33fe147caa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<06d45c4a967a726649440032225a9335>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a1a62e33fe147caa$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_jqlBuilderWithAiKey",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "JQLBuilderWithAI"
        }
    ],
    "type": "JiraQuery"
};
$a1a62e33fe147caa$var$node.hash = "80c3394e44d3807fba8367e369569f00";
var $a1a62e33fe147caa$export$2e2bcd8739ae039 = $a1a62e33fe147caa$var$node;

});

parcelRegister("kqHfo", function(module, exports) {
$parcel$export(module.exports, "default", () => $edbe7116fa70a8a9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a76e30faae7fd3f790cc395215820217>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $edbe7116fa70a8a9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_filter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ],
    "type": "JiraCustomFilter"
};
$edbe7116fa70a8a9$var$node.hash = "46b543f50c73d7423957a8ecbe71b627";
var $edbe7116fa70a8a9$export$2e2bcd8739ae039 = $edbe7116fa70a8a9$var$node;

});

parcelRegister("4sjRg", function(module, exports) {
$parcel$export(module.exports, "default", () => $819bbd8840564a42$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a3182e66785e68d12090ebb9bf08695e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $819bbd8840564a42$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_issueResults",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "issueSearchError",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "messages"
                        }
                    ],
                    "type": "JiraInvalidJqlError"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "errorType"
                        }
                    ],
                    "type": "JiraInvalidSyntaxError"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$819bbd8840564a42$var$node.hash = "eeb59c3a307dc75263f7e39b4f314c7c";
var $819bbd8840564a42$export$2e2bcd8739ae039 = $819bbd8840564a42$var$node;

});

parcelRegister("dqj1A", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f515861bd935bc8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2da135e56e9e45c2e5f481821656e304>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9f515861bd935bc8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_groupResults",
    "selections": [
        {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$9f515861bd935bc8$var$node.hash = "30cd518272beee6c712a219e1b78cd63";
var $9f515861bd935bc8$export$2e2bcd8739ae039 = $9f515861bd935bc8$var$node;

});

parcelRegister("5i1j5", function(module, exports) {
$parcel$export(module.exports, "SaveFilterDropdown", () => $e2d596642d928dfd$export$4aae2fedc7924eed);

var $56Gwn = parcelRequire("56Gwn");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $1OQKp = parcelRequire("1OQKp");

var $goZPP = parcelRequire("goZPP");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $jn1Cb = parcelRequire("jn1Cb");
var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $lBPsC = parcelRequire("lBPsC");

var $j1qd7 = parcelRequire("j1qd7");

var $8oKDI = parcelRequire("8oKDI");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $KwCgo = parcelRequire("KwCgo");

var $koAZ4 = parcelRequire("koAZ4");

var $dF958 = parcelRequire("dF958");

var $4cTDP = parcelRequire("4cTDP");

var $d1S9l = parcelRequire("d1S9l");

var $3t225 = parcelRequire("3t225");
const $e2d596642d928dfd$export$a3ca021e3e6c7315 = (0, $jn1Cb.toFlagId)('issue-navigator-save-filter-success-flag');
const $e2d596642d928dfd$export$f5e4c120ac01b615 = (0, $jn1Cb.toFlagId)('issue-navigator-save-filter-error-flag');
const $e2d596642d928dfd$export$4aae2fedc7924eed = ({ defaultOpen: defaultOpen = false, filterId: filterId, query: query, onFilterSave: onFilterSave })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagService)(); // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [updateJiraCustomFilterJqlMutation] = (0, $j4oe4.useMutation)((0, $56Gwn.default));
    const { activationId: activationId, cloudId: cloudId } = (0, $koAZ4.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({});
    const onSaveChanges = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'saveFilterChanges');
        filterId !== undefined && updateJiraCustomFilterJqlMutation({
            variables: {
                id: (0, $8oKDI.createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'filter',
                    resourceId: filterId,
                    activationId: activationId
                }),
                jql: query
            },
            onCompleted: ({ jira: jira })=>{
                if (jira?.jiraFilterMutation?.updateJiraCustomFilterJql) {
                    const { success: success, filter: filter, errors: jiraErrors } = jira?.jiraFilterMutation?.updateJiraCustomFilterJql;
                    if (success && filter) {
                        const { name: name } = filter;
                        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({
                            actionSubject: 'issueFilterJql',
                            action: 'updated'
                        }), 'issueFilterJql updated');
                        showFlag({
                            id: $e2d596642d928dfd$export$a3ca021e3e6c7315,
                            render: (renderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j1qd7.SuccessFlag), {
                                    id: $e2d596642d928dfd$export$a3ca021e3e6c7315,
                                    messageId: "issue-navigator-custom-filters.ui.save-filter-dropdown.success-flag",
                                    messageType: "transactional",
                                    filterName: name,
                                    viewUrl: `${window.location.origin}/issues/?filter=${filterId}`,
                                    analyticsEvent: createAnalyticsEvent({
                                        actionSubject: 'button',
                                        action: 'clicked'
                                    }),
                                    ...renderProps
                                })
                        });
                    } else {
                        const errors = jiraErrors ? jiraErrors.map((error)=>error.message || '') : [];
                        showFlag({
                            id: $e2d596642d928dfd$export$f5e4c120ac01b615,
                            render: (renderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lBPsC.ErrorFlag), {
                                    id: $e2d596642d928dfd$export$f5e4c120ac01b615,
                                    messageId: "issue-navigator-custom-filters.ui.save-filter-dropdown.error-flag",
                                    messageType: "transactional",
                                    errors: errors,
                                    ...renderProps
                                })
                        });
                        (0, $9pTd3.fireErrorAnalytics)({
                            event: analyticsEvent,
                            error: new Error(errors[0]),
                            meta: {
                                id: 'updateFilterJqlMutation',
                                packageName: 'jiraIssueNavigatorCustomFilters',
                                teamName: 'empanada'
                            }
                        });
                    }
                }
            },
            onError: (error)=>{
                showFlag({
                    id: $e2d596642d928dfd$export$f5e4c120ac01b615,
                    render: (renderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lBPsC.ErrorFlag), {
                            id: $e2d596642d928dfd$export$f5e4c120ac01b615,
                            messageId: "issue-navigator-custom-filters.ui.save-filter-dropdown.error-flag.1",
                            messageType: "transactional",
                            ...renderProps,
                            errors: [
                                ''
                            ]
                        })
                });
                (0, $9pTd3.fireErrorAnalytics)({
                    event: analyticsEvent,
                    error: error,
                    meta: {
                        id: 'updateFilterJqlMutation',
                        packageName: 'jiraIssueNavigatorCustomFilters',
                        teamName: 'empanada'
                    }
                });
                return undefined;
            }
        });
    }, [
        activationId,
        cloudId,
        createAnalyticsEvent,
        filterId,
        query,
        showFlag,
        updateJiraCustomFilterJqlMutation,
        analyticsEvent
    ]);
    const [isDropdownOpen, setIsDropdownOpen] = (0, $eJOHy.useState)(defaultOpen);
    const [shouldShowThirdPartyNudge, setShouldShowThirdPartyNudge] = (0, $eJOHy.useState)(false);
    const onOpenSaveFilterModal = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'saveFilterCopy');
    }, [
        createAnalyticsEvent
    ]);
    const modalProps = {
        width: 'medium',
        shouldScrollInViewport: true,
        shouldReturnFocus: false
    };
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            jql: query,
            filterId: filterId,
            onFilterSave: onFilterSave,
            title: formatMessage((0, $3t225.default).copyFilterDialogTitle)
        }), [
        query,
        filterId,
        onFilterSave,
        formatMessage
    ]);
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            filterAri: filterId !== null && filterId !== undefined ? (0, $8oKDI.createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'filter',
                resourceId: filterId,
                activationId: activationId
            }) : undefined
        }), [
        filterId,
        cloudId,
        activationId
    ]);
    const onTriggerClick = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'dropdownMenu'
        }), 'filterOptions');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, shouldShowThirdPartyNudge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dF958.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e2d596642d928dfd$var$DropdownMenuWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        isOpen: isDropdownOpen,
        onOpenChange: (attrs)=>{
            setIsDropdownOpen(attrs.isOpen);
            if (attrs.isOpen) {
                setShouldShowThirdPartyNudge(true);
                onTriggerClick();
            }
        },
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...props,
                appearance: "link",
                ref: triggerRef,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
                    label: formatMessage((0, $3t225.default).saveFilter),
                    size: "small"
                })
            }, formatMessage((0, $3t225.default).saveFilter)),
        shouldRenderToParent: (0, $4cTDP.fg)('should-render-to-parent-should-be-true-empanada')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        onClick: onSaveChanges
    }, formatMessage((0, $3t225.default).saveChanges)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d1S9l.ModalEntryPointDropdownItemTrigger), {
        onClick: onOpenSaveFilterModal,
        modalProps: modalProps,
        entryPoint: (0, $KwCgo.saveFilterDialogEntryPoint),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        interactionName: "jiraSaveFilterDialog.SaveFilter",
        useInternalModal: true
    }, formatMessage((0, $3t225.default).saveAsACopy))))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e2d596642d928dfd$var$DropdownMenuWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_k4hekqvv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("56Gwn", function(module, exports) {
$parcel$export(module.exports, "default", () => $fdbf2fd39860c579$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bfa68958cffd28f839eb1cc1261ee729>>
 * @relayHash a8b99d4e5148c557424db90f1be8215c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 33abce877d8ddf36bd3fdb295b2e91c467ceff0b718872d73a32845f7130d8d5
const $fdbf2fd39860c579$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraFilterMutation",
                    "kind": "LinkedField",
                    "name": "jiraFilterMutation",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "fields": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "id"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "jql",
                                            "variableName": "jql"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "input"
                                }
                            ],
                            "concreteType": "JiraUpdateCustomFilterJqlPayload",
                            "kind": "LinkedField",
                            "name": "updateJiraCustomFilterJql",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "success"
                                },
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraCustomFilter",
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainUpdateFilterJqlMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainUpdateFilterJqlMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "33abce877d8ddf36bd3fdb295b2e91c467ceff0b718872d73a32845f7130d8d5",
            "metadata": {},
            "name": "mainUpdateFilterJqlMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$fdbf2fd39860c579$var$node.hash = "6807efed6a00f60f9cf95df455e467fd";
var $fdbf2fd39860c579$export$2e2bcd8739ae039 = $fdbf2fd39860c579$var$node;

});

parcelRegister("lBPsC", function(module, exports) {
$parcel$export(module.exports, "ErrorFlag", () => $53224918a80e87c9$export$518ba8e0e60f145f);

var $eJOHy = parcelRequire("eJOHy");

var $jn1Cb = parcelRequire("jn1Cb");
var $cSXp8 = parcelRequire("cSXp8");

var $2ePj6 = parcelRequire("2ePj6");

var $lRq8t = parcelRequire("lRq8t");

var $cU9K7 = parcelRequire("cU9K7");
const $53224918a80e87c9$export$518ba8e0e60f145f = ({ id: id, errors: errors, messageId: messageId = 'issue-navigator-actions-common.ui.error-flag.jira-error-flag', messageType: messageType = 'transactional' })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { dismissFlag: dismissFlag } = (0, $cSXp8.useFlagsService)();
    const onDismissed = (0, $eJOHy.useCallback)(()=>dismissFlag(id), [
        dismissFlag,
        id
    ]);
    const description = (0, $eJOHy.useMemo)(()=>errors.reduce((desc, error)=>`${desc}\n${error}`), [
        errors
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ePj6.default), {
        id: (0, $jn1Cb.fromFlagId)(id),
        onDismissed: onDismissed,
        title: formatMessage((0, $cU9K7.default).flagTitle),
        description: description,
        messageId: messageId,
        messageType: messageType
    });
};

});
parcelRegister("cU9K7", function(module, exports) {
$parcel$export(module.exports, "default", () => $21837d8f097bb3d5$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $21837d8f097bb3d5$var$messages = (0, $7qGN1.defineMessages)({
    flagTitle: {
        "id": "issue-navigator-actions-common.error-flag.flag-title",
        "defaultMessage": "Filter couldn't be saved"
    }
});
var $21837d8f097bb3d5$export$2e2bcd8739ae039 = $21837d8f097bb3d5$var$messages;

});


parcelRegister("j1qd7", function(module, exports) {
$parcel$export(module.exports, "SuccessFlag", () => $228f3473b1cf795e$export$93bd4963a1d00fd5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $9pTd3 = parcelRequire("9pTd3");

var $jn1Cb = parcelRequire("jn1Cb");
var $cSXp8 = parcelRequire("cSXp8");

var $kFis2 = parcelRequire("kFis2");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $kHc9M = parcelRequire("kHc9M");
const $228f3473b1cf795e$export$93bd4963a1d00fd5 = ({ id: id, filterName: filterName, viewUrl: viewUrl, analyticsEvent: analyticsEvent, messageId: messageId = 'issue-navigator-actions-common.ui.success-flag.jira-success-flag', messageType: messageType = 'transactional' })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { dismissFlag: dismissFlag } = (0, $cSXp8.useFlagsService)();
    const [isCopied, setCopied] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        let timeoutId;
        if (isCopied) timeoutId = setTimeout(()=>{
            setCopied(false);
        }, 2000);
        return ()=>{
            timeoutId && clearTimeout(timeoutId);
        };
    }, [
        isCopied
    ]);
    const copyToClipboard = (0, $eJOHy.useCallback)(()=>{
        try {
            globalThis.navigator.clipboard.writeText(viewUrl);
            setCopied(true);
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'copyLink'); // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'copyToClipboard',
                    packageName: 'jiraIssueNavigatorActionsCommon'
                }
            });
        }
    }, [
        analyticsEvent,
        viewUrl
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>{
        const flagActions = [];
        flagActions.push({
            content: isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($228f3473b1cf795e$var$CopySuccess, null, formatMessage((0, $kHc9M.default).copyActionCopied)) : formatMessage((0, $kHc9M.default).copyAction),
            onClick: copyToClipboard
        });
        return flagActions;
    }, [
        copyToClipboard,
        formatMessage,
        isCopied
    ]);
    const onDismissed = (0, $eJOHy.useCallback)(()=>dismissFlag(id), [
        dismissFlag,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kFis2.default), {
        id: (0, $jn1Cb.fromFlagId)(id),
        onDismissed: onDismissed,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($228f3473b1cf795e$var$WordBreakSpan, null, formatMessage((0, $kHc9M.default).flagTitle, {
            name: filterName
        })),
        description: formatMessage((0, $kHc9M.default).flagDescription),
        messageId: messageId,
        messageType: messageType,
        actions: actions
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $228f3473b1cf795e$var$CopySuccess = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syazgsak",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $228f3473b1cf795e$var$WordBreakSpan = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1nmz1hna",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $228f3473b1cf795e$export$7ed12d2a5241e393 = {
    WordBreakSpan: $228f3473b1cf795e$var$WordBreakSpan
};

});
parcelRegister("kHc9M", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a2e40dfe6da8157$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $7a2e40dfe6da8157$var$messages = (0, $7qGN1.defineMessages)({
    flagTitle: {
        "id": "issue-navigator-actions-common.success-flag.flag-title",
        "defaultMessage": "\"{name}\" filter saved"
    },
    flagDescription: {
        "id": "issue-navigator-actions-common.success-flag.flag-description",
        "defaultMessage": "We\u2019ve saved this filter successfully."
    },
    viewAction: {
        "id": "issue-navigator-actions-common.success-flag.view-action",
        "defaultMessage": "View filter"
    },
    copyAction: {
        "id": "issue-navigator-actions-common.success-flag.copy-action",
        "defaultMessage": "Copy link"
    },
    copyActionCopied: {
        "id": "issue-navigator-actions-common.success-flag.copy-action-copied",
        "defaultMessage": "Copied"
    }
});
var $7a2e40dfe6da8157$export$2e2bcd8739ae039 = $7a2e40dfe6da8157$var$messages;

});


parcelRegister("dF958", function(module, exports) {
$parcel$export(module.exports, "default", () => $c20eb83de0c2fc58$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $kg1bv = parcelRequire("kg1bv");
const $c20eb83de0c2fc58$var$runtimeProps = {};
const $c20eb83de0c2fc58$var$entryPointParams = {};
const $c20eb83de0c2fc58$var$AsyncThirdPartyNudge = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $kg1bv.thirdPartyNudgeEntryPoint), $c20eb83de0c2fc58$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "third-party-nudge-spotlight",
        packageName: "third-party-nudge",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $c20eb83de0c2fc58$var$runtimeProps,
        errorFallback: "unmount"
    });
};
var $c20eb83de0c2fc58$export$2e2bcd8739ae039 = $c20eb83de0c2fc58$var$AsyncThirdPartyNudge;

});
parcelRegister("kg1bv", function(module, exports) {
$parcel$export(module.exports, "thirdPartyNudgeEntryPoint", () => $7b3398d7aaaf0cc0$export$b751b31b276f613a);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $7b3398d7aaaf0cc0$export$b751b31b276f613a = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("dp2bH")), {
        moduleId: "3cb7fd8f",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dp2bH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5WL6j").then(()=>parcelRequire('3U1SG'));

});



parcelRegister("3t225", function(module, exports) {
$parcel$export(module.exports, "default", () => $32150c77d65fbd54$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $32150c77d65fbd54$var$messages = (0, $7qGN1.defineMessages)({
    saveFilter: {
        "id": "issue-navigator-custom-filters.save-filter-dropdown.save-filter",
        "defaultMessage": "Save filter"
    },
    saveChanges: {
        "id": "issue-navigator-custom-filters.save-filter-dropdown.save-changes",
        "defaultMessage": "Save changes"
    },
    saveAsACopy: {
        "id": "issue-navigator-custom-filters.save-filter-dropdown.save-as-a-copy",
        "defaultMessage": "Save as a copy"
    },
    copyFilterDialogTitle: {
        "id": "issue-navigator-custom-filters.save-filter-dropdown.copy-filter-dialog-title",
        "defaultMessage": "Copy filter"
    }
});
var $32150c77d65fbd54$export$2e2bcd8739ae039 = $32150c77d65fbd54$var$messages;

});


parcelRegister("lzg2Z", function(module, exports) {
$parcel$export(module.exports, "useIntegrateDotDialogContext", () => $cc4956edece29853$export$705d46354f301b1c);
$parcel$export(module.exports, "ShortcutsDialogIntegrationProvider", () => $cc4956edece29853$export$97e3ca22c7078b46);

var $eJOHy = parcelRequire("eJOHy");
const $cc4956edece29853$var$PRESET_VALUE = {
    DEFAULT: {
        isShortcutsDialogIntegrationAvailable: false
    },
    INTEGRATED: {
        isShortcutsDialogIntegrationAvailable: true
    }
};
const $cc4956edece29853$var$IntegrateDotDialogContext = /*#__PURE__*/ (0, $eJOHy.createContext)($cc4956edece29853$var$PRESET_VALUE.DEFAULT);
const $cc4956edece29853$export$705d46354f301b1c = ()=>(0, $eJOHy.useContext)($cc4956edece29853$var$IntegrateDotDialogContext);
const $cc4956edece29853$export$97e3ca22c7078b46 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cc4956edece29853$var$IntegrateDotDialogContext.Provider, {
        value: $cc4956edece29853$var$PRESET_VALUE.INTEGRATED
    }, children);

});

parcelRegister("gVAWF", function(module, exports) {
$parcel$export(module.exports, "JQLBuilderErrorBoundryFallback", () => $753680c12bef645e$export$4c766016a5659721);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $iHPvF = parcelRequire("iHPvF");

var $lRq8t = parcelRequire("lRq8t");

var $hN3Oc = parcelRequire("hN3Oc");
const $753680c12bef645e$var$onRefresh = ()=>{
    if (typeof window !== 'undefined') window.location.reload();
};
const $753680c12bef645e$export$4c766016a5659721 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        appearance: "error",
        testId: "jql-builder-common.ui.error-boundry-fallback.section-message"
    }, formatMessage((0, $hN3Oc.default).errorMessage, {
        link: (linkText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                appearance: "link",
                spacing: "none",
                onClick: $753680c12bef645e$var$onRefresh
            }, linkText)
    }));
};

});
parcelRegister("iHPvF", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c4a865afee94050$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $Ay1uj = parcelRequire("Ay1uj");

var $806LH = parcelRequire("806LH");

var $6J9k6 = parcelRequire("6J9k6");

var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");

var $9y5qW = parcelRequire("9y5qW");
const $1c4a865afee94050$var$sectionMessageStyles = {
    container: "_2rko12b0 _1rjcpxbi _18zrpxbi _1nmz1hna",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c82smr _syazi7uo",
    actionsContainer: "_11c82smr",
    dismissButtonContainer: "_1pfh1i6y"
};
const $1c4a865afee94050$var$appearanceStyles = {
    information: "_bfhk19ip",
    warning: "_bfhk1917",
    error: "_bfhk1gly",
    success: "_bfhk1y9u",
    discovery: "_bfhk6vm6"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $1c4a865afee94050$var$SectionMessage = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, isDismissible: isDismissible, onDismiss: onDismiss, testId: testId }, ref) {
    const [dismissed, setDismissed] = (0, $eJOHy.useState)(false);
    const handleDismiss = (0, $eJOHy.useCallback)(()=>{
        onDismiss?.();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $9y5qW.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, $eJOHy.Fragment) ? actions.props.children : actions;
    const actionsArray = (0, $eJOHy.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ (0, $gt9Am.jsx)("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $hcewu.default)([
            $1c4a865afee94050$var$sectionMessageStyles.container,
            $1c4a865afee94050$var$appearanceStyles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $1c4a865afee94050$var$sectionMessageStyles.iconContainer
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        LEGACY_size: "medium",
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    xcss: $1c4a865afee94050$var$sectionMessageStyles.contentContainer,
                    children: [
                        !!title && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $1c4a865afee94050$var$sectionMessageStyles.content
                            ]),
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: $1c4a865afee94050$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                }),
                isDismissible && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $1c4a865afee94050$var$sectionMessageStyles.dismissButtonContainer
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                        testId: testId && `${testId}--dismiss-button`,
                        label: "Dismiss",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))),
                        appearance: "subtle",
                        onClick: handleDismiss,
                        spacing: "compact"
                    })
                })
            ]
        })
    });
});
$1c4a865afee94050$var$SectionMessage.displayName = 'SectionMessage';
var $1c4a865afee94050$export$2e2bcd8739ae039 = $1c4a865afee94050$var$SectionMessage;

});
parcelRegister("9y5qW", function(module, exports) {
$parcel$export(module.exports, "getAppearanceIconStyles", () => $1656794cf4e78acc$export$e9b82d2e21ac0c1f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $ejT8C = parcelRequire("ejT8C");

var $1NG86 = parcelRequire("1NG86");

var $i4Iw4 = parcelRequire("i4Iw4");

var $3TFuO = parcelRequire("3TFuO");

var $jkYbX = parcelRequire("jkYbX");

const $1656794cf4e78acc$var$appearanceIconSchema = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $7bb4c1736002a04a$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($i4Iw4))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $7bb4c1736002a04a$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $7bb4c1736002a04a$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $7bb4c1736002a04a$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $7bb4c1736002a04a$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1NG86))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $7bb4c1736002a04a$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3TFuO))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $7bb4c1736002a04a$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $7bb4c1736002a04a$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ejT8C))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $7bb4c1736002a04a$export$147899de772240ec)})`
    }
};
function $1656794cf4e78acc$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $1656794cf4e78acc$var$appearanceIconSchema[appearance] || $1656794cf4e78acc$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, $gt9Am.jsx)(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
parcelRegister("ejT8C", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5501f2ec2c7fc2907a8ddc6771935d76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6cd9c4605f2f731$var$_react = $a6cd9c4605f2f731$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a6cd9c4605f2f731$var$_discovery = $a6cd9c4605f2f731$var$_interopRequireDefault((parcelRequire("h4COp")));

var $a6cd9c4605f2f731$var$_note = $a6cd9c4605f2f731$var$_interopRequireDefault((parcelRequire("94404")));
function $a6cd9c4605f2f731$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DiscoveryIcon.
 * This component is DiscoveryIcon, with `UNSAFE_fallbackIcon` set to "EditorNoteIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6cd9c4605f2f731$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $a6cd9c4605f2f731$var$_react.default.createElement($a6cd9c4605f2f731$var$_discovery.default, Object.assign({
        name: "DiscoveryIcon",
        LEGACY_fallbackIcon: $a6cd9c4605f2f731$var$_note.default
    }, props));
$a6cd9c4605f2f731$var$DiscoveryIcon.displayName = 'DiscoveryIconMigration';
var $a6cd9c4605f2f731$var$_default = module.exports.default = $a6cd9c4605f2f731$var$DiscoveryIcon;

});
parcelRegister("h4COp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84ac540d37aa7b8e7ab349dbbb474c30>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6e0eaad244db33f$var$_react = $c6e0eaad244db33f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c6e0eaad244db33f$var$_baseNew = $c6e0eaad244db33f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c6e0eaad244db33f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Discovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6e0eaad244db33f$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $c6e0eaad244db33f$var$_react.default.createElement($c6e0eaad244db33f$var$_baseNew.default, Object.assign({
        name: "DiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h6v-4.75C9 9.56 9.56 9 10.25 9H15V3a2 2 0 0 0-2-2M4 5.5h7V4H4zM4 9h3V7.5H4z" clip-rule="evenodd"/><path fill="currentcolor" d="M11.25 10.5a.75.75 0 0 0-.75.75v3.81l4.56-4.56z"/>`
    }, props));
$c6e0eaad244db33f$var$DiscoveryIcon.displayName = 'DiscoveryIcon';
var $c6e0eaad244db33f$var$_default = module.exports.default = $c6e0eaad244db33f$var$DiscoveryIcon;

});

parcelRegister("94404", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6997971b5d08dbe2$var$_react = $6997971b5d08dbe2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $6997971b5d08dbe2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6997971b5d08dbe2$var$EditorNoteIcon = (props)=>/*#__PURE__*/ $6997971b5d08dbe2$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 4h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m1.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm0 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props));
$6997971b5d08dbe2$var$EditorNoteIcon.displayName = 'EditorNoteIcon';
var $6997971b5d08dbe2$var$_default = module.exports.default = $6997971b5d08dbe2$var$EditorNoteIcon;

});




parcelRegister("hN3Oc", function(module, exports) {
$parcel$export(module.exports, "default", () => $26ab64dd92055a31$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $26ab64dd92055a31$var$messages = (0, $7qGN1.defineMessages)({
    errorMessage: {
        "id": "jql-builder-common.error-boundry-fallback.error-message",
        "defaultMessage": "We couldn't load your search criteria. <link>Refresh the page</link> to try again."
    }
});
var $26ab64dd92055a31$export$2e2bcd8739ae039 = $26ab64dd92055a31$var$messages;

});


parcelRegister("5ekXO", function(module, exports) {
$parcel$export(module.exports, "default", () => $89cd9a6ccae01711$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4EKqI = parcelRequire("4EKqI");

var $2imLM = parcelRequire("2imLM");

var $aF4Or = parcelRequire("aF4Or");

var $bQWwW = parcelRequire("bQWwW");

var $2dBpR = parcelRequire("2dBpR");

var $5vQ2T = parcelRequire("5vQ2T");

var $bJscI = parcelRequire("bJscI");

const $89cd9a6ccae01711$var$JQLBuilderWithAIAsync = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("fHcRZ")), {
    moduleId: "./src/packages/jql-builder/with-ai/src/ui/JQLBuilderWithAI.tsx"
});
const $89cd9a6ccae01711$var$JQLBuilderWithAIWithRLL = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-jql-builder-with-ai",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aF4Or.IssueNavigatorJQLBuilderSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($89cd9a6ccae01711$var$JQLBuilderWithAIAsync, props));
const $89cd9a6ccae01711$var$JQLBuilderWithAIWithEntrypoint = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
    const entryPointReference = props.preloadedEntryPoints?.jqlBuilderWithAiEntryPoint;
    if (entryPointReference) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "jql-builder-with-ai-entrypoint"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "jql-builder-with-ai-entrypoint",
        packageName: "jiraJQLBuilderWithAI"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dBpR.EntryPointReferencePlaceholder), {
        name: "jql-builder-with-ai",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aF4Or.IssueNavigatorJQLBuilderSkeleton), null),
        entryPointReference: entryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: props
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($89cd9a6ccae01711$var$JQLBuilderWithAIWithRLL, props);
});
const $89cd9a6ccae01711$var$JQLBuilderWithAI = (0, $bJscI.componentWithFG)('jql_builder_basic_ssr_stability_fixes', $89cd9a6ccae01711$var$JQLBuilderWithAIWithEntrypoint, $89cd9a6ccae01711$var$JQLBuilderWithAIWithRLL);
var $89cd9a6ccae01711$export$2e2bcd8739ae039 = $89cd9a6ccae01711$var$JQLBuilderWithAI;

});
parcelRegister("aF4Or", function(module, exports) {
$parcel$export(module.exports, "IssueNavigatorJQLBuilderSkeleton", () => $8cf3c2e2df07d003$export$5be82223ddc28851);
/* jql-builder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $2uUhz = parcelRequire("2uUhz");
const $8cf3c2e2df07d003$var$customCssStyles = null;
const $8cf3c2e2df07d003$var$containerStyles = {
    height: '52px'
};
const $8cf3c2e2df07d003$export$5be82223ddc28851 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2uUhz))),
        containerStyles: $8cf3c2e2df07d003$var$containerStyles,
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("2uUhz", function(module, exports) {
module.exports = new URL("issue-navigator-jql-builder-skeleton.tpl.20beba3c.svg", import.meta.url).toString();

});


parcelRegister("fHcRZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iuOzF").then(()=>parcelRequire('3rNQG'));

});


parcelRegister("56qWy", function(module, exports) {
$parcel$export(module.exports, "SEARCH_MODE_BASIC", () => $8645a6ff5f3a8efb$export$f963d14b266e4d2e);
$parcel$export(module.exports, "SEARCH_MODE_ADVANCED", () => $8645a6ff5f3a8efb$export$aad1d9eb9b751555);
$parcel$export(module.exports, "SERVER_SEARCH_MODE_BASIC", () => $8645a6ff5f3a8efb$export$87c41a6b3123c00f);
$parcel$export(module.exports, "SERVER_SEARCH_MODE_ADVANCED", () => $8645a6ff5f3a8efb$export$a7a000706ebc3ba8);
$parcel$export(module.exports, "DEFAULT_SEARCH_MODE", () => $8645a6ff5f3a8efb$export$e1eb2ddab803c5ec);
$parcel$export(module.exports, "mapSearchModeToAnalyticAtribute", () => $8645a6ff5f3a8efb$export$70c8f980e4a50682);
$parcel$export(module.exports, "SEARCH_MODE_SWITCHER_LEFT_LOCATION", () => $8645a6ff5f3a8efb$export$4dab29e715a4e6fb);
$parcel$export(module.exports, "SEARCH_MODE_SWITCHER_RIGHT_LOCATION", () => $8645a6ff5f3a8efb$export$59848395da0b4bcb);
$parcel$export(module.exports, "PACKAGE_NAME", () => $8645a6ff5f3a8efb$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $8645a6ff5f3a8efb$export$d57b6b390e78d90f);
const $8645a6ff5f3a8efb$export$f963d14b266e4d2e = 'basic';
const $8645a6ff5f3a8efb$export$aad1d9eb9b751555 = 'advanced';
const $8645a6ff5f3a8efb$export$87c41a6b3123c00f = 'BASIC';
const $8645a6ff5f3a8efb$export$a7a000706ebc3ba8 = 'ADVANCED';
const $8645a6ff5f3a8efb$export$e1eb2ddab803c5ec = $8645a6ff5f3a8efb$export$f963d14b266e4d2e;
const $8645a6ff5f3a8efb$export$70c8f980e4a50682 = {
    [$8645a6ff5f3a8efb$export$f963d14b266e4d2e]: $8645a6ff5f3a8efb$export$f963d14b266e4d2e,
    [$8645a6ff5f3a8efb$export$aad1d9eb9b751555]: 'JQL'
};
const $8645a6ff5f3a8efb$export$4dab29e715a4e6fb = 'Left';
const $8645a6ff5f3a8efb$export$59848395da0b4bcb = 'Right';
const $8645a6ff5f3a8efb$export$b8b9d90f9e5bd72b = 'jiraJqlBuilder';
const $8645a6ff5f3a8efb$export$d57b6b390e78d90f = 'empanada';

});

parcelRegister("J0ugN", function(module, exports) {
$parcel$export(module.exports, "SaveFilterDialog", () => $0c5b99e69ba2acd0$export$935f6430ba933614);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $dxcgx = parcelRequire("dxcgx");

var $8oKDI = parcelRequire("8oKDI");

var $kRgKj = parcelRequire("kRgKj");

var $f2sjT = parcelRequire("f2sjT");

var $cHtIB = parcelRequire("cHtIB");

var $KwCgo = parcelRequire("KwCgo");
const $0c5b99e69ba2acd0$export$935f6430ba933614 = ({ buttonText: buttonText, filterId: filterId, ...props })=>{
    const modalProps = (0, $eJOHy.useMemo)(()=>({
            width: 'medium',
            shouldScrollInViewport: true
        }), []);
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            filterId: filterId,
            ...props
        }), [
        filterId,
        props
    ]);
    const cloudId = (0, $cHtIB.useCloudId)();
    const activationId = (0, $f2sjT.useActivationId)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            filterAri: filterId !== null && filterId !== undefined ? (0, $8oKDI.createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'filter',
                resourceId: filterId,
                activationId: activationId
            }) : undefined
        }), [
        filterId,
        cloudId,
        activationId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxcgx.ModalEntryPointPressableTrigger), {
        modalProps: modalProps,
        entryPoint: (0, $KwCgo.saveFilterDialogEntryPoint),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        interactionName: "jiraSaveFilterDialog.SaveFilter",
        useInternalModal: true
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            onClick: (_, analyticsEvent)=>(0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'saveFilterDialog'),
            appearance: "link",
            testId: "save-filter-dialog.ui.save-filter-dialog.button",
            ref: ref
        }, buttonText));
};
var $0c5b99e69ba2acd0$export$2e2bcd8739ae039 = $0c5b99e69ba2acd0$export$935f6430ba933614;

});

parcelRegister("4COCY", function(module, exports) {
$parcel$export(module.exports, "useJqlSearchStatus", () => $2636782f3a6d3c9c$export$6d36bd77a6aeafd9);

var $i4yCJ = parcelRequire("i4yCJ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $lHVmb = parcelRequire("lHVmb");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $cHtIB = parcelRequire("cHtIB");

var $cdF1X = parcelRequire("cdF1X");
const $2636782f3a6d3c9c$export$529d2e9d8e9d3cad = 2000; // wait 2s before making the request
const $2636782f3a6d3c9c$export$bbec15ef0a4926b6 = 7000; // wait 7s before retrying after the previous request
const $2636782f3a6d3c9c$export$cf31b3fd6a57249f = 5; // Check the status no more than 5 times for the same JQL search
const $2636782f3a6d3c9c$var$statusToMessages = (status, formatMessage)=>{
    if (status == null || !('functions' in status) || !Array.isArray(status?.functions)) return [];
    const processing = status.functions.filter((fn)=>fn.app && fn.function && fn.status === 'PROCESSING');
    const functions = Array.from(new Set(processing.map((fn)=>fn.function)));
    const apps = Array.from(new Set(processing.map((fn)=>fn.app)));
    switch(functions.length){
        case 0:
            return [];
        case 1:
            {
                const message = formatMessage((0, $cdF1X.default).singleSlowForgeFunction, {
                    functionName: functions[0],
                    appName: apps[0]
                });
                return [
                    {
                        type: 'info',
                        message: message
                    }
                ];
            }
        default:
            {
                let message;
                switch(apps.length){
                    case 1:
                        message = formatMessage((0, $cdF1X.default).multipleSlowForgeFunctionsFromTheSameApp, {
                            appName: apps[0]
                        });
                        break;
                    case 2:
                        message = formatMessage((0, $cdF1X.default).multipleSlowForgeFunctionsTwoApps, {
                            appName1: apps[0],
                            appName2: apps[1]
                        });
                        break;
                    default:
                        message = formatMessage((0, $cdF1X.default).multipleSlowForgeFunctionsThreeApps, {
                            appName1: apps[0],
                            appName2: apps[1],
                            appName3: apps[2]
                        });
                }
                return [
                    {
                        type: 'info',
                        message: message
                    }
                ];
            }
    }
};
const $2636782f3a6d3c9c$var$analyticsMeta = {
    id: 'jqlSearchStatus',
    packageName: 'jiraIssueNavigator',
    teamName: 'empanada'
};
const $2636782f3a6d3c9c$var$EMPTY_EXTERNAL_INFO = [];
const $2636782f3a6d3c9c$export$6d36bd77a6aeafd9 = ({ query: query, isSearching: isSearching })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [statusMessages, setStatusMessages] = (0, $eJOHy.useState)($2636782f3a6d3c9c$var$EMPTY_EXTERNAL_INFO);
    const isSearchingRef = (0, $eJOHy.useRef)(isSearching);
    const timeoutRef = (0, $eJOHy.useRef)(null);
    const fetchCountRef = (0, $eJOHy.useRef)(0);
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireOperationalEvent = (0, $eJOHy.useCallback)((action, attributes)=>(0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), `${$2636782f3a6d3c9c$var$analyticsMeta.packageName}.${$2636782f3a6d3c9c$var$analyticsMeta.id} ${action}`, attributes), [
        createAnalyticsEvent
    ]);
    const cancelPendingOperations = (0, $eJOHy.useCallback)(()=>{
        timeoutRef.current && clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
        fetchCountRef.current = 0;
    }, []);
    const scheduleSearchStatusFetch = (0, $eJOHy.useCallback)((delay)=>{
        const isRetry = delay === $2636782f3a6d3c9c$export$bbec15ef0a4926b6;
        const defaultAnalyticsAttributes = (0, $lHVmb.createAttributes)({
            isRetry: isRetry
        });
        const timeout = setTimeout(()=>{
            if (fetchCountRef.current >= $2636782f3a6d3c9c$export$cf31b3fd6a57249f) {
                fireOperationalEvent('interrupted', {
                    ...defaultAnalyticsAttributes,
                    reason: 'MAX_ATTEMPTS_REACHED'
                });
                return;
            }
            fireOperationalEvent('attempt', defaultAnalyticsAttributes);
            fetchCountRef.current += 1;
            (0, $j4oe4.fetchQuery)(environment, (0, $i4yCJ.default), {
                cloudId: cloudId,
                jql: query
            }, {
                fetchPolicy: 'network-only'
            }).toPromise().then((data)=>{
                let hasPendingFn = false;
                const status = data?.jira?.issueSearchStatus ?? null;
                if (isSearchingRef.current && timeoutRef.current === timeout) {
                    const infos = $2636782f3a6d3c9c$var$statusToMessages(status, formatMessage);
                    setStatusMessages(infos);
                    if (infos.length) {
                        hasPendingFn = true;
                        scheduleSearchStatusFetch($2636782f3a6d3c9c$export$bbec15ef0a4926b6);
                    }
                }
                fireOperationalEvent('finished', {
                    ...defaultAnalyticsAttributes,
                    hasPendingFn: hasPendingFn
                });
            }).catch((error)=>{
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: $2636782f3a6d3c9c$var$analyticsMeta,
                    attributes: (0, $lHVmb.createAttributes)({
                        error: error,
                        isRetry: isRetry
                    })
                });
                if (isSearchingRef.current && timeoutRef.current === timeout) scheduleSearchStatusFetch($2636782f3a6d3c9c$export$bbec15ef0a4926b6);
            });
        }, delay);
        timeoutRef.current = timeout;
    }, [
        cloudId,
        environment,
        fireOperationalEvent,
        formatMessage,
        query
    ]);
    (0, $eJOHy.useEffect)(()=>{
        isSearchingRef.current = isSearching;
    }, [
        isSearching
    ]);
    (0, $eJOHy.useEffect)(()=>{
        setStatusMessages($2636782f3a6d3c9c$var$EMPTY_EXTERNAL_INFO);
        cancelPendingOperations();
        if (isSearching) scheduleSearchStatusFetch($2636782f3a6d3c9c$export$529d2e9d8e9d3cad);
    }, [
        isSearching,
        query,
        cancelPendingOperations,
        scheduleSearchStatusFetch
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            messages: statusMessages
        }), [
        statusMessages
    ]);
};

});
parcelRegister("i4yCJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7824086852fe611$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<06f329a4787d481a42a4c55f0b801953>>
 * @relayHash 7d47bdaa4d5aeb847704c6e13c25fd58
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8e680ef9e6d909ed43bf02677fe95ccafcad565518b3a659febcd16aa4f5bbd8
const $e7824086852fe611$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }
    ], v1 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "jql",
                            "variableName": "jql"
                        }
                    ],
                    "concreteType": "JiraIssueSearchStatus",
                    "kind": "LinkedField",
                    "name": "issueSearchStatus",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraJqlFunctionProcessingStatus",
                            "kind": "LinkedField",
                            "name": "functions",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "function"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "app"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "jqlSearchStatus_Query",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "jqlSearchStatus_Query",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "8e680ef9e6d909ed43bf02677fe95ccafcad565518b3a659febcd16aa4f5bbd8",
            "metadata": {},
            "name": "jqlSearchStatus_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e7824086852fe611$var$node.hash = "9dd1bed08ceb0d25df132f36097ae6d1";
var $e7824086852fe611$export$2e2bcd8739ae039 = $e7824086852fe611$var$node;

});

parcelRegister("cdF1X", function(module, exports) {
$parcel$export(module.exports, "default", () => $8fb766a04ea5acb0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $8fb766a04ea5acb0$var$messages = (0, $7qGN1.defineMessages)({
    singleSlowForgeFunction: {
        "id": "issue-navigator.controllers.jql-search-status.single-slow-forge-function",
        "defaultMessage": "{appName} is still executing the {functionName} JQL function."
    },
    multipleSlowForgeFunctionsFromTheSameApp: {
        "id": "issue-navigator.controllers.jql-search-status.multiple-slow-forge-functions-from-the-same-app",
        "defaultMessage": "{appName} is still executing multiple JQL functions."
    },
    multipleSlowForgeFunctionsTwoApps: {
        "id": "issue-navigator.controllers.jql-search-status.multiple-slow-forge-functions-two-apps",
        "defaultMessage": "{appName1} and {appName2} are still executing multiple JQL functions."
    },
    multipleSlowForgeFunctionsThreeApps: {
        "id": "issue-navigator.controllers.jql-search-status.multiple-slow-forge-functions-three-apps",
        "defaultMessage": "{appName1}, {appName2}, and {appName3} are still executing multiple JQL functions."
    }
});
var $8fb766a04ea5acb0$export$2e2bcd8739ae039 = $8fb766a04ea5acb0$var$messages;

});


parcelRegister("1fmSG", function(module, exports) {
$parcel$export(module.exports, "useJqlSearch", () => $b4925a5b6cf0a624$export$e69d0de2e354a2cb);

var $eJOHy = parcelRequire("eJOHy");

var $fwKw5 = parcelRequire("fwKw5");

var $3kDjB = parcelRequire("3kDjB");
const $b4925a5b6cf0a624$export$e69d0de2e354a2cb = (changeJql)=>{
    const query = (0, $fwKw5.useResolvedJql)();
    const { refetch: refetch } = (0, $3kDjB.useIssueSearchActions)();
    const onSearch = (0, $eJOHy.useCallback)((jql)=>{
        if (jql === query) // This will execute a new search against the network with current JQL input arguments
        refetch();
        else changeJql && changeJql(jql);
    }, [
        query,
        refetch,
        changeJql
    ]);
    return {
        onSearch: onSearch,
        query: query
    };
};

});

parcelRegister("a8Oge", function(module, exports) {
$parcel$export(module.exports, "default", () => $39acabe3aec5695d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $39acabe3aec5695d$var$messages = (0, $7qGN1.defineMessages)({
    saveFilterButton: {
        "id": "issue-navigator.jql-builder.save-filter-button",
        "defaultMessage": "Save filter"
    },
    saveFilterDialogTitle: {
        "id": "issue-navigator.jql-builder.save-filter-dialog-title",
        "defaultMessage": "Save filter"
    },
    copyFilterButton: {
        "id": "issue-navigator.jql-builder.copy-filter-button",
        "defaultMessage": "Copy filter"
    },
    copyFilterDialogTitle: {
        "id": "issue-navigator.jql-builder.copy-filter-dialog-title",
        "defaultMessage": "Copy filter"
    }
});
var $39acabe3aec5695d$export$2e2bcd8739ae039 = $39acabe3aec5695d$var$messages;

});

parcelRegister("3d17F", function(module, exports) {
$parcel$export(module.exports, "NoOptionsMessage", () => $b7cc870d17f9e29b$export$d58b72b7d3c4072c);

var $eJOHy = parcelRequire("eJOHy");

var $80DPg = parcelRequire("80DPg");

var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $ldQj3 = parcelRequire("ldQj3");
const $b7cc870d17f9e29b$var$MessageContainer = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.150",
        xcss: $b7cc870d17f9e29b$var$stackStyles,
        alignInline: "center"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        color: "color.text"
    }, formatMessage((0, $ldQj3.default).noOptionsPrimaryMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $ldQj3.default).noOptionsSecondaryMessage)));
};
const $b7cc870d17f9e29b$export$d58b72b7d3c4072c = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b7cc870d17f9e29b$var$MessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        label: "",
        color: "var(--ds-icon, #292A2E)",
        LEGACY_primaryColor: "var(--ds-icon-subtle, #505258)"
    }));
};
const $b7cc870d17f9e29b$var$stackStyles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.150',
    paddingInline: 'space.100'
});

});
parcelRegister("ldQj3", function(module, exports) {
$parcel$export(module.exports, "default", () => $2049601416c73756$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $2049601416c73756$var$messages = (0, $7qGN1.defineMessages)({
    noOptionsPrimaryMessage: {
        "id": "issue-navigator.jql-builder.no-options-message.no-options-primary-message",
        "defaultMessage": "We couldn't find what you're looking for"
    },
    noOptionsSecondaryMessage: {
        "id": "issue-navigator.jql-builder.no-options-message.no-options-secondary-message",
        "defaultMessage": "Try using different search terms."
    }
});
var $2049601416c73756$export$2e2bcd8739ae039 = $2049601416c73756$var$messages;

});


parcelRegister("in3H6", function(module, exports) {
$parcel$export(module.exports, "ResetButton", () => $51793ad880d1faf0$export$2491f201e3dd9acf);
$parcel$export(module.exports, "default", () => $51793ad880d1faf0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $15B20 = parcelRequire("15B20");
const $51793ad880d1faf0$export$2491f201e3dd9acf = ({ onReset: onReset, isResetToFilter: isResetToFilter = false })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleOnReset = (0, $eJOHy.useCallback)((mouseEvent, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, isResetToFilter ? 'goBackToFilterButton' : 'resetButton', {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: mouseEvent.detail === 0
        });
        onReset && onReset(isResetToFilter);
    }, [
        onReset,
        isResetToFilter
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($51793ad880d1faf0$var$ResetButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        testId: "issue-navigator.ui.jql-builder.reset-button",
        appearance: "subtle-link",
        onClick: handleOnReset
    }, formatMessage(isResetToFilter ? (0, $15B20.default).goBackToFilterButtonText : (0, $15B20.default).clearFiltersButtonText)));
};
var $51793ad880d1faf0$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $51793ad880d1faf0$export$2491f201e3dd9acf;
const $51793ad880d1faf0$var$ResetButtonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zkb7n _i0dlf1ug _1e0c1txw _p12fuuw1 _4cvr1h6o _4t3izwfg _19pk1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("15B20", function(module, exports) {
$parcel$export(module.exports, "default", () => $b581130698f794e7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b581130698f794e7$var$messages = (0, $7qGN1.defineMessages)({
    clearFiltersButtonText: {
        "id": "issue-navigator.jql-builder.reset-button.clear-filters-button-text",
        "defaultMessage": "Clear filters"
    },
    goBackToFilterButtonText: {
        "id": "issue-navigator.jql-builder.reset-button.go-back-to-filter-button-text",
        "defaultMessage": "Go back to filter"
    }
});
var $b581130698f794e7$export$2e2bcd8739ae039 = $b581130698f794e7$var$messages;

});


parcelRegister("beKwt", function(module, exports) {
$parcel$export(module.exports, "useJqlBuilderInstrumentation", () => $57621f75a050aebd$export$42691712ca1334f9);

var $eJOHy = parcelRequire("eJOHy");

var $fAgUF = parcelRequire("fAgUF");
const $57621f75a050aebd$export$42691712ca1334f9 = ()=>{
    const [finished, setFinished] = (0, $eJOHy.useState)(false);
    return (0, $eJOHy.useMemo)(()=>({
            startJqlBuilderMetric: ()=>{
                if (finished) return;
                (0, $fAgUF.NINJqlBuilderAsyncLoad).start();
            },
            stopJqlBuilderMetric: ()=>{
                setFinished(true);
                (0, $fAgUF.NINJqlBuilderAsyncLoad).stop();
            },
            markJqlBuilderMetric: (mark)=>{
                if (finished) return;
                (0, $fAgUF.markOnce)(mark);
            }
        }), [
        finished
    ]);
};

});

parcelRegister("5B9jk", function(module, exports) {
$parcel$export(module.exports, "isOnlyJqlAndDifferentToDefault", () => $9bf62b829f568f84$export$3cfc4f52186efe7d);
$parcel$export(module.exports, "isOnlyFilterAndDifferentToDefault", () => $9bf62b829f568f84$export$933470cfeba275aa);
$parcel$export(module.exports, "filterAndJqlIsTheSameAndDifferentToDefault", () => $9bf62b829f568f84$export$a25fc74cc3fc7015);
$parcel$export(module.exports, "jqlIsDifferentToFilter", () => $9bf62b829f568f84$export$7dfcf59726e2b396);
$parcel$export(module.exports, "isFilterJqlModified", () => $9bf62b829f568f84$export$d3d543997ba807);
$parcel$export(module.exports, "jqlIsDifferentToDefault", () => $9bf62b829f568f84$export$69b172dbb100f335);
const $9bf62b829f568f84$export$3cfc4f52186efe7d = (jqlParam, defaultJqlTerm, filterParam)=>filterParam === undefined && jqlParam !== undefined && jqlParam.toLowerCase() !== defaultJqlTerm.toLowerCase();
const $9bf62b829f568f84$export$933470cfeba275aa = (jqlParam, defaultJqlTerm, filterJqlTerm)=>filterJqlTerm !== undefined && jqlParam === undefined && filterJqlTerm.toLowerCase() !== defaultJqlTerm.toLowerCase();
const $9bf62b829f568f84$export$a25fc74cc3fc7015 = (jqlParam, defaultJqlTerm, filterJqlTerm)=>jqlParam !== undefined && filterJqlTerm !== undefined && jqlParam.toLowerCase() === filterJqlTerm.toLowerCase() && filterJqlTerm.toLowerCase() !== defaultJqlTerm.toLowerCase();
const $9bf62b829f568f84$export$7dfcf59726e2b396 = (jqlParam, filterJqlTerm)=>jqlParam !== undefined && filterJqlTerm !== undefined && filterJqlTerm.toLowerCase() !== jqlParam.toLowerCase();
const $9bf62b829f568f84$export$d3d543997ba807 = ({ query: query, filterJql: filterJql })=>filterJql !== undefined && query.toLowerCase().trim() !== filterJql.toLowerCase().trim();
const $9bf62b829f568f84$export$69b172dbb100f335 = (jqlParam, defaultJqlTerm)=>jqlParam !== undefined && jqlParam.toLowerCase().trim() !== defaultJqlTerm.toLowerCase().trim();

});


parcelRegister("l5sqM", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb6fd92d51c455d7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $eb6fd92d51c455d7$var$messages = (0, $7qGN1.defineMessages)({
    screenReaderGroupResultInfo: {
        "id": "issue-navigator.screen-reader-group-result-info",
        "defaultMessage": "Grouping has been applied to the list."
    },
    screenReaderSearchResultInfo: {
        "id": "issue-navigator.screen-reader-search-result-info",
        "defaultMessage": "{total, plural, one {One issue matches your search.} other {{total} issues match your search.}}"
    },
    screenReaderSearchResultMoreInfo: {
        "id": "issue-navigator.screen-reader-search-result-more-info",
        "defaultMessage": "{total, plural, one {{total} or more issues found} other {{total} or more issues found}}."
    },
    screenReaderSearchResultInfoIssueTermRefresh: {
        "id": "issue-navigator.screen-reader-search-result-info-issue-term-refresh",
        "defaultMessage": "{total, plural, one {One work item matches your search.} other {{total} work items match your search.}}"
    },
    screenReaderSearchResultMoreInfoIssueTermRefresh: {
        "id": "issue-navigator.screen-reader-search-result-more-info-issue-term-refresh",
        "defaultMessage": "{total, plural, one {{total} or more work items found} other {{total} or more work items found}}."
    }
});
var $eb6fd92d51c455d7$export$2e2bcd8739ae039 = $eb6fd92d51c455d7$var$messages;

});

parcelRegister("1TTSy", function(module, exports) {
$parcel$export(module.exports, "default", () => $77f4e139beb9422c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $g51Bg = parcelRequire("g51Bg");

var $fo3wk = parcelRequire("fo3wk");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");
const $77f4e139beb9422c$var$RegisterDotShortcut = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ isLoaded: isLoaded }, { open: open }] = (0, $g51Bg.useCommandPaletteIsLoaded)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fo3wk.default), {
        keyMap: {
            '.': {
                callback: (ev)=>{
                    (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                        action: 'pressed',
                        actionSubject: 'keyboardShortcut'
                    }), 'dotDialogKeyboardShortcut', {
                        keyPressed: '.',
                        keyboardShortcut: true,
                        isLoaded: isLoaded
                    });
                    ev?.preventDefault();
                    open();
                }
            }
        }
    });
};
var $77f4e139beb9422c$export$2e2bcd8739ae039 = $77f4e139beb9422c$var$RegisterDotShortcut;

});

parcelRegister("dpNFU", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d57863267313bd6$export$2e2bcd8739ae039);

var $iSIZS = parcelRequire("iSIZS");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lHHP1 = parcelRequire("lHHP1");

var $gQyru = parcelRequire("gQyru");

var $eibCx = parcelRequire("eibCx");

var $HiS1C = parcelRequire("HiS1C");
// Remove all the changeboarding on clean up of 'remove_nin_changeboarding_rll_usages', should be showing as empty fragments already
const $9d57863267313bd6$var$IssueNavigatorSpotlight = ({ hasIssueResults: hasIssueResults, userPreferences: userPreferences, isAiEnabled: isAiEnabled })=>{
    const [{ view: view }] = (0, $HiS1C.useSelectedViewState)();
    const searchModeResponse = (0, $j4oe4.useFragment)((0, $iSIZS.default), userPreferences);
    const selectedSearchMode = (0, $gQyru.toSearchModeWithBasicModeFallback)(searchModeResponse?.jqlBuilderSearchMode);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lHHP1.NinChangeboardingTourCard), {
        mode: selectedSearchMode,
        view: (0, $eibCx.convertToView)(view),
        hasIssueResults: hasIssueResults,
        isAiEnabled: isAiEnabled
    });
};
var $9d57863267313bd6$export$2e2bcd8739ae039 = $9d57863267313bd6$var$IssueNavigatorSpotlight;

});
parcelRegister("iSIZS", function(module, exports) {
$parcel$export(module.exports, "default", () => $e35662d99fb1dc35$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<30a8994404dfcae5d894d268d148ffe9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e35662d99fb1dc35$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "spotlight_issueNavigator_IssueNavigatorSpotlight",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "jqlBuilderSearchMode"
        }
    ],
    "type": "JiraUserPreferences"
};
$e35662d99fb1dc35$var$node.hash = "3c8e72948beb901cccd7a6650610b18e";
var $e35662d99fb1dc35$export$2e2bcd8739ae039 = $e35662d99fb1dc35$var$node;

});

parcelRegister("gQyru", function(module, exports) {
$parcel$export(module.exports, "toSearchModeWithBasicModeFallback", () => $55476173f94cb033$export$7c0f55a4bd3730ea);
$parcel$export(module.exports, "toServerSearchMode", () => $55476173f94cb033$export$32a166cc1b3e6927);

var $56qWy = parcelRequire("56qWy");
function $55476173f94cb033$export$7c0f55a4bd3730ea(value) {
    switch(value){
        case 0, $56qWy.SERVER_SEARCH_MODE_ADVANCED:
            return 0, $56qWy.SEARCH_MODE_ADVANCED;
        default:
            return 0, $56qWy.DEFAULT_SEARCH_MODE;
    }
}
function $55476173f94cb033$export$32a166cc1b3e6927(mode) {
    switch(mode){
        case 0, $56qWy.SEARCH_MODE_ADVANCED:
            return 0, $56qWy.SERVER_SEARCH_MODE_ADVANCED;
        default:
            return 0, $56qWy.SERVER_SEARCH_MODE_BASIC;
    }
}

});


parcelRegister("78img", function(module, exports) {
$parcel$export(module.exports, "default", () => $6353b9041343e5e1$export$2e2bcd8739ae039);

var $g0IPL = parcelRequire("g0IPL");

var $5Gxoe = parcelRequire("5Gxoe");

var $kuMEK = parcelRequire("kuMEK");

var $5TPkN = parcelRequire("5TPkN");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $c12HM = parcelRequire("c12HM");

var $7tL08 = parcelRequire("7tL08");

var $1tPTE = parcelRequire("1tPTE");

var $3TtKq = parcelRequire("3TtKq");

var $cxKOj = parcelRequire("cxKOj");

var $4Oene = parcelRequire("4Oene");

var $4cTDP = parcelRequire("4cTDP");

var $2nr0r = parcelRequire("2nr0r");

var $a9bnL = parcelRequire("a9bnL");

var $2wbY1 = parcelRequire("2wbY1");

var $iRahl = parcelRequire("iRahl");

var $7E6oZ = parcelRequire("7E6oZ");

var $2UTIe = parcelRequire("2UTIe");

var $HiS1C = parcelRequire("HiS1C");

var $fwKw5 = parcelRequire("fwKw5");

var $cJdYi = parcelRequire("cJdYi");

var $3kDjB = parcelRequire("3kDjB");

var $3Ssg5 = parcelRequire("3Ssg5");
const $6353b9041343e5e1$var$getLastPage = (pageCursors)=>{
    if (pageCursors?.last) return pageCursors.last.pageNumber;
    if (pageCursors?.around?.length) return pageCursors.around[pageCursors.around.length - 1]?.pageNumber;
    return undefined;
};
const $6353b9041343e5e1$var$styles = {
    jqlWrapper: "_5ynfkb7n"
};
const $6353b9041343e5e1$var$TopBar = ({ ActionMenu: ActionMenu, filter: filter, issueResults: issueResults, HeaderSkeletonImage: HeaderSkeletonImage, jqlBuilder: jqlBuilder, jiraViewResult: jiraViewResult, projectResult: projectResult, isGroupingSupported: isGroupingSupported, onChangeFilter: onChangeFilter, onChangeJql: onChangeJql, isGridNavigationEnabled: isGridNavigationEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, defaultJql: defaultJql, onChangeJqlAndGroupBy: onChangeJqlAndGroupBy })=>{
    const issueResultsData = (0, $j4oe4.useFragment)((0, $5TPkN.default), issueResults);
    // Compute page data for our search results which is needed when requesting items for the legacy meatball menu
    const offset = (issueResultsData?.issueNavigatorPageInfo?.firstIssuePosition ?? 1) - 1; // offset is 0 based so subtract 1
    const pages = $6353b9041343e5e1$var$getLastPage(issueResultsData?.pageCursors) ?? 0;
    const total = issueResultsData?.totalIssueSearchResultCount ?? 0;
    const searchResultPageData = (0, $eJOHy.useMemo)(()=>({
            offset: offset,
            pages: pages,
            total: total
        }), [
        offset,
        pages,
        total
    ]);
    const { filterId: filterId } = (0, $fwKw5.useActiveJql)();
    const jql = (0, $fwKw5.useResolvedJql)();
    const { filterQueryIsFetching: filterQueryIsFetching } = (0, $cJdYi.useFilterQuery)();
    const filterData = (0, $j4oe4.useFragment)((0, $kuMEK.default), filter);
    const projectData = (0, $j4oe4.useFragment)((0, $5Gxoe.default), projectResult);
    const jiraViewData = (0, $j4oe4.useFragment)((0, $g0IPL.default), jiraViewResult);
    const filterDetails = (0, $eJOHy.useMemo)(()=>filterData ? {
            filterId: filterData.filterId,
            name: filterData.name,
            jql: filterData.jql,
            isFavourite: Boolean(filterData.isFavourite)
        } : undefined, [
        filterData
    ]);
    const [{ view: view }] = (0, $HiS1C.useSelectedViewState)();
    const jiraViewResultData = jiraViewData;
    const { changeHierarchy: changeHierarchy, changeGroupedByField: changeGroupedByField, changeHideDone: changeHideDone, resetView: resetView } = (0, $3kDjB.useIssueSearchActions)();
    const updateGroupByParam = (0, $3Ssg5.useUpdateUrlQueryParamCallback)('groupBy');
    const onChangeGroupedByField = (0, $eJOHy.useCallback)((nextGroupedByField)=>{
        changeGroupedByField(nextGroupedByField ?? null);
        updateGroupByParam(nextGroupedByField ?? undefined);
    }, [
        changeGroupedByField,
        updateGroupByParam
    ]);
    let hideDone = false;
    if ((0, $4cTDP.fg)('jsc_bulk_edit_hide_done_work_items')) hideDone = jiraViewData?.viewSettings?.hideDone ?? false;
    const HierarchyToggle = jiraViewResultData && view !== 'detail' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7E6oZ.HierarchyToggleItem), {
        isGroupingSupported: isGroupingSupported,
        viewResult: jiraViewResultData,
        onChangeHierarchy: changeHierarchy
    }) : null;
    const GroupByDropdown = isGroupingSupported && jiraViewData && (0, $iRahl.isJiraSpreadsheetView)(jiraViewData) && view !== 'detail' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1tPTE.GroupByDropdown), {
        onChangeGroupedByField: onChangeGroupedByField,
        spreadsheetView: jiraViewData
    }) : null;
    let onResetSelectedIssues = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    if ((0, $4cTDP.fg)('jsc_list_hide_done_items')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ reset: onResetSelectedIssues } = (0, $3TtKq.useIssueTableSelectedIssuesActions)());
    if (filterQueryIsFetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(HeaderSkeletonImage, null);
    const HideDoneToggle = jiraViewResultData && view !== 'detail' && (0, $4cTDP.fg)('jsc_list_hide_done_items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2nr0r.HideDoneItemsToggle), {
        isSavedViewsEnabled: (0, $4cTDP.fg)('saved_list_view_technical_changes'),
        viewResult: jiraViewResultData,
        onChangeHideDone: changeHideDone,
        onResetSelectedIssues: onResetSelectedIssues
    }) : null;
    const FiltersMenuComponent = projectData && onChangeJql && (0, $cxKOj.expVal)('jira-issue-navigator-saved-filters-menu', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2wbY1.FiltersMenu), {
        defaultJql: defaultJql,
        onChangeJql: onChangeJql,
        projectFragment: projectData
    }) : null;
    const saveResetViewSettingsButton = jiraViewResultData && (0, $cxKOj.expVal)('saved_list_view', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9bnL.SaveResetViewSettingsButton), {
        jql: jql,
        onChangeJql: onChangeJql,
        onReset: resetView,
        viewFragment: jiraViewResultData
    });
    const pageTopBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7tL08.PageTopBar), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ActionMenu, {
            jql: jql,
            filterId: filterId,
            filterDetails: filterDetails,
            searchResultPageData: searchResultPageData,
            HierarchyToggle: HierarchyToggle,
            GroupByDropdown: GroupByDropdown,
            HideDoneToggle: HideDoneToggle,
            FiltersMenu: FiltersMenuComponent,
            SaveResetViewSettingsButton: saveResetViewSettingsButton,
            isHideDoneWorkItemsEnabled: hideDone,
            onChangeFilter: onChangeFilter,
            isModifiedFilter: (0, $4cTDP.fg)('visual-refresh-headers-buttons') ? filterDetails?.jql !== jql : false,
            isGridNavigationEnabled: isGridNavigationEnabled,
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
            onChangeJqlAndGroupBy: onChangeJqlAndGroupBy
        }),
        bottomBar: jqlBuilder
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
        name: "top-bar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $6353b9041343e5e1$var$styles.jqlWrapper
        ])
    }, pageTopBar));
};
var $6353b9041343e5e1$export$2e2bcd8739ae039 = (0, $2UTIe.withReportErrors)($6353b9041343e5e1$var$TopBar, {
    id: 'ui.topbar.unhandled',
    packageName: (0, $iRahl.PACKAGE_NAME),
    teamName: (0, $iRahl.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $c12HM.isLoaderErrorAttributes)
});

});
parcelRegister("g0IPL", function(module, exports) {
$parcel$export(module.exports, "default", () => $03bbdc9688b3fd9b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<73e7b7887a29f8d2bcb4d20edecb24e5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $03bbdc9688b3fd9b$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "settings"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "topBar_issueNavigator_jiraViewResult",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "GroupByDropdown"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isSavedViewsEnabled",
                            "variableName": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "settings",
                            "variableName": "settings"
                        },
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hideDone"
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "SaveResetViewSettingsButton"
                        }
                    ]
                }
            ],
            "type": "JiraIssueSearchViewMetadata",
            "abstractKey": "__isJiraIssueSearchViewMetadata"
        }
    ],
    "type": "JiraView",
    "abstractKey": "__isJiraView"
};
$03bbdc9688b3fd9b$var$node.hash = "a5752283d807ac88d3d1b616e8a47dfc";
var $03bbdc9688b3fd9b$export$2e2bcd8739ae039 = $03bbdc9688b3fd9b$var$node;

});

parcelRegister("5Gxoe", function(module, exports) {
$parcel$export(module.exports, "default", () => $982e79dc93db9cf7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<66e8701c2bfd0f20c2c3ee43e36ab9a3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $982e79dc93db9cf7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "topBar_issueNavigator_projectResult",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "FiltersMenu_project"
        }
    ],
    "type": "JiraProject"
};
$982e79dc93db9cf7$var$node.hash = "5594f3f44e3a12b26314cdb1292648f2";
var $982e79dc93db9cf7$export$2e2bcd8739ae039 = $982e79dc93db9cf7$var$node;

});

parcelRegister("kuMEK", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfc9a55a1a1c6e29$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6ab7c2a8b5f9d7e53e2eda0626fb3cbe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bfc9a55a1a1c6e29$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "topBar_issueNavigator_filter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$bfc9a55a1a1c6e29$var$node.hash = "d1fd34a229f9cb2668ab6793af284885";
var $bfc9a55a1a1c6e29$export$2e2bcd8739ae039 = $bfc9a55a1a1c6e29$var$node;

});

parcelRegister("5TPkN", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb87491d30ecde40$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<222e07e55baf5ff3dcc37bb6cbd7a80e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fb87491d30ecde40$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "topBar_issueNavigator_issueResults",
        "selections": [
            {
                "concreteType": "JiraIssueNavigatorPageInfo",
                "kind": "LinkedField",
                "name": "issueNavigatorPageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "firstIssuePosition"
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                    }
                ],
                "concreteType": "JiraPageCursors",
                "kind": "LinkedField",
                "name": "pageCursors",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "last",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "storageKey": "pageCursors(maxCursors:7)"
            },
            {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$fb87491d30ecde40$var$node.hash = "52b4c743e436bc90ea0831559f2c3e48";
var $fb87491d30ecde40$export$2e2bcd8739ae039 = $fb87491d30ecde40$var$node;

});

parcelRegister("7tL08", function(module, exports) {
$parcel$export(module.exports, "PageTopBar", () => $1fc13d53be5e9467$export$7e5801dc91bf1819);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $6efFi = parcelRequire("6efFi");
var $1DXK0 = parcelRequire("1DXK0");

const $1fc13d53be5e9467$var$SporkPageTopBar = ({ bottomBar: bottomBar, actions: actions, wrapAtMd: wrapAtMd = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: (0, $9fdce687ce348642$export$90c4434a1e138106),
        xcss: [
            $1fc13d53be5e9467$var$wrapperStyles,
            wrapAtMd ? $1fc13d53be5e9467$var$wrapAtMdStyle : $1fc13d53be5e9467$var$noWrapStyle
        ]
    }, bottomBar, actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: (0, $9fdce687ce348642$export$1742330ac6a668f0),
        xcss: [
            $1fc13d53be5e9467$var$actionsBoxStyles,
            wrapAtMd && $1fc13d53be5e9467$var$actionsBoxAtMdStyles
        ]
    }, actions));
const $1fc13d53be5e9467$export$7e5801dc91bf1819 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1fc13d53be5e9467$var$SporkPageTopBar, {
        bottomBar: props.bottomBar,
        actions: props.actions,
        wrapAtMd: props.wrapAtMd
    });
const $1fc13d53be5e9467$var$noWrapStyle = (0, $1DXK0.xcss)({
    flexWrap: 'nowrap'
});
const $1fc13d53be5e9467$var$wrapAtMdStyle = (0, $1DXK0.xcss)({
    flexWrap: 'wrap-reverse',
    [(0, $6efFi.media).above.md]: {
        flexWrap: 'nowrap'
    }
});
const $1fc13d53be5e9467$var$wrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    paddingTop: 'space.250',
    paddingBottom: 'space.200',
    justifyContent: 'space-between',
    gap: 'space.100',
    [(0, $6efFi.media).above.md]: {
        gap: 'space.300'
    }
});
const $1fc13d53be5e9467$var$actionsBoxAtMdStyles = (0, $1DXK0.xcss)({
    flex: '1 1 auto',
    [(0, $6efFi.media).above.md]: {
        flex: '0 1 auto'
    }
});
const $1fc13d53be5e9467$var$actionsBoxStyles = (0, $1DXK0.xcss)({
    marginLeft: 'auto',
    display: 'flex',
    justifyContent: 'flex-end',
    flex: '0 0 auto'
});

});
const $9fdce687ce348642$export$90c4434a1e138106 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar';
const $9fdce687ce348642$export$1742330ac6a668f0 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar.actions';


parcelRegister("2wbY1", function(module, exports) {
$parcel$export(module.exports, "FiltersMenu", () => $2c94accbfe411a12$export$5cf20cdbe868e916);

var $90J9S = parcelRequire("90J9S");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $5CSKW = parcelRequire("5CSKW");

var $1OQKp = parcelRequire("1OQKp");

var $7ep4S = parcelRequire("7ep4S");

var $54CI2 = parcelRequire("54CI2");

var $806LH = parcelRequire("806LH");

var $80DPg = parcelRequire("80DPg");

var $bskNA = parcelRequire("bskNA");

var $b8OI0 = parcelRequire("b8OI0");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $lRq8t = parcelRequire("lRq8t");

var $8Uqf3 = parcelRequire("8Uqf3");

var $aqnJa = parcelRequire("aqnJa");

var $32OV5 = parcelRequire("32OV5");

var $egViP = parcelRequire("egViP");

var $g5wws = parcelRequire("g5wws");
const $2c94accbfe411a12$var$styles = {
    fallback: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1mjv _4t3iuuw1",
    errorBox: "_zulppxbi _4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i68cl _1bah1h6o _19pkpxbi _2hwx1ejb _otyrpxbi _18u01ejb"
};
const $2c94accbfe411a12$var$experience = 'viewSavedFilters';
const $2c94accbfe411a12$var$FiltersMenuComponent = ({ defaultJql: defaultJql, onChangeJql: onChangeJql, projectFragment: projectFragment })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const projectData = (0, $j4oe4.useFragment)((0, $90J9S.default), projectFragment);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            projectId: projectData.id,
            first: 50,
            includeProjectClause: true
        }), [
        projectData.id
    ]);
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            defaultJql: defaultJql,
            onChangeJql: (jql)=>onChangeJql(jql, true)
        }), [
        defaultJql,
        onChangeJql
    ]);
    const startExperience = (0, $8Uqf3.useExperienceStart)({
        experience: $2c94accbfe411a12$var$experience,
        analyticsSource: 'issue-navigator'
    });
    const trigger = (0, $eJOHy.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g5wws.FiltersMenuOnboarding), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
            ...triggerProps,
            appearance: "subtle",
            iconAfter: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
                    label: "",
                    size: "small"
                }),
            isSelected: triggerProps['aria-expanded'],
            onClick: ()=>{
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'savedFiltersMenu');
                startExperience();
            },
            testId: "issue-navigator-filters-menu.ui.trigger"
        }, formatMessage((0, $32OV5.default).menuTitle))), [
        createAnalyticsEvent,
        formatMessage,
        startExperience
    ]);
    const fallback = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            className: (0, $hcewu.default)([
                $2c94accbfe411a12$var$styles.fallback
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), null)), []);
    const errorFallback = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            className: (0, $hcewu.default)([
                $2c94accbfe411a12$var$styles.errorBox
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
            color: "var(--ds-icon, #292A2E)",
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
            size: "xsmall"
        }, formatMessage((0, $32OV5.default).failedToLoadSavedFilters))), [
        formatMessage
    ]);
    const failExperience = (0, $aqnJa.useExperienceFail)({
        experience: $2c94accbfe411a12$var$experience
    });
    const onError = (0, $eJOHy.useCallback)(({ error: error })=>{
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'FiltersMenuEntrypoint',
                packageName: 'jiraIssueNavigatorFiltersMenu',
                teamName: 'empanada'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        failExperience('jwmFilters query failed', error);
    }, [
        failExperience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bskNA.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), {
        blanketIsTinted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b8OI0.PopupTrigger), {
        entryPoint: (0, $egViP.filtersMenuEntryPoint),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        fallback: fallback,
        placement: "bottom-end",
        role: "dialog",
        shouldRenderToParent: true,
        trigger: trigger,
        label: formatMessage((0, $32OV5.default).filtersMenuLabel),
        errorFallback: errorFallback,
        onError: onError
    })));
};
const $2c94accbfe411a12$export$5cf20cdbe868e916 = /*#__PURE__*/ (0, $eJOHy.memo)($2c94accbfe411a12$var$FiltersMenuComponent);

});
parcelRegister("90J9S", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c8c901598d44587$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3544619a4781e193582fb065aac4f119>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6c8c901598d44587$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "FiltersMenu_project",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        }
    ],
    "type": "JiraProject"
};
$6c8c901598d44587$var$node.hash = "10737a2ddd3f3d9a01f47a3d5384848a";
var $6c8c901598d44587$export$2e2bcd8739ae039 = $6c8c901598d44587$var$node;

});

parcelRegister("32OV5", function(module, exports) {
$parcel$export(module.exports, "default", () => $b061aa273131fc76$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b061aa273131fc76$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    menuTitle: {
        "id": "issue-navigator-filters-menu.FiltersMenu.messages.menu-title",
        "defaultMessage": "Saved filters"
    },
    filtersMenuLabel: {
        "id": "issue-navigator-filters-menu.FiltersMenu.messages.updated-recently.filters-menu-label",
        "defaultMessage": "Saved filters menu"
    },
    failedToLoadSavedFilters: {
        "id": "issue-navigator-filters-menu.FiltersMenu.messages.failed-to-load-saved-filters",
        "defaultMessage": "Couldn\u2019t load saved filters"
    }
});

});

parcelRegister("egViP", function(module, exports) {
$parcel$export(module.exports, "filtersMenuEntryPoint", () => $841d1833e6312223$export$2687e4e1d35338ee);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $ld6W5 = parcelRequire("ld6W5");

const $841d1833e6312223$export$2687e4e1d35338ee = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("fOOMo")), {
        moduleId: "2d65f12d",
        moduleName: "FiltersMenuContent",
        priority: "interaction"
    }),
    getPreloadProps: ({ projectId: projectId, first: first, includeProjectClause: includeProjectClause })=>({
            queries: {
                mainQuery: {
                    parameters: (0, $ld6W5.default),
                    variables: {
                        projectId: projectId,
                        first: first,
                        includeProjectClause: includeProjectClause
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        })
});

});
parcelRegister("ld6W5", function(module, exports) {
$parcel$export(module.exports, "default", () => $7edaabec3a2ee18f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f4ce5ba6ef6c7c852ace100e30414c47>>
 * @relayHash 39ab72e4ebb13bd0b635f701a2979e96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bd10fa25885e26d93d19576869d64459a7f52bb8aebc53957cc93f37270da04b
const $7edaabec3a2ee18f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeProjectClause"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "contextId",
                    "variableName": "projectId"
                }
            ],
            "kind": "ObjectValue",
            "name": "searchParameters"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = {
        "args": [
            {
                "kind": "Variable",
                "name": "includeProjectClause",
                "variableName": "includeProjectClause"
            }
        ],
        "kind": "ScalarField",
        "name": "jql"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v10 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectId"
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "key"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "FiltersMenuContentQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "jwmFilters",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v4 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jwmFilters.__typename"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "PageInfo",
                                                        "kind": "LinkedField",
                                                        "name": "pageInfo",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v5 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "jira.jwmFilters.pageInfo.hasNextPage"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.jwmFilters.pageInfo"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraWorkManagementFilterEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "JiraWorkManagementFilter",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "FragmentSpread",
                                                                            "name": "SavedFilterMenuItem_filter"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v6 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "jira.jwmFilters.edges.node.id"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v7 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "jira.jwmFilters.edges.node.name"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v8 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "jira.jwmFilters.edges.node.jql"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "THROW",
                                                                "path": "jira.jwmFilters.edges.node"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.jwmFilters.edges"
                                                }
                                            ],
                                            "type": "JiraWorkManagementFilterConnection"
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jwmFilters"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v6 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jiraProject.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v11 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jiraProject.key"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProject"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "FiltersMenuContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "jwmFilters",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraWorkManagementFilterEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraWorkManagementFilter",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isEditable"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraWorkManagementFilterConnection"
                                },
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "args": v10 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProject",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bd10fa25885e26d93d19576869d64459a7f52bb8aebc53957cc93f37270da04b",
            "metadata": {},
            "name": "FiltersMenuContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7edaabec3a2ee18f$var$node.hash = "735d2244b9e34fe75b6a8fd949f297c2";
var $7edaabec3a2ee18f$export$2e2bcd8739ae039 = $7edaabec3a2ee18f$var$node;

});

parcelRegister("fOOMo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4ardH").then(()=>parcelRequire('ad3OL'));

});


parcelRegister("g5wws", function(module, exports) {
$parcel$export(module.exports, "FiltersMenuOnboarding", () => $0713d04e62cb5f19$export$76741ae4a6660ff9);

var $eJOHy = parcelRequire("eJOHy");

var $bdRit = parcelRequire("bdRit");
var $fBe2p = parcelRequire("fBe2p");
var $d2s5v = parcelRequire("d2s5v");

var $lRq8t = parcelRequire("lRq8t");

var $lBwnr = parcelRequire("lBwnr");

var $3H1nG = parcelRequire("3H1nG");
const $0713d04e62cb5f19$export$76741ae4a6660ff9 = ({ children: children })=>{
    const [isOnboardingVisible, markAsSeen] = (0, $lBwnr.useFiltersMenuSpotlightOnboarding)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fBe2p.Pulse), {
        radius: 3,
        pulse: isOnboardingVisible
    }, children), isOnboardingVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bdRit.default), {
        actions: [
            {
                onClick: markAsSeen,
                text: formatMessage((0, $3H1nG.default).spotlightDismissButton)
            }
        ],
        heading: formatMessage((0, $3H1nG.default).spotlightTitle),
        target: "jira-nin-saved-filters-popup-content",
        targetRadius: 3,
        dialogWidth: 275,
        pulse: false,
        dialogPlacement: "left top"
    }, formatMessage((0, $3H1nG.default).spotlightBody))));
};

});
parcelRegister("lBwnr", function(module, exports) {
$parcel$export(module.exports, "useFiltersMenuSpotlightOnboarding", () => $49af0c7770beeba8$export$8a11e98a54e79899);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $7ORWh = parcelRequire("7ORWh");
const $49af0c7770beeba8$var$TTL_SEEN = 31536000000; // ~ 365 days
const $49af0c7770beeba8$var$SEEN_ONBOARDING = 'saved-filters-menu';
const $49af0c7770beeba8$export$8a11e98a54e79899 = ()=>{
    const [isOnboardingVisible, setIsOnboardingVisible] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $4cTDP.fg)('nin-saved-filters-menu-onboarding')) return;
        if (false) return;
        (0, $7ORWh.getFlags)({
            [$49af0c7770beeba8$var$SEEN_ONBOARDING]: {}
        }).then((seenItResponse)=>{
            const isOnboardingSeen = seenItResponse[$49af0c7770beeba8$var$SEEN_ONBOARDING]?.status;
            if (isOnboardingSeen !== true) setIsOnboardingVisible(true);
        }).catch(()=>{
        // Ignore errors
        });
    }, []);
    const markAsSeen = (0, $eJOHy.useCallback)(()=>{
        setIsOnboardingVisible(false);
        (0, $7ORWh.setFlag)($49af0c7770beeba8$var$SEEN_ONBOARDING, $49af0c7770beeba8$var$TTL_SEEN);
    }, []);
    return [
        isOnboardingVisible,
        markAsSeen
    ];
};

});

parcelRegister("3H1nG", function(module, exports) {
$parcel$export(module.exports, "default", () => $bbac0a211f86ec14$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $bbac0a211f86ec14$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    spotlightTitle: {
        "id": "issue-navigator-filters-menu.FiltersMenuOnboarding.messages.spotlight-title",
        "defaultMessage": "Finding and creating saved filters just got easier"
    },
    spotlightBody: {
        "id": "issue-navigator-filters-menu.FiltersMenuOnboarding.messages.spotlight-body",
        "defaultMessage": "Find filters you've saved, and save new ones in one place."
    },
    spotlightDismissButton: {
        "id": "issue-navigator-filters-menu.FiltersMenuOnboarding.messages.spotlight-dismiss-button",
        "defaultMessage": "OK"
    }
});

});




parcelRegister("2cvR1", function(module, exports) {
$parcel$export(module.exports, "SidebarCloserController", () => $ab5072dfa3713fc5$export$700866716e53c09d);

var $gHKwt = parcelRequire("gHKwt");

var $6d9QY = parcelRequire("6d9QY");

var $HiS1C = parcelRequire("HiS1C");
const $ab5072dfa3713fc5$export$700866716e53c09d = ()=>{
    const [{ id: id }, { closeSidebar: closeSidebar }] = (0, $gHKwt.useSidebar)();
    const [{ view: view }] = (0, $HiS1C.useSelectedViewState)();
    const prevView = (0, $6d9QY.usePrevious)(view);
    if (id !== null && view === 'detail' && prevView !== 'detail') closeSidebar();
    return null;
};

});

parcelRegister("f7hID", function(module, exports) {
$parcel$export(module.exports, "SidebarExperienceRegistryWithErrorBoundary", () => $d78df323146a91c4$export$2ca0ed61c620e2d7);

var $8lOaw = parcelRequire("8lOaw");

var $cSAa9 = parcelRequire("cSAa9");

var $jFOQJ = parcelRequire("jFOQJ");

var $fTxsL = parcelRequire("fTxsL");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gHKwt = parcelRequire("gHKwt");

var $kxXHK = parcelRequire("kxXHK");


var $5vQ2T = parcelRequire("5vQ2T");

var $4cTDP = parcelRequire("4cTDP");

var $fwKw5 = parcelRequire("fwKw5");

var $6zIqj = parcelRequire("6zIqj");

var $d8fIq = parcelRequire("d8fIq");

var $3rE61 = parcelRequire("3rE61");

var $6gbGT = parcelRequire("6gbGT");
const $d78df323146a91c4$export$50cee155b5f4b008 = ({ project: project, view: view })=>{
    const [{ id: id, content: content }, { closeSidebar: closeSidebar }] = (0, $gHKwt.useSidebar)();
    const jql = (0, $fwKw5.useResolvedJql)();
    const projectData = (0, $j4oe4.useFragment)((0, $fTxsL.default), project);
    const viewData = (0, $j4oe4.useFragment)((0, $jFOQJ.default), // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4cTDP.fg)('jira_list_conditional_formatting') && (0, $4cTDP.fg)('saved_list_view_technical_changes') ? view : null);
    if (content) return content;
    if (id === (0, $kxXHK.SIDEBAR_EXPERIENCE_NAME)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6zIqj.IssueFieldStatisticsSidebarExperience), {
        jql: jql,
        onClose: closeSidebar
    });
    if (id === (0, $42018301743dbb45$export$716d68d214fad041) && (0, $4cTDP.fg)('jira_list_conditional_formatting')) {
        if ((0, $4cTDP.fg)('saved_list_view_technical_changes')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3rE61.ConditionalFormattingSidebarExperience), {
            project: projectData ?? null,
            view: viewData ?? null,
            onClose: closeSidebar
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6gbGT.MaybeConditionalFormattingSidebarExperienceOld), {
            project: projectData ?? null,
            onClose: closeSidebar
        });
    }
    return null;
};
const $d78df323146a91c4$export$2ca0ed61c620e2d7 = ({ project: project, view: view })=>{
    const { closeSidebar: closeSidebar } = (0, $gHKwt.useSidebarActions)();
    const fallback = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d8fIq.ErrorState), {
            onClose: closeSidebar
        }), [
        closeSidebar
    ]);
    const projectData = (0, $j4oe4.useFragment)((0, $cSAa9.default), project);
    const viewData = (0, $j4oe4.useFragment)((0, $8lOaw.default), view);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "sidebarExperienceRegistry",
        packageName: "jiraIssueNavigator",
        teamName: "empanada",
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d78df323146a91c4$export$50cee155b5f4b008, {
        project: projectData ?? null,
        view: viewData ?? null
    }));
};

});
parcelRegister("8lOaw", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6502226306f7b51$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<208dbcc9ae1d9866dcca034afd8f322e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c6502226306f7b51$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isSavedViewConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_view",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isSavedViewConditionalFormattingEnabled",
                    "variableName": "isSavedViewConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistry_view"
        }
    ],
    "type": "JiraSpreadsheetView",
    "abstractKey": "__isJiraSpreadsheetView"
};
$c6502226306f7b51$var$node.hash = "7179917945065d6e68ed8645bd82cdcd";
var $c6502226306f7b51$export$2e2bcd8739ae039 = $c6502226306f7b51$var$node;

});

parcelRegister("cSAa9", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bc67fa8b7ed4a56$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8b1e81390a68e04b7eee2c994f46e913>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6bc67fa8b7ed4a56$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isSavedViewConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isSavedViewConditionalFormattingEnabled",
                    "variableName": "isSavedViewConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistry_project"
        }
    ],
    "type": "JiraProject"
};
$6bc67fa8b7ed4a56$var$node.hash = "68c529d353dff98f98ffde69ce1a3cbe";
var $6bc67fa8b7ed4a56$export$2e2bcd8739ae039 = $6bc67fa8b7ed4a56$var$node;

});

parcelRegister("jFOQJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c947bde61ccf2c5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d711cd0941c6b4b46378081ad105178c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8c947bde61ccf2c5$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isSavedViewConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistry_view",
    "selections": [
        {
            "condition": "isSavedViewConditionalFormattingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ConditionalFormattingSidebarExperience_view"
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetView",
    "abstractKey": "__isJiraSpreadsheetView"
};
$8c947bde61ccf2c5$var$node.hash = "93e874a142b401eaf0fa856c593250f2";
var $8c947bde61ccf2c5$export$2e2bcd8739ae039 = $8c947bde61ccf2c5$var$node;

});

parcelRegister("fTxsL", function(module, exports) {
$parcel$export(module.exports, "default", () => $fde761d9e83a6ebd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<342f97ac1c29fc1450d55c7df8b38e85>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fde761d9e83a6ebd$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isSavedViewConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistry_project",
    "selections": [
        {
            "condition": "isSavedViewConditionalFormattingEnabled",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "condition": "isConditionalFormattingEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "ConditionalFormattingSidebarExperienceOld_project"
                        }
                    ]
                }
            ]
        },
        {
            "condition": "isSavedViewConditionalFormattingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ConditionalFormattingSidebarExperience_project"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$fde761d9e83a6ebd$var$node.hash = "6062124258e30f13bb5ba27435575c95";
var $fde761d9e83a6ebd$export$2e2bcd8739ae039 = $fde761d9e83a6ebd$var$node;

});

const $42018301743dbb45$export$716d68d214fad041 = 'conditional-formatting';
const $42018301743dbb45$export$a8fd8094a2b22bf9 = 'conditionalFormattingSidebarOpen';

parcelRegister("6zIqj", function(module, exports) {
$parcel$export(module.exports, "IssueFieldStatisticsSidebarExperience", () => $79585b9f48c73c4e$export$63b30538475bf529);

var $eJOHy = parcelRequire("eJOHy");

var $5wZfc = parcelRequire("5wZfc");

var $cBavF = parcelRequire("cBavF");

var $d8fIq = parcelRequire("d8fIq");
const $79585b9f48c73c4e$var$HELIOS_TEAM_NAME = 'helios';
const $79585b9f48c73c4e$export$63b30538475bf529 = ({ jql: jql, onClose: onClose })=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject } = (0, $5wZfc.useIssueFieldStatisticsEntryPoint)();
    const issueFieldStatisticsRuntimeProps = (0, $eJOHy.useMemo)(()=>({
            jql: jql,
            onClose: onClose
        }), [
        jql,
        onClose
    ]);
    const errorFallback = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d8fIq.ErrorState), {
            onClose: onClose
        }), [
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "issueFieldStatisticsSidebar",
        packageName: "jiraIssueNavigatorActionIssueFieldStatistics",
        errorFallback: errorFallback,
        teamName: $79585b9f48c73c4e$var$HELIOS_TEAM_NAME,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
        runtimeProps: issueFieldStatisticsRuntimeProps
    });
};

});
parcelRegister("d8fIq", function(module, exports) {
$parcel$export(module.exports, "ErrorState", () => $01ad5fea1c48d205$export$c1ed4f415b9e7023);

var $eJOHy = parcelRequire("eJOHy");

var $lmgo6 = parcelRequire("lmgo6");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $Ay1uj = parcelRequire("Ay1uj");

var $6zhpo = parcelRequire("6zhpo");

var $lRq8t = parcelRequire("lRq8t");

var $j1go5 = parcelRequire("j1go5");

var $7ieXo = parcelRequire("7ieXo");
const $01ad5fea1c48d205$export$c1ed4f415b9e7023 = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        direction: "column",
        alignItems: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        direction: "column",
        alignItems: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))),
        label: formatMessage((0, $7ieXo.default).close),
        isTooltipDisabled: false,
        onClick: ()=>{
            onClose();
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        direction: "column",
        alignItems: "center",
        xcss: $01ad5fea1c48d205$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j1go5.default), {
        alt: formatMessage((0, $7ieXo.default).warning)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        weight: "bold"
    }, formatMessage((0, $7ieXo.default).errorTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        align: "center"
    }, formatMessage((0, $7ieXo.default).errorBody))));
};
const $01ad5fea1c48d205$var$contentStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.800',
    gap: 'space.100'
});

});
parcelRegister("j1go5", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3b7fabdf20be871$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $8sLq9 = parcelRequire("8sLq9");

var $eiSz9 = parcelRequire("eiSz9");
const $d3b7fabdf20be871$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8sLq9)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($eiSz9))
});
var $d3b7fabdf20be871$export$2e2bcd8739ae039 = $d3b7fabdf20be871$var$Illustration;
const $d3b7fabdf20be871$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    212
];

});
parcelRegister("8sLq9", function(module, exports) {
module.exports = new URL("error-triangle-basic.6c1bbfdc.svg", import.meta.url).toString();

});

parcelRegister("eiSz9", function(module, exports) {
module.exports = new URL("error-triangle-basic-darkmode.aa5ef22c.svg", import.meta.url).toString();

});


parcelRegister("7ieXo", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ccef3d11c508bf4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $9ccef3d11c508bf4$var$messages = (0, $7qGN1.defineMessages)({
    warning: {
        "id": "issue-navigator.sidebar.experience-registry.error-state.warning-icon-label",
        "defaultMessage": "Warning"
    },
    close: {
        "id": "issue-navigator.sidebar.experience-registry.error-state.close",
        "defaultMessage": "Close"
    },
    errorTitle: {
        "id": "issue-navigator.sidebar.experience-registry.error-state.error-title",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "issue-navigator.sidebar.experience-registry.error-state.error-body",
        "defaultMessage": "Try refreshing the page, or check your connection."
    }
});
var $9ccef3d11c508bf4$export$2e2bcd8739ae039 = $9ccef3d11c508bf4$var$messages;

});



parcelRegister("3rE61", function(module, exports) {
$parcel$export(module.exports, "ConditionalFormattingSidebarExperience", () => $c62158ffb405e94b$export$6db38da61f084c10);

var $k92KS = parcelRequire("k92KS");

var $kr84k = parcelRequire("kr84k");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $cBavF = parcelRequire("cBavF");

var $116z7 = parcelRequire("116z7");

var $cR6bn = parcelRequire("cR6bn");

var $3R3DH = parcelRequire("3R3DH");

var $k7rL0 = parcelRequire("k7rL0");

var $d8fIq = parcelRequire("d8fIq");

var $fwKw5 = parcelRequire("fwKw5");
const $c62158ffb405e94b$export$6db38da61f084c10 = ({ onClose: onClose, project: project, view: view })=>{
    const resolvedJql = (0, $fwKw5.useResolvedJql)();
    const { entryPointReferenceSubject: entryPointReferenceSubject } = (0, $3R3DH.useConditionalFormattingEntryPoint)();
    const projectData = (0, $j4oe4.useFragment)((0, $kr84k.default), project);
    const viewData = (0, $j4oe4.useFragment)((0, $k92KS.default), view);
    const errorFallback = (0, $eJOHy.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $116z7.ExperienceFailure), {
            error: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d8fIq.ErrorState), {
            onClose: onClose
        })), [
        onClose
    ]);
    if (projectData?.key == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cR6bn.JqlProvider), {
        jqlContext: `project = '${projectData?.key}'`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "conditionalFormattingSidebar",
        packageName: "jiraIssueNavigatorActionConditionalFormatting",
        errorFallback: errorFallback,
        teamName: "Keystone",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k7rL0.SidebarFallback), null),
        runtimeProps: {
            projectId: projectData?.projectId ?? undefined,
            onCloseSidebar: onClose,
            viewFragment: viewData ?? null,
            jql: resolvedJql
        }
    }));
};

});
parcelRegister("k92KS", function(module, exports) {
$parcel$export(module.exports, "default", () => $33b1c59f73288ee7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8158e509906dd65c7663d14d60c5c5a4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $33b1c59f73288ee7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConditionalFormattingSidebarExperience_view",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 20
                }
            ],
            "kind": "FragmentSpread",
            "name": "RuleList_view"
        }
    ],
    "type": "JiraSpreadsheetView",
    "abstractKey": "__isJiraSpreadsheetView"
};
$33b1c59f73288ee7$var$node.hash = "e83efaac5cf4fadc776e4ada9c645e0b";
var $33b1c59f73288ee7$export$2e2bcd8739ae039 = $33b1c59f73288ee7$var$node;

});

parcelRegister("kr84k", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e7ea71a12fa47b4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e78ddac325648d871abe1e42591de2b9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9e7ea71a12fa47b4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConditionalFormattingSidebarExperience_project",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        }
    ],
    "type": "JiraProject"
};
$9e7ea71a12fa47b4$var$node.hash = "24722a997ffa32cc5348dce4b479c001";
var $9e7ea71a12fa47b4$export$2e2bcd8739ae039 = $9e7ea71a12fa47b4$var$node;

});

parcelRegister("116z7", function(module, exports) {
$parcel$export(module.exports, "ExperienceFailure", () => $4e9d8e7acc0b9191$export$eed1d73ebdd8c7ab);

var $eJOHy = parcelRequire("eJOHy");

var $aqnJa = parcelRequire("aqnJa");

const $4e9d8e7acc0b9191$var$STABLE_EMPTY_OBJECT = {};
function $4e9d8e7acc0b9191$export$eed1d73ebdd8c7ab({ error: error, attributes: attributes = $4e9d8e7acc0b9191$var$STABLE_EMPTY_OBJECT }) {
    const onExperienceFailure = (0, $aqnJa.useExperienceFail)({
        experience: (0, $42018301743dbb45$export$a8fd8094a2b22bf9),
        attributes: attributes
    });
    (0, $eJOHy.useEffect)(()=>{
        onExperienceFailure((0, $42018301743dbb45$export$a8fd8094a2b22bf9), error);
    }, [
        attributes,
        error,
        onExperienceFailure
    ]);
    (0, $eJOHy.useMemo)(()=>{
        if (false) onExperienceFailure((0, $42018301743dbb45$export$a8fd8094a2b22bf9), error);
    }, [
        error,
        onExperienceFailure
    ]);
    return null;
}

});

parcelRegister("cR6bn", function(module, exports) {
$parcel$export(module.exports, "JqlProvider", () => $c39511b242fbd3bc$export$fdc879e2ba0da048);
$parcel$export(module.exports, "useJqlContext", () => $c39511b242fbd3bc$export$f32e2f688fc08561);

var $eJOHy = parcelRequire("eJOHy");
const $c39511b242fbd3bc$var$JqlContext = /*#__PURE__*/ (0, $eJOHy.createContext)('');
const $c39511b242fbd3bc$export$fdc879e2ba0da048 = ({ jqlContext: jqlContext, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c39511b242fbd3bc$var$JqlContext.Provider, {
        value: jqlContext
    }, children);
const $c39511b242fbd3bc$export$f32e2f688fc08561 = ()=>(0, $eJOHy.useContext)($c39511b242fbd3bc$var$JqlContext);

});

parcelRegister("k7rL0", function(module, exports) {
$parcel$export(module.exports, "SidebarFallback", () => $7c96ea13ec0cdc51$export$289c886cdbc6d1e3);

var $eJOHy = parcelRequire("eJOHy");

var $2bMVP = parcelRequire("2bMVP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $aYt5q = parcelRequire("aYt5q");
const $7c96ea13ec0cdc51$export$289c886cdbc6d1e3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $7c96ea13ec0cdc51$var$containerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        isShimmering: true,
        width: "120px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        isShimmering: true,
        width: "100%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aYt5q.ListFallback), null)));
const $7c96ea13ec0cdc51$var$containerStyle = (0, $1DXK0.xcss)({
    padding: 'space.250'
});

});
parcelRegister("aYt5q", function(module, exports) {
$parcel$export(module.exports, "ListFallback", () => $0301e20cb879b200$export$a207fef8aae38be9);

var $eJOHy = parcelRequire("eJOHy");

var $2bMVP = parcelRequire("2bMVP");

var $8nu6j = parcelRequire("8nu6j");
const $0301e20cb879b200$export$a207fef8aae38be9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        hasIcon: true,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        hasIcon: true,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        hasIcon: true,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        hasIcon: true,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        hasIcon: true,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        isShimmering: true,
        width: "120px"
    }));

});



parcelRegister("6gbGT", function(module, exports) {
$parcel$export(module.exports, "MaybeConditionalFormattingSidebarExperienceOld", () => $5901763364b6fd19$export$4e53860ff94ae25a);

var $3mNyy = parcelRequire("3mNyy");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $cBavF = parcelRequire("cBavF");

var $dQ1Tp = parcelRequire("dQ1Tp");

var $f2JN3 = parcelRequire("f2JN3");

var $116z7 = parcelRequire("116z7");

var $cR6bn = parcelRequire("cR6bn");

var $6xXfL = parcelRequire("6xXfL");

var $gk2CF = parcelRequire("gk2CF");

var $d8fIq = parcelRequire("d8fIq");
const $5901763364b6fd19$export$305cd500fd3cdbea = ({ onClose: onClose, project: project })=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject } = (0, $dQ1Tp.useConditionalFormattingEntryPoint)();
    const projectData = (0, $j4oe4.useFragment)((0, $3mNyy.default), project);
    const errorFallback = (0, $eJOHy.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $116z7.ExperienceFailure), {
            error: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d8fIq.ErrorState), {
            onClose: onClose
        })), [
        onClose
    ]);
    if (projectData?.key == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6xXfL.FormatRulesContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cR6bn.JqlProvider), {
        jqlContext: `project = '${projectData?.key}'`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "conditionalFormattingSidebar",
        packageName: "jiraIssueNavigatorActionConditionalFormatting",
        errorFallback: errorFallback,
        teamName: "Keystone",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
        runtimeProps: {
            projectId: projectData?.projectId ?? undefined,
            onClose: onClose,
            showOnboarding: false
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gk2CF.FormatRulesFragment), {
        project: projectData ?? null
    }));
};
const $5901763364b6fd19$export$4e53860ff94ae25a = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('jira_list_conditional_formatting'), $5901763364b6fd19$export$305cd500fd3cdbea, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null));

});
parcelRegister("3mNyy", function(module, exports) {
$parcel$export(module.exports, "default", () => $9fdcaef17d90d901$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<553a77e197ff24dd7c9188ac38cc24b4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9fdcaef17d90d901$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConditionalFormattingSidebarExperienceOld_project",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 20
                }
            ],
            "kind": "FragmentSpread",
            "name": "FormatRules"
        }
    ],
    "type": "JiraProject"
};
$9fdcaef17d90d901$var$node.hash = "1c67a6820bbe6210dc3b3345c97a2554";
var $9fdcaef17d90d901$export$2e2bcd8739ae039 = $9fdcaef17d90d901$var$node;

});

parcelRegister("6xXfL", function(module, exports) {
$parcel$export(module.exports, "FormatRulesContainer", () => $e028b46b483d5a36$export$2022a9665c731c36);
$parcel$export(module.exports, "useFormatRulesStore", () => $e028b46b483d5a36$export$2fe3fe2e87aa2741);
$parcel$export(module.exports, "useFormatRulesSerialisedJql", () => $e028b46b483d5a36$export$3b2286d9a476f9a1);

var $7IX73 = parcelRequire("7IX73");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4cTDP = parcelRequire("4cTDP");
const $e028b46b483d5a36$var$initialState = {
    rowRules: [],
    cellRulesByFieldId: {},
    issueIdRowRuleMatched: {},
    rulesJqlInput: {}
};
const $e028b46b483d5a36$var$actions = {
    setFormatRules: (rules)=>({ setState: setState })=>{
            const newState = {
                ...rules
            };
            setState(newState);
        },
    setRulesForJqlInput: (input)=>({ setState: setState })=>{
            const newState = {
                rulesJqlInput: input
            };
            setState(newState);
        },
    setMatchedRowRule: ({ rule: rule, issueId: issueId })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const newState = {
                issueIdRowRuleMatched: {
                    ...currentState.issueIdRowRuleMatched,
                    [issueId]: rule
                }
            };
            setState(newState);
        },
    removeMatchedRowRule: ({ ruleId: ruleId })=>({ setState: setState, getState: getState })=>{
            const { issueIdRowRuleMatched: issueIdRowRuleMatched } = getState();
            const rowRuleMatched = Object.entries(issueIdRowRuleMatched).filter(([, value])=>value.id !== ruleId);
            const newIssueIdRowRuleMatched = Object.fromEntries(rowRuleMatched);
            setState({
                issueIdRowRuleMatched: newIssueIdRowRuleMatched
            });
        }
};
const $e028b46b483d5a36$var$oldStore = (0, $GtRbT.createStore)({
    initialState: $e028b46b483d5a36$var$initialState,
    actions: $e028b46b483d5a36$var$actions,
    name: 'JWMFormatRulesOld'
});
const $e028b46b483d5a36$export$2022a9665c731c36 = (0, $6E16M.createContainer)();
const $e028b46b483d5a36$var$Store = (0, $GtRbT.createStore)({
    initialState: $e028b46b483d5a36$var$initialState,
    actions: $e028b46b483d5a36$var$actions,
    name: 'JWMFormatRules',
    containedBy: $e028b46b483d5a36$export$2022a9665c731c36
});
const $e028b46b483d5a36$var$useFormatRulesStoreOld = (0, $iJq0l.createHook)($e028b46b483d5a36$var$oldStore);
const $e028b46b483d5a36$var$useFormatRulesStoreNew = (0, $iJq0l.createHook)($e028b46b483d5a36$var$Store);
const $e028b46b483d5a36$export$2fe3fe2e87aa2741 = ()=>(0, $4cTDP.fg)('jira_list_conditional_formatting') ? $e028b46b483d5a36$var$useFormatRulesStoreNew() : $e028b46b483d5a36$var$useFormatRulesStoreOld();
const $e028b46b483d5a36$var$getSerialisedJql = (state)=>(0, $7IX73.serialiseJql)(state.rulesJqlInput);
const $e028b46b483d5a36$var$useFormatRulesSerialisedJqlOld = (0, $iJq0l.createHook)($e028b46b483d5a36$var$oldStore, {
    selector: $e028b46b483d5a36$var$getSerialisedJql
});
const $e028b46b483d5a36$var$useFormatRulesSerialisedJqlNew = (0, $iJq0l.createHook)($e028b46b483d5a36$var$Store, {
    selector: $e028b46b483d5a36$var$getSerialisedJql
});
const $e028b46b483d5a36$export$3b2286d9a476f9a1 = ()=>(0, $4cTDP.fg)('jira_list_conditional_formatting') ? $e028b46b483d5a36$var$useFormatRulesSerialisedJqlNew() : $e028b46b483d5a36$var$useFormatRulesSerialisedJqlOld();

});

parcelRegister("gk2CF", function(module, exports) {
$parcel$export(module.exports, "FormatRulesFragment", () => $ca6a3b5363934a7d$export$cf415232d9027c0b);
$parcel$export(module.exports, "FormatRules", () => $ca6a3b5363934a7d$export$85cc1c447494ea9e);

var $3yspo = parcelRequire("3yspo");

var $jXEYo = parcelRequire("jXEYo");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $dGUd3 = parcelRequire("dGUd3");

var $6xXfL = parcelRequire("6xXfL");
const $ca6a3b5363934a7d$export$cf415232d9027c0b = ({ project: project })=>{
    const [, { setFormatRules: setFormatRules, setRulesForJqlInput: setRulesForJqlInput }] = (0, $6xXfL.useFormatRulesStore)();
    const projectData = (0, $j4oe4.useFragment)((0, $jXEYo.default), project);
    (0, $eJOHy.useEffect)(()=>{
        const formattingRulesByProject = projectData?.conditionalFormattingRules;
        if (!formattingRulesByProject) return;
        /* rowRules and cellRulesByFieldId - data to be able to format per rows and per field cell */ let rowRules = [];
        const cellRulesByFieldId = {};
        const rulesJqlInput = {};
        formattingRulesByProject.edges?.forEach((edge, index)=>{
            const rule = edge?.node;
            if (rule) {
                const { formattingArea: formattingArea, formattingColor: formattingColor } = rule;
                let fieldId = null;
                let operator = 'IS';
                let value;
                switch(rule.expression.__typename){
                    case 'JiraFormattingSingleValueOperand':
                        operator = rule.expression.singleValueOperator;
                        ({ value: value, fieldId: fieldId } = rule.expression);
                        break;
                    case 'JiraFormattingMultipleValueOperand':
                        operator = rule.expression.multipleValueOperator;
                        value = rule.expression.values;
                        fieldId = rule.expression.fieldId;
                        break;
                    case 'JiraFormattingNoValueOperand':
                        operator = rule.expression.noValueOperator;
                        fieldId = rule.expression.fieldId;
                        break;
                    default:
                        break;
                }
                const color = (0, $dGUd3.formattingColors)[formattingColor.colorKey || ''];
                const mappedRule = {
                    id: rule.id,
                    fieldId: fieldId,
                    operator: operator,
                    value: value,
                    color: color?.value,
                    formattingArea: formattingArea,
                    index: index,
                    hoverColor: color?.hoverValue
                };
                if (mappedRule.fieldId) {
                    if (mappedRule.formattingArea === 'ROW') rowRules = [
                        ...rowRules,
                        mappedRule
                    ];
                    else cellRulesByFieldId[mappedRule.fieldId] = [
                        ...cellRulesByFieldId[mappedRule.fieldId] || [],
                        mappedRule
                    ];
                    // input to serialise jql input
                    const DUMMY_VALUE = '-';
                    const values = Array.isArray(mappedRule.value) ? mappedRule.value : [
                        mappedRule.value
                    ];
                    if (!rulesJqlInput[mappedRule.fieldId]) rulesJqlInput[mappedRule.fieldId] = [];
                    values.forEach((ruleValue)=>{
                        if (mappedRule.fieldId) rulesJqlInput[mappedRule.fieldId]?.push({
                            value: ruleValue ?? DUMMY_VALUE,
                            label: ruleValue ?? DUMMY_VALUE
                        });
                    });
                }
            }
        });
        setFormatRules({
            rowRules: rowRules,
            cellRulesByFieldId: cellRulesByFieldId
        });
        setRulesForJqlInput(rulesJqlInput);
    }, [
        projectData?.conditionalFormattingRules,
        setFormatRules,
        setRulesForJqlInput
    ]);
    return null;
};
const $ca6a3b5363934a7d$export$85cc1c447494ea9e = ({ query: query })=>{
    const [, { setFormatRules: setFormatRules, setRulesForJqlInput: setRulesForJqlInput }] = (0, $6xXfL.useFormatRulesStore)();
    const { jira: jira } = (0, $j4oe4.usePreloadedQuery)((0, $3yspo.default), query);
    if ((0, $4cTDP.fg)('jira_list_conditional_formatting')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ca6a3b5363934a7d$export$cf415232d9027c0b, {
        project: jira?.jiraProjectByKey ?? null
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useEffect)(()=>{
        const formattingRulesByProject = jira?.jiraProjectByKey?.conditionalFormattingRules;
        if (!formattingRulesByProject) return;
        /* rowRules and cellRulesByFieldId - data to be able to format per rows and per field cell */ let rowRules = [];
        const cellRulesByFieldId = {};
        const rulesJqlInput = {};
        formattingRulesByProject.edges?.forEach((edge, index)=>{
            const rule = edge?.node;
            if (rule) {
                const { formattingArea: formattingArea, formattingColor: formattingColor } = rule;
                let fieldId = null;
                let operator = 'IS';
                let value;
                switch(rule.expression.__typename){
                    case 'JiraFormattingSingleValueOperand':
                        operator = rule.expression.singleValueOperator;
                        ({ value: value, fieldId: fieldId } = rule.expression);
                        break;
                    case 'JiraFormattingMultipleValueOperand':
                        operator = rule.expression.multipleValueOperator;
                        value = rule.expression.values;
                        fieldId = rule.expression.fieldId;
                        break;
                    case 'JiraFormattingNoValueOperand':
                        operator = rule.expression.noValueOperator;
                        fieldId = rule.expression.fieldId;
                        break;
                    default:
                        break;
                }
                const color = (0, $dGUd3.formattingColors)[formattingColor.colorKey || ''];
                const mappedRule = {
                    id: rule.id,
                    fieldId: fieldId,
                    operator: operator,
                    value: value,
                    color: color?.value,
                    formattingArea: formattingArea,
                    index: index,
                    hoverColor: color?.hoverValue
                };
                if (mappedRule.fieldId) {
                    if (mappedRule.formattingArea === 'ROW') rowRules = [
                        ...rowRules,
                        mappedRule
                    ];
                    else cellRulesByFieldId[mappedRule.fieldId] = [
                        ...cellRulesByFieldId[mappedRule.fieldId] || [],
                        mappedRule
                    ];
                    // input to serialise jql input
                    const DUMMY_VALUE = '-';
                    const values = Array.isArray(mappedRule.value) ? mappedRule.value : [
                        mappedRule.value
                    ];
                    if (!rulesJqlInput[mappedRule.fieldId]) rulesJqlInput[mappedRule.fieldId] = [];
                    values.forEach((ruleValue)=>{
                        if (mappedRule.fieldId) rulesJqlInput[mappedRule.fieldId]?.push({
                            value: ruleValue ?? DUMMY_VALUE,
                            label: ruleValue ?? DUMMY_VALUE
                        });
                    });
                }
            }
        });
        setFormatRules({
            rowRules: rowRules,
            cellRulesByFieldId: cellRulesByFieldId
        });
        setRulesForJqlInput(rulesJqlInput);
    }, [
        jira?.jiraProjectByKey?.conditionalFormattingRules,
        setFormatRules,
        setRulesForJqlInput
    ]);
    return null;
};

});
parcelRegister("3yspo", function(module, exports) {
$parcel$export(module.exports, "default", () => $0fd7e83655baad10$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b04f03ebac43e14823c695fee7c96bac>>
 * @relayHash 675361bd8a0cbf4e577c3d4a64e58d93
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a053b466a5a7278a0b6b6373921b28f57107b4a597af1f3eaa118e9a60bc2b09

var $37Ewn = parcelRequire("37Ewn");
const $0fd7e83655baad10$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "colorKey"
    }, v7 = {
        "kind": "ScalarField",
        "name": "formattingArea"
    }, v8 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v9 = {
        "kind": "LinkedField",
        "name": "expression",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "alias": "singleValueOperator",
                        "kind": "ScalarField",
                        "name": "operator"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ],
                "type": "JiraFormattingSingleValueOperand"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "alias": "multipleValueOperator",
                        "kind": "ScalarField",
                        "name": "operator"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "values"
                    }
                ],
                "type": "JiraFormattingMultipleValueOperand"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "alias": "noValueOperator",
                        "kind": "ScalarField",
                        "name": "operator"
                    }
                ],
                "type": "JiraFormattingNoValueOperand"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "FormatRulesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "kind": "FragmentSpread",
                                    "name": "FormatRules"
                                },
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraFormattingRuleConnection",
                                    "kind": "LinkedField",
                                    "name": "conditionalFormattingRules",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFormattingRuleEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFormattingRule",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraColor",
                                                            "kind": "LinkedField",
                                                            "name": "formattingColor",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ 
                                                            ]
                                                        },
                                                        v7 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "FormatRulesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraFormattingRuleConnection",
                                    "kind": "LinkedField",
                                    "name": "conditionalFormattingRules",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFormattingRuleEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFormattingRule",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraColor",
                                                            "kind": "LinkedField",
                                                            "name": "formattingColor",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        v7 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a053b466a5a7278a0b6b6373921b28f57107b4a597af1f3eaa118e9a60bc2b09",
            "metadata": {},
            "name": "FormatRulesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0fd7e83655baad10$var$node.hash = "a18a3649745191d38e6ffb3470019909";
(0, $37Ewn.PreloadableQueryRegistry).set($0fd7e83655baad10$var$node.params.id, $0fd7e83655baad10$var$node);
var $0fd7e83655baad10$export$2e2bcd8739ae039 = $0fd7e83655baad10$var$node;

});

parcelRegister("jXEYo", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6024108970a7267$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<64d987680eaf97ad3df7137360486810>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a6024108970a7267$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "first"
            }
        ],
        "kind": "Fragment",
        "name": "FormatRules",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "first"
                    }
                ],
                "concreteType": "JiraFormattingRuleConnection",
                "kind": "LinkedField",
                "name": "conditionalFormattingRules",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraFormattingRuleEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraFormattingRule",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "formattingColor",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "colorKey"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "formattingArea"
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "expression",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "singleValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "value"
                                                    }
                                                ],
                                                "type": "JiraFormattingSingleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "multipleValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "values"
                                                    }
                                                ],
                                                "type": "JiraFormattingMultipleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "noValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    }
                                                ],
                                                "type": "JiraFormattingNoValueOperand"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraProject"
    };
}();
$a6024108970a7267$var$node.hash = "53cee9935758d1283f056e0039c8153a";
var $a6024108970a7267$export$2e2bcd8739ae039 = $a6024108970a7267$var$node;

});

parcelRegister("dGUd3", function(module, exports) {
$parcel$export(module.exports, "formattingColors", () => $a4eb1a317ca8f680$export$2fedf4ac4eb04087);
$parcel$export(module.exports, "accessibleFormattingColors", () => $a4eb1a317ca8f680$export$bef44f43b99e197e);
$parcel$export(module.exports, "getColorKeyFromValue", () => $a4eb1a317ca8f680$export$ae7e938b8bdf2df5);

var $LFmXM = parcelRequire("LFmXM");

var $4hch1 = parcelRequire("4hch1");
const $a4eb1a317ca8f680$export$2fedf4ac4eb04087 = {
    lightPurple: {
        label: (0, $4hch1.default).lightPurple,
        value: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
        hoverValue: "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)"
    },
    lightBlue: {
        label: (0, $4hch1.default).lightBlue,
        value: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
        hoverValue: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)"
    },
    lightGreen: {
        label: (0, $4hch1.default).lightGreen,
        value: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
        hoverValue: "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)"
    },
    lightTeal: {
        label: (0, $4hch1.default).lightTeal,
        value: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
        hoverValue: "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)"
    },
    lightYellow: {
        label: (0, $4hch1.default).lightYellow,
        value: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        hoverValue: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)"
    },
    lightRed: {
        label: (0, $4hch1.default).lightRed,
        value: "var(--ds-background-accent-red-subtlest, #FFECEB)",
        hoverValue: "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)"
    },
    lightGray: {
        label: (0, $4hch1.default).lightGray,
        value: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
        hoverValue: "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"
    },
    purple: {
        label: (0, $4hch1.default).purple,
        value: "var(--ds-background-accent-purple-subtler, #EED7FC)",
        hoverValue: "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)"
    },
    blue: {
        label: (0, $4hch1.default).blue,
        value: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
        hoverValue: "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)"
    },
    green: {
        label: (0, $4hch1.default).green,
        value: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        hoverValue: "var(--ds-background-accent-green-subtler-hovered, #97EDC9)"
    },
    teal: {
        label: (0, $4hch1.default).teal,
        value: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        hoverValue: "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)"
    },
    yellow: {
        label: (0, $4hch1.default).yellow,
        value: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        hoverValue: "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)"
    },
    red: {
        label: (0, $4hch1.default).red,
        value: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        hoverValue: "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)"
    },
    gray: {
        label: (0, $4hch1.default).gray,
        value: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
        hoverValue: "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)"
    }
};
const $a4eb1a317ca8f680$var$nonAccessibleColors = new Set([
    'lightBlue',
    'blue'
]);
const $a4eb1a317ca8f680$export$bef44f43b99e197e = Object.fromEntries(Object.entries($a4eb1a317ca8f680$export$2fedf4ac4eb04087).filter(([key])=>!$a4eb1a317ca8f680$var$nonAccessibleColors.has(key)));
const $a4eb1a317ca8f680$export$ae7e938b8bdf2df5 = (0, $LFmXM.default)((value)=>{
    const selectedColor = Object.entries($a4eb1a317ca8f680$export$2fedf4ac4eb04087).find(([_, color])=>color.value.split(',')[0] === value.split(',')[0]);
    return selectedColor?.[0];
});

});
parcelRegister("4hch1", function(module, exports) {
$parcel$export(module.exports, "default", () => $059b0cba1e2b3d71$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $059b0cba1e2b3d71$var$messages = (0, $7qGN1.defineMessages)({
    lightPurple: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-purple",
        "defaultMessage": "Subtle purple"
    },
    lightBlue: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-blue",
        "defaultMessage": "Subtle blue"
    },
    lightGreen: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-green",
        "defaultMessage": "Subtle green"
    },
    lightTeal: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-teal",
        "defaultMessage": "Subtle teal"
    },
    lightYellow: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-yellow",
        "defaultMessage": "Subtle yellow"
    },
    lightRed: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-red",
        "defaultMessage": "Subtle red"
    },
    lightGray: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-gray",
        "defaultMessage": "Subtle gray"
    },
    purple: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.purple",
        "defaultMessage": "Bold purple"
    },
    blue: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.blue",
        "defaultMessage": "Bold blue"
    },
    green: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.green",
        "defaultMessage": "Bold green"
    },
    teal: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.teal",
        "defaultMessage": "Bold teal"
    },
    yellow: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.yellow",
        "defaultMessage": "Bold yellow"
    },
    red: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.red",
        "defaultMessage": "Bold red"
    },
    gray: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.gray",
        "defaultMessage": "Bold gray"
    }
});
var $059b0cba1e2b3d71$export$2e2bcd8739ae039 = $059b0cba1e2b3d71$var$messages;

});





parcelRegister("5eCXQ", function(module, exports) {
$parcel$export(module.exports, "SpotlightExploreListClickListener", () => $570edcd65c450728$export$b2f7d074212242f3);

var $eJOHy = parcelRequire("eJOHy");

var $82cqT = parcelRequire("82cqT");

var $5V25X = parcelRequire("5V25X");

var $iRahl = parcelRequire("iRahl");

var $HiS1C = parcelRequire("HiS1C");

var $eibCx = parcelRequire("eibCx");

var $fwKw5 = parcelRequire("fwKw5");
const $570edcd65c450728$var$EXPLORE_LIST_TRIGGER = 'jira-nin-list-merge-modal-onboarding-explore-list-clicked';
const $570edcd65c450728$export$b2f7d074212242f3 = ()=>{
    const { filterId: filterId } = (0, $fwKw5.useActiveJql)();
    const { setView: setView } = (0, $HiS1C.useSelectedViewActions)();
    const hasClicked = (0, $eJOHy.useRef)(false);
    const { isActive: isExploreListViewClicked } = (0, $5V25X.useTrigger)($570edcd65c450728$var$EXPLORE_LIST_TRIGGER);
    (0, $eJOHy.useEffect)(()=>{
        if (!hasClicked.current && isExploreListViewClicked) {
            const newView = filterId && (0, $82cqT.isCustomFilter)(filterId) ? (0, $eibCx.convertFilterIdToIssueNavigatorId)(filterId) : (0, $iRahl.LIST_VIEW_ID);
            setView(newView, '');
            hasClicked.current = true;
        }
    }, [
        filterId,
        isExploreListViewClicked,
        setView
    ]);
    return null;
};

});

parcelRegister("8Eogd", function(module, exports) {
$parcel$export(module.exports, "MigrateListConfigClickListener", () => $2565591394cfe4d2$export$677675f58dfec200);

var $8hNuP = parcelRequire("8hNuP");

var $hqI6m = parcelRequire("hqI6m");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $5V25X = parcelRequire("5V25X");

var $4cTDP = parcelRequire("4cTDP");

var $fDGY8 = parcelRequire("fDGY8");

var $keS9e = parcelRequire("keS9e");

var $3kDjB = parcelRequire("3kDjB");
const $2565591394cfe4d2$var$MIGRATE_CONFIG_TRIGGER = 'jira-nin-list-merge-modal-onboarding-explore-list-view-button-clicked-with-copy-list-settings';
const $2565591394cfe4d2$var$MIGRATE_CONFIG_TRIGGER_PAID_CURRENT_SPACE = 'jira-nin-paid-list-merge-modal-onboarding-explore-list-view-button-clicked-migrate-current-space';
const $2565591394cfe4d2$var$MIGRATE_CONFIG_TRIGGER_PAID_ALL_SPACES = 'jira-nin-paid-list-merge-modal-onboarding-explore-list-view-button-clicked-migrate-all-spaces';
const $2565591394cfe4d2$export$677675f58dfec200 = ({ onChangeJqlAndGroupBy: onChangeJqlAndGroupBy, project: project, view: view })=>{
    const projectData = (0, $j4oe4.useFragment)((0, $hqI6m.default), project);
    const viewData = (0, $j4oe4.useFragment)((0, $8hNuP.default), view);
    let viewId = viewData.id;
    if ((0, $4cTDP.fg)('saved_list_view_technical_changes')) {
        if (!viewData.savedViewId) throw new Error('Missing saved view ID');
        viewId = viewData.savedViewId;
    }
    const { changeGroupedByFieldAndJql: changeGroupedByFieldAndJql } = (0, $4cTDP.fg)('jira_paid_list_nin_merge') ? // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $3kDjB.useIssueSearchActions)() : {
        changeGroupedByFieldAndJql: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    };
    const migrateListConfig = (0, $fDGY8.useListNINConfigMigration)({
        projectId: projectData.projectId,
        projectKey: projectData.key,
        viewId: viewId,
        onChangeJqlAndGroupBy: onChangeJqlAndGroupBy
    });
    const { migrateCurrentProject: migrateCurrentProject, migrateAllProjects: migrateAllProjects } = (0, $4cTDP.fg)('jira_paid_list_nin_merge') ? // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $keS9e.usePaidListNINConfigMigration)({
        currentProjectId: projectData.projectId,
        currentProjectKey: projectData.key,
        onChangeJqlAndGroupBy: onChangeJqlAndGroupBy,
        onMigrationCompleted: changeGroupedByFieldAndJql
    }) : {
        migrateCurrentProject: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        migrateAllProjects: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    };
    const hasClicked = (0, $eJOHy.useRef)(false);
    const { isActive: isMigrateListConfigClicked } = (0, $5V25X.useTrigger)($2565591394cfe4d2$var$MIGRATE_CONFIG_TRIGGER);
    const { isActive: isMigrateListConfigClickedPaidCurrentProject } = (0, $4cTDP.fg)('jira_paid_list_nin_merge') ? // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $5V25X.useTrigger)($2565591394cfe4d2$var$MIGRATE_CONFIG_TRIGGER_PAID_CURRENT_SPACE) : {
        isActive: false
    };
    const { isActive: isMigrateListConfigClickedPaidAllProjects } = (0, $4cTDP.fg)('jira_paid_list_nin_merge') ? // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $5V25X.useTrigger)($2565591394cfe4d2$var$MIGRATE_CONFIG_TRIGGER_PAID_ALL_SPACES) : {
        isActive: false
    };
    const { fireTrigger: fireCurrentProjectTrigger } = (0, $4cTDP.fg)('jira_paid_list_nin_merge') ? // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $5V25X.useFirePostOfficeTrigger)({
        triggerId: $2565591394cfe4d2$var$MIGRATE_CONFIG_TRIGGER_PAID_CURRENT_SPACE
    }) : {
        fireTrigger: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    };
    const { fireTrigger: fireAllProjectsTrigger } = (0, $4cTDP.fg)('jira_paid_list_nin_merge') ? // eslint-disable-next-line  react-hooks/rules-of-hooks
    (0, $5V25X.useFirePostOfficeTrigger)({
        triggerId: $2565591394cfe4d2$var$MIGRATE_CONFIG_TRIGGER_PAID_ALL_SPACES
    }) : {
        fireTrigger: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    };
    (0, $eJOHy.useEffect)(()=>{
        if (!hasClicked.current && isMigrateListConfigClicked) {
            migrateListConfig();
            hasClicked.current = true;
        }
    }, [
        isMigrateListConfigClicked,
        migrateListConfig
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!hasClicked.current && isMigrateListConfigClickedPaidCurrentProject && (0, $4cTDP.fg)('jira_paid_list_nin_merge')) {
            migrateCurrentProject();
            hasClicked.current = true;
            fireCurrentProjectTrigger({
                isActive: false
            });
        }
    }, [
        isMigrateListConfigClickedPaidCurrentProject,
        migrateCurrentProject,
        fireCurrentProjectTrigger
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!hasClicked.current && isMigrateListConfigClickedPaidAllProjects && (0, $4cTDP.fg)('jira_paid_list_nin_merge')) {
            migrateAllProjects();
            hasClicked.current = true;
            fireAllProjectsTrigger({
                isActive: false
            });
        }
    }, [
        isMigrateListConfigClickedPaidAllProjects,
        migrateAllProjects,
        fireAllProjectsTrigger
    ]);
    return null;
};

});
parcelRegister("8hNuP", function(module, exports) {
$parcel$export(module.exports, "default", () => $57d73c121834e3b2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a15cd19c4eb175d06f665a3510cfe482>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $57d73c121834e3b2$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "MigrateListConfigClickListener_JiraView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "savedViewId"
                }
            ]
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$57d73c121834e3b2$var$node.hash = "c00cd5f5556284e990fce30c0e39a138";
var $57d73c121834e3b2$export$2e2bcd8739ae039 = $57d73c121834e3b2$var$node;

});

parcelRegister("hqI6m", function(module, exports) {
$parcel$export(module.exports, "default", () => $460c2f5647ecfa9e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<777346b32900b694debf88f702d5edc6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $460c2f5647ecfa9e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "MigrateListConfigClickListener_JiraProject",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        }
    ],
    "type": "JiraProject"
};
$460c2f5647ecfa9e$var$node.hash = "f3ad4cc29877caa8f8c8511c066b510d";
var $460c2f5647ecfa9e$export$2e2bcd8739ae039 = $460c2f5647ecfa9e$var$node;

});

parcelRegister("fDGY8", function(module, exports) {
$parcel$export(module.exports, "useListNINConfigMigration", () => $ef7be14c68f507fa$export$d634a0215ff417dd);

var $eJOHy = parcelRequire("eJOHy");

var $ktFj6 = parcelRequire("ktFj6");

var $3kDjB = parcelRequire("3kDjB");

var $3NnH8 = parcelRequire("3NnH8");
const $ef7be14c68f507fa$var$useListMigrationDataForProject = (projectId)=>{
    return (0, $eJOHy.useMemo)(()=>projectId ? (0, $3NnH8.getMigrationDataForProject)(projectId) : null, [
        projectId
    ]);
};
const $ef7be14c68f507fa$export$d634a0215ff417dd = ({ projectId: projectId, projectKey: projectKey, viewId: viewId, onChangeJqlAndGroupBy: onChangeJqlAndGroupBy })=>{
    const setSelectedGrouping = (0, $ktFj6.useSetSelectedGrouping)();
    const { changeGroupedByFieldAndJql: changeGroupedByFieldAndJql } = (0, $3kDjB.useIssueSearchActions)();
    const storedMigrationData = $ef7be14c68f507fa$var$useListMigrationDataForProject(projectId);
    const handleChangeGroupedByField = (0, $eJOHy.useCallback)((newGroupByField)=>{
        if (!newGroupByField?.fieldId || !storedMigrationData || !projectKey) return;
        const newJql = (0, $3NnH8.getJqlFromMigrationData)(storedMigrationData, projectKey);
        changeGroupedByFieldAndJql(newGroupByField.fieldId, newJql);
        onChangeJqlAndGroupBy?.({
            jql: newJql,
            groupBy: newGroupByField.fieldId
        });
    }, [
        storedMigrationData,
        projectKey,
        changeGroupedByFieldAndJql,
        onChangeJqlAndGroupBy
    ]);
    return (0, $eJOHy.useCallback)(()=>{
        if (!storedMigrationData || !projectKey) return;
        const { groupBy: groupBy, filter: filter, sorting: sorting } = storedMigrationData;
        if (groupBy) {
            setSelectedGrouping({
                fieldId: groupBy,
                fieldName: groupBy,
                viewId: viewId,
                onUpdateGroupByFieldAndRefetch: handleChangeGroupedByField
            });
            return;
        }
        if (filter || sorting) {
            const newJql = (0, $3NnH8.getJqlFromMigrationData)(storedMigrationData, projectKey);
            onChangeJqlAndGroupBy?.({
                jql: newJql
            });
        }
    }, [
        viewId,
        storedMigrationData,
        setSelectedGrouping,
        handleChangeGroupedByField,
        onChangeJqlAndGroupBy,
        projectKey
    ]);
};

});
parcelRegister("ktFj6", function(module, exports) {
$parcel$export(module.exports, "useSetSelectedGrouping", () => $1954bdc3f406c1c5$export$d8b093c63d9e565a);

var $ghi6F = parcelRequire("ghi6F");

var $1pC6h = parcelRequire("1pC6h");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");

var $9pTd3 = parcelRequire("9pTd3");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $4cTDP = parcelRequire("4cTDP");

var $kqd31 = parcelRequire("kqd31");

const $1954bdc3f406c1c5$var$recentlyUsedConnectionUpdater = (store, recentlyUsedConnectionId, fieldId)=>{
    const recentlyUsedConnection = store.get(recentlyUsedConnectionId);
    if (!recentlyUsedConnection) return;
    const fieldDataId = (0, $kqd31.default)({
        id: fieldId
    }, 'JiraField');
    if (!fieldDataId) return;
    const fieldNode = store.get(fieldDataId);
    if (!fieldNode) return;
    (0, $37Ewn.ConnectionHandler).deleteNode(recentlyUsedConnection, fieldDataId);
    const newEdge = (0, $37Ewn.ConnectionHandler).createEdge(store, recentlyUsedConnection, fieldNode, 'JiraSpreadsheetGroupByFieldOptionEdge');
    (0, $37Ewn.ConnectionHandler).insertEdgeBefore(recentlyUsedConnection, newEdge);
    // Ensure the list doesn't exceed 5 items
    const updatedEdges = recentlyUsedConnection.getLinkedRecords('edges') || [];
    if (updatedEdges.length > 5) {
        const lastEdge = updatedEdges[updatedEdges.length - 1];
        const lastNode = lastEdge?.getLinkedRecord('node');
        const lastNodeId = lastNode?.getDataID();
        if (typeof lastNodeId === 'string') (0, $37Ewn.ConnectionHandler).deleteNode(recentlyUsedConnection, lastNodeId);
    }
};
const $1954bdc3f406c1c5$export$d8b093c63d9e565a = ()=>{
    const [commitOld] = (0, $j4oe4.useMutation)((0, $1pC6h.default));
    const [commit] = (0, $j4oe4.useMutation)((0, $ghi6F.default));
    const onExperienceStart = (0, $8Uqf3.useExperienceStart)({
        experience: (0, $8e6e35a2682b0ead$export$64d8bb86ca32b86),
        analyticsSource: (0, $8e6e35a2682b0ead$export$f7109619a5e9e0d6)
    });
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $8e6e35a2682b0ead$export$64d8bb86ca32b86)
    });
    const onExperienceSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: (0, $8e6e35a2682b0ead$export$64d8bb86ca32b86)
    });
    const handleError = (0, $eJOHy.useCallback)((error)=>{
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'issueTableGroupByDropdownMutation',
                packageName: (0, $8e6e35a2682b0ead$export$b8b9d90f9e5bd72b),
                teamName: (0, $8e6e35a2682b0ead$export$d57b6b390e78d90f)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        onExperienceFail((0, $8e6e35a2682b0ead$export$b8b9d90f9e5bd72b), error);
    }, [
        onExperienceFail
    ]);
    return (0, $eJOHy.useCallback)(({ fieldId: fieldId, fieldName: fieldName, viewId: viewId, onUpdateGroupByFieldAndRefetch: onUpdateGroupByFieldAndRefetch, recentlyUsedConnectionId: recentlyUsedConnectionId })=>{
        onExperienceStart();
        if ((0, $4cTDP.fg)('saved_list_view_technical_changes')) {
            commit({
                variables: {
                    input: {
                        viewId: viewId,
                        fieldId: fieldId
                    }
                },
                updater: (store)=>{
                    if (recentlyUsedConnectionId && fieldId) $1954bdc3f406c1c5$var$recentlyUsedConnectionUpdater(store, recentlyUsedConnectionId, fieldId);
                },
                onCompleted: (payload)=>{
                    if (payload?.jira_setIssueSearchGroupBy?.success) onExperienceSuccess();
                    else {
                        const error = new Error(payload?.jira_setIssueSearchGroupBy?.errors?.[0]?.message ?? 'Failed to update group by field: Unknown Error occurred');
                        handleError(error);
                    }
                },
                onError: (error)=>{
                    handleError(error);
                }
            });
            // refetch query optimistically
            onUpdateGroupByFieldAndRefetch(fieldId && fieldName ? {
                fieldId: fieldId,
                name: fieldName
            } : null);
        } else {
            commitOld({
                variables: {
                    viewId: viewId,
                    fieldId: fieldId
                },
                updater: (store)=>{
                    if (recentlyUsedConnectionId && fieldId) $1954bdc3f406c1c5$var$recentlyUsedConnectionUpdater(store, recentlyUsedConnectionId, fieldId);
                },
                onCompleted: (payload)=>{
                    if (payload?.jira?.updateIssueSearchGroupByConfig?.success) onExperienceSuccess();
                    else {
                        const error = new Error(payload?.jira?.updateIssueSearchGroupByConfig?.errors?.[0]?.message ?? 'Failed to update group by field: Unknown Error occurred');
                        handleError(error);
                    }
                },
                onError: (error)=>{
                    handleError(error);
                }
            });
            onUpdateGroupByFieldAndRefetch(fieldId && fieldName ? {
                fieldId: fieldId,
                name: fieldName
            } : null);
        }
    }, [
        onExperienceStart,
        commit,
        onExperienceSuccess,
        handleError,
        commitOld
    ]);
};

});
parcelRegister("ghi6F", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7df4f75a3d5e638$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bdd2aa2762ac04ff6fe929ececc39d50>>
 * @relayHash 24954ddd5c61bb46d0c12ca8ce658977
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 07a0b6d0ab3fa61d2f1b700272cee29bfe3a244016f235e944d93196d101b083
const $f7df4f75a3d5e638$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "JiraSetIssueSearchGroupByPayload",
            "kind": "LinkedField",
            "name": "jira_setIssueSearchGroupBy",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSetSelectedGroupingMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSetSelectedGroupingMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "07a0b6d0ab3fa61d2f1b700272cee29bfe3a244016f235e944d93196d101b083",
            "metadata": {},
            "name": "useSetSelectedGroupingMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$f7df4f75a3d5e638$var$node.hash = "826544f4dd8f660081396531556cffe4";
var $f7df4f75a3d5e638$export$2e2bcd8739ae039 = $f7df4f75a3d5e638$var$node;

});

parcelRegister("1pC6h", function(module, exports) {
$parcel$export(module.exports, "default", () => $41917b7032f08fce$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<18447534f3f88ef5dc38d784df90549d>>
 * @relayHash 923b3a0cc62d702329135466ee6ed542
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d9bc5bb7a9cb65d7601583747fa24fc64d2a9b0aeeb3d7be0625fc77f76e83c9
const $41917b7032f08fce$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v2 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "fieldId",
                            "variableName": "fieldId"
                        },
                        {
                            "kind": "Variable",
                            "name": "viewId",
                            "variableName": "viewId"
                        }
                    ],
                    "concreteType": "JiraIssueSearchGroupByFieldMutationPayload",
                    "kind": "LinkedField",
                    "name": "updateIssueSearchGroupByConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSetSelectedGroupingOldMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSetSelectedGroupingOldMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "d9bc5bb7a9cb65d7601583747fa24fc64d2a9b0aeeb3d7be0625fc77f76e83c9",
            "metadata": {},
            "name": "useSetSelectedGroupingOldMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$41917b7032f08fce$var$node.hash = "a731023d2c60df2dbf21e0f2d0a2a2a8";
var $41917b7032f08fce$export$2e2bcd8739ae039 = $41917b7032f08fce$var$node;

});



parcelRegister("keS9e", function(module, exports) {
$parcel$export(module.exports, "usePaidListNINConfigMigration", () => $17ea532d364929fc$export$e43cbaf07d1fb857);

var $6HgRa = parcelRequire("6HgRa");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $cHtIB = parcelRequire("cHtIB");

var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $K4WWF = parcelRequire("K4WWF");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $iRahl = parcelRequire("iRahl");

var $3NnH8 = parcelRequire("3NnH8");

var $g6t48 = parcelRequire("g6t48");

var $76Jvn = parcelRequire("76Jvn");
const $17ea532d364929fc$var$IN_PROGRESS_FLAG_ID = 'paid-list-ninconfig-migration-in-progress';
const $17ea532d364929fc$var$ERROR_FLAG_ID = 'paid-list-ninconfig-migration-error';
const $17ea532d364929fc$var$IN_PROGRESS_FLAG_CONFIG = {
    id: $17ea532d364929fc$var$IN_PROGRESS_FLAG_ID,
    type: 'info',
    messageType: 'transactional',
    messageId: 'issue-navigator.services.list-nin-config-migration.in-progress-flag-config.info',
    render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $76Jvn.InProgressFlag), null)
};
const $17ea532d364929fc$var$MAX_PROJECTS_PER_REQUEST = 100;
function $17ea532d364929fc$var$chunkArray(projectData, size) {
    const out = [];
    for(let i = 0; i < projectData.length; i += size)out.push(projectData.slice(i, i + size));
    return out;
}
const $17ea532d364929fc$export$e43cbaf07d1fb857 = ({ currentProjectId: currentProjectId, currentProjectKey: currentProjectKey, onChangeJqlAndGroupBy: onChangeJqlAndGroupBy, onMigrationCompleted: onMigrationCompleted })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $cSXp8.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleError = (0, $eJOHy.useCallback)((error, onRetry)=>{
        dismissFlag($17ea532d364929fc$var$IN_PROGRESS_FLAG_ID);
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'paidListNINConfigMigration',
                packageName: (0, $iRahl.PACKAGE_NAME),
                teamName: (0, $iRahl.TEAM_NAME)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        showFlag({
            type: 'error',
            title: (0, $g6t48.default).listMigrationErrorFlag,
            messageType: 'transactional',
            messageId: 'issue-navigator.services.list-nin-config-migration.show-flag.error',
            actions: [
                {
                    content: formatMessage((0, $g6t48.default).listMigrationTryAgainAction),
                    onClick: ()=>{
                        dismissFlag($17ea532d364929fc$var$ERROR_FLAG_ID);
                        onRetry();
                    }
                }
            ]
        });
    }, [
        showFlag,
        formatMessage,
        dismissFlag
    ]);
    const handleSuccess = (0, $eJOHy.useCallback)((migrationData)=>{
        dismissFlag($17ea532d364929fc$var$IN_PROGRESS_FLAG_ID);
        showFlag({
            type: 'success',
            title: (0, $g6t48.default).listMigrationSuccessFlag,
            messageType: 'transactional',
            messageId: 'issue-navigator.services.list-nin-config-migration.show-flag.success',
            isAutoDismiss: true
        });
        if (!migrationData || !currentProjectKey) return;
        const jql = (0, $3NnH8.getJqlFromMigrationData)(migrationData, currentProjectKey);
        onMigrationCompleted?.(migrationData?.groupBy ?? null, jql);
        // Updates JQL and groupBy for current project if current project has had settings merged
        onChangeJqlAndGroupBy?.({
            jql: jql,
            groupBy: migrationData?.groupBy ?? undefined
        });
        const analyticsEvent = createAnalyticsEvent({});
        (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'paidListNINConfigMigration success');
    }, [
        onChangeJqlAndGroupBy,
        showFlag,
        dismissFlag,
        currentProjectKey,
        onMigrationCompleted,
        createAnalyticsEvent
    ]);
    const [migrateCurrentProjectMutation] = (0, $j4oe4.useMutation)((0, $6HgRa.default));
    const migrateCurrentProject = (0, $eJOHy.useCallback)(()=>{
        if (!currentProjectId) return;
        const paidMigrationData = (0, $3NnH8.getPaidMigrationDataForProject)(currentProjectId);
        const { groupBy: groupBy, fieldsDetail: fieldsDetail, filter: filter } = paidMigrationData;
        if (!groupBy && !fieldsDetail && !filter) return;
        const jql = (0, $3NnH8.getPaidJqlFromMigrationData)(paidMigrationData);
        showFlag($17ea532d364929fc$var$IN_PROGRESS_FLAG_CONFIG);
        migrateCurrentProjectMutation({
            variables: {
                input: {
                    cloudId: cloudId,
                    nodes: [
                        {
                            projectId: Number(currentProjectId),
                            columns: fieldsDetail?.order ?? undefined,
                            jql: jql ?? undefined,
                            groupBy: groupBy ?? undefined
                        }
                    ]
                }
            },
            onError: (error)=>{
                handleError(error, migrateCurrentProject);
            },
            onCompleted: (response)=>{
                if (response.jira_listSettingMigrationMutation?.success !== true) {
                    handleError(new (0, $K4WWF.MutationErrorCollection)(response.jira_listSettingMigrationMutation?.errors), migrateCurrentProject);
                    return;
                }
                handleSuccess(paidMigrationData);
            }
        });
    }, [
        currentProjectId,
        cloudId,
        migrateCurrentProjectMutation,
        handleError,
        handleSuccess,
        showFlag
    ]);
    const migrateAllProjects = (0, $eJOHy.useCallback)(()=>{
        const configuredProjectIds = (0, $3NnH8.getConfiguredProjectIdsFromLocalStorage)();
        if (configuredProjectIds.length === 0) return;
        showFlag($17ea532d364929fc$var$IN_PROGRESS_FLAG_CONFIG);
        let currentProjectData = null;
        const nodes = configuredProjectIds.map((projectId)=>{
            const paidMigrationData = (0, $3NnH8.getPaidMigrationDataForProject)(projectId);
            const jql = (0, $3NnH8.getPaidJqlFromMigrationData)(paidMigrationData);
            const { groupBy: groupBy, fieldsDetail: fieldsDetail } = paidMigrationData;
            if (projectId === currentProjectId) currentProjectData = paidMigrationData;
            return {
                projectId: Number(projectId),
                columns: fieldsDetail?.order ?? undefined,
                jql: jql ?? undefined,
                groupBy: groupBy ?? undefined
            };
        });
        const chunks = $17ea532d364929fc$var$chunkArray(nodes, $17ea532d364929fc$var$MAX_PROJECTS_PER_REQUEST);
        const commitChunk = (chunkNodes)=>new Promise((resolve, reject)=>{
                migrateCurrentProjectMutation({
                    variables: {
                        input: {
                            cloudId: cloudId,
                            nodes: chunkNodes
                        }
                    },
                    onCompleted: (response)=>{
                        if (response.jira_listSettingMigrationMutation?.success !== true) {
                            reject(new (0, $K4WWF.MutationErrorCollection)(response.jira_listSettingMigrationMutation?.errors));
                            return;
                        }
                        resolve();
                    },
                    onError: (error)=>{
                        reject(error);
                    }
                });
            });
        Promise.allSettled(chunks.map(commitChunk)).then((results)=>{
            const failed = results.find((r)=>r.status === 'rejected');
            if (failed) {
                handleError(failed.reason, migrateAllProjects);
                return;
            }
            handleSuccess(currentProjectData);
        });
    }, [
        showFlag,
        currentProjectId,
        migrateCurrentProjectMutation,
        cloudId,
        handleSuccess,
        handleError
    ]);
    return {
        migrateCurrentProject: migrateCurrentProject,
        migrateAllProjects: migrateAllProjects
    };
};

});
parcelRegister("6HgRa", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb51e79dadfa8285$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2fe4c607cadbe996f5a81fb4e9161963>>
 * @relayHash eeb341c01a4d12157855648a050b1205
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6837d0415941ad8e042c359d3da1eee1785982c246262d2aab74624649bfce1c
const $bb51e79dadfa8285$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePaidListNINConfigMigration_migrateCurrentProjectMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraListSettingMigrationPayload",
                    "kind": "LinkedField",
                    "name": "jira_listSettingMigrationMutation",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePaidListNINConfigMigration_migrateCurrentProjectMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraListSettingMigrationPayload",
                    "kind": "LinkedField",
                    "name": "jira_listSettingMigrationMutation",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6837d0415941ad8e042c359d3da1eee1785982c246262d2aab74624649bfce1c",
            "metadata": {},
            "name": "usePaidListNINConfigMigration_migrateCurrentProjectMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$bb51e79dadfa8285$var$node.hash = "b6c757641f8101d620b9b7b04da1bf81";
var $bb51e79dadfa8285$export$2e2bcd8739ae039 = $bb51e79dadfa8285$var$node;

});

parcelRegister("g6t48", function(module, exports) {
$parcel$export(module.exports, "default", () => $406cc07d8c3b261d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $406cc07d8c3b261d$var$messages = (0, $7qGN1.defineMessages)({
    listMigrationSuccessFlag: {
        "id": "issue-navigator.services.list-nin-config-migration.show-flag.success.list-migration-success.nonfinal",
        "defaultMessage": "Updated view settings"
    },
    listMigrationErrorFlag: {
        "id": "issue-navigator.services.list-nin-config-migration.show-flag.error.list-migration-error.nonfinal",
        "defaultMessage": "We can't update your view settings"
    },
    listMigrationTryAgainAction: {
        "id": "issue-navigator.services.list-nin-config-migration.show-flag.error.list-migration-try-again-action.nonfinal",
        "defaultMessage": "Try again"
    },
    listMigrationInProgressTitle: {
        "id": "issue-navigator.services.list-nin-config-migration.show-flag.info.list-migration-in-progress-title.nonfinal",
        "defaultMessage": "Updating view settings"
    },
    listMigrationInProgressDescription: {
        "id": "issue-navigator.services.list-nin-config-migration.show-flag.info.list-migration-in-progress-description.nonfinal",
        "defaultMessage": "Stay on this page until the update is finished."
    }
});
var $406cc07d8c3b261d$export$2e2bcd8739ae039 = $406cc07d8c3b261d$var$messages;

});

parcelRegister("76Jvn", function(module, exports) {
$parcel$export(module.exports, "InProgressFlag", () => $a77036a450ffd860$export$e75d6d3573e1e6fe);

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");

var $c9qWp = parcelRequire("c9qWp");

var $2pgjF = parcelRequire("2pgjF");

var $lRq8t = parcelRequire("lRq8t");

var $g6t48 = parcelRequire("g6t48");
const $a77036a450ffd860$var$IN_PROGRESS_FLAG_ID = 'paid-list-ninconfig-migration-in-progress';
const $a77036a450ffd860$export$e75d6d3573e1e6fe = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2pgjF.InfoFlag), {
        appearance: "normal",
        id: $a77036a450ffd860$var$IN_PROGRESS_FLAG_ID,
        title: formatMessage((0, $g6t48.default).listMigrationInProgressTitle),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
            space: "space.100"
        }, formatMessage((0, $g6t48.default).listMigrationInProgressDescription), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9qWp.default), {
            isIndeterminate: true
        })))
    });
};

});
parcelRegister("c9qWp", function(module, exports) {
$parcel$export(module.exports, "default", () => $f72ae726177d4e89$export$2e2bcd8739ae039);
/* progress-bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
const $f72ae726177d4e89$var$MIN_VALUE = 0;
const $f72ae726177d4e89$var$MAX_VALUE = 1;
const $f72ae726177d4e89$var$increasingBarAnimation = null;
const $f72ae726177d4e89$var$decreasingBarAnimation = null;
const $f72ae726177d4e89$var$containerStyles = null;
const $f72ae726177d4e89$var$containerAppearance = {
    default: "_bfhk1t45",
    success: "_bfhk1t45",
    inverse: "_bfhklgn7"
};
const $f72ae726177d4e89$var$barAppearance = {
    default: "_bfhk1wby",
    success: "_bfhk1bh5",
    inverse: "_bfhkvuon"
};
const $f72ae726177d4e89$var$barStyles = null;
const $f72ae726177d4e89$var$determinateBarStyles = null;
const $f72ae726177d4e89$var$increasingBarStyles = null;
const $f72ae726177d4e89$var$decreasingBarStyles = null;
/**
 * __Progress bar__
 *
 * A progress bar displays the status of a given process.
 *
 * - [Examples](https://atlassian.design/components/progress-bar/examples)
 * - [Code](https://atlassian.design/components/progress-bar/code)
 * - [Usage](https://atlassian.design/components/progress-bar/usage)
 */ const $f72ae726177d4e89$var$ProgressBar = ({ appearance: appearance = 'default', ariaLabel: ariaLabel, isIndeterminate: isIndeterminate = false, testId: testId = 'progress-bar', value: value = 0 })=>{
    const valueParsed = isIndeterminate ? $f72ae726177d4e89$var$MIN_VALUE : Math.max($f72ae726177d4e89$var$MIN_VALUE, Math.min(value, $f72ae726177d4e89$var$MAX_VALUE));
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $f72ae726177d4e89$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $f72ae726177d4e89$var$MAX_VALUE,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_2rkofajl _1reo15vq _18m915vq _1bsb1osq _4t3ii2wt _kqswh2mm _bfhk1t45",
            $f72ae726177d4e89$var$containerAppearance[appearance]
        ]),
        children: isIndeterminate ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                    className: (0, $hcewu.default)([
                        "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                        $f72ae726177d4e89$var$barAppearance[appearance],
                        "_5sagymdr _tip812c5 _j7hq7g40"
                    ])
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                    className: (0, $hcewu.default)([
                        "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                        $f72ae726177d4e89$var$barAppearance[appearance],
                        "_ju251bs3 _5sagymdr _tip812c5 _j7hqio0v"
                    ])
                })
            ]
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            style: {
                width: `${Number(value) * 100}%`
            },
            className: (0, $hcewu.default)([
                "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                $f72ae726177d4e89$var$barAppearance[appearance],
                "_v564calv"
            ])
        })
    });
};
var $f72ae726177d4e89$export$2e2bcd8739ae039 = $f72ae726177d4e89$var$ProgressBar;

});





parcelRegister("7QuRk", function(module, exports) {
$parcel$export(module.exports, "SelectedIssue", () => $e481ae70beb05107$export$39b2b4a30505b395);

var $g8n2A = parcelRequire("g8n2A");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2gvG4 = parcelRequire("2gvG4");

var $4cTDP = parcelRequire("4cTDP");

var $eibCx = parcelRequire("eibCx");

var $7681X = parcelRequire("7681X");

var $HiS1C = parcelRequire("HiS1C");

var $3kDjB = parcelRequire("3kDjB");

var $lvpZz = parcelRequire("lvpZz");
const $e481ae70beb05107$export$39b2b4a30505b395 = ({ children: children, issues: issues, selectedIssueKey: selectedIssueKey, onChange: onChange })=>{
    const [{ view: view }] = (0, $HiS1C.useSelectedViewState)();
    const searchKey = (0, $3kDjB.useSearchKey)();
    const issueData = (0, $j4oe4.useFragment)((0, $g8n2A.default), issues);
    const issuesFlatList = (0, $lvpZz.useFlatListIssues)();
    const issueKeys = (0, $eJOHy.useMemo)(()=>view !== 'detail' && issuesFlatList ? issuesFlatList : issueData?.edges?.map((edge)=>edge?.node?.key ?? '') ?? [], [
        issuesFlatList,
        issueData?.edges,
        view
    ]);
    const ufoData = (0, $eJOHy.useMemo)(()=>(0, $4cTDP.fg)('nin_perf_extra_ufo_attributes') ? {
            issuesLoaded: issueKeys.length
        } : undefined, [
        issueKeys.length
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7681X.SelectedIssueContainer), {
        view: (0, $eibCx.convertToView)(view),
        issueKeys: issueKeys,
        searchKey: searchKey,
        selectedIssueKey: selectedIssueKey,
        onChange: onChange
    }, children, ufoData && (0, $4cTDP.fg)('nin_perf_extra_ufo_attributes') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2gvG4.default), {
        data: ufoData
    }));
};

});
parcelRegister("g8n2A", function(module, exports) {
$parcel$export(module.exports, "default", () => $285d26b1bb73ea66$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<861c6a2b5276ec2a8b6ba119835e232f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $285d26b1bb73ea66$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "selectedIssue_issueNavigator",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$285d26b1bb73ea66$var$node.hash = "966aa39a272d43746556adcb1b54c0d8";
var $285d26b1bb73ea66$export$2e2bcd8739ae039 = $285d26b1bb73ea66$var$node;

});


parcelRegister("2y1A0", function(module, exports) {
$parcel$export(module.exports, "SelectedViewContainer", () => $0660590783621ed6$export$6e497a97feb37da2);

var $co6Lb = parcelRequire("co6Lb");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2gvG4 = parcelRequire("2gvG4");

var $4cTDP = parcelRequire("4cTDP");

var $iRahl = parcelRequire("iRahl");

var $eibCx = parcelRequire("eibCx");

var $HiS1C = parcelRequire("HiS1C");

var $3kDjB = parcelRequire("3kDjB");
const $0660590783621ed6$export$6e497a97feb37da2 = ({ children: children, jiraView: jiraView, onSetView: onSetView })=>{
    const { changeView: changeView } = (0, $3kDjB.useIssueSearchActions)();
    const jiraViewData = (0, $j4oe4.useFragment)((0, $co6Lb.default), jiraView);
    const viewId = (0, $eibCx.parseIssueNavigatorViewIdOrDefault)(jiraViewData?.viewId, (0, $iRahl.DEFAULT_VIEW_ID));
    const ufoData = (0, $eJOHy.useMemo)(()=>(0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes') ? {
            viewLayout: (0, $eibCx.convertToView)(viewId)
        } : undefined, [
        viewId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $HiS1C.Container), {
        view: viewId,
        onSetView: onSetView,
        onIssueSearchForView: changeView
    }, children, ufoData && (0, $4cTDP.fg)('jira_nin_last_used_jql_tech_changes') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2gvG4.default), {
        data: ufoData
    }));
};

});
parcelRegister("co6Lb", function(module, exports) {
$parcel$export(module.exports, "default", () => $82eb2c758a3610bd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<04fbb2bde6ed8bae3b30f5a477ad3660>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $82eb2c758a3610bd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "selectedView_issueNavigator_SelectedViewContainer",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "viewId"
                }
            ],
            "type": "JiraIssueSearchViewMetadata",
            "abstractKey": "__isJiraIssueSearchViewMetadata"
        }
    ],
    "type": "JiraView",
    "abstractKey": "__isJiraView"
};
$82eb2c758a3610bd$var$node.hash = "7af7655c76c900649cc8f8ecf6ff6734";
var $82eb2c758a3610bd$export$2e2bcd8739ae039 = $82eb2c758a3610bd$var$node;

});


parcelRegister("3YMzi", function(module, exports) {
$parcel$export(module.exports, "IssueSearchInputProvider", () => $268d66377c42747a$export$b6ab4b45f9fc3fe0);

var $3znGQ = parcelRequire("3znGQ");

var $e2F0k = parcelRequire("e2F0k");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $95O7y = parcelRequire("95O7y");

var $82cqT = parcelRequire("82cqT");

var $fwKw5 = parcelRequire("fwKw5");

var $cJdYi = parcelRequire("cJdYi");
const $268d66377c42747a$export$b6ab4b45f9fc3fe0 = /*#__PURE__*/ (0, $eJOHy.memo)(({ children: children, defaultJql: defaultJql, filterQuery: filterQuery, refetch: refetch, onFilterKeyToJql: onFilterKeyToJql, jiraFilter: jiraFilter, jiraView: jiraView })=>{
    const viewMetadata = (0, $j4oe4.useFragment)((0, $e2F0k.default), jiraView);
    const filterData = (0, $j4oe4.useFragment)((0, $3znGQ.default), jiraFilter);
    const [jqlParam, setJqlParam] = (0, $95O7y.useQueryParam)('jql');
    const [filterParam] = (0, $95O7y.useQueryParam)('filter');
    // JQL is first read from the query param
    let jql = jqlParam;
    let filterId;
    let filterJql;
    if ((0, $82cqT.isFilterId)(filterParam)) {
        filterId = filterParam;
        filterJql = filterData?.jql;
    } else {
        // If filter param is present (but is not an ID) try map to a hardcoded JQL value
        if (filterParam !== undefined) {
            filterJql = onFilterKeyToJql?.(filterParam);
            // If no explicit JQL query param is defined then use the mapped filter value.
            if (jql === undefined) jql = filterJql;
        }
        // Otherwise, if there is not filter query param, use the resolved JQL from the issue search response
        if (jql === undefined) jql = (0, $4cTDP.fg)('jira_nin_last_used_jql') ? viewMetadata?.jql ?? undefined : defaultJql;
    }
    // Ensure the JQL param reflects the resolved JQL value
    if (jql !== undefined && jql !== jqlParam) setJqlParam(jql, 'replace');
    const isFilterEditable = filterData?.isEditable;
    const initialJql = (0, $eJOHy.useRef)((0, $4cTDP.fg)('jracloud_85520_hydration_ref_only_on_page_load') ? jql ?? filterJql : undefined);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cJdYi.FilterQueryProvider), {
        query: filterQuery,
        refetch: refetch,
        filterId: filterId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fwKw5.ActiveJqlProvider), {
        initialJql: initialJql.current,
        filterId: filterId,
        filterJql: filterJql,
        jql: jql ?? undefined,
        isFilterEditable: isFilterEditable ?? undefined
    }, children));
});

});
parcelRegister("3znGQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c38cec3f158b2852$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d378146f64cc5ac448022a161198ec9e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c38cec3f158b2852$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueSearchInputProvider_jiraFilter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ],
            "type": "JiraCustomFilter"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$c38cec3f158b2852$var$node.hash = "07d892c67fb0e3830707a3d1cccfa800";
var $c38cec3f158b2852$export$2e2bcd8739ae039 = $c38cec3f158b2852$var$node;

});

parcelRegister("e2F0k", function(module, exports) {
$parcel$export(module.exports, "default", () => $d83617cfdcd808e1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<17fd23a8087769f68dd0d5cd8675f7c8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d83617cfdcd808e1$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "IssueSearchInputProvider_jiraView",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "jql"
                }
            ]
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$d83617cfdcd808e1$var$node.hash = "843375146a1d31e603cfec76c2a29acc";
var $d83617cfdcd808e1$export$2e2bcd8739ae039 = $d83617cfdcd808e1$var$node;

});



parcelRegister("9I5E1", function(module, exports) {
$parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", () => $9f17996c86676e6c$export$46976e0f90edfcfe);
$parcel$export(module.exports, "JsdGettingStartedPanel", () => $9f17996c86676e6c$export$6f9913539cfb4ab6);
$parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", () => $9f17996c86676e6c$export$4cb23b2c31a1b2ad);
$parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", () => $9f17996c86676e6c$export$c7732c55900cf0b9);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $9f17996c86676e6c$var$AsyncGettingStartedPanelShouldRender = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("kcqI9")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
});

const $9f17996c86676e6c$var$AsyncGettingStartedPanel = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("af8GM")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
});

const $9f17996c86676e6c$var$AsyncGettingStartedPanelOpenButton = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("jgb0S")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
});

const $9f17996c86676e6c$var$AsyncGettingStartedPanelReopenSpotlight = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("3ZBgZ")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
});
const $9f17996c86676e6c$export$46976e0f90edfcfe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "jsm-getting-started-panel-async-should-render",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f17996c86676e6c$var$AsyncGettingStartedPanelShouldRender, null));
$9f17996c86676e6c$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
const $9f17996c86676e6c$export$6f9913539cfb4ab6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "jsm-getting-started-panel-async-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f17996c86676e6c$var$AsyncGettingStartedPanel, null));
$9f17996c86676e6c$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
const $9f17996c86676e6c$export$4cb23b2c31a1b2ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "jsm-getting-started-panel-async-open-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f17996c86676e6c$var$AsyncGettingStartedPanelOpenButton, null));
$9f17996c86676e6c$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
const $9f17996c86676e6c$export$c7732c55900cf0b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "jsm-getting-started-panel-async-reopen-spotlight",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f17996c86676e6c$var$AsyncGettingStartedPanelReopenSpotlight, null));
$9f17996c86676e6c$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';

});
parcelRegister("kcqI9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("8OOe7")
]).then(()=>parcelRequire('5UcAl'));

});

parcelRegister("af8GM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("8YM4r")
]).then(()=>parcelRequire('6tZJD'));

});

parcelRegister("jgb0S", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("izzmP")
]).then(()=>parcelRequire('8IDjP'));

});

parcelRegister("3ZBgZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("caLxL")
]).then(()=>parcelRequire('c2Xzs'));

});


parcelRegister("2tWP9", function(module, exports) {
$parcel$export(module.exports, "ProjectIssueNavigatorHeaderSkeleton", () => $1a2c56de285a8aff$export$28359b78c47abc93);
/* project-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $321VJ = parcelRequire("321VJ");
const $1a2c56de285a8aff$var$customCssStyles = null;
const $1a2c56de285a8aff$var$containerStyles = {
    height: '104px'
};
const $1a2c56de285a8aff$export$28359b78c47abc93 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($321VJ))),
        containerStyles: $1a2c56de285a8aff$var$containerStyles,
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("321VJ", function(module, exports) {
module.exports = new URL("project-issue-navigator-header-skeleton.tpl.7e712bab.svg", import.meta.url).toString();

});


parcelRegister("3nL89", function(module, exports) {
$parcel$export(module.exports, "DocumentTitle", () => $8eb9deaadd9d6be8$export$dd5ad0b65cf665da);

var $19u1t = parcelRequire("19u1t");
const $8eb9deaadd9d6be8$export$dd5ad0b65cf665da = (0, $19u1t.DocumentTitleHelper);

});

parcelRegister("bwFBc", function(module, exports) {
$parcel$export(module.exports, "default", () => $bea50720caa01bff$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<188813c08a6b767043dfdfcd6e9e6e61>>
 * @relayHash 4269726e8ba7ceef0720803c06ec9dc3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4da1e676fb4717f68009f63522b10789960d60fc3543044cb90995abbb254a51
const $bea50720caa01bff$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "documentTitleQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "documentTitleQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4da1e676fb4717f68009f63522b10789960d60fc3543044cb90995abbb254a51",
            "metadata": {},
            "name": "documentTitleQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bea50720caa01bff$var$node.hash = "37cf341ecbc6674a0e4301d1a119d06d";
var $bea50720caa01bff$export$2e2bcd8739ae039 = $bea50720caa01bff$var$node;

});

parcelRegister("foygf", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c3c507384f706af$export$2e2bcd8739ae039);

var $bLbLx = parcelRequire("bLbLx");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $c12HM = parcelRequire("c12HM");

var $k71qx = parcelRequire("k71qx");

var $h6slU = parcelRequire("h6slU");

var $7KRE0 = parcelRequire("7KRE0");

var $gFB4g = parcelRequire("gFB4g");

var $gHI4w = parcelRequire("gHI4w");

var $5vQ2T = parcelRequire("5vQ2T");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $hbF3h = parcelRequire("hbF3h");

var $cSOX1 = parcelRequire("cSOX1");

var $82cqT = parcelRequire("82cqT");

var $aBVfX = parcelRequire("aBVfX");

var $7RWaJ = parcelRequire("7RWaJ");

var $egm3s = parcelRequire("egm3s");

var $2imLM = parcelRequire("2imLM");

var $cHtIB = parcelRequire("cHtIB");

var $kh7bJ = parcelRequire("kh7bJ");

var $4cTDP = parcelRequire("4cTDP");

var $hJkmA = parcelRequire("hJkmA");

var $7Nlco = parcelRequire("7Nlco");
const $1c3c507384f706af$export$49640514ca453805 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1c3c507384f706af$var$FilterTitleTooltipTagStyled, {
        ref: ref,
        ...props
    }));
const $1c3c507384f706af$var$ProjectBreadcrumbWithData = ({ queryReference: queryReference, projectKey: projectKey })=>{
    const data = (0, $j4oe4.usePreloadedQuery)((0, $bLbLx.default), queryReference);
    const projectName = data?.jira?.jiraProjectByKey?.name ?? '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gFB4g.default), {
        projectKey: projectKey,
        projectName: projectName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h6slU.default), null)));
};
const $1c3c507384f706af$var$BreadcrumbFallback = ({ projectKey: projectKey, projectName: projectName })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gFB4g.default), {
        projectKey: projectKey,
        projectName: projectName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h6slU.default), null));
};
const $1c3c507384f706af$var$useIsHydrationComplete = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jfp-magma-nin-post-hydration-fixes'), // Need to defer evaluation for magnetic di to work
()=>(0, $cSOX1.useIsClientReady)(), ()=>true);
const $1c3c507384f706af$var$Header = ({ projectKey: projectKey, jql: jql, filterId: filterId, filterDetails: filterDetails, searchResultPageData: searchResultPageData, isQuickFiltersDisabled: isQuickFiltersDisabled = false, HierarchyToggle: HierarchyToggle, GroupByDropdown: GroupByDropdown, HideDoneToggle: HideDoneToggle, FiltersMenu: FiltersMenu, SaveResetViewSettingsButton: SaveResetViewSettingsButton, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isHideDoneSupportEnabled: isHideDoneSupportEnabled, isHideDoneWorkItemsEnabled: isHideDoneWorkItemsEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, onChangeFilter: onChangeFilter })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    const [queryReference, loadQuery] = (0, $j4oe4.useQueryLoader)((0, $bLbLx.default));
    const isHydrationComplete = $1c3c507384f706af$var$useIsHydrationComplete();
    const cloudId = (0, $cHtIB.useCloudId)();
    (0, $eJOHy.useEffect)(()=>{
        loadQuery({
            projectKey: projectKey,
            cloudId: cloudId
        });
    }, [
        loadQuery,
        projectKey,
        cloudId
    ]);
    const heading = formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hJkmA.default).headingIssueTermRefresh : (0, $hJkmA.default).heading);
    const renderBreadcrumbs = ()=>{
        if ((0, $4cTDP.fg)('jfp-magma-nin-post-hydration-fixes')) // We need to render the fallback during SSR and CSR hydration initial render to avoid mismatch.
        // The current breadcrumbs API relies on updates after mount, which will always mismatch SSR content.
        return queryReference !== null && queryReference !== undefined && isHydrationComplete ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1c3c507384f706af$var$ProjectBreadcrumbWithData, {
            queryReference: queryReference,
            projectKey: projectKey
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7KRE0.EmptyBreadcrumbs), null);
        return queryReference !== null && queryReference !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1c3c507384f706af$var$ProjectBreadcrumbWithData, {
            queryReference: queryReference,
            projectKey: projectKey
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1c3c507384f706af$var$BreadcrumbFallback, {
            projectKey: projectKey,
            projectName: ""
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gHI4w.default), {
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
            name: "page-header",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1c3c507384f706af$var$BreadcrumbFallback, {
                projectKey: projectKey,
                projectName: ""
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
            id: "ui.project-name-query.boundary",
            packageName: "projectIssueNavigator",
            teamName: "empanada",
            sendToPrivacyUnsafeSplunk: true,
            attributes: (0, $c12HM.isLoaderErrorAttributes),
            fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1c3c507384f706af$var$BreadcrumbFallback, {
                    projectKey: projectKey,
                    projectName: projectKey
                })
        }, renderBreadcrumbs())),
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Nlco.default), {
            jql: jql,
            filterId: filterId,
            isModifiedFilter: filterDetails?.jql !== jql,
            searchResultPageData: searchResultPageData,
            isQuickFiltersDisabled: isQuickFiltersDisabled,
            HierarchyToggle: HierarchyToggle,
            GroupByDropdown: GroupByDropdown,
            HideDoneToggle: HideDoneToggle,
            FiltersMenu: FiltersMenu,
            SaveResetViewSettingsButton: SaveResetViewSettingsButton,
            isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
            isHideDoneSupportEnabled: isHideDoneSupportEnabled,
            isHideDoneWorkItemsEnabled: isHideDoneWorkItemsEnabled,
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled && (0, $4cTDP.fg)('ifc_export_for_jsm'),
            onChangeFilter: onChangeFilter
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1c3c507384f706af$var$HeaderContentWrapper, null, (0, $82cqT.isFilterId)(filterId) && filterDetails ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: filterDetails.name,
        tag: $1c3c507384f706af$export$49640514ca453805,
        position: "mouse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1c3c507384f706af$var$FilterTitleTooltipContent, null, filterDetails.name)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $egm3s.FavoriteButtonHeaderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $egm3s.FavoriteButton), {
        filterId: filterDetails.filterId,
        isFavoriteInitial: filterDetails.isFavourite
    })), (0, $82cqT.isCustomFilter)(filterDetails.filterId) && filterId !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7RWaJ.DetailsButtonHeaderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aBVfX.DetailsPopup), {
        filterId: filterId
    }))) : heading)));
};
const $1c3c507384f706af$var$MemoHeader = /*#__PURE__*/ (0, $eJOHy.memo)($1c3c507384f706af$var$Header);
var $1c3c507384f706af$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $1c3c507384f706af$var$MemoHeader;
const $1c3c507384f706af$var$FilterTitleTooltipTagStyled = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1c3c507384f706af$var$FilterTitleTooltipContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $1c3c507384f706af$var$HeaderContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8nf1z _1e0c116y _4cvr1y6m _4t3izwfg _p12f1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bLbLx", function(module, exports) {
$parcel$export(module.exports, "default", () => $60b3469171e38b76$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<67e071a33cf45c408e850b759f06d544>>
 * @relayHash 2dcb74ffdda96ee8a118627d99d348d4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 95320ce8ef75d958fcc0085329ca22dbd72ca5869d41448c798a39e83b9c8b19
const $60b3469171e38b76$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainProjectNameQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainProjectNameQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "95320ce8ef75d958fcc0085329ca22dbd72ca5869d41448c798a39e83b9c8b19",
            "metadata": {},
            "name": "mainProjectNameQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$60b3469171e38b76$var$node.hash = "fca14514ec7cc9e866219e1ef4f3f1e9";
var $60b3469171e38b76$export$2e2bcd8739ae039 = $60b3469171e38b76$var$node;

});

parcelRegister("gHI4w", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ff4753a1da78f6d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1BWxH = parcelRequire("1BWxH");
const $0ff4753a1da78f6d$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1BWxH.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0ff4753a1da78f6d$var$ActionsWrapper, null, actions) : null
    });
var $0ff4753a1da78f6d$export$2e2bcd8739ae039 = $0ff4753a1da78f6d$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0ff4753a1da78f6d$var$ActionsWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1BWxH", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4d2cd992b0acc82$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7Ob9A = parcelRequire("7Ob9A");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $d4d2cd992b0acc82$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7Ob9A.OuterWrapper), {
        children: [
            breadcrumbs,
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7Ob9A.TitleWrapper), {
                truncateTitle: truncateTitle,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Ob9A.TitleContainer), {
                        truncateTitle: truncateTitle,
                        children: disableTitleStyles ? children : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Ob9A.StyledTitleWrapper), {
                            ref: innerRef,
                            truncateTitle: truncateTitle,
                            id: id,
                            testId: testId,
                            children: children
                        })
                    }),
                    actions && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Ob9A.ActionsWrapper), {
                        children: actions
                    })
                ]
            }),
            bottomBar && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7Ob9A.BottomBarWrapper), {
                children: [
                    " ",
                    bottomBar,
                    " "
                ]
            })
        ]
    });
};
var $d4d2cd992b0acc82$export$2e2bcd8739ae039 = $d4d2cd992b0acc82$var$PageHeader;

});
parcelRegister("7Ob9A", function(module, exports) {
$parcel$export(module.exports, "OuterWrapper", () => $f896c1834f9739ce$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $f896c1834f9739ce$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $f896c1834f9739ce$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $f896c1834f9739ce$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $f896c1834f9739ce$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $f896c1834f9739ce$export$6330225854c30dc);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
const $f896c1834f9739ce$var$styles = {
    bottomBar: "_1pfhpxbi"
};
const $f896c1834f9739ce$var$truncateStyles = null;
const $f896c1834f9739ce$var$outerStyles = null;
const $f896c1834f9739ce$var$titleStyles = null;
const $f896c1834f9739ce$var$titleWrapperStyles = null;
const $f896c1834f9739ce$var$titleWrapperTruncateStyles = null;
const $f896c1834f9739ce$var$titleContainerStyles = null;
const $f896c1834f9739ce$var$actionStyles = null;
const $f896c1834f9739ce$var$titleContainerTruncateStyles = null;
const $f896c1834f9739ce$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_6rthpxbi _1pfh1ejb _12l2idpf _ahbqidpf"
        ]),
        children: children
    });
};
const $f896c1834f9739ce$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("h1", {
        ref: ref,
        tabIndex: -1,
        id: id,
        "data-testid": testId && `${testId}--title`,
        className: (0, $hcewu.default)([
            "_11c8nf1z _12ji1r31 _1qu2glyw _12y31o36 _syazi7uo _1dyz4jg8 _1pfhidpf",
            truncateTitle && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ]),
        children: children
    });
});
const $f896c1834f9739ce$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1y6m _1n261q9c",
            truncateTitle && "_1n261q9c"
        ]),
        children: children
    });
};
const $f896c1834f9739ce$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _p12f1osq _6rthu2gc _1i4q1hna",
            truncateTitle && "_1o9zkb7n"
        ]),
        children: children
    });
};
const $f896c1834f9739ce$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _p12f1osq _6rthu2gc _ahbq1wug _bozgxy5q _o5721q9c"
        ]),
        children: children
    });
};
const $f896c1834f9739ce$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $f896c1834f9739ce$var$styles.bottomBar,
        children: children
    });
};

});



parcelRegister("aBVfX", function(module, exports) {
$parcel$export(module.exports, "DetailsPopup", () => $276102c584ea09ec$export$b61797ace80c3d8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $e2Zbt = parcelRequire("e2Zbt");

var $9pTd3 = parcelRequire("9pTd3");

var $goZPP = parcelRequire("goZPP");

var $7ep4S = parcelRequire("7ep4S");

var $lRq8t = parcelRequire("lRq8t");

var $b8OI0 = parcelRequire("b8OI0");

var $kh7bJ = parcelRequire("kh7bJ");

var $f2sjT = parcelRequire("f2sjT");

var $cHtIB = parcelRequire("cHtIB");


var $cjyd0 = parcelRequire("cjyd0");

var $2dahp = parcelRequire("2dahp");

var $1RiLs = parcelRequire("1RiLs");

const $276102c584ea09ec$var$Trigger = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ triggerRef: triggerRef, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const mergedRef = (0, $e2Zbt.mergeRefs)([
        ref,
        triggerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        ...props,
        appearance: "link",
        isSelected: props['aria-expanded'],
        testId: "issue-navigator-custom-filters.ui.details-popup.button",
        ref: mergedRef
    }, formatMessage((0, $2dahp.default).filterDetails));
});
const $276102c584ea09ec$export$b61797ace80c3d8 = ({ filterId: filterId })=>{
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    const activationId = (0, $f2sjT.useActivationId)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            filterId: filterId,
            activationId: activationId,
            cloudId: cloudId,
            isAnonymous: isAnonymous
        }), [
        filterId,
        activationId,
        cloudId,
        isAnonymous
    ]);
    const triggerRef = (0, $eJOHy.useRef)(null);
    const titleId = 'issue-navigator-custom-filters.ui.details-popup.popup.title';
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            titleId: titleId,
            triggerRef: triggerRef
        }), [
        triggerRef,
        titleId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b8OI0.PopupTrigger), {
        entryPoint: (0, $cjyd0.popupContentEntrypoint),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        trigger: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($276102c584ea09ec$var$Trigger, {
                ...props,
                triggerRef: triggerRef
            }),
        errorFallback: (0, $1RiLs.ErrorState),
        onError: (props)=>{
            (0, $9pTd3.fireErrorAnalytics)({
                ...props,
                meta: {
                    id: 'DetailsPopupEntryPoint',
                    packageName: (0, $117f1f77d62e6b3b$export$ad257a98f20ee631),
                    teamName: 'empanada'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        },
        shouldRenderToParent: true,
        placement: "bottom-start",
        testId: "issue-navigator-custom-filters.ui.details-popup.popup",
        role: "dialog",
        titleId: titleId,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($276102c584ea09ec$var$LoadingFallback, null)
    });
};
const $276102c584ea09ec$var$LoadingFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($276102c584ea09ec$var$LoadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), null)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $276102c584ea09ec$var$LoadingWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo1wug _18m91wug _y3gn1h6o _1bsb1vif _ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k _c71lqdd9",
            __cmplp.className
        ])
    });
});

});
const $117f1f77d62e6b3b$export$ad257a98f20ee631 = 'jiraIssueNavigatorCustomFilters';

parcelRegister("cjyd0", function(module, exports) {
$parcel$export(module.exports, "popupContentEntrypoint", () => $a9b932e4b31faebc$export$530cc5cbdf6236ea);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $8oKDI = parcelRequire("8oKDI");

var $3KQ88 = parcelRequire("3KQ88");

const $a9b932e4b31faebc$export$530cc5cbdf6236ea = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("5l1By")), {
        moduleId: "0bfd023c",
        priority: "interaction"
    }),
    getPreloadProps: ({ filterId: filterId, activationId: activationId, cloudId: cloudId, isAnonymous: isAnonymous })=>{
        const filterAri = (0, $8oKDI.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'filter',
            resourceId: filterId,
            activationId: activationId
        });
        return {
            queries: {
                filterData: {
                    parameters: $3KQ88.default,
                    variables: {
                        filterAri: filterAri,
                        isAnonymous: isAnonymous
                    }
                }
            },
            extraProps: {
                filterId: filterId,
                filterAri: filterAri
            }
        };
    }
});

});
parcelRegister("3KQ88", function(module, exports) {
$parcel$export(module.exports, "default", () => $674e5c285781d030$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cabde37d42247daed0f55869eb5b6fd9>>
 * @relayHash 9f4cdfd24c4837edbec911e81f56cc4c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6bc8c23e9cd41f906771238f4fc28eed8056bad2b96a927b890039d4d973ea8d
const $674e5c285781d030$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAnonymous"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "filterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v5 /*: any*/ 
        ]
    }, v7 = [
        v2 /*: any*/ ,
        v5 /*: any*/ 
    ], v8 = {
        "concreteType": "JiraGroup",
        "kind": "LinkedField",
        "name": "group",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v9 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            v2 /*: any*/ ,
            v5 /*: any*/ 
        ]
    }, v10 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v4 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v6 /*: any*/ 
                    ],
                    "type": "JiraShareableEntityProjectGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "concreteType": "JiraRole",
                            "kind": "LinkedField",
                            "name": "role",
                            "plural": false,
                            "selections": v7 /*: any*/ 
                        }
                    ],
                    "type": "JiraShareableEntityProjectRoleGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v8 /*: any*/ 
                    ],
                    "type": "JiraShareableEntityGroupGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v9 /*: any*/ 
                    ],
                    "type": "JiraShareableEntityUserGrant"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainPopupContentFilterByAriQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "description_issueNavigatorCustomFilters"
                                                },
                                                {
                                                    "condition": "isAnonymous",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "owner_issueNavigatorCustomFilters"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "subscriptions_issueNavigatorCustomFilters"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "permissions_issueNavigatorCustomFilters"
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.filter"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainPopupContentFilterByAriQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "filter",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v2 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEditable"
                                        },
                                        {
                                            "concreteType": "JiraShareableEntityShareGrantConnection",
                                            "kind": "LinkedField",
                                            "name": "shareGrants",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraShareableEntityShareGrantEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": v10 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraShareableEntityEditGrantConnection",
                                            "kind": "LinkedField",
                                            "name": "editGrants",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraShareableEntityEditGrantEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": v10 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isAnonymous",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "owner",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "accountId"
                                                        },
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "picture"
                                                        },
                                                        v5 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "filterId"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "last",
                                                            "value": 5
                                                        }
                                                    ],
                                                    "concreteType": "JiraFilterEmailSubscriptionConnection",
                                                    "kind": "LinkedField",
                                                    "name": "emailSubscriptions",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraFilterEmailSubscriptionEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraFilterEmailSubscription",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        v9 /*: any*/ ,
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "emailSubscriptions(last:5)"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraCustomFilter"
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6bc8c23e9cd41f906771238f4fc28eed8056bad2b96a927b890039d4d973ea8d",
            "metadata": {},
            "name": "mainPopupContentFilterByAriQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$674e5c285781d030$var$node.hash = "0d557f612ff494f70f6caa72336c5a34";
var $674e5c285781d030$export$2e2bcd8739ae039 = $674e5c285781d030$var$node;

});

parcelRegister("5l1By", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4P97l").then(()=>parcelRequire('cCtZP'));

});


parcelRegister("2dahp", function(module, exports) {
$parcel$export(module.exports, "default", () => $1abd1b914f16bcb4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $1abd1b914f16bcb4$var$messages = (0, $7qGN1.defineMessages)({
    filterDetails: {
        "id": "issue-navigator-custom-filters.details-popup.filter-details",
        "defaultMessage": "Filter details"
    }
});
var $1abd1b914f16bcb4$export$2e2bcd8739ae039 = $1abd1b914f16bcb4$var$messages;

});

parcelRegister("1RiLs", function(module, exports) {
$parcel$export(module.exports, "ErrorState", () => $8f39fa98a026f447$export$c1ed4f415b9e7023);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $dyvFQ = parcelRequire("dyvFQ");

var $9vvZ3 = parcelRequire("9vvZ3");
const $8f39fa98a026f447$export$c1ed4f415b9e7023 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dyvFQ.ErrorState), {
        description: formatMessage((0, $9vvZ3.default).errorMessage),
        pageAction: "detailsPopup"
    });
};

});
parcelRegister("dyvFQ", function(module, exports) {
$parcel$export(module.exports, "ErrorState", () => $147eb7ee5e3e0a78$export$c1ed4f415b9e7023);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $goZPP = parcelRequire("goZPP");

var $80DPg = parcelRequire("80DPg");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $ivs94 = parcelRequire("ivs94");

var $1m9Wj = parcelRequire("1m9Wj");
const $147eb7ee5e3e0a78$var$BOX_HEIGHT = 144;
const $147eb7ee5e3e0a78$var$ERROR_ICON_BOX_WRAPPER_HEIGHT = 72;
const $147eb7ee5e3e0a78$var$ICON_SIZE = 72;
const $147eb7ee5e3e0a78$export$c1ed4f415b9e7023 = (props)=>{
    const { pageAction: pageAction, onRetry: onRetry, description: description, role: role } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onClick = ()=>{
        onRetry?.();
        (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), `${pageAction}Retry clicked`);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($147eb7ee5e3e0a78$var$StyledBox, {
        height: $147eb7ee5e3e0a78$var$BOX_HEIGHT,
        role: role
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($147eb7ee5e3e0a78$var$StyledBox, {
        height: $147eb7ee5e3e0a78$var$ERROR_ICON_BOX_WRAPPER_HEIGHT,
        iconSize: $147eb7ee5e3e0a78$var$ICON_SIZE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        color: "var(--ds-icon, #292A2E)",
        LEGACY_primaryColor: "var(--ds-icon, #292A2E)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1m9Wj.StyledText), null, description !== undefined ? description : formatMessage((0, $ivs94.default).errorMessage)), onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        onClick: onClick,
        appearance: "link",
        testId: "issue-navigator-actions-common.ui.error.button"
    }, formatMessage((0, $ivs94.default).retryMessage)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $147eb7ee5e3e0a78$var$StyledBox = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $awdRS.default)(__cmplp.height, "px"),
            "--_1kpj8xj": (0, $awdRS.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i1474 _1bah1h6o _19pkpxbi _2hwx1ejb _otyrpxbi _18u01ejb",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ivs94", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fc2779f4954708a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $7fc2779f4954708a$var$messages = (0, $7qGN1.defineMessages)({
    errorMessage: {
        "id": "issue-navigator-actions-common.error.error-message",
        "defaultMessage": "Couldn't retrieve data"
    },
    retryMessage: {
        "id": "issue-navigator-actions-common.error.retry-message",
        "defaultMessage": "Click to retry"
    }
});
var $7fc2779f4954708a$export$2e2bcd8739ae039 = $7fc2779f4954708a$var$messages;

});

parcelRegister("1m9Wj", function(module, exports) {
$parcel$export(module.exports, "StyledText", () => $fe5d3814363465dc$export$31ea92f3997410dd);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $806LH = parcelRequire("806LH");
const $fe5d3814363465dc$export$d675f139b342d51a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $awdRS.default)(__cmplp.height, "px"),
            "--_1kpj8xj": (0, $awdRS.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i1474 _1bah1h6o _19pkpxbi _2hwx1ejb _otyrpxbi _18u01ejb",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});
const $fe5d3814363465dc$var$StyledTextComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $fe5d3814363465dc$export$31ea92f3997410dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fe5d3814363465dc$var$StyledTextComponent, props));

});


parcelRegister("9vvZ3", function(module, exports) {
$parcel$export(module.exports, "default", () => $5cf3c3c0c3c8efca$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $5cf3c3c0c3c8efca$var$messages = (0, $7qGN1.defineMessages)({
    errorMessage: {
        "id": "issue-navigator-custom-filters.details-popup.error-state.error-message",
        "defaultMessage": "We couldn't display the filter details."
    }
});
var $5cf3c3c0c3c8efca$export$2e2bcd8739ae039 = $5cf3c3c0c3c8efca$var$messages;

});



parcelRegister("7RWaJ", function(module, exports) {
$parcel$export(module.exports, "DetailsButtonHeaderWrapper", () => $abb34d3c862a37c9$export$1eb74eb504903ed6);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $abb34d3c862a37c9$export$1eb74eb504903ed6 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _19pkv77o _2hwx1b66 _otyridpf _18u01b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("egm3s", function(module, exports) {
$parcel$export(module.exports, "FavoriteButton", () => $350054eec8c06571$export$8d5dab2ad1e19ea0);
$parcel$export(module.exports, "FavoriteButtonHeaderWrapper", () => $350054eec8c06571$export$5ca4047aa6ecffac);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $fNmFZ = parcelRequire("fNmFZ");

var $aMJA4 = parcelRequire("aMJA4");
const $350054eec8c06571$export$8d5dab2ad1e19ea0 = ({ filterId: filterId, isFavoriteInitial: isFavoriteInitial, favoriteItemName: favoriteItemName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fNmFZ.default), {
        key: filterId,
        itemType: (0, $aMJA4.FILTERS_ITEM_TYPE),
        itemId: filterId,
        isFavoriteInitial: isFavoriteInitial,
        favoriteItemName: favoriteItemName,
        isShownInList: true
    });
const $350054eec8c06571$export$5ca4047aa6ecffac = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _4t3izwfg _19pkze3t _2hwx1b66 _otyrze3t _18u01b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fNmFZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4961e4a04dcd2feb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dFtHW = parcelRequire("dFtHW");


var $c5DQI = parcelRequire("c5DQI");
class $4961e4a04dcd2feb$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dFtHW.FavoriteChangeConsumer), null, (favoriteChangeContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c5DQI.FavoriteButton), {
                ...this.props,
                favoriteChangeContext: favoriteChangeContext
            }));
    }
}

});
parcelRegister("c5DQI", function(module, exports) {
$parcel$export(module.exports, "FavoriteButton", () => $9f486e8c0fd92397$export$8d5dab2ad1e19ea0);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $fVPN0 = parcelRequire("fVPN0");

var $aMJA4 = parcelRequire("aMJA4");

var $9R7x8 = parcelRequire("9R7x8");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $9f486e8c0fd92397$var$isProduction = window.BUILD_KEY !== 'JF-TEST';
class $9f486e8c0fd92397$export$8d5dab2ad1e19ea0 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isFavoriteInitial: undefined,
            favoriteItemName: undefined,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    constructor(props){
        super(props), this.onClick = (analyticsEvent)=>{
            const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType, onClick: onClick } = this.props;
            const { changeFavorite: changeFavorite } = favoriteChangeContext;
            if (changeFavorite) changeFavorite({
                id: itemId,
                type: itemType,
                value: !this.getIsFavorite()
            }, analyticsEvent);
            if (typeof onClick === 'function') onClick();
        };
        this.state = {
            isFavorite: props.isFavoriteInitial
        };
    }
    componentDidMount() {
        const { itemId: itemId, itemType: itemType } = this.props;
        if (typeof itemId === 'undefined' || typeof itemType === 'undefined') return;
        // Adding an Error here for the next dev to implement this button.
        // This error won't show in prod, but will show when running a fragment.
        if (!$9f486e8c0fd92397$var$isProduction && !(0, $aMJA4.VALID_ITEM_TYPES).includes(itemType)) throw new Error(`FavoriteButton: Invalid value for prop 'type'.\n You passed: "${itemType}"\n It must be one of [${JSON.stringify((0, $aMJA4.VALID_ITEM_TYPES))}]\n\n`);
        if (typeof this.props.isFavoriteInitial !== 'undefined') // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        this.props.favoriteChangeContext.items[itemType][itemId] = {
            id: itemId,
            type: itemType,
            value: this.props.isFavoriteInitial,
            pending: false
        };
        if (this.getIsFavorite() === undefined) (0, $9R7x8.getFavorite)({
            id: itemId,
            type: itemType
        }).then((isFavorite)=>{
            this.setState({
                isFavorite: isFavorite
            });
        });
    }
    getIsFavorite() {
        const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType } = this.props;
        let itemChanged;
        if (typeof favoriteChangeContext.items[itemType] !== 'undefined' && typeof favoriteChangeContext.items[itemType][itemId] !== 'undefined') itemChanged = favoriteChangeContext.items[itemType][itemId];
        return itemChanged ? itemChanged.value : this.state.isFavorite;
    }
    getIsPending() {
        const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType } = this.props;
        let itemChanged;
        if (typeof favoriteChangeContext.items[itemType] !== 'undefined' && typeof favoriteChangeContext.items[itemType][itemId] !== 'undefined') itemChanged = favoriteChangeContext.items[itemType][itemId];
        return itemChanged ? itemChanged.pending : false;
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": "favourite-button.favorite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fVPN0.default), {
            isFavorite: this.getIsFavorite(),
            favoriteItemName: this.props.favoriteItemName,
            pending: this.getIsPending(),
            hideTooltip: this.props.hideTooltip,
            tooltipPosition: this.props.tooltipPosition,
            onClick: this.onClick,
            isShownInList: this.props.isShownInList,
            isSmall: this.props.isSmall
        }));
    }
}

});
parcelRegister("fVPN0", function(module, exports) {
$parcel$export(module.exports, "FavoriteButtonWrapper", () => $c7558d16e1b4ddea$export$bb1478fee6cd5f0c);
$parcel$export(module.exports, "default", () => $c7558d16e1b4ddea$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eq3Hf = parcelRequire("eq3Hf");

var $12DRg = parcelRequire("12DRg");

var $goZPP = parcelRequire("goZPP");

var $gGgaG = parcelRequire("gGgaG");

var $aaIe7 = parcelRequire("aaIe7");

var $dLR8J = parcelRequire("dLR8J");

var $k71qx = parcelRequire("k71qx");

var $6sjW5 = parcelRequire("6sjW5");

var $6YFG2 = parcelRequire("6YFG2");

var $6urTU = parcelRequire("6urTU");
const $c7558d16e1b4ddea$var$SKELETON_TEST_ID = 'favouriting.favorite-button-stateless.skeleton';
const $c7558d16e1b4ddea$var$ICON_WRAPPER_TEST_ID_PREFIX = 'favouriting.favorite-button-stateless.icon-wrapper';
class $c7558d16e1b4ddea$export$f8ad2acf0ec4860f extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isFavorite: undefined,
            favoriteItemName: undefined,
            isShownInList: false,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            tooltipPosition: 'bottom',
            skipAnimation: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!this.props.skipAnimation && (!prevProps.pending && this.props.pending || !prevProps.isFavorite && this.props.isFavorite)) {
            this.onAnimationStart();
            this.onSettingAnimationEnd();
        }
    }
    onAnimationStart() {
        this.setState({
            isAnimating: !this.state.isAnimating
        });
    }
    onSettingAnimationEnd() {
        setTimeout(()=>{
            this.setState({
                isAnimating: false
            });
        }, $c7558d16e1b4ddea$var$animationTime * 2);
    }
    render() {
        const { isFavorite: isFavorite, favoriteItemName: favoriteItemName, isShownInList: isShownInList, isSmall: isSmall, hideTooltip: hideTooltip, tooltipPosition: tooltipPosition, pending: pending, intl: { formatMessage: formatMessage } } = this.props;
        const { isAnimating: isAnimating } = this.state;
        if (isFavorite === undefined) // show skeleton as a space placeholder (to avoid layout recalculations in browser and visible "jump" when we got data)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
            name: "favourite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$export$db65185b5889c83, {
            "data-testid": $c7558d16e1b4ddea$var$SKELETON_TEST_ID,
            isSmall: isSmall
        }));
        const iconWrapperTestId = isShownInList ? `${$c7558d16e1b4ddea$var$ICON_WRAPPER_TEST_ID_PREFIX}-list` : $c7558d16e1b4ddea$var$ICON_WRAPPER_TEST_ID_PREFIX;
        const renderIcon = ()=>{
            const label = isFavorite ? formatMessage((0, $6urTU.default).removeFromStarred) : formatMessage((0, $6urTU.default).addToStarred);
            const StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($gGgaG))) : (0, (/*@__PURE__*/$parcel$interopDefault($aaIe7)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(StarIconComponent, {
                color: "currentColor",
                label: label,
                size: isSmall ? 'small' : 'medium'
            });
        };
        const tooltipContent = isFavorite ? formatMessage((0, $6urTU.default).removeFromStarred) : formatMessage((0, $6urTU.default).addToStarred);
        const ariaLabel = favoriteItemName ? formatMessage((0, $6urTU.default).toggleStarredWithItemName, {
            itemName: favoriteItemName
        }) : formatMessage((0, $6urTU.default).toggleStarred);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$export$bb1478fee6cd5f0c, {
            role: "presentation",
            onClick: this.onBtnClickWrapper,
            onKeyPress: this.onBtnClickWrapper,
            "data-is-favorite": isFavorite
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: !hideTooltip && tooltipContent,
            hideTooltipOnClick: true,
            position: tooltipPosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: isShownInList ? 'subtle-link' : 'subtle',
            spacing: "none",
            "aria-label": ariaLabel,
            "aria-pressed": isFavorite,
            onClick: !pending ? this.onClick : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, renderIcon()))));
    }
    constructor(...args){
        super(...args), this.state = {
            isAnimating: false
        }, this.onBtnClickWrapper = (e)=>{
            e.stopPropagation(); // should not let this event get outside of the component, to prevent issue when, for example, star button is clicked in an item or row, which goes somewhere else on onClick handler. Cannot put it in onBtnClick, otherwise hideTooltipOnClick in <Tooltip> will not work
            e.preventDefault(); // same for cases when btn is inside a link - not to go to that link (e.g. in Star Drawer)
        }, this.onClick = (_, analyticsEvent)=>{
            this.props.onClick(analyticsEvent);
        };
    }
}
var $c7558d16e1b4ddea$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $6sjW5.default)({
    onClick: ()=>({
            name: 'star'
        })
}), (0, $6YFG2.default))($c7558d16e1b4ddea$export$f8ad2acf0ec4860f);
const $c7558d16e1b4ddea$var$animationTime = 500; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c7558d16e1b4ddea$export$bb1478fee6cd5f0c = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7558d16e1b4ddea$var$FavoriteIconWrapperBase = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7558d16e1b4ddea$var$FavIconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $c7558d16e1b4ddea$var$FavoriteIconWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.isFavorite ? "_syaz1oqg" : "_syazdgkc",
            __cmplp.isFavorite ? "_30l31vop" : "_30l31q3r",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c7558d16e1b4ddea$export$db65185b5889c83 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6urTU", function(module, exports) {
$parcel$export(module.exports, "default", () => $708ae8e1a771b9ca$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $708ae8e1a771b9ca$var$messages = (0, $7qGN1.defineMessages)({
    addToStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.add-to-starred",
        "defaultMessage": "Add to Starred"
    },
    removeFromStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.remove-from-starred",
        "defaultMessage": "Remove from Starred"
    },
    toggleStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred",
        "defaultMessage": "Star"
    },
    toggleStarredWithItemName: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred-with-item-name",
        "defaultMessage": "Star {itemName}"
    }
});
var $708ae8e1a771b9ca$export$2e2bcd8739ae039 = $708ae8e1a771b9ca$var$messages;

});


parcelRegister("9R7x8", function(module, exports) {
$parcel$export(module.exports, "getFavorite", () => $d577b9b229521b80$export$fce5eda070ce88d0);

var $3ugTQ = parcelRequire("3ugTQ");
const $d577b9b229521b80$export$959ca2ee969adb8d = (request)=>`/rest/internal/2/favourites/${request.type}/${request.id}`;
const $d577b9b229521b80$export$fce5eda070ce88d0 = async (request)=>(0, $3ugTQ.performGetRequest)($d577b9b229521b80$export$959ca2ee969adb8d(request));

});




parcelRegister("hJkmA", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc994481ec05bb8b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $cc994481ec05bb8b$var$messages = (0, $7qGN1.defineMessages)({
    heading: {
        "id": "project-issue-navigator.heading",
        "defaultMessage": "Issues"
    },
    windowTitleMigration: {
        "id": "project-issue-navigator.window-title-migration",
        "defaultMessage": "{projectName} - Issues"
    },
    windowTitleMigrationIssueTermRefresh: {
        "id": "project-issue-navigator.window-title-migration-issue-term-refresh",
        "defaultMessage": "{projectName} - All work"
    },
    headingIssueTermRefresh: {
        "id": "project-issue-navigator.heading-issue-term-refresh",
        "defaultMessage": "All work"
    }
});
var $cc994481ec05bb8b$export$2e2bcd8739ae039 = $cc994481ec05bb8b$var$messages;

});

parcelRegister("7Nlco", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b267bf2ee1c0f9d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $e0I8k = parcelRequire("e0I8k");

var $b5RwB = parcelRequire("b5RwB");

var $guChT = parcelRequire("guChT");

var $ftN6c = parcelRequire("ftN6c");

var $jYYbf = parcelRequire("jYYbf");

var $1Bhzj = parcelRequire("1Bhzj");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $cxKOj = parcelRequire("cxKOj");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $9PZtK = parcelRequire("9PZtK");

var $hqg31 = parcelRequire("hqg31");


var $iCNcB = parcelRequire("iCNcB");

var $hOebY = parcelRequire("hOebY");

var $82cqT = parcelRequire("82cqT");

var $fAgUF = parcelRequire("fAgUF");

var $6fNuu = parcelRequire("6fNuu");

var $iUwEA = parcelRequire("iUwEA");

var $kRgKj = parcelRequire("kRgKj");

var $aaLZH = parcelRequire("aaLZH");

var $gn3Hu = parcelRequire("gn3Hu");
const $3b267bf2ee1c0f9d$var$HierarchyToggleWrapper = ({ children: children })=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.050",
        paddingInline: "space.150",
        onClick: (e)=>e.stopPropagation()
    }, children);
const $3b267bf2ee1c0f9d$var$HideDoneToggleWrapper = ({ children: children })=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.050",
        paddingInline: "space.150",
        onClick: (e)=>e.stopPropagation()
    }, children);
const $3b267bf2ee1c0f9d$var$MaybeSpotlightTarget = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('jira_list_nin_merge') || (0, $4cTDP.fg)('jira_list_conditional_formatting_onboarding'), (0, $guChT.default), ({ children: children })=>children);
const $3b267bf2ee1c0f9d$var$AdditionalItemsWrapper = (0, $f2JN3.componentWithCondition)(()=>(0, $cxKOj.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $3b267bf2ee1c0f9d$var$menuItemStyles
    }, children), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children));
const $3b267bf2ee1c0f9d$var$PageActions = ({ jql: jql, filterId: filterId, isModifiedFilter: isModifiedFilter, searchResultPageData: searchResultPageData, isQuickFiltersDisabled: isQuickFiltersDisabled = false, HierarchyToggle: HierarchyToggle, GroupByDropdown: GroupByDropdown, HideDoneToggle: HideDoneToggle, FiltersMenu: FiltersMenu, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isHideDoneSupportEnabled: isHideDoneSupportEnabled, isHideDoneWorkItemsEnabled: isHideDoneWorkItemsEnabled, isGridNavigationEnabled: isGridNavigationEnabled, SaveResetViewSettingsButton: SaveResetViewSettingsButton, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, onChangeFilter: onChangeFilter, onChangeJqlAndGroupBy: onChangeJqlAndGroupBy })=>{
    (0, $fAgUF.markOnce)((0, $fAgUF.marks).PAGE_ACTIONS_START);
    (0, $eJOHy.useLayoutEffect)(()=>{
        (0, $fAgUF.markOnce)((0, $fAgUF.marks).PAGE_ACTIONS_END);
    }, []);
    const savedFilter = (0, $82cqT.isFilterId)(filterId) ? filterId : undefined; // filter out non-standard PIN named filters
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireAdvanceSearchClickAnalytics = (e)=>{
        const leftClick = e.type === 'contextmenu';
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const withCmd = e.ctrlKey || e.metaKey;
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'advancedSearchButton', {
            openedIn: leftClick && !withCmd ? 'sameTab' : 'newTab'
        });
    };
    const jqlString = isModifiedFilter ? jql : undefined;
    const advancedSearchHref = (0, $4cTDP.fg)('nin_fix_stringify_in_go_to_advanced') ? `/issues/?${(0, $e0I8k.stringify)({
        jql: jqlString,
        filter: filterId
    })}` : `/issues/?${(0, $b5RwB.stringify)({
        jql: jqlString,
        filter: filterId
    })}`;
    const HierarchyToggleComponent = HierarchyToggle !== null && HierarchyToggle !== undefined && (0, $cxKOj.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        key: (0, $a0674c45e0861e1c$export$72cbdf7971462ebd),
        component: $3b267bf2ee1c0f9d$var$HierarchyToggleWrapper
    }, HierarchyToggle) : null;
    const HideDoneToggleComponent = HideDoneToggle !== null && HideDoneToggle !== undefined && (0, $4cTDP.fg)('jsc_list_hide_done_items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: "nin-hide-done-toggle-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        key: (0, $a0674c45e0861e1c$export$6e37bc383199950c),
        component: $3b267bf2ee1c0f9d$var$HideDoneToggleWrapper
    }, HideDoneToggle)) : null;
    const viewOptions = HideDoneToggleComponent || HierarchyToggleComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, HideDoneToggleComponent, HierarchyToggleComponent) : null;
    const additionalMenuItems = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        key: (0, $a0674c45e0861e1c$export$a7a312131aa962e0),
        onClick: (e)=>fireAdvanceSearchClickAnalytics(e),
        href: advancedSearchHref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b267bf2ee1c0f9d$var$AdditionalItemsWrapper, null, formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gn3Hu.default).allIssuesIssueTermRefresh : (0, $gn3Hu.default).allIssues)));
    const customExportTrigger = (isOpen, triggerButtonProps)=>{
        const { triggerRef: triggerRef, ...props } = triggerButtonProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hOebY.FilterIconButton), {
            customTriggerProps: {
                ...props,
                ref: triggerRef
            },
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1Bhzj))),
            label: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gn3Hu.default).exportIssuesButtonIconLabelIssueTermRefresh : (0, $gn3Hu.default).exportIssuesButtonIconLabel),
            isSelected: isOpen
        });
    };
    const customExportDisabled = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hOebY.FilterIconButton), {
        isDisabled: true,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1Bhzj))),
        label: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gn3Hu.default).exportIssuesButtonIconLabelIssueTermRefresh : (0, $gn3Hu.default).exportIssuesButtonIconLabel)
    });
    const [isNaturalLanguageMode] = (0, $iUwEA.useNaturalLanguageMode)();
    const enableQuickFilters = !isNaturalLanguageMode && !isQuickFiltersDisabled;
    const viewSwitcher = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b267bf2ee1c0f9d$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b267bf2ee1c0f9d$var$MaybeSpotlightTarget, {
        name: "project-issue-navigator.ui.page-actions.view-switcher"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6fNuu.default), {
        filterId: filterId
    })));
    const exportMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b267bf2ee1c0f9d$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9PZtK.default), {
        jql: jql,
        filterId: savedFilter,
        isModifiedFilter: isModifiedFilter,
        showEcosystemApps: false,
        isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
        customTriggerButton: customExportTrigger,
        customDisabledButton: customExportDisabled
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b267bf2ee1c0f9d$export$48377ae1c677702b, null, enableQuickFilters && !(0, $cxKOj.expVal)('jira-issue-navigator-saved-filters-menu', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b267bf2ee1c0f9d$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iCNcB.default), {
        onChangeFilter: onChangeFilter
    })), FiltersMenu && (0, $cxKOj.expVal)('jira-issue-navigator-saved-filters-menu', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b267bf2ee1c0f9d$var$StyledPageAction, null, FiltersMenu), GroupByDropdown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b267bf2ee1c0f9d$var$StyledPageAction, null, GroupByDropdown), !(0, $4cTDP.fg)('visual-refresh-headers-buttons') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaLZH.IssueNavigatorFeatureGuard), {
        featureKey: "isExportMenuEnabled",
        on: exportMenu
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaLZH.IssueNavigatorFeatureGuard), {
        featureKey: "isViewSwitcherEnabled",
        on: viewSwitcher
    }), SaveResetViewSettingsButton && (0, $cxKOj.expVal)('saved_list_view', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $3b267bf2ee1c0f9d$var$styles.saveResetButtonWrapper
        ])
    }, SaveResetViewSettingsButton), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b267bf2ee1c0f9d$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b267bf2ee1c0f9d$var$MaybeSpotlightTarget, {
        name: "project-issue-navigator.ui.page-actions.meatball-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hqg31.default), {
        jql: jql,
        filterId: savedFilter,
        searchResultPageData: searchResultPageData,
        additionalMenuItems: additionalMenuItems,
        viewOptions: viewOptions,
        isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
        isHideDoneSupportEnabled: isHideDoneSupportEnabled,
        isHideDoneWorkItemsEnabled: isHideDoneWorkItemsEnabled,
        isModifiedFilter: isModifiedFilter,
        isGridNavigationEnabled: isGridNavigationEnabled,
        isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
        onChangeJqlAndGroupBy: onChangeJqlAndGroupBy
    }))));
};
var $3b267bf2ee1c0f9d$export$2e2bcd8739ae039 = $3b267bf2ee1c0f9d$var$PageActions;
const $3b267bf2ee1c0f9d$var$styles = {
    saveResetButtonWrapper: "_19pkidpf _2hwx1b66 _otyridpf _18u0r5cr _1ul9idpf"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3b267bf2ee1c0f9d$var$StyledPageAction = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1b66 _otyridpf _18u01b66 _1ul9idpf _1xoqidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3b267bf2ee1c0f9d$export$48377ae1c677702b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx2vrvc _1n261q9c",
            __cmplp.className
        ])
    });
});
const $3b267bf2ee1c0f9d$var$menuItemStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.075',
    paddingBottom: 'space.075',
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});

});
parcelRegister("e0I8k", function(module, exports) {
$parcel$export(module.exports, "decode", () => $a3334cc298c2f94d$export$2f872c0f2117be69, (v) => $a3334cc298c2f94d$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "parse", () => $a3334cc298c2f94d$export$98e6a39c04603d36, (v) => $a3334cc298c2f94d$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "encode", () => $a3334cc298c2f94d$export$c564cdbbe6da493, (v) => $a3334cc298c2f94d$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "stringify", () => $a3334cc298c2f94d$export$fac44ee5b035f737, (v) => $a3334cc298c2f94d$export$fac44ee5b035f737 = v);
var $a3334cc298c2f94d$export$2f872c0f2117be69;
var $a3334cc298c2f94d$export$98e6a39c04603d36;
var $a3334cc298c2f94d$export$c564cdbbe6da493;
var $a3334cc298c2f94d$export$fac44ee5b035f737;
'use strict';

$a3334cc298c2f94d$export$2f872c0f2117be69 = $a3334cc298c2f94d$export$98e6a39c04603d36 = (parcelRequire("dsfwg"));

$a3334cc298c2f94d$export$c564cdbbe6da493 = $a3334cc298c2f94d$export$fac44ee5b035f737 = (parcelRequire("6vVY0"));

});
parcelRegister("dsfwg", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $9cb9edb7aa9a3001$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};
    if (typeof qs !== 'string' || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$9cb9edb7aa9a3001$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($9cb9edb7aa9a3001$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $9cb9edb7aa9a3001$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};

});

parcelRegister("6vVY0", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $4be29a4f00cc422b$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? 'true' : 'false';
        case 'number':
            return isFinite(v) ? v : '';
        default:
            return '';
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) obj = undefined;
    if (typeof obj === 'object') return $4be29a4f00cc422b$var$map($4be29a4f00cc422b$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($4be29a4f00cc422b$var$stringifyPrimitive(k)) + eq;
        if ($4be29a4f00cc422b$var$isArray(obj[k])) return $4be29a4f00cc422b$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($4be29a4f00cc422b$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($4be29a4f00cc422b$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return '';
    return encodeURIComponent($4be29a4f00cc422b$var$stringifyPrimitive(name)) + eq + encodeURIComponent($4be29a4f00cc422b$var$stringifyPrimitive(obj));
};
var $4be29a4f00cc422b$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};
function $4be29a4f00cc422b$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $4be29a4f00cc422b$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});


parcelRegister("1Bhzj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::afc4f0315b11d9afea68ddf0758e998e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12a6dfe6352f87c1$var$_react = $12a6dfe6352f87c1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $12a6dfe6352f87c1$var$_baseNew = $12a6dfe6352f87c1$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $12a6dfe6352f87c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Upload".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for upload in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $12a6dfe6352f87c1$var$UploadIcon = (props)=>/*#__PURE__*/ $12a6dfe6352f87c1$var$_react.default.createElement($12a6dfe6352f87c1$var$_baseNew.default, Object.assign({
        name: "UploadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.47 1.22a.75.75 0 0 1 1.06 0l4 4-1.06 1.06-2.72-2.72V11h-1.5V3.56L4.53 6.28 3.47 5.22zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$12a6dfe6352f87c1$var$UploadIcon.displayName = 'UploadIcon';
var $12a6dfe6352f87c1$var$_default = module.exports.default = $12a6dfe6352f87c1$var$UploadIcon;

});

parcelRegister("9PZtK", function(module, exports) {
$parcel$export(module.exports, "default", () => $52db55e2c3054746$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7rjYb = parcelRequire("7rjYb");

var $4cTDP = parcelRequire("4cTDP");

var $5vQ2T = parcelRequire("5vQ2T");

var $lRq8t = parcelRequire("lRq8t");

var $dyvFQ = parcelRequire("dyvFQ");

var $2k6Pt = parcelRequire("2k6Pt");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $71NoK = parcelRequire("71NoK");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $52db55e2c3054746$var$ExportIssues = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("bBtWe")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/actions/export-issues/src/ui/index.tsx"
});
const $52db55e2c3054746$var$Fallback = ({ onRetry: onRetry, customTriggerButton: customTriggerButton })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const triggerButton = ({ triggerRef: triggerRef, ...props })=>customTriggerButton ? customTriggerButton(false, {
            triggerRef: triggerRef,
            ...props
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2k6Pt.FilterButton), {
            ...props,
            text: formatMessage((0, $71NoK.default).exportButtonText),
            label: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $71NoK.default).exportIssuesButtonIconLabelIssueTerminologyRefreshM4 : (0, $71NoK.default).exportIssuesButtonIconLabel),
            ref: triggerRef
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>triggerButton({
                triggerRef: triggerRef,
                ...props
            }),
        shouldFlip: true,
        placement: "bottom-end",
        spacing: "compact",
        shouldRenderToParent: (0, $4cTDP.fg)('should-render-to-parent-should-be-true-empanada')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dyvFQ.ErrorState), {
        onRetry: onRetry,
        pageAction: "exportIssues"
    }));
};
const $52db55e2c3054746$var$AsyncExportIssues = (props)=>{
    const { customTriggerButton: customTriggerButton, customDisabledButton: customDisabledButton } = props;
    const [resetCaughtError, setResetCaughtError] = (0, $eJOHy.useState)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorActionExportIssues",
        id: "async-export-issues",
        sendToPrivacyUnsafeSplunk: true,
        // Attempt to re-render children when retry is pressed in the fallback error state
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($52db55e2c3054746$var$Fallback, {
                onRetry: ()=>setResetCaughtError(error),
                customTriggerButton: customTriggerButton
            }),
        onError: ()=>setResetCaughtError(undefined),
        resetCaughtError: resetCaughtError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-export-issues",
        fallback: customDisabledButton ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2k6Pt.FilterButton), {
            isDisabled: true,
            text: formatMessage((0, $71NoK.default).exportButtonText),
            label: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $71NoK.default).exportIssuesButtonIconLabelIssueTerminologyRefreshM4 : (0, $71NoK.default).exportIssuesButtonIconLabel)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($52db55e2c3054746$var$ExportIssues, props)));
};
var $52db55e2c3054746$export$2e2bcd8739ae039 = $52db55e2c3054746$var$AsyncExportIssues;

});
parcelRegister("2k6Pt", function(module, exports) {
$parcel$export(module.exports, "FilterButton", () => $070635dd59b3e334$export$fb46dd9777cc6db0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $1OQKp = parcelRequire("1OQKp");

var $goZPP = parcelRequire("goZPP");

var $4cTDP = parcelRequire("4cTDP");

var $bzbsd = parcelRequire("bzbsd");

var $9RE4U = parcelRequire("9RE4U");
const $070635dd59b3e334$export$fb46dd9777cc6db0 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isSelected: isSelected, onClick: onClick, testId: testId, vcId: vcId, isDisabled: // cleanup with empanada_nin_remove_data-vc_from_filter-button
isDisabled, text: text, label: label, customTriggerProps: customTriggerProps }, ref)=>{
    const mergedRefs = (0, $bzbsd.default)(ref, customTriggerProps?.ref ?? null);
    const isHydrateRenderMode = (0, $9RE4U.useIsHydrateRenderMode)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        isSelected: isSelected,
        onClick: onClick,
        testId: testId,
        isDisabled: isDisabled,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($070635dd59b3e334$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
            label: label,
            color: "currentColor",
            size: "small"
        })),
        "data-vc": (0, $4cTDP.fg)('empanada_nin_remove_data-vc_from_filter-button') ? undefined : `${vcId}-button${false && !isHydrateRenderMode ? '-ssr' : ''}`,
        ...customTriggerProps,
        ref: mergedRefs
    }, text);
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $070635dd59b3e334$var$IconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y _4cvr1h6o _2hwx196n",
            __cmplp.className
        ])
    });
});

});

parcelRegister("71NoK", function(module, exports) {
$parcel$export(module.exports, "default", () => $172feb23b9791a3f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $172feb23b9791a3f$var$messages = (0, $7qGN1.defineMessages)({
    exportButtonText: {
        "id": "issue-navigator-action-export-issues.export-button-text",
        "defaultMessage": "Export"
    },
    exportIssuesButtonIconLabel: {
        "id": "issue-navigator-action-export-issues.export-issues-button-icon-label",
        "defaultMessage": "Open export issues dropdown"
    },
    exportIssuesButtonIconLabelIssueTerminologyRefreshM4: {
        "id": "issue-navigator-action-export-issues.export-issues-button-icon-label-issue-terminology-refresh-m4",
        "defaultMessage": "Open export work items dropdown"
    }
});
var $172feb23b9791a3f$export$2e2bcd8739ae039 = $172feb23b9791a3f$var$messages;

});

parcelRegister("bBtWe", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hv7bx").then(()=>parcelRequire('4hiou'));

});


parcelRegister("hqg31", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b7f70980314b5ca$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3ag31 = parcelRequire("3ag31");

var $NByNW = parcelRequire("NByNW");

var $7ep4S = parcelRequire("7ep4S");

var $ftN6c = parcelRequire("ftN6c");

var $Ay1uj = parcelRequire("Ay1uj");

var $7rjYb = parcelRequire("7rjYb");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $iWvkh = parcelRequire("iWvkh");

var $cBavF = parcelRequire("cBavF");

var $dZ3jN = parcelRequire("dZ3jN");

var $4cTDP = parcelRequire("4cTDP");

var $dyvFQ = parcelRequire("dyvFQ");

var $lHHP1 = parcelRequire("lHHP1");

var $bzbsd = parcelRequire("bzbsd");

var $kh7bJ = parcelRequire("kh7bJ");

var $kRgKj = parcelRequire("kRgKj");

var $aaLZH = parcelRequire("aaLZH");

var $iHDt0 = parcelRequire("iHDt0");

var $d3C6g = parcelRequire("d3C6g");

var $3kMpn = parcelRequire("3kMpn");

var $eVgYc = parcelRequire("eVgYc");

var $iJf9r = parcelRequire("iJf9r");

const $8b7f70980314b5ca$var$StatisticsOnboardingSpotlight = ({ children: children, shouldShowSpotlight: shouldShowSpotlight, coordinationClient: coordinationClient, onStatisticsTryNow: onStatisticsTryNow, onStatisticsOnboardingStop: onStatisticsOnboardingStop })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eVgYc.StatisticsOnboarding), {
        shouldShowSpotlight: shouldShowSpotlight,
        coordinationClient: coordinationClient,
        onStatisticsTryNow: onStatisticsTryNow,
        onStatisticsOnboardingStop: ()=>onStatisticsOnboardingStop((0, $a9fb9c3dd2da1efa$export$36bc26bb4371a2a))
    }, children);
const $8b7f70980314b5ca$export$ef4a0fdddd7eccb7 = ({ jql: jql, filterId: filterId = '', searchResultPageData: searchResultPageData, additionalMenuItems: additionalMenuItems, showEcosystemAppsInExport: showEcosystemAppsInExport, viewOptions: viewOptions, isHideDoneSupportEnabled: isHideDoneSupportEnabled, isHideDoneWorkItemsEnabled: isHideDoneWorkItemsEnabled, isModifiedFilter: isModifiedFilter, isGridNavigationEnabled: isGridNavigationEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, onChangeJqlAndGroupBy: onChangeJqlAndGroupBy })=>{
    const { data: data, loading: loading, error: error, fetch: fetch, requestPayload: requestPayload } = (0, $iHDt0.useMeatballMenuItems)(searchResultPageData);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isNinChangeboardingEnabled = (0, $eJOHy.useContext)((0, $lHHP1.NinChangeboardingContext));
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    const shouldShowOptOut = isNinChangeboardingEnabled && !isAnonymous && !(0, $4cTDP.fg)('nin_remove_opt_out');
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const lastUsedRequestPayload = (0, $eJOHy.useRef)();
    const hasPreviousError = (0, $eJOHy.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        const isMeatballMenuOpenedWithNewPayload = isOpen && JSON.stringify(requestPayload) !== JSON.stringify(lastUsedRequestPayload.current);
        if (!loading && !hasPreviousError.current && isMeatballMenuOpenedWithNewPayload) {
            fetch(requestPayload);
            lastUsedRequestPayload.current = requestPayload;
        }
        // If there was a fetch error, we clear the lastUsedRequestPayload
        if (error) {
            hasPreviousError.current = true;
            lastUsedRequestPayload.current = undefined;
        }
    }, [
        fetch,
        isOpen,
        loading,
        requestPayload,
        error
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $d3C6g.meatballMenuPopUpEntryPoint), {});
    const { shouldShowSpotlight: shouldShowSpotlight, onStatisticsOnboardingStop: onStatisticsOnboardingStop, coordinationClient: coordinationClient } = (0, $iJf9r.useStatisticsSpotlight)();
    const onStatisticsTryNow = ()=>{
        onStatisticsOnboardingStop((0, $a9fb9c3dd2da1efa$export$e328a74db0175ecc));
        entryPointActions.load();
        setIsOpen(true);
    };
    const isConditionalFormattingEnabled = (0, $4cTDP.fg)('jira_list_conditional_formatting') && // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $aaLZH.useIssueNavigatorFeatures)().isConditionalFormattingEnabled;
    const isConditionalFormattingEditingEnabled = (0, $4cTDP.fg)('saved_list_view_technical_changes') && // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $aaLZH.useIssueNavigatorFeatures)().isConditionalFormattingEditingEnabled;
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            jql: jql,
            filterId: filterId,
            additionalMenuItems: additionalMenuItems,
            viewOptions: viewOptions,
            shouldShowOptOut: shouldShowOptOut,
            data: data,
            showEcosystemAppsInExport: showEcosystemAppsInExport,
            isHideDoneWorkItemsEnabled: isHideDoneSupportEnabled && isHideDoneWorkItemsEnabled && (0, $4cTDP.fg)('jsc_bulk_edit_hide_done_work_items'),
            isConditionalFormattingEnabled: isConditionalFormattingEnabled && (0, $4cTDP.fg)('jira_list_conditional_formatting'),
            isConditionalFormattingEditingEnabled: isConditionalFormattingEnabled && isConditionalFormattingEditingEnabled && (0, $4cTDP.fg)('saved_list_view_technical_changes'),
            isModifiedFilter: isModifiedFilter,
            isGridNavigationEnabled: isGridNavigationEnabled && (0, $4cTDP.fg)('jira_nin_navigation_onboarding'),
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled && (0, $4cTDP.fg)('jsc_project_scoped_column_config_for_csv_export'),
            onChangeJqlAndGroupBy: onChangeJqlAndGroupBy
        }), [
        jql,
        filterId,
        additionalMenuItems,
        viewOptions,
        shouldShowOptOut,
        data,
        showEcosystemAppsInExport,
        isHideDoneSupportEnabled,
        isHideDoneWorkItemsEnabled,
        isConditionalFormattingEnabled,
        isConditionalFormattingEditingEnabled,
        isModifiedFilter,
        isGridNavigationEnabled,
        isInlineFieldConfigEnabled,
        onChangeJqlAndGroupBy
    ]);
    const entryPointTriggerRef = (0, $dZ3jN.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const [retryKey, setRetryKey] = (0, $eJOHy.useState)(0);
    const errorFallback = (onRetry)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dyvFQ.ErrorState), {
            onRetry: onRetry,
            pageAction: "meatballMenu"
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b7f70980314b5ca$var$MaybePlacement, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        isLoading: loading && JSON.stringify(requestPayload) === JSON.stringify(lastUsedRequestPayload.current),
        onOpenChange: (nextState)=>{
            if (nextState.isOpen) hasPreviousError.current = false;
            setIsOpen(nextState.isOpen);
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                action: nextState.isOpen ? 'opened' : 'closed',
                actionSubject: 'button'
            }), 'meatballMenuPopup');
        },
        isOpen: isOpen,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b7f70980314b5ca$var$StatisticsOnboardingSpotlight, {
                shouldShowSpotlight: shouldShowSpotlight,
                onStatisticsTryNow: onStatisticsTryNow,
                onStatisticsOnboardingStop: onStatisticsOnboardingStop,
                coordinationClient: coordinationClient
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
                ref: (0, $bzbsd.mergeRefs)(triggerRef, entryPointTriggerRef),
                ...props,
                testId: "issue-navigator-action-meatball-menu.ui.menu-trigger",
                isSelected: isOpen,
                label: formatMessage((0, $3kMpn.default).moreActionsLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($NByNW))),
                isTooltipDisabled: false
            })),
        shouldFlip: true,
        placement: "bottom-end",
        spacing: "compact",
        testId: "issue-navigator-action-meatball-menu.ui.dropdown-menu"
    }, !error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        key: retryKey,
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "popup-content",
        packageName: "jiraIssueNavigatorActionMeatballMenu",
        errorFallback: ()=>errorFallback(()=>{
                ()=>setRetryKey((prev)=>prev + 1);
            }),
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $8b7f70980314b5ca$var$spinnerContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
            size: "small"
        })),
        runtimeProps: runtimeProps
    }) : errorFallback(()=>{
        fetch(requestPayload);
        lastUsedRequestPayload.current = requestPayload;
    })));
};
const $8b7f70980314b5ca$var$MaybePlacement = ({ children: children })=>{
    if (!(0, $4cTDP.fg)('visual-refresh-headers-buttons') || false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3ag31.Placement), null, children);
};
const $8b7f70980314b5ca$var$spinnerContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
var $8b7f70980314b5ca$export$2e2bcd8739ae039 = $8b7f70980314b5ca$export$ef4a0fdddd7eccb7;

});
parcelRegister("3ag31", function(module, exports) {
$parcel$export(module.exports, "Placement", () => $a60bb8006b782f0c$export$af2bcbdc04a2d456);

var $18ceV = parcelRequire("18ceV");

var $b5GNq = parcelRequire("b5GNq");

var $jsluB = parcelRequire("jsluB");

var $77DYh = parcelRequire("77DYh");
const $a60bb8006b782f0c$export$fb7710cf8bc72648 = (0, $jsluB.PlacementBackend).createPlacementBackend({
    messageTemplates: [
        (0, $18ceV.MessageBackend)({
            messageTemplateId: 'export-issues-flyout-in-meatball-menu'
        })
    ]
});
const $a60bb8006b782f0c$export$7b621692a0aa2333 = (0, $jsluB.PlacementFrontend).createPlacementFrontendComponent({
    messageTemplates: [
        (0, $18ceV.MessageFrontend)({
            messageTemplateId: 'export-issues-flyout-in-meatball-menu'
        })
    ]
});
const $a60bb8006b782f0c$export$af2bcbdc04a2d456 = (0, $77DYh.withI18n)($a60bb8006b782f0c$export$7b621692a0aa2333);
const $a60bb8006b782f0c$export$7d3d92a960f07a28 = $a60bb8006b782f0c$export$7b621692a0aa2333;
const $a60bb8006b782f0c$export$5a7767152ae0305f = $a60bb8006b782f0c$export$fb7710cf8bc72648((0, $b5GNq.productionRuntime));

});
parcelRegister("18ceV", function(module, exports) {
$parcel$export(module.exports, "MessageBackend", () => $3ae172d1d54e1441$export$e7843a8f64a8d87c);
$parcel$export(module.exports, "MessageFrontend", () => $3ae172d1d54e1441$export$fa9bb46961aca2cc);

var $gt9Am = parcelRequire("gt9Am");

var $9Uh9I = parcelRequire("9Uh9I");

var $fHiX9 = parcelRequire("fHiX9");
parcelRequire("eJOHy");

var $5ZM4Y = parcelRequire("5ZM4Y");

var $hPP7q = parcelRequire("hPP7q");
const $3ae172d1d54e1441$export$e7843a8f64a8d87c = (0, $fHiX9.PlacementBackend).createMessageBackend((0, $9Uh9I.defaultMessageBackend));
const $3ae172d1d54e1441$export$fa9bb46961aca2cc = (0, $fHiX9.PlacementFrontend).createMessageFrontend({
    render: {
        validate: (0, $hPP7q.assertMessageTemplateContext),
        Component: ({ children: children, isEnabled: isEnabled })=>{
            if (!isEnabled) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
                children: children
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5ZM4Y.ExportIssuesFlyoutSpotlight), {
                children: children
            });
        }
    }
});

});
parcelRegister("fHiX9", function(module, exports) {
$parcel$export(module.exports, "PlacementFrontend", () => $5fe576f3af9d53ce$export$55486c2b6964dcf2);
$parcel$export(module.exports, "PlacementBackend", () => $5fe576f3af9d53ce$export$d90b37843c84d1c3);

var $gt9Am = parcelRequire("gt9Am");

var $59rsN = parcelRequire("59rsN");

var $kX7CT = parcelRequire("kX7CT");

var $fuwhX = parcelRequire("fuwhX");
parcelRequire("eJOHy");
const { createFrontend: $5fe576f3af9d53ce$export$81df3aa6753d44e2, createBackend: $5fe576f3af9d53ce$export$da912f58cb37a643 } = (0, $kX7CT.createPlacement)({
    placementId: 'jira-filter-refinement-filter-button',
    options: {
        choreographer: {
            isDefaultEnabled: false
        }
    }
});
const $5fe576f3af9d53ce$export$55486c2b6964dcf2 = $5fe576f3af9d53ce$export$81df3aa6753d44e2((Messages)=>({ children: children, view: view })=>{
        const { data: data, error: error, isLoading: isLoading } = (0, $fuwhX.usePlacementApi)('/', view && (0, $59rsN.default).checkGate('changeboarding-filter-refinement-in-nin') ? {
            queryParams: {
                view: view
            }
        } : undefined);
        if (!children) return null;
        if (error || isLoading || data.messages.length === 0) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: children
        });
        const [message] = data.messages;
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Messages.render, {
            ...message,
            children: children
        });
    });
const $5fe576f3af9d53ce$export$d90b37843c84d1c3 = $5fe576f3af9d53ce$export$da912f58cb37a643();

});

parcelRegister("5ZM4Y", function(module, exports) {
$parcel$export(module.exports, "ExportIssuesFlyoutSpotlight", () => $479ebbc40d3484ed$export$1e07e937d0723d62);

var $gt9Am = parcelRequire("gt9Am");

var $fceQU = parcelRequire("fceQU");

var $bdRit = parcelRequire("bdRit");
var $fBe2p = parcelRequire("fBe2p");
var $d2s5v = parcelRequire("d2s5v");

var $k9r6D = parcelRequire("k9r6D");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $8Pf3V = parcelRequire("8Pf3V");
const $479ebbc40d3484ed$export$1e07e937d0723d62 = ({ children: children })=>{
    const [isActive, setIsActive] = (0, $eJOHy.useState)(true);
    const { messageInstanceClicked: messageInstanceClicked } = (0, $k9r6D.useMessageInstanceEvent)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleRead = (0, $eJOHy.useCallback)(()=>{
        setIsActive(false);
        messageInstanceClicked({
            action: {
                actionType: 'read'
            },
            additionalMetadataFromFrontend: {},
            clickedElement: {
                buttonType: 'primary',
                clickedElement: 'button',
                clickIdentifier: 'okButton'
            },
            messageEventType: 'clicked'
        });
    }, [
        messageInstanceClicked
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const handleEscape = (ev)=>{
            if (ev.key === 'Escape') handleRead();
        };
        (0, $fceQU.getDocument)()?.addEventListener('keydown', handleEscape);
        return ()=>{
            (0, $fceQU.getDocument)()?.removeEventListener('keydown', handleEscape);
        };
    }, [
        handleRead
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fBe2p.Pulse), {
                radius: 3,
                pulse: isActive,
                children: children
            }),
            isActive && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d2s5v.default), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bdRit.default), {
                    actions: [
                        {
                            onClick: handleRead,
                            text: formatMessage((0, $8Pf3V.spotlightMessages).spotlightOkButton),
                            appearance: 'default'
                        }
                    ],
                    heading: formatMessage((0, $8Pf3V.spotlightMessages).spotlightHeading),
                    target: "nin.page-actions.meatball-menu-popup-exports",
                    targetRadius: 3,
                    dialogWidth: 270,
                    targetBgColor: "var(--ds-surface, #FFFFFF)",
                    pulse: true,
                    testId: "export-issues-flyout-spotlight",
                    dialogPlacement: "left top",
                    children: formatMessage((0, $8Pf3V.spotlightMessages).spotlightBody)
                }, "nin.page-actions.meatball-menu-popup-exports")
            })
        ]
    });
};
var $479ebbc40d3484ed$export$2e2bcd8739ae039 = $479ebbc40d3484ed$export$1e07e937d0723d62;

});
parcelRegister("8Pf3V", function(module, exports) {
$parcel$export(module.exports, "spotlightMessages", () => $3483c7bbf39aede1$export$ba730283fc11b703);

var $7qGN1 = parcelRequire("7qGN1");
const $3483c7bbf39aede1$export$ba730283fc11b703 = (0, $7qGN1.defineMessages)({
    spotlightHeading: {
        id: 'export-issues-flyout-spotlight-tour.spotlight.heading',
        defaultMessage: 'Export options have moved',
        description: 'Heading for the export issues flyout spotlight'
    },
    spotlightBody: {
        id: 'export-issues-flyout-spotlight-tour.spotlight.body',
        defaultMessage: 'Export your work items in the format you need, right from the more actions menu.',
        description: 'Body for the export issues flyout spotlight'
    },
    spotlightOkButton: {
        id: 'export-issues-flyout-spotlight-tour.spotlight.okButton',
        defaultMessage: 'OK',
        description: 'OK button for the export issues flyout spotlight'
    }
});

});


parcelRegister("hPP7q", function(module, exports) {
$parcel$export(module.exports, "assertMessageTemplateContext", () => $67c50fb583204f0b$export$a7a9523472993e97);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var $jQKKt = parcelRequire("jQKKt");
function $67c50fb583204f0b$export$a7a9523472993e97(value) {
    const result = $67c50fb583204f0b$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $jQKKt.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $67c50fb583204f0b$export$226b3eccf92c9ed9(value) {
    const result = $67c50fb583204f0b$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $67c50fb583204f0b$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('isEnabled' in value)) errors.push({
            path: 'value["isEnabled"]',
            expected: 'boolean',
            value: undefined
        });
        else if (typeof value["isEnabled"] !== 'boolean') errors.push({
            path: 'value["isEnabled"]',
            expected: 'boolean',
            value: value["isEnabled"]
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}

});
parcelRegister("jQKKt", function(module, exports) {
$parcel$export(module.exports, "AssertError", () => $c4daae6043073904$export$1483326e00b53fdb);
/**
 * The Marker type that represents a type that can be used to generate validation code.
 *
 * Wrapping a type with this type will direct the code generator to generate validation code for it.
 */ class $c4daae6043073904$export$1483326e00b53fdb extends Error {
    constructor(method, path, expected, value){
        const message = path ? `Error on ${method}(): invalid type on ${path}, expect to be ${expected}` : `Error on ${method}(): invalid type, expect to be ${expected}`;
        super(message), this.method = method, this.path = path, this.expected = expected, this.value = value;
    }
}

});



parcelRegister("jsluB", function(module, exports) {
$parcel$export(module.exports, "PlacementFrontend", () => $c6a58a216d8040cb$export$55486c2b6964dcf2);
$parcel$export(module.exports, "PlacementBackend", () => $c6a58a216d8040cb$export$d90b37843c84d1c3);

var $gt9Am = parcelRequire("gt9Am");

var $kX7CT = parcelRequire("kX7CT");

var $fuwhX = parcelRequire("fuwhX");
parcelRequire("eJOHy");
const { createFrontend: $c6a58a216d8040cb$export$81df3aa6753d44e2, createBackend: $c6a58a216d8040cb$export$da912f58cb37a643 } = (0, $kX7CT.createPlacement)({
    placementId: 'jira-nin-meatball-menu-button',
    options: {
        choreographer: {
            isDefaultEnabled: false
        }
    }
});
const $c6a58a216d8040cb$export$55486c2b6964dcf2 = $c6a58a216d8040cb$export$81df3aa6753d44e2((Messages)=>({ children: children })=>{
        const { data: data, error: error, isLoading: isLoading } = (0, $fuwhX.usePlacementApi)('/');
        if (!children) return null;
        if (error || isLoading || data.messages.length === 0) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: children
        });
        const [message] = data.messages;
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Messages.render, {
            ...message,
            children: children
        });
    });
const $c6a58a216d8040cb$export$d90b37843c84d1c3 = $c6a58a216d8040cb$export$da912f58cb37a643();

});

parcelRegister("77DYh", function(module, exports) {
$parcel$export(module.exports, "withI18n", () => $97e539c92609961c$export$bfba3ccd9d9038f9);

var $4rvk5 = parcelRequire("4rvk5");

var $gqnrm = parcelRequire("gqnrm");
const $97e539c92609961c$export$bfba3ccd9d9038f9 = (0, $4rvk5.createWithI18n)((0, $gqnrm.messagesLoader));

});


parcelRegister("iHDt0", function(module, exports) {
$parcel$export(module.exports, "useMeatballMenuItems", () => $da015a7edbce1610$export$dcc369963df3381d);

var $eJOHy = parcelRequire("eJOHy");

var $b5RwB = parcelRequire("b5RwB");

var $bKKGc = parcelRequire("bKKGc");

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");
const $da015a7edbce1610$export$162e19c052deab0b = '/rest/issueNav/1/issueNav/operations/tools';
const $da015a7edbce1610$export$34482912a4c2747c = (options)=>(0, $3ugTQ.performPostRequest)($da015a7edbce1610$export$162e19c052deab0b, {
        credentials: 'same-origin',
        body: (0, $b5RwB.stringify)(options),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Atlassian-Token': 'no-check',
            __amdModuleName: 'jira/issue/utils/xsrf-token-header'
        }
    });
const $da015a7edbce1610$export$dcc369963df3381d = (searchResultPageData)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $bKKGc.useService)($da015a7edbce1610$export$34482912a4c2747c);
    const { offset: offset, pages: pages, total: total } = searchResultPageData;
    // Issue count here is used to show warning message in
    // bulk edit page. We show a warning message if the issue count is > 999.
    const allIssues = total > 999 ? 1000 : 999;
    const requestPayload = {
        offset: offset,
        searchResultsTotal: allIssues,
        searchResultsPages: pages,
        // useColumns and skipColumns aren't used in the endpoint but is required for the constructor
        useColumns: false,
        skipColumns: false,
        new: true
    };
    (0, $eJOHy.useEffect)(()=>{
        if (loading) return;
        if (error) (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            event: createAnalyticsEvent({}),
            meta: {
                id: 'useMeatballMenuItems'
            }
        });
        else if (data) (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'useMeatballMenuItems succeeded', 'meatballMenu');
    }, [
        createAnalyticsEvent,
        data,
        error,
        loading
    ]);
    return {
        loading: loading,
        error: error,
        data: data,
        fetch: fetch,
        requestPayload: requestPayload
    };
};

});

parcelRegister("d3C6g", function(module, exports) {
$parcel$export(module.exports, "meatballMenuPopUpEntryPoint", () => $a008388a2916bef0$export$a544c6272b25c45e);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $a008388a2916bef0$export$a544c6272b25c45e = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("fu5SQ")), {
        moduleId: "87e9200c",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fu5SQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4FQLY").then(()=>parcelRequire('dxZWk'));

});


parcelRegister("3kMpn", function(module, exports) {
$parcel$export(module.exports, "default", () => $398b8087b6e6aa75$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $398b8087b6e6aa75$var$messages = (0, $7qGN1.defineMessages)({
    applyOldListSettings: {
        "id": "issue-navigator-action-meatball-menu.apply-old-list-settings",
        "defaultMessage": "Apply settings from the old List view"
    },
    applyOldListSettingsDescription: {
        "id": "issue-navigator-action-meatball-menu.apply-old-list-settings-description",
        "defaultMessage": "This includes the filters, groups, and columns you've set"
    },
    applyOldListSettingsCurrentSpace: {
        "id": "issue-navigator-action-meatball-menu.apply-old-list-settings-current-space",
        "defaultMessage": "Apply settings from {spaceName} space"
    },
    applyOldListSettingsCurrentSpaceFallback: {
        "id": "issue-navigator-action-meatball-menu.apply-old-list-settings-current-space-fallback",
        "defaultMessage": "current"
    },
    applyOldListSettingsAllSpaces: {
        "id": "issue-navigator-action-meatball-menu.apply-old-list-settings-all-spaces",
        "defaultMessage": "Yes, apply settings from all Jira spaces"
    },
    applyOldListSettingsCancel: {
        "id": "issue-navigator-action-meatball-menu.apply-old-list-settings-cancel",
        "defaultMessage": "Cancel"
    },
    applyOldListSettingsApply: {
        "id": "issue-navigator-action-meatball-menu.apply-old-list-settings-apply",
        "defaultMessage": "Apply"
    },
    moreActionsLabel: {
        "id": "issue-navigator-action-meatball-menu.more-actions-label",
        "defaultMessage": "More actions"
    },
    actionsOptOutDisplayText: {
        "id": "issue-navigator-action-meatball-menu.actions-opt-out-display-text",
        "defaultMessage": "Go back to the old issue search"
    },
    actionsGiveFeedbackDisplayText: {
        "id": "issue-navigator-action-meatball-menu.actions-give-feedback-display-text",
        "defaultMessage": "Give feedback"
    },
    feedbackTitle: {
        "id": "issue-navigator-action-meatball-menu.feedback-title",
        "defaultMessage": "Give feedback for issue search"
    },
    feedbackTitleDetails: {
        "id": "issue-navigator-action-meatball-menu.feedback-title-details",
        "defaultMessage": "Let us know how we can improve this experience."
    },
    feedbackTitleDetailsContactSupport: {
        "id": "issue-navigator-action-meatball-menu.feedback-title-details-contact-support",
        "defaultMessage": "If you\u2019re having technical issues, contact our support team."
    },
    feedbackTypePlaceholder: {
        "id": "issue-navigator-action-meatball-menu.feedback-type-placeholder",
        "defaultMessage": "Select an option"
    },
    bulkChangeIssues: {
        "id": "issue-navigator-action-meatball-menu.bulk-change-issues",
        "defaultMessage": "Bulk change work items"
    },
    viewIssuesAsAChart: {
        "id": "issue-navigator-action-meatball-menu.view-issues-as-a-chart",
        "defaultMessage": "View issues as a chart"
    },
    viewWorkItemsAsAChart: {
        "id": "issue-navigator-action-meatball-menu.view-issues-as-a-chart-issue-term-refresh",
        "defaultMessage": "View work items as a chart"
    },
    export: {
        "id": "issue-navigator-action-meatball-menu.export",
        "defaultMessage": "Export"
    },
    newLozengeLabel: {
        "id": "issue-navigator-action-meatball-menu.new-lozenge-label",
        "defaultMessage": "New"
    },
    actionsOptOutDisplayTextIssueTerminologyRefreshM4: {
        "id": "issue-navigator-action-meatball-menu.actions-opt-out-display-text-issue-terminology-refresh-m4",
        "defaultMessage": "Go back to the old search"
    },
    feedbackTitleIssueTerminologyRefreshM4: {
        "id": "issue-navigator-action-meatball-menu.feedback-title-issue-terminology-refresh-m4",
        "defaultMessage": "Give feedback for the search"
    },
    formatRules: {
        "id": "issue-navigator-action-meatball-menu.formatRules",
        "defaultMessage": "Format rules"
    },
    keyboardNavigation: {
        "id": "issue-navigator-action-meatball-menu.keyboard-navigation",
        "defaultMessage": "Keyboard navigation"
    }
});
var $398b8087b6e6aa75$export$2e2bcd8739ae039 = $398b8087b6e6aa75$var$messages;

});

parcelRegister("eVgYc", function(module, exports) {
$parcel$export(module.exports, "StatisticsOnboarding", () => $893409cbddc2af78$export$d628ca45cec6f862);

var $eJOHy = parcelRequire("eJOHy");

var $fBe2p = parcelRequire("fBe2p");
var $guChT = parcelRequire("guChT");
var $d2s5v = parcelRequire("d2s5v");

var $58yRG = parcelRequire("58yRG");

var $6zxfT = parcelRequire("6zxfT");

var $kwVIr = parcelRequire("kwVIr");

var $hJw7S = parcelRequire("hJw7S");

var $lRq8t = parcelRequire("lRq8t");

var $iC2Fk = parcelRequire("iC2Fk");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $4stTh = parcelRequire("4stTh");

const $893409cbddc2af78$export$d628ca45cec6f862 = ({ shouldShowSpotlight: shouldShowSpotlight, coordinationClient: coordinationClient, onStatisticsTryNow: onStatisticsTryNow, onStatisticsOnboardingStop: onStatisticsOnboardingStop, children: children })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { colorMode: colorMode } = (0, $58yRG.default)();
    if (!shouldShowSpotlight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6zxfT.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: "nin-meatball-button-statistics-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fBe2p.Pulse), {
        radius: 3,
        pulse: shouldShowSpotlight
    }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iC2Fk.JiraSpotlight), {
        heading: formatMessage((0, $4stTh.default).getWorkInsights),
        messageId: (0, $4cTDP.fg)('helios_nin_statistics_onboarding_spotlight') ? (0, $a9fb9c3dd2da1efa$export$e57f07f68ad825f4) : (0, $a9fb9c3dd2da1efa$export$60f0ae43d6be43f1),
        image: colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($hJw7S))) : (0, (/*@__PURE__*/$parcel$interopDefault($kwVIr))),
        key: "nin-meatball-button-statistics-spotlight",
        actions: [
            {
                onClick: onStatisticsTryNow,
                text: formatMessage((0, $4stTh.default).tryItOut)
            },
            {
                onClick: onStatisticsOnboardingStop,
                text: formatMessage((0, $4stTh.default).dismiss)
            }
        ],
        targetRadius: 3,
        targetBgColor: "var(--ds-background-discovery, #F8EEFE)",
        target: "nin-meatball-button-statistics-spotlight",
        messageType: "engagement",
        dialogPlacement: "bottom right"
    }, (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? formatMessage((0, $4stTh.default).onboardingStatisticsDescriptionIssueTermRefresh) : formatMessage((0, $4stTh.default).onboardingStatisticsDescription))));
};

});
parcelRegister("kwVIr", function(module, exports) {
module.exports = new URL("issue-view-statistics-onboarding.3f045443.gif", import.meta.url).toString();

});

parcelRegister("hJw7S", function(module, exports) {
module.exports = new URL("issue-view-statistics-onboarding-dark-mode.18820f06.gif", import.meta.url).toString();

});

parcelRegister("4stTh", function(module, exports) {
$parcel$export(module.exports, "default", () => $11d534166ca1c173$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $11d534166ca1c173$var$messages = (0, $7qGN1.defineMessages)({
    onboardingStatisticsDescription: {
        "id": "issue-navigator-action-meatball-menu.onboarding-statistics-description",
        "defaultMessage": "You can now create charts from filtered issues for quick and useful insights."
    },
    onboardingStatisticsDescriptionIssueTermRefresh: {
        "id": "issue-navigator-action-meatball-menu.onboarding-statistics-description-issue-term-refresh",
        "defaultMessage": "You can now create charts from filtered work items for quick and useful insights."
    },
    tryItOut: {
        "id": "issue-navigator-action-meatball-menu.try-it-out",
        "defaultMessage": "Try it out"
    },
    dismiss: {
        "id": "issue-navigator-action-meatball-menu.dismiss",
        "defaultMessage": "Dismiss"
    },
    getWorkInsights: {
        "id": "issue-navigator-action-meatball-menu.get-work-insights",
        "defaultMessage": "Get work insights"
    }
});
var $11d534166ca1c173$export$2e2bcd8739ae039 = $11d534166ca1c173$var$messages;

});

const $a9fb9c3dd2da1efa$export$c7e6a6b283196232 = '/gateway/api';
const $a9fb9c3dd2da1efa$export$60f0ae43d6be43f1 = 'jira-nin-statistics-onboarding-spotlight';
const $a9fb9c3dd2da1efa$export$e57f07f68ad825f4 = 'jira_helios_nin_statistics_onboarding';
const $a9fb9c3dd2da1efa$export$e328a74db0175ecc = 'jiraNinStatisticsOnboardingTryItOut';
const $a9fb9c3dd2da1efa$export$36bc26bb4371a2a = 'jiraNinStatisticsOnboardingDismiss';
const $a9fb9c3dd2da1efa$export$db1926f449c86467 = 'jiraNinStatisticsOnboardingSpotlight';


parcelRegister("iJf9r", function(module, exports) {
$parcel$export(module.exports, "useStatisticsSpotlight", () => $ae90a3ffa5b02d19$export$e4f5ca4f8dca0290);

var $eJOHy = parcelRequire("eJOHy");

var $7UDun = parcelRequire("7UDun");

var $9zZj0 = parcelRequire("9zZj0");

var $cHtIB = parcelRequire("cHtIB");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4cTDP = parcelRequire("4cTDP");

const $ae90a3ffa5b02d19$export$e4f5ca4f8dca0290 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const [showPulse, setShowPulse] = (0, $eJOHy.useState)(false);
    const coordinationClient = (0, $eJOHy.useMemo)(()=>new (0, $9zZj0.CoordinationClient)(cloudId, (0, $a9fb9c3dd2da1efa$export$c7e6a6b283196232), false, '', 'engagement'), [
        cloudId
    ]);
    const [isMessageActive, stopMessage] = (0, $7UDun.useCoordination)(coordinationClient, (0, $4cTDP.fg)('helios_nin_statistics_onboarding_spotlight') ? (0, $a9fb9c3dd2da1efa$export$e57f07f68ad825f4) : (0, $a9fb9c3dd2da1efa$export$60f0ae43d6be43f1));
    (0, $eJOHy.useEffect)(()=>{
        if (isMessageActive) {
            setShowPulse(true);
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                action: 'viewed',
                actionSubject: 'spotlight'
            }), (0, $a9fb9c3dd2da1efa$export$db1926f449c86467));
        }
    }, [
        coordinationClient,
        createAnalyticsEvent,
        isMessageActive
    ]);
    const onStatisticsOnboardingStop = (0, $eJOHy.useCallback)((actionSubject)=>{
        stopMessage();
        setShowPulse(false);
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: `${actionSubject} button`
        }));
    }, [
        stopMessage,
        createAnalyticsEvent
    ]);
    return {
        shouldShowSpotlight: showPulse,
        onStatisticsOnboardingStop: onStatisticsOnboardingStop,
        coordinationClient: coordinationClient
    };
};

});


const $a0674c45e0861e1c$export$8a0f2e68464a820f = 'bulk_create_dd_link';
const $a0674c45e0861e1c$export$efad93080758a558 = 'bulkedit_curr_pg';
const $a0674c45e0861e1c$export$66cb530046350ea5 = 'bulkedit_all';
const $a0674c45e0861e1c$export$df7b2838a6fc207e = 'gin-meatball-menu-clear-sorts';
const $a0674c45e0861e1c$export$e389676e8d50a810 = 'opt-out-feedback';
const $a0674c45e0861e1c$export$c1dcd93cb65a1cc5 = 'connect-app';
const $a0674c45e0861e1c$export$3c1bb52064935485 = 'give-feedback';
const $a0674c45e0861e1c$export$a7a312131aa962e0 = 'go-to-all-issues';
const $a0674c45e0861e1c$export$72cbdf7971462ebd = 'hierarchy-toggle';
const $a0674c45e0861e1c$export$6e37bc383199950c = 'hide-done-toggle';
const $a0674c45e0861e1c$export$5fba477f4490fb8 = 'view-issues-as-a-chart';
const $a0674c45e0861e1c$export$ca7970ebc7c680b2 = 'conditional-formatting';
const $a0674c45e0861e1c$export$d544dff0deb6c9b0 = 'export-issues';
const $a0674c45e0861e1c$export$f95c3bbe4abbef8 = 'keyboard-navigation';
const $a0674c45e0861e1c$export$66ddeb1986afb940 = 'apply-old-list-settings';

parcelRegister("iCNcB", function(module, exports) {
$parcel$export(module.exports, "default", () => $951529af43e759ab$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $KDB2z = parcelRequire("KDB2z");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $kh7bJ = parcelRequire("kh7bJ");

var $gCY1z = parcelRequire("gCY1z");

var $lR5Ef = parcelRequire("lR5Ef");
const $951529af43e759ab$var$QuickFiltersDropdown = ({ isOpen: isOpen = false, onChangeFilter: onChangeFilter })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [{ match: match }] = (0, $gCY1z.useRouter)();
    const urlPrefix = match.url.endsWith('/') ? `${match.url}?filter=` : `${match.url}/?filter=`;
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleOnOpenChange = (0, $eJOHy.useCallback)(({ isOpen: newIsOpen })=>{
        if (newIsOpen) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'opened',
            actionSubject: 'dropdown'
        }), 'issueNavigatorQuickFiltersDropdown');
        else (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'dropdown'
        }), 'issueNavigatorQuickFiltersDropdown');
    }, [
        createAnalyticsEvent
    ]);
    const handleOnClick = (0, $eJOHy.useCallback)((filter)=>(e)=>{
            if (onChangeFilter) {
                onChangeFilter(filter);
                e.preventDefault();
            }
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'filter',
                action: 'selected'
            }), 'issueNavigatorQuickFiltersDropdown', {
                filter: filter
            });
        }, [
        createAnalyticsEvent,
        onChangeFilter
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
                ...props,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($KDB2z))),
                label: formatMessage((0, $lR5Ef.default).quickFilterDropdownTrigger),
                ref: triggerRef,
                isTooltipDisabled: false
            }),
        shouldRenderToParent: true,
        defaultOpen: isOpen,
        testId: "issue-navigator-action-quick-filters",
        onOpenChange: handleOnOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        href: `${urlPrefix}myopenissues`,
        onClick: handleOnClick('myopenissues')
    }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $lR5Ef.default).myOpenIssuesIssueTermRefresh : (0, $lR5Ef.default).myOpenIssues)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        href: `${urlPrefix}reportedbyme`,
        onClick: handleOnClick('reportedbyme')
    }, formatMessage((0, $lR5Ef.default).reportedByMe)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        href: `${urlPrefix}allopenissues`,
        onClick: handleOnClick('allopenissues')
    }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $lR5Ef.default).openIssuesIssueTermRefresh : (0, $lR5Ef.default).openIssues)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        href: `${urlPrefix}doneissues`,
        onClick: handleOnClick('doneissues')
    }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $lR5Ef.default).doneIssuesIssueTermRefresh : (0, $lR5Ef.default).doneIssues)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        href: `${urlPrefix}recentlyviewed`,
        onClick: handleOnClick('recentlyviewed')
    }, formatMessage((0, $lR5Ef.default).viewedRecently)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        href: `${urlPrefix}resolvedrecently`,
        onClick: handleOnClick('resolvedrecently')
    }, formatMessage((0, $lR5Ef.default).resolvedRecently)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        href: `${urlPrefix}updatedrecently`,
        onClick: handleOnClick('updatedrecently')
    }, formatMessage((0, $lR5Ef.default).updatedRecently))));
};
var $951529af43e759ab$export$2e2bcd8739ae039 = $951529af43e759ab$var$QuickFiltersDropdown;

});
parcelRegister("lR5Ef", function(module, exports) {
$parcel$export(module.exports, "default", () => $7183a7bee28dabf3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $7183a7bee28dabf3$var$messages = (0, $7qGN1.defineMessages)({
    quickFilterDropdownTrigger: {
        "id": "issue-navigator-action-quick-filters.quick-filter-dropdown-trigger",
        "defaultMessage": "Quick filters"
    },
    myOpenIssues: {
        "id": "issue-navigator-action-quick-filters.my-open-issues",
        "defaultMessage": "My open issues"
    },
    myOpenIssuesIssueTermRefresh: {
        "id": "issue-navigator-action-quick-filters.my-open-issues-issue-term-refresh",
        "defaultMessage": "My open work items"
    },
    reportedByMe: {
        "id": "issue-navigator-action-quick-filters.reported-by-me",
        "defaultMessage": "Reported by me"
    },
    openIssues: {
        "id": "issue-navigator-action-quick-filters.open-issues",
        "defaultMessage": "Open issues"
    },
    openIssuesIssueTermRefresh: {
        "id": "issue-navigator-action-quick-filters.open-issues-issue-term-refresh",
        "defaultMessage": "Open work items"
    },
    doneIssues: {
        "id": "issue-navigator-action-quick-filters.done-issues",
        "defaultMessage": "Done issues"
    },
    doneIssuesIssueTermRefresh: {
        "id": "issue-navigator-action-quick-filters.done-issues-issue-term-refresh",
        "defaultMessage": "Done work items"
    },
    viewedRecently: {
        "id": "issue-navigator-action-quick-filters.viewed-recently",
        "defaultMessage": "Viewed recently"
    },
    createdRecently: {
        "id": "issue-navigator-action-quick-filters.created-recently",
        "defaultMessage": "Created recently"
    },
    resolvedRecently: {
        "id": "issue-navigator-action-quick-filters.resolved-recently",
        "defaultMessage": "Resolved recently"
    },
    updatedRecently: {
        "id": "issue-navigator-action-quick-filters.updated-recently",
        "defaultMessage": "Updated recently"
    }
});
var $7183a7bee28dabf3$export$2e2bcd8739ae039 = $7183a7bee28dabf3$var$messages;

});


parcelRegister("hOebY", function(module, exports) {
$parcel$export(module.exports, "FilterIconButton", () => $321f0f715ecfa0ae$export$2c752f0ff253a7e6);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $321f0f715ecfa0ae$export$2c752f0ff253a7e6 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isSelected: isSelected, onClick: onClick, testId: testId, isDisabled: isDisabled, icon: icon, label: label, customTriggerProps: customTriggerProps }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $321f0f715ecfa0ae$var$iconButtonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        isDisabled: isDisabled,
        icon: icon,
        label: label,
        ...customTriggerProps
    })));
const $321f0f715ecfa0ae$var$iconButtonWrapperStyles = (0, $1DXK0.xcss)({
    position: 'relative'
});

});

parcelRegister("6fNuu", function(module, exports) {
$parcel$export(module.exports, "default", () => $05b34bd9feb8ad95$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $9S9DZ = parcelRequire("9S9DZ");

var $8IeH1 = parcelRequire("8IeH1");

var $1OKaP = parcelRequire("1OKaP");

var $k71qx = parcelRequire("k71qx");

var $fo3wk = parcelRequire("fo3wk");

var $cxKOj = parcelRequire("cxKOj");

var $dTocu = parcelRequire("dTocu");

var $82cqT = parcelRequire("82cqT");

var $lHHP1 = parcelRequire("lHHP1");

var $6sTi7 = parcelRequire("6sTi7");

var $fNOMn = parcelRequire("fNOMn");

var $437hw = parcelRequire("437hw");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $1JGvk = parcelRequire("1JGvk");

var $4cTDP = parcelRequire("4cTDP");

var $iRahl = parcelRequire("iRahl");

var $eibCx = parcelRequire("eibCx");

var $fAgUF = parcelRequire("fAgUF");

var $1wL9i = parcelRequire("1wL9i");

var $HiS1C = parcelRequire("HiS1C");

var $gApH5 = parcelRequire("gApH5");
const $05b34bd9feb8ad95$var$KeyboardShortcuts = ({ view: view, onToggle: onToggle, intl: { formatMessage: formatMessage } })=>{
    const isDetailView = view === (0, $iRahl.views).detail;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fo3wk.default), {
        keyMap: {
            t: {
                callback: ()=>{
                    const newView = isDetailView ? (0, $iRahl.views).list : (0, $iRahl.views).detail;
                    onToggle(newView, true);
                },
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage(isDetailView ? (0, $gApH5.default).listText : (0, $gApH5.default).detailText))
            }
        }
    });
};
const $05b34bd9feb8ad95$export$c774a1845e27fedc = ({ view: view, onToggle: onToggle, intl: intl })=>{
    const { formatMessage: formatMessage } = intl;
    const testIdPrefix = 'issue-navigator.ui.refinement-bar.view-switcher.toggle-button.';
    const listLabel = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: formatMessage((0, $gApH5.default).listOptionLabel)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            paddingInline: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OKaP))), {
            label: formatMessage((0, $gApH5.default).listOptionLabel)
        }))), [
        formatMessage
    ]);
    const detailLabel = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: formatMessage((0, $gApH5.default).detailOptionLabel)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            paddingInline: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9S9DZ))), {
            label: formatMessage((0, $gApH5.default).detailOptionLabel)
        }))), [
        formatMessage
    ]);
    const options = (0, $eJOHy.useMemo)(()=>[
            {
                id: (0, $iRahl.views).list,
                label: listLabel,
                testId: `${testIdPrefix}${(0, $iRahl.views).list}`
            },
            {
                id: (0, $iRahl.views).detail,
                label: detailLabel,
                testId: `${testIdPrefix}${(0, $iRahl.views).detail}`
            }
        ], [
        listLabel,
        detailLabel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($05b34bd9feb8ad95$var$KeyboardShortcuts, {
        view: view,
        onToggle: onToggle,
        intl: intl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1JGvk.ToggleButtons), {
        label: formatMessage((0, $gApH5.default).toggleButtonsLabel),
        isCompact: true,
        options: options,
        selectedOption: view,
        onChange: (newView)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            onToggle(newView, false);
        }
    }));
};
$05b34bd9feb8ad95$export$c774a1845e27fedc.defaultProps = {
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
const $05b34bd9feb8ad95$export$3f624639bbe23442 = ({ filterId: filterId })=>{
    (0, $fAgUF.markOnce)((0, $fAgUF.marks).PAGE_ACTIONS_VIEW_SWITCHER_START);
    (0, $eJOHy.useLayoutEffect)(()=>{
        (0, $fAgUF.markOnce)((0, $fAgUF.marks).PAGE_ACTIONS_VIEW_SWITCHER_END);
    }, []);
    const selectedIssueKey = (0, $1wL9i.useSelectedIssueKey)();
    const [{ view: view }, { setView: setView }] = (0, $HiS1C.useSelectedViewState)();
    const intl = (0, $dTocu.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleOnToggle = (0, $eJOHy.useCallback)((newView, isKeyboardShortcut)=>{
        // When toggling to detail view we want to update the issue key in the URL to match the currently selected
        // issue. When toggling to list view we want to discard the issue key from the URL.
        const newIssueKey = newView === (0, $iRahl.views).detail ? selectedIssueKey : '';
        let resolvedNewView = (0, $eibCx.convertToIssueNavigatorId)(newView);
        if (newView === (0, $iRahl.views).list && filterId && (0, $82cqT.isCustomFilter)(filterId)) resolvedNewView = (0, $eibCx.convertFilterIdToIssueNavigatorId)(filterId);
        setView(resolvedNewView, newIssueKey);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'switchIssueNavigatorView', {
            keyboardShortcut: isKeyboardShortcut,
            switchToView: newView
        });
        return true;
    }, [
        selectedIssueKey,
        filterId,
        setView,
        createAnalyticsEvent
    ]);
    const children = (0, $4cTDP.fg)('remove_nin_changeboarding_rll_usages') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($05b34bd9feb8ad95$export$c774a1845e27fedc, {
        view: (0, $eibCx.convertToView)(view),
        onToggle: handleOnToggle,
        intl: intl
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lHHP1.NinChangeboardingTourTarget), {
        engagementId: "nin.view-switcher"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($05b34bd9feb8ad95$export$c774a1845e27fedc, {
        view: (0, $eibCx.convertToView)(view),
        onToggle: handleOnToggle,
        intl: intl
    }));
    // Remove all the changeboarding on clean up of 'remove_nin_changeboarding_rll_usages', should be showing as empty fragments already
    const renderSpotlightCard = ({ onEndTour: onEndTour, onSetActiveCard: onSetActiveCard })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fNOMn.default), {
            cardKey: (0, $6sTi7.cardKeys).GLOBAL_SCOPE_VIEW_SWITCHER,
            dialogWidth: 272,
            dialogPlacement: "bottom right",
            actions: view === 'detail' ? [
                {
                    onClick: ()=>{
                        onEndTour();
                    },
                    text: intl.formatMessage((0, $gApH5.default).done)
                }
            ] : [
                {
                    onClick: ()=>{
                        onSetActiveCard((0, $6sTi7.cardKeys).GLOBAL_SCOPE_COLUMN_PICKER);
                    },
                    text: intl.formatMessage((0, $gApH5.default).next)
                },
                {
                    appearance: 'subtle',
                    onClick: ()=>{
                        onEndTour();
                    },
                    text: intl.formatMessage((0, $gApH5.default).skip)
                }
            ],
            heading: intl.formatMessage((0, $gApH5.default).tourHeading),
            target: "nin.spotlight.view-switcher",
            targetBgColor: "var(--ds-surface, #FFFFFF)",
            targetRadius: 3,
            messageId: "issue-navigator.ui.view-switcher.spotlight-tour-card.nin.spotlight.view-switcher.spotlight",
            messageType: "transactional"
        }, intl.formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gApH5.default).tourBodyIssueTermRefresh : (0, $gApH5.default).tourBody));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $437hw.default), {
        name: "nin.spotlight.view-switcher",
        renderSpotlightCard: renderSpotlightCard
    }, children);
};
var $05b34bd9feb8ad95$export$2e2bcd8739ae039 = $05b34bd9feb8ad95$export$3f624639bbe23442;

});
parcelRegister("9S9DZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4628d836a2702117fd4aa5f1325a9af2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7300a347552361ca$var$_react = $7300a347552361ca$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7300a347552361ca$var$_baseNew = $7300a347552361ca$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7300a347552361ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutTwoColumnsSidebarLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout with left sidebar option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7300a347552361ca$var$LayoutTwoColumnsSidebarLeftIcon = (props)=>/*#__PURE__*/ $7300a347552361ca$var$_react.default.createElement($7300a347552361ca$var$_baseNew.default, Object.assign({
        name: "LayoutTwoColumnsSidebarLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 2.375C16 1.615 15.384 1 14.625 1h-7.75C6.115 1 5.5 1.616 5.5 2.375v11.25c0 .76.616 1.375 1.375 1.375h7.75c.76 0 1.375-.616 1.375-1.375zm-1.5.125v11H7v-11zM4 2.375C4 1.615 3.384 1 2.625 1h-1.25C.615 1 0 1.616 0 2.375v11.25C0 14.385.616 15 1.375 15h1.25C3.385 15 4 14.384 4 13.625zM2.5 2.5v11h-1v-11z" clip-rule="evenodd"/>`
    }, props));
$7300a347552361ca$var$LayoutTwoColumnsSidebarLeftIcon.displayName = 'LayoutTwoColumnsSidebarLeftIcon';
var $7300a347552361ca$var$_default = module.exports.default = $7300a347552361ca$var$LayoutTwoColumnsSidebarLeftIcon;

});

parcelRegister("1OKaP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::039ea8d33e9a1538394bd0f26af6a9f8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $152e470ea615d0eb$var$_react = $152e470ea615d0eb$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $152e470ea615d0eb$var$_baseNew = $152e470ea615d0eb$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $152e470ea615d0eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Table".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for tables, tabular data, and spreadsheets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $152e470ea615d0eb$var$TableIcon = (props)=>/*#__PURE__*/ $152e470ea615d0eb$var$_react.default.createElement($152e470ea615d0eb$var$_baseNew.default, Object.assign({
        name: "TableIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8.75h-8v3.75H14a.5.5 0 0 0 .5-.5zM1.5 12a.5.5 0 0 0 .5.5h3V8.75H1.5zm13-8a.5.5 0 0 0-.5-.5H6.5v3.75h8zm-13 3.25H5V3.5H2a.5.5 0 0 0-.5.5zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z"/>`
    }, props));
$152e470ea615d0eb$var$TableIcon.displayName = 'TableIcon';
var $152e470ea615d0eb$var$_default = module.exports.default = $152e470ea615d0eb$var$TableIcon;

});

parcelRegister("6sTi7", function(module, exports) {
$parcel$export(module.exports, "cardKeys", () => $fe025dbff69a9482$export$79399c5778983d77);
// Remove this file on clean up of 'remove_nin_changeboarding_rll_usages'
/**
 * Collection of keys representing individual spotlight cards displayed within the issue navigator.
 */ const $fe025dbff69a9482$export$79399c5778983d77 = {
    GLOBAL_SCOPE_JQL_BUILDER_NL_TO_JQL: 'global-scope.jql-builder-with-ai.natural-language-to-jql',
    GLOBAL_SCOPE_VIEW_SWITCHER: 'global-scope.view-switcher',
    GLOBAL_SCOPE_COLUMN_PICKER: 'global-scope.column-picker',
    JQL_BUILDER_NL_TOGGLE: 'jql-builder-with-ai.natural-language-toggle',
    JQL_BUILDER_NL_TO_JQL: 'jql-builder-with-ai.natural-language-to-jql'
};

});

parcelRegister("fNOMn", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b9bd65aec627275$export$2e2bcd8739ae039);
// Remove this file on clean up of 'remove_nin_changeboarding_rll_usages'

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $bJscI = parcelRequire("bJscI");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5b9bd65aec627275$var$SpotlightTourCardAsync = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("aOhkZ")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/changeboarding/src/ui/spotlight-tour-card/main.tsx"
});
const $5b9bd65aec627275$var$SpotlightTourCardBase = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-issue-navigator-changeboarding-spotlight-tour-card",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-issue-navigator-changeboarding-spotlight-tour-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5b9bd65aec627275$var$SpotlightTourCardAsync, props)));
const $5b9bd65aec627275$var$SpotlightTourCard = (0, $bJscI.componentWithFG)('remove_nin_changeboarding_rll_usages', ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null), $5b9bd65aec627275$var$SpotlightTourCardBase);
var $5b9bd65aec627275$export$2e2bcd8739ae039 = $5b9bd65aec627275$var$SpotlightTourCard;

});
parcelRegister("aOhkZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3L085").then(()=>parcelRequire('966Nd'));

});


parcelRegister("437hw", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb7042db8e62785d$export$2e2bcd8739ae039);
// Remove this file on clean up of 'remove_nin_changeboarding_rll_usages'

var $eJOHy = parcelRequire("eJOHy");

var $54CI2 = parcelRequire("54CI2");
var $guChT = parcelRequire("guChT");
var $d2s5v = parcelRequire("d2s5v");

var $gokBr = parcelRequire("gokBr");
/**
 *
 * Renders a spotlight target and associated spotlight card.
 */ const $cb7042db8e62785d$var$SpotlightTourTarget = ({ children: children, name: name, renderSpotlightCard: renderSpotlightCard })=>{
    const { onEndTour: onEndTour, onSetActiveCard: onSetActiveCard } = (0, $gokBr.useSpotlightCoordinationActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: name
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, typeof renderSpotlightCard === 'function' ? renderSpotlightCard({
        onEndTour: onEndTour,
        onSetActiveCard: onSetActiveCard
    }) : renderSpotlightCard));
};
var $cb7042db8e62785d$export$2e2bcd8739ae039 = $cb7042db8e62785d$var$SpotlightTourTarget;

});
parcelRegister("gokBr", function(module, exports) {
$parcel$export(module.exports, "useIsActiveSpotlightCard", () => $afabf68402b50fe5$export$ac706a6842f43035);
$parcel$export(module.exports, "useSpotlightCoordinationActions", () => $afabf68402b50fe5$export$d0297e733168e478);

var $12DRg = parcelRequire("12DRg");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4cTDP = parcelRequire("4cTDP");

const $afabf68402b50fe5$var$initialState = {
    cardKey: null,
    onStopCoordination: null
};
const $afabf68402b50fe5$var$actions = {
    onSetActiveCard: (cardKey, stop)=>({ getState: getState, setState: setState })=>{
            const { onStopCoordination: onStopCoordination } = getState();
            setState({
                cardKey: cardKey,
                onStopCoordination: stop ?? onStopCoordination
            });
        },
    onEndTour: ()=>({ getState: getState, setState: setState })=>{
            const { onStopCoordination: onStopCoordination } = getState();
            onStopCoordination && onStopCoordination();
            setState({
                cardKey: null,
                onStopCoordination: null
            });
        }
};
const $afabf68402b50fe5$var$Store = (0, $GtRbT.createStore)({
    initialState: $afabf68402b50fe5$var$initialState,
    actions: $afabf68402b50fe5$var$actions
});
/**
 * Return `true` if the provided `cardKey` should be displayed as an active spotlight card.
 */ const $afabf68402b50fe5$var$useIsActiveSpotlightCardOld = (0, $iJq0l.createHook)($afabf68402b50fe5$var$Store, {
    selector: (state, cardKeys)=>Array.isArray(cardKeys) ? state.cardKey !== null && cardKeys.includes(state.cardKey) : state.cardKey === cardKeys
});
const $afabf68402b50fe5$export$ac706a6842f43035 = (...args)=>{
    const oldResult = $afabf68402b50fe5$var$useIsActiveSpotlightCardOld(...args);
    if ((0, $4cTDP.fg)('remove_nin_changeboarding_rll_usages')) return [
        false,
        {
            onSetActiveCard: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onEndTour: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        }
    ];
    return oldResult;
};
const $afabf68402b50fe5$var$useSpotlightCoordinationActionsOld = (0, $iJq0l.createActionsHook)($afabf68402b50fe5$var$Store);
const $afabf68402b50fe5$export$d0297e733168e478 = (...args)=>{
    const oldResult = $afabf68402b50fe5$var$useSpotlightCoordinationActionsOld(...args);
    if ((0, $4cTDP.fg)('remove_nin_changeboarding_rll_usages')) return {
        onSetActiveCard: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onEndTour: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    };
    return oldResult;
};

});


parcelRegister("1JGvk", function(module, exports) {
$parcel$export(module.exports, "ToggleButtons", () => $40397b328aa6cd17$export$34301fadafd0cd9d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");
const $40397b328aa6cd17$export$34301fadafd0cd9d = ({ options: options, selectedOption: selectedOption, onChange: onChange, label: label, isCompact: isCompact, expDesignRefresh: expDesignRefresh })=>{
    const getButtonWithContext = (0, $eJOHy.useCallback)(({ option: option, isSelected: isSelected })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQP4O.default), {
            role: "radio",
            "aria-checked": isSelected,
            xcss: [
                expDesignRefresh ? $40397b328aa6cd17$var$baseStylesDesignRefresh : $40397b328aa6cd17$var$baseStyles,
                !isCompact && (expDesignRefresh ? $40397b328aa6cd17$var$wideStylesDesignRefresh : $40397b328aa6cd17$var$wideStyles),
                isSelected && (expDesignRefresh ? $40397b328aa6cd17$var$selectedStylesDesignRefresh : $40397b328aa6cd17$var$selectedStyles)
            ],
            onClick: (event, analyticsEvent)=>!isSelected && onChange(option.id, event, analyticsEvent),
            isDisabled: option.isDisabled,
            testId: option.testId,
            interactionName: option.interactionName,
            children: option.label
        }, option.id), [
        onChange,
        isCompact,
        expDesignRefresh
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        // eslint-disable-next-line @atlassian/a11y/no-noninteractive-element-to-interactive-role
        role: "radiogroup",
        xcss: expDesignRefresh ? $40397b328aa6cd17$var$containerStylesDesignRefresh : $40397b328aa6cd17$var$containerStyles,
        "aria-label": label,
        as: "fieldset",
        children: options.map((option)=>getButtonWithContext({
                option: option,
                isSelected: option.id === selectedOption
            }))
    });
};
const $40397b328aa6cd17$var$containerStyles = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderRadius: "var(--ds-radius-small, 4px)",
    paddingInline: 'space.025',
    gap: 'space.025',
    display: 'inline-flex',
    alignItems: 'center',
    height: '2rem'
});
const $40397b328aa6cd17$var$containerStylesDesignRefresh = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderRadius: "var(--ds-radius-small, 6px)",
    padding: 'space.050',
    gap: 'space.025',
    display: 'inline-flex',
    alignItems: 'center',
    height: '2rem'
});
const $40397b328aa6cd17$var$baseStyles = (0, $1DXK0.xcss)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    border: `${"var(--ds-border-width, 1px)"} solid transparent`,
    borderRadius: "var(--ds-radius-xsmall, 2px)",
    color: 'color.text.subtle',
    height: '26px',
    fontWeight: 'font.weight.medium',
    padding: 'space.0',
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
        color: 'color.text.subtle'
    },
    ':focus': {
        outlineOffset: 'space.0'
    },
    ':disabled': {
        background: "var(--ds-background-disabled, #17171708)",
        color: 'color.text.disabled'
    }
});
const $40397b328aa6cd17$var$baseStylesDesignRefresh = (0, $1DXK0.xcss)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    border: `${"var(--ds-border-width, 1px)"} solid transparent`,
    borderRadius: "var(--ds-radius-xsmall, 3px)",
    color: 'color.text.subtle',
    height: '24px',
    fontWeight: 'font.weight.medium',
    padding: 'space.0',
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
        color: 'color.text.subtle'
    },
    ':focus': {
        outlineOffset: 'space.0'
    },
    ':disabled': {
        background: "var(--ds-background-disabled, #17171708)",
        color: 'color.text.disabled'
    }
});
const $40397b328aa6cd17$var$selectedStyles = (0, $1DXK0.xcss)({
    background: "var(--ds-background-selected, #E9F2FE)",
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-selected, #1868DB)"}`,
    color: 'color.text.selected',
    cursor: 'default',
    ':hover': {
        background: "var(--ds-background-selected, #E9F2FE)",
        color: 'color.text.selected'
    }
});
const $40397b328aa6cd17$var$selectedStylesDesignRefresh = (0, $1DXK0.xcss)({
    background: "var(--ds-background-selected, #E9F2FE)",
    color: 'color.text.selected',
    cursor: 'default',
    ':hover': {
        background: "var(--ds-background-selected, #E9F2FE)",
        color: 'color.text.selected'
    }
});
const $40397b328aa6cd17$var$wideStyles = (0, $1DXK0.xcss)({
    paddingLeft: 'space.150',
    paddingRight: 'space.150'
});
const $40397b328aa6cd17$var$wideStylesDesignRefresh = (0, $1DXK0.xcss)({
    paddingLeft: 'space.075',
    paddingRight: 'space.100'
});

});

parcelRegister("gApH5", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2a740695b4ac9af$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $f2a740695b4ac9af$var$messages = (0, $7qGN1.defineMessages)({
    done: {
        "id": "issue-navigator.view-switcher.done",
        "defaultMessage": "Done"
    },
    next: {
        "id": "issue-navigator.view-switcher.next",
        "defaultMessage": "Next"
    },
    skip: {
        "id": "issue-navigator.view-switcher.skip",
        "defaultMessage": "Skip"
    },
    tourHeading: {
        "id": "issue-navigator.view-switcher.tour-heading",
        "defaultMessage": "View switcher"
    },
    tourBody: {
        "id": "issue-navigator.view-switcher.tour-body",
        "defaultMessage": "Switch between these two views to easily scan through a list or view the details of the issues."
    },
    detailText: {
        "id": "issue-navigator.refinement-bar.view-switcher.detail-text",
        "defaultMessage": "Switch to detail view"
    },
    listText: {
        "id": "issue-navigator.refinement-bar.view-switcher.list-text",
        "defaultMessage": "Switch to list view"
    },
    toggleButtonsLabel: {
        "id": "issue-navigator.refinement-bar.view-switcher.toggle-buttons-label",
        "defaultMessage": "Select view"
    },
    detailOptionLabel: {
        "id": "issue-navigator.refinement-bar.view-switcher.detail-option-label",
        "defaultMessage": "Detail view"
    },
    listOptionLabel: {
        "id": "issue-navigator.refinement-bar.view-switcher.list-option-label",
        "defaultMessage": "List view"
    },
    tourBodyIssueTermRefresh: {
        "id": "issue-navigator.view-switcher.tour-body-issue-term-refresh",
        "defaultMessage": "Switch between these two views to easily scan through a list or view the details of the work item."
    }
});
var $f2a740695b4ac9af$export$2e2bcd8739ae039 = $f2a740695b4ac9af$var$messages;

});


parcelRegister("iUwEA", function(module, exports) {
$parcel$export(module.exports, "useNaturalLanguageMode", () => $6703b84e2e411836$export$617c50bbd595c5ac);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $6703b84e2e411836$var$initialState = {
    isNaturalLanguageMode: false
};
const $6703b84e2e411836$export$e324594224ef24da = {
    toggleNaturalLanguageMode: ()=>({ setState: setState, getState: getState })=>{
            setState({
                isNaturalLanguageMode: !getState().isNaturalLanguageMode
            });
        },
    exitNaturalLanguageMode: ()=>({ setState: setState })=>{
            setState({
                isNaturalLanguageMode: false
            });
        }
};
const $6703b84e2e411836$var$Store = (0, $GtRbT.createStore)({
    initialState: $6703b84e2e411836$var$initialState,
    actions: $6703b84e2e411836$export$e324594224ef24da
});
const $6703b84e2e411836$export$42a852a2b6b56249 = (0, $6E16M.createContainer)($6703b84e2e411836$var$Store, {
    onInit: ()=>({ setState: setState })=>{
            setState({
                isNaturalLanguageMode: false
            });
        }
});
const $6703b84e2e411836$var$getNaturalLanguageMode = (state)=>state.isNaturalLanguageMode;
const $6703b84e2e411836$export$617c50bbd595c5ac = (0, $iJq0l.createHook)($6703b84e2e411836$var$Store, {
    selector: $6703b84e2e411836$var$getNaturalLanguageMode
});
const $6703b84e2e411836$export$d99c2d47e59edc60 = (0, $iJq0l.createActionsHook)($6703b84e2e411836$var$Store);

});

parcelRegister("gn3Hu", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a01744634b090e1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $5a01744634b090e1$var$messages = (0, $7qGN1.defineMessages)({
    allIssues: {
        "id": "project-issue-navigator.page-actions.all-issues",
        "defaultMessage": "Go to all issues"
    },
    exportIssuesButtonIconLabel: {
        "id": "project-issue-navigator.page-actions.export-issues-button-icon-label",
        "defaultMessage": "Open export issues dropdown"
    },
    allIssuesIssueTermRefresh: {
        "id": "project-issue-navigator.page-actions.all-issues-issue-term-refresh",
        "defaultMessage": "Go to all work items"
    },
    exportIssuesButtonIconLabelIssueTermRefresh: {
        "id": "project-issue-navigator.page-actions.export-issues-button-icon-label-issue-term-refresh",
        "defaultMessage": "Open export work items dropdown"
    }
});
var $5a01744634b090e1$export$2e2bcd8739ae039 = $5a01744634b090e1$var$messages;

});



parcelRegister("epLyV", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fbb9d6bfd27c3af$export$2e2bcd8739ae039);

var $bwFBc = parcelRequire("bwFBc");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $3nL89 = parcelRequire("3nL89");

var $4cTDP = parcelRequire("4cTDP");

var $qRwd2 = parcelRequire("qRwd2");
const $7fbb9d6bfd27c3af$var$NavigatorDocumentTitle = ({ queryReference: queryReference })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.usePreloadedQuery)((0, $bwFBc.default), queryReference);
    const projectName = data?.jira?.jiraProjectByKey?.name ?? '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nL89.DocumentTitle), {
        title: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $qRwd2.default).windowTitleMigrationIssueTermRefresh : (0, $qRwd2.default).windowTitleMigration, {
            projectName: projectName
        })
    });
};
var $7fbb9d6bfd27c3af$export$2e2bcd8739ae039 = $7fbb9d6bfd27c3af$var$NavigatorDocumentTitle;

});
parcelRegister("qRwd2", function(module, exports) {
$parcel$export(module.exports, "default", () => $54bf144ca602d19e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $54bf144ca602d19e$var$messages = (0, $7qGN1.defineMessages)({
    windowTitleMigrationIssueTermRefresh: {
        "id": "project-issue-navigator.window-title-migration-issue-term-refresh",
        "defaultMessage": "{projectName} - All work"
    },
    windowTitleMigration: {
        "id": "project-issue-navigator.window-title-migration",
        "defaultMessage": "{projectName} - Issues"
    }
});
var $54bf144ca602d19e$export$2e2bcd8739ae039 = $54bf144ca602d19e$var$messages;

});



parcelRegister("jUHqr", function(module, exports) {
$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $0aba41a6ca8ce346$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $0aba41a6ca8ce346$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $0aba41a6ca8ce346$export$9b3029ee6188a41f);

var $eJOHy = parcelRequire("eJOHy");

var $2gvG4 = parcelRequire("2gvG4");

var $6whQo = parcelRequire("6whQo");

var $kVpZx = parcelRequire("kVpZx");

var $ioEQd = parcelRequire("ioEQd");

var $fRC66 = parcelRequire("fRC66");

var $CkF8u = parcelRequire("CkF8u");

var $iAPDN = parcelRequire("iAPDN");

var $4WwFo = parcelRequire("4WwFo");

var $cllya = parcelRequire("cllya");
const $0aba41a6ca8ce346$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $0aba41a6ca8ce346$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $0aba41a6ca8ce346$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $ioEQd.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $4WwFo.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $iAPDN.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $cllya.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2gvG4.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6whQo.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $CkF8u.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $kVpZx.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fRC66.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $0aba41a6ca8ce346$export$9b3029ee6188a41f = $0aba41a6ca8ce346$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("6whQo", function(module, exports) {
$parcel$export(module.exports, "getBm3Timings", () => $3708d872c36dd1bb$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $3708d872c36dd1bb$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $3708d872c36dd1bb$export$d93d677ef2f33c5c);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $3708d872c36dd1bb$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eJOHy.useContext)((0, $7aoMz.default));
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    (0, $eJOHy.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $3708d872c36dd1bb$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingsConfig);
        (0, $2QO3b.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("fRC66", function(module, exports) {
$parcel$export(module.exports, "StopBrowserMetrics3", () => $7986e193b27b5912$export$575e93c0f9905999);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $k04JP = parcelRequire("k04JP");

var $6uWhG = parcelRequire("6uWhG");

var $2HxHL = parcelRequire("2HxHL");

var $iEXnd = parcelRequire("iEXnd");

var $lOI8W = parcelRequire("lOI8W");

var $9DwQv = parcelRequire("9DwQv");

const $7986e193b27b5912$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $9DwQv.isAutomaticExposureCollectionEnabled)()) (0, $2HxHL.stopLowPriorityEventDelay)();
};
class $7986e193b27b5912$export$575e93c0f9905999 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $k04JP.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $iEXnd.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $fcc2379b1f384e36$export$99c08ec92759c71c));
                (0, $6uWhG.setMark)((0, $fcc2379b1f384e36$export$99c08ec92759c71c));
                (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $fcc2379b1f384e36$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $7986e193b27b5912$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $iEXnd.PRODUCT_START_MARK), true);
            $7986e193b27b5912$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $7aoMz.default);
    }
    render() {
        return null;
    }
}

});
const $fcc2379b1f384e36$export$56940a9488e85199 = 'jira.fe.spa-';
const $fcc2379b1f384e36$export$45c4b6bf7935c69a = `${$fcc2379b1f384e36$export$56940a9488e85199}start`;
const $fcc2379b1f384e36$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $fcc2379b1f384e36$export$ff834eccc35b9089 = 'appBundleReady';
const $fcc2379b1f384e36$export$86b05e34d462ead8 = 'prefetchApiReady';
const $fcc2379b1f384e36$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $fcc2379b1f384e36$export$3ae43cc1782d058f = 'jswRenderStart';
const $fcc2379b1f384e36$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $fcc2379b1f384e36$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $fcc2379b1f384e36$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $fcc2379b1f384e36$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $fcc2379b1f384e36$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $fcc2379b1f384e36$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $fcc2379b1f384e36$export$99c08ec92759c71c = 'tti-raf-mark';
const $fcc2379b1f384e36$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("CkF8u", function(module, exports) {
$parcel$export(module.exports, "StopUfo", () => $f04c01c7c6bf4310$export$d91154f099475c5);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $ioEQd = parcelRequire("ioEQd");
class $f04c01c7c6bf4310$export$d91154f099475c5 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $ioEQd.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $ioEQd.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $7aoMz.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("iAPDN", function(module, exports) {
$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $4d28fc5eaea80e10$export$bf239ac2bfb04967);

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $4d28fc5eaea80e10$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $2QO3b.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("4WwFo", function(module, exports) {
$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $3d02e80116d345ab$export$e63862cd888fe05a);

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");

var $ioEQd = parcelRequire("ioEQd");
var $8tVkR = parcelRequire("8tVkR");
async function $3d02e80116d345ab$export$e63862cd888fe05a() {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $ioEQd.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $8tVkR.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $2QO3b.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("cllya", function(module, exports) {
$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $eaa2e9e24133f900$export$f00f1e874ce869e9);

var $12DRg = parcelRequire("12DRg");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $eaa2e9e24133f900$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $eaa2e9e24133f900$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $eaa2e9e24133f900$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $eaa2e9e24133f900$export$7b4abba432e57989 = (value)=>$eaa2e9e24133f900$var$isString(value) && $eaa2e9e24133f900$var$startsAsObject(value) || $eaa2e9e24133f900$var$isObject(value);
const $eaa2e9e24133f900$export$fcc03ee4c944962f = (featureFlagValue)=>$eaa2e9e24133f900$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $eaa2e9e24133f900$export$d2818866b4acbea4 = new Map();
const $eaa2e9e24133f900$export$f00f1e874ce869e9 = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));

});


parcelRegister("dghMS", function(module, exports) {
$parcel$export(module.exports, "IssueNavigatorSubmitApdex", () => $1eda28399823732f$export$aeeda80369a76daf);

var $eJOHy = parcelRequire("eJOHy");

var $huMFD = parcelRequire("huMFD");

var $2vBmG = parcelRequire("2vBmG");

var $jUHqr = parcelRequire("jUHqr");

var $cH6Qf = parcelRequire("cH6Qf");

var $fAgUF = parcelRequire("fAgUF");
const $1eda28399823732f$export$aeeda80369a76daf = /*#__PURE__*/ (0, $eJOHy.memo)(({ appName: appName, attributes: attributes, emitOnAnimationFrame: emitOnAnimationFrame, metric: metric = (0, $fAgUF.NINPageLoad), scope: scope })=>{
    const getServerTimeUFO = (0, $huMFD.useServerTimeUFO)();
    const extra = (0, $eJOHy.useMemo)(()=>({
            scope: scope,
            ...getServerTimeUFO?.(),
            ...attributes
        }), [
        attributes,
        getServerTimeUFO,
        scope
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUHqr.default), {
        appName: appName,
        isExpectedToHaveSsr: true,
        withMarks: [
            (0, $2vBmG.appBundleReadyMark),
            (0, $2vBmG.prefetchApiReadyMark)
        ],
        ttrSlo: 3000,
        ttiSlo: 4000,
        extra: extra,
        metric: metric,
        emitOnAnimationFrame: emitOnAnimationFrame
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cH6Qf.SpaStatePageReady), null));
});

});

parcelRegister("2MmuH", function(module, exports) {
$parcel$export(module.exports, "WelcomeModal", () => $9d1aea9e31439ae5$export$9d12d42929c3fcf);

var $eJOHy = parcelRequire("eJOHy");

var $eaCdv = parcelRequire("eaCdv");

var $egzgh = parcelRequire("egzgh");

var $5vQ2T = parcelRequire("5vQ2T");

var $eJrcF = parcelRequire("eJrcF");

var $dZRaT = parcelRequire("dZRaT");

var $4cTDP = parcelRequire("4cTDP");
const $9d1aea9e31439ae5$var$ConditionalWelcomeModalForSoftware = ()=>{
    const shouldShowModal = (0, $egzgh.useShouldShowWelcomeModal)('list');
    const { data: data } = (0, $eJrcF.useResource)((0, $dZRaT.projectContextResource));
    const isSoftwareProject = data?.projectType === 'software';
    return shouldShowModal && isSoftwareProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eaCdv.AsyncWelcomeModal), {
        source: "list"
    }) : null;
};
const $9d1aea9e31439ae5$export$9d12d42929c3fcf = ()=>{
    if (!(0, $4cTDP.fg)('jira_list_nin_merge')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "welcome-modal-list-view",
        packageName: "jiraBusinessList",
        teamName: "jlove-makkuro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9d1aea9e31439ae5$var$ConditionalWelcomeModalForSoftware, null));
};

});
parcelRegister("eaCdv", function(module, exports) {
$parcel$export(module.exports, "AsyncWelcomeModal", () => $f425abc4bad8a088$export$d08881a6c29dfdb2);

var $eJOHy = parcelRequire("eJOHy");


var $hLlIx = parcelRequire("hLlIx");

var $bonXV = parcelRequire("bonXV");

var $2imLM = parcelRequire("2imLM");

var $4EKqI = parcelRequire("4EKqI");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f425abc4bad8a088$var$LazyWelcomeModal = (0, $bQWwW.lazy)(()=>(parcelRequire("eZcP6")).then(({ WelcomeModal: WelcomeModal })=>WelcomeModal), {
    moduleId: "./src/packages/software/onboarding-modals/src/ui/welcome-modal/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f425abc4bad8a088$var$LazyWelcomeModalWizard = (0, $bQWwW.lazy)(()=>(parcelRequire("5hANT")).then(({ WelcomeModal: WelcomeModal })=>WelcomeModal), {
    moduleId: "./src/packages/software/onboarding-modals/src/ui/welcome-modal/wizard/index.tsx"
});
const $f425abc4bad8a088$export$d08881a6c29dfdb2 = ({ source: source })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "async-onboarding-welcome-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hLlIx.ErrorBoundaryWithChunkErrorLogging), {
        id: "asyncWelcomeModalComponent",
        fallback: "unmount",
        packageName: "jiraSoftwareOnboardingModals",
        teamName: "Growth-Jira-Find"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "software-onboarding-modals-welcome-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, [
        'list',
        'board'
    ].includes(source) && // our new wizard only needs to render on list/board
    (0, $bonXV.sessionStorageProvider).get((0, $2b839a8453de5367$export$c9dc4cb209930823)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f425abc4bad8a088$var$LazyWelcomeModalWizard, {
        source: source
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f425abc4bad8a088$var$LazyWelcomeModal, {
        source: source
    }))));
};

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
const $2b839a8453de5367$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $2b839a8453de5367$export$e3884212029f7bef = 'should-show-welcome-modal';
const $2b839a8453de5367$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $2b839a8453de5367$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $2b839a8453de5367$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $2b839a8453de5367$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $2b839a8453de5367$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $2b839a8453de5367$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $2b839a8453de5367$export$6e69f8dc03075ef8 = 'team-type';
const $2b839a8453de5367$export$c06666264cd35603 = 'team-type-shorthand';
const $2b839a8453de5367$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $2b839a8453de5367$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $2b839a8453de5367$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $2b839a8453de5367$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $2b839a8453de5367$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $2b839a8453de5367$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $2b839a8453de5367$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $2b839a8453de5367$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $2b839a8453de5367$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $2b839a8453de5367$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $2b839a8453de5367$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $2b839a8453de5367$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $2b839a8453de5367$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $2b839a8453de5367$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $2b839a8453de5367$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $2b839a8453de5367$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $2b839a8453de5367$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $2b839a8453de5367$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $2b839a8453de5367$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $2b839a8453de5367$export$468488291ccd988 = 'timelineAddItemNudge';
const $2b839a8453de5367$export$7a33548109ac931d = 'createFormNudge';
const $2b839a8453de5367$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $2b839a8453de5367$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $2b839a8453de5367$export$594d3436316492be = 'summaryViewNudge';
const $2b839a8453de5367$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $2b839a8453de5367$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $2b839a8453de5367$export$baf21119361ffad = 'planCreateMoreWorkItemsNudge';
const $2b839a8453de5367$export$7fac0b950c128b4b = 'planConnectRelatedWorkNudge';
const $2b839a8453de5367$export$9fac41c1d8941795 = 'planShareYourPlanWithTheWorldTeamNudge';
const $2b839a8453de5367$export$994f00a8ff485faf = 'planShareYourPlanWithTheWorldAddPeopleNudge';
const $2b839a8453de5367$export$fc1e19da8853ecdc = 'planBringInTheTeamNudge';
const $2b839a8453de5367$export$d0ece87d6f260877 = 'planConfirmScopeNudge';
const $2b839a8453de5367$export$cc93e7cb8dd884fe = 'planCheckYourSettingsNudge';
const $2b839a8453de5367$export$b579a6f09436e23e = 'asyncPlanOnboardingTourNudge';
const $2b839a8453de5367$export$c7f7837470493c6f = 'planAdjustDetailsFieldsMenuNudge';
const $2b839a8453de5367$export$8909317d0f73beab = 'planAdjustDetailsFieldCellsNudge';
const $2b839a8453de5367$export$699265ec8ad9a740 = 'Software Development';
const $2b839a8453de5367$export$e07d1fa2da8ed874 = 'Customer Service';
const $2b839a8453de5367$export$76dcec3f438d9e56 = 'IT Support';
const $2b839a8453de5367$export$9a574c301f67ba30 = 'Human Resources';
const $2b839a8453de5367$export$363ec144a94029c8 = 'Finance';
const $2b839a8453de5367$export$df0fb32d68ae1e78 = 'Legal';
const $2b839a8453de5367$export$d9c0e3e59442fb4 = 'Marketing';
const $2b839a8453de5367$export$27dbc7d7ce66e6e3 = 'Operations';
const $2b839a8453de5367$export$a5dce388adf922bd = 'Sales';
const $2b839a8453de5367$export$e1473b31a257caff = 'Data Science';
const $2b839a8453de5367$export$85657457db93c2c2 = 'Product Management';
const $2b839a8453de5367$export$c0c2d1dfaeba89dd = 'Project Management';
const $2b839a8453de5367$export$2e6a7ad3ab9c82a3 = 'Design';
const $2b839a8453de5367$export$7b60378c3b4372e9 = 'Other or Personal';
const $2b839a8453de5367$export$572242e58bd07594 = 'CS';
const $2b839a8453de5367$export$d7de553940261eba = 'ITS';
const $2b839a8453de5367$export$4c29d0d04c15e55d = 'HR';
const $2b839a8453de5367$export$3950f7f841bf94b6 = 'FNC';
const $2b839a8453de5367$export$881249b988b6030f = 'LGL';
const $2b839a8453de5367$export$e4824f74b9879164 = 'MKT';
const $2b839a8453de5367$export$4f3cb0844009af52 = 'OPS';
const $2b839a8453de5367$export$1a65d50c4a641bb4 = 'SAL';
const $2b839a8453de5367$export$9ee64e8fbd8b03a2 = 'DS';
const $2b839a8453de5367$export$b8b1ac856ba1434b = 'DEV';
const $2b839a8453de5367$export$4f54a09a24fd1d74 = 'PDM';
const $2b839a8453de5367$export$79685802e8ff1098 = 'PJM';
const $2b839a8453de5367$export$e5c438b7501b5a24 = 'DES';
const $2b839a8453de5367$export$cbc0e551d91a692d = 'OTR';

parcelRegister("bonXV", function(module, exports) {
$parcel$export(module.exports, "sessionStorageProvider", () => $d3902f951848120d$export$5a24cb3021127ff7);
$parcel$export(module.exports, "localStorageProvider", () => $d3902f951848120d$export$aa821bfb3308a1f5);

var $3hRxq = parcelRequire("3hRxq");

var $8tIrO = parcelRequire("8tIrO");




const $d3902f951848120d$export$5a24cb3021127ff7 = (0, $8tIrO.createSessionExpirableStorageProvider)('onboarding-core');
const $d3902f951848120d$export$aa821bfb3308a1f5 = (0, $3hRxq.createLocalExpirableStorageProvider)('onboarding-core');

});

parcelRegister("eZcP6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("8QSHq")
]).then(()=>parcelRequire('fmEci'));

});

parcelRegister("5hANT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("lwWcG")
]).then(()=>parcelRequire('faS2r'));

});


parcelRegister("egzgh", function(module, exports) {
$parcel$export(module.exports, "useShouldShowModalBasedOnSessionStorage", () => $b456e169e3488e0b$export$b39cbd941f378bec);
$parcel$export(module.exports, "useShouldShowWelcomeModal", () => $b456e169e3488e0b$export$b01115c2f75a04f8);

var $eJOHy = parcelRequire("eJOHy");


var $bonXV = parcelRequire("bonXV");

var $gMNY3 = parcelRequire("gMNY3");
const $b456e169e3488e0b$export$b39cbd941f378bec = ()=>{
    const shouldShowModalBasedOnSessionStorage = (0, $eJOHy.useMemo)(()=>{
        const isWizardDuringSignup = (0, $bonXV.sessionStorageProvider).get((0, $2b839a8453de5367$export$c45d2ea50af63a85));
        if (isWizardDuringSignup) return false;
        const sessionStorageVal = (0, $bonXV.sessionStorageProvider).get((0, $2b839a8453de5367$export$e3884212029f7bef));
        if (sessionStorageVal === undefined) return false;
        return true;
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        // Remove the session storage value to prevent the modal showing again
        (0, $bonXV.sessionStorageProvider).remove((0, $2b839a8453de5367$export$e3884212029f7bef));
    }, []);
    return shouldShowModalBasedOnSessionStorage;
};
const $b456e169e3488e0b$export$b01115c2f75a04f8 = (source)=>{
    const canShowNudgeTour = (0, $gMNY3.useCanShowNudgeTour)();
    const sessionStorageVal = (0, $eJOHy.useMemo)(()=>(0, $bonXV.sessionStorageProvider).get((0, $2b839a8453de5367$export$e3884212029f7bef)), []);
    const isWizardDuringSignup = (0, $bonXV.sessionStorageProvider).get((0, $2b839a8453de5367$export$c45d2ea50af63a85));
    if (isWizardDuringSignup) return false;
    if (sessionStorageVal === undefined) return false;
    return canShowNudgeTour(source);
};

});
parcelRegister("gMNY3", function(module, exports) {
$parcel$export(module.exports, "useCanShowNudgeTour", () => $ed2f93c043223105$export$3381da528a252680);

var $gxP9D = parcelRequire("gxP9D");
const $ed2f93c043223105$export$3381da528a252680 = ()=>{
    const [shouldShowOnboardingKanbanTour] = (0, $gxP9D.useShouldShowOnboardingKanbanTour)();
    return (source)=>{
        switch(source){
            case 'board':
                return shouldShowOnboardingKanbanTour;
            case 'timeline':
                // display if eligible for either board/backlog scenarios
                return shouldShowOnboardingKanbanTour;
            case 'list':
                return true;
            default:
                return false;
        }
    };
};

});






$parcel$global.rlb("d9fW6")
//# sourceMappingURL=async-project-issue-navigator-entrypoint.cd9aa66c.js.map
